
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirecfad"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirecfad"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ikxKt", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $d58446040c6113e6$export$ffb0004e005737fa, (v) => $d58446040c6113e6$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $d58446040c6113e6$export$34b9dba7ce09269b, (v) => $d58446040c6113e6$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $d58446040c6113e6$export$25062201e9e25d76, (v) => $d58446040c6113e6$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d58446040c6113e6$export$ffb0004e005737fa;
var $d58446040c6113e6$export$34b9dba7ce09269b;
var $d58446040c6113e6$export$25062201e9e25d76;
"use strict";

var $2gcPZ = parcelRequire("2gcPZ");
var $d58446040c6113e6$var$k = Symbol.for("react.element"), $d58446040c6113e6$var$l = Symbol.for("react.fragment"), $d58446040c6113e6$var$m = Object.prototype.hasOwnProperty, $d58446040c6113e6$var$n = $2gcPZ.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $d58446040c6113e6$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $d58446040c6113e6$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$d58446040c6113e6$var$m.call(a, b) && !$d58446040c6113e6$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $d58446040c6113e6$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $d58446040c6113e6$var$n.current
    };
}
$d58446040c6113e6$export$ffb0004e005737fa = $d58446040c6113e6$var$l;
$d58446040c6113e6$export$34b9dba7ce09269b = $d58446040c6113e6$var$q;
$d58446040c6113e6$export$25062201e9e25d76 = $d58446040c6113e6$var$q;

});
parcelRegister("2gcPZ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("c0xAX"));

});
parcelRegister("c0xAX", function(module, exports) {

$parcel$export(module.exports, "Children", () => $8bdf8b6b6bf9ee80$export$dca3b0875bd9a954, (v) => $8bdf8b6b6bf9ee80$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $8bdf8b6b6bf9ee80$export$16fa2f45be04daa8, (v) => $8bdf8b6b6bf9ee80$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $8bdf8b6b6bf9ee80$export$ffb0004e005737fa, (v) => $8bdf8b6b6bf9ee80$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $8bdf8b6b6bf9ee80$export$e2c29f18771995cb, (v) => $8bdf8b6b6bf9ee80$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $8bdf8b6b6bf9ee80$export$221d75b3f55bb0bd, (v) => $8bdf8b6b6bf9ee80$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $8bdf8b6b6bf9ee80$export$5f8d39834fd61797, (v) => $8bdf8b6b6bf9ee80$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $8bdf8b6b6bf9ee80$export$74bf444e3cd11ea5, (v) => $8bdf8b6b6bf9ee80$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $8bdf8b6b6bf9ee80$export$ae55be85d98224ed, (v) => $8bdf8b6b6bf9ee80$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $8bdf8b6b6bf9ee80$export$e530037191fcd5d7, (v) => $8bdf8b6b6bf9ee80$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $8bdf8b6b6bf9ee80$export$fd42f52fd3ae1109, (v) => $8bdf8b6b6bf9ee80$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $8bdf8b6b6bf9ee80$export$c8a8987d4410bf2d, (v) => $8bdf8b6b6bf9ee80$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $8bdf8b6b6bf9ee80$export$d38cd72104c1f0e9, (v) => $8bdf8b6b6bf9ee80$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $8bdf8b6b6bf9ee80$export$7d1e3a5e95ceca43, (v) => $8bdf8b6b6bf9ee80$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $8bdf8b6b6bf9ee80$export$257a8862b851cb5b, (v) => $8bdf8b6b6bf9ee80$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $8bdf8b6b6bf9ee80$export$a8257692ac88316c, (v) => $8bdf8b6b6bf9ee80$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $8bdf8b6b6bf9ee80$export$488013bae63b21da, (v) => $8bdf8b6b6bf9ee80$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $8bdf8b6b6bf9ee80$export$7c73462e0d25e514, (v) => $8bdf8b6b6bf9ee80$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $8bdf8b6b6bf9ee80$export$7568632d0d33d16d, (v) => $8bdf8b6b6bf9ee80$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $8bdf8b6b6bf9ee80$export$88948ce120ea2619, (v) => $8bdf8b6b6bf9ee80$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $8bdf8b6b6bf9ee80$export$35808ee640e87ca7, (v) => $8bdf8b6b6bf9ee80$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $8bdf8b6b6bf9ee80$export$fae74005e78b1a27, (v) => $8bdf8b6b6bf9ee80$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $8bdf8b6b6bf9ee80$export$dc8fbce3eb94dc1e, (v) => $8bdf8b6b6bf9ee80$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $8bdf8b6b6bf9ee80$export$6a7bc4e911dc01cf, (v) => $8bdf8b6b6bf9ee80$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $8bdf8b6b6bf9ee80$export$6d9c69b0de29b591, (v) => $8bdf8b6b6bf9ee80$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $8bdf8b6b6bf9ee80$export$f680877a34711e37, (v) => $8bdf8b6b6bf9ee80$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $8bdf8b6b6bf9ee80$export$d5a552a76deda3c2, (v) => $8bdf8b6b6bf9ee80$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $8bdf8b6b6bf9ee80$export$aaabe4eda9ed9969, (v) => $8bdf8b6b6bf9ee80$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $8bdf8b6b6bf9ee80$export$e5c5a5f917a5871c, (v) => $8bdf8b6b6bf9ee80$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $8bdf8b6b6bf9ee80$export$1538c33de8887b59, (v) => $8bdf8b6b6bf9ee80$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $8bdf8b6b6bf9ee80$export$13e3392192263954, (v) => $8bdf8b6b6bf9ee80$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $8bdf8b6b6bf9ee80$export$b8f5890fc79d6aca, (v) => $8bdf8b6b6bf9ee80$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $8bdf8b6b6bf9ee80$export$60241385465d0a34, (v) => $8bdf8b6b6bf9ee80$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $8bdf8b6b6bf9ee80$export$306c0aa65ff9ec16, (v) => $8bdf8b6b6bf9ee80$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $8bdf8b6b6bf9ee80$export$7b286972b8d8ccbf, (v) => $8bdf8b6b6bf9ee80$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $8bdf8b6b6bf9ee80$export$83d89fbfd8236492, (v) => $8bdf8b6b6bf9ee80$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8bdf8b6b6bf9ee80$export$dca3b0875bd9a954;
var $8bdf8b6b6bf9ee80$export$16fa2f45be04daa8;
var $8bdf8b6b6bf9ee80$export$ffb0004e005737fa;
var $8bdf8b6b6bf9ee80$export$e2c29f18771995cb;
var $8bdf8b6b6bf9ee80$export$221d75b3f55bb0bd;
var $8bdf8b6b6bf9ee80$export$5f8d39834fd61797;
var $8bdf8b6b6bf9ee80$export$74bf444e3cd11ea5;
var $8bdf8b6b6bf9ee80$export$ae55be85d98224ed;
var $8bdf8b6b6bf9ee80$export$e530037191fcd5d7;
var $8bdf8b6b6bf9ee80$export$fd42f52fd3ae1109;
var $8bdf8b6b6bf9ee80$export$c8a8987d4410bf2d;
var $8bdf8b6b6bf9ee80$export$d38cd72104c1f0e9;
var $8bdf8b6b6bf9ee80$export$7d1e3a5e95ceca43;
var $8bdf8b6b6bf9ee80$export$257a8862b851cb5b;
var $8bdf8b6b6bf9ee80$export$a8257692ac88316c;
var $8bdf8b6b6bf9ee80$export$488013bae63b21da;
var $8bdf8b6b6bf9ee80$export$7c73462e0d25e514;
var $8bdf8b6b6bf9ee80$export$7568632d0d33d16d;
var $8bdf8b6b6bf9ee80$export$88948ce120ea2619;
var $8bdf8b6b6bf9ee80$export$35808ee640e87ca7;
var $8bdf8b6b6bf9ee80$export$fae74005e78b1a27;
var $8bdf8b6b6bf9ee80$export$dc8fbce3eb94dc1e;
var $8bdf8b6b6bf9ee80$export$6a7bc4e911dc01cf;
var $8bdf8b6b6bf9ee80$export$6d9c69b0de29b591;
var $8bdf8b6b6bf9ee80$export$f680877a34711e37;
var $8bdf8b6b6bf9ee80$export$d5a552a76deda3c2;
var $8bdf8b6b6bf9ee80$export$aaabe4eda9ed9969;
var $8bdf8b6b6bf9ee80$export$e5c5a5f917a5871c;
var $8bdf8b6b6bf9ee80$export$1538c33de8887b59;
var $8bdf8b6b6bf9ee80$export$13e3392192263954;
var $8bdf8b6b6bf9ee80$export$b8f5890fc79d6aca;
var $8bdf8b6b6bf9ee80$export$60241385465d0a34;
var $8bdf8b6b6bf9ee80$export$306c0aa65ff9ec16;
var $8bdf8b6b6bf9ee80$export$7b286972b8d8ccbf;
var $8bdf8b6b6bf9ee80$export$83d89fbfd8236492;
"use strict";
var $8bdf8b6b6bf9ee80$var$l = Symbol.for("react.element"), $8bdf8b6b6bf9ee80$var$n = Symbol.for("react.portal"), $8bdf8b6b6bf9ee80$var$p = Symbol.for("react.fragment"), $8bdf8b6b6bf9ee80$var$q = Symbol.for("react.strict_mode"), $8bdf8b6b6bf9ee80$var$r = Symbol.for("react.profiler"), $8bdf8b6b6bf9ee80$var$t = Symbol.for("react.provider"), $8bdf8b6b6bf9ee80$var$u = Symbol.for("react.context"), $8bdf8b6b6bf9ee80$var$v = Symbol.for("react.forward_ref"), $8bdf8b6b6bf9ee80$var$w = Symbol.for("react.suspense"), $8bdf8b6b6bf9ee80$var$x = Symbol.for("react.memo"), $8bdf8b6b6bf9ee80$var$y = Symbol.for("react.lazy"), $8bdf8b6b6bf9ee80$var$z = Symbol.iterator;
function $8bdf8b6b6bf9ee80$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $8bdf8b6b6bf9ee80$var$z && a[$8bdf8b6b6bf9ee80$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $8bdf8b6b6bf9ee80$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $8bdf8b6b6bf9ee80$var$C = Object.assign, $8bdf8b6b6bf9ee80$var$D = {};
function $8bdf8b6b6bf9ee80$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $8bdf8b6b6bf9ee80$var$D;
    this.updater = e || $8bdf8b6b6bf9ee80$var$B;
}
$8bdf8b6b6bf9ee80$var$E.prototype.isReactComponent = {};
$8bdf8b6b6bf9ee80$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$8bdf8b6b6bf9ee80$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $8bdf8b6b6bf9ee80$var$F() {}
$8bdf8b6b6bf9ee80$var$F.prototype = $8bdf8b6b6bf9ee80$var$E.prototype;
function $8bdf8b6b6bf9ee80$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $8bdf8b6b6bf9ee80$var$D;
    this.updater = e || $8bdf8b6b6bf9ee80$var$B;
}
var $8bdf8b6b6bf9ee80$var$H = $8bdf8b6b6bf9ee80$var$G.prototype = new $8bdf8b6b6bf9ee80$var$F;
$8bdf8b6b6bf9ee80$var$H.constructor = $8bdf8b6b6bf9ee80$var$G;
$8bdf8b6b6bf9ee80$var$C($8bdf8b6b6bf9ee80$var$H, $8bdf8b6b6bf9ee80$var$E.prototype);
$8bdf8b6b6bf9ee80$var$H.isPureReactComponent = !0;
var $8bdf8b6b6bf9ee80$var$I = Array.isArray, $8bdf8b6b6bf9ee80$var$J = Object.prototype.hasOwnProperty, $8bdf8b6b6bf9ee80$var$K = {
    current: null
}, $8bdf8b6b6bf9ee80$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $8bdf8b6b6bf9ee80$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$8bdf8b6b6bf9ee80$var$J.call(b, d) && !$8bdf8b6b6bf9ee80$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $8bdf8b6b6bf9ee80$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $8bdf8b6b6bf9ee80$var$K.current
    };
}
function $8bdf8b6b6bf9ee80$var$N(a, b) {
    return {
        $$typeof: $8bdf8b6b6bf9ee80$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $8bdf8b6b6bf9ee80$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $8bdf8b6b6bf9ee80$var$l;
}
function $8bdf8b6b6bf9ee80$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $8bdf8b6b6bf9ee80$var$P = /\/+/g;
function $8bdf8b6b6bf9ee80$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $8bdf8b6b6bf9ee80$var$escape("" + a.key) : b.toString(36);
}
function $8bdf8b6b6bf9ee80$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $8bdf8b6b6bf9ee80$var$l:
                case $8bdf8b6b6bf9ee80$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $8bdf8b6b6bf9ee80$var$Q(h, 0) : d, $8bdf8b6b6bf9ee80$var$I(c) ? (e = "", null != a && (e = a.replace($8bdf8b6b6bf9ee80$var$P, "$&/") + "/"), $8bdf8b6b6bf9ee80$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($8bdf8b6b6bf9ee80$var$O(c) && (c = $8bdf8b6b6bf9ee80$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($8bdf8b6b6bf9ee80$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($8bdf8b6b6bf9ee80$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $8bdf8b6b6bf9ee80$var$Q(k, g);
        h += $8bdf8b6b6bf9ee80$var$R(k, b, e, f, c);
    }
    else if (f = $8bdf8b6b6bf9ee80$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $8bdf8b6b6bf9ee80$var$Q(k, g++), h += $8bdf8b6b6bf9ee80$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $8bdf8b6b6bf9ee80$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $8bdf8b6b6bf9ee80$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $8bdf8b6b6bf9ee80$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $8bdf8b6b6bf9ee80$var$U = {
    current: null
}, $8bdf8b6b6bf9ee80$var$V = {
    transition: null
}, $8bdf8b6b6bf9ee80$var$W = {
    ReactCurrentDispatcher: $8bdf8b6b6bf9ee80$var$U,
    ReactCurrentBatchConfig: $8bdf8b6b6bf9ee80$var$V,
    ReactCurrentOwner: $8bdf8b6b6bf9ee80$var$K
};
$8bdf8b6b6bf9ee80$export$dca3b0875bd9a954 = {
    map: $8bdf8b6b6bf9ee80$var$S,
    forEach: function(a, b, e) {
        $8bdf8b6b6bf9ee80$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $8bdf8b6b6bf9ee80$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $8bdf8b6b6bf9ee80$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$8bdf8b6b6bf9ee80$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$8bdf8b6b6bf9ee80$export$16fa2f45be04daa8 = $8bdf8b6b6bf9ee80$var$E;
$8bdf8b6b6bf9ee80$export$ffb0004e005737fa = $8bdf8b6b6bf9ee80$var$p;
$8bdf8b6b6bf9ee80$export$e2c29f18771995cb = $8bdf8b6b6bf9ee80$var$r;
$8bdf8b6b6bf9ee80$export$221d75b3f55bb0bd = $8bdf8b6b6bf9ee80$var$G;
$8bdf8b6b6bf9ee80$export$5f8d39834fd61797 = $8bdf8b6b6bf9ee80$var$q;
$8bdf8b6b6bf9ee80$export$74bf444e3cd11ea5 = $8bdf8b6b6bf9ee80$var$w;
$8bdf8b6b6bf9ee80$export$ae55be85d98224ed = $8bdf8b6b6bf9ee80$var$W;
$8bdf8b6b6bf9ee80$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $8bdf8b6b6bf9ee80$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $8bdf8b6b6bf9ee80$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$8bdf8b6b6bf9ee80$var$J.call(b, f) && !$8bdf8b6b6bf9ee80$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $8bdf8b6b6bf9ee80$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$8bdf8b6b6bf9ee80$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $8bdf8b6b6bf9ee80$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $8bdf8b6b6bf9ee80$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$8bdf8b6b6bf9ee80$export$c8a8987d4410bf2d = $8bdf8b6b6bf9ee80$var$M;
$8bdf8b6b6bf9ee80$export$d38cd72104c1f0e9 = function(a) {
    var b = $8bdf8b6b6bf9ee80$var$M.bind(null, a);
    b.type = a;
    return b;
};
$8bdf8b6b6bf9ee80$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$8bdf8b6b6bf9ee80$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $8bdf8b6b6bf9ee80$var$v,
        render: a
    };
};
$8bdf8b6b6bf9ee80$export$a8257692ac88316c = $8bdf8b6b6bf9ee80$var$O;
$8bdf8b6b6bf9ee80$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $8bdf8b6b6bf9ee80$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $8bdf8b6b6bf9ee80$var$T
    };
};
$8bdf8b6b6bf9ee80$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $8bdf8b6b6bf9ee80$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$8bdf8b6b6bf9ee80$export$7568632d0d33d16d = function(a) {
    var b = $8bdf8b6b6bf9ee80$var$V.transition;
    $8bdf8b6b6bf9ee80$var$V.transition = {};
    try {
        a();
    } finally{
        $8bdf8b6b6bf9ee80$var$V.transition = b;
    }
};
$8bdf8b6b6bf9ee80$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$8bdf8b6b6bf9ee80$export$35808ee640e87ca7 = function(a, b) {
    return $8bdf8b6b6bf9ee80$var$U.current.useCallback(a, b);
};
$8bdf8b6b6bf9ee80$export$fae74005e78b1a27 = function(a) {
    return $8bdf8b6b6bf9ee80$var$U.current.useContext(a);
};
$8bdf8b6b6bf9ee80$export$dc8fbce3eb94dc1e = function() {};
$8bdf8b6b6bf9ee80$export$6a7bc4e911dc01cf = function(a) {
    return $8bdf8b6b6bf9ee80$var$U.current.useDeferredValue(a);
};
$8bdf8b6b6bf9ee80$export$6d9c69b0de29b591 = function(a, b) {
    return $8bdf8b6b6bf9ee80$var$U.current.useEffect(a, b);
};
$8bdf8b6b6bf9ee80$export$f680877a34711e37 = function() {
    return $8bdf8b6b6bf9ee80$var$U.current.useId();
};
$8bdf8b6b6bf9ee80$export$d5a552a76deda3c2 = function(a, b, e) {
    return $8bdf8b6b6bf9ee80$var$U.current.useImperativeHandle(a, b, e);
};
$8bdf8b6b6bf9ee80$export$aaabe4eda9ed9969 = function(a, b) {
    return $8bdf8b6b6bf9ee80$var$U.current.useInsertionEffect(a, b);
};
$8bdf8b6b6bf9ee80$export$e5c5a5f917a5871c = function(a, b) {
    return $8bdf8b6b6bf9ee80$var$U.current.useLayoutEffect(a, b);
};
$8bdf8b6b6bf9ee80$export$1538c33de8887b59 = function(a, b) {
    return $8bdf8b6b6bf9ee80$var$U.current.useMemo(a, b);
};
$8bdf8b6b6bf9ee80$export$13e3392192263954 = function(a, b, e) {
    return $8bdf8b6b6bf9ee80$var$U.current.useReducer(a, b, e);
};
$8bdf8b6b6bf9ee80$export$b8f5890fc79d6aca = function(a) {
    return $8bdf8b6b6bf9ee80$var$U.current.useRef(a);
};
$8bdf8b6b6bf9ee80$export$60241385465d0a34 = function(a) {
    return $8bdf8b6b6bf9ee80$var$U.current.useState(a);
};
$8bdf8b6b6bf9ee80$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $8bdf8b6b6bf9ee80$var$U.current.useSyncExternalStore(a, b, e);
};
$8bdf8b6b6bf9ee80$export$7b286972b8d8ccbf = function() {
    return $8bdf8b6b6bf9ee80$var$U.current.useTransition();
};
$8bdf8b6b6bf9ee80$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("fuyzp", function(module, exports) {
"use strict";
function $b474794392760152$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b474794392760152$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b474794392760152$var$checkDCE();

module.exports = (parcelRequire("4SqTK"));

});
parcelRegister("4SqTK", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $38d111fe5d5a6e3d$export$ae55be85d98224ed, (v) => $38d111fe5d5a6e3d$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $38d111fe5d5a6e3d$export$d39a5bbd09211389, (v) => $38d111fe5d5a6e3d$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $38d111fe5d5a6e3d$export$882461b6382ed46c, (v) => $38d111fe5d5a6e3d$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $38d111fe5d5a6e3d$export$466bfc07425424d5, (v) => $38d111fe5d5a6e3d$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $38d111fe5d5a6e3d$export$cd75ccfd720a3cd4, (v) => $38d111fe5d5a6e3d$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $38d111fe5d5a6e3d$export$fa8d919ba61d84db, (v) => $38d111fe5d5a6e3d$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $38d111fe5d5a6e3d$export$757ceba2d55c277e, (v) => $38d111fe5d5a6e3d$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $38d111fe5d5a6e3d$export$b3890eb0ae9dca99, (v) => $38d111fe5d5a6e3d$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $38d111fe5d5a6e3d$export$502457920280e6be, (v) => $38d111fe5d5a6e3d$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $38d111fe5d5a6e3d$export$c78a37762a8d58e1, (v) => $38d111fe5d5a6e3d$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $38d111fe5d5a6e3d$export$dc54d992c10e8a18, (v) => $38d111fe5d5a6e3d$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $38d111fe5d5a6e3d$export$83d89fbfd8236492, (v) => $38d111fe5d5a6e3d$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $38d111fe5d5a6e3d$export$ae55be85d98224ed;
var $38d111fe5d5a6e3d$export$d39a5bbd09211389;
var $38d111fe5d5a6e3d$export$882461b6382ed46c;
var $38d111fe5d5a6e3d$export$466bfc07425424d5;
var $38d111fe5d5a6e3d$export$cd75ccfd720a3cd4;
var $38d111fe5d5a6e3d$export$fa8d919ba61d84db;
var $38d111fe5d5a6e3d$export$757ceba2d55c277e;
var $38d111fe5d5a6e3d$export$b3890eb0ae9dca99;
var $38d111fe5d5a6e3d$export$502457920280e6be;
var $38d111fe5d5a6e3d$export$c78a37762a8d58e1;
var $38d111fe5d5a6e3d$export$dc54d992c10e8a18;
var $38d111fe5d5a6e3d$export$83d89fbfd8236492;
"use strict";

var $2gcPZ = parcelRequire("2gcPZ");

var $7ARQs = parcelRequire("7ARQs");
function $38d111fe5d5a6e3d$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $38d111fe5d5a6e3d$var$da = new Set, $38d111fe5d5a6e3d$var$ea = {};
function $38d111fe5d5a6e3d$var$fa(a, b) {
    $38d111fe5d5a6e3d$var$ha(a, b);
    $38d111fe5d5a6e3d$var$ha(a + "Capture", b);
}
function $38d111fe5d5a6e3d$var$ha(a, b) {
    $38d111fe5d5a6e3d$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$38d111fe5d5a6e3d$var$da.add(b[a]);
}
var $38d111fe5d5a6e3d$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $38d111fe5d5a6e3d$var$ja = Object.prototype.hasOwnProperty, $38d111fe5d5a6e3d$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $38d111fe5d5a6e3d$var$la = {}, $38d111fe5d5a6e3d$var$ma = {};
function $38d111fe5d5a6e3d$var$oa(a) {
    if ($38d111fe5d5a6e3d$var$ja.call($38d111fe5d5a6e3d$var$ma, a)) return !0;
    if ($38d111fe5d5a6e3d$var$ja.call($38d111fe5d5a6e3d$var$la, a)) return !1;
    if ($38d111fe5d5a6e3d$var$ka.test(a)) return $38d111fe5d5a6e3d$var$ma[a] = !0;
    $38d111fe5d5a6e3d$var$la[a] = !0;
    return !1;
}
function $38d111fe5d5a6e3d$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $38d111fe5d5a6e3d$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $38d111fe5d5a6e3d$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $38d111fe5d5a6e3d$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $38d111fe5d5a6e3d$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $38d111fe5d5a6e3d$var$z[a] = new $38d111fe5d5a6e3d$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $38d111fe5d5a6e3d$var$z[b] = new $38d111fe5d5a6e3d$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $38d111fe5d5a6e3d$var$z[a] = new $38d111fe5d5a6e3d$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $38d111fe5d5a6e3d$var$z[a] = new $38d111fe5d5a6e3d$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $38d111fe5d5a6e3d$var$z[a] = new $38d111fe5d5a6e3d$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $38d111fe5d5a6e3d$var$z[a] = new $38d111fe5d5a6e3d$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $38d111fe5d5a6e3d$var$z[a] = new $38d111fe5d5a6e3d$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $38d111fe5d5a6e3d$var$z[a] = new $38d111fe5d5a6e3d$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $38d111fe5d5a6e3d$var$z[a] = new $38d111fe5d5a6e3d$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $38d111fe5d5a6e3d$var$ra = /[\-:]([a-z])/g;
function $38d111fe5d5a6e3d$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($38d111fe5d5a6e3d$var$ra, $38d111fe5d5a6e3d$var$sa);
    $38d111fe5d5a6e3d$var$z[b] = new $38d111fe5d5a6e3d$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($38d111fe5d5a6e3d$var$ra, $38d111fe5d5a6e3d$var$sa);
    $38d111fe5d5a6e3d$var$z[b] = new $38d111fe5d5a6e3d$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($38d111fe5d5a6e3d$var$ra, $38d111fe5d5a6e3d$var$sa);
    $38d111fe5d5a6e3d$var$z[b] = new $38d111fe5d5a6e3d$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $38d111fe5d5a6e3d$var$z[a] = new $38d111fe5d5a6e3d$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$38d111fe5d5a6e3d$var$z.xlinkHref = new $38d111fe5d5a6e3d$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $38d111fe5d5a6e3d$var$z[a] = new $38d111fe5d5a6e3d$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $38d111fe5d5a6e3d$var$ta(a, b, c, d) {
    var e = $38d111fe5d5a6e3d$var$z.hasOwnProperty(b) ? $38d111fe5d5a6e3d$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $38d111fe5d5a6e3d$var$qa(b, c, e, d) && (c = null), d || null === e ? $38d111fe5d5a6e3d$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $38d111fe5d5a6e3d$var$ua = $2gcPZ.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $38d111fe5d5a6e3d$var$va = Symbol.for("react.element"), $38d111fe5d5a6e3d$var$wa = Symbol.for("react.portal"), $38d111fe5d5a6e3d$var$ya = Symbol.for("react.fragment"), $38d111fe5d5a6e3d$var$za = Symbol.for("react.strict_mode"), $38d111fe5d5a6e3d$var$Aa = Symbol.for("react.profiler"), $38d111fe5d5a6e3d$var$Ba = Symbol.for("react.provider"), $38d111fe5d5a6e3d$var$Ca = Symbol.for("react.context"), $38d111fe5d5a6e3d$var$Da = Symbol.for("react.forward_ref"), $38d111fe5d5a6e3d$var$Ea = Symbol.for("react.suspense"), $38d111fe5d5a6e3d$var$Fa = Symbol.for("react.suspense_list"), $38d111fe5d5a6e3d$var$Ga = Symbol.for("react.memo"), $38d111fe5d5a6e3d$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $38d111fe5d5a6e3d$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $38d111fe5d5a6e3d$var$Ja = Symbol.iterator;
function $38d111fe5d5a6e3d$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $38d111fe5d5a6e3d$var$Ja && a[$38d111fe5d5a6e3d$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $38d111fe5d5a6e3d$var$A = Object.assign, $38d111fe5d5a6e3d$var$La;
function $38d111fe5d5a6e3d$var$Ma(a) {
    if (void 0 === $38d111fe5d5a6e3d$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $38d111fe5d5a6e3d$var$La = b && b[1] || "";
    }
    return "\n" + $38d111fe5d5a6e3d$var$La + a;
}
var $38d111fe5d5a6e3d$var$Na = !1;
function $38d111fe5d5a6e3d$var$Oa(a, b) {
    if (!a || $38d111fe5d5a6e3d$var$Na) return "";
    $38d111fe5d5a6e3d$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $38d111fe5d5a6e3d$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $38d111fe5d5a6e3d$var$Ma(a) : "";
}
function $38d111fe5d5a6e3d$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $38d111fe5d5a6e3d$var$Ma(a.type);
        case 16:
            return $38d111fe5d5a6e3d$var$Ma("Lazy");
        case 13:
            return $38d111fe5d5a6e3d$var$Ma("Suspense");
        case 19:
            return $38d111fe5d5a6e3d$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $38d111fe5d5a6e3d$var$Oa(a.type, !1), a;
        case 11:
            return a = $38d111fe5d5a6e3d$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $38d111fe5d5a6e3d$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $38d111fe5d5a6e3d$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $38d111fe5d5a6e3d$var$ya:
            return "Fragment";
        case $38d111fe5d5a6e3d$var$wa:
            return "Portal";
        case $38d111fe5d5a6e3d$var$Aa:
            return "Profiler";
        case $38d111fe5d5a6e3d$var$za:
            return "StrictMode";
        case $38d111fe5d5a6e3d$var$Ea:
            return "Suspense";
        case $38d111fe5d5a6e3d$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $38d111fe5d5a6e3d$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $38d111fe5d5a6e3d$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $38d111fe5d5a6e3d$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $38d111fe5d5a6e3d$var$Ga:
            return b = a.displayName || null, null !== b ? b : $38d111fe5d5a6e3d$var$Qa(a.type) || "Memo";
        case $38d111fe5d5a6e3d$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $38d111fe5d5a6e3d$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $38d111fe5d5a6e3d$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $38d111fe5d5a6e3d$var$Qa(b);
        case 8:
            return b === $38d111fe5d5a6e3d$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $38d111fe5d5a6e3d$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $38d111fe5d5a6e3d$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $38d111fe5d5a6e3d$var$Ua(a) {
    var b = $38d111fe5d5a6e3d$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $38d111fe5d5a6e3d$var$Va(a) {
    a._valueTracker || (a._valueTracker = $38d111fe5d5a6e3d$var$Ua(a));
}
function $38d111fe5d5a6e3d$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $38d111fe5d5a6e3d$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $38d111fe5d5a6e3d$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $38d111fe5d5a6e3d$var$Ya(a, b) {
    var c = b.checked;
    return $38d111fe5d5a6e3d$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $38d111fe5d5a6e3d$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $38d111fe5d5a6e3d$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $38d111fe5d5a6e3d$var$ab(a, b) {
    b = b.checked;
    null != b && $38d111fe5d5a6e3d$var$ta(a, "checked", b, !1);
}
function $38d111fe5d5a6e3d$var$bb(a, b) {
    $38d111fe5d5a6e3d$var$ab(a, b);
    var c = $38d111fe5d5a6e3d$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $38d111fe5d5a6e3d$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $38d111fe5d5a6e3d$var$cb(a, b.type, $38d111fe5d5a6e3d$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $38d111fe5d5a6e3d$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $38d111fe5d5a6e3d$var$cb(a, b, c) {
    if ("number" !== b || $38d111fe5d5a6e3d$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $38d111fe5d5a6e3d$var$eb = Array.isArray;
function $38d111fe5d5a6e3d$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $38d111fe5d5a6e3d$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $38d111fe5d5a6e3d$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($38d111fe5d5a6e3d$var$p(91));
    return $38d111fe5d5a6e3d$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $38d111fe5d5a6e3d$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($38d111fe5d5a6e3d$var$p(92));
            if ($38d111fe5d5a6e3d$var$eb(c)) {
                if (1 < c.length) throw Error($38d111fe5d5a6e3d$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $38d111fe5d5a6e3d$var$Sa(c)
    };
}
function $38d111fe5d5a6e3d$var$ib(a, b) {
    var c = $38d111fe5d5a6e3d$var$Sa(b.value), d = $38d111fe5d5a6e3d$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $38d111fe5d5a6e3d$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $38d111fe5d5a6e3d$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $38d111fe5d5a6e3d$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $38d111fe5d5a6e3d$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $38d111fe5d5a6e3d$var$mb, $38d111fe5d5a6e3d$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $38d111fe5d5a6e3d$var$mb = $38d111fe5d5a6e3d$var$mb || document.createElement("div");
        $38d111fe5d5a6e3d$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $38d111fe5d5a6e3d$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $38d111fe5d5a6e3d$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $38d111fe5d5a6e3d$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $38d111fe5d5a6e3d$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($38d111fe5d5a6e3d$var$pb).forEach(function(a) {
    $38d111fe5d5a6e3d$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $38d111fe5d5a6e3d$var$pb[b] = $38d111fe5d5a6e3d$var$pb[a];
    });
});
function $38d111fe5d5a6e3d$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $38d111fe5d5a6e3d$var$pb.hasOwnProperty(a) && $38d111fe5d5a6e3d$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $38d111fe5d5a6e3d$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $38d111fe5d5a6e3d$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $38d111fe5d5a6e3d$var$tb = $38d111fe5d5a6e3d$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $38d111fe5d5a6e3d$var$ub(a, b) {
    if (b) {
        if ($38d111fe5d5a6e3d$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($38d111fe5d5a6e3d$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($38d111fe5d5a6e3d$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($38d111fe5d5a6e3d$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($38d111fe5d5a6e3d$var$p(62));
    }
}
function $38d111fe5d5a6e3d$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $38d111fe5d5a6e3d$var$wb = null;
function $38d111fe5d5a6e3d$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $38d111fe5d5a6e3d$var$yb = null, $38d111fe5d5a6e3d$var$zb = null, $38d111fe5d5a6e3d$var$Ab = null;
function $38d111fe5d5a6e3d$var$Bb(a) {
    if (a = $38d111fe5d5a6e3d$var$Cb(a)) {
        if ("function" !== typeof $38d111fe5d5a6e3d$var$yb) throw Error($38d111fe5d5a6e3d$var$p(280));
        var b = a.stateNode;
        b && (b = $38d111fe5d5a6e3d$var$Db(b), $38d111fe5d5a6e3d$var$yb(a.stateNode, a.type, b));
    }
}
function $38d111fe5d5a6e3d$var$Eb(a) {
    $38d111fe5d5a6e3d$var$zb ? $38d111fe5d5a6e3d$var$Ab ? $38d111fe5d5a6e3d$var$Ab.push(a) : $38d111fe5d5a6e3d$var$Ab = [
        a
    ] : $38d111fe5d5a6e3d$var$zb = a;
}
function $38d111fe5d5a6e3d$var$Fb() {
    if ($38d111fe5d5a6e3d$var$zb) {
        var a = $38d111fe5d5a6e3d$var$zb, b = $38d111fe5d5a6e3d$var$Ab;
        $38d111fe5d5a6e3d$var$Ab = $38d111fe5d5a6e3d$var$zb = null;
        $38d111fe5d5a6e3d$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$38d111fe5d5a6e3d$var$Bb(b[a]);
    }
}
function $38d111fe5d5a6e3d$var$Gb(a, b) {
    return a(b);
}
function $38d111fe5d5a6e3d$var$Hb() {}
var $38d111fe5d5a6e3d$var$Ib = !1;
function $38d111fe5d5a6e3d$var$Jb(a, b, c) {
    if ($38d111fe5d5a6e3d$var$Ib) return a(b, c);
    $38d111fe5d5a6e3d$var$Ib = !0;
    try {
        return $38d111fe5d5a6e3d$var$Gb(a, b, c);
    } finally{
        if ($38d111fe5d5a6e3d$var$Ib = !1, null !== $38d111fe5d5a6e3d$var$zb || null !== $38d111fe5d5a6e3d$var$Ab) $38d111fe5d5a6e3d$var$Hb(), $38d111fe5d5a6e3d$var$Fb();
    }
}
function $38d111fe5d5a6e3d$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $38d111fe5d5a6e3d$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($38d111fe5d5a6e3d$var$p(231, b, typeof c));
    return c;
}
var $38d111fe5d5a6e3d$var$Lb = !1;
if ($38d111fe5d5a6e3d$var$ia) try {
    var $38d111fe5d5a6e3d$var$Mb = {};
    Object.defineProperty($38d111fe5d5a6e3d$var$Mb, "passive", {
        get: function() {
            $38d111fe5d5a6e3d$var$Lb = !0;
        }
    });
    window.addEventListener("test", $38d111fe5d5a6e3d$var$Mb, $38d111fe5d5a6e3d$var$Mb);
    window.removeEventListener("test", $38d111fe5d5a6e3d$var$Mb, $38d111fe5d5a6e3d$var$Mb);
} catch (a) {
    $38d111fe5d5a6e3d$var$Lb = !1;
}
function $38d111fe5d5a6e3d$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $38d111fe5d5a6e3d$var$Ob = !1, $38d111fe5d5a6e3d$var$Pb = null, $38d111fe5d5a6e3d$var$Qb = !1, $38d111fe5d5a6e3d$var$Rb = null, $38d111fe5d5a6e3d$var$Sb = {
    onError: function(a) {
        $38d111fe5d5a6e3d$var$Ob = !0;
        $38d111fe5d5a6e3d$var$Pb = a;
    }
};
function $38d111fe5d5a6e3d$var$Tb(a, b, c, d, e, f, g, h, k) {
    $38d111fe5d5a6e3d$var$Ob = !1;
    $38d111fe5d5a6e3d$var$Pb = null;
    $38d111fe5d5a6e3d$var$Nb.apply($38d111fe5d5a6e3d$var$Sb, arguments);
}
function $38d111fe5d5a6e3d$var$Ub(a, b, c, d, e, f, g, h, k) {
    $38d111fe5d5a6e3d$var$Tb.apply(this, arguments);
    if ($38d111fe5d5a6e3d$var$Ob) {
        if ($38d111fe5d5a6e3d$var$Ob) {
            var l = $38d111fe5d5a6e3d$var$Pb;
            $38d111fe5d5a6e3d$var$Ob = !1;
            $38d111fe5d5a6e3d$var$Pb = null;
        } else throw Error($38d111fe5d5a6e3d$var$p(198));
        $38d111fe5d5a6e3d$var$Qb || ($38d111fe5d5a6e3d$var$Qb = !0, $38d111fe5d5a6e3d$var$Rb = l);
    }
}
function $38d111fe5d5a6e3d$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $38d111fe5d5a6e3d$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $38d111fe5d5a6e3d$var$Xb(a) {
    if ($38d111fe5d5a6e3d$var$Vb(a) !== a) throw Error($38d111fe5d5a6e3d$var$p(188));
}
function $38d111fe5d5a6e3d$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $38d111fe5d5a6e3d$var$Vb(a);
        if (null === b) throw Error($38d111fe5d5a6e3d$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $38d111fe5d5a6e3d$var$Xb(e), a;
                if (f === d) return $38d111fe5d5a6e3d$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($38d111fe5d5a6e3d$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($38d111fe5d5a6e3d$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($38d111fe5d5a6e3d$var$p(190));
    }
    if (3 !== c.tag) throw Error($38d111fe5d5a6e3d$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $38d111fe5d5a6e3d$var$Zb(a) {
    a = $38d111fe5d5a6e3d$var$Yb(a);
    return null !== a ? $38d111fe5d5a6e3d$var$$b(a) : null;
}
function $38d111fe5d5a6e3d$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $38d111fe5d5a6e3d$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $38d111fe5d5a6e3d$var$ac = $7ARQs.unstable_scheduleCallback, $38d111fe5d5a6e3d$var$bc = $7ARQs.unstable_cancelCallback, $38d111fe5d5a6e3d$var$cc = $7ARQs.unstable_shouldYield, $38d111fe5d5a6e3d$var$dc = $7ARQs.unstable_requestPaint, $38d111fe5d5a6e3d$var$B = $7ARQs.unstable_now, $38d111fe5d5a6e3d$var$ec = $7ARQs.unstable_getCurrentPriorityLevel, $38d111fe5d5a6e3d$var$fc = $7ARQs.unstable_ImmediatePriority, $38d111fe5d5a6e3d$var$gc = $7ARQs.unstable_UserBlockingPriority, $38d111fe5d5a6e3d$var$hc = $7ARQs.unstable_NormalPriority, $38d111fe5d5a6e3d$var$ic = $7ARQs.unstable_LowPriority, $38d111fe5d5a6e3d$var$jc = $7ARQs.unstable_IdlePriority, $38d111fe5d5a6e3d$var$kc = null, $38d111fe5d5a6e3d$var$lc = null;
function $38d111fe5d5a6e3d$var$mc(a) {
    if ($38d111fe5d5a6e3d$var$lc && "function" === typeof $38d111fe5d5a6e3d$var$lc.onCommitFiberRoot) try {
        $38d111fe5d5a6e3d$var$lc.onCommitFiberRoot($38d111fe5d5a6e3d$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $38d111fe5d5a6e3d$var$oc = Math.clz32 ? Math.clz32 : $38d111fe5d5a6e3d$var$nc, $38d111fe5d5a6e3d$var$pc = Math.log, $38d111fe5d5a6e3d$var$qc = Math.LN2;
function $38d111fe5d5a6e3d$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($38d111fe5d5a6e3d$var$pc(a) / $38d111fe5d5a6e3d$var$qc | 0) | 0;
}
var $38d111fe5d5a6e3d$var$rc = 64, $38d111fe5d5a6e3d$var$sc = 4194304;
function $38d111fe5d5a6e3d$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $38d111fe5d5a6e3d$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $38d111fe5d5a6e3d$var$tc(h) : (f &= g, 0 !== f && (d = $38d111fe5d5a6e3d$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $38d111fe5d5a6e3d$var$tc(g) : 0 !== f && (d = $38d111fe5d5a6e3d$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $38d111fe5d5a6e3d$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $38d111fe5d5a6e3d$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $38d111fe5d5a6e3d$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $38d111fe5d5a6e3d$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $38d111fe5d5a6e3d$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $38d111fe5d5a6e3d$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $38d111fe5d5a6e3d$var$yc() {
    var a = $38d111fe5d5a6e3d$var$rc;
    $38d111fe5d5a6e3d$var$rc <<= 1;
    0 === ($38d111fe5d5a6e3d$var$rc & 4194240) && ($38d111fe5d5a6e3d$var$rc = 64);
    return a;
}
function $38d111fe5d5a6e3d$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $38d111fe5d5a6e3d$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $38d111fe5d5a6e3d$var$oc(b);
    a[b] = c;
}
function $38d111fe5d5a6e3d$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $38d111fe5d5a6e3d$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $38d111fe5d5a6e3d$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $38d111fe5d5a6e3d$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $38d111fe5d5a6e3d$var$C = 0;
function $38d111fe5d5a6e3d$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $38d111fe5d5a6e3d$var$Ec, $38d111fe5d5a6e3d$var$Fc, $38d111fe5d5a6e3d$var$Gc, $38d111fe5d5a6e3d$var$Hc, $38d111fe5d5a6e3d$var$Ic, $38d111fe5d5a6e3d$var$Jc = !1, $38d111fe5d5a6e3d$var$Kc = [], $38d111fe5d5a6e3d$var$Lc = null, $38d111fe5d5a6e3d$var$Mc = null, $38d111fe5d5a6e3d$var$Nc = null, $38d111fe5d5a6e3d$var$Oc = new Map, $38d111fe5d5a6e3d$var$Pc = new Map, $38d111fe5d5a6e3d$var$Qc = [], $38d111fe5d5a6e3d$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $38d111fe5d5a6e3d$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $38d111fe5d5a6e3d$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $38d111fe5d5a6e3d$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $38d111fe5d5a6e3d$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $38d111fe5d5a6e3d$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $38d111fe5d5a6e3d$var$Pc.delete(b.pointerId);
    }
}
function $38d111fe5d5a6e3d$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $38d111fe5d5a6e3d$var$Cb(b), null !== b && $38d111fe5d5a6e3d$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $38d111fe5d5a6e3d$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $38d111fe5d5a6e3d$var$Lc = $38d111fe5d5a6e3d$var$Tc($38d111fe5d5a6e3d$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $38d111fe5d5a6e3d$var$Mc = $38d111fe5d5a6e3d$var$Tc($38d111fe5d5a6e3d$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $38d111fe5d5a6e3d$var$Nc = $38d111fe5d5a6e3d$var$Tc($38d111fe5d5a6e3d$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $38d111fe5d5a6e3d$var$Oc.set(f, $38d111fe5d5a6e3d$var$Tc($38d111fe5d5a6e3d$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $38d111fe5d5a6e3d$var$Pc.set(f, $38d111fe5d5a6e3d$var$Tc($38d111fe5d5a6e3d$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $38d111fe5d5a6e3d$var$Vc(a) {
    var b = $38d111fe5d5a6e3d$var$Wc(a.target);
    if (null !== b) {
        var c = $38d111fe5d5a6e3d$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $38d111fe5d5a6e3d$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $38d111fe5d5a6e3d$var$Ic(a.priority, function() {
                        $38d111fe5d5a6e3d$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $38d111fe5d5a6e3d$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $38d111fe5d5a6e3d$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $38d111fe5d5a6e3d$var$wb = d;
            c.target.dispatchEvent(d);
            $38d111fe5d5a6e3d$var$wb = null;
        } else return b = $38d111fe5d5a6e3d$var$Cb(c), null !== b && $38d111fe5d5a6e3d$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $38d111fe5d5a6e3d$var$Zc(a, b, c) {
    $38d111fe5d5a6e3d$var$Xc(a) && c.delete(b);
}
function $38d111fe5d5a6e3d$var$$c() {
    $38d111fe5d5a6e3d$var$Jc = !1;
    null !== $38d111fe5d5a6e3d$var$Lc && $38d111fe5d5a6e3d$var$Xc($38d111fe5d5a6e3d$var$Lc) && ($38d111fe5d5a6e3d$var$Lc = null);
    null !== $38d111fe5d5a6e3d$var$Mc && $38d111fe5d5a6e3d$var$Xc($38d111fe5d5a6e3d$var$Mc) && ($38d111fe5d5a6e3d$var$Mc = null);
    null !== $38d111fe5d5a6e3d$var$Nc && $38d111fe5d5a6e3d$var$Xc($38d111fe5d5a6e3d$var$Nc) && ($38d111fe5d5a6e3d$var$Nc = null);
    $38d111fe5d5a6e3d$var$Oc.forEach($38d111fe5d5a6e3d$var$Zc);
    $38d111fe5d5a6e3d$var$Pc.forEach($38d111fe5d5a6e3d$var$Zc);
}
function $38d111fe5d5a6e3d$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $38d111fe5d5a6e3d$var$Jc || ($38d111fe5d5a6e3d$var$Jc = !0, $7ARQs.unstable_scheduleCallback($7ARQs.unstable_NormalPriority, $38d111fe5d5a6e3d$var$$c)));
}
function $38d111fe5d5a6e3d$var$bd(a) {
    function b(b) {
        return $38d111fe5d5a6e3d$var$ad(b, a);
    }
    if (0 < $38d111fe5d5a6e3d$var$Kc.length) {
        $38d111fe5d5a6e3d$var$ad($38d111fe5d5a6e3d$var$Kc[0], a);
        for(var c = 1; c < $38d111fe5d5a6e3d$var$Kc.length; c++){
            var d = $38d111fe5d5a6e3d$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $38d111fe5d5a6e3d$var$Lc && $38d111fe5d5a6e3d$var$ad($38d111fe5d5a6e3d$var$Lc, a);
    null !== $38d111fe5d5a6e3d$var$Mc && $38d111fe5d5a6e3d$var$ad($38d111fe5d5a6e3d$var$Mc, a);
    null !== $38d111fe5d5a6e3d$var$Nc && $38d111fe5d5a6e3d$var$ad($38d111fe5d5a6e3d$var$Nc, a);
    $38d111fe5d5a6e3d$var$Oc.forEach(b);
    $38d111fe5d5a6e3d$var$Pc.forEach(b);
    for(c = 0; c < $38d111fe5d5a6e3d$var$Qc.length; c++)d = $38d111fe5d5a6e3d$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $38d111fe5d5a6e3d$var$Qc.length && (c = $38d111fe5d5a6e3d$var$Qc[0], null === c.blockedOn);)$38d111fe5d5a6e3d$var$Vc(c), null === c.blockedOn && $38d111fe5d5a6e3d$var$Qc.shift();
}
var $38d111fe5d5a6e3d$var$cd = $38d111fe5d5a6e3d$var$ua.ReactCurrentBatchConfig, $38d111fe5d5a6e3d$var$dd = !0;
function $38d111fe5d5a6e3d$var$ed(a, b, c, d) {
    var e = $38d111fe5d5a6e3d$var$C, f = $38d111fe5d5a6e3d$var$cd.transition;
    $38d111fe5d5a6e3d$var$cd.transition = null;
    try {
        $38d111fe5d5a6e3d$var$C = 1, $38d111fe5d5a6e3d$var$fd(a, b, c, d);
    } finally{
        $38d111fe5d5a6e3d$var$C = e, $38d111fe5d5a6e3d$var$cd.transition = f;
    }
}
function $38d111fe5d5a6e3d$var$gd(a, b, c, d) {
    var e = $38d111fe5d5a6e3d$var$C, f = $38d111fe5d5a6e3d$var$cd.transition;
    $38d111fe5d5a6e3d$var$cd.transition = null;
    try {
        $38d111fe5d5a6e3d$var$C = 4, $38d111fe5d5a6e3d$var$fd(a, b, c, d);
    } finally{
        $38d111fe5d5a6e3d$var$C = e, $38d111fe5d5a6e3d$var$cd.transition = f;
    }
}
function $38d111fe5d5a6e3d$var$fd(a, b, c, d) {
    if ($38d111fe5d5a6e3d$var$dd) {
        var e = $38d111fe5d5a6e3d$var$Yc(a, b, c, d);
        if (null === e) $38d111fe5d5a6e3d$var$hd(a, b, d, $38d111fe5d5a6e3d$var$id, c), $38d111fe5d5a6e3d$var$Sc(a, d);
        else if ($38d111fe5d5a6e3d$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($38d111fe5d5a6e3d$var$Sc(a, d), b & 4 && -1 < $38d111fe5d5a6e3d$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $38d111fe5d5a6e3d$var$Cb(e);
                null !== f && $38d111fe5d5a6e3d$var$Ec(f);
                f = $38d111fe5d5a6e3d$var$Yc(a, b, c, d);
                null === f && $38d111fe5d5a6e3d$var$hd(a, b, d, $38d111fe5d5a6e3d$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $38d111fe5d5a6e3d$var$hd(a, b, d, null, c);
    }
}
var $38d111fe5d5a6e3d$var$id = null;
function $38d111fe5d5a6e3d$var$Yc(a, b, c, d) {
    $38d111fe5d5a6e3d$var$id = null;
    a = $38d111fe5d5a6e3d$var$xb(d);
    a = $38d111fe5d5a6e3d$var$Wc(a);
    if (null !== a) {
        if (b = $38d111fe5d5a6e3d$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $38d111fe5d5a6e3d$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $38d111fe5d5a6e3d$var$id = a;
    return null;
}
function $38d111fe5d5a6e3d$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($38d111fe5d5a6e3d$var$ec()){
                case $38d111fe5d5a6e3d$var$fc:
                    return 1;
                case $38d111fe5d5a6e3d$var$gc:
                    return 4;
                case $38d111fe5d5a6e3d$var$hc:
                case $38d111fe5d5a6e3d$var$ic:
                    return 16;
                case $38d111fe5d5a6e3d$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $38d111fe5d5a6e3d$var$kd = null, $38d111fe5d5a6e3d$var$ld = null, $38d111fe5d5a6e3d$var$md = null;
function $38d111fe5d5a6e3d$var$nd() {
    if ($38d111fe5d5a6e3d$var$md) return $38d111fe5d5a6e3d$var$md;
    var a, b = $38d111fe5d5a6e3d$var$ld, c = b.length, d, e = "value" in $38d111fe5d5a6e3d$var$kd ? $38d111fe5d5a6e3d$var$kd.value : $38d111fe5d5a6e3d$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $38d111fe5d5a6e3d$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $38d111fe5d5a6e3d$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $38d111fe5d5a6e3d$var$pd() {
    return !0;
}
function $38d111fe5d5a6e3d$var$qd() {
    return !1;
}
function $38d111fe5d5a6e3d$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $38d111fe5d5a6e3d$var$pd : $38d111fe5d5a6e3d$var$qd;
        this.isPropagationStopped = $38d111fe5d5a6e3d$var$qd;
        return this;
    }
    $38d111fe5d5a6e3d$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $38d111fe5d5a6e3d$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $38d111fe5d5a6e3d$var$pd);
        },
        persist: function() {},
        isPersistent: $38d111fe5d5a6e3d$var$pd
    });
    return b;
}
var $38d111fe5d5a6e3d$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $38d111fe5d5a6e3d$var$td = $38d111fe5d5a6e3d$var$rd($38d111fe5d5a6e3d$var$sd), $38d111fe5d5a6e3d$var$ud = $38d111fe5d5a6e3d$var$A({}, $38d111fe5d5a6e3d$var$sd, {
    view: 0,
    detail: 0
}), $38d111fe5d5a6e3d$var$vd = $38d111fe5d5a6e3d$var$rd($38d111fe5d5a6e3d$var$ud), $38d111fe5d5a6e3d$var$wd, $38d111fe5d5a6e3d$var$xd, $38d111fe5d5a6e3d$var$yd, $38d111fe5d5a6e3d$var$Ad = $38d111fe5d5a6e3d$var$A({}, $38d111fe5d5a6e3d$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $38d111fe5d5a6e3d$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $38d111fe5d5a6e3d$var$yd && ($38d111fe5d5a6e3d$var$yd && "mousemove" === a.type ? ($38d111fe5d5a6e3d$var$wd = a.screenX - $38d111fe5d5a6e3d$var$yd.screenX, $38d111fe5d5a6e3d$var$xd = a.screenY - $38d111fe5d5a6e3d$var$yd.screenY) : $38d111fe5d5a6e3d$var$xd = $38d111fe5d5a6e3d$var$wd = 0, $38d111fe5d5a6e3d$var$yd = a);
        return $38d111fe5d5a6e3d$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $38d111fe5d5a6e3d$var$xd;
    }
}), $38d111fe5d5a6e3d$var$Bd = $38d111fe5d5a6e3d$var$rd($38d111fe5d5a6e3d$var$Ad), $38d111fe5d5a6e3d$var$Cd = $38d111fe5d5a6e3d$var$A({}, $38d111fe5d5a6e3d$var$Ad, {
    dataTransfer: 0
}), $38d111fe5d5a6e3d$var$Dd = $38d111fe5d5a6e3d$var$rd($38d111fe5d5a6e3d$var$Cd), $38d111fe5d5a6e3d$var$Ed = $38d111fe5d5a6e3d$var$A({}, $38d111fe5d5a6e3d$var$ud, {
    relatedTarget: 0
}), $38d111fe5d5a6e3d$var$Fd = $38d111fe5d5a6e3d$var$rd($38d111fe5d5a6e3d$var$Ed), $38d111fe5d5a6e3d$var$Gd = $38d111fe5d5a6e3d$var$A({}, $38d111fe5d5a6e3d$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $38d111fe5d5a6e3d$var$Hd = $38d111fe5d5a6e3d$var$rd($38d111fe5d5a6e3d$var$Gd), $38d111fe5d5a6e3d$var$Id = $38d111fe5d5a6e3d$var$A({}, $38d111fe5d5a6e3d$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $38d111fe5d5a6e3d$var$Jd = $38d111fe5d5a6e3d$var$rd($38d111fe5d5a6e3d$var$Id), $38d111fe5d5a6e3d$var$Kd = $38d111fe5d5a6e3d$var$A({}, $38d111fe5d5a6e3d$var$sd, {
    data: 0
}), $38d111fe5d5a6e3d$var$Ld = $38d111fe5d5a6e3d$var$rd($38d111fe5d5a6e3d$var$Kd), $38d111fe5d5a6e3d$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $38d111fe5d5a6e3d$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $38d111fe5d5a6e3d$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $38d111fe5d5a6e3d$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $38d111fe5d5a6e3d$var$Od[a]) ? !!b[a] : !1;
}
function $38d111fe5d5a6e3d$var$zd() {
    return $38d111fe5d5a6e3d$var$Pd;
}
var $38d111fe5d5a6e3d$var$Qd = $38d111fe5d5a6e3d$var$A({}, $38d111fe5d5a6e3d$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $38d111fe5d5a6e3d$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $38d111fe5d5a6e3d$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $38d111fe5d5a6e3d$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $38d111fe5d5a6e3d$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $38d111fe5d5a6e3d$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $38d111fe5d5a6e3d$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $38d111fe5d5a6e3d$var$Rd = $38d111fe5d5a6e3d$var$rd($38d111fe5d5a6e3d$var$Qd), $38d111fe5d5a6e3d$var$Sd = $38d111fe5d5a6e3d$var$A({}, $38d111fe5d5a6e3d$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $38d111fe5d5a6e3d$var$Td = $38d111fe5d5a6e3d$var$rd($38d111fe5d5a6e3d$var$Sd), $38d111fe5d5a6e3d$var$Ud = $38d111fe5d5a6e3d$var$A({}, $38d111fe5d5a6e3d$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $38d111fe5d5a6e3d$var$zd
}), $38d111fe5d5a6e3d$var$Vd = $38d111fe5d5a6e3d$var$rd($38d111fe5d5a6e3d$var$Ud), $38d111fe5d5a6e3d$var$Wd = $38d111fe5d5a6e3d$var$A({}, $38d111fe5d5a6e3d$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $38d111fe5d5a6e3d$var$Xd = $38d111fe5d5a6e3d$var$rd($38d111fe5d5a6e3d$var$Wd), $38d111fe5d5a6e3d$var$Yd = $38d111fe5d5a6e3d$var$A({}, $38d111fe5d5a6e3d$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $38d111fe5d5a6e3d$var$Zd = $38d111fe5d5a6e3d$var$rd($38d111fe5d5a6e3d$var$Yd), $38d111fe5d5a6e3d$var$$d = [
    9,
    13,
    27,
    32
], $38d111fe5d5a6e3d$var$ae = $38d111fe5d5a6e3d$var$ia && "CompositionEvent" in window, $38d111fe5d5a6e3d$var$be = null;
$38d111fe5d5a6e3d$var$ia && "documentMode" in document && ($38d111fe5d5a6e3d$var$be = document.documentMode);
var $38d111fe5d5a6e3d$var$ce = $38d111fe5d5a6e3d$var$ia && "TextEvent" in window && !$38d111fe5d5a6e3d$var$be, $38d111fe5d5a6e3d$var$de = $38d111fe5d5a6e3d$var$ia && (!$38d111fe5d5a6e3d$var$ae || $38d111fe5d5a6e3d$var$be && 8 < $38d111fe5d5a6e3d$var$be && 11 >= $38d111fe5d5a6e3d$var$be), $38d111fe5d5a6e3d$var$ee = String.fromCharCode(32), $38d111fe5d5a6e3d$var$fe = !1;
function $38d111fe5d5a6e3d$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $38d111fe5d5a6e3d$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $38d111fe5d5a6e3d$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $38d111fe5d5a6e3d$var$ie = !1;
function $38d111fe5d5a6e3d$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $38d111fe5d5a6e3d$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $38d111fe5d5a6e3d$var$fe = !0;
            return $38d111fe5d5a6e3d$var$ee;
        case "textInput":
            return a = b.data, a === $38d111fe5d5a6e3d$var$ee && $38d111fe5d5a6e3d$var$fe ? null : a;
        default:
            return null;
    }
}
function $38d111fe5d5a6e3d$var$ke(a, b) {
    if ($38d111fe5d5a6e3d$var$ie) return "compositionend" === a || !$38d111fe5d5a6e3d$var$ae && $38d111fe5d5a6e3d$var$ge(a, b) ? (a = $38d111fe5d5a6e3d$var$nd(), $38d111fe5d5a6e3d$var$md = $38d111fe5d5a6e3d$var$ld = $38d111fe5d5a6e3d$var$kd = null, $38d111fe5d5a6e3d$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $38d111fe5d5a6e3d$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $38d111fe5d5a6e3d$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $38d111fe5d5a6e3d$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$38d111fe5d5a6e3d$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $38d111fe5d5a6e3d$var$ne(a, b, c, d) {
    $38d111fe5d5a6e3d$var$Eb(d);
    b = $38d111fe5d5a6e3d$var$oe(b, "onChange");
    0 < b.length && (c = new $38d111fe5d5a6e3d$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $38d111fe5d5a6e3d$var$pe = null, $38d111fe5d5a6e3d$var$qe = null;
function $38d111fe5d5a6e3d$var$re(a) {
    $38d111fe5d5a6e3d$var$se(a, 0);
}
function $38d111fe5d5a6e3d$var$te(a) {
    var b = $38d111fe5d5a6e3d$var$ue(a);
    if ($38d111fe5d5a6e3d$var$Wa(b)) return a;
}
function $38d111fe5d5a6e3d$var$ve(a, b) {
    if ("change" === a) return b;
}
var $38d111fe5d5a6e3d$var$we = !1;
if ($38d111fe5d5a6e3d$var$ia) {
    var $38d111fe5d5a6e3d$var$xe;
    if ($38d111fe5d5a6e3d$var$ia) {
        var $38d111fe5d5a6e3d$var$ye = "oninput" in document;
        if (!$38d111fe5d5a6e3d$var$ye) {
            var $38d111fe5d5a6e3d$var$ze = document.createElement("div");
            $38d111fe5d5a6e3d$var$ze.setAttribute("oninput", "return;");
            $38d111fe5d5a6e3d$var$ye = "function" === typeof $38d111fe5d5a6e3d$var$ze.oninput;
        }
        $38d111fe5d5a6e3d$var$xe = $38d111fe5d5a6e3d$var$ye;
    } else $38d111fe5d5a6e3d$var$xe = !1;
    $38d111fe5d5a6e3d$var$we = $38d111fe5d5a6e3d$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $38d111fe5d5a6e3d$var$Ae() {
    $38d111fe5d5a6e3d$var$pe && ($38d111fe5d5a6e3d$var$pe.detachEvent("onpropertychange", $38d111fe5d5a6e3d$var$Be), $38d111fe5d5a6e3d$var$qe = $38d111fe5d5a6e3d$var$pe = null);
}
function $38d111fe5d5a6e3d$var$Be(a) {
    if ("value" === a.propertyName && $38d111fe5d5a6e3d$var$te($38d111fe5d5a6e3d$var$qe)) {
        var b = [];
        $38d111fe5d5a6e3d$var$ne(b, $38d111fe5d5a6e3d$var$qe, a, $38d111fe5d5a6e3d$var$xb(a));
        $38d111fe5d5a6e3d$var$Jb($38d111fe5d5a6e3d$var$re, b);
    }
}
function $38d111fe5d5a6e3d$var$Ce(a, b, c) {
    "focusin" === a ? ($38d111fe5d5a6e3d$var$Ae(), $38d111fe5d5a6e3d$var$pe = b, $38d111fe5d5a6e3d$var$qe = c, $38d111fe5d5a6e3d$var$pe.attachEvent("onpropertychange", $38d111fe5d5a6e3d$var$Be)) : "focusout" === a && $38d111fe5d5a6e3d$var$Ae();
}
function $38d111fe5d5a6e3d$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $38d111fe5d5a6e3d$var$te($38d111fe5d5a6e3d$var$qe);
}
function $38d111fe5d5a6e3d$var$Ee(a, b) {
    if ("click" === a) return $38d111fe5d5a6e3d$var$te(b);
}
function $38d111fe5d5a6e3d$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $38d111fe5d5a6e3d$var$te(b);
}
function $38d111fe5d5a6e3d$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $38d111fe5d5a6e3d$var$He = "function" === typeof Object.is ? Object.is : $38d111fe5d5a6e3d$var$Ge;
function $38d111fe5d5a6e3d$var$Ie(a, b) {
    if ($38d111fe5d5a6e3d$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$38d111fe5d5a6e3d$var$ja.call(b, e) || !$38d111fe5d5a6e3d$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $38d111fe5d5a6e3d$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $38d111fe5d5a6e3d$var$Ke(a, b) {
    var c = $38d111fe5d5a6e3d$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $38d111fe5d5a6e3d$var$Je(c);
    }
}
function $38d111fe5d5a6e3d$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $38d111fe5d5a6e3d$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $38d111fe5d5a6e3d$var$Me() {
    for(var a = window, b = $38d111fe5d5a6e3d$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $38d111fe5d5a6e3d$var$Xa(a.document);
    }
    return b;
}
function $38d111fe5d5a6e3d$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $38d111fe5d5a6e3d$var$Oe(a) {
    var b = $38d111fe5d5a6e3d$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $38d111fe5d5a6e3d$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $38d111fe5d5a6e3d$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $38d111fe5d5a6e3d$var$Ke(c, f);
                var g = $38d111fe5d5a6e3d$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $38d111fe5d5a6e3d$var$Pe = $38d111fe5d5a6e3d$var$ia && "documentMode" in document && 11 >= document.documentMode, $38d111fe5d5a6e3d$var$Qe = null, $38d111fe5d5a6e3d$var$Re = null, $38d111fe5d5a6e3d$var$Se = null, $38d111fe5d5a6e3d$var$Te = !1;
function $38d111fe5d5a6e3d$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $38d111fe5d5a6e3d$var$Te || null == $38d111fe5d5a6e3d$var$Qe || $38d111fe5d5a6e3d$var$Qe !== $38d111fe5d5a6e3d$var$Xa(d) || (d = $38d111fe5d5a6e3d$var$Qe, "selectionStart" in d && $38d111fe5d5a6e3d$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $38d111fe5d5a6e3d$var$Se && $38d111fe5d5a6e3d$var$Ie($38d111fe5d5a6e3d$var$Se, d) || ($38d111fe5d5a6e3d$var$Se = d, d = $38d111fe5d5a6e3d$var$oe($38d111fe5d5a6e3d$var$Re, "onSelect"), 0 < d.length && (b = new $38d111fe5d5a6e3d$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $38d111fe5d5a6e3d$var$Qe)));
}
function $38d111fe5d5a6e3d$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $38d111fe5d5a6e3d$var$We = {
    animationend: $38d111fe5d5a6e3d$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $38d111fe5d5a6e3d$var$Ve("Animation", "AnimationIteration"),
    animationstart: $38d111fe5d5a6e3d$var$Ve("Animation", "AnimationStart"),
    transitionend: $38d111fe5d5a6e3d$var$Ve("Transition", "TransitionEnd")
}, $38d111fe5d5a6e3d$var$Xe = {}, $38d111fe5d5a6e3d$var$Ye = {};
$38d111fe5d5a6e3d$var$ia && ($38d111fe5d5a6e3d$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $38d111fe5d5a6e3d$var$We.animationend.animation, delete $38d111fe5d5a6e3d$var$We.animationiteration.animation, delete $38d111fe5d5a6e3d$var$We.animationstart.animation), "TransitionEvent" in window || delete $38d111fe5d5a6e3d$var$We.transitionend.transition);
function $38d111fe5d5a6e3d$var$Ze(a) {
    if ($38d111fe5d5a6e3d$var$Xe[a]) return $38d111fe5d5a6e3d$var$Xe[a];
    if (!$38d111fe5d5a6e3d$var$We[a]) return a;
    var b = $38d111fe5d5a6e3d$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $38d111fe5d5a6e3d$var$Ye) return $38d111fe5d5a6e3d$var$Xe[a] = b[c];
    return a;
}
var $38d111fe5d5a6e3d$var$$e = $38d111fe5d5a6e3d$var$Ze("animationend"), $38d111fe5d5a6e3d$var$af = $38d111fe5d5a6e3d$var$Ze("animationiteration"), $38d111fe5d5a6e3d$var$bf = $38d111fe5d5a6e3d$var$Ze("animationstart"), $38d111fe5d5a6e3d$var$cf = $38d111fe5d5a6e3d$var$Ze("transitionend"), $38d111fe5d5a6e3d$var$df = new Map, $38d111fe5d5a6e3d$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $38d111fe5d5a6e3d$var$ff(a, b) {
    $38d111fe5d5a6e3d$var$df.set(a, b);
    $38d111fe5d5a6e3d$var$fa(b, [
        a
    ]);
}
for(var $38d111fe5d5a6e3d$var$gf = 0; $38d111fe5d5a6e3d$var$gf < $38d111fe5d5a6e3d$var$ef.length; $38d111fe5d5a6e3d$var$gf++){
    var $38d111fe5d5a6e3d$var$hf = $38d111fe5d5a6e3d$var$ef[$38d111fe5d5a6e3d$var$gf], $38d111fe5d5a6e3d$var$jf = $38d111fe5d5a6e3d$var$hf.toLowerCase(), $38d111fe5d5a6e3d$var$kf = $38d111fe5d5a6e3d$var$hf[0].toUpperCase() + $38d111fe5d5a6e3d$var$hf.slice(1);
    $38d111fe5d5a6e3d$var$ff($38d111fe5d5a6e3d$var$jf, "on" + $38d111fe5d5a6e3d$var$kf);
}
$38d111fe5d5a6e3d$var$ff($38d111fe5d5a6e3d$var$$e, "onAnimationEnd");
$38d111fe5d5a6e3d$var$ff($38d111fe5d5a6e3d$var$af, "onAnimationIteration");
$38d111fe5d5a6e3d$var$ff($38d111fe5d5a6e3d$var$bf, "onAnimationStart");
$38d111fe5d5a6e3d$var$ff("dblclick", "onDoubleClick");
$38d111fe5d5a6e3d$var$ff("focusin", "onFocus");
$38d111fe5d5a6e3d$var$ff("focusout", "onBlur");
$38d111fe5d5a6e3d$var$ff($38d111fe5d5a6e3d$var$cf, "onTransitionEnd");
$38d111fe5d5a6e3d$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$38d111fe5d5a6e3d$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$38d111fe5d5a6e3d$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$38d111fe5d5a6e3d$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$38d111fe5d5a6e3d$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$38d111fe5d5a6e3d$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$38d111fe5d5a6e3d$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$38d111fe5d5a6e3d$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$38d111fe5d5a6e3d$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$38d111fe5d5a6e3d$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $38d111fe5d5a6e3d$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $38d111fe5d5a6e3d$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($38d111fe5d5a6e3d$var$lf));
function $38d111fe5d5a6e3d$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $38d111fe5d5a6e3d$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $38d111fe5d5a6e3d$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $38d111fe5d5a6e3d$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $38d111fe5d5a6e3d$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($38d111fe5d5a6e3d$var$Qb) throw a = $38d111fe5d5a6e3d$var$Rb, $38d111fe5d5a6e3d$var$Qb = !1, $38d111fe5d5a6e3d$var$Rb = null, a;
}
function $38d111fe5d5a6e3d$var$D(a, b) {
    var c = b[$38d111fe5d5a6e3d$var$of];
    void 0 === c && (c = b[$38d111fe5d5a6e3d$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($38d111fe5d5a6e3d$var$pf(b, a, 2, !1), c.add(d));
}
function $38d111fe5d5a6e3d$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $38d111fe5d5a6e3d$var$pf(c, a, d, b);
}
var $38d111fe5d5a6e3d$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $38d111fe5d5a6e3d$var$sf(a) {
    if (!a[$38d111fe5d5a6e3d$var$rf]) {
        a[$38d111fe5d5a6e3d$var$rf] = !0;
        $38d111fe5d5a6e3d$var$da.forEach(function(b) {
            "selectionchange" !== b && ($38d111fe5d5a6e3d$var$mf.has(b) || $38d111fe5d5a6e3d$var$qf(b, !1, a), $38d111fe5d5a6e3d$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$38d111fe5d5a6e3d$var$rf] || (b[$38d111fe5d5a6e3d$var$rf] = !0, $38d111fe5d5a6e3d$var$qf("selectionchange", !1, b));
    }
}
function $38d111fe5d5a6e3d$var$pf(a, b, c, d) {
    switch($38d111fe5d5a6e3d$var$jd(b)){
        case 1:
            var e = $38d111fe5d5a6e3d$var$ed;
            break;
        case 4:
            e = $38d111fe5d5a6e3d$var$gd;
            break;
        default:
            e = $38d111fe5d5a6e3d$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$38d111fe5d5a6e3d$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $38d111fe5d5a6e3d$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $38d111fe5d5a6e3d$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $38d111fe5d5a6e3d$var$Jb(function() {
        var d = f, e = $38d111fe5d5a6e3d$var$xb(c), g = [];
        a: {
            var h = $38d111fe5d5a6e3d$var$df.get(a);
            if (void 0 !== h) {
                var k = $38d111fe5d5a6e3d$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $38d111fe5d5a6e3d$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $38d111fe5d5a6e3d$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $38d111fe5d5a6e3d$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $38d111fe5d5a6e3d$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $38d111fe5d5a6e3d$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $38d111fe5d5a6e3d$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $38d111fe5d5a6e3d$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $38d111fe5d5a6e3d$var$Vd;
                        break;
                    case $38d111fe5d5a6e3d$var$$e:
                    case $38d111fe5d5a6e3d$var$af:
                    case $38d111fe5d5a6e3d$var$bf:
                        k = $38d111fe5d5a6e3d$var$Hd;
                        break;
                    case $38d111fe5d5a6e3d$var$cf:
                        k = $38d111fe5d5a6e3d$var$Xd;
                        break;
                    case "scroll":
                        k = $38d111fe5d5a6e3d$var$vd;
                        break;
                    case "wheel":
                        k = $38d111fe5d5a6e3d$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $38d111fe5d5a6e3d$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $38d111fe5d5a6e3d$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $38d111fe5d5a6e3d$var$Kb(w, x), null != F && t.push($38d111fe5d5a6e3d$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $38d111fe5d5a6e3d$var$wb && (n = c.relatedTarget || c.fromElement) && ($38d111fe5d5a6e3d$var$Wc(n) || n[$38d111fe5d5a6e3d$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $38d111fe5d5a6e3d$var$Wc(n) : null, null !== n && (J = $38d111fe5d5a6e3d$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $38d111fe5d5a6e3d$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $38d111fe5d5a6e3d$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $38d111fe5d5a6e3d$var$ue(k);
                        u = null == n ? h : $38d111fe5d5a6e3d$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $38d111fe5d5a6e3d$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $38d111fe5d5a6e3d$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $38d111fe5d5a6e3d$var$vf(F))u++;
                            for(; 0 < w - u;)t = $38d111fe5d5a6e3d$var$vf(t), w--;
                            for(; 0 < u - w;)x = $38d111fe5d5a6e3d$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $38d111fe5d5a6e3d$var$vf(t);
                                x = $38d111fe5d5a6e3d$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $38d111fe5d5a6e3d$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $38d111fe5d5a6e3d$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $38d111fe5d5a6e3d$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $38d111fe5d5a6e3d$var$ve;
                else if ($38d111fe5d5a6e3d$var$me(h)) {
                    if ($38d111fe5d5a6e3d$var$we) na = $38d111fe5d5a6e3d$var$Fe;
                    else {
                        na = $38d111fe5d5a6e3d$var$De;
                        var xa = $38d111fe5d5a6e3d$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $38d111fe5d5a6e3d$var$Ee);
                if (na && (na = na(a, d))) {
                    $38d111fe5d5a6e3d$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $38d111fe5d5a6e3d$var$cb(h, "number", h.value);
            }
            xa = d ? $38d111fe5d5a6e3d$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($38d111fe5d5a6e3d$var$me(xa) || "true" === xa.contentEditable) $38d111fe5d5a6e3d$var$Qe = xa, $38d111fe5d5a6e3d$var$Re = d, $38d111fe5d5a6e3d$var$Se = null;
                    break;
                case "focusout":
                    $38d111fe5d5a6e3d$var$Se = $38d111fe5d5a6e3d$var$Re = $38d111fe5d5a6e3d$var$Qe = null;
                    break;
                case "mousedown":
                    $38d111fe5d5a6e3d$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $38d111fe5d5a6e3d$var$Te = !1;
                    $38d111fe5d5a6e3d$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($38d111fe5d5a6e3d$var$Pe) break;
                case "keydown":
                case "keyup":
                    $38d111fe5d5a6e3d$var$Ue(g, c, e);
            }
            var $a;
            if ($38d111fe5d5a6e3d$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $38d111fe5d5a6e3d$var$ie ? $38d111fe5d5a6e3d$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($38d111fe5d5a6e3d$var$de && "ko" !== c.locale && ($38d111fe5d5a6e3d$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $38d111fe5d5a6e3d$var$ie && ($a = $38d111fe5d5a6e3d$var$nd()) : ($38d111fe5d5a6e3d$var$kd = e, $38d111fe5d5a6e3d$var$ld = "value" in $38d111fe5d5a6e3d$var$kd ? $38d111fe5d5a6e3d$var$kd.value : $38d111fe5d5a6e3d$var$kd.textContent, $38d111fe5d5a6e3d$var$ie = !0)), xa = $38d111fe5d5a6e3d$var$oe(d, ba), 0 < xa.length && (ba = new $38d111fe5d5a6e3d$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $38d111fe5d5a6e3d$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $38d111fe5d5a6e3d$var$ce ? $38d111fe5d5a6e3d$var$je(a, c) : $38d111fe5d5a6e3d$var$ke(a, c)) d = $38d111fe5d5a6e3d$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $38d111fe5d5a6e3d$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $38d111fe5d5a6e3d$var$se(g, b);
    });
}
function $38d111fe5d5a6e3d$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $38d111fe5d5a6e3d$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $38d111fe5d5a6e3d$var$Kb(a, c), null != f && d.unshift($38d111fe5d5a6e3d$var$tf(a, f, e)), f = $38d111fe5d5a6e3d$var$Kb(a, b), null != f && d.push($38d111fe5d5a6e3d$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $38d111fe5d5a6e3d$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $38d111fe5d5a6e3d$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $38d111fe5d5a6e3d$var$Kb(c, f), null != k && g.unshift($38d111fe5d5a6e3d$var$tf(c, k, h))) : e || (k = $38d111fe5d5a6e3d$var$Kb(c, f), null != k && g.push($38d111fe5d5a6e3d$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $38d111fe5d5a6e3d$var$xf = /\r\n?/g, $38d111fe5d5a6e3d$var$yf = /\u0000|\uFFFD/g;
function $38d111fe5d5a6e3d$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($38d111fe5d5a6e3d$var$xf, "\n").replace($38d111fe5d5a6e3d$var$yf, "");
}
function $38d111fe5d5a6e3d$var$Af(a, b, c) {
    b = $38d111fe5d5a6e3d$var$zf(b);
    if ($38d111fe5d5a6e3d$var$zf(a) !== b && c) throw Error($38d111fe5d5a6e3d$var$p(425));
}
function $38d111fe5d5a6e3d$var$Bf() {}
var $38d111fe5d5a6e3d$var$Cf = null, $38d111fe5d5a6e3d$var$Df = null;
function $38d111fe5d5a6e3d$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $38d111fe5d5a6e3d$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $38d111fe5d5a6e3d$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $38d111fe5d5a6e3d$var$Hf = "function" === typeof Promise ? Promise : void 0, $38d111fe5d5a6e3d$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $38d111fe5d5a6e3d$var$Hf ? function(a) {
    return $38d111fe5d5a6e3d$var$Hf.resolve(null).then(a).catch($38d111fe5d5a6e3d$var$If);
} : $38d111fe5d5a6e3d$var$Ff;
function $38d111fe5d5a6e3d$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $38d111fe5d5a6e3d$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $38d111fe5d5a6e3d$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $38d111fe5d5a6e3d$var$bd(b);
}
function $38d111fe5d5a6e3d$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $38d111fe5d5a6e3d$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $38d111fe5d5a6e3d$var$Nf = Math.random().toString(36).slice(2), $38d111fe5d5a6e3d$var$Of = "__reactFiber$" + $38d111fe5d5a6e3d$var$Nf, $38d111fe5d5a6e3d$var$Pf = "__reactProps$" + $38d111fe5d5a6e3d$var$Nf, $38d111fe5d5a6e3d$var$uf = "__reactContainer$" + $38d111fe5d5a6e3d$var$Nf, $38d111fe5d5a6e3d$var$of = "__reactEvents$" + $38d111fe5d5a6e3d$var$Nf, $38d111fe5d5a6e3d$var$Qf = "__reactListeners$" + $38d111fe5d5a6e3d$var$Nf, $38d111fe5d5a6e3d$var$Rf = "__reactHandles$" + $38d111fe5d5a6e3d$var$Nf;
function $38d111fe5d5a6e3d$var$Wc(a) {
    var b = a[$38d111fe5d5a6e3d$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$38d111fe5d5a6e3d$var$uf] || c[$38d111fe5d5a6e3d$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $38d111fe5d5a6e3d$var$Mf(a); null !== a;){
                if (c = a[$38d111fe5d5a6e3d$var$Of]) return c;
                a = $38d111fe5d5a6e3d$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $38d111fe5d5a6e3d$var$Cb(a) {
    a = a[$38d111fe5d5a6e3d$var$Of] || a[$38d111fe5d5a6e3d$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $38d111fe5d5a6e3d$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($38d111fe5d5a6e3d$var$p(33));
}
function $38d111fe5d5a6e3d$var$Db(a) {
    return a[$38d111fe5d5a6e3d$var$Pf] || null;
}
var $38d111fe5d5a6e3d$var$Sf = [], $38d111fe5d5a6e3d$var$Tf = -1;
function $38d111fe5d5a6e3d$var$Uf(a) {
    return {
        current: a
    };
}
function $38d111fe5d5a6e3d$var$E(a) {
    0 > $38d111fe5d5a6e3d$var$Tf || (a.current = $38d111fe5d5a6e3d$var$Sf[$38d111fe5d5a6e3d$var$Tf], $38d111fe5d5a6e3d$var$Sf[$38d111fe5d5a6e3d$var$Tf] = null, $38d111fe5d5a6e3d$var$Tf--);
}
function $38d111fe5d5a6e3d$var$G(a, b) {
    $38d111fe5d5a6e3d$var$Tf++;
    $38d111fe5d5a6e3d$var$Sf[$38d111fe5d5a6e3d$var$Tf] = a.current;
    a.current = b;
}
var $38d111fe5d5a6e3d$var$Vf = {}, $38d111fe5d5a6e3d$var$H = $38d111fe5d5a6e3d$var$Uf($38d111fe5d5a6e3d$var$Vf), $38d111fe5d5a6e3d$var$Wf = $38d111fe5d5a6e3d$var$Uf(!1), $38d111fe5d5a6e3d$var$Xf = $38d111fe5d5a6e3d$var$Vf;
function $38d111fe5d5a6e3d$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $38d111fe5d5a6e3d$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $38d111fe5d5a6e3d$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $38d111fe5d5a6e3d$var$$f() {
    $38d111fe5d5a6e3d$var$E($38d111fe5d5a6e3d$var$Wf);
    $38d111fe5d5a6e3d$var$E($38d111fe5d5a6e3d$var$H);
}
function $38d111fe5d5a6e3d$var$ag(a, b, c) {
    if ($38d111fe5d5a6e3d$var$H.current !== $38d111fe5d5a6e3d$var$Vf) throw Error($38d111fe5d5a6e3d$var$p(168));
    $38d111fe5d5a6e3d$var$G($38d111fe5d5a6e3d$var$H, b);
    $38d111fe5d5a6e3d$var$G($38d111fe5d5a6e3d$var$Wf, c);
}
function $38d111fe5d5a6e3d$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($38d111fe5d5a6e3d$var$p(108, $38d111fe5d5a6e3d$var$Ra(a) || "Unknown", e));
    return $38d111fe5d5a6e3d$var$A({}, c, d);
}
function $38d111fe5d5a6e3d$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $38d111fe5d5a6e3d$var$Vf;
    $38d111fe5d5a6e3d$var$Xf = $38d111fe5d5a6e3d$var$H.current;
    $38d111fe5d5a6e3d$var$G($38d111fe5d5a6e3d$var$H, a);
    $38d111fe5d5a6e3d$var$G($38d111fe5d5a6e3d$var$Wf, $38d111fe5d5a6e3d$var$Wf.current);
    return !0;
}
function $38d111fe5d5a6e3d$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($38d111fe5d5a6e3d$var$p(169));
    c ? (a = $38d111fe5d5a6e3d$var$bg(a, b, $38d111fe5d5a6e3d$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $38d111fe5d5a6e3d$var$E($38d111fe5d5a6e3d$var$Wf), $38d111fe5d5a6e3d$var$E($38d111fe5d5a6e3d$var$H), $38d111fe5d5a6e3d$var$G($38d111fe5d5a6e3d$var$H, a)) : $38d111fe5d5a6e3d$var$E($38d111fe5d5a6e3d$var$Wf);
    $38d111fe5d5a6e3d$var$G($38d111fe5d5a6e3d$var$Wf, c);
}
var $38d111fe5d5a6e3d$var$eg = null, $38d111fe5d5a6e3d$var$fg = !1, $38d111fe5d5a6e3d$var$gg = !1;
function $38d111fe5d5a6e3d$var$hg(a) {
    null === $38d111fe5d5a6e3d$var$eg ? $38d111fe5d5a6e3d$var$eg = [
        a
    ] : $38d111fe5d5a6e3d$var$eg.push(a);
}
function $38d111fe5d5a6e3d$var$ig(a) {
    $38d111fe5d5a6e3d$var$fg = !0;
    $38d111fe5d5a6e3d$var$hg(a);
}
function $38d111fe5d5a6e3d$var$jg() {
    if (!$38d111fe5d5a6e3d$var$gg && null !== $38d111fe5d5a6e3d$var$eg) {
        $38d111fe5d5a6e3d$var$gg = !0;
        var a = 0, b = $38d111fe5d5a6e3d$var$C;
        try {
            var c = $38d111fe5d5a6e3d$var$eg;
            for($38d111fe5d5a6e3d$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $38d111fe5d5a6e3d$var$eg = null;
            $38d111fe5d5a6e3d$var$fg = !1;
        } catch (e) {
            throw null !== $38d111fe5d5a6e3d$var$eg && ($38d111fe5d5a6e3d$var$eg = $38d111fe5d5a6e3d$var$eg.slice(a + 1)), $38d111fe5d5a6e3d$var$ac($38d111fe5d5a6e3d$var$fc, $38d111fe5d5a6e3d$var$jg), e;
        } finally{
            $38d111fe5d5a6e3d$var$C = b, $38d111fe5d5a6e3d$var$gg = !1;
        }
    }
    return null;
}
var $38d111fe5d5a6e3d$var$kg = [], $38d111fe5d5a6e3d$var$lg = 0, $38d111fe5d5a6e3d$var$mg = null, $38d111fe5d5a6e3d$var$ng = 0, $38d111fe5d5a6e3d$var$og = [], $38d111fe5d5a6e3d$var$pg = 0, $38d111fe5d5a6e3d$var$qg = null, $38d111fe5d5a6e3d$var$rg = 1, $38d111fe5d5a6e3d$var$sg = "";
function $38d111fe5d5a6e3d$var$tg(a, b) {
    $38d111fe5d5a6e3d$var$kg[$38d111fe5d5a6e3d$var$lg++] = $38d111fe5d5a6e3d$var$ng;
    $38d111fe5d5a6e3d$var$kg[$38d111fe5d5a6e3d$var$lg++] = $38d111fe5d5a6e3d$var$mg;
    $38d111fe5d5a6e3d$var$mg = a;
    $38d111fe5d5a6e3d$var$ng = b;
}
function $38d111fe5d5a6e3d$var$ug(a, b, c) {
    $38d111fe5d5a6e3d$var$og[$38d111fe5d5a6e3d$var$pg++] = $38d111fe5d5a6e3d$var$rg;
    $38d111fe5d5a6e3d$var$og[$38d111fe5d5a6e3d$var$pg++] = $38d111fe5d5a6e3d$var$sg;
    $38d111fe5d5a6e3d$var$og[$38d111fe5d5a6e3d$var$pg++] = $38d111fe5d5a6e3d$var$qg;
    $38d111fe5d5a6e3d$var$qg = a;
    var d = $38d111fe5d5a6e3d$var$rg;
    a = $38d111fe5d5a6e3d$var$sg;
    var e = 32 - $38d111fe5d5a6e3d$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $38d111fe5d5a6e3d$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $38d111fe5d5a6e3d$var$rg = 1 << 32 - $38d111fe5d5a6e3d$var$oc(b) + e | c << e | d;
        $38d111fe5d5a6e3d$var$sg = f + a;
    } else $38d111fe5d5a6e3d$var$rg = 1 << f | c << e | d, $38d111fe5d5a6e3d$var$sg = a;
}
function $38d111fe5d5a6e3d$var$vg(a) {
    null !== a.return && ($38d111fe5d5a6e3d$var$tg(a, 1), $38d111fe5d5a6e3d$var$ug(a, 1, 0));
}
function $38d111fe5d5a6e3d$var$wg(a) {
    for(; a === $38d111fe5d5a6e3d$var$mg;)$38d111fe5d5a6e3d$var$mg = $38d111fe5d5a6e3d$var$kg[--$38d111fe5d5a6e3d$var$lg], $38d111fe5d5a6e3d$var$kg[$38d111fe5d5a6e3d$var$lg] = null, $38d111fe5d5a6e3d$var$ng = $38d111fe5d5a6e3d$var$kg[--$38d111fe5d5a6e3d$var$lg], $38d111fe5d5a6e3d$var$kg[$38d111fe5d5a6e3d$var$lg] = null;
    for(; a === $38d111fe5d5a6e3d$var$qg;)$38d111fe5d5a6e3d$var$qg = $38d111fe5d5a6e3d$var$og[--$38d111fe5d5a6e3d$var$pg], $38d111fe5d5a6e3d$var$og[$38d111fe5d5a6e3d$var$pg] = null, $38d111fe5d5a6e3d$var$sg = $38d111fe5d5a6e3d$var$og[--$38d111fe5d5a6e3d$var$pg], $38d111fe5d5a6e3d$var$og[$38d111fe5d5a6e3d$var$pg] = null, $38d111fe5d5a6e3d$var$rg = $38d111fe5d5a6e3d$var$og[--$38d111fe5d5a6e3d$var$pg], $38d111fe5d5a6e3d$var$og[$38d111fe5d5a6e3d$var$pg] = null;
}
var $38d111fe5d5a6e3d$var$xg = null, $38d111fe5d5a6e3d$var$yg = null, $38d111fe5d5a6e3d$var$I = !1, $38d111fe5d5a6e3d$var$zg = null;
function $38d111fe5d5a6e3d$var$Ag(a, b) {
    var c = $38d111fe5d5a6e3d$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $38d111fe5d5a6e3d$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $38d111fe5d5a6e3d$var$xg = a, $38d111fe5d5a6e3d$var$yg = $38d111fe5d5a6e3d$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $38d111fe5d5a6e3d$var$xg = a, $38d111fe5d5a6e3d$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $38d111fe5d5a6e3d$var$qg ? {
                id: $38d111fe5d5a6e3d$var$rg,
                overflow: $38d111fe5d5a6e3d$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $38d111fe5d5a6e3d$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $38d111fe5d5a6e3d$var$xg = a, $38d111fe5d5a6e3d$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $38d111fe5d5a6e3d$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $38d111fe5d5a6e3d$var$Eg(a) {
    if ($38d111fe5d5a6e3d$var$I) {
        var b = $38d111fe5d5a6e3d$var$yg;
        if (b) {
            var c = b;
            if (!$38d111fe5d5a6e3d$var$Cg(a, b)) {
                if ($38d111fe5d5a6e3d$var$Dg(a)) throw Error($38d111fe5d5a6e3d$var$p(418));
                b = $38d111fe5d5a6e3d$var$Lf(c.nextSibling);
                var d = $38d111fe5d5a6e3d$var$xg;
                b && $38d111fe5d5a6e3d$var$Cg(a, b) ? $38d111fe5d5a6e3d$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $38d111fe5d5a6e3d$var$I = !1, $38d111fe5d5a6e3d$var$xg = a);
            }
        } else {
            if ($38d111fe5d5a6e3d$var$Dg(a)) throw Error($38d111fe5d5a6e3d$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $38d111fe5d5a6e3d$var$I = !1;
            $38d111fe5d5a6e3d$var$xg = a;
        }
    }
}
function $38d111fe5d5a6e3d$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $38d111fe5d5a6e3d$var$xg = a;
}
function $38d111fe5d5a6e3d$var$Gg(a) {
    if (a !== $38d111fe5d5a6e3d$var$xg) return !1;
    if (!$38d111fe5d5a6e3d$var$I) return $38d111fe5d5a6e3d$var$Fg(a), $38d111fe5d5a6e3d$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$38d111fe5d5a6e3d$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $38d111fe5d5a6e3d$var$yg)) {
        if ($38d111fe5d5a6e3d$var$Dg(a)) throw $38d111fe5d5a6e3d$var$Hg(), Error($38d111fe5d5a6e3d$var$p(418));
        for(; b;)$38d111fe5d5a6e3d$var$Ag(a, b), b = $38d111fe5d5a6e3d$var$Lf(b.nextSibling);
    }
    $38d111fe5d5a6e3d$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($38d111fe5d5a6e3d$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $38d111fe5d5a6e3d$var$yg = $38d111fe5d5a6e3d$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $38d111fe5d5a6e3d$var$yg = null;
        }
    } else $38d111fe5d5a6e3d$var$yg = $38d111fe5d5a6e3d$var$xg ? $38d111fe5d5a6e3d$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $38d111fe5d5a6e3d$var$Hg() {
    for(var a = $38d111fe5d5a6e3d$var$yg; a;)a = $38d111fe5d5a6e3d$var$Lf(a.nextSibling);
}
function $38d111fe5d5a6e3d$var$Ig() {
    $38d111fe5d5a6e3d$var$yg = $38d111fe5d5a6e3d$var$xg = null;
    $38d111fe5d5a6e3d$var$I = !1;
}
function $38d111fe5d5a6e3d$var$Jg(a) {
    null === $38d111fe5d5a6e3d$var$zg ? $38d111fe5d5a6e3d$var$zg = [
        a
    ] : $38d111fe5d5a6e3d$var$zg.push(a);
}
var $38d111fe5d5a6e3d$var$Kg = $38d111fe5d5a6e3d$var$ua.ReactCurrentBatchConfig;
function $38d111fe5d5a6e3d$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $38d111fe5d5a6e3d$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $38d111fe5d5a6e3d$var$Mg = $38d111fe5d5a6e3d$var$Uf(null), $38d111fe5d5a6e3d$var$Ng = null, $38d111fe5d5a6e3d$var$Og = null, $38d111fe5d5a6e3d$var$Pg = null;
function $38d111fe5d5a6e3d$var$Qg() {
    $38d111fe5d5a6e3d$var$Pg = $38d111fe5d5a6e3d$var$Og = $38d111fe5d5a6e3d$var$Ng = null;
}
function $38d111fe5d5a6e3d$var$Rg(a) {
    var b = $38d111fe5d5a6e3d$var$Mg.current;
    $38d111fe5d5a6e3d$var$E($38d111fe5d5a6e3d$var$Mg);
    a._currentValue = b;
}
function $38d111fe5d5a6e3d$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $38d111fe5d5a6e3d$var$Tg(a, b) {
    $38d111fe5d5a6e3d$var$Ng = a;
    $38d111fe5d5a6e3d$var$Pg = $38d111fe5d5a6e3d$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($38d111fe5d5a6e3d$var$Ug = !0), a.firstContext = null);
}
function $38d111fe5d5a6e3d$var$Vg(a) {
    var b = a._currentValue;
    if ($38d111fe5d5a6e3d$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $38d111fe5d5a6e3d$var$Og) {
            if (null === $38d111fe5d5a6e3d$var$Ng) throw Error($38d111fe5d5a6e3d$var$p(308));
            $38d111fe5d5a6e3d$var$Og = a;
            $38d111fe5d5a6e3d$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $38d111fe5d5a6e3d$var$Og = $38d111fe5d5a6e3d$var$Og.next = a;
    }
    return b;
}
var $38d111fe5d5a6e3d$var$Wg = null;
function $38d111fe5d5a6e3d$var$Xg(a) {
    null === $38d111fe5d5a6e3d$var$Wg ? $38d111fe5d5a6e3d$var$Wg = [
        a
    ] : $38d111fe5d5a6e3d$var$Wg.push(a);
}
function $38d111fe5d5a6e3d$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $38d111fe5d5a6e3d$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $38d111fe5d5a6e3d$var$Zg(a, d);
}
function $38d111fe5d5a6e3d$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $38d111fe5d5a6e3d$var$$g = !1;
function $38d111fe5d5a6e3d$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $38d111fe5d5a6e3d$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $38d111fe5d5a6e3d$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $38d111fe5d5a6e3d$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($38d111fe5d5a6e3d$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $38d111fe5d5a6e3d$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $38d111fe5d5a6e3d$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $38d111fe5d5a6e3d$var$Zg(a, c);
}
function $38d111fe5d5a6e3d$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $38d111fe5d5a6e3d$var$Cc(a, c);
    }
}
function $38d111fe5d5a6e3d$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $38d111fe5d5a6e3d$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $38d111fe5d5a6e3d$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $38d111fe5d5a6e3d$var$A({}, q, r);
                            break a;
                        case 2:
                            $38d111fe5d5a6e3d$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $38d111fe5d5a6e3d$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $38d111fe5d5a6e3d$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($38d111fe5d5a6e3d$var$p(191, e));
            e.call(d);
        }
    }
}
var $38d111fe5d5a6e3d$var$jh = (new $2gcPZ.Component).refs;
function $38d111fe5d5a6e3d$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $38d111fe5d5a6e3d$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $38d111fe5d5a6e3d$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $38d111fe5d5a6e3d$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $38d111fe5d5a6e3d$var$L(), e = $38d111fe5d5a6e3d$var$lh(a), f = $38d111fe5d5a6e3d$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $38d111fe5d5a6e3d$var$dh(a, f, e);
        null !== b && ($38d111fe5d5a6e3d$var$mh(b, a, e, d), $38d111fe5d5a6e3d$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $38d111fe5d5a6e3d$var$L(), e = $38d111fe5d5a6e3d$var$lh(a), f = $38d111fe5d5a6e3d$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $38d111fe5d5a6e3d$var$dh(a, f, e);
        null !== b && ($38d111fe5d5a6e3d$var$mh(b, a, e, d), $38d111fe5d5a6e3d$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $38d111fe5d5a6e3d$var$L(), d = $38d111fe5d5a6e3d$var$lh(a), e = $38d111fe5d5a6e3d$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $38d111fe5d5a6e3d$var$dh(a, e, d);
        null !== b && ($38d111fe5d5a6e3d$var$mh(b, a, d, c), $38d111fe5d5a6e3d$var$eh(b, a, d));
    }
};
function $38d111fe5d5a6e3d$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$38d111fe5d5a6e3d$var$Ie(c, d) || !$38d111fe5d5a6e3d$var$Ie(e, f) : !0;
}
function $38d111fe5d5a6e3d$var$ph(a, b, c) {
    var d = !1, e = $38d111fe5d5a6e3d$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $38d111fe5d5a6e3d$var$Vg(f) : (e = $38d111fe5d5a6e3d$var$Zf(b) ? $38d111fe5d5a6e3d$var$Xf : $38d111fe5d5a6e3d$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $38d111fe5d5a6e3d$var$Yf(a, e) : $38d111fe5d5a6e3d$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $38d111fe5d5a6e3d$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $38d111fe5d5a6e3d$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $38d111fe5d5a6e3d$var$nh.enqueueReplaceState(b, b.state, null);
}
function $38d111fe5d5a6e3d$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $38d111fe5d5a6e3d$var$jh;
    $38d111fe5d5a6e3d$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $38d111fe5d5a6e3d$var$Vg(f) : (f = $38d111fe5d5a6e3d$var$Zf(b) ? $38d111fe5d5a6e3d$var$Xf : $38d111fe5d5a6e3d$var$H.current, e.context = $38d111fe5d5a6e3d$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($38d111fe5d5a6e3d$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $38d111fe5d5a6e3d$var$nh.enqueueReplaceState(e, e.state, null), $38d111fe5d5a6e3d$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $38d111fe5d5a6e3d$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($38d111fe5d5a6e3d$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($38d111fe5d5a6e3d$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $38d111fe5d5a6e3d$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($38d111fe5d5a6e3d$var$p(284));
        if (!c._owner) throw Error($38d111fe5d5a6e3d$var$p(290, a));
    }
    return a;
}
function $38d111fe5d5a6e3d$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($38d111fe5d5a6e3d$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $38d111fe5d5a6e3d$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $38d111fe5d5a6e3d$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $38d111fe5d5a6e3d$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $38d111fe5d5a6e3d$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $38d111fe5d5a6e3d$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $38d111fe5d5a6e3d$var$Ha && $38d111fe5d5a6e3d$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $38d111fe5d5a6e3d$var$sh(a, b, c), d.return = a, d;
        d = $38d111fe5d5a6e3d$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $38d111fe5d5a6e3d$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $38d111fe5d5a6e3d$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $38d111fe5d5a6e3d$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $38d111fe5d5a6e3d$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $38d111fe5d5a6e3d$var$va:
                    return c = $38d111fe5d5a6e3d$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $38d111fe5d5a6e3d$var$sh(a, null, b), c.return = a, c;
                case $38d111fe5d5a6e3d$var$wa:
                    return b = $38d111fe5d5a6e3d$var$zh(b, a.mode, c), b.return = a, b;
                case $38d111fe5d5a6e3d$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($38d111fe5d5a6e3d$var$eb(b) || $38d111fe5d5a6e3d$var$Ka(b)) return b = $38d111fe5d5a6e3d$var$Ah(b, a.mode, c, null), b.return = a, b;
            $38d111fe5d5a6e3d$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $38d111fe5d5a6e3d$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $38d111fe5d5a6e3d$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $38d111fe5d5a6e3d$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($38d111fe5d5a6e3d$var$eb(c) || $38d111fe5d5a6e3d$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $38d111fe5d5a6e3d$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $38d111fe5d5a6e3d$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $38d111fe5d5a6e3d$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $38d111fe5d5a6e3d$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($38d111fe5d5a6e3d$var$eb(d) || $38d111fe5d5a6e3d$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $38d111fe5d5a6e3d$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $38d111fe5d5a6e3d$var$I && $38d111fe5d5a6e3d$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $38d111fe5d5a6e3d$var$I && $38d111fe5d5a6e3d$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $38d111fe5d5a6e3d$var$I && $38d111fe5d5a6e3d$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $38d111fe5d5a6e3d$var$Ka(h);
        if ("function" !== typeof l) throw Error($38d111fe5d5a6e3d$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($38d111fe5d5a6e3d$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $38d111fe5d5a6e3d$var$I && $38d111fe5d5a6e3d$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $38d111fe5d5a6e3d$var$I && $38d111fe5d5a6e3d$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $38d111fe5d5a6e3d$var$I && $38d111fe5d5a6e3d$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $38d111fe5d5a6e3d$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $38d111fe5d5a6e3d$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $38d111fe5d5a6e3d$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $38d111fe5d5a6e3d$var$Ha && $38d111fe5d5a6e3d$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $38d111fe5d5a6e3d$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $38d111fe5d5a6e3d$var$ya ? (d = $38d111fe5d5a6e3d$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $38d111fe5d5a6e3d$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $38d111fe5d5a6e3d$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $38d111fe5d5a6e3d$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $38d111fe5d5a6e3d$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $38d111fe5d5a6e3d$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($38d111fe5d5a6e3d$var$eb(f)) return n(a, d, f, h);
            if ($38d111fe5d5a6e3d$var$Ka(f)) return t(a, d, f, h);
            $38d111fe5d5a6e3d$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $38d111fe5d5a6e3d$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $38d111fe5d5a6e3d$var$Bh = $38d111fe5d5a6e3d$var$vh(!0), $38d111fe5d5a6e3d$var$Ch = $38d111fe5d5a6e3d$var$vh(!1), $38d111fe5d5a6e3d$var$Dh = {}, $38d111fe5d5a6e3d$var$Eh = $38d111fe5d5a6e3d$var$Uf($38d111fe5d5a6e3d$var$Dh), $38d111fe5d5a6e3d$var$Fh = $38d111fe5d5a6e3d$var$Uf($38d111fe5d5a6e3d$var$Dh), $38d111fe5d5a6e3d$var$Gh = $38d111fe5d5a6e3d$var$Uf($38d111fe5d5a6e3d$var$Dh);
function $38d111fe5d5a6e3d$var$Hh(a) {
    if (a === $38d111fe5d5a6e3d$var$Dh) throw Error($38d111fe5d5a6e3d$var$p(174));
    return a;
}
function $38d111fe5d5a6e3d$var$Ih(a, b) {
    $38d111fe5d5a6e3d$var$G($38d111fe5d5a6e3d$var$Gh, b);
    $38d111fe5d5a6e3d$var$G($38d111fe5d5a6e3d$var$Fh, a);
    $38d111fe5d5a6e3d$var$G($38d111fe5d5a6e3d$var$Eh, $38d111fe5d5a6e3d$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $38d111fe5d5a6e3d$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $38d111fe5d5a6e3d$var$lb(b, a);
    }
    $38d111fe5d5a6e3d$var$E($38d111fe5d5a6e3d$var$Eh);
    $38d111fe5d5a6e3d$var$G($38d111fe5d5a6e3d$var$Eh, b);
}
function $38d111fe5d5a6e3d$var$Jh() {
    $38d111fe5d5a6e3d$var$E($38d111fe5d5a6e3d$var$Eh);
    $38d111fe5d5a6e3d$var$E($38d111fe5d5a6e3d$var$Fh);
    $38d111fe5d5a6e3d$var$E($38d111fe5d5a6e3d$var$Gh);
}
function $38d111fe5d5a6e3d$var$Kh(a) {
    $38d111fe5d5a6e3d$var$Hh($38d111fe5d5a6e3d$var$Gh.current);
    var b = $38d111fe5d5a6e3d$var$Hh($38d111fe5d5a6e3d$var$Eh.current);
    var c = $38d111fe5d5a6e3d$var$lb(b, a.type);
    b !== c && ($38d111fe5d5a6e3d$var$G($38d111fe5d5a6e3d$var$Fh, a), $38d111fe5d5a6e3d$var$G($38d111fe5d5a6e3d$var$Eh, c));
}
function $38d111fe5d5a6e3d$var$Lh(a) {
    $38d111fe5d5a6e3d$var$Fh.current === a && ($38d111fe5d5a6e3d$var$E($38d111fe5d5a6e3d$var$Eh), $38d111fe5d5a6e3d$var$E($38d111fe5d5a6e3d$var$Fh));
}
var $38d111fe5d5a6e3d$var$M = $38d111fe5d5a6e3d$var$Uf(0);
function $38d111fe5d5a6e3d$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $38d111fe5d5a6e3d$var$Nh = [];
function $38d111fe5d5a6e3d$var$Oh() {
    for(var a = 0; a < $38d111fe5d5a6e3d$var$Nh.length; a++)$38d111fe5d5a6e3d$var$Nh[a]._workInProgressVersionPrimary = null;
    $38d111fe5d5a6e3d$var$Nh.length = 0;
}
var $38d111fe5d5a6e3d$var$Ph = $38d111fe5d5a6e3d$var$ua.ReactCurrentDispatcher, $38d111fe5d5a6e3d$var$Qh = $38d111fe5d5a6e3d$var$ua.ReactCurrentBatchConfig, $38d111fe5d5a6e3d$var$Rh = 0, $38d111fe5d5a6e3d$var$N = null, $38d111fe5d5a6e3d$var$O = null, $38d111fe5d5a6e3d$var$P = null, $38d111fe5d5a6e3d$var$Sh = !1, $38d111fe5d5a6e3d$var$Th = !1, $38d111fe5d5a6e3d$var$Uh = 0, $38d111fe5d5a6e3d$var$Vh = 0;
function $38d111fe5d5a6e3d$var$Q() {
    throw Error($38d111fe5d5a6e3d$var$p(321));
}
function $38d111fe5d5a6e3d$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$38d111fe5d5a6e3d$var$He(a[c], b[c])) return !1;
    return !0;
}
function $38d111fe5d5a6e3d$var$Xh(a, b, c, d, e, f) {
    $38d111fe5d5a6e3d$var$Rh = f;
    $38d111fe5d5a6e3d$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $38d111fe5d5a6e3d$var$Ph.current = null === a || null === a.memoizedState ? $38d111fe5d5a6e3d$var$Yh : $38d111fe5d5a6e3d$var$Zh;
    a = c(d, e);
    if ($38d111fe5d5a6e3d$var$Th) {
        f = 0;
        do {
            $38d111fe5d5a6e3d$var$Th = !1;
            $38d111fe5d5a6e3d$var$Uh = 0;
            if (25 <= f) throw Error($38d111fe5d5a6e3d$var$p(301));
            f += 1;
            $38d111fe5d5a6e3d$var$P = $38d111fe5d5a6e3d$var$O = null;
            b.updateQueue = null;
            $38d111fe5d5a6e3d$var$Ph.current = $38d111fe5d5a6e3d$var$$h;
            a = c(d, e);
        }while ($38d111fe5d5a6e3d$var$Th);
    }
    $38d111fe5d5a6e3d$var$Ph.current = $38d111fe5d5a6e3d$var$ai;
    b = null !== $38d111fe5d5a6e3d$var$O && null !== $38d111fe5d5a6e3d$var$O.next;
    $38d111fe5d5a6e3d$var$Rh = 0;
    $38d111fe5d5a6e3d$var$P = $38d111fe5d5a6e3d$var$O = $38d111fe5d5a6e3d$var$N = null;
    $38d111fe5d5a6e3d$var$Sh = !1;
    if (b) throw Error($38d111fe5d5a6e3d$var$p(300));
    return a;
}
function $38d111fe5d5a6e3d$var$bi() {
    var a = 0 !== $38d111fe5d5a6e3d$var$Uh;
    $38d111fe5d5a6e3d$var$Uh = 0;
    return a;
}
function $38d111fe5d5a6e3d$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $38d111fe5d5a6e3d$var$P ? $38d111fe5d5a6e3d$var$N.memoizedState = $38d111fe5d5a6e3d$var$P = a : $38d111fe5d5a6e3d$var$P = $38d111fe5d5a6e3d$var$P.next = a;
    return $38d111fe5d5a6e3d$var$P;
}
function $38d111fe5d5a6e3d$var$di() {
    if (null === $38d111fe5d5a6e3d$var$O) {
        var a = $38d111fe5d5a6e3d$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $38d111fe5d5a6e3d$var$O.next;
    var b = null === $38d111fe5d5a6e3d$var$P ? $38d111fe5d5a6e3d$var$N.memoizedState : $38d111fe5d5a6e3d$var$P.next;
    if (null !== b) $38d111fe5d5a6e3d$var$P = b, $38d111fe5d5a6e3d$var$O = a;
    else {
        if (null === a) throw Error($38d111fe5d5a6e3d$var$p(310));
        $38d111fe5d5a6e3d$var$O = a;
        a = {
            memoizedState: $38d111fe5d5a6e3d$var$O.memoizedState,
            baseState: $38d111fe5d5a6e3d$var$O.baseState,
            baseQueue: $38d111fe5d5a6e3d$var$O.baseQueue,
            queue: $38d111fe5d5a6e3d$var$O.queue,
            next: null
        };
        null === $38d111fe5d5a6e3d$var$P ? $38d111fe5d5a6e3d$var$N.memoizedState = $38d111fe5d5a6e3d$var$P = a : $38d111fe5d5a6e3d$var$P = $38d111fe5d5a6e3d$var$P.next = a;
    }
    return $38d111fe5d5a6e3d$var$P;
}
function $38d111fe5d5a6e3d$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $38d111fe5d5a6e3d$var$fi(a) {
    var b = $38d111fe5d5a6e3d$var$di(), c = b.queue;
    if (null === c) throw Error($38d111fe5d5a6e3d$var$p(311));
    c.lastRenderedReducer = a;
    var d = $38d111fe5d5a6e3d$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($38d111fe5d5a6e3d$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $38d111fe5d5a6e3d$var$N.lanes |= m;
                $38d111fe5d5a6e3d$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $38d111fe5d5a6e3d$var$He(d, b.memoizedState) || ($38d111fe5d5a6e3d$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $38d111fe5d5a6e3d$var$N.lanes |= f, $38d111fe5d5a6e3d$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $38d111fe5d5a6e3d$var$gi(a) {
    var b = $38d111fe5d5a6e3d$var$di(), c = b.queue;
    if (null === c) throw Error($38d111fe5d5a6e3d$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $38d111fe5d5a6e3d$var$He(f, b.memoizedState) || ($38d111fe5d5a6e3d$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $38d111fe5d5a6e3d$var$hi() {}
function $38d111fe5d5a6e3d$var$ii(a, b) {
    var c = $38d111fe5d5a6e3d$var$N, d = $38d111fe5d5a6e3d$var$di(), e = b(), f = !$38d111fe5d5a6e3d$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $38d111fe5d5a6e3d$var$Ug = !0);
    d = d.queue;
    $38d111fe5d5a6e3d$var$ji($38d111fe5d5a6e3d$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $38d111fe5d5a6e3d$var$P && $38d111fe5d5a6e3d$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $38d111fe5d5a6e3d$var$li(9, $38d111fe5d5a6e3d$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $38d111fe5d5a6e3d$var$R) throw Error($38d111fe5d5a6e3d$var$p(349));
        0 !== ($38d111fe5d5a6e3d$var$Rh & 30) || $38d111fe5d5a6e3d$var$ni(c, b, e);
    }
    return e;
}
function $38d111fe5d5a6e3d$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $38d111fe5d5a6e3d$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $38d111fe5d5a6e3d$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $38d111fe5d5a6e3d$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $38d111fe5d5a6e3d$var$oi(b) && $38d111fe5d5a6e3d$var$pi(a);
}
function $38d111fe5d5a6e3d$var$ki(a, b, c) {
    return c(function() {
        $38d111fe5d5a6e3d$var$oi(b) && $38d111fe5d5a6e3d$var$pi(a);
    });
}
function $38d111fe5d5a6e3d$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$38d111fe5d5a6e3d$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $38d111fe5d5a6e3d$var$pi(a) {
    var b = $38d111fe5d5a6e3d$var$Zg(a, 1);
    null !== b && $38d111fe5d5a6e3d$var$mh(b, a, 1, -1);
}
function $38d111fe5d5a6e3d$var$qi(a) {
    var b = $38d111fe5d5a6e3d$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $38d111fe5d5a6e3d$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $38d111fe5d5a6e3d$var$ri.bind(null, $38d111fe5d5a6e3d$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $38d111fe5d5a6e3d$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $38d111fe5d5a6e3d$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $38d111fe5d5a6e3d$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $38d111fe5d5a6e3d$var$si() {
    return $38d111fe5d5a6e3d$var$di().memoizedState;
}
function $38d111fe5d5a6e3d$var$ti(a, b, c, d) {
    var e = $38d111fe5d5a6e3d$var$ci();
    $38d111fe5d5a6e3d$var$N.flags |= a;
    e.memoizedState = $38d111fe5d5a6e3d$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $38d111fe5d5a6e3d$var$ui(a, b, c, d) {
    var e = $38d111fe5d5a6e3d$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $38d111fe5d5a6e3d$var$O) {
        var g = $38d111fe5d5a6e3d$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $38d111fe5d5a6e3d$var$Wh(d, g.deps)) {
            e.memoizedState = $38d111fe5d5a6e3d$var$li(b, c, f, d);
            return;
        }
    }
    $38d111fe5d5a6e3d$var$N.flags |= a;
    e.memoizedState = $38d111fe5d5a6e3d$var$li(1 | b, c, f, d);
}
function $38d111fe5d5a6e3d$var$vi(a, b) {
    return $38d111fe5d5a6e3d$var$ti(8390656, 8, a, b);
}
function $38d111fe5d5a6e3d$var$ji(a, b) {
    return $38d111fe5d5a6e3d$var$ui(2048, 8, a, b);
}
function $38d111fe5d5a6e3d$var$wi(a, b) {
    return $38d111fe5d5a6e3d$var$ui(4, 2, a, b);
}
function $38d111fe5d5a6e3d$var$xi(a, b) {
    return $38d111fe5d5a6e3d$var$ui(4, 4, a, b);
}
function $38d111fe5d5a6e3d$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $38d111fe5d5a6e3d$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $38d111fe5d5a6e3d$var$ui(4, 4, $38d111fe5d5a6e3d$var$yi.bind(null, b, a), c);
}
function $38d111fe5d5a6e3d$var$Ai() {}
function $38d111fe5d5a6e3d$var$Bi(a, b) {
    var c = $38d111fe5d5a6e3d$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $38d111fe5d5a6e3d$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $38d111fe5d5a6e3d$var$Ci(a, b) {
    var c = $38d111fe5d5a6e3d$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $38d111fe5d5a6e3d$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $38d111fe5d5a6e3d$var$Di(a, b, c) {
    if (0 === ($38d111fe5d5a6e3d$var$Rh & 21)) return a.baseState && (a.baseState = !1, $38d111fe5d5a6e3d$var$Ug = !0), a.memoizedState = c;
    $38d111fe5d5a6e3d$var$He(c, b) || (c = $38d111fe5d5a6e3d$var$yc(), $38d111fe5d5a6e3d$var$N.lanes |= c, $38d111fe5d5a6e3d$var$hh |= c, a.baseState = !0);
    return b;
}
function $38d111fe5d5a6e3d$var$Ei(a, b) {
    var c = $38d111fe5d5a6e3d$var$C;
    $38d111fe5d5a6e3d$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $38d111fe5d5a6e3d$var$Qh.transition;
    $38d111fe5d5a6e3d$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $38d111fe5d5a6e3d$var$C = c, $38d111fe5d5a6e3d$var$Qh.transition = d;
    }
}
function $38d111fe5d5a6e3d$var$Fi() {
    return $38d111fe5d5a6e3d$var$di().memoizedState;
}
function $38d111fe5d5a6e3d$var$Gi(a, b, c) {
    var d = $38d111fe5d5a6e3d$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($38d111fe5d5a6e3d$var$Hi(a)) $38d111fe5d5a6e3d$var$Ii(b, c);
    else if (c = $38d111fe5d5a6e3d$var$Yg(a, b, c, d), null !== c) {
        var e = $38d111fe5d5a6e3d$var$L();
        $38d111fe5d5a6e3d$var$mh(c, a, d, e);
        $38d111fe5d5a6e3d$var$Ji(c, b, d);
    }
}
function $38d111fe5d5a6e3d$var$ri(a, b, c) {
    var d = $38d111fe5d5a6e3d$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($38d111fe5d5a6e3d$var$Hi(a)) $38d111fe5d5a6e3d$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($38d111fe5d5a6e3d$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $38d111fe5d5a6e3d$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $38d111fe5d5a6e3d$var$Yg(a, b, e, d);
        null !== c && (e = $38d111fe5d5a6e3d$var$L(), $38d111fe5d5a6e3d$var$mh(c, a, d, e), $38d111fe5d5a6e3d$var$Ji(c, b, d));
    }
}
function $38d111fe5d5a6e3d$var$Hi(a) {
    var b = a.alternate;
    return a === $38d111fe5d5a6e3d$var$N || null !== b && b === $38d111fe5d5a6e3d$var$N;
}
function $38d111fe5d5a6e3d$var$Ii(a, b) {
    $38d111fe5d5a6e3d$var$Th = $38d111fe5d5a6e3d$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $38d111fe5d5a6e3d$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $38d111fe5d5a6e3d$var$Cc(a, c);
    }
}
var $38d111fe5d5a6e3d$var$ai = {
    readContext: $38d111fe5d5a6e3d$var$Vg,
    useCallback: $38d111fe5d5a6e3d$var$Q,
    useContext: $38d111fe5d5a6e3d$var$Q,
    useEffect: $38d111fe5d5a6e3d$var$Q,
    useImperativeHandle: $38d111fe5d5a6e3d$var$Q,
    useInsertionEffect: $38d111fe5d5a6e3d$var$Q,
    useLayoutEffect: $38d111fe5d5a6e3d$var$Q,
    useMemo: $38d111fe5d5a6e3d$var$Q,
    useReducer: $38d111fe5d5a6e3d$var$Q,
    useRef: $38d111fe5d5a6e3d$var$Q,
    useState: $38d111fe5d5a6e3d$var$Q,
    useDebugValue: $38d111fe5d5a6e3d$var$Q,
    useDeferredValue: $38d111fe5d5a6e3d$var$Q,
    useTransition: $38d111fe5d5a6e3d$var$Q,
    useMutableSource: $38d111fe5d5a6e3d$var$Q,
    useSyncExternalStore: $38d111fe5d5a6e3d$var$Q,
    useId: $38d111fe5d5a6e3d$var$Q,
    unstable_isNewReconciler: !1
}, $38d111fe5d5a6e3d$var$Yh = {
    readContext: $38d111fe5d5a6e3d$var$Vg,
    useCallback: function(a, b) {
        $38d111fe5d5a6e3d$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $38d111fe5d5a6e3d$var$Vg,
    useEffect: $38d111fe5d5a6e3d$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $38d111fe5d5a6e3d$var$ti(4194308, 4, $38d111fe5d5a6e3d$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $38d111fe5d5a6e3d$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $38d111fe5d5a6e3d$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $38d111fe5d5a6e3d$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $38d111fe5d5a6e3d$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $38d111fe5d5a6e3d$var$Gi.bind(null, $38d111fe5d5a6e3d$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $38d111fe5d5a6e3d$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $38d111fe5d5a6e3d$var$qi,
    useDebugValue: $38d111fe5d5a6e3d$var$Ai,
    useDeferredValue: function(a) {
        return $38d111fe5d5a6e3d$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $38d111fe5d5a6e3d$var$qi(!1), b = a[0];
        a = $38d111fe5d5a6e3d$var$Ei.bind(null, a[1]);
        $38d111fe5d5a6e3d$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $38d111fe5d5a6e3d$var$N, e = $38d111fe5d5a6e3d$var$ci();
        if ($38d111fe5d5a6e3d$var$I) {
            if (void 0 === c) throw Error($38d111fe5d5a6e3d$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $38d111fe5d5a6e3d$var$R) throw Error($38d111fe5d5a6e3d$var$p(349));
            0 !== ($38d111fe5d5a6e3d$var$Rh & 30) || $38d111fe5d5a6e3d$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $38d111fe5d5a6e3d$var$vi($38d111fe5d5a6e3d$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $38d111fe5d5a6e3d$var$li(9, $38d111fe5d5a6e3d$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $38d111fe5d5a6e3d$var$ci(), b = $38d111fe5d5a6e3d$var$R.identifierPrefix;
        if ($38d111fe5d5a6e3d$var$I) {
            var c = $38d111fe5d5a6e3d$var$sg;
            var d = $38d111fe5d5a6e3d$var$rg;
            c = (d & ~(1 << 32 - $38d111fe5d5a6e3d$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $38d111fe5d5a6e3d$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $38d111fe5d5a6e3d$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $38d111fe5d5a6e3d$var$Zh = {
    readContext: $38d111fe5d5a6e3d$var$Vg,
    useCallback: $38d111fe5d5a6e3d$var$Bi,
    useContext: $38d111fe5d5a6e3d$var$Vg,
    useEffect: $38d111fe5d5a6e3d$var$ji,
    useImperativeHandle: $38d111fe5d5a6e3d$var$zi,
    useInsertionEffect: $38d111fe5d5a6e3d$var$wi,
    useLayoutEffect: $38d111fe5d5a6e3d$var$xi,
    useMemo: $38d111fe5d5a6e3d$var$Ci,
    useReducer: $38d111fe5d5a6e3d$var$fi,
    useRef: $38d111fe5d5a6e3d$var$si,
    useState: function() {
        return $38d111fe5d5a6e3d$var$fi($38d111fe5d5a6e3d$var$ei);
    },
    useDebugValue: $38d111fe5d5a6e3d$var$Ai,
    useDeferredValue: function(a) {
        var b = $38d111fe5d5a6e3d$var$di();
        return $38d111fe5d5a6e3d$var$Di(b, $38d111fe5d5a6e3d$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $38d111fe5d5a6e3d$var$fi($38d111fe5d5a6e3d$var$ei)[0], b = $38d111fe5d5a6e3d$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $38d111fe5d5a6e3d$var$hi,
    useSyncExternalStore: $38d111fe5d5a6e3d$var$ii,
    useId: $38d111fe5d5a6e3d$var$Fi,
    unstable_isNewReconciler: !1
}, $38d111fe5d5a6e3d$var$$h = {
    readContext: $38d111fe5d5a6e3d$var$Vg,
    useCallback: $38d111fe5d5a6e3d$var$Bi,
    useContext: $38d111fe5d5a6e3d$var$Vg,
    useEffect: $38d111fe5d5a6e3d$var$ji,
    useImperativeHandle: $38d111fe5d5a6e3d$var$zi,
    useInsertionEffect: $38d111fe5d5a6e3d$var$wi,
    useLayoutEffect: $38d111fe5d5a6e3d$var$xi,
    useMemo: $38d111fe5d5a6e3d$var$Ci,
    useReducer: $38d111fe5d5a6e3d$var$gi,
    useRef: $38d111fe5d5a6e3d$var$si,
    useState: function() {
        return $38d111fe5d5a6e3d$var$gi($38d111fe5d5a6e3d$var$ei);
    },
    useDebugValue: $38d111fe5d5a6e3d$var$Ai,
    useDeferredValue: function(a) {
        var b = $38d111fe5d5a6e3d$var$di();
        return null === $38d111fe5d5a6e3d$var$O ? b.memoizedState = a : $38d111fe5d5a6e3d$var$Di(b, $38d111fe5d5a6e3d$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $38d111fe5d5a6e3d$var$gi($38d111fe5d5a6e3d$var$ei)[0], b = $38d111fe5d5a6e3d$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $38d111fe5d5a6e3d$var$hi,
    useSyncExternalStore: $38d111fe5d5a6e3d$var$ii,
    useId: $38d111fe5d5a6e3d$var$Fi,
    unstable_isNewReconciler: !1
};
function $38d111fe5d5a6e3d$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $38d111fe5d5a6e3d$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $38d111fe5d5a6e3d$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $38d111fe5d5a6e3d$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $38d111fe5d5a6e3d$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $38d111fe5d5a6e3d$var$Oi(a, b, c) {
    c = $38d111fe5d5a6e3d$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $38d111fe5d5a6e3d$var$Pi || ($38d111fe5d5a6e3d$var$Pi = !0, $38d111fe5d5a6e3d$var$Qi = d);
        $38d111fe5d5a6e3d$var$Mi(a, b);
    };
    return c;
}
function $38d111fe5d5a6e3d$var$Ri(a, b, c) {
    c = $38d111fe5d5a6e3d$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $38d111fe5d5a6e3d$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $38d111fe5d5a6e3d$var$Mi(a, b);
        "function" !== typeof d && (null === $38d111fe5d5a6e3d$var$Si ? $38d111fe5d5a6e3d$var$Si = new Set([
            this
        ]) : $38d111fe5d5a6e3d$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $38d111fe5d5a6e3d$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $38d111fe5d5a6e3d$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $38d111fe5d5a6e3d$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $38d111fe5d5a6e3d$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $38d111fe5d5a6e3d$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $38d111fe5d5a6e3d$var$ch(-1, 1), b.tag = 2, $38d111fe5d5a6e3d$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $38d111fe5d5a6e3d$var$Xi = $38d111fe5d5a6e3d$var$ua.ReactCurrentOwner, $38d111fe5d5a6e3d$var$Ug = !1;
function $38d111fe5d5a6e3d$var$Yi(a, b, c, d) {
    b.child = null === a ? $38d111fe5d5a6e3d$var$Ch(b, null, c, d) : $38d111fe5d5a6e3d$var$Bh(b, a.child, c, d);
}
function $38d111fe5d5a6e3d$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $38d111fe5d5a6e3d$var$Tg(b, e);
    d = $38d111fe5d5a6e3d$var$Xh(a, b, c, d, f, e);
    c = $38d111fe5d5a6e3d$var$bi();
    if (null !== a && !$38d111fe5d5a6e3d$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $38d111fe5d5a6e3d$var$$i(a, b, e);
    $38d111fe5d5a6e3d$var$I && c && $38d111fe5d5a6e3d$var$vg(b);
    b.flags |= 1;
    $38d111fe5d5a6e3d$var$Yi(a, b, d, e);
    return b.child;
}
function $38d111fe5d5a6e3d$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$38d111fe5d5a6e3d$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $38d111fe5d5a6e3d$var$cj(a, b, f, d, e);
        a = $38d111fe5d5a6e3d$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $38d111fe5d5a6e3d$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $38d111fe5d5a6e3d$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $38d111fe5d5a6e3d$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $38d111fe5d5a6e3d$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($38d111fe5d5a6e3d$var$Ie(f, d) && a.ref === b.ref) {
            if ($38d111fe5d5a6e3d$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($38d111fe5d5a6e3d$var$Ug = !0);
            else return b.lanes = a.lanes, $38d111fe5d5a6e3d$var$$i(a, b, e);
        }
    }
    return $38d111fe5d5a6e3d$var$dj(a, b, c, d, e);
}
function $38d111fe5d5a6e3d$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $38d111fe5d5a6e3d$var$G($38d111fe5d5a6e3d$var$fj, $38d111fe5d5a6e3d$var$gj), $38d111fe5d5a6e3d$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $38d111fe5d5a6e3d$var$G($38d111fe5d5a6e3d$var$fj, $38d111fe5d5a6e3d$var$gj), $38d111fe5d5a6e3d$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $38d111fe5d5a6e3d$var$G($38d111fe5d5a6e3d$var$fj, $38d111fe5d5a6e3d$var$gj);
            $38d111fe5d5a6e3d$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $38d111fe5d5a6e3d$var$G($38d111fe5d5a6e3d$var$fj, $38d111fe5d5a6e3d$var$gj), $38d111fe5d5a6e3d$var$gj |= d;
    $38d111fe5d5a6e3d$var$Yi(a, b, e, c);
    return b.child;
}
function $38d111fe5d5a6e3d$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $38d111fe5d5a6e3d$var$dj(a, b, c, d, e) {
    var f = $38d111fe5d5a6e3d$var$Zf(c) ? $38d111fe5d5a6e3d$var$Xf : $38d111fe5d5a6e3d$var$H.current;
    f = $38d111fe5d5a6e3d$var$Yf(b, f);
    $38d111fe5d5a6e3d$var$Tg(b, e);
    c = $38d111fe5d5a6e3d$var$Xh(a, b, c, d, f, e);
    d = $38d111fe5d5a6e3d$var$bi();
    if (null !== a && !$38d111fe5d5a6e3d$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $38d111fe5d5a6e3d$var$$i(a, b, e);
    $38d111fe5d5a6e3d$var$I && d && $38d111fe5d5a6e3d$var$vg(b);
    b.flags |= 1;
    $38d111fe5d5a6e3d$var$Yi(a, b, c, e);
    return b.child;
}
function $38d111fe5d5a6e3d$var$ij(a, b, c, d, e) {
    if ($38d111fe5d5a6e3d$var$Zf(c)) {
        var f = !0;
        $38d111fe5d5a6e3d$var$cg(b);
    } else f = !1;
    $38d111fe5d5a6e3d$var$Tg(b, e);
    if (null === b.stateNode) $38d111fe5d5a6e3d$var$jj(a, b), $38d111fe5d5a6e3d$var$ph(b, c, d), $38d111fe5d5a6e3d$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $38d111fe5d5a6e3d$var$Vg(l) : (l = $38d111fe5d5a6e3d$var$Zf(c) ? $38d111fe5d5a6e3d$var$Xf : $38d111fe5d5a6e3d$var$H.current, l = $38d111fe5d5a6e3d$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $38d111fe5d5a6e3d$var$qh(b, g, d, l);
        $38d111fe5d5a6e3d$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $38d111fe5d5a6e3d$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $38d111fe5d5a6e3d$var$Wf.current || $38d111fe5d5a6e3d$var$$g ? ("function" === typeof m && ($38d111fe5d5a6e3d$var$kh(b, c, m, d), k = b.memoizedState), (h = $38d111fe5d5a6e3d$var$$g || $38d111fe5d5a6e3d$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $38d111fe5d5a6e3d$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $38d111fe5d5a6e3d$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $38d111fe5d5a6e3d$var$Vg(k) : (k = $38d111fe5d5a6e3d$var$Zf(c) ? $38d111fe5d5a6e3d$var$Xf : $38d111fe5d5a6e3d$var$H.current, k = $38d111fe5d5a6e3d$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $38d111fe5d5a6e3d$var$qh(b, g, d, k);
        $38d111fe5d5a6e3d$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $38d111fe5d5a6e3d$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $38d111fe5d5a6e3d$var$Wf.current || $38d111fe5d5a6e3d$var$$g ? ("function" === typeof y && ($38d111fe5d5a6e3d$var$kh(b, c, y, d), n = b.memoizedState), (l = $38d111fe5d5a6e3d$var$$g || $38d111fe5d5a6e3d$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $38d111fe5d5a6e3d$var$kj(a, b, c, d, f, e);
}
function $38d111fe5d5a6e3d$var$kj(a, b, c, d, e, f) {
    $38d111fe5d5a6e3d$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $38d111fe5d5a6e3d$var$dg(b, c, !1), $38d111fe5d5a6e3d$var$$i(a, b, f);
    d = b.stateNode;
    $38d111fe5d5a6e3d$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $38d111fe5d5a6e3d$var$Bh(b, a.child, null, f), b.child = $38d111fe5d5a6e3d$var$Bh(b, null, h, f)) : $38d111fe5d5a6e3d$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $38d111fe5d5a6e3d$var$dg(b, c, !0);
    return b.child;
}
function $38d111fe5d5a6e3d$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $38d111fe5d5a6e3d$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $38d111fe5d5a6e3d$var$ag(a, b.context, !1);
    $38d111fe5d5a6e3d$var$Ih(a, b.containerInfo);
}
function $38d111fe5d5a6e3d$var$mj(a, b, c, d, e) {
    $38d111fe5d5a6e3d$var$Ig();
    $38d111fe5d5a6e3d$var$Jg(e);
    b.flags |= 256;
    $38d111fe5d5a6e3d$var$Yi(a, b, c, d);
    return b.child;
}
var $38d111fe5d5a6e3d$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $38d111fe5d5a6e3d$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $38d111fe5d5a6e3d$var$pj(a, b, c) {
    var d = b.pendingProps, e = $38d111fe5d5a6e3d$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $38d111fe5d5a6e3d$var$G($38d111fe5d5a6e3d$var$M, e & 1);
    if (null === a) {
        $38d111fe5d5a6e3d$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $38d111fe5d5a6e3d$var$qj(g, d, 0, null), a = $38d111fe5d5a6e3d$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $38d111fe5d5a6e3d$var$oj(c), b.memoizedState = $38d111fe5d5a6e3d$var$nj, a) : $38d111fe5d5a6e3d$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $38d111fe5d5a6e3d$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $38d111fe5d5a6e3d$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $38d111fe5d5a6e3d$var$wh(h, f) : (f = $38d111fe5d5a6e3d$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $38d111fe5d5a6e3d$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $38d111fe5d5a6e3d$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $38d111fe5d5a6e3d$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $38d111fe5d5a6e3d$var$rj(a, b) {
    b = $38d111fe5d5a6e3d$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $38d111fe5d5a6e3d$var$tj(a, b, c, d) {
    null !== d && $38d111fe5d5a6e3d$var$Jg(d);
    $38d111fe5d5a6e3d$var$Bh(b, a.child, null, c);
    a = $38d111fe5d5a6e3d$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $38d111fe5d5a6e3d$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $38d111fe5d5a6e3d$var$Li(Error($38d111fe5d5a6e3d$var$p(422))), $38d111fe5d5a6e3d$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $38d111fe5d5a6e3d$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $38d111fe5d5a6e3d$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $38d111fe5d5a6e3d$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $38d111fe5d5a6e3d$var$oj(g);
        b.memoizedState = $38d111fe5d5a6e3d$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $38d111fe5d5a6e3d$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($38d111fe5d5a6e3d$var$p(419));
        d = $38d111fe5d5a6e3d$var$Li(f, d, void 0);
        return $38d111fe5d5a6e3d$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($38d111fe5d5a6e3d$var$Ug || h) {
        d = $38d111fe5d5a6e3d$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $38d111fe5d5a6e3d$var$Zg(a, e), $38d111fe5d5a6e3d$var$mh(d, a, e, -1));
        }
        $38d111fe5d5a6e3d$var$uj();
        d = $38d111fe5d5a6e3d$var$Li(Error($38d111fe5d5a6e3d$var$p(421)));
        return $38d111fe5d5a6e3d$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $38d111fe5d5a6e3d$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $38d111fe5d5a6e3d$var$yg = $38d111fe5d5a6e3d$var$Lf(e.nextSibling);
    $38d111fe5d5a6e3d$var$xg = b;
    $38d111fe5d5a6e3d$var$I = !0;
    $38d111fe5d5a6e3d$var$zg = null;
    null !== a && ($38d111fe5d5a6e3d$var$og[$38d111fe5d5a6e3d$var$pg++] = $38d111fe5d5a6e3d$var$rg, $38d111fe5d5a6e3d$var$og[$38d111fe5d5a6e3d$var$pg++] = $38d111fe5d5a6e3d$var$sg, $38d111fe5d5a6e3d$var$og[$38d111fe5d5a6e3d$var$pg++] = $38d111fe5d5a6e3d$var$qg, $38d111fe5d5a6e3d$var$rg = a.id, $38d111fe5d5a6e3d$var$sg = a.overflow, $38d111fe5d5a6e3d$var$qg = b);
    b = $38d111fe5d5a6e3d$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $38d111fe5d5a6e3d$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $38d111fe5d5a6e3d$var$Sg(a.return, b, c);
}
function $38d111fe5d5a6e3d$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $38d111fe5d5a6e3d$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $38d111fe5d5a6e3d$var$Yi(a, b, d.children, c);
    d = $38d111fe5d5a6e3d$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $38d111fe5d5a6e3d$var$wj(a, c, b);
            else if (19 === a.tag) $38d111fe5d5a6e3d$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $38d111fe5d5a6e3d$var$G($38d111fe5d5a6e3d$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $38d111fe5d5a6e3d$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $38d111fe5d5a6e3d$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $38d111fe5d5a6e3d$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $38d111fe5d5a6e3d$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $38d111fe5d5a6e3d$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $38d111fe5d5a6e3d$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $38d111fe5d5a6e3d$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $38d111fe5d5a6e3d$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($38d111fe5d5a6e3d$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $38d111fe5d5a6e3d$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $38d111fe5d5a6e3d$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $38d111fe5d5a6e3d$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $38d111fe5d5a6e3d$var$lj(b);
            $38d111fe5d5a6e3d$var$Ig();
            break;
        case 5:
            $38d111fe5d5a6e3d$var$Kh(b);
            break;
        case 1:
            $38d111fe5d5a6e3d$var$Zf(b.type) && $38d111fe5d5a6e3d$var$cg(b);
            break;
        case 4:
            $38d111fe5d5a6e3d$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $38d111fe5d5a6e3d$var$G($38d111fe5d5a6e3d$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $38d111fe5d5a6e3d$var$G($38d111fe5d5a6e3d$var$M, $38d111fe5d5a6e3d$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $38d111fe5d5a6e3d$var$pj(a, b, c);
                $38d111fe5d5a6e3d$var$G($38d111fe5d5a6e3d$var$M, $38d111fe5d5a6e3d$var$M.current & 1);
                a = $38d111fe5d5a6e3d$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $38d111fe5d5a6e3d$var$G($38d111fe5d5a6e3d$var$M, $38d111fe5d5a6e3d$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $38d111fe5d5a6e3d$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $38d111fe5d5a6e3d$var$G($38d111fe5d5a6e3d$var$M, $38d111fe5d5a6e3d$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $38d111fe5d5a6e3d$var$ej(a, b, c);
    }
    return $38d111fe5d5a6e3d$var$$i(a, b, c);
}
var $38d111fe5d5a6e3d$var$Aj, $38d111fe5d5a6e3d$var$Bj, $38d111fe5d5a6e3d$var$Cj, $38d111fe5d5a6e3d$var$Dj;
$38d111fe5d5a6e3d$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$38d111fe5d5a6e3d$var$Bj = function() {};
$38d111fe5d5a6e3d$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $38d111fe5d5a6e3d$var$Hh($38d111fe5d5a6e3d$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $38d111fe5d5a6e3d$var$Ya(a, e);
                d = $38d111fe5d5a6e3d$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $38d111fe5d5a6e3d$var$A({}, e, {
                    value: void 0
                });
                d = $38d111fe5d5a6e3d$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $38d111fe5d5a6e3d$var$gb(a, e);
                d = $38d111fe5d5a6e3d$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $38d111fe5d5a6e3d$var$Bf);
        }
        $38d111fe5d5a6e3d$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($38d111fe5d5a6e3d$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($38d111fe5d5a6e3d$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $38d111fe5d5a6e3d$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$38d111fe5d5a6e3d$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $38d111fe5d5a6e3d$var$Ej(a, b) {
    if (!$38d111fe5d5a6e3d$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $38d111fe5d5a6e3d$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $38d111fe5d5a6e3d$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $38d111fe5d5a6e3d$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $38d111fe5d5a6e3d$var$S(b), null;
        case 1:
            return $38d111fe5d5a6e3d$var$Zf(b.type) && $38d111fe5d5a6e3d$var$$f(), $38d111fe5d5a6e3d$var$S(b), null;
        case 3:
            d = b.stateNode;
            $38d111fe5d5a6e3d$var$Jh();
            $38d111fe5d5a6e3d$var$E($38d111fe5d5a6e3d$var$Wf);
            $38d111fe5d5a6e3d$var$E($38d111fe5d5a6e3d$var$H);
            $38d111fe5d5a6e3d$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $38d111fe5d5a6e3d$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $38d111fe5d5a6e3d$var$zg && ($38d111fe5d5a6e3d$var$Gj($38d111fe5d5a6e3d$var$zg), $38d111fe5d5a6e3d$var$zg = null));
            $38d111fe5d5a6e3d$var$Bj(a, b);
            $38d111fe5d5a6e3d$var$S(b);
            return null;
        case 5:
            $38d111fe5d5a6e3d$var$Lh(b);
            var e = $38d111fe5d5a6e3d$var$Hh($38d111fe5d5a6e3d$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $38d111fe5d5a6e3d$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($38d111fe5d5a6e3d$var$p(166));
                    $38d111fe5d5a6e3d$var$S(b);
                    return null;
                }
                a = $38d111fe5d5a6e3d$var$Hh($38d111fe5d5a6e3d$var$Eh.current);
                if ($38d111fe5d5a6e3d$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$38d111fe5d5a6e3d$var$Of] = b;
                    d[$38d111fe5d5a6e3d$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $38d111fe5d5a6e3d$var$D("cancel", d);
                            $38d111fe5d5a6e3d$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $38d111fe5d5a6e3d$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $38d111fe5d5a6e3d$var$lf.length; e++)$38d111fe5d5a6e3d$var$D($38d111fe5d5a6e3d$var$lf[e], d);
                            break;
                        case "source":
                            $38d111fe5d5a6e3d$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $38d111fe5d5a6e3d$var$D("error", d);
                            $38d111fe5d5a6e3d$var$D("load", d);
                            break;
                        case "details":
                            $38d111fe5d5a6e3d$var$D("toggle", d);
                            break;
                        case "input":
                            $38d111fe5d5a6e3d$var$Za(d, f);
                            $38d111fe5d5a6e3d$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $38d111fe5d5a6e3d$var$D("invalid", d);
                            break;
                        case "textarea":
                            $38d111fe5d5a6e3d$var$hb(d, f), $38d111fe5d5a6e3d$var$D("invalid", d);
                    }
                    $38d111fe5d5a6e3d$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $38d111fe5d5a6e3d$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $38d111fe5d5a6e3d$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $38d111fe5d5a6e3d$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $38d111fe5d5a6e3d$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $38d111fe5d5a6e3d$var$Va(d);
                            $38d111fe5d5a6e3d$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $38d111fe5d5a6e3d$var$Va(d);
                            $38d111fe5d5a6e3d$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $38d111fe5d5a6e3d$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $38d111fe5d5a6e3d$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$38d111fe5d5a6e3d$var$Of] = b;
                    a[$38d111fe5d5a6e3d$var$Pf] = d;
                    $38d111fe5d5a6e3d$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $38d111fe5d5a6e3d$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $38d111fe5d5a6e3d$var$D("cancel", a);
                                $38d111fe5d5a6e3d$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $38d111fe5d5a6e3d$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $38d111fe5d5a6e3d$var$lf.length; e++)$38d111fe5d5a6e3d$var$D($38d111fe5d5a6e3d$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $38d111fe5d5a6e3d$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $38d111fe5d5a6e3d$var$D("error", a);
                                $38d111fe5d5a6e3d$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $38d111fe5d5a6e3d$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $38d111fe5d5a6e3d$var$Za(a, d);
                                e = $38d111fe5d5a6e3d$var$Ya(a, d);
                                $38d111fe5d5a6e3d$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $38d111fe5d5a6e3d$var$A({}, d, {
                                    value: void 0
                                });
                                $38d111fe5d5a6e3d$var$D("invalid", a);
                                break;
                            case "textarea":
                                $38d111fe5d5a6e3d$var$hb(a, d);
                                e = $38d111fe5d5a6e3d$var$gb(a, d);
                                $38d111fe5d5a6e3d$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $38d111fe5d5a6e3d$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $38d111fe5d5a6e3d$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $38d111fe5d5a6e3d$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $38d111fe5d5a6e3d$var$ob(a, k) : "number" === typeof k && $38d111fe5d5a6e3d$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($38d111fe5d5a6e3d$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $38d111fe5d5a6e3d$var$D("scroll", a) : null != k && $38d111fe5d5a6e3d$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $38d111fe5d5a6e3d$var$Va(a);
                                $38d111fe5d5a6e3d$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $38d111fe5d5a6e3d$var$Va(a);
                                $38d111fe5d5a6e3d$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $38d111fe5d5a6e3d$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $38d111fe5d5a6e3d$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $38d111fe5d5a6e3d$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $38d111fe5d5a6e3d$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $38d111fe5d5a6e3d$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $38d111fe5d5a6e3d$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($38d111fe5d5a6e3d$var$p(166));
                c = $38d111fe5d5a6e3d$var$Hh($38d111fe5d5a6e3d$var$Gh.current);
                $38d111fe5d5a6e3d$var$Hh($38d111fe5d5a6e3d$var$Eh.current);
                if ($38d111fe5d5a6e3d$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$38d111fe5d5a6e3d$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $38d111fe5d5a6e3d$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $38d111fe5d5a6e3d$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $38d111fe5d5a6e3d$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$38d111fe5d5a6e3d$var$Of] = b, b.stateNode = d;
            }
            $38d111fe5d5a6e3d$var$S(b);
            return null;
        case 13:
            $38d111fe5d5a6e3d$var$E($38d111fe5d5a6e3d$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($38d111fe5d5a6e3d$var$I && null !== $38d111fe5d5a6e3d$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $38d111fe5d5a6e3d$var$Hg(), $38d111fe5d5a6e3d$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $38d111fe5d5a6e3d$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($38d111fe5d5a6e3d$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($38d111fe5d5a6e3d$var$p(317));
                        f[$38d111fe5d5a6e3d$var$Of] = b;
                    } else $38d111fe5d5a6e3d$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $38d111fe5d5a6e3d$var$S(b);
                    f = !1;
                } else null !== $38d111fe5d5a6e3d$var$zg && ($38d111fe5d5a6e3d$var$Gj($38d111fe5d5a6e3d$var$zg), $38d111fe5d5a6e3d$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($38d111fe5d5a6e3d$var$M.current & 1) ? 0 === $38d111fe5d5a6e3d$var$T && ($38d111fe5d5a6e3d$var$T = 3) : $38d111fe5d5a6e3d$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $38d111fe5d5a6e3d$var$S(b);
            return null;
        case 4:
            return $38d111fe5d5a6e3d$var$Jh(), $38d111fe5d5a6e3d$var$Bj(a, b), null === a && $38d111fe5d5a6e3d$var$sf(b.stateNode.containerInfo), $38d111fe5d5a6e3d$var$S(b), null;
        case 10:
            return $38d111fe5d5a6e3d$var$Rg(b.type._context), $38d111fe5d5a6e3d$var$S(b), null;
        case 17:
            return $38d111fe5d5a6e3d$var$Zf(b.type) && $38d111fe5d5a6e3d$var$$f(), $38d111fe5d5a6e3d$var$S(b), null;
        case 19:
            $38d111fe5d5a6e3d$var$E($38d111fe5d5a6e3d$var$M);
            f = b.memoizedState;
            if (null === f) return $38d111fe5d5a6e3d$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $38d111fe5d5a6e3d$var$Ej(f, !1);
                else {
                    if (0 !== $38d111fe5d5a6e3d$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $38d111fe5d5a6e3d$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $38d111fe5d5a6e3d$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $38d111fe5d5a6e3d$var$G($38d111fe5d5a6e3d$var$M, $38d111fe5d5a6e3d$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $38d111fe5d5a6e3d$var$B() > $38d111fe5d5a6e3d$var$Hj && (b.flags |= 128, d = !0, $38d111fe5d5a6e3d$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $38d111fe5d5a6e3d$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $38d111fe5d5a6e3d$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$38d111fe5d5a6e3d$var$I) return $38d111fe5d5a6e3d$var$S(b), null;
                    } else 2 * $38d111fe5d5a6e3d$var$B() - f.renderingStartTime > $38d111fe5d5a6e3d$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $38d111fe5d5a6e3d$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $38d111fe5d5a6e3d$var$B(), b.sibling = null, c = $38d111fe5d5a6e3d$var$M.current, $38d111fe5d5a6e3d$var$G($38d111fe5d5a6e3d$var$M, d ? c & 1 | 2 : c & 1), b;
            $38d111fe5d5a6e3d$var$S(b);
            return null;
        case 22:
        case 23:
            return $38d111fe5d5a6e3d$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($38d111fe5d5a6e3d$var$gj & 1073741824) && ($38d111fe5d5a6e3d$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $38d111fe5d5a6e3d$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($38d111fe5d5a6e3d$var$p(156, b.tag));
}
function $38d111fe5d5a6e3d$var$Jj(a, b) {
    $38d111fe5d5a6e3d$var$wg(b);
    switch(b.tag){
        case 1:
            return $38d111fe5d5a6e3d$var$Zf(b.type) && $38d111fe5d5a6e3d$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $38d111fe5d5a6e3d$var$Jh(), $38d111fe5d5a6e3d$var$E($38d111fe5d5a6e3d$var$Wf), $38d111fe5d5a6e3d$var$E($38d111fe5d5a6e3d$var$H), $38d111fe5d5a6e3d$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $38d111fe5d5a6e3d$var$Lh(b), null;
        case 13:
            $38d111fe5d5a6e3d$var$E($38d111fe5d5a6e3d$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($38d111fe5d5a6e3d$var$p(340));
                $38d111fe5d5a6e3d$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $38d111fe5d5a6e3d$var$E($38d111fe5d5a6e3d$var$M), null;
        case 4:
            return $38d111fe5d5a6e3d$var$Jh(), null;
        case 10:
            return $38d111fe5d5a6e3d$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $38d111fe5d5a6e3d$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $38d111fe5d5a6e3d$var$Kj = !1, $38d111fe5d5a6e3d$var$U = !1, $38d111fe5d5a6e3d$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $38d111fe5d5a6e3d$var$V = null;
function $38d111fe5d5a6e3d$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $38d111fe5d5a6e3d$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $38d111fe5d5a6e3d$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $38d111fe5d5a6e3d$var$W(a, b, d);
    }
}
var $38d111fe5d5a6e3d$var$Oj = !1;
function $38d111fe5d5a6e3d$var$Pj(a, b) {
    $38d111fe5d5a6e3d$var$Cf = $38d111fe5d5a6e3d$var$dd;
    a = $38d111fe5d5a6e3d$var$Me();
    if ($38d111fe5d5a6e3d$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $38d111fe5d5a6e3d$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $38d111fe5d5a6e3d$var$dd = !1;
    for($38d111fe5d5a6e3d$var$V = b; null !== $38d111fe5d5a6e3d$var$V;)if (b = $38d111fe5d5a6e3d$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $38d111fe5d5a6e3d$var$V = a;
    else for(; null !== $38d111fe5d5a6e3d$var$V;){
        b = $38d111fe5d5a6e3d$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $38d111fe5d5a6e3d$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($38d111fe5d5a6e3d$var$p(163));
            }
        } catch (F) {
            $38d111fe5d5a6e3d$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $38d111fe5d5a6e3d$var$V = a;
            break;
        }
        $38d111fe5d5a6e3d$var$V = b.return;
    }
    n = $38d111fe5d5a6e3d$var$Oj;
    $38d111fe5d5a6e3d$var$Oj = !1;
    return n;
}
function $38d111fe5d5a6e3d$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $38d111fe5d5a6e3d$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $38d111fe5d5a6e3d$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $38d111fe5d5a6e3d$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $38d111fe5d5a6e3d$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $38d111fe5d5a6e3d$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$38d111fe5d5a6e3d$var$Of], delete b[$38d111fe5d5a6e3d$var$Pf], delete b[$38d111fe5d5a6e3d$var$of], delete b[$38d111fe5d5a6e3d$var$Qf], delete b[$38d111fe5d5a6e3d$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $38d111fe5d5a6e3d$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $38d111fe5d5a6e3d$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $38d111fe5d5a6e3d$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $38d111fe5d5a6e3d$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $38d111fe5d5a6e3d$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($38d111fe5d5a6e3d$var$Wj(a, b, c), a = a.sibling; null !== a;)$38d111fe5d5a6e3d$var$Wj(a, b, c), a = a.sibling;
}
function $38d111fe5d5a6e3d$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($38d111fe5d5a6e3d$var$Xj(a, b, c), a = a.sibling; null !== a;)$38d111fe5d5a6e3d$var$Xj(a, b, c), a = a.sibling;
}
var $38d111fe5d5a6e3d$var$X = null, $38d111fe5d5a6e3d$var$Yj = !1;
function $38d111fe5d5a6e3d$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$38d111fe5d5a6e3d$var$ak(a, b, c), c = c.sibling;
}
function $38d111fe5d5a6e3d$var$ak(a, b, c) {
    if ($38d111fe5d5a6e3d$var$lc && "function" === typeof $38d111fe5d5a6e3d$var$lc.onCommitFiberUnmount) try {
        $38d111fe5d5a6e3d$var$lc.onCommitFiberUnmount($38d111fe5d5a6e3d$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $38d111fe5d5a6e3d$var$U || $38d111fe5d5a6e3d$var$Mj(c, b);
        case 6:
            var d = $38d111fe5d5a6e3d$var$X, e = $38d111fe5d5a6e3d$var$Yj;
            $38d111fe5d5a6e3d$var$X = null;
            $38d111fe5d5a6e3d$var$Zj(a, b, c);
            $38d111fe5d5a6e3d$var$X = d;
            $38d111fe5d5a6e3d$var$Yj = e;
            null !== $38d111fe5d5a6e3d$var$X && ($38d111fe5d5a6e3d$var$Yj ? (a = $38d111fe5d5a6e3d$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $38d111fe5d5a6e3d$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $38d111fe5d5a6e3d$var$X && ($38d111fe5d5a6e3d$var$Yj ? (a = $38d111fe5d5a6e3d$var$X, c = c.stateNode, 8 === a.nodeType ? $38d111fe5d5a6e3d$var$Kf(a.parentNode, c) : 1 === a.nodeType && $38d111fe5d5a6e3d$var$Kf(a, c), $38d111fe5d5a6e3d$var$bd(a)) : $38d111fe5d5a6e3d$var$Kf($38d111fe5d5a6e3d$var$X, c.stateNode));
            break;
        case 4:
            d = $38d111fe5d5a6e3d$var$X;
            e = $38d111fe5d5a6e3d$var$Yj;
            $38d111fe5d5a6e3d$var$X = c.stateNode.containerInfo;
            $38d111fe5d5a6e3d$var$Yj = !0;
            $38d111fe5d5a6e3d$var$Zj(a, b, c);
            $38d111fe5d5a6e3d$var$X = d;
            $38d111fe5d5a6e3d$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$38d111fe5d5a6e3d$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $38d111fe5d5a6e3d$var$Nj(c, b, g) : 0 !== (f & 4) && $38d111fe5d5a6e3d$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $38d111fe5d5a6e3d$var$Zj(a, b, c);
            break;
        case 1:
            if (!$38d111fe5d5a6e3d$var$U && ($38d111fe5d5a6e3d$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $38d111fe5d5a6e3d$var$W(c, b, h);
            }
            $38d111fe5d5a6e3d$var$Zj(a, b, c);
            break;
        case 21:
            $38d111fe5d5a6e3d$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($38d111fe5d5a6e3d$var$U = (d = $38d111fe5d5a6e3d$var$U) || null !== c.memoizedState, $38d111fe5d5a6e3d$var$Zj(a, b, c), $38d111fe5d5a6e3d$var$U = d) : $38d111fe5d5a6e3d$var$Zj(a, b, c);
            break;
        default:
            $38d111fe5d5a6e3d$var$Zj(a, b, c);
    }
}
function $38d111fe5d5a6e3d$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $38d111fe5d5a6e3d$var$Lj);
        b.forEach(function(b) {
            var d = $38d111fe5d5a6e3d$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $38d111fe5d5a6e3d$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $38d111fe5d5a6e3d$var$X = h.stateNode;
                        $38d111fe5d5a6e3d$var$Yj = !1;
                        break a;
                    case 3:
                        $38d111fe5d5a6e3d$var$X = h.stateNode.containerInfo;
                        $38d111fe5d5a6e3d$var$Yj = !0;
                        break a;
                    case 4:
                        $38d111fe5d5a6e3d$var$X = h.stateNode.containerInfo;
                        $38d111fe5d5a6e3d$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $38d111fe5d5a6e3d$var$X) throw Error($38d111fe5d5a6e3d$var$p(160));
            $38d111fe5d5a6e3d$var$ak(f, g, e);
            $38d111fe5d5a6e3d$var$X = null;
            $38d111fe5d5a6e3d$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $38d111fe5d5a6e3d$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$38d111fe5d5a6e3d$var$ek(b, a), b = b.sibling;
}
function $38d111fe5d5a6e3d$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $38d111fe5d5a6e3d$var$dk(b, a);
            $38d111fe5d5a6e3d$var$fk(a);
            if (d & 4) {
                try {
                    $38d111fe5d5a6e3d$var$Qj(3, a, a.return), $38d111fe5d5a6e3d$var$Rj(3, a);
                } catch (t) {
                    $38d111fe5d5a6e3d$var$W(a, a.return, t);
                }
                try {
                    $38d111fe5d5a6e3d$var$Qj(5, a, a.return);
                } catch (t) {
                    $38d111fe5d5a6e3d$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $38d111fe5d5a6e3d$var$dk(b, a);
            $38d111fe5d5a6e3d$var$fk(a);
            d & 512 && null !== c && $38d111fe5d5a6e3d$var$Mj(c, c.return);
            break;
        case 5:
            $38d111fe5d5a6e3d$var$dk(b, a);
            $38d111fe5d5a6e3d$var$fk(a);
            d & 512 && null !== c && $38d111fe5d5a6e3d$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $38d111fe5d5a6e3d$var$ob(e, "");
                } catch (t) {
                    $38d111fe5d5a6e3d$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $38d111fe5d5a6e3d$var$ab(e, f);
                    $38d111fe5d5a6e3d$var$vb(h, g);
                    var l = $38d111fe5d5a6e3d$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $38d111fe5d5a6e3d$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $38d111fe5d5a6e3d$var$nb(e, q) : "children" === m ? $38d111fe5d5a6e3d$var$ob(e, q) : $38d111fe5d5a6e3d$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $38d111fe5d5a6e3d$var$bb(e, f);
                            break;
                        case "textarea":
                            $38d111fe5d5a6e3d$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $38d111fe5d5a6e3d$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $38d111fe5d5a6e3d$var$fb(e, !!f.multiple, f.defaultValue, !0) : $38d111fe5d5a6e3d$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$38d111fe5d5a6e3d$var$Pf] = f;
                } catch (t) {
                    $38d111fe5d5a6e3d$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $38d111fe5d5a6e3d$var$dk(b, a);
            $38d111fe5d5a6e3d$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($38d111fe5d5a6e3d$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $38d111fe5d5a6e3d$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $38d111fe5d5a6e3d$var$dk(b, a);
            $38d111fe5d5a6e3d$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $38d111fe5d5a6e3d$var$bd(b.containerInfo);
            } catch (t) {
                $38d111fe5d5a6e3d$var$W(a, a.return, t);
            }
            break;
        case 4:
            $38d111fe5d5a6e3d$var$dk(b, a);
            $38d111fe5d5a6e3d$var$fk(a);
            break;
        case 13:
            $38d111fe5d5a6e3d$var$dk(b, a);
            $38d111fe5d5a6e3d$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($38d111fe5d5a6e3d$var$gk = $38d111fe5d5a6e3d$var$B()));
            d & 4 && $38d111fe5d5a6e3d$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($38d111fe5d5a6e3d$var$U = (l = $38d111fe5d5a6e3d$var$U) || m, $38d111fe5d5a6e3d$var$dk(b, a), $38d111fe5d5a6e3d$var$U = l) : $38d111fe5d5a6e3d$var$dk(b, a);
            $38d111fe5d5a6e3d$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($38d111fe5d5a6e3d$var$V = a, m = a.child; null !== m;){
                    for(q = $38d111fe5d5a6e3d$var$V = m; null !== $38d111fe5d5a6e3d$var$V;){
                        r = $38d111fe5d5a6e3d$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $38d111fe5d5a6e3d$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $38d111fe5d5a6e3d$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $38d111fe5d5a6e3d$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $38d111fe5d5a6e3d$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $38d111fe5d5a6e3d$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $38d111fe5d5a6e3d$var$V = y) : $38d111fe5d5a6e3d$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $38d111fe5d5a6e3d$var$rb("display", g));
                            } catch (t) {
                                $38d111fe5d5a6e3d$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $38d111fe5d5a6e3d$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $38d111fe5d5a6e3d$var$dk(b, a);
            $38d111fe5d5a6e3d$var$fk(a);
            d & 4 && $38d111fe5d5a6e3d$var$bk(a);
            break;
        case 21:
            break;
        default:
            $38d111fe5d5a6e3d$var$dk(b, a), $38d111fe5d5a6e3d$var$fk(a);
    }
}
function $38d111fe5d5a6e3d$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($38d111fe5d5a6e3d$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($38d111fe5d5a6e3d$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($38d111fe5d5a6e3d$var$ob(e, ""), d.flags &= -33);
                    var f = $38d111fe5d5a6e3d$var$Vj(a);
                    $38d111fe5d5a6e3d$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $38d111fe5d5a6e3d$var$Vj(a);
                    $38d111fe5d5a6e3d$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($38d111fe5d5a6e3d$var$p(161));
            }
        } catch (k) {
            $38d111fe5d5a6e3d$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $38d111fe5d5a6e3d$var$ik(a, b, c) {
    $38d111fe5d5a6e3d$var$V = a;
    $38d111fe5d5a6e3d$var$jk(a, b, c);
}
function $38d111fe5d5a6e3d$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $38d111fe5d5a6e3d$var$V;){
        var e = $38d111fe5d5a6e3d$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $38d111fe5d5a6e3d$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $38d111fe5d5a6e3d$var$U;
                h = $38d111fe5d5a6e3d$var$Kj;
                var l = $38d111fe5d5a6e3d$var$U;
                $38d111fe5d5a6e3d$var$Kj = g;
                if (($38d111fe5d5a6e3d$var$U = k) && !l) for($38d111fe5d5a6e3d$var$V = e; null !== $38d111fe5d5a6e3d$var$V;)g = $38d111fe5d5a6e3d$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $38d111fe5d5a6e3d$var$kk(e) : null !== k ? (k.return = g, $38d111fe5d5a6e3d$var$V = k) : $38d111fe5d5a6e3d$var$kk(e);
                for(; null !== f;)$38d111fe5d5a6e3d$var$V = f, $38d111fe5d5a6e3d$var$jk(f, b, c), f = f.sibling;
                $38d111fe5d5a6e3d$var$V = e;
                $38d111fe5d5a6e3d$var$Kj = h;
                $38d111fe5d5a6e3d$var$U = l;
            }
            $38d111fe5d5a6e3d$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $38d111fe5d5a6e3d$var$V = f) : $38d111fe5d5a6e3d$var$lk(a, b, c);
    }
}
function $38d111fe5d5a6e3d$var$lk(a) {
    for(; null !== $38d111fe5d5a6e3d$var$V;){
        var b = $38d111fe5d5a6e3d$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $38d111fe5d5a6e3d$var$U || $38d111fe5d5a6e3d$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$38d111fe5d5a6e3d$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $38d111fe5d5a6e3d$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $38d111fe5d5a6e3d$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $38d111fe5d5a6e3d$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $38d111fe5d5a6e3d$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($38d111fe5d5a6e3d$var$p(163));
                }
                $38d111fe5d5a6e3d$var$U || b.flags & 512 && $38d111fe5d5a6e3d$var$Sj(b);
            } catch (r) {
                $38d111fe5d5a6e3d$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $38d111fe5d5a6e3d$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $38d111fe5d5a6e3d$var$V = c;
            break;
        }
        $38d111fe5d5a6e3d$var$V = b.return;
    }
}
function $38d111fe5d5a6e3d$var$hk(a) {
    for(; null !== $38d111fe5d5a6e3d$var$V;){
        var b = $38d111fe5d5a6e3d$var$V;
        if (b === a) {
            $38d111fe5d5a6e3d$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $38d111fe5d5a6e3d$var$V = c;
            break;
        }
        $38d111fe5d5a6e3d$var$V = b.return;
    }
}
function $38d111fe5d5a6e3d$var$kk(a) {
    for(; null !== $38d111fe5d5a6e3d$var$V;){
        var b = $38d111fe5d5a6e3d$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $38d111fe5d5a6e3d$var$Rj(4, b);
                    } catch (k) {
                        $38d111fe5d5a6e3d$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $38d111fe5d5a6e3d$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $38d111fe5d5a6e3d$var$Sj(b);
                    } catch (k) {
                        $38d111fe5d5a6e3d$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $38d111fe5d5a6e3d$var$Sj(b);
                    } catch (k) {
                        $38d111fe5d5a6e3d$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $38d111fe5d5a6e3d$var$W(b, b.return, k);
        }
        if (b === a) {
            $38d111fe5d5a6e3d$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $38d111fe5d5a6e3d$var$V = h;
            break;
        }
        $38d111fe5d5a6e3d$var$V = b.return;
    }
}
var $38d111fe5d5a6e3d$var$mk = Math.ceil, $38d111fe5d5a6e3d$var$nk = $38d111fe5d5a6e3d$var$ua.ReactCurrentDispatcher, $38d111fe5d5a6e3d$var$ok = $38d111fe5d5a6e3d$var$ua.ReactCurrentOwner, $38d111fe5d5a6e3d$var$pk = $38d111fe5d5a6e3d$var$ua.ReactCurrentBatchConfig, $38d111fe5d5a6e3d$var$K = 0, $38d111fe5d5a6e3d$var$R = null, $38d111fe5d5a6e3d$var$Y = null, $38d111fe5d5a6e3d$var$Z = 0, $38d111fe5d5a6e3d$var$gj = 0, $38d111fe5d5a6e3d$var$fj = $38d111fe5d5a6e3d$var$Uf(0), $38d111fe5d5a6e3d$var$T = 0, $38d111fe5d5a6e3d$var$qk = null, $38d111fe5d5a6e3d$var$hh = 0, $38d111fe5d5a6e3d$var$rk = 0, $38d111fe5d5a6e3d$var$sk = 0, $38d111fe5d5a6e3d$var$tk = null, $38d111fe5d5a6e3d$var$uk = null, $38d111fe5d5a6e3d$var$gk = 0, $38d111fe5d5a6e3d$var$Hj = Infinity, $38d111fe5d5a6e3d$var$vk = null, $38d111fe5d5a6e3d$var$Pi = !1, $38d111fe5d5a6e3d$var$Qi = null, $38d111fe5d5a6e3d$var$Si = null, $38d111fe5d5a6e3d$var$wk = !1, $38d111fe5d5a6e3d$var$xk = null, $38d111fe5d5a6e3d$var$yk = 0, $38d111fe5d5a6e3d$var$zk = 0, $38d111fe5d5a6e3d$var$Ak = null, $38d111fe5d5a6e3d$var$Bk = -1, $38d111fe5d5a6e3d$var$Ck = 0;
function $38d111fe5d5a6e3d$var$L() {
    return 0 !== ($38d111fe5d5a6e3d$var$K & 6) ? $38d111fe5d5a6e3d$var$B() : -1 !== $38d111fe5d5a6e3d$var$Bk ? $38d111fe5d5a6e3d$var$Bk : $38d111fe5d5a6e3d$var$Bk = $38d111fe5d5a6e3d$var$B();
}
function $38d111fe5d5a6e3d$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($38d111fe5d5a6e3d$var$K & 2) && 0 !== $38d111fe5d5a6e3d$var$Z) return $38d111fe5d5a6e3d$var$Z & -$38d111fe5d5a6e3d$var$Z;
    if (null !== $38d111fe5d5a6e3d$var$Kg.transition) return 0 === $38d111fe5d5a6e3d$var$Ck && ($38d111fe5d5a6e3d$var$Ck = $38d111fe5d5a6e3d$var$yc()), $38d111fe5d5a6e3d$var$Ck;
    a = $38d111fe5d5a6e3d$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $38d111fe5d5a6e3d$var$jd(a.type);
    return a;
}
function $38d111fe5d5a6e3d$var$mh(a, b, c, d) {
    if (50 < $38d111fe5d5a6e3d$var$zk) throw $38d111fe5d5a6e3d$var$zk = 0, $38d111fe5d5a6e3d$var$Ak = null, Error($38d111fe5d5a6e3d$var$p(185));
    $38d111fe5d5a6e3d$var$Ac(a, c, d);
    if (0 === ($38d111fe5d5a6e3d$var$K & 2) || a !== $38d111fe5d5a6e3d$var$R) a === $38d111fe5d5a6e3d$var$R && (0 === ($38d111fe5d5a6e3d$var$K & 2) && ($38d111fe5d5a6e3d$var$rk |= c), 4 === $38d111fe5d5a6e3d$var$T && $38d111fe5d5a6e3d$var$Dk(a, $38d111fe5d5a6e3d$var$Z)), $38d111fe5d5a6e3d$var$Ek(a, d), 1 === c && 0 === $38d111fe5d5a6e3d$var$K && 0 === (b.mode & 1) && ($38d111fe5d5a6e3d$var$Hj = $38d111fe5d5a6e3d$var$B() + 500, $38d111fe5d5a6e3d$var$fg && $38d111fe5d5a6e3d$var$jg());
}
function $38d111fe5d5a6e3d$var$Ek(a, b) {
    var c = a.callbackNode;
    $38d111fe5d5a6e3d$var$wc(a, b);
    var d = $38d111fe5d5a6e3d$var$uc(a, a === $38d111fe5d5a6e3d$var$R ? $38d111fe5d5a6e3d$var$Z : 0);
    if (0 === d) null !== c && $38d111fe5d5a6e3d$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $38d111fe5d5a6e3d$var$bc(c);
        if (1 === b) 0 === a.tag ? $38d111fe5d5a6e3d$var$ig($38d111fe5d5a6e3d$var$Fk.bind(null, a)) : $38d111fe5d5a6e3d$var$hg($38d111fe5d5a6e3d$var$Fk.bind(null, a)), $38d111fe5d5a6e3d$var$Jf(function() {
            0 === ($38d111fe5d5a6e3d$var$K & 6) && $38d111fe5d5a6e3d$var$jg();
        }), c = null;
        else {
            switch($38d111fe5d5a6e3d$var$Dc(d)){
                case 1:
                    c = $38d111fe5d5a6e3d$var$fc;
                    break;
                case 4:
                    c = $38d111fe5d5a6e3d$var$gc;
                    break;
                case 16:
                    c = $38d111fe5d5a6e3d$var$hc;
                    break;
                case 536870912:
                    c = $38d111fe5d5a6e3d$var$jc;
                    break;
                default:
                    c = $38d111fe5d5a6e3d$var$hc;
            }
            c = $38d111fe5d5a6e3d$var$Gk(c, $38d111fe5d5a6e3d$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $38d111fe5d5a6e3d$var$Hk(a, b) {
    $38d111fe5d5a6e3d$var$Bk = -1;
    $38d111fe5d5a6e3d$var$Ck = 0;
    if (0 !== ($38d111fe5d5a6e3d$var$K & 6)) throw Error($38d111fe5d5a6e3d$var$p(327));
    var c = a.callbackNode;
    if ($38d111fe5d5a6e3d$var$Ik() && a.callbackNode !== c) return null;
    var d = $38d111fe5d5a6e3d$var$uc(a, a === $38d111fe5d5a6e3d$var$R ? $38d111fe5d5a6e3d$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $38d111fe5d5a6e3d$var$Jk(a, d);
    else {
        b = d;
        var e = $38d111fe5d5a6e3d$var$K;
        $38d111fe5d5a6e3d$var$K |= 2;
        var f = $38d111fe5d5a6e3d$var$Kk();
        if ($38d111fe5d5a6e3d$var$R !== a || $38d111fe5d5a6e3d$var$Z !== b) $38d111fe5d5a6e3d$var$vk = null, $38d111fe5d5a6e3d$var$Hj = $38d111fe5d5a6e3d$var$B() + 500, $38d111fe5d5a6e3d$var$Lk(a, b);
        for(;;)try {
            $38d111fe5d5a6e3d$var$Mk();
            break;
        } catch (h) {
            $38d111fe5d5a6e3d$var$Nk(a, h);
        }
        $38d111fe5d5a6e3d$var$Qg();
        $38d111fe5d5a6e3d$var$nk.current = f;
        $38d111fe5d5a6e3d$var$K = e;
        null !== $38d111fe5d5a6e3d$var$Y ? b = 0 : ($38d111fe5d5a6e3d$var$R = null, $38d111fe5d5a6e3d$var$Z = 0, b = $38d111fe5d5a6e3d$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $38d111fe5d5a6e3d$var$xc(a), 0 !== e && (d = e, b = $38d111fe5d5a6e3d$var$Ok(a, e)));
        if (1 === b) throw c = $38d111fe5d5a6e3d$var$qk, $38d111fe5d5a6e3d$var$Lk(a, 0), $38d111fe5d5a6e3d$var$Dk(a, d), $38d111fe5d5a6e3d$var$Ek(a, $38d111fe5d5a6e3d$var$B()), c;
        if (6 === b) $38d111fe5d5a6e3d$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$38d111fe5d5a6e3d$var$Pk(e) && (b = $38d111fe5d5a6e3d$var$Jk(a, d), 2 === b && (f = $38d111fe5d5a6e3d$var$xc(a), 0 !== f && (d = f, b = $38d111fe5d5a6e3d$var$Ok(a, f))), 1 === b)) throw c = $38d111fe5d5a6e3d$var$qk, $38d111fe5d5a6e3d$var$Lk(a, 0), $38d111fe5d5a6e3d$var$Dk(a, d), $38d111fe5d5a6e3d$var$Ek(a, $38d111fe5d5a6e3d$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($38d111fe5d5a6e3d$var$p(345));
                case 2:
                    $38d111fe5d5a6e3d$var$Qk(a, $38d111fe5d5a6e3d$var$uk, $38d111fe5d5a6e3d$var$vk);
                    break;
                case 3:
                    $38d111fe5d5a6e3d$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $38d111fe5d5a6e3d$var$gk + 500 - $38d111fe5d5a6e3d$var$B(), 10 < b)) {
                        if (0 !== $38d111fe5d5a6e3d$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $38d111fe5d5a6e3d$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $38d111fe5d5a6e3d$var$Ff($38d111fe5d5a6e3d$var$Qk.bind(null, a, $38d111fe5d5a6e3d$var$uk, $38d111fe5d5a6e3d$var$vk), b);
                        break;
                    }
                    $38d111fe5d5a6e3d$var$Qk(a, $38d111fe5d5a6e3d$var$uk, $38d111fe5d5a6e3d$var$vk);
                    break;
                case 4:
                    $38d111fe5d5a6e3d$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $38d111fe5d5a6e3d$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $38d111fe5d5a6e3d$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $38d111fe5d5a6e3d$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $38d111fe5d5a6e3d$var$Ff($38d111fe5d5a6e3d$var$Qk.bind(null, a, $38d111fe5d5a6e3d$var$uk, $38d111fe5d5a6e3d$var$vk), d);
                        break;
                    }
                    $38d111fe5d5a6e3d$var$Qk(a, $38d111fe5d5a6e3d$var$uk, $38d111fe5d5a6e3d$var$vk);
                    break;
                case 5:
                    $38d111fe5d5a6e3d$var$Qk(a, $38d111fe5d5a6e3d$var$uk, $38d111fe5d5a6e3d$var$vk);
                    break;
                default:
                    throw Error($38d111fe5d5a6e3d$var$p(329));
            }
        }
    }
    $38d111fe5d5a6e3d$var$Ek(a, $38d111fe5d5a6e3d$var$B());
    return a.callbackNode === c ? $38d111fe5d5a6e3d$var$Hk.bind(null, a) : null;
}
function $38d111fe5d5a6e3d$var$Ok(a, b) {
    var c = $38d111fe5d5a6e3d$var$tk;
    a.current.memoizedState.isDehydrated && ($38d111fe5d5a6e3d$var$Lk(a, b).flags |= 256);
    a = $38d111fe5d5a6e3d$var$Jk(a, b);
    2 !== a && (b = $38d111fe5d5a6e3d$var$uk, $38d111fe5d5a6e3d$var$uk = c, null !== b && $38d111fe5d5a6e3d$var$Gj(b));
    return a;
}
function $38d111fe5d5a6e3d$var$Gj(a) {
    null === $38d111fe5d5a6e3d$var$uk ? $38d111fe5d5a6e3d$var$uk = a : $38d111fe5d5a6e3d$var$uk.push.apply($38d111fe5d5a6e3d$var$uk, a);
}
function $38d111fe5d5a6e3d$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$38d111fe5d5a6e3d$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $38d111fe5d5a6e3d$var$Dk(a, b) {
    b &= ~$38d111fe5d5a6e3d$var$sk;
    b &= ~$38d111fe5d5a6e3d$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $38d111fe5d5a6e3d$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $38d111fe5d5a6e3d$var$Fk(a) {
    if (0 !== ($38d111fe5d5a6e3d$var$K & 6)) throw Error($38d111fe5d5a6e3d$var$p(327));
    $38d111fe5d5a6e3d$var$Ik();
    var b = $38d111fe5d5a6e3d$var$uc(a, 0);
    if (0 === (b & 1)) return $38d111fe5d5a6e3d$var$Ek(a, $38d111fe5d5a6e3d$var$B()), null;
    var c = $38d111fe5d5a6e3d$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $38d111fe5d5a6e3d$var$xc(a);
        0 !== d && (b = d, c = $38d111fe5d5a6e3d$var$Ok(a, d));
    }
    if (1 === c) throw c = $38d111fe5d5a6e3d$var$qk, $38d111fe5d5a6e3d$var$Lk(a, 0), $38d111fe5d5a6e3d$var$Dk(a, b), $38d111fe5d5a6e3d$var$Ek(a, $38d111fe5d5a6e3d$var$B()), c;
    if (6 === c) throw Error($38d111fe5d5a6e3d$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $38d111fe5d5a6e3d$var$Qk(a, $38d111fe5d5a6e3d$var$uk, $38d111fe5d5a6e3d$var$vk);
    $38d111fe5d5a6e3d$var$Ek(a, $38d111fe5d5a6e3d$var$B());
    return null;
}
function $38d111fe5d5a6e3d$var$Rk(a, b) {
    var c = $38d111fe5d5a6e3d$var$K;
    $38d111fe5d5a6e3d$var$K |= 1;
    try {
        return a(b);
    } finally{
        $38d111fe5d5a6e3d$var$K = c, 0 === $38d111fe5d5a6e3d$var$K && ($38d111fe5d5a6e3d$var$Hj = $38d111fe5d5a6e3d$var$B() + 500, $38d111fe5d5a6e3d$var$fg && $38d111fe5d5a6e3d$var$jg());
    }
}
function $38d111fe5d5a6e3d$var$Sk(a) {
    null !== $38d111fe5d5a6e3d$var$xk && 0 === $38d111fe5d5a6e3d$var$xk.tag && 0 === ($38d111fe5d5a6e3d$var$K & 6) && $38d111fe5d5a6e3d$var$Ik();
    var b = $38d111fe5d5a6e3d$var$K;
    $38d111fe5d5a6e3d$var$K |= 1;
    var c = $38d111fe5d5a6e3d$var$pk.transition, d = $38d111fe5d5a6e3d$var$C;
    try {
        if ($38d111fe5d5a6e3d$var$pk.transition = null, $38d111fe5d5a6e3d$var$C = 1, a) return a();
    } finally{
        $38d111fe5d5a6e3d$var$C = d, $38d111fe5d5a6e3d$var$pk.transition = c, $38d111fe5d5a6e3d$var$K = b, 0 === ($38d111fe5d5a6e3d$var$K & 6) && $38d111fe5d5a6e3d$var$jg();
    }
}
function $38d111fe5d5a6e3d$var$Ij() {
    $38d111fe5d5a6e3d$var$gj = $38d111fe5d5a6e3d$var$fj.current;
    $38d111fe5d5a6e3d$var$E($38d111fe5d5a6e3d$var$fj);
}
function $38d111fe5d5a6e3d$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $38d111fe5d5a6e3d$var$Gf(c));
    if (null !== $38d111fe5d5a6e3d$var$Y) for(c = $38d111fe5d5a6e3d$var$Y.return; null !== c;){
        var d = c;
        $38d111fe5d5a6e3d$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $38d111fe5d5a6e3d$var$$f();
                break;
            case 3:
                $38d111fe5d5a6e3d$var$Jh();
                $38d111fe5d5a6e3d$var$E($38d111fe5d5a6e3d$var$Wf);
                $38d111fe5d5a6e3d$var$E($38d111fe5d5a6e3d$var$H);
                $38d111fe5d5a6e3d$var$Oh();
                break;
            case 5:
                $38d111fe5d5a6e3d$var$Lh(d);
                break;
            case 4:
                $38d111fe5d5a6e3d$var$Jh();
                break;
            case 13:
                $38d111fe5d5a6e3d$var$E($38d111fe5d5a6e3d$var$M);
                break;
            case 19:
                $38d111fe5d5a6e3d$var$E($38d111fe5d5a6e3d$var$M);
                break;
            case 10:
                $38d111fe5d5a6e3d$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $38d111fe5d5a6e3d$var$Ij();
        }
        c = c.return;
    }
    $38d111fe5d5a6e3d$var$R = a;
    $38d111fe5d5a6e3d$var$Y = a = $38d111fe5d5a6e3d$var$wh(a.current, null);
    $38d111fe5d5a6e3d$var$Z = $38d111fe5d5a6e3d$var$gj = b;
    $38d111fe5d5a6e3d$var$T = 0;
    $38d111fe5d5a6e3d$var$qk = null;
    $38d111fe5d5a6e3d$var$sk = $38d111fe5d5a6e3d$var$rk = $38d111fe5d5a6e3d$var$hh = 0;
    $38d111fe5d5a6e3d$var$uk = $38d111fe5d5a6e3d$var$tk = null;
    if (null !== $38d111fe5d5a6e3d$var$Wg) {
        for(b = 0; b < $38d111fe5d5a6e3d$var$Wg.length; b++)if (c = $38d111fe5d5a6e3d$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $38d111fe5d5a6e3d$var$Wg = null;
    }
    return a;
}
function $38d111fe5d5a6e3d$var$Nk(a, b) {
    do {
        var c = $38d111fe5d5a6e3d$var$Y;
        try {
            $38d111fe5d5a6e3d$var$Qg();
            $38d111fe5d5a6e3d$var$Ph.current = $38d111fe5d5a6e3d$var$ai;
            if ($38d111fe5d5a6e3d$var$Sh) {
                for(var d = $38d111fe5d5a6e3d$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $38d111fe5d5a6e3d$var$Sh = !1;
            }
            $38d111fe5d5a6e3d$var$Rh = 0;
            $38d111fe5d5a6e3d$var$P = $38d111fe5d5a6e3d$var$O = $38d111fe5d5a6e3d$var$N = null;
            $38d111fe5d5a6e3d$var$Th = !1;
            $38d111fe5d5a6e3d$var$Uh = 0;
            $38d111fe5d5a6e3d$var$ok.current = null;
            if (null === c || null === c.return) {
                $38d111fe5d5a6e3d$var$T = 1;
                $38d111fe5d5a6e3d$var$qk = b;
                $38d111fe5d5a6e3d$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $38d111fe5d5a6e3d$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $38d111fe5d5a6e3d$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $38d111fe5d5a6e3d$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $38d111fe5d5a6e3d$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $38d111fe5d5a6e3d$var$Ti(f, l, b);
                            $38d111fe5d5a6e3d$var$uj();
                            break a;
                        }
                        k = Error($38d111fe5d5a6e3d$var$p(426));
                    }
                } else if ($38d111fe5d5a6e3d$var$I && h.mode & 1) {
                    var J = $38d111fe5d5a6e3d$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $38d111fe5d5a6e3d$var$Wi(J, g, h, f, b);
                        $38d111fe5d5a6e3d$var$Jg($38d111fe5d5a6e3d$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $38d111fe5d5a6e3d$var$Ki(k, h);
                4 !== $38d111fe5d5a6e3d$var$T && ($38d111fe5d5a6e3d$var$T = 2);
                null === $38d111fe5d5a6e3d$var$tk ? $38d111fe5d5a6e3d$var$tk = [
                    f
                ] : $38d111fe5d5a6e3d$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $38d111fe5d5a6e3d$var$Oi(f, k, b);
                            $38d111fe5d5a6e3d$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $38d111fe5d5a6e3d$var$Si || !$38d111fe5d5a6e3d$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $38d111fe5d5a6e3d$var$Ri(f, h, b);
                                $38d111fe5d5a6e3d$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $38d111fe5d5a6e3d$var$Tk(c);
        } catch (na) {
            b = na;
            $38d111fe5d5a6e3d$var$Y === c && null !== c && ($38d111fe5d5a6e3d$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $38d111fe5d5a6e3d$var$Kk() {
    var a = $38d111fe5d5a6e3d$var$nk.current;
    $38d111fe5d5a6e3d$var$nk.current = $38d111fe5d5a6e3d$var$ai;
    return null === a ? $38d111fe5d5a6e3d$var$ai : a;
}
function $38d111fe5d5a6e3d$var$uj() {
    if (0 === $38d111fe5d5a6e3d$var$T || 3 === $38d111fe5d5a6e3d$var$T || 2 === $38d111fe5d5a6e3d$var$T) $38d111fe5d5a6e3d$var$T = 4;
    null === $38d111fe5d5a6e3d$var$R || 0 === ($38d111fe5d5a6e3d$var$hh & 268435455) && 0 === ($38d111fe5d5a6e3d$var$rk & 268435455) || $38d111fe5d5a6e3d$var$Dk($38d111fe5d5a6e3d$var$R, $38d111fe5d5a6e3d$var$Z);
}
function $38d111fe5d5a6e3d$var$Jk(a, b) {
    var c = $38d111fe5d5a6e3d$var$K;
    $38d111fe5d5a6e3d$var$K |= 2;
    var d = $38d111fe5d5a6e3d$var$Kk();
    if ($38d111fe5d5a6e3d$var$R !== a || $38d111fe5d5a6e3d$var$Z !== b) $38d111fe5d5a6e3d$var$vk = null, $38d111fe5d5a6e3d$var$Lk(a, b);
    for(;;)try {
        $38d111fe5d5a6e3d$var$Uk();
        break;
    } catch (e) {
        $38d111fe5d5a6e3d$var$Nk(a, e);
    }
    $38d111fe5d5a6e3d$var$Qg();
    $38d111fe5d5a6e3d$var$K = c;
    $38d111fe5d5a6e3d$var$nk.current = d;
    if (null !== $38d111fe5d5a6e3d$var$Y) throw Error($38d111fe5d5a6e3d$var$p(261));
    $38d111fe5d5a6e3d$var$R = null;
    $38d111fe5d5a6e3d$var$Z = 0;
    return $38d111fe5d5a6e3d$var$T;
}
function $38d111fe5d5a6e3d$var$Uk() {
    for(; null !== $38d111fe5d5a6e3d$var$Y;)$38d111fe5d5a6e3d$var$Vk($38d111fe5d5a6e3d$var$Y);
}
function $38d111fe5d5a6e3d$var$Mk() {
    for(; null !== $38d111fe5d5a6e3d$var$Y && !$38d111fe5d5a6e3d$var$cc();)$38d111fe5d5a6e3d$var$Vk($38d111fe5d5a6e3d$var$Y);
}
function $38d111fe5d5a6e3d$var$Vk(a) {
    var b = $38d111fe5d5a6e3d$var$Wk(a.alternate, a, $38d111fe5d5a6e3d$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $38d111fe5d5a6e3d$var$Tk(a) : $38d111fe5d5a6e3d$var$Y = b;
    $38d111fe5d5a6e3d$var$ok.current = null;
}
function $38d111fe5d5a6e3d$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $38d111fe5d5a6e3d$var$Fj(c, b, $38d111fe5d5a6e3d$var$gj), null !== c) {
                $38d111fe5d5a6e3d$var$Y = c;
                return;
            }
        } else {
            c = $38d111fe5d5a6e3d$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $38d111fe5d5a6e3d$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $38d111fe5d5a6e3d$var$T = 6;
                $38d111fe5d5a6e3d$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $38d111fe5d5a6e3d$var$Y = b;
            return;
        }
        $38d111fe5d5a6e3d$var$Y = b = a;
    }while (null !== b);
    0 === $38d111fe5d5a6e3d$var$T && ($38d111fe5d5a6e3d$var$T = 5);
}
function $38d111fe5d5a6e3d$var$Qk(a, b, c) {
    var d = $38d111fe5d5a6e3d$var$C, e = $38d111fe5d5a6e3d$var$pk.transition;
    try {
        $38d111fe5d5a6e3d$var$pk.transition = null, $38d111fe5d5a6e3d$var$C = 1, $38d111fe5d5a6e3d$var$Xk(a, b, c, d);
    } finally{
        $38d111fe5d5a6e3d$var$pk.transition = e, $38d111fe5d5a6e3d$var$C = d;
    }
    return null;
}
function $38d111fe5d5a6e3d$var$Xk(a, b, c, d) {
    do $38d111fe5d5a6e3d$var$Ik();
    while (null !== $38d111fe5d5a6e3d$var$xk);
    if (0 !== ($38d111fe5d5a6e3d$var$K & 6)) throw Error($38d111fe5d5a6e3d$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($38d111fe5d5a6e3d$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $38d111fe5d5a6e3d$var$Bc(a, f);
    a === $38d111fe5d5a6e3d$var$R && ($38d111fe5d5a6e3d$var$Y = $38d111fe5d5a6e3d$var$R = null, $38d111fe5d5a6e3d$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $38d111fe5d5a6e3d$var$wk || ($38d111fe5d5a6e3d$var$wk = !0, $38d111fe5d5a6e3d$var$Gk($38d111fe5d5a6e3d$var$hc, function() {
        $38d111fe5d5a6e3d$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $38d111fe5d5a6e3d$var$pk.transition;
        $38d111fe5d5a6e3d$var$pk.transition = null;
        var g = $38d111fe5d5a6e3d$var$C;
        $38d111fe5d5a6e3d$var$C = 1;
        var h = $38d111fe5d5a6e3d$var$K;
        $38d111fe5d5a6e3d$var$K |= 4;
        $38d111fe5d5a6e3d$var$ok.current = null;
        $38d111fe5d5a6e3d$var$Pj(a, c);
        $38d111fe5d5a6e3d$var$ek(c, a);
        $38d111fe5d5a6e3d$var$Oe($38d111fe5d5a6e3d$var$Df);
        $38d111fe5d5a6e3d$var$dd = !!$38d111fe5d5a6e3d$var$Cf;
        $38d111fe5d5a6e3d$var$Df = $38d111fe5d5a6e3d$var$Cf = null;
        a.current = c;
        $38d111fe5d5a6e3d$var$ik(c, a, e);
        $38d111fe5d5a6e3d$var$dc();
        $38d111fe5d5a6e3d$var$K = h;
        $38d111fe5d5a6e3d$var$C = g;
        $38d111fe5d5a6e3d$var$pk.transition = f;
    } else a.current = c;
    $38d111fe5d5a6e3d$var$wk && ($38d111fe5d5a6e3d$var$wk = !1, $38d111fe5d5a6e3d$var$xk = a, $38d111fe5d5a6e3d$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($38d111fe5d5a6e3d$var$Si = null);
    $38d111fe5d5a6e3d$var$mc(c.stateNode, d);
    $38d111fe5d5a6e3d$var$Ek(a, $38d111fe5d5a6e3d$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($38d111fe5d5a6e3d$var$Pi) throw $38d111fe5d5a6e3d$var$Pi = !1, a = $38d111fe5d5a6e3d$var$Qi, $38d111fe5d5a6e3d$var$Qi = null, a;
    0 !== ($38d111fe5d5a6e3d$var$yk & 1) && 0 !== a.tag && $38d111fe5d5a6e3d$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $38d111fe5d5a6e3d$var$Ak ? $38d111fe5d5a6e3d$var$zk++ : ($38d111fe5d5a6e3d$var$zk = 0, $38d111fe5d5a6e3d$var$Ak = a) : $38d111fe5d5a6e3d$var$zk = 0;
    $38d111fe5d5a6e3d$var$jg();
    return null;
}
function $38d111fe5d5a6e3d$var$Ik() {
    if (null !== $38d111fe5d5a6e3d$var$xk) {
        var a = $38d111fe5d5a6e3d$var$Dc($38d111fe5d5a6e3d$var$yk), b = $38d111fe5d5a6e3d$var$pk.transition, c = $38d111fe5d5a6e3d$var$C;
        try {
            $38d111fe5d5a6e3d$var$pk.transition = null;
            $38d111fe5d5a6e3d$var$C = 16 > a ? 16 : a;
            if (null === $38d111fe5d5a6e3d$var$xk) var d = !1;
            else {
                a = $38d111fe5d5a6e3d$var$xk;
                $38d111fe5d5a6e3d$var$xk = null;
                $38d111fe5d5a6e3d$var$yk = 0;
                if (0 !== ($38d111fe5d5a6e3d$var$K & 6)) throw Error($38d111fe5d5a6e3d$var$p(331));
                var e = $38d111fe5d5a6e3d$var$K;
                $38d111fe5d5a6e3d$var$K |= 4;
                for($38d111fe5d5a6e3d$var$V = a.current; null !== $38d111fe5d5a6e3d$var$V;){
                    var f = $38d111fe5d5a6e3d$var$V, g = f.child;
                    if (0 !== ($38d111fe5d5a6e3d$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($38d111fe5d5a6e3d$var$V = l; null !== $38d111fe5d5a6e3d$var$V;){
                                    var m = $38d111fe5d5a6e3d$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $38d111fe5d5a6e3d$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $38d111fe5d5a6e3d$var$V = q;
                                    else for(; null !== $38d111fe5d5a6e3d$var$V;){
                                        m = $38d111fe5d5a6e3d$var$V;
                                        var r = m.sibling, y = m.return;
                                        $38d111fe5d5a6e3d$var$Tj(m);
                                        if (m === l) {
                                            $38d111fe5d5a6e3d$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $38d111fe5d5a6e3d$var$V = r;
                                            break;
                                        }
                                        $38d111fe5d5a6e3d$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $38d111fe5d5a6e3d$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $38d111fe5d5a6e3d$var$V = g;
                    else b: for(; null !== $38d111fe5d5a6e3d$var$V;){
                        f = $38d111fe5d5a6e3d$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $38d111fe5d5a6e3d$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $38d111fe5d5a6e3d$var$V = x;
                            break b;
                        }
                        $38d111fe5d5a6e3d$var$V = f.return;
                    }
                }
                var w = a.current;
                for($38d111fe5d5a6e3d$var$V = w; null !== $38d111fe5d5a6e3d$var$V;){
                    g = $38d111fe5d5a6e3d$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $38d111fe5d5a6e3d$var$V = u;
                    else b: for(g = w; null !== $38d111fe5d5a6e3d$var$V;){
                        h = $38d111fe5d5a6e3d$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $38d111fe5d5a6e3d$var$Rj(9, h);
                            }
                        } catch (na) {
                            $38d111fe5d5a6e3d$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $38d111fe5d5a6e3d$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $38d111fe5d5a6e3d$var$V = F;
                            break b;
                        }
                        $38d111fe5d5a6e3d$var$V = h.return;
                    }
                }
                $38d111fe5d5a6e3d$var$K = e;
                $38d111fe5d5a6e3d$var$jg();
                if ($38d111fe5d5a6e3d$var$lc && "function" === typeof $38d111fe5d5a6e3d$var$lc.onPostCommitFiberRoot) try {
                    $38d111fe5d5a6e3d$var$lc.onPostCommitFiberRoot($38d111fe5d5a6e3d$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $38d111fe5d5a6e3d$var$C = c, $38d111fe5d5a6e3d$var$pk.transition = b;
        }
    }
    return !1;
}
function $38d111fe5d5a6e3d$var$Yk(a, b, c) {
    b = $38d111fe5d5a6e3d$var$Ki(c, b);
    b = $38d111fe5d5a6e3d$var$Oi(a, b, 1);
    a = $38d111fe5d5a6e3d$var$dh(a, b, 1);
    b = $38d111fe5d5a6e3d$var$L();
    null !== a && ($38d111fe5d5a6e3d$var$Ac(a, 1, b), $38d111fe5d5a6e3d$var$Ek(a, b));
}
function $38d111fe5d5a6e3d$var$W(a, b, c) {
    if (3 === a.tag) $38d111fe5d5a6e3d$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $38d111fe5d5a6e3d$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $38d111fe5d5a6e3d$var$Si || !$38d111fe5d5a6e3d$var$Si.has(d))) {
                a = $38d111fe5d5a6e3d$var$Ki(c, a);
                a = $38d111fe5d5a6e3d$var$Ri(b, a, 1);
                b = $38d111fe5d5a6e3d$var$dh(b, a, 1);
                a = $38d111fe5d5a6e3d$var$L();
                null !== b && ($38d111fe5d5a6e3d$var$Ac(b, 1, a), $38d111fe5d5a6e3d$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $38d111fe5d5a6e3d$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $38d111fe5d5a6e3d$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $38d111fe5d5a6e3d$var$R === a && ($38d111fe5d5a6e3d$var$Z & c) === c && (4 === $38d111fe5d5a6e3d$var$T || 3 === $38d111fe5d5a6e3d$var$T && ($38d111fe5d5a6e3d$var$Z & 130023424) === $38d111fe5d5a6e3d$var$Z && 500 > $38d111fe5d5a6e3d$var$B() - $38d111fe5d5a6e3d$var$gk ? $38d111fe5d5a6e3d$var$Lk(a, 0) : $38d111fe5d5a6e3d$var$sk |= c);
    $38d111fe5d5a6e3d$var$Ek(a, b);
}
function $38d111fe5d5a6e3d$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $38d111fe5d5a6e3d$var$sc, $38d111fe5d5a6e3d$var$sc <<= 1, 0 === ($38d111fe5d5a6e3d$var$sc & 130023424) && ($38d111fe5d5a6e3d$var$sc = 4194304)));
    var c = $38d111fe5d5a6e3d$var$L();
    a = $38d111fe5d5a6e3d$var$Zg(a, b);
    null !== a && ($38d111fe5d5a6e3d$var$Ac(a, b, c), $38d111fe5d5a6e3d$var$Ek(a, c));
}
function $38d111fe5d5a6e3d$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $38d111fe5d5a6e3d$var$Zk(a, c);
}
function $38d111fe5d5a6e3d$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($38d111fe5d5a6e3d$var$p(314));
    }
    null !== d && d.delete(b);
    $38d111fe5d5a6e3d$var$Zk(a, c);
}
var $38d111fe5d5a6e3d$var$Wk;
$38d111fe5d5a6e3d$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $38d111fe5d5a6e3d$var$Wf.current) $38d111fe5d5a6e3d$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $38d111fe5d5a6e3d$var$Ug = !1, $38d111fe5d5a6e3d$var$zj(a, b, c);
            $38d111fe5d5a6e3d$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $38d111fe5d5a6e3d$var$Ug = !1, $38d111fe5d5a6e3d$var$I && 0 !== (b.flags & 1048576) && $38d111fe5d5a6e3d$var$ug(b, $38d111fe5d5a6e3d$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $38d111fe5d5a6e3d$var$jj(a, b);
            a = b.pendingProps;
            var e = $38d111fe5d5a6e3d$var$Yf(b, $38d111fe5d5a6e3d$var$H.current);
            $38d111fe5d5a6e3d$var$Tg(b, c);
            e = $38d111fe5d5a6e3d$var$Xh(null, b, d, a, e, c);
            var f = $38d111fe5d5a6e3d$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $38d111fe5d5a6e3d$var$Zf(d) ? (f = !0, $38d111fe5d5a6e3d$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $38d111fe5d5a6e3d$var$ah(b), e.updater = $38d111fe5d5a6e3d$var$nh, b.stateNode = e, e._reactInternals = b, $38d111fe5d5a6e3d$var$rh(b, d, a, c), b = $38d111fe5d5a6e3d$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $38d111fe5d5a6e3d$var$I && f && $38d111fe5d5a6e3d$var$vg(b), $38d111fe5d5a6e3d$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $38d111fe5d5a6e3d$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $38d111fe5d5a6e3d$var$$k(d);
                a = $38d111fe5d5a6e3d$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $38d111fe5d5a6e3d$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $38d111fe5d5a6e3d$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $38d111fe5d5a6e3d$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $38d111fe5d5a6e3d$var$aj(null, b, d, $38d111fe5d5a6e3d$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($38d111fe5d5a6e3d$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $38d111fe5d5a6e3d$var$Lg(d, e), $38d111fe5d5a6e3d$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $38d111fe5d5a6e3d$var$Lg(d, e), $38d111fe5d5a6e3d$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $38d111fe5d5a6e3d$var$lj(b);
                if (null === a) throw Error($38d111fe5d5a6e3d$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $38d111fe5d5a6e3d$var$bh(a, b);
                $38d111fe5d5a6e3d$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $38d111fe5d5a6e3d$var$Ki(Error($38d111fe5d5a6e3d$var$p(423)), b);
                        b = $38d111fe5d5a6e3d$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $38d111fe5d5a6e3d$var$Ki(Error($38d111fe5d5a6e3d$var$p(424)), b);
                        b = $38d111fe5d5a6e3d$var$mj(a, b, d, c, e);
                        break a;
                    } else for($38d111fe5d5a6e3d$var$yg = $38d111fe5d5a6e3d$var$Lf(b.stateNode.containerInfo.firstChild), $38d111fe5d5a6e3d$var$xg = b, $38d111fe5d5a6e3d$var$I = !0, $38d111fe5d5a6e3d$var$zg = null, c = $38d111fe5d5a6e3d$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $38d111fe5d5a6e3d$var$Ig();
                    if (d === e) {
                        b = $38d111fe5d5a6e3d$var$$i(a, b, c);
                        break a;
                    }
                    $38d111fe5d5a6e3d$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $38d111fe5d5a6e3d$var$Kh(b), null === a && $38d111fe5d5a6e3d$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $38d111fe5d5a6e3d$var$Ef(d, e) ? g = null : null !== f && $38d111fe5d5a6e3d$var$Ef(d, f) && (b.flags |= 32), $38d111fe5d5a6e3d$var$hj(a, b), $38d111fe5d5a6e3d$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $38d111fe5d5a6e3d$var$Eg(b), null;
        case 13:
            return $38d111fe5d5a6e3d$var$pj(a, b, c);
        case 4:
            return $38d111fe5d5a6e3d$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $38d111fe5d5a6e3d$var$Bh(b, null, d, c) : $38d111fe5d5a6e3d$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $38d111fe5d5a6e3d$var$Lg(d, e), $38d111fe5d5a6e3d$var$Zi(a, b, d, e, c);
        case 7:
            return $38d111fe5d5a6e3d$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $38d111fe5d5a6e3d$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $38d111fe5d5a6e3d$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $38d111fe5d5a6e3d$var$G($38d111fe5d5a6e3d$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($38d111fe5d5a6e3d$var$He(f.value, g)) {
                        if (f.children === e.children && !$38d111fe5d5a6e3d$var$Wf.current) {
                            b = $38d111fe5d5a6e3d$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $38d111fe5d5a6e3d$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $38d111fe5d5a6e3d$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($38d111fe5d5a6e3d$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $38d111fe5d5a6e3d$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $38d111fe5d5a6e3d$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $38d111fe5d5a6e3d$var$Tg(b, c), e = $38d111fe5d5a6e3d$var$Vg(e), d = d(e), b.flags |= 1, $38d111fe5d5a6e3d$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $38d111fe5d5a6e3d$var$Lg(d, b.pendingProps), e = $38d111fe5d5a6e3d$var$Lg(d.type, e), $38d111fe5d5a6e3d$var$aj(a, b, d, e, c);
        case 15:
            return $38d111fe5d5a6e3d$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $38d111fe5d5a6e3d$var$Lg(d, e), $38d111fe5d5a6e3d$var$jj(a, b), b.tag = 1, $38d111fe5d5a6e3d$var$Zf(d) ? (a = !0, $38d111fe5d5a6e3d$var$cg(b)) : a = !1, $38d111fe5d5a6e3d$var$Tg(b, c), $38d111fe5d5a6e3d$var$ph(b, d, e), $38d111fe5d5a6e3d$var$rh(b, d, e, c), $38d111fe5d5a6e3d$var$kj(null, b, d, !0, a, c);
        case 19:
            return $38d111fe5d5a6e3d$var$yj(a, b, c);
        case 22:
            return $38d111fe5d5a6e3d$var$ej(a, b, c);
    }
    throw Error($38d111fe5d5a6e3d$var$p(156, b.tag));
};
function $38d111fe5d5a6e3d$var$Gk(a, b) {
    return $38d111fe5d5a6e3d$var$ac(a, b);
}
function $38d111fe5d5a6e3d$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $38d111fe5d5a6e3d$var$Bg(a, b, c, d) {
    return new $38d111fe5d5a6e3d$var$al(a, b, c, d);
}
function $38d111fe5d5a6e3d$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $38d111fe5d5a6e3d$var$$k(a) {
    if ("function" === typeof a) return $38d111fe5d5a6e3d$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $38d111fe5d5a6e3d$var$Da) return 11;
        if (a === $38d111fe5d5a6e3d$var$Ga) return 14;
    }
    return 2;
}
function $38d111fe5d5a6e3d$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $38d111fe5d5a6e3d$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $38d111fe5d5a6e3d$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $38d111fe5d5a6e3d$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $38d111fe5d5a6e3d$var$ya:
            return $38d111fe5d5a6e3d$var$Ah(c.children, e, f, b);
        case $38d111fe5d5a6e3d$var$za:
            g = 8;
            e |= 8;
            break;
        case $38d111fe5d5a6e3d$var$Aa:
            return a = $38d111fe5d5a6e3d$var$Bg(12, c, b, e | 2), a.elementType = $38d111fe5d5a6e3d$var$Aa, a.lanes = f, a;
        case $38d111fe5d5a6e3d$var$Ea:
            return a = $38d111fe5d5a6e3d$var$Bg(13, c, b, e), a.elementType = $38d111fe5d5a6e3d$var$Ea, a.lanes = f, a;
        case $38d111fe5d5a6e3d$var$Fa:
            return a = $38d111fe5d5a6e3d$var$Bg(19, c, b, e), a.elementType = $38d111fe5d5a6e3d$var$Fa, a.lanes = f, a;
        case $38d111fe5d5a6e3d$var$Ia:
            return $38d111fe5d5a6e3d$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $38d111fe5d5a6e3d$var$Ba:
                    g = 10;
                    break a;
                case $38d111fe5d5a6e3d$var$Ca:
                    g = 9;
                    break a;
                case $38d111fe5d5a6e3d$var$Da:
                    g = 11;
                    break a;
                case $38d111fe5d5a6e3d$var$Ga:
                    g = 14;
                    break a;
                case $38d111fe5d5a6e3d$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($38d111fe5d5a6e3d$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $38d111fe5d5a6e3d$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $38d111fe5d5a6e3d$var$Ah(a, b, c, d) {
    a = $38d111fe5d5a6e3d$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $38d111fe5d5a6e3d$var$qj(a, b, c, d) {
    a = $38d111fe5d5a6e3d$var$Bg(22, a, d, b);
    a.elementType = $38d111fe5d5a6e3d$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $38d111fe5d5a6e3d$var$xh(a, b, c) {
    a = $38d111fe5d5a6e3d$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $38d111fe5d5a6e3d$var$zh(a, b, c) {
    b = $38d111fe5d5a6e3d$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $38d111fe5d5a6e3d$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $38d111fe5d5a6e3d$var$zc(0);
    this.expirationTimes = $38d111fe5d5a6e3d$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $38d111fe5d5a6e3d$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $38d111fe5d5a6e3d$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $38d111fe5d5a6e3d$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $38d111fe5d5a6e3d$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $38d111fe5d5a6e3d$var$ah(f);
    return a;
}
function $38d111fe5d5a6e3d$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $38d111fe5d5a6e3d$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $38d111fe5d5a6e3d$var$el(a) {
    if (!a) return $38d111fe5d5a6e3d$var$Vf;
    a = a._reactInternals;
    a: {
        if ($38d111fe5d5a6e3d$var$Vb(a) !== a || 1 !== a.tag) throw Error($38d111fe5d5a6e3d$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($38d111fe5d5a6e3d$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($38d111fe5d5a6e3d$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($38d111fe5d5a6e3d$var$Zf(c)) return $38d111fe5d5a6e3d$var$bg(a, c, b);
    }
    return b;
}
function $38d111fe5d5a6e3d$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $38d111fe5d5a6e3d$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $38d111fe5d5a6e3d$var$el(null);
    c = a.current;
    d = $38d111fe5d5a6e3d$var$L();
    e = $38d111fe5d5a6e3d$var$lh(c);
    f = $38d111fe5d5a6e3d$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $38d111fe5d5a6e3d$var$dh(c, f, e);
    a.current.lanes = e;
    $38d111fe5d5a6e3d$var$Ac(a, e, d);
    $38d111fe5d5a6e3d$var$Ek(a, d);
    return a;
}
function $38d111fe5d5a6e3d$var$gl(a, b, c, d) {
    var e = b.current, f = $38d111fe5d5a6e3d$var$L(), g = $38d111fe5d5a6e3d$var$lh(e);
    c = $38d111fe5d5a6e3d$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $38d111fe5d5a6e3d$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $38d111fe5d5a6e3d$var$dh(e, b, g);
    null !== a && ($38d111fe5d5a6e3d$var$mh(a, e, g, f), $38d111fe5d5a6e3d$var$eh(a, e, g));
    return g;
}
function $38d111fe5d5a6e3d$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $38d111fe5d5a6e3d$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $38d111fe5d5a6e3d$var$jl(a, b) {
    $38d111fe5d5a6e3d$var$il(a, b);
    (a = a.alternate) && $38d111fe5d5a6e3d$var$il(a, b);
}
function $38d111fe5d5a6e3d$var$kl() {
    return null;
}
var $38d111fe5d5a6e3d$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $38d111fe5d5a6e3d$var$ml(a) {
    this._internalRoot = a;
}
$38d111fe5d5a6e3d$var$nl.prototype.render = $38d111fe5d5a6e3d$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($38d111fe5d5a6e3d$var$p(409));
    $38d111fe5d5a6e3d$var$gl(a, b, null, null);
};
$38d111fe5d5a6e3d$var$nl.prototype.unmount = $38d111fe5d5a6e3d$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $38d111fe5d5a6e3d$var$Sk(function() {
            $38d111fe5d5a6e3d$var$gl(null, a, null, null);
        });
        b[$38d111fe5d5a6e3d$var$uf] = null;
    }
};
function $38d111fe5d5a6e3d$var$nl(a) {
    this._internalRoot = a;
}
$38d111fe5d5a6e3d$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $38d111fe5d5a6e3d$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $38d111fe5d5a6e3d$var$Qc.length && 0 !== b && b < $38d111fe5d5a6e3d$var$Qc[c].priority; c++);
        $38d111fe5d5a6e3d$var$Qc.splice(c, 0, a);
        0 === c && $38d111fe5d5a6e3d$var$Vc(a);
    }
};
function $38d111fe5d5a6e3d$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $38d111fe5d5a6e3d$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $38d111fe5d5a6e3d$var$ql() {}
function $38d111fe5d5a6e3d$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $38d111fe5d5a6e3d$var$hl(g);
                f.call(a);
            };
        }
        var g = $38d111fe5d5a6e3d$var$fl(b, d, a, 0, null, !1, !1, "", $38d111fe5d5a6e3d$var$ql);
        a._reactRootContainer = g;
        a[$38d111fe5d5a6e3d$var$uf] = g.current;
        $38d111fe5d5a6e3d$var$sf(8 === a.nodeType ? a.parentNode : a);
        $38d111fe5d5a6e3d$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $38d111fe5d5a6e3d$var$hl(k);
            h.call(a);
        };
    }
    var k = $38d111fe5d5a6e3d$var$cl(a, 0, !1, null, null, !1, !1, "", $38d111fe5d5a6e3d$var$ql);
    a._reactRootContainer = k;
    a[$38d111fe5d5a6e3d$var$uf] = k.current;
    $38d111fe5d5a6e3d$var$sf(8 === a.nodeType ? a.parentNode : a);
    $38d111fe5d5a6e3d$var$Sk(function() {
        $38d111fe5d5a6e3d$var$gl(b, k, c, d);
    });
    return k;
}
function $38d111fe5d5a6e3d$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $38d111fe5d5a6e3d$var$hl(g);
                h.call(a);
            };
        }
        $38d111fe5d5a6e3d$var$gl(b, g, a, e);
    } else g = $38d111fe5d5a6e3d$var$rl(c, b, a, e, d);
    return $38d111fe5d5a6e3d$var$hl(g);
}
$38d111fe5d5a6e3d$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $38d111fe5d5a6e3d$var$tc(b.pendingLanes);
                0 !== c && ($38d111fe5d5a6e3d$var$Cc(b, c | 1), $38d111fe5d5a6e3d$var$Ek(b, $38d111fe5d5a6e3d$var$B()), 0 === ($38d111fe5d5a6e3d$var$K & 6) && ($38d111fe5d5a6e3d$var$Hj = $38d111fe5d5a6e3d$var$B() + 500, $38d111fe5d5a6e3d$var$jg()));
            }
            break;
        case 13:
            $38d111fe5d5a6e3d$var$Sk(function() {
                var b = $38d111fe5d5a6e3d$var$Zg(a, 1);
                if (null !== b) {
                    var c = $38d111fe5d5a6e3d$var$L();
                    $38d111fe5d5a6e3d$var$mh(b, a, 1, c);
                }
            }), $38d111fe5d5a6e3d$var$jl(a, 1);
    }
};
$38d111fe5d5a6e3d$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $38d111fe5d5a6e3d$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $38d111fe5d5a6e3d$var$L();
            $38d111fe5d5a6e3d$var$mh(b, a, 134217728, c);
        }
        $38d111fe5d5a6e3d$var$jl(a, 134217728);
    }
};
$38d111fe5d5a6e3d$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $38d111fe5d5a6e3d$var$lh(a), c = $38d111fe5d5a6e3d$var$Zg(a, b);
        if (null !== c) {
            var d = $38d111fe5d5a6e3d$var$L();
            $38d111fe5d5a6e3d$var$mh(c, a, b, d);
        }
        $38d111fe5d5a6e3d$var$jl(a, b);
    }
};
$38d111fe5d5a6e3d$var$Hc = function() {
    return $38d111fe5d5a6e3d$var$C;
};
$38d111fe5d5a6e3d$var$Ic = function(a, b) {
    var c = $38d111fe5d5a6e3d$var$C;
    try {
        return $38d111fe5d5a6e3d$var$C = a, b();
    } finally{
        $38d111fe5d5a6e3d$var$C = c;
    }
};
$38d111fe5d5a6e3d$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $38d111fe5d5a6e3d$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $38d111fe5d5a6e3d$var$Db(d);
                        if (!e) throw Error($38d111fe5d5a6e3d$var$p(90));
                        $38d111fe5d5a6e3d$var$Wa(d);
                        $38d111fe5d5a6e3d$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $38d111fe5d5a6e3d$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $38d111fe5d5a6e3d$var$fb(a, !!c.multiple, b, !1);
    }
};
$38d111fe5d5a6e3d$var$Gb = $38d111fe5d5a6e3d$var$Rk;
$38d111fe5d5a6e3d$var$Hb = $38d111fe5d5a6e3d$var$Sk;
var $38d111fe5d5a6e3d$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $38d111fe5d5a6e3d$var$Cb,
        $38d111fe5d5a6e3d$var$ue,
        $38d111fe5d5a6e3d$var$Db,
        $38d111fe5d5a6e3d$var$Eb,
        $38d111fe5d5a6e3d$var$Fb,
        $38d111fe5d5a6e3d$var$Rk
    ]
}, $38d111fe5d5a6e3d$var$ul = {
    findFiberByHostInstance: $38d111fe5d5a6e3d$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $38d111fe5d5a6e3d$var$vl = {
    bundleType: $38d111fe5d5a6e3d$var$ul.bundleType,
    version: $38d111fe5d5a6e3d$var$ul.version,
    rendererPackageName: $38d111fe5d5a6e3d$var$ul.rendererPackageName,
    rendererConfig: $38d111fe5d5a6e3d$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $38d111fe5d5a6e3d$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $38d111fe5d5a6e3d$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $38d111fe5d5a6e3d$var$ul.findFiberByHostInstance || $38d111fe5d5a6e3d$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $38d111fe5d5a6e3d$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$38d111fe5d5a6e3d$var$wl.isDisabled && $38d111fe5d5a6e3d$var$wl.supportsFiber) try {
        $38d111fe5d5a6e3d$var$kc = $38d111fe5d5a6e3d$var$wl.inject($38d111fe5d5a6e3d$var$vl), $38d111fe5d5a6e3d$var$lc = $38d111fe5d5a6e3d$var$wl;
    } catch (a) {}
}
$38d111fe5d5a6e3d$export$ae55be85d98224ed = $38d111fe5d5a6e3d$var$tl;
$38d111fe5d5a6e3d$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$38d111fe5d5a6e3d$var$ol(b)) throw Error($38d111fe5d5a6e3d$var$p(200));
    return $38d111fe5d5a6e3d$var$dl(a, b, null, c);
};
$38d111fe5d5a6e3d$export$882461b6382ed46c = function(a, b) {
    if (!$38d111fe5d5a6e3d$var$ol(a)) throw Error($38d111fe5d5a6e3d$var$p(299));
    var c = !1, d = "", e = $38d111fe5d5a6e3d$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $38d111fe5d5a6e3d$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$38d111fe5d5a6e3d$var$uf] = b.current;
    $38d111fe5d5a6e3d$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $38d111fe5d5a6e3d$var$ml(b);
};
$38d111fe5d5a6e3d$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($38d111fe5d5a6e3d$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($38d111fe5d5a6e3d$var$p(268, a));
    }
    a = $38d111fe5d5a6e3d$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$38d111fe5d5a6e3d$export$cd75ccfd720a3cd4 = function(a) {
    return $38d111fe5d5a6e3d$var$Sk(a);
};
$38d111fe5d5a6e3d$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$38d111fe5d5a6e3d$var$pl(b)) throw Error($38d111fe5d5a6e3d$var$p(200));
    return $38d111fe5d5a6e3d$var$sl(null, a, b, !0, c);
};
$38d111fe5d5a6e3d$export$757ceba2d55c277e = function(a, b, c) {
    if (!$38d111fe5d5a6e3d$var$ol(a)) throw Error($38d111fe5d5a6e3d$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $38d111fe5d5a6e3d$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $38d111fe5d5a6e3d$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$38d111fe5d5a6e3d$var$uf] = b.current;
    $38d111fe5d5a6e3d$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $38d111fe5d5a6e3d$var$nl(b);
};
$38d111fe5d5a6e3d$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$38d111fe5d5a6e3d$var$pl(b)) throw Error($38d111fe5d5a6e3d$var$p(200));
    return $38d111fe5d5a6e3d$var$sl(null, a, b, !1, c);
};
$38d111fe5d5a6e3d$export$502457920280e6be = function(a) {
    if (!$38d111fe5d5a6e3d$var$pl(a)) throw Error($38d111fe5d5a6e3d$var$p(40));
    return a._reactRootContainer ? ($38d111fe5d5a6e3d$var$Sk(function() {
        $38d111fe5d5a6e3d$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$38d111fe5d5a6e3d$var$uf] = null;
        });
    }), !0) : !1;
};
$38d111fe5d5a6e3d$export$c78a37762a8d58e1 = $38d111fe5d5a6e3d$var$Rk;
$38d111fe5d5a6e3d$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$38d111fe5d5a6e3d$var$pl(c)) throw Error($38d111fe5d5a6e3d$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($38d111fe5d5a6e3d$var$p(38));
    return $38d111fe5d5a6e3d$var$sl(a, b, c, !1, d);
};
$38d111fe5d5a6e3d$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("7ARQs", function(module, exports) {
"use strict";

module.exports = (parcelRequire("1ZnBZ"));

});
parcelRegister("1ZnBZ", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $172dcdbc06105c0b$export$c4744153514ff05d, (v) => $172dcdbc06105c0b$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $172dcdbc06105c0b$export$3e506c1ccc9cc1a7, (v) => $172dcdbc06105c0b$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $172dcdbc06105c0b$export$e26fe2ed2fa76875, (v) => $172dcdbc06105c0b$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $172dcdbc06105c0b$export$502329bbf4b505b1, (v) => $172dcdbc06105c0b$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $172dcdbc06105c0b$export$6e3807111c4874c4, (v) => $172dcdbc06105c0b$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $172dcdbc06105c0b$export$c27134553091fb3a, (v) => $172dcdbc06105c0b$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $172dcdbc06105c0b$export$33ee1acdc04fd2a2, (v) => $172dcdbc06105c0b$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $172dcdbc06105c0b$export$b00a404bbd5edef2, (v) => $172dcdbc06105c0b$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $172dcdbc06105c0b$export$8352ce38b91d0c62, (v) => $172dcdbc06105c0b$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $172dcdbc06105c0b$export$d66a1c1c77bd778b, (v) => $172dcdbc06105c0b$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $172dcdbc06105c0b$export$d3dfb8e4810cb555, (v) => $172dcdbc06105c0b$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $172dcdbc06105c0b$export$839f9183b0465a69, (v) => $172dcdbc06105c0b$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $172dcdbc06105c0b$export$72fdf0e06517287b, (v) => $172dcdbc06105c0b$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $172dcdbc06105c0b$export$4b844e58a3e414b4, (v) => $172dcdbc06105c0b$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $172dcdbc06105c0b$export$816d2913ae6b83b1, (v) => $172dcdbc06105c0b$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $172dcdbc06105c0b$export$61bcfe829111a1d0, (v) => $172dcdbc06105c0b$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $172dcdbc06105c0b$export$7ee8c9beb337bc3f, (v) => $172dcdbc06105c0b$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $172dcdbc06105c0b$export$b5836b71941fa3ed, (v) => $172dcdbc06105c0b$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $172dcdbc06105c0b$export$cf845f2c119da08a, (v) => $172dcdbc06105c0b$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $172dcdbc06105c0b$export$c4744153514ff05d;
var $172dcdbc06105c0b$export$3e506c1ccc9cc1a7;
var $172dcdbc06105c0b$export$e26fe2ed2fa76875;
var $172dcdbc06105c0b$export$502329bbf4b505b1;
var $172dcdbc06105c0b$export$6e3807111c4874c4;
var $172dcdbc06105c0b$export$c27134553091fb3a;
var $172dcdbc06105c0b$export$33ee1acdc04fd2a2;
var $172dcdbc06105c0b$export$b00a404bbd5edef2;
var $172dcdbc06105c0b$export$8352ce38b91d0c62;
var $172dcdbc06105c0b$export$d66a1c1c77bd778b;
var $172dcdbc06105c0b$export$d3dfb8e4810cb555;
var $172dcdbc06105c0b$export$839f9183b0465a69;
var $172dcdbc06105c0b$export$72fdf0e06517287b;
var $172dcdbc06105c0b$export$4b844e58a3e414b4;
var $172dcdbc06105c0b$export$816d2913ae6b83b1;
var $172dcdbc06105c0b$export$61bcfe829111a1d0;
var $172dcdbc06105c0b$export$7ee8c9beb337bc3f;
var $172dcdbc06105c0b$export$b5836b71941fa3ed;
var $172dcdbc06105c0b$export$cf845f2c119da08a;
"use strict";
function $172dcdbc06105c0b$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $172dcdbc06105c0b$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $172dcdbc06105c0b$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $172dcdbc06105c0b$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $172dcdbc06105c0b$var$g(C, c)) n < e && 0 > $172dcdbc06105c0b$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $172dcdbc06105c0b$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $172dcdbc06105c0b$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $172dcdbc06105c0b$var$l = performance;
    $172dcdbc06105c0b$export$c4744153514ff05d = function() {
        return $172dcdbc06105c0b$var$l.now();
    };
} else {
    var $172dcdbc06105c0b$var$p = Date, $172dcdbc06105c0b$var$q = $172dcdbc06105c0b$var$p.now();
    $172dcdbc06105c0b$export$c4744153514ff05d = function() {
        return $172dcdbc06105c0b$var$p.now() - $172dcdbc06105c0b$var$q;
    };
}
var $172dcdbc06105c0b$var$r = [], $172dcdbc06105c0b$var$t = [], $172dcdbc06105c0b$var$u = 1, $172dcdbc06105c0b$var$v = null, $172dcdbc06105c0b$var$y = 3, $172dcdbc06105c0b$var$z = !1, $172dcdbc06105c0b$var$A = !1, $172dcdbc06105c0b$var$B = !1, $172dcdbc06105c0b$var$D = "function" === typeof setTimeout ? setTimeout : null, $172dcdbc06105c0b$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $172dcdbc06105c0b$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $172dcdbc06105c0b$var$G(a) {
    for(var b = $172dcdbc06105c0b$var$h($172dcdbc06105c0b$var$t); null !== b;){
        if (null === b.callback) $172dcdbc06105c0b$var$k($172dcdbc06105c0b$var$t);
        else if (b.startTime <= a) $172dcdbc06105c0b$var$k($172dcdbc06105c0b$var$t), b.sortIndex = b.expirationTime, $172dcdbc06105c0b$var$f($172dcdbc06105c0b$var$r, b);
        else break;
        b = $172dcdbc06105c0b$var$h($172dcdbc06105c0b$var$t);
    }
}
function $172dcdbc06105c0b$var$H(a) {
    $172dcdbc06105c0b$var$B = !1;
    $172dcdbc06105c0b$var$G(a);
    if (!$172dcdbc06105c0b$var$A) {
        if (null !== $172dcdbc06105c0b$var$h($172dcdbc06105c0b$var$r)) $172dcdbc06105c0b$var$A = !0, $172dcdbc06105c0b$var$I($172dcdbc06105c0b$var$J);
        else {
            var b = $172dcdbc06105c0b$var$h($172dcdbc06105c0b$var$t);
            null !== b && $172dcdbc06105c0b$var$K($172dcdbc06105c0b$var$H, b.startTime - a);
        }
    }
}
function $172dcdbc06105c0b$var$J(a, b) {
    $172dcdbc06105c0b$var$A = !1;
    $172dcdbc06105c0b$var$B && ($172dcdbc06105c0b$var$B = !1, $172dcdbc06105c0b$var$E($172dcdbc06105c0b$var$L), $172dcdbc06105c0b$var$L = -1);
    $172dcdbc06105c0b$var$z = !0;
    var c = $172dcdbc06105c0b$var$y;
    try {
        $172dcdbc06105c0b$var$G(b);
        for($172dcdbc06105c0b$var$v = $172dcdbc06105c0b$var$h($172dcdbc06105c0b$var$r); null !== $172dcdbc06105c0b$var$v && (!($172dcdbc06105c0b$var$v.expirationTime > b) || a && !$172dcdbc06105c0b$var$M());){
            var d = $172dcdbc06105c0b$var$v.callback;
            if ("function" === typeof d) {
                $172dcdbc06105c0b$var$v.callback = null;
                $172dcdbc06105c0b$var$y = $172dcdbc06105c0b$var$v.priorityLevel;
                var e = d($172dcdbc06105c0b$var$v.expirationTime <= b);
                b = $172dcdbc06105c0b$export$c4744153514ff05d();
                "function" === typeof e ? $172dcdbc06105c0b$var$v.callback = e : $172dcdbc06105c0b$var$v === $172dcdbc06105c0b$var$h($172dcdbc06105c0b$var$r) && $172dcdbc06105c0b$var$k($172dcdbc06105c0b$var$r);
                $172dcdbc06105c0b$var$G(b);
            } else $172dcdbc06105c0b$var$k($172dcdbc06105c0b$var$r);
            $172dcdbc06105c0b$var$v = $172dcdbc06105c0b$var$h($172dcdbc06105c0b$var$r);
        }
        if (null !== $172dcdbc06105c0b$var$v) var w = !0;
        else {
            var m = $172dcdbc06105c0b$var$h($172dcdbc06105c0b$var$t);
            null !== m && $172dcdbc06105c0b$var$K($172dcdbc06105c0b$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $172dcdbc06105c0b$var$v = null, $172dcdbc06105c0b$var$y = c, $172dcdbc06105c0b$var$z = !1;
    }
}
var $172dcdbc06105c0b$var$N = !1, $172dcdbc06105c0b$var$O = null, $172dcdbc06105c0b$var$L = -1, $172dcdbc06105c0b$var$P = 5, $172dcdbc06105c0b$var$Q = -1;
function $172dcdbc06105c0b$var$M() {
    return $172dcdbc06105c0b$export$c4744153514ff05d() - $172dcdbc06105c0b$var$Q < $172dcdbc06105c0b$var$P ? !1 : !0;
}
function $172dcdbc06105c0b$var$R() {
    if (null !== $172dcdbc06105c0b$var$O) {
        var a = $172dcdbc06105c0b$export$c4744153514ff05d();
        $172dcdbc06105c0b$var$Q = a;
        var b = !0;
        try {
            b = $172dcdbc06105c0b$var$O(!0, a);
        } finally{
            b ? $172dcdbc06105c0b$var$S() : ($172dcdbc06105c0b$var$N = !1, $172dcdbc06105c0b$var$O = null);
        }
    } else $172dcdbc06105c0b$var$N = !1;
}
var $172dcdbc06105c0b$var$S;
if ("function" === typeof $172dcdbc06105c0b$var$F) $172dcdbc06105c0b$var$S = function() {
    $172dcdbc06105c0b$var$F($172dcdbc06105c0b$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $172dcdbc06105c0b$var$T = new MessageChannel, $172dcdbc06105c0b$var$U = $172dcdbc06105c0b$var$T.port2;
    $172dcdbc06105c0b$var$T.port1.onmessage = $172dcdbc06105c0b$var$R;
    $172dcdbc06105c0b$var$S = function() {
        $172dcdbc06105c0b$var$U.postMessage(null);
    };
} else $172dcdbc06105c0b$var$S = function() {
    $172dcdbc06105c0b$var$D($172dcdbc06105c0b$var$R, 0);
};
function $172dcdbc06105c0b$var$I(a) {
    $172dcdbc06105c0b$var$O = a;
    $172dcdbc06105c0b$var$N || ($172dcdbc06105c0b$var$N = !0, $172dcdbc06105c0b$var$S());
}
function $172dcdbc06105c0b$var$K(a, b) {
    $172dcdbc06105c0b$var$L = $172dcdbc06105c0b$var$D(function() {
        a($172dcdbc06105c0b$export$c4744153514ff05d());
    }, b);
}
$172dcdbc06105c0b$export$3e506c1ccc9cc1a7 = 5;
$172dcdbc06105c0b$export$e26fe2ed2fa76875 = 1;
$172dcdbc06105c0b$export$502329bbf4b505b1 = 4;
$172dcdbc06105c0b$export$6e3807111c4874c4 = 3;
$172dcdbc06105c0b$export$c27134553091fb3a = null;
$172dcdbc06105c0b$export$33ee1acdc04fd2a2 = 2;
$172dcdbc06105c0b$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$172dcdbc06105c0b$export$8352ce38b91d0c62 = function() {
    $172dcdbc06105c0b$var$A || $172dcdbc06105c0b$var$z || ($172dcdbc06105c0b$var$A = !0, $172dcdbc06105c0b$var$I($172dcdbc06105c0b$var$J));
};
$172dcdbc06105c0b$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $172dcdbc06105c0b$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$172dcdbc06105c0b$export$d3dfb8e4810cb555 = function() {
    return $172dcdbc06105c0b$var$y;
};
$172dcdbc06105c0b$export$839f9183b0465a69 = function() {
    return $172dcdbc06105c0b$var$h($172dcdbc06105c0b$var$r);
};
$172dcdbc06105c0b$export$72fdf0e06517287b = function(a) {
    switch($172dcdbc06105c0b$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $172dcdbc06105c0b$var$y;
    }
    var c = $172dcdbc06105c0b$var$y;
    $172dcdbc06105c0b$var$y = b;
    try {
        return a();
    } finally{
        $172dcdbc06105c0b$var$y = c;
    }
};
$172dcdbc06105c0b$export$4b844e58a3e414b4 = function() {};
$172dcdbc06105c0b$export$816d2913ae6b83b1 = function() {};
$172dcdbc06105c0b$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $172dcdbc06105c0b$var$y;
    $172dcdbc06105c0b$var$y = a;
    try {
        return b();
    } finally{
        $172dcdbc06105c0b$var$y = c;
    }
};
$172dcdbc06105c0b$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $172dcdbc06105c0b$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $172dcdbc06105c0b$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $172dcdbc06105c0b$var$f($172dcdbc06105c0b$var$t, a), null === $172dcdbc06105c0b$var$h($172dcdbc06105c0b$var$r) && a === $172dcdbc06105c0b$var$h($172dcdbc06105c0b$var$t) && ($172dcdbc06105c0b$var$B ? ($172dcdbc06105c0b$var$E($172dcdbc06105c0b$var$L), $172dcdbc06105c0b$var$L = -1) : $172dcdbc06105c0b$var$B = !0, $172dcdbc06105c0b$var$K($172dcdbc06105c0b$var$H, c - d))) : (a.sortIndex = e, $172dcdbc06105c0b$var$f($172dcdbc06105c0b$var$r, a), $172dcdbc06105c0b$var$A || $172dcdbc06105c0b$var$z || ($172dcdbc06105c0b$var$A = !0, $172dcdbc06105c0b$var$I($172dcdbc06105c0b$var$J)));
    return a;
};
$172dcdbc06105c0b$export$b5836b71941fa3ed = $172dcdbc06105c0b$var$M;
$172dcdbc06105c0b$export$cf845f2c119da08a = function(a) {
    var b = $172dcdbc06105c0b$var$y;
    return function() {
        var c = $172dcdbc06105c0b$var$y;
        $172dcdbc06105c0b$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $172dcdbc06105c0b$var$y = c;
        }
    };
};

});




parcelRegister("zPQCX", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $06bb7ce5ce3f23d8$export$306c0aa65ff9ec16, (v) => $06bb7ce5ce3f23d8$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $06bb7ce5ce3f23d8$export$306c0aa65ff9ec16;
"use strict";

var $2gcPZ = parcelRequire("2gcPZ");
function $06bb7ce5ce3f23d8$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $06bb7ce5ce3f23d8$var$k = "function" === typeof Object.is ? Object.is : $06bb7ce5ce3f23d8$var$h, $06bb7ce5ce3f23d8$var$l = $2gcPZ.useState, $06bb7ce5ce3f23d8$var$m = $2gcPZ.useEffect, $06bb7ce5ce3f23d8$var$n = $2gcPZ.useLayoutEffect, $06bb7ce5ce3f23d8$var$p = $2gcPZ.useDebugValue;
function $06bb7ce5ce3f23d8$var$q(a, b) {
    var d = b(), f = $06bb7ce5ce3f23d8$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $06bb7ce5ce3f23d8$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $06bb7ce5ce3f23d8$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $06bb7ce5ce3f23d8$var$m(function() {
        $06bb7ce5ce3f23d8$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $06bb7ce5ce3f23d8$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $06bb7ce5ce3f23d8$var$p(d);
    return d;
}
function $06bb7ce5ce3f23d8$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$06bb7ce5ce3f23d8$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $06bb7ce5ce3f23d8$var$t(a, b) {
    return b();
}
var $06bb7ce5ce3f23d8$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $06bb7ce5ce3f23d8$var$t : $06bb7ce5ce3f23d8$var$q;
$06bb7ce5ce3f23d8$export$306c0aa65ff9ec16 = void 0 !== $2gcPZ.useSyncExternalStore ? $2gcPZ.useSyncExternalStore : $06bb7ce5ce3f23d8$var$u;

});

parcelRegister("8pFzM", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $6200e8b1867550da$export$bf730a2d8bf68b42, (v) => $6200e8b1867550da$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6200e8b1867550da$export$bf730a2d8bf68b42;
"use strict";

var $2gcPZ = parcelRequire("2gcPZ");

var $gt46n = parcelRequire("gt46n");
function $6200e8b1867550da$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $6200e8b1867550da$var$q = "function" === typeof Object.is ? Object.is : $6200e8b1867550da$var$p, $6200e8b1867550da$var$r = $gt46n.useSyncExternalStore, $6200e8b1867550da$var$t = $2gcPZ.useRef, $6200e8b1867550da$var$u = $2gcPZ.useEffect, $6200e8b1867550da$var$v = $2gcPZ.useMemo, $6200e8b1867550da$var$w = $2gcPZ.useDebugValue;
$6200e8b1867550da$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $6200e8b1867550da$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $6200e8b1867550da$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($6200e8b1867550da$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $6200e8b1867550da$var$r(a, c[0], c[1]);
    $6200e8b1867550da$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $6200e8b1867550da$var$w(d);
    return d;
};

});
parcelRegister("gt46n", function(module, exports) {
"use strict";

module.exports = (parcelRequire("zPQCX"));

});


parcelRegister("1Xs83", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $16d11ef09497f559$export$2b8d127b894957b9, (v) => $16d11ef09497f559$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $16d11ef09497f559$export$cea3a54a6425200c, (v) => $16d11ef09497f559$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $16d11ef09497f559$export$a7c73072b1a182ae, (v) => $16d11ef09497f559$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $16d11ef09497f559$export$9f27bc3417b4524d, (v) => $16d11ef09497f559$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $16d11ef09497f559$export$db77ccec0bb4ccac, (v) => $16d11ef09497f559$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $16d11ef09497f559$export$8392c0c9d3dcbd35, (v) => $16d11ef09497f559$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $16d11ef09497f559$export$ffb0004e005737fa, (v) => $16d11ef09497f559$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $16d11ef09497f559$export$b624eff549462981, (v) => $16d11ef09497f559$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $16d11ef09497f559$export$7897aa7841a5380c, (v) => $16d11ef09497f559$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $16d11ef09497f559$export$602eac185826482c, (v) => $16d11ef09497f559$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $16d11ef09497f559$export$e2c29f18771995cb, (v) => $16d11ef09497f559$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $16d11ef09497f559$export$5f8d39834fd61797, (v) => $16d11ef09497f559$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $16d11ef09497f559$export$74bf444e3cd11ea5, (v) => $16d11ef09497f559$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $16d11ef09497f559$export$92387174baf9b227, (v) => $16d11ef09497f559$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $16d11ef09497f559$export$ec112efeb987d9c6, (v) => $16d11ef09497f559$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $16d11ef09497f559$export$b706b080d889d2c9, (v) => $16d11ef09497f559$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $16d11ef09497f559$export$5be5a87408f70ddc, (v) => $16d11ef09497f559$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $16d11ef09497f559$export$45a5e7f76e0caa8d, (v) => $16d11ef09497f559$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $16d11ef09497f559$export$455c2e768291efa6, (v) => $16d11ef09497f559$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $16d11ef09497f559$export$9522e17588c12572, (v) => $16d11ef09497f559$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $16d11ef09497f559$export$2110ac352bb060b9, (v) => $16d11ef09497f559$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $16d11ef09497f559$export$56885ab8b9c456ab, (v) => $16d11ef09497f559$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $16d11ef09497f559$export$d927fcb6adf8f9de, (v) => $16d11ef09497f559$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $16d11ef09497f559$export$b82d16f27459e05a, (v) => $16d11ef09497f559$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $16d11ef09497f559$export$522c17b4f5e123e8, (v) => $16d11ef09497f559$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $16d11ef09497f559$export$1aabd8a0274ecfd6, (v) => $16d11ef09497f559$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $16d11ef09497f559$export$9b621391a187a31a, (v) => $16d11ef09497f559$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $16d11ef09497f559$export$f5bbd400c2f4426f, (v) => $16d11ef09497f559$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $16d11ef09497f559$export$2b8d127b894957b9;
var $16d11ef09497f559$export$cea3a54a6425200c;
var $16d11ef09497f559$export$a7c73072b1a182ae;
var $16d11ef09497f559$export$9f27bc3417b4524d;
var $16d11ef09497f559$export$db77ccec0bb4ccac;
var $16d11ef09497f559$export$8392c0c9d3dcbd35;
var $16d11ef09497f559$export$ffb0004e005737fa;
var $16d11ef09497f559$export$b624eff549462981;
var $16d11ef09497f559$export$7897aa7841a5380c;
var $16d11ef09497f559$export$602eac185826482c;
var $16d11ef09497f559$export$e2c29f18771995cb;
var $16d11ef09497f559$export$5f8d39834fd61797;
var $16d11ef09497f559$export$74bf444e3cd11ea5;
var $16d11ef09497f559$export$92387174baf9b227;
var $16d11ef09497f559$export$ec112efeb987d9c6;
var $16d11ef09497f559$export$b706b080d889d2c9;
var $16d11ef09497f559$export$5be5a87408f70ddc;
var $16d11ef09497f559$export$45a5e7f76e0caa8d;
var $16d11ef09497f559$export$455c2e768291efa6;
var $16d11ef09497f559$export$9522e17588c12572;
var $16d11ef09497f559$export$2110ac352bb060b9;
var $16d11ef09497f559$export$56885ab8b9c456ab;
var $16d11ef09497f559$export$d927fcb6adf8f9de;
var $16d11ef09497f559$export$b82d16f27459e05a;
var $16d11ef09497f559$export$522c17b4f5e123e8;
var $16d11ef09497f559$export$1aabd8a0274ecfd6;
var $16d11ef09497f559$export$9b621391a187a31a;
var $16d11ef09497f559$export$f5bbd400c2f4426f;
"use strict";
var $16d11ef09497f559$var$b = "function" === typeof Symbol && Symbol.for, $16d11ef09497f559$var$c = $16d11ef09497f559$var$b ? Symbol.for("react.element") : 60103, $16d11ef09497f559$var$d = $16d11ef09497f559$var$b ? Symbol.for("react.portal") : 60106, $16d11ef09497f559$var$e = $16d11ef09497f559$var$b ? Symbol.for("react.fragment") : 60107, $16d11ef09497f559$var$f = $16d11ef09497f559$var$b ? Symbol.for("react.strict_mode") : 60108, $16d11ef09497f559$var$g = $16d11ef09497f559$var$b ? Symbol.for("react.profiler") : 60114, $16d11ef09497f559$var$h = $16d11ef09497f559$var$b ? Symbol.for("react.provider") : 60109, $16d11ef09497f559$var$k = $16d11ef09497f559$var$b ? Symbol.for("react.context") : 60110, $16d11ef09497f559$var$l = $16d11ef09497f559$var$b ? Symbol.for("react.async_mode") : 60111, $16d11ef09497f559$var$m = $16d11ef09497f559$var$b ? Symbol.for("react.concurrent_mode") : 60111, $16d11ef09497f559$var$n = $16d11ef09497f559$var$b ? Symbol.for("react.forward_ref") : 60112, $16d11ef09497f559$var$p = $16d11ef09497f559$var$b ? Symbol.for("react.suspense") : 60113, $16d11ef09497f559$var$q = $16d11ef09497f559$var$b ? Symbol.for("react.suspense_list") : 60120, $16d11ef09497f559$var$r = $16d11ef09497f559$var$b ? Symbol.for("react.memo") : 60115, $16d11ef09497f559$var$t = $16d11ef09497f559$var$b ? Symbol.for("react.lazy") : 60116, $16d11ef09497f559$var$v = $16d11ef09497f559$var$b ? Symbol.for("react.block") : 60121, $16d11ef09497f559$var$w = $16d11ef09497f559$var$b ? Symbol.for("react.fundamental") : 60117, $16d11ef09497f559$var$x = $16d11ef09497f559$var$b ? Symbol.for("react.responder") : 60118, $16d11ef09497f559$var$y = $16d11ef09497f559$var$b ? Symbol.for("react.scope") : 60119;
function $16d11ef09497f559$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $16d11ef09497f559$var$c:
                switch(a = a.type, a){
                    case $16d11ef09497f559$var$l:
                    case $16d11ef09497f559$var$m:
                    case $16d11ef09497f559$var$e:
                    case $16d11ef09497f559$var$g:
                    case $16d11ef09497f559$var$f:
                    case $16d11ef09497f559$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $16d11ef09497f559$var$k:
                            case $16d11ef09497f559$var$n:
                            case $16d11ef09497f559$var$t:
                            case $16d11ef09497f559$var$r:
                            case $16d11ef09497f559$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $16d11ef09497f559$var$d:
                return u;
        }
    }
}
function $16d11ef09497f559$var$A(a) {
    return $16d11ef09497f559$var$z(a) === $16d11ef09497f559$var$m;
}
$16d11ef09497f559$export$2b8d127b894957b9 = $16d11ef09497f559$var$l;
$16d11ef09497f559$export$cea3a54a6425200c = $16d11ef09497f559$var$m;
$16d11ef09497f559$export$a7c73072b1a182ae = $16d11ef09497f559$var$k;
$16d11ef09497f559$export$9f27bc3417b4524d = $16d11ef09497f559$var$h;
$16d11ef09497f559$export$db77ccec0bb4ccac = $16d11ef09497f559$var$c;
$16d11ef09497f559$export$8392c0c9d3dcbd35 = $16d11ef09497f559$var$n;
$16d11ef09497f559$export$ffb0004e005737fa = $16d11ef09497f559$var$e;
$16d11ef09497f559$export$b624eff549462981 = $16d11ef09497f559$var$t;
$16d11ef09497f559$export$7897aa7841a5380c = $16d11ef09497f559$var$r;
$16d11ef09497f559$export$602eac185826482c = $16d11ef09497f559$var$d;
$16d11ef09497f559$export$e2c29f18771995cb = $16d11ef09497f559$var$g;
$16d11ef09497f559$export$5f8d39834fd61797 = $16d11ef09497f559$var$f;
$16d11ef09497f559$export$74bf444e3cd11ea5 = $16d11ef09497f559$var$p;
$16d11ef09497f559$export$92387174baf9b227 = function(a) {
    return $16d11ef09497f559$var$A(a) || $16d11ef09497f559$var$z(a) === $16d11ef09497f559$var$l;
};
$16d11ef09497f559$export$ec112efeb987d9c6 = $16d11ef09497f559$var$A;
$16d11ef09497f559$export$b706b080d889d2c9 = function(a) {
    return $16d11ef09497f559$var$z(a) === $16d11ef09497f559$var$k;
};
$16d11ef09497f559$export$5be5a87408f70ddc = function(a) {
    return $16d11ef09497f559$var$z(a) === $16d11ef09497f559$var$h;
};
$16d11ef09497f559$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $16d11ef09497f559$var$c;
};
$16d11ef09497f559$export$455c2e768291efa6 = function(a) {
    return $16d11ef09497f559$var$z(a) === $16d11ef09497f559$var$n;
};
$16d11ef09497f559$export$9522e17588c12572 = function(a) {
    return $16d11ef09497f559$var$z(a) === $16d11ef09497f559$var$e;
};
$16d11ef09497f559$export$2110ac352bb060b9 = function(a) {
    return $16d11ef09497f559$var$z(a) === $16d11ef09497f559$var$t;
};
$16d11ef09497f559$export$56885ab8b9c456ab = function(a) {
    return $16d11ef09497f559$var$z(a) === $16d11ef09497f559$var$r;
};
$16d11ef09497f559$export$d927fcb6adf8f9de = function(a) {
    return $16d11ef09497f559$var$z(a) === $16d11ef09497f559$var$d;
};
$16d11ef09497f559$export$b82d16f27459e05a = function(a) {
    return $16d11ef09497f559$var$z(a) === $16d11ef09497f559$var$g;
};
$16d11ef09497f559$export$522c17b4f5e123e8 = function(a) {
    return $16d11ef09497f559$var$z(a) === $16d11ef09497f559$var$f;
};
$16d11ef09497f559$export$1aabd8a0274ecfd6 = function(a) {
    return $16d11ef09497f559$var$z(a) === $16d11ef09497f559$var$p;
};
$16d11ef09497f559$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $16d11ef09497f559$var$e || a === $16d11ef09497f559$var$m || a === $16d11ef09497f559$var$g || a === $16d11ef09497f559$var$f || a === $16d11ef09497f559$var$p || a === $16d11ef09497f559$var$q || "object" === typeof a && null !== a && (a.$$typeof === $16d11ef09497f559$var$t || a.$$typeof === $16d11ef09497f559$var$r || a.$$typeof === $16d11ef09497f559$var$h || a.$$typeof === $16d11ef09497f559$var$k || a.$$typeof === $16d11ef09497f559$var$n || a.$$typeof === $16d11ef09497f559$var$w || a.$$typeof === $16d11ef09497f559$var$x || a.$$typeof === $16d11ef09497f559$var$y || a.$$typeof === $16d11ef09497f559$var$v);
};
$16d11ef09497f559$export$f5bbd400c2f4426f = $16d11ef09497f559$var$z;

});

parcelRegister("bAxob", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $86fcf4e41810f6ed$export$a7c73072b1a182ae, (v) => $86fcf4e41810f6ed$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $86fcf4e41810f6ed$export$9f27bc3417b4524d, (v) => $86fcf4e41810f6ed$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $86fcf4e41810f6ed$export$db77ccec0bb4ccac, (v) => $86fcf4e41810f6ed$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $86fcf4e41810f6ed$export$8392c0c9d3dcbd35, (v) => $86fcf4e41810f6ed$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $86fcf4e41810f6ed$export$ffb0004e005737fa, (v) => $86fcf4e41810f6ed$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $86fcf4e41810f6ed$export$b624eff549462981, (v) => $86fcf4e41810f6ed$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $86fcf4e41810f6ed$export$7897aa7841a5380c, (v) => $86fcf4e41810f6ed$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $86fcf4e41810f6ed$export$602eac185826482c, (v) => $86fcf4e41810f6ed$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $86fcf4e41810f6ed$export$e2c29f18771995cb, (v) => $86fcf4e41810f6ed$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $86fcf4e41810f6ed$export$5f8d39834fd61797, (v) => $86fcf4e41810f6ed$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $86fcf4e41810f6ed$export$74bf444e3cd11ea5, (v) => $86fcf4e41810f6ed$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $86fcf4e41810f6ed$export$998bcd577473dd93, (v) => $86fcf4e41810f6ed$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $86fcf4e41810f6ed$export$92387174baf9b227, (v) => $86fcf4e41810f6ed$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $86fcf4e41810f6ed$export$ec112efeb987d9c6, (v) => $86fcf4e41810f6ed$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $86fcf4e41810f6ed$export$b706b080d889d2c9, (v) => $86fcf4e41810f6ed$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $86fcf4e41810f6ed$export$5be5a87408f70ddc, (v) => $86fcf4e41810f6ed$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $86fcf4e41810f6ed$export$45a5e7f76e0caa8d, (v) => $86fcf4e41810f6ed$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $86fcf4e41810f6ed$export$455c2e768291efa6, (v) => $86fcf4e41810f6ed$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $86fcf4e41810f6ed$export$9522e17588c12572, (v) => $86fcf4e41810f6ed$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $86fcf4e41810f6ed$export$2110ac352bb060b9, (v) => $86fcf4e41810f6ed$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $86fcf4e41810f6ed$export$56885ab8b9c456ab, (v) => $86fcf4e41810f6ed$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $86fcf4e41810f6ed$export$d927fcb6adf8f9de, (v) => $86fcf4e41810f6ed$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $86fcf4e41810f6ed$export$b82d16f27459e05a, (v) => $86fcf4e41810f6ed$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $86fcf4e41810f6ed$export$522c17b4f5e123e8, (v) => $86fcf4e41810f6ed$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $86fcf4e41810f6ed$export$1aabd8a0274ecfd6, (v) => $86fcf4e41810f6ed$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $86fcf4e41810f6ed$export$3d6c20d97e46b957, (v) => $86fcf4e41810f6ed$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $86fcf4e41810f6ed$export$9b621391a187a31a, (v) => $86fcf4e41810f6ed$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $86fcf4e41810f6ed$export$f5bbd400c2f4426f, (v) => $86fcf4e41810f6ed$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $86fcf4e41810f6ed$export$a7c73072b1a182ae;
var $86fcf4e41810f6ed$export$9f27bc3417b4524d;
var $86fcf4e41810f6ed$export$db77ccec0bb4ccac;
var $86fcf4e41810f6ed$export$8392c0c9d3dcbd35;
var $86fcf4e41810f6ed$export$ffb0004e005737fa;
var $86fcf4e41810f6ed$export$b624eff549462981;
var $86fcf4e41810f6ed$export$7897aa7841a5380c;
var $86fcf4e41810f6ed$export$602eac185826482c;
var $86fcf4e41810f6ed$export$e2c29f18771995cb;
var $86fcf4e41810f6ed$export$5f8d39834fd61797;
var $86fcf4e41810f6ed$export$74bf444e3cd11ea5;
var $86fcf4e41810f6ed$export$998bcd577473dd93;
var $86fcf4e41810f6ed$export$92387174baf9b227;
var $86fcf4e41810f6ed$export$ec112efeb987d9c6;
var $86fcf4e41810f6ed$export$b706b080d889d2c9;
var $86fcf4e41810f6ed$export$5be5a87408f70ddc;
var $86fcf4e41810f6ed$export$45a5e7f76e0caa8d;
var $86fcf4e41810f6ed$export$455c2e768291efa6;
var $86fcf4e41810f6ed$export$9522e17588c12572;
var $86fcf4e41810f6ed$export$2110ac352bb060b9;
var $86fcf4e41810f6ed$export$56885ab8b9c456ab;
var $86fcf4e41810f6ed$export$d927fcb6adf8f9de;
var $86fcf4e41810f6ed$export$b82d16f27459e05a;
var $86fcf4e41810f6ed$export$522c17b4f5e123e8;
var $86fcf4e41810f6ed$export$1aabd8a0274ecfd6;
var $86fcf4e41810f6ed$export$3d6c20d97e46b957;
var $86fcf4e41810f6ed$export$9b621391a187a31a;
var $86fcf4e41810f6ed$export$f5bbd400c2f4426f;
"use strict";
var $86fcf4e41810f6ed$var$b = Symbol.for("react.element"), $86fcf4e41810f6ed$var$c = Symbol.for("react.portal"), $86fcf4e41810f6ed$var$d = Symbol.for("react.fragment"), $86fcf4e41810f6ed$var$e = Symbol.for("react.strict_mode"), $86fcf4e41810f6ed$var$f = Symbol.for("react.profiler"), $86fcf4e41810f6ed$var$g = Symbol.for("react.provider"), $86fcf4e41810f6ed$var$h = Symbol.for("react.context"), $86fcf4e41810f6ed$var$k = Symbol.for("react.server_context"), $86fcf4e41810f6ed$var$l = Symbol.for("react.forward_ref"), $86fcf4e41810f6ed$var$m = Symbol.for("react.suspense"), $86fcf4e41810f6ed$var$n = Symbol.for("react.suspense_list"), $86fcf4e41810f6ed$var$p = Symbol.for("react.memo"), $86fcf4e41810f6ed$var$q = Symbol.for("react.lazy"), $86fcf4e41810f6ed$var$t = Symbol.for("react.offscreen"), $86fcf4e41810f6ed$var$u;
$86fcf4e41810f6ed$var$u = Symbol.for("react.module.reference");
function $86fcf4e41810f6ed$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $86fcf4e41810f6ed$var$b:
                switch(a = a.type, a){
                    case $86fcf4e41810f6ed$var$d:
                    case $86fcf4e41810f6ed$var$f:
                    case $86fcf4e41810f6ed$var$e:
                    case $86fcf4e41810f6ed$var$m:
                    case $86fcf4e41810f6ed$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $86fcf4e41810f6ed$var$k:
                            case $86fcf4e41810f6ed$var$h:
                            case $86fcf4e41810f6ed$var$l:
                            case $86fcf4e41810f6ed$var$q:
                            case $86fcf4e41810f6ed$var$p:
                            case $86fcf4e41810f6ed$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $86fcf4e41810f6ed$var$c:
                return r;
        }
    }
}
$86fcf4e41810f6ed$export$a7c73072b1a182ae = $86fcf4e41810f6ed$var$h;
$86fcf4e41810f6ed$export$9f27bc3417b4524d = $86fcf4e41810f6ed$var$g;
$86fcf4e41810f6ed$export$db77ccec0bb4ccac = $86fcf4e41810f6ed$var$b;
$86fcf4e41810f6ed$export$8392c0c9d3dcbd35 = $86fcf4e41810f6ed$var$l;
$86fcf4e41810f6ed$export$ffb0004e005737fa = $86fcf4e41810f6ed$var$d;
$86fcf4e41810f6ed$export$b624eff549462981 = $86fcf4e41810f6ed$var$q;
$86fcf4e41810f6ed$export$7897aa7841a5380c = $86fcf4e41810f6ed$var$p;
$86fcf4e41810f6ed$export$602eac185826482c = $86fcf4e41810f6ed$var$c;
$86fcf4e41810f6ed$export$e2c29f18771995cb = $86fcf4e41810f6ed$var$f;
$86fcf4e41810f6ed$export$5f8d39834fd61797 = $86fcf4e41810f6ed$var$e;
$86fcf4e41810f6ed$export$74bf444e3cd11ea5 = $86fcf4e41810f6ed$var$m;
$86fcf4e41810f6ed$export$998bcd577473dd93 = $86fcf4e41810f6ed$var$n;
$86fcf4e41810f6ed$export$92387174baf9b227 = function() {
    return !1;
};
$86fcf4e41810f6ed$export$ec112efeb987d9c6 = function() {
    return !1;
};
$86fcf4e41810f6ed$export$b706b080d889d2c9 = function(a) {
    return $86fcf4e41810f6ed$var$v(a) === $86fcf4e41810f6ed$var$h;
};
$86fcf4e41810f6ed$export$5be5a87408f70ddc = function(a) {
    return $86fcf4e41810f6ed$var$v(a) === $86fcf4e41810f6ed$var$g;
};
$86fcf4e41810f6ed$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $86fcf4e41810f6ed$var$b;
};
$86fcf4e41810f6ed$export$455c2e768291efa6 = function(a) {
    return $86fcf4e41810f6ed$var$v(a) === $86fcf4e41810f6ed$var$l;
};
$86fcf4e41810f6ed$export$9522e17588c12572 = function(a) {
    return $86fcf4e41810f6ed$var$v(a) === $86fcf4e41810f6ed$var$d;
};
$86fcf4e41810f6ed$export$2110ac352bb060b9 = function(a) {
    return $86fcf4e41810f6ed$var$v(a) === $86fcf4e41810f6ed$var$q;
};
$86fcf4e41810f6ed$export$56885ab8b9c456ab = function(a) {
    return $86fcf4e41810f6ed$var$v(a) === $86fcf4e41810f6ed$var$p;
};
$86fcf4e41810f6ed$export$d927fcb6adf8f9de = function(a) {
    return $86fcf4e41810f6ed$var$v(a) === $86fcf4e41810f6ed$var$c;
};
$86fcf4e41810f6ed$export$b82d16f27459e05a = function(a) {
    return $86fcf4e41810f6ed$var$v(a) === $86fcf4e41810f6ed$var$f;
};
$86fcf4e41810f6ed$export$522c17b4f5e123e8 = function(a) {
    return $86fcf4e41810f6ed$var$v(a) === $86fcf4e41810f6ed$var$e;
};
$86fcf4e41810f6ed$export$1aabd8a0274ecfd6 = function(a) {
    return $86fcf4e41810f6ed$var$v(a) === $86fcf4e41810f6ed$var$m;
};
$86fcf4e41810f6ed$export$3d6c20d97e46b957 = function(a) {
    return $86fcf4e41810f6ed$var$v(a) === $86fcf4e41810f6ed$var$n;
};
$86fcf4e41810f6ed$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $86fcf4e41810f6ed$var$d || a === $86fcf4e41810f6ed$var$f || a === $86fcf4e41810f6ed$var$e || a === $86fcf4e41810f6ed$var$m || a === $86fcf4e41810f6ed$var$n || a === $86fcf4e41810f6ed$var$t || "object" === typeof a && null !== a && (a.$$typeof === $86fcf4e41810f6ed$var$q || a.$$typeof === $86fcf4e41810f6ed$var$p || a.$$typeof === $86fcf4e41810f6ed$var$g || a.$$typeof === $86fcf4e41810f6ed$var$h || a.$$typeof === $86fcf4e41810f6ed$var$l || a.$$typeof === $86fcf4e41810f6ed$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$86fcf4e41810f6ed$export$f5bbd400c2f4426f = $86fcf4e41810f6ed$var$v;

});

parcelRegister("jO74U", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6b82d6835169cf7$export$2e2bcd8739ae039);

var $6xdFa = parcelRequire("6xdFa");
var $e6b82d6835169cf7$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $e6b82d6835169cf7$var$index = (0, $6xdFa.default)(function(prop) {
    return $e6b82d6835169cf7$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $e6b82d6835169cf7$export$2e2bcd8739ae039 = $e6b82d6835169cf7$var$index;

});
parcelRegister("6xdFa", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c206c55bc2c8c2a$export$2e2bcd8739ae039);
function $4c206c55bc2c8c2a$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $4c206c55bc2c8c2a$export$2e2bcd8739ae039 = $4c206c55bc2c8c2a$var$memoize;

});


parcelRegister("irAxG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2gcPZ = parcelRequire("2gcPZ");
var $d6d71823c96d9cd0$var$useEffectOnce = function(effect) {
    $2gcPZ.useEffect(effect, []);
};
module.exports.default = $d6d71823c96d9cd0$var$useEffectOnce;

});

parcelRegister("iZCiH", function(module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object);
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
var defineProperty = function() {
    try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeMax = Math.max, nativeNow = Date.now;
/* Built-in method references that are verified to be native. */ var Map = getNative(root, "Map"), nativeCreate = getNative(Object, "create");
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignMergeValue(object, key, value) {
    if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == "__proto__" && defineProperty) defineProperty(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeysIn(object) {
    if (!isObject(object)) return nativeKeysIn(object);
    var isProto = isPrototype(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            assignMergeValue(object, key, newValue);
        }
    }, keysIn);
}
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) newValue = objValue;
            else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
            } else newValue = [];
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) newValue = toPlainObject(objValue);
            else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    assignMergeValue(object, key, newValue);
}
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function baseRest(func, start) {
    return setToString(overRest(func, start, identity), func + "");
}
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var baseSetToString = !defineProperty ? identity : function(func, string) {
    return defineProperty(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
    });
};
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function createAssigner(assigner) {
    return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function isIterateeCall(value, index, object) {
    if (!isObject(object)) return false;
    var type = typeof index;
    if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
    return false;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function overRest(func, start, transform) {
    start = nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
    };
}
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var setToString = shortOut(baseSetToString);
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == "object";
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
    var proto = getPrototype(value);
    if (proto === null) return true;
    var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function toPlainObject(value) {
    return copyObject(value, keysIn(value));
}
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function keysIn(object) {
    return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var merge = createAssigner(function(object, source, srcIndex) {
    baseMerge(object, source, srcIndex);
});
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function constant(value) {
    return function() {
        return value;
    };
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = merge;

});

parcelRegister("bEIGg", function(module, exports) {

$parcel$export(module.exports, "createDraftSafeSelector", () => $87c616c4cc6cc015$export$a5d3c27355e35910);
$parcel$export(module.exports, "isPlainObject", () => $87c616c4cc6cc015$export$53b83ca8eaab0383);
$parcel$export(module.exports, "MiddlewareArray", () => $87c616c4cc6cc015$export$20df1e9bd1a54f25);
$parcel$export(module.exports, "EnhancerArray", () => $87c616c4cc6cc015$export$490d10040a0cbe8a);
$parcel$export(module.exports, "isImmutableDefault", () => $87c616c4cc6cc015$export$9021b2733a0028a3);
$parcel$export(module.exports, "createImmutableStateInvariantMiddleware", () => $87c616c4cc6cc015$export$9181bb1a5474289);
$parcel$export(module.exports, "isPlain", () => $87c616c4cc6cc015$export$77670485918dab4e);
$parcel$export(module.exports, "findNonSerializableValue", () => $87c616c4cc6cc015$export$ada5dca0b571bc7);
$parcel$export(module.exports, "createSerializableStateInvariantMiddleware", () => $87c616c4cc6cc015$export$6dea1aad6dac5ac2);
$parcel$export(module.exports, "getDefaultMiddleware", () => $87c616c4cc6cc015$export$36c1185aeee5b0a6);
$parcel$export(module.exports, "configureStore", () => $87c616c4cc6cc015$export$7d8a5b498da695ac);
$parcel$export(module.exports, "createAction", () => $87c616c4cc6cc015$export$309c7a02b0b0bc62);
$parcel$export(module.exports, "isAction", () => $87c616c4cc6cc015$export$b956e38827fca970);
$parcel$export(module.exports, "isFluxStandardAction", () => $87c616c4cc6cc015$export$ebd532f9034651f3);
$parcel$export(module.exports, "getType", () => $87c616c4cc6cc015$export$e2b5c5db9e2009fd);
$parcel$export(module.exports, "createReducer", () => $87c616c4cc6cc015$export$473eb76d322d0290);
$parcel$export(module.exports, "createSlice", () => $87c616c4cc6cc015$export$4d8d9bd83c24ae8b);
$parcel$export(module.exports, "createEntityAdapter", () => $87c616c4cc6cc015$export$abcf4037b41e0df);
$parcel$export(module.exports, "nanoid", () => $87c616c4cc6cc015$export$ac4959f4f1338dfc);
$parcel$export(module.exports, "miniSerializeError", () => $87c616c4cc6cc015$export$c97c53d0b2d5d81e);
$parcel$export(module.exports, "createAsyncThunk", () => $87c616c4cc6cc015$export$6abd22dc03e5063f);
$parcel$export(module.exports, "unwrapResult", () => $87c616c4cc6cc015$export$5b28227b4c5dc983);
$parcel$export(module.exports, "isAnyOf", () => $87c616c4cc6cc015$export$2c3435c7647f7b0d);
$parcel$export(module.exports, "isAllOf", () => $87c616c4cc6cc015$export$9dd1fb32974da385);
$parcel$export(module.exports, "isPending", () => $87c616c4cc6cc015$export$872dec21e9a69476);
$parcel$export(module.exports, "isRejected", () => $87c616c4cc6cc015$export$a5c5d27e3994c5be);
$parcel$export(module.exports, "isRejectedWithValue", () => $87c616c4cc6cc015$export$fcc3388fb56de601);
$parcel$export(module.exports, "isFulfilled", () => $87c616c4cc6cc015$export$1da80a6ef1307441);
$parcel$export(module.exports, "isAsyncThunkAction", () => $87c616c4cc6cc015$export$6aa4142d99c1abce);
$parcel$export(module.exports, "TaskAbortError", () => $87c616c4cc6cc015$export$cb1bdac908fed7f);
$parcel$export(module.exports, "addListener", () => $87c616c4cc6cc015$export$f03a6b845d3fb58b);
$parcel$export(module.exports, "clearAllListeners", () => $87c616c4cc6cc015$export$b1b8022855fb2b71);
$parcel$export(module.exports, "removeListener", () => $87c616c4cc6cc015$export$b03e9483f936dccb);
$parcel$export(module.exports, "createListenerMiddleware", () => $87c616c4cc6cc015$export$1228acebbbcb485b);
$parcel$export(module.exports, "SHOULD_AUTOBATCH", () => $87c616c4cc6cc015$export$8fb31c0f05df007b);
$parcel$export(module.exports, "prepareAutoBatched", () => $87c616c4cc6cc015$export$39fcd5145ec5e4e2);
$parcel$export(module.exports, "autoBatchEnhancer", () => $87c616c4cc6cc015$export$676277d7dca0f396);
$parcel$export(module.exports, "createNextState", () => (parcelRequire("jewWr")).default);
$parcel$export(module.exports, "createSelector", () => (parcelRequire("ffM0i")).createSelector);
$parcel$export(module.exports, "current", () => (parcelRequire("jewWr")).current);
$parcel$export(module.exports, "freeze", () => (parcelRequire("jewWr")).freeze);
$parcel$export(module.exports, "isDraft", () => (parcelRequire("jewWr")).isDraft);
$parcel$export(module.exports, "original", () => (parcelRequire("jewWr")).original);

var $jewWr = parcelRequire("jewWr");

var $kHUM6 = parcelRequire("kHUM6");

var $ffM0i = parcelRequire("ffM0i");

var $9QQqP = parcelRequire("9QQqP");

var $fr0vp = parcelRequire("fr0vp");
var $87c616c4cc6cc015$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $87c616c4cc6cc015$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $87c616c4cc6cc015$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $87c616c4cc6cc015$var$__defProp = Object.defineProperty;
var $87c616c4cc6cc015$var$__defProps = Object.defineProperties;
var $87c616c4cc6cc015$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $87c616c4cc6cc015$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $87c616c4cc6cc015$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $87c616c4cc6cc015$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $87c616c4cc6cc015$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $87c616c4cc6cc015$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $87c616c4cc6cc015$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($87c616c4cc6cc015$var$__hasOwnProp.call(b, prop)) $87c616c4cc6cc015$var$__defNormalProp(a, prop, b[prop]);
    if ($87c616c4cc6cc015$var$__getOwnPropSymbols) for(var _i = 0, _c = $87c616c4cc6cc015$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($87c616c4cc6cc015$var$__propIsEnum.call(b, prop)) $87c616c4cc6cc015$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $87c616c4cc6cc015$var$__spreadProps = function(a, b) {
    return $87c616c4cc6cc015$var$__defProps(a, $87c616c4cc6cc015$var$__getOwnPropDescs(b));
};
var $87c616c4cc6cc015$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $87c616c4cc6cc015$export$a5d3c27355e35910 = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, $ffM0i.createSelector).apply(void 0, args);
    var wrappedSelector = function(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, $87c616c4cc6cc015$var$__spreadArray([
            (0, $jewWr.isDraft)(value) ? (0, $jewWr.current)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var $87c616c4cc6cc015$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $kHUM6.compose;
    return (0, $kHUM6.compose).apply(null, arguments);
};
var $87c616c4cc6cc015$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function $87c616c4cc6cc015$export$53b83ca8eaab0383(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
function $87c616c4cc6cc015$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var $87c616c4cc6cc015$export$20df1e9bd1a54f25 = /** @class */ function(_super) {
    $87c616c4cc6cc015$var$__extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, $87c616c4cc6cc015$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, $87c616c4cc6cc015$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
var $87c616c4cc6cc015$export$490d10040a0cbe8a = /** @class */ function(_super) {
    $87c616c4cc6cc015$var$__extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function() {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (EnhancerArray.bind.apply(EnhancerArray, $87c616c4cc6cc015$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (EnhancerArray.bind.apply(EnhancerArray, $87c616c4cc6cc015$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array);
function $87c616c4cc6cc015$var$freezeDraftable(val) {
    return (0, $jewWr.isDraftable)(val) ? (0, $jewWr.default)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var $87c616c4cc6cc015$var$isProduction = true;
var $87c616c4cc6cc015$var$prefix = "Invariant failed";
function $87c616c4cc6cc015$var$invariant(condition, message) {
    if (condition) return;
    if ($87c616c4cc6cc015$var$isProduction) throw new Error($87c616c4cc6cc015$var$prefix);
    throw new Error($87c616c4cc6cc015$var$prefix + ": " + (message || ""));
}
function $87c616c4cc6cc015$var$stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, $87c616c4cc6cc015$var$getSerialize(serializer, decycler), indent);
}
function $87c616c4cc6cc015$var$getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function $87c616c4cc6cc015$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $87c616c4cc6cc015$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $87c616c4cc6cc015$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $87c616c4cc6cc015$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $87c616c4cc6cc015$var$trackProperties(isImmutable, ignorePaths, obj, path) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj)) {
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $87c616c4cc6cc015$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $87c616c4cc6cc015$var$detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) ignoredPaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function(key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $87c616c4cc6cc015$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return {
            value: result
        };
    };
    for(var key in keysToDetect){
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return {
        wasMutated: false
    };
}
function $87c616c4cc6cc015$export$9181bb1a5474289(options) {
    if (options === void 0) options = {};
    var _c, isImmutable, ignoredPaths, _d, warnAfter, ignore, track;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function $87c616c4cc6cc015$export$77670485918dab4e(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || $87c616c4cc6cc015$export$53b83ca8eaab0383(val);
}
function $87c616c4cc6cc015$export$ada5dca0b571bc7(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = $87c616c4cc6cc015$export$77670485918dab4e;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function(key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        if (!isSerializable(nestedValue)) return {
            value: {
                keyPath: nestedPath,
                value: nestedValue
            }
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $87c616c4cc6cc015$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return {
                value: foundNestedSerializable
            };
        }
    };
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object") return state_2.value;
    }
    if (cache && $87c616c4cc6cc015$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $87c616c4cc6cc015$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for(var _i = 0, _c = Object.values(value); _i < _c.length; _i++){
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$87c616c4cc6cc015$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $87c616c4cc6cc015$export$6dea1aad6dac5ac2(options) {
    if (options === void 0) options = {};
    var _c, isSerializable, getEntries, _d, ignoredActions, _e, ignoredActionPaths, _f, ignoredPaths, _g, warnAfter, _h, ignoreState, _j, ignoreActions, _k, disableCache, cache;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $87c616c4cc6cc015$var$isBoolean(x) {
    return typeof x === "boolean";
}
function $87c616c4cc6cc015$var$curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return $87c616c4cc6cc015$export$36c1185aeee5b0a6(options);
    };
}
function $87c616c4cc6cc015$export$36c1185aeee5b0a6(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e;
    var middlewareArray = new $87c616c4cc6cc015$export$20df1e9bd1a54f25();
    if (thunk) {
        if ($87c616c4cc6cc015$var$isBoolean(thunk)) middlewareArray.push((0, $9QQqP.default));
        else middlewareArray.push((0, $9QQqP.default).withExtraArgument(thunk.extraArgument));
    }
    var immutableOptions, serializableOptions;
    return middlewareArray;
}
// src/configureStore.ts
var $87c616c4cc6cc015$var$IS_PRODUCTION = true;
function $87c616c4cc6cc015$export$7d8a5b498da695ac(options) {
    var curriedGetDefaultMiddleware = $87c616c4cc6cc015$var$curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ($87c616c4cc6cc015$export$53b83ca8eaab0383(reducer)) rootReducer = (0, $kHUM6.combineReducers)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!$87c616c4cc6cc015$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!$87c616c4cc6cc015$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, $kHUM6.applyMiddleware).apply(void 0, finalMiddleware);
    var finalCompose = (0, $kHUM6.compose);
    if (devTools) finalCompose = $87c616c4cc6cc015$var$composeWithDevTools($87c616c4cc6cc015$var$__spreadValues({
        trace: !$87c616c4cc6cc015$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var defaultEnhancers = new $87c616c4cc6cc015$export$490d10040a0cbe8a(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) storeEnhancers = $87c616c4cc6cc015$var$__spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(defaultEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, $kHUM6.createStore)(rootReducer, preloadedState, composedEnhancer);
}
// src/createAction.ts
function $87c616c4cc6cc015$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return $87c616c4cc6cc015$var$__spreadValues($87c616c4cc6cc015$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function $87c616c4cc6cc015$export$b956e38827fca970(action) {
    return $87c616c4cc6cc015$export$53b83ca8eaab0383(action) && "type" in action;
}
function $87c616c4cc6cc015$export$ebd532f9034651f3(action) {
    return $87c616c4cc6cc015$export$b956e38827fca970(action) && typeof action.type === "string" && Object.keys(action).every($87c616c4cc6cc015$var$isValidKey);
}
function $87c616c4cc6cc015$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function $87c616c4cc6cc015$export$e2b5c5db9e2009fd(actionCreator) {
    return "" + actionCreator;
}
// src/mapBuilders.ts
function $87c616c4cc6cc015$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (type in actionsMap) throw new Error("addCase cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $87c616c4cc6cc015$var$isStateFunction(x) {
    return typeof x === "function";
}
var $87c616c4cc6cc015$var$hasWarnedAboutObjectNotation = false;
function $87c616c4cc6cc015$export$473eb76d322d0290(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) actionMatchers = [];
    var _c = typeof mapOrBuilderCallback === "function" ? $87c616c4cc6cc015$var$executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if ($87c616c4cc6cc015$var$isStateFunction(initialState)) getInitialState = function() {
        return $87c616c4cc6cc015$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = $87c616c4cc6cc015$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState_1;
        };
    }
    function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = $87c616c4cc6cc015$var$__spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $jewWr.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $jewWr.isDraftable)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $jewWr.default)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var $87c616c4cc6cc015$var$hasWarnedAboutObjectNotation2 = false;
function $87c616c4cc6cc015$var$getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function $87c616c4cc6cc015$export$4d8d9bd83c24ae8b(options) {
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    typeof $fr0vp;
    var initialState = typeof options.initialState == "function" ? options.initialState : $87c616c4cc6cc015$var$freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = $87c616c4cc6cc015$var$getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? $87c616c4cc6cc015$export$309c7a02b0b0bc62(type, prepareCallback) : $87c616c4cc6cc015$export$309c7a02b0b0bc62(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? $87c616c4cc6cc015$var$executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = $87c616c4cc6cc015$var$__spreadValues($87c616c4cc6cc015$var$__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return $87c616c4cc6cc015$export$473eb76d322d0290(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function $87c616c4cc6cc015$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $87c616c4cc6cc015$var$createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign($87c616c4cc6cc015$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $87c616c4cc6cc015$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = $87c616c4cc6cc015$export$a5d3c27355e35910(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = $87c616c4cc6cc015$export$a5d3c27355e35910(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: $87c616c4cc6cc015$export$a5d3c27355e35910(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = $87c616c4cc6cc015$export$a5d3c27355e35910(selectState, selectEntities);
        return {
            selectIds: $87c616c4cc6cc015$export$a5d3c27355e35910(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: $87c616c4cc6cc015$export$a5d3c27355e35910(selectState, selectAll),
            selectTotal: $87c616c4cc6cc015$export$a5d3c27355e35910(selectState, selectTotal),
            selectById: $87c616c4cc6cc015$export$a5d3c27355e35910(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
function $87c616c4cc6cc015$var$createSingleArgumentStateOperator(mutator) {
    var operator = $87c616c4cc6cc015$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $87c616c4cc6cc015$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $87c616c4cc6cc015$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, $jewWr.isDraft)(state)) {
            runMutator(state);
            return state;
        } else return (0, $jewWr.default)(state, runMutator);
    };
}
// src/entities/utils.ts
function $87c616c4cc6cc015$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $87c616c4cc6cc015$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $87c616c4cc6cc015$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $87c616c4cc6cc015$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = $87c616c4cc6cc015$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $87c616c4cc6cc015$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $87c616c4cc6cc015$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $87c616c4cc6cc015$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = $87c616c4cc6cc015$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $87c616c4cc6cc015$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $87c616c4cc6cc015$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = $87c616c4cc6cc015$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: $87c616c4cc6cc015$var$__spreadValues($87c616c4cc6cc015$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $87c616c4cc6cc015$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $87c616c4cc6cc015$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $87c616c4cc6cc015$var$createStateOperator(addOneMutably),
        addMany: $87c616c4cc6cc015$var$createStateOperator(addManyMutably),
        setOne: $87c616c4cc6cc015$var$createStateOperator(setOneMutably),
        setMany: $87c616c4cc6cc015$var$createStateOperator(setManyMutably),
        setAll: $87c616c4cc6cc015$var$createStateOperator(setAllMutably),
        updateOne: $87c616c4cc6cc015$var$createStateOperator(updateOneMutably),
        updateMany: $87c616c4cc6cc015$var$createStateOperator(updateManyMutably),
        upsertOne: $87c616c4cc6cc015$var$createStateOperator(upsertOneMutably),
        upsertMany: $87c616c4cc6cc015$var$createStateOperator(upsertManyMutably),
        removeOne: $87c616c4cc6cc015$var$createStateOperator(removeOneMutably),
        removeMany: $87c616c4cc6cc015$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $87c616c4cc6cc015$var$createSortedStateAdapter(selectId, sort) {
    var _c = $87c616c4cc6cc015$var$createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $87c616c4cc6cc015$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($87c616c4cc6cc015$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $87c616c4cc6cc015$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $87c616c4cc6cc015$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $87c616c4cc6cc015$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $87c616c4cc6cc015$var$createStateOperator(addOneMutably),
        updateOne: $87c616c4cc6cc015$var$createStateOperator(updateOneMutably),
        upsertOne: $87c616c4cc6cc015$var$createStateOperator(upsertOneMutably),
        setOne: $87c616c4cc6cc015$var$createStateOperator(setOneMutably),
        setMany: $87c616c4cc6cc015$var$createStateOperator(setManyMutably),
        setAll: $87c616c4cc6cc015$var$createStateOperator(setAllMutably),
        addMany: $87c616c4cc6cc015$var$createStateOperator(addManyMutably),
        updateMany: $87c616c4cc6cc015$var$createStateOperator(updateManyMutably),
        upsertMany: $87c616c4cc6cc015$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $87c616c4cc6cc015$export$abcf4037b41e0df(options) {
    if (options === void 0) options = {};
    var _c = $87c616c4cc6cc015$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = $87c616c4cc6cc015$var$createInitialStateFactory();
    var selectorsFactory = $87c616c4cc6cc015$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $87c616c4cc6cc015$var$createSortedStateAdapter(selectId, sortComparer) : $87c616c4cc6cc015$var$createUnsortedStateAdapter(selectId);
    return $87c616c4cc6cc015$var$__spreadValues($87c616c4cc6cc015$var$__spreadValues($87c616c4cc6cc015$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var $87c616c4cc6cc015$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $87c616c4cc6cc015$export$ac4959f4f1338dfc = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += $87c616c4cc6cc015$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $87c616c4cc6cc015$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $87c616c4cc6cc015$var$RejectWithValue = /** @class */ function() {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}();
var $87c616c4cc6cc015$var$FulfillWithMeta = /** @class */ function() {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}();
var $87c616c4cc6cc015$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = $87c616c4cc6cc015$var$commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $87c616c4cc6cc015$export$6abd22dc03e5063f = function() {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $87c616c4cc6cc015$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $87c616c4cc6cc015$var$__spreadProps($87c616c4cc6cc015$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $87c616c4cc6cc015$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $87c616c4cc6cc015$var$__spreadProps($87c616c4cc6cc015$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $87c616c4cc6cc015$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $87c616c4cc6cc015$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $87c616c4cc6cc015$var$__spreadProps($87c616c4cc6cc015$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function() {},
                    dispatchEvent: function() {
                        return false;
                    },
                    onabort: function() {},
                    removeEventListener: function() {},
                    reason: void 0,
                    throwIfAborted: function() {}
                };
            }
            class_1.prototype.abort = function() {};
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $87c616c4cc6cc015$export$ac4959f4f1338dfc();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return $87c616c4cc6cc015$var$__async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return $87c616c4cc6cc015$var$__generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!$87c616c4cc6cc015$var$isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new $87c616c4cc6cc015$var$RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new $87c616c4cc6cc015$var$FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof $87c616c4cc6cc015$var$RejectWithValue) throw result;
                                                if (result instanceof $87c616c4cc6cc015$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof $87c616c4cc6cc015$var$RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise2.then($87c616c4cc6cc015$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $87c616c4cc6cc015$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $87c616c4cc6cc015$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/tsHelpers.ts
var $87c616c4cc6cc015$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/matchers.ts
var $87c616c4cc6cc015$var$matches = function(matcher, action) {
    if ($87c616c4cc6cc015$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $87c616c4cc6cc015$export$2c3435c7647f7b0d() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return $87c616c4cc6cc015$var$matches(matcher, action);
        });
    };
}
function $87c616c4cc6cc015$export$9dd1fb32974da385() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return $87c616c4cc6cc015$var$matches(matcher, action);
        });
    };
}
function $87c616c4cc6cc015$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $87c616c4cc6cc015$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $87c616c4cc6cc015$export$872dec21e9a69476() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $87c616c4cc6cc015$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$87c616c4cc6cc015$var$isAsyncThunkArray(asyncThunks)) return $87c616c4cc6cc015$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $87c616c4cc6cc015$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $87c616c4cc6cc015$export$a5c5d27e3994c5be() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $87c616c4cc6cc015$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$87c616c4cc6cc015$var$isAsyncThunkArray(asyncThunks)) return $87c616c4cc6cc015$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $87c616c4cc6cc015$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $87c616c4cc6cc015$export$fcc3388fb56de601() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $87c616c4cc6cc015$export$9dd1fb32974da385($87c616c4cc6cc015$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$87c616c4cc6cc015$var$isAsyncThunkArray(asyncThunks)) return $87c616c4cc6cc015$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $87c616c4cc6cc015$export$9dd1fb32974da385($87c616c4cc6cc015$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $87c616c4cc6cc015$export$1da80a6ef1307441() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $87c616c4cc6cc015$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$87c616c4cc6cc015$var$isAsyncThunkArray(asyncThunks)) return $87c616c4cc6cc015$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $87c616c4cc6cc015$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $87c616c4cc6cc015$export$6aa4142d99c1abce() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $87c616c4cc6cc015$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$87c616c4cc6cc015$var$isAsyncThunkArray(asyncThunks)) return $87c616c4cc6cc015$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = $87c616c4cc6cc015$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var $87c616c4cc6cc015$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var $87c616c4cc6cc015$var$noop = function() {};
var $87c616c4cc6cc015$var$catchRejection = function(promise2, onError) {
    if (onError === void 0) onError = $87c616c4cc6cc015$var$noop;
    promise2.catch(onError);
    return promise2;
};
var $87c616c4cc6cc015$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $87c616c4cc6cc015$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var $87c616c4cc6cc015$var$task = "task";
var $87c616c4cc6cc015$var$listener = "listener";
var $87c616c4cc6cc015$var$completed = "completed";
var $87c616c4cc6cc015$var$cancelled = "cancelled";
var $87c616c4cc6cc015$var$taskCancelled = "task-" + $87c616c4cc6cc015$var$cancelled;
var $87c616c4cc6cc015$var$taskCompleted = "task-" + $87c616c4cc6cc015$var$completed;
var $87c616c4cc6cc015$var$listenerCancelled = $87c616c4cc6cc015$var$listener + "-" + $87c616c4cc6cc015$var$cancelled;
var $87c616c4cc6cc015$var$listenerCompleted = $87c616c4cc6cc015$var$listener + "-" + $87c616c4cc6cc015$var$completed;
var $87c616c4cc6cc015$export$cb1bdac908fed7f = /** @class */ function() {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = $87c616c4cc6cc015$var$task + " " + $87c616c4cc6cc015$var$cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var $87c616c4cc6cc015$var$validateActive = function(signal) {
    if (signal.aborted) throw new $87c616c4cc6cc015$export$cb1bdac908fed7f(signal.reason);
};
function $87c616c4cc6cc015$var$raceWithSignal(signal, promise2) {
    var cleanup = $87c616c4cc6cc015$var$noop;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $87c616c4cc6cc015$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $87c616c4cc6cc015$var$addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $87c616c4cc6cc015$var$noop;
    });
}
var $87c616c4cc6cc015$var$runTask = function(task2, cleanUp) {
    return $87c616c4cc6cc015$var$__async(void 0, null, function() {
        var value, error_1;
        return $87c616c4cc6cc015$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof $87c616c4cc6cc015$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $87c616c4cc6cc015$var$createPause = function(signal) {
    return function(promise2) {
        return $87c616c4cc6cc015$var$catchRejection($87c616c4cc6cc015$var$raceWithSignal(signal, promise2).then(function(output) {
            $87c616c4cc6cc015$var$validateActive(signal);
            return output;
        }));
    };
};
var $87c616c4cc6cc015$var$createDelay = function(signal) {
    var pause = $87c616c4cc6cc015$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $87c616c4cc6cc015$var$assign = Object.assign;
var $87c616c4cc6cc015$var$INTERNAL_NIL_TOKEN = {};
var $87c616c4cc6cc015$var$alm = "listenerMiddleware";
var $87c616c4cc6cc015$var$createFork = function(parentAbortSignal) {
    var linkControllers = function(controller) {
        return $87c616c4cc6cc015$var$addAbortSignalListener(parentAbortSignal, function() {
            return $87c616c4cc6cc015$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor) {
        $87c616c4cc6cc015$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $87c616c4cc6cc015$var$runTask(function() {
            return $87c616c4cc6cc015$var$__async(void 0, null, function() {
                var result2;
                return $87c616c4cc6cc015$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            $87c616c4cc6cc015$var$validateActive(parentAbortSignal);
                            $87c616c4cc6cc015$var$validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: $87c616c4cc6cc015$var$createPause(childAbortController.signal),
                                    delay: $87c616c4cc6cc015$var$createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            $87c616c4cc6cc015$var$validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return $87c616c4cc6cc015$var$abortControllerWithReason(childAbortController, $87c616c4cc6cc015$var$taskCompleted);
        });
        return {
            result: $87c616c4cc6cc015$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $87c616c4cc6cc015$var$abortControllerWithReason(childAbortController, $87c616c4cc6cc015$var$taskCancelled);
            }
        };
    };
};
var $87c616c4cc6cc015$var$createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return $87c616c4cc6cc015$var$__async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return $87c616c4cc6cc015$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $87c616c4cc6cc015$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            $87c616c4cc6cc015$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _c.sent();
                        $87c616c4cc6cc015$var$validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return $87c616c4cc6cc015$var$catchRejection(take(predicate, timeout));
    };
};
var $87c616c4cc6cc015$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $87c616c4cc6cc015$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    $87c616c4cc6cc015$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $87c616c4cc6cc015$var$createListenerEntry = function(options) {
    var _c = $87c616c4cc6cc015$var$getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = $87c616c4cc6cc015$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var $87c616c4cc6cc015$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $87c616c4cc6cc015$var$abortControllerWithReason(controller, $87c616c4cc6cc015$var$listenerCancelled);
    });
};
var $87c616c4cc6cc015$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($87c616c4cc6cc015$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $87c616c4cc6cc015$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $87c616c4cc6cc015$export$f03a6b845d3fb58b = $87c616c4cc6cc015$export$309c7a02b0b0bc62($87c616c4cc6cc015$var$alm + "/add");
var $87c616c4cc6cc015$export$b1b8022855fb2b71 = $87c616c4cc6cc015$export$309c7a02b0b0bc62($87c616c4cc6cc015$var$alm + "/removeAll");
var $87c616c4cc6cc015$export$b03e9483f936dccb = $87c616c4cc6cc015$export$309c7a02b0b0bc62($87c616c4cc6cc015$var$alm + "/remove");
var $87c616c4cc6cc015$var$defaultErrorHandler = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, $87c616c4cc6cc015$var$__spreadArray([
        $87c616c4cc6cc015$var$alm + "/error"
    ], args));
};
function $87c616c4cc6cc015$export$1228acebbbcb485b(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? $87c616c4cc6cc015$var$defaultErrorHandler : _c;
    $87c616c4cc6cc015$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $87c616c4cc6cc015$var$cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $87c616c4cc6cc015$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function(options) {
        var _c = $87c616c4cc6cc015$var$getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $87c616c4cc6cc015$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function(entry, action, api, getOriginalState) {
        return $87c616c4cc6cc015$var$__async(_this, null, function() {
            var internalTaskController, take, listenerError_1;
            return $87c616c4cc6cc015$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $87c616c4cc6cc015$var$createTakePattern(startListening, internalTaskController.signal);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, $87c616c4cc6cc015$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $87c616c4cc6cc015$var$createDelay(internalTaskController.signal),
                                pause: $87c616c4cc6cc015$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $87c616c4cc6cc015$var$createFork(internalTaskController.signal),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $87c616c4cc6cc015$var$abortControllerWithReason(controller, $87c616c4cc6cc015$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof $87c616c4cc6cc015$export$cb1bdac908fed7f)) $87c616c4cc6cc015$var$safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        $87c616c4cc6cc015$var$abortControllerWithReason(internalTaskController, $87c616c4cc6cc015$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = $87c616c4cc6cc015$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!$87c616c4cc6cc015$export$b956e38827fca970(action)) return next(action);
                if ($87c616c4cc6cc015$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($87c616c4cc6cc015$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($87c616c4cc6cc015$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $87c616c4cc6cc015$var$INTERNAL_NIL_TOKEN) throw new Error($87c616c4cc6cc015$var$alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $87c616c4cc6cc015$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $87c616c4cc6cc015$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var $87c616c4cc6cc015$export$8fb31c0f05df007b = "RTK_autoBatch";
var $87c616c4cc6cc015$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[$87c616c4cc6cc015$export$8fb31c0f05df007b] = true, _c)
        };
    };
};
var $87c616c4cc6cc015$var$promise;
var $87c616c4cc6cc015$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function(cb) {
    return ($87c616c4cc6cc015$var$promise || ($87c616c4cc6cc015$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $87c616c4cc6cc015$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $87c616c4cc6cc015$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $87c616c4cc6cc015$var$createQueueWithTimer(10);
var $87c616c4cc6cc015$export$676277d7dca0f396 = function(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? $87c616c4cc6cc015$var$queueMicrotaskShim : options.type === "raf" ? $87c616c4cc6cc015$var$rAF : options.type === "callback" ? options.queueNotification : $87c616c4cc6cc015$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$87c616c4cc6cc015$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, $jewWr.enableES5)();
$parcel$exportWildcard(module.exports, $kHUM6);

});
parcelRegister("jewWr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "isDraft", () => r);
$parcel$export(module.exports, "isDraftable", () => t);
$parcel$export(module.exports, "immerable", () => L);
$parcel$export(module.exports, "original", () => e);
$parcel$export(module.exports, "freeze", () => d);
$parcel$export(module.exports, "nothing", () => H);
$parcel$export(module.exports, "current", () => R);
$parcel$export(module.exports, "enableES5", () => F);
$parcel$export(module.exports, "enablePatches", () => T);
$parcel$export(module.exports, "enableMapSet", () => C);
$parcel$export(module.exports, "enableAllPlugins", () => J);
$parcel$export(module.exports, "castDraft", () => K);
$parcel$export(module.exports, "castImmutable", () => $);
$parcel$export(module.exports, "Immer", () => un);
$parcel$export(module.exports, "produce", () => fn);
$parcel$export(module.exports, "produceWithPatches", () => cn);
$parcel$export(module.exports, "setAutoFreeze", () => sn);
$parcel$export(module.exports, "setUseProxies", () => vn);
$parcel$export(module.exports, "applyPatches", () => pn);
$parcel$export(module.exports, "createDraft", () => ln);
$parcel$export(module.exports, "finishDraft", () => dn);
$parcel$export(module.exports, "default", () => $e008e0aa03047139$export$2e2bcd8739ae039);
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $e008e0aa03047139$export$2e2bcd8739ae039 = fn;

});

parcelRegister("kHUM6", function(module, exports) {

$parcel$export(module.exports, "__DO_NOT_USE__ActionTypes", () => $f133dd18b12093cf$export$4219e499db7ca678);
$parcel$export(module.exports, "createStore", () => $f133dd18b12093cf$export$f51a9068ac82ea43);
$parcel$export(module.exports, "legacy_createStore", () => $f133dd18b12093cf$export$8928921ea2d3b126);
$parcel$export(module.exports, "combineReducers", () => $f133dd18b12093cf$export$66e4520cdb265d18);
$parcel$export(module.exports, "bindActionCreators", () => $f133dd18b12093cf$export$aea084d96e84da92);
$parcel$export(module.exports, "compose", () => $f133dd18b12093cf$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "applyMiddleware", () => $f133dd18b12093cf$export$9ff26e0402cc7b7);

var $02vbh = parcelRequire("02vbh");
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $f133dd18b12093cf$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $f133dd18b12093cf$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $f133dd18b12093cf$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $f133dd18b12093cf$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $f133dd18b12093cf$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $f133dd18b12093cf$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $f133dd18b12093cf$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $f133dd18b12093cf$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $f133dd18b12093cf$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($f133dd18b12093cf$var$isDate(val)) return "date";
    if ($f133dd18b12093cf$var$isError(val)) return "error";
    var constructorName = $f133dd18b12093cf$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $f133dd18b12093cf$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $f133dd18b12093cf$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $f133dd18b12093cf$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $f133dd18b12093cf$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $f133dd18b12093cf$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($f133dd18b12093cf$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($f133dd18b12093cf$var$formatProdErrorMessage(1));
        return enhancer($f133dd18b12093cf$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($f133dd18b12093cf$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($f133dd18b12093cf$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($f133dd18b12093cf$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($f133dd18b12093cf$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($f133dd18b12093cf$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$f133dd18b12093cf$var$isPlainObject(action)) throw new Error($f133dd18b12093cf$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($f133dd18b12093cf$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($f133dd18b12093cf$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($f133dd18b12093cf$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $f133dd18b12093cf$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($f133dd18b12093cf$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$f133dd18b12093cf$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $f133dd18b12093cf$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$f133dd18b12093cf$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $f133dd18b12093cf$export$8928921ea2d3b126 = $f133dd18b12093cf$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $f133dd18b12093cf$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $f133dd18b12093cf$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $f133dd18b12093cf$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$f133dd18b12093cf$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $f133dd18b12093cf$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $f133dd18b12093cf$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $f133dd18b12093cf$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $f133dd18b12093cf$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($f133dd18b12093cf$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $f133dd18b12093cf$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($f133dd18b12093cf$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $f133dd18b12093cf$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $f133dd18b12093cf$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($f133dd18b12093cf$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $f133dd18b12093cf$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $f133dd18b12093cf$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $f133dd18b12093cf$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($f133dd18b12093cf$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $f133dd18b12093cf$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $f133dd18b12093cf$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $f133dd18b12093cf$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($f133dd18b12093cf$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $f133dd18b12093cf$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $02vbh.default)((0, $02vbh.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRegister("02vbh", function(module, exports) {

$parcel$export(module.exports, "default", () => $00785fecc30a8cda$export$2e2bcd8739ae039);

var $03j8w = parcelRequire("03j8w");
function $00785fecc30a8cda$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $00785fecc30a8cda$export$2e2bcd8739ae039(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $00785fecc30a8cda$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $03j8w.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $00785fecc30a8cda$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

});
parcelRegister("03j8w", function(module, exports) {

$parcel$export(module.exports, "default", () => $009f20083733ec9a$export$2e2bcd8739ae039);

var $9Alaj = parcelRequire("9Alaj");
function $009f20083733ec9a$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $9Alaj.default)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});
parcelRegister("9Alaj", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fa7e4d76434c347$export$2e2bcd8739ae039);

var $eVLAC = parcelRequire("eVLAC");

var $eaz8e = parcelRequire("eaz8e");
function $6fa7e4d76434c347$export$2e2bcd8739ae039(arg) {
    var key = (0, $eaz8e.default)(arg, "string");
    return (0, $eVLAC.default)(key) === "symbol" ? key : String(key);
}

});
parcelRegister("eVLAC", function(module, exports) {

$parcel$export(module.exports, "default", () => $adeb4de1c0b1ded6$export$2e2bcd8739ae039);
function $adeb4de1c0b1ded6$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $adeb4de1c0b1ded6$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $adeb4de1c0b1ded6$export$2e2bcd8739ae039(obj);
}

});

parcelRegister("eaz8e", function(module, exports) {

$parcel$export(module.exports, "default", () => $a50d404776ef82ff$export$2e2bcd8739ae039);

var $eVLAC = parcelRequire("eVLAC");
function $a50d404776ef82ff$export$2e2bcd8739ae039(input, hint) {
    if ((0, $eVLAC.default)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $eVLAC.default)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

});





parcelRegister("ffM0i", function(module, exports) {

$parcel$export(module.exports, "createSelectorCreator", () => $b1ad7e452c63f0bd$export$5943f4447f6ef248);
$parcel$export(module.exports, "createSelector", () => $b1ad7e452c63f0bd$export$595d22ed68ca2841);
$parcel$export(module.exports, "createStructuredSelector", () => $b1ad7e452c63f0bd$export$75979cfcd91bf38f);
$parcel$export(module.exports, "defaultMemoize", () => (parcelRequire("hWhND")).defaultMemoize);
$parcel$export(module.exports, "defaultEqualityCheck", () => (parcelRequire("hWhND")).defaultEqualityCheck);

var $hWhND = parcelRequire("hWhND");
function $b1ad7e452c63f0bd$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === "function";
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === "function" ? "function " + (dep.name || "unnamed") + "()" : typeof dep;
        }).join(", ");
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $b1ad7e452c63f0bd$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== "function") throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $b1ad7e452c63f0bd$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $b1ad7e452c63f0bd$export$595d22ed68ca2841 = /* #__PURE__ */ $b1ad7e452c63f0bd$export$5943f4447f6ef248((0, $hWhND.defaultMemoize));
var $b1ad7e452c63f0bd$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $b1ad7e452c63f0bd$export$595d22ed68ca2841;
    if (typeof selectors !== "object") throw new Error("createStructuredSelector expects first argument to be an object " + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};

});
parcelRegister("hWhND", function(module, exports) {

$parcel$export(module.exports, "defaultEqualityCheck", () => $d0f5a9172ce51191$export$e0b28855d0126ccc);
$parcel$export(module.exports, "defaultMemoize", () => $d0f5a9172ce51191$export$281bff7f05488aa2);
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $d0f5a9172ce51191$var$NOT_FOUND = "NOT_FOUND";
function $d0f5a9172ce51191$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $d0f5a9172ce51191$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $d0f5a9172ce51191$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $d0f5a9172ce51191$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $d0f5a9172ce51191$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $d0f5a9172ce51191$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $d0f5a9172ce51191$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $d0f5a9172ce51191$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $d0f5a9172ce51191$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $d0f5a9172ce51191$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $d0f5a9172ce51191$var$createSingletonCache(comparator) : $d0f5a9172ce51191$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $d0f5a9172ce51191$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}

});


parcelRegister("9QQqP", function(module, exports) {

$parcel$export(module.exports, "default", () => $72c1a4374d28d24c$export$2e2bcd8739ae039);
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $72c1a4374d28d24c$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === "function") // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $72c1a4374d28d24c$var$thunk = $72c1a4374d28d24c$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$72c1a4374d28d24c$var$thunk.withExtraArgument = $72c1a4374d28d24c$var$createThunkMiddleware;
var $72c1a4374d28d24c$export$2e2bcd8739ae039 = $72c1a4374d28d24c$var$thunk;

});

parcelRegister("fr0vp", function(module, exports) {
"use strict";

});


parcelRegister("kL91E", function(module, exports) {
var $f1cf32bbab6589f6$var$e, $f1cf32bbab6589f6$var$t, $f1cf32bbab6589f6$var$n = module.exports && module.exports.__generator || function(e, t) {
    var n, r, i, a, u = {
        label: 0,
        sent: function() {
            if (1 & i[0]) throw i[1];
            return i[1];
        },
        trys: [],
        ops: []
    };
    return a = {
        next: o(0),
        throw: o(1),
        return: o(2)
    }, "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function o(a) {
        return function(o) {
            return function(a) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; u;)try {
                    if (n = 1, r && (i = 2 & a[0] ? r.return : a[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, a[1])).done) return i;
                    switch(r = 0, i && (a = [
                        2 & a[0],
                        i.value
                    ]), a[0]){
                        case 0:
                        case 1:
                            i = a;
                            break;
                        case 4:
                            return u.label++, {
                                value: a[1],
                                done: !1
                            };
                        case 5:
                            u.label++, r = a[1], a = [
                                0
                            ];
                            continue;
                        case 7:
                            a = u.ops.pop(), u.trys.pop();
                            continue;
                        default:
                            if (!((i = (i = u.trys).length > 0 && i[i.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                                u = 0;
                                continue;
                            }
                            if (3 === a[0] && (!i || a[1] > i[0] && a[1] < i[3])) {
                                u.label = a[1];
                                break;
                            }
                            if (6 === a[0] && u.label < i[1]) {
                                u.label = i[1], i = a;
                                break;
                            }
                            if (i && u.label < i[2]) {
                                u.label = i[2], u.ops.push(a);
                                break;
                            }
                            i[2] && u.ops.pop(), u.trys.pop();
                            continue;
                    }
                    a = t.call(e, u);
                } catch (e) {
                    a = [
                        6,
                        e
                    ], r = 0;
                } finally{
                    n = i = 0;
                }
                if (5 & a[0]) throw a[1];
                return {
                    value: a[0] ? a[1] : void 0,
                    done: !0
                };
            }([
                a,
                o
            ]);
        };
    }
}, $f1cf32bbab6589f6$var$r = module.exports && module.exports.__spreadArray || function(e, t) {
    for(var n = 0, r = t.length, i = e.length; n < r; n++, i++)e[i] = t[n];
    return e;
}, $f1cf32bbab6589f6$var$i = Object.create, $f1cf32bbab6589f6$var$a = Object.defineProperty, $f1cf32bbab6589f6$var$u = Object.defineProperties, $f1cf32bbab6589f6$var$o = Object.getOwnPropertyDescriptor, $f1cf32bbab6589f6$var$s = Object.getOwnPropertyDescriptors, $f1cf32bbab6589f6$var$c = Object.getOwnPropertyNames, $f1cf32bbab6589f6$var$l = Object.getOwnPropertySymbols, $f1cf32bbab6589f6$var$d = Object.getPrototypeOf, $f1cf32bbab6589f6$var$f = Object.prototype.hasOwnProperty, $f1cf32bbab6589f6$var$p = Object.prototype.propertyIsEnumerable, $f1cf32bbab6589f6$var$h = function(e, t, n) {
    return t in e ? $f1cf32bbab6589f6$var$a(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
    }) : e[t] = n;
}, $f1cf32bbab6589f6$var$v = function(e, t) {
    for(var n in t || (t = {}))$f1cf32bbab6589f6$var$f.call(t, n) && $f1cf32bbab6589f6$var$h(e, n, t[n]);
    if ($f1cf32bbab6589f6$var$l) for(var r = 0, i = $f1cf32bbab6589f6$var$l(t); r < i.length; r++)$f1cf32bbab6589f6$var$p.call(t, n = i[r]) && $f1cf32bbab6589f6$var$h(e, n, t[n]);
    return e;
}, $f1cf32bbab6589f6$var$y = function(e, t) {
    return $f1cf32bbab6589f6$var$u(e, $f1cf32bbab6589f6$var$s(t));
}, $f1cf32bbab6589f6$var$m = function(e) {
    return $f1cf32bbab6589f6$var$a(e, "__esModule", {
        value: !0
    });
}, $f1cf32bbab6589f6$var$g = function(e, t) {
    var n = {};
    for(var r in e)$f1cf32bbab6589f6$var$f.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
    if (null != e && $f1cf32bbab6589f6$var$l) for(var i = 0, a = $f1cf32bbab6589f6$var$l(e); i < a.length; i++)t.indexOf(r = a[i]) < 0 && $f1cf32bbab6589f6$var$p.call(e, r) && (n[r] = e[r]);
    return n;
}, $f1cf32bbab6589f6$var$b = function(e) {
    return function(e, t, n) {
        if (t && "object" == typeof t || "function" == typeof t) for(var r = function(r) {
            $f1cf32bbab6589f6$var$f.call(e, r) || "default" === r || $f1cf32bbab6589f6$var$a(e, r, {
                get: function() {
                    return t[r];
                },
                enumerable: !(n = $f1cf32bbab6589f6$var$o(t, r)) || n.enumerable
            });
        }, i = 0, u = $f1cf32bbab6589f6$var$c(t); i < u.length; i++)r(u[i]);
        return e;
    }($f1cf32bbab6589f6$var$m($f1cf32bbab6589f6$var$a(null != e ? $f1cf32bbab6589f6$var$i($f1cf32bbab6589f6$var$d(e)) : {}, "default", e && e.__esModule && "default" in e ? {
        get: function() {
            return e.default;
        },
        enumerable: !0
    } : {
        value: e,
        enumerable: !0
    })), e);
}, $f1cf32bbab6589f6$var$q = function(e, t, n) {
    return new Promise(function(r, i) {
        var a = function(e) {
            try {
                o(n.next(e));
            } catch (e) {
                i(e);
            }
        }, u = function(e) {
            try {
                o(n.throw(e));
            } catch (e) {
                i(e);
            }
        }, o = function(e) {
            return e.done ? r(e.value) : Promise.resolve(e.value).then(a, u);
        };
        o((n = n.apply(e, t)).next());
    });
};
$f1cf32bbab6589f6$var$m(module.exports), function(e, t) {
    for(var n in t)$f1cf32bbab6589f6$var$a(e, n, {
        get: t[n],
        enumerable: !0
    });
}(module.exports, {
    QueryStatus: function() {
        return $f1cf32bbab6589f6$var$e;
    },
    buildCreateApi: function() {
        return $f1cf32bbab6589f6$var$ge;
    },
    copyWithStructuralSharing: function() {
        return $f1cf32bbab6589f6$var$A;
    },
    coreModule: function() {
        return $f1cf32bbab6589f6$var$Ee;
    },
    createApi: function() {
        return $f1cf32bbab6589f6$var$Ke;
    },
    defaultSerializeQueryArgs: function() {
        return $f1cf32bbab6589f6$var$ve;
    },
    fakeBaseQuery: function() {
        return $f1cf32bbab6589f6$var$be;
    },
    fetchBaseQuery: function() {
        return $f1cf32bbab6589f6$var$x;
    },
    retry: function() {
        return $f1cf32bbab6589f6$var$I;
    },
    setupListeners: function() {
        return $f1cf32bbab6589f6$var$F;
    },
    skipSelector: function() {
        return $f1cf32bbab6589f6$var$ce;
    },
    skipToken: function() {
        return $f1cf32bbab6589f6$var$se;
    }
}), ($f1cf32bbab6589f6$var$t = $f1cf32bbab6589f6$var$e || ($f1cf32bbab6589f6$var$e = {})).uninitialized = "uninitialized", $f1cf32bbab6589f6$var$t.pending = "pending", $f1cf32bbab6589f6$var$t.fulfilled = "fulfilled", $f1cf32bbab6589f6$var$t.rejected = "rejected";
var $f1cf32bbab6589f6$var$S = function(e) {
    return [].concat.apply([], e);
};

var $f1cf32bbab6589f6$var$O = $f1cf32bbab6589f6$var$b((parcelRequire("bEIGg"))).isPlainObject;
function $f1cf32bbab6589f6$var$A(e, t) {
    if (e === t || !($f1cf32bbab6589f6$var$O(e) && $f1cf32bbab6589f6$var$O(t) || Array.isArray(e) && Array.isArray(t))) return t;
    for(var n = Object.keys(t), r = Object.keys(e), i = n.length === r.length, a = Array.isArray(t) ? [] : {}, u = 0, o = n; u < o.length; u++){
        var s = o[u];
        a[s] = $f1cf32bbab6589f6$var$A(e[s], t[s]), i && (i = e[s] === a[s]);
    }
    return i ? e : a;
}

var $f1cf32bbab6589f6$var$T = $f1cf32bbab6589f6$var$b((parcelRequire("bEIGg"))), $f1cf32bbab6589f6$var$R = function() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    return fetch.apply(void 0, e);
}, $f1cf32bbab6589f6$var$j = function(e) {
    return e.status >= 200 && e.status <= 299;
}, $f1cf32bbab6589f6$var$w = function(e) {
    return /ion\/(vnd\.api\+)?json/.test(e.get("content-type") || "");
};
function $f1cf32bbab6589f6$var$k(e) {
    if (!(0, $f1cf32bbab6589f6$var$T.isPlainObject)(e)) return e;
    for(var t = $f1cf32bbab6589f6$var$v({}, e), n = 0, r = Object.entries(t); n < r.length; n++){
        var i = r[n];
        void 0 === i[1] && delete t[i[0]];
    }
    return t;
}
function $f1cf32bbab6589f6$var$x(e) {
    var t = this;
    void 0 === e && (e = {});
    var r = e.baseUrl, i = e.prepareHeaders, a = void 0 === i ? function(e) {
        return e;
    } : i, u = e.fetchFn, o = void 0 === u ? $f1cf32bbab6589f6$var$R : u, s = e.paramsSerializer, c = e.isJsonContentType, l = void 0 === c ? $f1cf32bbab6589f6$var$w : c, d = e.jsonContentType, f = void 0 === d ? "application/json" : d, p = e.jsonReplacer, h = e.timeout, m = e.responseHandler, b = e.validateStatus, S = $f1cf32bbab6589f6$var$g(e, [
        "baseUrl",
        "prepareHeaders",
        "fetchFn",
        "paramsSerializer",
        "isJsonContentType",
        "jsonContentType",
        "jsonReplacer",
        "timeout",
        "responseHandler",
        "validateStatus"
    ]);
    return "undefined" == typeof fetch && o === $f1cf32bbab6589f6$var$R && console.warn("Warning: `fetch` is not available. Please supply a custom `fetchFn` property to use `fetchBaseQuery` on SSR environments."), function(e, i) {
        return $f1cf32bbab6589f6$var$q(t, null, function() {
            var t, u, c, d, q, A, R, w, x, Q, P, C, I, M, D, N, E, K, _, F, z, U, L, W, H, B, J, V, G, Y, $, X, Z, ee, te, ne;
            return $f1cf32bbab6589f6$var$n(this, function(n) {
                switch(n.label){
                    case 0:
                        return t = i.signal, u = i.getState, c = i.extra, d = i.endpoint, q = i.forced, A = i.type, x = (w = "string" == typeof e ? {
                            url: e
                        } : e).url, P = void 0 === (Q = w.headers) ? new Headers(S.headers) : Q, I = void 0 === (C = w.params) ? void 0 : C, D = void 0 === (M = w.responseHandler) ? null != m ? m : "json" : M, E = void 0 === (N = w.validateStatus) ? null != b ? b : $f1cf32bbab6589f6$var$j : N, _ = void 0 === (K = w.timeout) ? h : K, F = $f1cf32bbab6589f6$var$g(w, [
                            "url",
                            "headers",
                            "params",
                            "responseHandler",
                            "validateStatus",
                            "timeout"
                        ]), z = $f1cf32bbab6589f6$var$v($f1cf32bbab6589f6$var$y($f1cf32bbab6589f6$var$v({}, S), {
                            signal: t
                        }), F), P = new Headers($f1cf32bbab6589f6$var$k(P)), U = z, [
                            4,
                            a(P, {
                                getState: u,
                                extra: c,
                                endpoint: d,
                                forced: q,
                                type: A
                            })
                        ];
                    case 1:
                        U.headers = n.sent() || P, L = function(e) {
                            return "object" == typeof e && ((0, $f1cf32bbab6589f6$var$T.isPlainObject)(e) || Array.isArray(e) || "function" == typeof e.toJSON);
                        }, !z.headers.has("content-type") && L(z.body) && z.headers.set("content-type", f), L(z.body) && l(z.headers) && (z.body = JSON.stringify(z.body, p)), I && (W = ~x.indexOf("?") ? "&" : "?", H = s ? s(I) : new URLSearchParams($f1cf32bbab6589f6$var$k(I)), x += W + H), x = function(e, t) {
                            if (!e) return t;
                            if (!t) return e;
                            if (function(e) {
                                return new RegExp("(^|:)//").test(e);
                            }(t)) return t;
                            var n = e.endsWith("/") || !t.startsWith("?") ? "/" : "";
                            return e = function(e) {
                                return e.replace(/\/$/, "");
                            }(e), "" + e + n + function(e) {
                                return e.replace(/^\//, "");
                            }(t);
                        }(r, x), B = new Request(x, z), J = B.clone(), R = {
                            request: J
                        }, G = !1, Y = _ && setTimeout(function() {
                            G = !0, i.abort();
                        }, _), n.label = 2;
                    case 2:
                        return n.trys.push([
                            2,
                            4,
                            5,
                            6
                        ]), [
                            4,
                            o(B)
                        ];
                    case 3:
                        return V = n.sent(), [
                            3,
                            6
                        ];
                    case 4:
                        return $ = n.sent(), [
                            2,
                            {
                                error: {
                                    status: G ? "TIMEOUT_ERROR" : "FETCH_ERROR",
                                    error: String($)
                                },
                                meta: R
                            }
                        ];
                    case 5:
                        return Y && clearTimeout(Y), [
                            7
                        ];
                    case 6:
                        X = V.clone(), R.response = X, ee = "", n.label = 7;
                    case 7:
                        return n.trys.push([
                            7,
                            9,
                            ,
                            10
                        ]), [
                            4,
                            Promise.all([
                                O(V, D).then(function(e) {
                                    return Z = e;
                                }, function(e) {
                                    return te = e;
                                }),
                                X.text().then(function(e) {
                                    return ee = e;
                                }, function() {})
                            ])
                        ];
                    case 8:
                        if (n.sent(), te) throw te;
                        return [
                            3,
                            10
                        ];
                    case 9:
                        return ne = n.sent(), [
                            2,
                            {
                                error: {
                                    status: "PARSING_ERROR",
                                    originalStatus: V.status,
                                    data: ee,
                                    error: String(ne)
                                },
                                meta: R
                            }
                        ];
                    case 10:
                        return [
                            2,
                            E(V, Z) ? {
                                data: Z,
                                meta: R
                            } : {
                                error: {
                                    status: V.status,
                                    data: Z
                                },
                                meta: R
                            }
                        ];
                }
            });
        });
    };
    function O(e, t) {
        return $f1cf32bbab6589f6$var$q(this, null, function() {
            var r;
            return $f1cf32bbab6589f6$var$n(this, function(n) {
                switch(n.label){
                    case 0:
                        return "function" == typeof t ? [
                            2,
                            t(e)
                        ] : ("content-type" === t && (t = l(e.headers) ? "json" : "text"), "json" !== t ? [
                            3,
                            2
                        ] : [
                            4,
                            e.text()
                        ]);
                    case 1:
                        return [
                            2,
                            (r = n.sent()).length ? JSON.parse(r) : null
                        ];
                    case 2:
                        return [
                            2,
                            e.text()
                        ];
                }
            });
        });
    }
}
var $f1cf32bbab6589f6$var$Q = function(e, t) {
    void 0 === t && (t = void 0), this.value = e, this.meta = t;
};
function $f1cf32bbab6589f6$var$P(e, t) {
    return void 0 === e && (e = 0), void 0 === t && (t = 5), $f1cf32bbab6589f6$var$q(this, null, function() {
        var r, i;
        return $f1cf32bbab6589f6$var$n(this, function(n) {
            switch(n.label){
                case 0:
                    return r = Math.min(e, t), i = ~~((Math.random() + .4) * (300 << r)), [
                        4,
                        new Promise(function(e) {
                            return setTimeout(function(t) {
                                return e(t);
                            }, i);
                        })
                    ];
                case 1:
                    return n.sent(), [
                        2
                    ];
            }
        });
    });
}
var $f1cf32bbab6589f6$var$C = {}, $f1cf32bbab6589f6$var$I = Object.assign(function(e, t) {
    return function(r, i, a) {
        return $f1cf32bbab6589f6$var$q(void 0, null, function() {
            var u, o, s, c, l, d, f;
            return $f1cf32bbab6589f6$var$n(this, function(n) {
                switch(n.label){
                    case 0:
                        u = [
                            5,
                            (t || $f1cf32bbab6589f6$var$C).maxRetries,
                            (a || $f1cf32bbab6589f6$var$C).maxRetries
                        ].filter(function(e) {
                            return void 0 !== e;
                        }), o = u.slice(-1)[0], s = function(e, t, n) {
                            return n.attempt <= o;
                        }, c = $f1cf32bbab6589f6$var$v($f1cf32bbab6589f6$var$v({
                            maxRetries: o,
                            backoff: $f1cf32bbab6589f6$var$P,
                            retryCondition: s
                        }, t), a), l = 0, n.label = 1;
                    case 1:
                        n.label = 2;
                    case 2:
                        return n.trys.push([
                            2,
                            4,
                            ,
                            6
                        ]), [
                            4,
                            e(r, i, a)
                        ];
                    case 3:
                        if ((d = n.sent()).error) throw new $f1cf32bbab6589f6$var$Q(d);
                        return [
                            2,
                            d
                        ];
                    case 4:
                        if (f = n.sent(), l++, f.throwImmediately) {
                            if (f instanceof $f1cf32bbab6589f6$var$Q) return [
                                2,
                                f.value
                            ];
                            throw f;
                        }
                        return f instanceof $f1cf32bbab6589f6$var$Q && !c.retryCondition(f.value.error, r, {
                            attempt: l,
                            baseQueryApi: i,
                            extraOptions: a
                        }) ? [
                            2,
                            f.value
                        ] : [
                            4,
                            c.backoff(l, c.maxRetries)
                        ];
                    case 5:
                        return n.sent(), [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            3,
                            1
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
    };
}, {
    fail: function(e) {
        throw Object.assign(new $f1cf32bbab6589f6$var$Q({
            error: e
        }), {
            throwImmediately: !0
        });
    }
});

var $f1cf32bbab6589f6$var$M = $f1cf32bbab6589f6$var$b((parcelRequire("bEIGg"))), $f1cf32bbab6589f6$var$D = (0, $f1cf32bbab6589f6$var$M.createAction)("__rtkq/focused"), $f1cf32bbab6589f6$var$N = (0, $f1cf32bbab6589f6$var$M.createAction)("__rtkq/unfocused"), $f1cf32bbab6589f6$var$E = (0, $f1cf32bbab6589f6$var$M.createAction)("__rtkq/online"), $f1cf32bbab6589f6$var$K = (0, $f1cf32bbab6589f6$var$M.createAction)("__rtkq/offline"), $f1cf32bbab6589f6$var$_ = !1;
function $f1cf32bbab6589f6$var$F(e, t) {
    var n, r, i, a;
    return t ? t(e, {
        onFocus: $f1cf32bbab6589f6$var$D,
        onFocusLost: $f1cf32bbab6589f6$var$N,
        onOffline: $f1cf32bbab6589f6$var$K,
        onOnline: $f1cf32bbab6589f6$var$E
    }) : (n = function() {
        return e($f1cf32bbab6589f6$var$D());
    }, r = function() {
        return e($f1cf32bbab6589f6$var$E());
    }, i = function() {
        return e($f1cf32bbab6589f6$var$K());
    }, a = function() {
        "visible" === window.document.visibilityState ? n() : e($f1cf32bbab6589f6$var$N());
    }, $f1cf32bbab6589f6$var$_ || "undefined" != typeof window && window.addEventListener && (window.addEventListener("visibilitychange", a, !1), window.addEventListener("focus", n, !1), window.addEventListener("online", r, !1), window.addEventListener("offline", i, !1), $f1cf32bbab6589f6$var$_ = !0), function() {
        window.removeEventListener("focus", n), window.removeEventListener("visibilitychange", a), window.removeEventListener("online", r), window.removeEventListener("offline", i), $f1cf32bbab6589f6$var$_ = !1;
    });
}
var $f1cf32bbab6589f6$var$z, $f1cf32bbab6589f6$var$U;

var $f1cf32bbab6589f6$var$L = $f1cf32bbab6589f6$var$b((parcelRequire("bEIGg")));
function $f1cf32bbab6589f6$var$W(e) {
    return e.type === $f1cf32bbab6589f6$var$z.query;
}
function $f1cf32bbab6589f6$var$H(e, t, n, r, i, a) {
    return "function" == typeof e ? e(t, n, r, i).map($f1cf32bbab6589f6$var$B).map(a) : Array.isArray(e) ? e.map($f1cf32bbab6589f6$var$B).map(a) : [];
}
function $f1cf32bbab6589f6$var$B(e) {
    return "string" == typeof e ? {
        type: e
    } : e;
}
($f1cf32bbab6589f6$var$U = $f1cf32bbab6589f6$var$z || ($f1cf32bbab6589f6$var$z = {})).query = "query", $f1cf32bbab6589f6$var$U.mutation = "mutation";

var $f1cf32bbab6589f6$var$J = $f1cf32bbab6589f6$var$b((parcelRequire("bEIGg")));
function $f1cf32bbab6589f6$var$V(e) {
    return null != e;
}
var $f1cf32bbab6589f6$var$G = Symbol("forceQueryFn"), $f1cf32bbab6589f6$var$Y = function(e) {
    return "function" == typeof e[$f1cf32bbab6589f6$var$G];
};

var $f1cf32bbab6589f6$var$$ = $f1cf32bbab6589f6$var$b((parcelRequire("bEIGg")));

var $f1cf32bbab6589f6$var$X = $f1cf32bbab6589f6$var$b((parcelRequire("jewWr")));

var $f1cf32bbab6589f6$var$Z = $f1cf32bbab6589f6$var$b((parcelRequire("bEIGg")));
function $f1cf32bbab6589f6$var$ee(e) {
    return e;
}
function $f1cf32bbab6589f6$var$te(e, t, n, r) {
    return $f1cf32bbab6589f6$var$H(n[e.meta.arg.endpointName][t], (0, $f1cf32bbab6589f6$var$$.isFulfilled)(e) ? e.payload : void 0, (0, $f1cf32bbab6589f6$var$$.isRejectedWithValue)(e) ? e.payload : void 0, e.meta.arg.originalArgs, "baseQueryMeta" in e.meta ? e.meta.baseQueryMeta : void 0, r);
}

var $f1cf32bbab6589f6$var$ne = $f1cf32bbab6589f6$var$b((parcelRequire("jewWr")));

var $f1cf32bbab6589f6$var$re = $f1cf32bbab6589f6$var$b((parcelRequire("jewWr")));
function $f1cf32bbab6589f6$var$ie(e, t, n) {
    var r = e[t];
    r && n(r);
}
function $f1cf32bbab6589f6$var$ae(e) {
    var t;
    return null != (t = "arg" in e ? e.arg.fixedCacheKey : e.fixedCacheKey) ? t : e.requestId;
}
function $f1cf32bbab6589f6$var$ue(e, t, n) {
    var r = e[$f1cf32bbab6589f6$var$ae(t)];
    r && n(r);
}
var $f1cf32bbab6589f6$var$oe = {}, $f1cf32bbab6589f6$var$se = Symbol.for("RTKQ/skipToken"), $f1cf32bbab6589f6$var$ce = $f1cf32bbab6589f6$var$se, $f1cf32bbab6589f6$var$le = {
    status: $f1cf32bbab6589f6$var$e.uninitialized
}, $f1cf32bbab6589f6$var$de = (0, $f1cf32bbab6589f6$var$L.createNextState)($f1cf32bbab6589f6$var$le, function() {}), $f1cf32bbab6589f6$var$fe = (0, $f1cf32bbab6589f6$var$L.createNextState)($f1cf32bbab6589f6$var$le, function() {});

var $f1cf32bbab6589f6$var$pe = $f1cf32bbab6589f6$var$b((parcelRequire("bEIGg"))), $f1cf32bbab6589f6$var$he = WeakMap ? new WeakMap : void 0, $f1cf32bbab6589f6$var$ve = function(e) {
    var t = e.endpointName, n = e.queryArgs, r = "", i = null == $f1cf32bbab6589f6$var$he ? void 0 : $f1cf32bbab6589f6$var$he.get(n);
    if ("string" == typeof i) r = i;
    else {
        var a = JSON.stringify(n, function(e, t) {
            return (0, $f1cf32bbab6589f6$var$pe.isPlainObject)(t) ? Object.keys(t).sort().reduce(function(e, n) {
                return e[n] = t[n], e;
            }, {}) : t;
        });
        (0, $f1cf32bbab6589f6$var$pe.isPlainObject)(n) && (null == $f1cf32bbab6589f6$var$he || $f1cf32bbab6589f6$var$he.set(n, a)), r = a;
    }
    return t + "(" + r + ")";
};

var $f1cf32bbab6589f6$var$ye = $f1cf32bbab6589f6$var$b((parcelRequire("bEIGg")));

var $f1cf32bbab6589f6$var$me = $f1cf32bbab6589f6$var$b((parcelRequire("ffM0i")));
function $f1cf32bbab6589f6$var$ge() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    return function(t) {
        var n = (0, $f1cf32bbab6589f6$var$me.defaultMemoize)(function(e) {
            var n, r;
            return null == (r = t.extractRehydrationInfo) ? void 0 : r.call(t, e, {
                reducerPath: null != (n = t.reducerPath) ? n : "api"
            });
        }), i = $f1cf32bbab6589f6$var$y($f1cf32bbab6589f6$var$v({
            reducerPath: "api",
            keepUnusedDataFor: 60,
            refetchOnMountOrArgChange: !1,
            refetchOnFocus: !1,
            refetchOnReconnect: !1
        }, t), {
            extractRehydrationInfo: n,
            serializeQueryArgs: function(e) {
                var n = $f1cf32bbab6589f6$var$ve;
                if ("serializeQueryArgs" in e.endpointDefinition) {
                    var r = e.endpointDefinition.serializeQueryArgs;
                    n = function(e) {
                        var t = r(e);
                        return "string" == typeof t ? t : $f1cf32bbab6589f6$var$ve($f1cf32bbab6589f6$var$y($f1cf32bbab6589f6$var$v({}, e), {
                            queryArgs: t
                        }));
                    };
                } else t.serializeQueryArgs && (n = t.serializeQueryArgs);
                return n(e);
            },
            tagTypes: $f1cf32bbab6589f6$var$r([], t.tagTypes || [])
        }), a = {
            endpointDefinitions: {},
            batch: function(e) {
                e();
            },
            apiUid: (0, $f1cf32bbab6589f6$var$ye.nanoid)(),
            extractRehydrationInfo: n,
            hasRehydrationInfo: (0, $f1cf32bbab6589f6$var$me.defaultMemoize)(function(e) {
                return null != n(e);
            })
        }, u = {
            injectEndpoints: function(e) {
                for(var t = e.endpoints({
                    query: function(e) {
                        return $f1cf32bbab6589f6$var$y($f1cf32bbab6589f6$var$v({}, e), {
                            type: $f1cf32bbab6589f6$var$z.query
                        });
                    },
                    mutation: function(e) {
                        return $f1cf32bbab6589f6$var$y($f1cf32bbab6589f6$var$v({}, e), {
                            type: $f1cf32bbab6589f6$var$z.mutation
                        });
                    }
                }), n = 0, r = Object.entries(t); n < r.length; n++){
                    var i = r[n], s = i[0], c = i[1];
                    if (e.overrideExisting || !(s in a.endpointDefinitions)) {
                        a.endpointDefinitions[s] = c;
                        for(var l = 0, d = o; l < d.length; l++)d[l].injectEndpoint(s, c);
                    }
                }
                return u;
            },
            enhanceEndpoints: function(e) {
                var t = e.addTagTypes, n = e.endpoints;
                if (t) for(var r = 0, o = t; r < o.length; r++){
                    var s = o[r];
                    i.tagTypes.includes(s) || i.tagTypes.push(s);
                }
                if (n) for(var c = 0, l = Object.entries(n); c < l.length; c++){
                    var d = l[c], f = d[0], p = d[1];
                    "function" == typeof p ? p(a.endpointDefinitions[f]) : Object.assign(a.endpointDefinitions[f] || {}, p);
                }
                return u;
            }
        }, o = e.map(function(e) {
            return e.init(u, i, a);
        });
        return u.injectEndpoints({
            endpoints: t.endpoints
        });
    };
}
function $f1cf32bbab6589f6$var$be() {
    return function() {
        throw new Error("When using `fakeBaseQuery`, all queries & mutations must use the `queryFn` definition syntax.");
    };
}
var $f1cf32bbab6589f6$var$qe;

var $f1cf32bbab6589f6$var$Se = $f1cf32bbab6589f6$var$b((parcelRequire("bEIGg"))), $f1cf32bbab6589f6$var$Oe = function(e) {
    var t = e.reducerPath, n = e.api, r = e.context, i = e.internalState, a = n.internalActions, u = a.removeQueryResult, o = a.unsubscribeQueryResult;
    function s(e) {
        var t = i.currentSubscriptions[e];
        return !!t && !function(e) {
            for(var t in e)return !1;
            return !0;
        }(t);
    }
    var c = {};
    function l(e, t, n, i) {
        var a, o = r.endpointDefinitions[t], l = null != (a = null == o ? void 0 : o.keepUnusedDataFor) ? a : i.keepUnusedDataFor;
        if (Infinity !== l) {
            var d = Math.max(0, Math.min(l, 2147482.647));
            if (!s(e)) {
                var f = c[e];
                f && clearTimeout(f), c[e] = setTimeout(function() {
                    s(e) || n.dispatch(u({
                        queryCacheKey: e
                    })), delete c[e];
                }, 1e3 * d);
            }
        }
    }
    return function(e, i, a) {
        var u;
        if (o.match(e)) {
            var s = i.getState()[t];
            l(b = e.payload.queryCacheKey, null == (u = s.queries[b]) ? void 0 : u.endpointName, i, s.config);
        }
        if (n.util.resetApiState.match(e)) for(var d = 0, f = Object.entries(c); d < f.length; d++){
            var p = f[d], h = p[0], v = p[1];
            v && clearTimeout(v), delete c[h];
        }
        if (r.hasRehydrationInfo(e)) {
            s = i.getState()[t];
            for(var y = r.extractRehydrationInfo(e).queries, m = 0, g = Object.entries(y); m < g.length; m++){
                var b, q = g[m], S = q[1];
                l(b = q[0], null == S ? void 0 : S.endpointName, i, s.config);
            }
        }
    };
};

var $f1cf32bbab6589f6$var$Ae = $f1cf32bbab6589f6$var$b((parcelRequire("bEIGg"))), $f1cf32bbab6589f6$var$Te = function(t) {
    var n = t.reducerPath, r = t.context, i = t.context.endpointDefinitions, a = t.mutationThunk, u = t.api, o = t.assertTagType, s = t.refetchQuery, c = u.internalActions.removeQueryResult, l = (0, $f1cf32bbab6589f6$var$Ae.isAnyOf)((0, $f1cf32bbab6589f6$var$Ae.isFulfilled)(a), (0, $f1cf32bbab6589f6$var$Ae.isRejectedWithValue)(a));
    function d(t, i) {
        var a = i.getState(), o = a[n], l = u.util.selectInvalidatedBy(a, t);
        r.batch(function() {
            for(var t, n = 0, r = Array.from(l.values()); n < r.length; n++){
                var a = r[n].queryCacheKey, u = o.queries[a], d = null != (t = o.subscriptions[a]) ? t : {};
                u && (0 === Object.keys(d).length ? i.dispatch(c({
                    queryCacheKey: a
                })) : u.status !== $f1cf32bbab6589f6$var$e.uninitialized && i.dispatch(s(u, a)));
            }
        });
    }
    return function(e, t) {
        l(e) && d($f1cf32bbab6589f6$var$te(e, "invalidatesTags", i, o), t), u.util.invalidateTags.match(e) && d($f1cf32bbab6589f6$var$H(e.payload, void 0, void 0, void 0, void 0, o), t);
    };
}, $f1cf32bbab6589f6$var$Re = function(t) {
    var n = t.reducerPath, r = t.queryThunk, i = t.api, a = t.refetchQuery, u = t.internalState, o = {};
    function s(t, r) {
        var i = t.queryCacheKey, s = r.getState()[n].queries[i];
        if (s && s.status !== $f1cf32bbab6589f6$var$e.uninitialized) {
            var c = d(u.currentSubscriptions[i]);
            if (Number.isFinite(c)) {
                var l = o[i];
                (null == l ? void 0 : l.timeout) && (clearTimeout(l.timeout), l.timeout = void 0);
                var f = Date.now() + c, p = o[i] = {
                    nextPollTimestamp: f,
                    pollingInterval: c,
                    timeout: setTimeout(function() {
                        p.timeout = void 0, r.dispatch(a(s, i));
                    }, c)
                };
            }
        }
    }
    function c(t, r) {
        var i = t.queryCacheKey, a = r.getState()[n].queries[i];
        if (a && a.status !== $f1cf32bbab6589f6$var$e.uninitialized) {
            var c = d(u.currentSubscriptions[i]);
            if (Number.isFinite(c)) {
                var f = o[i], p = Date.now() + c;
                (!f || p < f.nextPollTimestamp) && s({
                    queryCacheKey: i
                }, r);
            } else l(i);
        }
    }
    function l(e) {
        var t = o[e];
        (null == t ? void 0 : t.timeout) && clearTimeout(t.timeout), delete o[e];
    }
    function d(e) {
        void 0 === e && (e = {});
        var t = Number.POSITIVE_INFINITY;
        for(var n in e)e[n].pollingInterval && (t = Math.min(e[n].pollingInterval, t));
        return t;
    }
    return function(e, t) {
        (i.internalActions.updateSubscriptionOptions.match(e) || i.internalActions.unsubscribeQueryResult.match(e)) && c(e.payload, t), (r.pending.match(e) || r.rejected.match(e) && e.meta.condition) && c(e.meta.arg, t), (r.fulfilled.match(e) || r.rejected.match(e) && !e.meta.condition) && s(e.meta.arg, t), i.util.resetApiState.match(e) && function() {
            for(var e = 0, t = Object.keys(o); e < t.length; e++)l(t[e]);
        }();
    };
};

var $f1cf32bbab6589f6$var$je = $f1cf32bbab6589f6$var$b((parcelRequire("bEIGg"))), $f1cf32bbab6589f6$var$we = new Error("Promise never resolved before cacheEntryRemoved."), $f1cf32bbab6589f6$var$ke = function(e) {
    var t = e.api, n = e.reducerPath, r = e.context, i = e.queryThunk, a = e.mutationThunk, u = (0, $f1cf32bbab6589f6$var$je.isAsyncThunkAction)(i), o = (0, $f1cf32bbab6589f6$var$je.isAsyncThunkAction)(a), s = (0, $f1cf32bbab6589f6$var$je.isFulfilled)(i, a), c = {};
    function l(e, n, i, a, u) {
        var o = r.endpointDefinitions[e], s = null == o ? void 0 : o.onCacheEntryAdded;
        if (s) {
            var l = {}, d = new Promise(function(e) {
                l.cacheEntryRemoved = e;
            }), f = Promise.race([
                new Promise(function(e) {
                    l.valueResolved = e;
                }),
                d.then(function() {
                    throw $f1cf32bbab6589f6$var$we;
                })
            ]);
            f.catch(function() {}), c[i] = l;
            var p = t.endpoints[e].select(o.type === $f1cf32bbab6589f6$var$z.query ? n : i), h = a.dispatch(function(e, t, n) {
                return n;
            }), m = $f1cf32bbab6589f6$var$y($f1cf32bbab6589f6$var$v({}, a), {
                getCacheEntry: function() {
                    return p(a.getState());
                },
                requestId: u,
                extra: h,
                updateCachedData: o.type === $f1cf32bbab6589f6$var$z.query ? function(r) {
                    return a.dispatch(t.util.updateQueryData(e, n, r));
                } : void 0,
                cacheDataLoaded: f,
                cacheEntryRemoved: d
            }), g = s(n, m);
            Promise.resolve(g).catch(function(e) {
                if (e !== $f1cf32bbab6589f6$var$we) throw e;
            });
        }
    }
    return function(e, r, d) {
        var f = function(e) {
            return u(e) ? e.meta.arg.queryCacheKey : o(e) ? e.meta.requestId : t.internalActions.removeQueryResult.match(e) ? e.payload.queryCacheKey : t.internalActions.removeMutationResult.match(e) ? $f1cf32bbab6589f6$var$ae(e.payload) : "";
        }(e);
        if (i.pending.match(e)) {
            var p = d[n].queries[f], h = r.getState()[n].queries[f];
            !p && h && l(e.meta.arg.endpointName, e.meta.arg.originalArgs, f, r, e.meta.requestId);
        } else if (a.pending.match(e)) (h = r.getState()[n].mutations[f]) && l(e.meta.arg.endpointName, e.meta.arg.originalArgs, f, r, e.meta.requestId);
        else if (s(e)) (null == (g = c[f]) ? void 0 : g.valueResolved) && (g.valueResolved({
            data: e.payload,
            meta: e.meta.baseQueryMeta
        }), delete g.valueResolved);
        else if (t.internalActions.removeQueryResult.match(e) || t.internalActions.removeMutationResult.match(e)) (g = c[f]) && (delete c[f], g.cacheEntryRemoved());
        else if (t.util.resetApiState.match(e)) for(var v = 0, y = Object.entries(c); v < y.length; v++){
            var m = y[v], g = m[1];
            delete c[m[0]], g.cacheEntryRemoved();
        }
    };
};

var $f1cf32bbab6589f6$var$xe = $f1cf32bbab6589f6$var$b((parcelRequire("bEIGg"))), $f1cf32bbab6589f6$var$Qe = function(e) {
    var t = e.api, n = e.context, r = e.queryThunk, i = e.mutationThunk, a = (0, $f1cf32bbab6589f6$var$xe.isPending)(r, i), u = (0, $f1cf32bbab6589f6$var$xe.isRejected)(r, i), o = (0, $f1cf32bbab6589f6$var$xe.isFulfilled)(r, i), s = {};
    return function(e, r) {
        var i, c, l;
        if (a(e)) {
            var d = e.meta, f = d.requestId, p = d.arg, h = p.endpointName, m = p.originalArgs, g = n.endpointDefinitions[h], b = null == g ? void 0 : g.onQueryStarted;
            if (b) {
                var q = {}, S = new Promise(function(e, t) {
                    q.resolve = e, q.reject = t;
                });
                S.catch(function() {}), s[f] = q;
                var O = t.endpoints[h].select(g.type === $f1cf32bbab6589f6$var$z.query ? m : f), A = r.dispatch(function(e, t, n) {
                    return n;
                }), T = $f1cf32bbab6589f6$var$y($f1cf32bbab6589f6$var$v({}, r), {
                    getCacheEntry: function() {
                        return O(r.getState());
                    },
                    requestId: f,
                    extra: A,
                    updateCachedData: g.type === $f1cf32bbab6589f6$var$z.query ? function(e) {
                        return r.dispatch(t.util.updateQueryData(h, m, e));
                    } : void 0,
                    queryFulfilled: S
                });
                b(m, T);
            }
        } else if (o(e)) {
            var R = e.meta, j = R.baseQueryMeta;
            null == (i = s[f = R.requestId]) || i.resolve({
                data: e.payload,
                meta: j
            }), delete s[f];
        } else if (u(e)) {
            var w = e.meta;
            j = w.baseQueryMeta, null == (l = s[f = w.requestId]) || l.reject({
                error: null != (c = e.payload) ? c : e.error,
                isUnhandledError: !w.rejectedWithValue,
                meta: j
            }), delete s[f];
        }
    };
}, $f1cf32bbab6589f6$var$Pe = function(e) {
    var t = e.api, n = e.context.apiUid;
    return function(e, r) {
        t.util.resetApiState.match(e) && r.dispatch(t.internalActions.middlewareRegistered(n));
    };
};

var $f1cf32bbab6589f6$var$Ce = $f1cf32bbab6589f6$var$b((parcelRequire("jewWr"))), $f1cf32bbab6589f6$var$Ie = "function" == typeof queueMicrotask ? queueMicrotask.bind("undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : globalThis) : function(e) {
    return ($f1cf32bbab6589f6$var$qe || ($f1cf32bbab6589f6$var$qe = Promise.resolve())).then(e).catch(function(e) {
        return setTimeout(function() {
            throw e;
        }, 0);
    });
};
function $f1cf32bbab6589f6$var$Me(e) {
    for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
    Object.assign.apply(Object, $f1cf32bbab6589f6$var$r([
        e
    ], t));
}

var $f1cf32bbab6589f6$var$De = $f1cf32bbab6589f6$var$b((parcelRequire("jewWr"))), $f1cf32bbab6589f6$var$Ne = Symbol(), $f1cf32bbab6589f6$var$Ee = function() {
    return {
        name: $f1cf32bbab6589f6$var$Ne,
        init: function(t, i, a) {
            var u = i.baseQuery, o = i.reducerPath, s = i.serializeQueryArgs, c = i.keepUnusedDataFor, l = i.refetchOnMountOrArgChange, d = i.refetchOnFocus, f = i.refetchOnReconnect;
            (0, $f1cf32bbab6589f6$var$De.enablePatches)();
            var p = function(e) {
                return e;
            };
            Object.assign(t, {
                reducerPath: o,
                endpoints: {},
                internalActions: {
                    onOnline: $f1cf32bbab6589f6$var$E,
                    onOffline: $f1cf32bbab6589f6$var$K,
                    onFocus: $f1cf32bbab6589f6$var$D,
                    onFocusLost: $f1cf32bbab6589f6$var$N
                },
                util: {}
            });
            var h = function(t) {
                var r = this, i = t.reducerPath, a = t.baseQuery, u = t.context.endpointDefinitions, o = t.serializeQueryArgs, s = t.api, c = function(e, t) {
                    return $f1cf32bbab6589f6$var$q(r, [
                        e,
                        t
                    ], function(e, t) {
                        var r, i, o, s, c, d, f, p, h, v, y, m, g, b = t.signal, q = t.abort, S = t.rejectWithValue, O = t.fulfillWithValue, A = t.dispatch, T = t.getState, R = t.extra;
                        return $f1cf32bbab6589f6$var$n(this, function(t) {
                            switch(t.label){
                                case 0:
                                    r = u[e.endpointName], t.label = 1;
                                case 1:
                                    return t.trys.push([
                                        1,
                                        8,
                                        ,
                                        13
                                    ]), i = $f1cf32bbab6589f6$var$ee, o = void 0, s = {
                                        signal: b,
                                        abort: q,
                                        dispatch: A,
                                        getState: T,
                                        extra: R,
                                        endpoint: e.endpointName,
                                        type: e.type,
                                        forced: "query" === e.type ? l(e, T()) : void 0
                                    }, (c = "query" === e.type ? e[$f1cf32bbab6589f6$var$G] : void 0) ? (o = c(), [
                                        3,
                                        6
                                    ]) : [
                                        3,
                                        2
                                    ];
                                case 2:
                                    return r.query ? [
                                        4,
                                        a(r.query(e.originalArgs), s, r.extraOptions)
                                    ] : [
                                        3,
                                        4
                                    ];
                                case 3:
                                    return o = t.sent(), r.transformResponse && (i = r.transformResponse), [
                                        3,
                                        6
                                    ];
                                case 4:
                                    return [
                                        4,
                                        r.queryFn(e.originalArgs, s, r.extraOptions, function(e) {
                                            return a(e, s, r.extraOptions);
                                        })
                                    ];
                                case 5:
                                    o = t.sent(), t.label = 6;
                                case 6:
                                    if (o.error) throw new $f1cf32bbab6589f6$var$Q(o.error, o.meta);
                                    return d = O, [
                                        4,
                                        i(o.data, o.meta, e.originalArgs)
                                    ];
                                case 7:
                                    return [
                                        2,
                                        d.apply(void 0, [
                                            t.sent(),
                                            (m = {
                                                fulfilledTimeStamp: Date.now(),
                                                baseQueryMeta: o.meta
                                            }, m[$f1cf32bbab6589f6$var$Z.SHOULD_AUTOBATCH] = !0, m)
                                        ])
                                    ];
                                case 8:
                                    if (f = t.sent(), !((p = f) instanceof $f1cf32bbab6589f6$var$Q)) return [
                                        3,
                                        12
                                    ];
                                    h = $f1cf32bbab6589f6$var$ee, r.query && r.transformErrorResponse && (h = r.transformErrorResponse), t.label = 9;
                                case 9:
                                    return t.trys.push([
                                        9,
                                        11,
                                        ,
                                        12
                                    ]), v = S, [
                                        4,
                                        h(p.value, p.meta, e.originalArgs)
                                    ];
                                case 10:
                                    return [
                                        2,
                                        v.apply(void 0, [
                                            t.sent(),
                                            (g = {
                                                baseQueryMeta: p.meta
                                            }, g[$f1cf32bbab6589f6$var$Z.SHOULD_AUTOBATCH] = !0, g)
                                        ])
                                    ];
                                case 11:
                                    return y = t.sent(), p = y, [
                                        3,
                                        12
                                    ];
                                case 12:
                                    throw console.error(p), p;
                                case 13:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                };
                function l(e, t) {
                    var n, r, a, u, o = null == (r = null == (n = t[i]) ? void 0 : n.queries) ? void 0 : r[e.queryCacheKey], s = null == (a = t[i]) ? void 0 : a.config.refetchOnMountOrArgChange, c = null == o ? void 0 : o.fulfilledTimeStamp, l = null != (u = e.forceRefetch) ? u : e.subscribe && s;
                    return !!l && (!0 === l || (Number(new Date) - Number(c)) / 1e3 >= l);
                }
                var d = (0, $f1cf32bbab6589f6$var$Z.createAsyncThunk)(i + "/executeQuery", c, {
                    getPendingMeta: function() {
                        var e;
                        return (e = {
                            startedTimeStamp: Date.now()
                        })[$f1cf32bbab6589f6$var$Z.SHOULD_AUTOBATCH] = !0, e;
                    },
                    condition: function(e, t) {
                        var n, r, a, o = (0, t.getState)(), s = null == (r = null == (n = o[i]) ? void 0 : n.queries) ? void 0 : r[e.queryCacheKey], c = null == s ? void 0 : s.fulfilledTimeStamp, d = e.originalArgs, f = null == s ? void 0 : s.originalArgs, p = u[e.endpointName];
                        return !(!$f1cf32bbab6589f6$var$Y(e) && ("pending" === (null == s ? void 0 : s.status) || !l(e, o) && (!$f1cf32bbab6589f6$var$W(p) || !(null == (a = null == p ? void 0 : p.forceRefetch) ? void 0 : a.call(p, {
                            currentArg: d,
                            previousArg: f,
                            endpointState: s,
                            state: o
                        }))) && c));
                    },
                    dispatchConditionRejection: !0
                }), f = (0, $f1cf32bbab6589f6$var$Z.createAsyncThunk)(i + "/executeMutation", c, {
                    getPendingMeta: function() {
                        var e;
                        return (e = {
                            startedTimeStamp: Date.now()
                        })[$f1cf32bbab6589f6$var$Z.SHOULD_AUTOBATCH] = !0, e;
                    }
                });
                function p(e) {
                    return function(t) {
                        var n, r;
                        return (null == (r = null == (n = null == t ? void 0 : t.meta) ? void 0 : n.arg) ? void 0 : r.endpointName) === e;
                    };
                }
                return {
                    queryThunk: d,
                    mutationThunk: f,
                    prefetch: function(e, t, n) {
                        return function(r, i) {
                            var a = function(e) {
                                return "force" in e;
                            }(n) && n.force, u = function(e) {
                                return "ifOlderThan" in e;
                            }(n) && n.ifOlderThan, o = function(n) {
                                return void 0 === n && (n = !0), s.endpoints[e].initiate(t, {
                                    forceRefetch: n
                                });
                            }, c = s.endpoints[e].select(t)(i());
                            if (a) r(o());
                            else if (u) {
                                var l = null == c ? void 0 : c.fulfilledTimeStamp;
                                if (!l) return void r(o());
                                (Number(new Date) - Number(new Date(l))) / 1e3 >= u && r(o());
                            } else r(o(!1));
                        };
                    },
                    updateQueryData: function(t, n, r) {
                        return function(i, a) {
                            var u, o, c = s.endpoints[t].select(n)(a()), l = {
                                patches: [],
                                inversePatches: [],
                                undo: function() {
                                    return i(s.util.patchQueryData(t, n, l.inversePatches));
                                }
                            };
                            if (c.status === $f1cf32bbab6589f6$var$e.uninitialized) return l;
                            if ("data" in c) {
                                if ((0, $f1cf32bbab6589f6$var$X.isDraftable)(c.data)) {
                                    var d = (0, $f1cf32bbab6589f6$var$X.produceWithPatches)(c.data, r), f = d[2];
                                    (u = l.patches).push.apply(u, d[1]), (o = l.inversePatches).push.apply(o, f);
                                } else {
                                    var p = r(c.data);
                                    l.patches.push({
                                        op: "replace",
                                        path: [],
                                        value: p
                                    }), l.inversePatches.push({
                                        op: "replace",
                                        path: [],
                                        value: c.data
                                    });
                                }
                            }
                            return i(s.util.patchQueryData(t, n, l.patches)), l;
                        };
                    },
                    upsertQueryData: function(e, t, n) {
                        return function(r) {
                            var i;
                            return r(s.endpoints[e].initiate(t, ((i = {
                                subscribe: !1,
                                forceRefetch: !0
                            })[$f1cf32bbab6589f6$var$G] = function() {
                                return {
                                    data: n
                                };
                            }, i)));
                        };
                    },
                    patchQueryData: function(e, t, n) {
                        return function(r) {
                            r(s.internalActions.queryResultPatched({
                                queryCacheKey: o({
                                    queryArgs: t,
                                    endpointDefinition: u[e],
                                    endpointName: e
                                }),
                                patches: n
                            }));
                        };
                    },
                    buildMatchThunkActions: function(e, t) {
                        return {
                            matchPending: (0, $f1cf32bbab6589f6$var$$.isAllOf)((0, $f1cf32bbab6589f6$var$$.isPending)(e), p(t)),
                            matchFulfilled: (0, $f1cf32bbab6589f6$var$$.isAllOf)((0, $f1cf32bbab6589f6$var$$.isFulfilled)(e), p(t)),
                            matchRejected: (0, $f1cf32bbab6589f6$var$$.isAllOf)((0, $f1cf32bbab6589f6$var$$.isRejected)(e), p(t))
                        };
                    }
                };
            }({
                baseQuery: u,
                reducerPath: o,
                context: a,
                api: t,
                serializeQueryArgs: s
            }), m = h.queryThunk, g = h.mutationThunk, b = h.patchQueryData, O = h.updateQueryData, T = h.upsertQueryData, R = h.prefetch, j = h.buildMatchThunkActions, w = function(t) {
                var n = t.reducerPath, r = t.queryThunk, i = t.mutationThunk, a = t.context, u = a.endpointDefinitions, o = a.apiUid, s = a.extractRehydrationInfo, c = a.hasRehydrationInfo, l = t.assertTagType, d = t.config, f = (0, $f1cf32bbab6589f6$var$J.createAction)(n + "/resetApiState"), p = (0, $f1cf32bbab6589f6$var$J.createSlice)({
                    name: n + "/queries",
                    initialState: $f1cf32bbab6589f6$var$oe,
                    reducers: {
                        removeQueryResult: {
                            reducer: function(e, t) {
                                delete e[t.payload.queryCacheKey];
                            },
                            prepare: (0, $f1cf32bbab6589f6$var$J.prepareAutoBatched)()
                        },
                        queryResultPatched: function(e, t) {
                            var n = t.payload, r = n.patches;
                            $f1cf32bbab6589f6$var$ie(e, n.queryCacheKey, function(e) {
                                e.data = (0, $f1cf32bbab6589f6$var$re.applyPatches)(e.data, r.concat());
                            });
                        }
                    },
                    extraReducers: function(t) {
                        t.addCase(r.pending, function(t, n) {
                            var r, i = n.meta, a = n.meta.arg, u = $f1cf32bbab6589f6$var$Y(a);
                            (a.subscribe || u) && (null != t[r = a.queryCacheKey] || (t[r] = {
                                status: $f1cf32bbab6589f6$var$e.uninitialized,
                                endpointName: a.endpointName
                            })), $f1cf32bbab6589f6$var$ie(t, a.queryCacheKey, function(t) {
                                t.status = $f1cf32bbab6589f6$var$e.pending, t.requestId = u && t.requestId ? t.requestId : i.requestId, void 0 !== a.originalArgs && (t.originalArgs = a.originalArgs), t.startedTimeStamp = i.startedTimeStamp;
                            });
                        }).addCase(r.fulfilled, function(t, n) {
                            var r = n.meta, i = n.payload;
                            $f1cf32bbab6589f6$var$ie(t, r.arg.queryCacheKey, function(t) {
                                var n;
                                if (t.requestId === r.requestId || $f1cf32bbab6589f6$var$Y(r.arg)) {
                                    var a = u[r.arg.endpointName].merge;
                                    if (t.status = $f1cf32bbab6589f6$var$e.fulfilled, a) {
                                        if (void 0 !== t.data) {
                                            var o = r.fulfilledTimeStamp, s = r.arg, c = r.baseQueryMeta, l = r.requestId, d = (0, $f1cf32bbab6589f6$var$J.createNextState)(t.data, function(e) {
                                                return a(e, i, {
                                                    arg: s.originalArgs,
                                                    baseQueryMeta: c,
                                                    fulfilledTimeStamp: o,
                                                    requestId: l
                                                });
                                            });
                                            t.data = d;
                                        } else t.data = i;
                                    } else t.data = null == (n = u[r.arg.endpointName].structuralSharing) || n ? $f1cf32bbab6589f6$var$A((0, $f1cf32bbab6589f6$var$ne.isDraft)(t.data) ? (0, $f1cf32bbab6589f6$var$re.original)(t.data) : t.data, i) : i;
                                    delete t.error, t.fulfilledTimeStamp = r.fulfilledTimeStamp;
                                }
                            });
                        }).addCase(r.rejected, function(t, n) {
                            var r = n.meta, i = r.condition, a = r.requestId, u = n.error, o = n.payload;
                            $f1cf32bbab6589f6$var$ie(t, r.arg.queryCacheKey, function(t) {
                                if (i) ;
                                else {
                                    if (t.requestId !== a) return;
                                    t.status = $f1cf32bbab6589f6$var$e.rejected, t.error = null != o ? o : u;
                                }
                            });
                        }).addMatcher(c, function(t, n) {
                            for(var r = s(n).queries, i = 0, a = Object.entries(r); i < a.length; i++){
                                var u = a[i], o = u[1];
                                (null == o ? void 0 : o.status) !== $f1cf32bbab6589f6$var$e.fulfilled && (null == o ? void 0 : o.status) !== $f1cf32bbab6589f6$var$e.rejected || (t[u[0]] = o);
                            }
                        });
                    }
                }), h = (0, $f1cf32bbab6589f6$var$J.createSlice)({
                    name: n + "/mutations",
                    initialState: $f1cf32bbab6589f6$var$oe,
                    reducers: {
                        removeMutationResult: {
                            reducer: function(e, t) {
                                var n = $f1cf32bbab6589f6$var$ae(t.payload);
                                n in e && delete e[n];
                            },
                            prepare: (0, $f1cf32bbab6589f6$var$J.prepareAutoBatched)()
                        }
                    },
                    extraReducers: function(t) {
                        t.addCase(i.pending, function(t, n) {
                            var r = n.meta, i = r.requestId, a = r.arg, u = r.startedTimeStamp;
                            a.track && (t[$f1cf32bbab6589f6$var$ae(n.meta)] = {
                                requestId: i,
                                status: $f1cf32bbab6589f6$var$e.pending,
                                endpointName: a.endpointName,
                                startedTimeStamp: u
                            });
                        }).addCase(i.fulfilled, function(t, n) {
                            var r = n.payload, i = n.meta;
                            i.arg.track && $f1cf32bbab6589f6$var$ue(t, i, function(t) {
                                t.requestId === i.requestId && (t.status = $f1cf32bbab6589f6$var$e.fulfilled, t.data = r, t.fulfilledTimeStamp = i.fulfilledTimeStamp);
                            });
                        }).addCase(i.rejected, function(t, n) {
                            var r = n.payload, i = n.error, a = n.meta;
                            a.arg.track && $f1cf32bbab6589f6$var$ue(t, a, function(t) {
                                t.requestId === a.requestId && (t.status = $f1cf32bbab6589f6$var$e.rejected, t.error = null != r ? r : i);
                            });
                        }).addMatcher(c, function(t, n) {
                            for(var r = s(n).mutations, i = 0, a = Object.entries(r); i < a.length; i++){
                                var u = a[i], o = u[0], c = u[1];
                                (null == c ? void 0 : c.status) !== $f1cf32bbab6589f6$var$e.fulfilled && (null == c ? void 0 : c.status) !== $f1cf32bbab6589f6$var$e.rejected || o === (null == c ? void 0 : c.requestId) || (t[o] = c);
                            }
                        });
                    }
                }), m = (0, $f1cf32bbab6589f6$var$J.createSlice)({
                    name: n + "/invalidation",
                    initialState: $f1cf32bbab6589f6$var$oe,
                    reducers: {},
                    extraReducers: function(e) {
                        e.addCase(p.actions.removeQueryResult, function(e, t) {
                            for(var n = t.payload.queryCacheKey, r = 0, i = Object.values(e); r < i.length; r++)for(var a = 0, u = Object.values(i[r]); a < u.length; a++){
                                var o = u[a], s = o.indexOf(n);
                                -1 !== s && o.splice(s, 1);
                            }
                        }).addMatcher(c, function(e, t) {
                            for(var n, r, i, a, u = s(t).provided, o = 0, c = Object.entries(u); o < c.length; o++)for(var l = c[o], d = l[0], f = 0, p = Object.entries(l[1]); f < p.length; f++)for(var h = p[f], v = h[0], y = h[1], m = null != (a = (r = null != (n = e[d]) ? n : e[d] = {})[i = v || "__internal_without_id"]) ? a : r[i] = [], g = 0, b = y; g < b.length; g++){
                                var q = b[g];
                                m.includes(q) || m.push(q);
                            }
                        }).addMatcher((0, $f1cf32bbab6589f6$var$J.isAnyOf)((0, $f1cf32bbab6589f6$var$J.isFulfilled)(r), (0, $f1cf32bbab6589f6$var$J.isRejectedWithValue)(r)), function(e, t) {
                            for(var n, r, i, a, o = $f1cf32bbab6589f6$var$te(t, "providesTags", u, l), s = t.meta.arg.queryCacheKey, c = 0, d = Object.values(e); c < d.length; c++)for(var f = 0, p = Object.values(d[c]); f < p.length; f++){
                                var h = p[f], v = h.indexOf(s);
                                -1 !== v && h.splice(v, 1);
                            }
                            for(var y = 0, m = o; y < m.length; y++){
                                var g = m[y], b = g.type, q = g.id, S = null != (a = (r = null != (n = e[b]) ? n : e[b] = {})[i = q || "__internal_without_id"]) ? a : r[i] = [];
                                S.includes(s) || S.push(s);
                            }
                        });
                    }
                }), g = (0, $f1cf32bbab6589f6$var$J.createSlice)({
                    name: n + "/subscriptions",
                    initialState: $f1cf32bbab6589f6$var$oe,
                    reducers: {
                        updateSubscriptionOptions: function(e, t) {},
                        unsubscribeQueryResult: function(e, t) {},
                        internal_probeSubscription: function(e, t) {}
                    }
                }), b = (0, $f1cf32bbab6589f6$var$J.createSlice)({
                    name: n + "/internalSubscriptions",
                    initialState: $f1cf32bbab6589f6$var$oe,
                    reducers: {
                        subscriptionsUpdated: {
                            reducer: function(e, t) {
                                return (0, $f1cf32bbab6589f6$var$re.applyPatches)(e, t.payload);
                            },
                            prepare: (0, $f1cf32bbab6589f6$var$J.prepareAutoBatched)()
                        }
                    }
                }), q = (0, $f1cf32bbab6589f6$var$J.createSlice)({
                    name: n + "/config",
                    initialState: $f1cf32bbab6589f6$var$v({
                        online: "undefined" == typeof navigator || void 0 === navigator.onLine || navigator.onLine,
                        focused: "undefined" == typeof document || "hidden" !== document.visibilityState,
                        middlewareRegistered: !1
                    }, d),
                    reducers: {
                        middlewareRegistered: function(e, t) {
                            e.middlewareRegistered = "conflict" !== e.middlewareRegistered && o === t.payload || "conflict";
                        }
                    },
                    extraReducers: function(e) {
                        e.addCase($f1cf32bbab6589f6$var$E, function(e) {
                            e.online = !0;
                        }).addCase($f1cf32bbab6589f6$var$K, function(e) {
                            e.online = !1;
                        }).addCase($f1cf32bbab6589f6$var$D, function(e) {
                            e.focused = !0;
                        }).addCase($f1cf32bbab6589f6$var$N, function(e) {
                            e.focused = !1;
                        }).addMatcher(c, function(e) {
                            return $f1cf32bbab6589f6$var$v({}, e);
                        });
                    }
                }), S = (0, $f1cf32bbab6589f6$var$J.combineReducers)({
                    queries: p.reducer,
                    mutations: h.reducer,
                    provided: m.reducer,
                    subscriptions: b.reducer,
                    config: q.reducer
                });
                return {
                    reducer: function(e, t) {
                        return S(f.match(t) ? void 0 : e, t);
                    },
                    actions: $f1cf32bbab6589f6$var$y($f1cf32bbab6589f6$var$v($f1cf32bbab6589f6$var$v($f1cf32bbab6589f6$var$v($f1cf32bbab6589f6$var$v($f1cf32bbab6589f6$var$v({}, q.actions), p.actions), g.actions), b.actions), h.actions), {
                        unsubscribeMutationResult: h.actions.removeMutationResult,
                        resetApiState: f
                    })
                };
            }({
                context: a,
                queryThunk: m,
                mutationThunk: g,
                reducerPath: o,
                assertTagType: p,
                config: {
                    refetchOnFocus: d,
                    refetchOnReconnect: f,
                    refetchOnMountOrArgChange: l,
                    keepUnusedDataFor: c,
                    reducerPath: o
                }
            }), k = w.reducer, x = w.actions;
            $f1cf32bbab6589f6$var$Me(t.util, {
                patchQueryData: b,
                updateQueryData: O,
                upsertQueryData: T,
                prefetch: R,
                resetApiState: x.resetApiState
            }), $f1cf32bbab6589f6$var$Me(t.internalActions, x);
            var P = function(t) {
                var n = t.reducerPath, r = t.queryThunk, i = t.api, a = t.context, u = a.apiUid, o = {
                    invalidateTags: (0, $f1cf32bbab6589f6$var$Se.createAction)(n + "/invalidateTags")
                }, s = [
                    $f1cf32bbab6589f6$var$Pe,
                    $f1cf32bbab6589f6$var$Oe,
                    $f1cf32bbab6589f6$var$Te,
                    $f1cf32bbab6589f6$var$Re,
                    $f1cf32bbab6589f6$var$ke,
                    $f1cf32bbab6589f6$var$Qe
                ];
                return {
                    middleware: function(r) {
                        var o = !1, l = $f1cf32bbab6589f6$var$y($f1cf32bbab6589f6$var$v({}, t), {
                            internalState: {
                                currentSubscriptions: {}
                            },
                            refetchQuery: c
                        }), d = s.map(function(e) {
                            return e(l);
                        }), f = function(e) {
                            var t = e.api, n = e.queryThunk, r = e.internalState, i = t.reducerPath + "/subscriptions", a = null, u = !1, o = t.internalActions, s = o.updateSubscriptionOptions, c = o.unsubscribeQueryResult;
                            return function(e, o) {
                                var l, d;
                                if (a || (a = JSON.parse(JSON.stringify(r.currentSubscriptions))), t.util.resetApiState.match(e)) return a = r.currentSubscriptions = {}, [
                                    !0,
                                    !1
                                ];
                                if (t.internalActions.internal_probeSubscription.match(e)) {
                                    var f = e.payload;
                                    return [
                                        !1,
                                        !!(null == (l = r.currentSubscriptions[f.queryCacheKey]) ? void 0 : l[f.requestId])
                                    ];
                                }
                                var p = function(e, r) {
                                    var i, a, u, o, l, d, f, p, h;
                                    if (s.match(r)) {
                                        var v = r.payload, y = v.queryCacheKey, m = v.requestId;
                                        return (null == (i = null == e ? void 0 : e[y]) ? void 0 : i[m]) && (e[y][m] = v.options), !0;
                                    }
                                    if (c.match(r)) {
                                        var g = r.payload;
                                        return m = g.requestId, e[y = g.queryCacheKey] && delete e[y][m], !0;
                                    }
                                    if (t.internalActions.removeQueryResult.match(r)) return delete e[r.payload.queryCacheKey], !0;
                                    if (n.pending.match(r)) {
                                        var b = r.meta;
                                        if (m = b.requestId, (O = b.arg).subscribe) return (q = null != (u = e[a = O.queryCacheKey]) ? u : e[a] = {})[m] = null != (l = null != (o = O.subscriptionOptions) ? o : q[m]) ? l : {}, !0;
                                    }
                                    if (n.rejected.match(r)) {
                                        var q, S = r.meta, O = S.arg;
                                        if (m = S.requestId, S.condition && O.subscribe) return (q = null != (f = e[d = O.queryCacheKey]) ? f : e[d] = {})[m] = null != (h = null != (p = O.subscriptionOptions) ? p : q[m]) ? h : {}, !0;
                                    }
                                    return !1;
                                }(r.currentSubscriptions, e);
                                if (p) {
                                    u || ($f1cf32bbab6589f6$var$Ie(function() {
                                        var e = JSON.parse(JSON.stringify(r.currentSubscriptions)), n = (0, $f1cf32bbab6589f6$var$Ce.produceWithPatches)(a, function() {
                                            return e;
                                        });
                                        o.next(t.internalActions.subscriptionsUpdated(n[1])), a = e, u = !1;
                                    }), u = !0);
                                    var h = !!(null == (d = e.type) ? void 0 : d.startsWith(i)), v = n.rejected.match(e) && e.meta.condition && !!e.meta.arg.subscribe;
                                    return [
                                        !h && !v,
                                        !1
                                    ];
                                }
                                return [
                                    !0,
                                    !1
                                ];
                            };
                        }(l), p = function(t) {
                            var n = t.reducerPath, r = t.context, i = t.refetchQuery, a = t.internalState, u = t.api.internalActions.removeQueryResult;
                            function o(t, o) {
                                var s = t.getState()[n], c = s.queries, l = a.currentSubscriptions;
                                r.batch(function() {
                                    for(var n = 0, r = Object.keys(l); n < r.length; n++){
                                        var a = r[n], d = c[a], f = l[a];
                                        f && d && (Object.values(f).some(function(e) {
                                            return !0 === e[o];
                                        }) || Object.values(f).every(function(e) {
                                            return void 0 === e[o];
                                        }) && s.config[o]) && (0 === Object.keys(f).length ? t.dispatch(u({
                                            queryCacheKey: a
                                        })) : d.status !== $f1cf32bbab6589f6$var$e.uninitialized && t.dispatch(i(d, a)));
                                    }
                                });
                            }
                            return function(e, t) {
                                $f1cf32bbab6589f6$var$D.match(e) && o(t, "refetchOnFocus"), $f1cf32bbab6589f6$var$E.match(e) && o(t, "refetchOnReconnect");
                            };
                        }(l);
                        return function(e) {
                            return function(t) {
                                o || (o = !0, r.dispatch(i.internalActions.middlewareRegistered(u)));
                                var s, c = $f1cf32bbab6589f6$var$y($f1cf32bbab6589f6$var$v({}, r), {
                                    next: e
                                }), l = r.getState(), h = f(t, c, l), m = h[1];
                                if (s = h[0] ? e(t) : m, r.getState()[n] && (p(t, c, l), function(e) {
                                    return !!e && "string" == typeof e.type && e.type.startsWith(n + "/");
                                }(t) || a.hasRehydrationInfo(t))) for(var g = 0, b = d; g < b.length; g++)(0, b[g])(t, c, l);
                                return s;
                            };
                        };
                    },
                    actions: o
                };
                function c(e, t, n) {
                    return void 0 === n && (n = {}), r($f1cf32bbab6589f6$var$v({
                        type: "query",
                        endpointName: e.endpointName,
                        originalArgs: e.originalArgs,
                        subscribe: !1,
                        forceRefetch: !0,
                        queryCacheKey: t
                    }, n));
                }
            }({
                reducerPath: o,
                context: a,
                queryThunk: m,
                mutationThunk: g,
                api: t,
                assertTagType: p
            }), C = P.middleware;
            $f1cf32bbab6589f6$var$Me(t.util, P.actions), $f1cf32bbab6589f6$var$Me(t, {
                reducer: k,
                middleware: C
            });
            var I = function(t) {
                var n = t.serializeQueryArgs, r = t.reducerPath, i = function(e) {
                    return $f1cf32bbab6589f6$var$de;
                }, a = function(e) {
                    return $f1cf32bbab6589f6$var$fe;
                };
                return {
                    buildQuerySelector: function(e, t) {
                        return function(r) {
                            var a = n({
                                queryArgs: r,
                                endpointDefinition: t,
                                endpointName: e
                            });
                            return (0, $f1cf32bbab6589f6$var$L.createSelector)(r === $f1cf32bbab6589f6$var$se ? i : function(e) {
                                var t, n, r;
                                return null != (r = null == (n = null == (t = o(e)) ? void 0 : t.queries) ? void 0 : n[a]) ? r : $f1cf32bbab6589f6$var$de;
                            }, u);
                        };
                    },
                    buildMutationSelector: function() {
                        return function(e) {
                            var t, n;
                            return n = "object" == typeof e ? null != (t = $f1cf32bbab6589f6$var$ae(e)) ? t : $f1cf32bbab6589f6$var$se : e, (0, $f1cf32bbab6589f6$var$L.createSelector)(n === $f1cf32bbab6589f6$var$se ? a : function(e) {
                                var t, r, i;
                                return null != (i = null == (r = null == (t = o(e)) ? void 0 : t.mutations) ? void 0 : r[n]) ? i : $f1cf32bbab6589f6$var$fe;
                            }, u);
                        };
                    },
                    selectInvalidatedBy: function(e, t) {
                        for(var n, i = e[r], a = new Set, u = 0, o = t.map($f1cf32bbab6589f6$var$B); u < o.length; u++){
                            var s = o[u], c = i.provided[s.type];
                            if (c) for(var l = 0, d = null != (n = void 0 !== s.id ? c[s.id] : $f1cf32bbab6589f6$var$S(Object.values(c))) ? n : []; l < d.length; l++)a.add(d[l]);
                        }
                        return $f1cf32bbab6589f6$var$S(Array.from(a.values()).map(function(e) {
                            var t = i.queries[e];
                            return t ? [
                                {
                                    queryCacheKey: e,
                                    endpointName: t.endpointName,
                                    originalArgs: t.originalArgs
                                }
                            ] : [];
                        }));
                    }
                };
                function u(t) {
                    var n;
                    return $f1cf32bbab6589f6$var$v($f1cf32bbab6589f6$var$v({}, t), {
                        status: n = t.status,
                        isUninitialized: n === $f1cf32bbab6589f6$var$e.uninitialized,
                        isLoading: n === $f1cf32bbab6589f6$var$e.pending,
                        isSuccess: n === $f1cf32bbab6589f6$var$e.fulfilled,
                        isError: n === $f1cf32bbab6589f6$var$e.rejected
                    });
                }
                function o(e) {
                    return e[r];
                }
            }({
                serializeQueryArgs: s,
                reducerPath: o
            }), M = I.buildQuerySelector, _ = I.buildMutationSelector;
            $f1cf32bbab6589f6$var$Me(t.util, {
                selectInvalidatedBy: I.selectInvalidatedBy
            });
            var F = function(e) {
                var t = e.serializeQueryArgs, i = e.queryThunk, a = e.mutationThunk, u = e.api, o = e.context, s = new Map, c = new Map, l = u.internalActions, d = l.unsubscribeQueryResult, f = l.removeMutationResult, p = l.updateSubscriptionOptions;
                return {
                    buildInitiateQuery: function(e, r) {
                        var a = function(o, c) {
                            var l = void 0 === c ? {} : c, f = l.subscribe, h = void 0 === f || f, v = l.forceRefetch, y = l.subscriptionOptions, m = l[$f1cf32bbab6589f6$var$G];
                            return function(c, l) {
                                var f, g, b = t({
                                    queryArgs: o,
                                    endpointDefinition: r,
                                    endpointName: e
                                }), S = i(((f = {
                                    type: "query",
                                    subscribe: h,
                                    forceRefetch: v,
                                    subscriptionOptions: y,
                                    endpointName: e,
                                    originalArgs: o,
                                    queryCacheKey: b
                                })[$f1cf32bbab6589f6$var$G] = m, f)), O = u.endpoints[e].select(o), A = c(S), T = O(l()), R = A.requestId, j = A.abort, w = T.requestId !== R, k = null == (g = s.get(c)) ? void 0 : g[b], x = function() {
                                    return O(l());
                                }, Q = Object.assign(m ? A.then(x) : w && !k ? Promise.resolve(T) : Promise.all([
                                    k,
                                    A
                                ]).then(x), {
                                    arg: o,
                                    requestId: R,
                                    subscriptionOptions: y,
                                    queryCacheKey: b,
                                    abort: j,
                                    unwrap: function() {
                                        return $f1cf32bbab6589f6$var$q(this, null, function() {
                                            var e;
                                            return $f1cf32bbab6589f6$var$n(this, function(t) {
                                                switch(t.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            Q
                                                        ];
                                                    case 1:
                                                        if ((e = t.sent()).isError) throw e.error;
                                                        return [
                                                            2,
                                                            e.data
                                                        ];
                                                }
                                            });
                                        });
                                    },
                                    refetch: function() {
                                        return c(a(o, {
                                            subscribe: !1,
                                            forceRefetch: !0
                                        }));
                                    },
                                    unsubscribe: function() {
                                        h && c(d({
                                            queryCacheKey: b,
                                            requestId: R
                                        }));
                                    },
                                    updateSubscriptionOptions: function(t) {
                                        Q.subscriptionOptions = t, c(p({
                                            endpointName: e,
                                            requestId: R,
                                            queryCacheKey: b,
                                            options: t
                                        }));
                                    }
                                });
                                if (!k && !w && !m) {
                                    var P = s.get(c) || {};
                                    P[b] = Q, s.set(c, P), Q.then(function() {
                                        delete P[b], Object.keys(P).length || s.delete(c);
                                    });
                                }
                                return Q;
                            };
                        };
                        return a;
                    },
                    buildInitiateMutation: function(e) {
                        return function(t, n) {
                            var r = void 0 === n ? {} : n, i = r.track, u = void 0 === i || i, o = r.fixedCacheKey;
                            return function(n, r) {
                                var i = a({
                                    type: "mutation",
                                    endpointName: e,
                                    originalArgs: t,
                                    track: u,
                                    fixedCacheKey: o
                                }), s = n(i), l = s.requestId, d = s.abort, p = s.unwrap, h = s.unwrap().then(function(e) {
                                    return {
                                        data: e
                                    };
                                }).catch(function(e) {
                                    return {
                                        error: e
                                    };
                                }), v = function() {
                                    n(f({
                                        requestId: l,
                                        fixedCacheKey: o
                                    }));
                                }, y = Object.assign(h, {
                                    arg: s.arg,
                                    requestId: l,
                                    abort: d,
                                    unwrap: p,
                                    unsubscribe: v,
                                    reset: v
                                }), m = c.get(n) || {};
                                return c.set(n, m), m[l] = y, y.then(function() {
                                    delete m[l], Object.keys(m).length || c.delete(n);
                                }), o && (m[o] = y, y.then(function() {
                                    m[o] === y && (delete m[o], Object.keys(m).length || c.delete(n));
                                })), y;
                            };
                        };
                    },
                    getRunningQueryThunk: function(e, n) {
                        return function(r) {
                            var i, a = t({
                                queryArgs: n,
                                endpointDefinition: o.endpointDefinitions[e],
                                endpointName: e
                            });
                            return null == (i = s.get(r)) ? void 0 : i[a];
                        };
                    },
                    getRunningMutationThunk: function(e, t) {
                        return function(e) {
                            var n;
                            return null == (n = c.get(e)) ? void 0 : n[t];
                        };
                    },
                    getRunningQueriesThunk: function() {
                        return function(e) {
                            return Object.values(s.get(e) || {}).filter($f1cf32bbab6589f6$var$V);
                        };
                    },
                    getRunningMutationsThunk: function() {
                        return function(e) {
                            return Object.values(c.get(e) || {}).filter($f1cf32bbab6589f6$var$V);
                        };
                    },
                    getRunningOperationPromises: function() {
                        var e = function(e) {
                            return Array.from(e.values()).flatMap(function(e) {
                                return e ? Object.values(e) : [];
                            });
                        };
                        return $f1cf32bbab6589f6$var$r($f1cf32bbab6589f6$var$r([], e(s)), e(c)).filter($f1cf32bbab6589f6$var$V);
                    },
                    removalWarning: function() {
                        throw new Error("This method had to be removed due to a conceptual bug in RTK.\n       Please see https://github.com/reduxjs/redux-toolkit/pull/2481 for details.\n       See https://redux-toolkit.js.org/rtk-query/usage/server-side-rendering for new guidance on SSR.");
                    }
                };
            }({
                queryThunk: m,
                mutationThunk: g,
                api: t,
                serializeQueryArgs: s,
                context: a
            }), U = F.buildInitiateQuery, H = F.buildInitiateMutation;
            return $f1cf32bbab6589f6$var$Me(t.util, {
                getRunningOperationPromises: F.getRunningOperationPromises,
                getRunningOperationPromise: F.removalWarning,
                getRunningMutationThunk: F.getRunningMutationThunk,
                getRunningMutationsThunk: F.getRunningMutationsThunk,
                getRunningQueryThunk: F.getRunningQueryThunk,
                getRunningQueriesThunk: F.getRunningQueriesThunk
            }), {
                name: $f1cf32bbab6589f6$var$Ne,
                injectEndpoint: function(e, n) {
                    var r, i = t;
                    null != (r = i.endpoints)[e] || (r[e] = {}), $f1cf32bbab6589f6$var$W(n) ? $f1cf32bbab6589f6$var$Me(i.endpoints[e], {
                        name: e,
                        select: M(e, n),
                        initiate: U(e, n)
                    }, j(m, e)) : n.type === $f1cf32bbab6589f6$var$z.mutation && $f1cf32bbab6589f6$var$Me(i.endpoints[e], {
                        name: e,
                        select: _(),
                        initiate: H(e)
                    }, j(g, e));
                }
            };
        }
    };
}, $f1cf32bbab6589f6$var$Ke = $f1cf32bbab6589f6$var$ge($f1cf32bbab6589f6$var$Ee());

});

parcelRegister("iTIA1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $dc1ff1b53430654d$export$1e511d4a378977f5, (v) => $dc1ff1b53430654d$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $dc1ff1b53430654d$export$2e2bcd8739ae039, (v) => $dc1ff1b53430654d$export$2e2bcd8739ae039 = v);
var $dc1ff1b53430654d$export$1e511d4a378977f5;
var $dc1ff1b53430654d$export$2e2bcd8739ae039;
"use strict";
$dc1ff1b53430654d$export$1e511d4a378977f5 = true;
$dc1ff1b53430654d$export$2e2bcd8739ae039 = void 0;

var $dc1ff1b53430654d$var$React = $dc1ff1b53430654d$var$_interopRequireWildcard((parcelRequire("2gcPZ")));

var $j2iUf = parcelRequire("j2iUf");

var $6mLez = parcelRequire("6mLez");

var $1xZa5 = parcelRequire("1xZa5");
var $dc1ff1b53430654d$var$_excluded = [
    "children",
    "className",
    "draggableOpts",
    "width",
    "height",
    "handle",
    "handleSize",
    "lockAspectRatio",
    "axis",
    "minConstraints",
    "maxConstraints",
    "onResize",
    "onResizeStop",
    "onResizeStart",
    "resizeHandles",
    "transformScale"
];
function $dc1ff1b53430654d$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($dc1ff1b53430654d$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $dc1ff1b53430654d$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $dc1ff1b53430654d$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $dc1ff1b53430654d$var$_extends() {
    $dc1ff1b53430654d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dc1ff1b53430654d$var$_extends.apply(this, arguments);
}
function $dc1ff1b53430654d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $dc1ff1b53430654d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $dc1ff1b53430654d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $dc1ff1b53430654d$var$ownKeys(Object(source), !0).forEach(function(key) {
            $dc1ff1b53430654d$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $dc1ff1b53430654d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $dc1ff1b53430654d$var$_defineProperty(obj, key, value) {
    key = $dc1ff1b53430654d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $dc1ff1b53430654d$var$_toPropertyKey(arg) {
    var key = $dc1ff1b53430654d$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $dc1ff1b53430654d$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $dc1ff1b53430654d$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $dc1ff1b53430654d$var$_setPrototypeOf(subClass, superClass);
}
function $dc1ff1b53430654d$var$_setPrototypeOf(o, p) {
    $dc1ff1b53430654d$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $dc1ff1b53430654d$var$_setPrototypeOf(o, p);
}
// The base <Resizable> component.
// This component does not have state and relies on the parent to set its props based on callback data.
var $dc1ff1b53430654d$var$Resizable = /*#__PURE__*/ function(_React$Component) {
    $dc1ff1b53430654d$var$_inheritsLoose(Resizable, _React$Component);
    function Resizable() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handleRefs = {};
        _this.lastHandleRect = null;
        _this.slack = null;
        return _this;
    }
    var _proto = Resizable.prototype;
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.resetData();
    };
    _proto.resetData = function resetData() {
        this.lastHandleRect = this.slack = null;
    };
    _proto.runConstraints = function runConstraints(width, height) {
        var _this$props = this.props, minConstraints = _this$props.minConstraints, maxConstraints = _this$props.maxConstraints, lockAspectRatio = _this$props.lockAspectRatio;
        // short circuit
        if (!minConstraints && !maxConstraints && !lockAspectRatio) return [
            width,
            height
        ];
        // If constraining to min and max, we need to also fit width and height to aspect ratio.
        if (lockAspectRatio) {
            var ratio = this.props.width / this.props.height;
            var deltaW = width - this.props.width;
            var deltaH = height - this.props.height;
            // Find which coordinate was greater and should push the other toward it.
            // E.g.:
            // ratio = 1, deltaW = 10, deltaH = 5, deltaH should become 10.
            // ratio = 2, deltaW = 10, deltaH = 6, deltaW should become 12.
            if (Math.abs(deltaW) > Math.abs(deltaH * ratio)) height = width / ratio;
            else width = height * ratio;
        }
        var oldW = width, oldH = height;
        // Add slack to the values used to calculate bound position. This will ensure that if
        // we start removing slack, the element won't react to it right away until it's been
        // completely removed.
        var _ref = this.slack || [
            0,
            0
        ], slackW = _ref[0], slackH = _ref[1];
        width += slackW;
        height += slackH;
        if (minConstraints) {
            width = Math.max(minConstraints[0], width);
            height = Math.max(minConstraints[1], height);
        }
        if (maxConstraints) {
            width = Math.min(maxConstraints[0], width);
            height = Math.min(maxConstraints[1], height);
        }
        // If the width or height changed, we must have introduced some slack. Record it for the next iteration.
        this.slack = [
            slackW + (oldW - width),
            slackH + (oldH - height)
        ];
        return [
            width,
            height
        ];
    } /**
   * Wrapper around drag events to provide more useful data.
   *
   * @param  {String} handlerName Handler name to wrap.
   * @return {Function}           Handler function.
   */ ;
    _proto.resizeHandler = function resizeHandler(handlerName, axis) {
        var _this2 = this;
        return function(e, _ref2) {
            var node = _ref2.node, deltaX = _ref2.deltaX, deltaY = _ref2.deltaY;
            // Reset data in case it was left over somehow (should not be possible)
            if (handlerName === "onResizeStart") _this2.resetData();
            // Axis restrictions
            var canDragX = (_this2.props.axis === "both" || _this2.props.axis === "x") && axis !== "n" && axis !== "s";
            var canDragY = (_this2.props.axis === "both" || _this2.props.axis === "y") && axis !== "e" && axis !== "w";
            // No dragging possible.
            if (!canDragX && !canDragY) return;
            // Decompose axis for later use
            var axisV = axis[0];
            var axisH = axis[axis.length - 1]; // intentionally not axis[1], so that this catches axis === 'w' for example
            // Track the element being dragged to account for changes in position.
            // If a handle's position is changed between callbacks, we need to factor this in to the next callback.
            // Failure to do so will cause the element to "skip" when resized upwards or leftwards.
            var handleRect = node.getBoundingClientRect();
            if (_this2.lastHandleRect != null) {
                // If the handle has repositioned on either axis since last render,
                // we need to increase our callback values by this much.
                // Only checking 'n', 'w' since resizing by 's', 'w' won't affect the overall position on page,
                if (axisH === "w") {
                    var deltaLeftSinceLast = handleRect.left - _this2.lastHandleRect.left;
                    deltaX += deltaLeftSinceLast;
                }
                if (axisV === "n") {
                    var deltaTopSinceLast = handleRect.top - _this2.lastHandleRect.top;
                    deltaY += deltaTopSinceLast;
                }
            }
            // Storage of last rect so we know how much it has really moved.
            _this2.lastHandleRect = handleRect;
            // Reverse delta if using top or left drag handles.
            if (axisH === "w") deltaX = -deltaX;
            if (axisV === "n") deltaY = -deltaY;
            // Update w/h by the deltas. Also factor in transformScale.
            var width = _this2.props.width + (canDragX ? deltaX / _this2.props.transformScale : 0);
            var height = _this2.props.height + (canDragY ? deltaY / _this2.props.transformScale : 0);
            // Run user-provided constraints.
            var _this2$runConstraints = _this2.runConstraints(width, height);
            width = _this2$runConstraints[0];
            height = _this2$runConstraints[1];
            var dimensionsChanged = width !== _this2.props.width || height !== _this2.props.height;
            // Call user-supplied callback if present.
            var cb = typeof _this2.props[handlerName] === "function" ? _this2.props[handlerName] : null;
            // Don't call 'onResize' if dimensions haven't changed.
            var shouldSkipCb = handlerName === "onResize" && !dimensionsChanged;
            if (cb && !shouldSkipCb) {
                e.persist == null || e.persist();
                cb(e, {
                    node: node,
                    size: {
                        width: width,
                        height: height
                    },
                    handle: axis
                });
            }
            // Reset internal data
            if (handlerName === "onResizeStop") _this2.resetData();
        };
    };
    _proto.renderResizeHandle = function renderResizeHandle(handleAxis, ref) {
        var handle = this.props.handle;
        // No handle provided, make the default
        if (!handle) return /*#__PURE__*/ $dc1ff1b53430654d$var$React.createElement("span", {
            className: "react-resizable-handle react-resizable-handle-" + handleAxis,
            ref: ref
        });
        // Handle is a function, such as:
        // `handle={(handleAxis) => <span className={...} />}`
        if (typeof handle === "function") return handle(handleAxis, ref);
        // Handle is a React component (composite or DOM).
        var isDOMElement = typeof handle.type === "string";
        var props = $dc1ff1b53430654d$var$_objectSpread({
            ref: ref
        }, isDOMElement ? {} : {
            handleAxis: handleAxis
        });
        return /*#__PURE__*/ $dc1ff1b53430654d$var$React.cloneElement(handle, props);
    };
    _proto.render = function render() {
        var _this3 = this;
        // Pass along only props not meant for the `<Resizable>`.`
        // eslint-disable-next-line no-unused-vars
        var _this$props2 = this.props, children = _this$props2.children, className = _this$props2.className, draggableOpts = _this$props2.draggableOpts, width = _this$props2.width, height = _this$props2.height, handle = _this$props2.handle, handleSize = _this$props2.handleSize, lockAspectRatio = _this$props2.lockAspectRatio, axis = _this$props2.axis, minConstraints = _this$props2.minConstraints, maxConstraints = _this$props2.maxConstraints, onResize = _this$props2.onResize, onResizeStop = _this$props2.onResizeStop, onResizeStart = _this$props2.onResizeStart, resizeHandles = _this$props2.resizeHandles, transformScale = _this$props2.transformScale, p = $dc1ff1b53430654d$var$_objectWithoutPropertiesLoose(_this$props2, $dc1ff1b53430654d$var$_excluded);
        // What we're doing here is getting the child of this element, and cloning it with this element's props.
        // We are then defining its children as:
        // 1. Its original children (resizable's child's children), and
        // 2. One or more draggable handles.
        return (0, $6mLez.cloneElement)(children, $dc1ff1b53430654d$var$_objectSpread($dc1ff1b53430654d$var$_objectSpread({}, p), {}, {
            className: (className ? className + " " : "") + "react-resizable",
            children: [].concat(children.props.children, resizeHandles.map(function(handleAxis) {
                var _this3$handleRefs$han;
                // Create a ref to the handle so that `<DraggableCore>` doesn't have to use ReactDOM.findDOMNode().
                var ref = (_this3$handleRefs$han = _this3.handleRefs[handleAxis]) != null ? _this3$handleRefs$han : _this3.handleRefs[handleAxis] = /*#__PURE__*/ $dc1ff1b53430654d$var$React.createRef();
                return /*#__PURE__*/ $dc1ff1b53430654d$var$React.createElement($j2iUf.DraggableCore, $dc1ff1b53430654d$var$_extends({}, draggableOpts, {
                    nodeRef: ref,
                    key: "resizableHandle-" + handleAxis,
                    onStop: _this3.resizeHandler("onResizeStop", handleAxis),
                    onStart: _this3.resizeHandler("onResizeStart", handleAxis),
                    onDrag: _this3.resizeHandler("onResize", handleAxis)
                }), _this3.renderResizeHandle(handleAxis, ref));
            }))
        }));
    };
    return Resizable;
}($dc1ff1b53430654d$var$React.Component);
$dc1ff1b53430654d$export$2e2bcd8739ae039 = $dc1ff1b53430654d$var$Resizable;
$dc1ff1b53430654d$var$Resizable.propTypes = $1xZa5.resizableProps;
$dc1ff1b53430654d$var$Resizable.defaultProps = {
    axis: "both",
    handleSize: [
        20,
        20
    ],
    lockAspectRatio: false,
    minConstraints: [
        20,
        20
    ],
    maxConstraints: [
        Infinity,
        Infinity
    ],
    resizeHandles: [
        "se"
    ],
    transformScale: 1
};

});
parcelRegister("j2iUf", function(module, exports) {
"use strict";

var $lBknJ = parcelRequire("lBknJ");
var $ddbcde95b188d5ce$var$Draggable = $lBknJ.default, $ddbcde95b188d5ce$var$DraggableCore = $lBknJ.DraggableCore; // Previous versions of this lib exported <Draggable> as the root export. As to no-// them, or TypeScript, we export *both* as the root and as 'default'.
// See https://github.com/mzabriskie/react-draggable/pull/254
// and https://github.com/mzabriskie/react-draggable/issues/266
module.exports = $ddbcde95b188d5ce$var$Draggable;
module.exports.default = $ddbcde95b188d5ce$var$Draggable;
module.exports.DraggableCore = $ddbcde95b188d5ce$var$DraggableCore;

});
parcelRegister("lBknJ", function(module, exports) {
"use strict";
function $fb9cdd18149816b7$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $fb9cdd18149816b7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $fb9cdd18149816b7$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "DraggableCore", {
    enumerable: true,
    get: function get() {
        return $fb9cdd18149816b7$var$_DraggableCore.default;
    }
});
module.exports.default = void 0;

var $fb9cdd18149816b7$var$React = $fb9cdd18149816b7$var$_interopRequireWildcard((parcelRequire("2gcPZ")));

var $fb9cdd18149816b7$var$_propTypes = $fb9cdd18149816b7$var$_interopRequireDefault((parcelRequire("gArjD")));

var $fb9cdd18149816b7$var$_reactDom = $fb9cdd18149816b7$var$_interopRequireDefault((parcelRequire("fuyzp")));

var $fb9cdd18149816b7$var$_clsx2 = $fb9cdd18149816b7$var$_interopRequireDefault((parcelRequire("loprT")));

var $1u6Ge = parcelRequire("1u6Ge");

var $9xeV2 = parcelRequire("9xeV2");

var $3jnBc = parcelRequire("3jnBc");

var $fb9cdd18149816b7$var$_DraggableCore = $fb9cdd18149816b7$var$_interopRequireDefault((parcelRequire("frbf6")));

var $fb9cdd18149816b7$var$_log = $fb9cdd18149816b7$var$_interopRequireDefault((parcelRequire("kCQwh")));
var $fb9cdd18149816b7$var$_excluded = [
    "axis",
    "bounds",
    "children",
    "defaultPosition",
    "defaultClassName",
    "defaultClassNameDragging",
    "defaultClassNameDragged",
    "position",
    "positionOffset",
    "scale"
];
function $fb9cdd18149816b7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fb9cdd18149816b7$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($fb9cdd18149816b7$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $fb9cdd18149816b7$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $fb9cdd18149816b7$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $fb9cdd18149816b7$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $fb9cdd18149816b7$var$_extends() {
    $fb9cdd18149816b7$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fb9cdd18149816b7$var$_extends.apply(this, arguments);
}
function $fb9cdd18149816b7$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $fb9cdd18149816b7$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $fb9cdd18149816b7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $fb9cdd18149816b7$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $fb9cdd18149816b7$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $fb9cdd18149816b7$var$ownKeys(Object(source), !0).forEach(function(key) {
            $fb9cdd18149816b7$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $fb9cdd18149816b7$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $fb9cdd18149816b7$var$_slicedToArray(arr, i) {
    return $fb9cdd18149816b7$var$_arrayWithHoles(arr) || $fb9cdd18149816b7$var$_iterableToArrayLimit(arr, i) || $fb9cdd18149816b7$var$_unsupportedIterableToArray(arr, i) || $fb9cdd18149816b7$var$_nonIterableRest();
}
function $fb9cdd18149816b7$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fb9cdd18149816b7$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $fb9cdd18149816b7$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $fb9cdd18149816b7$var$_arrayLikeToArray(o, minLen);
}
function $fb9cdd18149816b7$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $fb9cdd18149816b7$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $fb9cdd18149816b7$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $fb9cdd18149816b7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $fb9cdd18149816b7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $fb9cdd18149816b7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $fb9cdd18149816b7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fb9cdd18149816b7$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $fb9cdd18149816b7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $fb9cdd18149816b7$var$_setPrototypeOf(subClass, superClass);
}
function $fb9cdd18149816b7$var$_setPrototypeOf(o, p) {
    $fb9cdd18149816b7$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $fb9cdd18149816b7$var$_setPrototypeOf(o, p);
}
function $fb9cdd18149816b7$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $fb9cdd18149816b7$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $fb9cdd18149816b7$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $fb9cdd18149816b7$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $fb9cdd18149816b7$var$_possibleConstructorReturn(this, result);
    };
}
function $fb9cdd18149816b7$var$_possibleConstructorReturn(self, call) {
    if (call && ($fb9cdd18149816b7$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $fb9cdd18149816b7$var$_assertThisInitialized(self);
}
function $fb9cdd18149816b7$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $fb9cdd18149816b7$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $fb9cdd18149816b7$var$_getPrototypeOf(o) {
    $fb9cdd18149816b7$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $fb9cdd18149816b7$var$_getPrototypeOf(o);
}
function $fb9cdd18149816b7$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
//
// Define <Draggable>
//
var $fb9cdd18149816b7$var$Draggable = /*#__PURE__*/ function(_React$Component) {
    $fb9cdd18149816b7$var$_inherits(Draggable, _React$Component);
    var _super = $fb9cdd18149816b7$var$_createSuper(Draggable);
    function Draggable(props) {
        var _this;
        $fb9cdd18149816b7$var$_classCallCheck(this, Draggable);
        _this = _super.call(this, props);
        $fb9cdd18149816b7$var$_defineProperty($fb9cdd18149816b7$var$_assertThisInitialized(_this), "onDragStart", function(e, coreData) {
            (0, $fb9cdd18149816b7$var$_log.default)("Draggable: onDragStart: %j", coreData); // Short-circuit if user's callback killed it.
            var shouldStart = _this.props.onStart(e, (0, $9xeV2.createDraggableData)($fb9cdd18149816b7$var$_assertThisInitialized(_this), coreData)); // Kills start event on core as well, so move handlers are never bound.
            if (shouldStart === false) return false;
            _this.setState({
                dragging: true,
                dragged: true
            });
        });
        $fb9cdd18149816b7$var$_defineProperty($fb9cdd18149816b7$var$_assertThisInitialized(_this), "onDrag", function(e, coreData) {
            if (!_this.state.dragging) return false;
            (0, $fb9cdd18149816b7$var$_log.default)("Draggable: onDrag: %j", coreData);
            var uiData = (0, $9xeV2.createDraggableData)($fb9cdd18149816b7$var$_assertThisInitialized(_this), coreData);
            var newState = {
                x: uiData.x,
                y: uiData.y
            }; // Keep within bounds.
            if (_this.props.bounds) {
                // Save original x and y.
                var x = newState.x, y = newState.y; // Add slack to the values used to calculate bound position. This will ensure that if
                // we start removing slack, the element won't react to it right away until it's been
                // completely removed.
                newState.x += _this.state.slackX;
                newState.y += _this.state.slackY; // Get bound position. This will ceil/floor the x and y within the boundaries.
                var _getBoundPosition = (0, $9xeV2.getBoundPosition)($fb9cdd18149816b7$var$_assertThisInitialized(_this), newState.x, newState.y), _getBoundPosition2 = $fb9cdd18149816b7$var$_slicedToArray(_getBoundPosition, 2), newStateX = _getBoundPosition2[0], newStateY = _getBoundPosition2[1];
                newState.x = newStateX;
                newState.y = newStateY; // Recalculate slack by noting how much was shaved by the boundPosition handler.
                newState.slackX = _this.state.slackX + (x - newState.x);
                newState.slackY = _this.state.slackY + (y - newState.y); // Update the event we fire to reflect what really happened after bounds took effect.
                uiData.x = newState.x;
                uiData.y = newState.y;
                uiData.deltaX = newState.x - _this.state.x;
                uiData.deltaY = newState.y - _this.state.y;
            } // Short-circuit if user's callback killed it.
            var shouldUpdate = _this.props.onDrag(e, uiData);
            if (shouldUpdate === false) return false;
            _this.setState(newState);
        });
        $fb9cdd18149816b7$var$_defineProperty($fb9cdd18149816b7$var$_assertThisInitialized(_this), "onDragStop", function(e, coreData) {
            if (!_this.state.dragging) return false; // Short-circuit if user's callback killed it.
            var shouldContinue = _this.props.onStop(e, (0, $9xeV2.createDraggableData)($fb9cdd18149816b7$var$_assertThisInitialized(_this), coreData));
            if (shouldContinue === false) return false;
            (0, $fb9cdd18149816b7$var$_log.default)("Draggable: onDragStop: %j", coreData);
            var newState = {
                dragging: false,
                slackX: 0,
                slackY: 0
            }; // If this is a controlled component, the result of this operation will be to
            // revert back to the old position. We expect a handler on `onDragStop`, at the least.
            var controlled = Boolean(_this.props.position);
            if (controlled) {
                var _this$props$position = _this.props.position, x = _this$props$position.x, y = _this$props$position.y;
                newState.x = x;
                newState.y = y;
            }
            _this.setState(newState);
        });
        _this.state = {
            // Whether or not we are currently dragging.
            dragging: false,
            // Whether or not we have been dragged before.
            dragged: false,
            // Current transform x and y.
            x: props.position ? props.position.x : props.defaultPosition.x,
            y: props.position ? props.position.y : props.defaultPosition.y,
            prevPropsPosition: $fb9cdd18149816b7$var$_objectSpread({}, props.position),
            // Used for compensating for out-of-bounds drags
            slackX: 0,
            slackY: 0,
            // Can only determine if SVG after mounting
            isElementSVG: false
        };
        if (props.position && !(props.onDrag || props.onStop)) // eslint-disable-next-line no-console
        console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
        return _this;
    }
    $fb9cdd18149816b7$var$_createClass(Draggable, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                // Check to see if the element passed is an instanceof SVGElement
                if (typeof window.SVGElement !== "undefined" && this.findDOMNode() instanceof window.SVGElement) this.setState({
                    isElementSVG: true
                });
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.setState({
                    dragging: false
                }); // prevents invariant if unmounted while dragging
            } // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
        },
        {
            key: "findDOMNode",
            value: function findDOMNode() /*: ?HTMLElement*/ {
                var _this$props$nodeRef$c, _this$props, _this$props$nodeRef;
                return (_this$props$nodeRef$c = (_this$props = this.props) === null || _this$props === void 0 ? void 0 : (_this$props$nodeRef = _this$props.nodeRef) === null || _this$props$nodeRef === void 0 ? void 0 : _this$props$nodeRef.current) !== null && _this$props$nodeRef$c !== void 0 ? _this$props$nodeRef$c : $fb9cdd18149816b7$var$_reactDom.default.findDOMNode(this);
            }
        },
        {
            key: "render",
            value: function render() /*: ReactElement<any>*/ {
                var _clsx;
                var _this$props2 = this.props, axis = _this$props2.axis, bounds = _this$props2.bounds, children = _this$props2.children, defaultPosition = _this$props2.defaultPosition, defaultClassName = _this$props2.defaultClassName, defaultClassNameDragging = _this$props2.defaultClassNameDragging, defaultClassNameDragged = _this$props2.defaultClassNameDragged, position = _this$props2.position, positionOffset = _this$props2.positionOffset, scale = _this$props2.scale, draggableCoreProps = $fb9cdd18149816b7$var$_objectWithoutProperties(_this$props2, $fb9cdd18149816b7$var$_excluded);
                var style = {};
                var svgTransform = null; // If this is controlled, we don't want to move it - unless it's dragging.
                var controlled = Boolean(position);
                var draggable = !controlled || this.state.dragging;
                var validPosition = position || defaultPosition;
                var transformOpts = {
                    // Set left if horizontal drag is enabled
                    x: (0, $9xeV2.canDragX)(this) && draggable ? this.state.x : validPosition.x,
                    // Set top if vertical drag is enabled
                    y: (0, $9xeV2.canDragY)(this) && draggable ? this.state.y : validPosition.y
                }; // If this element was SVG, we use the `transform` attribute.
                if (this.state.isElementSVG) svgTransform = (0, $1u6Ge.createSVGTransform)(transformOpts, positionOffset);
                else // Add a CSS transform to move the element around. This allows us to move the element around
                // without worrying about whether or not it is relatively or absolutely positioned.
                // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
                // has a clean slate.
                style = (0, $1u6Ge.createCSSTransform)(transformOpts, positionOffset);
                 // Mark with class while dragging
                var className = (0, $fb9cdd18149816b7$var$_clsx2.default)(children.props.className || "", defaultClassName, (_clsx = {}, $fb9cdd18149816b7$var$_defineProperty(_clsx, defaultClassNameDragging, this.state.dragging), $fb9cdd18149816b7$var$_defineProperty(_clsx, defaultClassNameDragged, this.state.dragged), _clsx)); // Reuse the child provided
                // This makes it flexible to use whatever element is wanted (div, ul, etc)
                return /*#__PURE__*/ $fb9cdd18149816b7$var$React.createElement($fb9cdd18149816b7$var$_DraggableCore.default, $fb9cdd18149816b7$var$_extends({}, draggableCoreProps, {
                    onStart: this.onDragStart,
                    onDrag: this.onDrag,
                    onStop: this.onDragStop
                }), /*#__PURE__*/ $fb9cdd18149816b7$var$React.cloneElement($fb9cdd18149816b7$var$React.Children.only(children), {
                    className: className,
                    style: $fb9cdd18149816b7$var$_objectSpread($fb9cdd18149816b7$var$_objectSpread({}, children.props.style), style),
                    transform: svgTransform
                }));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: // Arity (props, state)
            function getDerivedStateFromProps(_ref, _ref2) /*: ?$Shape<DraggableState>*/ {
                var position = _ref.position;
                var prevPropsPosition = _ref2.prevPropsPosition;
                // Set x/y if a new position is provided in props that is different than the previous.
                if (position && (!prevPropsPosition || position.x !== prevPropsPosition.x || position.y !== prevPropsPosition.y)) {
                    (0, $fb9cdd18149816b7$var$_log.default)("Draggable: getDerivedStateFromProps %j", {
                        position: position,
                        prevPropsPosition: prevPropsPosition
                    });
                    return {
                        x: position.x,
                        y: position.y,
                        prevPropsPosition: $fb9cdd18149816b7$var$_objectSpread({}, position)
                    };
                }
                return null;
            }
        }
    ]);
    return Draggable;
}($fb9cdd18149816b7$var$React.Component);
module.exports.default = $fb9cdd18149816b7$var$Draggable;
$fb9cdd18149816b7$var$_defineProperty($fb9cdd18149816b7$var$Draggable, "displayName", "Draggable");
$fb9cdd18149816b7$var$_defineProperty($fb9cdd18149816b7$var$Draggable, "propTypes", $fb9cdd18149816b7$var$_objectSpread($fb9cdd18149816b7$var$_objectSpread({}, $fb9cdd18149816b7$var$_DraggableCore.default.propTypes), {}, {
    /**
   * `axis` determines which axis the draggable can move.
   *
   *  Note that all callbacks will still return data as normal. This only
   *  controls flushing to the DOM.
   *
   * 'both' allows movement horizontally and vertically.
   * 'x' limits movement to horizontal axis.
   * 'y' limits movement to vertical axis.
   * 'none' limits all movement.
   *
   * Defaults to 'both'.
   */ axis: $fb9cdd18149816b7$var$_propTypes.default.oneOf([
        "both",
        "x",
        "y",
        "none"
    ]),
    /**
   * `bounds` determines the range of movement available to the element.
   * Available values are:
   *
   * 'parent' restricts movement within the Draggable's parent node.
   *
   * Alternatively, pass an object with the following properties, all of which are optional:
   *
   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
   *
   * All values are in px.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable bounds={{right: 300, bottom: 300}}>
   *              <div>Content</div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ bounds: $fb9cdd18149816b7$var$_propTypes.default.oneOfType([
        $fb9cdd18149816b7$var$_propTypes.default.shape({
            left: $fb9cdd18149816b7$var$_propTypes.default.number,
            right: $fb9cdd18149816b7$var$_propTypes.default.number,
            top: $fb9cdd18149816b7$var$_propTypes.default.number,
            bottom: $fb9cdd18149816b7$var$_propTypes.default.number
        }),
        $fb9cdd18149816b7$var$_propTypes.default.string,
        $fb9cdd18149816b7$var$_propTypes.default.oneOf([
            false
        ])
    ]),
    defaultClassName: $fb9cdd18149816b7$var$_propTypes.default.string,
    defaultClassNameDragging: $fb9cdd18149816b7$var$_propTypes.default.string,
    defaultClassNameDragged: $fb9cdd18149816b7$var$_propTypes.default.string,
    /**
   * `defaultPosition` specifies the x and y that the dragged item should start at
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ defaultPosition: $fb9cdd18149816b7$var$_propTypes.default.shape({
        x: $fb9cdd18149816b7$var$_propTypes.default.number,
        y: $fb9cdd18149816b7$var$_propTypes.default.number
    }),
    positionOffset: $fb9cdd18149816b7$var$_propTypes.default.shape({
        x: $fb9cdd18149816b7$var$_propTypes.default.oneOfType([
            $fb9cdd18149816b7$var$_propTypes.default.number,
            $fb9cdd18149816b7$var$_propTypes.default.string
        ]),
        y: $fb9cdd18149816b7$var$_propTypes.default.oneOfType([
            $fb9cdd18149816b7$var$_propTypes.default.number,
            $fb9cdd18149816b7$var$_propTypes.default.string
        ])
    }),
    /**
   * `position`, if present, defines the current position of the element.
   *
   *  This is similar to how form elements in React work - if no `position` is supplied, the component
   *  is uncontrolled.
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable position={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */ position: $fb9cdd18149816b7$var$_propTypes.default.shape({
        x: $fb9cdd18149816b7$var$_propTypes.default.number,
        y: $fb9cdd18149816b7$var$_propTypes.default.number
    }),
    /**
   * These properties should be defined on the child, not here.
   */ className: $3jnBc.dontSetMe,
    style: $3jnBc.dontSetMe,
    transform: $3jnBc.dontSetMe
}));
$fb9cdd18149816b7$var$_defineProperty($fb9cdd18149816b7$var$Draggable, "defaultProps", $fb9cdd18149816b7$var$_objectSpread($fb9cdd18149816b7$var$_objectSpread({}, $fb9cdd18149816b7$var$_DraggableCore.default.defaultProps), {}, {
    axis: "both",
    bounds: false,
    defaultClassName: "react-draggable",
    defaultClassNameDragging: "react-draggable-dragging",
    defaultClassNameDragged: "react-draggable-dragged",
    defaultPosition: {
        x: 0,
        y: 0
    },
    scale: 1
}));

});
parcelRegister("gArjD", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c1353278486d4d1f$var$ReactIs, $c1353278486d4d1f$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("iQiRC"))();

});
parcelRegister("iQiRC", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $jJgYh = parcelRequire("jJgYh");
function $db7bb74bcd016669$var$emptyFunction() {}
function $db7bb74bcd016669$var$emptyFunctionWithReset() {}
$db7bb74bcd016669$var$emptyFunctionWithReset.resetWarningCache = $db7bb74bcd016669$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $jJgYh) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $db7bb74bcd016669$var$emptyFunctionWithReset,
        resetWarningCache: $db7bb74bcd016669$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("jJgYh", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $e5cf626c5a66a4e0$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $e5cf626c5a66a4e0$var$ReactPropTypesSecret;

});



parcelRegister("loprT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "clsx", () => $f92f94818433bc41$export$4f5d2d50c9deca37);
$parcel$export(module.exports, "default", () => $f92f94818433bc41$export$2e2bcd8739ae039);
function $f92f94818433bc41$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $f92f94818433bc41$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $f92f94818433bc41$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $f92f94818433bc41$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f92f94818433bc41$export$2e2bcd8739ae039 = $f92f94818433bc41$export$4f5d2d50c9deca37;

});

parcelRegister("1u6Ge", function(module, exports) {
"use strict";
function $114dc6546d5af90f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $114dc6546d5af90f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $114dc6546d5af90f$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.addClassName = $114dc6546d5af90f$var$addClassName;
module.exports.addEvent = $114dc6546d5af90f$var$addEvent;
module.exports.addUserSelectStyles = $114dc6546d5af90f$var$addUserSelectStyles;
module.exports.createCSSTransform = $114dc6546d5af90f$var$createCSSTransform;
module.exports.createSVGTransform = $114dc6546d5af90f$var$createSVGTransform;
module.exports.getTouch = $114dc6546d5af90f$var$getTouch;
module.exports.getTouchIdentifier = $114dc6546d5af90f$var$getTouchIdentifier;
module.exports.getTranslation = $114dc6546d5af90f$var$getTranslation;
module.exports.innerHeight = $114dc6546d5af90f$var$innerHeight;
module.exports.innerWidth = $114dc6546d5af90f$var$innerWidth;
module.exports.matchesSelector = $114dc6546d5af90f$var$matchesSelector;
module.exports.matchesSelectorAndParentsTo = $114dc6546d5af90f$var$matchesSelectorAndParentsTo;
module.exports.offsetXYFromParent = $114dc6546d5af90f$var$offsetXYFromParent;
module.exports.outerHeight = $114dc6546d5af90f$var$outerHeight;
module.exports.outerWidth = $114dc6546d5af90f$var$outerWidth;
module.exports.removeClassName = $114dc6546d5af90f$var$removeClassName;
module.exports.removeEvent = $114dc6546d5af90f$var$removeEvent;
module.exports.removeUserSelectStyles = $114dc6546d5af90f$var$removeUserSelectStyles;

var $3jnBc = parcelRequire("3jnBc");

var $114dc6546d5af90f$var$_getPrefix = $114dc6546d5af90f$var$_interopRequireWildcard((parcelRequire("8Hmnt")));
function $114dc6546d5af90f$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($114dc6546d5af90f$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $114dc6546d5af90f$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $114dc6546d5af90f$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $114dc6546d5af90f$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $114dc6546d5af90f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $114dc6546d5af90f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $114dc6546d5af90f$var$ownKeys(Object(source), !0).forEach(function(key) {
            $114dc6546d5af90f$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $114dc6546d5af90f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $114dc6546d5af90f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $114dc6546d5af90f$var$matchesSelectorFunc = "";
function $114dc6546d5af90f$var$matchesSelector(el, selector) /*: boolean*/ {
    if (!$114dc6546d5af90f$var$matchesSelectorFunc) $114dc6546d5af90f$var$matchesSelectorFunc = (0, $3jnBc.findInArray)([
        "matches",
        "webkitMatchesSelector",
        "mozMatchesSelector",
        "msMatchesSelector",
        "oMatchesSelector"
    ], function(method) {
        // $FlowIgnore: Doesn't think elements are indexable
        return (0, $3jnBc.isFunction)(el[method]);
    });
     // Might not be found entirely (not an Element?) - in that case, bail
    // $FlowIgnore: Doesn't think elements are indexable
    if (!(0, $3jnBc.isFunction)(el[$114dc6546d5af90f$var$matchesSelectorFunc])) return false; // $FlowIgnore: Doesn't think elements are indexable
    return el[$114dc6546d5af90f$var$matchesSelectorFunc](selector);
} // Works up the tree to the draggable itself attempting to match selector.
function $114dc6546d5af90f$var$matchesSelectorAndParentsTo(el, selector, baseNode) /*: boolean*/ {
    var node = el;
    do {
        if ($114dc6546d5af90f$var$matchesSelector(node, selector)) return true;
        if (node === baseNode) return false;
        node = node.parentNode;
    }while (node);
    return false;
}
function $114dc6546d5af90f$var$addEvent(el, event, handler, inputOptions) /*: void*/ {
    if (!el) return;
    var options = $114dc6546d5af90f$var$_objectSpread({
        capture: true
    }, inputOptions); // $FlowIgnore[method-unbinding]
    if (el.addEventListener) el.addEventListener(event, handler, options);
    else if (el.attachEvent) el.attachEvent("on" + event, handler);
    else // $FlowIgnore: Doesn't think elements are indexable
    el["on" + event] = handler;
}
function $114dc6546d5af90f$var$removeEvent(el, event, handler, inputOptions) /*: void*/ {
    if (!el) return;
    var options = $114dc6546d5af90f$var$_objectSpread({
        capture: true
    }, inputOptions); // $FlowIgnore[method-unbinding]
    if (el.removeEventListener) el.removeEventListener(event, handler, options);
    else if (el.detachEvent) el.detachEvent("on" + event, handler);
    else // $FlowIgnore: Doesn't think elements are indexable
    el["on" + event] = null;
}
function $114dc6546d5af90f$var$outerHeight(node) /*: number*/ {
    // This is deliberately excluding margin for our calculations, since we are using
    // offsetTop which is including margin. See getBoundPosition
    var height = node.clientHeight;
    var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height += (0, $3jnBc.int)(computedStyle.borderTopWidth);
    height += (0, $3jnBc.int)(computedStyle.borderBottomWidth);
    return height;
}
function $114dc6546d5af90f$var$outerWidth(node) /*: number*/ {
    // This is deliberately excluding margin for our calculations, since we are using
    // offsetLeft which is including margin. See getBoundPosition
    var width = node.clientWidth;
    var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width += (0, $3jnBc.int)(computedStyle.borderLeftWidth);
    width += (0, $3jnBc.int)(computedStyle.borderRightWidth);
    return width;
}
function $114dc6546d5af90f$var$innerHeight(node) /*: number*/ {
    var height = node.clientHeight;
    var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    height -= (0, $3jnBc.int)(computedStyle.paddingTop);
    height -= (0, $3jnBc.int)(computedStyle.paddingBottom);
    return height;
}
function $114dc6546d5af90f$var$innerWidth(node) /*: number*/ {
    var width = node.clientWidth;
    var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
    width -= (0, $3jnBc.int)(computedStyle.paddingLeft);
    width -= (0, $3jnBc.int)(computedStyle.paddingRight);
    return width;
}
/*:: interface EventWithOffset {
  clientX: number, clientY: number
}*/ // Get from offsetParent
function $114dc6546d5af90f$var$offsetXYFromParent(evt, offsetParent, scale) /*: ControlPosition*/ {
    var isBody = offsetParent === offsetParent.ownerDocument.body;
    var offsetParentRect = isBody ? {
        left: 0,
        top: 0
    } : offsetParent.getBoundingClientRect();
    var x = (evt.clientX + offsetParent.scrollLeft - offsetParentRect.left) / scale;
    var y = (evt.clientY + offsetParent.scrollTop - offsetParentRect.top) / scale;
    return {
        x: x,
        y: y
    };
}
function $114dc6546d5af90f$var$createCSSTransform(controlPos, positionOffset) /*: Object*/ {
    var translation = $114dc6546d5af90f$var$getTranslation(controlPos, positionOffset, "px");
    return $114dc6546d5af90f$var$_defineProperty({}, (0, $114dc6546d5af90f$var$_getPrefix.browserPrefixToKey)("transform", $114dc6546d5af90f$var$_getPrefix.default), translation);
}
function $114dc6546d5af90f$var$createSVGTransform(controlPos, positionOffset) /*: string*/ {
    var translation = $114dc6546d5af90f$var$getTranslation(controlPos, positionOffset, "");
    return translation;
}
function $114dc6546d5af90f$var$getTranslation(_ref2, positionOffset, unitSuffix) /*: string*/ {
    var x = _ref2.x, y = _ref2.y;
    var translation = "translate(".concat(x).concat(unitSuffix, ",").concat(y).concat(unitSuffix, ")");
    if (positionOffset) {
        var defaultX = "".concat(typeof positionOffset.x === "string" ? positionOffset.x : positionOffset.x + unitSuffix);
        var defaultY = "".concat(typeof positionOffset.y === "string" ? positionOffset.y : positionOffset.y + unitSuffix);
        translation = "translate(".concat(defaultX, ", ").concat(defaultY, ")") + translation;
    }
    return translation;
}
function $114dc6546d5af90f$var$getTouch(e, identifier) /*: ?{clientX: number, clientY: number}*/ {
    return e.targetTouches && (0, $3jnBc.findInArray)(e.targetTouches, function(t) {
        return identifier === t.identifier;
    }) || e.changedTouches && (0, $3jnBc.findInArray)(e.changedTouches, function(t) {
        return identifier === t.identifier;
    });
}
function $114dc6546d5af90f$var$getTouchIdentifier(e) /*: ?number*/ {
    if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
    if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
} // User-select Hacks:
//
// Useful for preventing blue highlights all over everything when dragging.
// Note we're passing `document` b/c we could be iframed
function $114dc6546d5af90f$var$addUserSelectStyles(doc) {
    if (!doc) return;
    var styleEl = doc.getElementById("react-draggable-style-el");
    if (!styleEl) {
        styleEl = doc.createElement("style");
        styleEl.type = "text/css";
        styleEl.id = "react-draggable-style-el";
        styleEl.innerHTML = ".react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n";
        styleEl.innerHTML += ".react-draggable-transparent-selection *::selection {all: inherit;}\n";
        doc.getElementsByTagName("head")[0].appendChild(styleEl);
    }
    if (doc.body) $114dc6546d5af90f$var$addClassName(doc.body, "react-draggable-transparent-selection");
}
function $114dc6546d5af90f$var$removeUserSelectStyles(doc) {
    if (!doc) return;
    try {
        if (doc.body) $114dc6546d5af90f$var$removeClassName(doc.body, "react-draggable-transparent-selection"); // $FlowIgnore: IE
        if (doc.selection) // $FlowIgnore: IE
        doc.selection.empty();
        else {
            // Remove selection caused by scroll, unless it's a focused input
            // (we use doc.defaultView in case we're in an iframe)
            var selection = (doc.defaultView || window).getSelection();
            if (selection && selection.type !== "Caret") selection.removeAllRanges();
        }
    } catch (e) {}
}
function $114dc6546d5af90f$var$addClassName(el, className) {
    if (el.classList) el.classList.add(className);
    else if (!el.className.match(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)")))) el.className += " ".concat(className);
}
function $114dc6546d5af90f$var$removeClassName(el, className) {
    if (el.classList) el.classList.remove(className);
    else el.className = el.className.replace(new RegExp("(?:^|\\s)".concat(className, "(?!\\S)"), "g"), "");
}

});
parcelRegister("3jnBc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dontSetMe = $269573bc97375b06$var$dontSetMe;
module.exports.findInArray = $269573bc97375b06$var$findInArray;
module.exports.int = $269573bc97375b06$var$int;
module.exports.isFunction = $269573bc97375b06$var$isFunction;
module.exports.isNum = $269573bc97375b06$var$isNum;
// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
function $269573bc97375b06$var$findInArray(array, callback) /*: any*/ {
    for(var i = 0, length = array.length; i < length; i++){
        if (callback.apply(callback, [
            array[i],
            i,
            array
        ])) return array[i];
    }
}
function $269573bc97375b06$var$isFunction(func) /*: boolean %checks*/ {
    // $FlowIgnore[method-unbinding]
    return typeof func === "function" || Object.prototype.toString.call(func) === "[object Function]";
}
function $269573bc97375b06$var$isNum(num) /*: boolean %checks*/ {
    return typeof num === "number" && !isNaN(num);
}
function $269573bc97375b06$var$int(a) /*: number*/ {
    return parseInt(a, 10);
}
function $269573bc97375b06$var$dontSetMe(props, propName, componentName) /*: ?Error*/ {
    if (props[propName]) return new Error("Invalid prop ".concat(propName, " passed to ").concat(componentName, " - do not set this, set it on the child."));
}

});

parcelRegister("8Hmnt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.browserPrefixToKey = $6553b2a09c1a5edb$var$browserPrefixToKey;
module.exports.browserPrefixToStyle = $6553b2a09c1a5edb$var$browserPrefixToStyle;
module.exports.default = void 0;
module.exports.getPrefix = $6553b2a09c1a5edb$var$getPrefix;
var $6553b2a09c1a5edb$var$prefixes = [
    "Moz",
    "Webkit",
    "O",
    "ms"
];
function $6553b2a09c1a5edb$var$getPrefix() /*: string*/ {
    var _window$document, _window$document$docu;
    var prop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "transform";
    // Ensure we're running in an environment where there is actually a global
    // `window` obj
    if (typeof window === "undefined") return ""; // If we're in a pseudo-browser server-side environment, this access
    // path may not exist, so bail out if it doesn't.
    var style = (_window$document = window.document) === null || _window$document === void 0 ? void 0 : (_window$document$docu = _window$document.documentElement) === null || _window$document$docu === void 0 ? void 0 : _window$document$docu.style;
    if (!style) return "";
    if (prop in style) return "";
    for(var i = 0; i < $6553b2a09c1a5edb$var$prefixes.length; i++){
        if ($6553b2a09c1a5edb$var$browserPrefixToKey(prop, $6553b2a09c1a5edb$var$prefixes[i]) in style) return $6553b2a09c1a5edb$var$prefixes[i];
    }
    return "";
}
function $6553b2a09c1a5edb$var$browserPrefixToKey(prop, prefix) /*: string*/ {
    return prefix ? "".concat(prefix).concat($6553b2a09c1a5edb$var$kebabToTitleCase(prop)) : prop;
}
function $6553b2a09c1a5edb$var$browserPrefixToStyle(prop, prefix) /*: string*/ {
    return prefix ? "-".concat(prefix.toLowerCase(), "-").concat(prop) : prop;
}
function $6553b2a09c1a5edb$var$kebabToTitleCase(str) /*: string*/ {
    var out = "";
    var shouldCapitalize = true;
    for(var i = 0; i < str.length; i++){
        if (shouldCapitalize) {
            out += str[i].toUpperCase();
            shouldCapitalize = false;
        } else if (str[i] === "-") shouldCapitalize = true;
        else out += str[i];
    }
    return out;
} // Default export is the prefix itself, like 'Moz', 'Webkit', etc
// Note that you may have to re-test for certain things; for instance, Chrome 50
// can handle unprefixed `transform`, but not unprefixed `user-select`
var $6553b2a09c1a5edb$var$_default = $6553b2a09c1a5edb$var$getPrefix();
module.exports.default = $6553b2a09c1a5edb$var$_default;

});


parcelRegister("9xeV2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.canDragX = $6f12c4b1dc410d92$var$canDragX;
module.exports.canDragY = $6f12c4b1dc410d92$var$canDragY;
module.exports.createCoreData = $6f12c4b1dc410d92$var$createCoreData;
module.exports.createDraggableData = $6f12c4b1dc410d92$var$createDraggableData;
module.exports.getBoundPosition = $6f12c4b1dc410d92$var$getBoundPosition;
module.exports.getControlPosition = $6f12c4b1dc410d92$var$getControlPosition;
module.exports.snapToGrid = $6f12c4b1dc410d92$var$snapToGrid;

var $3jnBc = parcelRequire("3jnBc");

var $1u6Ge = parcelRequire("1u6Ge");
function $6f12c4b1dc410d92$var$getBoundPosition(draggable, x, y) /*: [number, number]*/ {
    // If no bounds, short-circuit and move on
    if (!draggable.props.bounds) return [
        x,
        y
    ]; // Clone new bounds
    var bounds = draggable.props.bounds;
    bounds = typeof bounds === "string" ? bounds : $6f12c4b1dc410d92$var$cloneBounds(bounds);
    var node = $6f12c4b1dc410d92$var$findDOMNode(draggable);
    if (typeof bounds === "string") {
        var ownerDocument = node.ownerDocument;
        var ownerWindow = ownerDocument.defaultView;
        var boundNode;
        if (bounds === "parent") boundNode = node.parentNode;
        else boundNode = ownerDocument.querySelector(bounds);
        if (!(boundNode instanceof ownerWindow.HTMLElement)) throw new Error('Bounds selector "' + bounds + '" could not find an element.');
        var boundNodeEl = boundNode; // for Flow, can't seem to refine correctly
        var nodeStyle = ownerWindow.getComputedStyle(node);
        var boundNodeStyle = ownerWindow.getComputedStyle(boundNodeEl); // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
        bounds = {
            left: -node.offsetLeft + (0, $3jnBc.int)(boundNodeStyle.paddingLeft) + (0, $3jnBc.int)(nodeStyle.marginLeft),
            top: -node.offsetTop + (0, $3jnBc.int)(boundNodeStyle.paddingTop) + (0, $3jnBc.int)(nodeStyle.marginTop),
            right: (0, $1u6Ge.innerWidth)(boundNodeEl) - (0, $1u6Ge.outerWidth)(node) - node.offsetLeft + (0, $3jnBc.int)(boundNodeStyle.paddingRight) - (0, $3jnBc.int)(nodeStyle.marginRight),
            bottom: (0, $1u6Ge.innerHeight)(boundNodeEl) - (0, $1u6Ge.outerHeight)(node) - node.offsetTop + (0, $3jnBc.int)(boundNodeStyle.paddingBottom) - (0, $3jnBc.int)(nodeStyle.marginBottom)
        };
    } // Keep x and y below right and bottom limits...
    if ((0, $3jnBc.isNum)(bounds.right)) x = Math.min(x, bounds.right);
    if ((0, $3jnBc.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom); // But above left and top limits.
    if ((0, $3jnBc.isNum)(bounds.left)) x = Math.max(x, bounds.left);
    if ((0, $3jnBc.isNum)(bounds.top)) y = Math.max(y, bounds.top);
    return [
        x,
        y
    ];
}
function $6f12c4b1dc410d92$var$snapToGrid(grid, pendingX, pendingY) /*: [number, number]*/ {
    var x = Math.round(pendingX / grid[0]) * grid[0];
    var y = Math.round(pendingY / grid[1]) * grid[1];
    return [
        x,
        y
    ];
}
function $6f12c4b1dc410d92$var$canDragX(draggable) /*: boolean*/ {
    return draggable.props.axis === "both" || draggable.props.axis === "x";
}
function $6f12c4b1dc410d92$var$canDragY(draggable) /*: boolean*/ {
    return draggable.props.axis === "both" || draggable.props.axis === "y";
} // Get {x, y} positions from event.
function $6f12c4b1dc410d92$var$getControlPosition(e, touchIdentifier, draggableCore) /*: ?ControlPosition*/ {
    var touchObj = typeof touchIdentifier === "number" ? (0, $1u6Ge.getTouch)(e, touchIdentifier) : null;
    if (typeof touchIdentifier === "number" && !touchObj) return null; // not the right touch
    var node = $6f12c4b1dc410d92$var$findDOMNode(draggableCore); // User can provide an offsetParent if desired.
    var offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
    return (0, $1u6Ge.offsetXYFromParent)(touchObj || e, offsetParent, draggableCore.props.scale);
} // Create an data object exposed by <DraggableCore>'s events
function $6f12c4b1dc410d92$var$createCoreData(draggable, x, y) /*: DraggableData*/ {
    var state = draggable.state;
    var isStart = !(0, $3jnBc.isNum)(state.lastX);
    var node = $6f12c4b1dc410d92$var$findDOMNode(draggable);
    if (isStart) // If this is our first move, use the x and y as last coords.
    return {
        node: node,
        deltaX: 0,
        deltaY: 0,
        lastX: x,
        lastY: y,
        x: x,
        y: y
    };
    else // Otherwise calculate proper values.
    return {
        node: node,
        deltaX: x - state.lastX,
        deltaY: y - state.lastY,
        lastX: state.lastX,
        lastY: state.lastY,
        x: x,
        y: y
    };
} // Create an data exposed by <Draggable>'s events
function $6f12c4b1dc410d92$var$createDraggableData(draggable, coreData) /*: DraggableData*/ {
    var scale = draggable.props.scale;
    return {
        node: coreData.node,
        x: draggable.state.x + coreData.deltaX / scale,
        y: draggable.state.y + coreData.deltaY / scale,
        deltaX: coreData.deltaX / scale,
        deltaY: coreData.deltaY / scale,
        lastX: draggable.state.x,
        lastY: draggable.state.y
    };
} // A lot faster than stringify/parse
function $6f12c4b1dc410d92$var$cloneBounds(bounds) /*: Bounds*/ {
    return {
        left: bounds.left,
        top: bounds.top,
        right: bounds.right,
        bottom: bounds.bottom
    };
}
function $6f12c4b1dc410d92$var$findDOMNode(draggable) /*: HTMLElement*/ {
    var node = draggable.findDOMNode();
    if (!node) throw new Error("<DraggableCore>: Unmounted during event!");
     // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME
    return node;
}

});

parcelRegister("frbf6", function(module, exports) {
"use strict";
function $b3d219318c907d6c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $b3d219318c907d6c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $b3d219318c907d6c$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b3d219318c907d6c$var$React = $b3d219318c907d6c$var$_interopRequireWildcard((parcelRequire("2gcPZ")));

var $b3d219318c907d6c$var$_propTypes = $b3d219318c907d6c$var$_interopRequireDefault((parcelRequire("gArjD")));

var $b3d219318c907d6c$var$_reactDom = $b3d219318c907d6c$var$_interopRequireDefault((parcelRequire("fuyzp")));

var $1u6Ge = parcelRequire("1u6Ge");

var $9xeV2 = parcelRequire("9xeV2");

var $3jnBc = parcelRequire("3jnBc");

var $b3d219318c907d6c$var$_log = $b3d219318c907d6c$var$_interopRequireDefault((parcelRequire("kCQwh")));
function $b3d219318c907d6c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b3d219318c907d6c$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($b3d219318c907d6c$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $b3d219318c907d6c$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $b3d219318c907d6c$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $b3d219318c907d6c$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $b3d219318c907d6c$var$_slicedToArray(arr, i) {
    return $b3d219318c907d6c$var$_arrayWithHoles(arr) || $b3d219318c907d6c$var$_iterableToArrayLimit(arr, i) || $b3d219318c907d6c$var$_unsupportedIterableToArray(arr, i) || $b3d219318c907d6c$var$_nonIterableRest();
}
function $b3d219318c907d6c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b3d219318c907d6c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b3d219318c907d6c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b3d219318c907d6c$var$_arrayLikeToArray(o, minLen);
}
function $b3d219318c907d6c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b3d219318c907d6c$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $b3d219318c907d6c$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $b3d219318c907d6c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b3d219318c907d6c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $b3d219318c907d6c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b3d219318c907d6c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b3d219318c907d6c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $b3d219318c907d6c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $b3d219318c907d6c$var$_setPrototypeOf(subClass, superClass);
}
function $b3d219318c907d6c$var$_setPrototypeOf(o, p) {
    $b3d219318c907d6c$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b3d219318c907d6c$var$_setPrototypeOf(o, p);
}
function $b3d219318c907d6c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $b3d219318c907d6c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $b3d219318c907d6c$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $b3d219318c907d6c$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $b3d219318c907d6c$var$_possibleConstructorReturn(this, result);
    };
}
function $b3d219318c907d6c$var$_possibleConstructorReturn(self, call) {
    if (call && ($b3d219318c907d6c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $b3d219318c907d6c$var$_assertThisInitialized(self);
}
function $b3d219318c907d6c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $b3d219318c907d6c$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $b3d219318c907d6c$var$_getPrototypeOf(o) {
    $b3d219318c907d6c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $b3d219318c907d6c$var$_getPrototypeOf(o);
}
function $b3d219318c907d6c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// Simple abstraction for dragging events names.
var $b3d219318c907d6c$var$eventsFor = {
    touch: {
        start: "touchstart",
        move: "touchmove",
        stop: "touchend"
    },
    mouse: {
        start: "mousedown",
        move: "mousemove",
        stop: "mouseup"
    }
}; // Default to mouse events.
var $b3d219318c907d6c$var$dragEventFor = $b3d219318c907d6c$var$eventsFor.mouse;
/*:: type DraggableCoreState = {
  dragging: boolean,
  lastX: number,
  lastY: number,
  touchIdentifier: ?number
};*/ /*:: export type DraggableData = {
  node: HTMLElement,
  x: number, y: number,
  deltaX: number, deltaY: number,
  lastX: number, lastY: number,
};*/ /*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void | false;*/ /*:: export type ControlPosition = {x: number, y: number};*/ /*:: export type PositionOffsetControlPosition = {x: number|string, y: number|string};*/ /*:: export type DraggableCoreDefaultProps = {
  allowAnyClick: boolean,
  disabled: boolean,
  enableUserSelectHack: boolean,
  onStart: DraggableEventHandler,
  onDrag: DraggableEventHandler,
  onStop: DraggableEventHandler,
  onMouseDown: (e: MouseEvent) => void,
  scale: number,
};*/ /*:: export type DraggableCoreProps = {
  ...DraggableCoreDefaultProps,
  cancel: string,
  children: ReactElement<any>,
  offsetParent: HTMLElement,
  grid: [number, number],
  handle: string,
  nodeRef?: ?React.ElementRef<any>,
};*/ //
// Define <DraggableCore>.
//
// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
// work well with libraries that require more control over the element.
//
var $b3d219318c907d6c$var$DraggableCore = /*#__PURE__*/ function(_React$Component) {
    $b3d219318c907d6c$var$_inherits(DraggableCore, _React$Component);
    var _super = $b3d219318c907d6c$var$_createSuper(DraggableCore);
    function DraggableCore() {
        var _this;
        $b3d219318c907d6c$var$_classCallCheck(this, DraggableCore);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $b3d219318c907d6c$var$_defineProperty($b3d219318c907d6c$var$_assertThisInitialized(_this), "state", {
            dragging: false,
            // Used while dragging to determine deltas.
            lastX: NaN,
            lastY: NaN,
            touchIdentifier: null
        });
        $b3d219318c907d6c$var$_defineProperty($b3d219318c907d6c$var$_assertThisInitialized(_this), "mounted", false);
        $b3d219318c907d6c$var$_defineProperty($b3d219318c907d6c$var$_assertThisInitialized(_this), "handleDragStart", function(e) {
            // Make it possible to attach event handlers on top of this one.
            _this.props.onMouseDown(e); // Only accept left-clicks.
            if (!_this.props.allowAnyClick && typeof e.button === "number" && e.button !== 0) return false; // Get nodes. Be sure to grab relative document (could be iframed)
            var thisNode = _this.findDOMNode();
            if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) throw new Error("<DraggableCore> not mounted on DragStart!");
            var ownerDocument = thisNode.ownerDocument; // Short circuit if handle or cancel prop was provided and selector doesn't match.
            if (_this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || _this.props.handle && !(0, $1u6Ge.matchesSelectorAndParentsTo)(e.target, _this.props.handle, thisNode) || _this.props.cancel && (0, $1u6Ge.matchesSelectorAndParentsTo)(e.target, _this.props.cancel, thisNode)) return;
             // Prevent scrolling on mobile devices, like ipad/iphone.
            // Important that this is after handle/cancel.
            if (e.type === "touchstart") e.preventDefault(); // Set touch identifier in component state if this is a touch event. This allows us to
            // distinguish between individual touches on multitouch screens by identifying which
            // touchpoint was set to this element.
            var touchIdentifier = (0, $1u6Ge.getTouchIdentifier)(e);
            _this.setState({
                touchIdentifier: touchIdentifier
            }); // Get the current drag point from the event. This is used as the offset.
            var position = (0, $9xeV2.getControlPosition)(e, touchIdentifier, $b3d219318c907d6c$var$_assertThisInitialized(_this));
            if (position == null) return; // not possible but satisfies flow
            var x = position.x, y = position.y; // Create an event object with all the data parents need to make a decision here.
            var coreEvent = (0, $9xeV2.createCoreData)($b3d219318c907d6c$var$_assertThisInitialized(_this), x, y);
            (0, $b3d219318c907d6c$var$_log.default)("DraggableCore: handleDragStart: %j", coreEvent); // Call event handler. If it returns explicit false, cancel.
            (0, $b3d219318c907d6c$var$_log.default)("calling", _this.props.onStart);
            var shouldUpdate = _this.props.onStart(e, coreEvent);
            if (shouldUpdate === false || _this.mounted === false) return; // Add a style to the body to disable user-select. This prevents text from
            // being selected all over the page.
            if (_this.props.enableUserSelectHack) (0, $1u6Ge.addUserSelectStyles)(ownerDocument); // Initiate dragging. Set the current x and y as offsets
            // so we know how much we've moved during the drag. This allows us
            // to drag elements around even if they have been moved, without issue.
            _this.setState({
                dragging: true,
                lastX: x,
                lastY: y
            }); // Add events to the document directly so we catch when the user's mouse/touch moves outside of
            // this element. We use different events depending on whether or not we have detected that this
            // is a touch-capable device.
            (0, $1u6Ge.addEvent)(ownerDocument, $b3d219318c907d6c$var$dragEventFor.move, _this.handleDrag);
            (0, $1u6Ge.addEvent)(ownerDocument, $b3d219318c907d6c$var$dragEventFor.stop, _this.handleDragStop);
        });
        $b3d219318c907d6c$var$_defineProperty($b3d219318c907d6c$var$_assertThisInitialized(_this), "handleDrag", function(e) {
            // Get the current drag point from the event. This is used as the offset.
            var position = (0, $9xeV2.getControlPosition)(e, _this.state.touchIdentifier, $b3d219318c907d6c$var$_assertThisInitialized(_this));
            if (position == null) return;
            var x = position.x, y = position.y; // Snap to grid if prop has been provided
            if (Array.isArray(_this.props.grid)) {
                var deltaX = x - _this.state.lastX, deltaY = y - _this.state.lastY;
                var _snapToGrid = (0, $9xeV2.snapToGrid)(_this.props.grid, deltaX, deltaY);
                var _snapToGrid2 = $b3d219318c907d6c$var$_slicedToArray(_snapToGrid, 2);
                deltaX = _snapToGrid2[0];
                deltaY = _snapToGrid2[1];
                if (!deltaX && !deltaY) return; // skip useless drag
                x = _this.state.lastX + deltaX, y = _this.state.lastY + deltaY;
            }
            var coreEvent = (0, $9xeV2.createCoreData)($b3d219318c907d6c$var$_assertThisInitialized(_this), x, y);
            (0, $b3d219318c907d6c$var$_log.default)("DraggableCore: handleDrag: %j", coreEvent); // Call event handler. If it returns explicit false, trigger end.
            var shouldUpdate = _this.props.onDrag(e, coreEvent);
            if (shouldUpdate === false || _this.mounted === false) {
                try {
                    // $FlowIgnore
                    _this.handleDragStop(new MouseEvent("mouseup"));
                } catch (err) {
                    // Old browsers
                    var event = document.createEvent("MouseEvents"); // I see why this insanity was deprecated
                    // $FlowIgnore
                    event.initMouseEvent("mouseup", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                    _this.handleDragStop(event);
                }
                return;
            }
            _this.setState({
                lastX: x,
                lastY: y
            });
        });
        $b3d219318c907d6c$var$_defineProperty($b3d219318c907d6c$var$_assertThisInitialized(_this), "handleDragStop", function(e) {
            if (!_this.state.dragging) return;
            var position = (0, $9xeV2.getControlPosition)(e, _this.state.touchIdentifier, $b3d219318c907d6c$var$_assertThisInitialized(_this));
            if (position == null) return;
            var x = position.x, y = position.y; // Snap to grid if prop has been provided
            if (Array.isArray(_this.props.grid)) {
                var deltaX = x - _this.state.lastX || 0;
                var deltaY = y - _this.state.lastY || 0;
                var _snapToGrid3 = (0, $9xeV2.snapToGrid)(_this.props.grid, deltaX, deltaY);
                var _snapToGrid4 = $b3d219318c907d6c$var$_slicedToArray(_snapToGrid3, 2);
                deltaX = _snapToGrid4[0];
                deltaY = _snapToGrid4[1];
                x = _this.state.lastX + deltaX, y = _this.state.lastY + deltaY;
            }
            var coreEvent = (0, $9xeV2.createCoreData)($b3d219318c907d6c$var$_assertThisInitialized(_this), x, y); // Call event handler
            var shouldContinue = _this.props.onStop(e, coreEvent);
            if (shouldContinue === false || _this.mounted === false) return false;
            var thisNode = _this.findDOMNode();
            if (thisNode) // Remove user-select hack
            {
                if (_this.props.enableUserSelectHack) (0, $1u6Ge.removeUserSelectStyles)(thisNode.ownerDocument);
            }
            (0, $b3d219318c907d6c$var$_log.default)("DraggableCore: handleDragStop: %j", coreEvent); // Reset the el.
            _this.setState({
                dragging: false,
                lastX: NaN,
                lastY: NaN
            });
            if (thisNode) {
                // Remove event handlers
                (0, $b3d219318c907d6c$var$_log.default)("DraggableCore: Removing handlers");
                (0, $1u6Ge.removeEvent)(thisNode.ownerDocument, $b3d219318c907d6c$var$dragEventFor.move, _this.handleDrag);
                (0, $1u6Ge.removeEvent)(thisNode.ownerDocument, $b3d219318c907d6c$var$dragEventFor.stop, _this.handleDragStop);
            }
        });
        $b3d219318c907d6c$var$_defineProperty($b3d219318c907d6c$var$_assertThisInitialized(_this), "onMouseDown", function(e) {
            $b3d219318c907d6c$var$dragEventFor = $b3d219318c907d6c$var$eventsFor.mouse; // on touchscreen laptops we could switch back to mouse
            return _this.handleDragStart(e);
        });
        $b3d219318c907d6c$var$_defineProperty($b3d219318c907d6c$var$_assertThisInitialized(_this), "onMouseUp", function(e) {
            $b3d219318c907d6c$var$dragEventFor = $b3d219318c907d6c$var$eventsFor.mouse;
            return _this.handleDragStop(e);
        });
        $b3d219318c907d6c$var$_defineProperty($b3d219318c907d6c$var$_assertThisInitialized(_this), "onTouchStart", function(e) {
            // We're on a touch device now, so change the event handlers
            $b3d219318c907d6c$var$dragEventFor = $b3d219318c907d6c$var$eventsFor.touch;
            return _this.handleDragStart(e);
        });
        $b3d219318c907d6c$var$_defineProperty($b3d219318c907d6c$var$_assertThisInitialized(_this), "onTouchEnd", function(e) {
            // We're on a touch device now, so change the event handlers
            $b3d219318c907d6c$var$dragEventFor = $b3d219318c907d6c$var$eventsFor.touch;
            return _this.handleDragStop(e);
        });
        return _this;
    }
    $b3d219318c907d6c$var$_createClass(DraggableCore, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.mounted = true; // Touch handlers must be added with {passive: false} to be cancelable.
                // https://developers.google.com/web/updates/2017/01/scrolling-intervention
                var thisNode = this.findDOMNode();
                if (thisNode) (0, $1u6Ge.addEvent)(thisNode, $b3d219318c907d6c$var$eventsFor.touch.start, this.onTouchStart, {
                    passive: false
                });
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mounted = false; // Remove any leftover event handlers. Remove both touch and mouse handlers in case
                // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
                var thisNode = this.findDOMNode();
                if (thisNode) {
                    var ownerDocument = thisNode.ownerDocument;
                    (0, $1u6Ge.removeEvent)(ownerDocument, $b3d219318c907d6c$var$eventsFor.mouse.move, this.handleDrag);
                    (0, $1u6Ge.removeEvent)(ownerDocument, $b3d219318c907d6c$var$eventsFor.touch.move, this.handleDrag);
                    (0, $1u6Ge.removeEvent)(ownerDocument, $b3d219318c907d6c$var$eventsFor.mouse.stop, this.handleDragStop);
                    (0, $1u6Ge.removeEvent)(ownerDocument, $b3d219318c907d6c$var$eventsFor.touch.stop, this.handleDragStop);
                    (0, $1u6Ge.removeEvent)(thisNode, $b3d219318c907d6c$var$eventsFor.touch.start, this.onTouchStart, {
                        passive: false
                    });
                    if (this.props.enableUserSelectHack) (0, $1u6Ge.removeUserSelectStyles)(ownerDocument);
                }
            } // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
        },
        {
            key: "findDOMNode",
            value: function findDOMNode() /*: ?HTMLElement*/ {
                var _this$props, _this$props2, _this$props2$nodeRef;
                return (_this$props = this.props) !== null && _this$props !== void 0 && _this$props.nodeRef ? (_this$props2 = this.props) === null || _this$props2 === void 0 ? void 0 : (_this$props2$nodeRef = _this$props2.nodeRef) === null || _this$props2$nodeRef === void 0 ? void 0 : _this$props2$nodeRef.current : $b3d219318c907d6c$var$_reactDom.default.findDOMNode(this);
            }
        },
        {
            key: "render",
            value: function render() /*: React.Element<any>*/ {
                // Reuse the child provided
                // This makes it flexible to use whatever element is wanted (div, ul, etc)
                return /*#__PURE__*/ $b3d219318c907d6c$var$React.cloneElement($b3d219318c907d6c$var$React.Children.only(this.props.children), {
                    // Note: mouseMove handler is attached to document so it will still function
                    // when the user drags quickly and leaves the bounds of the element.
                    onMouseDown: this.onMouseDown,
                    onMouseUp: this.onMouseUp,
                    // onTouchStart is added on `componentDidMount` so they can be added with
                    // {passive: false}, which allows it to cancel. See
                    // https://developers.google.com/web/updates/2017/01/scrolling-intervention
                    onTouchEnd: this.onTouchEnd
                });
            }
        }
    ]);
    return DraggableCore;
}($b3d219318c907d6c$var$React.Component);
module.exports.default = $b3d219318c907d6c$var$DraggableCore;
$b3d219318c907d6c$var$_defineProperty($b3d219318c907d6c$var$DraggableCore, "displayName", "DraggableCore");
$b3d219318c907d6c$var$_defineProperty($b3d219318c907d6c$var$DraggableCore, "propTypes", {
    /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */ allowAnyClick: $b3d219318c907d6c$var$_propTypes.default.bool,
    /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */ disabled: $b3d219318c907d6c$var$_propTypes.default.bool,
    /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */ enableUserSelectHack: $b3d219318c907d6c$var$_propTypes.default.bool,
    /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */ offsetParent: function offsetParent(props, propName) {
        if (props[propName] && props[propName].nodeType !== 1) throw new Error("Draggable's offsetParent must be a DOM Node.");
    },
    /**
   * `grid` specifies the x and y that dragging should snap to.
   */ grid: $b3d219318c907d6c$var$_propTypes.default.arrayOf($b3d219318c907d6c$var$_propTypes.default.number),
    /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */ handle: $b3d219318c907d6c$var$_propTypes.default.string,
    /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */ cancel: $b3d219318c907d6c$var$_propTypes.default.string,
    /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */ nodeRef: $b3d219318c907d6c$var$_propTypes.default.object,
    /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */ onStart: $b3d219318c907d6c$var$_propTypes.default.func,
    /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */ onDrag: $b3d219318c907d6c$var$_propTypes.default.func,
    /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */ onStop: $b3d219318c907d6c$var$_propTypes.default.func,
    /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */ onMouseDown: $b3d219318c907d6c$var$_propTypes.default.func,
    /**
   * `scale`, if set, applies scaling while dragging an element
   */ scale: $b3d219318c907d6c$var$_propTypes.default.number,
    /**
   * These properties should be defined on the child, not here.
   */ className: $3jnBc.dontSetMe,
    style: $3jnBc.dontSetMe,
    transform: $3jnBc.dontSetMe
});
$b3d219318c907d6c$var$_defineProperty($b3d219318c907d6c$var$DraggableCore, "defaultProps", {
    allowAnyClick: false,
    // by default only accept left click
    disabled: false,
    enableUserSelectHack: true,
    onStart: function onStart() {},
    onDrag: function onDrag() {},
    onStop: function onStop() {},
    onMouseDown: function onMouseDown() {},
    scale: 1
});

});
parcelRegister("kCQwh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f040188eb69862c4$var$log;
/*eslint no-console:0*/ function $f040188eb69862c4$var$log() {
    var _console;
}

});




parcelRegister("6mLez", function(module, exports) {

$parcel$export(module.exports, "cloneElement", () => $4a296fdb9e26db80$export$e530037191fcd5d7, (v) => $4a296fdb9e26db80$export$e530037191fcd5d7 = v);
var $4a296fdb9e26db80$export$1e511d4a378977f5;
var $4a296fdb9e26db80$export$e530037191fcd5d7;
"use strict";
$4a296fdb9e26db80$export$1e511d4a378977f5 = true;
$4a296fdb9e26db80$export$e530037191fcd5d7 = $4a296fdb9e26db80$var$cloneElement;

var $4a296fdb9e26db80$var$_react = $4a296fdb9e26db80$var$_interopRequireDefault((parcelRequire("2gcPZ")));
function $4a296fdb9e26db80$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4a296fdb9e26db80$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4a296fdb9e26db80$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $4a296fdb9e26db80$var$ownKeys(Object(source), !0).forEach(function(key) {
            $4a296fdb9e26db80$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $4a296fdb9e26db80$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4a296fdb9e26db80$var$_defineProperty(obj, key, value) {
    key = $4a296fdb9e26db80$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4a296fdb9e26db80$var$_toPropertyKey(arg) {
    var key = $4a296fdb9e26db80$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $4a296fdb9e26db80$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
// React.addons.cloneWithProps look-alike that merges style & className.
function $4a296fdb9e26db80$var$cloneElement(element, props) {
    if (props.style && element.props.style) props.style = $4a296fdb9e26db80$var$_objectSpread($4a296fdb9e26db80$var$_objectSpread({}, element.props.style), props.style);
    if (props.className && element.props.className) props.className = element.props.className + " " + props.className;
    return /*#__PURE__*/ $4a296fdb9e26db80$var$_react.default.cloneElement(element, props);
}

});

parcelRegister("1xZa5", function(module, exports) {

$parcel$export(module.exports, "resizableProps", () => $120850f5f56a6152$export$32a002ec6a601762, (v) => $120850f5f56a6152$export$32a002ec6a601762 = v);
var $120850f5f56a6152$export$1e511d4a378977f5;
var $120850f5f56a6152$export$32a002ec6a601762;
"use strict";
$120850f5f56a6152$export$1e511d4a378977f5 = true;
$120850f5f56a6152$export$32a002ec6a601762 = void 0;

var $120850f5f56a6152$var$_propTypes = $120850f5f56a6152$var$_interopRequireDefault((parcelRequire("gArjD")));
parcelRequire("j2iUf");
function $120850f5f56a6152$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $120850f5f56a6152$var$resizableProps = {
    /*
  * Restricts resizing to a particular axis (default: 'both')
  * 'both' - allows resizing by width or height
  * 'x' - only allows the width to be changed
  * 'y' - only allows the height to be changed
  * 'none' - disables resizing altogether
  * */ axis: $120850f5f56a6152$var$_propTypes.default.oneOf([
        "both",
        "x",
        "y",
        "none"
    ]),
    className: $120850f5f56a6152$var$_propTypes.default.string,
    /*
  * Require that one and only one child be present.
  * */ children: $120850f5f56a6152$var$_propTypes.default.element.isRequired,
    /*
  * These will be passed wholesale to react-draggable's DraggableCore
  * */ draggableOpts: $120850f5f56a6152$var$_propTypes.default.shape({
        allowAnyClick: $120850f5f56a6152$var$_propTypes.default.bool,
        cancel: $120850f5f56a6152$var$_propTypes.default.string,
        children: $120850f5f56a6152$var$_propTypes.default.node,
        disabled: $120850f5f56a6152$var$_propTypes.default.bool,
        enableUserSelectHack: $120850f5f56a6152$var$_propTypes.default.bool,
        offsetParent: $120850f5f56a6152$var$_propTypes.default.node,
        grid: $120850f5f56a6152$var$_propTypes.default.arrayOf($120850f5f56a6152$var$_propTypes.default.number),
        handle: $120850f5f56a6152$var$_propTypes.default.string,
        nodeRef: $120850f5f56a6152$var$_propTypes.default.object,
        onStart: $120850f5f56a6152$var$_propTypes.default.func,
        onDrag: $120850f5f56a6152$var$_propTypes.default.func,
        onStop: $120850f5f56a6152$var$_propTypes.default.func,
        onMouseDown: $120850f5f56a6152$var$_propTypes.default.func,
        scale: $120850f5f56a6152$var$_propTypes.default.number
    }),
    /*
  * Initial height
  * */ height: function height() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var props = args[0];
        // Required if resizing height or both
        if (props.axis === "both" || props.axis === "y") {
            var _PropTypes$number;
            return (_PropTypes$number = $120850f5f56a6152$var$_propTypes.default.number).isRequired.apply(_PropTypes$number, args);
        }
        return $120850f5f56a6152$var$_propTypes.default.number.apply($120850f5f56a6152$var$_propTypes.default, args);
    },
    /*
  * Customize cursor resize handle
  * */ handle: $120850f5f56a6152$var$_propTypes.default.oneOfType([
        $120850f5f56a6152$var$_propTypes.default.node,
        $120850f5f56a6152$var$_propTypes.default.func
    ]),
    /*
  * If you change this, be sure to update your css
  * */ handleSize: $120850f5f56a6152$var$_propTypes.default.arrayOf($120850f5f56a6152$var$_propTypes.default.number),
    lockAspectRatio: $120850f5f56a6152$var$_propTypes.default.bool,
    /*
  * Max X & Y measure
  * */ maxConstraints: $120850f5f56a6152$var$_propTypes.default.arrayOf($120850f5f56a6152$var$_propTypes.default.number),
    /*
  * Min X & Y measure
  * */ minConstraints: $120850f5f56a6152$var$_propTypes.default.arrayOf($120850f5f56a6152$var$_propTypes.default.number),
    /*
  * Called on stop resize event
  * */ onResizeStop: $120850f5f56a6152$var$_propTypes.default.func,
    /*
  * Called on start resize event
  * */ onResizeStart: $120850f5f56a6152$var$_propTypes.default.func,
    /*
  * Called on resize event
  * */ onResize: $120850f5f56a6152$var$_propTypes.default.func,
    /*
  * Defines which resize handles should be rendered (default: 'se')
  * 's' - South handle (bottom-center)
  * 'w' - West handle (left-center)
  * 'e' - East handle (right-center)
  * 'n' - North handle (top-center)
  * 'sw' - Southwest handle (bottom-left)
  * 'nw' - Northwest handle (top-left)
  * 'se' - Southeast handle (bottom-right)
  * 'ne' - Northeast handle (top-center)
  * */ resizeHandles: $120850f5f56a6152$var$_propTypes.default.arrayOf($120850f5f56a6152$var$_propTypes.default.oneOf([
        "s",
        "w",
        "e",
        "n",
        "sw",
        "nw",
        "se",
        "ne"
    ])),
    /*
  * If `transform: scale(n)` is set on the parent, this should be set to `n`.
  * */ transformScale: $120850f5f56a6152$var$_propTypes.default.number,
    /*
   * Initial width
   */ width: function width() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var props = args[0];
        // Required if resizing width or both
        if (props.axis === "both" || props.axis === "x") {
            var _PropTypes$number2;
            return (_PropTypes$number2 = $120850f5f56a6152$var$_propTypes.default.number).isRequired.apply(_PropTypes$number2, args);
        }
        return $120850f5f56a6152$var$_propTypes.default.number.apply($120850f5f56a6152$var$_propTypes.default, args);
    }
};
$120850f5f56a6152$export$32a002ec6a601762 = $120850f5f56a6152$var$resizableProps;

});


parcelRegister("gSv69", function(module, exports) {

$parcel$export(module.exports, "default", () => $c499cff103c0f7a9$export$2e2bcd8739ae039, (v) => $c499cff103c0f7a9$export$2e2bcd8739ae039 = v);
var $c499cff103c0f7a9$export$1e511d4a378977f5;
var $c499cff103c0f7a9$export$2e2bcd8739ae039;
"use strict";
$c499cff103c0f7a9$export$1e511d4a378977f5 = true;
$c499cff103c0f7a9$export$2e2bcd8739ae039 = void 0;

var $c499cff103c0f7a9$var$React = $c499cff103c0f7a9$var$_interopRequireWildcard((parcelRequire("2gcPZ")));

var $c499cff103c0f7a9$var$_propTypes = $c499cff103c0f7a9$var$_interopRequireDefault((parcelRequire("gArjD")));

var $c499cff103c0f7a9$var$_Resizable = $c499cff103c0f7a9$var$_interopRequireDefault((parcelRequire("iTIA1")));

var $1xZa5 = parcelRequire("1xZa5");
var $c499cff103c0f7a9$var$_excluded = [
    "handle",
    "handleSize",
    "onResize",
    "onResizeStart",
    "onResizeStop",
    "draggableOpts",
    "minConstraints",
    "maxConstraints",
    "lockAspectRatio",
    "axis",
    "width",
    "height",
    "resizeHandles",
    "style",
    "transformScale"
];
function $c499cff103c0f7a9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c499cff103c0f7a9$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($c499cff103c0f7a9$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $c499cff103c0f7a9$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $c499cff103c0f7a9$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $c499cff103c0f7a9$var$_extends() {
    $c499cff103c0f7a9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c499cff103c0f7a9$var$_extends.apply(this, arguments);
}
function $c499cff103c0f7a9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c499cff103c0f7a9$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c499cff103c0f7a9$var$ownKeys(Object(source), !0).forEach(function(key) {
            $c499cff103c0f7a9$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c499cff103c0f7a9$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c499cff103c0f7a9$var$_defineProperty(obj, key, value) {
    key = $c499cff103c0f7a9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c499cff103c0f7a9$var$_toPropertyKey(arg) {
    var key = $c499cff103c0f7a9$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $c499cff103c0f7a9$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $c499cff103c0f7a9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $c499cff103c0f7a9$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $c499cff103c0f7a9$var$_setPrototypeOf(subClass, superClass);
}
function $c499cff103c0f7a9$var$_setPrototypeOf(o, p) {
    $c499cff103c0f7a9$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c499cff103c0f7a9$var$_setPrototypeOf(o, p);
}
var $c499cff103c0f7a9$var$ResizableBox = /*#__PURE__*/ function(_React$Component) {
    $c499cff103c0f7a9$var$_inheritsLoose(ResizableBox, _React$Component);
    function ResizableBox() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.state = {
            width: _this.props.width,
            height: _this.props.height,
            propsWidth: _this.props.width,
            propsHeight: _this.props.height
        };
        _this.onResize = function(e, data) {
            var size = data.size;
            if (_this.props.onResize) {
                e.persist == null || e.persist();
                _this.setState(size, function() {
                    return _this.props.onResize && _this.props.onResize(e, data);
                });
            } else _this.setState(size);
        };
        return _this;
    }
    ResizableBox.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        // If parent changes height/width, set that in our state.
        if (state.propsWidth !== props.width || state.propsHeight !== props.height) return {
            width: props.width,
            height: props.height,
            propsWidth: props.width,
            propsHeight: props.height
        };
        return null;
    };
    var _proto = ResizableBox.prototype;
    _proto.render = function render() {
        // Basic wrapper around a Resizable instance.
        // If you use Resizable directly, you are responsible for updating the child component
        // with a new width and height.
        var _this$props = this.props, handle = _this$props.handle, handleSize = _this$props.handleSize, onResize = _this$props.onResize, onResizeStart = _this$props.onResizeStart, onResizeStop = _this$props.onResizeStop, draggableOpts = _this$props.draggableOpts, minConstraints = _this$props.minConstraints, maxConstraints = _this$props.maxConstraints, lockAspectRatio = _this$props.lockAspectRatio, axis = _this$props.axis, width = _this$props.width, height = _this$props.height, resizeHandles = _this$props.resizeHandles, style = _this$props.style, transformScale = _this$props.transformScale, props = $c499cff103c0f7a9$var$_objectWithoutPropertiesLoose(_this$props, $c499cff103c0f7a9$var$_excluded);
        return /*#__PURE__*/ $c499cff103c0f7a9$var$React.createElement($c499cff103c0f7a9$var$_Resizable.default, {
            axis: axis,
            draggableOpts: draggableOpts,
            handle: handle,
            handleSize: handleSize,
            height: this.state.height,
            lockAspectRatio: lockAspectRatio,
            maxConstraints: maxConstraints,
            minConstraints: minConstraints,
            onResizeStart: onResizeStart,
            onResize: this.onResize,
            onResizeStop: onResizeStop,
            resizeHandles: resizeHandles,
            transformScale: transformScale,
            width: this.state.width
        }, /*#__PURE__*/ $c499cff103c0f7a9$var$React.createElement("div", $c499cff103c0f7a9$var$_extends({}, props, {
            style: $c499cff103c0f7a9$var$_objectSpread($c499cff103c0f7a9$var$_objectSpread({}, style), {}, {
                width: this.state.width + "px",
                height: this.state.height + "px"
            })
        })));
    };
    return ResizableBox;
}($c499cff103c0f7a9$var$React.Component);
$c499cff103c0f7a9$export$2e2bcd8739ae039 = $c499cff103c0f7a9$var$ResizableBox;
// PropTypes are identical to <Resizable>, except that children are not strictly required to be present.
$c499cff103c0f7a9$var$ResizableBox.propTypes = $c499cff103c0f7a9$var$_objectSpread($c499cff103c0f7a9$var$_objectSpread({}, $1xZa5.resizableProps), {}, {
    children: $c499cff103c0f7a9$var$_propTypes.default.element
});

});

parcelRegister("lkU6W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2gcPZ = parcelRequire("2gcPZ");

var $bBRhx = parcelRequire("bBRhx");
var $f886fdb318144d77$var$useIsomorphicLayoutEffect = $bBRhx.isBrowser ? $2gcPZ.useLayoutEffect : $2gcPZ.useEffect;
module.exports.default = $f886fdb318144d77$var$useIsomorphicLayoutEffect;

});
parcelRegister("bBRhx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isNavigator = module.exports.isBrowser = module.exports.off = module.exports.on = module.exports.noop = void 0;
var $873c7b16844f90e5$var$noop = function() {};
module.exports.noop = $873c7b16844f90e5$var$noop;
function $873c7b16844f90e5$var$on(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (obj && obj.addEventListener) obj.addEventListener.apply(obj, args);
}
module.exports.on = $873c7b16844f90e5$var$on;
function $873c7b16844f90e5$var$off(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (obj && obj.removeEventListener) obj.removeEventListener.apply(obj, args);
}
module.exports.off = $873c7b16844f90e5$var$off;
module.exports.isBrowser = typeof window !== "undefined";
module.exports.isNavigator = typeof navigator !== "undefined";

});


var $afa7be861492543f$exports = {};
"use strict";

$afa7be861492543f$exports = (parcelRequire("ikxKt"));


var $15fe56b1fcc04799$export$882461b6382ed46c;
var $15fe56b1fcc04799$export$757ceba2d55c277e;
"use strict";

var $fuyzp = parcelRequire("fuyzp");
var $15fe56b1fcc04799$var$i;
$15fe56b1fcc04799$export$882461b6382ed46c = $fuyzp.createRoot;
$15fe56b1fcc04799$export$757ceba2d55c277e = $fuyzp.hydrateRoot;


// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $gt46n = parcelRequire("gt46n");
var $7ad818c59c680869$exports = {};
"use strict";

$7ad818c59c680869$exports = (parcelRequire("8pFzM"));



var $fuyzp = parcelRequire("fuyzp");


var $fuyzp = parcelRequire("fuyzp");
// Default to a dummy "batch" implementation that just runs the callback
function $d388de1444432d6d$var$defaultNoopBatch(callback) {
    callback();
}
let $d388de1444432d6d$var$batch = $d388de1444432d6d$var$defaultNoopBatch; // Allow injecting another batching function later
const $d388de1444432d6d$export$4b9874722d0da7bc = (newBatch)=>$d388de1444432d6d$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $d388de1444432d6d$export$fc47d4c0ba3bd2c6 = ()=>$d388de1444432d6d$var$batch;



var $2gcPZ = parcelRequire("2gcPZ");

var $2gcPZ = parcelRequire("2gcPZ");

var $2gcPZ = parcelRequire("2gcPZ");
const $01f959793d1b7537$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, $2gcPZ.createContext)(null);
var $01f959793d1b7537$export$2e2bcd8739ae039 = $01f959793d1b7537$export$cc80c08dc91f1c00;


function $bf4a5e460937c0ab$export$c1275ca9a6fd3ec5() {
    const contextValue = (0, $2gcPZ.useContext)((0, $01f959793d1b7537$export$cc80c08dc91f1c00));
    return contextValue;
}



const $f0f5e360cc28d25c$export$20656a4825650bd0 = ()=>{
    throw new Error("uSES not initialized!");
};


let $1a280fbaa3fcabb5$var$useSyncExternalStoreWithSelector = (0, $f0f5e360cc28d25c$export$20656a4825650bd0);
const $1a280fbaa3fcabb5$export$e2e6e3f3f3b782e3 = (fn)=>{
    $1a280fbaa3fcabb5$var$useSyncExternalStoreWithSelector = fn;
};
const $1a280fbaa3fcabb5$var$refEquality = (a, b)=>a === b;
function $1a280fbaa3fcabb5$export$2b53f90d2bd1cbfb(context = (0, $01f959793d1b7537$export$cc80c08dc91f1c00)) {
    const useReduxContext = context === (0, $01f959793d1b7537$export$cc80c08dc91f1c00) ? (0, $bf4a5e460937c0ab$export$c1275ca9a6fd3ec5) : ()=>(0, $2gcPZ.useContext)(context);
    return function useSelector(selector, equalityFn = $1a280fbaa3fcabb5$var$refEquality) {
        const { store: store, subscription: subscription, getServerState: getServerState } = useReduxContext();
        const selectedState = $1a280fbaa3fcabb5$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, selector, equalityFn);
        (0, $2gcPZ.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $1a280fbaa3fcabb5$export$2105062e25df4afe = /*#__PURE__*/ $1a280fbaa3fcabb5$export$2b53f90d2bd1cbfb();


function $dc04f589521b3b66$export$2e2bcd8739ae039() {
    $dc04f589521b3b66$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dc04f589521b3b66$export$2e2bcd8739ae039.apply(this, arguments);
}


function $cab781be726aa81b$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var $50b434e7ab34dacd$exports = {};
"use strict";
var $a85b6b92e8e1242b$exports = {};
"use strict";

$a85b6b92e8e1242b$exports = (parcelRequire("1Xs83"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $50b434e7ab34dacd$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $50b434e7ab34dacd$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $50b434e7ab34dacd$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $50b434e7ab34dacd$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $50b434e7ab34dacd$var$TYPE_STATICS = {};
$50b434e7ab34dacd$var$TYPE_STATICS[$a85b6b92e8e1242b$exports.ForwardRef] = $50b434e7ab34dacd$var$FORWARD_REF_STATICS;
$50b434e7ab34dacd$var$TYPE_STATICS[$a85b6b92e8e1242b$exports.Memo] = $50b434e7ab34dacd$var$MEMO_STATICS;
function $50b434e7ab34dacd$var$getStatics(component) {
    // React v16.11 and below
    if ($a85b6b92e8e1242b$exports.isMemo(component)) return $50b434e7ab34dacd$var$MEMO_STATICS;
     // React v16.12 and above
    return $50b434e7ab34dacd$var$TYPE_STATICS[component["$$typeof"]] || $50b434e7ab34dacd$var$REACT_STATICS;
}
var $50b434e7ab34dacd$var$defineProperty = Object.defineProperty;
var $50b434e7ab34dacd$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $50b434e7ab34dacd$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $50b434e7ab34dacd$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $50b434e7ab34dacd$var$getPrototypeOf = Object.getPrototypeOf;
var $50b434e7ab34dacd$var$objectPrototype = Object.prototype;
function $50b434e7ab34dacd$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($50b434e7ab34dacd$var$objectPrototype) {
            var inheritedComponent = $50b434e7ab34dacd$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $50b434e7ab34dacd$var$objectPrototype) $50b434e7ab34dacd$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $50b434e7ab34dacd$var$getOwnPropertyNames(sourceComponent);
        if ($50b434e7ab34dacd$var$getOwnPropertySymbols) keys = keys.concat($50b434e7ab34dacd$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $50b434e7ab34dacd$var$getStatics(targetComponent);
        var sourceStatics = $50b434e7ab34dacd$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$50b434e7ab34dacd$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $50b434e7ab34dacd$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $50b434e7ab34dacd$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$50b434e7ab34dacd$exports = $50b434e7ab34dacd$var$hoistNonReactStatics;



var $2gcPZ = parcelRequire("2gcPZ");
var $ed6038b4400db297$exports = {};
"use strict";

$ed6038b4400db297$exports = (parcelRequire("bAxob"));



/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $5e3508305d55af2a$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $98051230423bce7c$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, $5e3508305d55af2a$export$2e2bcd8739ae039)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $98051230423bce7c$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $98051230423bce7c$var$verify(mapStateToProps, "mapStateToProps");
    $98051230423bce7c$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $98051230423bce7c$var$verify(mergeProps, "mergeProps");
}


const $36cd01fb52d5d3c8$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $36cd01fb52d5d3c8$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $36cd01fb52d5d3c8$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $cab781be726aa81b$export$2e2bcd8739ae039)(_ref, $36cd01fb52d5d3c8$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $36cd01fb52d5d3c8$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


function $c4acf148389ebbb7$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $329e3b2d6955e34b$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}



function $96f8ee0aeb8953de$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $329e3b2d6955e34b$export$2e2bcd8739ae039)(value)) (0, $5e3508305d55af2a$export$2e2bcd8739ae039)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}


function $2910277ccf3d0f31$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $2910277ccf3d0f31$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $2910277ccf3d0f31$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $2910277ccf3d0f31$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $2910277ccf3d0f31$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $4b504ee4b4e92f32$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}


function $8de5e1d1f98b295b$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $2910277ccf3d0f31$export$710f7c60f68acd3e)((dispatch)=>(0, $c4acf148389ebbb7$export$2e2bcd8739ae039)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $2910277ccf3d0f31$export$710f7c60f68acd3e)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? (0, $2910277ccf3d0f31$export$8d46c7f53c8c602f)(mapDispatchToProps, "mapDispatchToProps") : (0, $4b504ee4b4e92f32$export$19ef7b929f7e2559)(mapDispatchToProps, "mapDispatchToProps");
}




function $64a4419914ccfffe$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $2910277ccf3d0f31$export$710f7c60f68acd3e)(()=>({})) : typeof mapStateToProps === "function" ? (0, $2910277ccf3d0f31$export$8d46c7f53c8c602f)(mapStateToProps, "mapStateToProps") : (0, $4b504ee4b4e92f32$export$19ef7b929f7e2559)(mapStateToProps, "mapStateToProps");
}





function $d04088b80e7900d1$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $dc04f589521b3b66$export$2e2bcd8739ae039)({}, ownProps, stateProps, dispatchProps);
}
function $d04088b80e7900d1$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $d04088b80e7900d1$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$d04088b80e7900d1$export$691c327fc30bc857 : typeof mergeProps === "function" ? $d04088b80e7900d1$export$5b105939c84b5234(mergeProps) : (0, $4b504ee4b4e92f32$export$19ef7b929f7e2559)(mergeProps, "mergeProps");
}



// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $634a17a8e19f18a5$var$createListenerCollection() {
    const batch = (0, $d388de1444432d6d$export$fc47d4c0ba3bd2c6)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $634a17a8e19f18a5$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $634a17a8e19f18a5$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $634a17a8e19f18a5$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $634a17a8e19f18a5$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $634a17a8e19f18a5$var$nullListeners;
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: ()=>listeners
    };
    return subscription;
}



var $2gcPZ = parcelRequire("2gcPZ");
const $cbb4663c006b3bf5$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $cbb4663c006b3bf5$export$700979bc83e7db82 = $cbb4663c006b3bf5$export$71594e8a50f746f4 ? (0, $2gcPZ.useLayoutEffect) : (0, $2gcPZ.useEffect);


function $adc60b347c86dc3c$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $adc60b347c86dc3c$export$2e2bcd8739ae039(objA, objB) {
    if ($adc60b347c86dc3c$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$adc60b347c86dc3c$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}





const $bc97fe51171f5197$var$_excluded = [
    "reactReduxForwardedRef"
];
let $bc97fe51171f5197$var$useSyncExternalStore = (0, $f0f5e360cc28d25c$export$20656a4825650bd0);
const $bc97fe51171f5197$export$36d45daa6a4925b8 = (fn)=>{
    $bc97fe51171f5197$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $bc97fe51171f5197$var$EMPTY_ARRAY = [
    null,
    0
];
const $bc97fe51171f5197$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $bc97fe51171f5197$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $bc97fe51171f5197$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $cbb4663c006b3bf5$export$700979bc83e7db82)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $bc97fe51171f5197$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $bc97fe51171f5197$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $bc97fe51171f5197$var$initStateUpdates = ()=>$bc97fe51171f5197$var$EMPTY_ARRAY;
function $bc97fe51171f5197$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $bc97fe51171f5197$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $bc97fe51171f5197$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $bc97fe51171f5197$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $adc60b347c86dc3c$export$2e2bcd8739ae039), areStatePropsEqual: areStatePropsEqual = (0, $adc60b347c86dc3c$export$2e2bcd8739ae039), areMergedPropsEqual: areMergedPropsEqual = (0, $adc60b347c86dc3c$export$2e2bcd8739ae039), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $01f959793d1b7537$export$cc80c08dc91f1c00) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $64a4419914ccfffe$export$e00e93951827eda7)(mapStateToProps);
    const initMapDispatchToProps = (0, $8de5e1d1f98b295b$export$b69a785ceac019a6)(mapDispatchToProps);
    const initMergeProps = (0, $d04088b80e7900d1$export$17457cf6fa742f84)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = (0, $2gcPZ.useMemo)(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $cab781be726aa81b$export$2e2bcd8739ae039)(props, $bc97fe51171f5197$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = (0, $2gcPZ.useMemo)(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $ed6038b4400db297$exports.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = (0, $2gcPZ.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = (0, $2gcPZ.useMemo)(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $36cd01fb52d5d3c8$export$2e2bcd8739ae039)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = (0, $2gcPZ.useMemo)(()=>{
                if (!shouldHandleStateChanges) return $bc97fe51171f5197$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $634a17a8e19f18a5$export$d567d2b9af322f8f)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = (0, $2gcPZ.useMemo)(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $dc04f589521b3b66$export$2e2bcd8739ae039)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = (0, $2gcPZ.useRef)();
            const lastWrapperProps = (0, $2gcPZ.useRef)(wrapperProps);
            const childPropsFromStoreUpdate = (0, $2gcPZ.useRef)();
            const renderIsScheduled = (0, $2gcPZ.useRef)(false);
            const isProcessingDispatch = (0, $2gcPZ.useRef)(false);
            const isMounted = (0, $2gcPZ.useRef)(false);
            const latestSubscriptionCallbackError = (0, $2gcPZ.useRef)();
            (0, $cbb4663c006b3bf5$export$700979bc83e7db82)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = (0, $2gcPZ.useMemo)(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = (0, $2gcPZ.useMemo)(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $bc97fe51171f5197$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $bc97fe51171f5197$var$useIsomorphicLayoutEffectWithArgs($bc97fe51171f5197$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $bc97fe51171f5197$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $cbb4663c006b3bf5$export$700979bc83e7db82)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = (0, $2gcPZ.useMemo)(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).createElement(WrappedComponent, (0, $dc04f589521b3b66$export$2e2bcd8739ae039)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = (0, $2gcPZ.useMemo)(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).createElement(Connect, (0, $dc04f589521b3b66$export$2e2bcd8739ae039)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($50b434e7ab34dacd$exports)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($50b434e7ab34dacd$exports)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $bc97fe51171f5197$export$2e2bcd8739ae039 = $bc97fe51171f5197$var$connect;



var $2gcPZ = parcelRequire("2gcPZ");



function $5293de6422d97033$var$Provider({ store: store, context: context, children: children, serverState: serverState }) {
    const contextValue = (0, $2gcPZ.useMemo)(()=>{
        const subscription = (0, $634a17a8e19f18a5$export$d567d2b9af322f8f)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined
        };
    }, [
        store,
        serverState
    ]);
    const previousState = (0, $2gcPZ.useMemo)(()=>store.getState(), [
        store
    ]);
    (0, $cbb4663c006b3bf5$export$700979bc83e7db82)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $01f959793d1b7537$export$cc80c08dc91f1c00); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $5293de6422d97033$export$2e2bcd8739ae039 = $5293de6422d97033$var$Provider;






var $2gcPZ = parcelRequire("2gcPZ");


function $8a1a7714098215c4$export$671dba69185d0304(context = (0, $01f959793d1b7537$export$cc80c08dc91f1c00)) {
    const useReduxContext = context === (0, $01f959793d1b7537$export$cc80c08dc91f1c00) ? (0, $bf4a5e460937c0ab$export$c1275ca9a6fd3ec5) : ()=>(0, $2gcPZ.useContext)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $8a1a7714098215c4$export$6ccbb43953eebf8 = /*#__PURE__*/ $8a1a7714098215c4$export$671dba69185d0304();


function $b1ddf03ae6418ae8$export$bc9b55530897c558(context = (0, $01f959793d1b7537$export$cc80c08dc91f1c00)) {
    const useStore = context === (0, $01f959793d1b7537$export$cc80c08dc91f1c00) ? (0, $8a1a7714098215c4$export$6ccbb43953eebf8) : (0, $8a1a7714098215c4$export$671dba69185d0304)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $b1ddf03ae6418ae8$export$8ad76b76a4c905f8 = /*#__PURE__*/ $b1ddf03ae6418ae8$export$bc9b55530897c558();









(0, $1a280fbaa3fcabb5$export$e2e6e3f3f3b782e3)((0, $7ad818c59c680869$exports.useSyncExternalStoreWithSelector));
(0, $bc97fe51171f5197$export$36d45daa6a4925b8)((0, $gt46n.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $d388de1444432d6d$export$4b9874722d0da7bc)((0, $fuyzp.unstable_batchedUpdates));


/**
 * React Router DOM v6.11.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $2gcPZ = parcelRequire("2gcPZ");
/**
 * @remix-run/router v1.6.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $856cec7af8563ae8$var$_extends() {
    $856cec7af8563ae8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $856cec7af8563ae8$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $856cec7af8563ae8$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($856cec7af8563ae8$export$e19cd5f9376f8cee || ($856cec7af8563ae8$export$e19cd5f9376f8cee = {}));
const $856cec7af8563ae8$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $856cec7af8563ae8$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $856cec7af8563ae8$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $856cec7af8563ae8$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $856cec7af8563ae8$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $856cec7af8563ae8$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $856cec7af8563ae8$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $856cec7af8563ae8$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $856cec7af8563ae8$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $856cec7af8563ae8$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $856cec7af8563ae8$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $856cec7af8563ae8$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $856cec7af8563ae8$export$fe53371bee54353d(to);
    }
    return $856cec7af8563ae8$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $856cec7af8563ae8$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $856cec7af8563ae8$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        return $856cec7af8563ae8$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $856cec7af8563ae8$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $856cec7af8563ae8$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $856cec7af8563ae8$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $856cec7af8563ae8$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $856cec7af8563ae8$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $856cec7af8563ae8$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $856cec7af8563ae8$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $856cec7af8563ae8$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $856cec7af8563ae8$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $856cec7af8563ae8$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $856cec7af8563ae8$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $856cec7af8563ae8$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $856cec7af8563ae8$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $856cec7af8563ae8$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $856cec7af8563ae8$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex(); // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($856cec7af8563ae8$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $856cec7af8563ae8$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $856cec7af8563ae8$export$e19cd5f9376f8cee.Push;
        let location = $856cec7af8563ae8$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $856cec7af8563ae8$var$getHistoryState(location, index);
        let url = history.createHref(location); // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $856cec7af8563ae8$export$e19cd5f9376f8cee.Replace;
        let location = $856cec7af8563ae8$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $856cec7af8563ae8$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $856cec7af8563ae8$export$fe53371bee54353d(to);
        $856cec7af8563ae8$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($856cec7af8563ae8$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($856cec7af8563ae8$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
} //#endregion
var $856cec7af8563ae8$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($856cec7af8563ae8$var$ResultType || ($856cec7af8563ae8$var$ResultType = {}));
const $856cec7af8563ae8$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $856cec7af8563ae8$var$isIndexRoute(route) {
    return route.index === true;
} // Walk the route tree generating unique IDs where necessary so we are working
// solely with AgnosticDataRouteObject's within the Router
function $856cec7af8563ae8$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $856cec7af8563ae8$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $856cec7af8563ae8$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($856cec7af8563ae8$var$isIndexRoute(route)) {
            let indexRoute = $856cec7af8563ae8$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $856cec7af8563ae8$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $856cec7af8563ae8$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $856cec7af8563ae8$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $856cec7af8563ae8$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $856cec7af8563ae8$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $856cec7af8563ae8$var$flattenRoutes(routes);
    $856cec7af8563ae8$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $856cec7af8563ae8$var$matchRouteBranch(branches[i], // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $856cec7af8563ae8$var$safelyDecodeURI(pathname));
    return matches;
}
function $856cec7af8563ae8$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $856cec7af8563ae8$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $856cec7af8563ae8$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta); // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $856cec7af8563ae8$export$3e9cee6b33872309(// @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $856cec7af8563ae8$var$flattenRoutes(route.children, branches, routesMeta, path);
        } // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $856cec7af8563ae8$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $856cec7af8563ae8$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $856cec7af8563ae8$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments; // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?"); // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $856cec7af8563ae8$var$explodeOptionalSegments(rest.join("/"));
    let result = []; // All child paths with the prefix.  Do this for all children before the
    // optional version for all children so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explodes _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/"))); // Then if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
     // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $856cec7af8563ae8$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $856cec7af8563ae8$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $856cec7af8563ae8$var$paramRe = /^:\w+$/;
const $856cec7af8563ae8$var$dynamicSegmentValue = 3;
const $856cec7af8563ae8$var$indexRouteValue = 2;
const $856cec7af8563ae8$var$emptySegmentValue = 1;
const $856cec7af8563ae8$var$staticSegmentValue = 10;
const $856cec7af8563ae8$var$splatPenalty = -2;
const $856cec7af8563ae8$var$isSplat = (s)=>s === "*";
function $856cec7af8563ae8$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($856cec7af8563ae8$var$isSplat)) initialScore += $856cec7af8563ae8$var$splatPenalty;
    if (index) initialScore += $856cec7af8563ae8$var$indexRouteValue;
    return segments.filter((s)=>!$856cec7af8563ae8$var$isSplat(s)).reduce((score, segment)=>score + ($856cec7af8563ae8$var$paramRe.test(segment) ? $856cec7af8563ae8$var$dynamicSegmentValue : segment === "" ? $856cec7af8563ae8$var$emptySegmentValue : $856cec7af8563ae8$var$staticSegmentValue), initialScore);
}
function $856cec7af8563ae8$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // so they sort equally.
    0;
}
function $856cec7af8563ae8$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $856cec7af8563ae8$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $856cec7af8563ae8$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $856cec7af8563ae8$export$a5c6d149b50c1d86($856cec7af8563ae8$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $856cec7af8563ae8$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $856cec7af8563ae8$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $856cec7af8563ae8$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    } // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1; // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            const starParam = params[star]; // Apply the splat
            return starParam;
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            if (optional === "?") return param == null ? "" : param;
            if (param == null) $856cec7af8563ae8$export$3e9cee6b33872309(false, 'Missing ":' + key + '" param');
            return param;
        } // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    }) // Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $856cec7af8563ae8$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $856cec7af8563ae8$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $856cec7af8563ae8$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $856cec7af8563ae8$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $856cec7af8563ae8$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $856cec7af8563ae8$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $856cec7af8563ae8$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $856cec7af8563ae8$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $856cec7af8563ae8$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $856cec7af8563ae8$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
     // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $856cec7af8563ae8$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $856cec7af8563ae8$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $856cec7af8563ae8$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $856cec7af8563ae8$var$normalizeSearch(search),
        hash: $856cec7af8563ae8$var$normalizeHash(hash)
    };
}
function $856cec7af8563ae8$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $856cec7af8563ae8$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $856cec7af8563ae8$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $856cec7af8563ae8$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $856cec7af8563ae8$export$8ccf933b0513f8d0(toArg);
    else {
        to = $856cec7af8563ae8$var$_extends({}, toArg);
        $856cec7af8563ae8$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $856cec7af8563ae8$var$getInvalidPathError("?", "pathname", "search", to));
        $856cec7af8563ae8$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $856cec7af8563ae8$var$getInvalidPathError("#", "pathname", "hash", to));
        $856cec7af8563ae8$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $856cec7af8563ae8$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from; // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/"); // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        } // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $856cec7af8563ae8$export$b09f2ff0bbcb43c7(to, from); // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/"); // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $856cec7af8563ae8$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $856cec7af8563ae8$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $856cec7af8563ae8$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $856cec7af8563ae8$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $856cec7af8563ae8$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $856cec7af8563ae8$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $856cec7af8563ae8$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $856cec7af8563ae8$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $856cec7af8563ae8$export$42a99a7a4bc0e76a extends Error {
}
class $856cec7af8563ae8$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $856cec7af8563ae8$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects"); // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $856cec7af8563ae8$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key); // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, null, data), (error)=>this.onSettle(promise, key, error)); // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $856cec7af8563ae8$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        if (error) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $856cec7af8563ae8$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $856cec7af8563ae8$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $856cec7af8563ae8$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $856cec7af8563ae8$var$unwrapTrackedPromise(value) {
    if (!$856cec7af8563ae8$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $856cec7af8563ae8$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $856cec7af8563ae8$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $856cec7af8563ae8$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $856cec7af8563ae8$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ class $856cec7af8563ae8$export$acf1a680051f5031 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $856cec7af8563ae8$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $856cec7af8563ae8$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $856cec7af8563ae8$var$validMutationMethods = new Set($856cec7af8563ae8$var$validMutationMethodsArr);
const $856cec7af8563ae8$var$validRequestMethodsArr = [
    "get",
    ...$856cec7af8563ae8$var$validMutationMethodsArr
];
const $856cec7af8563ae8$var$validRequestMethods = new Set($856cec7af8563ae8$var$validRequestMethodsArr);
const $856cec7af8563ae8$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $856cec7af8563ae8$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $856cec7af8563ae8$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
const $856cec7af8563ae8$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
const $856cec7af8563ae8$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $856cec7af8563ae8$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $856cec7af8563ae8$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $856cec7af8563ae8$var$isServer = !$856cec7af8563ae8$var$isBrowser;
const $856cec7af8563ae8$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    }); //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $856cec7af8563ae8$export$baddd0131ee8c05b(init) {
    $856cec7af8563ae8$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $856cec7af8563ae8$var$defaultMapRouteProperties;
     // Routes keyed by ID
    let manifest = {}; // Routes in tree format for matching
    let dataRoutes = $856cec7af8563ae8$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/"; // Config driven behavior flags
    let future = $856cec7af8563ae8$var$_extends({
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future); // Cleanup function for history
    let unlistenHistory = null; // Externally-provided functions to call on all state changes
    let subscribers = new Set(); // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null; // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null; // Externally-provided function to get current scroll position
    let getScrollPosition = null; // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $856cec7af8563ae8$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $856cec7af8563ae8$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $856cec7af8563ae8$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $856cec7af8563ae8$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    }; // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $856cec7af8563ae8$export$e19cd5f9376f8cee.Pop; // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false; // AbortController for the active navigation
    let pendingNavigationController; // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false; // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false; // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = []; // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = []; // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map(); // Track loads based on the order in which they started
    let incrementingLoadId = 0; // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1; // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map(); // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set(); // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map(); // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map(); // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map(); // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false; // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $856cec7af8563ae8$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1); // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        }); // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        deleteBlocker(blockerKey);
                        updateState({
                            blockers: new Map(router.state.blockers)
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        }); // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($856cec7af8563ae8$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    } // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    } // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    } // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $856cec7af8563ae8$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state));
    } // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $856cec7af8563ae8$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
         // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $856cec7af8563ae8$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData; // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        for (let [key] of blockerFunctions)deleteBlocker(key);
         // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $856cec7af8563ae8$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        updateState($856cec7af8563ae8$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $856cec7af8563ae8$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: new Map(state.blockers)
        }));
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $856cec7af8563ae8$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $856cec7af8563ae8$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $856cec7af8563ae8$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
         // Reset stateful navigation vars
        pendingAction = $856cec7af8563ae8$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    } // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $856cec7af8563ae8$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $856cec7af8563ae8$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $856cec7af8563ae8$var$createLocation(state.location, path, opts && opts.state); // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $856cec7af8563ae8$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $856cec7af8563ae8$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $856cec7af8563ae8$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $856cec7af8563ae8$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $856cec7af8563ae8$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    }); // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    deleteBlocker(blockerKey);
                    updateState({
                        blockers: new Map(state.blockers)
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace
        });
    } // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        }); // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
         // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        } // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    } // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true; // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $856cec7af8563ae8$export$2708184779ceb39d(routesToUse, location, basename); // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $856cec7af8563ae8$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $856cec7af8563ae8$var$getShortCircuitMatches(routesToUse); // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        } // Short circuit if it's only a hash change and not a mutation submission
        // For example, on /page#hash and submit a <Form method="post"> which will
        // default to a navigation to /page
        if ($856cec7af8563ae8$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $856cec7af8563ae8$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        } // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $856cec7af8563ae8$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$856cec7af8563ae8$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $856cec7af8563ae8$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            let navigation = $856cec7af8563ae8$var$_extends({
                state: "loading",
                location: location
            }, opts.submission);
            loadingNavigation = navigation; // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        } // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
         // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $856cec7af8563ae8$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    } // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        interruptActiveLoads(); // Put us in a submitting state
        let navigation = $856cec7af8563ae8$var$_extends({
            state: "submitting",
            location: location
        }, submission);
        updateState({
            navigation: navigation
        }); // Call our action and get the result
        let result;
        let actionMatch = $856cec7af8563ae8$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $856cec7af8563ae8$var$ResultType.error,
            error: $856cec7af8563ae8$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $856cec7af8563ae8$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($856cec7af8563ae8$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($856cec7af8563ae8$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $856cec7af8563ae8$var$findNearestBoundary(matches, actionMatch.route.id); // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $856cec7af8563ae8$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($856cec7af8563ae8$var$isDeferredResult(result)) throw $856cec7af8563ae8$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    } // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation;
        if (!loadingNavigation) {
            let navigation = $856cec7af8563ae8$var$_extends({
                state: "loading",
                location: location,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            }, submission);
            loadingNavigation = navigation;
        } // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission ? submission || fetcherSubmission : loadingNavigation.formMethod && loadingNavigation.formAction && loadingNavigation.formData && loadingNavigation.formEncType ? {
            formMethod: loadingNavigation.formMethod,
            formAction: loadingNavigation.formAction,
            formData: loadingNavigation.formData,
            formEncType: loadingNavigation.formEncType
        } : undefined;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $856cec7af8563ae8$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, basename, pendingActionData, pendingError); // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId)); // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $856cec7af8563ae8$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            return {
                shortCircuited: true
            };
        } // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = {
                    state: "loading",
                    data: fetcher && fetcher.data,
                    formMethod: undefined,
                    formAction: undefined,
                    formEncType: undefined,
                    formData: undefined,
                    " _hasFetcherDoneAnything ": true
                };
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($856cec7af8563ae8$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        pendingNavigationLoadId = ++incrementingLoadId;
        revalidatingFetchers.forEach((rf)=>{
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        }); // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
         // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key)); // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $856cec7af8563ae8$var$findRedirect(results);
        if (redirect) {
            await startRedirectNavigation(state, redirect, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        } // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $856cec7af8563ae8$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds); // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $856cec7af8563ae8$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $856cec7af8563ae8$export$52eace9c284d3585;
    } // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if ($856cec7af8563ae8$var$isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $856cec7af8563ae8$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        let matches = $856cec7af8563ae8$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $856cec7af8563ae8$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        let { path: path, submission: submission } = $856cec7af8563ae8$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        let match = $856cec7af8563ae8$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $856cec7af8563ae8$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        } // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    } // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $856cec7af8563ae8$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        } // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $856cec7af8563ae8$var$_extends({
            state: "submitting"
        }, submission, {
            data: existingFetcher && existingFetcher.data,
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }); // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $856cec7af8563ae8$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let actionResult = await $856cec7af8563ae8$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($856cec7af8563ae8$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            fetchRedirectIds.add(key);
            let loadingFetcher = $856cec7af8563ae8$var$_extends({
                state: "loading"
            }, submission, {
                data: undefined,
                " _hasFetcherDoneAnything ": true
            });
            state.fetchers.set(key, loadingFetcher);
            updateState({
                fetchers: new Map(state.fetchers)
            });
            return startRedirectNavigation(state, actionResult, {
                submission: submission,
                isFetchActionRedirect: true
            });
        } // Process any non-redirect errors thrown
        if ($856cec7af8563ae8$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($856cec7af8563ae8$var$isDeferredResult(actionResult)) throw $856cec7af8563ae8$var$getInternalRouterError(400, {
            type: "defer-action"
        });
         // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $856cec7af8563ae8$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $856cec7af8563ae8$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $856cec7af8563ae8$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $856cec7af8563ae8$var$_extends({
            state: "loading",
            data: actionResult.data
        }, submission, {
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $856cec7af8563ae8$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        ); // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = {
                state: "loading",
                data: existingFetcher && existingFetcher.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $856cec7af8563ae8$var$findRedirect(results);
        if (redirect) return startRedirectNavigation(state, redirect);
         // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $856cec7af8563ae8$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        let doneFetcher = {
            state: "idle",
            data: actionResult.data,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            " _hasFetcherDoneAnything ": true
        };
        state.fetchers.set(key, doneFetcher);
        let didAbortFetchLoads = abortStaleFetchLoads(loadId); // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $856cec7af8563ae8$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($856cec7af8563ae8$var$_extends({
                errors: errors,
                loaderData: $856cec7af8563ae8$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    } // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key); // Put this fetcher into it's loading state
        let loadingFetcher = $856cec7af8563ae8$var$_extends({
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined
        }, submission, {
            data: existingFetcher && existingFetcher.data,
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }); // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $856cec7af8563ae8$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let result = await $856cec7af8563ae8$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename); // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($856cec7af8563ae8$var$isDeferredResult(result)) result = await $856cec7af8563ae8$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
         // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
         // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($856cec7af8563ae8$var$isRedirectResult(result)) {
            fetchRedirectIds.add(key);
            await startRedirectNavigation(state, result);
            return;
        } // Process any non-redirect errors thrown
        if ($856cec7af8563ae8$var$isErrorResult(result)) {
            let boundaryMatch = $856cec7af8563ae8$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key); // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $856cec7af8563ae8$export$3e9cee6b33872309(!$856cec7af8563ae8$var$isDeferredResult(result), "Unhandled fetcher deferred data"); // Put the fetcher back into an idle state
        let doneFetcher = {
            state: "idle",
            data: result.data,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            " _hasFetcherDoneAnything ": true
        };
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        var _window;
        let { submission: submission, replace: replace, isFetchActionRedirect: isFetchActionRedirect } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $856cec7af8563ae8$var$createLocation(state.location, redirect.location, $856cec7af8563ae8$var$_extends({
            _isRedirect: true
        }, isFetchActionRedirect ? {
            _isFetchActionRedirect: true
        } : {}));
        $856cec7af8563ae8$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation"); // Check if this an absolute external redirect that goes to a new origin
        if ($856cec7af8563ae8$var$ABSOLUTE_URL_REGEX.test(redirect.location) && $856cec7af8563ae8$var$isBrowser && typeof ((_window = window) == null ? void 0 : _window.location) !== "undefined") {
            let url = init.history.createURL(redirect.location);
            let isDifferentBasename = $856cec7af8563ae8$export$b69e3301ce081aa3(url.pathname, basename) == null;
            if (window.location.origin !== url.origin || isDifferentBasename) {
                if (replace) window.location.replace(redirect.location);
                else window.location.assign(redirect.location);
                return;
            }
        } // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $856cec7af8563ae8$export$e19cd5f9376f8cee.Replace : $856cec7af8563ae8$export$e19cd5f9376f8cee.Push; // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, formData: formData } = state.navigation;
        if (!submission && formMethod && formAction && formData && formEncType) submission = {
            formMethod: formMethod,
            formAction: formAction,
            formEncType: formEncType,
            formData: formData
        };
         // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        if ($856cec7af8563ae8$var$redirectPreserveMethodStatusCodes.has(redirect.status) && submission && $856cec7af8563ae8$var$isMutationMethod(submission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $856cec7af8563ae8$var$_extends({}, submission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else if (isFetchActionRedirect) // For a fetch action redirect, we kick off a new loading navigation
        // without the fetcher submission, but we send it along for shouldRevalidate
        await startNavigation(redirectHistoryAction, redirectLocation, {
            overrideNavigation: {
                state: "loading",
                location: redirectLocation,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            },
            fetcherSubmission: submission,
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else // Otherwise, we kick off a new loading navigation, preserving the
        // submission info for the duration of this navigation
        await startNavigation(redirectHistoryAction, redirectLocation, {
            overrideNavigation: {
                state: "loading",
                location: redirectLocation,
                formMethod: submission ? submission.formMethod : undefined,
                formAction: submission ? submission.formAction : undefined,
                formEncType: submission ? submission.formEncType : undefined,
                formData: submission ? submission.formData : undefined
            },
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$856cec7af8563ae8$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $856cec7af8563ae8$var$callLoaderOrAction("loader", $856cec7af8563ae8$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                else {
                    let error = {
                        type: $856cec7af8563ae8$var$ResultType.error,
                        error: $856cec7af8563ae8$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $856cec7af8563ae8$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $856cec7af8563ae8$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true; // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds()); // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $856cec7af8563ae8$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        if (fetchControllers.has(key)) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $856cec7af8563ae8$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = {
                state: "idle",
                data: fetcher.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $856cec7af8563ae8$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $856cec7af8563ae8$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $856cec7af8563ae8$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    } // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $856cec7af8563ae8$export$386d57f03f0b2883; // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $856cec7af8563ae8$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        state.blockers.set(key, newBlocker);
        updateState({
            blockers: new Map(state.blockers)
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
         // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $856cec7af8563ae8$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
         // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    } // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || ((location)=>location.key); // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $856cec7af8563ae8$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            let userMatches = matches.map((m)=>$856cec7af8563ae8$var$createUseMatchesMatch(m, state.loaderData));
            let key = getScrollRestorationKey(location, userMatches) || location.key;
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            let userMatches = matches.map((m)=>$856cec7af8563ae8$var$createUseMatchesMatch(m, state.loaderData));
            let key = getScrollRestorationKey(location, userMatches) || location.key;
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        inFlightDataRoutes = newRoutes;
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $856cec7af8563ae8$export$4d0306f8f6a4585b = Symbol("deferred");
function $856cec7af8563ae8$export$3336b097a6fbc59a(routes, opts) {
    $856cec7af8563ae8$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $856cec7af8563ae8$var$defaultMapRouteProperties;
    let dataRoutes = $856cec7af8563ae8$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method;
        let location = $856cec7af8563ae8$var$createLocation("", $856cec7af8563ae8$export$fe53371bee54353d(url), null, "default");
        let matches = $856cec7af8563ae8$export$2708184779ceb39d(dataRoutes, location, basename); // SSR supports HEAD requests while SPA doesn't
        if (!$856cec7af8563ae8$var$isValidMethod(method) && method !== "HEAD") {
            let error = $856cec7af8563ae8$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $856cec7af8563ae8$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $856cec7af8563ae8$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $856cec7af8563ae8$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($856cec7af8563ae8$var$isResponse(result)) return result;
         // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $856cec7af8563ae8$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId, requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $856cec7af8563ae8$var$createLocation("", $856cec7af8563ae8$export$fe53371bee54353d(url), null, "default");
        let matches = $856cec7af8563ae8$export$2708184779ceb39d(dataRoutes, location, basename); // SSR supports HEAD requests while SPA doesn't
        if (!$856cec7af8563ae8$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $856cec7af8563ae8$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $856cec7af8563ae8$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $856cec7af8563ae8$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $856cec7af8563ae8$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $856cec7af8563ae8$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($856cec7af8563ae8$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
         // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$856cec7af8563ae8$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $856cec7af8563ae8$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($856cec7af8563ae8$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $856cec7af8563ae8$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $856cec7af8563ae8$var$isResponse(result) ? result : $856cec7af8563ae8$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($856cec7af8563ae8$var$isQueryRouteResponse(e)) {
                if (e.type === $856cec7af8563ae8$var$ResultType.error && !$856cec7af8563ae8$var$isRedirectResponse(e.response)) throw e.response;
                return e.response;
            } // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($856cec7af8563ae8$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $856cec7af8563ae8$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $856cec7af8563ae8$var$ResultType.error,
                error: error
            };
        } else {
            result = await $856cec7af8563ae8$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, true, isRouteRequest, requestContext);
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted");
            }
        }
        if ($856cec7af8563ae8$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($856cec7af8563ae8$var$isDeferredResult(result)) {
            let error = $856cec7af8563ae8$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $856cec7af8563ae8$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($856cec7af8563ae8$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($856cec7af8563ae8$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $856cec7af8563ae8$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            }); // action status codes take precedence over loader status codes
            return $856cec7af8563ae8$var$_extends({}, context, {
                statusCode: $856cec7af8563ae8$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $856cec7af8563ae8$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        } // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $856cec7af8563ae8$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $856cec7af8563ae8$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null; // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $856cec7af8563ae8$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $856cec7af8563ae8$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy); // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$856cec7af8563ae8$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, true, isRouteRequest, requestContext))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted");
        } // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $856cec7af8563ae8$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds); // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $856cec7af8563ae8$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $856cec7af8563ae8$export$fec11da027c70692(routes, context, error) {
    let newContext = $856cec7af8563ae8$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $856cec7af8563ae8$var$isSubmissionNavigation(opts) {
    return opts != null && "formData" in opts;
}
function $856cec7af8563ae8$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    } // Resolve the relative path
    let path = $856cec7af8563ae8$export$cae722b0cc860f13(to ? to : ".", $856cec7af8563ae8$export$90ba53ce1c7fdff2(contextualMatches).map((m)=>m.pathnameBase), $856cec7af8563ae8$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path"); // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    } // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$856cec7af8563ae8$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
     // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $856cec7af8563ae8$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $856cec7af8563ae8$export$fe53371bee54353d(path);
} // Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $856cec7af8563ae8$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$856cec7af8563ae8$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$856cec7af8563ae8$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $856cec7af8563ae8$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
     // Create a Submission on non-GET navigations
    let submission;
    if (opts.formData) {
        let formMethod = opts.formMethod || "get";
        submission = {
            formMethod: normalizeFormMethod ? formMethod.toUpperCase() : formMethod.toLowerCase(),
            formAction: $856cec7af8563ae8$var$stripHashFromPath(path),
            formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
            formData: opts.formData
        };
        if ($856cec7af8563ae8$var$isMutationMethod(submission.formMethod)) return {
            path: path,
            submission: submission
        };
    } // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $856cec7af8563ae8$export$8ccf933b0513f8d0(path);
    let searchParams = $856cec7af8563ae8$var$convertFormDataToSearchParams(opts.formData); // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $856cec7af8563ae8$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $856cec7af8563ae8$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
} // Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $856cec7af8563ae8$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $856cec7af8563ae8$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location); // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $856cec7af8563ae8$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
         // Always call the loader on new route instances and pending defer cancellations
        if ($856cec7af8563ae8$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
         // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $856cec7af8563ae8$var$shouldRevalidateLoader(match, $856cec7af8563ae8$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $856cec7af8563ae8$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    }); // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId)) return;
        let fetcherMatches = $856cec7af8563ae8$export$2708184779ceb39d(routesToUse, f.path, basename); // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        let fetcherMatch = $856cec7af8563ae8$var$getTargetMatch(fetcherMatches, f.path);
        if (cancelledFetcherLoads.includes(key)) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: fetcherMatches,
                match: fetcherMatch,
                controller: new AbortController()
            });
            return;
        } // Revalidating fetchers are decoupled from the route matches since they
        // hit a static href, so they _always_ check shouldRevalidate and the
        // default is strictly if a revalidation is explicitly required (action
        // submissions, useRevalidator, X-Remix-Revalidate).
        let shouldRevalidate = $856cec7af8563ae8$var$shouldRevalidateLoader(fetcherMatch, $856cec7af8563ae8$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $856cec7af8563ae8$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id; // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined; // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $856cec7af8563ae8$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"];
}
function $856cec7af8563ae8$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $856cec7af8563ae8$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy(); // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $856cec7af8563ae8$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest"); // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $856cec7af8563ae8$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$856cec7af8563ae8$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    } // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates); // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $856cec7af8563ae8$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $856cec7af8563ae8$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, isStaticRequest, isRouteRequest, requestContext) {
    if (isStaticRequest === void 0) isStaticRequest = false;
    if (isRouteRequest === void 0) isRouteRequest = false;
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let values = await Promise.all([
                    runHandler(handler),
                    $856cec7af8563ae8$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $856cec7af8563ae8$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $856cec7af8563ae8$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $856cec7af8563ae8$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $856cec7af8563ae8$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $856cec7af8563ae8$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $856cec7af8563ae8$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($856cec7af8563ae8$var$isResponse(result)) {
        let status = result.status; // Process redirects
        if ($856cec7af8563ae8$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $856cec7af8563ae8$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header"); // Support relative routing in internal redirects
            if (!$856cec7af8563ae8$var$ABSOLUTE_URL_REGEX.test(location)) location = $856cec7af8563ae8$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
            else if (!isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $856cec7af8563ae8$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            } // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $856cec7af8563ae8$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null
            };
        } // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (isRouteRequest) // eslint-disable-next-line no-throw-literal
        throw {
            type: resultType || $856cec7af8563ae8$var$ResultType.data,
            response: result
        };
        let data;
        let contentType = result.headers.get("Content-Type"); // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $856cec7af8563ae8$var$ResultType.error) return {
            type: resultType,
            error: new $856cec7af8563ae8$export$acf1a680051f5031(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $856cec7af8563ae8$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $856cec7af8563ae8$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($856cec7af8563ae8$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $856cec7af8563ae8$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $856cec7af8563ae8$var$ResultType.data,
        data: result
    };
} // Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $856cec7af8563ae8$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($856cec7af8563ae8$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $856cec7af8563ae8$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType, formData: formData } = submission; // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        init.body = formEncType === "application/x-www-form-urlencoded" ? $856cec7af8563ae8$var$convertFormDataToSearchParams(formData) : formData;
    } // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
    return new Request(url, init);
}
function $856cec7af8563ae8$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, value instanceof File ? value.name : value);
    return searchParams;
}
function $856cec7af8563ae8$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {}; // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $856cec7af8563ae8$export$3e9cee6b33872309(!$856cec7af8563ae8$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($856cec7af8563ae8$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $856cec7af8563ae8$var$findNearestBoundary(matches, id);
            let error = result.error; // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {}; // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
             // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined; // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $856cec7af8563ae8$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($856cec7af8563ae8$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
             // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    }); // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $856cec7af8563ae8$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $856cec7af8563ae8$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds); // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $856cec7af8563ae8$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index]; // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($856cec7af8563ae8$var$isErrorResult(result)) {
            let boundaryMatch = $856cec7af8563ae8$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $856cec7af8563ae8$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($856cec7af8563ae8$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $856cec7af8563ae8$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($856cec7af8563ae8$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $856cec7af8563ae8$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = {
                state: "idle",
                data: result.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $856cec7af8563ae8$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $856cec7af8563ae8$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
} // Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $856cec7af8563ae8$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $856cec7af8563ae8$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $856cec7af8563ae8$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $856cec7af8563ae8$export$acf1a680051f5031(status || 500, statusText, new Error(errorMessage), true);
} // Find any returned redirect errors, starting from the lowest match
function $856cec7af8563ae8$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($856cec7af8563ae8$var$isRedirectResult(result)) return result;
    }
}
function $856cec7af8563ae8$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $856cec7af8563ae8$export$8ccf933b0513f8d0(path) : path;
    return $856cec7af8563ae8$export$fe53371bee54353d($856cec7af8563ae8$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $856cec7af8563ae8$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // No hash -> hash
    return b.hash !== "";
    else if (a.hash === b.hash) // current hash -> same hash
    return true;
    else if (b.hash !== "") // current hash -> new hash
    return true;
    return false;
}
function $856cec7af8563ae8$var$isDeferredResult(result) {
    return result.type === $856cec7af8563ae8$var$ResultType.deferred;
}
function $856cec7af8563ae8$var$isErrorResult(result) {
    return result.type === $856cec7af8563ae8$var$ResultType.error;
}
function $856cec7af8563ae8$var$isRedirectResult(result) {
    return (result && result.type) === $856cec7af8563ae8$var$ResultType.redirect;
}
function $856cec7af8563ae8$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $856cec7af8563ae8$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $856cec7af8563ae8$var$isRedirectResponse(result) {
    if (!$856cec7af8563ae8$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $856cec7af8563ae8$var$isQueryRouteResponse(obj) {
    return obj && $856cec7af8563ae8$var$isResponse(obj.response) && (obj.type === $856cec7af8563ae8$var$ResultType.data || $856cec7af8563ae8$var$ResultType.error);
}
function $856cec7af8563ae8$var$isValidMethod(method) {
    return $856cec7af8563ae8$var$validRequestMethods.has(method.toLowerCase());
}
function $856cec7af8563ae8$var$isMutationMethod(method) {
    return $856cec7af8563ae8$var$validMutationMethods.has(method.toLowerCase());
}
async function $856cec7af8563ae8$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index]; // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$856cec7af8563ae8$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($856cec7af8563ae8$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $856cec7af8563ae8$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $856cec7af8563ae8$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $856cec7af8563ae8$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $856cec7af8563ae8$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $856cec7af8563ae8$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $856cec7af8563ae8$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $856cec7af8563ae8$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
} // Note: This should match the format exported by useMatches, so if you change
// this please also change that :)  Eventually we'll DRY this up
function $856cec7af8563ae8$var$createUseMatchesMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $856cec7af8563ae8$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $856cec7af8563ae8$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $856cec7af8563ae8$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
     // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $856cec7af8563ae8$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
} //#endregion

/**
 * React Router v6.11.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $2gcPZ = parcelRequire("2gcPZ");

function $efeb47d767416279$var$_extends() {
    $efeb47d767416279$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $efeb47d767416279$var$_extends.apply(this, arguments);
}
const $efeb47d767416279$export$3add0d5dce533e2e = /*#__PURE__*/ $2gcPZ.createContext(null);
const $efeb47d767416279$export$145dfa71566a64dc = /*#__PURE__*/ $2gcPZ.createContext(null);
const $efeb47d767416279$var$AwaitContext = /*#__PURE__*/ $2gcPZ.createContext(null);
const $efeb47d767416279$export$26749e8557646306 = /*#__PURE__*/ $2gcPZ.createContext(null);
const $efeb47d767416279$export$c7914228fb69b0f5 = /*#__PURE__*/ $2gcPZ.createContext(null);
const $efeb47d767416279$export$9072aa6dd1f93057 = /*#__PURE__*/ $2gcPZ.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $efeb47d767416279$var$RouteErrorContext = /*#__PURE__*/ $2gcPZ.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $efeb47d767416279$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$efeb47d767416279$export$9c954a9d03d32f4a() && (0, $856cec7af8563ae8$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $2gcPZ.useContext($efeb47d767416279$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $efeb47d767416279$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname; // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $856cec7af8563ae8$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $efeb47d767416279$export$9c954a9d03d32f4a() {
    return $2gcPZ.useContext($efeb47d767416279$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $efeb47d767416279$export$45d76561a5302f2b() {
    !$efeb47d767416279$export$9c954a9d03d32f4a() && (0, $856cec7af8563ae8$export$3e9cee6b33872309)(false);
    return $2gcPZ.useContext($efeb47d767416279$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $efeb47d767416279$export$1b3f31771c5d07c() {
    return $2gcPZ.useContext($efeb47d767416279$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $efeb47d767416279$export$6c330e8992e8a295(pattern) {
    !$efeb47d767416279$export$9c954a9d03d32f4a() && (0, $856cec7af8563ae8$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $efeb47d767416279$export$45d76561a5302f2b();
    return $2gcPZ.useMemo(()=>(0, $856cec7af8563ae8$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $efeb47d767416279$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered."; // Mute warnings for calls to useNavigate in SSR environments
function $efeb47d767416279$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $2gcPZ.useContext($efeb47d767416279$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $2gcPZ.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $efeb47d767416279$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $2gcPZ.useContext($efeb47d767416279$export$9072aa6dd1f93057); // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $efeb47d767416279$var$useNavigateStable() : $efeb47d767416279$var$useNavigateUnstable();
}
function $efeb47d767416279$var$useNavigateUnstable() {
    !$efeb47d767416279$export$9c954a9d03d32f4a() && (0, $856cec7af8563ae8$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $2gcPZ.useContext($efeb47d767416279$export$26749e8557646306);
    let { matches: matches } = $2gcPZ.useContext($efeb47d767416279$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $efeb47d767416279$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $856cec7af8563ae8$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    let activeRef = $2gcPZ.useRef(false);
    $efeb47d767416279$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $2gcPZ.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $856cec7af8563ae8$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path"); // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history.  If this is a root navigation, then we
        // navigate to the raw basename which allows the basename to have full
        // control over the presence of a trailing slash on root links
        if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $856cec7af8563ae8$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname
    ]);
    return navigate;
}
const $efeb47d767416279$var$OutletContext = /*#__PURE__*/ $2gcPZ.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $efeb47d767416279$export$4138103a3ae699cc() {
    return $2gcPZ.useContext($efeb47d767416279$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $efeb47d767416279$export$a3be3530d8e40d0b(context) {
    let outlet = $2gcPZ.useContext($efeb47d767416279$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $2gcPZ.createElement($efeb47d767416279$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $efeb47d767416279$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $2gcPZ.useContext($efeb47d767416279$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $efeb47d767416279$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $2gcPZ.useContext($efeb47d767416279$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $efeb47d767416279$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $856cec7af8563ae8$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    return $2gcPZ.useMemo(()=>(0, $856cec7af8563ae8$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $efeb47d767416279$export$5d3fca4a98652595(routes, locationArg) {
    return $efeb47d767416279$export$5fcee62552a12fbf(routes, locationArg);
} // Internal implementation with accept optional param for RouterProvider usage
function $efeb47d767416279$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$efeb47d767416279$export$9c954a9d03d32f4a() && (0, $856cec7af8563ae8$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $2gcPZ.useContext($efeb47d767416279$export$26749e8557646306);
    let { matches: parentMatches } = $2gcPZ.useContext($efeb47d767416279$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $efeb47d767416279$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $856cec7af8563ae8$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $856cec7af8563ae8$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $856cec7af8563ae8$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $efeb47d767416279$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $856cec7af8563ae8$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $856cec7af8563ae8$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState); // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $2gcPZ.createElement($efeb47d767416279$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $efeb47d767416279$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $856cec7af8563ae8$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $efeb47d767416279$var$DefaultErrorComponent() {
    let error = $efeb47d767416279$export$ed527bf60f6e05f2();
    let message = (0, $856cec7af8563ae8$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $2gcPZ.createElement($2gcPZ.Fragment, null, /*#__PURE__*/ $2gcPZ.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $2gcPZ.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $2gcPZ.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $efeb47d767416279$var$defaultErrorElement = /*#__PURE__*/ $2gcPZ.createElement($efeb47d767416279$var$DefaultErrorComponent, null);
class $efeb47d767416279$var$RenderErrorBoundary extends $2gcPZ.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
         // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $2gcPZ.createElement($efeb47d767416279$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $2gcPZ.createElement($efeb47d767416279$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $efeb47d767416279$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $2gcPZ.useContext($efeb47d767416279$export$3add0d5dce533e2e); // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $2gcPZ.createElement($efeb47d767416279$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $efeb47d767416279$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches; // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $856cec7af8563ae8$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null; // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $efeb47d767416279$var$defaultErrorElement;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $2gcPZ.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $2gcPZ.createElement($efeb47d767416279$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        }; // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $2gcPZ.createElement($efeb47d767416279$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $efeb47d767416279$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
})($efeb47d767416279$var$DataRouterHook || ($efeb47d767416279$var$DataRouterHook = {}));
var $efeb47d767416279$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
})($efeb47d767416279$var$DataRouterStateHook || ($efeb47d767416279$var$DataRouterStateHook = {}));
function $efeb47d767416279$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $efeb47d767416279$var$useDataRouterContext(hookName) {
    let ctx = $2gcPZ.useContext($efeb47d767416279$export$3add0d5dce533e2e);
    !ctx && (0, $856cec7af8563ae8$export$3e9cee6b33872309)(false);
    return ctx;
}
function $efeb47d767416279$var$useDataRouterState(hookName) {
    let state = $2gcPZ.useContext($efeb47d767416279$export$145dfa71566a64dc);
    !state && (0, $856cec7af8563ae8$export$3e9cee6b33872309)(false);
    return state;
}
function $efeb47d767416279$var$useRouteContext(hookName) {
    let route = $2gcPZ.useContext($efeb47d767416279$export$9072aa6dd1f93057);
    !route && (0, $856cec7af8563ae8$export$3e9cee6b33872309)(false);
    return route;
} // Internal version with hookName-aware debugging
function $efeb47d767416279$var$useCurrentRouteId(hookName) {
    let route = $efeb47d767416279$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $856cec7af8563ae8$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $efeb47d767416279$export$5fc8298006ad9e58() {
    return $efeb47d767416279$var$useCurrentRouteId($efeb47d767416279$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $efeb47d767416279$export$d0fd4b7106de2769() {
    let state = $efeb47d767416279$var$useDataRouterState($efeb47d767416279$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $efeb47d767416279$export$600dc272ed516c15() {
    let dataRouterContext = $efeb47d767416279$var$useDataRouterContext($efeb47d767416279$var$DataRouterHook.UseRevalidator);
    let state = $efeb47d767416279$var$useDataRouterState($efeb47d767416279$var$DataRouterStateHook.UseRevalidator);
    return {
        revalidate: dataRouterContext.router.revalidate,
        state: state.revalidation
    };
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $efeb47d767416279$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $efeb47d767416279$var$useDataRouterState($efeb47d767416279$var$DataRouterStateHook.UseMatches);
    return $2gcPZ.useMemo(()=>matches.map((match)=>{
            let { pathname: pathname, params: params } = match; // Note: This structure matches that created by createUseMatchesMatch
            // in the @remix-run/router , so if you change this please also change
            // that :)  Eventually we'll DRY this up
            return {
                id: match.route.id,
                pathname: pathname,
                params: params,
                data: loaderData[match.route.id],
                handle: match.route.handle
            };
        }), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $efeb47d767416279$export$1448a5050d252c4d() {
    let state = $efeb47d767416279$var$useDataRouterState($efeb47d767416279$var$DataRouterStateHook.UseLoaderData);
    let routeId = $efeb47d767416279$var$useCurrentRouteId($efeb47d767416279$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $efeb47d767416279$export$fd5d37484eab868d(routeId) {
    let state = $efeb47d767416279$var$useDataRouterState($efeb47d767416279$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $efeb47d767416279$export$fdc00f3f26066d5e() {
    let state = $efeb47d767416279$var$useDataRouterState($efeb47d767416279$var$DataRouterStateHook.UseActionData);
    let route = $2gcPZ.useContext($efeb47d767416279$export$9072aa6dd1f93057);
    !route && (0, $856cec7af8563ae8$export$3e9cee6b33872309)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $efeb47d767416279$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $2gcPZ.useContext($efeb47d767416279$var$RouteErrorContext);
    let state = $efeb47d767416279$var$useDataRouterState($efeb47d767416279$var$DataRouterStateHook.UseRouteError);
    let routeId = $efeb47d767416279$var$useCurrentRouteId($efeb47d767416279$var$DataRouterStateHook.UseRouteError); // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
     // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $efeb47d767416279$export$78a72ddb39bdd145() {
    let value = $2gcPZ.useContext($efeb47d767416279$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $efeb47d767416279$export$17f53340677d5831() {
    let value = $2gcPZ.useContext($efeb47d767416279$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $efeb47d767416279$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $efeb47d767416279$export$2af03a1de5c0910(shouldBlock) {
    let { router: router } = $efeb47d767416279$var$useDataRouterContext($efeb47d767416279$var$DataRouterHook.UseBlocker);
    let state = $efeb47d767416279$var$useDataRouterState($efeb47d767416279$var$DataRouterStateHook.UseBlocker);
    let [blockerKey] = $2gcPZ.useState(()=>String(++$efeb47d767416279$var$blockerId));
    let blockerFunction = $2gcPZ.useCallback((args)=>{
        return typeof shouldBlock === "function" ? !!shouldBlock(args) : !!shouldBlock;
    }, [
        shouldBlock
    ]);
    let blocker = router.getBlocker(blockerKey, blockerFunction); // Cleanup on unmount
    $2gcPZ.useEffect(()=>()=>router.deleteBlocker(blockerKey), [
        router,
        blockerKey
    ]); // Prefer the blocker from state since DataRouterContext is memoized so this
    // ensures we update on blocker state updates
    return state.blockers.get(blockerKey) || blocker;
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $efeb47d767416279$var$useNavigateStable() {
    let { router: router } = $efeb47d767416279$var$useDataRouterContext($efeb47d767416279$var$DataRouterHook.UseNavigateStable);
    let id = $efeb47d767416279$var$useCurrentRouteId($efeb47d767416279$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $2gcPZ.useRef(false);
    $efeb47d767416279$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $2gcPZ.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $efeb47d767416279$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $efeb47d767416279$var$alreadyWarned = {};
function $efeb47d767416279$var$warningOnce(key, cond, message) {
    if (!cond && !$efeb47d767416279$var$alreadyWarned[key]) $efeb47d767416279$var$alreadyWarned[key] = true;
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $efeb47d767416279$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router } = _ref;
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    let [state, setState] = $2gcPZ.useState(router.state);
    $2gcPZ.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let navigator = $2gcPZ.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $2gcPZ.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]); // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $2gcPZ.createElement($2gcPZ.Fragment, null, /*#__PURE__*/ $2gcPZ.createElement($efeb47d767416279$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $2gcPZ.createElement($efeb47d767416279$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $2gcPZ.createElement($efeb47d767416279$export$55185c17a0fcbe46, {
        basename: router.basename,
        location: router.state.location,
        navigationType: router.state.historyAction,
        navigator: navigator
    }, router.state.initialized ? /*#__PURE__*/ $2gcPZ.createElement($efeb47d767416279$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $efeb47d767416279$var$DataRoutes(_ref2) {
    let { routes: routes, state: state } = _ref2;
    return $efeb47d767416279$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $efeb47d767416279$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex } = _ref3;
    let historyRef = $2gcPZ.useRef();
    if (historyRef.current == null) historyRef.current = (0, $856cec7af8563ae8$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $2gcPZ.useState({
        action: history.action,
        location: history.location
    });
    $2gcPZ.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $2gcPZ.createElement($efeb47d767416279$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $efeb47d767416279$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$efeb47d767416279$export$9c954a9d03d32f4a() && (0, $856cec7af8563ae8$export$3e9cee6b33872309)(false);
    let { matches: matches } = $2gcPZ.useContext($efeb47d767416279$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $efeb47d767416279$export$45d76561a5302f2b();
    let navigate = $efeb47d767416279$export$9770f232ac06a008(); // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $856cec7af8563ae8$export$cae722b0cc860f13)(to, (0, $856cec7af8563ae8$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $2gcPZ.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $efeb47d767416279$export$910ae8079b2c2852(props) {
    return $efeb47d767416279$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $efeb47d767416279$export$e7b0ac011bb776c6(_props) {
    (0, $856cec7af8563ae8$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $efeb47d767416279$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $856cec7af8563ae8$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref5;
    !!$efeb47d767416279$export$9c954a9d03d32f4a() && (0, $856cec7af8563ae8$export$3e9cee6b33872309)(false); // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $2gcPZ.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $856cec7af8563ae8$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $2gcPZ.useMemo(()=>{
        let trailingPathname = (0, $856cec7af8563ae8$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $2gcPZ.createElement($efeb47d767416279$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $2gcPZ.createElement($efeb47d767416279$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $efeb47d767416279$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $efeb47d767416279$export$5d3fca4a98652595($efeb47d767416279$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $efeb47d767416279$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $2gcPZ.createElement($efeb47d767416279$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $2gcPZ.createElement($efeb47d767416279$var$ResolveAwait, null, children));
}
var $efeb47d767416279$var$AwaitRenderStatus;
(function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
})($efeb47d767416279$var$AwaitRenderStatus || ($efeb47d767416279$var$AwaitRenderStatus = {}));
const $efeb47d767416279$var$neverSettledPromise = new Promise(()=>{});
class $efeb47d767416279$var$AwaitErrorBoundary extends $2gcPZ.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $efeb47d767416279$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $efeb47d767416279$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $efeb47d767416279$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $efeb47d767416279$var$AwaitRenderStatus.error : promise._data !== undefined ? $efeb47d767416279$var$AwaitRenderStatus.success : $efeb47d767416279$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $efeb47d767416279$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $efeb47d767416279$var$AwaitRenderStatus.error && promise._error instanceof (0, $856cec7af8563ae8$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $efeb47d767416279$var$neverSettledPromise;
        if (status === $efeb47d767416279$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $efeb47d767416279$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $2gcPZ.createElement($efeb47d767416279$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $efeb47d767416279$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $2gcPZ.createElement($efeb47d767416279$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
         // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $efeb47d767416279$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $efeb47d767416279$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $2gcPZ.createElement($2gcPZ.Fragment, null, toRender);
} ///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $efeb47d767416279$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $2gcPZ.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $2gcPZ.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $2gcPZ.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $efeb47d767416279$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $efeb47d767416279$export$e7b0ac011bb776c6) && (0, $856cec7af8563ae8$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $856cec7af8563ae8$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $efeb47d767416279$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $efeb47d767416279$export$daf73786167a7f72(matches) {
    return $efeb47d767416279$var$_renderMatches(matches);
}
function $efeb47d767416279$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $2gcPZ.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $2gcPZ.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $efeb47d767416279$export$f30f7e456d254e83(routes, opts) {
    return (0, $856cec7af8563ae8$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $efeb47d767416279$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $856cec7af8563ae8$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $efeb47d767416279$export$52b333d321859367
    }).initialize();
} ///////////////////////////////////////////////////////////////////////////////



function $e7b98158099ae00d$var$_extends() {
    $e7b98158099ae00d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e7b98158099ae00d$var$_extends.apply(this, arguments);
}
function $e7b98158099ae00d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $e7b98158099ae00d$var$defaultMethod = "get";
const $e7b98158099ae00d$var$defaultEncType = "application/x-www-form-urlencoded";
function $e7b98158099ae00d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $e7b98158099ae00d$var$isButtonElement(object) {
    return $e7b98158099ae00d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $e7b98158099ae00d$var$isFormElement(object) {
    return $e7b98158099ae00d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $e7b98158099ae00d$var$isInputElement(object) {
    return $e7b98158099ae00d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $e7b98158099ae00d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $e7b98158099ae00d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$e7b98158099ae00d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $e7b98158099ae00d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $e7b98158099ae00d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $e7b98158099ae00d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) {
        for (let key of defaultSearchParams.keys())if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    }
    return searchParams;
}
function $e7b98158099ae00d$var$getFormSubmissionInfo(target, options, basename) {
    let method;
    let action = null;
    let encType;
    let formData;
    if ($e7b98158099ae00d$var$isFormElement(target)) {
        let submissionTrigger = options.submissionTrigger;
        if (options.action) action = options.action;
        else {
            // When grabbing the action from the element, it will have had the basename
            // prefixed to ensure non-JS scenarios work, so strip it since we'll
            // re-prefix in the router
            let attr = target.getAttribute("action");
            action = attr ? (0, $856cec7af8563ae8$export$b69e3301ce081aa3)(attr, basename) : null;
        }
        method = options.method || target.getAttribute("method") || $e7b98158099ae00d$var$defaultMethod;
        encType = options.encType || target.getAttribute("enctype") || $e7b98158099ae00d$var$defaultEncType;
        formData = new FormData(target);
        if (submissionTrigger && submissionTrigger.name) formData.append(submissionTrigger.name, submissionTrigger.value);
    } else if ($e7b98158099ae00d$var$isButtonElement(target) || $e7b98158099ae00d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
         // <button>/<input type="submit"> may override attributes of <form>
        if (options.action) action = options.action;
        else {
            // When grabbing the action from the element, it will have had the basename
            // prefixed to ensure non-JS scenarios work, so strip it since we'll
            // re-prefix in the router
            let attr = target.getAttribute("formaction") || form.getAttribute("action");
            action = attr ? (0, $856cec7af8563ae8$export$b69e3301ce081aa3)(attr, basename) : null;
        }
        method = options.method || target.getAttribute("formmethod") || form.getAttribute("method") || $e7b98158099ae00d$var$defaultMethod;
        encType = options.encType || target.getAttribute("formenctype") || form.getAttribute("enctype") || $e7b98158099ae00d$var$defaultEncType;
        formData = new FormData(form); // Include name + value from a <button>, appending in case the button name
        // matches an existing input name
        if (target.name) formData.append(target.name, target.value);
    } else if ($e7b98158099ae00d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = options.method || $e7b98158099ae00d$var$defaultMethod;
        action = options.action || null;
        encType = options.encType || $e7b98158099ae00d$var$defaultEncType;
        if (target instanceof FormData) formData = target;
        else {
            formData = new FormData();
            if (target instanceof URLSearchParams) for (let [name, value] of target)formData.append(name, value);
            else if (target != null) for (let name of Object.keys(target))formData.append(name, target[name]);
        }
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData
    };
}
const $e7b98158099ae00d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $e7b98158099ae00d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $e7b98158099ae00d$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "method",
    "action",
    "onSubmit",
    "fetcherKey",
    "routeId",
    "relative",
    "preventScrollReset"
];
function $e7b98158099ae00d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $856cec7af8563ae8$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $e7b98158099ae00d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $856cec7af8563ae8$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $e7b98158099ae00d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $efeb47d767416279$export$52b333d321859367)
    }).initialize();
}
function $e7b98158099ae00d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $856cec7af8563ae8$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $e7b98158099ae00d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $856cec7af8563ae8$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $e7b98158099ae00d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $efeb47d767416279$export$52b333d321859367)
    }).initialize();
}
function $e7b98158099ae00d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $e7b98158099ae00d$var$_extends({}, state, {
        errors: $e7b98158099ae00d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $e7b98158099ae00d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $856cec7af8563ae8$export$acf1a680051f5031)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            let error = new Error(val.message); // Wipe away the client-side stack trace.  Nothing to fill it in with
            // because we don't serialize SSR stack traces for security reasons
            error.stack = "";
            serialized[key] = error;
        } else serialized[key] = val;
    }
    return serialized;
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $e7b98158099ae00d$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, window: window1 } = _ref;
    let historyRef = $2gcPZ.useRef();
    if (historyRef.current == null) historyRef.current = (0, $856cec7af8563ae8$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $2gcPZ.useState({
        action: history.action,
        location: history.location
    });
    $2gcPZ.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $2gcPZ.createElement((0, $efeb47d767416279$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $e7b98158099ae00d$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, window: window1 } = _ref2;
    let historyRef = $2gcPZ.useRef();
    if (historyRef.current == null) historyRef.current = (0, $856cec7af8563ae8$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $2gcPZ.useState({
        action: history.action,
        location: history.location
    });
    $2gcPZ.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $2gcPZ.createElement((0, $efeb47d767416279$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $e7b98158099ae00d$export$eefb0c834599897e(_ref3) {
    let { basename: basename, children: children, history: history } = _ref3;
    const [state, setState] = $2gcPZ.useState({
        action: history.action,
        location: history.location
    });
    $2gcPZ.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $2gcPZ.createElement((0, $efeb47d767416279$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $e7b98158099ae00d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $e7b98158099ae00d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware <a>.
 */ const $e7b98158099ae00d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $2gcPZ.forwardRef(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset } = _ref4, rest = $e7b98158099ae00d$var$_objectWithoutPropertiesLoose(_ref4, $e7b98158099ae00d$var$_excluded);
    let { basename: basename } = $2gcPZ.useContext((0, $efeb47d767416279$export$26749e8557646306)); // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $e7b98158099ae00d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to; // Only check for external origins client-side
        if ($e7b98158099ae00d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $856cec7af8563ae8$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    } // Rendered into <a href> for relative URLs
    let href = (0, $efeb47d767416279$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $e7b98158099ae00d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $2gcPZ.createElement("a", $e7b98158099ae00d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $e7b98158099ae00d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $2gcPZ.forwardRef(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, children: children } = _ref5, rest = $e7b98158099ae00d$var$_objectWithoutPropertiesLoose(_ref5, $e7b98158099ae00d$var$_excluded2);
    let path = (0, $efeb47d767416279$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $efeb47d767416279$export$45d76561a5302f2b)();
    let routerState = $2gcPZ.useContext((0, $efeb47d767416279$export$145dfa71566a64dc));
    let { navigator: navigator } = $2gcPZ.useContext((0, $efeb47d767416279$export$26749e8557646306));
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $2gcPZ.createElement($e7b98158099ae00d$export$a6c7ac8248d6e38a, $e7b98158099ae00d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $e7b98158099ae00d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $2gcPZ.forwardRef((props, ref)=>{
    return /*#__PURE__*/ $2gcPZ.createElement($e7b98158099ae00d$var$FormImpl, $e7b98158099ae00d$var$_extends({}, props, {
        ref: ref
    }));
});
const $e7b98158099ae00d$var$FormImpl = /*#__PURE__*/ $2gcPZ.forwardRef((_ref6, forwardedRef)=>{
    let { reloadDocument: reloadDocument, replace: replace, method: method = $e7b98158099ae00d$var$defaultMethod, action: action, onSubmit: onSubmit, fetcherKey: fetcherKey, routeId: routeId, relative: relative, preventScrollReset: preventScrollReset } = _ref6, props = $e7b98158099ae00d$var$_objectWithoutPropertiesLoose(_ref6, $e7b98158099ae00d$var$_excluded3);
    let submit = $e7b98158099ae00d$var$useSubmitImpl(fetcherKey, routeId);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $e7b98158099ae00d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            relative: relative,
            preventScrollReset: preventScrollReset
        });
    };
    return /*#__PURE__*/ $2gcPZ.createElement("form", $e7b98158099ae00d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $e7b98158099ae00d$export$11aac1aab828f1fa(_ref7) {
    let { getKey: getKey, storageKey: storageKey } = _ref7;
    $e7b98158099ae00d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $e7b98158099ae00d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmitImpl"] = "useSubmitImpl";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($e7b98158099ae00d$var$DataRouterHook || ($e7b98158099ae00d$var$DataRouterHook = {}));
var $e7b98158099ae00d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($e7b98158099ae00d$var$DataRouterStateHook || ($e7b98158099ae00d$var$DataRouterStateHook = {}));
function $e7b98158099ae00d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $e7b98158099ae00d$var$useDataRouterContext(hookName) {
    let ctx = $2gcPZ.useContext((0, $efeb47d767416279$export$3add0d5dce533e2e));
    !ctx && (0, $856cec7af8563ae8$export$3e9cee6b33872309)(false);
    return ctx;
}
function $e7b98158099ae00d$var$useDataRouterState(hookName) {
    let state = $2gcPZ.useContext((0, $efeb47d767416279$export$145dfa71566a64dc));
    !state && (0, $856cec7af8563ae8$export$3e9cee6b33872309)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $e7b98158099ae00d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $efeb47d767416279$export$9770f232ac06a008)();
    let location = (0, $efeb47d767416279$export$45d76561a5302f2b)();
    let path = (0, $efeb47d767416279$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $2gcPZ.useCallback((event)=>{
        if ($e7b98158099ae00d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault(); // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $856cec7af8563ae8$export$fe53371bee54353d)(location) === (0, $856cec7af8563ae8$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $e7b98158099ae00d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $2gcPZ.useRef($e7b98158099ae00d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $2gcPZ.useRef(false);
    let location = (0, $efeb47d767416279$export$45d76561a5302f2b)();
    let searchParams = $2gcPZ.useMemo(()=>// Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $e7b98158099ae00d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $efeb47d767416279$export$9770f232ac06a008)();
    let setSearchParams = $2gcPZ.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $e7b98158099ae00d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $e7b98158099ae00d$export$47c85c6e3a081d3() {
    return $e7b98158099ae00d$var$useSubmitImpl();
}
function $e7b98158099ae00d$var$useSubmitImpl(fetcherKey, fetcherRouteId) {
    let { router: router } = $e7b98158099ae00d$var$useDataRouterContext($e7b98158099ae00d$var$DataRouterHook.UseSubmitImpl);
    let { basename: basename } = $2gcPZ.useContext((0, $efeb47d767416279$export$26749e8557646306));
    let currentRouteId = (0, $efeb47d767416279$export$5fc8298006ad9e58)();
    return $2gcPZ.useCallback(function(target, options) {
        if (options === void 0) options = {};
        if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
        let { action: action, method: method, encType: encType, formData: formData } = $e7b98158099ae00d$var$getFormSubmissionInfo(target, options, basename); // Base options shared between fetch() and navigate()
        let opts = {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            formMethod: method,
            formEncType: encType
        };
        if (fetcherKey) {
            !(fetcherRouteId != null) && (0, $856cec7af8563ae8$export$3e9cee6b33872309)(false);
            router.fetch(fetcherKey, fetcherRouteId, action, opts);
        } else router.navigate(action, $e7b98158099ae00d$var$_extends({}, opts, {
            replace: options.replace,
            fromRouteId: currentRouteId
        }));
    }, [
        router,
        basename,
        fetcherKey,
        fetcherRouteId,
        currentRouteId
    ]);
} // v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $e7b98158099ae00d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $2gcPZ.useContext((0, $efeb47d767416279$export$26749e8557646306));
    let routeContext = $2gcPZ.useContext((0, $efeb47d767416279$export$9072aa6dd1f93057));
    !routeContext && (0, $856cec7af8563ae8$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1); // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $e7b98158099ae00d$var$_extends({}, (0, $efeb47d767416279$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    })); // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params and the hash of the resolved
    // URL. This is the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $efeb47d767416279$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to these directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        // or hash
        path.search = location.search;
        path.hash = location.hash; // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
     // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $856cec7af8563ae8$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $856cec7af8563ae8$export$fe53371bee54353d)(path);
}
function $e7b98158099ae00d$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $2gcPZ.forwardRef((props, ref)=>{
        return /*#__PURE__*/ $2gcPZ.createElement($e7b98158099ae00d$var$FormImpl, $e7b98158099ae00d$var$_extends({}, props, {
            ref: ref,
            fetcherKey: fetcherKey,
            routeId: routeId
        }));
    });
    return FetcherForm;
}
let $e7b98158099ae00d$var$fetcherId = 0;
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $e7b98158099ae00d$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router } = $e7b98158099ae00d$var$useDataRouterContext($e7b98158099ae00d$var$DataRouterHook.UseFetcher);
    let route = $2gcPZ.useContext((0, $efeb47d767416279$export$9072aa6dd1f93057));
    !route && (0, $856cec7af8563ae8$export$3e9cee6b33872309)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $856cec7af8563ae8$export$3e9cee6b33872309)(false);
    let [fetcherKey] = $2gcPZ.useState(()=>String(++$e7b98158099ae00d$var$fetcherId));
    let [Form] = $2gcPZ.useState(()=>{
        !routeId && (0, $856cec7af8563ae8$export$3e9cee6b33872309)(false);
        return $e7b98158099ae00d$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $2gcPZ.useState(()=>(href)=>{
            !router && (0, $856cec7af8563ae8$export$3e9cee6b33872309)(false);
            !routeId && (0, $856cec7af8563ae8$export$3e9cee6b33872309)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $e7b98158099ae00d$var$useSubmitImpl(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $2gcPZ.useMemo(()=>$e7b98158099ae00d$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $2gcPZ.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No router available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $e7b98158099ae00d$export$fa996778a3a31087() {
    let state = $e7b98158099ae00d$var$useDataRouterState($e7b98158099ae00d$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $e7b98158099ae00d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $e7b98158099ae00d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $e7b98158099ae00d$export$25057cfe5591e3e9(_temp3) {
    let { getKey: getKey, storageKey: storageKey } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $e7b98158099ae00d$var$useDataRouterContext($e7b98158099ae00d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $e7b98158099ae00d$var$useDataRouterState($e7b98158099ae00d$var$DataRouterStateHook.UseScrollRestoration);
    let location = (0, $efeb47d767416279$export$45d76561a5302f2b)();
    let matches = (0, $efeb47d767416279$export$2378eb7f5ff86053)();
    let navigation = (0, $efeb47d767416279$export$d0fd4b7106de2769)(); // Trigger manual scroll restoration while we're active
    $2gcPZ.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []); // Save positions on pagehide
    $e7b98158099ae00d$var$usePageHide($2gcPZ.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $e7b98158099ae00d$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $e7b98158099ae00d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($e7b98158099ae00d$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ])); // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $2gcPZ.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $e7b98158099ae00d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $e7b98158099ae00d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]); // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $2gcPZ.useLayoutEffect(()=>{
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($e7b98158099ae00d$var$savedScrollPositions, ()=>window.scrollY, getKey);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            getKey
        ]); // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $2gcPZ.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
             // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            } // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(location.hash.slice(1));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            } // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
             // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $e7b98158099ae00d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $2gcPZ.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $e7b98158099ae00d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $2gcPZ.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $e7b98158099ae00d$export$39f4eb3dbd812741(_ref8) {
    let { when: when, message: message } = _ref8;
    let blocker = (0, $efeb47d767416279$export$2af03a1de5c0910)(when);
    $2gcPZ.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
    $2gcPZ.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
}




var $2gcPZ = parcelRequire("2gcPZ");
var $4a1c560b86d66e4c$exports = {};
//
$4a1c560b86d66e4c$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


function $f1b14e537d02742b$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = "", p = "", F = "", G = "", C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, "")), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, "").trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ""));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(""), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ""));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + "{" + k + "}";
                                        break;
                                    case 107:
                                        f = f.replace(fa, "$1 $2");
                                        k = f + "{" + k + "}";
                                        k = 1 === w || 2 === w && L("@" + k, 3) ? "@-webkit-" + k + "@" + k : "@" + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ""));
                                }
                                else k = "";
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, "") : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(" ", ":")).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = "\x00\x00"), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += "\x00");
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = "";
                                    break;
                                default:
                                    32 !== g && (y = " ");
                            }
                            break;
                        case 0:
                            y = "\\0";
                            break;
                        case 12:
                            y = "\\f";
                            break;
                        case 11:
                            y = "\\v";
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = "\f" + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += "\r");
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = "", b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(",") + "{" + p + "}";
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ":-moz-$1") + p;
                        break;
                    case 112:
                        p = p.replace(Q, "::-webkit-input-$1") + p.replace(Q, "::-moz-$1") + p.replace(Q, ":-ms-input-$1") + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? "" : d[0] + " "; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + " ", h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, "$1" + d.trim());
            case 58:
                return d.trim() + c.replace(F, "$1" + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf("\f")) return c.replace(F, (58 === d.charCodeAt(0) ? "" : "$1") + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ";", m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(":", 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ";";
            return 1 === w || 2 === w && L(b, 1) ? "-webkit-" + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return "-webkit-" + a + a;
            case 978:
                return "-webkit-" + a + "-moz-" + a + a;
            case 1019:
            case 983:
                return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return "-webkit-" + a + a;
                if (0 < a.indexOf("image-set(", 11)) return a.replace(ja, "$1-webkit-$2") + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
                    case 115:
                        return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
                    case 98:
                        return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
                }
                return "-webkit-" + a + "-ms-" + a + a;
            case 964:
                return "-webkit-" + a + "-ms-flex-" + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
                return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ":-webkit-") + a.replace(aa, ":-moz-") + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf("-") + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, "tb");
                        break;
                    case 232:
                        b = a.replace(G, "tb-rl");
                        break;
                    case 220:
                        b = a.replace(G, "lr");
                        break;
                    default:
                        return a;
                }
                return "-webkit-" + a + "-ms-" + b + a;
            case 1017:
                if (-1 === a.indexOf("sticky", 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(":", 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, "-webkit-" + b) + ";" + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, "-webkit-" + (102 < m ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;
                }
                return a + ";";
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;
                    case 115:
                        return "-webkit-" + a + "-ms-flex-item-" + a.replace(ba, "") + a;
                    default:
                        return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(ba, "") + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(":") + 1)).charCodeAt(0) ? P(d.replace("stretch", "fill-available"), c, e, h).replace(":fill-available", ":stretch") : a.replace(b, "-webkit-" + b) + a.replace(b, "-moz-" + b.replace("fill-", "")) + a;
                break;
            case 962:
                if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ":" : "{"), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, "$1"), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ";" ? e.replace(oa, " or ($1)").substring(4) : "(" + c + ")";
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ("function" === typeof d) S[A++] = d;
                else if ("object" === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? "function" !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && "string" === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = "";
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = "";
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $f1b14e537d02742b$export$2e2bcd8739ae039 = $f1b14e537d02742b$var$stylis_min;


var $2a52a6a6f810fb39$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $2a52a6a6f810fb39$export$2e2bcd8739ae039 = $2a52a6a6f810fb39$var$unitlessKeys;


function $5dd0e8947529242b$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $d8cfdd7868e3bc66$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $d8cfdd7868e3bc66$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $5dd0e8947529242b$export$2e2bcd8739ae039)(function(prop) {
    return $d8cfdd7868e3bc66$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});




var $fr0vp = parcelRequire("fr0vp");
function $4e8e6ea7d6e48c37$var$v() {
    return ($4e8e6ea7d6e48c37$var$v = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }).apply(this, arguments);
}
var $4e8e6ea7d6e48c37$var$g = function(e, t) {
    for(var n = [
        e[0]
    ], r = 0, o = t.length; r < o; r += 1)n.push(t[r], e[r + 1]);
    return n;
}, $4e8e6ea7d6e48c37$var$S = function(t) {
    return null !== t && "object" == typeof t && "[object Object]" === (t.toString ? t.toString() : Object.prototype.toString.call(t)) && !(0, $ed6038b4400db297$exports.typeOf)(t);
}, $4e8e6ea7d6e48c37$var$w = Object.freeze([]), $4e8e6ea7d6e48c37$var$E = Object.freeze({});
function $4e8e6ea7d6e48c37$var$b(e) {
    return "function" == typeof e;
}
function $4e8e6ea7d6e48c37$var$_(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $4e8e6ea7d6e48c37$export$7ba318d8d2f06c76(e) {
    return e && "string" == typeof e.styledComponentId;
}
var $4e8e6ea7d6e48c37$var$A = ("undefined" != typeof $fr0vp && void 0 !== $fr0vp.env && undefined, "data-styled"), $4e8e6ea7d6e48c37$export$83d89fbfd8236492 = "5.3.9", $4e8e6ea7d6e48c37$var$I = "undefined" != typeof window && "HTMLElement" in window, $4e8e6ea7d6e48c37$var$P = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : "undefined" != typeof $fr0vp && void 0 !== $fr0vp.env && false), $4e8e6ea7d6e48c37$var$O = {}, $4e8e6ea7d6e48c37$var$R = {};
function $4e8e6ea7d6e48c37$var$D() {
    for(var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1)t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    return t.forEach(function(t) {
        e = e.replace(/%[a-z]/, t);
    }), e;
}
function $4e8e6ea7d6e48c37$var$j(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : ""));
}
var $4e8e6ea7d6e48c37$var$T = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, t.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, r = n.length, o = r; e >= o;)(o <<= 1) < 0 && $4e8e6ea7d6e48c37$var$j(16, "" + e);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
            for(var s = r; s < o; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = 0, c = t.length; a < c; a++)this.tag.insertRule(i, t[a]) && (this.groupSizes[e]++, i++);
    }, t.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), r = n + t;
            this.groupSizes[e] = 0;
            for(var o = n; o < r; o++)this.tag.deleteRule(n);
        }
    }, t.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, s = r; s < o; s++)t += this.tag.getRule(s) + "/*!sc*/\n";
        return t;
    }, e;
}(), $4e8e6ea7d6e48c37$var$x = new Map, $4e8e6ea7d6e48c37$var$k = new Map, $4e8e6ea7d6e48c37$var$V = 1, $4e8e6ea7d6e48c37$var$B = function(e) {
    if ($4e8e6ea7d6e48c37$var$x.has(e)) return $4e8e6ea7d6e48c37$var$x.get(e);
    for(; $4e8e6ea7d6e48c37$var$k.has($4e8e6ea7d6e48c37$var$V);)$4e8e6ea7d6e48c37$var$V++;
    var t = $4e8e6ea7d6e48c37$var$V++;
    return $4e8e6ea7d6e48c37$var$x.set(e, t), $4e8e6ea7d6e48c37$var$k.set(t, e), t;
}, $4e8e6ea7d6e48c37$var$z = function(e) {
    return $4e8e6ea7d6e48c37$var$k.get(e);
}, $4e8e6ea7d6e48c37$var$M = function(e, t) {
    t >= $4e8e6ea7d6e48c37$var$V && ($4e8e6ea7d6e48c37$var$V = t + 1), $4e8e6ea7d6e48c37$var$x.set(e, t), $4e8e6ea7d6e48c37$var$k.set(t, e);
}, $4e8e6ea7d6e48c37$var$G = "style[" + $4e8e6ea7d6e48c37$var$A + '][data-styled-version="5.3.9"]', $4e8e6ea7d6e48c37$var$L = new RegExp("^" + $4e8e6ea7d6e48c37$var$A + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), $4e8e6ea7d6e48c37$var$F = function(e, t, n) {
    for(var r, o = n.split(","), s = 0, i = o.length; s < i; s++)(r = o[s]) && e.registerName(t, r);
}, $4e8e6ea7d6e48c37$var$Y = function(e, t) {
    for(var n = (t.textContent || "").split("/*!sc*/\n"), r = [], o = 0, s = n.length; o < s; o++){
        var i = n[o].trim();
        if (i) {
            var a = i.match($4e8e6ea7d6e48c37$var$L);
            if (a) {
                var c = 0 | parseInt(a[1], 10), u = a[2];
                0 !== c && ($4e8e6ea7d6e48c37$var$M(u, c), $4e8e6ea7d6e48c37$var$F(e, u, a[3]), e.getTag().insertRules(c, r)), r.length = 0;
            } else r.push(i);
        }
    }
}, $4e8e6ea7d6e48c37$var$q = function() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}, $4e8e6ea7d6e48c37$var$H = function(e) {
    var t = document.head, n = e || t, r = document.createElement("style"), o = function(e) {
        for(var t = e.childNodes, n = t.length; n >= 0; n--){
            var r = t[n];
            if (r && 1 === r.nodeType && r.hasAttribute($4e8e6ea7d6e48c37$var$A)) return r;
        }
    }(n), s = void 0 !== o ? o.nextSibling : null;
    r.setAttribute($4e8e6ea7d6e48c37$var$A, "active"), r.setAttribute("data-styled-version", "5.3.9");
    var i = $4e8e6ea7d6e48c37$var$q();
    return i && r.setAttribute("nonce", i), n.insertBefore(r, s), r;
}, $4e8e6ea7d6e48c37$var$$ = function() {
    function e(e) {
        var t = this.element = $4e8e6ea7d6e48c37$var$H(e);
        t.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, r = t.length; n < r; n++){
                var o = t[n];
                if (o.ownerNode === e) return o;
            }
            $4e8e6ea7d6e48c37$var$j(17);
        }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, t.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
}(), $4e8e6ea7d6e48c37$var$W = function() {
    function e(e) {
        var t = this.element = $4e8e6ea7d6e48c37$var$H(e);
        this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t), r = this.nodes[e];
            return this.element.insertBefore(n, r || null), this.length++, !0;
        }
        return !1;
    }, t.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $4e8e6ea7d6e48c37$var$U = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $4e8e6ea7d6e48c37$var$J = $4e8e6ea7d6e48c37$var$I, $4e8e6ea7d6e48c37$var$X = {
    isServer: !$4e8e6ea7d6e48c37$var$I,
    useCSSOMInjection: !$4e8e6ea7d6e48c37$var$P
}, $4e8e6ea7d6e48c37$var$Z = function() {
    function e(e, t, n) {
        void 0 === e && (e = $4e8e6ea7d6e48c37$var$E), void 0 === t && (t = {}), this.options = $4e8e6ea7d6e48c37$var$v({}, $4e8e6ea7d6e48c37$var$X, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && $4e8e6ea7d6e48c37$var$I && $4e8e6ea7d6e48c37$var$J && ($4e8e6ea7d6e48c37$var$J = !1, function(e) {
            for(var t = document.querySelectorAll($4e8e6ea7d6e48c37$var$G), n = 0, r = t.length; n < r; n++){
                var o = t[n];
                o && "active" !== o.getAttribute($4e8e6ea7d6e48c37$var$A) && ($4e8e6ea7d6e48c37$var$Y(e, o), o.parentNode && o.parentNode.removeChild(o));
            }
        }(this));
    }
    e.registerId = function(e) {
        return $4e8e6ea7d6e48c37$var$B(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function(t, n) {
        return void 0 === n && (n = !0), new e($4e8e6ea7d6e48c37$var$v({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function() {
        var e, t, n, r, o;
        return this.tag || (this.tag = (n = (t = this.options).isServer, r = t.useCSSOMInjection, o = t.target, e = n ? new $4e8e6ea7d6e48c37$var$U(o) : r ? new $4e8e6ea7d6e48c37$var$$(o) : new $4e8e6ea7d6e48c37$var$W(o), new $4e8e6ea7d6e48c37$var$T(e)));
    }, t.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function(e, t) {
        if ($4e8e6ea7d6e48c37$var$B(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, t.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($4e8e6ea7d6e48c37$var$B(e), n);
    }, t.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function(e) {
        this.getTag().clearGroup($4e8e6ea7d6e48c37$var$B(e)), this.clearNames(e);
    }, t.clearTag = function() {
        this.tag = void 0;
    }, t.toString = function() {
        return function(e) {
            for(var t = e.getTag(), n = t.length, r = "", o = 0; o < n; o++){
                var s = $4e8e6ea7d6e48c37$var$z(o);
                if (void 0 !== s) {
                    var i = e.names.get(s), a = t.getGroup(o);
                    if (i && a && i.size) {
                        var c = $4e8e6ea7d6e48c37$var$A + ".g" + o + '[id="' + s + '"]', u = "";
                        void 0 !== i && i.forEach(function(e) {
                            e.length > 0 && (u += e + ",");
                        }), r += "" + a + c + '{content:"' + u + '"}/*!sc*/\n';
                    }
                }
            }
            return r;
        }(this);
    }, e;
}(), $4e8e6ea7d6e48c37$var$K = /(a)(d)/gi, $4e8e6ea7d6e48c37$var$Q = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $4e8e6ea7d6e48c37$var$ee(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $4e8e6ea7d6e48c37$var$Q(t % 52) + n;
    return ($4e8e6ea7d6e48c37$var$Q(t % 52) + n).replace($4e8e6ea7d6e48c37$var$K, "$1-$2");
}
var $4e8e6ea7d6e48c37$var$te = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $4e8e6ea7d6e48c37$var$ne = function(e) {
    return $4e8e6ea7d6e48c37$var$te(5381, e);
};
function $4e8e6ea7d6e48c37$var$re(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($4e8e6ea7d6e48c37$var$b(n) && !$4e8e6ea7d6e48c37$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $4e8e6ea7d6e48c37$var$oe = $4e8e6ea7d6e48c37$var$ne("5.3.9"), $4e8e6ea7d6e48c37$var$se = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $4e8e6ea7d6e48c37$var$re(e), this.componentId = t, this.baseHash = $4e8e6ea7d6e48c37$var$te($4e8e6ea7d6e48c37$var$oe, t), this.baseStyle = n, $4e8e6ea7d6e48c37$var$Z.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var r = this.componentId, o = [];
        if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(r, this.staticRulesId)) o.push(this.staticRulesId);
            else {
                var s = $4e8e6ea7d6e48c37$var$Ne(this.rules, e, t, n).join(""), i = $4e8e6ea7d6e48c37$var$ee($4e8e6ea7d6e48c37$var$te(this.baseHash, s) >>> 0);
                if (!t.hasNameForId(r, i)) {
                    var a = n(s, "." + i, void 0, r);
                    t.insertRules(r, i, a);
                }
                o.push(i), this.staticRulesId = i;
            }
        } else {
            for(var c = this.rules.length, u = $4e8e6ea7d6e48c37$var$te(this.baseHash, n.hash), l = "", d = 0; d < c; d++){
                var h = this.rules[d];
                if ("string" == typeof h) l += h;
                else if (h) {
                    var p = $4e8e6ea7d6e48c37$var$Ne(h, e, t, n), f = Array.isArray(p) ? p.join("") : p;
                    u = $4e8e6ea7d6e48c37$var$te(u, f + d), l += f;
                }
            }
            if (l) {
                var m = $4e8e6ea7d6e48c37$var$ee(u >>> 0);
                if (!t.hasNameForId(r, m)) {
                    var y = n(l, "." + m, void 0, r);
                    t.insertRules(r, m, y);
                }
                o.push(m);
            }
        }
        return o.join(" ");
    }, e;
}(), $4e8e6ea7d6e48c37$var$ie = /^\s*\/\/.*$/gm, $4e8e6ea7d6e48c37$var$ae = [
    ":",
    "[",
    ".",
    "#"
];
function $4e8e6ea7d6e48c37$var$ce(e) {
    var t, n, r, o, s = void 0 === e ? $4e8e6ea7d6e48c37$var$E : e, i = s.options, a = void 0 === i ? $4e8e6ea7d6e48c37$var$E : i, c = s.plugins, u = void 0 === c ? $4e8e6ea7d6e48c37$var$w : c, l = new (0, $f1b14e537d02742b$export$2e2bcd8739ae039)(a), d = [], h = function(e) {
        function t(t) {
            if (t) try {
                e(t + "}");
            } catch (e) {}
        }
        return function(n, r, o, s, i, a, c, u, l, d) {
            switch(n){
                case 1:
                    if (0 === l && 64 === r.charCodeAt(0)) return e(r + ";"), "";
                    break;
                case 2:
                    if (0 === u) return r + "/*|*/";
                    break;
                case 3:
                    switch(u){
                        case 102:
                        case 112:
                            return e(o[0] + r), "";
                        default:
                            return r + (0 === d ? "/*|*/" : "");
                    }
                case -2:
                    r.split("/*|*/}").forEach(t);
            }
        };
    }(function(e) {
        d.push(e);
    }), f = function(e, r, s) {
        return 0 === r && -1 !== $4e8e6ea7d6e48c37$var$ae.indexOf(s[n.length]) || s.match(o) ? e : "." + t;
    };
    function m(e, s, i, a) {
        void 0 === a && (a = "&");
        var c = e.replace($4e8e6ea7d6e48c37$var$ie, ""), u = s && i ? i + " " + s + " { " + c + " }" : c;
        return t = a, n = s, r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), l(i || !s ? "" : s, u);
    }
    return l.use([].concat(u, [
        function(e, t, o) {
            2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(r, f));
        },
        h,
        function(e) {
            if (-2 === e) {
                var t = d;
                return d = [], t;
            }
        }
    ])), m.hash = u.length ? u.reduce(function(e, t) {
        return t.name || $4e8e6ea7d6e48c37$var$j(15), $4e8e6ea7d6e48c37$var$te(e, t.name);
    }, 5381).toString() : "", m;
}
var $4e8e6ea7d6e48c37$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).createContext(), $4e8e6ea7d6e48c37$export$91317688fc694efa = $4e8e6ea7d6e48c37$export$8c190ef828af4c86.Consumer, $4e8e6ea7d6e48c37$var$de = (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).createContext(), $4e8e6ea7d6e48c37$var$he = ($4e8e6ea7d6e48c37$var$de.Consumer, new $4e8e6ea7d6e48c37$var$Z), $4e8e6ea7d6e48c37$var$pe = $4e8e6ea7d6e48c37$var$ce();
function $4e8e6ea7d6e48c37$var$fe() {
    return (0, $2gcPZ.useContext)($4e8e6ea7d6e48c37$export$8c190ef828af4c86) || $4e8e6ea7d6e48c37$var$he;
}
function $4e8e6ea7d6e48c37$var$me() {
    return (0, $2gcPZ.useContext)($4e8e6ea7d6e48c37$var$de) || $4e8e6ea7d6e48c37$var$pe;
}
function $4e8e6ea7d6e48c37$export$a473771da2f0ff7c(e) {
    var t = (0, $2gcPZ.useState)(e.stylisPlugins), n = t[0], s = t[1], c = $4e8e6ea7d6e48c37$var$fe(), u = (0, $2gcPZ.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target
    ]), l = (0, $2gcPZ.useMemo)(function() {
        return $4e8e6ea7d6e48c37$var$ce({
            options: {
                prefix: !e.disableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.disableVendorPrefixes,
        n
    ]);
    return (0, $2gcPZ.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($4a1c560b86d66e4c$exports)))(n, e.stylisPlugins) || s(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).createElement($4e8e6ea7d6e48c37$export$8c190ef828af4c86.Provider, {
        value: u
    }, (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).createElement($4e8e6ea7d6e48c37$var$de.Provider, {
        value: l
    }, (0, e.children)));
}
var $4e8e6ea7d6e48c37$var$ve = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $4e8e6ea7d6e48c37$var$pe);
            var r = n.name + t.hash;
            e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
        }, this.toString = function() {
            return $4e8e6ea7d6e48c37$var$j(12, String(n.name));
        }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $4e8e6ea7d6e48c37$var$pe), this.name + e.hash;
    }, e;
}(), $4e8e6ea7d6e48c37$var$ge = /([A-Z])/, $4e8e6ea7d6e48c37$var$Se = /([A-Z])/g, $4e8e6ea7d6e48c37$var$we = /^ms-/, $4e8e6ea7d6e48c37$var$Ee = function(e) {
    return "-" + e.toLowerCase();
};
function $4e8e6ea7d6e48c37$var$be(e) {
    return $4e8e6ea7d6e48c37$var$ge.test(e) ? e.replace($4e8e6ea7d6e48c37$var$Se, $4e8e6ea7d6e48c37$var$Ee).replace($4e8e6ea7d6e48c37$var$we, "-ms-") : e;
}
var $4e8e6ea7d6e48c37$var$_e = function(e) {
    return null == e || !1 === e || "" === e;
};
function $4e8e6ea7d6e48c37$var$Ne(e, n, r, o) {
    if (Array.isArray(e)) {
        for(var s, i = [], a = 0, c = e.length; a < c; a += 1)"" !== (s = $4e8e6ea7d6e48c37$var$Ne(e[a], n, r, o)) && (Array.isArray(s) ? i.push.apply(i, s) : i.push(s));
        return i;
    }
    if ($4e8e6ea7d6e48c37$var$_e(e)) return "";
    if ($4e8e6ea7d6e48c37$export$7ba318d8d2f06c76(e)) return "." + e.styledComponentId;
    if ($4e8e6ea7d6e48c37$var$b(e)) {
        if ("function" != typeof (l = e) || l.prototype && l.prototype.isReactComponent || !n) return e;
        var u = e(n);
        return $4e8e6ea7d6e48c37$var$Ne(u, n, r, o);
    }
    var l;
    return e instanceof $4e8e6ea7d6e48c37$var$ve ? r ? (e.inject(r, o), e.getName(o)) : e : $4e8e6ea7d6e48c37$var$S(e) ? function e(t, n) {
        var r, o, s = [];
        for(var i in t)t.hasOwnProperty(i) && !$4e8e6ea7d6e48c37$var$_e(t[i]) && (Array.isArray(t[i]) && t[i].isCss || $4e8e6ea7d6e48c37$var$b(t[i]) ? s.push($4e8e6ea7d6e48c37$var$be(i) + ":", t[i], ";") : $4e8e6ea7d6e48c37$var$S(t[i]) ? s.push.apply(s, e(t[i], i)) : s.push($4e8e6ea7d6e48c37$var$be(i) + ": " + (r = i, null == (o = t[i]) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || r in (0, $2a52a6a6f810fb39$export$2e2bcd8739ae039) ? String(o).trim() : o + "px") + ";"));
        return n ? [
            n + " {"
        ].concat(s, [
            "}"
        ]) : s;
    }(e) : e.toString();
}
var $4e8e6ea7d6e48c37$var$Ae = function(e) {
    return Array.isArray(e) && (e.isCss = !0), e;
};
function $4e8e6ea7d6e48c37$export$dbf350e5966cf602(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    return $4e8e6ea7d6e48c37$var$b(e) || $4e8e6ea7d6e48c37$var$S(e) ? $4e8e6ea7d6e48c37$var$Ae($4e8e6ea7d6e48c37$var$Ne($4e8e6ea7d6e48c37$var$g($4e8e6ea7d6e48c37$var$w, [
        e
    ].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : $4e8e6ea7d6e48c37$var$Ae($4e8e6ea7d6e48c37$var$Ne($4e8e6ea7d6e48c37$var$g(e, n)));
}
var $4e8e6ea7d6e48c37$var$Ie = /invalid hook call/i, $4e8e6ea7d6e48c37$var$Pe = new Set, $4e8e6ea7d6e48c37$var$Oe = function(e, t) {
    var n, r, o, e1;
}, $4e8e6ea7d6e48c37$var$Re = function(e, t, n) {
    return void 0 === n && (n = $4e8e6ea7d6e48c37$var$E), e.theme !== n.theme && e.theme || t || n.theme;
}, $4e8e6ea7d6e48c37$var$De = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $4e8e6ea7d6e48c37$var$je = /(^-|-$)/g;
function $4e8e6ea7d6e48c37$var$Te(e) {
    return e.replace($4e8e6ea7d6e48c37$var$De, "-").replace($4e8e6ea7d6e48c37$var$je, "");
}
var $4e8e6ea7d6e48c37$var$xe = function(e) {
    return $4e8e6ea7d6e48c37$var$ee($4e8e6ea7d6e48c37$var$ne(e) >>> 0);
};
function $4e8e6ea7d6e48c37$var$ke(e) {
    return "string" == typeof e && true;
}
var $4e8e6ea7d6e48c37$var$Ve = function(e) {
    return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
}, $4e8e6ea7d6e48c37$var$Be = function(e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
};
function $4e8e6ea7d6e48c37$var$ze(e, t, n) {
    var r = e[n];
    $4e8e6ea7d6e48c37$var$Ve(t) && $4e8e6ea7d6e48c37$var$Ve(r) ? $4e8e6ea7d6e48c37$var$Me(r, t) : e[n] = t;
}
function $4e8e6ea7d6e48c37$var$Me(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    for(var o = 0, s = n; o < s.length; o++){
        var i = s[o];
        if ($4e8e6ea7d6e48c37$var$Ve(i)) for(var a in i)$4e8e6ea7d6e48c37$var$Be(a) && $4e8e6ea7d6e48c37$var$ze(e, i[a], a);
    }
    return e;
}
var $4e8e6ea7d6e48c37$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).createContext(), $4e8e6ea7d6e48c37$export$b631efc24e9d5e2f = $4e8e6ea7d6e48c37$export$2c657da244d00bd6.Consumer;
function $4e8e6ea7d6e48c37$export$d8964aec282183a3(e) {
    var t = (0, $2gcPZ.useContext)($4e8e6ea7d6e48c37$export$2c657da244d00bd6), n = (0, $2gcPZ.useMemo)(function() {
        return function(e, t) {
            if (!e) return $4e8e6ea7d6e48c37$var$j(14);
            if ($4e8e6ea7d6e48c37$var$b(e)) {
                var n = e(t);
                return n;
            }
            return Array.isArray(e) || "object" != typeof e ? $4e8e6ea7d6e48c37$var$j(8) : t ? $4e8e6ea7d6e48c37$var$v({}, t, {}, e) : e;
        }(e.theme, t);
    }, [
        e.theme,
        t
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).createElement($4e8e6ea7d6e48c37$export$2c657da244d00bd6.Provider, {
        value: n
    }, e.children) : null;
}
var $4e8e6ea7d6e48c37$var$Ye = {};
function $4e8e6ea7d6e48c37$var$qe(e, t, n) {
    var o = $4e8e6ea7d6e48c37$export$7ba318d8d2f06c76(e), i = !$4e8e6ea7d6e48c37$var$ke(e), a = t.attrs, c = void 0 === a ? $4e8e6ea7d6e48c37$var$w : a, d = t.componentId, h = void 0 === d ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $4e8e6ea7d6e48c37$var$Te(e);
        $4e8e6ea7d6e48c37$var$Ye[n] = ($4e8e6ea7d6e48c37$var$Ye[n] || 0) + 1;
        var r = n + "-" + $4e8e6ea7d6e48c37$var$xe("5.3.9" + n + $4e8e6ea7d6e48c37$var$Ye[n]);
        return t ? t + "-" + r : r;
    }(t.displayName, t.parentComponentId) : d, p = t.displayName, f = void 0 === p ? function(e) {
        return $4e8e6ea7d6e48c37$var$ke(e) ? "styled." + e : "Styled(" + $4e8e6ea7d6e48c37$var$_(e) + ")";
    }(e) : p, g = t.displayName && t.componentId ? $4e8e6ea7d6e48c37$var$Te(t.displayName) + "-" + t.componentId : t.componentId || h, S = o && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, A = t.shouldForwardProp;
    o && e.shouldForwardProp && (A = t.shouldForwardProp ? function(n, r, o) {
        return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
    } : e.shouldForwardProp);
    var C, I = new $4e8e6ea7d6e48c37$var$se(n, g, o ? e.componentStyle : void 0), P = I.isStatic && 0 === c.length, O = function(e, t) {
        return function(e, t, n, r) {
            var o = e.attrs, i = e.componentStyle, a = e.defaultProps, c = e.foldedComponentIds, d = e.shouldForwardProp, h = e.styledComponentId, p = e.target;
            var f = function(e, t, n) {
                void 0 === e && (e = $4e8e6ea7d6e48c37$var$E);
                var r = $4e8e6ea7d6e48c37$var$v({}, t, {
                    theme: e
                }), o = {};
                return n.forEach(function(e) {
                    var t, n, s, i = e;
                    for(t in $4e8e6ea7d6e48c37$var$b(i) && (i = i(r)), i)r[t] = o[t] = "className" === t ? (n = o[t], s = i[t], n && s ? n + " " + s : n || s) : i[t];
                }), [
                    r,
                    o
                ];
            }($4e8e6ea7d6e48c37$var$Re(t, (0, $2gcPZ.useContext)($4e8e6ea7d6e48c37$export$2c657da244d00bd6), a) || $4e8e6ea7d6e48c37$var$E, t, o), y = f[0], g = f[1], S = function(e, t, n, r) {
                var o = $4e8e6ea7d6e48c37$var$fe(), s = $4e8e6ea7d6e48c37$var$me(), i = t ? e.generateAndInjectStyles($4e8e6ea7d6e48c37$var$E, o, s) : e.generateAndInjectStyles(n, o, s);
                return i;
            }(i, r, y, void 0), w = n, _ = g.$as || t.$as || g.as || t.as || p, N = $4e8e6ea7d6e48c37$var$ke(_), A = g !== t ? $4e8e6ea7d6e48c37$var$v({}, t, {}, g) : t, C = {};
            for(var I in A)"$" !== I[0] && "as" !== I && ("forwardedAs" === I ? C.as = A[I] : (d ? d(I, (0, $d8cfdd7868e3bc66$export$2e2bcd8739ae039), _) : !N || (0, $d8cfdd7868e3bc66$export$2e2bcd8739ae039)(I)) && (C[I] = A[I]));
            return t.style && g.style !== t.style && (C.style = $4e8e6ea7d6e48c37$var$v({}, t.style, {}, g.style)), C.className = Array.prototype.concat(c, h, S !== h ? S : null, t.className, g.className).filter(Boolean).join(" "), C.ref = w, (0, $2gcPZ.createElement)(_, C);
        }(C, e, t, P);
    };
    return O.displayName = f, (C = (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).forwardRef(O)).attrs = S, C.componentStyle = I, C.displayName = f, C.shouldForwardProp = A, C.foldedComponentIds = o ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : $4e8e6ea7d6e48c37$var$w, C.styledComponentId = g, C.target = o ? e.target : e, C.withComponent = function(e) {
        var r = t.componentId, o = function(e, t) {
            if (null == e) return {};
            var n, r, o = {}, s = Object.keys(e);
            for(r = 0; r < s.length; r++)n = s[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
            return o;
        }(t, [
            "componentId"
        ]), s = r && r + "-" + ($4e8e6ea7d6e48c37$var$ke(e) ? e : $4e8e6ea7d6e48c37$var$Te($4e8e6ea7d6e48c37$var$_(e)));
        return $4e8e6ea7d6e48c37$var$qe(e, $4e8e6ea7d6e48c37$var$v({}, o, {
            attrs: S,
            componentId: s
        }), n);
    }, Object.defineProperty(C, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(t) {
            this._foldedDefaultProps = o ? $4e8e6ea7d6e48c37$var$Me({}, e.defaultProps, t) : t;
        }
    }), Object.defineProperty(C, "toString", {
        value: function() {
            return "." + C.styledComponentId;
        }
    }), i && (0, (/*@__PURE__*/$parcel$interopDefault($50b434e7ab34dacd$exports)))(C, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0,
        withComponent: !0
    }), C;
}
var $4e8e6ea7d6e48c37$var$He = function(e) {
    return function e(t, r, o) {
        if (void 0 === o && (o = $4e8e6ea7d6e48c37$var$E), !(0, $ed6038b4400db297$exports.isValidElementType)(r)) return $4e8e6ea7d6e48c37$var$j(1, String(r));
        var s = function() {
            return t(r, o, $4e8e6ea7d6e48c37$export$dbf350e5966cf602.apply(void 0, arguments));
        };
        return s.withConfig = function(n) {
            return e(t, r, $4e8e6ea7d6e48c37$var$v({}, o, {}, n));
        }, s.attrs = function(n) {
            return e(t, r, $4e8e6ea7d6e48c37$var$v({}, o, {
                attrs: Array.prototype.concat(o.attrs, n).filter(Boolean)
            }));
        }, s;
    }($4e8e6ea7d6e48c37$var$qe, e);
};
[
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "textPath",
    "tspan"
].forEach(function(e) {
    $4e8e6ea7d6e48c37$var$He[e] = $4e8e6ea7d6e48c37$var$He(e);
});
var $4e8e6ea7d6e48c37$var$$e = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $4e8e6ea7d6e48c37$var$re(e), $4e8e6ea7d6e48c37$var$Z.registerId(this.componentId + 1);
    }
    var t = e.prototype;
    return t.createStyles = function(e, t, n, r) {
        var o = r($4e8e6ea7d6e48c37$var$Ne(this.rules, t, n, r).join(""), ""), s = this.componentId + e;
        n.insertRules(s, s, o);
    }, t.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, t.renderStyles = function(e, t, n, r) {
        e > 2 && $4e8e6ea7d6e48c37$var$Z.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r);
    }, e;
}();
function $4e8e6ea7d6e48c37$export$f0f03736edb61697(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)n[o - 1] = arguments[o];
    var i = $4e8e6ea7d6e48c37$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)), a = "sc-global-" + $4e8e6ea7d6e48c37$var$xe(JSON.stringify(i)), u = new $4e8e6ea7d6e48c37$var$$e(i, a);
    function l(e) {
        var t = $4e8e6ea7d6e48c37$var$fe(), n = $4e8e6ea7d6e48c37$var$me(), o = (0, $2gcPZ.useContext)($4e8e6ea7d6e48c37$export$2c657da244d00bd6), l = (0, $2gcPZ.useRef)(t.allocateGSInstance(a)).current;
        return t.server && h(l, e, t, o, n), (0, $2gcPZ.useLayoutEffect)(function() {
            if (!t.server) return h(l, e, t, o, n), function() {
                return u.removeStyles(l, t);
            };
        }, [
            l,
            e,
            t,
            o,
            n
        ]), null;
    }
    function h(e, t, n, r, o) {
        if (u.isStatic) u.renderStyles(e, $4e8e6ea7d6e48c37$var$O, n, o);
        else {
            var s = $4e8e6ea7d6e48c37$var$v({}, t, {
                theme: $4e8e6ea7d6e48c37$var$Re(t, r, l.defaultProps)
            });
            u.renderStyles(e, s, n, o);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).memo(l);
}
function $4e8e6ea7d6e48c37$export$d25ddfdf17c3ad3e(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    var o = $4e8e6ea7d6e48c37$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)).join(""), s = $4e8e6ea7d6e48c37$var$xe(o);
    return new $4e8e6ea7d6e48c37$var$ve(s, o);
}
var $4e8e6ea7d6e48c37$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $4e8e6ea7d6e48c37$var$q();
            return "<style " + [
                n && 'nonce="' + n + '"',
                $4e8e6ea7d6e48c37$var$A + '="true"',
                'data-styled-version="5.3.9"'
            ].filter(Boolean).join(" ") + ">" + t + "</style>";
        }, this.getStyleTags = function() {
            return e.sealed ? $4e8e6ea7d6e48c37$var$j(2) : e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var t;
            if (e.sealed) return $4e8e6ea7d6e48c37$var$j(2);
            var n = ((t = {})[$4e8e6ea7d6e48c37$var$A] = "", t["data-styled-version"] = "5.3.9", t.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, t), o = $4e8e6ea7d6e48c37$var$q();
            return o && (n.nonce = o), [
                (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).createElement("style", $4e8e6ea7d6e48c37$var$v({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $4e8e6ea7d6e48c37$var$Z({
            isServer: !0
        }), this.sealed = !1;
    }
    var t = e.prototype;
    return t.collectStyles = function(e) {
        return this.sealed ? $4e8e6ea7d6e48c37$var$j(2) : (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).createElement($4e8e6ea7d6e48c37$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, t.interleaveWithNodeStream = function(e) {
        return $4e8e6ea7d6e48c37$var$j(3);
    }, e;
}(), $4e8e6ea7d6e48c37$export$e8748c6a27b910dc = function(e) {
    var t = (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).forwardRef(function(t, n) {
        var o = (0, $2gcPZ.useContext)($4e8e6ea7d6e48c37$export$2c657da244d00bd6), i = e.defaultProps, a = $4e8e6ea7d6e48c37$var$Re(t, o, i);
        return (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).createElement(e, $4e8e6ea7d6e48c37$var$v({}, t, {
            theme: a,
            ref: n
        }));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($50b434e7ab34dacd$exports)))(t, e), t.displayName = "WithTheme(" + $4e8e6ea7d6e48c37$var$_(e) + ")", t;
}, $4e8e6ea7d6e48c37$export$93d4e7f90805808f = function() {
    return (0, $2gcPZ.useContext)($4e8e6ea7d6e48c37$export$2c657da244d00bd6);
}, $4e8e6ea7d6e48c37$export$5c87cfe6c475f500 = {
    StyleSheet: $4e8e6ea7d6e48c37$var$Z,
    masterSheet: $4e8e6ea7d6e48c37$var$he
};
var $4e8e6ea7d6e48c37$export$2e2bcd8739ae039 = $4e8e6ea7d6e48c37$var$He;





var $2gcPZ = parcelRequire("2gcPZ");




function $798c5c40009ebe8a$export$c84671f46d6a1ca({ children: children }) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($798c5c40009ebe8a$var$AppContainer, {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $cb106f951b2907d8$export$ef8da11641c635de), {}),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($798c5c40009ebe8a$var$Main, {
                children: children
            })
        ]
    });
}
const $798c5c40009ebe8a$var$AppContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: { media: media } })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    --spacing-nav-container: 56px;

    display: grid;
    grid-template-rows: var(--spacing-nav-container) 1fr;
    height: 100%;
    overflow: hidden;

    ${media.sm`
      --spacing-nav-container: 60px;
    `}
  `);
const $798c5c40009ebe8a$var$Main = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).main`
  overflow-y: auto;
`;








var $0c5c766c1e242605$exports = {};

$parcel$export($0c5c766c1e242605$exports, "Container", () => $0c5c766c1e242605$export$42a852a2b6b56249);
$parcel$export($0c5c766c1e242605$exports, "Content", () => $0c5c766c1e242605$export$7c6e2c02157bb7d2);
$parcel$export($0c5c766c1e242605$exports, "Header", () => $0c5c766c1e242605$export$8b251419efc915eb);
$parcel$export($0c5c766c1e242605$exports, "Heading", () => $0c5c766c1e242605$export$a8a3e93435678ff9);
$parcel$export($0c5c766c1e242605$exports, "HelperText", () => $0c5c766c1e242605$export$7bc3de131d90901c);
$parcel$export($0c5c766c1e242605$exports, "BigIcon", () => $0c5c766c1e242605$export$7e5aa1a6f087569b);



var $2gcPZ = parcelRequire("2gcPZ");

var $2gcPZ = parcelRequire("2gcPZ");
/**
 * @public
 */ const $b5a5866b74856a29$export$22a697fb29aac98d = (0, $2gcPZ.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});



var $2gcPZ = parcelRequire("2gcPZ");
const $ac453d01d9fa8f1a$export$2285bbca2c666415 = (0, $2gcPZ.createContext)({});



var $2gcPZ = parcelRequire("2gcPZ");

var $2gcPZ = parcelRequire("2gcPZ");
/**
 * @public
 */ const $3198de5e69aa0cdd$export$f224e4635b6f8ce2 = (0, $2gcPZ.createContext)(null);




var $2gcPZ = parcelRequire("2gcPZ");
const $4989af2740acfe07$export$4e09c449d6c407f7 = typeof document !== "undefined";


const $ad16f58ee69383b5$export$700979bc83e7db82 = (0, $4989af2740acfe07$export$4e09c449d6c407f7) ? (0, $2gcPZ.useLayoutEffect) : (0, $2gcPZ.useEffect);



var $2gcPZ = parcelRequire("2gcPZ");
const $24524d583ddee80d$export$40f10139ecf1f171 = (0, $2gcPZ.createContext)({
    strict: false
});



function $96d4c9b9a5aad237$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement) {
    const { visualElement: parent } = (0, $2gcPZ.useContext)((0, $ac453d01d9fa8f1a$export$2285bbca2c666415));
    const lazyContext = (0, $2gcPZ.useContext)((0, $24524d583ddee80d$export$40f10139ecf1f171));
    const presenceContext = (0, $2gcPZ.useContext)((0, $3198de5e69aa0cdd$export$f224e4635b6f8ce2));
    const reducedMotionConfig = (0, $2gcPZ.useContext)((0, $b5a5866b74856a29$export$22a697fb29aac98d)).reducedMotion;
    const visualElementRef = (0, $2gcPZ.useRef)();
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    (0, $2gcPZ.useInsertionEffect)(()=>{
        visualElement && visualElement.update(props, presenceContext);
    });
    (0, $ad16f58ee69383b5$export$700979bc83e7db82)(()=>{
        visualElement && visualElement.render();
    });
    (0, $2gcPZ.useEffect)(()=>{
        visualElement && visualElement.updateFeatures();
    });
    /**
     * Ideally this function would always run in a useEffect.
     *
     * However, if we have optimised appear animations to handoff from,
     * it needs to happen synchronously to ensure there's no flash of
     * incorrect styles in the event of a hydration error.
     *
     * So if we detect a situtation where optimised appear animations
     * are running, we use useLayoutEffect to trigger animations.
     */ const useAnimateChangesEffect = window.HandoffAppearAnimations ? (0, $ad16f58ee69383b5$export$700979bc83e7db82) : (0, $2gcPZ.useEffect);
    useAnimateChangesEffect(()=>{
        if (visualElement && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    return visualElement;
}



var $2gcPZ = parcelRequire("2gcPZ");
function $3e7c51262248630b$export$dedd81df7bc1307(ref) {
    return typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}


/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $4c091b51833e03e5$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $2gcPZ.useCallback)((instance)=>{
        instance && visualState.mount && visualState.mount(instance);
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $3e7c51262248630b$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}



var $2gcPZ = parcelRequire("2gcPZ");

/**
 * Decides if the supplied variable is variant label
 */ function $3f159601009ddaf2$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


function $d39b81e97dffc1d9$export$aa71198ceeaf53ce(v) {
    return typeof v === "object" && typeof v.start === "function";
}



const $d3885f669dd71fbf$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $d3885f669dd71fbf$export$1405a65085f40b9 = [
    "initial",
    ...$d3885f669dd71fbf$export$16e45afcc206d3a8
];


function $c90e990e74ab2ce2$export$4b3c3bd8d910d78d(props) {
    return (0, $d39b81e97dffc1d9$export$aa71198ceeaf53ce)(props.animate) || (0, $d3885f669dd71fbf$export$1405a65085f40b9).some((name)=>(0, $3f159601009ddaf2$export$720b90e312cea233)(props[name]));
}
function $c90e990e74ab2ce2$export$ce46fa4165cdec40(props) {
    return Boolean($c90e990e74ab2ce2$export$4b3c3bd8d910d78d(props) || props.variants);
}


function $9e48fcc98ecb5c41$export$12fc32fc096a04a3(props, context) {
    if ((0, $c90e990e74ab2ce2$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $3f159601009ddaf2$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $3f159601009ddaf2$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $9451b711bf3cf7f7$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $9e48fcc98ecb5c41$export$12fc32fc096a04a3)(props, (0, $2gcPZ.useContext)((0, $ac453d01d9fa8f1a$export$2285bbca2c666415)));
    return (0, $2gcPZ.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $9451b711bf3cf7f7$var$variantLabelsAsDependency(initial),
        $9451b711bf3cf7f7$var$variantLabelsAsDependency(animate)
    ]);
}
function $9451b711bf3cf7f7$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}


const $d1eb9b343be92f21$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $d1eb9b343be92f21$export$65570e08d843624d = {};
for(const key in $d1eb9b343be92f21$var$featureProps)$d1eb9b343be92f21$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$d1eb9b343be92f21$var$featureProps[key].some((name)=>!!props[name])
};


function $8d8ee0665779765e$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $d1eb9b343be92f21$export$65570e08d843624d)[key] = {
        ...(0, $d1eb9b343be92f21$export$65570e08d843624d)[key],
        ...features[key]
    };
}




var $2gcPZ = parcelRequire("2gcPZ");
const $f679b97cb314af99$export$a3579ca508007a95 = (0, $2gcPZ.createContext)({});




var $2gcPZ = parcelRequire("2gcPZ");
/**
 * Internal, exported only for usage in Framer
 */ const $594aee70035be9ea$export$da5f7b802957459a = (0, $2gcPZ.createContext)({});


const $9e113efc9de46794$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");


/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $683b720263bf4232$export$46b7e4b9dc6110c3({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    preloadedFeatures && (0, $8d8ee0665779765e$export$449561ec5703cdc8)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $2gcPZ.useContext)((0, $b5a5866b74856a29$export$22a697fb29aac98d)),
            ...props,
            layoutId: $683b720263bf4232$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $9451b711bf3cf7f7$export$c5638d843b37a176)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $4989af2740acfe07$export$4e09c449d6c407f7)) {
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $96d4c9b9a5aad237$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement);
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             */ const initialLayoutGroupConfig = (0, $2gcPZ.useContext)((0, $594aee70035be9ea$export$da5f7b802957459a));
            const isStrict = (0, $2gcPZ.useContext)((0, $24524d583ddee80d$export$40f10139ecf1f171)).strict;
            if (context.visualElement) MeasureLayout = context.visualElement.loadFeatures(// Note: Pass the full new combined props to correctly re-render dynamic feature components.
            configAndProps, isStrict, preloadedFeatures, initialLayoutGroupConfig);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return $2gcPZ.createElement((0, $ac453d01d9fa8f1a$export$2285bbca2c666415).Provider, {
            value: context
        }, MeasureLayout && context.visualElement ? $2gcPZ.createElement(MeasureLayout, {
            visualElement: context.visualElement,
            ...configAndProps
        }) : null, useRender(Component, props, (0, $4c091b51833e03e5$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement));
    }
    const ForwardRefComponent = (0, $2gcPZ.forwardRef)(MotionComponent);
    ForwardRefComponent[0, $9e113efc9de46794$export$28e2e4cce424ae23] = Component;
    return ForwardRefComponent;
}
function $683b720263bf4232$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $2gcPZ.useContext)((0, $f679b97cb314af99$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}



/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */ function $e6b2e5e028e31e14$export$a28d6df673050e18(createConfig) {
    function custom(Component, customMotionComponentConfig = {}) {
        return (0, $683b720263bf4232$export$46b7e4b9dc6110c3)(createConfig(Component, customMotionComponentConfig));
    }
    if (typeof Proxy === "undefined") return custom;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, custom(key));
            return componentCache.get(key);
        }
    });
}


/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $22d5a56ad21d348f$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $d871a0058d319304$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $22d5a56ad21d348f$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/.test(Component)) return true;
    return false;
}



var $2gcPZ = parcelRequire("2gcPZ");

var $2gcPZ = parcelRequire("2gcPZ");
const $edd8247212265180$export$91ddd985b97788d1 = {};
function $edd8247212265180$export$de9e7791c71225fd(correctors) {
    Object.assign($edd8247212265180$export$91ddd985b97788d1, correctors);
}


/**
 * Generate a list of every possible transform key.
 */ const $b25a583cb32de3e0$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $b25a583cb32de3e0$export$7b42a0094fb00b6e = new Set($b25a583cb32de3e0$export$280dc01950909d86);


function $ccb7efc074991e2b$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $b25a583cb32de3e0$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $edd8247212265180$export$91ddd985b97788d1)[key] || key === "opacity");
}


const $40691104928af1ab$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);



const $80556224d14cacbe$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $80556224d14cacbe$var$numTransforms = (0, $b25a583cb32de3e0$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $80556224d14cacbe$export$bdc96e0d5c8f914(transform, { enableHardwareAcceleration: enableHardwareAcceleration = true, allowTransformNone: allowTransformNone = true }, transformIsDefault, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $80556224d14cacbe$var$numTransforms; i++){
        const key = (0, $b25a583cb32de3e0$export$280dc01950909d86)[i];
        if (transform[key] !== undefined) {
            const transformName = $80556224d14cacbe$var$translateAlias[key] || key;
            transformString += `${transformName}(${transform[key]}) `;
        }
    }
    if (enableHardwareAcceleration && !transform.z) transformString += "translateZ(0)";
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (allowTransformNone && transformIsDefault) transformString = "none";
    return transformString;
}


const $15b5c3bffdb47066$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $15b5c3bffdb47066$export$9de1236619d9e756 = $15b5c3bffdb47066$var$checkStringStartsWith("--");
const $15b5c3bffdb47066$export$31f9caa2600b5723 = $15b5c3bffdb47066$var$checkStringStartsWith("var(--");
const $15b5c3bffdb47066$export$f7c0a352d8ef6313 = /var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)/g;



/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $3ef8c6b604c10bb0$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};


const $635d47cb6378920a$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);


const $3db28672b0a6a577$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $3db28672b0a6a577$export$58f0f39f63f3cf42 = {
    ...$3db28672b0a6a577$export$98e628dec113755e,
    transform: (v)=>(0, $635d47cb6378920a$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $3db28672b0a6a577$export$dcdf75081b88279d = {
    ...$3db28672b0a6a577$export$98e628dec113755e,
    default: 1
};


/**
 * TODO: When we move from string as a source of truth to data models
 * everything in this folder should probably be referred to as models vs types
 */ // If this number is a decimal, make it just five decimal places
// to avoid exponents
const $3b9c9662c5f9ca2b$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;
const $3b9c9662c5f9ca2b$export$2444ca58c08448e4 = /(-)?([\d]*\.?[\d])+/g;
const $3b9c9662c5f9ca2b$export$740b69c5fad25dba = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi;
const $3b9c9662c5f9ca2b$export$ed808ff6ecd39e8d = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function $3b9c9662c5f9ca2b$export$844ec244b1367d54(v) {
    return typeof v === "string";
}


const $ca276f8dec7edf41$var$createUnitType = (unit)=>({
        test: (v)=>(0, $3b9c9662c5f9ca2b$export$844ec244b1367d54)(v) && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $ca276f8dec7edf41$export$41fc368e1a942b97 = $ca276f8dec7edf41$var$createUnitType("deg");
const $ca276f8dec7edf41$export$626336c2cd4b14de = $ca276f8dec7edf41$var$createUnitType("%");
const $ca276f8dec7edf41$export$91c0eda1d06bf008 = $ca276f8dec7edf41$var$createUnitType("px");
const $ca276f8dec7edf41$export$f91e8c45a95a32f2 = $ca276f8dec7edf41$var$createUnitType("vh");
const $ca276f8dec7edf41$export$aed3d7b7d206c196 = $ca276f8dec7edf41$var$createUnitType("vw");
const $ca276f8dec7edf41$export$44e2e1705876d7ed = {
    ...$ca276f8dec7edf41$export$626336c2cd4b14de,
    parse: (v)=>$ca276f8dec7edf41$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$ca276f8dec7edf41$export$626336c2cd4b14de.transform(v * 100)
};



const $9f0db0b2f6db1a6f$export$7d260a2a5f8bc19e = {
    ...(0, $3db28672b0a6a577$export$98e628dec113755e),
    transform: Math.round
};


const $15c6a7b85ca55290$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    borderTopWidth: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    borderRightWidth: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    borderRadius: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    radius: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    maxWidth: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    height: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    maxHeight: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    size: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    top: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    right: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    bottom: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    left: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    paddingTop: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    paddingRight: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    paddingBottom: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    paddingLeft: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    margin: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    marginTop: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    marginRight: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    marginBottom: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    marginLeft: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    // Transform props
    rotate: (0, $ca276f8dec7edf41$export$41fc368e1a942b97),
    rotateX: (0, $ca276f8dec7edf41$export$41fc368e1a942b97),
    rotateY: (0, $ca276f8dec7edf41$export$41fc368e1a942b97),
    rotateZ: (0, $ca276f8dec7edf41$export$41fc368e1a942b97),
    scale: $3db28672b0a6a577$export$dcdf75081b88279d,
    scaleX: (0, $3db28672b0a6a577$export$dcdf75081b88279d),
    scaleY: (0, $3db28672b0a6a577$export$dcdf75081b88279d),
    scaleZ: (0, $3db28672b0a6a577$export$dcdf75081b88279d),
    skew: (0, $ca276f8dec7edf41$export$41fc368e1a942b97),
    skewX: (0, $ca276f8dec7edf41$export$41fc368e1a942b97),
    skewY: (0, $ca276f8dec7edf41$export$41fc368e1a942b97),
    distance: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    translateX: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    translateY: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    translateZ: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    x: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    y: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    z: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    perspective: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    transformPerspective: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    opacity: (0, $3db28672b0a6a577$export$58f0f39f63f3cf42),
    originX: (0, $ca276f8dec7edf41$export$44e2e1705876d7ed),
    originY: (0, $ca276f8dec7edf41$export$44e2e1705876d7ed),
    originZ: (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    // Misc
    zIndex: (0, $9f0db0b2f6db1a6f$export$7d260a2a5f8bc19e),
    // SVG
    fillOpacity: (0, $3db28672b0a6a577$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $3db28672b0a6a577$export$58f0f39f63f3cf42),
    numOctaves: (0, $9f0db0b2f6db1a6f$export$7d260a2a5f8bc19e)
};


function $c01395051c485855$export$bb517f8b40f8e99d(state, latestValues, options, transformTemplate) {
    const { style: style, vars: vars, transform: transform, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    let transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */ if ((0, $15b5c3bffdb47066$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        const valueType = (0, $15c6a7b85ca55290$export$eec14432cd1cb67b)[key];
        const valueAsType = (0, $3ef8c6b604c10bb0$export$453ef540a9a1bd6b)(value, valueType);
        if ((0, $b25a583cb32de3e0$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            // If we already know we have a non-default transform, early return
            if (!transformIsNone) continue;
            // Otherwise check to see if this is a default transform
            if (value !== (valueType.default || 0)) transformIsNone = false;
        } else if (key.startsWith("origin")) {
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
            transformOrigin[key] = valueAsType;
        } else style[key] = valueAsType;
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $80556224d14cacbe$export$bdc96e0d5c8f914)(state.transform, options, transformIsNone, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}


const $bae158d2bdee3d12$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


function $f9fb8251375bb2c2$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $40691104928af1ab$export$605d60a2578142d3)(source[key]) && !(0, $ccb7efc074991e2b$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $f9fb8251375bb2c2$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState, isStatic) {
    return (0, $2gcPZ.useMemo)(()=>{
        const state = (0, $bae158d2bdee3d12$export$8940b483cf52eeda)();
        (0, $c01395051c485855$export$bb517f8b40f8e99d)(state, visualState, {
            enableHardwareAcceleration: !isStatic
        }, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $f9fb8251375bb2c2$var$useStyle(props, visualState, isStatic) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $f9fb8251375bb2c2$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $f9fb8251375bb2c2$var$useInitialMotionValues(props, visualState, isStatic));
    return props.transformValues ? props.transformValues(style) : style;
}
function $f9fb8251375bb2c2$export$57be0a314572d87d(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $f9fb8251375bb2c2$var$useStyle(props, visualState, isStatic);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $7df0ca0ac7e2489b$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "transformValues",
    "custom",
    "inherit",
    "onLayoutAnimationStart",
    "onLayoutAnimationComplete",
    "onLayoutMeasure",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $7df0ca0ac7e2489b$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || $7df0ca0ac7e2489b$var$validMotionProps.has(key);
}


let $99904b5df54a815f$var$shouldForward = (key)=>!(0, $7df0ca0ac7e2489b$export$2f9c46555243bf04)(key);
function $99904b5df54a815f$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $99904b5df54a815f$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $7df0ca0ac7e2489b$export$2f9c46555243bf04)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $99904b5df54a815f$export$59d6962c470509a5((parcelRequire("jO74U")).default);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $99904b5df54a815f$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($99904b5df54a815f$var$shouldForward(key) || forwardMotionProps === true && (0, $7df0ca0ac7e2489b$export$2f9c46555243bf04)(key) || !isDom && !(0, $7df0ca0ac7e2489b$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}




var $2gcPZ = parcelRequire("2gcPZ");



function $61b07b112ad29060$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $ca276f8dec7edf41$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $61b07b112ad29060$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $61b07b112ad29060$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $61b07b112ad29060$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}



const $cd88269b292b03e8$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $cd88269b292b03e8$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $cd88269b292b03e8$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $cd88269b292b03e8$var$dashKeys : $cd88269b292b03e8$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $ca276f8dec7edf41$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $ca276f8dec7edf41$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $ca276f8dec7edf41$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $3d72eb36e78ecf71$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, options, isSVGTag, transformTemplate) {
    (0, $c01395051c485855$export$bb517f8b40f8e99d)(state, latest, options, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $61b07b112ad29060$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $cd88269b292b03e8$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}



const $fe8f93ae93d5f704$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $bae158d2bdee3d12$export$8940b483cf52eeda)(),
        attrs: {}
    });


const $56f23e3e58132193$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";


function $7ad80c5645b0b38b$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $2gcPZ.useMemo)(()=>{
        const state = (0, $fe8f93ae93d5f704$export$41be8b43e1c4d4f9)();
        (0, $3d72eb36e78ecf71$export$5475d24f125d7053)(state, visualState, {
            enableHardwareAcceleration: false
        }, (0, $56f23e3e58132193$export$6328ce7565ea1049)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $f9fb8251375bb2c2$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}



function $6707a62640e7b2f4$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $d871a0058d319304$export$88f3fc2fd3766989)(Component) ? (0, $7ad80c5645b0b38b$export$84309c4f53cb1bd5) : (0, $f9fb8251375bb2c2$export$57be0a314572d87d);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $99904b5df54a815f$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = {
            ...filteredProps,
            ...visualProps,
            ref: ref
        };
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children } = props;
        const renderedChildren = (0, $2gcPZ.useMemo)(()=>(0, $40691104928af1ab$export$605d60a2578142d3)(children) ? children.get() : children, [
            children
        ]);
        return (0, $2gcPZ.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}


/**
 * Convert camelCase to dash-case properties.
 */ const $ef58bee680d214c3$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();


function $7b7d80b641b76eab$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $48cf872e59d6d084$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


function $a714ce5de61c73cd$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $7b7d80b641b76eab$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $48cf872e59d6d084$export$28931db5d57958e5).has(key) ? (0, $ef58bee680d214c3$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $0511a22a5bb38274$export$16da615486abaa45(props, prevProps) {
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $40691104928af1ab$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $40691104928af1ab$export$605d60a2578142d3)(prevProps.style[key]) || (0, $ccb7efc074991e2b$export$6d27ce8e3de1c3cf)(key, props)) newValues[key] = style[key];
    return newValues;
}



function $6adee4e45678a40b$export$16da615486abaa45(props, prevProps) {
    const newValues = (0, $0511a22a5bb38274$export$16da615486abaa45)(props, prevProps);
    for(const key in props)if ((0, $40691104928af1ab$export$605d60a2578142d3)(props[key]) || (0, $40691104928af1ab$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $b25a583cb32de3e0$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}



var $2gcPZ = parcelRequire("2gcPZ");


function $2c8ef2a1a049b491$export$d68f140c4d9b48bc(props, definition, custom, currentValues = {}, currentVelocity = {}) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    return definition;
}



var $2gcPZ = parcelRequire("2gcPZ");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $3263fe593d864f70$export$fe4300aa8eebea86(init) {
    const ref = (0, $2gcPZ.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}


const $53442b5a509d9f4b$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


const $fdcd80e87b1fd446$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $fdcd80e87b1fd446$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $53442b5a509d9f4b$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
};



/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $be1238c34e009d37$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $40691104928af1ab$export$605d60a2578142d3)(value) ? value.get() : value;
    return (0, $fdcd80e87b1fd446$export$2f308ad9864b3ac9)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}




function $14591909cdf64160$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onMount: onMount }, props, context, presenceContext) {
    const state = {
        latestValues: $14591909cdf64160$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = (instance)=>onMount(props, instance, state);
    return state;
}
const $14591909cdf64160$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $2gcPZ.useContext)((0, $ac453d01d9fa8f1a$export$2285bbca2c666415));
        const presenceContext = (0, $2gcPZ.useContext)((0, $3198de5e69aa0cdd$export$f224e4635b6f8ce2));
        const make = ()=>$14591909cdf64160$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $3263fe593d864f70$export$fe4300aa8eebea86)(make);
    };
function $14591909cdf64160$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $be1238c34e009d37$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $c90e990e74ab2ce2$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $c90e990e74ab2ce2$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $d39b81e97dffc1d9$export$aa71198ceeaf53ce)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        list.forEach((definition)=>{
            const resolved = (0, $2c8ef2a1a049b491$export$d68f140c4d9b48bc)(props, definition);
            if (!resolved) return;
            const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
            for(const key in target){
                let valueTarget = target[key];
                if (Array.isArray(valueTarget)) {
                    /**
                     * Take final keyframe if the initial animation is blocked because
                     * we want to initialise at the end of that blocked animation.
                     */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                    valueTarget = valueTarget[index];
                }
                if (valueTarget !== null) values[key] = valueTarget;
            }
            for(const key in transitionEnd)values[key] = transitionEnd[key];
        });
    }
    return values;
}





const $b989e126b6770243$export$44dabd3fae512e85 = {
    useVisualState: (0, $14591909cdf64160$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $6adee4e45678a40b$export$16da615486abaa45),
        createRenderState: (0, $fe8f93ae93d5f704$export$41be8b43e1c4d4f9),
        onMount: (props, instance, { renderState: renderState, latestValues: latestValues })=>{
            try {
                renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
            } catch (e) {
                // Most likely trying to measure an unrendered element under Firefox
                renderState.dimensions = {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                };
            }
            (0, $3d72eb36e78ecf71$export$5475d24f125d7053)(renderState, latestValues, {
                enableHardwareAcceleration: false
            }, (0, $56f23e3e58132193$export$6328ce7565ea1049)(instance.tagName), props.transformTemplate);
            (0, $a714ce5de61c73cd$export$c5f8399d19a7394b)(instance, renderState);
        }
    })
};





const $8c48a93e8695897d$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $14591909cdf64160$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: $0511a22a5bb38274$export$16da615486abaa45,
        createRenderState: (0, $bae158d2bdee3d12$export$8940b483cf52eeda)
    })
};


function $4673bf8afc8607d6$export$732916c0e88175fb(Component, { forwardMotionProps: forwardMotionProps = false }, preloadedFeatures, createVisualElement) {
    const baseConfig = (0, $d871a0058d319304$export$88f3fc2fd3766989)(Component) ? (0, $b989e126b6770243$export$44dabd3fae512e85) : (0, $8c48a93e8695897d$export$e13ea21d87ea57c8);
    return {
        ...baseConfig,
        preloadedFeatures: preloadedFeatures,
        useRender: (0, $6707a62640e7b2f4$export$5d29104eefd89cc8)(forwardMotionProps),
        createVisualElement: createVisualElement,
        Component: Component
    };
}


function $1eafa31e475fa1b9$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}


const $72135cf2fadcce8b$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};


function $37ad62a5a00c9515$export$12f84bb882d06e1a(event, pointType = "page") {
    return {
        point: {
            x: event[pointType + "X"],
            y: event[pointType + "Y"]
        }
    };
}
const $37ad62a5a00c9515$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $72135cf2fadcce8b$export$a4cf9c8a4b063a6e)(event) && handler(event, $37ad62a5a00c9515$export$12f84bb882d06e1a(event));
};


function $705ce2c92f6e40ca$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $1eafa31e475fa1b9$export$b1d829ddf82884aa)(target, eventName, (0, $37ad62a5a00c9515$export$c404e80f92c98d29)(handler), options);
}


/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $57a0a335cd293854$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $57a0a335cd293854$export$a4627e546088548d = (...transformers)=>transformers.reduce($57a0a335cd293854$var$combineFunctions);


function $e59e159b20744553$export$518c5fc2dcb7974b(name) {
    let lock = null;
    return ()=>{
        const openLock = ()=>{
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
const $e59e159b20744553$var$globalHorizontalLock = $e59e159b20744553$export$518c5fc2dcb7974b("dragHorizontal");
const $e59e159b20744553$var$globalVerticalLock = $e59e159b20744553$export$518c5fc2dcb7974b("dragVertical");
function $e59e159b20744553$export$2b7959ed03c1a3fe(drag) {
    let lock = false;
    if (drag === "y") lock = $e59e159b20744553$var$globalVerticalLock();
    else if (drag === "x") lock = $e59e159b20744553$var$globalHorizontalLock();
    else {
        const openHorizontal = $e59e159b20744553$var$globalHorizontalLock();
        const openVertical = $e59e159b20744553$var$globalVerticalLock();
        if (openHorizontal && openVertical) lock = ()=>{
            openHorizontal();
            openVertical();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal) openHorizontal();
            if (openVertical) openVertical();
        }
    }
    return lock;
}
function $e59e159b20744553$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    const openGestureLock = $e59e159b20744553$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}


class $ab6644c4f7a97411$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}


function $16c3e0339555e720$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two arrays, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let toRun = [];
    let toRunNextFrame = [];
    /**
     *
     */ let numToRun = 0;
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const buffer = addToCurrentFrame ? toRun : toRunNextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            // If the buffer doesn't already contain this callback, add it
            if (buffer.indexOf(callback) === -1) {
                buffer.push(callback);
                // If we're adding it to the currently running buffer, update its measured size
                if (addToCurrentFrame && isProcessing) numToRun = toRun.length;
            }
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            const index = toRunNextFrame.indexOf(callback);
            if (index !== -1) toRunNextFrame.splice(index, 1);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [toRun, toRunNextFrame] = [
                toRunNextFrame,
                toRun
            ];
            // Clear the next frame list
            toRunNextFrame.length = 0;
            // Execute this frame
            numToRun = toRun.length;
            if (numToRun) for(let i = 0; i < numToRun; i++){
                const callback = toRun[i];
                callback(frameData);
                if (toKeepAlive.has(callback)) {
                    step.schedule(callback);
                    runNextFrame();
                }
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $ef064ed7af32d6e0$export$fff89137e9e818ce = {
    delta: 0,
    timestamp: 0,
    isProcessing: false
};


const $d959fd4c7cb328b7$var$maxElapsed = 40;
let $d959fd4c7cb328b7$var$useDefaultElapsed = true;
let $d959fd4c7cb328b7$var$runNextFrame = false;
const $d959fd4c7cb328b7$export$71ecace0a033b35a = [
    "read",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $d959fd4c7cb328b7$export$be3f796aed065412 = $d959fd4c7cb328b7$export$71ecace0a033b35a.reduce((acc, key)=>{
    acc[key] = (0, $16c3e0339555e720$export$b995e5e85f5c8289)(()=>$d959fd4c7cb328b7$var$runNextFrame = true);
    return acc;
}, {});
const $d959fd4c7cb328b7$var$processStep = (stepId)=>$d959fd4c7cb328b7$export$be3f796aed065412[stepId].process((0, $ef064ed7af32d6e0$export$fff89137e9e818ce));
const $d959fd4c7cb328b7$var$processFrame = (timestamp)=>{
    $d959fd4c7cb328b7$var$runNextFrame = false;
    (0, $ef064ed7af32d6e0$export$fff89137e9e818ce).delta = $d959fd4c7cb328b7$var$useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - (0, $ef064ed7af32d6e0$export$fff89137e9e818ce).timestamp, $d959fd4c7cb328b7$var$maxElapsed), 1);
    (0, $ef064ed7af32d6e0$export$fff89137e9e818ce).timestamp = timestamp;
    (0, $ef064ed7af32d6e0$export$fff89137e9e818ce).isProcessing = true;
    $d959fd4c7cb328b7$export$71ecace0a033b35a.forEach($d959fd4c7cb328b7$var$processStep);
    (0, $ef064ed7af32d6e0$export$fff89137e9e818ce).isProcessing = false;
    if ($d959fd4c7cb328b7$var$runNextFrame) {
        $d959fd4c7cb328b7$var$useDefaultElapsed = false;
        requestAnimationFrame($d959fd4c7cb328b7$var$processFrame);
    }
};
const $d959fd4c7cb328b7$var$startLoop = ()=>{
    $d959fd4c7cb328b7$var$runNextFrame = true;
    $d959fd4c7cb328b7$var$useDefaultElapsed = true;
    if (!(0, $ef064ed7af32d6e0$export$fff89137e9e818ce).isProcessing) requestAnimationFrame($d959fd4c7cb328b7$var$processFrame);
};
const $d959fd4c7cb328b7$export$2cef06c20297c17d = $d959fd4c7cb328b7$export$71ecace0a033b35a.reduce((acc, key)=>{
    const step = $d959fd4c7cb328b7$export$be3f796aed065412[key];
    acc[key] = (process, keepAlive = false, immediate = false)=>{
        if (!$d959fd4c7cb328b7$var$runNextFrame) $d959fd4c7cb328b7$var$startLoop();
        return step.schedule(process, keepAlive, immediate);
    };
    return acc;
}, {});
function $d959fd4c7cb328b7$export$ec99c0ef4978dccb(process) {
    $d959fd4c7cb328b7$export$71ecace0a033b35a.forEach((key)=>$d959fd4c7cb328b7$export$be3f796aed065412[key].cancel(process));
}


function $516f6ff88a54eee7$var$addHoverEvent(node, isActive) {
    const eventName = "pointer" + (isActive ? "enter" : "leave");
    const callbackName = "onHover" + (isActive ? "Start" : "End");
    const handleEvent = (event, info)=>{
        if (event.type === "touch" || (0, $e59e159b20744553$export$1b3dd616664938e4)()) return;
        const props = node.getProps();
        if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", isActive);
        if (props[callbackName]) (0, $d959fd4c7cb328b7$export$2cef06c20297c17d).update(()=>props[callbackName](event, info));
    };
    return (0, $705ce2c92f6e40ca$export$fcff2e64e6676b81)(node.current, eventName, handleEvent, {
        passive: !node.getProps()[callbackName]
    });
}
class $516f6ff88a54eee7$export$93a81ea037eac456 extends (0, $ab6644c4f7a97411$export$6e91cf7616333d5) {
    mount() {
        this.unmount = (0, $57a0a335cd293854$export$a4627e546088548d)($516f6ff88a54eee7$var$addHoverEvent(this.node, true), $516f6ff88a54eee7$var$addHoverEvent(this.node, false));
    }
    unmount() {}
}





class $0c31fdae5e03f211$export$d4826db40d47595b extends (0, $ab6644c4f7a97411$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $57a0a335cd293854$export$a4627e546088548d)((0, $1eafa31e475fa1b9$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $1eafa31e475fa1b9$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}








/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $86dac4ea80c24d47$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $86dac4ea80c24d47$export$e841ada32ff745b(parent, child.parentElement);
};


const $698766df269bc8f4$export$8793edee2d425525 = (any)=>any;



function $2e7a3db49260710e$var$fireSyntheticPointerEvent(name, handler) {
    if (!handler) return;
    const syntheticPointerEvent = new PointerEvent("pointer" + name);
    handler(syntheticPointerEvent, (0, $37ad62a5a00c9515$export$12f84bb882d06e1a)(syntheticPointerEvent));
}
class $2e7a3db49260710e$export$f026abdbba7f0c9e extends (0, $ab6644c4f7a97411$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removeStartListeners = (0, $698766df269bc8f4$export$8793edee2d425525);
        this.removeEndListeners = (0, $698766df269bc8f4$export$8793edee2d425525);
        this.removeAccessibleListeners = (0, $698766df269bc8f4$export$8793edee2d425525);
        this.startPointerPress = (startEvent, startInfo)=>{
            this.removeEndListeners();
            if (this.isPressing) return;
            const props = this.node.getProps();
            const endPointerPress = (endEvent, endInfo)=>{
                if (!this.checkPressEnd()) return;
                const { onTap: onTap, onTapCancel: onTapCancel } = this.node.getProps();
                (0, $d959fd4c7cb328b7$export$2cef06c20297c17d).update(()=>{
                    /**
                     * We only count this as a tap gesture if the event.target is the same
                     * as, or a child of, this component's element
                     */ !(0, $86dac4ea80c24d47$export$e841ada32ff745b)(this.node.current, endEvent.target) ? onTapCancel && onTapCancel(endEvent, endInfo) : onTap && onTap(endEvent, endInfo);
                });
            };
            const removePointerUpListener = (0, $705ce2c92f6e40ca$export$fcff2e64e6676b81)(window, "pointerup", endPointerPress, {
                passive: !(props.onTap || props["onPointerUp"])
            });
            const removePointerCancelListener = (0, $705ce2c92f6e40ca$export$fcff2e64e6676b81)(window, "pointercancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo), {
                passive: !(props.onTapCancel || props["onPointerCancel"])
            });
            this.removeEndListeners = (0, $57a0a335cd293854$export$a4627e546088548d)(removePointerUpListener, removePointerCancelListener);
            this.startPress(startEvent, startInfo);
        };
        this.startAccessiblePress = ()=>{
            const handleKeydown = (keydownEvent)=>{
                if (keydownEvent.key !== "Enter" || this.isPressing) return;
                const handleKeyup = (keyupEvent)=>{
                    if (keyupEvent.key !== "Enter" || !this.checkPressEnd()) return;
                    $2e7a3db49260710e$var$fireSyntheticPointerEvent("up", (event, info)=>{
                        const { onTap: onTap } = this.node.getProps();
                        if (onTap) (0, $d959fd4c7cb328b7$export$2cef06c20297c17d).update(()=>onTap(event, info));
                    });
                };
                this.removeEndListeners();
                this.removeEndListeners = (0, $1eafa31e475fa1b9$export$b1d829ddf82884aa)(this.node.current, "keyup", handleKeyup);
                $2e7a3db49260710e$var$fireSyntheticPointerEvent("down", (event, info)=>{
                    this.startPress(event, info);
                });
            };
            const removeKeydownListener = (0, $1eafa31e475fa1b9$export$b1d829ddf82884aa)(this.node.current, "keydown", handleKeydown);
            const handleBlur = ()=>{
                if (!this.isPressing) return;
                $2e7a3db49260710e$var$fireSyntheticPointerEvent("cancel", (cancelEvent, cancelInfo)=>this.cancelPress(cancelEvent, cancelInfo));
            };
            const removeBlurListener = (0, $1eafa31e475fa1b9$export$b1d829ddf82884aa)(this.node.current, "blur", handleBlur);
            this.removeAccessibleListeners = (0, $57a0a335cd293854$export$a4627e546088548d)(removeKeydownListener, removeBlurListener);
        };
    }
    startPress(event, info) {
        this.isPressing = true;
        const { onTapStart: onTapStart, whileTap: whileTap } = this.node.getProps();
        /**
         * Ensure we trigger animations before firing event callback
         */ if (whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", true);
        if (onTapStart) (0, $d959fd4c7cb328b7$export$2cef06c20297c17d).update(()=>onTapStart(event, info));
    }
    checkPressEnd() {
        this.removeEndListeners();
        this.isPressing = false;
        const props = this.node.getProps();
        if (props.whileTap && this.node.animationState) this.node.animationState.setActive("whileTap", false);
        return !(0, $e59e159b20744553$export$1b3dd616664938e4)();
    }
    cancelPress(event, info) {
        if (!this.checkPressEnd()) return;
        const { onTapCancel: onTapCancel } = this.node.getProps();
        if (onTapCancel) (0, $d959fd4c7cb328b7$export$2cef06c20297c17d).update(()=>onTapCancel(event, info));
    }
    mount() {
        const props = this.node.getProps();
        const removePointerListener = (0, $705ce2c92f6e40ca$export$fcff2e64e6676b81)(this.node.current, "pointerdown", this.startPointerPress, {
            passive: !(props.onTapStart || props["onPointerStart"])
        });
        const removeFocusListener = (0, $1eafa31e475fa1b9$export$b1d829ddf82884aa)(this.node.current, "focus", this.startAccessiblePress);
        this.removeStartListeners = (0, $57a0a335cd293854$export$a4627e546088548d)(removePointerListener, removeFocusListener);
    }
    unmount() {
        this.removeStartListeners();
        this.removeEndListeners();
        this.removeAccessibleListeners();
    }
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $4a286d285fa38ddc$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $4a286d285fa38ddc$var$observers = new WeakMap();
const $4a286d285fa38ddc$var$fireObserverCallback = (entry)=>{
    const callback = $4a286d285fa38ddc$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $4a286d285fa38ddc$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($4a286d285fa38ddc$var$fireObserverCallback);
};
function $4a286d285fa38ddc$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$4a286d285fa38ddc$var$observers.has(lookupRoot)) $4a286d285fa38ddc$var$observers.set(lookupRoot, {});
    const rootObservers = $4a286d285fa38ddc$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($4a286d285fa38ddc$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $4a286d285fa38ddc$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $4a286d285fa38ddc$var$initIntersectionObserver(options);
    $4a286d285fa38ddc$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $4a286d285fa38ddc$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $c121f0d17c237a13$var$thresholdNames = {
    some: 0,
    all: 1
};
class $c121f0d17c237a13$export$150851c8cc2f0c72 extends (0, $ab6644c4f7a97411$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $c121f0d17c237a13$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $4a286d285fa38ddc$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($c121f0d17c237a13$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $c121f0d17c237a13$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $325d5b8c575cc3a3$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $c121f0d17c237a13$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $2e7a3db49260710e$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $0c31fdae5e03f211$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $516f6ff88a54eee7$export$93a81ea037eac456)
    }
};





function $80a01873ec27e152$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}




/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */ function $17da0c2d09e6a150$var$getCurrent(visualElement) {
    const current = {};
    visualElement.values.forEach((value, key)=>current[key] = value.get());
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */ function $17da0c2d09e6a150$var$getVelocity(visualElement) {
    const velocity = {};
    visualElement.values.forEach((value, key)=>velocity[key] = value.getVelocity());
    return velocity;
}
function $17da0c2d09e6a150$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $2c8ef2a1a049b491$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, $17da0c2d09e6a150$var$getCurrent(visualElement), $17da0c2d09e6a150$var$getVelocity(visualElement));
}







const $1f191d6b0abb9602$export$ed7b8fa9dbf0105d = "framerAppearId";
const $1f191d6b0abb9602$export$8592e1c077c890a6 = "data-" + (0, $ef58bee680d214c3$export$9fd24a634729c672)($1f191d6b0abb9602$export$ed7b8fa9dbf0105d);



let $f3c6a28fc8795b13$export$491112666e282270 = (0, $698766df269bc8f4$export$8793edee2d425525);
let $f3c6a28fc8795b13$export$f5708dca728d7177 = (0, $698766df269bc8f4$export$8793edee2d425525);
var $f3c6a28fc8795b13$var$check, $f3c6a28fc8795b13$var$message, $f3c6a28fc8795b13$var$check1, $f3c6a28fc8795b13$var$message1;


/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ const $93c5ce4b0f38c723$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
const $93c5ce4b0f38c723$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;


const $e8c0bf68d4a30d76$export$888a3d84909f9e3d = {
    current: false
};



const $4c0c8f588f005525$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";


function $1fd818a7bd0ae395$export$fcdd8f3f2160beda(easing) {
    return Boolean(!easing || typeof easing === "string" && $1fd818a7bd0ae395$export$2cf569f5e2221176[easing] || (0, $4c0c8f588f005525$export$ff43f99925d7366b)(easing) || Array.isArray(easing) && easing.every($1fd818a7bd0ae395$export$fcdd8f3f2160beda));
}
const $1fd818a7bd0ae395$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $1fd818a7bd0ae395$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: $1fd818a7bd0ae395$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: $1fd818a7bd0ae395$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: $1fd818a7bd0ae395$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: $1fd818a7bd0ae395$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $1fd818a7bd0ae395$export$916ea73bcd3a6030(easing) {
    if (!easing) return undefined;
    return (0, $4c0c8f588f005525$export$ff43f99925d7366b)(easing) ? $1fd818a7bd0ae395$export$2523b8f0bd8f44cb(easing) : Array.isArray(easing) ? easing.map($1fd818a7bd0ae395$export$916ea73bcd3a6030) : $1fd818a7bd0ae395$export$2cf569f5e2221176[easing];
}


function $c2f2dd293550b84f$export$c76cd972d26986f9(element, valueName, keyframes, { delay: delay = 0, duration: duration, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease, times: times } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $1fd818a7bd0ae395$export$916ea73bcd3a6030)(ease);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}



const $b555914fef88b800$var$featureTests = {
    waapi: ()=>Object.hasOwnProperty.call(Element.prototype, "animate")
};
const $b555914fef88b800$var$results = {};
const $b555914fef88b800$export$cde6a56f9669daf6 = {};
/**
 * Generate features tests that cache their results.
 */ for(const key in $b555914fef88b800$var$featureTests)$b555914fef88b800$export$cde6a56f9669daf6[key] = ()=>{
    if ($b555914fef88b800$var$results[key] === undefined) $b555914fef88b800$var$results[key] = $b555914fef88b800$var$featureTests[key]();
    return $b555914fef88b800$var$results[key];
};


function $099119182bd50243$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }) {
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : keyframes.length - 1;
    return keyframes[index];
}



/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $1c165a75e95ed162$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $1c165a75e95ed162$var$subdivisionPrecision = 0.0000001;
const $1c165a75e95ed162$var$subdivisionMaxIterations = 12;
function $1c165a75e95ed162$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $1c165a75e95ed162$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $1c165a75e95ed162$var$subdivisionPrecision && ++i < $1c165a75e95ed162$var$subdivisionMaxIterations);
    return currentT;
}
function $1c165a75e95ed162$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $698766df269bc8f4$export$8793edee2d425525;
    const getTForX = (aX)=>$1c165a75e95ed162$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $1c165a75e95ed162$var$calcBezier(getTForX(t), mY1, mY2);
}


const $2d39f912b4b510f8$export$929e5a82286172a6 = (0, $1c165a75e95ed162$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $2d39f912b4b510f8$export$57636bb43b1ccbb0 = (0, $1c165a75e95ed162$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $2d39f912b4b510f8$export$c07234257a03d5e9 = (0, $1c165a75e95ed162$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);


const $0384e0581614a062$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};






// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $fd22e640349721c6$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $303d4b2957480fff$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $a67b54e7526e09bf$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $a67b54e7526e09bf$export$c8d67a19199d1a50 = (0, $303d4b2957480fff$export$2c07eeff45156d4d)($a67b54e7526e09bf$export$e444123e42d03385);
const $a67b54e7526e09bf$export$30d3455eee55bed5 = (0, $fd22e640349721c6$export$f946554fb8aeaf0d)($a67b54e7526e09bf$export$c8d67a19199d1a50);





const $208d3327d8949b08$export$77edfce482316a60 = (0, $1c165a75e95ed162$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $208d3327d8949b08$export$b01116c84cdfe1a2 = (0, $303d4b2957480fff$export$2c07eeff45156d4d)($208d3327d8949b08$export$77edfce482316a60);
const $208d3327d8949b08$export$ddc5fd596f6c71b2 = (0, $fd22e640349721c6$export$f946554fb8aeaf0d)($208d3327d8949b08$export$b01116c84cdfe1a2);



const $aa5e41ec04b68ea3$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $208d3327d8949b08$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));


const $01c57b98418cd911$var$easingLookup = {
    linear: (0, $698766df269bc8f4$export$8793edee2d425525),
    easeIn: $2d39f912b4b510f8$export$929e5a82286172a6,
    easeInOut: $2d39f912b4b510f8$export$c07234257a03d5e9,
    easeOut: $2d39f912b4b510f8$export$57636bb43b1ccbb0,
    circIn: $a67b54e7526e09bf$export$e444123e42d03385,
    circInOut: $a67b54e7526e09bf$export$30d3455eee55bed5,
    circOut: $a67b54e7526e09bf$export$c8d67a19199d1a50,
    backIn: $208d3327d8949b08$export$b01116c84cdfe1a2,
    backInOut: $208d3327d8949b08$export$ddc5fd596f6c71b2,
    backOut: $208d3327d8949b08$export$77edfce482316a60,
    anticipate: $aa5e41ec04b68ea3$export$6b0af63b873d419e
};
const $01c57b98418cd911$export$ef97fe084f156ca4 = (definition)=>{
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $f3c6a28fc8795b13$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $1c165a75e95ed162$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $f3c6a28fc8795b13$export$f5708dca728d7177)($01c57b98418cd911$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $01c57b98418cd911$var$easingLookup[definition];
    }
    return definition;
};








/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $ada1d0d211f27fb4$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean((0, $3b9c9662c5f9ca2b$export$844ec244b1367d54)(v) && (0, $3b9c9662c5f9ca2b$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $ada1d0d211f27fb4$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (!(0, $3b9c9662c5f9ca2b$export$844ec244b1367d54)(v)) return v;
        const [a, b, c, alpha] = v.match((0, $3b9c9662c5f9ca2b$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $733efa29f0447519$var$clampRgbUnit = (v)=>(0, $635d47cb6378920a$export$7d15b64cf5a3a4c4)(0, 255, v);
const $733efa29f0447519$export$7a99c86b5b1f4c9e = {
    ...(0, $3db28672b0a6a577$export$98e628dec113755e),
    transform: (v)=>Math.round($733efa29f0447519$var$clampRgbUnit(v))
};
const $733efa29f0447519$export$4e46ac54fc82cf3b = {
    test: (0, $ada1d0d211f27fb4$export$2c8400d58aca05e)("rgb", "red"),
    parse: (0, $ada1d0d211f27fb4$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $733efa29f0447519$export$7a99c86b5b1f4c9e.transform(red) + ", " + $733efa29f0447519$export$7a99c86b5b1f4c9e.transform(green) + ", " + $733efa29f0447519$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $3b9c9662c5f9ca2b$export$83d2e9e3e4ee39ed)((0, $3db28672b0a6a577$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $0dee0c1bcb382a87$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $0dee0c1bcb382a87$export$834dfc94dde4b3d8 = {
    test: (0, $ada1d0d211f27fb4$export$2c8400d58aca05e)("#"),
    parse: $0dee0c1bcb382a87$var$parseHex,
    transform: (0, $733efa29f0447519$export$4e46ac54fc82cf3b).transform
};






const $940c656974595790$export$810b04175080204c = {
    test: (0, $ada1d0d211f27fb4$export$2c8400d58aca05e)("hsl", "hue"),
    parse: (0, $ada1d0d211f27fb4$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $ca276f8dec7edf41$export$626336c2cd4b14de).transform((0, $3b9c9662c5f9ca2b$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $ca276f8dec7edf41$export$626336c2cd4b14de).transform((0, $3b9c9662c5f9ca2b$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $3b9c9662c5f9ca2b$export$83d2e9e3e4ee39ed)((0, $3db28672b0a6a577$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $7d11bcabbac03365$export$35e9368ef982300f = {
    test: (v)=>(0, $733efa29f0447519$export$4e46ac54fc82cf3b).test(v) || (0, $0dee0c1bcb382a87$export$834dfc94dde4b3d8).test(v) || (0, $940c656974595790$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $733efa29f0447519$export$4e46ac54fc82cf3b).test(v)) return (0, $733efa29f0447519$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $940c656974595790$export$810b04175080204c).test(v)) return (0, $940c656974595790$export$810b04175080204c).parse(v);
        else return (0, $0dee0c1bcb382a87$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return (0, $3b9c9662c5f9ca2b$export$844ec244b1367d54)(v) ? v : v.hasOwnProperty("red") ? (0, $733efa29f0447519$export$4e46ac54fc82cf3b).transform(v) : (0, $940c656974595790$export$810b04175080204c).transform(v);
    }
};



/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $5cbd34a3bc31f43d$export$2c9e8a9632a706b2 = (from, to, progress)=>-progress * from + progress * to + from;




// Adapted from https://gist.github.com/mjackson/5311256
function $405ea57f359b2e6a$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $405ea57f359b2e6a$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $405ea57f359b2e6a$var$hueToRgb(p, q, hue + 1 / 3);
        green = $405ea57f359b2e6a$var$hueToRgb(p, q, hue);
        blue = $405ea57f359b2e6a$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}





// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $9792e8c2d440e5a9$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    return Math.sqrt(Math.max(0, v * (to * to - fromExpo) + fromExpo));
};
const $9792e8c2d440e5a9$var$colorTypes = [
    (0, $0dee0c1bcb382a87$export$834dfc94dde4b3d8),
    (0, $733efa29f0447519$export$4e46ac54fc82cf3b),
    (0, $940c656974595790$export$810b04175080204c)
];
const $9792e8c2d440e5a9$var$getColorType = (v)=>$9792e8c2d440e5a9$var$colorTypes.find((type)=>type.test(v));
function $9792e8c2d440e5a9$var$asRGBA(color) {
    const type = $9792e8c2d440e5a9$var$getColorType(color);
    (0, $f3c6a28fc8795b13$export$f5708dca728d7177)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    let model = type.parse(color);
    if (type === (0, $940c656974595790$export$810b04175080204c)) // TODO Remove this cast - needed since Framer Motion's stricter typing
    model = (0, $405ea57f359b2e6a$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $9792e8c2d440e5a9$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $9792e8c2d440e5a9$var$asRGBA(from);
    const toRGBA = $9792e8c2d440e5a9$var$asRGBA(to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $9792e8c2d440e5a9$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $9792e8c2d440e5a9$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $9792e8c2d440e5a9$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $5cbd34a3bc31f43d$export$2c9e8a9632a706b2)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $733efa29f0447519$export$4e46ac54fc82cf3b).transform(blended);
    };
};












function $4a52942eb99333f7$var$test(v) {
    var _a, _b;
    return isNaN(v) && (0, $3b9c9662c5f9ca2b$export$844ec244b1367d54)(v) && (((_a = v.match((0, $3b9c9662c5f9ca2b$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $3b9c9662c5f9ca2b$export$740b69c5fad25dba))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const $4a52942eb99333f7$var$cssVarTokeniser = {
    regex: (0, $15b5c3bffdb47066$export$f7c0a352d8ef6313),
    countKey: "Vars",
    token: "${v}",
    parse: (0, $698766df269bc8f4$export$8793edee2d425525)
};
const $4a52942eb99333f7$var$colorTokeniser = {
    regex: (0, $3b9c9662c5f9ca2b$export$740b69c5fad25dba),
    countKey: "Colors",
    token: "${c}",
    parse: (0, $7d11bcabbac03365$export$35e9368ef982300f).parse
};
const $4a52942eb99333f7$var$numberTokeniser = {
    regex: (0, $3b9c9662c5f9ca2b$export$2444ca58c08448e4),
    countKey: "Numbers",
    token: "${n}",
    parse: (0, $3db28672b0a6a577$export$98e628dec113755e).parse
};
function $4a52942eb99333f7$var$tokenise(info, { regex: regex, countKey: countKey, token: token, parse: parse }) {
    const matches = info.tokenised.match(regex);
    if (!matches) return;
    info["num" + countKey] = matches.length;
    info.tokenised = info.tokenised.replace(regex, token);
    info.values.push(...matches.map(parse));
}
function $4a52942eb99333f7$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const info = {
        value: originalValue,
        tokenised: originalValue,
        values: [],
        numVars: 0,
        numColors: 0,
        numNumbers: 0
    };
    if (info.value.includes("var(--")) $4a52942eb99333f7$var$tokenise(info, $4a52942eb99333f7$var$cssVarTokeniser);
    $4a52942eb99333f7$var$tokenise(info, $4a52942eb99333f7$var$colorTokeniser);
    $4a52942eb99333f7$var$tokenise(info, $4a52942eb99333f7$var$numberTokeniser);
    return info;
}
function $4a52942eb99333f7$var$parseComplexValue(v) {
    return $4a52942eb99333f7$export$b61fc7c44bf646d5(v).values;
}
function $4a52942eb99333f7$var$createTransformer(source) {
    const { values: values, numColors: numColors, numVars: numVars, tokenised: tokenised } = $4a52942eb99333f7$export$b61fc7c44bf646d5(source);
    const numValues = values.length;
    return (v)=>{
        let output = tokenised;
        for(let i = 0; i < numValues; i++){
            if (i < numVars) output = output.replace($4a52942eb99333f7$var$cssVarTokeniser.token, v[i]);
            else if (i < numVars + numColors) output = output.replace($4a52942eb99333f7$var$colorTokeniser.token, (0, $7d11bcabbac03365$export$35e9368ef982300f).transform(v[i]));
            else output = output.replace($4a52942eb99333f7$var$numberTokeniser.token, (0, $3b9c9662c5f9ca2b$export$83d2e9e3e4ee39ed)(v[i]));
        }
        return output;
    };
}
const $4a52942eb99333f7$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $4a52942eb99333f7$var$getAnimatableNone(v) {
    const parsed = $4a52942eb99333f7$var$parseComplexValue(v);
    const transformer = $4a52942eb99333f7$var$createTransformer(v);
    return transformer(parsed.map($4a52942eb99333f7$var$convertNumbersToZero));
}
const $4a52942eb99333f7$export$83a0e34f1302825b = {
    test: $4a52942eb99333f7$var$test,
    parse: $4a52942eb99333f7$var$parseComplexValue,
    createTransformer: $4a52942eb99333f7$var$createTransformer,
    getAnimatableNone: $4a52942eb99333f7$var$getAnimatableNone
};


const $6a7167931f8d2ab9$var$mixImmediate = (origin, target)=>(p)=>`${p > 0 ? target : origin}`;
function $6a7167931f8d2ab9$var$getMixer(origin, target) {
    if (typeof origin === "number") return (v)=>(0, $5cbd34a3bc31f43d$export$2c9e8a9632a706b2)(origin, target, v);
    else if ((0, $7d11bcabbac03365$export$35e9368ef982300f).test(origin)) return (0, $9792e8c2d440e5a9$export$51e568cf5c039bac)(origin, target);
    else return origin.startsWith("var(") ? $6a7167931f8d2ab9$var$mixImmediate(origin, target) : $6a7167931f8d2ab9$export$65516310a87d8205(origin, target);
}
const $6a7167931f8d2ab9$export$3bbefa2f402845c4 = (from, to)=>{
    const output = [
        ...from
    ];
    const numValues = output.length;
    const blendValue = from.map((fromThis, i)=>$6a7167931f8d2ab9$var$getMixer(fromThis, to[i]));
    return (v)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](v);
        return output;
    };
};
const $6a7167931f8d2ab9$export$ebc23b6840c51ba1 = (origin, target)=>{
    const output = {
        ...origin,
        ...target
    };
    const blendValue = {};
    for(const key in output)if (origin[key] !== undefined && target[key] !== undefined) blendValue[key] = $6a7167931f8d2ab9$var$getMixer(origin[key], target[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
};
const $6a7167931f8d2ab9$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $4a52942eb99333f7$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $4a52942eb99333f7$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $4a52942eb99333f7$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.numVars === targetStats.numVars && originStats.numColors === targetStats.numColors && originStats.numNumbers >= targetStats.numNumbers;
    if (canInterpolate) return (0, $57a0a335cd293854$export$a4627e546088548d)($6a7167931f8d2ab9$export$3bbefa2f402845c4(originStats.values, targetStats.values), template);
    else {
        (0, $f3c6a28fc8795b13$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return $6a7167931f8d2ab9$var$mixImmediate(origin, target);
    }
};



/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ const $aac79f37d389f44b$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};



const $adcec5af7bc5366a$var$mixNumber = (from, to)=>(p)=>(0, $5cbd34a3bc31f43d$export$2c9e8a9632a706b2)(from, to, p);
function $adcec5af7bc5366a$var$detectMixerFactory(v) {
    if (typeof v === "number") return $adcec5af7bc5366a$var$mixNumber;
    else if (typeof v === "string") return (0, $7d11bcabbac03365$export$35e9368ef982300f).test(v) ? (0, $9792e8c2d440e5a9$export$51e568cf5c039bac) : (0, $6a7167931f8d2ab9$export$65516310a87d8205);
    else if (Array.isArray(v)) return 0, $6a7167931f8d2ab9$export$3bbefa2f402845c4;
    else if (typeof v === "object") return 0, $6a7167931f8d2ab9$export$ebc23b6840c51ba1;
    return $adcec5af7bc5366a$var$mixNumber;
}
function $adcec5af7bc5366a$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || $adcec5af7bc5366a$var$detectMixerFactory(output[0]);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $698766df269bc8f4$export$8793edee2d425525) : ease;
            mixer = (0, $57a0a335cd293854$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $adcec5af7bc5366a$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $f3c6a28fc8795b13$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $adcec5af7bc5366a$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $aac79f37d389f44b$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $635d47cb6378920a$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $a02b49f7f8f52c06$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $aac79f37d389f44b$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $5cbd34a3bc31f43d$export$2c9e8a9632a706b2)(min, 1, offsetProgress));
    }
}


function $a846c2634628f4cd$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $a02b49f7f8f52c06$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $0395fb13c2ec55e2$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $c6829a6de2b8e987$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $2d39f912b4b510f8$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $c6829a6de2b8e987$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $0384e0581614a062$export$216948827bbdc797)(ease) ? ease.map((0, $01c57b98418cd911$export$ef97fe084f156ca4)) : (0, $01c57b98418cd911$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $0395fb13c2ec55e2$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $a846c2634628f4cd$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $adcec5af7bc5366a$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $c6829a6de2b8e987$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}



/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $02399dc340bd952d$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


const $c196a9aafbf28c41$var$velocitySampleDuration = 5; // ms
function $c196a9aafbf28c41$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $c196a9aafbf28c41$var$velocitySampleDuration, 0);
    return (0, $02399dc340bd952d$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}





const $fcb67cb36a1e1faf$var$safeMin = 0.001;
const $fcb67cb36a1e1faf$export$a3cdb76e84ee608e = 0.01;
const $fcb67cb36a1e1faf$export$1824b851fad8862b = 10.0;
const $fcb67cb36a1e1faf$export$ff08f2d53484465 = 0.05;
const $fcb67cb36a1e1faf$export$201ca48e54038115 = 1;
function $fcb67cb36a1e1faf$export$b15f158dc6d6f458({ duration: duration = 800, bounce: bounce = 0.25, velocity: velocity = 0, mass: mass = 1 }) {
    let envelope;
    let derivative;
    (0, $f3c6a28fc8795b13$export$491112666e282270)(duration <= (0, $93c5ce4b0f38c723$export$fc3e7e8557f8c8c7)($fcb67cb36a1e1faf$export$1824b851fad8862b), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $635d47cb6378920a$export$7d15b64cf5a3a4c4)($fcb67cb36a1e1faf$export$ff08f2d53484465, $fcb67cb36a1e1faf$export$201ca48e54038115, dampingRatio);
    duration = (0, $635d47cb6378920a$export$7d15b64cf5a3a4c4)($fcb67cb36a1e1faf$export$a3cdb76e84ee608e, $fcb67cb36a1e1faf$export$1824b851fad8862b, (0, $93c5ce4b0f38c723$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $fcb67cb36a1e1faf$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $fcb67cb36a1e1faf$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $fcb67cb36a1e1faf$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $fcb67cb36a1e1faf$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$fcb67cb36a1e1faf$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $fcb67cb36a1e1faf$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $93c5ce4b0f38c723$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $fcb67cb36a1e1faf$var$rootIterations = 12;
function $fcb67cb36a1e1faf$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $fcb67cb36a1e1faf$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $fcb67cb36a1e1faf$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


const $b2e85d9d8eca8f3f$var$durationKeys = [
    "duration",
    "bounce"
];
const $b2e85d9d8eca8f3f$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $b2e85d9d8eca8f3f$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $b2e85d9d8eca8f3f$var$getSpringOptions(options) {
    let springOptions = {
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$b2e85d9d8eca8f3f$var$isSpringType(options, $b2e85d9d8eca8f3f$var$physicsKeys) && $b2e85d9d8eca8f3f$var$isSpringType(options, $b2e85d9d8eca8f3f$var$durationKeys)) {
        const derived = (0, $fcb67cb36a1e1faf$export$b15f158dc6d6f458)(options);
        springOptions = {
            ...springOptions,
            ...derived,
            velocity: 0.0,
            mass: 1.0
        };
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $b2e85d9d8eca8f3f$export$b36281d89752ae66({ keyframes: keyframes, restDelta: restDelta, restSpeed: restSpeed, ...options }) {
    const origin = keyframes[0];
    const target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, velocity: velocity, duration: duration, isResolvedFromDuration: isResolvedFromDuration } = $b2e85d9d8eca8f3f$var$getSpringOptions(options);
    const initialVelocity = velocity ? -(0, $93c5ce4b0f38c723$export$f64c3bfbc58eec0f)(velocity) : 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $93c5ce4b0f38c723$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
    restDelta || (restDelta = isGranularScale ? 0.005 : 0.5);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $fcb67cb36a1e1faf$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    return {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = initialVelocity;
                if (t !== 0) {
                    /**
                     * We only need to calculate velocity for under-damped springs
                     * as over- and critically-damped springs can't overshoot, so
                     * checking only for displacement is enough.
                     */ if (dampingRatio < 1) currentVelocity = (0, $c196a9aafbf28c41$export$854187271d233eb5)(resolveSpring, t, current);
                    else currentVelocity = 0;
                }
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        }
    };
}




function $06157b61968ac82f$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $b2e85d9d8eca8f3f$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $c196a9aafbf28c41$export$854187271d233eb5)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t > timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}




const $89bc9264d32b4caa$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: ()=>(0, $d959fd4c7cb328b7$export$2cef06c20297c17d).update(passTimestamp, true),
        stop: ()=>(0, $d959fd4c7cb328b7$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $ef064ed7af32d6e0$export$fff89137e9e818ce).isProcessing ? (0, $ef064ed7af32d6e0$export$fff89137e9e818ce).timestamp : performance.now()
    };
};





/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $0d84b35d74616e62$export$f4ff70a5b4808fd8 = 20000;
function $0d84b35d74616e62$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $0d84b35d74616e62$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $0d84b35d74616e62$export$f4ff70a5b4808fd8 ? Infinity : duration;
}


const $73aeb0047c039d76$var$types = {
    decay: (0, $06157b61968ac82f$export$ee3ff3a17106998),
    inertia: $06157b61968ac82f$export$ee3ff3a17106998,
    tween: (0, $c6829a6de2b8e987$export$d25ddfdf17c3ad3e),
    keyframes: (0, $c6829a6de2b8e987$export$d25ddfdf17c3ad3e),
    spring: $b2e85d9d8eca8f3f$export$b36281d89752ae66
};
/**
 * Animate a single value on the main thread.
 *
 * This function is written, where functionality overlaps,
 * to be largely spec-compliant with WAAPI to allow fungibility
 * between the two.
 */ function $73aeb0047c039d76$export$ee9b76de7353d815({ autoplay: autoplay = true, delay: delay = 0, driver: driver = (0, $89bc9264d32b4caa$export$c1033964b5ad7fef), keyframes: keyframes$1, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", onPlay: onPlay, onStop: onStop, onComplete: onComplete, onUpdate: onUpdate, ...options }) {
    let speed = 1;
    let hasStopped = false;
    let resolveFinishedPromise;
    let currentFinishedPromise;
    /**
     * Create a new finished Promise every time we enter the
     * finished state and resolve the old Promise. This is
     * WAAPI-compatible behaviour.
     */ const updateFinishedPromise = ()=>{
        resolveFinishedPromise && resolveFinishedPromise();
        currentFinishedPromise = new Promise((resolve)=>{
            resolveFinishedPromise = resolve;
        });
    };
    // Create the first finished promise
    updateFinishedPromise();
    let animationDriver;
    const generatorFactory = $73aeb0047c039d76$var$types[type] || (0, $c6829a6de2b8e987$export$d25ddfdf17c3ad3e);
    /**
     * If this isn't the keyframes generator and we've been provided
     * strings as keyframes, we need to interpolate these.
     * TODO: Support velocity for units and complex value types/
     */ let mapNumbersToKeyframes;
    if (generatorFactory !== (0, $c6829a6de2b8e987$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
        mapNumbersToKeyframes = (0, $adcec5af7bc5366a$export$89e29e4ab65e70a9)([
            0,
            100
        ], keyframes$1, {
            clamp: false
        });
        keyframes$1 = [
            0,
            100
        ];
    }
    const generator = generatorFactory({
        ...options,
        keyframes: keyframes$1
    });
    let mirroredGenerator;
    if (repeatType === "mirror") mirroredGenerator = generatorFactory({
        ...options,
        keyframes: [
            ...keyframes$1
        ].reverse(),
        velocity: -(options.velocity || 0)
    });
    let playState = "idle";
    let holdTime = null;
    let startTime = null;
    let cancelTime = null;
    /**
     * If duration is undefined and we have repeat options,
     * we need to calculate a duration from the generator.
     *
     * We set it to the generator itself to cache the duration.
     * Any timeline resolver will need to have already precalculated
     * the duration by this step.
     */ if (generator.calculatedDuration === null && repeat) generator.calculatedDuration = (0, $0d84b35d74616e62$export$cbdd6b3d40ea54e2)(generator);
    const { calculatedDuration: calculatedDuration } = generator;
    let resolvedDuration = Infinity;
    let totalDuration = Infinity;
    if (calculatedDuration !== null) {
        resolvedDuration = calculatedDuration + repeatDelay;
        totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
    }
    let currentTime = 0;
    const tick = (timestamp)=>{
        if (startTime === null) return;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (speed > 0) startTime = Math.min(startTime, timestamp);
        if (holdTime !== null) currentTime = holdTime;
        else currentTime = (timestamp - startTime) * speed;
        // Rebase on delay
        const timeWithoutDelay = currentTime - delay;
        const isInDelayPhase = timeWithoutDelay < 0;
        currentTime = Math.max(timeWithoutDelay, 0);
        /**
         * If this animation has finished, set the current time
         * to the total duration.
         */ if (playState === "finished" && holdTime === null) currentTime = totalDuration;
        let elapsed = currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = currentTime / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const iterationIsOdd = Boolean(currentIteration % 2);
            if (iterationIsOdd) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            let p = (0, $635d47cb6378920a$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress);
            if (currentTime > totalDuration) p = repeatType === "reverse" && iterationIsOdd ? 1 : 0;
            elapsed = p * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes$1[0]
        } : frameGenerator.next(elapsed);
        if (mapNumbersToKeyframes) state.value = mapNumbersToKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = currentTime >= totalDuration;
        const isAnimationFinished = holdTime === null && (playState === "finished" || playState === "running" && done || speed < 0 && currentTime <= 0);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) finish();
        return state;
    };
    const stopAnimationDriver = ()=>{
        animationDriver && animationDriver.stop();
        animationDriver = undefined;
    };
    const cancel = ()=>{
        playState = "idle";
        stopAnimationDriver();
        updateFinishedPromise();
        startTime = cancelTime = null;
    };
    const finish = ()=>{
        playState = "finished";
        onComplete && onComplete();
        stopAnimationDriver();
        updateFinishedPromise();
    };
    const play = ()=>{
        if (hasStopped) return;
        if (!animationDriver) animationDriver = driver(tick);
        const now = animationDriver.now();
        onPlay && onPlay();
        if (holdTime !== null) startTime = now - holdTime;
        else if (!startTime || playState === "finished") startTime = now;
        cancelTime = startTime;
        holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ playState = "running";
        animationDriver.start();
    };
    if (autoplay) play();
    const controls = {
        then (resolve, reject) {
            return currentFinishedPromise.then(resolve, reject);
        },
        get time () {
            return (0, $93c5ce4b0f38c723$export$f64c3bfbc58eec0f)(currentTime);
        },
        set time (newTime){
            newTime = (0, $93c5ce4b0f38c723$export$fc3e7e8557f8c8c7)(newTime);
            currentTime = newTime;
            if (holdTime !== null || !animationDriver || speed === 0) holdTime = newTime;
            else startTime = animationDriver.now() - newTime / speed;
        },
        get duration () {
            const duration = generator.calculatedDuration === null ? (0, $0d84b35d74616e62$export$cbdd6b3d40ea54e2)(generator) : generator.calculatedDuration;
            return (0, $93c5ce4b0f38c723$export$f64c3bfbc58eec0f)(duration);
        },
        get speed () {
            return speed;
        },
        set speed (newSpeed){
            if (newSpeed === speed || !animationDriver) return;
            speed = newSpeed;
            controls.time = (0, $93c5ce4b0f38c723$export$f64c3bfbc58eec0f)(currentTime);
        },
        get state () {
            return playState;
        },
        play: play,
        pause: ()=>{
            playState = "paused";
            holdTime = currentTime;
        },
        stop: ()=>{
            hasStopped = true;
            if (playState === "idle") return;
            playState = "idle";
            onStop && onStop();
            cancel();
        },
        cancel: ()=>{
            if (cancelTime !== null) tick(cancelTime);
            cancel();
        },
        complete: ()=>{
            playState = "finished";
        },
        sample: (elapsed)=>{
            startTime = 0;
            return tick(elapsed);
        }
    };
    return controls;
}



/**
 * A list of values that can be hardware-accelerated.
 */ const $d46ba1d7e5c9c2c1$var$acceleratedValues = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform",
    "backgroundColor"
]);
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $d46ba1d7e5c9c2c1$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $d46ba1d7e5c9c2c1$var$maxDuration = 20000;
const $d46ba1d7e5c9c2c1$var$requiresPregeneratedKeyframes = (valueName, options)=>options.type === "spring" || valueName === "backgroundColor" || !(0, $1fd818a7bd0ae395$export$fcdd8f3f2160beda)(options.ease);
function $d46ba1d7e5c9c2c1$export$4d5d9557ab897126(value, valueName, { onUpdate: onUpdate, onComplete: onComplete, ...options }) {
    const canAccelerateAnimation = (0, $b555914fef88b800$export$cde6a56f9669daf6).waapi() && $d46ba1d7e5c9c2c1$var$acceleratedValues.has(valueName) && !options.repeatDelay && options.repeatType !== "mirror" && options.damping !== 0 && options.type !== "inertia";
    if (!canAccelerateAnimation) return false;
    /**
     * TODO: Unify with js/index
     */ let hasStopped = false;
    let resolveFinishedPromise;
    let currentFinishedPromise;
    /**
     * Create a new finished Promise every time we enter the
     * finished state and resolve the old Promise. This is
     * WAAPI-compatible behaviour.
     */ const updateFinishedPromise = ()=>{
        currentFinishedPromise = new Promise((resolve)=>{
            resolveFinishedPromise = resolve;
        });
    };
    // Create the first finished promise
    updateFinishedPromise();
    let { keyframes: keyframes, duration: duration = 300, ease: ease, times: times } = options;
    /**
     * If this animation needs pre-generated keyframes then generate.
     */ if ($d46ba1d7e5c9c2c1$var$requiresPregeneratedKeyframes(valueName, options)) {
        const sampleAnimation = (0, $73aeb0047c039d76$export$ee9b76de7353d815)({
            ...options,
            repeat: 0,
            delay: 0
        });
        let state = {
            done: false,
            value: keyframes[0]
        };
        const pregeneratedKeyframes = [];
        /**
         * Bail after 20 seconds of pre-generated keyframes as it's likely
         * we're heading for an infinite loop.
         */ let t = 0;
        while(!state.done && t < $d46ba1d7e5c9c2c1$var$maxDuration){
            state = sampleAnimation.sample(t);
            pregeneratedKeyframes.push(state.value);
            t += $d46ba1d7e5c9c2c1$var$sampleDelta;
        }
        times = undefined;
        keyframes = pregeneratedKeyframes;
        duration = t - $d46ba1d7e5c9c2c1$var$sampleDelta;
        ease = "linear";
    }
    const animation = (0, $c2f2dd293550b84f$export$c76cd972d26986f9)(value.owner.current, valueName, keyframes, {
        ...options,
        duration: duration,
        /**
         * This function is currently not called if ease is provided
         * as a function so the cast is safe.
         *
         * However it would be possible for a future refinement to port
         * in easing pregeneration from Motion One for browsers that
         * support the upcoming `linear()` easing function.
         */ ease: ease,
        times: times
    });
    const cancelAnimation = ()=>animation.cancel();
    const safeCancel = ()=>{
        (0, $d959fd4c7cb328b7$export$2cef06c20297c17d).update(cancelAnimation);
        resolveFinishedPromise();
        updateFinishedPromise();
    };
    /**
     * Prefer the `onfinish` prop as it's more widely supported than
     * the `finished` promise.
     *
     * Here, we synchronously set the provided MotionValue to the end
     * keyframe. If we didn't, when the WAAPI animation is finished it would
     * be removed from the element which would then revert to its old styles.
     */ animation.onfinish = ()=>{
        value.set((0, $099119182bd50243$export$14de59408fad90b)(keyframes, options));
        onComplete && onComplete();
        safeCancel();
    };
    /**
     * Animation interrupt callback.
     */ return {
        then (resolve, reject) {
            return currentFinishedPromise.then(resolve, reject);
        },
        get time () {
            return (0, $93c5ce4b0f38c723$export$f64c3bfbc58eec0f)(animation.currentTime || 0);
        },
        set time (newTime){
            animation.currentTime = (0, $93c5ce4b0f38c723$export$fc3e7e8557f8c8c7)(newTime);
        },
        get speed () {
            return animation.playbackRate;
        },
        set speed (newSpeed){
            animation.playbackRate = newSpeed;
        },
        get duration () {
            return (0, $93c5ce4b0f38c723$export$f64c3bfbc58eec0f)(duration);
        },
        play: ()=>{
            if (hasStopped) return;
            animation.play();
            /**
             * Cancel any pending cancel tasks
             */ (0, $d959fd4c7cb328b7$export$ec99c0ef4978dccb)(cancelAnimation);
        },
        pause: ()=>animation.pause(),
        stop: ()=>{
            hasStopped = true;
            if (animation.playState === "idle") return;
            /**
             * WAAPI doesn't natively have any interruption capabilities.
             *
             * Rather than read commited styles back out of the DOM, we can
             * create a renderless JS animation and sample it twice to calculate
             * its current value, "previous" value, and therefore allow
             * Motion to calculate velocity for any subsequent animation.
             */ const { currentTime: currentTime } = animation;
            if (currentTime) {
                const sampleAnimation = (0, $73aeb0047c039d76$export$ee9b76de7353d815)({
                    ...options,
                    autoplay: false
                });
                value.setWithVelocity(sampleAnimation.sample(currentTime - $d46ba1d7e5c9c2c1$var$sampleDelta).value, sampleAnimation.sample(currentTime).value, $d46ba1d7e5c9c2c1$var$sampleDelta);
            }
            safeCancel();
        },
        complete: ()=>animation.finish(),
        cancel: safeCancel
    };
}




function $e62ca676763eeb8c$export$6f34fc8ef6c42b70({ keyframes: keyframes, delay: delay, onUpdate: onUpdate, onComplete: onComplete }) {
    const setValue = ()=>{
        onUpdate && onUpdate(keyframes[keyframes.length - 1]);
        onComplete && onComplete();
        /**
         * TODO: As this API grows it could make sense to always return
         * animateValue. This will be a bigger project as animateValue
         * is frame-locked whereas this function resolves instantly.
         * This is a behavioural change and also has ramifications regarding
         * assumptions within tests.
         */ return {
            time: 0,
            speed: 1,
            duration: 0,
            play: (0, $698766df269bc8f4$export$8793edee2d425525),
            pause: (0, $698766df269bc8f4$export$8793edee2d425525),
            stop: (0, $698766df269bc8f4$export$8793edee2d425525),
            then: (resolve)=>{
                resolve();
                return Promise.resolve();
            },
            cancel: (0, $698766df269bc8f4$export$8793edee2d425525),
            complete: (0, $698766df269bc8f4$export$8793edee2d425525)
        };
    };
    return delay ? (0, $73aeb0047c039d76$export$ee9b76de7353d815)({
        keyframes: [
            0,
            1
        ],
        duration: 0,
        delay: delay,
        onComplete: setValue
    }) : setValue();
}



const $ab020b748bb871f7$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $ab020b748bb871f7$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $ab020b748bb871f7$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $ab020b748bb871f7$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $ab020b748bb871f7$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $ab020b748bb871f7$var$keyframesTransition;
    else if ((0, $b25a583cb32de3e0$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $ab020b748bb871f7$var$criticallyDampedSpring(keyframes[1]) : $ab020b748bb871f7$var$underDampedSpring;
    return $ab020b748bb871f7$var$ease;
};



/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $eb8d35dd617f1ebe$export$65676b58b122bc38 = (key, value)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (key === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $4a52942eb99333f7$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};





/**
 * Properties that should default to 1 or 100%
 */ const $af9a0cf293250bb4$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $af9a0cf293250bb4$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $3b9c9662c5f9ca2b$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $af9a0cf293250bb4$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $af9a0cf293250bb4$var$functionRegex = /([a-z-]*)\(.*?\)/g;
const $af9a0cf293250bb4$export$3dea766d36a8935f = {
    ...(0, $4a52942eb99333f7$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($af9a0cf293250bb4$var$functionRegex);
        return functions ? functions.map($af9a0cf293250bb4$var$applyDefaultFilter).join(" ") : v;
    }
};





/**
 * A map of default value types for common values
 */ const $1a9ec190942d3446$export$98cd7c72c5a731fb = {
    ...(0, $15c6a7b85ca55290$export$eec14432cd1cb67b),
    color: // Color props
    $7d11bcabbac03365$export$35e9368ef982300f,
    backgroundColor: (0, $7d11bcabbac03365$export$35e9368ef982300f),
    outlineColor: (0, $7d11bcabbac03365$export$35e9368ef982300f),
    fill: (0, $7d11bcabbac03365$export$35e9368ef982300f),
    stroke: (0, $7d11bcabbac03365$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $7d11bcabbac03365$export$35e9368ef982300f),
    borderTopColor: (0, $7d11bcabbac03365$export$35e9368ef982300f),
    borderRightColor: (0, $7d11bcabbac03365$export$35e9368ef982300f),
    borderBottomColor: (0, $7d11bcabbac03365$export$35e9368ef982300f),
    borderLeftColor: (0, $7d11bcabbac03365$export$35e9368ef982300f),
    filter: $af9a0cf293250bb4$export$3dea766d36a8935f,
    WebkitFilter: (0, $af9a0cf293250bb4$export$3dea766d36a8935f)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $1a9ec190942d3446$export$67d1babe0338d23b = (key)=>$1a9ec190942d3446$export$98cd7c72c5a731fb[key];


function $e8846bd1d1d6943e$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $1a9ec190942d3446$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $af9a0cf293250bb4$export$3dea766d36a8935f)) defaultValueType = (0, $4a52942eb99333f7$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}



/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $4f996c8cd576a593$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/.test(v);


function $edaf578af02e3284$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $4f996c8cd576a593$export$ade84c85e44a6cb1)(value);
}


function $922306a426ede757$export$b2b5e866b2fbf2ec(value, valueName, target, transition) {
    const isTargetAnimatable = (0, $eb8d35dd617f1ebe$export$65676b58b122bc38)(valueName, target);
    let keyframes;
    if (Array.isArray(target)) keyframes = [
        ...target
    ];
    else keyframes = [
        null,
        target
    ];
    const defaultOrigin = transition.from !== undefined ? transition.from : value.get();
    let animatableTemplateValue = undefined;
    const noneKeyframeIndexes = [];
    for(let i = 0; i < keyframes.length; i++){
        /**
         * Fill null/wildcard keyframes
         */ if (keyframes[i] === null) keyframes[i] = i === 0 ? defaultOrigin : keyframes[i - 1];
        if ((0, $edaf578af02e3284$export$e56af863d5645d5f)(keyframes[i])) noneKeyframeIndexes.push(i);
        // TODO: Clean this conditional, it works for now
        if (typeof keyframes[i] === "string" && keyframes[i] !== "none" && keyframes[i] !== "0") animatableTemplateValue = keyframes[i];
    }
    if (isTargetAnimatable && noneKeyframeIndexes.length && animatableTemplateValue) for(let i = 0; i < noneKeyframeIndexes.length; i++){
        const index = noneKeyframeIndexes[i];
        keyframes[index] = (0, $e8846bd1d1d6943e$export$cea0cedcb94873b5)(valueName, animatableTemplateValue);
    }
    return keyframes;
}


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $f970ee86818edb42$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}
function $f970ee86818edb42$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}



const $92a13601a1e6930d$export$90b3dfc33ff3548 = (valueName, value, target, transition = {})=>{
    return (onComplete)=>{
        const valueTransition = (0, $f970ee86818edb42$export$7c1391340308742e)(transition, valueName) || {};
        /**
         * Most transition values are currently completely overwritten by value-specific
         * transitions. In the future it'd be nicer to blend these transitions. But for now
         * delay actually does inherit from the root transition if not value-specific.
         */ const delay = valueTransition.delay || transition.delay || 0;
        /**
         * Elapsed isn't a public transition option but can be passed through from
         * optimized appear effects in milliseconds.
         */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $93c5ce4b0f38c723$export$fc3e7e8557f8c8c7)(delay);
        const keyframes = (0, $922306a426ede757$export$b2b5e866b2fbf2ec)(value, valueName, target, valueTransition);
        /**
         * Check if we're able to animate between the start and end keyframes,
         * and throw a warning if we're attempting to animate between one that's
         * animatable and another that isn't.
         */ const originKeyframe = keyframes[0];
        const targetKeyframe = keyframes[keyframes.length - 1];
        const isOriginAnimatable = (0, $eb8d35dd617f1ebe$export$65676b58b122bc38)(valueName, originKeyframe);
        const isTargetAnimatable = (0, $eb8d35dd617f1ebe$export$65676b58b122bc38)(valueName, targetKeyframe);
        (0, $f3c6a28fc8795b13$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${valueName} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
        let options = {
            keyframes: keyframes,
            velocity: value.getVelocity(),
            ease: "easeOut",
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            }
        };
        /**
         * If there's no transition defined for this value, we can generate
         * unqiue transition settings for this value.
         */ if (!(0, $f970ee86818edb42$export$ca8e47dc8ed5a9d7)(valueTransition)) options = {
            ...options,
            ...(0, $ab020b748bb871f7$export$262124b154b9f1c0)(valueName, options)
        };
        /**
         * Both WAAPI and our internal animation functions use durations
         * as defined by milliseconds, while our external API defines them
         * as seconds.
         */ if (options.duration) options.duration = (0, $93c5ce4b0f38c723$export$fc3e7e8557f8c8c7)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $93c5ce4b0f38c723$export$fc3e7e8557f8c8c7)(options.repeatDelay);
        if (!isOriginAnimatable || !isTargetAnimatable || (0, $e8c0bf68d4a30d76$export$888a3d84909f9e3d).current || valueTransition.type === false) /**
             * If we can't animate this value, or the global instant animation flag is set,
             * or this is simply defined as an instant transition, return an instant transition.
             */ return (0, $e62ca676763eeb8c$export$6f34fc8ef6c42b70)(options);
        /**
         * Animate via WAAPI if possible.
         */ if (value.owner && value.owner.current instanceof HTMLElement && !value.owner.getProps().onUpdate) {
            const acceleratedAnimation = (0, $d46ba1d7e5c9c2c1$export$4d5d9557ab897126)(value, valueName, options);
            if (acceleratedAnimation) return acceleratedAnimation;
        }
        /**
         * If we didn't create an accelerated animation, create a JS animation
         */ return (0, $73aeb0047c039d76$export$ee9b76de7353d815)(options);
    };
};



function $79c5e793c0fc2623$export$98397f3adbf6259f(value) {
    return Boolean((0, $40691104928af1ab$export$605d60a2578142d3)(value) && value.add);
}


/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $8f474ef444072ed3$export$65583ed5a868f2d9 = (v)=>/^\-?\d*\.?\d+$/.test(v);






function $cefc68c3989214f3$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $cefc68c3989214f3$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $cefc68c3989214f3$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $bd26a630358fb62d$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $cefc68c3989214f3$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $cefc68c3989214f3$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}




const $ac6ee9d0a6913bb6$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $ac6ee9d0a6913bb6$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "10.12.12";
        /**
         * Duration, in milliseconds, since last updating frame.
         *
         * @internal
         */ this.timeDelta = 0;
        /**
         * Timestamp of the last time this `MotionValue` was updated.
         *
         * @internal
         */ this.lastUpdated = 0;
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = false;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            this.prev = this.current;
            this.current = v;
            // Update timestamp
            const { delta: delta, timestamp: timestamp } = (0, $ef064ed7af32d6e0$export$fff89137e9e818ce);
            if (this.lastUpdated !== timestamp) {
                this.timeDelta = delta;
                this.lastUpdated = timestamp;
                (0, $d959fd4c7cb328b7$export$2cef06c20297c17d).postRender(this.scheduleVelocityCheck);
            }
            // Update update subscribers
            if (this.prev !== this.current && this.events.change) this.events.change.notify(this.current);
            // Update velocity subscribers
            if (this.events.velocityChange) this.events.velocityChange.notify(this.getVelocity());
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        /**
         * Schedule a velocity check for the next frame.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.scheduleVelocityCheck = ()=>(0, $d959fd4c7cb328b7$export$2cef06c20297c17d).postRender(this.velocityCheck);
        /**
         * Updates `prev` with `current` if the value hasn't been updated this frame.
         * This ensures velocity calculations return `0`.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.velocityCheck = ({ timestamp: timestamp })=>{
            if (timestamp !== this.lastUpdated) {
                this.prev = this.current;
                if (this.events.velocityChange) this.events.velocityChange.notify(this.getVelocity());
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = $ac6ee9d0a6913bb6$var$isFloat(this.current);
        this.owner = options.owner;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $bd26a630358fb62d$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $d959fd4c7cb328b7$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = prev;
        this.timeDelta = delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v) {
        this.updateAndNotify(v);
        this.prev = v;
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
        return this.canTrackVelocity ? (0, $02399dc340bd952d$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $ac6ee9d0a6913bb6$export$ce8bdc721e76545f(init, options) {
    return new $ac6ee9d0a6913bb6$export$8cea36d14ee64562(init, options);
}








/**
 * Tests a provided value against a ValueType
 */ const $9ce6381104e83827$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * ValueType for "auto"
 */ const $1931ed67932cafec$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


/**
 * A list of value types commonly used for dimensions
 */ const $5469ce2e9af910bb$export$d176691c1998a1f5 = [
    (0, $3db28672b0a6a577$export$98e628dec113755e),
    (0, $ca276f8dec7edf41$export$91c0eda1d06bf008),
    (0, $ca276f8dec7edf41$export$626336c2cd4b14de),
    (0, $ca276f8dec7edf41$export$41fc368e1a942b97),
    (0, $ca276f8dec7edf41$export$aed3d7b7d206c196),
    (0, $ca276f8dec7edf41$export$f91e8c45a95a32f2),
    (0, $1931ed67932cafec$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $5469ce2e9af910bb$export$eefdd52e3ccae428 = (v)=>$5469ce2e9af910bb$export$d176691c1998a1f5.find((0, $9ce6381104e83827$export$6eae4d0a6a7ca7cd)(v));



/**
 * A list of all ValueTypes
 */ const $1df85722fc64673d$var$valueTypes = [
    ...(0, $5469ce2e9af910bb$export$d176691c1998a1f5),
    (0, $7d11bcabbac03365$export$35e9368ef982300f),
    (0, $4a52942eb99333f7$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $1df85722fc64673d$export$950e7e59ea1ffed7 = (v)=>$1df85722fc64673d$var$valueTypes.find((0, $9ce6381104e83827$export$6eae4d0a6a7ca7cd)(v));



/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $5b4992dabc9e61c6$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $ac6ee9d0a6913bb6$export$ce8bdc721e76545f)(value));
}
function $5b4992dabc9e61c6$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $17da0c2d09e6a150$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $fdcd80e87b1fd446$export$5485128c47bd48bb)(target[key]);
        $5b4992dabc9e61c6$var$setMotionValue(visualElement, key, value);
    }
}
function $5b4992dabc9e61c6$var$setVariants(visualElement, variantLabels) {
    const reversedLabels = [
        ...variantLabels
    ].reverse();
    reversedLabels.forEach((key)=>{
        const variant = visualElement.getVariant(key);
        variant && $5b4992dabc9e61c6$export$1f61c53461aff4a5(visualElement, variant);
        if (visualElement.variantChildren) visualElement.variantChildren.forEach((child)=>{
            $5b4992dabc9e61c6$var$setVariants(child, variantLabels);
        });
    });
}
function $5b4992dabc9e61c6$export$b7771d60d308862f(visualElement, definition) {
    if (Array.isArray(definition)) return $5b4992dabc9e61c6$var$setVariants(visualElement, definition);
    else if (typeof definition === "string") return $5b4992dabc9e61c6$var$setVariants(visualElement, [
        definition
    ]);
    else $5b4992dabc9e61c6$export$1f61c53461aff4a5(visualElement, definition);
}
function $5b4992dabc9e61c6$export$6afbed164019a54c(visualElement, target, origin) {
    var _a, _b;
    const newValueKeys = Object.keys(target).filter((key)=>!visualElement.hasValue(key));
    const numNewValues = newValueKeys.length;
    if (!numNewValues) return;
    for(let i = 0; i < numNewValues; i++){
        const key = newValueKeys[i];
        const targetValue = target[key];
        let value = null;
        /**
         * If the target is a series of keyframes, we can use the first value
         * in the array. If this first value is null, we'll still need to read from the DOM.
         */ if (Array.isArray(targetValue)) value = targetValue[0];
        /**
         * If the target isn't keyframes, or the first keyframe was null, we need to
         * first check if an origin value was explicitly defined in the transition as "from",
         * if not read the value from the DOM. As an absolute fallback, take the defined target value.
         */ if (value === null) value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
        /**
         * If value is still undefined or null, ignore it. Preferably this would throw,
         * but this was causing issues in Framer.
         */ if (value === undefined || value === null) continue;
        if (typeof value === "string" && ((0, $8f474ef444072ed3$export$65583ed5a868f2d9)(value) || (0, $4f996c8cd576a593$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
        value = parseFloat(value);
        else if (!(0, $1df85722fc64673d$export$950e7e59ea1ffed7)(value) && (0, $4a52942eb99333f7$export$83a0e34f1302825b).test(targetValue)) value = (0, $e8846bd1d1d6943e$export$cea0cedcb94873b5)(key, targetValue);
        visualElement.addValue(key, (0, $ac6ee9d0a6913bb6$export$ce8bdc721e76545f)(value, {
            owner: visualElement
        }));
        if (origin[key] === undefined) origin[key] = value;
        if (value !== null) visualElement.setBaseTarget(key, value);
    }
}
function $5b4992dabc9e61c6$export$c3befe8e18686628(key, transition) {
    if (!transition) return;
    const valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function $5b4992dabc9e61c6$export$5a759dc7a1cfb72a(target, transition, visualElement) {
    const origin = {};
    for(const key in target){
        const transitionOrigin = $5b4992dabc9e61c6$export$c3befe8e18686628(key, transition);
        if (transitionOrigin !== undefined) origin[key] = transitionOrigin;
        else {
            const value = visualElement.getValue(key);
            if (value) origin[key] = value.get();
        }
    }
    return origin;
}


/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $01b1a2888a7e6035$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $01b1a2888a7e6035$export$68cacfeee78d98d2(visualElement, definition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = visualElement.makeTargetAnimatable(definition);
    const willChange = visualElement.getValue("willChange");
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key);
        const valueTarget = target[key];
        if (!value || valueTarget === undefined || animationTypeState && $01b1a2888a7e6035$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            elapsed: 0,
            ...transition
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ if (window.HandoffAppearAnimations && !value.hasAnimated) {
            const appearId = visualElement.getProps()[0, $1f191d6b0abb9602$export$8592e1c077c890a6];
            if (appearId) valueTransition.elapsed = window.HandoffAppearAnimations(appearId, key, value, (0, $d959fd4c7cb328b7$export$2cef06c20297c17d));
        }
        value.start((0, $92a13601a1e6930d$export$90b3dfc33ff3548)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $b25a583cb32de3e0$export$7b42a0094fb00b6e).has(key) ? {
            type: false
        } : valueTransition));
        const animation = value.animation;
        if ((0, $79c5e793c0fc2623$export$98397f3adbf6259f)(willChange)) {
            willChange.add(key);
            animation.then(()=>willChange.remove(key));
        }
        animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        transitionEnd && (0, $5b4992dabc9e61c6$export$1f61c53461aff4a5)(visualElement, transitionEnd);
    });
    return animations;
}




function $8afb2d624cdf4c85$export$4709dc300705b2af(visualElement, variant, options = {}) {
    const resolved = (0, $17da0c2d09e6a150$export$7b1b1c981f4f0558)(visualElement, variant, options.custom);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $01b1a2888a7e6035$export$68cacfeee78d98d2)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $8afb2d624cdf4c85$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $8afb2d624cdf4c85$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($8afb2d624cdf4c85$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($8afb2d624cdf4c85$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $8afb2d624cdf4c85$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}


function $3bd88e10cdde0432$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $8afb2d624cdf4c85$export$4709dc300705b2af)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $8afb2d624cdf4c85$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $17da0c2d09e6a150$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $01b1a2888a7e6035$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>visualElement.notify("AnimationComplete", definition));
}


const $ab1e3b0bfff35d61$var$reversePriorityOrder = [
    ...(0, $d3885f669dd71fbf$export$16e45afcc206d3a8)
].reverse();
const $ab1e3b0bfff35d61$var$numAnimationTypes = (0, $d3885f669dd71fbf$export$16e45afcc206d3a8).length;
function $ab1e3b0bfff35d61$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $3bd88e10cdde0432$export$ff62cf473653f109)(visualElement, animation, options)));
}
function $ab1e3b0bfff35d61$export$bb53502b7a672aa8(visualElement) {
    let animate = $ab1e3b0bfff35d61$var$animateList(visualElement);
    const state = $ab1e3b0bfff35d61$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (acc, definition)=>{
        const resolved = (0, $17da0c2d09e6a150$export$7b1b1c981f4f0558)(visualElement, definition);
        if (resolved) {
            const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
            acc = {
                ...acc,
                ...target,
                ...transitionEnd
            };
        }
        return acc;
    };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(options, changedActiveType) {
        const props = visualElement.getProps();
        const context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $ab1e3b0bfff35d61$var$numAnimationTypes; i++){
            const type = $ab1e3b0bfff35d61$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $3f159601009ddaf2$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $d39b81e97dffc1d9$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $ab1e3b0bfff35d61$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                removedKeys.delete(key);
                typeState.needsAnimating[key] = true;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ if (next !== prev) {
                    /**
                     * If both values are keyframes, we need to shallow compare them to
                     * detect whether any value has changed. If it has, we animate it.
                     */ if ((0, $53442b5a509d9f4b$export$9153ad4c4999f4a0)(next) && (0, $53442b5a509d9f4b$export$9153ad4c4999f4a0)(prev)) {
                        if (!(0, $80a01873ec27e152$export$90e866afbd6b9f1a)(next, prev) || variantDidChange) markToAnimate(key);
                        else /**
                             * If it hasn't changed, we want to ensure it doesn't animate by
                             * adding it to the list of protected keys.
                             */ typeState.protectedKeys[key] = true;
                    } else if (next !== undefined) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             * TODO: Test as this should probably still handle animations triggered
             * by removed values?
             */ if (shouldAnimateType && !isInherited) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type,
                        ...options
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                if (fallbackTarget !== undefined) fallbackAnimation[key] = fallbackTarget;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && props.initial === false && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive, options) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(options, type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state
    };
}
function $ab1e3b0bfff35d61$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $80a01873ec27e152$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $ab1e3b0bfff35d61$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $ab1e3b0bfff35d61$var$createState() {
    return {
        animate: $ab1e3b0bfff35d61$var$createTypeState(true),
        whileInView: $ab1e3b0bfff35d61$var$createTypeState(),
        whileHover: $ab1e3b0bfff35d61$var$createTypeState(),
        whileTap: $ab1e3b0bfff35d61$var$createTypeState(),
        whileDrag: $ab1e3b0bfff35d61$var$createTypeState(),
        whileFocus: $ab1e3b0bfff35d61$var$createTypeState(),
        exit: $ab1e3b0bfff35d61$var$createTypeState()
    };
}



class $eed223562011adc4$export$b45b3fe5caabdca extends (0, $ab6644c4f7a97411$export$6e91cf7616333d5) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $ab1e3b0bfff35d61$export$bb53502b7a672aa8)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        this.unmount();
        if ((0, $d39b81e97dffc1d9$export$aa71198ceeaf53ce)(animate)) this.unmount = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {}
}



let $bb8f0775133f3114$var$id = 0;
class $bb8f0775133f3114$export$4989d1eb6104cc6c extends (0, $ab6644c4f7a97411$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.id = $bb8f0775133f3114$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete, custom: custom } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent, {
            custom: custom !== null && custom !== void 0 ? custom : this.node.getProps().custom
        });
        if (onExitComplete && !isPresent) exitAnimation.then(()=>onExitComplete(this.id));
    }
    mount() {
        const { register: register } = this.node.presenceContext || {};
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}


const $677ee99392cbbdac$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $eed223562011adc4$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $bb8f0775133f3114$export$4989d1eb6104cc6c)
    }
};










const $046a7e91679b1234$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $046a7e91679b1234$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $046a7e91679b1234$export$9f17032d917177de(a.x, b.x);
    const yDelta = $046a7e91679b1234$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}




/**
 * @internal
 */ class $9ba914184f4e86d7$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $9ba914184f4e86d7$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $046a7e91679b1234$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $ef064ed7af32d6e0$export$fff89137e9e818ce);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $9ba914184f4e86d7$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $d959fd4c7cb328b7$export$2cef06c20297c17d).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const { onEnd: onEnd, onSessionEnd: onSessionEnd } = this.handlers;
            const panInfo = $9ba914184f4e86d7$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $9ba914184f4e86d7$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $72135cf2fadcce8b$export$a4cf9c8a4b063a6e)(event)) return;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        const info = (0, $37ad62a5a00c9515$export$12f84bb882d06e1a)(event);
        const initialInfo = $9ba914184f4e86d7$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $ef064ed7af32d6e0$export$fff89137e9e818ce);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $9ba914184f4e86d7$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $57a0a335cd293854$export$a4627e546088548d)((0, $705ce2c92f6e40ca$export$fcff2e64e6676b81)(window, "pointermove", this.handlePointerMove), (0, $705ce2c92f6e40ca$export$fcff2e64e6676b81)(window, "pointerup", this.handlePointerUp), (0, $705ce2c92f6e40ca$export$fcff2e64e6676b81)(window, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $d959fd4c7cb328b7$export$ec99c0ef4978dccb)(this.updatePoint);
    }
}
function $9ba914184f4e86d7$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $9ba914184f4e86d7$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $9ba914184f4e86d7$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $9ba914184f4e86d7$var$subtractPoint(point, $9ba914184f4e86d7$var$lastDevicePoint(history)),
        offset: $9ba914184f4e86d7$var$subtractPoint(point, $9ba914184f4e86d7$var$startDevicePoint(history)),
        velocity: $9ba914184f4e86d7$var$getVelocity(history, 0.1)
    };
}
function $9ba914184f4e86d7$var$startDevicePoint(history) {
    return history[0];
}
function $9ba914184f4e86d7$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $9ba914184f4e86d7$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $9ba914184f4e86d7$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $93c5ce4b0f38c723$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $93c5ce4b0f38c723$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}







function $d959a4d48684fa58$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $d959a4d48684fa58$export$28d0384c4b79bde2(value, target = 0, maxDistance = 0.01) {
    return Math.abs(value - target) <= maxDistance;
}
function $d959a4d48684fa58$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $5cbd34a3bc31f43d$export$2c9e8a9632a706b2)(source.min, source.max, delta.origin);
    delta.scale = $d959a4d48684fa58$export$c1c127004b72a37(target) / $d959a4d48684fa58$export$c1c127004b72a37(source);
    if ($d959a4d48684fa58$export$28d0384c4b79bde2(delta.scale, 1, 0.0001) || isNaN(delta.scale)) delta.scale = 1;
    delta.translate = (0, $5cbd34a3bc31f43d$export$2c9e8a9632a706b2)(target.min, target.max, delta.origin) - delta.originPoint;
    if ($d959a4d48684fa58$export$28d0384c4b79bde2(delta.translate) || isNaN(delta.translate)) delta.translate = 0;
}
function $d959a4d48684fa58$export$c0d25e96fc67d310(delta, source, target, origin) {
    $d959a4d48684fa58$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $d959a4d48684fa58$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $d959a4d48684fa58$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $d959a4d48684fa58$export$c1c127004b72a37(relative);
}
function $d959a4d48684fa58$export$426154f9d100f99(target, relative, parent) {
    $d959a4d48684fa58$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $d959a4d48684fa58$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $d959a4d48684fa58$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $d959a4d48684fa58$export$c1c127004b72a37(layout);
}
function $d959a4d48684fa58$export$2785bfcc929c5650(target, layout, parent) {
    $d959a4d48684fa58$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $d959a4d48684fa58$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}




/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $03cc6966959981da$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $5cbd34a3bc31f43d$export$2c9e8a9632a706b2)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $5cbd34a3bc31f43d$export$2c9e8a9632a706b2)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $03cc6966959981da$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $03cc6966959981da$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $03cc6966959981da$export$690c180aa5775042(layoutBox.x, left, right),
        y: $03cc6966959981da$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $03cc6966959981da$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $03cc6966959981da$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $03cc6966959981da$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $03cc6966959981da$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $03cc6966959981da$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $d959a4d48684fa58$export$c1c127004b72a37)(source);
    const targetLength = (0, $d959a4d48684fa58$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $aac79f37d389f44b$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $aac79f37d389f44b$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $635d47cb6378920a$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $03cc6966959981da$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $03cc6966959981da$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $03cc6966959981da$export$7c5eaef8f4723d22(dragElastic = $03cc6966959981da$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $03cc6966959981da$export$a3366d3bac43a742;
    return {
        x: $03cc6966959981da$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $03cc6966959981da$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $03cc6966959981da$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $03cc6966959981da$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $03cc6966959981da$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $03cc6966959981da$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}


const $b9f69e6ca851b432$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $b9f69e6ca851b432$export$3d227df54007d73a = ()=>({
        x: $b9f69e6ca851b432$export$ff25708b37f72782(),
        y: $b9f69e6ca851b432$export$ff25708b37f72782()
    });
const $b9f69e6ca851b432$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $b9f69e6ca851b432$export$6459fc9e86be362e = ()=>({
        x: $b9f69e6ca851b432$export$6db76765312617ac(),
        y: $b9f69e6ca851b432$export$6db76765312617ac()
    });


function $04f185e8ac0cb356$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $359a81f173144552$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $359a81f173144552$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $359a81f173144552$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



function $05b0cdb706dd6e6e$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $05b0cdb706dd6e6e$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$05b0cdb706dd6e6e$var$isIdentityScale(scale) || !$05b0cdb706dd6e6e$var$isIdentityScale(scaleX) || !$05b0cdb706dd6e6e$var$isIdentityScale(scaleY);
}
function $05b0cdb706dd6e6e$export$a545127cf1fbb600(values) {
    return $05b0cdb706dd6e6e$export$bdf30dca883ea463(values) || $05b0cdb706dd6e6e$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY;
}
function $05b0cdb706dd6e6e$export$bf80f5f8f4dc327f(values) {
    return $05b0cdb706dd6e6e$var$is2DTranslate(values.x) || $05b0cdb706dd6e6e$var$is2DTranslate(values.y);
}
function $05b0cdb706dd6e6e$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $237e1fd38c273aa4$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $237e1fd38c273aa4$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $237e1fd38c273aa4$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $237e1fd38c273aa4$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $237e1fd38c273aa4$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $237e1fd38c273aa4$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $237e1fd38c273aa4$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $237e1fd38c273aa4$export$d80074982803af5c(box, { x: x, y: y }) {
    $237e1fd38c273aa4$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $237e1fd38c273aa4$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $237e1fd38c273aa4$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const instance = node.instance;
        if (instance && instance.style && instance.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $237e1fd38c273aa4$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $237e1fd38c273aa4$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $05b0cdb706dd6e6e$export$a545127cf1fbb600)(node.latestValues)) $237e1fd38c273aa4$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ treeScale.x = $237e1fd38c273aa4$var$snapToDefault(treeScale.x);
    treeScale.y = $237e1fd38c273aa4$var$snapToDefault(treeScale.y);
}
function $237e1fd38c273aa4$var$snapToDefault(scale) {
    if (Number.isInteger(scale)) return scale;
    return scale > 1.0000000000001 || scale < 0.999999999999 ? scale : 1;
}
function $237e1fd38c273aa4$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $237e1fd38c273aa4$export$625f1dd140a2f5e7(axis, transforms, [key, scaleKey, originKey]) {
    const axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    const originPoint = (0, $5cbd34a3bc31f43d$export$2c9e8a9632a706b2)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $237e1fd38c273aa4$export$e8e3a712e9ebf422(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $237e1fd38c273aa4$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $237e1fd38c273aa4$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $237e1fd38c273aa4$export$58b16271041fbfb(box, transform) {
    $237e1fd38c273aa4$export$625f1dd140a2f5e7(box.x, transform, $237e1fd38c273aa4$var$xKeys);
    $237e1fd38c273aa4$export$625f1dd140a2f5e7(box.y, transform, $237e1fd38c273aa4$var$yKeys);
}


function $5051822a2b8b87f6$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $359a81f173144552$export$d3955c6a8f65a36b)((0, $359a81f173144552$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $5051822a2b8b87f6$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $5051822a2b8b87f6$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $237e1fd38c273aa4$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $237e1fd38c273aa4$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}










const $c2c7b2cf79ee7b33$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class $c2c7b2cf79ee7b33$export$86bff71f18910307 {
    constructor(visualElement){
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $b9f69e6ca851b432$export$6459fc9e86be362e)();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            // Stop any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $37ad62a5a00c9515$export$12f84bb882d06e1a)(event, "page").point);
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openGlobalLock) this.openGlobalLock();
                this.openGlobalLock = (0, $e59e159b20744553$export$2b7959ed03c1a3fe)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openGlobalLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $04f185e8ac0cb356$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $ca276f8dec7edf41$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $d959a4d48684fa58$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $d959fd4c7cb328b7$export$2cef06c20297c17d).update(()=>onDragStart(event, info), false, true);
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openGlobalLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $c2c7b2cf79ee7b33$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        this.panSession = new (0, $9ba914184f4e86d7$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint()
        });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $d959fd4c7cb328b7$export$2cef06c20297c17d).update(()=>onDragEnd(event, info));
    }
    cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$c2c7b2cf79ee7b33$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $03cc6966959981da$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const { layout: layout } = this.visualElement.projection || {};
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $3e7c51262248630b$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $03cc6966959981da$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $03cc6966959981da$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $04f185e8ac0cb356$export$b789de563eb43b1)((axis)=>{
            if (this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $03cc6966959981da$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $3e7c51262248630b$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $f3c6a28fc8795b13$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $5051822a2b8b87f6$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $03cc6966959981da$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $359a81f173144552$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $359a81f173144552$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $04f185e8ac0cb356$export$b789de563eb43b1)((axis)=>{
            if (!$c2c7b2cf79ee7b33$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        return axisValue.start((0, $92a13601a1e6930d$export$90b3dfc33ff3548)(axis, axisValue, 0, transition));
    }
    stopAnimation() {
        (0, $04f185e8ac0cb356$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = "_drag" + axis.toUpperCase();
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $04f185e8ac0cb356$export$b789de563eb43b1)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$c2c7b2cf79ee7b33$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $5cbd34a3bc31f43d$export$2c9e8a9632a706b2)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $3e7c51262248630b$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $04f185e8ac0cb356$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $03cc6966959981da$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $04f185e8ac0cb356$export$b789de563eb43b1)((axis)=>{
            if (!$c2c7b2cf79ee7b33$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $5cbd34a3bc31f43d$export$2c9e8a9632a706b2)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $c2c7b2cf79ee7b33$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $705ce2c92f6e40ca$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $3e7c51262248630b$export$dedd81df7bc1307)(dragConstraints)) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        measureDragConstraints();
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $1eafa31e475fa1b9$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $04f185e8ac0cb356$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $03cc6966959981da$export$a3366d3bac43a742), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $c2c7b2cf79ee7b33$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $c2c7b2cf79ee7b33$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}


class $f0ce0a01359874a9$export$5d97dc2872682820 extends (0, $ab6644c4f7a97411$export$6e91cf7616333d5) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $698766df269bc8f4$export$8793edee2d425525);
        this.removeListeners = (0, $698766df269bc8f4$export$8793edee2d425525);
        this.controls = new (0, $c2c7b2cf79ee7b33$export$86bff71f18910307)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $698766df269bc8f4$export$8793edee2d425525);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}







const $37571c39f436ca14$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $d959fd4c7cb328b7$export$2cef06c20297c17d).update(()=>handler(event, info));
    };
class $37571c39f436ca14$export$b4f8f1ee75ce5859 extends (0, $ab6644c4f7a97411$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $698766df269bc8f4$export$8793edee2d425525);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $9ba914184f4e86d7$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint()
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $37571c39f436ca14$var$asyncHandler(onPanSessionStart),
            onStart: $37571c39f436ca14$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $d959fd4c7cb328b7$export$2cef06c20297c17d).update(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $705ce2c92f6e40ca$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}




var $2gcPZ = parcelRequire("2gcPZ");

var $2gcPZ = parcelRequire("2gcPZ");

/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $4e874968f39b3fe9$export$2a8c16d82a0a0e26() {
    const context = (0, $2gcPZ.useContext)((0, $3198de5e69aa0cdd$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $2gcPZ.useId)();
    (0, $2gcPZ.useEffect)(()=>register(id), []);
    const safeToRemove = ()=>onExitComplete && onExitComplete(id);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $4e874968f39b3fe9$export$8249053f690ea39a() {
    return $4e874968f39b3fe9$export$ee27c052bca048fb((0, $2gcPZ.useContext)((0, $3198de5e69aa0cdd$export$f224e4635b6f8ce2)));
}
function $4e874968f39b3fe9$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}




/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $34090965703108dd$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};



function $d8e2152d387789ed$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $d8e2152d387789ed$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $ca276f8dec7edf41$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $d8e2152d387789ed$export$fafff692be55225d(latest, node.target.x);
        const y = $d8e2152d387789ed$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};




const $7803a985db551483$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $4a52942eb99333f7$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $4a52942eb99333f7$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $5cbd34a3bc31f43d$export$2c9e8a9632a706b2)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};



class $47dfc3127a695f16$var$MeasureLayoutWithContext extends (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).Component {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $edd8247212265180$export$de9e7791c71225fd)($47dfc3127a695f16$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $34090965703108dd$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $d959fd4c7cb328b7$export$2cef06c20297c17d).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            queueMicrotask(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $47dfc3127a695f16$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $4e874968f39b3fe9$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $2gcPZ.useContext)((0, $f679b97cb314af99$export$a3579ca508007a95));
    return (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).createElement($47dfc3127a695f16$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $2gcPZ.useContext)((0, $594aee70035be9ea$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $47dfc3127a695f16$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $d8e2152d387789ed$export$5eafb6257a5844c),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $d8e2152d387789ed$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $d8e2152d387789ed$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $d8e2152d387789ed$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $d8e2152d387789ed$export$5eafb6257a5844c),
    boxShadow: (0, $7803a985db551483$export$eb0bc629e74dcf8)
};









const $d6f42bd1dc03804a$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $d6f42bd1dc03804a$var$numBorders = $d6f42bd1dc03804a$var$borders.length;
const $d6f42bd1dc03804a$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $d6f42bd1dc03804a$var$isPx = (value)=>typeof value === "number" || (0, $ca276f8dec7edf41$export$91c0eda1d06bf008).test(value);
function $d6f42bd1dc03804a$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $5cbd34a3bc31f43d$export$2c9e8a9632a706b2)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, $d6f42bd1dc03804a$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $5cbd34a3bc31f43d$export$2c9e8a9632a706b2)(follow.opacity !== undefined ? follow.opacity : 1, 0, $d6f42bd1dc03804a$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $5cbd34a3bc31f43d$export$2c9e8a9632a706b2)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $d6f42bd1dc03804a$var$numBorders; i++){
        const borderLabel = `border${$d6f42bd1dc03804a$var$borders[i]}Radius`;
        let followRadius = $d6f42bd1dc03804a$var$getRadius(follow, borderLabel);
        let leadRadius = $d6f42bd1dc03804a$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $d6f42bd1dc03804a$var$isPx(followRadius) === $d6f42bd1dc03804a$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $5cbd34a3bc31f43d$export$2c9e8a9632a706b2)($d6f42bd1dc03804a$var$asNumber(followRadius), $d6f42bd1dc03804a$var$asNumber(leadRadius), progress), 0);
            if ((0, $ca276f8dec7edf41$export$626336c2cd4b14de).test(leadRadius) || (0, $ca276f8dec7edf41$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $5cbd34a3bc31f43d$export$2c9e8a9632a706b2)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $d6f42bd1dc03804a$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $d6f42bd1dc03804a$var$easeCrossfadeIn = $d6f42bd1dc03804a$var$compress(0, 0.5, (0, $a67b54e7526e09bf$export$c8d67a19199d1a50));
const $d6f42bd1dc03804a$var$easeCrossfadeOut = $d6f42bd1dc03804a$var$compress(0.5, 0.95, (0, $698766df269bc8f4$export$8793edee2d425525));
function $d6f42bd1dc03804a$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $aac79f37d389f44b$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $04e4ebf2afbbb67d$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $04e4ebf2afbbb67d$export$c53fd88f45d77e4b(box, originBox) {
    $04e4ebf2afbbb67d$export$a0230ae482601ae8(box.x, originBox.x);
    $04e4ebf2afbbb67d$export$a0230ae482601ae8(box.y, originBox.y);
}







/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $80abb5d9eb076d40$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $237e1fd38c273aa4$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $237e1fd38c273aa4$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $80abb5d9eb076d40$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $ca276f8dec7edf41$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $5cbd34a3bc31f43d$export$2c9e8a9632a706b2)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $5cbd34a3bc31f43d$export$2c9e8a9632a706b2)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $80abb5d9eb076d40$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $80abb5d9eb076d40$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $80abb5d9eb076d40$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $80abb5d9eb076d40$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $80abb5d9eb076d40$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $80abb5d9eb076d40$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $80abb5d9eb076d40$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $80abb5d9eb076d40$export$42b76f1d0d16d5b(box.x, transforms, $80abb5d9eb076d40$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $80abb5d9eb076d40$export$42b76f1d0d16d5b(box.y, transforms, $80abb5d9eb076d40$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}





function $41290d76e90e597b$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $41290d76e90e597b$export$a7ec7642fe550fb6(delta) {
    return $41290d76e90e597b$var$isAxisDeltaZero(delta.x) && $41290d76e90e597b$var$isAxisDeltaZero(delta.y);
}
function $41290d76e90e597b$export$8d5cf76bb7daff09(a, b) {
    return a.x.min === b.x.min && a.x.max === b.x.max && a.y.min === b.y.min && a.y.max === b.y.max;
}
function $41290d76e90e597b$export$c5706146bc63213(box) {
    return (0, $d959a4d48684fa58$export$c1c127004b72a37)(box.x) / (0, $d959a4d48684fa58$export$c1c127004b72a37)(box.y);
}



class $f4af71ed391f772d$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $cefc68c3989214f3$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $cefc68c3989214f3$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options, resumingFrom: resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}



function $3eeca1e8989b5d03$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    if (xTranslate || yTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, 0) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { rotate: rotate, rotateX: rotateX, rotateY: rotateY } = latestTransform;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}





const $21e6fa025dc6507d$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $9d4072c3c43b3697$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $cefc68c3989214f3$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $cefc68c3989214f3$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $21e6fa025dc6507d$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}





/**
 * Timeout defined in ms
 */ function $9746e9c5b99106aa$export$1391212d75b2ee65(callback, timeout) {
    const start = performance.now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $d959fd4c7cb328b7$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $d959fd4c7cb328b7$export$2cef06c20297c17d).read(checkElapsed, true);
    return ()=>(0, $d959fd4c7cb328b7$export$ec99c0ef4978dccb)(checkElapsed);
}



function $bc32311a4b610b14$export$e5185e241753e543(data) {
    if (window.MotionDebug) window.MotionDebug.record(data);
}


function $3150bfed5c929507$export$17eda790a720ec57(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}





function $e266581d77d940f2$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $40691104928af1ab$export$605d60a2578142d3)(value) ? value : (0, $ac6ee9d0a6913bb6$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $92a13601a1e6930d$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}



const $81150a370d5c86c4$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $81150a370d5c86c4$var$animationTarget = 1000;
let $81150a370d5c86c4$var$id = 0;
/**
 * Use a mutable data object for debug data so as to not create a new
 * object every frame.
 */ const $81150a370d5c86c4$var$projectionFrameData = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0
};
function $81150a370d5c86c4$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $81150a370d5c86c4$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ $81150a370d5c86c4$var$projectionFrameData.totalNodes = $81150a370d5c86c4$var$projectionFrameData.resolvedTargetDeltas = $81150a370d5c86c4$var$projectionFrameData.recalculatedProjection = 0;
                this.nodes.forEach($81150a370d5c86c4$export$131f2f0cc5fe9609);
                this.nodes.forEach($81150a370d5c86c4$var$resolveTargetDelta);
                this.nodes.forEach($81150a370d5c86c4$var$calcProjection);
                this.nodes.forEach($81150a370d5c86c4$export$c2664f37bc951031);
                (0, $bc32311a4b610b14$export$e5185e241753e543)($81150a370d5c86c4$var$projectionFrameData);
            };
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $9d4072c3c43b3697$export$1465d17e3de78a96)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $bd26a630358fb62d$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance) return;
            this.isSVG = (0, $3150bfed5c929507$export$17eda790a720ec57)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $9746e9c5b99106aa$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $34090965703108dd$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $34090965703108dd$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($81150a370d5c86c4$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeTargetChanged: hasRelativeTargetChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $81150a370d5c86c4$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const targetChanged = !this.targetLayout || !(0, $41290d76e90e597b$export$8d5cf76bb7daff09)(this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = {
                        ...(0, $f970ee86818edb42$export$7c1391340308742e)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $81150a370d5c86c4$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            (0, $d959fd4c7cb328b7$export$ec99c0ef4978dccb)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($81150a370d5c86c4$var$resetRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($81150a370d5c86c4$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) return;
            this.isUpdating = false;
            /**
             * Write
             */ this.nodes.forEach($81150a370d5c86c4$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($81150a370d5c86c4$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($81150a370d5c86c4$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            // Flush any scheduled updates
            (0, $d959fd4c7cb328b7$export$be3f796aed065412).update.process((0, $ef064ed7af32d6e0$export$fff89137e9e818ce));
            (0, $d959fd4c7cb328b7$export$be3f796aed065412).preRender.process((0, $ef064ed7af32d6e0$export$fff89137e9e818ce));
            (0, $d959fd4c7cb328b7$export$be3f796aed065412).render.process((0, $ef064ed7af32d6e0$export$fff89137e9e818ce));
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                queueMicrotask(()=>this.update());
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($81150a370d5c86c4$var$clearSnapshot);
            this.sharedNodes.forEach($81150a370d5c86c4$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            (0, $d959fd4c7cb328b7$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $d959fd4c7cb328b7$export$2cef06c20297c17d).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $b9f69e6ca851b432$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) this.scroll = {
                animationId: this.root.animationId,
                phase: phase,
                isRoot: checkIsScrollRoot(this.instance),
                offset: measureScroll(this.instance)
            };
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform;
            const hasProjection = this.projectionDelta && !(0, $41290d76e90e597b$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $05b0cdb706dd6e6e$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $81150a370d5c86c4$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $b9f69e6ca851b432$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            // Remove viewport scroll to give page-relative coordinates
            const { scroll: scroll } = this.root;
            if (scroll) {
                (0, $237e1fd38c273aa4$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                (0, $237e1fd38c273aa4$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = (0, $b9f69e6ca851b432$export$6459fc9e86be362e)();
            (0, $04e4ebf2afbbb67d$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.isRoot) {
                        (0, $04e4ebf2afbbb67d$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                        const { scroll: rootScroll } = this.root;
                        /**
                         * Undo the application of page scroll that was originally added
                         * to the measured bounding box.
                         */ if (rootScroll) {
                            (0, $237e1fd38c273aa4$export$a807a5ce5ebb3895)(boxWithoutScroll.x, -rootScroll.offset.x);
                            (0, $237e1fd38c273aa4$export$a807a5ce5ebb3895)(boxWithoutScroll.y, -rootScroll.offset.y);
                        }
                    }
                    (0, $237e1fd38c273aa4$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $237e1fd38c273aa4$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $b9f69e6ca851b432$export$6459fc9e86be362e)();
            (0, $04e4ebf2afbbb67d$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $237e1fd38c273aa4$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $05b0cdb706dd6e6e$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $237e1fd38c273aa4$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $05b0cdb706dd6e6e$export$a545127cf1fbb600)(this.latestValues)) (0, $237e1fd38c273aa4$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $b9f69e6ca851b432$export$6459fc9e86be362e)();
            (0, $04e4ebf2afbbb67d$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $05b0cdb706dd6e6e$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $05b0cdb706dd6e6e$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $b9f69e6ca851b432$export$6459fc9e86be362e)();
                const nodeBox = node.measurePageBox();
                (0, $04e4ebf2afbbb67d$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $80abb5d9eb076d40$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $05b0cdb706dd6e6e$export$a545127cf1fbb600)(this.latestValues)) (0, $80abb5d9eb076d40$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $ef064ed7af32d6e0$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $ef064ed7af32d6e0$export$fff89137e9e818ce).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ // TODO If this is unsuccessful this currently happens every frame
            if (!this.targetDelta && !this.relativeTarget) {
                // TODO: This is a semi-repetition of further down this function, make DRY
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $b9f69e6ca851b432$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $b9f69e6ca851b432$export$6459fc9e86be362e)();
                    (0, $d959a4d48684fa58$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $04e4ebf2afbbb67d$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $b9f69e6ca851b432$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $b9f69e6ca851b432$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $d959a4d48684fa58$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $04e4ebf2afbbb67d$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $237e1fd38c273aa4$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $04e4ebf2afbbb67d$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $b9f69e6ca851b432$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $b9f69e6ca851b432$export$6459fc9e86be362e)();
                    (0, $d959a4d48684fa58$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $04e4ebf2afbbb67d$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ $81150a370d5c86c4$var$projectionFrameData.resolvedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $05b0cdb706dd6e6e$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $05b0cdb706dd6e6e$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $ef064ed7af32d6e0$export$fff89137e9e818ce).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $04e4ebf2afbbb67d$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $237e1fd38c273aa4$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.projectionTransform) {
                    this.projectionTransform = "none";
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta) {
                this.projectionDelta = (0, $b9f69e6ca851b432$export$3d227df54007d73a)();
                this.projectionDeltaWithTransform = (0, $b9f69e6ca851b432$export$3d227df54007d73a)();
            }
            const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            const prevProjectionTransform = this.projectionTransform;
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $d959a4d48684fa58$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            this.projectionTransform = (0, $3eeca1e8989b5d03$export$d33653b270fe725c)(this.projectionDelta, this.treeScale);
            if (this.projectionTransform !== prevProjectionTransform || this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ $81150a370d5c86c4$var$projectionFrameData.recalculatedProjection++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            this.options.scheduleRender && this.options.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $b9f69e6ca851b432$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $b9f69e6ca851b432$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($81150a370d5c86c4$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $81150a370d5c86c4$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $81150a370d5c86c4$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $d959a4d48684fa58$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $81150a370d5c86c4$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $41290d76e90e597b$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $b9f69e6ca851b432$export$6459fc9e86be362e)();
                    (0, $04e4ebf2afbbb67d$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $d6f42bd1dc03804a$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, $d959fd4c7cb328b7$export$ec99c0ef4978dccb)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $d959fd4c7cb328b7$export$2cef06c20297c17d).update(()=>{
                (0, $34090965703108dd$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                this.currentAnimation = (0, $e266581d77d940f2$export$335a17c977067b99)(0, $81150a370d5c86c4$var$animationTarget, {
                    ...options,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onComplete: ()=>{
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($81150a370d5c86c4$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $81150a370d5c86c4$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $b9f69e6ca851b432$export$6459fc9e86be362e)();
                const xLength = (0, $d959a4d48684fa58$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $d959a4d48684fa58$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $04e4ebf2afbbb67d$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $237e1fd38c273aa4$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $d959a4d48684fa58$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $f4af71ed391f772d$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected rotation values, we can early return without a forced render.
            let hasRotate = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ) hasRotate = true;
            // If there's no rotation values, we don't need to do any more.
            if (!hasRotate) return;
            const resetValues = {};
            // Check the rotate value of all axes and reset to 0
            for(let i = 0; i < $81150a370d5c86c4$var$transformAxes.length; i++){
                const key = "rotate" + $81150a370d5c86c4$var$transformAxes[i];
                // Record the rotation and then temporarily set it to 0
                if (latestValues[key]) {
                    resetValues[key] = latestValues[key];
                    visualElement.setStaticValue(key, 0);
                }
            }
            // Force a render of this element to apply the transform with all rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues)visualElement.setStaticValue(key, resetValues[key]);
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp = {}) {
            var _a, _b;
            // TODO: Return lifecycle-persistent object
            const styles = {};
            if (!this.instance || this.isSVG) return styles;
            if (!this.isVisible) return {
                visibility: "hidden"
            };
            else styles.visibility = "";
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $be1238c34e009d37$export$fcc2206ecb6d74b)(styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $be1238c34e009d37$export$fcc2206ecb6d74b)(styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $05b0cdb706dd6e6e$export$a545127cf1fbb600)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $3eeca1e8989b5d03$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x, y: y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $edd8247212265180$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo } = (0, $edd8247212265180$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $be1238c34e009d37$export$fcc2206ecb6d74b)(styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($81150a370d5c86c4$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $81150a370d5c86c4$var$updateLayout(node) {
    node.updateLayout();
}
function $81150a370d5c86c4$var$notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $04f185e8ac0cb356$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $d959a4d48684fa58$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($81150a370d5c86c4$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $04f185e8ac0cb356$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $d959a4d48684fa58$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $b9f69e6ca851b432$export$3d227df54007d73a)();
        (0, $d959a4d48684fa58$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $b9f69e6ca851b432$export$3d227df54007d73a)();
        if (isShared) (0, $d959a4d48684fa58$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $d959a4d48684fa58$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $41290d76e90e597b$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $b9f69e6ca851b432$export$6459fc9e86be362e)();
                    (0, $d959a4d48684fa58$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $b9f69e6ca851b432$export$6459fc9e86be362e)();
                    (0, $d959a4d48684fa58$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $41290d76e90e597b$export$8d5cf76bb7daff09)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $81150a370d5c86c4$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ $81150a370d5c86c4$var$projectionFrameData.totalNodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $81150a370d5c86c4$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $81150a370d5c86c4$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $81150a370d5c86c4$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $81150a370d5c86c4$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $81150a370d5c86c4$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $81150a370d5c86c4$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $81150a370d5c86c4$var$calcProjection(node) {
    node.calcProjection();
}
function $81150a370d5c86c4$var$resetRotation(node) {
    node.resetRotation();
}
function $81150a370d5c86c4$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $81150a370d5c86c4$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $5cbd34a3bc31f43d$export$2c9e8a9632a706b2)(delta.translate, 0, p);
    output.scale = (0, $5cbd34a3bc31f43d$export$2c9e8a9632a706b2)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $81150a370d5c86c4$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $5cbd34a3bc31f43d$export$2c9e8a9632a706b2)(from.min, to.min, p);
    output.max = (0, $5cbd34a3bc31f43d$export$2c9e8a9632a706b2)(from.max, to.max, p);
}
function $81150a370d5c86c4$export$6ffd3e6ae339a132(output, from, to, p) {
    $81150a370d5c86c4$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $81150a370d5c86c4$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $81150a370d5c86c4$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $81150a370d5c86c4$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
function $81150a370d5c86c4$var$roundAxis(axis) {
    axis.min = Math.round(axis.min);
    axis.max = Math.round(axis.max);
}
function $81150a370d5c86c4$var$roundBox(box) {
    $81150a370d5c86c4$var$roundAxis(box.x);
    $81150a370d5c86c4$var$roundAxis(box.y);
}
function $81150a370d5c86c4$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $d959a4d48684fa58$export$28d0384c4b79bde2)((0, $41290d76e90e597b$export$c5706146bc63213)(snapshot), (0, $41290d76e90e597b$export$c5706146bc63213)(layout), 0.2);
}




const $11d81a88fec5808f$export$2d029a49a09b6177 = (0, $81150a370d5c86c4$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $1eafa31e475fa1b9$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});


const $b6ae1a60264048cd$export$b91509fcf893b648 = {
    current: undefined
};
const $b6ae1a60264048cd$export$b61a9eb3dbde8858 = (0, $81150a370d5c86c4$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$b6ae1a60264048cd$export$b91509fcf893b648.current) {
            const documentNode = new (0, $11d81a88fec5808f$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $b6ae1a60264048cd$export$b91509fcf893b648.current = documentNode;
        }
        return $b6ae1a60264048cd$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $345fd910b32f02c8$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $37571c39f436ca14$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $f0ce0a01359874a9$export$5d97dc2872682820),
        ProjectionNode: (0, $b6ae1a60264048cd$export$b61a9eb3dbde8858),
        MeasureLayout: $47dfc3127a695f16$export$779f5fb01ad751cd
    }
};












/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $07ec76544fe9b078$var$splitCSSVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function $07ec76544fe9b078$export$b9f0c1f373aee2b0(current) {
    const match = $07ec76544fe9b078$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
}
const $07ec76544fe9b078$var$maxDepth = 4;
function $07ec76544fe9b078$var$getVariableValue(current, element, depth = 1) {
    (0, $f3c6a28fc8795b13$export$f5708dca728d7177)(depth <= $07ec76544fe9b078$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $07ec76544fe9b078$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) return resolved.trim();
    else if ((0, $15b5c3bffdb47066$export$31f9caa2600b5723)(fallback)) // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
    return $07ec76544fe9b078$var$getVariableValue(fallback, element, depth + 1);
    else return fallback;
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */ function $07ec76544fe9b078$export$669319b042b57350(visualElement, { ...target }, transitionEnd) {
    const element = visualElement.current;
    if (!(element instanceof Element)) return {
        target: target,
        transitionEnd: transitionEnd
    };
    // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
    // only if they change but I think this reads clearer and this isn't a performance-critical path.
    if (transitionEnd) transitionEnd = {
        ...transitionEnd
    };
    // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
    visualElement.values.forEach((value)=>{
        const current = value.get();
        if (!(0, $15b5c3bffdb47066$export$31f9caa2600b5723)(current)) return;
        const resolved = $07ec76544fe9b078$var$getVariableValue(current, element);
        if (resolved) value.set(resolved);
    });
    // Cycle through every target property and resolve CSS variables. Currently
    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
    for(const key in target){
        const current = target[key];
        if (!(0, $15b5c3bffdb47066$export$31f9caa2600b5723)(current)) continue;
        const resolved = $07ec76544fe9b078$var$getVariableValue(current, element);
        if (!resolved) continue;
        // Clone target if it hasn't already been
        target[key] = resolved;
        if (!transitionEnd) transitionEnd = {};
        // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
        // CSS variable. This will ensure that after the animation the component will reflect
        // changes in the value of the CSS variable.
        if (transitionEnd[key] === undefined) transitionEnd[key] = current;
    }
    return {
        target: target,
        transitionEnd: transitionEnd
    };
}









const $76ca9766c718f1f4$var$positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y"
]);
const $76ca9766c718f1f4$var$isPositionalKey = (key)=>$76ca9766c718f1f4$var$positionalKeys.has(key);
const $76ca9766c718f1f4$var$hasPositionalKey = (target)=>{
    return Object.keys(target).some($76ca9766c718f1f4$var$isPositionalKey);
};
const $76ca9766c718f1f4$var$isNumOrPxType = (v)=>v === (0, $3db28672b0a6a577$export$98e628dec113755e) || v === (0, $ca276f8dec7edf41$export$91c0eda1d06bf008);
const $76ca9766c718f1f4$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $76ca9766c718f1f4$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/);
        if (matrix3d) return $76ca9766c718f1f4$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/);
            if (matrix) return $76ca9766c718f1f4$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $76ca9766c718f1f4$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $76ca9766c718f1f4$var$nonTranslationalTransformKeys = (0, $b25a583cb32de3e0$export$280dc01950909d86).filter((key)=>!$76ca9766c718f1f4$var$transformKeys.has(key));
function $76ca9766c718f1f4$var$removeNonTranslationalTransform(visualElement) {
    const removedTransforms = [];
    $76ca9766c718f1f4$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    // Apply changes to element before measurement
    if (removedTransforms.length) visualElement.render();
    return removedTransforms;
}
const $76ca9766c718f1f4$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $76ca9766c718f1f4$var$getTranslateFromMatrix(4, 13),
    y: $76ca9766c718f1f4$var$getTranslateFromMatrix(5, 14)
};
const $76ca9766c718f1f4$var$convertChangedValueTypes = (target, visualElement, changedKeys)=>{
    const originBbox = visualElement.measureViewportBox();
    const element = visualElement.current;
    const elementComputedStyle = getComputedStyle(element);
    const { display: display } = elementComputedStyle;
    const origin = {};
    // If the element is currently set to display: "none", make it visible before
    // measuring the target bounding box
    if (display === "none") visualElement.setStaticValue("display", target.display || "block");
    /**
     * Record origins before we render and update styles
     */ changedKeys.forEach((key)=>{
        origin[key] = $76ca9766c718f1f4$export$781d46a8aa670d52[key](originBbox, elementComputedStyle);
    });
    // Apply the latest values (as set in checkAndConvertChangedValueTypes)
    visualElement.render();
    const targetBbox = visualElement.measureViewportBox();
    changedKeys.forEach((key)=>{
        // Restore styles to their **calculated computed style**, not their actual
        // originally set style. This allows us to animate between equivalent pixel units.
        const value = visualElement.getValue(key);
        value && value.jump(origin[key]);
        target[key] = $76ca9766c718f1f4$export$781d46a8aa670d52[key](targetBbox, elementComputedStyle);
    });
    return target;
};
const $76ca9766c718f1f4$var$checkAndConvertChangedValueTypes = (visualElement, target, origin = {}, transitionEnd = {})=>{
    target = {
        ...target
    };
    transitionEnd = {
        ...transitionEnd
    };
    const targetPositionalKeys = Object.keys(target).filter($76ca9766c718f1f4$var$isPositionalKey);
    // We want to remove any transform values that could affect the element's bounding box before
    // it's measured. We'll reapply these later.
    let removedTransformValues = [];
    let hasAttemptedToRemoveTransformValues = false;
    const changedValueTypeKeys = [];
    targetPositionalKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (!visualElement.hasValue(key)) return;
        let from = origin[key];
        let fromType = (0, $5469ce2e9af910bb$export$eefdd52e3ccae428)(from);
        const to = target[key];
        let toType;
        // TODO: The current implementation of this basically throws an error
        // if you try and do value conversion via keyframes. There's probably
        // a way of doing this but the performance implications would need greater scrutiny,
        // as it'd be doing multiple resize-remeasure operations.
        if ((0, $53442b5a509d9f4b$export$9153ad4c4999f4a0)(to)) {
            const numKeyframes = to.length;
            const fromIndex = to[0] === null ? 1 : 0;
            from = to[fromIndex];
            fromType = (0, $5469ce2e9af910bb$export$eefdd52e3ccae428)(from);
            for(let i = fromIndex; i < numKeyframes; i++){
                /**
                 * Don't allow wildcard keyframes to be used to detect
                 * a difference in value types.
                 */ if (to[i] === null) break;
                if (!toType) {
                    toType = (0, $5469ce2e9af910bb$export$eefdd52e3ccae428)(to[i]);
                    (0, $f3c6a28fc8795b13$export$f5708dca728d7177)(toType === fromType || $76ca9766c718f1f4$var$isNumOrPxType(fromType) && $76ca9766c718f1f4$var$isNumOrPxType(toType), "Keyframes must be of the same dimension as the current value");
                } else (0, $f3c6a28fc8795b13$export$f5708dca728d7177)((0, $5469ce2e9af910bb$export$eefdd52e3ccae428)(to[i]) === toType, "All keyframes must be of the same type");
            }
        } else toType = (0, $5469ce2e9af910bb$export$eefdd52e3ccae428)(to);
        if (fromType !== toType) {
            // If they're both just number or px, convert them both to numbers rather than
            // relying on resize/remeasure to convert (which is wasteful in this situation)
            if ($76ca9766c718f1f4$var$isNumOrPxType(fromType) && $76ca9766c718f1f4$var$isNumOrPxType(toType)) {
                const current = value.get();
                if (typeof current === "string") value.set(parseFloat(current));
                if (typeof to === "string") target[key] = parseFloat(to);
                else if (Array.isArray(to) && toType === (0, $ca276f8dec7edf41$export$91c0eda1d06bf008)) target[key] = to.map(parseFloat);
            } else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) && (toType === null || toType === void 0 ? void 0 : toType.transform) && (from === 0 || to === 0)) {
                // If one or the other value is 0, it's safe to coerce it to the
                // type of the other without measurement
                if (from === 0) value.set(toType.transform(from));
                else target[key] = fromType.transform(to);
            } else {
                // If we're going to do value conversion via DOM measurements, we first
                // need to remove non-positional transform values that could affect the bbox measurements.
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues = $76ca9766c718f1f4$var$removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] = transitionEnd[key] !== undefined ? transitionEnd[key] : target[key];
                value.jump(to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        const scrollY = changedValueTypeKeys.indexOf("height") >= 0 ? window.pageYOffset : null;
        const convertedTarget = $76ca9766c718f1f4$var$convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        // If we removed transform values, reapply them before the next render
        if (removedTransformValues.length) removedTransformValues.forEach(([key, value])=>{
            visualElement.getValue(key).set(value);
        });
        // Reapply original values
        visualElement.render();
        // Restore scroll position
        if ((0, $4989af2740acfe07$export$4e09c449d6c407f7) && scrollY !== null) window.scrollTo({
            top: scrollY
        });
        return {
            target: convertedTarget,
            transitionEnd: transitionEnd
        };
    } else return {
        target: target,
        transitionEnd: transitionEnd
    };
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */ function $76ca9766c718f1f4$export$9e04b0cab841a28(visualElement, target, origin, transitionEnd) {
    return $76ca9766c718f1f4$var$hasPositionalKey(target) ? $76ca9766c718f1f4$var$checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd) : {
        target: target,
        transitionEnd: transitionEnd
    };
}


/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */ const $8cd0100f5cab9ef4$export$5849e743e29831d6 = (visualElement, target, origin, transitionEnd)=>{
    const resolved = (0, $07ec76544fe9b078$export$669319b042b57350)(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return (0, $76ca9766c718f1f4$export$9e04b0cab841a28)(visualElement, target, origin, transitionEnd);
};







// Does this device prefer reduced motion? Returns `null` server-side.
const $530328e7268335c3$export$ff7706047246b98b = {
    current: null
};
const $530328e7268335c3$export$6476d16e2fd2d0db = {
    current: false
};


function $49b4e09bb1f9a78c$export$ca9f41fb23dded3d() {
    (0, $530328e7268335c3$export$6476d16e2fd2d0db).current = true;
    if (!(0, $4989af2740acfe07$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $530328e7268335c3$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $530328e7268335c3$export$ff7706047246b98b).current = false;
}














function $7da1f1d4b0ae68b1$export$9a552858d5197f6e(element, next, prev) {
    const { willChange: willChange } = next;
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $40691104928af1ab$export$605d60a2578142d3)(nextValue)) {
            /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
            if ((0, $79c5e793c0fc2623$export$98397f3adbf6259f)(willChange)) willChange.add(key);
        } else if ((0, $40691104928af1ab$export$605d60a2578142d3)(prevValue)) {
            /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $ac6ee9d0a6913bb6$export$ce8bdc721e76545f)(nextValue, {
                owner: element
            }));
            if ((0, $79c5e793c0fc2623$export$98397f3adbf6259f)(willChange)) willChange.remove(key);
        } else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                // TODO: Only update values that aren't being animated or even looked at
                !existingValue.hasAnimated && existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $ac6ee9d0a6913bb6$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}






const $05892fed83d344f3$export$bc2a978a17abfdde = new WeakMap();


const $7a0b9e8f8cf34940$var$featureNames = Object.keys((0, $d1eb9b343be92f21$export$65570e08d843624d));
const $7a0b9e8f8cf34940$var$numFeatures = $7a0b9e8f8cf34940$var$featureNames.length;
const $7a0b9e8f8cf34940$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
const $7a0b9e8f8cf34940$var$numVariantProps = (0, $d3885f669dd71fbf$export$1405a65085f40b9).length;
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $7a0b9e8f8cf34940$export$fa8b653c0f3714e5 {
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.scheduleRender = ()=>(0, $d959fd4c7cb328b7$export$2cef06c20297c17d).render(this.render, false, true);
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.isControllingVariants = (0, $c90e990e74ab2ce2$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $c90e990e74ab2ce2$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {});
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $40691104928af1ab$export$605d60a2578142d3)(value)) {
                value.set(latestValues[key], false);
                if ((0, $79c5e793c0fc2623$export$98397f3adbf6259f)(willChange)) willChange.add(key);
            }
        }
    }
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps) {
        return {};
    }
    mount(instance) {
        this.current = instance;
        (0, $05892fed83d344f3$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $530328e7268335c3$export$6476d16e2fd2d0db).current) (0, $49b4e09bb1f9a78c$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $530328e7268335c3$export$ff7706047246b98b).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        (0, $05892fed83d344f3$export$bc2a978a17abfdde).delete(this.current);
        this.projection && this.projection.unmount();
        (0, $d959fd4c7cb328b7$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $d959fd4c7cb328b7$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features)this.features[key].unmount();
        this.current = null;
    }
    bindToMotionValue(key, value) {
        const valueIsTransform = (0, $b25a583cb32de3e0$export$7b42a0094fb00b6e).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $d959fd4c7cb328b7$export$2cef06c20297c17d).update(this.notifyUpdate, false, true);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    loadFeatures({ children: children, ...renderedProps }, isStrict, preloadedFeatures, initialLayoutGroupConfig) {
        let ProjectionNodeConstructor;
        let MeasureLayout;
        for(let i = 0; i < $7a0b9e8f8cf34940$var$numFeatures; i++){
            const name = $7a0b9e8f8cf34940$var$featureNames[i];
            const { isEnabled: isEnabled, Feature: FeatureConstructor, ProjectionNode: ProjectionNode, MeasureLayout: MeasureLayoutComponent } = (0, $d1eb9b343be92f21$export$65570e08d843624d)[name];
            if (ProjectionNode) ProjectionNodeConstructor = ProjectionNode;
            if (isEnabled(renderedProps)) {
                if (!this.features[name] && FeatureConstructor) this.features[name] = new FeatureConstructor(this);
                if (MeasureLayoutComponent) MeasureLayout = MeasureLayoutComponent;
            }
        }
        if (!this.projection && ProjectionNodeConstructor) {
            this.projection = new ProjectionNodeConstructor(this.latestValues, this.parent && this.parent.projection);
            const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot } = renderedProps;
            this.projection.setOptions({
                layoutId: layoutId,
                layout: layout,
                alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $3e7c51262248630b$export$dedd81df7bc1307)(dragConstraints),
                visualElement: this,
                scheduleRender: ()=>this.scheduleRender(),
                /**
                 * TODO: Update options in an effect. This could be tricky as it'll be too late
                 * to update by the time layout animations run.
                 * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
                 * ensuring it gets called if there's no potential layout animations.
                 *
                 */ animationType: typeof layout === "string" ? layout : "both",
                initialPromotionConfig: initialLayoutGroupConfig,
                layoutScroll: layoutScroll,
                layoutRoot: layoutRoot
            });
        }
        return MeasureLayout;
    }
    updateFeatures() {
        for(const key in this.features){
            const feature = this.features[key];
            if (feature.isMounted) feature.update();
            else {
                feature.mount();
                feature.isMounted = true;
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.options, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $b9f69e6ca851b432$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Make a target animatable by Popmotion. For instance, if we're
     * trying to animate width from 100px to 100vw we need to measure 100vw
     * in pixels to determine what we really need to animate to. This is also
     * pluggable to support Framer's custom value types like Color,
     * and CSS variables.
     */ makeTargetAnimatable(target, canMutate = true) {
        return this.makeTargetAnimatableFromInstance(target, this.props, canMutate);
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $7a0b9e8f8cf34940$var$propEventHandlers.length; i++){
            const key = $7a0b9e8f8cf34940$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listener = props["on" + key];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $7da1f1d4b0ae68b1$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    getVariantContext(startAtParent = false) {
        if (startAtParent) return this.parent ? this.parent.getVariantContext() : undefined;
        if (!this.isControllingVariants) {
            const context = this.parent ? this.parent.getVariantContext() || {} : {};
            if (this.props.initial !== undefined) context.initial = this.props.initial;
            return context;
        }
        const context = {};
        for(let i = 0; i < $7a0b9e8f8cf34940$var$numVariantProps; i++){
            const name = (0, $d3885f669dd71fbf$export$1405a65085f40b9)[i];
            const prop = this.props[name];
            if ((0, $3f159601009ddaf2$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
        }
        return context;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        if (value !== this.values.get(key)) {
            this.removeValue(key);
            this.bindToMotionValue(key, value);
        }
        this.values.set(key, value);
        this.latestValues[key] = value.get();
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $ac6ee9d0a6913bb6$export$ce8bdc721e76545f)(defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key) {
        return this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : this.readValueFromInstance(this.current, key, this.options);
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial } = this.props;
        const valueFromInitial = typeof initial === "string" || typeof initial === "object" ? (_a = (0, $2c8ef2a1a049b491$export$d68f140c4d9b48bc)(this.props, initial)) === null || _a === void 0 ? void 0 : _a[key] : undefined;
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $40691104928af1ab$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $bd26a630358fb62d$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}


class $2334e65babdd115a$export$e49735c2a366bdc7 extends (0, $7a0b9e8f8cf34940$export$fa8b653c0f3714e5) {
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    makeTargetAnimatableFromInstance({ transition: transition, transitionEnd: transitionEnd, ...target }, { transformValues: transformValues }, isMounted) {
        let origin = (0, $5b4992dabc9e61c6$export$5a759dc7a1cfb72a)(target, transition || {}, this);
        /**
         * If Framer has provided a function to convert `Color` etc value types, convert them
         */ if (transformValues) {
            if (transitionEnd) transitionEnd = transformValues(transitionEnd);
            if (target) target = transformValues(target);
            if (origin) origin = transformValues(origin);
        }
        if (isMounted) {
            (0, $5b4992dabc9e61c6$export$6afbed164019a54c)(this, target, origin);
            const parsed = (0, $8cd0100f5cab9ef4$export$5849e743e29831d6)(this, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return {
            transition: transition,
            transitionEnd: transitionEnd,
            ...target
        };
    }
}



function $de36ef519ef4189a$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $de36ef519ef4189a$export$23fea75b03ac16b3 extends (0, $2334e65babdd115a$export$e49735c2a366bdc7) {
    readValueFromInstance(instance, key) {
        if ((0, $b25a583cb32de3e0$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $1a9ec190942d3446$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $de36ef519ef4189a$export$3735103072e4a80(instance);
            const value = ((0, $15b5c3bffdb47066$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $5051822a2b8b87f6$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, options, props) {
        (0, $c01395051c485855$export$bb517f8b40f8e99d)(renderState, latestValues, options, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return (0, $0511a22a5bb38274$export$16da615486abaa45)(props, prevProps);
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $40691104928af1ab$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $7b7d80b641b76eab$export$1a32bf6229c258c0)(instance, renderState, styleProp, projection);
    }
}












class $82278fd73cda683c$export$86bcdffbaf733d84 extends (0, $2334e65babdd115a$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.isSVGTag = false;
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $b25a583cb32de3e0$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $1a9ec190942d3446$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $48cf872e59d6d084$export$28931db5d57958e5).has(key) ? (0, $ef58bee680d214c3$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    measureInstanceViewportBox() {
        return (0, $b9f69e6ca851b432$export$6459fc9e86be362e)();
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return (0, $6adee4e45678a40b$export$16da615486abaa45)(props, prevProps);
    }
    build(renderState, latestValues, options, props) {
        (0, $3d72eb36e78ecf71$export$5475d24f125d7053)(renderState, latestValues, options, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $a714ce5de61c73cd$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $56f23e3e58132193$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
}



const $aeed83e4c24bbc5e$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $d871a0058d319304$export$88f3fc2fd3766989)(Component) ? new (0, $82278fd73cda683c$export$86bcdffbaf733d84)(options, {
        enableHardwareAcceleration: false
    }) : new (0, $de36ef519ef4189a$export$23fea75b03ac16b3)(options, {
        enableHardwareAcceleration: true
    });
};




const $bb6c1a6b40e03cbf$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $b6ae1a60264048cd$export$b61a9eb3dbde8858),
        MeasureLayout: $47dfc3127a695f16$export$779f5fb01ad751cd
    }
};


const $5980fceb02c72dc0$var$preloadedFeatures = {
    ...(0, $677ee99392cbbdac$export$7f9953c70dacfd7f),
    ...(0, $325d5b8c575cc3a3$export$e5b72898e5a201f1),
    ...(0, $345fd910b32f02c8$export$d7d5d435647ed5a0),
    ...(0, $bb6c1a6b40e03cbf$export$b3219800bda33a1f)
};
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */ const $5980fceb02c72dc0$export$e25e478948902b8b = /*@__PURE__*/ (0, $e6b2e5e028e31e14$export$a28d6df673050e18)((Component, config)=>(0, $4673bf8afc8607d6$export$732916c0e88175fb)(Component, config, $5980fceb02c72dc0$var$preloadedFeatures, (0, $aeed83e4c24bbc5e$export$56ba0183203348f5)));
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */ function $5980fceb02c72dc0$export$546614c4a05701f9(key) {
    return (0, $683b720263bf4232$export$46b7e4b9dc6110c3)((0, $4673bf8afc8607d6$export$732916c0e88175fb)(key, {
        forwardMotionProps: false
    }, $5980fceb02c72dc0$var$preloadedFeatures, (0, $aeed83e4c24bbc5e$export$56ba0183203348f5)));
}







var $2gcPZ = parcelRequire("2gcPZ");

parcelRequire("2gcPZ");
const $393cc5ec6df0b713$var$SvgAlarmDuotone = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.268 17A1.99 1.99 0 0 1 8 16v-1h4v1a2 2 0 0 1-3.732 1ZM6 11H5a1 1 0 0 0-1 1v2h12v-1a1 1 0 0 0-1-1h-1V7a2 2 0 0 0-2-2V4H8v1a2 2 0 0 0-2 2v4Zm6 1V7H8v5h4Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("g", {
                opacity: 0.2,
                fill: "currentColor",
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                    d: "M8 7h4v5H8V7ZM5 2a2 2 0 0 0-2 2h2V2ZM15 2a2 2 0 0 1 2 2h-2V2Z"
                })
            })
        ]
    });
var $393cc5ec6df0b713$export$2e2bcd8739ae039 = $393cc5ec6df0b713$var$SvgAlarmDuotone;



parcelRequire("2gcPZ");
const $100c8e167c8c9281$var$SvgAlarm = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M3 4a2 2 0 0 1 2-2v2H3ZM17 4a2 2 0 0 0-2-2v2h2ZM8 4h4v1a2 2 0 0 1 2 2v5h1a1 1 0 0 1 1 1v1H4v-2a1 1 0 0 1 1-1h1V7a2 2 0 0 1 2-2V4ZM8 15h4v1a2 2 0 1 1-4 0v-1Z",
            fill: "currentColor"
        })
    });
var $100c8e167c8c9281$export$2e2bcd8739ae039 = $100c8e167c8c9281$var$SvgAlarm;



parcelRequire("2gcPZ");
const $79d68eaf906c3ef5$var$SvgAlertsDuotone = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                opacity: 0.2,
                fill: "currentColor",
                d: "M5 4h10v12H5z"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M15 4H5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2ZM3 10c0 1.68.688 3.196 1.801 4.286l-1.4 1.428A7.979 7.979 0 0 1 1.001 10c0-2.238.92-4.263 2.4-5.714l1.4 1.428A5.979 5.979 0 0 0 3.001 10ZM17.101 10c0-1.68-.688-3.196-1.8-4.286L16.7 4.286A7.979 7.979 0 0 1 19.1 10c0 2.238-.92 4.263-2.401 5.714l-1.4-1.428A5.98 5.98 0 0 0 17.101 10Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10 7a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-1 3a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M13.223 7.63C13.685 8.2 14 9.035 14 10c0 .964-.315 1.8-.777 2.37l1.554 1.26C15.55 12.675 16 11.386 16 10s-.45-2.676-1.223-3.63l-1.554 1.26ZM6.878 12.37c-.462-.57-.777-1.406-.777-2.37 0-.964.315-1.8.777-2.37L5.324 6.37C4.552 7.325 4.1 8.614 4.1 10s.451 2.676 1.223 3.63l1.554-1.26ZM13 18a2 2 0 0 0 2-2H5a2 2 0 0 0 2 2h6Z",
                fill: "currentColor"
            })
        ]
    });
var $79d68eaf906c3ef5$export$2e2bcd8739ae039 = $79d68eaf906c3ef5$var$SvgAlertsDuotone;



parcelRequire("2gcPZ");
const $a781bb92b75143ec$var$SvgAndroidLogo = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.18 6.93 16 6.758l1.945-1.938a.633.633 0 0 0-.89-.89L15.03 5.96a8.711 8.711 0 0 0-10.047.017L2.945 3.93a.633.633 0 0 0-.89.89l1.96 1.953a8.86 8.86 0 0 0-2.765 6.438V15a1.25 1.25 0 0 0 1.25 1.25h15A1.25 1.25 0 0 0 18.75 15v-1.875a8.689 8.689 0 0 0-2.57-6.195Zm-8.992 6.195a.938.938 0 1 1 0-1.875.938.938 0 0 1 0 1.875Zm5.625 0a.937.937 0 1 1 0-1.875.937.937 0 0 1 0 1.875Z",
            fill: "currentColor"
        })
    });
var $a781bb92b75143ec$export$2e2bcd8739ae039 = $a781bb92b75143ec$var$SvgAndroidLogo;



parcelRequire("2gcPZ");
const $ee52bdb1639d0e03$var$SvgAngularLogo = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "m17.742 5.047-7.5-3.125a.648.648 0 0 0-.484 0l-7.5 3.125a.633.633 0 0 0-.375.664l1.25 9.375a.632.632 0 0 0 .336.476l6.25 3.126a.663.663 0 0 0 .562 0l6.25-3.125a.633.633 0 0 0 .336-.477l1.25-9.375a.633.633 0 0 0-.375-.664Zm-4.648 8.016a.735.735 0 0 1-.282.062.633.633 0 0 1-.562-.344l-.656-1.32H8.406l-.656 1.32a.629.629 0 1 1-1.125-.562l2.812-5.625a.633.633 0 0 1 1.125 0l2.813 5.625a.64.64 0 0 1-.281.844ZM10 8.273l.969 1.938H9.03L10 8.273Z",
            fill: "currentColor"
        })
    });
var $ee52bdb1639d0e03$export$2e2bcd8739ae039 = $ee52bdb1639d0e03$var$SvgAngularLogo;



parcelRequire("2gcPZ");
const $a0d32bfb8ec49c49$var$SvgAppleLogo = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M10.21 2.313a3.141 3.141 0 0 1 2.915-2 .625.625 0 1 1 0 1.25 1.883 1.883 0 0 0-1.75 1.203.625.625 0 1 1-1.164-.454Zm7.134 9.859a3.125 3.125 0 0 1-.211-5.469.64.64 0 0 0 .172-.922A5.313 5.313 0 0 0 10 4.766a5.313 5.313 0 0 0-8.438 4.296c.02 2.061.641 4.07 1.79 5.782C4.477 16.508 5.906 17.5 7.188 17.5h5.625c1.757 0 3.742-1.867 4.835-4.531a.617.617 0 0 0-.304-.797Z",
            fill: "currentColor"
        })
    });
var $a0d32bfb8ec49c49$export$2e2bcd8739ae039 = $a0d32bfb8ec49c49$var$SvgAppleLogo;



parcelRequire("2gcPZ");
const $5c6a179e700c85f2$var$SvgApplePodcastsLogo = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M10 11.25a2.187 2.187 0 1 1 2.188-2.188A2.195 2.195 0 0 1 10 11.25Zm.977 0H9.024a1.555 1.555 0 0 0-1.204.57 1.532 1.532 0 0 0-.328 1.297l.75 3.75a1.57 1.57 0 0 0 1.532 1.258h.453a1.57 1.57 0 0 0 1.53-1.258l.75-3.75a1.53 1.53 0 0 0-.327-1.297 1.556 1.556 0 0 0-1.203-.57Zm3.101.336a.625.625 0 0 0 1.164.453 5.625 5.625 0 1 0-10.484 0 .625.625 0 0 0 .578.399.563.563 0 0 0 .227-.047.625.625 0 0 0 .359-.805 4.375 4.375 0 1 1 8.156 0ZM10 1.875a8.125 8.125 0 0 0-4.375 14.977.627.627 0 0 0 .68-1.055 6.875 6.875 0 1 1 7.39 0 .625.625 0 0 0 .344 1.148.687.687 0 0 0 .336-.093A8.126 8.126 0 0 0 10 1.875Z",
            fill: "currentColor"
        })
    });
var $5c6a179e700c85f2$export$2e2bcd8739ae039 = $5c6a179e700c85f2$var$SvgApplePodcastsLogo;



parcelRequire("2gcPZ");
const $14ee732dc5140431$var$SvgAppStoreLogo = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "m5.023 15.945-.734 1.25a.633.633 0 0 1-.86.219.633.633 0 0 1-.218-.86l.742-1.25a.624.624 0 1 1 1.07.641ZM18.125 12.5h-3.734l-2.399-4.063a.626.626 0 0 0-1.078.633l4.797 8.125a.634.634 0 0 0 .86.219.633.633 0 0 0 .218-.86l-1.656-2.804h2.992a.625.625 0 0 0 0-1.25Zm-6.992 0h-4.07l3.468-5.875h.008l1.875-3.172a.627.627 0 0 0-1.078-.64L10 5.07 8.664 2.805a.627.627 0 0 0-1.078.64l1.687 2.852L5.61 12.5H1.875a.625.625 0 1 0 0 1.25h9.258a.625.625 0 0 0 0-1.25Z",
            fill: "currentColor"
        })
    });
var $14ee732dc5140431$export$2e2bcd8739ae039 = $14ee732dc5140431$var$SvgAppStoreLogo;



parcelRequire("2gcPZ");
const $c1b128b34064482d$var$SvgArrowClockwise = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M6.973 15.294A5.87 5.87 0 0 1 12.798 5.1c.318.234.78.627 1.16 1.057.197.224.351.435.452.62.054.097.083.17.099.222H12v2h6V3h-2v2.542a6.076 6.076 0 0 0-.542-.707 9.868 9.868 0 0 0-1.53-1.385l-.041-.03-.044-.025a7.87 7.87 0 1 0 2.88 10.75l-1.732-1a5.87 5.87 0 0 1-8.018 2.149Z",
            fill: "currentColor"
        })
    });
var $c1b128b34064482d$export$2e2bcd8739ae039 = $c1b128b34064482d$var$SvgArrowClockwise;



parcelRequire("2gcPZ");
const $2dce1275063044dd$var$SvgArrowCounterClockwise = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M6.234 7.79h-3.75V4.04",
                stroke: "currentColor",
                strokeWidth: 1.25,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M5.14 14.86a6.875 6.875 0 1 0 0-9.72L2.485 7.79",
                stroke: "currentColor",
                strokeWidth: 1.25,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $2dce1275063044dd$export$2e2bcd8739ae039 = $2dce1275063044dd$var$SvgArrowCounterClockwise;



parcelRequire("2gcPZ");
const $3bd1adbbf2c8fa56$var$SvgArrowDown = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M9.001 13.64V3h2v10.634l1.363-1.363 1.183 1.182L10 16.999l-1.773-1.772-1.772-1.773 1.182-1.182L9 13.639Z",
            fill: "currentColor"
        })
    });
var $3bd1adbbf2c8fa56$export$2e2bcd8739ae039 = $3bd1adbbf2c8fa56$var$SvgArrowDown;



parcelRequire("2gcPZ");
const $dc34c0bb9f4fdfe4$var$SvgArrowLeft = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M6.361 9H17v2H6.366l1.363 1.363-1.182 1.183L3.002 10l1.772-1.774 1.773-1.772L7.73 7.636 6.361 9Z",
            fill: "currentColor"
        })
    });
var $dc34c0bb9f4fdfe4$export$2e2bcd8739ae039 = $dc34c0bb9f4fdfe4$var$SvgArrowLeft;



parcelRequire("2gcPZ");
const $77e3387764f09602$var$SvgArrowOut = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 32,
        height: 32,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M27 12.5V5h-7.5M18 14l9-9M23 18v8a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1h8",
            stroke: "currentColor",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
var $77e3387764f09602$export$2e2bcd8739ae039 = $77e3387764f09602$var$SvgArrowOut;



parcelRequire("2gcPZ");
const $656231c7ec0fa770$var$SvgArrowRight = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M13.64 11H3.002V9h10.634l-1.363-1.363 1.181-1.183L17 10.001l-1.772 1.773-1.774 1.772-1.181-1.182L13.64 11Z",
            fill: "currentColor"
        })
    });
var $656231c7ec0fa770$export$2e2bcd8739ae039 = $656231c7ec0fa770$var$SvgArrowRight;



parcelRequire("2gcPZ");
const $8f1e4045a4037df2$var$SvgArrowsClockwise = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M13.766 7.79h3.75V4.04",
                stroke: "currentColor",
                strokeWidth: 1.25,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M5.14 5.14a6.867 6.867 0 0 1 9.72 0l2.656 2.65M6.234 12.21h-3.75v3.75",
                stroke: "currentColor",
                strokeWidth: 1.25,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M14.86 14.86a6.869 6.869 0 0 1-9.72 0l-2.656-2.65",
                stroke: "currentColor",
                strokeWidth: 1.25,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $8f1e4045a4037df2$export$2e2bcd8739ae039 = $8f1e4045a4037df2$var$SvgArrowsClockwise;



parcelRequire("2gcPZ");
const $0f363353139fac57$var$SvgArrowsDownUp = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "m8.75 13.75-2.5 2.5-2.5-2.5M6.25 3.75v12.5M11.25 6.25l2.5-2.5 2.5 2.5M13.75 16.25V3.75",
            stroke: "currentColor",
            strokeWidth: 1.25,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
var $0f363353139fac57$export$2e2bcd8739ae039 = $0f363353139fac57$var$SvgArrowsDownUp;



parcelRequire("2gcPZ");
const $3cbc2a81ad17472d$var$SvgArrowsLeftRight = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "m13.75 11.25 2.5 2.5-2.5 2.5M3.75 13.75h12.5M6.25 8.75l-2.5-2.5 2.5-2.5M16.25 6.25H3.75",
            stroke: "currentColor",
            strokeWidth: 1.25,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
var $3cbc2a81ad17472d$export$2e2bcd8739ae039 = $3cbc2a81ad17472d$var$SvgArrowsLeftRight;



parcelRequire("2gcPZ");
const $021418aea03dba2f$var$SvgArrowsOut = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M13.125 3.75h3.125v3.125M11.875 8.125 16.25 3.75M6.875 16.25H3.75v-3.125M8.125 11.875 3.75 16.25M16.25 13.125v3.125h-3.125M11.875 11.875l4.375 4.375M3.75 6.875V3.75h3.125M8.125 8.125 3.75 3.75",
            stroke: "currentColor",
            strokeWidth: 1.25,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
var $021418aea03dba2f$export$2e2bcd8739ae039 = $021418aea03dba2f$var$SvgArrowsOut;



parcelRequire("2gcPZ");
const $9a8314d40ed56690$var$SvgArrowsOutSimple = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M12.5 3.75h3.75V7.5M11.875 8.125 16.25 3.75M7.5 16.25H3.75V12.5M8.125 11.875 3.75 16.25",
            stroke: "currentColor",
            strokeWidth: 1.25,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
var $9a8314d40ed56690$export$2e2bcd8739ae039 = $9a8314d40ed56690$var$SvgArrowsOutSimple;



parcelRequire("2gcPZ");
const $6af9d36bd6f71eba$var$SvgArrowSquareLeftDuotone = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("g", {
            fill: "currentColor",
            children: [
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                    opacity: 0.2,
                    d: "M16.875 3.75v12.5a.624.624 0 0 1-.625.625H3.75a.625.625 0 0 1-.625-.625V3.75a.625.625 0 0 1 .625-.625h12.5a.625.625 0 0 1 .625.625Z"
                }),
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                    d: "M16.25 2.5H3.75A1.25 1.25 0 0 0 2.5 3.75v12.5a1.25 1.25 0 0 0 1.25 1.25h12.5a1.25 1.25 0 0 0 1.25-1.25V3.75a1.25 1.25 0 0 0-1.25-1.25Zm0 13.75H3.75V3.75h12.5v12.5Zm-9.817-5.808a.625.625 0 0 1 0-.884l2.5-2.5a.625.625 0 0 1 .884.884L8.384 9.375h4.741a.625.625 0 1 1 0 1.25H8.384l1.433 1.433a.626.626 0 0 1-.884.884l-2.5-2.5Z"
                })
            ]
        })
    });
var $6af9d36bd6f71eba$export$2e2bcd8739ae039 = $6af9d36bd6f71eba$var$SvgArrowSquareLeftDuotone;



parcelRequire("2gcPZ");
const $8c92fc55bfe585bf$var$SvgArrowUp = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M11 6.36V17H9V6.365L7.639 7.728 6.455 6.547 10.001 3l1.774 1.772 1.772 1.774-1.182 1.181-1.364-1.367Z",
            fill: "currentColor"
        })
    });
var $8c92fc55bfe585bf$export$2e2bcd8739ae039 = $8c92fc55bfe585bf$var$SvgArrowUp;



parcelRequire("2gcPZ");
const $8062c0953fc81593$var$SvgAutometricsColor = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 32,
        height: 32,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("g", {
                clipPath: "url(#AutometricsColor_svg__a)",
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("mask", {
                        id: "AutometricsColor_svg__b",
                        style: {
                            maskType: "luminance"
                        },
                        maskUnits: "userSpaceOnUse",
                        x: 0,
                        y: 0,
                        width: 32,
                        height: 32,
                        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                            d: "M32 0H0v32h32V0Z",
                            fill: "#fff"
                        })
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("g", {
                        mask: "url(#AutometricsColor_svg__b)",
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 13.645H2.9c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F1050F"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 13.887H2.9c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F1060F"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 14.127H2.9c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F0070F"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 14.367H2.9c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F0080F"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 14.608H2.9c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EF090F"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 14.848H2.9c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EF0A0F"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 15.09H2.9c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EF0B0F"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 15.33H2.9c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EE0C0F"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 15.57H2.9c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EE0D0E"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 15.811H2.9c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EE0E0E"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 16.051H2.9c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#ED0F0E"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 16.291H2.9c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#ED100E"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 16.533H2.9c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EC110E"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 16.773H2.9c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EC120E"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 17.013H2.9c-1.05 0-1.9.841-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EC130E"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 17.254H2.9c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EB140E"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 17.494H2.9c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EB150E"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 17.736H2.9c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EB160E"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 17.976H2.9c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EA170E"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 18.217H2.9c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EA180E"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 18.457H2.9c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E9190E"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 18.697H2.9c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E91A0E"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 18.939H2.9c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E91B0E"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 19.179H2.9c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E81B0D"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 19.42H2.9c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88V21.3a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E81C0D"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 19.66H2.9c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E81D0D"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 19.9H2.9c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E71E0D"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 20.142H2.9c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E71F0D"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 20.382H2.9c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E71E0D"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 20.623H2.9c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E6210D"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 20.863H2.9c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E6220D"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 21.103H2.9c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E5230D"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 21.345H2.9c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E5240D"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 21.585H2.9c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E5250D"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 21.825H2.9c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E4260D"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 22.066H2.9c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E4270D"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 22.306H2.9c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E3280D"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 22.546H2.9c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E3290D"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 22.788H2.9c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E32A0C"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 23.028H2.9c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E22B0C"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 23.268H2.9c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E22C0C"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 23.51H2.9c-1.05 0-1.9.84-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E22D0C"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 23.75H2.9c-1.05 0-1.9.84-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E12E0C"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 23.99H2.9c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E12F0C"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 24.23H2.9c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E0300C"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.7 24.47H2.9c-1.05 0-1.9.842-1.9 1.88v2.77C1 30.158 1.85 31 2.9 31h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E0310C"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.83 24.278h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E0320C"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M5.964 24.088h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#E0330C"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M6.094 23.896h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E1340D"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M6.224 23.703h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E1350D"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M6.355 23.511h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E1360D"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M6.488 23.319h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E1370D"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M6.619 23.127h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E2380D"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M6.749 22.934h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E2390D"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M6.883 22.742h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E23A0E"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M7.013 22.55h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E23B0E"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M7.143 22.36h-2.8c-1.05 0-1.9.84-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E33C0E"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M7.277 22.167h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E33D0E"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M7.407 21.975h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E33E0E"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M7.538 21.783h-2.8c-1.05 0-1.9.841-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E33F0F"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M7.668 21.59h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E3400F"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M7.802 21.398h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E4410F"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M7.932 21.206h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E4420F"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M8.062 21.014h-2.8c-1.05 0-1.9.841-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E4430F"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M8.196 20.821h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88V22.7a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E4440F"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M8.326 20.629h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#E54510"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M8.456 20.439h-2.8c-1.05 0-1.9.841-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E54610"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M8.59 20.246h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E54710"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M8.72 20.054h-2.8c-1.049 0-1.9.841-1.9 1.88v2.77c0 1.038.851 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#E54810"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M8.85 19.862h-2.8c-1.049 0-1.9.841-1.9 1.88v2.77c0 1.037.851 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E54910"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M8.985 19.67h-2.8c-1.05 0-1.9.841-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E64A11"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M9.115 19.477h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E64B11"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M9.245 19.285h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#E64C11"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M9.375 19.093h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E64D11"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M9.51 18.9h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E74E11"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M9.64 18.708h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E74F11"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M9.77 18.516h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E75012"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M9.904 18.324h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E75112"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M10.034 18.131h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E85212"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M10.164 17.94h-2.8c-1.05 0-1.9.84-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E85312"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M10.298 17.747h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E85412"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M10.428 17.556h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E85513"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M10.559 17.364h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E85613"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M10.692 17.172h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E95713"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M10.822 16.98h-2.8c-1.049 0-1.9.841-1.9 1.88v2.77c0 1.037.851 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E95813"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M10.953 16.787h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E95913"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M11.083 16.595h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E95A13"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M11.217 16.403h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EA5A14"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M11.347 16.21h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EA5B14"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M11.477 16.018h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EA5C14"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M11.611 15.828h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EA5D14"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M11.742 15.636h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EB5E14"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M11.872 15.443h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EB5F14"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M12.002 15.251h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#EB6015"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M12.136 15.059h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EB6115"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M12.266 14.867h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.878 1.9 1.878h2.8c1.05 0 1.9-.84 1.9-1.879v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EB6215"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M12.396 14.674h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EC6315"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M12.53 14.482h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#EC6415"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M12.66 14.29h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EC6516"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M12.79 14.1h-2.8c-1.049 0-1.9.84-1.9 1.879v2.77c0 1.038.851 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EC6616"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M12.92 13.907h-2.8c-1.049 0-1.9.841-1.9 1.88v2.77c0 1.038.851 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#ED6716"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M13.055 13.715h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#ED6816"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M13.185 13.523h-2.8c-1.05 0-1.9.841-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#ED6916"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M13.315 13.33h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#ED6A16"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M13.449 13.138h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#EE6B17"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M13.58 12.946h-2.801c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EE6C17"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M13.71 12.753h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EE6D17"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M13.843 12.561h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EE6E17"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M13.974 12.369h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#EE6F17"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M14.104 12.177h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EF7018"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M14.238 11.984h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EF7118"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M14.368 11.792h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EF7218"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M14.498 11.6h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EF7318"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M14.628 11.41h-2.8c-1.05 0-1.9.84-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F07418"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M14.762 11.217h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#F07518"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M14.893 11.025h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F07619"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M15.023 10.833h-2.8c-1.05 0-1.9.841-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F07719"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M15.157 10.64h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F07819"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M15.287 10.448h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F17919"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M15.417 10.256h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F17A19"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M15.551 10.063h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F17B1A"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M15.681 9.871h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F17C1A"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M15.811 9.679h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#F27D1A"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M15.945 9.487h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F27E1A"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.076 9.296h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F27F1A"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.206 9.104h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#F2801A"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.336 8.912h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F3811B"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.47 8.72h-2.8c-1.05 0-1.9.841-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F3821B"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 8.527h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F3831B"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 8.657h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F3821C"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 8.79h-2.8c-1.05 0-1.9.84-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F3811C"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 8.92h-2.8c-1.05 0-1.9.84-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F3801D"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 9.05h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F27F1D"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 9.18h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F27E1E"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 9.31h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F27D1F"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 9.441h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#F27C1F"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 9.573h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F27B20"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 9.703h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F27A20"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 9.835h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F27921"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 9.965h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F17821"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 10.095h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F17722"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 10.226h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F17623"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 10.357h-2.8c-1.05 0-1.9.841-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F17523"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 10.488h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F17424"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 10.618h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F17324"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 10.748h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F07225"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 10.88h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F07126"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 11.01h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F07026"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 11.14h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F06F27"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 11.272h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#F06E27"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 11.402h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#F06D28"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 11.534h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F06C29"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 11.664h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EF6B29"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 11.794h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EF6A2A"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 11.926h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EF692A"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 12.056h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EF682B"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 12.188h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EF672C"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 12.318h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EF662C"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 12.448h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EF652D"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 12.578h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EE642D"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 12.71h-2.8c-1.05 0-1.9.84-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EE632E"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 12.84h-2.8c-1.05 0-1.9.841-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EE622E"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 12.971h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EE612F"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 13.101h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EE6030"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 13.231h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EE5F30"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 13.363h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EE5E31"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 13.493h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#ED5D31"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 13.625h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#ED5C32"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 13.755h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#ED5B33"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 13.885h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#ED5A33"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 14.015h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#ED5934"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 14.147h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#ED5834"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 14.279h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#ED5735"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 14.409h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EC5636"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 14.539h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EC5536"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 14.669h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EC5437"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 14.8h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EC5337"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 14.93h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EC5238"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 15.062h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EC5139"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 15.192h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EB5039"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 15.322h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EB4F3A"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 15.454h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EB4E3A"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 15.584h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EB4D3B"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 15.716h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EB4C3B"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 15.846h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EB4B3C"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 15.976h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EB4A3D"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 16.108h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EA493D"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 16.238h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#EA483E"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 16.368h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#EA473E"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 16.5h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EA463F"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 16.63h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EA4640"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 16.762h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EA4540"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 16.892h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EA4441"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 17.022h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E94341"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 17.154h-2.8c-1.05 0-1.9.841-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E94242"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 17.284h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.878 1.9 1.878h2.8c1.05 0 1.9-.84 1.9-1.879v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E94143"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 17.416h-2.8c-1.05 0-1.9.84-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E94043"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 17.545h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E93F44"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 17.675h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E93E44"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 17.805h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E93D45"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 17.937h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E83C45"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 18.067h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E83B46"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 18.2h-2.8c-1.05 0-1.9.84-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E83A47"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 18.33h-2.8c-1.05 0-1.9.84-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E83947"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 18.459h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E83848"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 18.59h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E83748"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 18.72h-2.8c-1.05 0-1.9.843-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.841 1.9-1.88V20.6a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E73649"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 18.853h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E7354A"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 18.983h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E7344A"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 19.113h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E7334B"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 19.243h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E7324B"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 19.375h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E7314C"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 19.505h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E7304D"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 19.637h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E62F4D"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 19.767h-2.8c-1.05 0-1.9.841-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E62E4E"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 19.896h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E62D4E"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 20.028h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E62C4F"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 20.158h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E62B50"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 20.29h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E62A50"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 20.42h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88V22.3a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E62951"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 20.55h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E52851"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 20.68h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E52752"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 20.812h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E52652"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 20.942h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E52553"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 21.074h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E52454"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 21.204h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E52354"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 21.334h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#E52255"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 21.466h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E42155"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 21.596h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E42056"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 21.728h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E41F57"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 21.858h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E41E57"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 21.988h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E41D58"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 22.12h-2.8c-1.05 0-1.9.841-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E41C58"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 22.25h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E41B59"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 22.38h-2.8c-1.05 0-1.9.84-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E31A5A"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 22.511h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E3195A"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 22.641h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E3185B"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 22.773h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E3175B"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 22.903h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E3165C"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 23.033h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E3155D"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 23.165h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#E2145D"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 23.295h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#E2135E"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 23.427h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E2125E"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 23.557h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E2115F"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 23.687h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E2105F"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 23.819h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E20F60"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 23.949h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E20E61"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 24.08h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E10D61"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 24.21h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E10C62"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 24.34h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E10B62"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.6 24.47h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E10A63"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.693 24.299h-2.8c-1.05 0-1.9.841-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E10A64"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.782 24.126h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E10A65"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.875 23.954h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E10A66"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M16.968 23.78h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E20A67"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M17.058 23.608h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E20A68"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M17.15 23.436h-2.8c-1.049 0-1.9.841-1.9 1.88v2.77c0 1.038.851 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#E20A69"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M17.244 23.264h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E20A6A"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M17.337 23.09h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.049 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#E20A6B"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M17.426 22.918h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E20A6C"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M17.519 22.746h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E30A6D"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M17.612 22.574h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E30A6E"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M17.701 22.4h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E30A6F"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M17.794 22.227h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E30A70"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M17.887 22.055h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E30A71"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M17.98 21.883h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E30A72"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M18.07 21.71h-2.8c-1.05 0-1.9.84-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E40A73"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M18.163 21.537h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E40A74"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M18.256 21.365h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E40A75"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M18.345 21.191h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E40A76"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M18.438 21.019h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#E40A77"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M18.53 20.847h-2.8c-1.049 0-1.9.841-1.9 1.88v2.77c0 1.037.851 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E40A78"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M18.624 20.675h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E50A79"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M18.713 20.5h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E50B7A"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M18.806 20.329h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E50B7B"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M18.9 20.157h-2.801c-1.05 0-1.9.841-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E50B7C"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M18.988 19.984h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E50B7D"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M19.081 19.812h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E50B7E"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M19.174 19.638h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E60B7F"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M19.264 19.466h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E60B80"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M19.357 19.294h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E60B81"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M19.45 19.122h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.049 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#E60B82"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M19.543 18.948h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#E60B83"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M19.632 18.776h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E60B84"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M19.725 18.604h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E70B85"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M19.818 18.432h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E70B86"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M19.907 18.26h-2.8c-1.05 0-1.9.841-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E70B87"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M20 18.086h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879H20c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E70B88"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M20.093 17.913h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E70B89"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M20.186 17.741h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E70B8A"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M20.276 17.57h-2.8c-1.05 0-1.9.84-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E70B8B"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M20.369 17.395h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E80B8C"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M20.462 17.223h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E80B8D"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M20.551 17.051h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#E80B8E"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M20.644 16.879h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E80B8F"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M20.737 16.705h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#E80B90"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M20.826 16.533h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E80B91"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M20.92 16.36h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E90B92"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M21.012 16.187h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E90B93"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M21.105 16.015h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E90B94"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M21.195 15.842h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E90B95"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M21.288 15.67h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E90B96"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M21.38 15.496h-2.8c-1.049 0-1.9.842-1.9 1.88v2.77c0 1.038.851 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E90B97"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M21.47 15.324h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EA0B98"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M21.563 15.152h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EA0B99"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M21.656 14.98h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.843 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EA0B9A"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M21.749 14.806h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EA0B9B"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M21.838 14.634h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#EA0B9C"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M21.931 14.462h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EA0B9D"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M22.024 14.29h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EB0B9E"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M22.113 14.116h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EB0B9F"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M22.206 13.944h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EB0BA0"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M22.3 13.771h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EB0BA1"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M22.392 13.6h-2.8c-1.05 0-1.9.84-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EB0BA2"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M22.482 13.425h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EB0BA3"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M22.575 13.253h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EC0BA4"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M22.668 13.081h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EC0BA5"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M22.757 12.91h-2.8c-1.05 0-1.9.84-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EC0BA6"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M22.85 12.735h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EC0BA7"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M22.943 12.563h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#EC0CA8"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M23.032 12.39h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EC0CA9"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M23.125 12.219h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EC0CAA"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M23.218 12.045h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#ED0CAB"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M23.311 11.873h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#ED0CAC"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M23.4 11.7h-2.8c-1.049 0-1.9.842-1.9 1.88v2.77c0 1.038.851 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#ED0CAD"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M23.494 11.528h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#ED0CAE"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M23.587 11.354h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#ED0CAF"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M23.676 11.182h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#ED0CB0"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M23.769 11.01h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EE0CB1"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M23.862 10.836h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EE0CB2"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M23.955 10.664h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EE0CB3"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M24.044 10.492h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#EE0CB4"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M24.137 10.32h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88V12.2a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EE0CB5"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M24.23 10.146h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EE0CB6"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M24.32 9.974h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EF0CB7"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M24.413 9.802h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EF0CB8"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M24.506 9.63h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EF0CB9"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M24.595 9.456h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EF0CBA"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M24.688 9.283h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EF0CBB"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M24.78 9.111h-2.8c-1.049 0-1.9.842-1.9 1.88v2.77c0 1.038.851 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EF0CBC"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M24.874 8.94h-2.8c-1.05 0-1.9.84-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F00CBD"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M24.963 8.765h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F00CBE"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M25.056 8.593h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F00CBF"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M25.15 8.421h-2.801c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88V10.3a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#F00CC0"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M25.238 8.249h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F00CC1"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M25.331 8.075h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F00CC2"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M25.424 7.903h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F10CC3"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M25.517 7.73h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88V9.61a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F10CC4"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M25.607 7.559h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F10CC5"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M25.7 7.385h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F10CC6"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M25.793 7.213h-2.8c-1.05 0-1.9.841-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F10CC7"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M25.882 7.04h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88V8.92a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F10CC8"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M25.975 6.868h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F10CC9"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M26.068 6.694h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F20CCA"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M26.161 6.522h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F20CCB"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M26.25 6.35h-2.8c-1.05 0-1.9.842-1.9 1.88V11c0 1.038.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88V8.23a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#F20CCC"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M26.343 6.176h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F20CCD"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M26.436 6.004h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#F20CCE"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M26.526 5.832h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F20CCF"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M26.619 5.66h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.049 0 1.9-.842 1.9-1.88V7.54a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F30CD0"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M26.712 5.486h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F30CD1"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M26.8 5.314H24c-1.049 0-1.9.841-1.9 1.88v2.77c0 1.037.851 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F30CD2"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M26.894 5.142h-2.8c-1.05 0-1.9.841-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F30CD3"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M26.987 4.97h-2.8c-1.05 0-1.9.84-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F30CD4"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M27.08 4.795h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F30DD5"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M27.17 4.623h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F40DD6"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M27.262 4.451h-2.8c-1.05 0-1.9.842-1.9 1.88V9.1c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88V6.33a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F40DD7"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M27.355 4.279h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#F40DD8"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M27.445 4.105h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F40DD9"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M27.538 3.933h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.049 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#F40DDA"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M27.63 3.76h-2.8c-1.049 0-1.9.842-1.9 1.88v2.77c0 1.038.851 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88V5.64a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F40DDB"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M27.724 3.589h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F50DDC"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M27.813 3.415h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F50DDD"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M27.906 3.243h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F50DDE"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M27.995 3.07h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88V4.95a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F50DDF"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M28.088 2.898h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F50DE0"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M28.181 2.724h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F50DE1"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M28.274 2.552h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F60DE2"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M28.367 2.38h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88V4.26a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F60DE3"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M28.456 2.208h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F60DE4"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M28.55 2.034h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F60DE5"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M28.639 1.862h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#F60DE6"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M28.732 1.69h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88V3.57a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F60DE7"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M28.825 1.518h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F70DE8"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M28.918 1.344h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.049 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F70DE9"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.007 1.172h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F70DEA"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 1h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88V2.88A1.89 1.89 0 0 0 29.1 1Z",
                                fill: "#F70DEB"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 1.263h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F60DEB"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 1.527h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F50DEB"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 1.79h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88V3.67a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F40EEC"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 2.054h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F30EEC"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 2.318h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#F20EEC"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 2.582h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F10EEC"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 2.845h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#F00FEC"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 3.109h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#EF0FED"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 3.373h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EE0FED"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 3.636h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#ED0FED"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 3.9h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88V5.78A1.89 1.89 0 0 0 29.1 3.9Z",
                                fill: "#EC10ED"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 4.164h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EB10EE"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 4.427h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#EA10EE"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 4.693h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E910EE"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 4.955h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E811EE"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 5.218h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E711EE"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 5.484h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E611EF"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 5.748h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E511EF"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 6.01h-2.8c-1.05 0-1.9.84-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E412EF"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 6.275h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#E312EF"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 6.539h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E212EF"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 6.802h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#E112F0"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 7.066h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#E013F0"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 7.33h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88V9.21a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#DF13F0"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 7.593h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#DE13F0"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 7.857h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#DD13F1"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 8.12h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88V10a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#DC14F1"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 8.384h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#DB14F1"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 8.648h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#DA14F1"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 8.912h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#D914F1"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 9.175h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#D815F2"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 9.44h-2.8c-1.05 0-1.9.84-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#D715F2"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 9.703h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#D615F2"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 9.966h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#D515F2"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 10.23h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#D416F2"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 10.494h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#D316F3"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 10.758h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#D216F3"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 11.021h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88V12.9a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#D116F3"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 11.285h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#D017F3"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 11.549h-2.8c-1.05 0-1.9.841-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#CF17F4"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 11.812h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#CE17F4"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 12.076h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#CD17F4"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 12.34h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#CC18F4"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 12.603h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#CB18F4"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 12.867h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#CB18F5"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 13.13h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#CA18F5"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 13.394h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#C919F5"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 13.658h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#C819F5"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 13.922h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#C719F5"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 14.185h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#C619F6"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 14.45h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#C51AF6"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 14.713h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#C41AF6"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 14.976h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#C31AF6"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 15.242h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#C21AF7"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 15.506h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#C11BF7"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 15.768h-2.8c-1.05 0-1.9.84-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#C01BF7"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 16.033h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#BF1BF7"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 16.297h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#BE1BF7"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 16.558h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#BD1CF8"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 16.824h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#BC1CF8"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 17.088h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#BB1CF8"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 17.351h-2.8c-1.05 0-1.9.842-1.9 1.88V22c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#BA1CF8"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 17.615h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.843 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#B91DF8"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 17.879h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#B81DF9"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 18.142h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#B71DF9"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 18.406h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#B61DF9"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 18.67h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#B51EF9"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 18.933h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#B41EFA"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 19.197h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#B31EFA"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 19.46h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#B21EFA"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 19.724h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#B11FFA"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 19.988h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#B01FFA"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 20.252h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#AF1FFB"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 20.515h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#AE1FFB"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 20.78h-2.8c-1.05 0-1.9.84-1.9 1.879v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#AD20FB"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 21.043h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#AC20FB"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 21.306h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#AB20FB"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 21.57h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#AA20FC"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 21.834h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#A921FC"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 22.098h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.878 1.9 1.878h2.8c1.05 0 1.9-.841 1.9-1.879v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#A821FC"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 22.361h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#A721FC"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 22.625h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#A621FD"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 22.889h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#A522FD"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 23.154h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#A422FD"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 23.416h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#A322FD"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 23.68h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.037.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#A222FD"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 23.945h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#A123FE"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 24.207h-2.8c-1.05 0-1.9.841-1.9 1.88v2.77c0 1.038.85 1.879 1.9 1.879h2.8c1.05 0 1.9-.841 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.879Z",
                                fill: "#A023FE"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M29.1 24.47h-2.8c-1.05 0-1.9.842-1.9 1.88v2.77c0 1.038.85 1.88 1.9 1.88h2.8c1.05 0 1.9-.842 1.9-1.88v-2.77a1.89 1.89 0 0 0-1.9-1.88Z",
                                fill: "#9F23FE"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("clipPath", {
                    id: "AutometricsColor_svg__a",
                    children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h32v32H0z"
                    })
                })
            })
        ]
    });
var $8062c0953fc81593$export$2e2bcd8739ae039 = $8062c0953fc81593$var$SvgAutometricsColor;



parcelRequire("2gcPZ");
const $608ec8e54eb7aeea$var$SvgAutometrics = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.306.905h4.69l-7.633 19.028H7.666L15.306.905Zm-7.64 4.948h4.69l-7.632 14.08H.027l7.64-14.08Z",
                fill: "currentColor",
                fillOpacity: 0.5
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.447 0c-.632 0-1.144.512-1.144 1.144v17.65c0 .632.512 1.144 1.144 1.144h2.41c.63 0 1.143-.512 1.143-1.143V1.144C20 .512 19.488 0 18.856 0h-2.41ZM7.652 6.128c0-.631.512-1.143 1.143-1.143h2.41c.632 0 1.144.512 1.144 1.143v12.667c0 .631-.512 1.143-1.144 1.143h-2.41a1.144 1.144 0 0 1-1.143-1.143V6.128ZM0 11.524c0-.632.512-1.144 1.144-1.144h2.415c.631 0 1.144.512 1.144 1.143v7.333c0 .632-.513 1.144-1.144 1.144H1.144A1.144 1.144 0 0 1 0 18.856v-7.333Z",
                fill: "currentColor"
            })
        ]
    });
var $608ec8e54eb7aeea$export$2e2bcd8739ae039 = $608ec8e54eb7aeea$var$SvgAutometrics;



parcelRequire("2gcPZ");
const $d1d81a21dd09e55c$var$SvgAutometricsLogoBlackFaded = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 43,
        height: 44,
        viewBox: "0 0 43 44",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("g", {
                clipPath: "url(#AutometricsLogoBlackFaded_svg__a)",
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                        d: "m9.185 40.963-.592 1.481c.11-.13 1.027-1.014 1.107-1.167.107-.127.2-.264.277-.414.11-.126.203-.266.28-.416.11-.13.203-.267.28-.417.106-.127.203-.267.28-.417.106-.126.2-.266.28-.416.11-.13.203-.27.283-.424.107-.126.2-.263.277-.413.106-.13.203-.267.28-.417.106-.13.2-.266.28-.416.106-.13.203-.267.28-.417.11-.13.203-.27.283-.42.107-.127.2-.267.277-.413.106-.13.2-.267.28-.417.106-.13.2-.267.28-.417.106-.13.2-.266.28-.416.11-.13.203-.27.283-.42.107-.127.2-.267.277-.414.106-.13.2-.266.28-.416.106-.13.2-.267.28-.417.106-.13.2-.27.28-.417a2.56 2.56 0 0 0 .21-.29v7.5c0 1.76 1.443 3.184 3.22 3.184h2.946c1.29 0 2.4-.75 2.914-1.834.056-.093.106-.19.153-.286.053-.09.103-.184.15-.28.053-.087.1-.177.147-.27a2.92 2.92 0 0 0 .153-.287 2.8 2.8 0 0 0 .15-.28c.057-.09.107-.183.15-.28a2.8 2.8 0 0 0 .15-.28c.057-.093.11-.19.157-.29.053-.087.1-.177.146-.27.057-.093.107-.187.154-.287.053-.09.103-.18.146-.273.057-.09.107-.187.154-.283a2.92 2.92 0 0 0 .153-.287c.053-.087.103-.18.147-.273.06-.097.113-.197.16-.297.05-.087.1-.173.14-.263.056-.094.106-.187.153-.284a3.34 3.34 0 0 0 .153-.283c.054-.09.104-.18.147-.273.057-.094.11-.19.157-.29.053-.09.103-.18.146-.277.057-.093.107-.19.154-.287.053-.09.103-.183.15-.28.053-.09.103-.18.146-.276a2.91 2.91 0 0 0 .154-.284 2.81 2.81 0 0 0 .15-.28 2.81 2.81 0 0 0 .15-.28c.056-.09.106-.186.153-.283.057-.093.11-.19.157-.29.053-.087.1-.18.146-.27.057-.09.107-.183.15-.28.057-.09.107-.183.15-.28.057-.09.107-.183.15-.28.057-.09.107-.183.15-.28.057-.09.107-.183.15-.28.057-.093.11-.19.157-.29.053-.087.1-.177.147-.27.056-.093.106-.187.153-.287a2.62 2.62 0 0 0 .147-.27 3.31 3.31 0 0 0 .153-.283 2.89 2.89 0 0 0 .153-.283c.054-.09.104-.184.15-.277.06-.097.114-.193.16-.297a4.02 4.02 0 0 0 .14-.263c.057-.09.107-.187.154-.283a2.92 2.92 0 0 0 .153-.287c.053-.087.103-.18.147-.273.056-.094.11-.19.156-.287.054-.09.104-.183.15-.277.057-.093.107-.186.154-.283.056-.09.106-.183.15-.283a2.7 2.7 0 0 0 .146-.274c.057-.093.11-.19.157-.29.053-.09.103-.18.147-.273.053-.09.103-.183.15-.277.056-.093.11-.19.156-.29.057-.09.107-.186.154-.283.026-.047.056-.09.08-.137v15.14c0 .187.02.37.056.547 0 .017.007.033.01.047.037.163.087.32.147.47.01.026.023.053.033.076.064.14.134.27.217.397a2.934 2.934 0 0 0 .34.423c.027.027.053.057.083.084.104.1.217.19.337.273l.09.06c.127.083.26.153.4.217.027.01.053.023.077.033.153.06.31.11.476.147.017 0 .03.006.047.01.18.036.367.053.557.056h3.643c.19 0 .377-.02.557-.056.016 0 .03-.007.046-.01.164-.037.324-.084.477-.147.027-.01.053-.023.077-.033a2.765 2.765 0 0 0 .493-.277 2.682 2.682 0 0 0 .42-.357c.1-.103.193-.213.277-.333l.063-.09c.083-.127.157-.257.217-.397a2.807 2.807 0 0 0 .247-1.14V3.997S33.47 2.4 33.436 2.467c-.034.066-8.437 15.976-8.48 16.07-.024.04-.05.08-.07.12V14.223c0-.186-.02-.37-.057-.546 0-.017-.007-.034-.01-.05a2.806 2.806 0 0 0-.147-.467c-.01-.027-.023-.053-.033-.08a3.051 3.051 0 0 0-.28-.487 3.243 3.243 0 0 0-.36-.416c-.103-.1-.217-.19-.337-.274l-.09-.06a2.87 2.87 0 0 0-.4-.213c-.026-.013-.053-.023-.08-.033a3.24 3.24 0 0 0-.473-.147l-.047-.01a3.018 3.018 0 0 0-.553-.057h-3.643c-.19 0-.374.02-.554.057-.016 0-.033.007-.046.01a2.88 2.88 0 0 0-.474.147c-.026.01-.053.023-.08.033-.14.06-.273.133-.4.213l-.09.06a2.94 2.94 0 0 0-.42.357c-.1.103-.193.213-.276.33-.02.03-6.807 9.753-6.864 9.837.012.166.32 1.943.308 2.24v16.296",
                        fill: "url(#AutometricsLogoBlackFaded_svg__b)",
                        fillOpacity: 0.4
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                        d: "M6.303 20.666H3.307A3.307 3.307 0 0 0 0 23.973v16.053a3.307 3.307 0 0 0 3.307 3.307h2.996a3.307 3.307 0 0 0 3.307-3.306V23.973a3.307 3.307 0 0 0-3.307-3.306Z",
                        fill: "url(#AutometricsLogoBlackFaded_svg__c)"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                        d: "M21.833 11.383h-2.996a3.307 3.307 0 0 0-3.307 3.307v25.306a3.307 3.307 0 0 0 3.307 3.307h2.996a3.307 3.307 0 0 0 3.307-3.307V14.69a3.307 3.307 0 0 0-3.307-3.307Z",
                        fill: "url(#AutometricsLogoBlackFaded_svg__d)"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                        d: "M39.36.667h-2.997a3.307 3.307 0 0 0-3.306 3.306v36.053a3.307 3.307 0 0 0 3.306 3.307h2.997a3.307 3.307 0 0 0 3.307-3.306V3.972A3.307 3.307 0 0 0 39.36.667Z",
                        fill: "url(#AutometricsLogoBlackFaded_svg__e)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("linearGradient", {
                        id: "AutometricsLogoBlackFaded_svg__b",
                        x1: 36.444,
                        y1: 3.926,
                        x2: 1.778,
                        y2: 43.333,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                stopOpacity: 0.8
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                offset: 1,
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("linearGradient", {
                        id: "AutometricsLogoBlackFaded_svg__c",
                        x1: 14.943,
                        y1: 29.009,
                        x2: 4.525,
                        y2: 46.093,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                stopColor: "#A4A4A4"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#A4A4A4",
                                stopOpacity: 0.1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("linearGradient", {
                        id: "AutometricsLogoBlackFaded_svg__d",
                        x1: 30.473,
                        y1: 23.131,
                        x2: 14.233,
                        y2: 40.138,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                stopColor: "#A4A4A4"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#A4A4A4",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("linearGradient", {
                        id: "AutometricsLogoBlackFaded_svg__e",
                        x1: 48,
                        y1: 16.37,
                        x2: 30.903,
                        y2: 31.898,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                stopColor: "#A4A4A4"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#A4A4A4",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("clipPath", {
                        id: "AutometricsLogoBlackFaded_svg__a",
                        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(0 .667)",
                            d: "M0 0h42.667v42.667H0z"
                        })
                    })
                ]
            })
        ]
    });
var $d1d81a21dd09e55c$export$2e2bcd8739ae039 = $d1d81a21dd09e55c$var$SvgAutometricsLogoBlackFaded;



parcelRequire("2gcPZ");
const $fd4a46ef6c21a767$var$SvgAutometricsLogoPurple = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("g", {
            fill: "#9027FF",
            children: [
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                    d: "M17.74 2.679A.5.5 0 0 0 17.273 2h-2.337a1 1 0 0 0-.934.642L8.394 17.268a.5.5 0 0 0 .466.679h2.687a.5.5 0 0 0 .467-.321L17.74 2.679ZM11.885 6.682H8.133l-5.315 9.843A1 1 0 0 0 3.698 18h1.783a.5.5 0 0 0 .44-.263l5.964-11.055Z",
                    fillOpacity: 0.5
                }),
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                    x: 2,
                    y: 10.304,
                    width: 3.762,
                    height: 7.696,
                    rx: 0.5
                }),
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                    x: 8.121,
                    y: 5.988,
                    width: 3.758,
                    height: 11.963,
                    rx: 0.5
                }),
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                    x: 14.242,
                    y: 2,
                    width: 3.758,
                    height: 15.951,
                    rx: 0.5
                })
            ]
        })
    });
var $fd4a46ef6c21a767$export$2e2bcd8739ae039 = $fd4a46ef6c21a767$var$SvgAutometricsLogoPurple;



parcelRequire("2gcPZ");
const $c5d3d9e4252f1c34$var$SvgAutometricsLogoType = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 104,
        height: 14,
        viewBox: "0 0 104 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M10.397 12.994h2.076L7.893.476H5.438L.943 12.994h1.99l.979-2.73h5.524l.961 2.73ZM4.461 8.735l.823-2.3 1.201-3.933h.395l1.2 3.932.807 2.301H4.461ZM22.146 3.962h-1.819V8.77c0 1.717-.91 2.884-2.505 2.884-1.167 0-1.921-.67-1.921-2.06V3.962h-1.82v6.181c0 1.803.996 3.022 2.918 3.022 1.338 0 2.47-.686 2.968-1.837h.377l.24 1.666h1.562V3.962ZM27.274 11.517V5.455h2.265V3.962h-2.265V1.008h-1.801v2.954H23.74v1.493h1.733v6.062c0 .876.394 1.477 1.527 1.477h2.728v-1.477h-2.454ZM30.907 8.478c0 2.885 1.647 4.688 4.272 4.688 2.71 0 4.272-1.872 4.272-4.688 0-3.005-1.767-4.688-4.272-4.688-2.557 0-4.273 1.751-4.273 4.688Zm1.853.738V7.808c0-1.528.995-2.507 2.419-2.507 1.407 0 2.419.962 2.419 2.507v1.408c0 1.597-1.047 2.456-2.42 2.456-1.337 0-2.418-.842-2.418-2.456ZM41.68 12.994h1.82V8.1c0-1.683.875-2.8 2.179-2.8 1.2 0 1.835.774 1.835 2.37v5.324h1.82v-4.86c0-1.683.737-2.833 2.11-2.833 1.166 0 1.887.567 1.887 2.215v5.478h1.819V6.949c0-2.18-1.15-3.16-2.934-3.16-1.27 0-2.334.722-2.814 1.924h-.378c-.309-1.22-1.32-1.923-2.522-1.923-1.184 0-2.213.687-2.642 1.854h-.36l-.24-1.682h-1.58v9.032ZM57.246 8.46c0 2.868 1.682 4.705 4.324 4.705 2.093 0 3.723-1.167 4.049-2.936h-1.767c-.223.91-1.098 1.528-2.282 1.528-1.476 0-2.47-.961-2.47-2.37v-.514h6.433c.052-.292.069-.687.069-1.014 0-2.575-1.664-4.07-4.067-4.07-2.556 0-4.289 1.718-4.289 4.671Zm1.853-.824V7.38c0-1.288.995-2.164 2.42-2.164 1.355 0 2.281.841 2.281 2.095v.326h-4.7ZM70 11.517V5.455h2.266V3.962H70V1.008h-1.802v2.954h-1.733v1.493H68.2v6.062c0 .876.395 1.477 1.527 1.477h2.728v-1.477h-2.453ZM79.704 3.91c-1.184 0-2.214.67-2.608 1.872h-.344l-.24-1.82h-3.26v1.493h1.665v7.539h1.818V8.632c0-2.009 1.287-3.056 3.003-3.056.189 0 .412.017.618.051V3.962a3.454 3.454 0 0 0-.652-.052ZM82.179 2.485h1.801V.355H82.18v2.13Zm0 10.509h1.801V3.962H82.18v9.032ZM94.47 9.851h-1.751c-.171 1.116-1.03 1.82-2.213 1.82-1.476 0-2.437-.978-2.437-2.42V7.841c0-1.494.995-2.541 2.42-2.541 1.098 0 1.956.55 2.196 1.7h1.75c-.172-1.94-1.716-3.211-3.895-3.211-2.556 0-4.324 1.768-4.324 4.705 0 2.799 1.613 4.67 4.29 4.67 2.213 0 3.74-1.304 3.963-3.314ZM97.752 10.212h-1.733c-.017 1.82 1.441 2.954 3.758 2.954 2.247 0 3.723-1.082 3.723-2.851 0-1.202-.687-2.164-2.419-2.473l-1.716-.292c-.48-.085-1.356-.24-1.356-1.167 0-.756.584-1.237 1.716-1.237 1.047 0 1.767.43 1.802 1.46h1.681c.017-1.734-1.218-2.816-3.534-2.816-2.11 0-3.5 1.047-3.5 2.764 0 1.202.737 2.13 2.487 2.439l1.836.343c.395.069 1.115.24 1.115 1.134 0 .841-.686 1.339-1.835 1.339-1.236 0-2.025-.601-2.025-1.597Z",
            fill: "currentColor"
        })
    });
var $c5d3d9e4252f1c34$export$2e2bcd8739ae039 = $c5d3d9e4252f1c34$var$SvgAutometricsLogoType;



parcelRequire("2gcPZ");
const $795abbf13d040043$var$SvgBehanceLogo = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M12.5 6.25a.625.625 0 0 1 .625-.625h5a.625.625 0 1 1 0 1.25h-5a.625.625 0 0 1-.625-.625Zm6.875 5.625a.624.624 0 0 1-.625.625h-5.547a2.507 2.507 0 0 0 3.38 1.686 2.46 2.46 0 0 0 .808-.545.625.625 0 0 1 .882.882 3.704 3.704 0 0 1-2.648 1.102 3.75 3.75 0 1 1 3.75-3.75Zm-1.328-.625a2.5 2.5 0 0 0-4.844 0h4.844Zm-7.11 1.094a3.281 3.281 0 0 1-3.28 3.281H2.5A.625.625 0 0 1 1.875 15V5a.625.625 0 0 1 .625-.625h4.219a2.969 2.969 0 0 1 2.21 4.945 3.281 3.281 0 0 1 2.008 3.024ZM3.125 9.063h3.594a1.719 1.719 0 1 0 0-3.438H3.125v3.438Zm6.563 3.28a2.04 2.04 0 0 0-2.032-2.03H3.125v4.062h4.531a2.04 2.04 0 0 0 2.032-2.031Z",
            fill: "currentColor"
        })
    });
var $795abbf13d040043$export$2e2bcd8739ae039 = $795abbf13d040043$var$SvgBehanceLogo;



parcelRequire("2gcPZ");
const $b2acbc88fd251d87$var$SvgBell = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M17.25 13.742c-.461-.797-1.016-2.312-1.016-4.992v-.555c0-3.46-2.773-6.297-6.187-6.32H10a6.242 6.242 0 0 0-6.234 6.25v.625c0 2.68-.555 4.195-1.016 4.992a1.25 1.25 0 0 0 1.078 1.883h3.047a3.125 3.125 0 1 0 6.25 0h3.047a1.241 1.241 0 0 0 1.25-1.255 1.265 1.265 0 0 0-.172-.628ZM10 17.5a1.883 1.883 0 0 1-1.875-1.875h3.75A1.884 1.884 0 0 1 10 17.5Z",
            fill: "currentColor"
        })
    });
var $b2acbc88fd251d87$export$2e2bcd8739ae039 = $b2acbc88fd251d87$var$SvgBell;



parcelRequire("2gcPZ");
const $72485eb7105eb3d7$var$SvgBellNew = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 21,
        height: 21,
        viewBox: "0 0 21 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M17.25 14.742c-.46-.797-1.015-2.312-1.015-4.992v-.555c0-3.46-2.774-6.297-6.188-6.32H10a6.242 6.242 0 0 0-6.234 6.25v.625c0 2.68-.555 4.195-1.016 4.992a1.25 1.25 0 0 0 1.078 1.883h3.047a3.125 3.125 0 1 0 6.25 0h3.047a1.242 1.242 0 0 0 1.25-1.255 1.265 1.265 0 0 0-.172-.628ZM10 18.5a1.883 1.883 0 0 1-1.875-1.875h3.75A1.883 1.883 0 0 1 10 18.5Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("circle", {
                cx: 16,
                cy: 5,
                r: 4.333,
                fill: "#F41900",
                stroke: "#fff",
                strokeWidth: 0.667
            })
        ]
    });
var $72485eb7105eb3d7$export$2e2bcd8739ae039 = $72485eb7105eb3d7$var$SvgBellNew;



parcelRequire("2gcPZ");
const $80c7369ab17e9ed1$var$SvgBoltDuotone = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                opacity: 0.2,
                d: "M4 11.571 11.002 4l-.004 5.429H16L8.999 17v-5.429H4Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.366 3.069a1 1 0 0 1 .636.932l-.003 4.428H16a1 1 0 0 1 .734 1.678L9.733 17.68A1 1 0 0 1 7.999 17v-4.429H4a1 1 0 0 1-.734-1.678l7.001-7.572a1 1 0 0 1 1.1-.252Zm-5.08 7.502H9a1 1 0 0 1 1 1v2.875l3.714-4.017H11a1 1 0 0 1-1-1.001L10 6.556 6.287 10.57Z",
                fill: "currentColor"
            })
        ]
    });
var $80c7369ab17e9ed1$export$2e2bcd8739ae039 = $80c7369ab17e9ed1$var$SvgBoltDuotone;



parcelRequire("2gcPZ");
const $25d4103349b29feb$var$SvgBook = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.875 2.5V15a.624.624 0 0 1-.625.625H5.625a1.25 1.25 0 0 0-1.25 1.25H15a.624.624 0 1 1 0 1.25H3.75a.625.625 0 0 1-.625-.625V4.375a2.508 2.508 0 0 1 2.5-2.5H16.25a.625.625 0 0 1 .625.625Z",
            fill: "currentColor"
        })
    });
var $25d4103349b29feb$export$2e2bcd8739ae039 = $25d4103349b29feb$var$SvgBook;



parcelRequire("2gcPZ");
const $fef72c11fe8da75e$var$SvgBookOpen = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M7.5 16.25a1.883 1.883 0 0 1 1.875 1.875.625.625 0 1 0 1.25 0A1.884 1.884 0 0 1 12.5 16.25h5A1.25 1.25 0 0 0 18.75 15V5a1.25 1.25 0 0 0-1.25-1.25h-3.75a3.125 3.125 0 0 0-3.125 3.125v6.25a.624.624 0 1 1-1.25 0v-6.25A3.125 3.125 0 0 0 6.25 3.75H2.5A1.25 1.25 0 0 0 1.25 5v10a1.25 1.25 0 0 0 1.25 1.25h5Z",
            fill: "currentColor"
        })
    });
var $fef72c11fe8da75e$export$2e2bcd8739ae039 = $fef72c11fe8da75e$var$SvgBookOpen;



parcelRequire("2gcPZ");
const $553eefcffed4707d$var$SvgBracketsAngle = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M6.774 3.461 2.617 10l4.157 6.54a.617.617 0 0 1-.188.858.617.617 0 0 1-.86-.188l-4.374-6.874a.618.618 0 0 1 0-.672L5.727 2.79a.625.625 0 1 1 1.047.672Zm11.874 6.203L14.274 2.79a.625.625 0 1 0-1.047.672L17.383 10l-4.156 6.54a.618.618 0 0 0 .187.858.617.617 0 0 0 .86-.188l4.374-6.874a.618.618 0 0 0 0-.672Z",
            fill: "currentColor"
        })
    });
var $553eefcffed4707d$export$2e2bcd8739ae039 = $553eefcffed4707d$var$SvgBracketsAngle;



parcelRequire("2gcPZ");
const $1598d5d00f35534e$var$SvgBracketsCurly = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M3.375 10c.264.22.477.494.625.805.375.773.375 1.718.375 2.633 0 1.898.078 2.812 1.875 2.812a.625.625 0 1 1 0 1.25c-1.367 0-2.29-.477-2.75-1.43-.375-.773-.375-1.718-.375-2.633 0-1.898-.078-2.812-1.875-2.812a.625.625 0 1 1 0-1.25c1.797 0 1.875-.914 1.875-2.813 0-.914 0-1.859.375-2.632.46-.953 1.383-1.43 2.75-1.43a.625.625 0 0 1 0 1.25c-1.797 0-1.875.914-1.875 2.813 0 .914 0 1.859-.375 2.632-.148.31-.36.585-.625.805Zm15.375-.625c-1.797 0-1.875-.914-1.875-2.813 0-.914 0-1.859-.375-2.632-.46-.953-1.383-1.43-2.75-1.43a.625.625 0 1 0 0 1.25c1.797 0 1.875.914 1.875 2.813 0 .914 0 1.859.375 2.632.148.31.36.585.625.805-.264.22-.477.494-.625.805-.375.773-.375 1.718-.375 2.633 0 1.898-.078 2.812-1.875 2.812a.624.624 0 1 0 0 1.25c1.367 0 2.29-.477 2.75-1.43.375-.773.375-1.718.375-2.633 0-1.898.078-2.812 1.875-2.812a.624.624 0 1 0 0-1.25Z",
            fill: "currentColor"
        })
    });
var $1598d5d00f35534e$export$2e2bcd8739ae039 = $1598d5d00f35534e$var$SvgBracketsCurly;



parcelRequire("2gcPZ");
const $934777f3b7658f2c$var$SvgBracketsRound = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M3.125 10c0 4.555 2.71 6.273 2.828 6.344a.625.625 0 0 1-.648 1.07c-.14-.086-3.43-2.117-3.43-7.414s3.29-7.328 3.43-7.414a.633.633 0 0 1 .86.219.625.625 0 0 1-.22.851c-.125.078-2.82 1.797-2.82 6.344Zm11.57-7.414a.626.626 0 1 0-.648 1.07c.117.07 2.828 1.79 2.828 6.344 0 4.555-2.71 6.273-2.82 6.336a.625.625 0 0 0 .32 1.164.68.68 0 0 0 .32-.086c.14-.086 3.43-2.117 3.43-7.414s-3.29-7.328-3.43-7.414Z",
            fill: "currentColor"
        })
    });
var $934777f3b7658f2c$export$2e2bcd8739ae039 = $934777f3b7658f2c$var$SvgBracketsRound;



parcelRequire("2gcPZ");
const $9e3a4c91e7f8b302$var$SvgBracketsSquare = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M3.75 3.75v12.5h2.5a.625.625 0 1 1 0 1.25H3.125a.625.625 0 0 1-.625-.625V3.125a.625.625 0 0 1 .625-.625H6.25a.625.625 0 0 1 0 1.25h-2.5ZM16.875 2.5H13.75a.625.625 0 1 0 0 1.25h2.5v12.5h-2.5a.624.624 0 1 0 0 1.25h3.125a.624.624 0 0 0 .625-.625V3.125a.625.625 0 0 0-.625-.625Z",
            fill: "currentColor"
        })
    });
var $9e3a4c91e7f8b302$export$2e2bcd8739ae039 = $9e3a4c91e7f8b302$var$SvgBracketsSquare;



parcelRequire("2gcPZ");
const $250188d81791352d$var$SvgBugBeetle = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M3.938 2.64a.625.625 0 0 1 .859-.906l1.46 1.391a6.234 6.234 0 0 1 7.477-.008l1.454-1.383a.625.625 0 0 1 1.014.23.617.617 0 0 1-.155.677l-1.39 1.32A6.22 6.22 0 0 1 16.218 7.5H3.78a6.242 6.242 0 0 1 1.555-3.531L3.937 2.64ZM2.5 7.5a.625.625 0 0 0 0 1.25h1.25V7.5H2.5Zm13.75 4.375c.002.209-.009.417-.031.625H17.5a.625.625 0 1 1 0 1.25h-1.54a6.25 6.25 0 0 1-11.92 0H2.5a.625.625 0 0 1 0-1.25h1.281a5.492 5.492 0 0 1-.031-.625v-.625H2.5a.625.625 0 0 1 0-1.25h1.25V8.75h12.5V10h1.25a.625.625 0 1 1 0 1.25h-1.25v.625Zm-5.625-1.25a.625.625 0 1 0-1.25 0v5a.625.625 0 0 0 1.25 0v-5Zm7.5-2.5A.625.625 0 0 0 17.5 7.5h-1.25v1.25h1.25a.625.625 0 0 0 .625-.625Z",
            fill: "currentColor"
        })
    });
var $250188d81791352d$export$2e2bcd8739ae039 = $250188d81791352d$var$SvgBugBeetle;



parcelRequire("2gcPZ");
const $abc31113dd05b220$var$SvgBugDroid = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "m14.945 3.672 1.102-1.024a.64.64 0 0 0 .031-.89.625.625 0 0 0-.883-.031l-1.203 1.125a6.852 6.852 0 0 0-8 0L4.797 1.727a.627.627 0 0 0-.852.921l1.102 1.024a6.828 6.828 0 0 0-1.93 4.765v3.126a6.875 6.875 0 0 0 13.75 0V8.437a6.852 6.852 0 0 0-1.922-4.765Zm-4.953-.86a5.633 5.633 0 0 1 5.625 5.625v.938H4.367v-.938a5.633 5.633 0 0 1 5.625-5.625Zm1.25 4.375a.938.938 0 1 1 1.875 0 .938.938 0 0 1-1.875 0Zm-4.375 0a.938.938 0 1 1 1.875 0 .938.938 0 0 1-1.875 0Z",
            fill: "currentColor"
        })
    });
var $abc31113dd05b220$export$2e2bcd8739ae039 = $abc31113dd05b220$var$SvgBugDroid;



parcelRequire("2gcPZ");
const $b2a203e9c663fd89$var$SvgBug = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M13.117 7.188a.938.938 0 1 1-1.875 0 .938.938 0 0 1 1.875 0ZM7.805 6.25a.938.938 0 1 0 0 1.875.938.938 0 0 0 0-1.875ZM19.688 10a.625.625 0 0 1-.625.625h-2.188v.625a6.884 6.884 0 0 1-.25 1.852l1.805 1.046a.624.624 0 0 1-.625 1.079l-1.633-.946a6.874 6.874 0 0 1-12.344 0l-1.633.946a.593.593 0 0 1-.312.085.625.625 0 0 1-.313-1.163l1.805-1.047a6.883 6.883 0 0 1-.25-1.852v-.625H.937a.625.625 0 1 1 0-1.25h2.188V8.75a6.883 6.883 0 0 1 .25-1.852L1.57 5.852A.625.625 0 0 1 1.336 5a.633.633 0 0 1 .86-.227l1.632.946a6.875 6.875 0 0 1 12.344 0l1.633-.946a.633.633 0 0 1 .86.227.625.625 0 0 1-.235.852l-1.805 1.046c.167.603.251 1.226.25 1.852v.625h2.188a.625.625 0 0 1 .625.625Zm-9.063 1.25a.625.625 0 1 0-1.25 0v5a.625.625 0 0 0 1.25 0v-5Zm5-2.5a5.625 5.625 0 1 0-11.25 0v.625h11.25V8.75Z",
            fill: "currentColor"
        })
    });
var $b2a203e9c663fd89$export$2e2bcd8739ae039 = $b2a203e9c663fd89$var$SvgBug;



parcelRequire("2gcPZ");
const $2f624e11e324b3ac$var$SvgCalendarBlank = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.25 2.5h-1.875v-.625a.625.625 0 1 0-1.25 0V2.5h-6.25v-.625a.625.625 0 0 0-1.25 0V2.5H3.75A1.25 1.25 0 0 0 2.5 3.75v12.5a1.25 1.25 0 0 0 1.25 1.25h12.5a1.25 1.25 0 0 0 1.25-1.25V3.75a1.25 1.25 0 0 0-1.25-1.25Zm0 3.75H3.75v-2.5h1.875v.625a.625.625 0 0 0 1.25 0V3.75h6.25v.625a.625.625 0 1 0 1.25 0V3.75h1.875v2.5Z",
            fill: "currentColor"
        })
    });
var $2f624e11e324b3ac$export$2e2bcd8739ae039 = $2f624e11e324b3ac$var$SvgCalendarBlank;



parcelRequire("2gcPZ");
const $d25d6a32a20e3e35$var$SvgCalendarCheck = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.25 2.5h-1.875v-.625a.625.625 0 1 0-1.25 0V2.5h-6.25v-.625a.625.625 0 0 0-1.25 0V2.5H3.75A1.25 1.25 0 0 0 2.5 3.75v12.5a1.25 1.25 0 0 0 1.25 1.25h12.5a1.25 1.25 0 0 0 1.25-1.25V3.75a1.25 1.25 0 0 0-1.25-1.25Zm-3.008 7.953-3.648 3.438a.602.602 0 0 1-.43.171.617.617 0 0 1-.43-.171l-1.976-1.875a.625.625 0 1 1 .86-.907l1.546 1.47 3.219-3.032a.616.616 0 0 1 .883.023.625.625 0 0 1-.024.883ZM16.25 6.25H3.75v-2.5h1.875v.625a.625.625 0 0 0 1.25 0V3.75h6.25v.625a.625.625 0 1 0 1.25 0V3.75h1.875v2.5Z",
            fill: "currentColor"
        })
    });
var $d25d6a32a20e3e35$export$2e2bcd8739ae039 = $d25d6a32a20e3e35$var$SvgCalendarCheck;



parcelRequire("2gcPZ");
const $c08c58265cff0573$var$SvgCalendarPlus = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.25 2.5h-1.875v-.625a.625.625 0 1 0-1.25 0V2.5h-6.25v-.625a.625.625 0 0 0-1.25 0V2.5H3.75A1.25 1.25 0 0 0 2.5 3.75v12.5a1.25 1.25 0 0 0 1.25 1.25h12.5a1.25 1.25 0 0 0 1.25-1.25V3.75a1.25 1.25 0 0 0-1.25-1.25Zm-4.063 10h-1.562v1.563a.624.624 0 1 1-1.25 0V12.5H7.812a.625.625 0 1 1 0-1.25h1.563V9.687a.625.625 0 0 1 1.25 0v1.563h1.563a.624.624 0 1 1 0 1.25Zm4.063-6.25H3.75v-2.5h1.875v.625a.625.625 0 0 0 1.25 0V3.75h6.25v.625a.625.625 0 1 0 1.25 0V3.75h1.875v2.5Z",
            fill: "currentColor"
        })
    });
var $c08c58265cff0573$export$2e2bcd8739ae039 = $c08c58265cff0573$var$SvgCalendarPlus;



parcelRequire("2gcPZ");
const $a8032c80ac25a88d$var$SvgCalendarX = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.25 2.5h-1.875v-.625a.625.625 0 1 0-1.25 0V2.5h-6.25v-.625a.625.625 0 0 0-1.25 0V2.5H3.75A1.25 1.25 0 0 0 2.5 3.75v12.5a1.25 1.25 0 0 0 1.25 1.25h12.5a1.25 1.25 0 0 0 1.25-1.25V3.75a1.25 1.25 0 0 0-1.25-1.25Zm-3.93 10.805a.633.633 0 0 1 0 .89.664.664 0 0 1-.445.18.648.648 0 0 1-.445-.18L10 12.758l-1.43 1.437a.664.664 0 0 1-.445.18.648.648 0 0 1-.445-.18.633.633 0 0 1 0-.89l1.437-1.43-1.437-1.43a.633.633 0 0 1 .89-.89L10 10.992l1.43-1.437a.633.633 0 0 1 .89.89l-1.437 1.43 1.437 1.43Zm3.93-7.055H3.75v-2.5h1.875v.625a.625.625 0 0 0 1.25 0V3.75h6.25v.625a.625.625 0 1 0 1.25 0V3.75h1.875v2.5Z",
            fill: "currentColor"
        })
    });
var $a8032c80ac25a88d$export$2e2bcd8739ae039 = $a8032c80ac25a88d$var$SvgCalendarX;



parcelRequire("2gcPZ");
const $d065009456d28f4d$var$SvgCallGraph = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                opacity: 0.2,
                d: "M5.625 8.75v2.5a.625.625 0 0 1-.625.625H2.5a.625.625 0 0 1-.625-.625v-2.5a.625.625 0 0 1 .625-.625H5a.625.625 0 0 1 .625.625Zm11.25-5.625h-3.75a.625.625 0 0 0-.625.625V7.5a.625.625 0 0 0 .625.625h3.75A.625.625 0 0 0 17.5 7.5V3.75a.625.625 0 0 0-.625-.625Zm0 8.75h-3.75a.624.624 0 0 0-.625.625v3.75a.624.624 0 0 0 .625.625h3.75a.624.624 0 0 0 .625-.625V12.5a.624.624 0 0 0-.625-.625Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M13.125 8.75h3.75a1.25 1.25 0 0 0 1.25-1.25V3.75a1.25 1.25 0 0 0-1.25-1.25h-3.75a1.25 1.25 0 0 0-1.25 1.25V5h-.625a2.5 2.5 0 0 0-2.5 2.5v1.875h-2.5V8.75A1.25 1.25 0 0 0 5 7.5H2.5a1.25 1.25 0 0 0-1.25 1.25v2.5A1.25 1.25 0 0 0 2.5 12.5H5a1.25 1.25 0 0 0 1.25-1.25v-.625h2.5V12.5a2.5 2.5 0 0 0 2.5 2.5h.625v1.25a1.25 1.25 0 0 0 1.25 1.25h3.75a1.25 1.25 0 0 0 1.25-1.25V12.5a1.25 1.25 0 0 0-1.25-1.25h-3.75a1.25 1.25 0 0 0-1.25 1.25v1.25h-.625A1.25 1.25 0 0 1 10 12.5v-5a1.25 1.25 0 0 1 1.25-1.25h.625V7.5a1.25 1.25 0 0 0 1.25 1.25ZM5 11.25H2.5v-2.5H5v2.5Zm8.125 1.25h3.75v3.75h-3.75V12.5Zm0-8.75h3.75V7.5h-3.75V3.75Z",
                fill: "currentColor"
            })
        ]
    });
var $d065009456d28f4d$export$2e2bcd8739ae039 = $d065009456d28f4d$var$SvgCallGraph;



parcelRequire("2gcPZ");
const $07c635228cbb53b8$var$SvgCaretDoubleDown = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.25 10 10 16.25 3.75 10M16.25 3.75 10 10 3.75 3.75",
            stroke: "currentColor",
            strokeWidth: 1.25,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
var $07c635228cbb53b8$export$2e2bcd8739ae039 = $07c635228cbb53b8$var$SvgCaretDoubleDown;



parcelRequire("2gcPZ");
const $64325b6b4c054085$var$SvgCaretDouble = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "m9.995 18 3.344-6H6.65l3.346 6ZM9.995 2l3.344 6H6.65l3.346-6Z",
            fill: "currentColor"
        })
    });
var $64325b6b4c054085$export$2e2bcd8739ae039 = $64325b6b4c054085$var$SvgCaretDouble;



parcelRequire("2gcPZ");
const $9e8e14d6d02edc73$var$SvgCaretDoubleLeft = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M15.625 16.25 9.375 10l6.25-6.25M9.375 16.25 3.125 10l6.25-6.25",
            stroke: "currentColor",
            strokeWidth: 1.25,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
var $9e8e14d6d02edc73$export$2e2bcd8739ae039 = $9e8e14d6d02edc73$var$SvgCaretDoubleLeft;



parcelRequire("2gcPZ");
const $920f917645114abc$var$SvgCaretDoubleRight = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "m4.375 3.75 6.25 6.25-6.25 6.25M10.625 3.75l6.25 6.25-6.25 6.25",
            stroke: "currentColor",
            strokeWidth: 1.25,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
var $920f917645114abc$export$2e2bcd8739ae039 = $920f917645114abc$var$SvgCaretDoubleRight;



parcelRequire("2gcPZ");
const $8bee966903657d10$var$SvgCaretDoubleUp = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M3.75 16.25 10 10l6.25 6.25M3.75 10 10 3.75 16.25 10",
            stroke: "currentColor",
            strokeWidth: 1.25,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
var $8bee966903657d10$export$2e2bcd8739ae039 = $8bee966903657d10$var$SvgCaretDoubleUp;



parcelRequire("2gcPZ");
const $1de437b217c45fa7$var$SvgCaretDown = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M14.972 9.738C15.67 9.141 15.246 8 14.33 8a.988.988 0 0 0-.593.198L10 11 6.263 8.198A.988.988 0 0 0 5.671 8c-.918 0-1.34 1.141-.643 1.738L10 14l4.972-4.262Z",
            fill: "currentColor"
        })
    });
var $1de437b217c45fa7$export$2e2bcd8739ae039 = $1de437b217c45fa7$var$SvgCaretDown;



parcelRequire("2gcPZ");
const $0e9abb1ac58eb6eb$var$SvgCaretLeft = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M10.262 14.972c.597.697 1.738.274 1.738-.643a.988.988 0 0 0-.198-.593L9 10l2.802-3.737A.988.988 0 0 0 12 5.671c0-.918-1.141-1.34-1.738-.643L6 10l4.262 4.972Z",
            fill: "currentColor"
        })
    });
var $0e9abb1ac58eb6eb$export$2e2bcd8739ae039 = $0e9abb1ac58eb6eb$var$SvgCaretLeft;



parcelRequire("2gcPZ");
const $ab7095f8ab49f723$var$SvgCaretRight = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M9.738 14.972C9.141 15.67 8 15.246 8 14.33c0-.213.07-.421.198-.593L11 10 8.198 6.263A.988.988 0 0 1 8 5.671c0-.918 1.141-1.34 1.738-.643L14 10l-4.262 4.972Z",
            fill: "currentColor"
        })
    });
var $ab7095f8ab49f723$export$2e2bcd8739ae039 = $ab7095f8ab49f723$var$SvgCaretRight;



parcelRequire("2gcPZ");
const $8d3fb75789d1dde1$var$SvgCaretUp = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M14.972 11.262c.697.597.274 1.738-.643 1.738a.988.988 0 0 1-.593-.198L10 10l-3.737 2.802a.988.988 0 0 1-.592.198c-.918 0-1.34-1.141-.643-1.738L10 7l4.972 4.262Z",
            fill: "currentColor"
        })
    });
var $8d3fb75789d1dde1$export$2e2bcd8739ae039 = $8d3fb75789d1dde1$var$SvgCaretUp;



parcelRequire("2gcPZ");
const $8afff172ab51f57c$var$SvgChartBarHorizontal = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.875 7.5H13.75V4.375a.625.625 0 0 0-.625-.625H3.75v-.625a.625.625 0 0 0-1.25 0v13.75a.625.625 0 1 0 1.25 0v-.625h6.875a.624.624 0 0 0 .625-.625V12.5h5.625a.624.624 0 0 0 .625-.625v-3.75a.625.625 0 0 0-.625-.625ZM12.5 5v2.5H3.75V5h8.75ZM10 15H3.75v-2.5H10V15Z",
            fill: "currentColor"
        })
    });
var $8afff172ab51f57c$export$2e2bcd8739ae039 = $8afff172ab51f57c$var$SvgChartBarHorizontal;



parcelRequire("2gcPZ");
const $5e9691f5f7865779$var$SvgChartBar = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M17.813 15.625h-.625v-12.5a.625.625 0 0 0-.625-.625h-4.375a.625.625 0 0 0-.626.625V6.25h-3.75a.625.625 0 0 0-.625.625V10h-3.75a.625.625 0 0 0-.624.625v5h-.626a.625.625 0 1 0 0 1.25h15.626a.624.624 0 1 0 0-1.25ZM8.438 7.5h3.124v8.125H8.438V7.5Zm-4.376 3.75h3.125v4.375H4.063V11.25Z",
            fill: "currentColor"
        })
    });
var $5e9691f5f7865779$export$2e2bcd8739ae039 = $5e9691f5f7865779$var$SvgChartBar;



parcelRequire("2gcPZ");
const $b3e84e3263dbeb89$var$SvgChartLine = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M17.5 15.625H3.125v-2.844L7.531 8.93l4.594 3.445a.625.625 0 0 0 .79-.031l5-4.375a.625.625 0 0 0-.83-.938l-4.616 4.04-4.594-3.446a.625.625 0 0 0-.79.031l-3.96 3.469V3.75a.625.625 0 0 0-1.25 0v12.5a.625.625 0 0 0 .625.625h15a.624.624 0 1 0 0-1.25Z",
            fill: "currentColor"
        })
    });
var $b3e84e3263dbeb89$export$2e2bcd8739ae039 = $b3e84e3263dbeb89$var$SvgChartLine;



parcelRequire("2gcPZ");
const $1c9b87d40c98d2fc$var$SvgChartLineUp = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M18.125 16.25a.624.624 0 0 1-.625.625h-15a.625.625 0 0 1-.625-.625V3.75a.625.625 0 0 1 1.25 0v8.492l3.93-3.937a.633.633 0 0 1 .89 0L10 10.367l3.805-3.805-1.125-1.117a.656.656 0 0 1-.133-.687.632.632 0 0 1 .578-.383h3.125a.625.625 0 0 1 .625.625v3.125a.625.625 0 0 1-.625.625.648.648 0 0 1-.445-.18l-1.117-1.125-4.243 4.25a.633.633 0 0 1-.89 0L7.5 9.633l-4.375 4.375v1.617H17.5a.624.624 0 0 1 .625.625Z",
            fill: "currentColor"
        })
    });
var $1c9b87d40c98d2fc$export$2e2bcd8739ae039 = $1c9b87d40c98d2fc$var$SvgChartLineUp;



parcelRequire("2gcPZ");
const $88ef12e494389612$var$SvgChartPie = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M17.055 5.969a.062.062 0 0 1-.016-.032l-.031-.039a8.125 8.125 0 0 0-14.063 8.133l.016.031.023.032a8.125 8.125 0 0 0 14.07-8.125Zm-1.438.07-4.992 2.875V3.156a6.89 6.89 0 0 1 4.992 2.883ZM10 16.875a6.875 6.875 0 0 1-5.617-2.914l11.86-6.844A6.876 6.876 0 0 1 10 16.875Z",
            fill: "currentColor"
        })
    });
var $88ef12e494389612$export$2e2bcd8739ae039 = $88ef12e494389612$var$SvgChartPie;



parcelRequire("2gcPZ");
const $c983fc41cb015479$var$SvgChartPieSlice = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M7.813 9.102a.633.633 0 0 0 .312-.547V2.93a.625.625 0 0 0-.836-.594 8.148 8.148 0 0 0-5.281 9.148.633.633 0 0 0 .617.516c.11 0 .218-.03.313-.086l4.874-2.812Zm-.938-5.227v4.32L3.133 10.36c-.008-.125-.008-.242-.008-.359a6.899 6.899 0 0 1 3.75-6.125Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M17.055 5.969a.062.062 0 0 1-.016-.032l-.031-.039A8.117 8.117 0 0 0 10 1.875a.625.625 0 0 0-.625.625v7.14l-6.18 3.57a.617.617 0 0 0-.234.852v.016l.023.04A8.125 8.125 0 0 0 18.124 10a8.086 8.086 0 0 0-1.07-4.031Z",
                fill: "currentColor"
            })
        ]
    });
var $c983fc41cb015479$export$2e2bcd8739ae039 = $c983fc41cb015479$var$SvgChartPieSlice;



parcelRequire("2gcPZ");
const $f523f03e0d5b29ce$var$SvgChatCircleDots = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M10 1.875a8.125 8.125 0 0 0-7.125 12.031l-.664 2.336a1.258 1.258 0 0 0 .313 1.235 1.235 1.235 0 0 0 1.226.312l2.344-.664A8.125 8.125 0 1 0 10 1.875Zm-3.75 9.063a.938.938 0 1 1 0-1.876.938.938 0 0 1 0 1.876Zm3.75 0a.938.938 0 1 1 0-1.876.938.938 0 0 1 0 1.876Zm3.75 0a.938.938 0 1 1 0-1.876.938.938 0 0 1 0 1.876Z",
            fill: "currentColor"
        })
    });
var $f523f03e0d5b29ce$export$2e2bcd8739ae039 = $f523f03e0d5b29ce$var$SvgChatCircleDots;



parcelRequire("2gcPZ");
const $16f8a2531c71a1c0$var$SvgChatCircle = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M10 1.875a8.125 8.125 0 0 0-7.125 12.031l-.664 2.344a1.242 1.242 0 0 0 1.54 1.54l2.343-.665A8.125 8.125 0 1 0 10 1.875Z",
            fill: "currentColor"
        })
    });
var $16f8a2531c71a1c0$export$2e2bcd8739ae039 = $16f8a2531c71a1c0$var$SvgChatCircle;



parcelRequire("2gcPZ");
const $760144b730bd2966$var$SvgChatsCircle = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M18.008 14.828a6.25 6.25 0 0 0-4.758-9.156 6.25 6.25 0 1 0-11.258 5.406l-.484 1.688a1.086 1.086 0 0 0 1.351 1.351l1.688-.484a6.312 6.312 0 0 0 2.203.695 6.25 6.25 0 0 0 8.703 3.055l1.688.484a1.086 1.086 0 0 0 1.351-1.351l-.484-1.688Zm-1.203-.398a.593.593 0 0 0-.07.484l.484 1.68-1.68-.485a.594.594 0 0 0-.484.07 5.017 5.017 0 0 1-6.907-1.835 6.266 6.266 0 0 0 5.602-6.219 6.53 6.53 0 0 0-.102-1.117 5 5 0 0 1 3.852 4.867 5.063 5.063 0 0 1-.695 2.555Z",
            fill: "currentColor"
        })
    });
var $760144b730bd2966$export$2e2bcd8739ae039 = $760144b730bd2966$var$SvgChatsCircle;



parcelRequire("2gcPZ");
const $82e3cd2dc3367131$var$SvgCheckboxDuotone = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                opacity: 0.2,
                fill: "currentColor",
                d: "M3 3h14v14H3z"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2 4v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Zm14 0H4v12h12V4Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M10.124 12.28h.001L8.947 13.46 5 9.512l1.178-1.179 2.768 2.768 5.267-5.268 1.179 1.179-5.268 5.267Z",
                fill: "currentColor"
            })
        ]
    });
var $82e3cd2dc3367131$export$2e2bcd8739ae039 = $82e3cd2dc3367131$var$SvgCheckboxDuotone;



parcelRequire("2gcPZ");
const $d8a3b0ea7f88ae57$var$SvgCheckCircle = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M10 1.875A8.125 8.125 0 1 0 18.125 10 8.14 8.14 0 0 0 10 1.875Zm3.867 6.703L9.29 12.953a.633.633 0 0 1-.867 0l-2.29-2.187a.625.625 0 1 1 .86-.907l1.86 1.774 4.156-3.961a.625.625 0 0 1 .86.906Z",
            fill: "currentColor"
        })
    });
var $d8a3b0ea7f88ae57$export$2e2bcd8739ae039 = $d8a3b0ea7f88ae57$var$SvgCheckCircle;



parcelRequire("2gcPZ");
const $86b647e4e5ff8593$var$SvgCheck = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "m9.917 12.608.002.001L8.558 14 4 9.342 5.36 7.95l3.197 3.266L14.639 5 16 6.39l-6.083 6.218Z",
            fill: "currentColor"
        })
    });
var $86b647e4e5ff8593$export$2e2bcd8739ae039 = $86b647e4e5ff8593$var$SvgCheck;



parcelRequire("2gcPZ");
const $d0e64ff380be9ce1$var$SvgCheckSquare = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.25 2.5H3.75A1.25 1.25 0 0 0 2.5 3.75v12.5a1.25 1.25 0 0 0 1.25 1.25h12.5a1.25 1.25 0 0 0 1.25-1.25V3.75a1.25 1.25 0 0 0-1.25-1.25Zm-2.383 6.078L9.29 12.953a.633.633 0 0 1-.867 0l-2.29-2.187a.625.625 0 1 1 .86-.907l1.86 1.774 4.156-3.961a.625.625 0 0 1 .86.906Z",
            fill: "currentColor"
        })
    });
var $d0e64ff380be9ce1$export$2e2bcd8739ae039 = $d0e64ff380be9ce1$var$SvgCheckSquare;



parcelRequire("2gcPZ");
const $6d11b906dfbb5ceb$var$SvgClockClockwise = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M10.625 6.25v3.39l2.937 1.696a.625.625 0 0 1-.312 1.164.555.555 0 0 1-.313-.086l-3.25-1.875h-.015l-.031-.016-.024-.023-.023-.016-.024-.023-.015-.016c-.016-.008-.024-.023-.032-.03l-.015-.017-.016-.03-.016-.024-.015-.024a.039.039 0 0 1-.016-.031l-.015-.023c0-.008-.008-.016-.008-.032a.032.032 0 0 1-.008-.023l-.016-.031a.031.031 0 0 0-.007-.024c0-.015 0-.023-.008-.031v-.031c0-.016-.008-.024-.008-.031V6.25a.625.625 0 0 1 1.25 0Zm7.125-2.164a.625.625 0 0 0-.68.14l-1.117 1.118-.648-.649a7.5 7.5 0 1 0 0 10.61.625.625 0 0 0-.883-.883 6.25 6.25 0 1 1 0-8.844l.648.649-1.125 1.125a.625.625 0 0 0 .445 1.062h3.125a.625.625 0 0 0 .625-.625V4.664a.64.64 0 0 0-.39-.578Z",
            fill: "currentColor"
        })
    });
var $6d11b906dfbb5ceb$export$2e2bcd8739ae039 = $6d11b906dfbb5ceb$var$SvgClockClockwise;



parcelRequire("2gcPZ");
const $0535e97fded80d17$var$SvgClockCounterClockwise = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M10.625 6.25v3.39l2.938 1.696a.625.625 0 0 1-.313 1.164.554.554 0 0 1-.313-.086l-3.25-1.875h-.015l-.031-.016-.024-.023-.023-.016-.024-.023-.015-.016c-.016-.008-.024-.023-.032-.031l-.015-.016-.016-.03-.015-.024-.016-.024a.039.039 0 0 1-.016-.031l-.015-.023c0-.008-.008-.016-.008-.032a.031.031 0 0 1-.008-.023l-.016-.031a.032.032 0 0 0-.007-.024c0-.015 0-.023-.008-.031v-.031c0-.016-.008-.024-.008-.031V6.25a.625.625 0 0 1 1.25 0Zm4.68-1.555a7.516 7.516 0 0 0-10.61 0l-.648.649L2.93 4.227a.625.625 0 0 0-.68-.141.64.64 0 0 0-.39.578v3.125a.625.625 0 0 0 .624.625H5.61a.625.625 0 0 0 .446-1.062L4.93 6.227l.648-.649a6.25 6.25 0 1 1 0 8.844.616.616 0 0 0-.883 0 .625.625 0 0 0 0 .883 7.502 7.502 0 0 0 10.61-10.61Z",
            fill: "currentColor"
        })
    });
var $0535e97fded80d17$export$2e2bcd8739ae039 = $0535e97fded80d17$var$SvgClockCounterClockwise;



parcelRequire("2gcPZ");
const $31e7c9394123792a$var$SvgClock = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M10 1.875A8.125 8.125 0 1 0 18.125 10 8.14 8.14 0 0 0 10 1.875Zm4.375 8.75H10A.625.625 0 0 1 9.375 10V5.625a.625.625 0 0 1 1.25 0v3.75h3.75a.625.625 0 1 1 0 1.25Z",
            fill: "currentColor"
        })
    });
var $31e7c9394123792a$export$2e2bcd8739ae039 = $31e7c9394123792a$var$SvgClock;



parcelRequire("2gcPZ");
const $59d8568b50e6ef8d$var$SvgX = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M14.95 6.464 13.536 5.05 10 8.586 6.464 5.05 5.05 6.464 8.586 10 5.05 13.536l1.414 1.414L10 11.414l3.536 3.536 1.414-1.414L11.414 10l3.536-3.536Z",
            fill: "currentColor"
        })
    });
var $59d8568b50e6ef8d$export$2e2bcd8739ae039 = $59d8568b50e6ef8d$var$SvgX;



parcelRequire("2gcPZ");
const $25fd7544a6d53b85$var$SvgCloudwatchColor = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 28,
        height: 28,
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("g", {
                clipPath: "url(#CloudwatchColor_svg__a)",
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                        d: "M28 0H0v28h28V0Z",
                        fill: "url(#CloudwatchColor_svg__b)"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                        d: "M11.76 17.92H7.653a2.28 2.28 0 0 1-1.172-.35 3.8 3.8 0 0 1-1.814-3.32 3.394 3.394 0 0 1 2.426-3.423v-.291a5.115 5.115 0 0 1 2.92-4.51 4.898 4.898 0 0 1 5.521 1.093 5.619 5.619 0 0 1 1.12 1.643 2.188 2.188 0 0 1 1.374-.485c1.016 0 2.158.769 2.367 2.456.96.228 2.93 1.012 2.93 3.55a3.36 3.36 0 0 1-1.765 3.133l-.373-.653a2.643 2.643 0 0 0 1.381-2.48c0-2.194-1.818-2.74-2.613-2.874a.374.374 0 0 1-.243-.157.373.373 0 0 1-.064-.269c-.108-1.355-.9-1.96-1.642-1.96a1.493 1.493 0 0 0-1.206.631.373.373 0 0 1-.355.15.373.373 0 0 1-.295-.247 5.076 5.076 0 0 0-1.172-1.911 4.166 4.166 0 0 0-4.67-.926 4.39 4.39 0 0 0-2.468 3.808c0 .172.01.344.03.515a.373.373 0 0 1-.303.415A2.703 2.703 0 0 0 5.41 14.25a3.035 3.035 0 0 0 1.467 2.688c.232.149.5.23.776.235h4.107v.747Z",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                        d: "m22.919 20.16-2.65-2.662a3.961 3.961 0 1 0-1.815 1.915l2.613 2.614c.25.243.585.377.933.373a1.299 1.299 0 0 0 .93-.373 1.312 1.312 0 0 0-.011-1.867Zm-6.268-1.056a3.207 3.207 0 1 1 0-6.414 3.207 3.207 0 0 1 0 6.414Zm5.749 2.381a.586.586 0 0 1-.806 0L19.107 19c.304-.238.57-.52.792-.836l2.501 2.516a.575.575 0 0 1 0 .806Z",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                        d: "m17.677 14.16-.444.602a1.26 1.26 0 0 0-1.994 1.194 1.232 1.232 0 0 0 .497.844l-.43.582a2.004 2.004 0 0 1 2.386-3.222h-.015Z",
                        fill: "#fff"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("linearGradient", {
                        id: "CloudwatchColor_svg__b",
                        x1: -5.798,
                        y1: 33.798,
                        x2: 33.798,
                        y2: -5.798,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                stopColor: "#B0084D"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF4F8B"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("clipPath", {
                        id: "CloudwatchColor_svg__a",
                        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                            width: 28,
                            height: 28,
                            rx: 14,
                            fill: "#fff"
                        })
                    })
                ]
            })
        ]
    });
var $25fd7544a6d53b85$export$2e2bcd8739ae039 = $25fd7544a6d53b85$var$SvgCloudwatchColor;



parcelRequire("2gcPZ");
const $9ccfd95909d73f8c$var$SvgCloudwatch = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M17.96 10.137c-.183-1.198-.953-2.145-2.06-2.532-.265-.093-.372-.207-.454-.488-.306-1.036-1.015-1.643-1.996-1.71a1.843 1.843 0 0 0-.108-.004c-.294 0-.58.077-.856.152a6.153 6.153 0 0 1-.195.052C11.24 3.987 9.97 3.2 8.418 3.2c-.318 0-.653.034-.996.102-.797.157-1.514.559-2.13 1.192-.827.848-1.268 1.885-1.316 3.084-1.583.833-2.16 1.947-1.926 3.692.088.65.428 1.32.932 1.836.555.567 1.24.879 1.928.879l9.32-.01h.006c.247 0 1.507-.022 2.127-.468l.157-.102c.107-.066.206-.13.303-.202.876-.652 1.322-1.855 1.137-3.067v.001Zm-3.724 3.547h.003-.003Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M8.266 11.624c.004-1.641 1.318-3.105 2.9-3.227 1.82-.141 3.384 1.023 3.597 2.737.061.49-.016 1.009-.1 1.503-.046.264-.032.428.167.618a79.69 79.69 0 0 1 1.774 1.773c.533.544.582 1.216.137 1.68-.469.488-1.145.455-1.716-.1-.514-.499-1.038-.991-1.515-1.524-.313-.35-.602-.418-1.06-.287-2.155.62-4.19-.94-4.184-3.173Zm3.281 2.619c1.44-.005 2.569-1.126 2.57-2.553.002-1.444-1.156-2.619-2.582-2.618-1.38 0-2.619 1.231-2.597 2.578.024 1.455 1.171 2.597 2.61 2.594v-.001Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M11.547 14.244c-1.437.004-2.586-1.138-2.61-2.595-.02-1.346 1.219-2.576 2.598-2.577 1.426 0 2.584 1.173 2.582 2.618-.002 1.427-1.13 2.55-2.57 2.553ZM13.928 14.025l.006-.005a.394.394 0 0 1 .519.024c.561.54 1.16 1.108 1.732 1.703.04.041.048.113.044.197a.39.39 0 0 1-.363.366c-.123.01-.235.006-.298-.051-.572-.524-1.114-1.081-1.675-1.65a.395.395 0 0 1 .035-.585v.001Z",
                fill: "#000"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M12.3 10.168a.385.385 0 0 0-.215-.255 1.692 1.692 0 0 0-2.111.594c-.457.66-.414 1.515.103 2.082.076.084.179.13.288.13.127 0 .248-.06.324-.159a.375.375 0 0 0 .065-.33c-.02-.078-.065-.159-.11-.26-.293-.66-.179-.782.031-1.026s.431-.37.668-.37c.085 0 .175.008.268.023a.869.869 0 0 1 .164.048.398.398 0 0 0 .522-.475l.003-.002Zm-1.614 2.08a.385.385 0 0 0-.013-.043l.013.042Zm-.319.398-.013-.001h.017-.004Zm1.002-2.813h.011l.033.003-.043-.001-.001-.002Zm.549.762h-.005.014l-.01.001Zm.138-.615Zm.123.483Z",
                fill: "currentColor"
            })
        ]
    });
var $9ccfd95909d73f8c$export$2e2bcd8739ae039 = $9ccfd95909d73f8c$var$SvgCloudwatch;



parcelRequire("2gcPZ");
const $765d6f6fa2824e44$var$SvgCodeDuotone = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                opacity: 0.2,
                x: 2,
                y: 2,
                width: 16,
                height: 16,
                rx: 2,
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M4 4h9v2H4V4ZM4 7h12v2H4V7ZM6 10H4v2h2v-2ZM15 10H7v2h8v-2ZM10 15v-2H4v2h6ZM16 4h-2v2h2V4Z",
                fill: "currentColor"
            })
        ]
    });
var $765d6f6fa2824e44$export$2e2bcd8739ae039 = $765d6f6fa2824e44$var$SvgCodeDuotone;



parcelRequire("2gcPZ");
const $9c52aa319eae5403$var$SvgCode = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M5.476 6.477a.61.61 0 0 0-.875-.079L.851 9.523a.617.617 0 0 0 0 .954l3.75 3.124a.61.61 0 0 0 .875-.078.61.61 0 0 0-.078-.875L2.226 10l3.172-2.648a.61.61 0 0 0 .078-.875ZM19.148 9.523l-3.75-3.125a.625.625 0 0 0-.796.954L17.773 10l-3.171 2.648A.625.625 0 0 0 15 13.75a.602.602 0 0 0 .398-.149l3.75-3.125a.617.617 0 0 0 0-.953ZM12.71 2.539a.617.617 0 0 0-.796.375l-5 13.75a.617.617 0 0 0 .375.797.617.617 0 0 0 .797-.375l5-13.75a.618.618 0 0 0-.375-.797Z",
            fill: "currentColor"
        })
    });
var $9c52aa319eae5403$export$2e2bcd8739ae039 = $9c52aa319eae5403$var$SvgCode;



parcelRequire("2gcPZ");
const $f42bac1a71a72c24$var$SvgCodepenLogo = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M18.75 7.89v5a.626.626 0 0 1-.32.547l-7.336 4.165a.314.314 0 0 1-.469-.274v-4.46l4.36-2.477 2.515 1.43V8.96l-2.516 1.43-1.265-.72 3.14-1.78-6.234-3.54v3.563l3.094 1.758L10 11.782l-3.719-2.11 3.094-1.758V4.352L3.141 7.89l3.14 1.78-1.265.72L2.5 8.96v2.86l2.516-1.43 4.359 2.476v4.461a.313.313 0 0 1-.469.274L1.57 13.437a.625.625 0 0 1-.32-.546v-5a.625.625 0 0 1 .32-.547l7.813-4.43a1.242 1.242 0 0 1 1.234 0l7.813 4.43a.625.625 0 0 1 .32.547Z",
            fill: "currentColor"
        })
    });
var $f42bac1a71a72c24$export$2e2bcd8739ae039 = $f42bac1a71a72c24$var$SvgCodepenLogo;



parcelRequire("2gcPZ");
const $b82b5ad4f5bf8027$var$SvgCodesandboxLogo = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M18.125 9.906V6.148a1.219 1.219 0 0 0-.164-.617h-.008a1.21 1.21 0 0 0-.469-.46L10.61 1.202a1.25 1.25 0 0 0-1.218 0L2.516 5.07a1.265 1.265 0 0 0-.471.467.008.008 0 0 1-.006.002v.016c-.107.18-.163.384-.164.593V13.852a1.258 1.258 0 0 0 .64 1.093l3.438 1.93 3.438 1.938c.173.094.365.147.562.156h.102c.194-.009.384-.062.554-.157l3.438-1.937 3.437-1.93a1.257 1.257 0 0 0 .641-1.093V9.906Zm-11.57 1.578-3.43-1.937V6.844l6.32 3.523-.062 7.008-2.508-1.414v-3.938a.617.617 0 0 0-.32-.539ZM6.172 4.43l3.523 1.976a.586.586 0 0 0 .61 0l3.523-1.976 2.399 1.351-6.157 3.5-6.289-3.5 2.39-1.351Zm4.523 5.937 6.18-3.515v2.695l-3.43 1.937a.616.616 0 0 0-.32.54v3.937l-2.492 1.406.062-7Z",
            fill: "currentColor"
        })
    });
var $b82b5ad4f5bf8027$export$2e2bcd8739ae039 = $b82b5ad4f5bf8027$var$SvgCodesandboxLogo;



parcelRequire("2gcPZ");
const $ff903588c6b87cbd$var$SvgCodeSimple = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M7.344 4.586a.625.625 0 0 0-.883-.055l-5.625 5a.625.625 0 0 0 0 .938l5.625 5a.633.633 0 0 0 .77.046.625.625 0 0 0 .058-.984L2.188 10l5.101-4.531a.625.625 0 0 0 .055-.883ZM19.164 9.531l-5.625-5a.625.625 0 1 0-.828.938l5.102 4.53-5.102 4.532a.625.625 0 1 0 .828.938l5.625-5a.625.625 0 0 0 0-.938Z",
            fill: "currentColor"
        })
    });
var $ff903588c6b87cbd$export$2e2bcd8739ae039 = $ff903588c6b87cbd$var$SvgCodeSimple;



parcelRequire("2gcPZ");
const $f6fda72197f85523$var$SvgCombined = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.157 3.794a.5.5 0 0 0-.916.011l-2.805 6.64-1.139-2.331a.5.5 0 0 0-.894-.008l-4.43 8.666a.5.5 0 0 0 .445.728h15.168a.5.5 0 0 0 .455-.706l-5.884-13Zm-.76 12.706h5.414L11.716 5.247 9.02 11.635l2.378 4.865Zm-2.894-3.643 1.78 3.643h-3.32l1.54-3.643Zm-.583-1.191L5.878 16.5H3.235l3.603-7.049 1.082 2.215Z",
            fill: "currentColor"
        })
    });
var $f6fda72197f85523$export$2e2bcd8739ae039 = $f6fda72197f85523$var$SvgCombined;



parcelRequire("2gcPZ");
const $c030951c691687fc$var$SvgCommand = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M14.063 11.25H12.5v-2.5h1.563a2.812 2.812 0 1 0-2.813-2.813V7.5h-2.5V5.937A2.812 2.812 0 1 0 5.937 8.75H7.5v2.5H5.937a2.813 2.813 0 1 0 2.813 2.813V12.5h2.5v1.563a2.813 2.813 0 1 0 2.813-2.813ZM12.5 5.937A1.562 1.562 0 1 1 14.063 7.5H12.5V5.937Zm-8.125 0a1.562 1.562 0 1 1 3.125 0V7.5H5.937a1.57 1.57 0 0 1-1.562-1.563ZM7.5 14.063A1.563 1.563 0 1 1 5.937 12.5H7.5v1.563ZM8.75 8.75h2.5v2.5h-2.5v-2.5Zm5.313 6.875a1.57 1.57 0 0 1-1.563-1.563V12.5h1.563a1.563 1.563 0 0 1 0 3.125Z",
            fill: "currentColor"
        })
    });
var $c030951c691687fc$export$2e2bcd8739ae039 = $c030951c691687fc$var$SvgCommand;



parcelRequire("2gcPZ");
const $43060a13336fe1a4$var$SvgCopy = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.875 2.5h-10a.625.625 0 0 0-.625.625V6.25H3.125a.625.625 0 0 0-.625.625v10a.625.625 0 0 0 .625.625h10a.624.624 0 0 0 .625-.625V13.75h3.125a.624.624 0 0 0 .625-.625v-10a.625.625 0 0 0-.625-.625Zm-.625 10h-2.5V6.875a.625.625 0 0 0-.625-.625H7.5v-2.5h8.75v8.75Z",
            fill: "currentColor"
        })
    });
var $43060a13336fe1a4$export$2e2bcd8739ae039 = $43060a13336fe1a4$var$SvgCopy;



parcelRequire("2gcPZ");
const $f165988b2568be0e$var$SvgCpu = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M18.125 11.25h-1.25v-2.5h1.25a.625.625 0 1 0 0-1.25h-1.25V4.375a1.25 1.25 0 0 0-1.25-1.25H12.5v-1.25a.625.625 0 1 0-1.25 0v1.25h-2.5v-1.25a.625.625 0 0 0-1.25 0v1.25H4.375a1.25 1.25 0 0 0-1.25 1.25V7.5h-1.25a.625.625 0 0 0 0 1.25h1.25v2.5h-1.25a.625.625 0 1 0 0 1.25h1.25v3.125a1.25 1.25 0 0 0 1.25 1.25H7.5v1.25a.625.625 0 1 0 1.25 0v-1.25h2.5v1.25a.624.624 0 1 0 1.25 0v-1.25h3.125a1.25 1.25 0 0 0 1.25-1.25V12.5h1.25a.624.624 0 1 0 0-1.25Zm-5.313.938a.624.624 0 0 1-.624.624H7.811a.625.625 0 0 1-.625-.624V7.811a.625.625 0 0 1 .625-.625h4.375a.625.625 0 0 1 .626.625v4.375Zm-4.374-3.75h3.124v3.124H8.438V8.438Z",
            fill: "currentColor"
        })
    });
var $f165988b2568be0e$export$2e2bcd8739ae039 = $f165988b2568be0e$var$SvgCpu;



parcelRequire("2gcPZ");
const $bfa96e7370d20f96$var$SvgDashboardDuotone = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                opacity: 0.2,
                fill: "currentColor",
                d: "M4 4h12v12H4z"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M4 15.998h11.998a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-1.998A2 2 0 0 1 2 14V6a2 2 0 0 1 2-2v11.998ZM18 14V6a2 2 0 0 0-1.997-2 2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2H16v12a2 2 0 0 0 2-2Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M10 4h2v5h-2V4ZM8 11h2v5H8v-5ZM16 9v2H4V9h12Z",
                fill: "currentColor"
            })
        ]
    });
var $bfa96e7370d20f96$export$2e2bcd8739ae039 = $bfa96e7370d20f96$var$SvgDashboardDuotone;



parcelRequire("2gcPZ");
const $b388717dfa81d7ce$var$SvgDatabase = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M10 1.875c-4.203 0-7.5 1.922-7.5 4.375v7.5c0 2.453 3.297 4.375 7.5 4.375 4.203 0 7.5-1.922 7.5-4.375v-7.5c0-2.453-3.297-4.375-7.5-4.375ZM16.25 10c0 .75-.617 1.516-1.688 2.102-1.21.664-2.828 1.023-4.562 1.023-1.734 0-3.352-.36-4.563-1.023C4.367 11.516 3.75 10.75 3.75 10V8.703c1.336 1.164 3.61 1.922 6.25 1.922s4.914-.758 6.25-1.922V10Zm-1.688 5.852c-1.21.664-2.828 1.023-4.562 1.023-1.734 0-3.352-.36-4.563-1.023-1.07-.586-1.687-1.352-1.687-2.102v-1.297c1.336 1.164 3.61 1.922 6.25 1.922s4.914-.758 6.25-1.922v1.297c0 .75-.617 1.516-1.688 2.102Z",
            fill: "currentColor"
        })
    });
var $b388717dfa81d7ce$export$2e2bcd8739ae039 = $b388717dfa81d7ce$var$SvgDatabase;



parcelRequire("2gcPZ");
const $10260b7679a2ca43$var$SvgDesktop = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.25 3.125H3.75A1.883 1.883 0 0 0 1.875 5v8.75a1.883 1.883 0 0 0 1.875 1.875h5.625v1.25H7.5a.625.625 0 1 0 0 1.25h5a.624.624 0 1 0 0-1.25h-1.875v-1.25h5.625a1.884 1.884 0 0 0 1.875-1.875V5a1.883 1.883 0 0 0-1.875-1.875Zm0 11.25H3.75a.625.625 0 0 1-.625-.625V12.5h13.75v1.25a.624.624 0 0 1-.625.625Z",
            fill: "currentColor"
        })
    });
var $10260b7679a2ca43$export$2e2bcd8739ae039 = $10260b7679a2ca43$var$SvgDesktop;



parcelRequire("2gcPZ");
const $5c411603f5f68af9$var$SvgDeviceMobile = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M13.75 1.25h-7.5a1.883 1.883 0 0 0-1.875 1.875v13.75A1.883 1.883 0 0 0 6.25 18.75h7.5a1.884 1.884 0 0 0 1.875-1.875V3.125A1.883 1.883 0 0 0 13.75 1.25ZM6.25 2.5h7.5a.625.625 0 0 1 .625.625v.625h-8.75v-.625A.625.625 0 0 1 6.25 2.5Zm7.5 15h-7.5a.625.625 0 0 1-.625-.625v-.625h8.75v.625a.624.624 0 0 1-.625.625Z",
            fill: "currentColor"
        })
    });
var $5c411603f5f68af9$export$2e2bcd8739ae039 = $5c411603f5f68af9$var$SvgDeviceMobile;



parcelRequire("2gcPZ");
const $fa263f4b0143261f$var$SvgDiscordLogo = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "m19.32 13.266-2.656-8.844a1.218 1.218 0 0 0-.719-.797H15.9l.046-.016a15.033 15.033 0 0 0-2.695-.796.625.625 0 0 0-.734.492.616.616 0 0 0 .484.734c.352.07.695.156 1.031.25a.624.624 0 0 1-.28 1.18h-.063A14.485 14.485 0 0 0 10 5a14.203 14.203 0 0 0-3.601.453.625.625 0 0 1-.438-1.164h.008c.336-.094.68-.18 1.031-.25a.625.625 0 0 0 .492-.734.633.633 0 0 0-.734-.492c-.925.184-1.83.456-2.703.812a1.219 1.219 0 0 0-.719.797L.68 13.266a1.25 1.25 0 0 0 .383 1.304c.071.07.147.135.226.196h.008c1.266 1.03 2.93 1.82 4.805 2.273a.492.492 0 0 0 .148.023.625.625 0 0 0 .149-1.234 12.525 12.525 0 0 1-2.446-.867.625.625 0 0 1 .672-1.031C6.11 14.586 7.977 15 10 15c2.024 0 3.89-.414 5.375-1.07a.625.625 0 0 1 .672 1.031c-.783.373-1.602.663-2.445.867a.626.626 0 0 0 .148 1.235c.05 0 .1-.009.149-.024 1.875-.453 3.539-1.242 4.804-2.273h.008c.08-.061.155-.126.227-.196a1.25 1.25 0 0 0 .382-1.304ZM7.5 12.187a.938.938 0 1 1 0-1.875.938.938 0 0 1 0 1.876Zm5 0a.938.938 0 1 1 0-1.875.938.938 0 0 1 0 1.876Z",
            fill: "currentColor"
        })
    });
var $fa263f4b0143261f$export$2e2bcd8739ae039 = $fa263f4b0143261f$var$SvgDiscordLogo;



parcelRequire("2gcPZ");
const $b6b2c068cb8bafe2$var$SvgDivider = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4 3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3Zm-2.625 7c0-.345.28-.625.625-.625h16a.625.625 0 1 1 0 1.25H2A.625.625 0 0 1 1.375 10ZM5 13a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1H5Z",
            fill: "currentColor"
        })
    });
var $b6b2c068cb8bafe2$export$2e2bcd8739ae039 = $b6b2c068cb8bafe2$var$SvgDivider;



parcelRequire("2gcPZ");
const $033fbd1cd8d734fe$var$SvgDocumentationDuotone = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                opacity: 0.2,
                d: "M16 2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4V2h12Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M13 6H8v2h5V6Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16 2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Zm0 14V4H6v12h10Z",
                fill: "currentColor"
            })
        ]
    });
var $033fbd1cd8d734fe$export$2e2bcd8739ae039 = $033fbd1cd8d734fe$var$SvgDocumentationDuotone;



parcelRequire("2gcPZ");
const $fdb05b62c4a56c1e$var$SvgDotsSixVertical = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M8.125 4.688a.937.937 0 1 1-1.875 0 .937.937 0 0 1 1.875 0Zm4.688.937a.937.937 0 1 0 0-1.874.937.937 0 0 0 0 1.874ZM7.186 9.063a.937.937 0 1 0 0 1.874.937.937 0 0 0 0-1.874Zm5.625 0a.937.937 0 1 0 0 1.874.937.937 0 0 0 0-1.874Zm-5.624 5.312a.938.938 0 1 0 0 1.875.938.938 0 0 0 0-1.875Zm5.625 0a.937.937 0 1 0 0 1.875.937.937 0 0 0 0-1.875Z",
            fill: "currentColor"
        })
    });
var $fdb05b62c4a56c1e$export$2e2bcd8739ae039 = $fdb05b62c4a56c1e$var$SvgDotsSixVertical;



parcelRequire("2gcPZ");
const $60ef8aebd8e8b3b2$var$SvgDoubleArrow = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M6.25 7.5 10 3.75l3.75 3.75M13.75 12.5 10 16.25 6.25 12.5",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
var $60ef8aebd8e8b3b2$export$2e2bcd8739ae039 = $60ef8aebd8e8b3b2$var$SvgDoubleArrow;



parcelRequire("2gcPZ");
const $c4959f5556bebe2a$var$SvgDownload = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M5.805 6.695a.633.633 0 0 1 .89-.89l2.68 2.687V1.875a.625.625 0 0 1 1.25 0v6.617l2.68-2.687a.633.633 0 0 1 .89.89l-3.75 3.75a.64.64 0 0 1-.89 0l-3.75-3.75Zm12.945 3.93v5a1.25 1.25 0 0 1-1.25 1.25h-15a1.25 1.25 0 0 1-1.25-1.25v-5a1.25 1.25 0 0 1 1.25-1.25h4.094a.281.281 0 0 1 .218.094l1.86 1.86a1.883 1.883 0 0 0 2.656 0l1.86-1.86a.281.281 0 0 1 .218-.094H17.5a1.25 1.25 0 0 1 1.25 1.25Zm-3.125 2.5a.937.937 0 1 0-1.875 0 .937.937 0 0 0 1.875 0Z",
            fill: "currentColor"
        })
    });
var $c4959f5556bebe2a$export$2e2bcd8739ae039 = $c4959f5556bebe2a$var$SvgDownload;



parcelRequire("2gcPZ");
const $6d20db3542142d67$var$SvgDribbbleLogo = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M7.29 2.883a.313.313 0 0 1 .062-.563 8.102 8.102 0 0 1 6.921.774.313.313 0 0 1 .086.46 12.196 12.196 0 0 1-3.273 2.891 13.203 13.203 0 0 0-3.797-3.562ZM9.968 7.03a12.047 12.047 0 0 0-4.375-3.664.336.336 0 0 0-.32.024A8.21 8.21 0 0 0 2.28 7.46a.313.313 0 0 0 .235.398 11.805 11.805 0 0 0 7.453-.828Zm8.11 2.086a8.125 8.125 0 0 0-2.282-4.805.32.32 0 0 0-.469.024 13.148 13.148 0 0 1-3.57 3.156c.428.743.784 1.525 1.062 2.336a13.07 13.07 0 0 1 4.914-.367.312.312 0 0 0 .344-.344Zm-4.915 1.914a13.206 13.206 0 0 1 .024 5.883.313.313 0 0 0 .445.352 8.133 8.133 0 0 0 4.422-6.188.312.312 0 0 0-.274-.351 11.81 11.81 0 0 0-4.617.305Zm-1.539-.812a11.14 11.14 0 0 0-.969-2.125 13.062 13.062 0 0 1-8.383.992.313.313 0 0 0-.375.281 8.102 8.102 0 0 0 2.555 6.563.305.305 0 0 0 .477-.07 13.187 13.187 0 0 1 6.695-5.641Zm-5.71 6.437a.312.312 0 0 0 .116.43A8.039 8.039 0 0 0 10 18.125c.474.002.948-.04 1.414-.125a.298.298 0 0 0 .234-.203c.406-1.212.611-2.48.61-3.758 0-.88-.098-1.758-.29-2.617a11.969 11.969 0 0 0-6.054 5.234Z",
            fill: "currentColor"
        })
    });
var $6d20db3542142d67$export$2e2bcd8739ae039 = $6d20db3542142d67$var$SvgDribbbleLogo;



parcelRequire("2gcPZ");
const $c7d5650b8e5e8c4a$var$SvgDuplicateDuotone = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                opacity: 0.2,
                x: 5,
                y: 3,
                width: 12,
                height: 12,
                rx: 2,
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M4 18a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2v13.001h13a2 2 0 0 1-2 2L4 18Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M12 6h-2v2H8v2h2v2h2v-2h2V8h-2V6Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7 3a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H7Zm8 2H7v8h8V5Z",
                fill: "currentColor"
            })
        ]
    });
var $c7d5650b8e5e8c4a$export$2e2bcd8739ae039 = $c7d5650b8e5e8c4a$var$SvgDuplicateDuotone;



parcelRequire("2gcPZ");
const $c67c8630fb9ade47$var$SvgEditDuotone = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                opacity: 0.2,
                fill: "currentColor",
                d: "M4 6h10v10H4z"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M3.999 4h6V2l-6-.001a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2l12 .001a2 2 0 0 0 2-2V9h-2v7h-12V4ZM14.9 3.414l.707-.707a1 1 0 1 1 1.414 1.414l-.707.707-1.415-1.414Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "m15.607 5.536-7.223 7.222-2.677 1.263 1.263-2.677 7.222-7.223 1.415 1.415Z",
                fill: "currentColor"
            })
        ]
    });
var $c67c8630fb9ade47$export$2e2bcd8739ae039 = $c67c8630fb9ade47$var$SvgEditDuotone;



parcelRequire("2gcPZ");
const $24ed665473663122$var$SvgEdit = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M3.999 4h6V2h-6a2 2 0 0 0-2 1.999v12a2 2 0 0 0 2 2l12 .001a2 2 0 0 0 2-2V9h-2v7h-12V4ZM14.9 3.414l.707-.707a1 1 0 1 1 1.414 1.414l-.707.707-1.415-1.414Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "m15.607 5.536-7.223 7.222-2.677 1.263 1.263-2.677 7.222-7.223 1.415 1.415Z",
                fill: "currentColor"
            })
        ]
    });
var $24ed665473663122$export$2e2bcd8739ae039 = $24ed665473663122$var$SvgEdit;



parcelRequire("2gcPZ");
const $2dca32076b6deb58$var$SvgElasticsearchColor = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 80 80",
        width: 14,
        height: 14,
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("circle", {
                    id: "ElasticsearchColor_svg__a",
                    cx: 40,
                    cy: 40,
                    r: 32
                })
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("clipPath", {
                id: "ElasticsearchColor_svg__b",
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("use", {
                    xlinkHref: "#ElasticsearchColor_svg__a",
                    overflow: "visible"
                })
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M53.7 26H10c-1.1 0-2-.9-2-2V10c0-1.1.9-2 2-2h57c1.1 0 2 .9 2 2v.7C68.9 19.1 62.1 26 53.7 26z",
                style: {
                    clipPath: "url(#ElasticsearchColor_svg__b)",
                    fill: "#f0bf1a"
                }
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("circle", {
                    id: "ElasticsearchColor_svg__c",
                    cx: 40,
                    cy: 40,
                    r: 32
                })
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("clipPath", {
                id: "ElasticsearchColor_svg__d",
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("use", {
                    xlinkHref: "#ElasticsearchColor_svg__c",
                    overflow: "visible"
                })
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M69.1 72H8.2V54h45.7c8.4 0 15.2 6.8 15.2 15.2V72z",
                style: {
                    clipPath: "url(#ElasticsearchColor_svg__d)",
                    fill: "#3ebeb0"
                }
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("circle", {
                    id: "ElasticsearchColor_svg__e",
                    cx: 40,
                    cy: 40,
                    r: 32
                })
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("clipPath", {
                id: "ElasticsearchColor_svg__f",
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("use", {
                    xlinkHref: "#ElasticsearchColor_svg__e",
                    overflow: "visible"
                })
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M50.1 49H4.8V31h45.3c5 0 9 4 9 9s-4.1 9-9 9z",
                style: {
                    clipPath: "url(#ElasticsearchColor_svg__f)",
                    fill: "#07a5de"
                }
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("circle", {
                    id: "ElasticsearchColor_svg__g",
                    cx: 40,
                    cy: 40,
                    r: 32
                })
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("clipPath", {
                id: "ElasticsearchColor_svg__h",
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("use", {
                    xlinkHref: "#ElasticsearchColor_svg__g",
                    overflow: "visible"
                })
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M36 31H6.4v18H36c.7-2.7 1.1-5.7 1.1-9s-.4-6.3-1.1-9z",
                style: {
                    clipPath: "url(#ElasticsearchColor_svg__h)",
                    fill: "#231f20"
                }
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M23.9 12.3c-5.4 3.2-9.9 8-12.7 13.7h23.6c-2.4-5.5-6.2-10.1-10.9-13.7z",
                style: {
                    fill: "#d7a229"
                }
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M24.9 68.2c4.6-3.7 8.3-8.6 10.6-14.2H11.2c3 6 7.8 11 13.7 14.2z",
                style: {
                    fill: "#019b8f"
                }
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M0 0h80v80H0z",
                style: {
                    fill: "none"
                }
            })
        ]
    });
var $2dca32076b6deb58$export$2e2bcd8739ae039 = $2dca32076b6deb58$var$SvgElasticsearchColor;



parcelRequire("2gcPZ");
const $1e42f6f802b7aff3$var$SvgElastic = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.826 4.275a6.445 6.445 0 0 1 1.28 1.598c.205.328.39.676.554 1.045H3.656c.656-1.455 1.7-2.705 3.012-3.566.328.226.656.451.943.718.071.071.143.138.215.205Zm2.51 6.557c.02-.205.02-.43.02-.635 0-.205 0-.43-.02-.636a7.522 7.522 0 0 0-.266-1.536c-.013-.061-.032-.122-.05-.179a1.849 1.849 0 0 1-.032-.108h-6.62A8.118 8.118 0 0 0 3 10.197c0 .86.123 1.68.369 2.459h6.619c.012-.061.031-.122.05-.179l.032-.108a7.522 7.522 0 0 0 .266-1.537ZM9.127 14.52c.205-.327.39-.676.553-1.045H3.676a8.103 8.103 0 0 0 3.013 3.566c.327-.226.635-.45.942-.717.144-.123.287-.267.43-.41.39-.41.759-.881 1.066-1.394Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.668 3.352A8.11 8.11 0 0 1 11.176 2C14.025 2 16.525 3.455 18 5.648a4.18 4.18 0 0 1-2.992 1.27H9.681a8.423 8.423 0 0 0-.554-1.045 7.954 7.954 0 0 0-1.086-1.394c-.143-.143-.287-.286-.43-.41a10.394 10.394 0 0 0-.943-.717Zm7.603 4.386H9.988c.012.06.032.122.05.178.012.039.024.075.032.109.143.491.225 1.004.266 1.536.02.205.02.43.02.636 0 .205 0 .43-.02.635a7.536 7.536 0 0 1-.266 1.537 1.668 1.668 0 0 1-.05.178c-.012.039-.024.075-.032.109h4.283c1.352 0 2.438-1.107 2.438-2.46 0-1.352-1.086-2.458-2.438-2.458Zm.737 5.737H9.681a8.42 8.42 0 0 1-.554 1.045 7.957 7.957 0 0 1-1.086 1.394c-.072.072-.143.138-.215.205-.072.066-.143.133-.215.205-.287.266-.615.491-.943.717a8.109 8.109 0 0 0 4.508 1.352c2.849 0 5.349-1.455 6.824-3.647a4.18 4.18 0 0 0-2.992-1.27Z",
                fill: "currentColor"
            })
        ]
    });
var $1e42f6f802b7aff3$export$2e2bcd8739ae039 = $1e42f6f802b7aff3$var$SvgElastic;



parcelRequire("2gcPZ");
const $b1d0942505cacd1b$var$SvgDotsThree = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M10.938 10a.937.937 0 1 1-1.875 0 .937.937 0 0 1 1.874 0ZM15 9.062a.937.937 0 1 0 0 1.875.937.937 0 0 0 0-1.874Zm-10 0a.937.937 0 1 0 0 1.875.937.937 0 0 0 0-1.874Z",
            fill: "currentColor"
        })
    });
var $b1d0942505cacd1b$export$2e2bcd8739ae039 = $b1d0942505cacd1b$var$SvgDotsThree;



parcelRequire("2gcPZ");
const $9e83a05be9ccc05d$var$SvgDotsThreeVertical = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M10.938 10a.937.937 0 1 1-1.875 0 .937.937 0 0 1 1.874 0ZM10 5.937a.937.937 0 1 0 0-1.874.937.937 0 0 0 0 1.875Zm0 8.125a.938.938 0 1 0 0 1.876.938.938 0 0 0 0-1.876Z",
            fill: "currentColor"
        })
    });
var $9e83a05be9ccc05d$export$2e2bcd8739ae039 = $9e83a05be9ccc05d$var$SvgDotsThreeVertical;



parcelRequire("2gcPZ");
const $a82b054ee5f811ef$var$SvgEnvelopeSimple = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M17.5 3.75h-15a.625.625 0 0 0-.625.625V15a1.25 1.25 0 0 0 1.25 1.25h13.75a1.25 1.25 0 0 0 1.25-1.25V4.375a.625.625 0 0 0-.625-.625ZM16.875 15H3.125V5.797l6.453 5.914a.625.625 0 0 0 .844 0l6.453-5.914V15Z",
            fill: "currentColor"
        })
    });
var $a82b054ee5f811ef$export$2e2bcd8739ae039 = $a82b054ee5f811ef$var$SvgEnvelopeSimple;



parcelRequire("2gcPZ");
const $63316bb19f101a63$var$SvgEnvelopeSimpleOpen = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "m17.844 6.976-7.5-5a.64.64 0 0 0-.688 0l-7.5 5a.617.617 0 0 0-.281.524v8.125a1.25 1.25 0 0 0 1.25 1.25h13.75a1.25 1.25 0 0 0 1.25-1.25V7.5a.616.616 0 0 0-.281-.524ZM3.125 15.625V8.71l5.148 3.672c.105.075.23.116.36.117h2.734c.13 0 .255-.042.36-.117l5.148-3.672v6.914H3.125Z",
            fill: "currentColor"
        })
    });
var $63316bb19f101a63$export$2e2bcd8739ae039 = $63316bb19f101a63$var$SvgEnvelopeSimpleOpen;



parcelRequire("2gcPZ");
const $2df3f7ee88caa9c8$var$SvgEnvironmentsDuotone = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                opacity: 0.2,
                fill: "currentColor",
                d: "M4 4h12v12H4z"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M4 15.998h11.998a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-1.998A2 2 0 0 1 2 14V6a2 2 0 0 1 2-2v11.998ZM18 14V8h-2v8a2 2 0 0 0 2-2Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M18 8V6a2 2 0 0 0-1.997-2 2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2H16v4h2ZM6 6h3v3H6V6ZM9 11H6v3h3v-3Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M11 6h3v3h-3V6ZM14 11h-3v3h3v-3Z",
                fill: "currentColor"
            })
        ]
    });
var $2df3f7ee88caa9c8$export$2e2bcd8739ae039 = $2df3f7ee88caa9c8$var$SvgEnvironmentsDuotone;



parcelRequire("2gcPZ");
const $aa5eb9e7f0c4c25d$var$SvgExportDuotone = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("g", {
            fill: "currentColor",
            children: [
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                    opacity: 0.2,
                    d: "M4 7h12v9H4z"
                }),
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                    d: "m11 3.999 1 1.003 1-1L10.003 1l.002 2 .002.002H10v-2l-3 3 1 1 1-1v8h2V3.999Z"
                }),
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                    d: "M18 16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2v2H4v9h12V7h2v9Z"
                }),
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                    d: "M14 5h2a2 2 0 0 1 2 2h-4V5Z"
                })
            ]
        })
    });
var $aa5eb9e7f0c4c25d$export$2e2bcd8739ae039 = $aa5eb9e7f0c4c25d$var$SvgExportDuotone;



parcelRequire("2gcPZ");
const $44d8fb12ba7512f2$var$SvgExport = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "m11 3.999 1 1.003 1-1L10.003 1l.002 2 .002.002H10v-2l-3 3 1 1 1-1v8h2V3.999Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M18 16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2v2H4v9h12V7h2v9Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M14 5h2a2 2 0 0 1 2 2h-4V5Z",
                fill: "currentColor"
            })
        ]
    });
var $44d8fb12ba7512f2$export$2e2bcd8739ae039 = $44d8fb12ba7512f2$var$SvgExport;



parcelRequire("2gcPZ");
const $ba30942af1ee2328$var$SvgEye = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M19.32 9.75c-.023-.063-.687-1.531-2.156-3.008C15.204 4.79 12.727 3.75 10 3.75c-2.726 0-5.203 1.04-7.164 2.992C1.367 8.22.703 9.688.68 9.75a.617.617 0 0 0 0 .5c.023.063.687 1.531 2.156 3.008C4.797 15.21 7.274 16.25 10 16.25c2.727 0 5.203-1.04 7.164-2.992 1.469-1.477 2.133-2.945 2.156-3.008a.617.617 0 0 0 0-.5ZM10 7.187a2.812 2.812 0 1 1 0 5.625 2.812 2.812 0 0 1 0-5.624Z",
            fill: "currentColor"
        })
    });
var $ba30942af1ee2328$export$2e2bcd8739ae039 = $ba30942af1ee2328$var$SvgEye;



parcelRequire("2gcPZ");
const $6ca4a9f6cd89d465$var$SvgEyeSlash = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M19.32 9.75c-.023-.062-.687-1.531-2.156-3.008C15.204 4.79 12.727 3.75 10 3.75c-.576-.001-1.15.046-1.719.14a.633.633 0 0 0-.359 1.04l7.914 8.703a.625.625 0 0 0 .461.203.672.672 0 0 0 .422-.156c1.781-1.602 2.57-3.352 2.601-3.422a.64.64 0 0 0 0-.508ZM4.21 2.703a.625.625 0 0 0-.921.844l1.5 1.648C1.953 6.938.734 9.625.679 9.75a.64.64 0 0 0 0 .508c.024.055.688 1.523 2.157 3C4.796 15.21 7.273 16.25 10 16.25a9.914 9.914 0 0 0 4.07-.844l1.719 1.89a.627.627 0 0 0 1.05-.635.616.616 0 0 0-.128-.208L4.21 2.703ZM10 12.813A2.813 2.813 0 0 1 7.695 8.39l3.688 4.054c-.421.242-.898.368-1.383.367Z",
            fill: "currentColor"
        })
    });
var $6ca4a9f6cd89d465$export$2e2bcd8739ae039 = $6ca4a9f6cd89d465$var$SvgEyeSlash;



parcelRequire("2gcPZ");
const $17eabb2fcde38803$var$SvgFacebookLogo = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M18.125 10a8.149 8.149 0 0 1-7.149 8.07.32.32 0 0 1-.351-.312v-5.883H12.5a.625.625 0 0 0 .625-.664.641.641 0 0 0-.649-.586h-1.851V8.75a1.25 1.25 0 0 1 1.25-1.25h1.25a.625.625 0 0 0 .625-.664.641.641 0 0 0-.649-.586h-1.226a2.5 2.5 0 0 0-2.5 2.5v1.875H7.5a.625.625 0 0 0-.625.664.64.64 0 0 0 .648.586h1.852v5.883a.313.313 0 0 1-.344.312c-4.125-.5-7.312-4.086-7.148-8.375A8.125 8.125 0 0 1 18.125 10Z",
            fill: "currentColor"
        })
    });
var $17eabb2fcde38803$export$2e2bcd8739ae039 = $17eabb2fcde38803$var$SvgFacebookLogo;



parcelRequire("2gcPZ");
const $81af963876bddfab$var$SvgFiberplaneLogoCracked = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 98,
        height: 114,
        viewBox: "0 0 98 114",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("g", {
                filter: "url(#FiberplaneLogoCracked_svg__a)",
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M43.4 19.009 40 34.005l11.477 8.09a4.417 4.417 0 0 0-.645-.048L27 42v5.953l26.515.045-4.729 7.042L27 55v5.953l17.792.034-2.362 3.516.633 1.529L27 66v5.953l18.534.039 4.4 10.618 6.59 1.907L54.58 95l5.513-11.327-6.501-2.789-1.02-2.075c.442.124.91.191 1.4.191H58.5L61 73H49.72l-.491-1h.265l1.39-5.495.376-.528L65.715 66 68 60.024l-12.495-.02 4.29-6.034 14.56-.064L77 48l-12.99.04L67 43.834 51.664 27.811l5.81-8.777c12.345.159 19.906 1.074 25.162 6.33C89 31.728 89 41.472 89 59c0 17.528 0 27.272-6.364 33.636C76.272 99 66.528 99 49 99c-17.528 0-27.272 0-33.636-6.364C9 86.272 9 76.528 9 59c0-17.528 0-27.272 6.364-33.636 5.652-5.652 13.969-6.284 28.036-6.355Zm11.593 26.79.559-.833-.983-.692c.242.468.39.985.424 1.524Z",
                    fill: "url(#FiberplaneLogoCracked_svg__b)"
                })
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "m46.416 2.8-8.415 1.783 8.482 8.065-.067-9.849ZM65.294 8.855l-4.963-3.53-5.003 8.65 10.095-.888-.13-4.232ZM51.014 5.826l4.812 1.16-3.483 3.888-1.329-5.048ZM35.345 14.315l3.385-3.703 1.76 4.843-5.145-1.14Z",
                fill: "#000"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("linearGradient", {
                        id: "FiberplaneLogoCracked_svg__b",
                        x1: 17,
                        y1: 24.09,
                        x2: 81.75,
                        y2: 93.182,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                offset: 0.479
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#2C2C2C"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("filter", {
                        id: "FiberplaneLogoCracked_svg__a",
                        x: 0.248,
                        y: 15.826,
                        width: 97.503,
                        height: 97.494,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("feOffset", {
                                dy: 5.569
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("feGaussianBlur", {
                                stdDeviation: 4.376
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("feBlend", {
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_1_556"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_1_556",
                                result: "shape"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $81af963876bddfab$export$2e2bcd8739ae039 = $81af963876bddfab$var$SvgFiberplaneLogoCracked;



parcelRequire("2gcPZ");
const $fb24ca84a1e49e66$var$SvgFiberplaneLogo = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 65,
        height: 64,
        viewBox: "0 0 65 64",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M32.5 64c14.022 0 21.817 0 26.909-5.091C64.5 53.817 64.5 46.022 64.5 32c0-14.022 0-21.817-5.091-26.909C54.317 0 46.522 0 32.5 0 18.478 0 10.683 0 5.591 5.091.5 10.183.5 17.978.5 32c0 14.022 0 21.817 5.091 26.909C10.683 64 18.478 64 32.5 64Z",
                fill: "url(#FiberplaneLogo_svg__a)"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("g", {
                clipPath: "url(#FiberplaneLogo_svg__b)",
                filter: "url(#FiberplaneLogo_svg__c)",
                fill: "#313131",
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                        d: "M14.464 28.115v5.029l20.162.04 1.19-5.03-21.352-.04ZM14.464 18.036v5.03l22.542.04.201-.879c.504-2.115-1.109-4.15-3.306-4.15l-19.437-.04Z"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                        d: "m33.417 38.213 1.19-5.03 12.762.02-1.875 5.03-12.077-.02ZM35.795 28.155l1.21-5.03 18.186-.06-2.137 5.01-17.259.08ZM14.464 38.173v5.03l17.763.04 1.19-5.03-18.953-.04Z"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                        d: "M39.808 48.29h-3.69c-2.661 0-4.597-2.514-3.912-5.048h9.638l-2.036 5.049Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("g", {
                clipPath: "url(#FiberplaneLogo_svg__d)",
                filter: "url(#FiberplaneLogo_svg__e)",
                fill: "#fff",
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                        d: "M14.464 28.115v5.029l20.162.04 1.19-5.03-21.352-.04ZM14.464 18.036v5.03l22.542.04.201-.879c.504-2.115-1.109-4.15-3.306-4.15l-19.437-.04Z"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                        d: "m33.417 38.213 1.19-5.03 12.762.02-1.875 5.03-12.077-.02ZM35.795 28.155l1.21-5.03 18.186-.06-2.137 5.01-17.259.08ZM14.464 38.173v5.03l17.763.04 1.19-5.03-18.953-.04Z"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                        d: "M39.808 48.29h-3.69c-2.661 0-4.597-2.514-3.912-5.048h9.638l-2.036 5.049Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("clipPath", {
                        id: "FiberplaneLogo_svg__b",
                        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(14.463 18.036)",
                            d: "M0 0h40.727v30.255H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("clipPath", {
                        id: "FiberplaneLogo_svg__d",
                        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(14.463 18.036)",
                            d: "M0 0h40.727v30.255H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("filter", {
                        id: "FiberplaneLogo_svg__c",
                        x: 11.309,
                        y: 17.405,
                        width: 47.036,
                        height: 36.563,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("feOffset", {
                                dy: 2.524
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("feGaussianBlur", {
                                stdDeviation: 1.577
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("feBlend", {
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_325_26279"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_325_26279",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("filter", {
                        id: "FiberplaneLogo_svg__e",
                        x: 11.309,
                        y: 17.405,
                        width: 47.036,
                        height: 36.563,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("feOffset", {
                                dy: 2.524
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("feGaussianBlur", {
                                stdDeviation: 1.577
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("feBlend", {
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_325_26279"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_325_26279",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("linearGradient", {
                        id: "FiberplaneLogo_svg__a",
                        x1: 6.9,
                        y1: 4.073,
                        x2: 58.682,
                        y2: 59.346,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                offset: 0.479
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#2C2C2C"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $fb24ca84a1e49e66$export$2e2bcd8739ae039 = $fb24ca84a1e49e66$var$SvgFiberplaneLogo;



parcelRequire("2gcPZ");
const $18f6c97aabcc6fd7$var$SvgFiberplaneLogoType = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 143,
        height: 27,
        viewBox: "0 0 143 27",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M13.298 26.596c5.827 0 9.066 0 11.182-2.116 2.116-2.116 2.116-5.355 2.116-11.182s0-9.067-2.116-11.182C22.364 0 19.125 0 13.298 0S4.23 0 2.116 2.116C0 4.23 0 7.47 0 13.298s0 9.066 2.116 11.182c2.115 2.116 5.355 2.116 11.182 2.116Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M6.357 11.308v1.984l7.68.016.453-1.984-8.133-.016ZM6.357 7.333v1.984l8.586.015.077-.346c.192-.835-.422-1.637-1.26-1.637l-7.403-.016ZM13.574 15.291l.453-1.983 4.862.008-.715 1.983-4.6-.008ZM14.483 11.323l.461-1.983 6.928-.024-.814 1.976-6.575.031Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M6.357 15.274v1.984l6.766.015.453-1.983-7.22-.016ZM16.008 19.265h-1.406c-1.014 0-1.751-.992-1.49-1.991h3.671l-.775 1.991Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M48.308 21.019h3.455l.335-2.052h.628c.502 1.508 1.863 2.261 3.266 2.261 2.91 0 4.69-1.884 4.69-5.904 0-3.539-1.465-5.905-4.606-5.905-1.508 0-2.848.9-3.35 2.24h-.628l.209-3.14V5.315h-4V21.02Zm3.999-5.34v-.69c0-1.466.817-2.366 2.24-2.366 1.236 0 2.073.544 2.073 1.947V16.1c0 1.151-.565 1.926-2.052 1.926-1.486 0-2.261-.9-2.261-2.345ZM61.728 15.345c0 3.538 2.325 5.883 5.863 5.883 2.932 0 5.088-1.549 5.381-3.936h-3.81c-.105.65-.775 1.026-1.696 1.026-.943 0-1.717-.586-1.717-1.466v-.586h7.098c.125-.44.167-1.047.167-1.633 0-3.392-2.45-5.214-5.548-5.214-3.225 0-5.737 2.136-5.737 5.926Zm4.02-1.466v-.23c0-.754.713-1.298 1.676-1.298s1.591.544 1.591 1.298v.23h-3.266ZM82.337 9.566c-1.278 0-2.262.733-2.576 2.554h-.628l-.481-2.491h-5.256v3.203h1.738v8.187h4v-4.648c0-2.387 1.486-3.057 3.182-3.057.23 0 .46.02.712.042V9.629a3.241 3.241 0 0 0-.691-.063ZM84.09 9.629v14.887h4v-2.387l-.21-3.141h.629c.502 1.34 1.842 2.24 3.35 2.24 3.14 0 4.606-2.366 4.606-5.904 0-4.02-1.78-5.905-4.69-5.905-1.403 0-2.764.754-3.266 2.262h-.628l-.335-2.052H84.09Zm4 5.339c0-1.445.775-2.345 2.261-2.345 1.487 0 2.052.775 2.052 1.926v1.529c0 1.402-.837 1.947-2.073 1.947-1.423 0-2.24-.9-2.24-2.366v-.691ZM101.432 17.92V5.315h-3.978v12.668c0 1.822.732 3.036 3.036 3.036h3.538V17.92h-2.596ZM104.763 17.816c0 2.093 1.528 3.412 3.873 3.412 1.948 0 3.309-.9 3.748-2.24h.566v2.031h4.187v-2.931h-1.444v-4.544c0-2.47-1.424-4.125-5.067-4.125-3.35 0-5.298 1.445-5.172 4.25h3.664c-.063-.942.503-1.255 1.319-1.255.775 0 1.277.313 1.277 1.11v.795l-3.182.21c-2.241.146-3.769 1.193-3.769 3.287Zm4.02-.545c0-.44.314-.858 1.026-.9l1.905-.126v1.32c-.314.48-.942.795-1.717.795-.837 0-1.214-.356-1.214-.838v-.25ZM118.351 21.019h3.999v-6.093c0-1.34.67-2.282 2.01-2.282 1.131 0 1.759.649 1.759 2.052v6.323h4.02v-7.726c0-2.324-1.277-3.874-3.56-3.874-1.758 0-3.015.817-3.601 2.24h-.628l-.482-2.03h-3.517v11.39ZM131.424 15.345c0 3.538 2.324 5.883 5.863 5.883 2.931 0 5.088-1.549 5.381-3.936h-3.811c-.105.65-.775 1.026-1.696 1.026-.942 0-1.717-.586-1.717-1.466v-.586h7.098c.126-.44.168-1.047.168-1.633 0-3.392-2.45-5.214-5.549-5.214-3.225 0-5.737 2.136-5.737 5.926Zm4.02-1.466v-.23c0-.754.712-1.298 1.675-1.298.963 0 1.591.544 1.591 1.298v.23h-3.266ZM39.07 9.63h7.894v11.389h-4.018v-8.19H39.07v8.19h-4.018v-8.19h-2.075v-3.2h2.075v-.98c0-.266.003-.46.01-.583.007-.13.027-.29.062-.48.04-.192.102-.396.184-.614.402-1.104 1.428-1.657 3.077-1.657h3.26v3.098h-2.575V9.63Zm3.896-1.217V5.315h3.998v3.098h-3.998Z",
                fill: "currentColor"
            })
        ]
    });
var $18f6c97aabcc6fd7$export$2e2bcd8739ae039 = $18f6c97aabcc6fd7$var$SvgFiberplaneLogoType;



parcelRequire("2gcPZ");
const $e20af91af68fa9a4$var$SvgFigmaLogo = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M14.578 7.344a3.281 3.281 0 0 0-1.922-5.938H7.344a3.281 3.281 0 0 0-1.922 5.938 3.274 3.274 0 0 0 0 5.312 3.282 3.282 0 1 0 5.203 2.656V12.57a3.281 3.281 0 1 0 3.953-5.226Zm.11-2.657a2.039 2.039 0 0 1-2.032 2.032h-2.031V2.656h2.031a2.039 2.039 0 0 1 2.031 2.031Zm-2.032 7.344a2.031 2.031 0 1 1 0-4.062 2.031 2.031 0 0 1 0 4.062Z",
            fill: "currentColor"
        })
    });
var $e20af91af68fa9a4$export$2e2bcd8739ae039 = $e20af91af68fa9a4$var$SvgFigmaLogo;



parcelRequire("2gcPZ");
const $68ed132d2c23195b$var$SvgFileArrowDown = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.695 6.43 12.32 2.055a.633.633 0 0 0-.445-.18h-7.5a1.25 1.25 0 0 0-1.25 1.25v13.75a1.25 1.25 0 0 0 1.25 1.25h11.25a1.25 1.25 0 0 0 1.25-1.25v-10a.633.633 0 0 0-.18-.445Zm-4.062 6.203-2.188 2.187a.64.64 0 0 1-.89 0l-2.188-2.187a.633.633 0 0 1 .89-.89l1.118 1.124V9.375a.625.625 0 0 1 1.25 0v3.492l1.117-1.125a.633.633 0 0 1 .89.89Zm-.758-5.758V3.438l3.438 3.437h-3.438Z",
            fill: "currentColor"
        })
    });
var $68ed132d2c23195b$export$2e2bcd8739ae039 = $68ed132d2c23195b$var$SvgFileArrowDown;



parcelRequire("2gcPZ");
const $c3c0d574fc2c540b$var$SvgFileArrowUp = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.688 6.43 12.32 2.055l-.023-.016-.024-.023L12.25 2l-.023-.016c-.008-.007-.016-.007-.016-.015l-.04-.024h-.015l-.039-.023h-.008l-.054-.024h-7.68a1.25 1.25 0 0 0-1.25 1.227v13.75a1.25 1.25 0 0 0 1.25 1.25h11.25a1.25 1.25 0 0 0 1.25-1.25v-10a.61.61 0 0 0-.188-.445Zm-4.055 5.578a.633.633 0 0 1-.89 0l-1.118-1.125v3.492a.624.624 0 1 1-1.25 0v-3.492l-1.117 1.125a.633.633 0 0 1-.89-.89L9.554 8.93h.008l.039-.04.023-.015.031-.023.024-.016.023-.016h.031l.024-.015h.031l.031-.016h.36l.03.016h.032l.024.015h.03l.024.016.024.016.031.023.023.016.04.039h.007l2.188 2.187a.633.633 0 0 1 0 .89Zm-.758-5.133V3.383l3.492 3.492h-3.492Z",
            fill: "currentColor"
        })
    });
var $c3c0d574fc2c540b$export$2e2bcd8739ae039 = $c3c0d574fc2c540b$var$SvgFileArrowUp;



parcelRequire("2gcPZ");
const $20cbb1db94eb7ff4$var$SvgFileCode = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.695 6.43 12.32 2.055a.633.633 0 0 0-.445-.18h-7.5a1.25 1.25 0 0 0-1.25 1.25v13.75a1.25 1.25 0 0 0 1.25 1.25h11.25a1.25 1.25 0 0 0 1.25-1.25v-10a.633.633 0 0 0-.18-.445ZM8.57 13.305a.633.633 0 0 1 0 .89.64.64 0 0 1-.89 0L5.805 12.32a.633.633 0 0 1 0-.89L7.68 9.555a.633.633 0 0 1 .89.89l-1.437 1.43 1.437 1.43Zm5.625-.985-1.875 1.875a.64.64 0 0 1-.89 0 .633.633 0 0 1 0-.89l1.437-1.43-1.437-1.43a.633.633 0 0 1 .89-.89l1.875 1.875a.633.633 0 0 1 0 .89Zm-2.32-5.445V3.438l3.438 3.437h-3.438Z",
            fill: "currentColor"
        })
    });
var $20cbb1db94eb7ff4$export$2e2bcd8739ae039 = $20cbb1db94eb7ff4$var$SvgFileCode;



parcelRequire("2gcPZ");
const $6b5a51987e975816$var$SvgFileCss = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M10.133 14.36c-.242-.063-.672-.18-.758-.282v-.015c0-.258.188-.391.547-.391.279.006.55.092.781.25h-.008c.114.09.254.14.399.14a.625.625 0 0 0 .567-.89.594.594 0 0 0-.169-.211 2.61 2.61 0 0 0-1.57-.54c-1.055 0-1.797.673-1.797 1.642 0 .968 1.016 1.328 1.688 1.507.265.07.546.14.718.242.172.102.094.079.094.126 0 .046 0 .39-.703.39a1.437 1.437 0 0 1-.781-.25h.007a.625.625 0 0 0-.966.75c.04.082.098.155.17.211a2.61 2.61 0 0 0 1.57.54c1.226 0 1.953-.618 1.953-1.642 0-1.023-1.094-1.406-1.742-1.578Zm-6.07.64c0 .688.492 1.25 1.093 1.25.25-.003.489-.097.672-.266a.616.616 0 0 1 .883.047.625.625 0 0 1-.04.883 2.29 2.29 0 0 1-1.515.586c-1.289 0-2.343-1.125-2.343-2.5s1.054-2.5 2.343-2.5c.56.003 1.1.212 1.516.586a.625.625 0 0 1 .039.883.618.618 0 0 1-.883.047 1.008 1.008 0 0 0-.672-.266c-.601 0-1.093.563-1.093 1.25Zm11.07-.64c-.242-.063-.672-.18-.758-.282v-.015c0-.258.188-.391.547-.391.279.006.55.092.781.25h-.008c.114.09.254.14.399.14a.625.625 0 0 0 .567-.89.594.594 0 0 0-.169-.211 2.61 2.61 0 0 0-1.57-.54c-1.055 0-1.797.673-1.797 1.642 0 .968 1.016 1.328 1.688 1.507.265.07.546.14.718.242.172.102.094.079.094.126 0 .046 0 .39-.703.39a1.437 1.437 0 0 1-.781-.25h.007a.625.625 0 0 0-.966.75c.04.082.098.155.17.211a2.61 2.61 0 0 0 1.57.54c1.226 0 1.953-.618 1.953-1.642 0-1.023-1.094-1.406-1.742-1.578Zm1.562-7.93L12.32 2.055a.633.633 0 0 0-.445-.18h-7.5a1.25 1.25 0 0 0-1.25 1.25V10a.625.625 0 0 0 .625.625h12.5a.625.625 0 0 0 .625-.625V6.875a.633.633 0 0 0-.18-.445Zm-4.82.445V3.438l3.438 3.437h-3.438Z",
            fill: "currentColor"
        })
    });
var $6b5a51987e975816$export$2e2bcd8739ae039 = $6b5a51987e975816$var$SvgFileCss;



parcelRequire("2gcPZ");
const $b05022f516a7511f$var$SvgFileCsv = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "m17.14 13.367-1.562 3.75a.625.625 0 0 1-1.156 0l-1.563-3.75a.626.626 0 1 1 1.157-.484L15 15.25l.984-2.367a.626.626 0 1 1 1.157.484Zm-11.984.383c.25.002.489.097.672.266a.618.618 0 0 0 .883-.047.625.625 0 0 0-.04-.883 2.29 2.29 0 0 0-1.515-.586c-1.289 0-2.343 1.125-2.343 2.5s1.054 2.5 2.343 2.5a2.29 2.29 0 0 0 1.516-.586.625.625 0 0 0 .039-.883.617.617 0 0 0-.883-.047 1.008 1.008 0 0 1-.672.266c-.601 0-1.093-.563-1.093-1.25 0-.688.492-1.25 1.093-1.25Zm4.977.61c-.242-.063-.672-.18-.758-.282v-.015c0-.258.188-.391.547-.391.279.006.55.092.781.25h-.008c.114.09.254.14.399.14a.625.625 0 0 0 .567-.89.594.594 0 0 0-.169-.211 2.61 2.61 0 0 0-1.57-.54c-1.055 0-1.797.673-1.797 1.642 0 .968 1.016 1.328 1.688 1.507.265.07.546.14.718.242.172.102.094.079.094.126 0 .046 0 .39-.703.39a1.437 1.437 0 0 1-.781-.25h.007a.625.625 0 0 0-.966.75c.04.082.098.155.17.211a2.61 2.61 0 0 0 1.57.54c1.226 0 1.953-.618 1.953-1.642 0-1.023-1.094-1.406-1.742-1.578ZM3.125 10V3.125a1.25 1.25 0 0 1 1.25-1.25h7.5c.166 0 .326.064.445.18l4.375 4.375c.116.119.18.279.18.445V10a.625.625 0 0 1-.625.625H3.75A.625.625 0 0 1 3.125 10Zm8.75-3.125h3.438l-3.438-3.437v3.437Z",
            fill: "currentColor"
        })
    });
var $b05022f516a7511f$export$2e2bcd8739ae039 = $b05022f516a7511f$var$SvgFileCsv;



parcelRequire("2gcPZ");
const $51afea924c47320b$var$SvgFileDoc = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M4.531 12.5H3.438a.625.625 0 0 0-.626.625v3.75a.625.625 0 0 0 .626.625H4.53a2.5 2.5 0 0 0 0-5Zm0 3.75h-.468v-2.5h.468a1.25 1.25 0 0 1 0 2.5Zm5.625-3.75c-1.289 0-2.344 1.125-2.344 2.5s1.055 2.5 2.344 2.5c1.29 0 2.344-1.125 2.344-2.5s-1.055-2.5-2.344-2.5Zm0 3.75c-.601 0-1.094-.563-1.094-1.25 0-.688.493-1.25 1.094-1.25.602 0 1.094.563 1.094 1.25 0 .688-.492 1.25-1.094 1.25Zm6.867-.219a.625.625 0 0 1-.039.883 2.29 2.29 0 0 1-1.515.586c-1.29 0-2.344-1.125-2.344-2.5s1.055-2.5 2.344-2.5a2.29 2.29 0 0 1 1.515.586.625.625 0 0 1 .04.883.618.618 0 0 1-.883.047 1.008 1.008 0 0 0-.672-.266c-.602 0-1.094.563-1.094 1.25 0 .688.492 1.25 1.094 1.25.249-.003.488-.097.672-.266a.617.617 0 0 1 .882.047ZM3.75 10.625h12.5a.625.625 0 0 0 .625-.625V6.875a.633.633 0 0 0-.18-.445L12.32 2.055a.633.633 0 0 0-.445-.18h-7.5a1.25 1.25 0 0 0-1.25 1.25V10a.625.625 0 0 0 .625.625Zm8.125-7.187 3.438 3.437h-3.438V3.438Z",
            fill: "currentColor"
        })
    });
var $51afea924c47320b$export$2e2bcd8739ae039 = $51afea924c47320b$var$SvgFileDoc;



parcelRequire("2gcPZ");
const $bf5d470f936ee11d$var$SvgFileDotted = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M6.25 17.5a.625.625 0 0 1-.625.625h-1.25a1.25 1.25 0 0 1-1.25-1.25v-2.5a.625.625 0 1 1 1.25 0v2.5h1.25a.625.625 0 0 1 .625.625Zm0-15.625H4.375a1.25 1.25 0 0 0-1.25 1.25V5a.625.625 0 0 0 1.25 0V3.125H6.25a.625.625 0 0 0 0-1.25Zm10.625 5a.61.61 0 0 0-.188-.445L12.32 2.055h-.015l-.032-.032h-.015L12.227 2c-.008-.008-.016-.008-.016-.016l-.04-.023h-.015l-.039-.024h-.008l-.054-.023h-2.68a.625.625 0 0 0 0 1.25h1.875v3.711a.625.625 0 0 0 .625.625h3.75v3.125a.624.624 0 1 0 1.25 0v-3.75Zm-.625 6.25a.624.624 0 0 0-.625.625v3.125H15a.624.624 0 1 0 0 1.25h.625a1.25 1.25 0 0 0 1.25-1.25V13.75a.624.624 0 0 0-.625-.625Zm-12.5-1.25a.625.625 0 0 0 .625-.625V8.125a.625.625 0 0 0-1.25 0v3.125a.625.625 0 0 0 .625.625Zm8.125 5H8.75a.625.625 0 1 0 0 1.25h3.125a.624.624 0 1 0 0-1.25Z",
            fill: "currentColor"
        })
    });
var $bf5d470f936ee11d$export$2e2bcd8739ae039 = $bf5d470f936ee11d$var$SvgFileDotted;



parcelRequire("2gcPZ");
const $713e353bee131f8a$var$SvgFileHtml = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M9.375 13.125h-2.5a.625.625 0 1 0 0 1.25H7.5v2.5a.625.625 0 1 0 1.25 0v-2.5h.625a.625.625 0 1 0 0-1.25ZM5 13.125a.625.625 0 0 0-.625.625v.938h-.938v-.938a.625.625 0 1 0-1.25 0v3.125a.625.625 0 1 0 1.25 0v-.938h.938v.938a.625.625 0 1 0 1.25 0V13.75A.625.625 0 0 0 5 13.125ZM18.438 16.25h-1.25v-2.5a.624.624 0 1 0-1.25 0v3.125a.624.624 0 0 0 .624.625h1.875a.624.624 0 1 0 0-1.25ZM14.563 13.156a.61.61 0 0 0-.696.235l-1.055 1.468-1.054-1.468a.626.626 0 0 0-1.133.359v3.125a.625.625 0 1 0 1.25 0v-1.172l.43.594a.618.618 0 0 0 1.015 0l.43-.594v1.172a.625.625 0 1 0 1.25 0V13.75a.61.61 0 0 0-.438-.594ZM3.75 10.625h12.5a.625.625 0 0 0 .625-.625V6.875a.633.633 0 0 0-.18-.445L12.32 2.055a.633.633 0 0 0-.445-.18h-7.5a1.25 1.25 0 0 0-1.25 1.25V10a.625.625 0 0 0 .625.625Zm8.125-7.187 3.438 3.437h-3.438V3.438Z",
            fill: "currentColor"
        })
    });
var $713e353bee131f8a$export$2e2bcd8739ae039 = $713e353bee131f8a$var$SvgFileHtml;



parcelRequire("2gcPZ");
const $cabce8192db1c345$var$SvgFile = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.695 6.43 12.32 2.055a.633.633 0 0 0-.445-.18h-7.5a1.25 1.25 0 0 0-1.25 1.25v13.75a1.25 1.25 0 0 0 1.25 1.25h11.25a1.25 1.25 0 0 0 1.25-1.25v-10a.633.633 0 0 0-.18-.445Zm-4.82.445V3.438l3.438 3.437h-3.438Z",
            fill: "currentColor"
        })
    });
var $cabce8192db1c345$export$2e2bcd8739ae039 = $cabce8192db1c345$var$SvgFile;



parcelRequire("2gcPZ");
const $bca870f4abbff2ec$var$SvgFileImage = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.695 6.43 12.32 2.055a.633.633 0 0 0-.445-.18h-7.5a1.25 1.25 0 0 0-1.25 1.25v7.5a.625.625 0 0 0 1.25 0v-7.5h6.875v3.75a.625.625 0 0 0 .625.625h3.75v9.375H15a.625.625 0 0 0 0 1.25h.625a1.25 1.25 0 0 0 1.25-1.25v-10a.632.632 0 0 0-.18-.445ZM12.5 6.25V4.008l2.242 2.242H12.5ZM12.4 17.156a.647.647 0 0 1 .03.64.626.626 0 0 1-.554.329h-10a.625.625 0 0 1-.523-.96l2.547-3.97a.938.938 0 0 1 1.578 0l.5.782 1.367-2.055a.937.937 0 0 1 1.562 0l3.493 5.234Z",
            fill: "currentColor"
        })
    });
var $bca870f4abbff2ec$export$2e2bcd8739ae039 = $bca870f4abbff2ec$var$SvgFileImage;



parcelRequire("2gcPZ");
const $fa2be8a9ead50ce4$var$SvgFileJpg = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M9.375 12.5h-1.25a.625.625 0 0 0-.625.625v3.75a.625.625 0 0 0 1.25 0v-.625h.625a1.875 1.875 0 1 0 0-3.75Zm0 2.5H8.75v-1.25h.625a.625.625 0 0 1 0 1.25ZM6.25 13.125v2.5a1.875 1.875 0 1 1-3.75 0 .625.625 0 1 1 1.25 0 .625.625 0 0 0 1.25 0v-2.5a.625.625 0 1 1 1.25 0Zm10 2.031v.922a.586.586 0 0 1-.102.336 2.296 2.296 0 0 1-1.93 1.086c-1.288 0-2.343-1.125-2.343-2.5s1.055-2.5 2.344-2.5c.466.001.92.149 1.297.422a.625.625 0 0 1-.72 1.015.985.985 0 0 0-.577-.187c-.602 0-1.094.563-1.094 1.25 0 .688.492 1.25 1.094 1.25a1.038 1.038 0 0 0 .781-.375v-.094h-.313a.625.625 0 0 1 0-1.25h.938a.625.625 0 0 1 .625.625Zm.445-8.726L12.32 2.055a.633.633 0 0 0-.445-.18h-7.5a1.25 1.25 0 0 0-1.25 1.25V10a.625.625 0 0 0 .625.625h12.5a.625.625 0 0 0 .625-.625V6.875a.633.633 0 0 0-.18-.445Zm-4.82.445V3.438l3.438 3.437h-3.438Z",
            fill: "currentColor"
        })
    });
var $fa2be8a9ead50ce4$export$2e2bcd8739ae039 = $fa2be8a9ead50ce4$var$SvgFileJpg;



parcelRequire("2gcPZ");
const $f6df1cfe4b7f4ee5$var$SvgFileJs = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M11.25 15.938c0 1.023-.727 1.64-1.953 1.64a2.61 2.61 0 0 1-1.57-.531.593.593 0 0 1-.227-.485.625.625 0 0 1 1.023-.484h-.007c.23.158.502.244.78.25.704 0 .704-.234.704-.39 0-.157 0-.07-.094-.126-.094-.054-.453-.171-.719-.242-.671-.18-1.687-.453-1.687-1.508 0-1.054.742-1.64 1.797-1.64a2.61 2.61 0 0 1 1.57.531.594.594 0 0 1 .227.485.625.625 0 0 1-1.024.484h.008a1.437 1.437 0 0 0-.781-.25c-.36 0-.547.133-.547.39v.016c.086.102.516.219.758.281.648.172 1.742.461 1.742 1.579ZM5.625 12.5a.625.625 0 0 0-.625.625v2.5a.625.625 0 0 1-1.25 0 .625.625 0 1 0-1.25 0 1.875 1.875 0 1 0 3.75 0v-2.5a.625.625 0 0 0-.625-.625Zm11.25-5.625v10a1.25 1.25 0 0 1-1.25 1.25H13.75a.625.625 0 0 1-.625-.625v-6.25a.624.624 0 0 0-.625-.625H3.75A.625.625 0 0 1 3.125 10V3.125a1.25 1.25 0 0 1 1.25-1.25h7.5c.166 0 .326.064.445.18l4.375 4.375c.116.119.18.279.18.445Zm-1.563 0-3.437-3.437v3.437h3.438Z",
            fill: "currentColor"
        })
    });
var $f6df1cfe4b7f4ee5$export$2e2bcd8739ae039 = $f6df1cfe4b7f4ee5$var$SvgFileJs;



parcelRequire("2gcPZ");
const $4fdc9b3d2deb9763$var$SvgFileJsx = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M6.25 13.125v2.5a1.875 1.875 0 1 1-3.75 0 .625.625 0 1 1 1.25 0 .625.625 0 0 0 1.25 0v-2.5a.625.625 0 1 1 1.25 0Zm3.258 1.234c-.242-.062-.672-.18-.758-.28v-.017c0-.257.188-.39.547-.39.279.006.55.092.781.25h-.008c.114.09.254.14.399.14a.625.625 0 0 0 .567-.89.594.594 0 0 0-.169-.211 2.61 2.61 0 0 0-1.57-.54c-1.055 0-1.797.673-1.797 1.642 0 .968 1.016 1.328 1.688 1.507.265.07.546.14.718.242.172.102.094.079.094.126 0 .046 0 .39-.703.39a1.437 1.437 0 0 1-.781-.25h.007a.625.625 0 0 0-.966.75c.04.082.098.155.17.211a2.61 2.61 0 0 0 1.57.54c1.226 0 1.953-.618 1.953-1.642 0-1.023-1.094-1.406-1.742-1.578ZM16 12.625a.625.625 0 0 0-.875.125l-.906 1.21-.906-1.21a.623.623 0 0 0-.876-.125.625.625 0 0 0-.124.875l1.124 1.5-1.124 1.5a.625.625 0 0 0 1 .75l.906-1.21.906 1.21a.625.625 0 0 0 1-.75L15 15l1.125-1.5a.625.625 0 0 0-.125-.875Zm.875-5.75V10a.625.625 0 0 1-.625.625H3.75A.625.625 0 0 1 3.125 10V3.125a1.25 1.25 0 0 1 1.25-1.25h7.5c.166 0 .326.064.445.18l4.375 4.375c.116.119.18.279.18.445Zm-1.563 0-3.437-3.437v3.437h3.438Z",
            fill: "currentColor"
        })
    });
var $4fdc9b3d2deb9763$export$2e2bcd8739ae039 = $4fdc9b3d2deb9763$var$SvgFileJsx;



parcelRequire("2gcPZ");
const $452c2753598bf078$var$SvgFileLock = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.695 6.43 12.32 2.055a.633.633 0 0 0-.445-.18h-7.5a1.25 1.25 0 0 0-1.25 1.25V10a.625.625 0 0 0 1.25 0V3.125h6.875v3.75a.625.625 0 0 0 .625.625h3.75v9.375h-2.5a.625.625 0 0 0 0 1.25h2.5a1.25 1.25 0 0 0 1.25-1.25v-10a.633.633 0 0 0-.18-.445ZM12.5 4.008l2.242 2.242H12.5V4.008Zm-2.5 9.43h-.625v-.313a2.187 2.187 0 1 0-4.375 0v.313h-.625a.625.625 0 0 0-.625.624V17.5a.625.625 0 0 0 .625.625H10a.625.625 0 0 0 .625-.625v-3.438a.624.624 0 0 0-.625-.624Zm-1.875 0H6.25v-.313a.937.937 0 0 1 1.875 0v.313Z",
            fill: "currentColor"
        })
    });
var $452c2753598bf078$export$2e2bcd8739ae039 = $452c2753598bf078$var$SvgFileLock;



parcelRequire("2gcPZ");
const $01b7d130b8db3e50$var$SvgFileMinus = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.695 6.43 12.32 2.055a.633.633 0 0 0-.445-.18h-7.5a1.25 1.25 0 0 0-1.25 1.25v13.75a1.25 1.25 0 0 0 1.25 1.25h11.25a1.25 1.25 0 0 0 1.25-1.25v-10a.633.633 0 0 0-.18-.445Zm-4.82 6.07h-3.75a.625.625 0 1 1 0-1.25h3.75a.625.625 0 0 1 0 1.25Zm0-5.625V3.383l3.492 3.492h-3.492Z",
            fill: "currentColor"
        })
    });
var $01b7d130b8db3e50$export$2e2bcd8739ae039 = $01b7d130b8db3e50$var$SvgFileMinus;



parcelRequire("2gcPZ");
const $a8f1ad042cf86047$var$SvgFilePdf = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M5 12.5H3.75a.625.625 0 0 0-.625.625v3.75a.625.625 0 0 0 1.25 0v-.625H5a1.875 1.875 0 1 0 0-3.75ZM5 15h-.625v-1.25H5A.625.625 0 0 1 5 15Zm10.313-1.25v.938h1.25a.625.625 0 0 1 0 1.25h-1.25v.937a.625.625 0 1 1-1.25 0v-3.75a.624.624 0 0 1 .624-.625h2.188a.625.625 0 0 1 0 1.25h-1.563ZM10 12.5H8.906a.625.625 0 0 0-.625.625v3.75a.625.625 0 0 0 .625.625H10a2.5 2.5 0 0 0 0-5Zm0 3.75h-.469v-2.5H10a1.25 1.25 0 0 1 0 2.5Zm-6.25-5.625h12.5a.625.625 0 0 0 .625-.625V6.875a.633.633 0 0 0-.18-.445L12.32 2.055a.633.633 0 0 0-.445-.18h-7.5a1.25 1.25 0 0 0-1.25 1.25V10a.625.625 0 0 0 .625.625Zm8.125-7.187 3.438 3.437h-3.438V3.438Z",
            fill: "currentColor"
        })
    });
var $a8f1ad042cf86047$export$2e2bcd8739ae039 = $a8f1ad042cf86047$var$SvgFilePdf;



parcelRequire("2gcPZ");
const $cbbf6c8675c526c4$var$SvgFilePlus = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.695 6.43 12.32 2.055a.633.633 0 0 0-.445-.18h-7.5a1.25 1.25 0 0 0-1.25 1.25v13.75a1.25 1.25 0 0 0 1.25 1.25h11.25a1.25 1.25 0 0 0 1.25-1.25v-10a.633.633 0 0 0-.18-.445Zm-4.82 6.07h-1.25v1.25a.625.625 0 1 1-1.25 0V12.5h-1.25a.625.625 0 1 1 0-1.25h1.25V10a.625.625 0 0 1 1.25 0v1.25h1.25a.625.625 0 0 1 0 1.25Zm0-5.625V3.383l3.492 3.492h-3.492Z",
            fill: "currentColor"
        })
    });
var $cbbf6c8675c526c4$export$2e2bcd8739ae039 = $cbbf6c8675c526c4$var$SvgFilePlus;



parcelRequire("2gcPZ");
const $e003bbd9142be2ed$var$SvgFilePng = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M4.688 12.5h-1.25a.625.625 0 0 0-.626.625v3.75a.625.625 0 0 0 1.25 0v-.625h.625a1.875 1.875 0 1 0 0-3.75Zm0 2.5h-.625v-1.25h.625a.625.625 0 0 1 0 1.25Zm7.187-1.875v3.75a.625.625 0 0 1-1.125.375L9.062 15v1.875a.625.625 0 0 1-1.25 0v-3.75a.625.625 0 0 1 1.125-.375L10.626 15v-1.875a.624.624 0 1 1 1.25 0Zm5.625 2.953a.586.586 0 0 1-.102.336 2.296 2.296 0 0 1-1.93 1.086c-1.288 0-2.343-1.125-2.343-2.5s1.055-2.5 2.344-2.5c.466.001.92.149 1.297.422a.625.625 0 0 1-.72 1.015.985.985 0 0 0-.577-.187c-.602 0-1.094.563-1.094 1.25 0 .688.492 1.25 1.094 1.25a1.038 1.038 0 0 0 .781-.375v-.094h-.313a.625.625 0 0 1 0-1.25h.938a.625.625 0 0 1 .625.625v.922ZM3.75 10.625h12.5a.625.625 0 0 0 .625-.625V6.875a.633.633 0 0 0-.18-.445L12.32 2.055a.633.633 0 0 0-.445-.18h-7.5a1.25 1.25 0 0 0-1.25 1.25V10a.625.625 0 0 0 .625.625Zm8.125-7.187 3.438 3.437h-3.438V3.438Z",
            fill: "currentColor"
        })
    });
var $e003bbd9142be2ed$export$2e2bcd8739ae039 = $e003bbd9142be2ed$var$SvgFilePng;



parcelRequire("2gcPZ");
const $0ca7003438806bbf$var$SvgFilePpt = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.695 6.43 12.32 2.055a.633.633 0 0 0-.445-.18h-7.5a1.25 1.25 0 0 0-1.25 1.25V10a.625.625 0 0 0 .625.625h12.5a.625.625 0 0 0 .625-.625V6.875a.633.633 0 0 0-.18-.445Zm-4.82.445V3.438l3.438 3.437h-3.438ZM5 12.5H3.75a.625.625 0 0 0-.625.625v3.75a.625.625 0 0 0 1.25 0v-.625H5a1.875 1.875 0 1 0 0-3.75ZM5 15h-.625v-1.25H5A.625.625 0 0 1 5 15Zm5-2.5H8.75a.625.625 0 0 0-.625.625v3.75a.625.625 0 0 0 1.25 0v-.625H10a1.875 1.875 0 1 0 0-3.75Zm0 2.5h-.625v-1.25H10A.625.625 0 0 1 10 15Zm6.875-1.875a.625.625 0 0 1-.625.625h-.781v3.125a.625.625 0 0 1-1.25 0V13.75h-.781a.625.625 0 1 1 0-1.25h2.812a.625.625 0 0 1 .625.625Z",
            fill: "currentColor"
        })
    });
var $0ca7003438806bbf$export$2e2bcd8739ae039 = $0ca7003438806bbf$var$SvgFilePpt;



parcelRequire("2gcPZ");
const $7481ec526a5f75de$var$SvgFileRs = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M6.258 15.766A1.875 1.875 0 0 0 5 12.5H3.75a.625.625 0 0 0-.625.625v3.75a.625.625 0 0 0 1.25 0v-.625h.703l.649.969a.617.617 0 0 0 .523.281.609.609 0 0 0 .516-.274.625.625 0 0 0 0-.695l-.508-.765ZM5 15h-.625v-1.25H5A.625.625 0 0 1 5 15Zm6.875.938c0 1.023-.727 1.64-1.953 1.64a2.61 2.61 0 0 1-1.57-.531.593.593 0 0 1-.227-.485.625.625 0 0 1 1.023-.484h-.007c.23.158.502.244.78.25.704 0 .704-.234.704-.39 0-.157 0-.07-.094-.126-.094-.054-.453-.171-.719-.242-.671-.18-1.687-.453-1.687-1.508 0-1.054.742-1.64 1.797-1.64a2.61 2.61 0 0 1 1.57.531.594.594 0 0 1 .227.485.625.625 0 0 1-1.024.484h.008a1.437 1.437 0 0 0-.781-.25c-.36 0-.547.133-.547.39v.016c.086.102.516.219.758.281.648.172 1.742.461 1.742 1.579Zm4.82-9.508L12.32 2.055a.633.633 0 0 0-.445-.18h-7.5a1.25 1.25 0 0 0-1.25 1.25V10a.625.625 0 0 0 .625.625h9.375a.625.625 0 0 1 .625.625v6.25a.625.625 0 0 0 .625.625h1.25a1.25 1.25 0 0 0 1.25-1.25v-10a.633.633 0 0 0-.18-.445Zm-4.82.445V3.438l3.438 3.437h-3.438Z",
            fill: "currentColor"
        })
    });
var $7481ec526a5f75de$export$2e2bcd8739ae039 = $7481ec526a5f75de$var$SvgFileRs;



parcelRequire("2gcPZ");
const $2c31d0ed4c113830$var$SvgFileSearch = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M16.688 6.43 12.32 2.055l-.023-.016-.024-.023L12.25 2l-.023-.016c-.008-.007-.016-.007-.016-.015l-.04-.024h-.015l-.039-.023h-.008l-.054-.024h-7.68a1.25 1.25 0 0 0-1.25 1.227v13.75a1.25 1.25 0 0 0 1.25 1.25h11.25a1.25 1.25 0 0 0 1.25-1.25v-10a.61.61 0 0 0-.188-.445Zm-3.766 8.375a.625.625 0 0 1-.438.18.648.648 0 0 1-.445-.18l-.851-.86c-.451.28-.97.428-1.5.43a2.813 2.813 0 1 1 2.812-2.813c.002.531-.147 1.051-.43 1.5l.852.852a.624.624 0 0 1 0 .89Zm-1.047-7.93V3.383l3.492 3.492h-3.492Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M9.687 10a1.554 1.554 0 0 0-1.101.46 1.547 1.547 0 0 0 0 2.204 1.555 1.555 0 0 0 2.203 0 1.546 1.546 0 0 0 0-2.203A1.555 1.555 0 0 0 9.687 10Z",
                fill: "currentColor"
            })
        ]
    });
var $2c31d0ed4c113830$export$2e2bcd8739ae039 = $2c31d0ed4c113830$var$SvgFileSearch;



parcelRequire("2gcPZ");
const $650b5b4205a01ce7$var$SvgFiles = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.695 5.18 13.57 2.055a.633.633 0 0 0-.445-.18h-6.25a1.25 1.25 0 0 0-1.25 1.25v1.25h-1.25a1.25 1.25 0 0 0-1.25 1.25v11.25a1.25 1.25 0 0 0 1.25 1.25h8.75a1.25 1.25 0 0 0 1.25-1.25v-1.25h1.25a1.25 1.25 0 0 0 1.25-1.25v-8.75a.633.633 0 0 0-.18-.445ZM10.625 15h-3.75a.625.625 0 1 1 0-1.25h3.75a.625.625 0 0 1 0 1.25Zm0-2.5h-3.75a.625.625 0 1 1 0-1.25h3.75a.625.625 0 0 1 0 1.25Zm5 1.875h-1.25v-6.25a.633.633 0 0 0-.18-.445L11.07 4.555a.633.633 0 0 0-.445-.18h-3.75v-1.25h5.992l2.758 2.758v8.492Z",
            fill: "currentColor"
        })
    });
var $650b5b4205a01ce7$export$2e2bcd8739ae039 = $650b5b4205a01ce7$var$SvgFiles;



parcelRequire("2gcPZ");
const $b0ddcbbb86f9113a$var$SvgFileText = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.695 6.43 12.32 2.055a.633.633 0 0 0-.445-.18h-7.5a1.25 1.25 0 0 0-1.25 1.25v13.75a1.25 1.25 0 0 0 1.25 1.25h11.25a1.25 1.25 0 0 0 1.25-1.25v-10a.633.633 0 0 0-.18-.445ZM12.5 13.75h-5a.625.625 0 1 1 0-1.25h5a.625.625 0 0 1 0 1.25Zm0-2.5h-5a.625.625 0 1 1 0-1.25h5a.625.625 0 0 1 0 1.25Zm-.625-4.375V3.438l3.438 3.437h-3.438Z",
            fill: "currentColor"
        })
    });
var $b0ddcbbb86f9113a$export$2e2bcd8739ae039 = $b0ddcbbb86f9113a$var$SvgFileText;



parcelRequire("2gcPZ");
const $abe136a760fb49eb$var$SvgFileTs = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M7.188 13.125a.625.625 0 0 1-.625.625H5.78v3.125a.625.625 0 0 1-1.25 0V13.75H3.75a.625.625 0 1 1 0-1.25h2.813a.625.625 0 0 1 .625.625Zm2.945 1.234c-.242-.062-.672-.18-.758-.28v-.017c0-.257.188-.39.547-.39.279.006.55.092.781.25h-.008c.114.09.254.14.399.14a.625.625 0 0 0 .567-.89.594.594 0 0 0-.169-.211 2.61 2.61 0 0 0-1.57-.54c-1.055 0-1.797.673-1.797 1.642 0 .968 1.016 1.328 1.688 1.507.265.07.546.14.718.242.172.102.094.079.094.126 0 .046 0 .39-.703.39a1.437 1.437 0 0 1-.781-.25h.007a.625.625 0 0 0-.966.75c.04.082.098.155.17.211a2.61 2.61 0 0 0 1.57.54c1.226 0 1.953-.618 1.953-1.642 0-1.023-1.094-1.406-1.742-1.578Zm6.742-7.484v10a1.25 1.25 0 0 1-1.25 1.25h-1.25a.625.625 0 0 1-.625-.625v-6.25a.624.624 0 0 0-.625-.625H3.75A.625.625 0 0 1 3.125 10V3.125a1.25 1.25 0 0 1 1.25-1.25h7.5c.166 0 .326.064.445.18l4.375 4.375c.116.119.18.279.18.445Zm-1.563 0-3.437-3.437v3.437h3.438Z",
            fill: "currentColor"
        })
    });
var $abe136a760fb49eb$export$2e2bcd8739ae039 = $abe136a760fb49eb$var$SvgFileTs;



parcelRequire("2gcPZ");
const $a81c128a7340fc31$var$SvgFileTsx = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.695 6.43 12.32 2.055a.633.633 0 0 0-.445-.18h-7.5a1.25 1.25 0 0 0-1.25 1.25V10a.625.625 0 0 0 .625.625h12.5a.625.625 0 0 0 .625-.625V6.875a.633.633 0 0 0-.18-.445Zm-4.82.445V3.438l3.438 3.437h-3.438Zm-4.688 6.25a.625.625 0 0 1-.625.625h-.78v3.125a.625.625 0 0 1-1.25 0V13.75H3.75a.625.625 0 1 1 0-1.25h2.813a.625.625 0 0 1 .625.625Zm9.563.375L15.625 15l1.125 1.5a.625.625 0 0 1-1 .75l-.906-1.21-.906 1.21a.625.625 0 0 1-.876.125.633.633 0 0 1-.124-.875l1.124-1.5-1.124-1.5a.633.633 0 0 1 .124-.875.625.625 0 0 1 .876.125l.906 1.21.906-1.21a.623.623 0 0 1 .875-.125.625.625 0 0 1 .125.875Zm-4.875 2.438c0 1.023-.727 1.64-1.953 1.64a2.61 2.61 0 0 1-1.57-.531.593.593 0 0 1-.227-.485.625.625 0 0 1 1.023-.484h-.007c.23.158.502.244.78.25.704 0 .704-.234.704-.39 0-.157 0-.07-.094-.126-.094-.054-.453-.171-.719-.242-.671-.18-1.687-.453-1.687-1.508 0-1.054.742-1.64 1.797-1.64a2.61 2.61 0 0 1 1.57.531.594.594 0 0 1 .227.485.625.625 0 0 1-1.024.484h.008a1.437 1.437 0 0 0-.781-.25c-.36 0-.547.133-.547.39v.016c.086.102.516.219.758.281.648.172 1.742.461 1.742 1.579Z",
            fill: "currentColor"
        })
    });
var $a81c128a7340fc31$export$2e2bcd8739ae039 = $a81c128a7340fc31$var$SvgFileTsx;



parcelRequire("2gcPZ");
const $00f3490931a15bc2$var$SvgFileVideo = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M11.875 12.813v3.843a.632.632 0 0 1-.352.563.618.618 0 0 1-.656-.07l-1.492-1.172v.273a1.25 1.25 0 0 1-1.25 1.25H3.75a1.25 1.25 0 0 1-1.25-1.25v-3.125a1.25 1.25 0 0 1 1.25-1.25h4.375a1.25 1.25 0 0 1 1.25 1.25v.313l1.5-1.126a.626.626 0 0 1 1 .5Zm5-5.938v10a1.25 1.25 0 0 1-1.25 1.25h-2.5a.625.625 0 1 1 0-1.25h2.5V7.5h-3.75a.625.625 0 0 1-.625-.625v-3.75H4.375v6.25a.625.625 0 0 1-1.25 0v-6.25a1.25 1.25 0 0 1 1.25-1.25h7.5c.166 0 .326.064.445.18l4.375 4.375c.116.119.18.279.18.445Zm-2.133-.625L12.5 4.008V6.25h2.242Z",
            fill: "currentColor"
        })
    });
var $00f3490931a15bc2$export$2e2bcd8739ae039 = $00f3490931a15bc2$var$SvgFileVideo;



parcelRequire("2gcPZ");
const $b784cae3c7c0d32e$var$SvgFileVue = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M14.687 13.75v.625h1.25a.625.625 0 0 1 0 1.25h-1.25v.625h1.563a.625.625 0 0 1 0 1.25h-2.188a.625.625 0 0 1-.625-.625v-3.75a.625.625 0 0 1 .625-.625h2.188a.625.625 0 0 1 0 1.25h-1.563Zm-7.882-1.203a.623.623 0 0 0-.82.336L5 15.25l-.985-2.367a.627.627 0 0 0-1.156.484l1.563 3.75a.625.625 0 0 0 1.156 0l1.562-3.75a.625.625 0 0 0-.335-.82Zm4.757-.047a.625.625 0 0 0-.625.625v2.344a.781.781 0 0 1-1.562 0v-2.344a.625.625 0 1 0-1.25 0v2.344a2.031 2.031 0 0 0 4.062 0v-2.344a.625.625 0 0 0-.625-.625Zm5.313-5.625V10a.625.625 0 0 1-.625.625H3.75A.625.625 0 0 1 3.125 10V3.125a1.25 1.25 0 0 1 1.25-1.25h7.5c.166 0 .326.064.445.18l4.375 4.375c.116.119.18.279.18.445Zm-1.563 0-3.437-3.437v3.437h3.437Z",
            fill: "currentColor"
        })
    });
var $b784cae3c7c0d32e$export$2e2bcd8739ae039 = $b784cae3c7c0d32e$var$SvgFileVue;



parcelRequire("2gcPZ");
const $a762ec26c5193881$var$SvgFileX = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.695 6.43 12.32 2.055a.633.633 0 0 0-.445-.18h-7.5a1.25 1.25 0 0 0-1.25 1.25v13.75a1.25 1.25 0 0 0 1.25 1.25h11.25a1.25 1.25 0 0 0 1.25-1.25v-10a.633.633 0 0 0-.18-.445Zm-4.375 6.875a.633.633 0 0 1 0 .89.64.64 0 0 1-.89 0L10 12.758l-1.43 1.437a.64.64 0 0 1-.89 0 .633.633 0 0 1 0-.89l1.437-1.43-1.437-1.43a.633.633 0 0 1 .89-.89L10 10.992l1.43-1.437a.633.633 0 0 1 .89.89l-1.437 1.43 1.437 1.43Zm-.445-6.43V3.438l3.438 3.437h-3.438Z",
            fill: "currentColor"
        })
    });
var $a762ec26c5193881$export$2e2bcd8739ae039 = $a762ec26c5193881$var$SvgFileX;



parcelRequire("2gcPZ");
const $6a236f631ded7f60$var$SvgFileXls = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M7.375 13.5 6.25 15l1.125 1.5a.625.625 0 1 1-1 .75l-.906-1.21-.907 1.21a.625.625 0 0 1-1-.75L4.688 15l-1.125-1.5a.625.625 0 0 1 1-.75l.906 1.21.906-1.21a.625.625 0 1 1 1 .75Zm4.188 2.75H10v-3.125a.625.625 0 1 0-1.25 0v3.75a.625.625 0 0 0 .625.625h2.188a.625.625 0 1 0 0-1.25Zm3.57-1.89c-.242-.063-.672-.18-.758-.282v-.015c0-.258.188-.391.547-.391.279.006.55.092.781.25h-.008c.114.09.254.14.399.14a.625.625 0 0 0 .567-.89.594.594 0 0 0-.169-.211 2.61 2.61 0 0 0-1.57-.54c-1.055 0-1.797.673-1.797 1.642 0 .968 1.016 1.328 1.688 1.507.265.07.546.14.718.242.172.102.094.079.094.126 0 .046 0 .39-.703.39a1.437 1.437 0 0 1-.781-.25h.007a.625.625 0 0 0-.966.75c.04.082.098.155.17.211a2.61 2.61 0 0 0 1.57.54c1.226 0 1.953-.618 1.953-1.642 0-1.023-1.094-1.406-1.742-1.578Zm1.742-7.485V10a.625.625 0 0 1-.625.625H3.75A.625.625 0 0 1 3.125 10V3.125a1.25 1.25 0 0 1 1.25-1.25h7.5c.166 0 .326.064.445.18l4.375 4.375c.116.119.18.279.18.445Zm-1.563 0-3.437-3.437v3.437h3.438Z",
            fill: "currentColor"
        })
    });
var $6a236f631ded7f60$export$2e2bcd8739ae039 = $6a236f631ded7f60$var$SvgFileXls;



parcelRequire("2gcPZ");
const $be7110859a24df1c$var$SvgFileZip = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M14.375 12.5h-1.25a.625.625 0 0 0-.625.625v3.75a.625.625 0 1 0 1.25 0v-.625h.625a1.875 1.875 0 1 0 0-3.75Zm0 2.5h-.625v-1.25h.625a.625.625 0 0 1 0 1.25ZM7.5 16.875a.625.625 0 0 1-.625.625h-2.5a.625.625 0 0 1-.555-.328.649.649 0 0 1 .032-.64L5.71 13.75H4.375a.625.625 0 1 1 0-1.25h2.5a.626.626 0 0 1 .555.328.649.649 0 0 1-.032.64L5.54 16.25h1.336a.625.625 0 0 1 .625.625Zm3.125-3.75v3.75a.625.625 0 1 1-1.25 0v-3.75a.625.625 0 1 1 1.25 0Zm6.07-6.695L12.32 2.055a.633.633 0 0 0-.445-.18h-7.5a1.25 1.25 0 0 0-1.25 1.25V10a.625.625 0 0 0 .625.625h12.5a.625.625 0 0 0 .625-.625V6.875a.633.633 0 0 0-.18-.445Zm-4.82.445V3.438l3.438 3.437h-3.438Z",
            fill: "currentColor"
        })
    });
var $be7110859a24df1c$export$2e2bcd8739ae039 = $be7110859a24df1c$var$SvgFileZip;



parcelRequire("2gcPZ");
const $c017c6c62e4c34b3$var$SvgFire = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 21,
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M17.18 11.438a7.188 7.188 0 0 1-14.375 0c0-1.805.773-3.883 2.296-6.18a.625.625 0 0 1 .391-.266.64.64 0 0 1 .477.094l2.515 1.68 2.414-5.063a.617.617 0 0 1 .453-.344.633.633 0 0 1 .555.172c1.149 1.149 2.461 2.547 3.484 4.172 1.204 1.914 1.79 3.79 1.79 5.734Z",
            fill: "currentColor"
        })
    });
var $c017c6c62e4c34b3$export$2e2bcd8739ae039 = $c017c6c62e4c34b3$var$SvgFire;



parcelRequire("2gcPZ");
const $3c3d27c97f5ae700$var$SvgFloppyDiskBack = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.25 2.5h-2.813a.313.313 0 0 0-.312.313V6.25a.625.625 0 0 1-.625.625H7.523a.64.64 0 0 1-.648-.586.625.625 0 0 1 .625-.664h4.375V2.812a.312.312 0 0 0-.313-.312h-4.43a1.242 1.242 0 0 0-.882.367L2.867 6.25a1.242 1.242 0 0 0-.367.883v9.117a1.25 1.25 0 0 0 1.25 1.25h12.5a1.25 1.25 0 0 0 1.25-1.25V3.75a1.25 1.25 0 0 0-1.25-1.25ZM10 13.75a2.187 2.187 0 1 1 2.188-2.188A2.195 2.195 0 0 1 10 13.75Z",
            fill: "currentColor"
        })
    });
var $3c3d27c97f5ae700$export$2e2bcd8739ae039 = $3c3d27c97f5ae700$var$SvgFloppyDiskBack;



parcelRequire("2gcPZ");
const $80b47dfe2a3d87cc$var$SvgFloppyDisk = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M17.133 6.25 13.75 2.867a1.242 1.242 0 0 0-.883-.367H3.75A1.25 1.25 0 0 0 2.5 3.75v12.5a1.25 1.25 0 0 0 1.25 1.25h12.5a1.25 1.25 0 0 0 1.25-1.25V7.133a1.242 1.242 0 0 0-.367-.883Zm-.883.883v9.117h-1.875v-4.375a1.25 1.25 0 0 0-1.25-1.25h-6.25a1.25 1.25 0 0 0-1.25 1.25v4.375H3.75V3.75h9.117l3.383 3.383ZM12.5 5.625a.625.625 0 0 1-.625.625H7.5A.625.625 0 0 1 7.5 5h4.375a.625.625 0 0 1 .625.625Z",
            fill: "currentColor"
        })
    });
var $80b47dfe2a3d87cc$export$2e2bcd8739ae039 = $80b47dfe2a3d87cc$var$SvgFloppyDisk;



parcelRequire("2gcPZ");
const $a7f6a82b52184a78$var$SvgFolderDotted = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M7.5 16.25a.625.625 0 0 1-.625.625H3.078a1.203 1.203 0 0 1-1.203-1.203V15a.625.625 0 1 1 1.25 0v.625h3.75a.625.625 0 0 1 .625.625Zm5-.625H10a.625.625 0 1 0 0 1.25h2.5a.624.624 0 1 0 0-1.25Zm5-4.375a.624.624 0 0 0-.625.625v3.75h-1.25a.624.624 0 1 0 0 1.25h1.32a1.187 1.187 0 0 0 1.18-1.18v-3.82a.624.624 0 0 0-.625-.625Zm-.625-5.625h-3.75a.625.625 0 1 0 0 1.25h3.75V8.75a.625.625 0 1 0 1.25 0V6.875a1.25 1.25 0 0 0-1.25-1.25ZM2.5 6.875H10a.625.625 0 0 0 .578-.383.656.656 0 0 0-.133-.687l-2.32-2.313a1.242 1.242 0 0 0-.883-.367H3.125a1.25 1.25 0 0 0-1.25 1.25V6.25a.625.625 0 0 0 .625.625Zm0 5.625a.625.625 0 0 0 .625-.625v-2.5a.625.625 0 0 0-1.25 0v2.5a.625.625 0 0 0 .625.625Z",
            fill: "currentColor"
        })
    });
var $a7f6a82b52184a78$export$2e2bcd8739ae039 = $a7f6a82b52184a78$var$SvgFolderDotted;



parcelRequire("2gcPZ");
const $37ae730f6f90c9ef$var$SvgFolderDuotone = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M16 16H4V6h14a2 2 0 0 0-2-2H8a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-1.999v-10l-2-1.224V16Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                opacity: 0.2,
                fill: "currentColor",
                d: "M4 6h12v10H4z"
            })
        ]
    });
var $37ae730f6f90c9ef$export$2e2bcd8739ae039 = $37ae730f6f90c9ef$var$SvgFolderDuotone;



parcelRequire("2gcPZ");
const $2d3aaa4370969daf$var$SvgFolder = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16 16H4V6h14a2 2 0 0 0-2-2H8a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-1.999v-10h-2V16Z",
            fill: "currentColor"
        })
    });
var $2d3aaa4370969daf$export$2e2bcd8739ae039 = $2d3aaa4370969daf$var$SvgFolder;



parcelRequire("2gcPZ");
const $89b384198ed92943$var$SvgFolderLock = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M17.5 12.188h-.625v-.313a2.188 2.188 0 0 0-4.375 0v.313h-.625a.624.624 0 0 0-.625.624v3.438a.624.624 0 0 0 .625.625H17.5a.624.624 0 0 0 .625-.625v-3.438a.624.624 0 0 0-.625-.624Zm-3.75-.313a.938.938 0 0 1 1.875 0v.313H13.75v-.313Zm3.125-6.25h-6.617L8.125 3.492a1.242 1.242 0 0 0-.883-.367H3.125a1.25 1.25 0 0 0-1.25 1.25v11.297a1.203 1.203 0 0 0 1.203 1.203h5.719a.625.625 0 1 0 0-1.25H3.125v-8.75h13.75v1.25a.625.625 0 1 0 1.25 0v-1.25a1.25 1.25 0 0 0-1.25-1.25Zm-9.633-1.25 1.25 1.25H3.125v-1.25h4.117Z",
            fill: "currentColor"
        })
    });
var $89b384198ed92943$export$2e2bcd8739ae039 = $89b384198ed92943$var$SvgFolderLock;



parcelRequire("2gcPZ");
const $4b3c96f12b642597$var$SvgFolderOpenDuotone = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                opacity: 0.2,
                d: "M16 6H4v2h9v8h3V6Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6 2a2 2 0 0 1 2 2h8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h2Zm10 4H4v2h9a2 2 0 0 1 2 2v6h1V6ZM4 16v-6h9v6H4Z",
                fill: "currentColor"
            })
        ]
    });
var $4b3c96f12b642597$export$2e2bcd8739ae039 = $4b3c96f12b642597$var$SvgFolderOpenDuotone;



parcelRequire("2gcPZ");
const $a2fb66ccc1ab8780$var$SvgFolderOpen = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6 2a2 2 0 0 1 2 2h8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h2Zm10 4H4v2h9a2 2 0 0 1 2 2v6h1V6ZM4 16v-6h9v6H4Z",
            fill: "currentColor"
        })
    });
var $a2fb66ccc1ab8780$export$2e2bcd8739ae039 = $a2fb66ccc1ab8780$var$SvgFolderOpen;



parcelRequire("2gcPZ");
const $7c69e6f6ff2d1eea$var$SvgFolderPlus = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.875 5.625h-6.617L8.125 3.492a1.258 1.258 0 0 0-.883-.367H3.125a1.25 1.25 0 0 0-1.25 1.25v11.297a1.203 1.203 0 0 0 1.203 1.203h13.867a1.187 1.187 0 0 0 1.18-1.18v-8.82a1.25 1.25 0 0 0-1.25-1.25Zm-13.75-1.25h4.117l1.25 1.25H3.125v-1.25Zm8.75 7.5h-1.25v1.25a.624.624 0 1 1-1.25 0v-1.25h-1.25a.625.625 0 1 1 0-1.25h1.25v-1.25a.625.625 0 0 1 1.25 0v1.25h1.25a.624.624 0 1 1 0 1.25Z",
            fill: "currentColor"
        })
    });
var $7c69e6f6ff2d1eea$export$2e2bcd8739ae039 = $7c69e6f6ff2d1eea$var$SvgFolderPlus;



parcelRequire("2gcPZ");
const $7d11f6be51550742$var$SvgFolders = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M17.5 5h-5.414L9.914 3.375a1.219 1.219 0 0 0-.75-.25H5.625a1.25 1.25 0 0 0-1.25 1.25v1.25h-1.25a1.25 1.25 0 0 0-1.25 1.25v8.75a1.25 1.25 0 0 0 1.25 1.25H15.07a1.187 1.187 0 0 0 1.18-1.18v-1.32h1.32a1.187 1.187 0 0 0 1.18-1.18V6.25A1.25 1.25 0 0 0 17.5 5Zm0 8.125h-1.25V8.75A1.25 1.25 0 0 0 15 7.5H9.586L7.414 5.875a1.219 1.219 0 0 0-.75-.25H5.625v-1.25h3.54L11.334 6c.216.164.48.252.75.25H17.5v6.875Z",
            fill: "currentColor"
        })
    });
var $7d11f6be51550742$export$2e2bcd8739ae039 = $7d11f6be51550742$var$SvgFolders;



parcelRequire("2gcPZ");
const $9c6352268b4745af$var$SvgFolderSimple = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.875 5.625h-6.664L8.039 4a1.219 1.219 0 0 0-.75-.25H3.125A1.25 1.25 0 0 0 1.875 5v10.625a1.25 1.25 0 0 0 1.25 1.25h13.82a1.187 1.187 0 0 0 1.18-1.18v-8.82a1.25 1.25 0 0 0-1.25-1.25Z",
            fill: "currentColor"
        })
    });
var $9c6352268b4745af$export$2e2bcd8739ae039 = $9c6352268b4745af$var$SvgFolderSimple;



parcelRequire("2gcPZ");
const $7e12deb9ebd58487$var$SvgFramerLogo = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.25 7.813V2.5a.625.625 0 0 0-.625-.625H4.375a.625.625 0 0 0-.43 1.078L8.43 7.188H4.375a.625.625 0 0 0-.625.625v5.312a.617.617 0 0 0 .195.453l5.625 5.313a.64.64 0 0 0 .43.172.577.577 0 0 0 .25-.055.616.616 0 0 0 .375-.57V13.75h5a.625.625 0 0 0 .43-1.078L11.57 8.437h4.055a.625.625 0 0 0 .625-.624Z",
            fill: "currentColor"
        })
    });
var $7e12deb9ebd58487$export$2e2bcd8739ae039 = $7e12deb9ebd58487$var$SvgFramerLogo;



parcelRequire("2gcPZ");
const $61a83cc33faf6bde$var$SvgFunctionDuotone = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                opacity: 0.2,
                d: "M16 4H4v12h12V4Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M4 3.998A2 2 0 0 1 6 2h2v2H4.004v11.998a2 2 0 0 1-2-2v-8a2 2 0 0 1 1.996-2ZM8 18H6a2 2 0 0 1-2-2h4v2ZM16 16V4.003a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2A2 2 0 0 1 14 18h-2v-2h4ZM12 2h2a2 2 0 0 1 2 2h-4V2Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M14 12H9v2h5v-2ZM6 12h2v2H6v-2ZM14 9H6v2h8V9ZM6 6h5v2H6V6ZM14 6h-2v2h2V6Z",
                fill: "currentColor"
            })
        ]
    });
var $61a83cc33faf6bde$export$2e2bcd8739ae039 = $61a83cc33faf6bde$var$SvgFunctionDuotone;



parcelRequire("2gcPZ");
const $e46037ed7b305d65$var$SvgFunction = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M12 18v-2h4V4.003a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2A2 2 0 0 1 14 18h-2ZM12 2h2a2 2 0 0 1 2 2h-4V2ZM4 3.998A2 2 0 0 1 6 2h2v2H4.004v11.998a2 2 0 0 1-2-2v-8a2 2 0 0 1 1.996-2ZM8 18H6a2 2 0 0 1-2-2h4v2Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M14 12H9v2h5v-2ZM6 12h2v2H6v-2ZM14 9H6v2h8V9ZM6 6h5v2H6V6ZM14 6h-2v2h2V6Z",
                fill: "currentColor"
            })
        ]
    });
var $e46037ed7b305d65$export$2e2bcd8739ae039 = $e46037ed7b305d65$var$SvgFunction;



parcelRequire("2gcPZ");
const $6c9de372d764eb36$var$SvgFunnel = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M17.852 3.867a1.242 1.242 0 0 0-1.141-.742H3.289a1.258 1.258 0 0 0-.93 2.094l5.14 5.648v6.094a1.242 1.242 0 0 0 .665 1.102A1.25 1.25 0 0 0 9.445 18l2.5-1.672a1.241 1.241 0 0 0 .555-1.039v-4.422l5.14-5.648a1.242 1.242 0 0 0 .212-1.352Z",
            fill: "currentColor"
        })
    });
var $6c9de372d764eb36$export$2e2bcd8739ae039 = $6c9de372d764eb36$var$SvgFunnel;



parcelRequire("2gcPZ");
const $cd2b1705e20141ff$var$SvgFunnelSimple = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M15 9.375H5a.625.625 0 0 0 0 1.25h10a.624.624 0 1 0 0-1.25ZM18.125 5.625H1.875a.625.625 0 0 0 0 1.25h16.25a.625.625 0 1 0 0-1.25ZM11.875 13.125h-3.75a.625.625 0 1 0 0 1.25h3.75a.624.624 0 1 0 0-1.25Z",
            fill: "currentColor"
        })
    });
var $cd2b1705e20141ff$export$2e2bcd8739ae039 = $cd2b1705e20141ff$var$SvgFunnelSimple;



parcelRequire("2gcPZ");
const $4081b0ca085a7188$var$SvgGearSix = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M18.555 8.148a.624.624 0 0 0-.313-.414l-1.86-1.03a5.815 5.815 0 0 0-.327-.587l.031-2.125a.65.65 0 0 0-.203-.476 8.75 8.75 0 0 0-3.211-1.852.633.633 0 0 0-.516.063l-1.82 1.093a9.638 9.638 0 0 0-.672 0l-1.82-1.093a.633.633 0 0 0-.516-.063 8.68 8.68 0 0 0-3.21 1.86.617.617 0 0 0-.204.468l.04 2.125a7.198 7.198 0 0 0-.345.586L1.758 7.734a.601.601 0 0 0-.313.414 8.703 8.703 0 0 0 0 3.704.625.625 0 0 0 .313.414l1.86 1.03c.099.203.211.399.335.587l-.039 2.125a.649.649 0 0 0 .203.476 8.82 8.82 0 0 0 3.211 1.852.632.632 0 0 0 .516-.063l1.82-1.093h.672l1.828 1.093a.57.57 0 0 0 .32.094.785.785 0 0 0 .188-.031 8.679 8.679 0 0 0 3.21-1.86.618.618 0 0 0 .204-.468l-.031-2.125c.117-.188.226-.383.336-.586l1.859-1.031a.616.616 0 0 0 .305-.414 8.702 8.702 0 0 0 0-3.704ZM13.438 10a3.438 3.438 0 1 1-6.876 0 3.438 3.438 0 0 1 6.875 0Z",
            fill: "currentColor"
        })
    });
var $4081b0ca085a7188$export$2e2bcd8739ae039 = $4081b0ca085a7188$var$SvgGearSix;



parcelRequire("2gcPZ");
const $41ea0660b798dae0$var$SvgGitBranch = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M17.5 5.312a2.812 2.812 0 1 0-3.438 2.743v.07a1.25 1.25 0 0 1-1.25 1.25H7.189c-.44.001-.87.117-1.25.336V8.055a2.812 2.812 0 1 0-1.25 0v3.89a2.813 2.813 0 1 0 1.25 0v-.07a1.25 1.25 0 0 1 1.25-1.25h5.625a2.508 2.508 0 0 0 2.5-2.5v-.07A2.82 2.82 0 0 0 17.5 5.312Zm-13.75 0a1.563 1.563 0 1 1 1.563 1.563A1.57 1.57 0 0 1 3.75 5.312Zm3.125 9.375a1.563 1.563 0 1 1-1.562-1.562 1.57 1.57 0 0 1 1.562 1.563Z",
            fill: "currentColor"
        })
    });
var $41ea0660b798dae0$export$2e2bcd8739ae039 = $41ea0660b798dae0$var$SvgGitBranch;



parcelRequire("2gcPZ");
const $31f474745ccc55b9$var$SvgGitCommit = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M19.375 9.375h-4.727a4.687 4.687 0 0 0-9.289 0H.625a.625.625 0 1 0 0 1.25h4.734a4.687 4.687 0 0 0 9.29 0h4.726a.625.625 0 0 0 0-1.25Z",
            fill: "currentColor"
        })
    });
var $31f474745ccc55b9$export$2e2bcd8739ae039 = $31f474745ccc55b9$var$SvgGitCommit;



parcelRequire("2gcPZ");
const $d420d6151634778d$var$SvgGitDiff = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M18.125 14.688a2.813 2.813 0 1 1-3.438-2.743V9.367a3.124 3.124 0 0 0-.914-2.21l-1.898-1.9v1.618a.625.625 0 1 1-1.25 0V3.75a.625.625 0 0 1 .625-.625h3.125a.625.625 0 1 1 0 1.25h-1.617l1.898 1.898a4.338 4.338 0 0 1 1.281 3.094v2.578a2.82 2.82 0 0 1 2.188 2.742ZM8.75 12.5a.625.625 0 0 0-.625.625v1.617l-1.898-1.898a3.124 3.124 0 0 1-.914-2.211V8.055a2.813 2.813 0 1 0-1.25 0v2.578a4.336 4.336 0 0 0 1.28 3.094l1.9 1.898H5.624a.625.625 0 1 0 0 1.25H8.75a.625.625 0 0 0 .625-.625v-3.125a.625.625 0 0 0-.625-.625Z",
            fill: "currentColor"
        })
    });
var $d420d6151634778d$export$2e2bcd8739ae039 = $d420d6151634778d$var$SvgGitDiff;



parcelRequire("2gcPZ");
const $e855226857bcdfcf$var$SvgGitFork = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M17.5 5.312a2.812 2.812 0 1 0-3.438 2.743v.07a1.25 1.25 0 0 1-1.25 1.25H7.189a1.25 1.25 0 0 1-1.25-1.25v-.07a2.812 2.812 0 1 0-1.25 0v.07a2.508 2.508 0 0 0 2.5 2.5h2.187v1.32a2.813 2.813 0 1 0 1.25 0v-1.32h2.188a2.508 2.508 0 0 0 2.5-2.5v-.07A2.82 2.82 0 0 0 17.5 5.312Zm-5.938 9.375A1.563 1.563 0 1 1 10 13.126a1.57 1.57 0 0 1 1.563 1.563Z",
            fill: "currentColor"
        })
    });
var $e855226857bcdfcf$export$2e2bcd8739ae039 = $e855226857bcdfcf$var$SvgGitFork;



parcelRequire("2gcPZ");
const $32846c1f7fdf9868$var$SvgGithubLogoAlt = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.97 0C4.457 0 0 4.583 0 10.254c0 4.532 2.856 8.369 6.817 9.727.496.102.677-.221.677-.493 0-.237-.016-1.052-.016-1.9-2.774.61-3.351-1.223-3.351-1.223C3.68 15.177 3.02 14.87 3.02 14.87c-.908-.628.066-.628.066-.628 1.007.068 1.535 1.052 1.535 1.052.891 1.562 2.327 1.12 2.905.85.083-.663.347-1.121.627-1.376-2.212-.238-4.539-1.12-4.539-5.059 0-1.12.396-2.037 1.023-2.75-.099-.254-.445-1.307.1-2.716 0 0 .841-.272 2.74 1.052a9.402 9.402 0 0 1 2.492-.34c.842 0 1.7.12 2.493.34 1.898-1.324 2.74-1.052 2.74-1.052.545 1.409.198 2.462.099 2.716.644.713 1.023 1.63 1.023 2.75 0 3.939-2.327 4.804-4.556 5.06.364.322.677.933.677 1.9 0 1.375-.016 2.479-.016 2.818 0 .272.181.595.677.493 3.961-1.359 6.817-5.195 6.817-9.728C19.94 4.584 15.467 0 9.97 0Z",
            fill: "currentColor"
        })
    });
var $32846c1f7fdf9868$export$2e2bcd8739ae039 = $32846c1f7fdf9868$var$SvgGithubLogoAlt;



parcelRequire("2gcPZ");
const $71ea5417b708d912$var$SvgGithubLogo = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M17.5 17.5a.625.625 0 0 1-.625.625 2.508 2.508 0 0 1-2.5-2.5V15a1.25 1.25 0 0 0-1.25-1.25h-.938v3.125a1.25 1.25 0 0 0 1.25 1.25.625.625 0 1 1 0 1.25 2.508 2.508 0 0 1-2.5-2.5V13.75H9.063v3.125a2.508 2.508 0 0 1-2.5 2.5.625.625 0 0 1 0-1.25 1.25 1.25 0 0 0 1.25-1.25V13.75h-.938A1.25 1.25 0 0 0 5.625 15v.625a2.508 2.508 0 0 1-2.5 2.5.625.625 0 0 1 0-1.25 1.25 1.25 0 0 0 1.25-1.25V15a2.508 2.508 0 0 1 1.156-2.11A4.359 4.359 0 0 1 3.75 9.376V8.75a4.531 4.531 0 0 1 .602-2.211 4.68 4.68 0 0 1 .421-3.727.61.61 0 0 1 .54-.312 4.664 4.664 0 0 1 3.75 1.875h1.874a4.665 4.665 0 0 1 3.75-1.875.61.61 0 0 1 .54.312 4.68 4.68 0 0 1 .421 3.727 4.53 4.53 0 0 1 .602 2.211v.625a4.36 4.36 0 0 1-1.781 3.516A2.507 2.507 0 0 1 15.625 15v.625a1.25 1.25 0 0 0 1.25 1.25.625.625 0 0 1 .625.625Z",
            fill: "currentColor"
        })
    });
var $71ea5417b708d912$export$2e2bcd8739ae039 = $71ea5417b708d912$var$SvgGithubLogo;



parcelRequire("2gcPZ");
const $20380f70205ed709$var$SvgGitlabLogo = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "m18.617 11.914-2.133-8.008a.937.937 0 0 0-1.789-.086l-1.61 4.305H6.915L5.304 3.82a.937.937 0 0 0-1.789.086l-2.132 8.008a1.258 1.258 0 0 0 .5 1.352l7.406 5.125c.164.115.355.187.555.21h.312c.2-.023.39-.095.555-.21l7.406-5.125a1.258 1.258 0 0 0 .5-1.352Zm-16.023.32.757-2.859h2.704l2.656 7.102-6.117-4.243Zm8.695 4.243 2.656-7.102h2.703l.758 2.86-6.117 4.242Z",
            fill: "currentColor"
        })
    });
var $20380f70205ed709$export$2e2bcd8739ae039 = $20380f70205ed709$var$SvgGitlabLogo;



parcelRequire("2gcPZ");
const $0a78d3ef7c5cbcc2$var$SvgGitlabLogoSimple = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "m18.117 13.266-7.406 5.125a1.226 1.226 0 0 1-1.422 0l-7.406-5.125a1.258 1.258 0 0 1-.5-1.352l2.132-8.008a.938.938 0 0 1 1.79-.086l1.609 4.305h6.172l1.61-4.305a.938.938 0 0 1 1.788.086l2.133 8.008a1.259 1.259 0 0 1-.5 1.352Z",
            fill: "currentColor"
        })
    });
var $0a78d3ef7c5cbcc2$export$2e2bcd8739ae039 = $0a78d3ef7c5cbcc2$var$SvgGitlabLogoSimple;



parcelRequire("2gcPZ");
const $83ee15ce327f77d1$var$SvgGitMerge = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M14.688 8.125a2.82 2.82 0 0 0-2.797 2.5h-1.696A3.126 3.126 0 0 1 7.79 9.5L6.445 7.883a2.805 2.805 0 1 0-1.757.172v3.89a2.813 2.813 0 1 0 1.25 0V9.227l.898 1.07a4.328 4.328 0 0 0 3.36 1.578h1.843a2.812 2.812 0 1 0 2.649-3.75Zm-7.813 6.563a1.563 1.563 0 1 1-1.562-1.563 1.57 1.57 0 0 1 1.562 1.563Zm7.813-2.188a1.563 1.563 0 1 1 1.562-1.563 1.57 1.57 0 0 1-1.563 1.563Z",
            fill: "currentColor"
        })
    });
var $83ee15ce327f77d1$export$2e2bcd8739ae039 = $83ee15ce327f77d1$var$SvgGitMerge;



parcelRequire("2gcPZ");
const $9062505d0a8e860c$var$SvgGitPullRequest = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M8.125 5.312a2.813 2.813 0 1 0-3.437 2.743v3.89a2.813 2.813 0 1 0 1.25 0v-3.89a2.82 2.82 0 0 0 2.187-2.743Zm-1.25 9.375a1.563 1.563 0 1 1-1.562-1.562 1.57 1.57 0 0 1 1.562 1.563Zm10.625 0a2.813 2.813 0 1 1-3.438-2.742V9.367a3.124 3.124 0 0 0-.914-2.21l-1.898-1.9v1.618a.625.625 0 1 1-1.25 0V3.75a.625.625 0 0 1 .625-.625h3.125a.625.625 0 1 1 0 1.25h-1.617l1.898 1.898a4.338 4.338 0 0 1 1.281 3.094v2.578a2.82 2.82 0 0 1 2.188 2.742Z",
            fill: "currentColor"
        })
    });
var $9062505d0a8e860c$export$2e2bcd8739ae039 = $9062505d0a8e860c$var$SvgGitPullRequest;



parcelRequire("2gcPZ");
const $582f3eabc57cb758$var$SvgGlobe = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "m17.648 12.75.024-.078a8.102 8.102 0 0 0 0-5.344l-.024-.078A8.14 8.14 0 0 0 10 1.875 8.14 8.14 0 0 0 2.35 7.25l-.023.078a8.102 8.102 0 0 0 0 5.344l.023.078A8.156 8.156 0 0 0 10 18.125a8.14 8.14 0 0 0 7.648-5.375ZM10 3.562a8.485 8.485 0 0 1 1.992 3.313H8.008A8.484 8.484 0 0 1 10 3.562Zm-1.992 9.563h3.984A8.486 8.486 0 0 1 10 16.438a8.485 8.485 0 0 1-1.992-3.313Zm-.328-1.25a9.875 9.875 0 0 1 0-3.75h4.64a9.876 9.876 0 0 1 0 3.75H7.68Zm5.914-3.75h3.023a6.946 6.946 0 0 1 0 3.75h-3.023a11.325 11.325 0 0 0 0-3.75Zm2.53-1.25h-2.812a10.055 10.055 0 0 0-1.882-3.602 6.922 6.922 0 0 1 4.695 3.602Zm-4.694 9.852a10.055 10.055 0 0 0 1.882-3.602h2.813a6.922 6.922 0 0 1-4.695 3.602Z",
            fill: "currentColor"
        })
    });
var $582f3eabc57cb758$export$2e2bcd8739ae039 = $582f3eabc57cb758$var$SvgGlobe;



parcelRequire("2gcPZ");
const $ac3d639a2ea74c47$var$SvgGoogleChromeLogo = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M10 1.875A8.125 8.125 0 1 0 18.125 10 8.14 8.14 0 0 0 10 1.875Zm0 1.25a6.883 6.883 0 0 1 5.953 3.438H10a3.438 3.438 0 0 0-3.219 2.234l-1.93-3.344A6.844 6.844 0 0 1 10 3.125ZM3.125 10c0-1.207.317-2.393.922-3.438l2.976 5.157.016.023a3.438 3.438 0 0 0 3.531 1.649l-1.937 3.351A6.899 6.899 0 0 1 3.125 10ZM10 16.875l2.977-5.156c.007-.008.007-.024.015-.031a3.422 3.422 0 0 0-.344-3.876h3.868c.239.705.36 1.444.359 2.188A6.883 6.883 0 0 1 10 16.875Z",
            fill: "currentColor"
        })
    });
var $ac3d639a2ea74c47$export$2e2bcd8739ae039 = $ac3d639a2ea74c47$var$SvgGoogleChromeLogo;



parcelRequire("2gcPZ");
const $f5bda37b72c767f8$var$SvgGoogleLogo = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M10 1.875A8.125 8.125 0 1 0 18.125 10 8.14 8.14 0 0 0 10 1.875Zm0 14.375a6.25 6.25 0 1 1 4.422-10.672.625.625 0 0 1-.883.883 5.008 5.008 0 1 0 1.422 4.164H10a.625.625 0 1 1 0-1.25h5.625a.625.625 0 0 1 .625.625A6.258 6.258 0 0 1 10 16.25Z",
            fill: "currentColor"
        })
    });
var $f5bda37b72c767f8$export$2e2bcd8739ae039 = $f5bda37b72c767f8$var$SvgGoogleLogo;



parcelRequire("2gcPZ");
const $f21297db804b80ae$var$SvgGooglePhotosLogo = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M18.125 9.688h-3.516a5.265 5.265 0 0 0 1.016-3.126 5.32 5.32 0 0 0-5.313-5.312.625.625 0 0 0-.624.625v3.516a5.266 5.266 0 0 0-3.126-1.016A5.32 5.32 0 0 0 1.25 9.688a.625.625 0 0 0 .625.624h3.516a5.266 5.266 0 0 0-1.016 3.126 5.32 5.32 0 0 0 5.313 5.312.625.625 0 0 0 .624-.625v-3.516a5.266 5.266 0 0 0 3.126 1.016 5.32 5.32 0 0 0 5.312-5.313.625.625 0 0 0-.625-.624ZM6.562 5.625a4.023 4.023 0 0 1 3.125 1.469v1.968h-7.14a4.07 4.07 0 0 1 4.015-3.437Zm6.875 8.75a4.024 4.024 0 0 1-3.124-1.469v-1.969h7.14a4.07 4.07 0 0 1-4.015 3.438Z",
            fill: "currentColor"
        })
    });
var $f21297db804b80ae$export$2e2bcd8739ae039 = $f21297db804b80ae$var$SvgGooglePhotosLogo;



parcelRequire("2gcPZ");
const $10571f3d86b624b4$var$SvgGooglePlayLogo = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M17.469 8.922 4.367 1.414a1.266 1.266 0 0 0-1.718.46 1.234 1.234 0 0 0-.165.618v15.016a1.25 1.25 0 0 0 1.25 1.242c.222 0 .44-.057.633-.164l13.102-7.508a1.227 1.227 0 0 0 0-2.156Zm-6.219 1.96 1.477 1.477-6.891 3.938 5.414-5.414ZM5.836 3.696l6.89 3.946-1.476 1.476-5.414-5.422Zm8.008 8.016L12.133 10l1.71-1.711 3 1.711-3 1.71Z",
            fill: "currentColor"
        })
    });
var $10571f3d86b624b4$export$2e2bcd8739ae039 = $10571f3d86b624b4$var$SvgGooglePlayLogo;



parcelRequire("2gcPZ");
const $d379db8f3127cffd$var$SvgGooglePodcastsLogo = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M10.625 1.875V3.75a.625.625 0 1 1-1.25 0V1.875a.625.625 0 0 1 1.25 0Zm3.125 2.813a.625.625 0 0 0-.625.625v1.875a.625.625 0 1 0 1.25 0V5.313a.625.625 0 0 0-.625-.625ZM10 15.624a.625.625 0 0 0-.625.625v1.875a.625.625 0 1 0 1.25 0V16.25a.624.624 0 0 0-.625-.625Zm0-10a.625.625 0 0 0-.625.625v7.5a.625.625 0 1 0 1.25 0v-7.5A.625.625 0 0 0 10 5.625Zm-3.75-.938a.625.625 0 0 0-.625.625v5a.625.625 0 1 0 1.25 0v-5a.625.625 0 0 0-.625-.625Zm7.5 4.375a.625.625 0 0 0-.625.626v5a.624.624 0 1 0 1.25 0v-5a.625.625 0 0 0-.625-.626ZM2.5 8.438a.625.625 0 0 0-.625.624v1.876a.625.625 0 1 0 1.25 0V9.062a.625.625 0 0 0-.625-.624Zm3.75 3.75a.625.625 0 0 0-.625.624v1.876a.625.625 0 1 0 1.25 0v-1.876a.625.625 0 0 0-.625-.624Zm11.25-3.75a.625.625 0 0 0-.625.624v1.876a.624.624 0 1 0 1.25 0V9.062a.625.625 0 0 0-.625-.624Z",
            fill: "currentColor"
        })
    });
var $d379db8f3127cffd$export$2e2bcd8739ae039 = $d379db8f3127cffd$var$SvgGooglePodcastsLogo;



parcelRequire("2gcPZ");
const $0ec2e405c6b640d8$var$SvgGraphDuotone = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                opacity: 0.2,
                fill: "currentColor",
                d: "M4 2h14v14H4z"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M4 16V2H2v14a2 2 0 0 0 2 2h14v-2H4Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M8 5v9H6V5h2ZM11 14V9H9v5h2ZM14 6v8h-2V6h2ZM17 14V9h-2v5h2Z",
                fill: "currentColor"
            })
        ]
    });
var $0ec2e405c6b640d8$export$2e2bcd8739ae039 = $0ec2e405c6b640d8$var$SvgGraphDuotone;



parcelRequire("2gcPZ");
const $3de930637890852a$var$SvgGraph = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M4 16V2H2v14a2 2 0 0 0 2 2h14v-2H4Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M8 5v9H6V5h2ZM11 14V9H9v5h2ZM14 6v8h-2V6h2ZM17 14V9h-2v5h2Z",
                fill: "currentColor"
            })
        ]
    });
var $3de930637890852a$export$2e2bcd8739ae039 = $3de930637890852a$var$SvgGraph;



parcelRequire("2gcPZ");
const $cbfc5379f580f883$var$SvgHighlighterCircle = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M15.742 4.258a8.109 8.109 0 0 0-11.484 0 8.11 8.11 0 0 0 0 11.484 8.109 8.109 0 0 0 11.484 0 8.109 8.109 0 0 0 0-11.484ZM7.5 16.406v-4.531h5v4.531a6.899 6.899 0 0 1-5 0Zm7.36-1.547c-.337.34-.71.645-1.11.907v-3.891a1.25 1.25 0 0 0-1.25-1.25v-5a.618.618 0 0 0-.297-.531.625.625 0 0 0-.61-.031l-3.75 1.875A.64.64 0 0 0 7.5 7.5v3.125a1.25 1.25 0 0 0-1.25 1.25v3.89A6.93 6.93 0 0 1 3.125 10a6.875 6.875 0 1 1 11.734 4.86Z",
            fill: "currentColor"
        })
    });
var $cbfc5379f580f883$export$2e2bcd8739ae039 = $cbfc5379f580f883$var$SvgHighlighterCircle;



parcelRequire("2gcPZ");
const $643b80c55e69690f$var$SvgImage = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M13.125 7.813a.938.938 0 1 1-1.875 0 .938.938 0 0 1 1.875 0Zm5-3.438v11.25a1.25 1.25 0 0 1-1.25 1.25H3.125a1.25 1.25 0 0 1-1.25-1.25V4.375a1.25 1.25 0 0 1 1.25-1.25h13.75a1.25 1.25 0 0 1 1.25 1.25Zm-1.25 8.492V4.375H3.125v7.242L5.992 8.75a1.258 1.258 0 0 1 1.766 0l3.492 3.492 1.617-1.617a1.258 1.258 0 0 1 1.766 0l2.242 2.242Z",
            fill: "currentColor"
        })
    });
var $643b80c55e69690f$export$2e2bcd8739ae039 = $643b80c55e69690f$var$SvgImage;



parcelRequire("2gcPZ");
const $ef316fec114f2be8$var$SvgImageSquare = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M7.813 8.125a.937.937 0 1 0 0-1.875.937.937 0 0 0 0 1.875Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M16.25 2.5H3.75A1.25 1.25 0 0 0 2.5 3.75v12.5a1.25 1.25 0 0 0 1.25 1.25h12.5a1.25 1.25 0 0 0 1.25-1.25V3.75a1.25 1.25 0 0 0-1.25-1.25Zm-2.242 6.25a1.258 1.258 0 0 0-1.766 0L8.75 12.242l-1.617-1.617a1.258 1.258 0 0 0-1.766 0L3.75 12.242V3.75h12.5v7.242L14.008 8.75Z",
                fill: "currentColor"
            })
        ]
    });
var $ef316fec114f2be8$export$2e2bcd8739ae039 = $ef316fec114f2be8$var$SvgImageSquare;



parcelRequire("2gcPZ");
const $436f8486d4112169$var$SvgInfoDuotone = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                opacity: 0.2,
                x: 2,
                y: 2,
                width: 16,
                height: 16,
                rx: 8,
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                fill: "currentColor",
                d: "M9 9h2v5H9zM9 6h2v2H9z"
            })
        ]
    });
var $436f8486d4112169$export$2e2bcd8739ae039 = $436f8486d4112169$var$SvgInfoDuotone;



parcelRequire("2gcPZ");
const $1592e702866a460f$var$SvgInfo = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M8.438 6.563a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm10 3.437A8.437 8.437 0 1 1 10 1.562 8.447 8.447 0 0 1 18.438 10Zm-1.875 0A6.562 6.562 0 1 0 10 16.563 6.57 6.57 0 0 0 16.563 10Zm-5.625 2.866v-2.553A1.563 1.563 0 0 0 9.375 8.75a.938.938 0 0 0-.312 1.822v2.553a1.563 1.563 0 0 0 1.562 1.563.938.938 0 0 0 .313-1.822Z",
            fill: "currentColor"
        })
    });
var $1592e702866a460f$export$2e2bcd8739ae039 = $1592e702866a460f$var$SvgInfo;



parcelRequire("2gcPZ");
const $4a1da76b328a0445$var$SvgInstagramLogo = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M10 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M13.438 2.188H6.561a4.375 4.375 0 0 0-4.375 4.374v6.875a4.375 4.375 0 0 0 4.376 4.376h6.875a4.375 4.375 0 0 0 4.374-4.375V6.561a4.375 4.375 0 0 0-4.375-4.375ZM10 13.75a3.75 3.75 0 1 1 0-7.5 3.75 3.75 0 0 1 0 7.5Zm4.063-6.875a.937.937 0 1 1 0-1.874.937.937 0 0 1 0 1.874Z",
                fill: "currentColor"
            })
        ]
    });
var $4a1da76b328a0445$export$2e2bcd8739ae039 = $4a1da76b328a0445$var$SvgInstagramLogo;



parcelRequire("2gcPZ");
const $241d71afac365389$var$SvgKanban = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.875 3.75H3.125a.625.625 0 0 0-.625.625V16.25a1.25 1.25 0 0 0 1.25 1.25h3.125a1.25 1.25 0 0 0 1.25-1.25V12.5h3.75v1.25a1.25 1.25 0 0 0 1.25 1.25h3.125a1.25 1.25 0 0 0 1.25-1.25V4.375a.625.625 0 0 0-.625-.625ZM6.875 5v4.375H3.75V5h3.125Zm1.25 6.25V5h3.75v6.25h-3.75Zm5 2.5V9.375h3.125v4.375h-3.125Z",
            fill: "currentColor"
        })
    });
var $241d71afac365389$export$2e2bcd8739ae039 = $241d71afac365389$var$SvgKanban;



parcelRequire("2gcPZ");
const $94d798cf9e185bd9$var$SvgKeyboardDuotone = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                opacity: 0.2,
                x: 1,
                y: 4,
                width: 18,
                height: 12,
                rx: 2,
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M5 6H3v2h2V6ZM12 11V9h-2v2h2ZM5 12H3v2h2v-2ZM14 14v-2H6v2h8ZM15 12h2v2h-2v-2ZM9 9v2H7V9h2ZM6 6h2v2H6V6ZM11 6H9v2h2V6ZM12 6h2v2h-2V6ZM17 6h-2v2h2V6ZM3 9h3v2H3V9ZM17 9h-4v2h4V9Z",
                fill: "currentColor"
            })
        ]
    });
var $94d798cf9e185bd9$export$2e2bcd8739ae039 = $94d798cf9e185bd9$var$SvgKeyboardDuotone;



parcelRequire("2gcPZ");
const $e26421d3104b3009$var$SvgKey = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M12.5 1.25a6.258 6.258 0 0 0-5.945 8.188l-4.5 4.492a.633.633 0 0 0-.18.445V17.5a.625.625 0 0 0 .625.625h3.125a.625.625 0 0 0 .625-.625v-1.25H7.5a.625.625 0 0 0 .625-.625v-1.25h1.25a.633.633 0 0 0 .445-.18l.742-.75A6.25 6.25 0 1 0 12.5 1.25Zm1.563 5.938a1.25 1.25 0 1 1 0-2.501 1.25 1.25 0 0 1 0 2.5Z",
            fill: "currentColor"
        })
    });
var $e26421d3104b3009$export$2e2bcd8739ae039 = $e26421d3104b3009$var$SvgKey;



parcelRequire("2gcPZ");
const $2e12417a651aa55d$var$SvgKeyReturn = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.875 3.125H3.125a1.25 1.25 0 0 0-1.25 1.25v11.25a1.25 1.25 0 0 0 1.25 1.25h13.75a1.25 1.25 0 0 0 1.25-1.25V4.375a1.25 1.25 0 0 0-1.25-1.25Zm-2.5 7.5a.624.624 0 0 1-.625.625H7.758l.812.805a.633.633 0 0 1 0 .89.64.64 0 0 1-.89 0L5.805 11.07a.633.633 0 0 1 0-.89L7.68 8.305a.633.633 0 0 1 .89.89L7.758 10h5.367V8.125a.625.625 0 1 1 1.25 0v2.5Z",
            fill: "currentColor"
        })
    });
var $2e12417a651aa55d$export$2e2bcd8739ae039 = $2e12417a651aa55d$var$SvgKeyReturn;



parcelRequire("2gcPZ");
const $058c409de88b2492$var$SvgLightning = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.86 9.234a.625.625 0 0 0-.391-.445l-4.5-1.687 1.14-5.727a.633.633 0 0 0-.32-.68.617.617 0 0 0-.742.125l-8.75 9.375a.617.617 0 0 0-.016.841.64.64 0 0 0 .25.175l4.5 1.688-1.14 5.726a.633.633 0 0 0 .32.68c.09.045.188.069.289.07a.617.617 0 0 0 .453-.195l8.75-9.375a.617.617 0 0 0 .156-.57Z",
            fill: "currentColor"
        })
    });
var $058c409de88b2492$export$2e2bcd8739ae039 = $058c409de88b2492$var$SvgLightning;



parcelRequire("2gcPZ");
const $5027a6c0f5a22d22$var$SvgLightningSlash = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M4.21 2.703a.625.625 0 0 0-.921.844l3.063 3.367-3.055 3.281a.617.617 0 0 0-.016.841.64.64 0 0 0 .25.175l4.5 1.688-1.14 5.726a.633.633 0 0 0 .32.68c.09.045.188.069.289.07a.601.601 0 0 0 .453-.203L12.79 14l3 3.297a.627.627 0 0 0 1.05-.636.617.617 0 0 0-.128-.208L4.21 2.703ZM14.047 11.664a.624.624 0 0 0 .453.203h.008a.601.601 0 0 0 .453-.203l1.742-1.867a.618.618 0 0 0-.234-1.008l-4.5-1.687 1.14-5.735A.625.625 0 0 0 12.047.82L8.46 4.664a.617.617 0 0 0-.008.844l5.594 6.156Z",
            fill: "currentColor"
        })
    });
var $5027a6c0f5a22d22$export$2e2bcd8739ae039 = $5027a6c0f5a22d22$var$SvgLightningSlash;



parcelRequire("2gcPZ");
const $624413516e982bd5$var$SvgLinkBreak = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "m11.328 13.977-2.21 2.21a3.751 3.751 0 0 1-5.306-5.304l2.211-2.211M13.977 11.328l2.21-2.21a3.751 3.751 0 0 0-5.304-5.306L8.672 6.024",
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
var $624413516e982bd5$export$2e2bcd8739ae039 = $624413516e982bd5$var$SvgLinkBreak;



parcelRequire("2gcPZ");
const $9c6f1ba76da0c95e$var$SvgLinkedinLogo = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.563 2.188H3.438a1.25 1.25 0 0 0-1.25 1.25v13.124a1.25 1.25 0 0 0 1.25 1.25h13.124a1.25 1.25 0 0 0 1.25-1.25V3.438a1.25 1.25 0 0 0-1.25-1.25ZM7.5 13.75a.625.625 0 1 1-1.25 0v-5a.625.625 0 0 1 1.25 0v5Zm-.625-6.563a.937.937 0 1 1 0-1.874.937.937 0 0 1 0 1.875Zm7.5 6.563a.624.624 0 1 1-1.25 0v-2.813a1.563 1.563 0 1 0-3.125 0v2.813a.625.625 0 1 1-1.25 0v-5a.625.625 0 0 1 1.234-.14 2.813 2.813 0 0 1 4.391 2.328v2.812Z",
            fill: "currentColor"
        })
    });
var $9c6f1ba76da0c95e$export$2e2bcd8739ae039 = $9c6f1ba76da0c95e$var$SvgLinkedinLogo;



parcelRequire("2gcPZ");
const $e7a3b7977fcd3630$var$SvgLink = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M16.406 3.594a4.048 4.048 0 0 0-5.742 0L9.117 5.14a.625.625 0 0 0 .883.882l1.547-1.546a2.82 2.82 0 0 1 4.588.911 2.804 2.804 0 0 1-.612 3.065l-2.21 2.211a2.82 2.82 0 0 1-3.977 0 .626.626 0 0 0-1.088.435.625.625 0 0 0 .205.448 4.063 4.063 0 0 0 5.742 0l2.211-2.211a4.048 4.048 0 0 0 0-5.742Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "m10 13.977-1.547 1.546a2.812 2.812 0 0 1-3.977-3.976l2.211-2.211a2.82 2.82 0 0 1 3.977 0 .625.625 0 0 0 .883-.883 4.062 4.062 0 0 0-5.742 0l-2.211 2.211a4.062 4.062 0 1 0 5.742 5.742l1.547-1.547a.625.625 0 0 0-.883-.882Z",
                fill: "currentColor"
            })
        ]
    });
var $e7a3b7977fcd3630$export$2e2bcd8739ae039 = $e7a3b7977fcd3630$var$SvgLink;



parcelRequire("2gcPZ");
const $38382e201903956d$var$SvgLinkOutDuotone = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("g", {
            fill: "currentColor",
            children: [
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                    opacity: 0.2,
                    d: "M4 6h10v10H4z"
                }),
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3.999 4h6V2h-6v-.001a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2V16v2h12a2 2 0 0 0 2-2V9h-2v7h-12V4Zm14.003-2-.003 5h-1.997l.002-1.347-6.591 6.591-1.415-1.414L14.83 4h-1.827V2h5Z"
                })
            ]
        })
    });
var $38382e201903956d$export$2e2bcd8739ae039 = $38382e201903956d$var$SvgLinkOutDuotone;



parcelRequire("2gcPZ");
const $fdc36f733a081eb6$var$SvgLinkOut = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M3.999 4h6V2h-6a2 2 0 0 0-2 1.999v12a2 2 0 0 0 2 2l12 .001a2 2 0 0 0 2-2V9h-2v7h-12V4Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "m18.002 2-.003 5h-1.997l.002-1.347-6.591 6.591-1.415-1.414L14.83 4h-1.827V2h5Z",
                fill: "currentColor"
            })
        ]
    });
var $fdc36f733a081eb6$export$2e2bcd8739ae039 = $fdc36f733a081eb6$var$SvgLinkOut;



parcelRequire("2gcPZ");
const $f14daca39c272133$var$SvgLinuxLogo = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M12.594 17.008a.312.312 0 0 1-.258.492H7.664a.313.313 0 0 1-.258-.492 3.125 3.125 0 0 1 5.188 0Zm5.36.297a.64.64 0 0 1-.47.195h-3.062a.32.32 0 0 1-.297-.211 4.375 4.375 0 0 0-8.25 0 .32.32 0 0 1-.297.211H2.516a.627.627 0 0 1-.637-.552.617.617 0 0 1 .082-.386c.023-.039 2.414-4.296 2.414-9.062a5.633 5.633 0 0 1 5.664-5.625c3.094.023 5.578 2.57 5.586 5.664.016 4.75 2.39 8.984 2.414 9.024a.617.617 0 0 1-.086.742ZM6.874 8.437a.937.937 0 1 0 1.875 0 .937.937 0 0 0-1.875 0Zm6.188 2.532a.64.64 0 0 0-.844-.281L10 11.805l-2.219-1.117a.627.627 0 0 0-.843.28.63.63 0 0 0 .28.845l2.5 1.25a.665.665 0 0 0 .563 0l2.5-1.25a.64.64 0 0 0 .281-.844Zm.062-2.532a.938.938 0 1 0-1.875 0 .938.938 0 0 0 1.875 0Z",
            fill: "currentColor"
        })
    });
var $f14daca39c272133$export$2e2bcd8739ae039 = $f14daca39c272133$var$SvgLinuxLogo;



parcelRequire("2gcPZ");
const $5568765f342bb099$var$SvgListBullets = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M6.25 5a.625.625 0 0 1 .625-.625h10a.625.625 0 1 1 0 1.25h-10A.625.625 0 0 1 6.25 5Zm10.625 4.375h-10a.625.625 0 0 0 0 1.25h10a.624.624 0 1 0 0-1.25Zm0 5h-10a.625.625 0 1 0 0 1.25h10a.624.624 0 1 0 0-1.25ZM3.437 9.062a.937.937 0 1 0 0 1.875.937.937 0 0 0 0-1.874Zm0-5a.937.937 0 1 0 0 1.875.937.937 0 0 0 0-1.875Zm0 10a.938.938 0 1 0 0 1.876.938.938 0 0 0 0-1.876Z",
            fill: "currentColor"
        })
    });
var $5568765f342bb099$export$2e2bcd8739ae039 = $5568765f342bb099$var$SvgListBullets;



parcelRequire("2gcPZ");
const $db2fb14d46f3d6e0$var$SvgListChecks = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M17.5 10a.625.625 0 0 1-.625.625H10a.625.625 0 0 1 0-1.25h6.875A.625.625 0 0 1 17.5 10ZM10 5.625h6.875a.625.625 0 0 0 0-1.25H10a.625.625 0 0 0 0 1.25Zm6.875 8.75H10a.625.625 0 1 0 0 1.25h6.875a.625.625 0 0 0 0-1.25ZM6.765 3.289l-2.288 2.11-.93-.86a.625.625 0 0 0-.844.922l1.352 1.25a.625.625 0 0 0 .422.164.64.64 0 0 0 .43-.164l2.702-2.5a.625.625 0 1 0-.843-.922Zm0 5-2.288 2.11-.93-.86a.625.625 0 1 0-.844.922l1.352 1.25a.625.625 0 0 0 .422.164.64.64 0 0 0 .43-.164l2.702-2.5a.625.625 0 1 0-.843-.922Zm0 5-2.288 2.11-.93-.86a.624.624 0 0 0-1.056.486.625.625 0 0 0 .212.436l1.352 1.25a.625.625 0 0 0 .422.164.64.64 0 0 0 .43-.164l2.702-2.5a.625.625 0 0 0-.843-.922Z",
            fill: "currentColor"
        })
    });
var $db2fb14d46f3d6e0$export$2e2bcd8739ae039 = $db2fb14d46f3d6e0$var$SvgListChecks;



parcelRequire("2gcPZ");
const $26a56a566d9469ef$var$SvgListDashes = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M6.875 5a.625.625 0 0 1 .625-.625h9.375a.625.625 0 1 1 0 1.25H7.5A.625.625 0 0 1 6.875 5Zm10 4.375H7.5a.625.625 0 0 0 0 1.25h9.375a.624.624 0 1 0 0-1.25Zm0 5H7.5a.625.625 0 1 0 0 1.25h9.375a.624.624 0 1 0 0-1.25Zm-12.5-10h-1.25a.625.625 0 0 0 0 1.25h1.25a.625.625 0 0 0 0-1.25Zm0 5h-1.25a.625.625 0 0 0 0 1.25h1.25a.625.625 0 1 0 0-1.25Zm0 5h-1.25a.625.625 0 1 0 0 1.25h1.25a.625.625 0 1 0 0-1.25Z",
            fill: "currentColor"
        })
    });
var $26a56a566d9469ef$export$2e2bcd8739ae039 = $26a56a566d9469ef$var$SvgListDashes;



parcelRequire("2gcPZ");
const $5dfe93864893c17f$var$SvgList = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.875 9.375H3.125a.625.625 0 0 0 0 1.25h13.75a.624.624 0 1 0 0-1.25ZM3.125 5.625h13.75a.625.625 0 1 0 0-1.25H3.125a.625.625 0 0 0 0 1.25ZM16.875 14.375H3.125a.625.625 0 1 0 0 1.25h13.75a.624.624 0 1 0 0-1.25Z",
            fill: "currentColor"
        })
    });
var $5dfe93864893c17f$export$2e2bcd8739ae039 = $5dfe93864893c17f$var$SvgList;



parcelRequire("2gcPZ");
const $b9d1fa91d65e89ac$var$SvgListNumbers = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M17.5 10a.625.625 0 0 1-.625.625h-8.75a.625.625 0 1 1 0-1.25h8.75A.625.625 0 0 1 17.5 10ZM8.125 5.625h8.75a.625.625 0 0 0 0-1.25h-8.75a.625.625 0 0 0 0 1.25Zm8.75 8.75h-8.75a.625.625 0 0 0 0 1.25h8.75a.625.625 0 1 0 0-1.25ZM3.406 5.25l.344-.18v3.368a.625.625 0 0 0 1.25 0V4.063a.617.617 0 0 0-.297-.532.625.625 0 0 0-.61-.031l-1.25.625a.629.629 0 1 0 .563 1.125Zm2.235 8.055a1.68 1.68 0 0 0 .296-.961 1.719 1.719 0 0 0-3.304-.672.628.628 0 0 0 1.156.492.453.453 0 0 1 .43-.289.469.469 0 0 1 .398.719L2.625 15.25a.625.625 0 0 0 .5 1h2.187a.625.625 0 1 0 0-1.25h-.937l1.25-1.672.016-.023Z",
            fill: "currentColor"
        })
    });
var $b9d1fa91d65e89ac$export$2e2bcd8739ae039 = $b9d1fa91d65e89ac$var$SvgListNumbers;



parcelRequire("2gcPZ");
const $012ba0f446d16d20$var$SvgListPlus = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M2.5 5a.625.625 0 0 1 .625-.625h13.75a.625.625 0 1 1 0 1.25H3.125A.625.625 0 0 1 2.5 5Zm.625 5.625h13.75a.624.624 0 1 0 0-1.25H3.125a.625.625 0 0 0 0 1.25Zm8.125 3.75H3.125a.625.625 0 1 0 0 1.25h8.125a.624.624 0 1 0 0-1.25Zm6.875 0h-1.25v-1.25a.624.624 0 1 0-1.25 0v1.25h-1.25a.624.624 0 1 0 0 1.25h1.25v1.25a.624.624 0 1 0 1.25 0v-1.25h1.25a.624.624 0 1 0 0-1.25Z",
            fill: "currentColor"
        })
    });
var $012ba0f446d16d20$export$2e2bcd8739ae039 = $012ba0f446d16d20$var$SvgListPlus;



parcelRequire("2gcPZ");
const $c01ae1f6c660ad70$var$SvgLockKey = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 12,
        height: 12,
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M9.75 3.75h-1.5V2.625a2.25 2.25 0 1 0-4.5 0V3.75h-1.5a.75.75 0 0 0-.75.75v5.25a.75.75 0 0 0 .75.75h7.5a.75.75 0 0 0 .75-.75V4.5a.75.75 0 0 0-.75-.75ZM6.375 7.436v1.189a.375.375 0 0 1-.75 0v-1.19a1.125 1.125 0 1 1 .75 0ZM7.5 3.75h-3V2.625a1.5 1.5 0 0 1 3 0V3.75Z",
            fill: "currentColor"
        })
    });
var $c01ae1f6c660ad70$export$2e2bcd8739ae039 = $c01ae1f6c660ad70$var$SvgLockKey;



parcelRequire("2gcPZ");
const $8bb80cdfe715cfc9$var$SvgLockSimple = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.25 6.25h-2.813V4.062a3.438 3.438 0 0 0-6.874 0V6.25H3.75A1.25 1.25 0 0 0 2.5 7.5v8.75a1.25 1.25 0 0 0 1.25 1.25h12.5a1.25 1.25 0 0 0 1.25-1.25V7.5a1.25 1.25 0 0 0-1.25-1.25ZM7.812 4.062a2.188 2.188 0 0 1 4.375 0V6.25H7.814V4.062Z",
            fill: "currentColor"
        })
    });
var $8bb80cdfe715cfc9$export$2e2bcd8739ae039 = $8bb80cdfe715cfc9$var$SvgLockSimple;



parcelRequire("2gcPZ");
const $9a088da0c02488fe$var$SvgLockSimpleOpen = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.25 6.875H3.75a.625.625 0 0 0-.625.625v8.75c0 .345.28.625.625.625h12.5c.345 0 .625-.28.625-.625V7.5a.625.625 0 0 0-.625-.625ZM7.438 6.875V4.062a2.813 2.813 0 0 0-5.625 0",
            stroke: "currentColor",
            strokeWidth: 1.5,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
var $9a088da0c02488fe$export$2e2bcd8739ae039 = $9a088da0c02488fe$var$SvgLockSimpleOpen;



parcelRequire("2gcPZ");
const $0fa7cd6e17b0f3bc$var$SvgLokiColor = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 14,
        height: 16,
        viewBox: "0 0 14 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                transform: "rotate(-11.27 0 2.624)",
                fill: "url(#LokiColor_svg__a)",
                d: "M0 2.624h.547v9.774H0z"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                transform: "rotate(-11.27 .537 1.773)",
                fill: "url(#LokiColor_svg__b)",
                d: "M.537 1.773h.547v10.503H.537z"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                transform: "rotate(-11.27 1.432 .107)",
                fill: "url(#LokiColor_svg__c)",
                d: "M1.432.107h.547v11.962h-.547z"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                transform: "rotate(-11.27 2.304 .937)",
                fill: "url(#LokiColor_svg__d)",
                d: "M2.304.937h.547v10.977h-.547z"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                transform: "rotate(-11.27 3.87 2.633)",
                fill: "url(#LokiColor_svg__e)",
                d: "M3.869 2.633h.547v9.008h-.547z"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                transform: "rotate(-11.27 4.485 2.176)",
                fill: "url(#LokiColor_svg__f)",
                d: "M4.485 2.176h.547v9.336h-.547z"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                transform: "rotate(-11.27 2.046 12.888)",
                fill: "url(#LokiColor_svg__g)",
                d: "M2.046 12.888h1.24v1.24h-1.24z"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                transform: "rotate(-11.27 2.423 14.784)",
                fill: "url(#LokiColor_svg__h)",
                d: "M2.423 14.784h1.24v1.24h-1.24z"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                transform: "rotate(-11.27 3.905 12.518)",
                fill: "url(#LokiColor_svg__i)",
                d: "M3.905 12.518h1.24v1.24h-1.24z"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                transform: "rotate(-11.27 4.283 14.413)",
                fill: "url(#LokiColor_svg__j)",
                d: "M4.283 14.413h1.24v1.24h-1.24z"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                transform: "rotate(-11.27 5.765 12.147)",
                fill: "url(#LokiColor_svg__k)",
                d: "M5.765 12.147h1.24v1.24h-1.24z"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                transform: "rotate(-11.27 6.143 14.043)",
                fill: "url(#LokiColor_svg__l)",
                d: "M6.143 14.043h1.24v1.24h-1.24z"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                transform: "rotate(-11.27 7.625 11.777)",
                fill: "url(#LokiColor_svg__m)",
                d: "M7.625 11.777h5.47v1.24h-5.47z"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                transform: "rotate(-11.27 8.003 13.672)",
                fill: "url(#LokiColor_svg__n)",
                d: "M8.003 13.672h5.47v1.24h-5.47z"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("linearGradient", {
                        id: "LokiColor_svg__a",
                        x1: 0.274,
                        y1: 2.624,
                        x2: 0.274,
                        y2: 12.397,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                stopColor: "#F1652A"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F6B422"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("linearGradient", {
                        id: "LokiColor_svg__b",
                        x1: 0.811,
                        y1: 1.773,
                        x2: 0.811,
                        y2: 12.276,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                stopColor: "#F1662A"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F6B422"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("linearGradient", {
                        id: "LokiColor_svg__c",
                        x1: 1.706,
                        y1: 0.107,
                        x2: 1.706,
                        y2: 12.069,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                stopColor: "#F1662A"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F6B422"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("linearGradient", {
                        id: "LokiColor_svg__d",
                        x1: 2.578,
                        y1: 0.937,
                        x2: 2.578,
                        y2: 11.914,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                stopColor: "#F1662A"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F6B422"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("linearGradient", {
                        id: "LokiColor_svg__e",
                        x1: 4.143,
                        y1: 2.633,
                        x2: 4.143,
                        y2: 11.641,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                stopColor: "#F1662A"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F6B422"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("linearGradient", {
                        id: "LokiColor_svg__f",
                        x1: 4.758,
                        y1: 2.176,
                        x2: 4.758,
                        y2: 11.512,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                stopColor: "#F1662A"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F6B422"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("linearGradient", {
                        id: "LokiColor_svg__g",
                        x1: 2.666,
                        y1: 12.888,
                        x2: 2.666,
                        y2: 14.128,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                stopColor: "#F6BB21"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F6C320"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("linearGradient", {
                        id: "LokiColor_svg__h",
                        x1: 3.043,
                        y1: 14.784,
                        x2: 3.043,
                        y2: 16.024,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                stopColor: "#F6C921"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F7D31F"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("linearGradient", {
                        id: "LokiColor_svg__i",
                        x1: 4.525,
                        y1: 12.518,
                        x2: 4.525,
                        y2: 13.758,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                stopColor: "#F6BB21"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F6C320"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("linearGradient", {
                        id: "LokiColor_svg__j",
                        x1: 4.903,
                        y1: 14.413,
                        x2: 4.903,
                        y2: 15.653,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                stopColor: "#F6C921"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F7D31F"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("linearGradient", {
                        id: "LokiColor_svg__k",
                        x1: 6.385,
                        y1: 12.147,
                        x2: 6.385,
                        y2: 13.387,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                stopColor: "#F6BB21"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F6C320"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("linearGradient", {
                        id: "LokiColor_svg__l",
                        x1: 6.763,
                        y1: 14.043,
                        x2: 6.763,
                        y2: 15.283,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                stopColor: "#F6C921"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F7D31F"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("linearGradient", {
                        id: "LokiColor_svg__m",
                        x1: 10.36,
                        y1: 11.777,
                        x2: 10.36,
                        y2: 13.016,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                stopColor: "#F6BB21"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F6C320"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("linearGradient", {
                        id: "LokiColor_svg__n",
                        x1: 10.738,
                        y1: 13.672,
                        x2: 10.738,
                        y2: 14.912,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                stopColor: "#F6C921"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F7D31F"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $0fa7cd6e17b0f3bc$export$2e2bcd8739ae039 = $0fa7cd6e17b0f3bc$var$SvgLokiColor;



parcelRequire("2gcPZ");
const $ed6005ae36e97b1d$var$SvgLoki = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("g", {
                clipPath: "url(#Loki_svg__a)",
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M6.976 13.629 5.05 1l-.592.119 1.926 12.569.593-.06ZM3.775 1.918l1.838 11.917-.593.089L3.182 2.038l.593-.119Zm1.037 12.036L3.122 2.868l-.622.089 1.72 11.086.592-.088Zm12.125-1.068.237 1.364-6.136.949-.178-1.364 6.077-.949Zm-10.88 3.884.208 1.393-1.364.207-.237-1.393 1.393-.207Zm2.817-1.216 1.393-.237-.208-1.364-1.393.208.208 1.393Zm-.653.89.238 1.363-1.423.237-.178-1.393 1.363-.207Zm-3.883-1.63.207 1.393L5.94 16l-.208-1.393-1.393.207Zm7.055 2.578-.237-1.423 6.137-.919.207 1.394-6.107.948Zm-2.164.297 1.364-.178-.208-1.423-1.393.237.237 1.364ZM6.74 15.88l-.237-1.393 1.393-.207.208 1.393-1.364.207ZM5.998 2.008 7.777 13.51l-.564.06L5.435 2.096l.563-.09ZM9.14 13.273 7.57 3.075l-.594.089 1.571 10.227.593-.118ZM8.31 2.57l1.63 10.583-.562.09L7.718 2.66l.592-.089Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("clipPath", {
                    id: "Loki_svg__a",
                    children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                        fill: "#fff",
                        transform: "translate(2.5 1)",
                        d: "M0 0h15v17.5H0z"
                    })
                })
            })
        ]
    });
var $ed6005ae36e97b1d$export$2e2bcd8739ae039 = $ed6005ae36e97b1d$var$SvgLoki;



parcelRequire("2gcPZ");
const $f69b4fa2a07b46c3$var$SvgMagnet = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.172 3.922a6.851 6.851 0 0 0-4.875-2.047h-.024a6.82 6.82 0 0 0-4.867 2.016L3.774 6.555 1.241 9.117a1.258 1.258 0 0 0 .008 1.766l2.234 2.234a1.218 1.218 0 0 0 .883.367h.008a1.235 1.235 0 0 0 .89-.375l2.5-2.562 2.626-2.68a1.258 1.258 0 0 1 1.75-.015 1.227 1.227 0 0 1 .367.875c.001.35-.136.687-.383.937l-2.664 2.578-2.563 2.492a1.242 1.242 0 0 0-.015 1.782l2.234 2.242a1.274 1.274 0 0 0 1.766.008l2.57-2.532 2.625-2.57c2.688-2.687 2.735-7.055.094-9.742ZM4.367 12.234 2.133 10l2.086-2.117 2.226 2.226-2.078 2.125Zm5.64 5.633-2.241-2.234 2.133-2.07 2.226 2.226-2.117 2.078Z",
            fill: "currentColor"
        })
    });
var $f69b4fa2a07b46c3$export$2e2bcd8739ae039 = $f69b4fa2a07b46c3$var$SvgMagnet;



parcelRequire("2gcPZ");
const $8cb45e2a7246b1b4$var$SvgMagnetStraight = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M15.625 3.125H12.5a1.25 1.25 0 0 0-1.25 1.25v6.875a1.25 1.25 0 0 1-2.5 0V4.375a1.25 1.25 0 0 0-1.25-1.25H4.375a1.25 1.25 0 0 0-1.25 1.25v6.875A6.868 6.868 0 0 0 10 18.125h.055c3.758-.031 6.82-3.148 6.82-6.953V4.375a1.25 1.25 0 0 0-1.25-1.25Zm0 1.25V7.5H12.5V4.375h3.125Zm-8.125 0V7.5H4.375V4.375H7.5Z",
            fill: "currentColor"
        })
    });
var $8cb45e2a7246b1b4$export$2e2bcd8739ae039 = $8cb45e2a7246b1b4$var$SvgMagnetStraight;



parcelRequire("2gcPZ");
const $7ae4d7ea08c08fe5$var$SvgMagnifyingGlass = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M9.063 15.625a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125ZM13.703 13.703 17.5 17.5",
            stroke: "currentColor",
            strokeWidth: 1.25,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
var $7ae4d7ea08c08fe5$export$2e2bcd8739ae039 = $7ae4d7ea08c08fe5$var$SvgMagnifyingGlass;



parcelRequire("2gcPZ");
const $00e467ba62521042$var$SvgMagnifyingGlassMinus = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "m17.938 17.055-3.375-3.375a7.203 7.203 0 1 0-.883.883l3.375 3.382c.12.115.279.18.445.18a.625.625 0 0 0 .438-1.07Zm-6.375-7.367h-5a.625.625 0 0 1 0-1.25h5a.625.625 0 1 1 0 1.25Z",
            fill: "currentColor"
        })
    });
var $00e467ba62521042$export$2e2bcd8739ae039 = $00e467ba62521042$var$SvgMagnifyingGlassMinus;



parcelRequire("2gcPZ");
const $fc278b4a72a90e0b$var$SvgMagnifyingGlassPlus = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "m17.938 17.055-3.375-3.375a7.203 7.203 0 1 0-.883.883l3.375 3.382c.12.115.279.18.445.18a.625.625 0 0 0 .438-1.07Zm-6.375-7.367H9.687v1.874a.625.625 0 1 1-1.25 0V9.688H6.563a.625.625 0 0 1 0-1.25h1.875V6.562a.625.625 0 0 1 1.25 0v1.875h1.874a.625.625 0 1 1 0 1.25Z",
            fill: "currentColor"
        })
    });
var $fc278b4a72a90e0b$export$2e2bcd8739ae039 = $fc278b4a72a90e0b$var$SvgMagnifyingGlassPlus;



parcelRequire("2gcPZ");
const $15e6f51b1bb10d48$var$SvgMapPin = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M10 1.25a6.883 6.883 0 0 0-6.875 6.875c0 5.883 6.25 10.328 6.516 10.516a.648.648 0 0 0 .718 0c.266-.188 6.516-4.633 6.516-10.516A6.883 6.883 0 0 0 10 1.25Zm0 4.375a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Z",
            fill: "currentColor"
        })
    });
var $15e6f51b1bb10d48$export$2e2bcd8739ae039 = $15e6f51b1bb10d48$var$SvgMapPin;



parcelRequire("2gcPZ");
const $317646ee7ae95bf7$var$SvgModulesDuotone = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("g", {
                clipPath: "url(#ModulesDuotone_svg__a)",
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("g", {
                        opacity: 0.2,
                        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                            d: "M1 5a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V5ZM1 17a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-1ZM1 11a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-1Z"
                        })
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M0 5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-5v1h5a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-5v1h5a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2h5v-1H2a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2h5V8H2a2 2 0 0 1-2-2V5Zm18 0H2v1h16V5Zm0 12H2v1h16v-1Zm0-6H2v1h16v-1Z"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                        d: "M11 2H1a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("clipPath", {
                    id: "ModulesDuotone_svg__a",
                    children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h20v20H0z"
                    })
                })
            })
        ]
    });
var $317646ee7ae95bf7$export$2e2bcd8739ae039 = $317646ee7ae95bf7$var$SvgModulesDuotone;



parcelRequire("2gcPZ");
const $c25b85f9fe866028$var$SvgMoneyDuotone = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                opacity: 0.2,
                d: "M17 5a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h14Z",
                fill: "currentColor",
                stroke: "currentColor",
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-2 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17 4a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h14Zm-2 4h2v4h-2v2H5v-2H3V8h2V6h10v2Z",
                fill: "currentColor"
            })
        ]
    });
var $c25b85f9fe866028$export$2e2bcd8739ae039 = $c25b85f9fe866028$var$SvgMoneyDuotone;



parcelRequire("2gcPZ");
const $a83fcaf701c84db6$var$SvgMoonDuotone = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("circle", {
                opacity: 0.2,
                cx: 10,
                cy: 10,
                r: 7,
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "m15 2 .81 2.19L18 5l-2.19.81L15 8l-.81-2.19L12 5l2.19-.81L15 2Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.93 10.84a4.375 4.375 0 0 1-3.392-7.67A7.024 7.024 0 0 0 9 3.07 7.002 7.002 0 0 0 10 17a7.003 7.003 0 0 0 6.542-4.503A6.984 6.984 0 0 0 17 10c-.592.445-1.3.743-2.07.84Zm-.835 2.029A5 5 0 1 1 8.1 5.374a6.375 6.375 0 0 0 5.996 7.495Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M3.905 16.095 3.5 15l-.405 1.095L2 16.5l1.095.405L3.5 18l.405-1.095L5 16.5l-1.095-.405Z",
                fill: "currentColor"
            })
        ]
    });
var $a83fcaf701c84db6$export$2e2bcd8739ae039 = $a83fcaf701c84db6$var$SvgMoonDuotone;



parcelRequire("2gcPZ");
const $eebe5be4309e440c$var$SvgMoon = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 21,
        height: 21,
        viewBox: "0 0 21 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M18.564 12.722a8.19 8.19 0 0 1-2.89 4.133A8.126 8.126 0 0 1 4.293 5.477a8.19 8.19 0 0 1 4.133-2.89.625.625 0 0 1 .781.78 6.881 6.881 0 0 0 8.578 8.579.625.625 0 0 1 .782.781l-.004-.005Z",
            fill: "currentColor"
        })
    });
var $eebe5be4309e440c$export$2e2bcd8739ae039 = $eebe5be4309e440c$var$SvgMoon;



parcelRequire("2gcPZ");
const $0a259afd76e1ffd7$var$SvgNoteBlank = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.25 2.5H3.75A1.25 1.25 0 0 0 2.5 3.75v12.5a1.25 1.25 0 0 0 1.25 1.25h8.492a1.241 1.241 0 0 0 .883-.367l4.008-4.008a1.24 1.24 0 0 0 .367-.883V3.75a1.25 1.25 0 0 0-1.25-1.25ZM12.5 15.992V12.5h3.492L12.5 15.992Z",
            fill: "currentColor"
        })
    });
var $0a259afd76e1ffd7$export$2e2bcd8739ae039 = $0a259afd76e1ffd7$var$SvgNoteBlank;



parcelRequire("2gcPZ");
const $2a55c1d52e06f4b3$var$SvgNotebookDuotone = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                opacity: 0.2,
                d: "M16 2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h10Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16 2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2H2v-2h2v-3H2V9h2V6H2V4h2a2 2 0 0 1 2-2h10Zm0 2v12H6V4h10Z",
                fill: "currentColor"
            })
        ]
    });
var $2a55c1d52e06f4b3$export$2e2bcd8739ae039 = $2a55c1d52e06f4b3$var$SvgNotebookDuotone;



parcelRequire("2gcPZ");
const $c78e976e11011540$var$SvgNotebook = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.25 2.5H3.75A1.25 1.25 0 0 0 2.5 3.75v12.5a1.25 1.25 0 0 0 1.25 1.25h12.5a1.25 1.25 0 0 0 1.25-1.25V3.75a1.25 1.25 0 0 0-1.25-1.25Zm-10 13.75h-2.5V3.75h2.5v12.5Zm7.5-4.375h-5a.625.625 0 1 1 0-1.25h5a.624.624 0 1 1 0 1.25Zm0-2.5h-5a.625.625 0 0 1 0-1.25h5a.625.625 0 1 1 0 1.25Z",
            fill: "currentColor"
        })
    });
var $c78e976e11011540$export$2e2bcd8739ae039 = $c78e976e11011540$var$SvgNotebook;



parcelRequire("2gcPZ");
const $14e808cdf323d234$var$SvgNotebookMenu = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M3 3a1 1 0 0 1 1-1h2v16H4a1 1 0 0 1-1-1V3Zm12-1a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7.5V2H15Z",
            fill: "currentColor"
        })
    });
var $14e808cdf323d234$export$2e2bcd8739ae039 = $14e808cdf323d234$var$SvgNotebookMenu;



parcelRequire("2gcPZ");
const $2719838715122be4$var$SvgNote = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.25 2.5H3.75A1.25 1.25 0 0 0 2.5 3.75v12.5a1.25 1.25 0 0 0 1.25 1.25h8.492a1.241 1.241 0 0 0 .883-.367l4.008-4.008a1.24 1.24 0 0 0 .367-.883V3.75a1.25 1.25 0 0 0-1.25-1.25ZM7.5 6.875h5a.625.625 0 1 1 0 1.25h-5a.625.625 0 0 1 0-1.25Zm2.5 6.25H7.5a.625.625 0 1 1 0-1.25H10a.624.624 0 1 1 0 1.25Zm-2.5-2.5a.625.625 0 1 1 0-1.25h5a.625.625 0 1 1 0 1.25h-5Zm5 5.367V12.5h3.492L12.5 15.992Z",
            fill: "currentColor"
        })
    });
var $2719838715122be4$export$2e2bcd8739ae039 = $2719838715122be4$var$SvgNote;



parcelRequire("2gcPZ");
const $cccffbb7537f893b$var$SvgNotepad = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M15.625 2.5h-1.25v-.625a.625.625 0 1 0-1.25 0V2.5h-2.5v-.625a.625.625 0 1 0-1.25 0V2.5h-2.5v-.625a.625.625 0 0 0-1.25 0V2.5h-1.25a1.25 1.25 0 0 0-1.25 1.25v11.875a2.5 2.5 0 0 0 2.5 2.5h8.75a2.5 2.5 0 0 0 2.5-2.5V3.75a1.25 1.25 0 0 0-1.25-1.25ZM12.5 13.125h-5a.625.625 0 1 1 0-1.25h5a.624.624 0 1 1 0 1.25Zm0-2.5h-5a.625.625 0 1 1 0-1.25h5a.625.625 0 1 1 0 1.25Z",
            fill: "currentColor"
        })
    });
var $cccffbb7537f893b$export$2e2bcd8739ae039 = $cccffbb7537f893b$var$SvgNotepad;



parcelRequire("2gcPZ");
const $8707c4d6d17b308c$var$SvgNotePencil = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M17.5 9.375v6.875a1.25 1.25 0 0 1-1.25 1.25H3.75a1.25 1.25 0 0 1-1.25-1.25V3.75A1.25 1.25 0 0 1 3.75 2.5h6.875a.625.625 0 1 1 0 1.25H3.75v12.5h12.5V9.375a.625.625 0 1 1 1.25 0Zm.445-3.93-7.5 7.5a.633.633 0 0 1-.445.18H7.5a.625.625 0 0 1-.625-.625V10c0-.166.064-.326.18-.445l7.5-7.5a.633.633 0 0 1 .89 0l2.5 2.5a.633.633 0 0 1 0 .89ZM16.617 5 15 3.383l-.992.992 1.617 1.617.992-.992Z",
            fill: "currentColor"
        })
    });
var $8707c4d6d17b308c$export$2e2bcd8739ae039 = $8707c4d6d17b308c$var$SvgNotePencil;



parcelRequire("2gcPZ");
const $337c899d45bd2899$var$SvgNotifcation = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M10 2a6 6 0 0 1 6 6c0 3.123 3 5-1 6s-6 1-10 0-1-2.88-1-6a6 6 0 0 1 6-6Zm0 16a3 3 0 0 1-2.956-2.486C7.3 15.595 8.65 16 10 16s2.699-.405 2.956-.486A3 3 0 0 1 10 18Z",
            fill: "currentColor"
        })
    });
var $337c899d45bd2899$export$2e2bcd8739ae039 = $337c899d45bd2899$var$SvgNotifcation;



parcelRequire("2gcPZ");
const $1afbda52705fc5d1$var$SvgPaperclip = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.383 9.555a.633.633 0 0 1-.008.89l-6.406 6.399a4.375 4.375 0 1 1-6.188-6.188l7.758-7.86a3.126 3.126 0 1 1 4.422 4.415l-7.758 7.86a1.86 1.86 0 0 1-1.328.554 1.874 1.874 0 0 1-1.328-3.203l6.508-6.61a.624.624 0 1 1 .89.875l-6.508 6.618a.626.626 0 0 0-.187.445.633.633 0 0 0 1.07.445l7.75-7.867A1.86 1.86 0 0 0 15.625 5a1.876 1.876 0 0 0-3.203-1.328l-7.75 7.867a3.126 3.126 0 1 0 4.414 4.422l6.406-6.406a.633.633 0 0 1 .89 0Z",
            fill: "currentColor"
        })
    });
var $1afbda52705fc5d1$export$2e2bcd8739ae039 = $1afbda52705fc5d1$var$SvgPaperclip;



parcelRequire("2gcPZ");
const $ed97df3fe9973e9a$var$SvgPaperPlaneTilt = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "m17.79 3.773-4.095 14.524a1.242 1.242 0 0 1-1.101.906h-.11a1.25 1.25 0 0 1-1.124-.71l-2.79-5.891a.32.32 0 0 1 .063-.36l4.008-4.008a.625.625 0 1 0-.883-.882L7.75 11.367a.32.32 0 0 1-.36.063L1.532 8.656A1.297 1.297 0 0 1 .79 7.437a1.242 1.242 0 0 1 .914-1.132l14.555-4.102a1.25 1.25 0 0 1 1.383.508 1.304 1.304 0 0 1 .148 1.062Z",
            fill: "currentColor"
        })
    });
var $ed97df3fe9973e9a$export$2e2bcd8739ae039 = $ed97df3fe9973e9a$var$SvgPaperPlaneTilt;



parcelRequire("2gcPZ");
const $6f4b27bb6f7b4ef1$var$SvgPencilSimple = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "m17.5 5.992-3.46-3.469a1.25 1.25 0 0 0-1.797-.023L10.18 4.555l-7.313 7.32a1.242 1.242 0 0 0-.367.883v3.492a1.25 1.25 0 0 0 1.25 1.25h3.492c.331-.002.649-.133.883-.367L17.5 7.758a1.258 1.258 0 0 0 0-1.766Zm-2.5 2.5L11.508 5l1.617-1.617 3.492 3.492L15 8.492Z",
            fill: "currentColor"
        })
    });
var $6f4b27bb6f7b4ef1$export$2e2bcd8739ae039 = $6f4b27bb6f7b4ef1$var$SvgPencilSimple;



parcelRequire("2gcPZ");
const $ca9197106fbbe83d$var$SvgPercentage = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.354 4.646a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.708-.708l10-10a.5.5 0 0 1 .708 0ZM6.5 5.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm8 7a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm1-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z",
            fill: "currentColor"
        })
    });
var $ca9197106fbbe83d$export$2e2bcd8739ae039 = $ca9197106fbbe83d$var$SvgPercentage;



parcelRequire("2gcPZ");
const $21277c190506bbf2$var$SvgPhone = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "m17.344 12.375-3.664-1.563a1.22 1.22 0 0 0-1.18.102l-1.96 1.305a5.977 5.977 0 0 1-2.75-2.735L9.085 7.5a1.242 1.242 0 0 0 .11-1.18L7.624 2.656a1.273 1.273 0 0 0-1.305-.75A4.39 4.39 0 0 0 2.5 6.25c0 6.203 5.047 11.25 11.25 11.25a4.391 4.391 0 0 0 4.344-3.82 1.274 1.274 0 0 0-.75-1.305Z",
            fill: "currentColor"
        })
    });
var $21277c190506bbf2$export$2e2bcd8739ae039 = $21277c190506bbf2$var$SvgPhone;



parcelRequire("2gcPZ");
const $87130f5837f2bce5$var$SvgPieChartDuotone = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                opacity: 0.2,
                d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm9-7a7 7 0 0 0-5.056 11.842L10 10v7a7 7 0 0 0 7-7h-7V3Z",
                fill: "currentColor"
            })
        ]
    });
var $87130f5837f2bce5$export$2e2bcd8739ae039 = $87130f5837f2bce5$var$SvgPieChartDuotone;



parcelRequire("2gcPZ");
const $fccd5f034ad81c27$var$SvgPlugsConnected = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M18.57 1.43a.633.633 0 0 0-.89 0l-3.93 3.937-.422-.422a2.492 2.492 0 0 0-3.531 0L7.813 6.93l-.18-.188a.633.633 0 0 0-.89.89l.187.18-1.985 1.985a2.493 2.493 0 0 0 0 3.531l.422.422-3.937 3.93a.633.633 0 0 0 0 .89.64.64 0 0 0 .89 0l3.93-3.937.422.422a2.508 2.508 0 0 0 3.531 0l1.985-1.985.18.188a.64.64 0 0 0 .89 0 .633.633 0 0 0 0-.89l-.188-.18 1.985-1.985a2.492 2.492 0 0 0 0-3.531l-.422-.422 3.937-3.93a.633.633 0 0 0 0-.89Zm-4.398 7.89-1.984 1.985-3.493-3.493 1.985-1.984a1.242 1.242 0 0 1 1.765 0l1.727 1.727a1.242 1.242 0 0 1 0 1.765Zm3.922 3.375a.617.617 0 0 1-.594.43.572.572 0 0 1-.195-.031l-1.875-.625a.625.625 0 1 1 .39-1.188l1.875.625a.626.626 0 0 1 .399.79ZM1.906 7.305a.625.625 0 0 1 .79-.399l1.874.625a.625.625 0 1 1-.39 1.188l-1.875-.625a.625.625 0 0 1-.399-.79Zm5-4.61a.625.625 0 1 1 1.188-.39l.625 1.875a.625.625 0 1 1-1.188.39l-.625-1.875Zm6.188 14.61a.625.625 0 1 1-1.188.39l-.625-1.875a.627.627 0 0 1 .64-.818.624.624 0 0 1 .548.428l.625 1.875Z",
            fill: "currentColor"
        })
    });
var $fccd5f034ad81c27$export$2e2bcd8739ae039 = $fccd5f034ad81c27$var$SvgPlugsConnected;



parcelRequire("2gcPZ");
const $8f5a1085ca0ea0a9$var$SvgPlugs = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "m18.57 2.32-2.062 2.055.422.422a2.492 2.492 0 0 1 0 3.531l-1.985 1.985.188.18a.633.633 0 0 1 0 .89.64.64 0 0 1-.89 0l-.626-.625-4.375-4.375-.625-.625a.633.633 0 0 1 .89-.89l.18.187 1.985-1.985a2.492 2.492 0 0 1 3.531 0l.422.422L17.68 1.43a.633.633 0 0 1 .89.89Zm-7.765 8.485-1.43 1.437-1.617-1.617 1.437-1.43a.633.633 0 0 0-.89-.89l-1.43 1.437-.492-.5-.625-.625a.633.633 0 0 0-.89.89l.187.18-1.985 1.985a2.492 2.492 0 0 0 0 3.531l.422.422L1.43 17.68a.633.633 0 0 0 0 .89.64.64 0 0 0 .89 0l2.055-2.062.422.422a2.494 2.494 0 0 0 3.531 0l1.985-1.985.18.188a.64.64 0 0 0 .89 0 .633.633 0 0 0 0-.89l-.625-.626-.5-.492 1.437-1.43a.633.633 0 0 0-.89-.89Z",
            fill: "currentColor"
        })
    });
var $8f5a1085ca0ea0a9$export$2e2bcd8739ae039 = $8f5a1085ca0ea0a9$var$SvgPlugs;



parcelRequire("2gcPZ");
const $c06479f9c8a250f5$var$SvgPlusBorderedDuotone = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                opacity: 0.2,
                x: 2,
                y: 2,
                width: 16,
                height: 16,
                rx: 2,
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M9 6h2v3h3v2h-3v3H9v-3H6V9h3V6Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4Zm2 0h12v12H4V4Z",
                fill: "currentColor"
            })
        ]
    });
var $c06479f9c8a250f5$export$2e2bcd8739ae039 = $c06479f9c8a250f5$var$SvgPlusBorderedDuotone;



parcelRequire("2gcPZ");
const $d0d0608628cdd367$var$SvgPlusDuotone = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                opacity: 0.2,
                x: 2,
                y: 2,
                width: 16,
                height: 16,
                rx: 2,
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5Z",
                fill: "currentColor"
            })
        ]
    });
var $d0d0608628cdd367$export$2e2bcd8739ae039 = $d0d0608628cdd367$var$SvgPlusDuotone;



parcelRequire("2gcPZ");
const $c50f9efb719f5587$var$SvgPlus = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5Z",
            fill: "currentColor"
        })
    });
var $c50f9efb719f5587$export$2e2bcd8739ae039 = $c50f9efb719f5587$var$SvgPlus;



parcelRequire("2gcPZ");
const $608c1ece9a05a20c$var$SvgPresentation = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.875 3.125h-6.25v-1.25a.625.625 0 1 0-1.25 0v1.25h-6.25a1.25 1.25 0 0 0-1.25 1.25v9.375A1.25 1.25 0 0 0 3.125 15h3.078l-1.687 2.11a.625.625 0 0 0 .753.954.61.61 0 0 0 .215-.173L7.797 15h4.406l2.313 2.89a.61.61 0 0 0 .816.138.624.624 0 0 0 .152-.919L13.797 15h3.078a1.25 1.25 0 0 0 1.25-1.25V4.375a1.25 1.25 0 0 0-1.25-1.25Z",
            fill: "currentColor"
        })
    });
var $608c1ece9a05a20c$export$2e2bcd8739ae039 = $608c1ece9a05a20c$var$SvgPresentation;



parcelRequire("2gcPZ");
const $65d41b5402c3eebd$var$SvgPrinter = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.46 5.625h-.835v-2.5A.625.625 0 0 0 15 2.5H5a.625.625 0 0 0-.625.625v2.5h-.836c-1.086 0-1.977.844-1.977 1.875v6.25a.625.625 0 0 0 .625.625h2.188v2.813a.625.625 0 0 0 .625.625h10a.624.624 0 0 0 .625-.625v-2.813h2.188a.624.624 0 0 0 .625-.625V7.5c0-1.031-.891-1.875-1.977-1.875ZM5.626 3.75h8.75v1.875h-8.75V3.75Zm8.75 12.813h-8.75V12.5h8.75v4.063ZM14.688 10a.937.937 0 1 1 0-1.874.937.937 0 0 1 0 1.874Z",
            fill: "currentColor"
        })
    });
var $65d41b5402c3eebd$export$2e2bcd8739ae039 = $65d41b5402c3eebd$var$SvgPrinter;



parcelRequire("2gcPZ");
const $5779f6a9e32009aa$var$SvgPrometheusColorGradientDark = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 272,
        height: 272,
        viewBox: "0 0 272 272",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("circle", {
                opacity: 0.8,
                cx: 136,
                cy: 136,
                r: 136,
                fill: "#000"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M136.001 224c-15.778 0-28.569-10.584-28.569-23.637h57.138c0 13.051-12.792 23.637-28.569 23.637Zm47.187-31.465h-94.38v-17.186h94.382l-.002 17.186Zm-.338-26.032H89.078c-.312-.361-.631-.717-.932-1.083C78.485 153.64 76.21 147.49 74 141.222c-.037-.207 11.715 2.411 20.048 4.294 0 0 4.288.996 10.557 2.144-6.019-7.086-9.593-16.093-9.593-25.301 0-20.213 15.437-37.876 9.868-52.153 5.42.443 11.218 11.489 11.61 28.758 5.762-7.996 8.174-22.6 8.174-31.555 0-9.271 6.083-20.04 12.168-20.409-5.424 8.977 1.405 16.674 7.476 35.766 2.277 7.171 1.986 19.24 3.744 26.893.583-15.896 3.305-39.09 13.346-47.097-4.43 10.084.656 22.702 4.134 28.769 5.612 9.787 9.014 17.202 9.014 31.226 0 9.403-3.457 18.256-9.288 25.176 6.63-1.249 11.209-2.376 11.209-2.376L198 141.138s-3.128 12.921-15.15 25.365Z",
                fill: "url(#PrometheusColorGradientDark_svg__a)"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("linearGradient", {
                    id: "PrometheusColorGradientDark_svg__a",
                    x1: 83.44,
                    y1: 148.373,
                    x2: 198.002,
                    y2: 148.454,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                            stopColor: "#9A0F71",
                            stopOpacity: 0.71
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                            offset: 0.449,
                            stopColor: "#E0196E"
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                            offset: 1,
                            stopColor: "#E5801A",
                            stopOpacity: 0.72
                        })
                    ]
                })
            })
        ]
    });
var $5779f6a9e32009aa$export$2e2bcd8739ae039 = $5779f6a9e32009aa$var$SvgPrometheusColorGradientDark;



parcelRequire("2gcPZ");
const $f1e23b17235be460$var$SvgPrometheusColor = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 26,
        height: 26,
        viewBox: "0 0 26 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M13.4 3C7.657 3 3 7.656 3 13.4c0 5.744 4.657 10.4 10.4 10.4 5.744 0 10.4-4.656 10.4-10.4C23.8 7.656 19.144 3 13.4 3Zm0 19.465c-1.634 0-2.959-1.092-2.959-2.438h5.918c0 1.346-1.325 2.438-2.959 2.438Zm4.888-3.246H8.512v-1.772h9.776v1.772Zm-.035-2.684H8.54l-.096-.112c-1.001-1.215-1.237-1.85-1.466-2.496-.003-.021 1.214.249 2.077.443 0 0 .444.103 1.093.221-.623-.73-.993-1.66-.993-2.61 0-2.084 1.599-3.906 1.022-5.378.561.045 1.162 1.184 1.202 2.966.597-.825.847-2.331.847-3.255 0-.956.63-2.067 1.26-2.105-.561.926.146 1.72.775 3.689.236.74.205 1.984.388 2.774.06-1.64.342-4.032 1.382-4.858-.459 1.04.068 2.342.428 2.967.581 1.01.934 1.774.934 3.22 0 .97-.358 1.884-.962 2.598.686-.13 1.16-.245 1.16-.245l2.23-.436c.001 0-.323 1.333-1.568 2.617Z",
            fill: "#FF5A47"
        })
    });
var $f1e23b17235be460$export$2e2bcd8739ae039 = $f1e23b17235be460$var$SvgPrometheusColor;



parcelRequire("2gcPZ");
const $a2acdd9e49ccf3b6$var$SvgPrometheusFilledGrey = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 51,
        height: 51,
        viewBox: "0 0 51 51",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("circle", {
                cx: 25.541,
                cy: 25.541,
                r: 25.405,
                fill: "#C4C4C4"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M25.541 43.379c-3.163 0-5.729-2.069-5.729-4.62H31.27c0 2.55-2.565 4.62-5.729 4.62Zm9.462-6.15H16.078v-3.36h18.926v3.36Zm-.068-5.088H16.132c-.063-.07-.126-.14-.187-.212-1.937-2.302-2.393-3.504-2.836-4.73-.008-.04 2.349.472 4.02.84 0 0 .86.195 2.117.42-1.207-1.386-1.924-3.146-1.924-4.946 0-3.95 3.096-7.403 1.979-10.193 1.087.086 2.25 2.245 2.328 5.62 1.155-1.562 1.639-4.417 1.639-6.167 0-1.812 1.22-3.917 2.44-3.989-1.088 1.755.282 3.26 1.499 6.99.457 1.402.398 3.761.75 5.257.118-3.107.663-7.64 2.677-9.205-.888 1.97.131 4.437.829 5.623 1.125 1.912 1.807 3.362 1.807 6.103 0 1.838-.693 3.568-1.862 4.92a47.25 47.25 0 0 0 2.248-.464l4.318-.825s-.628 2.526-3.038 4.958Z",
                fill: "#fff"
            })
        ]
    });
var $a2acdd9e49ccf3b6$export$2e2bcd8739ae039 = $a2acdd9e49ccf3b6$var$SvgPrometheusFilledGrey;



parcelRequire("2gcPZ");
const $d192281d287e2e95$var$SvgPrometheus = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M10.5 19.478c-1.654 0-2.995-1.105-2.995-2.468h5.99c0 1.363-1.34 2.468-2.995 2.468Zm4.947-3.285H5.552V14.4h9.895v1.794Zm-.035-2.717H5.58c-.033-.038-.066-.075-.098-.114C4.47 12.132 4.232 11.491 4 10.836c-.004-.021 1.228.252 2.102.449 0 0 .45.104 1.107.223-.631-.74-1.006-1.68-1.006-2.64 0-2.111 1.618-3.955 1.034-5.445.569.046 1.177 1.199 1.218 3.002.604-.835.857-2.36.857-3.294 0-.968.637-2.093 1.275-2.131-.568.937.148 1.74.784 3.734.239.748.208 2.008.393 2.807.06-1.66.346-4.08 1.399-4.916-.465 1.052.069 2.37.433 3.003.588 1.022.945 1.796.945 3.26 0 .981-.362 1.906-.974 2.628.695-.13 1.175-.248 1.175-.248l2.258-.44s-.328 1.349-1.588 2.648Z",
            fill: "currentColor"
        })
    });
var $d192281d287e2e95$export$2e2bcd8739ae039 = $d192281d287e2e95$var$SvgPrometheus;



parcelRequire("2gcPZ");
const $f7938048fc7d0559$var$SvgProxy = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.077 3.429c0-.91.738-1.649 1.648-1.649h10.55c.91 0 1.648.738 1.648 1.649v5.934c0 .91-.738 1.648-1.648 1.648h-4.698v2.308a.582.582 0 0 1-.005.071 2.31 2.31 0 0 1 1.71 1.894.575.575 0 0 1 .218-.042h2.692a.577.577 0 0 1 0 1.154H12.5a.574.574 0 0 1-.296-.082 2.309 2.309 0 0 1-4.453-.168.575.575 0 0 1-.251.057H4.808a.577.577 0 0 1 0-1.154H7.5c.09 0 .175.02.251.058a2.311 2.311 0 0 1 1.676-1.717.582.582 0 0 1-.004-.071V11.01H4.725c-.91 0-1.648-.738-1.648-1.648V3.429Zm2.308 1.236c0-.319.258-.577.577-.577h8.076a.577.577 0 1 1 0 1.154H5.962a.577.577 0 0 1-.577-.577Zm.577 2.884a.577.577 0 0 0 0 1.154h8.076a.577.577 0 1 0 0-1.154H5.962Z",
            fill: "currentColor"
        })
    });
var $f7938048fc7d0559$export$2e2bcd8739ae039 = $f7938048fc7d0559$var$SvgProxy;



parcelRequire("2gcPZ");
const $c39080db2219f25f$var$SvgPushPin = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "m18.125 8.383-4.57 4.57c.351.992.5 2.649-1.032 4.688a1.273 1.273 0 0 1-.914.5h-.086a1.258 1.258 0 0 1-.882-.367l-3.766-3.766-2.68 2.687a.64.64 0 0 1-.89 0 .633.633 0 0 1 0-.89l2.687-2.68-3.781-3.781a1.242 1.242 0 0 1 .102-1.86c1.984-1.601 3.882-1.28 4.718-1.023l4.586-4.586a1.258 1.258 0 0 1 1.766 0l4.742 4.742a1.242 1.242 0 0 1 0 1.766Z",
            fill: "currentColor"
        })
    });
var $c39080db2219f25f$export$2e2bcd8739ae039 = $c39080db2219f25f$var$SvgPushPin;



parcelRequire("2gcPZ");
const $d07fa463259eb4d3$var$SvgPushPinSlash = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.71 16.453a.615.615 0 0 1-.038.883.625.625 0 0 1-.883-.04l-2.062-2.272c-.196 1.109-.774 2.046-1.204 2.617a1.273 1.273 0 0 1-.914.5h-.086a1.258 1.258 0 0 1-.882-.367l-3.766-3.766-2.68 2.687a.64.64 0 0 1-.89 0 .633.633 0 0 1 0-.89l2.687-2.68-3.781-3.781a1.242 1.242 0 0 1 .102-1.86C3.577 6.47 4.804 6.227 5.742 6.25L3.288 3.547a.625.625 0 0 1 .922-.844l12.5 13.75Zm1.415-9.836-4.742-4.742a1.258 1.258 0 0 0-1.766 0L8.648 4.844a.625.625 0 0 0-.023.86l5.36 5.89a.633.633 0 0 0 .445.21h.015a.626.626 0 0 0 .446-.187l3.234-3.234a1.242 1.242 0 0 0 0-1.766Z",
            fill: "currentColor"
        })
    });
var $d07fa463259eb4d3$export$2e2bcd8739ae039 = $d07fa463259eb4d3$var$SvgPushPinSlash;



parcelRequire("2gcPZ");
const $1a2ba9591e2567b1$var$SvgQuestion = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M10 1.875A8.125 8.125 0 1 0 18.125 10 8.14 8.14 0 0 0 10 1.875ZM10 15a.938.938 0 1 1 0-1.875A.938.938 0 0 1 10 15Zm.625-3.82v.07a.624.624 0 1 1-1.25 0v-.625A.625.625 0 0 1 10 10a1.563 1.563 0 1 0-1.563-1.563.625.625 0 1 1-1.25 0 2.813 2.813 0 1 1 3.438 2.743Z",
            fill: "currentColor"
        })
    });
var $1a2ba9591e2567b1$export$2e2bcd8739ae039 = $1a2ba9591e2567b1$var$SvgQuestion;



parcelRequire("2gcPZ");
const $069212f7771a86db$var$SvgQuotes = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M9.063 5.625V12.5a3.75 3.75 0 0 1-3.75 3.75.625.625 0 1 1 0-1.25 2.508 2.508 0 0 0 2.5-2.5v-.625H3.125a1.25 1.25 0 0 1-1.25-1.25v-5a1.25 1.25 0 0 1 1.25-1.25h4.688a1.25 1.25 0 0 1 1.25 1.25Zm7.812-1.25h-4.688a1.25 1.25 0 0 0-1.25 1.25v5a1.25 1.25 0 0 0 1.25 1.25h4.688v.625a2.508 2.508 0 0 1-2.5 2.5.624.624 0 1 0 0 1.25 3.75 3.75 0 0 0 3.75-3.75V5.625a1.25 1.25 0 0 0-1.25-1.25Z",
            fill: "currentColor"
        })
    });
var $069212f7771a86db$export$2e2bcd8739ae039 = $069212f7771a86db$var$SvgQuotes;



parcelRequire("2gcPZ");
const $d4690072a05bdc5a$var$SvgRobot = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M15.625 3.75h-5v-2.5a.625.625 0 1 0-1.25 0v2.5h-5a2.508 2.508 0 0 0-2.5 2.5V15a2.508 2.508 0 0 0 2.5 2.5h11.25a2.508 2.508 0 0 0 2.5-2.5V6.25a2.508 2.508 0 0 0-2.5-2.5Zm-10 4.688a.937.937 0 1 1 1.875 0 .937.937 0 0 1-1.875 0Zm2.188 5.937h-.625a1.25 1.25 0 0 1 0-2.5h.625v2.5Zm3.125 0H9.062v-2.5h1.876v2.5Zm1.874 0h-.624v-2.5h.624a1.25 1.25 0 0 1 0 2.5Zm.626-5a.937.937 0 1 1 0-1.874.937.937 0 0 1 0 1.874Z",
            fill: "currentColor"
        })
    });
var $d4690072a05bdc5a$export$2e2bcd8739ae039 = $d4690072a05bdc5a$var$SvgRobot;



parcelRequire("2gcPZ");
const $1f0218f2475cfbbe$var$SvgRocket = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "m5.42 14.53-.619-.516c-.543-.2-1.147.082-1.811.847l-.35.885c-.174.831-.174 1.346 0 1.543.205.182.723.185 1.554.01l.896-.338c.765-.664 1.044-1.272.836-1.822l-.506-.609M16.642 3.288c-.979-.293-2.133-.39-3.462-.29-2.658.2-4.866 1.28-6.624 3.237a7.583 7.583 0 0 0-1.654-.403c-1.185-.144-1.994.086-2.429.692L1.328 8.141C.651 9.304.504 10.094.887 10.51c.171.172.454.34.847.504.787.342 1.734.517 2.84.525l.238.855c.244.656.6 1.207 1.07 1.653.445.469.996.825 1.652 1.07l.855.238c.004.538.047 1.038.129 1.5.05.279.115.543.193.793.06.19.128.372.204.547.164.393.332.675.503.846.417.383 1.208.236 2.37-.441l1.617-1.145c.606-.434.837-1.244.693-2.428a7.579 7.579 0 0 0-.404-1.655c1.958-1.758 3.037-3.966 3.237-6.624.1-1.329.004-2.483-.29-3.461Z",
            fill: "currentColor"
        })
    });
var $1f0218f2475cfbbe$export$2e2bcd8739ae039 = $1f0218f2475cfbbe$var$SvgRocket;



parcelRequire("2gcPZ");
const $b2565a04875043e2$var$SvgScissors = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 18,
        height: 14,
        viewBox: "0 0 18 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M11.32 5.836a.625.625 0 0 1 .164-.867l5.29-3.617a.625.625 0 0 1 .703 1.03L12.195 6a.61.61 0 0 1-.36.11.625.625 0 0 1-.515-.274Zm6.32 6.648a.617.617 0 0 1-.867.164l-7.148-4.89-3.32 2.273a2.843 2.843 0 0 1-.431 2.813A2.82 2.82 0 1 1 5.593 9l2.922-2-2.922-2a2.773 2.773 0 0 1-1.907.75 2.813 2.813 0 1 1 2.618-1.781l11.172 7.648a.618.618 0 0 1 .164.867ZM5.25 11.063a1.54 1.54 0 0 0-.461-1.102 1.547 1.547 0 0 0-2.203 0 1.547 1.547 0 0 0 0 2.203 1.555 1.555 0 0 0 2.203 0 1.54 1.54 0 0 0 .461-1.101Zm-.461-7.024a1.547 1.547 0 0 0 0-2.203 1.547 1.547 0 0 0-2.203 0 1.547 1.547 0 0 0 0 2.203 1.555 1.555 0 0 0 2.203 0Z",
            fill: "currentColor"
        })
    });
var $b2565a04875043e2$export$2e2bcd8739ae039 = $b2565a04875043e2$var$SvgScissors;



parcelRequire("2gcPZ");
const $a7d7766bdcb70bde$var$SvgSearchDuotone = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("circle", {
                opacity: 0.2,
                cx: 8.5,
                cy: 8.5,
                r: 6.5,
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.335 13.749a6.5 6.5 0 1 1 1.414-1.414l3.907 3.907-1.414 1.415-3.908-3.908ZM13 8.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z",
                fill: "currentColor"
            })
        ]
    });
var $a7d7766bdcb70bde$export$2e2bcd8739ae039 = $a7d7766bdcb70bde$var$SvgSearchDuotone;



parcelRequire("2gcPZ");
const $f5d23a9bd8093c39$var$SvgSettingsDuotone = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("g", {
                clipPath: "url(#SettingsDuotone_svg__a)",
                fillRule: "evenodd",
                clipRule: "evenodd",
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                        opacity: 0.2,
                        d: "M4.77 4.937a1 1 0 0 1 .365-1.366l1.732-1a1 1 0 0 1 1.366.366l.452.782c.069.026.138.055.206.087a2.6 2.6 0 0 0 2.22 0c.068-.032.137-.061.207-.087l.45-.78a1 1 0 0 1 1.366-.367l1.732 1a1 1 0 0 1 .366 1.366l-.45.78c.012.073.022.148.028.224.064.774.471 1.48 1.11 1.922.062.043.122.088.179.136h.902a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H16.1a2.691 2.691 0 0 1-.18.136 2.599 2.599 0 0 0-1.109 1.921c-.006.076-.016.15-.028.223l.451.781a1 1 0 0 1-.366 1.366l-1.732 1a1 1 0 0 1-1.366-.366l-.45-.78a2.713 2.713 0 0 1-.209-.087 2.6 2.6 0 0 0-2.219 0 2.665 2.665 0 0 1-.208.087l-.45.782a1 1 0 0 1-1.367.366l-1.732-1a1 1 0 0 1-.366-1.366l.452-.782a2.687 2.687 0 0 1-.028-.224 2.6 2.6 0 0 0-1.11-1.921 2.703 2.703 0 0 1-.18-.136h-.9a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h.9c.058-.048.118-.093.18-.136a2.6 2.6 0 0 0 1.11-1.922c.006-.076.015-.151.028-.225l-.45-.78Zm6.73 7.66a3 3 0 1 0-3-5.195 3 3 0 0 0 3 5.196Z"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                        d: "M3.902 5.437a2 2 0 0 1 .733-2.732l1.732-1a2 2 0 0 1 2.732.732l.285.494a1.6 1.6 0 0 0 1.233 0l.284-.493a2 2 0 0 1 2.732-.732l1.733 1a2 2 0 0 1 .732 2.732l-.285.492A1.6 1.6 0 0 0 16.43 7H17a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-.57c-.34.259-.562.643-.616 1.068l.285.493a2 2 0 0 1-.732 2.733l-1.733 1a2 2 0 0 1-2.732-.733l-.284-.492a1.6 1.6 0 0 0-1.235 0l-.285.494a2 2 0 0 1-2.733.732l-1.732-1a2 2 0 0 1-.732-2.732l.286-.495A1.599 1.599 0 0 0 3.569 13h-.568a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h.57a1.6 1.6 0 0 0 .616-1.07l-.285-.493Zm3.465-2-1.732 1 .63 1.092-.06.355a1.683 1.683 0 0 0-.017.14A3.6 3.6 0 0 1 4.65 8.687c-.04.027-.077.056-.112.085L4.26 9h-1.26v2h1.26l.277.229c.036.03.074.058.113.085a3.599 3.599 0 0 1 1.537 2.661c.004.048.01.095.017.14l.06.354-.632 1.094 1.732 1 .631-1.093.337-.126c.044-.016.087-.034.13-.055.974-.459 2.1-.459 3.074 0 .043.021.087.04.13.056l.338.125.63 1.091 1.732-1-.631-1.092.06-.354c.007-.046.013-.092.017-.14a3.599 3.599 0 0 1 1.536-2.66 1.67 1.67 0 0 0 .113-.086l.277-.23h1.262V9h-1.262l-.277-.228a1.693 1.693 0 0 0-.113-.085 3.6 3.6 0 0 1-1.536-2.661 1.69 1.69 0 0 0-.018-.141l-.06-.355.63-1.09-1.732-1-.63 1.09-.337.127a1.698 1.698 0 0 0-.13.054c-.972.46-2.1.46-3.072 0a1.683 1.683 0 0 0-.13-.054l-.336-.126-.631-1.093ZM6.537 12a4 4 0 1 1 6.927-4 4 4 0 0 1-6.928 4ZM9 8.268a2 2 0 1 0 2 3.464 2 2 0 0 0-2-3.464Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("clipPath", {
                    id: "SettingsDuotone_svg__a",
                    children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h20v20H0z"
                    })
                })
            })
        ]
    });
var $f5d23a9bd8093c39$export$2e2bcd8739ae039 = $f5d23a9bd8093c39$var$SvgSettingsDuotone;



parcelRequire("2gcPZ");
const $9e648fed48488f9f$var$SvgShareNetwork = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M13.75 12.5a3.101 3.101 0 0 0-2.234.945l-3.602-2.312a3.148 3.148 0 0 0 0-2.266l3.602-2.312a3.125 3.125 0 1 0-.89-2.18c0 .387.072.771.21 1.133L7.234 7.82a3.125 3.125 0 1 0 0 4.36l3.602 2.312c-.138.362-.21.746-.21 1.133A3.125 3.125 0 1 0 13.75 12.5Z",
            fill: "currentColor"
        })
    });
var $9e648fed48488f9f$export$2e2bcd8739ae039 = $9e648fed48488f9f$var$SvgShareNetwork;



parcelRequire("2gcPZ");
const $a4643cddd9dbbfe6$var$SvgShieldCheck = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.25 3.125H3.75a1.25 1.25 0 0 0-1.25 1.25v4.586c0 6.984 5.922 9.305 7.11 9.695.253.084.527.084.78 0 1.188-.39 7.11-2.71 7.11-9.695V4.375a1.25 1.25 0 0 0-1.25-1.25Zm-2.383 5.453L9.29 12.953a.633.633 0 0 1-.867 0l-2.29-2.187a.625.625 0 1 1 .86-.907l1.86 1.774 4.156-3.961a.625.625 0 0 1 .86.906Z",
            fill: "currentColor"
        })
    });
var $a4643cddd9dbbfe6$export$2e2bcd8739ae039 = $a4643cddd9dbbfe6$var$SvgShieldCheck;



parcelRequire("2gcPZ");
const $b032e89052ccbde4$var$SvgSidebarDot = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 21,
        height: 21,
        viewBox: "0 0 21 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M16.875 4.125H3.125a1.25 1.25 0 0 0-1.25 1.25v11.25a1.25 1.25 0 0 0 1.25 1.25h13.75a1.25 1.25 0 0 0 1.25-1.25V5.375a1.25 1.25 0 0 0-1.25-1.25Zm0 12.5h-10V5.375h10v11.25Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("circle", {
                cx: 16,
                cy: 5,
                r: 4.333,
                fill: "#F41900",
                stroke: "#fff",
                strokeWidth: 0.667
            })
        ]
    });
var $b032e89052ccbde4$export$2e2bcd8739ae039 = $b032e89052ccbde4$var$SvgSidebarDot;



parcelRequire("2gcPZ");
const $e3d1812cae5753f9$var$SvgSidebar = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M2 6a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V6Zm2 8a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8Z",
            fill: "currentColor"
        })
    });
var $e3d1812cae5753f9$export$2e2bcd8739ae039 = $e3d1812cae5753f9$var$SvgSidebar;



parcelRequire("2gcPZ");
const $149179754d5551f1$var$SvgSidebarSimple = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M2 6a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V6Zm2 8a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8Z",
            fill: "currentColor"
        })
    });
var $149179754d5551f1$export$2e2bcd8739ae039 = $149179754d5551f1$var$SvgSidebarSimple;



parcelRequire("2gcPZ");
const $da32dd93171d73a7$var$SvgSignOut = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "m17.32 10.445-3.28 3.282a.649.649 0 0 1-.446.18.625.625 0 0 1-.625-.625v-2.657H8.125a.625.625 0 1 1 0-1.25h4.844V6.719a.624.624 0 0 1 .75-.612c.12.024.231.081.32.166l3.281 3.282a.633.633 0 0 1 0 .89ZM8.125 16.25H3.75V3.75h4.375a.625.625 0 0 0 0-1.25H3.75A1.25 1.25 0 0 0 2.5 3.75v12.5a1.25 1.25 0 0 0 1.25 1.25h4.375a.625.625 0 1 0 0-1.25Z",
            fill: "currentColor"
        })
    });
var $da32dd93171d73a7$export$2e2bcd8739ae039 = $da32dd93171d73a7$var$SvgSignOut;



parcelRequire("2gcPZ");
const $1a291ca23c4d0362$var$SvgSloDuotone = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                opacity: 0.2,
                fill: "currentColor",
                d: "M4 4h12v12H4z"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M4.001 15.999v-2.998h-2v1a2 2 0 0 0 1.998 2 2 2 0 0 0 2 1.998h8a2 2 0 0 0 2-2H4.001ZM18.001 13.001v1a2 2 0 0 1-2 2v-3h2ZM16.001 4.001H4.004a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2 2 2 0 0 1 1.997 2v2h-2v-4ZM2.001 8.001v-2a2 2 0 0 1 2-2v4h-2Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M13.127 6.802a1 1 0 0 0-1.834-.322l-2.804 4.6-.61-1a1 1 0 0 0-.854-.479H3.001v2h3.463l1.171 1.92a1 1 0 0 0 1.708 0l2.332-3.824.224 1.103a1 1 0 0 0 .98.801h5.122v-2h-4.305l-.569-2.8Z",
                fill: "currentColor"
            })
        ]
    });
var $1a291ca23c4d0362$export$2e2bcd8739ae039 = $1a291ca23c4d0362$var$SvgSloDuotone;



parcelRequire("2gcPZ");
const $b92ad0e568581a59$var$SvgSortAscending = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "m17.945 13.57-3.125 3.125a.64.64 0 0 1-.89 0l-3.125-3.125a.656.656 0 0 1-.133-.687.625.625 0 0 1 .578-.383h2.5V8.75a.625.625 0 1 1 1.25 0v3.75h2.5a.625.625 0 0 1 .578.383.656.656 0 0 1-.133.687Zm-8.57-4.195H3.75a.625.625 0 0 0 0 1.25h5.625a.625.625 0 1 0 0-1.25ZM3.75 5.625h10.625a.625.625 0 1 0 0-1.25H3.75a.625.625 0 0 0 0 1.25Zm4.375 8.75H3.75a.625.625 0 1 0 0 1.25h4.375a.625.625 0 1 0 0-1.25Z",
            fill: "currentColor"
        })
    });
var $b92ad0e568581a59$export$2e2bcd8739ae039 = $b92ad0e568581a59$var$SvgSortAscending;



parcelRequire("2gcPZ");
const $b1edb2efe647d8b2$var$SvgSortDescending = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M18.078 7.11a.625.625 0 0 1-.578.39H15v3.75a.625.625 0 1 1-1.25 0V7.5h-2.5a.633.633 0 0 1-.578-.383.656.656 0 0 1 .133-.687l3.125-3.125a.633.633 0 0 1 .89 0l3.125 3.125a.64.64 0 0 1 .133.68ZM3.75 10.624h5.625a.625.625 0 0 0 0-1.25H3.75a.625.625 0 1 0 0 1.25Zm0-5h4.375a.625.625 0 0 0 0-1.25H3.75a.625.625 0 1 0 0 1.25Zm10.625 8.75H3.75a.625.625 0 1 0 0 1.25h10.625a.625.625 0 0 0 0-1.25Z",
            fill: "currentColor"
        })
    });
var $b1edb2efe647d8b2$export$2e2bcd8739ae039 = $b1edb2efe647d8b2$var$SvgSortDescending;



parcelRequire("2gcPZ");
const $30af157fa3e79bb7$var$SvgSource = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M16 11v1.2c0 .477-.27.935-.753 1.273-.482.337-1.136.527-1.818.527h-.715v3M4 11v1.2c0 .477.27.935.753 1.273.482.337 1.136.527 1.818.527h.715v3",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("circle", {
                cx: 10,
                cy: 4,
                r: 2,
                fill: "currentColor",
                stroke: "currentColor",
                strokeWidth: 0.714
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("circle", {
                cx: 14.999,
                cy: 9,
                r: 2,
                fill: "currentColor",
                stroke: "currentColor",
                strokeWidth: 0.714
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("circle", {
                cx: 5,
                cy: 9,
                r: 2,
                fill: "currentColor",
                stroke: "currentColor",
                strokeWidth: 0.714
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M10 12V6",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $30af157fa3e79bb7$export$2e2bcd8739ae039 = $30af157fa3e79bb7$var$SvgSource;



parcelRequire("2gcPZ");
const $82b81d3b0c385c3e$var$SvgSparkle = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                opacity: 0.2,
                d: "m15.22 11.83-4.036 1.485a.615.615 0 0 0-.366.366l-1.484 4.036a.619.619 0 0 1-1.161 0l-1.485-4.036a.615.615 0 0 0-.366-.366L2.286 11.83a.62.62 0 0 1 0-1.162l4.036-1.484a.616.616 0 0 0 .366-.366l1.485-4.036a.619.619 0 0 1 1.16 0l1.485 4.036a.616.616 0 0 0 .366.366l4.036 1.484a.619.619 0 0 1 0 1.162Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "m15.436 10.083-4.032-1.485L9.92 4.563a1.244 1.244 0 0 0-2.335 0L6.1 8.593l-4.035 1.485a1.244 1.244 0 0 0 0 2.335l4.03 1.493 1.484 4.033a1.243 1.243 0 0 0 2.335 0l1.484-4.032 4.035-1.484a1.244 1.244 0 0 0 0-2.335l.004-.005Zm-4.468 2.651a1.24 1.24 0 0 0-.737.737l-1.484 4.02-1.481-4.023a1.24 1.24 0 0 0-.734-.734l-4.02-1.484 4.02-1.484a1.24 1.24 0 0 0 .734-.734l1.484-4.02 1.484 4.02a1.24 1.24 0 0 0 .737.737l4.02 1.484-4.023 1.481Zm.282-9.609a.625.625 0 0 1 .625-.625h1.25V1.25a.625.625 0 1 1 1.25 0V2.5h1.25a.625.625 0 0 1 0 1.25h-1.25V5a.625.625 0 0 1-1.25 0V3.75h-1.25a.625.625 0 0 1-.625-.625Zm8.125 3.75a.625.625 0 0 1-.625.625h-.625v.625a.625.625 0 0 1-1.25 0V7.5h-.625a.625.625 0 1 1 0-1.25h.625v-.625a.625.625 0 1 1 1.25 0v.625h.625a.625.625 0 0 1 .625.625Z",
                fill: "currentColor"
            })
        ]
    });
var $82b81d3b0c385c3e$export$2e2bcd8739ae039 = $82b81d3b0c385c3e$var$SvgSparkle;



parcelRequire("2gcPZ");
const $88132325f260e2ab$var$SvgSquaresFour = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M8.75 3.125h-5a.625.625 0 0 0-.625.625v5c0 .345.28.625.625.625h5c.345 0 .625-.28.625-.625v-5a.625.625 0 0 0-.625-.625ZM16.25 3.125h-5a.625.625 0 0 0-.625.625v5c0 .345.28.625.625.625h5c.345 0 .625-.28.625-.625v-5a.625.625 0 0 0-.625-.625ZM8.75 10.625h-5a.625.625 0 0 0-.625.625v5c0 .345.28.625.625.625h5c.345 0 .625-.28.625-.625v-5a.625.625 0 0 0-.625-.625ZM16.25 10.625h-5a.625.625 0 0 0-.625.625v5c0 .345.28.625.625.625h5c.345 0 .625-.28.625-.625v-5a.625.625 0 0 0-.625-.625Z",
            fill: "currentColor"
        })
    });
var $88132325f260e2ab$export$2e2bcd8739ae039 = $88132325f260e2ab$var$SvgSquaresFour;



parcelRequire("2gcPZ");
const $6dfa8b55b25e46f2$var$SvgStacked = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.688 3.125a.5.5 0 0 1 .5-.5h4.374a.5.5 0 0 1 .5.5V16.25a.5.5 0 0 1-.5.5H7.885a.503.503 0 0 1-.142 0H3.438a.5.5 0 0 1-.5-.5V6.812a.5.5 0 0 1 .5-.5h3.874v-.437a.5.5 0 0 1 .5-.5h3.875v-2.25ZM7.311 7.312H3.938V11h3.376V7.312Zm0 4.688H3.938v3.75h3.376V12Zm1 3.75V6.375h3.376v9.375H8.312Zm4.376 0V3.625h3.374V15.75h-3.375Z",
            fill: "currentColor"
        })
    });
var $6dfa8b55b25e46f2$export$2e2bcd8739ae039 = $6dfa8b55b25e46f2$var$SvgStacked;



parcelRequire("2gcPZ");
const $bff0bf5d5a5b26c8$var$SvgStack = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M17.188 13.21 10 17.399l-7.187-4.187a.625.625 0 0 0-.625 1.078l7.5 4.375a.61.61 0 0 0 .624 0l7.5-4.375a.627.627 0 0 0 .271-.877.627.627 0 0 0-.895-.201Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M17.188 9.46 10 13.649 2.813 9.461a.625.625 0 0 0-.625 1.078l7.5 4.375a.61.61 0 0 0 .624 0l7.5-4.375a.627.627 0 0 0 .271-.877.627.627 0 0 0-.895-.201Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "m2.188 6.79 7.5 4.374a.61.61 0 0 0 .625 0l7.5-4.375a.625.625 0 0 0 0-1.078l-7.5-4.375a.602.602 0 0 0-.625 0l-7.5 4.375a.625.625 0 0 0 0 1.078Z",
                fill: "currentColor"
            })
        ]
    });
var $bff0bf5d5a5b26c8$export$2e2bcd8739ae039 = $bff0bf5d5a5b26c8$var$SvgStack;



parcelRequire("2gcPZ");
const $1d6e05ed834a847e$var$SvgStar = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M18.688 7.61a1.282 1.282 0 0 0-1.141-.891l-4.64-.32-1.72-4.337A1.281 1.281 0 0 0 10 1.25a1.281 1.281 0 0 0-1.188.813l-1.75 4.359-4.609.297a1.289 1.289 0 0 0-1.14.89 1.312 1.312 0 0 0 .406 1.414l3.547 3-1.055 4.149a1.445 1.445 0 0 0 .547 1.531 1.407 1.407 0 0 0 1.57.047l3.664-2.32h.016l3.945 2.492c.203.131.438.202.68.203a1.288 1.288 0 0 0 1.234-1.625l-1.117-4.54 3.531-2.937a1.313 1.313 0 0 0 .407-1.414Z",
            fill: "currentColor"
        })
    });
var $1d6e05ed834a847e$export$2e2bcd8739ae039 = $1d6e05ed834a847e$var$SvgStar;



parcelRequire("2gcPZ");
const $300b8720044a1f3a$var$SvgSunDuotone = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("circle", {
                opacity: 0.2,
                cx: 10,
                cy: 10,
                r: 8,
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M9 1h2v3H9V1Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10 15a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0-2a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M16 11h3V9h-3v2ZM4 9v2H1V9h3ZM9 16v3h2v-3H9ZM13.634 1.706l1.732 1-1.5 2.598-1.732-1 1.5-2.598ZM17.294 15.366l1-1.732-2.598-1.5-1 1.732 2.598 1.5ZM5.304 6.134l-1 1.732-2.598-1.5 1-1.732 2.598 1.5ZM4.634 17.294l1.732 1 1.5-2.598-1.732-1-1.5 2.598ZM17.294 4.634l1 1.732-2.599 1.5-1-1.732 2.599-1.5ZM13.633 18.294l1.732-1-1.5-2.598-1.732 1 1.5 2.598ZM7.865 4.304l-1.732 1-1.5-2.598 1.732-1 1.5 2.598ZM1.705 13.634l1 1.732 2.598-1.5-1-1.732-2.598 1.5Z",
                fill: "currentColor"
            })
        ]
    });
var $300b8720044a1f3a$export$2e2bcd8739ae039 = $300b8720044a1f3a$var$SvgSunDuotone;



parcelRequire("2gcPZ");
const $bf684c266a4b4c72$var$SvgSun = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 21,
        height: 21,
        viewBox: "0 0 21 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M9.6 3.263v-.625a.625.625 0 1 1 1.25 0v.625a.625.625 0 0 1-1.25 0Zm.626 1.875a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm-5.443.442a.625.625 0 1 0 .885-.884l-.625-.625a.625.625 0 1 0-.885.884l.625.625Zm0 9.116-.625.624a.625.625 0 1 0 .885.885l.625-.625a.625.625 0 0 0-.885-.885Zm10.443-8.933a.625.625 0 0 0 .442-.183l.625-.625a.626.626 0 0 0-.885-.884l-.625.625a.625.625 0 0 0 .443 1.067Zm.442 8.932a.625.625 0 1 0-.885.885l.625.625a.624.624 0 1 0 .885-.884l-.625-.626ZM3.35 9.513h-.625a.625.625 0 1 0 0 1.25h.625a.625.625 0 0 0 0-1.25Zm6.875 6.875a.625.625 0 0 0-.625.625v.625a.625.625 0 1 0 1.25 0v-.625a.625.625 0 0 0-.625-.625Zm7.5-6.875H17.1a.625.625 0 0 0 0 1.25h.625a.625.625 0 0 0 0-1.25Z",
            fill: "currentColor"
        })
    });
var $bf684c266a4b4c72$export$2e2bcd8739ae039 = $bf684c266a4b4c72$var$SvgSun;



parcelRequire("2gcPZ");
const $e1b0b53e20c94b28$var$SvgTable = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M17.5 3.75h-15a.625.625 0 0 0-.625.625V15a1.25 1.25 0 0 0 1.25 1.25h13.75a1.25 1.25 0 0 0 1.25-1.25V4.375a.625.625 0 0 0-.625-.625Zm-14.375 5H6.25v2.5H3.125v-2.5Zm4.375 0h9.375v2.5H7.5v-2.5ZM3.125 12.5H6.25V15H3.125v-2.5Zm13.75 2.5H7.5v-2.5h9.375V15Z",
            fill: "currentColor"
        })
    });
var $e1b0b53e20c94b28$export$2e2bcd8739ae039 = $e1b0b53e20c94b28$var$SvgTable;



parcelRequire("2gcPZ");
const $19c2b644e139f368$var$SvgTargetDuotone = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                opacity: 0.2,
                d: "M14 10a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14 10a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-2 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-2 0a6 6 0 1 1-12 0 6 6 0 0 1 12 0Z",
                fill: "currentColor"
            })
        ]
    });
var $19c2b644e139f368$export$2e2bcd8739ae039 = $19c2b644e139f368$var$SvgTargetDuotone;



parcelRequire("2gcPZ");
const $1cf13b33d88ba807$var$SvgTemplates = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.25 7.5a1.25 1.25 0 0 0 1.25-1.25v-2.5a1.25 1.25 0 0 0-1.25-1.25h-2.5a1.25 1.25 0 0 0-1.25 1.25v.625h-5V3.75A1.25 1.25 0 0 0 6.25 2.5h-2.5A1.25 1.25 0 0 0 2.5 3.75v2.5A1.25 1.25 0 0 0 3.75 7.5h.625v5H3.75a1.25 1.25 0 0 0-1.25 1.25v2.5a1.25 1.25 0 0 0 1.25 1.25h2.5a1.25 1.25 0 0 0 1.25-1.25v-.625h5v.625a1.25 1.25 0 0 0 1.25 1.25h2.5a1.25 1.25 0 0 0 1.25-1.25v-2.5a1.25 1.25 0 0 0-1.25-1.25h-.625v-5h.625Zm-1.875 5h-.625a1.25 1.25 0 0 0-1.25 1.25v.625h-5v-.625a1.25 1.25 0 0 0-1.25-1.25h-.625v-5h.625A1.25 1.25 0 0 0 7.5 6.25v-.625h5v.625a1.25 1.25 0 0 0 1.25 1.25h.625v5Z",
            fill: "currentColor"
        })
    });
var $1cf13b33d88ba807$export$2e2bcd8739ae039 = $1cf13b33d88ba807$var$SvgTemplates;



parcelRequire("2gcPZ");
const $498005cebbf40775$var$SvgTerminal = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M9.375 10a.625.625 0 0 0-.21-.469l-5.626-5a.626.626 0 0 0-.828.938l5.102 4.53-5.102 4.532a.625.625 0 1 0 .828.938l5.625-5A.625.625 0 0 0 9.375 10ZM16.875 14.375h-7.5a.625.625 0 1 0 0 1.25h7.5a.624.624 0 1 0 0-1.25Z",
            fill: "currentColor"
        })
    });
var $498005cebbf40775$export$2e2bcd8739ae039 = $498005cebbf40775$var$SvgTerminal;



parcelRequire("2gcPZ");
const $f3e5924aa867a4eb$var$SvgTerminalWindow = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.836 3.086H3.164a1.328 1.328 0 0 0-1.328 1.328v11.172a1.328 1.328 0 0 0 1.328 1.328h13.672a1.329 1.329 0 0 0 1.328-1.328V4.414a1.328 1.328 0 0 0-1.328-1.328Zm-7.383 7.398-3.125 2.5a.617.617 0 0 1-.875-.093.616.616 0 0 1 .094-.875L8.063 10 5.546 7.984a.625.625 0 1 1 .781-.968l3.125 2.5a.617.617 0 0 1 0 .968Zm4.61 2.641h-3.126a.624.624 0 1 1 0-1.25h3.126a.624.624 0 1 1 0 1.25Z",
            fill: "currentColor"
        })
    });
var $f3e5924aa867a4eb$export$2e2bcd8739ae039 = $f3e5924aa867a4eb$var$SvgTerminalWindow;



parcelRequire("2gcPZ");
const $23c363434d239101$var$SvgTextAa = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M10.773 11.578 6.805 4.086a.625.625 0 0 0-1.11 0l-3.968 7.492L.07 14.711a.633.633 0 0 0 .266.844.632.632 0 0 0 .844-.266L2.656 12.5h7.188l1.476 2.789a.616.616 0 0 0 .555.336.625.625 0 0 0 .555-.914l-1.657-3.133ZM3.32 11.25l2.93-5.54 2.93 5.54H3.32Zm12.93-3.836a3.281 3.281 0 0 0-2.313.922.626.626 0 1 0 .875.89c.387-.369.903-.571 1.438-.562 1.031 0 1.875.703 1.875 1.563v.562a3.36 3.36 0 0 0-1.875-.563c-1.727 0-3.125 1.258-3.125 2.813 0 1.555 1.398 2.813 3.125 2.813a3.351 3.351 0 0 0 1.93-.602.618.618 0 0 0 .57.375.625.625 0 0 0 .625-.625v-4.774c0-1.554-1.398-2.812-3.125-2.812Zm0 7.188c-1.031 0-1.875-.704-1.875-1.563 0-.86.844-1.563 1.875-1.563 1.031 0 1.875.704 1.875 1.563 0 .86-.844 1.563-1.875 1.563Z",
            fill: "currentColor"
        })
    });
var $23c363434d239101$export$2e2bcd8739ae039 = $23c363434d239101$var$SvgTextAa;



parcelRequire("2gcPZ");
const $0fb2a38f622c1aaa$var$SvgTextAlignCenter = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M3.125 5.938h13.75a.625.625 0 1 0 0-1.25H3.125a.625.625 0 0 0 0 1.25ZM5 7.813a.625.625 0 0 0 0 1.25h10a.625.625 0 1 0 0-1.25H5ZM16.875 10.938H3.125a.625.625 0 1 0 0 1.25h13.75a.624.624 0 1 0 0-1.25ZM15 14.063H5a.625.625 0 1 0 0 1.25h10a.624.624 0 1 0 0-1.25Z",
            fill: "currentColor"
        })
    });
var $0fb2a38f622c1aaa$export$2e2bcd8739ae039 = $0fb2a38f622c1aaa$var$SvgTextAlignCenter;



parcelRequire("2gcPZ");
const $8b35d4e8e2c7e3d5$var$SvgTextAlignJustify = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M3.125 5.938h13.75a.625.625 0 1 0 0-1.25H3.125a.625.625 0 0 0 0 1.25ZM16.875 7.813H3.125a.625.625 0 0 0 0 1.25h13.75a.625.625 0 1 0 0-1.25ZM16.875 10.938H3.125a.625.625 0 1 0 0 1.25h13.75a.624.624 0 1 0 0-1.25ZM16.875 14.063H3.125a.625.625 0 1 0 0 1.25h13.75a.624.624 0 1 0 0-1.25Z",
            fill: "currentColor"
        })
    });
var $8b35d4e8e2c7e3d5$export$2e2bcd8739ae039 = $8b35d4e8e2c7e3d5$var$SvgTextAlignJustify;



parcelRequire("2gcPZ");
const $8379d67b430a6f2e$var$SvgTextAlignLeft = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M3.125 5.938h13.75a.625.625 0 1 0 0-1.25H3.125a.625.625 0 0 0 0 1.25ZM3.125 9.063h10a.625.625 0 1 0 0-1.25h-10a.625.625 0 0 0 0 1.25ZM16.875 10.938H3.125a.625.625 0 1 0 0 1.25h13.75a.624.624 0 1 0 0-1.25ZM13.125 14.063h-10a.625.625 0 1 0 0 1.25h10a.624.624 0 1 0 0-1.25Z",
            fill: "currentColor"
        })
    });
var $8379d67b430a6f2e$export$2e2bcd8739ae039 = $8379d67b430a6f2e$var$SvgTextAlignLeft;



parcelRequire("2gcPZ");
const $cb1c130d79faf927$var$SvgTextAlignRight = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M3.125 5.938h13.75a.625.625 0 1 0 0-1.25H3.125a.625.625 0 0 0 0 1.25ZM16.875 7.813h-10a.625.625 0 0 0 0 1.25h10a.625.625 0 1 0 0-1.25ZM16.875 10.938H3.125a.625.625 0 1 0 0 1.25h13.75a.624.624 0 1 0 0-1.25ZM16.875 14.063h-10a.625.625 0 1 0 0 1.25h10a.624.624 0 1 0 0-1.25Z",
            fill: "currentColor"
        })
    });
var $cb1c130d79faf927$export$2e2bcd8739ae039 = $cb1c130d79faf927$var$SvgTextAlignRight;



parcelRequire("2gcPZ");
const $bf501b18cb1c9a7b$var$SvgTextBolder = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M13.32 9.04a3.438 3.438 0 0 0-2.382-5.915H5a.617.617 0 0 0-.625.625v11.875A.625.625 0 0 0 5 16.25h6.875a3.75 3.75 0 0 0 1.445-7.21ZM5.625 4.374h5.313a2.187 2.187 0 0 1 0 4.375H5.625V4.375ZM11.875 15h-6.25v-5h6.25a2.5 2.5 0 1 1 0 5Z",
            fill: "currentColor"
        })
    });
var $bf501b18cb1c9a7b$export$2e2bcd8739ae039 = $bf501b18cb1c9a7b$var$SvgTextBolder;



parcelRequire("2gcPZ");
const $5b7cacbdd105d898$var$SvgTextbox = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M19.375 6.25v7.5a1.25 1.25 0 0 1-1.25 1.25H11.25a.624.624 0 0 1-.625-.625v-8.75A.625.625 0 0 1 11.25 5h6.875a1.25 1.25 0 0 1 1.25 1.25Zm-10-2.5v12.5a.625.625 0 1 1-1.25 0V15h-6.25a1.25 1.25 0 0 1-1.25-1.25v-7.5A1.25 1.25 0 0 1 1.875 5h6.25V3.75a.625.625 0 0 1 1.25 0Zm-2.656 5a.625.625 0 0 0-.625-.625H3.906a.625.625 0 0 0 0 1.25h.469v2.188a.625.625 0 1 0 1.25 0V9.374h.469a.625.625 0 0 0 .625-.625Z",
            fill: "currentColor"
        })
    });
var $5b7cacbdd105d898$export$2e2bcd8739ae039 = $5b7cacbdd105d898$var$SvgTextbox;



parcelRequire("2gcPZ");
const $3f21b23fced3a794$var$SvgTextHFive = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M11.875 4.375v9.375a.624.624 0 1 1-1.25 0V9.687H3.75v4.063a.625.625 0 1 1-1.25 0V4.375a.625.625 0 0 1 1.25 0v4.063h6.875V4.375a.625.625 0 1 1 1.25 0Zm4.68 6.563c-.248 0-.495.03-.735.093l.32-1.969h2.61a.625.625 0 1 0 0-1.25h-3.14a.625.625 0 0 0-.618.524l-.61 3.766a.625.625 0 0 0 1.056.546 1.57 1.57 0 0 1 1.117-.46 1.556 1.556 0 0 1 1.11.46 1.548 1.548 0 0 1 0 2.204 1.555 1.555 0 0 1-1.11.46 1.57 1.57 0 0 1-1.117-.46.626.626 0 1 0-.876.89 2.82 2.82 0 1 0 1.993-4.805Z",
            fill: "currentColor"
        })
    });
var $3f21b23fced3a794$export$2e2bcd8739ae039 = $3f21b23fced3a794$var$SvgTextHFive;



parcelRequire("2gcPZ");
const $904c318bc248b720$var$SvgTextHFour = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M11.875 4.375v9.375a.624.624 0 1 1-1.25 0V9.687H3.75v4.063a.625.625 0 1 1-1.25 0V4.375a.625.625 0 0 1 1.25 0v4.063h6.875V4.375a.625.625 0 1 1 1.25 0ZM18.438 10a.624.624 0 0 0-.625.625V12.5H15.57l1.578-4.477a.625.625 0 0 0-1.171-.421l-1.875 5.312a.617.617 0 0 0 .078.57.625.625 0 0 0 .508.266h3.124v1.875a.624.624 0 1 0 1.25 0v-5a.624.624 0 0 0-.625-.625Z",
            fill: "currentColor"
        })
    });
var $904c318bc248b720$export$2e2bcd8739ae039 = $904c318bc248b720$var$SvgTextHFour;



parcelRequire("2gcPZ");
const $d5d4d31064d56ed3$var$SvgTextH = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.25 4.375v11.25a.624.624 0 1 1-1.25 0v-5H5v5a.625.625 0 1 1-1.25 0V4.375a.625.625 0 0 1 1.25 0v5h10v-5a.625.625 0 1 1 1.25 0Z",
            fill: "currentColor"
        })
    });
var $d5d4d31064d56ed3$export$2e2bcd8739ae039 = $d5d4d31064d56ed3$var$SvgTextH;



parcelRequire("2gcPZ");
const $6fdd56eeb646fb08$var$SvgTextHOne = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M11.875 4.375v9.375a.624.624 0 1 1-1.25 0V9.687H3.75v4.063a.625.625 0 1 1-1.25 0V4.375a.625.625 0 0 1 1.25 0v4.063h6.875V4.375a.625.625 0 1 1 1.25 0Zm5.61 3.508a.649.649 0 0 0-.641.031l-1.875 1.25a.626.626 0 1 0 .687 1.047l.906-.61v6.024a.624.624 0 1 0 1.25 0V8.437a.624.624 0 0 0-.328-.554Z",
            fill: "currentColor"
        })
    });
var $6fdd56eeb646fb08$export$2e2bcd8739ae039 = $6fdd56eeb646fb08$var$SvgTextHOne;



parcelRequire("2gcPZ");
const $d21bc5067715eb83$var$SvgTextHSix = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M11.875 4.375v9.375a.624.624 0 1 1-1.25 0V9.687H3.75v4.063a.625.625 0 1 1-1.25 0V4.375a.625.625 0 0 1 1.25 0v4.063h6.875V4.375a.625.625 0 1 1 1.25 0Zm7.813 8.75a2.813 2.813 0 1 1-5.266-1.367l.023-.047 2.516-4.219a.627.627 0 0 1 1.078.64l-1.305 2.18h.141a2.812 2.812 0 0 1 2.813 2.813Zm-1.25 0a1.563 1.563 0 1 0-1.563 1.563 1.57 1.57 0 0 0 1.563-1.563Z",
            fill: "currentColor"
        })
    });
var $d21bc5067715eb83$export$2e2bcd8739ae039 = $d21bc5067715eb83$var$SvgTextHSix;



parcelRequire("2gcPZ");
const $75383884da2aef84$var$SvgTextHThree = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M11.875 4.375v9.375a.624.624 0 1 1-1.25 0V9.687H3.75v4.063a.625.625 0 1 1-1.25 0V4.375a.625.625 0 0 1 1.25 0v4.063h6.875V4.375a.625.625 0 1 1 1.25 0Zm6.68 7.383a2.962 2.962 0 0 0-.938-.617l1.649-2.344a.625.625 0 0 0-.192-.893.632.632 0 0 0-.324-.091H15a.625.625 0 1 0 0 1.25h2.547l-1.5 2.14a.625.625 0 0 0 .192.893c.098.06.21.09.323.091a1.563 1.563 0 1 1-1.101 2.665.633.633 0 0 0-.89.89 2.82 2.82 0 0 0 3.984-3.984Z",
            fill: "currentColor"
        })
    });
var $75383884da2aef84$export$2e2bcd8739ae039 = $75383884da2aef84$var$SvgTextHThree;



parcelRequire("2gcPZ");
const $610539af4e55a30d$var$SvgTextHTwo = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M11.875 4.375v9.375a.624.624 0 1 1-1.25 0V9.687H3.75v4.063a.625.625 0 1 1-1.25 0V4.375a.625.625 0 0 1 1.25 0v4.063h6.875V4.375a.625.625 0 1 1 1.25 0ZM18.75 15h-2.5l2.68-3.578.015-.024a2.5 2.5 0 1 0-4.375-2.375.628.628 0 0 0 1.157.493 1.241 1.241 0 0 1 1.148-.766 1.25 1.25 0 0 1 1.047 1.938l-3.414 4.554A.625.625 0 0 0 15 16.25h3.75a.624.624 0 1 0 0-1.25Z",
            fill: "currentColor"
        })
    });
var $610539af4e55a30d$export$2e2bcd8739ae039 = $610539af4e55a30d$var$SvgTextHTwo;



parcelRequire("2gcPZ");
const $7da21b78909fe1d6$var$SvgTextIndent = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M17.5 10a.625.625 0 0 1-.625.625h-7.5a.625.625 0 0 1 0-1.25h7.5A.625.625 0 0 1 17.5 10ZM9.375 5.625h7.5a.625.625 0 1 0 0-1.25h-7.5a.625.625 0 0 0 0 1.25Zm7.5 8.75H3.125a.625.625 0 1 0 0 1.25h13.75a.625.625 0 0 0 0-1.25ZM2.883 11.203a.648.648 0 0 0 .687-.133l3.125-3.125a.633.633 0 0 0 0-.89L3.57 3.93a.656.656 0 0 0-.687-.133.625.625 0 0 0-.383.578v6.25a.625.625 0 0 0 .383.578Z",
            fill: "currentColor"
        })
    });
var $7da21b78909fe1d6$export$2e2bcd8739ae039 = $7da21b78909fe1d6$var$SvgTextIndent;



parcelRequire("2gcPZ");
const $b662c143edc57420$var$SvgTextItalic = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M15.625 4.375A.625.625 0 0 1 15 5h-2.672L8.992 15h2.258a.624.624 0 1 1 0 1.25H5A.625.625 0 1 1 5 15h2.672l3.336-10H8.75a.625.625 0 0 1 0-1.25H15a.625.625 0 0 1 .625.625Z",
            fill: "currentColor"
        })
    });
var $b662c143edc57420$export$2e2bcd8739ae039 = $b662c143edc57420$var$SvgTextItalic;



parcelRequire("2gcPZ");
const $cebb4a60cc9fef3c$var$SvgTextOutdent = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M17.5 10a.625.625 0 0 1-.625.625h-7.5a.625.625 0 0 1 0-1.25h7.5A.625.625 0 0 1 17.5 10ZM9.375 5.625h7.5a.625.625 0 1 0 0-1.25h-7.5a.625.625 0 0 0 0 1.25Zm7.5 8.75H3.125a.625.625 0 1 0 0 1.25h13.75a.625.625 0 0 0 0-1.25ZM5.625 11.25a.625.625 0 0 0 .625-.625v-6.25a.625.625 0 0 0-.383-.578.656.656 0 0 0-.687.133L2.055 7.055a.633.633 0 0 0 0 .89L5.18 11.07c.12.115.28.18.445.18Z",
            fill: "currentColor"
        })
    });
var $cebb4a60cc9fef3c$export$2e2bcd8739ae039 = $cebb4a60cc9fef3c$var$SvgTextOutdent;



parcelRequire("2gcPZ");
const $5f219d1800e84831$var$SvgTextStrikethrough = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M17.5 10a.624.624 0 0 1-.625.625h-3.133c.719.555 1.258 1.344 1.258 2.5s-.547 2.008-1.547 2.719c-1 .71-2.156 1.031-3.453 1.031-1.297 0-2.523-.367-3.453-1.031C5.617 15.18 5 14.164 5 13.125a.625.625 0 1 1 1.25 0c0 1.352 1.719 2.5 3.75 2.5 2.031 0 3.75-1.148 3.75-2.5 0-1.164-.82-1.844-3.031-2.5H3.125a.625.625 0 1 1 0-1.25h13.75A.625.625 0 0 1 17.5 10ZM5.96 8.125a.625.625 0 0 0 .594-.82 1.5 1.5 0 0 1-.062-.43c0-1.422 1.508-2.5 3.508-2.5 1.523 0 2.82.648 3.305 1.64a.633.633 0 0 0 1.032.144.617.617 0 0 0 .093-.69C13.727 4.023 12.03 3.125 10 3.125c-2.71 0-4.758 1.61-4.758 3.75.001.278.043.555.125.82a.625.625 0 0 0 .594.43Z",
            fill: "currentColor"
        })
    });
var $5f219d1800e84831$export$2e2bcd8739ae039 = $5f219d1800e84831$var$SvgTextStrikethrough;



parcelRequire("2gcPZ");
const $f7e61d3b1a25e719$var$SvgTextT = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.25 3.75H3.75a.625.625 0 0 0-.625.625v2.5a.625.625 0 0 0 1.25 0V5h5v10H7.5a.625.625 0 1 0 0 1.25h5a.624.624 0 1 0 0-1.25h-1.875V5h5v1.875a.625.625 0 1 0 1.25 0v-2.5a.625.625 0 0 0-.625-.625Z",
            fill: "currentColor"
        })
    });
var $f7e61d3b1a25e719$export$2e2bcd8739ae039 = $f7e61d3b1a25e719$var$SvgTextT;



parcelRequire("2gcPZ");
const $9410602eef649d80$var$SvgTextUnderline = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M17.5 16.875a.624.624 0 0 1-.625.625H3.125a.625.625 0 1 1 0-1.25h13.75a.624.624 0 0 1 .625.625ZM10 15a5.633 5.633 0 0 0 5.625-5.625v-5a.625.625 0 1 0-1.25 0v5a4.375 4.375 0 1 1-8.75 0v-5a.625.625 0 0 0-1.25 0v5A5.633 5.633 0 0 0 10 15Z",
            fill: "currentColor"
        })
    });
var $9410602eef649d80$export$2e2bcd8739ae039 = $9410602eef649d80$var$SvgTextUnderline;



parcelRequire("2gcPZ");
const $880ebe222ca9ce5d$var$SvgThunder = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M12.535 2.22c.451-.375 1.118.053.963.619L12 8.333l4.6.511a.6.6 0 0 1 .318 1.058L7.465 17.78c-.45.375-1.118-.053-.963-.619L8 11.667l-4.6-.511a.6.6 0 0 1-.318-1.058l9.453-7.878Z",
            fill: "currentColor"
        })
    });
var $880ebe222ca9ce5d$export$2e2bcd8739ae039 = $880ebe222ca9ce5d$var$SvgThunder;



parcelRequire("2gcPZ");
const $ad19162eaaecebb9$var$SvgTimeDuotone = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                opacity: 0.2,
                d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M11 5v4h3v2H9V5h2Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1 10a9 9 0 1 1 18 0 9 9 0 0 1-18 0Zm9-7a7 7 0 1 0 0 14 7 7 0 0 0 0-14Z",
                fill: "currentColor"
            })
        ]
    });
var $ad19162eaaecebb9$export$2e2bcd8739ae039 = $ad19162eaaecebb9$var$SvgTimeDuotone;



parcelRequire("2gcPZ");
const $4fa6c310329dac0d$var$SvgTimer = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M8.125 1.25h3.75a.625.625 0 1 0 0-1.25h-3.75a.625.625 0 0 0 0 1.25ZM10 2.5a7.5 7.5 0 1 0 7.5 7.5A7.515 7.515 0 0 0 10 2.5Zm3.54 4.852-3.095 3.093a.64.64 0 0 1-.89 0 .633.633 0 0 1 0-.89l3.093-3.094a.634.634 0 1 1 .891.89Z",
            fill: "currentColor"
        })
    });
var $4fa6c310329dac0d$export$2e2bcd8739ae039 = $4fa6c310329dac0d$var$SvgTimer;



parcelRequire("2gcPZ");
const $7b0f31fee764d536$var$SvgTimeseries = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M4 4.511V14.74c0 .282.16.511.357.511h1.786c.197 0 .357-.229.357-.511V4.51C6.5 4.23 6.34 4 6.143 4H4.357C4.16 4 4 4.229 4 4.511ZM13 9.284v5.682c0 .157.16.284.357.284h1.786c.197 0 .357-.127.357-.284V9.284c0-.157-.16-.284-.357-.284h-1.786c-.197 0-.357.127-.357.284ZM8.5 6.898v7.954c0 .22.16.398.357.398h1.786c.197 0 .357-.178.357-.398V6.898c0-.22-.16-.398-.357-.398H8.857c-.197 0-.357.178-.357.398Z",
            fill: "currentColor"
        })
    });
var $7b0f31fee764d536$export$2e2bcd8739ae039 = $7b0f31fee764d536$var$SvgTimeseries;



parcelRequire("2gcPZ");
const $5d01ee605bff96bc$var$SvgTrash = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                opacity: 0.2,
                fill: "currentColor",
                d: "M7 15V7h6v8z"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M12 2H8v1H5a2 2 0 0 0-2 2h14a2 2 0 0 0-2-2h-3V2ZM16 16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6h2v10h8V6h2v10Z",
                fill: "currentColor"
            })
        ]
    });
var $5d01ee605bff96bc$export$2e2bcd8739ae039 = $5d01ee605bff96bc$var$SvgTrash;



parcelRequire("2gcPZ");
const $e99c819a7825109b$var$SvgTray = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M16.25 2.5H3.75A1.25 1.25 0 0 0 2.5 3.75v12.5a1.25 1.25 0 0 0 1.25 1.25h12.5a1.25 1.25 0 0 0 1.25-1.25V3.75a1.25 1.25 0 0 0-1.25-1.25Zm0 13.75H3.75v-3.125h2.242L7.5 14.633a1.242 1.242 0 0 0 .883.367h3.234a1.241 1.241 0 0 0 .883-.367l1.508-1.508h2.242v3.125Z",
            fill: "currentColor"
        })
    });
var $e99c819a7825109b$export$2e2bcd8739ae039 = $e99c819a7825109b$var$SvgTray;



parcelRequire("2gcPZ");
const $0dcf77ac000a0a7f$var$SvgTreeStructure = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M12.188 7.188V6.25h-.938A1.25 1.25 0 0 0 10 7.5v5a1.25 1.25 0 0 0 1.25 1.25h.938v-.938a1.25 1.25 0 0 1 1.25-1.25h3.124a1.25 1.25 0 0 1 1.25 1.25v3.126a1.25 1.25 0 0 1-1.25 1.25h-3.125a1.25 1.25 0 0 1-1.25-1.25V15h-.937a2.508 2.508 0 0 1-2.5-2.5v-1.875H6.562v.625a1.25 1.25 0 0 1-1.25 1.25h-2.5a1.25 1.25 0 0 1-1.25-1.25v-2.5a1.25 1.25 0 0 1 1.25-1.25h2.5a1.25 1.25 0 0 1 1.25 1.25v.625H8.75V7.5a2.508 2.508 0 0 1 2.5-2.5h.938v-.938a1.25 1.25 0 0 1 1.25-1.25h3.124a1.25 1.25 0 0 1 1.25 1.25v3.125a1.25 1.25 0 0 1-1.25 1.25h-3.125a1.25 1.25 0 0 1-1.25-1.25Z",
            fill: "currentColor"
        })
    });
var $0dcf77ac000a0a7f$export$2e2bcd8739ae039 = $0dcf77ac000a0a7f$var$SvgTreeStructure;



parcelRequire("2gcPZ");
const $793d8c5f345cf1dd$var$SvgArrow2Down = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "m10.143 13 3.344-6h-6.69l3.346 6Z",
            fill: "currentColor"
        })
    });
var $793d8c5f345cf1dd$export$2e2bcd8739ae039 = $793d8c5f345cf1dd$var$SvgArrow2Down;



parcelRequire("2gcPZ");
const $edd42a8a2268471c$var$SvgArrow2Right = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "m13.143 10.345-6 3.344V7l6 3.345Z",
            fill: "currentColor"
        })
    });
var $edd42a8a2268471c$export$2e2bcd8739ae039 = $edd42a8a2268471c$var$SvgArrow2Right;



parcelRequire("2gcPZ");
const $ff52fb5bed5cee12$var$SvgUpload = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M5.805 6.07a.633.633 0 0 1 0-.89l3.75-3.75a.633.633 0 0 1 .89 0l3.75 3.75a.633.633 0 0 1 0 .89.64.64 0 0 1-.89 0l-2.68-2.687V10a.625.625 0 1 1-1.25 0V3.383L6.695 6.07a.633.633 0 0 1-.89 0Zm12.945 4.555v5a1.25 1.25 0 0 1-1.25 1.25h-15a1.25 1.25 0 0 1-1.25-1.25v-5a1.25 1.25 0 0 1 1.25-1.25h5.313a.313.313 0 0 1 .312.312v.274c0 1.047.86 1.937 1.914 1.914A1.875 1.875 0 0 0 11.875 10v-.313a.313.313 0 0 1 .313-.312H17.5a1.25 1.25 0 0 1 1.25 1.25Zm-3.125 2.5a.938.938 0 1 0-1.876 0 .938.938 0 0 0 1.876 0Z",
            fill: "currentColor"
        })
    });
var $ff52fb5bed5cee12$export$2e2bcd8739ae039 = $ff52fb5bed5cee12$var$SvgUpload;



parcelRequire("2gcPZ");
const $08f32b732d10d1e2$var$SvgUserCircle = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M10 12.813a3.437 3.437 0 1 0 0-6.875 3.437 3.437 0 0 0 0 6.875Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M10 1.875A8.125 8.125 0 1 0 18.125 10 8.14 8.14 0 0 0 10 1.875Zm5.14 12.688a6.351 6.351 0 0 0-1.913-1.797 4.664 4.664 0 0 1-6.454 0 6.352 6.352 0 0 0-1.914 1.796 6.875 6.875 0 1 1 10.282 0Z",
                fill: "currentColor"
            })
        ]
    });
var $08f32b732d10d1e2$export$2e2bcd8739ae039 = $08f32b732d10d1e2$var$SvgUserCircle;



parcelRequire("2gcPZ");
const $888fc1b7070df389$var$SvgUserCircleMinus = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M10 5.938a3.437 3.437 0 1 1 0 6.874 3.437 3.437 0 0 1 0-6.874ZM13.75 5h3.75a.625.625 0 0 0 0-1.25h-3.75a.625.625 0 1 0 0 1.25Zm3.117 1.914a.617.617 0 0 0-.383.797 6.875 6.875 0 0 1-1.344 6.851 6.351 6.351 0 0 0-1.914-1.796 4.664 4.664 0 0 1-6.453 0 6.351 6.351 0 0 0-1.914 1.796 6.875 6.875 0 0 1 6.227-11.351.625.625 0 0 0 .195-1.234 8.125 8.125 0 0 0-6.766 14.016l.102.093a8.125 8.125 0 0 0 10.766 0l.101-.094a8.14 8.14 0 0 0 2.18-8.703.625.625 0 0 0-.797-.375Z",
            fill: "currentColor"
        })
    });
var $888fc1b7070df389$export$2e2bcd8739ae039 = $888fc1b7070df389$var$SvgUserCircleMinus;



parcelRequire("2gcPZ");
const $3a9355f44afde070$var$SvgUserCirclePlus = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M10 5.938a3.437 3.437 0 1 1 0 6.874 3.437 3.437 0 0 1 0-6.874ZM13.75 5H15v1.25a.625.625 0 1 0 1.25 0V5h1.25a.625.625 0 0 0 0-1.25h-1.25V2.5a.625.625 0 0 0-1.25 0v1.25h-1.25a.625.625 0 1 0 0 1.25Zm3.562 3.203a.617.617 0 0 0-.523.711 6.844 6.844 0 0 1-1.648 5.648 6.351 6.351 0 0 0-1.915-1.796 4.664 4.664 0 0 1-6.453 0 6.351 6.351 0 0 0-1.914 1.796 6.875 6.875 0 0 1 6.227-11.351.625.625 0 0 0 .195-1.234 8.125 8.125 0 0 0-6.766 14.016l.102.093a8.125 8.125 0 0 0 10.766 0l.101-.094a8.1 8.1 0 0 0 2.54-7.273.617.617 0 0 0-.712-.516Z",
            fill: "currentColor"
        })
    });
var $3a9355f44afde070$export$2e2bcd8739ae039 = $3a9355f44afde070$var$SvgUserCirclePlus;



parcelRequire("2gcPZ");
const $0caa0b39fb8da375$var$SvgUsersThree = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M5 10.937a.617.617 0 0 1-.625.625H.938a.64.64 0 0 1-.563-.343.64.64 0 0 1 .063-.657 5.297 5.297 0 0 1 2.14-1.695 3.125 3.125 0 1 1 5.18-2.89.633.633 0 0 1-.297.656 5.023 5.023 0 0 0-2.172 2.64A4.813 4.813 0 0 0 5 10.937Zm14.563-.375a5.297 5.297 0 0 0-2.141-1.695 3.125 3.125 0 1 0-5.18-2.89.632.632 0 0 0 .297.656 5 5 0 0 1 2.172 2.64c.194.534.291 1.097.289 1.664a.617.617 0 0 0 .625.625h3.438a.625.625 0 0 0 .5-1Zm-7.282 3.352a3.75 3.75 0 1 0-4.562 0 5.633 5.633 0 0 0-2.781 2.688.609.609 0 0 0 .039.601.61.61 0 0 0 .523.297h9a.61.61 0 0 0 .524-.297.61.61 0 0 0 .039-.601 5.633 5.633 0 0 0-2.782-2.688Z",
            fill: "currentColor"
        })
    });
var $0caa0b39fb8da375$export$2e2bcd8739ae039 = $0caa0b39fb8da375$var$SvgUsersThree;



parcelRequire("2gcPZ");
const $f14b355ec92a8324$var$SvgViews = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M9.013 2.261a1.957 1.957 0 0 1 1.954 0l6.496 3.72c.69.396.69 1.418 0 1.814l-6.496 3.72a1.956 1.956 0 0 1-1.954 0l-6.496-3.72c-.69-.396-.69-1.418 0-1.814l6.496-3.72Zm8.45 11.758-6.496 3.72a1.957 1.957 0 0 1-1.954 0l-6.496-3.72c-.624-.358-.683-1.23-.178-1.685.053.048.113.091.178.129l6.496 3.72a1.957 1.957 0 0 0 1.954 0l6.496-3.72c.065-.038.125-.081.178-.129.505.455.446 1.327-.178 1.685Zm.024-3.114L11.08 14.62a1.958 1.958 0 0 1-1.955.01L2.542 10.91c-.629-.356-.69-1.232-.183-1.688.054.049.116.093.183.132l6.582 3.722c.61.345 1.348.341 1.955-.01l6.408-3.717c.064-.038.122-.08.173-.127.505.454.447 1.323-.173 1.683Z",
            fill: "currentColor"
        })
    });
var $f14b355ec92a8324$export$2e2bcd8739ae039 = $f14b355ec92a8324$var$SvgViews;



parcelRequire("2gcPZ");
const $ef3cfabd07fc52e3$var$SvgVsCodeLogo = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M17 16.47V7.39l-6 4.54M2.22 9.19a.858.858 0 0 1-.02-1.15l1.2-1.11c.2-.18.69-.26 1.05 0l3.42 2.61 7.93-7.25c.32-.32.87-.45 1.5-.12l4 1.91c.36.21.7.54.7 1.15v13.5c0 .4-.29.83-.6 1l-4.4 2.1c-.32.13-.92.01-1.13-.2l-8.02-7.3-3.4 2.6c-.38.26-.85.19-1.05 0l-1.2-1.1c-.32-.33-.28-.87.05-1.2l3-2.7",
            fill: "currentColor"
        })
    });
var $ef3cfabd07fc52e3$export$2e2bcd8739ae039 = $ef3cfabd07fc52e3$var$SvgVsCodeLogo;



parcelRequire("2gcPZ");
const $029845dc8994ff38$var$SvgWarningCircle = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M10 1.875A8.125 8.125 0 1 0 18.125 10 8.14 8.14 0 0 0 10 1.875ZM9.375 6.25a.625.625 0 0 1 1.25 0v4.375a.624.624 0 1 1-1.25 0V6.25ZM10 14.375a.938.938 0 1 1 0-1.875.938.938 0 0 1 0 1.875Z",
            fill: "currentColor"
        })
    });
var $029845dc8994ff38$export$2e2bcd8739ae039 = $029845dc8994ff38$var$SvgWarningCircle;



parcelRequire("2gcPZ");
const $57e1621eb8a6874b$var$SvgWarning = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M18.492 14.688 11.625 2.813a1.875 1.875 0 0 0-3.25 0L1.508 14.688A1.867 1.867 0 0 0 3.125 17.5h13.75a1.867 1.867 0 0 0 1.617-2.813ZM9.375 8.125a.625.625 0 1 1 1.25 0v3.125a.625.625 0 1 1-1.25 0V8.125ZM10 15a.938.938 0 1 1 0-1.875A.938.938 0 0 1 10 15Z",
            fill: "currentColor"
        })
    });
var $57e1621eb8a6874b$export$2e2bcd8739ae039 = $57e1621eb8a6874b$var$SvgWarning;



parcelRequire("2gcPZ");
const $e11c791ab981433a$var$SvgWarningOctagon = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M9.063 10.313V6.25a.938.938 0 1 1 1.874 0v4.063a.937.937 0 1 1-1.874 0Zm9.374-3.16v5.695a1.55 1.55 0 0 1-.457 1.105l-4.028 4.027a1.55 1.55 0 0 1-1.104.458H7.152a1.55 1.55 0 0 1-1.104-.458L2.02 13.953a1.552 1.552 0 0 1-.457-1.105V7.153a1.552 1.552 0 0 1 .457-1.105l4.028-4.027a1.55 1.55 0 0 1 1.104-.458h5.696a1.55 1.55 0 0 1 1.104.458l4.028 4.027a1.551 1.551 0 0 1 .457 1.105Zm-1.875.13-3.844-3.845H7.282L3.438 7.282v5.436l3.844 3.845h5.436l3.845-3.845V7.282ZM10 12.187a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Z",
            fill: "currentColor"
        })
    });
var $e11c791ab981433a$export$2e2bcd8739ae039 = $e11c791ab981433a$var$SvgWarningOctagon;



parcelRequire("2gcPZ");
const $fcea27963636bb9e$var$SvgYoutubeLogo = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M18.305 5.453a1.836 1.836 0 0 0-1.133-1.273C14.5 3.148 10.234 3.156 10 3.156c-.234 0-4.5-.008-7.172 1.024a1.836 1.836 0 0 0-1.133 1.273C1.492 6.227 1.25 7.648 1.25 10s.242 3.773.445 4.547a1.836 1.836 0 0 0 1.133 1.273c2.563.992 6.578 1.024 7.117 1.024h.11c.539 0 4.554-.032 7.117-1.024a1.836 1.836 0 0 0 1.133-1.273c.203-.774.445-2.195.445-4.547s-.242-3.773-.445-4.547Zm-5.633 4.805-3.75 2.5a.282.282 0 0 1-.172.055.351.351 0 0 1-.148-.04.304.304 0 0 1-.165-.273v-5a.305.305 0 0 1 .165-.273.313.313 0 0 1 .32.015l3.75 2.5a.304.304 0 0 1 0 .516Z",
            fill: "currentColor"
        })
    });
var $fcea27963636bb9e$export$2e2bcd8739ae039 = $fcea27963636bb9e$var$SvgYoutubeLogo;


const $1711e19f0415bcb7$export$fd3cc7e916ad3b17 = {
    alarm_duotone: (0, $393cc5ec6df0b713$export$2e2bcd8739ae039),
    alarm: (0, $100c8e167c8c9281$export$2e2bcd8739ae039),
    alerts_duotone: (0, $79d68eaf906c3ef5$export$2e2bcd8739ae039),
    android_logo: (0, $a781bb92b75143ec$export$2e2bcd8739ae039),
    angular_logo: (0, $ee52bdb1639d0e03$export$2e2bcd8739ae039),
    app_store_logo: (0, $14ee732dc5140431$export$2e2bcd8739ae039),
    apple_logo: (0, $a0d32bfb8ec49c49$export$2e2bcd8739ae039),
    apple_podcasts_logo: (0, $5c6a179e700c85f2$export$2e2bcd8739ae039),
    arrow_clockwise: (0, $c1b128b34064482d$export$2e2bcd8739ae039),
    arrow_counter_clockwise: (0, $2dce1275063044dd$export$2e2bcd8739ae039),
    arrow_down: (0, $3bd1adbbf2c8fa56$export$2e2bcd8739ae039),
    arrow_left: (0, $dc34c0bb9f4fdfe4$export$2e2bcd8739ae039),
    arrow_out: (0, $77e3387764f09602$export$2e2bcd8739ae039),
    arrow_right: (0, $656231c7ec0fa770$export$2e2bcd8739ae039),
    arrow_square_left_duotone: (0, $6af9d36bd6f71eba$export$2e2bcd8739ae039),
    arrow_up: (0, $8c92fc55bfe585bf$export$2e2bcd8739ae039),
    arrows_clockwise: (0, $8f1e4045a4037df2$export$2e2bcd8739ae039),
    arrows_down_up: (0, $0f363353139fac57$export$2e2bcd8739ae039),
    arrows_left_right: (0, $3cbc2a81ad17472d$export$2e2bcd8739ae039),
    arrows_out_simple: (0, $9a8314d40ed56690$export$2e2bcd8739ae039),
    arrows_out: (0, $021418aea03dba2f$export$2e2bcd8739ae039),
    autometrics_black_faded: (0, $d1d81a21dd09e55c$export$2e2bcd8739ae039),
    // The autometrics color logo is very complex so it makes sense to memoize it
    autometrics_color: (0, $2gcPZ.memo)((0, $8062c0953fc81593$export$2e2bcd8739ae039)),
    autometrics_logo_purple: (0, $fd4a46ef6c21a767$export$2e2bcd8739ae039),
    autometrics_logo_type: (0, $c5d3d9e4252f1c34$export$2e2bcd8739ae039),
    autometrics: (0, $608ec8e54eb7aeea$export$2e2bcd8739ae039),
    behance_logo: (0, $795abbf13d040043$export$2e2bcd8739ae039),
    bell_new: (0, $72485eb7105eb3d7$export$2e2bcd8739ae039),
    bell: (0, $b2acbc88fd251d87$export$2e2bcd8739ae039),
    bolt_duotone: (0, $80c7369ab17e9ed1$export$2e2bcd8739ae039),
    book_open: (0, $fef72c11fe8da75e$export$2e2bcd8739ae039),
    book: (0, $25d4103349b29feb$export$2e2bcd8739ae039),
    brackets_angle: (0, $553eefcffed4707d$export$2e2bcd8739ae039),
    brackets_curly: (0, $1598d5d00f35534e$export$2e2bcd8739ae039),
    brackets_round: (0, $934777f3b7658f2c$export$2e2bcd8739ae039),
    brackets_square: (0, $9e3a4c91e7f8b302$export$2e2bcd8739ae039),
    bug_beetle: (0, $250188d81791352d$export$2e2bcd8739ae039),
    bug_droid: (0, $abc31113dd05b220$export$2e2bcd8739ae039),
    bug: (0, $b2a203e9c663fd89$export$2e2bcd8739ae039),
    calendar_blank: (0, $2f624e11e324b3ac$export$2e2bcd8739ae039),
    calendar_check: (0, $d25d6a32a20e3e35$export$2e2bcd8739ae039),
    calendar_plus: (0, $c08c58265cff0573$export$2e2bcd8739ae039),
    calendar_x: (0, $a8032c80ac25a88d$export$2e2bcd8739ae039),
    call_graph: (0, $d065009456d28f4d$export$2e2bcd8739ae039),
    caret_double_down: (0, $07c635228cbb53b8$export$2e2bcd8739ae039),
    caret_double_left: (0, $9e8e14d6d02edc73$export$2e2bcd8739ae039),
    caret_double_right: (0, $920f917645114abc$export$2e2bcd8739ae039),
    caret_double_up: (0, $8bee966903657d10$export$2e2bcd8739ae039),
    caret_double: (0, $64325b6b4c054085$export$2e2bcd8739ae039),
    caret_down: (0, $1de437b217c45fa7$export$2e2bcd8739ae039),
    caret_left: (0, $0e9abb1ac58eb6eb$export$2e2bcd8739ae039),
    caret_right: (0, $ab7095f8ab49f723$export$2e2bcd8739ae039),
    caret_up: (0, $8d3fb75789d1dde1$export$2e2bcd8739ae039),
    chart_bar_horizontal: (0, $8afff172ab51f57c$export$2e2bcd8739ae039),
    chart_bar: (0, $5e9691f5f7865779$export$2e2bcd8739ae039),
    chart_line_up: (0, $1c9b87d40c98d2fc$export$2e2bcd8739ae039),
    chart_line: (0, $b3e84e3263dbeb89$export$2e2bcd8739ae039),
    chart_pie_slice: (0, $c983fc41cb015479$export$2e2bcd8739ae039),
    chart_pie: (0, $88ef12e494389612$export$2e2bcd8739ae039),
    chat_circle_dots: (0, $f523f03e0d5b29ce$export$2e2bcd8739ae039),
    chat_circle: (0, $16f8a2531c71a1c0$export$2e2bcd8739ae039),
    chats_circle: (0, $760144b730bd2966$export$2e2bcd8739ae039),
    check_circle: (0, $d8a3b0ea7f88ae57$export$2e2bcd8739ae039),
    check_square: (0, $d0e64ff380be9ce1$export$2e2bcd8739ae039),
    check: (0, $86b647e4e5ff8593$export$2e2bcd8739ae039),
    checkbox_duotone: (0, $82e3cd2dc3367131$export$2e2bcd8739ae039),
    clock_clockwise: (0, $6d11b906dfbb5ceb$export$2e2bcd8739ae039),
    clock_counter_clockwise: (0, $0535e97fded80d17$export$2e2bcd8739ae039),
    clock: (0, $31e7c9394123792a$export$2e2bcd8739ae039),
    close: (0, $59d8568b50e6ef8d$export$2e2bcd8739ae039),
    cloudwatch_color: (0, $25fd7544a6d53b85$export$2e2bcd8739ae039),
    cloudwatch: (0, $9ccfd95909d73f8c$export$2e2bcd8739ae039),
    code_duotone: (0, $765d6f6fa2824e44$export$2e2bcd8739ae039),
    code_simple: (0, $ff903588c6b87cbd$export$2e2bcd8739ae039),
    code: (0, $9c52aa319eae5403$export$2e2bcd8739ae039),
    codepen_logo: (0, $f42bac1a71a72c24$export$2e2bcd8739ae039),
    codesandbox_logo: (0, $b82b5ad4f5bf8027$export$2e2bcd8739ae039),
    combined: (0, $f6fda72197f85523$export$2e2bcd8739ae039),
    command: (0, $c030951c691687fc$export$2e2bcd8739ae039),
    copy: (0, $43060a13336fe1a4$export$2e2bcd8739ae039),
    cpu: (0, $f165988b2568be0e$export$2e2bcd8739ae039),
    dashboard_duotone: (0, $bfa96e7370d20f96$export$2e2bcd8739ae039),
    database: (0, $b388717dfa81d7ce$export$2e2bcd8739ae039),
    desktop: (0, $10260b7679a2ca43$export$2e2bcd8739ae039),
    device_mobile: (0, $5c411603f5f68af9$export$2e2bcd8739ae039),
    discord_logo: (0, $fa263f4b0143261f$export$2e2bcd8739ae039),
    divider: (0, $b6b2c068cb8bafe2$export$2e2bcd8739ae039),
    docs_duotone: (0, $033fbd1cd8d734fe$export$2e2bcd8739ae039),
    dots_six_vertical: (0, $fdb05b62c4a56c1e$export$2e2bcd8739ae039),
    dots_three: (0, $b1d0942505cacd1b$export$2e2bcd8739ae039),
    double_arrow: (0, $60ef8aebd8e8b3b2$export$2e2bcd8739ae039),
    download: (0, $c4959f5556bebe2a$export$2e2bcd8739ae039),
    dribbble_logo: (0, $6d20db3542142d67$export$2e2bcd8739ae039),
    duplicate_duo_tone: (0, $c7d5650b8e5e8c4a$export$2e2bcd8739ae039),
    edit_duotone: (0, $c67c8630fb9ade47$export$2e2bcd8739ae039),
    edit: (0, $24ed665473663122$export$2e2bcd8739ae039),
    elasticsearch_color: (0, $2dca32076b6deb58$export$2e2bcd8739ae039),
    elasticsearch: (0, $1e42f6f802b7aff3$export$2e2bcd8739ae039),
    ellipsis_vertical: (0, $9e83a05be9ccc05d$export$2e2bcd8739ae039),
    ellipsis: (0, $b1d0942505cacd1b$export$2e2bcd8739ae039),
    envelope_simple_open: (0, $63316bb19f101a63$export$2e2bcd8739ae039),
    envelope_simple: (0, $a82b054ee5f811ef$export$2e2bcd8739ae039),
    environments_duotone: (0, $2df3f7ee88caa9c8$export$2e2bcd8739ae039),
    export_duotone: (0, $aa5eb9e7f0c4c25d$export$2e2bcd8739ae039),
    export: (0, $44d8fb12ba7512f2$export$2e2bcd8739ae039),
    eye_slash: (0, $6ca4a9f6cd89d465$export$2e2bcd8739ae039),
    eye: (0, $ba30942af1ee2328$export$2e2bcd8739ae039),
    facebook_logo: (0, $17eabb2fcde38803$export$2e2bcd8739ae039),
    fiberplane_logo_cracked: (0, $81af963876bddfab$export$2e2bcd8739ae039),
    fiberplane_logo_type: (0, $18f6c97aabcc6fd7$export$2e2bcd8739ae039),
    fiberplane_logo: (0, $fb24ca84a1e49e66$export$2e2bcd8739ae039),
    figma_logo: (0, $e20af91af68fa9a4$export$2e2bcd8739ae039),
    file_arrow_down: (0, $68ed132d2c23195b$export$2e2bcd8739ae039),
    file_arrow_up: (0, $c3c0d574fc2c540b$export$2e2bcd8739ae039),
    file_code: (0, $20cbb1db94eb7ff4$export$2e2bcd8739ae039),
    file_css: (0, $6b5a51987e975816$export$2e2bcd8739ae039),
    file_csv: (0, $b05022f516a7511f$export$2e2bcd8739ae039),
    file_doc: (0, $51afea924c47320b$export$2e2bcd8739ae039),
    file_dotted: (0, $bf5d470f936ee11d$export$2e2bcd8739ae039),
    file_html: (0, $713e353bee131f8a$export$2e2bcd8739ae039),
    file_image: (0, $bca870f4abbff2ec$export$2e2bcd8739ae039),
    file_jpg: (0, $fa2be8a9ead50ce4$export$2e2bcd8739ae039),
    file_js: (0, $f6df1cfe4b7f4ee5$export$2e2bcd8739ae039),
    file_jsx: (0, $4fdc9b3d2deb9763$export$2e2bcd8739ae039),
    file_lock: (0, $452c2753598bf078$export$2e2bcd8739ae039),
    file_minus: (0, $01b7d130b8db3e50$export$2e2bcd8739ae039),
    file_pdf: (0, $a8f1ad042cf86047$export$2e2bcd8739ae039),
    file_plus: (0, $cbbf6c8675c526c4$export$2e2bcd8739ae039),
    file_png: (0, $e003bbd9142be2ed$export$2e2bcd8739ae039),
    file_ppt: (0, $0ca7003438806bbf$export$2e2bcd8739ae039),
    file_rs: (0, $7481ec526a5f75de$export$2e2bcd8739ae039),
    file_search: (0, $2c31d0ed4c113830$export$2e2bcd8739ae039),
    file_text: (0, $b0ddcbbb86f9113a$export$2e2bcd8739ae039),
    file_ts: (0, $abe136a760fb49eb$export$2e2bcd8739ae039),
    file_tsx: (0, $a81c128a7340fc31$export$2e2bcd8739ae039),
    file_video: (0, $00f3490931a15bc2$export$2e2bcd8739ae039),
    file_vue: (0, $b784cae3c7c0d32e$export$2e2bcd8739ae039),
    file_x: (0, $a762ec26c5193881$export$2e2bcd8739ae039),
    file_xls: (0, $6a236f631ded7f60$export$2e2bcd8739ae039),
    file_zip: (0, $be7110859a24df1c$export$2e2bcd8739ae039),
    file: (0, $cabce8192db1c345$export$2e2bcd8739ae039),
    files: (0, $650b5b4205a01ce7$export$2e2bcd8739ae039),
    fire: (0, $c017c6c62e4c34b3$export$2e2bcd8739ae039),
    floppy_disk_back: (0, $3c3d27c97f5ae700$export$2e2bcd8739ae039),
    floppy_disk: (0, $80b47dfe2a3d87cc$export$2e2bcd8739ae039),
    folder_dotted: (0, $a7f6a82b52184a78$export$2e2bcd8739ae039),
    folder_duotone: (0, $37ae730f6f90c9ef$export$2e2bcd8739ae039),
    folder_lock: (0, $89b384198ed92943$export$2e2bcd8739ae039),
    folder_open_duotone: (0, $4b3c96f12b642597$export$2e2bcd8739ae039),
    folder_open: (0, $a2fb66ccc1ab8780$export$2e2bcd8739ae039),
    folder_plus: (0, $7c69e6f6ff2d1eea$export$2e2bcd8739ae039),
    folder_simple: (0, $9c6352268b4745af$export$2e2bcd8739ae039),
    folder: (0, $2d3aaa4370969daf$export$2e2bcd8739ae039),
    folders: (0, $7d11f6be51550742$export$2e2bcd8739ae039),
    framer_logo: (0, $7e12deb9ebd58487$export$2e2bcd8739ae039),
    function_duotone: (0, $61a83cc33faf6bde$export$2e2bcd8739ae039),
    function: (0, $e46037ed7b305d65$export$2e2bcd8739ae039),
    funnel_simple: (0, $cd2b1705e20141ff$export$2e2bcd8739ae039),
    funnel: (0, $6c9de372d764eb36$export$2e2bcd8739ae039),
    gear: (0, $4081b0ca085a7188$export$2e2bcd8739ae039),
    git_branch: (0, $41ea0660b798dae0$export$2e2bcd8739ae039),
    git_commit: (0, $31f474745ccc55b9$export$2e2bcd8739ae039),
    git_diff: (0, $d420d6151634778d$export$2e2bcd8739ae039),
    git_fork: (0, $e855226857bcdfcf$export$2e2bcd8739ae039),
    git_merge: (0, $83ee15ce327f77d1$export$2e2bcd8739ae039),
    git_pull_request: (0, $9062505d0a8e860c$export$2e2bcd8739ae039),
    github_logo_alt: (0, $32846c1f7fdf9868$export$2e2bcd8739ae039),
    github_logo: (0, $71ea5417b708d912$export$2e2bcd8739ae039),
    gitlab_logo_simple: (0, $0a78d3ef7c5cbcc2$export$2e2bcd8739ae039),
    gitlab_logo: (0, $20380f70205ed709$export$2e2bcd8739ae039),
    globe: (0, $582f3eabc57cb758$export$2e2bcd8739ae039),
    google_chrome_logo: (0, $ac3d639a2ea74c47$export$2e2bcd8739ae039),
    google_logo: (0, $f5bda37b72c767f8$export$2e2bcd8739ae039),
    google_photos_logo: (0, $f21297db804b80ae$export$2e2bcd8739ae039),
    google_play_logo: (0, $10571f3d86b624b4$export$2e2bcd8739ae039),
    google_podcasts_logo: (0, $d379db8f3127cffd$export$2e2bcd8739ae039),
    graph_duotone: (0, $0ec2e405c6b640d8$export$2e2bcd8739ae039),
    graph: (0, $3de930637890852a$export$2e2bcd8739ae039),
    highlighter_circle: (0, $cbfc5379f580f883$export$2e2bcd8739ae039),
    image_square: (0, $ef316fec114f2be8$export$2e2bcd8739ae039),
    image: (0, $643b80c55e69690f$export$2e2bcd8739ae039),
    info_duotone: (0, $436f8486d4112169$export$2e2bcd8739ae039),
    info: (0, $1592e702866a460f$export$2e2bcd8739ae039),
    instagram_logo: (0, $4a1da76b328a0445$export$2e2bcd8739ae039),
    kanban: (0, $241d71afac365389$export$2e2bcd8739ae039),
    key_return: (0, $2e12417a651aa55d$export$2e2bcd8739ae039),
    key: (0, $e26421d3104b3009$export$2e2bcd8739ae039),
    keyboard_duotone: (0, $94d798cf9e185bd9$export$2e2bcd8739ae039),
    lightning_slash: (0, $5027a6c0f5a22d22$export$2e2bcd8739ae039),
    lightning: (0, $058c409de88b2492$export$2e2bcd8739ae039),
    link_break: (0, $624413516e982bd5$export$2e2bcd8739ae039),
    link_out_duotone: (0, $38382e201903956d$export$2e2bcd8739ae039),
    link_out: (0, $fdc36f733a081eb6$export$2e2bcd8739ae039),
    link: (0, $e7a3b7977fcd3630$export$2e2bcd8739ae039),
    linkedin_logo: (0, $9c6f1ba76da0c95e$export$2e2bcd8739ae039),
    linux_logo: (0, $f14daca39c272133$export$2e2bcd8739ae039),
    list_bullets: (0, $5568765f342bb099$export$2e2bcd8739ae039),
    list_checks: (0, $db2fb14d46f3d6e0$export$2e2bcd8739ae039),
    list_dashes: (0, $26a56a566d9469ef$export$2e2bcd8739ae039),
    list_numbers: (0, $b9d1fa91d65e89ac$export$2e2bcd8739ae039),
    list_plus: (0, $012ba0f446d16d20$export$2e2bcd8739ae039),
    list: (0, $5dfe93864893c17f$export$2e2bcd8739ae039),
    lock_key: (0, $c01ae1f6c660ad70$export$2e2bcd8739ae039),
    lock_simple_open: (0, $9a088da0c02488fe$export$2e2bcd8739ae039),
    lock_simple: (0, $8bb80cdfe715cfc9$export$2e2bcd8739ae039),
    loki_color: (0, $0fa7cd6e17b0f3bc$export$2e2bcd8739ae039),
    loki: (0, $ed6005ae36e97b1d$export$2e2bcd8739ae039),
    magnet_straight: (0, $8cb45e2a7246b1b4$export$2e2bcd8739ae039),
    magnet: (0, $f69b4fa2a07b46c3$export$2e2bcd8739ae039),
    magnifying_glass_minus: (0, $00e467ba62521042$export$2e2bcd8739ae039),
    magnifying_glass_plus: (0, $fc278b4a72a90e0b$export$2e2bcd8739ae039),
    magnifying_glass: (0, $7ae4d7ea08c08fe5$export$2e2bcd8739ae039),
    map_pin: (0, $15e6f51b1bb10d48$export$2e2bcd8739ae039),
    modules_duotone: (0, $317646ee7ae95bf7$export$2e2bcd8739ae039),
    money_duotone: (0, $c25b85f9fe866028$export$2e2bcd8739ae039),
    moon_duotone: (0, $a83fcaf701c84db6$export$2e2bcd8739ae039),
    moon: (0, $eebe5be4309e440c$export$2e2bcd8739ae039),
    note_blank: (0, $0a259afd76e1ffd7$export$2e2bcd8739ae039),
    note_pencil: (0, $8707c4d6d17b308c$export$2e2bcd8739ae039),
    note: (0, $2719838715122be4$export$2e2bcd8739ae039),
    notebook_duotone: (0, $2a55c1d52e06f4b3$export$2e2bcd8739ae039),
    notebook_menu: (0, $14e808cdf323d234$export$2e2bcd8739ae039),
    notebook: (0, $c78e976e11011540$export$2e2bcd8739ae039),
    notepad: (0, $cccffbb7537f893b$export$2e2bcd8739ae039),
    notifcation: (0, $337c899d45bd2899$export$2e2bcd8739ae039),
    paper_plane_tilt: (0, $ed97df3fe9973e9a$export$2e2bcd8739ae039),
    paperclip: (0, $1afbda52705fc5d1$export$2e2bcd8739ae039),
    pencil_simple: (0, $6f4b27bb6f7b4ef1$export$2e2bcd8739ae039),
    percentage: (0, $ca9197106fbbe83d$export$2e2bcd8739ae039),
    phone: (0, $21277c190506bbf2$export$2e2bcd8739ae039),
    pie_chart_duotone: (0, $87130f5837f2bce5$export$2e2bcd8739ae039),
    plugs_connected: (0, $fccd5f034ad81c27$export$2e2bcd8739ae039),
    plugs: (0, $8f5a1085ca0ea0a9$export$2e2bcd8739ae039),
    plus_bordered_duotone: (0, $c06479f9c8a250f5$export$2e2bcd8739ae039),
    plus_duotone: (0, $d0d0608628cdd367$export$2e2bcd8739ae039),
    plus: (0, $c50f9efb719f5587$export$2e2bcd8739ae039),
    presentation: (0, $608c1ece9a05a20c$export$2e2bcd8739ae039),
    printer: (0, $65d41b5402c3eebd$export$2e2bcd8739ae039),
    prometheus_color_dark: (0, $5779f6a9e32009aa$export$2e2bcd8739ae039),
    prometheus_color: (0, $f1e23b17235be460$export$2e2bcd8739ae039),
    prometheus_filled_grey: (0, $a2acdd9e49ccf3b6$export$2e2bcd8739ae039),
    prometheus: (0, $d192281d287e2e95$export$2e2bcd8739ae039),
    proxy: (0, $f7938048fc7d0559$export$2e2bcd8739ae039),
    push_pin_slash: (0, $d07fa463259eb4d3$export$2e2bcd8739ae039),
    push_pin: (0, $c39080db2219f25f$export$2e2bcd8739ae039),
    question: (0, $1a2ba9591e2567b1$export$2e2bcd8739ae039),
    quotes: (0, $069212f7771a86db$export$2e2bcd8739ae039),
    robot: (0, $d4690072a05bdc5a$export$2e2bcd8739ae039),
    rocket: (0, $1f0218f2475cfbbe$export$2e2bcd8739ae039),
    scissors: (0, $b2565a04875043e2$export$2e2bcd8739ae039),
    search_duotone: (0, $a7d7766bdcb70bde$export$2e2bcd8739ae039),
    settings_duotone: (0, $f5d23a9bd8093c39$export$2e2bcd8739ae039),
    share_network: (0, $9e648fed48488f9f$export$2e2bcd8739ae039),
    shield_check: (0, $a4643cddd9dbbfe6$export$2e2bcd8739ae039),
    sidebar_dot: (0, $b032e89052ccbde4$export$2e2bcd8739ae039),
    sidebar_simple: (0, $149179754d5551f1$export$2e2bcd8739ae039),
    sidebar: (0, $e3d1812cae5753f9$export$2e2bcd8739ae039),
    sign_out: (0, $da32dd93171d73a7$export$2e2bcd8739ae039),
    slo_duotone: (0, $1a291ca23c4d0362$export$2e2bcd8739ae039),
    sort_ascending: (0, $b92ad0e568581a59$export$2e2bcd8739ae039),
    sort_descending: (0, $b1edb2efe647d8b2$export$2e2bcd8739ae039),
    source: (0, $30af157fa3e79bb7$export$2e2bcd8739ae039),
    sparkle: (0, $82b81d3b0c385c3e$export$2e2bcd8739ae039),
    squares_four: (0, $88132325f260e2ab$export$2e2bcd8739ae039),
    stack: (0, $bff0bf5d5a5b26c8$export$2e2bcd8739ae039),
    stacked: (0, $6dfa8b55b25e46f2$export$2e2bcd8739ae039),
    star: (0, $1d6e05ed834a847e$export$2e2bcd8739ae039),
    sun_duotone: (0, $300b8720044a1f3a$export$2e2bcd8739ae039),
    sun: (0, $bf684c266a4b4c72$export$2e2bcd8739ae039),
    table: (0, $e1b0b53e20c94b28$export$2e2bcd8739ae039),
    target_duotone: (0, $19c2b644e139f368$export$2e2bcd8739ae039),
    templates: (0, $1cf13b33d88ba807$export$2e2bcd8739ae039),
    terminal_window: (0, $f3e5924aa867a4eb$export$2e2bcd8739ae039),
    terminal: (0, $498005cebbf40775$export$2e2bcd8739ae039),
    text_aa: (0, $23c363434d239101$export$2e2bcd8739ae039),
    text_align_center: (0, $0fb2a38f622c1aaa$export$2e2bcd8739ae039),
    text_align_justify: (0, $8b35d4e8e2c7e3d5$export$2e2bcd8739ae039),
    text_align_left: (0, $8379d67b430a6f2e$export$2e2bcd8739ae039),
    text_align_right: (0, $cb1c130d79faf927$export$2e2bcd8739ae039),
    text_bolder: (0, $bf501b18cb1c9a7b$export$2e2bcd8739ae039),
    text_h_five: (0, $3f21b23fced3a794$export$2e2bcd8739ae039),
    text_h_four: (0, $904c318bc248b720$export$2e2bcd8739ae039),
    text_h_one: (0, $6fdd56eeb646fb08$export$2e2bcd8739ae039),
    text_h_six: (0, $d21bc5067715eb83$export$2e2bcd8739ae039),
    text_h_three: (0, $75383884da2aef84$export$2e2bcd8739ae039),
    text_h_two: (0, $610539af4e55a30d$export$2e2bcd8739ae039),
    text_h: (0, $d5d4d31064d56ed3$export$2e2bcd8739ae039),
    text_indent: (0, $7da21b78909fe1d6$export$2e2bcd8739ae039),
    text_italic: (0, $b662c143edc57420$export$2e2bcd8739ae039),
    text_outdent: (0, $cebb4a60cc9fef3c$export$2e2bcd8739ae039),
    text_strikethrough: (0, $5f219d1800e84831$export$2e2bcd8739ae039),
    text_t: (0, $f7e61d3b1a25e719$export$2e2bcd8739ae039),
    text_underline: (0, $9410602eef649d80$export$2e2bcd8739ae039),
    textbox: (0, $5b7cacbdd105d898$export$2e2bcd8739ae039),
    thunder: (0, $880ebe222ca9ce5d$export$2e2bcd8739ae039),
    time_duotone: (0, $ad19162eaaecebb9$export$2e2bcd8739ae039),
    timer: (0, $4fa6c310329dac0d$export$2e2bcd8739ae039),
    timeseries: (0, $7b0f31fee764d536$export$2e2bcd8739ae039),
    trash: (0, $5d01ee605bff96bc$export$2e2bcd8739ae039),
    tray: (0, $e99c819a7825109b$export$2e2bcd8739ae039),
    tree_structure: (0, $0dcf77ac000a0a7f$export$2e2bcd8739ae039),
    triangle_down: (0, $793d8c5f345cf1dd$export$2e2bcd8739ae039),
    triangle_right: (0, $edd42a8a2268471c$export$2e2bcd8739ae039),
    upload: (0, $ff52fb5bed5cee12$export$2e2bcd8739ae039),
    user_circle_minus: (0, $888fc1b7070df389$export$2e2bcd8739ae039),
    user_circle_plus: (0, $3a9355f44afde070$export$2e2bcd8739ae039),
    user_circle: (0, $08f32b732d10d1e2$export$2e2bcd8739ae039),
    users_three: (0, $0caa0b39fb8da375$export$2e2bcd8739ae039),
    views: (0, $f14b355ec92a8324$export$2e2bcd8739ae039),
    vscode: (0, $ef3cfabd07fc52e3$export$2e2bcd8739ae039),
    warning_circle: (0, $029845dc8994ff38$export$2e2bcd8739ae039),
    warning_octagon: (0, $e11c791ab981433a$export$2e2bcd8739ae039),
    warning: (0, $57e1621eb8a6874b$export$2e2bcd8739ae039),
    youtube_logo: (0, $fcea27963636bb9e$export$2e2bcd8739ae039)
};


function $0a830394bc38e4e3$export$89a7930dd7b3aac6(key) {
    return typeof key === "string" && key in (0, $1711e19f0415bcb7$export$fd3cc7e916ad3b17);
}
function $0a830394bc38e4e3$export$f04a61298a47a40f({ type: type, ...svgProps }) {
    const Component = (0, $1711e19f0415bcb7$export$fd3cc7e916ad3b17)[type];
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)(Component, {
        ...svgProps
    });
}






const $c624abcc931dc034$export$600c3fa3228a90e2 = {
    initial: {
        opacity: 0
    },
    in: {
        opacity: 1
    },
    out: {
        opacity: 0,
        transition: {
            type: "tween",
            ease: "anticipate",
            duration: 0.07
        }
    }
};
const $c624abcc931dc034$export$265cb1fbd6d6e43 = {
    type: "tween",
    ease: "anticipate",
    duration: 0.1
};
const $c624abcc931dc034$export$bd7370ffb2917ab7 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $5980fceb02c72dc0$export$e25e478948902b8b).div).attrs({
    initial: "initial",
    animate: "in",
    exit: "out",
    variants: $c624abcc931dc034$export$600c3fa3228a90e2,
    transition: $c624abcc931dc034$export$265cb1fbd6d6e43
})``;




const $f71dd936b17623f4$export$b95f86b6d0d0d23d = {
    initial: {
        opacity: 0.3
    },
    in: {
        opacity: [
            0.3,
            0.9,
            1,
            0.9,
            0.3
        ]
    },
    out: {
        opacity: 0
    }
};
const $f71dd936b17623f4$export$9ef324a66562f31b = {
    repeat: Number.POSITIVE_INFINITY,
    ease: "easeInOut",
    duration: 2
};
const $f71dd936b17623f4$export$ec58be8144c543a7 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $5980fceb02c72dc0$export$e25e478948902b8b).div).attrs({
    initial: "initial",
    animate: "in",
    exit: "out",
    transition: $f71dd936b17623f4$export$9ef324a66562f31b,
    variants: $f71dd936b17623f4$export$b95f86b6d0d0d23d
})``;




const $1f0ff5a61e121104$export$4c555a41c678bfff = {
    initial: {
        opacity: 0,
        y: "8%"
    },
    in: {
        opacity: 1,
        y: 0
    },
    out: {
        opacity: 0,
        transition: {
            type: "tween",
            ease: "anticipate",
            duration: 0.07
        }
    }
};
const $1f0ff5a61e121104$export$6ff854d9e175b21d = {
    type: "spring",
    stiffness: 800,
    damping: 80
};
const $1f0ff5a61e121104$export$7bd61839e455449b = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $5980fceb02c72dc0$export$e25e478948902b8b).div).attrs({
    initial: "initial",
    animate: "in",
    exit: "out",
    variants: $1f0ff5a61e121104$export$4c555a41c678bfff,
    transition: $1f0ff5a61e121104$export$6ff854d9e175b21d
})``;




function $1c3f96f2902350df$export$657832131d9fbace({ isActive: isActive, height: height = 20, width: width = 20, ...svgProps }) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($1c3f96f2902350df$var$IconContainer, {
        $height: height,
        $width: width,
        variants: $1c3f96f2902350df$var$variants,
        transition: (0, $1f0ff5a61e121104$export$6ff854d9e175b21d),
        animate: isActive ? "active" : "initial",
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0a830394bc38e4e3$export$f04a61298a47a40f), {
            type: "caret_down",
            height: height,
            width: width,
            ...svgProps
        })
    });
}
const $1c3f96f2902350df$var$variants = {
    initial: {
        rotate: 0
    },
    active: {
        rotate: 180
    }
};
const $1c3f96f2902350df$var$IconContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $5980fceb02c72dc0$export$e25e478948902b8b).div)(({ $height: $height, $width: $width, theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    height: ${$1c3f96f2902350df$var$getDimensionValue($height)};
    width: ${$1c3f96f2902350df$var$getDimensionValue($width)};
    color: ${theme.color.fg.subtle};
  `);
// Helper to force the dimension of the animated wrapper as it otherwise can
// result in unexpected element sizes.
const $1c3f96f2902350df$var$getDimensionValue = (value)=>typeof value === "number" ? `${value}px` : value;




var $2gcPZ = parcelRequire("2gcPZ");



/**
 * A hook that returns `true` if we should be using reduced motion based on the current device's Reduced Motion setting.
 *
 * This can be used to implement changes to your UI based on Reduced Motion. For instance, replacing motion-sickness inducing
 * `x`/`y` animations with `opacity`, disabling the autoplay of background videos, or turning off parallax motion.
 *
 * It will actively respond to changes and re-render your components with the latest setting.
 *
 * ```jsx
 * export function Sidebar({ isOpen }) {
 *   const shouldReduceMotion = useReducedMotion()
 *   const closedX = shouldReduceMotion ? 0 : "-100%"
 *
 *   return (
 *     <motion.div animate={{
 *       opacity: isOpen ? 1 : 0,
 *       x: isOpen ? 0 : closedX
 *     }} />
 *   )
 * }
 * ```
 *
 * @return boolean
 *
 * @public
 */ function $59c171cefc09529e$export$6a42007cf1e7b6f8() {
    /**
     * Lazy initialisation of prefersReducedMotion
     */ !(0, $530328e7268335c3$export$6476d16e2fd2d0db).current && (0, $49b4e09bb1f9a78c$export$ca9f41fb23dded3d)();
    const [shouldReduceMotion] = (0, $2gcPZ.useState)((0, $530328e7268335c3$export$ff7706047246b98b).current);
    /**
     * TODO See if people miss automatically updating shouldReduceMotion setting
     */ return shouldReduceMotion;
}



var $2gcPZ = parcelRequire("2gcPZ");
const $ac3093982c5abc41$export$83bbae95f3956836 = 10;
const $ac3093982c5abc41$export$851c9e1591280bd9 = /*#__PURE__*/ (0, $2gcPZ.forwardRef)(function AnimatedMenu({ children: children, className: string, initialX: initialX = 0, initialY: initialY = $ac3093982c5abc41$export$83bbae95f3956836 * -1 }, ref) {
    const shouldReduceMotion = (0, $59c171cefc09529e$export$6a42007cf1e7b6f8)();
    const variants = $ac3093982c5abc41$var$getVariants(initialX, initialY);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $5980fceb02c72dc0$export$e25e478948902b8b).div, {
        ref: ref,
        className: string,
        transition: {
            duration: shouldReduceMotion ? 0 : 0.1,
            ease: "easeOut"
        },
        variants: variants,
        initial: "initial",
        animate: "animate",
        exit: "initial",
        children: children
    });
});
function $ac3093982c5abc41$var$getVariants(initialX, initialY) {
    return {
        initial: {
            opacity: 0,
            x: initialX,
            y: initialY
        },
        animate: {
            opacity: 1,
            x: 0,
            y: 0
        }
    };
}




var $2gcPZ = parcelRequire("2gcPZ");



function $e79c02668c6bf624$var$stopAnimation(visualElement) {
    visualElement.values.forEach((value)=>value.stop());
}
/**
 * @public
 */ function $e79c02668c6bf624$export$e2858afe37bd256a() {
    /**
     * Track whether the host component has mounted.
     */ let hasMounted = false;
    /**
     * A collection of linked component animation controls.
     */ const subscribers = new Set();
    const controls = {
        subscribe (visualElement) {
            subscribers.add(visualElement);
            return ()=>void subscribers.delete(visualElement);
        },
        start (definition, transitionOverride) {
            (0, $f3c6a28fc8795b13$export$f5708dca728d7177)(hasMounted, "controls.start() should only be called after a component has mounted. Consider calling within a useEffect hook.");
            const animations = [];
            subscribers.forEach((visualElement)=>{
                animations.push((0, $3bd88e10cdde0432$export$ff62cf473653f109)(visualElement, definition, {
                    transitionOverride: transitionOverride
                }));
            });
            return Promise.all(animations);
        },
        set (definition) {
            (0, $f3c6a28fc8795b13$export$f5708dca728d7177)(hasMounted, "controls.set() should only be called after a component has mounted. Consider calling within a useEffect hook.");
            return subscribers.forEach((visualElement)=>{
                (0, $5b4992dabc9e61c6$export$b7771d60d308862f)(visualElement, definition);
            });
        },
        stop () {
            subscribers.forEach((visualElement)=>{
                $e79c02668c6bf624$var$stopAnimation(visualElement);
            });
        },
        mount () {
            hasMounted = true;
            return ()=>{
                hasMounted = false;
                controls.stop();
            };
        }
    };
    return controls;
}




/**
 * Creates `AnimationControls`, which can be used to manually start, stop
 * and sequence animations on one or more components.
 *
 * The returned `AnimationControls` should be passed to the `animate` property
 * of the components you want to animate.
 *
 * These components can then be animated with the `start` method.
 *
 * ```jsx
 * import * as React from 'react'
 * import { motion, useAnimation } from 'framer-motion'
 *
 * export function MyComponent(props) {
 *    const controls = useAnimation()
 *
 *    controls.start({
 *        x: 100,
 *        transition: { duration: 0.5 },
 *    })
 *
 *    return <motion.div animate={controls} />
 * }
 * ```
 *
 * @returns Animation controller with `start` and `stop` methods
 *
 * @public
 */ function $c239997b1a5deb7a$export$c705d7acb130fe23() {
    const controls = (0, $3263fe593d864f70$export$fe4300aa8eebea86)((0, $e79c02668c6bf624$export$e2858afe37bd256a));
    (0, $ad16f58ee69383b5$export$700979bc83e7db82)(controls.mount, []);
    return controls;
}
const $c239997b1a5deb7a$export$9e2608686d4ad846 = $c239997b1a5deb7a$export$c705d7acb130fe23;




/**
 * The animation state of the icon to be used in variants.
 */ const $9e6b3538bebe2537$export$2e55affa8f2a0ab6 = "animate";
const $9e6b3538bebe2537$export$a0af5b5e74349d9d = "animateInitial";
const $9e6b3538bebe2537$export$17227441e89ee693 = "initial";


function $77ec05f5c8ffc21b$export$283307ac62433e5a({ controls: controls, onAnimationComplete: onAnimationComplete, ...svgProps }) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...svgProps,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                opacity: "0.2",
                x: "5",
                y: "4",
                width: "10",
                height: "12",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M15 4H5C5 2.89543 5.89543 2 7 2L13 2C14.1046 2 15 2.89543 15 4Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10 7C8.34315 7 7 8.34315 7 10C7 11.6569 8.34315 13 10 13C11.6569 13 13 11.6569 13 10C13 8.34315 11.6569 7 10 7ZM9 10C9 9.44772 9.44772 9 10 9C10.5523 9 11 9.44772 11 10C11 10.5523 10.5523 11 10 11C9.44772 11 9 10.5523 9 10Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M13 18C14.1046 18 15 17.1046 15 16L5 16C5 17.1046 5.89543 18 7 18L13 18Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $5980fceb02c72dc0$export$e25e478948902b8b).g, {
                variants: $77ec05f5c8ffc21b$var$variants,
                animate: controls,
                onAnimationComplete: onAnimationComplete,
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                        d: "M6.87832 12.3708C6.41597 11.7997 6.10108 10.9636 6.10108 10C6.10108 9.03635 6.41597 8.20034 6.87832 7.6292L5.32383 6.3708C4.55197 7.32428 4.10108 8.61322 4.10108 10C4.10108 11.3868 4.55197 12.6757 5.32383 13.6292L6.87832 12.3708Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                        d: "M3.00006 10C3.00006 11.6791 3.68846 13.1956 4.80098 14.2858L3.40118 15.7142C1.92059 14.2634 1.00006 12.2383 1.00006 10C1.00006 7.76171 1.9206 5.73661 3.40118 4.28576L4.80098 5.71424C3.68846 6.80442 3.00006 8.32092 3.00006 10Z",
                        fill: "currentColor"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $5980fceb02c72dc0$export$e25e478948902b8b).g, {
                variants: $77ec05f5c8ffc21b$var$variants,
                animate: controls,
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                        d: "M13.2228 7.6292C13.6851 8.20034 14 9.03635 14 10C14 10.9636 13.6851 11.7997 13.2228 12.3708L14.7773 13.6292C15.5491 12.6757 16 11.3868 16 10C16 8.61322 15.5491 7.32428 14.7773 6.3708L13.2228 7.6292Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                        d: "M17.101 10C17.101 8.32092 16.4126 6.80442 15.3001 5.71424L16.6999 4.28576C18.1805 5.73661 19.101 7.76171 19.101 10C19.101 12.2383 18.1805 14.2634 16.6999 15.7142L15.3001 14.2858C16.4126 13.1956 17.101 11.6791 17.101 10Z",
                        fill: "currentColor"
                    })
                ]
            })
        ]
    });
}
const $77ec05f5c8ffc21b$var$variants = {
    [(0, $9e6b3538bebe2537$export$a0af5b5e74349d9d)]: {
        opacity: 0,
        transition: {
            duration: 0
        }
    },
    [(0, $9e6b3538bebe2537$export$2e55affa8f2a0ab6)]: {
        skewX: [
            5,
            -5,
            5,
            -5,
            5,
            -5,
            5,
            0
        ],
        opacity: 1,
        transition: {
            duration: 0.5
        }
    }
};





function $184858dc9ce4454d$export$729e9b6c47e0540({ controls: controls, onAnimationComplete: onAnimationComplete, ...svgProps }) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...svgProps,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                opacity: "0.2",
                x: "4",
                y: "4",
                width: "12",
                height: "12",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M4 15.998L15.998 15.998C15.998 17.1026 15.1026 17.998 13.998 17.998H5.99805C4.89413 17.998 3.9991 17.1037 3.99805 16C2.89438 15.9989 2 15.1039 2 14L2 6C2 4.89543 2.89543 4 4 4L4 15.998Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M18 14L18 6C18 4.8964 17.1062 4.00158 16.0029 4C16.0029 2.89543 15.1075 2 14.0029 2L6.00293 2C4.89836 2 4.00293 2.89543 4.00293 4L16 4L16 16C17.1046 16 18 15.1046 18 14Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $5980fceb02c72dc0$export$e25e478948902b8b).g, {
                variants: $184858dc9ce4454d$var$verticalVariants,
                animate: controls,
                onAnimationComplete: onAnimationComplete,
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                    d: "M10 4H12V9H10V4Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $5980fceb02c72dc0$export$e25e478948902b8b).g, {
                variants: $184858dc9ce4454d$var$verticalVariants,
                animate: controls,
                onAnimationComplete: onAnimationComplete,
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                    d: "M8 11H10V16H8V11Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $5980fceb02c72dc0$export$e25e478948902b8b).g, {
                variants: $184858dc9ce4454d$var$horizontalVariants,
                animate: controls,
                onAnimationComplete: onAnimationComplete,
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                    d: "M16 9V11H4V9L16 9Z",
                    fill: "currentColor"
                })
            })
        ]
    });
}
const $184858dc9ce4454d$var$verticalVariants = {
    [(0, $9e6b3538bebe2537$export$a0af5b5e74349d9d)]: {
        scaleY: 0,
        opacity: 0,
        transition: {
            duration: 0
        }
    },
    [(0, $9e6b3538bebe2537$export$2e55affa8f2a0ab6)]: {
        scaleY: 1,
        opacity: 1,
        transition: {
            duration: 0.5
        }
    }
};
const $184858dc9ce4454d$var$horizontalVariants = {
    [(0, $9e6b3538bebe2537$export$a0af5b5e74349d9d)]: {
        scaleX: 0,
        opacity: 0,
        transition: {
            duration: 0
        }
    },
    [(0, $9e6b3538bebe2537$export$2e55affa8f2a0ab6)]: {
        scaleX: 1,
        opacity: 1,
        transition: {
            duration: 0.5
        }
    }
};





function $2734e675cadaeee9$export$d485f8709f159446({ controls: controls, onAnimationComplete: onAnimationComplete, ...svgProps }) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...svgProps,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $5980fceb02c72dc0$export$e25e478948902b8b).g, {
                variants: $2734e675cadaeee9$var$variantsTop,
                initial: "initial",
                animate: controls,
                onAnimationComplete: onAnimationComplete,
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M16 2L4 2C2.89543 2 2 2.89543 2 4L2 16C2 17.1046 2.89543 18 4 18H16C17.1046 18 18 17.1046 18 16V4C18 2.89543 17.1046 2 16 2ZM16 16V4L6 4L6 16H16Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                        d: "M13 6H8V8H13V6Z",
                        fill: "currentColor"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $5980fceb02c72dc0$export$e25e478948902b8b).path, {
                variants: $2734e675cadaeee9$var$variantsBottom,
                animate: controls,
                initial: "initial",
                opacity: "0.2",
                d: "M16 2C17.1046 2 18 2.89543 18 4L18 16C18 17.1046 17.1046 18 16 18L4 18L4 2L16 2Z",
                fill: "currentColor"
            })
        ]
    });
}
const $2734e675cadaeee9$var$initial = {
    [(0, $9e6b3538bebe2537$export$17227441e89ee693)]: {
        originX: 0,
        originY: "bottom"
    }
};
const $2734e675cadaeee9$var$variantsTop = {
    ...$2734e675cadaeee9$var$initial,
    [(0, $9e6b3538bebe2537$export$2e55affa8f2a0ab6)]: {
        rotate: [
            "0deg",
            "-5deg",
            "0deg"
        ]
    }
};
const $2734e675cadaeee9$var$variantsBottom = {
    ...$2734e675cadaeee9$var$initial,
    [(0, $9e6b3538bebe2537$export$2e55affa8f2a0ab6)]: {
        rotate: [
            "0deg",
            "4deg",
            "0deg"
        ]
    }
};






const $fe3d9ecad4e90939$var$CLIP_PATH_ID = "animated-function-icon-clip-path";
function $fe3d9ecad4e90939$export$695753172f175352({ controls: controls, onAnimationComplete: onAnimationComplete, ...svgProps }) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...svgProps,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                opacity: "0.2",
                d: "M16 4H4V16H16V4Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M4 3.99805C4.00105 2.89438 4.89608 2 6 2H8V4L4.00391 4L4.00391 15.998C2.89934 15.998 2.00391 15.1026 2.00391 13.998V5.99805C2.00391 4.89478 2.89723 4.00016 4 3.99805Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M8 18H6C4.89543 18 4 17.1046 4 16H8V18Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M16 16V4.00293C17.1046 4.00293 18 4.89836 18 6.00293L18 14.0029C18 15.1075 17.1046 16.0029 16 16.0029C15.9984 17.1062 15.1036 18 14 18L12 18L12 16L16 16Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M12 2H14C15.1046 2 16 2.89543 16 4L12 4V2Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($fe3d9ecad4e90939$var$ClippedGroup, {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $5980fceb02c72dc0$export$e25e478948902b8b).g, {
                        custom: 1,
                        variants: $fe3d9ecad4e90939$var$variants,
                        animate: controls,
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M6 6H11V8H6V6Z",
                                fill: "currentColor"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M14 6H12V8H14V6Z",
                                fill: "currentColor"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $5980fceb02c72dc0$export$e25e478948902b8b).path, {
                        custom: 2,
                        variants: $fe3d9ecad4e90939$var$variants,
                        animate: controls,
                        d: "M14 9H6V11H14V9Z",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $5980fceb02c72dc0$export$e25e478948902b8b).g, {
                        custom: 3,
                        variants: $fe3d9ecad4e90939$var$variants,
                        animate: controls,
                        onAnimationComplete: onAnimationComplete,
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M14 12H9V14H14V12Z",
                                fill: "currentColor"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M6 12H8V14H6V12Z",
                                fill: "currentColor"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("clipPath", {
                id: $fe3d9ecad4e90939$var$CLIP_PATH_ID,
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                    x: "6",
                    y: "6",
                    width: "8",
                    height: "8"
                })
            })
        ]
    });
}
const $fe3d9ecad4e90939$var$variants = {
    [(0, $9e6b3538bebe2537$export$a0af5b5e74349d9d)]: {
        x: -8,
        transition: {
            duration: 0
        }
    },
    [(0, $9e6b3538bebe2537$export$2e55affa8f2a0ab6)]: (i)=>({
            x: 0,
            transition: {
                delay: 0.2 * i,
                ease: "easeOut",
                type: "linear",
                duration: 0.2
            }
        })
};
const $fe3d9ecad4e90939$var$ClippedGroup = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).g`
  clip-path: url(#${$fe3d9ecad4e90939$var$CLIP_PATH_ID});
`;





function $edf82f0a41f3d7ca$export$c8ca09d835abf263({ controls: controls, onAnimationComplete: onAnimationComplete, ...svgProps }) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...svgProps,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $5980fceb02c72dc0$export$e25e478948902b8b).path, {
                variants: $edf82f0a41f3d7ca$var$variantsTop,
                animate: controls,
                transition: $edf82f0a41f3d7ca$var$transition,
                onAnimationComplete: onAnimationComplete,
                d: "M16 5V7L4 7L4 5L16 5Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $5980fceb02c72dc0$export$e25e478948902b8b).path, {
                variants: $edf82f0a41f3d7ca$var$variantsMiddle,
                initial: "initial",
                animate: controls,
                transition: $edf82f0a41f3d7ca$var$transition,
                d: "M16 9V11L4 11L4 9L16 9Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $5980fceb02c72dc0$export$e25e478948902b8b).path, {
                variants: $edf82f0a41f3d7ca$var$variantsBottom,
                animate: controls,
                transition: $edf82f0a41f3d7ca$var$transition,
                d: "M16 13V15L4 15L4 13H16Z",
                fill: "currentColor"
            })
        ]
    });
}
const $edf82f0a41f3d7ca$var$transition = {
    duration: 0.1,
    type: "spring",
    stiffness: 300,
    damping: 30
};
const $edf82f0a41f3d7ca$var$initial = {
    [(0, $9e6b3538bebe2537$export$17227441e89ee693)]: {
        rotate: 0,
        y: 0
    }
};
const $edf82f0a41f3d7ca$var$variantsTop = {
    ...$edf82f0a41f3d7ca$var$initial,
    [(0, $9e6b3538bebe2537$export$2e55affa8f2a0ab6)]: {
        rotate: -45,
        y: 4
    }
};
const $edf82f0a41f3d7ca$var$variantsMiddle = {
    [(0, $9e6b3538bebe2537$export$17227441e89ee693)]: {
        opacity: 1
    },
    [(0, $9e6b3538bebe2537$export$2e55affa8f2a0ab6)]: {
        opacity: 0
    }
};
const $edf82f0a41f3d7ca$var$variantsBottom = {
    ...$edf82f0a41f3d7ca$var$initial,
    [(0, $9e6b3538bebe2537$export$2e55affa8f2a0ab6)]: {
        rotate: 45,
        y: -4
    }
};





function $8515724c46ec0d40$export$a6ebb67e28b258f0({ controls: controls, onAnimationComplete: onAnimationComplete, ...svgProps }) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...svgProps,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M3.99902 4L9.99902 4V2L3.99902 2C2.89445 2 1.99902 2.89445 1.99902 3.99902L1.99902 15.999C1.99902 17.1036 2.89445 17.999 3.99902 17.999L15.999 18C17.1036 18 17.999 17.1046 17.999 16L17.999 9H15.999L15.999 16L3.99902 16V4Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $5980fceb02c72dc0$export$e25e478948902b8b).path, {
                variants: $8515724c46ec0d40$var$variants,
                animate: controls,
                onAnimationComplete: onAnimationComplete,
                d: "M18.0016 2.00092L17.9985 7.00015L16.0016 7L16.0035 5.65348L9.4126 12.2444L7.99838 10.8302L14.829 3.99959L13.0024 4.00006L13.0016 2L18.0016 2.00092Z",
                fill: "currentColor"
            })
        ]
    });
}
const $8515724c46ec0d40$var$variants = {
    [(0, $9e6b3538bebe2537$export$17227441e89ee693)]: {
        x: 0,
        y: 0,
        transition: {
            type: "just"
        }
    },
    [(0, $9e6b3538bebe2537$export$2e55affa8f2a0ab6)]: {
        x: [
            0,
            -1,
            2,
            2
        ],
        y: [
            0,
            1,
            -2,
            -2
        ],
        transition: {
            duration: 0.6,
            type: "tween"
        }
    }
};





function $134728f6979c892b$export$bad20c1c678d5990({ controls: controls, onAnimationComplete: onAnimationComplete, ...svgProps }) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...svgProps,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $5980fceb02c72dc0$export$e25e478948902b8b).g, {
            variants: $134728f6979c892b$var$variants,
            animate: controls,
            onAnimationComplete: onAnimationComplete,
            children: [
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                    opacity: "0.2",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M4.76922 4.93694C4.49307 4.45865 4.65695 3.84706 5.13524 3.57092L6.86729 2.57092C7.34558 2.29477 7.95717 2.45865 8.23332 2.93694L8.68473 3.71881C8.75398 3.74468 8.82292 3.77373 8.89139 3.80605C9.59388 4.13766 10.4079 4.13766 11.1104 3.80605C11.179 3.77366 11.2481 3.74455 11.3175 3.71863L11.7681 2.93811C12.0443 2.45982 12.6559 2.29594 13.1342 2.57209L14.8662 3.57209C15.3445 3.84823 15.5084 4.45982 15.2322 4.93811L14.782 5.71789C14.7944 5.79132 14.8038 5.86607 14.8101 5.94207C14.8741 6.71625 15.2811 7.42119 15.9196 7.86376C15.982 7.90703 16.0418 7.95236 16.099 7.99956L17.0015 7.99956C17.5538 7.99956 18.0015 8.44728 18.0015 8.99956L18.0015 10.9996C18.0015 11.5518 17.5538 11.9996 17.0015 11.9996L16.0995 11.9996C16.0422 12.0469 15.9822 12.0924 15.9196 12.1358C15.2811 12.5784 14.8741 13.2833 14.8101 14.0575C14.8038 14.133 14.7945 14.2072 14.7823 14.2801L15.2333 15.0613C15.5095 15.5396 15.3456 16.1512 14.8673 16.4273L13.1352 17.4273C12.6569 17.7035 12.0454 17.5396 11.7692 17.0613L11.319 16.2815C11.2491 16.2554 11.1795 16.2261 11.1104 16.1935C10.4079 15.8619 9.59388 15.8619 8.89139 16.1935C8.82242 16.2261 8.75298 16.2553 8.68322 16.2813L8.23223 17.0625C7.95608 17.5408 7.34449 17.7046 6.8662 17.4285L5.13415 16.4285C4.65586 16.1523 4.49198 15.5408 4.76813 15.0625L5.21955 14.2806C5.20728 14.2075 5.19795 14.1331 5.19169 14.0575C5.12763 13.2833 4.72063 12.5784 4.0822 12.1358C4.01958 12.0924 3.9596 12.0469 3.90224 11.9996L3.00147 11.9996C2.44919 11.9996 2.00147 11.5518 2.00147 10.9996L2.00147 8.99956C2.00147 8.44728 2.44919 7.99956 3.00147 7.99956L3.90277 7.99956C3.95997 7.95236 4.01978 7.90703 4.0822 7.86376C4.72063 7.42119 5.12763 6.71625 5.19169 5.94207C5.19799 5.8659 5.20742 5.79098 5.21981 5.7174L4.76922 4.93694ZM11.5009 12.5979C12.9358 11.7694 13.4274 9.93466 12.599 8.49978C11.7705 7.06491 9.93575 6.57328 8.50088 7.40171C7.066 8.23014 6.57437 10.0649 7.4028 11.4998C8.23123 12.9347 10.066 13.4263 11.5009 12.5979Z",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M3.90249 5.43705C3.35021 4.48046 3.67796 3.25728 4.63454 2.705L6.36659 1.705C7.32318 1.15271 8.54636 1.48046 9.09864 2.43705L9.38407 2.93141C9.7784 3.09609 10.2225 3.09602 10.6168 2.93121L10.9014 2.43822C11.4537 1.48163 12.6769 1.15388 13.6335 1.70617L15.3655 2.70617C16.3221 3.25845 16.6498 4.48163 16.0976 5.43822L15.8134 5.9304C15.8676 6.35498 16.0899 6.74027 16.4303 6.99967L17.0008 6.99967C18.1053 6.99967 19.0008 7.8951 19.0008 8.99967L19.0008 10.9997C19.0008 12.1042 18.1053 12.9997 17.0008 12.9997L16.4309 12.9997C16.0906 13.2587 15.8682 13.6435 15.8136 14.0677L16.0986 14.5614C16.6509 15.518 16.3232 16.7412 15.3666 17.2935L13.6345 18.2935C12.678 18.8457 11.4548 18.518 10.9025 17.5614L10.6183 17.0692C10.2231 16.9035 9.77775 16.9035 9.38251 17.069L9.09756 17.5626C8.54527 18.5192 7.32209 18.8469 6.3655 18.2946L4.63345 17.2946C3.67687 16.7423 3.34912 15.5192 3.9014 14.5626L4.18682 14.0682C4.13234 13.6439 3.90991 13.2588 3.56947 12.9997L3.00078 12.9997C1.89621 12.9997 1.00078 12.1042 1.00078 10.9997L1.00077 8.99967C1.00078 7.8951 1.89621 6.99967 3.00077 6.99967L3.57005 6.99967C3.91061 6.74016 4.13296 6.35466 4.18703 5.92988L3.90249 5.43705ZM7.36659 3.43705L5.63454 4.43705L6.26497 5.52899L6.20522 5.88365C6.1975 5.92944 6.19157 5.97644 6.18758 6.02464C6.09888 7.09669 5.53528 8.07286 4.65122 8.68571C4.61171 8.7131 4.5742 8.74155 4.5386 8.77092L4.26144 8.99967L3.00077 8.99967L3.00077 10.9997L4.26105 10.9997L4.53827 11.2286C4.57396 11.2581 4.61159 11.2866 4.65122 11.3141C5.53528 11.9269 6.09888 12.9031 6.18759 13.9751C6.19154 14.023 6.19742 14.0697 6.20505 14.1151L6.26454 14.4695L5.63345 15.5626L7.3655 16.5626L7.99628 15.47L8.33318 15.3444C8.37659 15.3283 8.42017 15.3099 8.46382 15.2893C9.43659 14.8301 10.5638 14.8301 11.5365 15.2893C11.5803 15.31 11.624 15.3283 11.6675 15.3445L12.0045 15.4701L12.6345 16.5614L14.3666 15.5614L13.736 14.4691L13.7954 14.1148C13.803 14.0695 13.8088 14.0229 13.8128 13.9751C13.9015 12.9031 14.4651 11.9269 15.3491 11.3141C15.3888 11.2866 15.4264 11.2581 15.4621 11.2286L15.7393 10.9997L17.0008 10.9997L17.0008 8.99967L15.7389 8.99967L15.4618 8.77092C15.4262 8.74155 15.3886 8.7131 15.3491 8.68571C14.4651 8.07286 13.9015 7.09669 13.8128 6.02464C13.8088 5.97656 13.8029 5.92966 13.7952 5.88395L13.7355 5.52938L14.3655 4.43822L12.6335 3.43822L12.0032 4.52992L11.6665 4.65559C11.6233 4.67172 11.58 4.68997 11.5365 4.71047C10.5638 5.16967 9.43659 5.16966 8.46381 4.71047C8.42048 4.69001 8.37722 4.6718 8.33412 4.6557L7.99761 4.53001L7.36659 3.43705ZM6.53608 11.9999C5.43151 10.0867 6.08701 7.64036 8.00018 6.53579C9.91335 5.43122 12.3597 6.08672 13.4643 7.99989C14.5688 9.91306 13.9133 12.3594 12.0002 13.464C10.087 14.5686 7.64065 13.9131 6.53608 11.9999ZM9.00018 8.26784C8.04359 8.82013 7.71584 10.0433 8.26813 10.9999C8.82041 11.9565 10.0436 12.2842 11.0002 11.7319C11.9568 11.1797 12.2845 9.95648 11.7322 8.99989C11.1799 8.04331 9.95676 7.71556 9.00018 8.26784Z",
                    fill: "currentColor"
                })
            ]
        })
    });
}
const $134728f6979c892b$var$variants = {
    [(0, $9e6b3538bebe2537$export$a0af5b5e74349d9d)]: {
        rotate: 0,
        transition: {
            duration: 0
        }
    },
    [(0, $9e6b3538bebe2537$export$2e55affa8f2a0ab6)]: {
        rotate: 120,
        transition: {
            duration: 0.4
        }
    }
};






const $1250ae74c81c6027$var$CLIP_PATH_ID = "animated-slo-icon-clip-path";
function $1250ae74c81c6027$export$acb896ac14036e0c({ controls: controls, onAnimationComplete: onAnimationComplete, ...svgProps }) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...svgProps,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                opacity: "0.2",
                x: "4",
                y: "4",
                width: "12",
                height: "12",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M4.00098 15.999L4.00098 13.001L2.00098 13.001L2.00098 14.001C2.00098 15.1049 2.89535 15.9999 3.99902 16.001C4.00008 17.1046 4.8951 17.999 5.99902 17.999L13.999 17.999C15.1036 17.999 15.999 17.1036 15.999 15.999L4.00098 15.999Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M18.001 13.001L18.001 14.001C18.001 15.1055 17.1055 16.001 16.001 16.001L16.001 13.001L18.001 13.001Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M16.001 4.00098L4.00391 4.00098C4.00391 2.89641 4.89934 2.00098 6.00391 2.00098L14.0039 2.00098C15.1085 2.00098 16.0039 2.89641 16.0039 4.00098C17.1071 4.00256 18.001 4.89738 18.001 6.00098L18.001 8.00098L16.001 8.00098L16.001 4.00098Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M2.00098 8.00098L2.00098 6.00098C2.00098 4.89641 2.89641 4.00098 4.00098 4.00098L4.00098 8.00098L2.00098 8.00098Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($1250ae74c81c6027$var$ClippedPath, {
                d: "M13.1273 6.8018C13.0454 6.39878 12.7251 6.087 12.32 6.01599C11.9149 5.94499 11.5076 6.12924 11.2935 6.48037L8.48878 11.0801L7.87916 10.0804C7.69762 9.78264 7.37408 9.60098 7.02537 9.60098L3.00098 9.60098L3.00098 11.601L6.46388 11.601L7.63499 13.5216C7.81653 13.8193 8.14006 14.001 8.48878 14.001C8.8375 14.001 9.16103 13.8193 9.34258 13.5216L11.6748 9.69675L11.8991 10.8002C11.9938 11.2661 12.4035 11.601 12.879 11.601L18.001 11.601L18.001 9.60098L13.6962 9.60098L13.1273 6.8018Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("clipPath", {
                id: $1250ae74c81c6027$var$CLIP_PATH_ID,
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $5980fceb02c72dc0$export$e25e478948902b8b).rect, {
                    onAnimationComplete: onAnimationComplete,
                    variants: $1250ae74c81c6027$var$variants,
                    animate: controls,
                    x: "3",
                    y: "0",
                    width: "20",
                    height: "20"
                })
            })
        ]
    });
}
const $1250ae74c81c6027$var$ClippedPath = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).path`
  clip-path: url(#${$1250ae74c81c6027$var$CLIP_PATH_ID});
`;
const $1250ae74c81c6027$var$variants = {
    [(0, $9e6b3538bebe2537$export$a0af5b5e74349d9d)]: {
        width: "0%",
        transition: {
            duration: 0
        }
    },
    [(0, $9e6b3538bebe2537$export$2e55affa8f2a0ab6)]: {
        width: "100%",
        transition: {
            duration: 1
        }
    }
};







const $cf5557e4cde6a3c7$var$ANIMATED_ICON_MAP = {
    alerts_duotone: (0, $77ec05f5c8ffc21b$export$283307ac62433e5a),
    dashboard_duotone: (0, $184858dc9ce4454d$export$729e9b6c47e0540),
    documentation_duotone: (0, $2734e675cadaeee9$export$d485f8709f159446),
    function_duotone: (0, $fe3d9ecad4e90939$export$695753172f175352),
    hamburger: (0, $edf82f0a41f3d7ca$export$c8ca09d835abf263),
    link_out: (0, $8515724c46ec0d40$export$a6ebb67e28b258f0),
    settings_duotone: (0, $134728f6979c892b$export$bad20c1c678d5990),
    slo_duotone: (0, $1250ae74c81c6027$export$acb896ac14036e0c)
};
function $cf5557e4cde6a3c7$export$362afcc43006a410(type) {
    const [isAnimating, setIsAnimating] = (0, $2gcPZ.useState)(false);
    const controls = (0, $c239997b1a5deb7a$export$c705d7acb130fe23)();
    // As `startAnimation` is an async function, we need to keep track of whether
    // the component is mounted or not. If the component is unmounted while the
    // animation is running, we need to stop the animation.
    const isMounted = (0, $2gcPZ.useRef)(true);
    const onAnimationComplete = (definition)=>{
        if (definition === (0, $9e6b3538bebe2537$export$2e55affa8f2a0ab6)) setIsAnimating(false);
    };
    /**
   * Start the icon's animation. If the animation is already running ignore the
   * call.
   */ const startAnimation = async ()=>{
        if (isAnimating) return;
        await controls.start((0, $9e6b3538bebe2537$export$a0af5b5e74349d9d));
        if (!isMounted.current) {
            controls.stop();
            return;
        }
        controls.start((0, $9e6b3538bebe2537$export$2e55affa8f2a0ab6));
        setIsAnimating(true);
    };
    /**
   * Animate the icon to its initial state. For cases when the icon stays at its
   * animated state until the user stops interacting with it.
   */ const animateToInitial = ()=>{
        controls.start((0, $9e6b3538bebe2537$export$17227441e89ee693));
    };
    (0, $2gcPZ.useEffect)(()=>{
        return ()=>{
            isMounted.current = false;
            controls.stop();
        };
    }, [
        controls
    ]);
    const IconComponent = (0, $2gcPZ.useMemo)(()=>{
        const Component = $cf5557e4cde6a3c7$var$ANIMATED_ICON_MAP[type];
        return function Icon(props) {
            return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)(Component, {
                controls: controls,
                onAnimationComplete: onAnimationComplete,
                ...props
            });
        };
    }, [
        controls,
        type
    ]);
    return {
        icon: IconComponent,
        startAnimation: startAnimation,
        animateToInitial: animateToInitial
    };
}






var $2gcPZ = parcelRequire("2gcPZ");

var $2gcPZ = parcelRequire("2gcPZ");

var $fuyzp = parcelRequire("fuyzp");
function $4b1d85e5a1fd6a28$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $0947fb5206f9a9d3$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $4b1d85e5a1fd6a28$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $0947fb5206f9a9d3$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $4b1d85e5a1fd6a28$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $0947fb5206f9a9d3$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $4b1d85e5a1fd6a28$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $28de21ae56c6e620$export$8960430cfd85939f = Math.max;
var $28de21ae56c6e620$export$96ec731ed4dcb222 = Math.min;
var $28de21ae56c6e620$export$2077e0241d6afd3c = Math.round;



function $ec497c09ea4f40b2$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $bcf74f6721777ab1$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $ec497c09ea4f40b2$export$2e2bcd8739ae039)());
}


function $f0801ecebf2a1b6f$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $0947fb5206f9a9d3$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $28de21ae56c6e620$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $28de21ae56c6e620$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $0947fb5206f9a9d3$export$45a5e7f76e0caa8d)(element) ? (0, $4b1d85e5a1fd6a28$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $bcf74f6721777ab1$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $308d4d127fbe31a5$export$2e2bcd8739ae039(node) {
    var win = (0, $4b1d85e5a1fd6a28$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $5b26c938b4f8a00f$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $b18d8345f76981bb$export$2e2bcd8739ae039(node) {
    if (node === (0, $4b1d85e5a1fd6a28$export$2e2bcd8739ae039)(node) || !(0, $0947fb5206f9a9d3$export$1b3bfaa9684536aa)(node)) return (0, $308d4d127fbe31a5$export$2e2bcd8739ae039)(node);
    else return (0, $5b26c938b4f8a00f$export$2e2bcd8739ae039)(node);
}


function $f870e69a25eb1bca$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}





function $d6bac3b0e61d5bf2$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $0947fb5206f9a9d3$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $884a5007cf276654$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $f0801ecebf2a1b6f$export$2e2bcd8739ae039)((0, $d6bac3b0e61d5bf2$export$2e2bcd8739ae039)(element)).left + (0, $308d4d127fbe31a5$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $1675621cee1824c5$export$2e2bcd8739ae039(element) {
    return (0, $4b1d85e5a1fd6a28$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $2433a9f5df280133$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $1675621cee1824c5$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $37ac880899605a33$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $28de21ae56c6e620$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $28de21ae56c6e620$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $37ac880899605a33$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $0947fb5206f9a9d3$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $0947fb5206f9a9d3$export$1b3bfaa9684536aa)(offsetParent) && $37ac880899605a33$var$isElementScaled(offsetParent);
    var documentElement = (0, $d6bac3b0e61d5bf2$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $f0801ecebf2a1b6f$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $f870e69a25eb1bca$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $2433a9f5df280133$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $b18d8345f76981bb$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $0947fb5206f9a9d3$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $f0801ecebf2a1b6f$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $884a5007cf276654$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $fda9e3966a5a2df0$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $f0801ecebf2a1b6f$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $815b7b20fb58945a$export$2e2bcd8739ae039(element) {
    if ((0, $f870e69a25eb1bca$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $0947fb5206f9a9d3$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $d6bac3b0e61d5bf2$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $e82855d9d6cf2ee7$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $f870e69a25eb1bca$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $0947fb5206f9a9d3$export$1b3bfaa9684536aa)(node) && (0, $2433a9f5df280133$export$2e2bcd8739ae039)(node)) return node;
    return $e82855d9d6cf2ee7$export$2e2bcd8739ae039((0, $815b7b20fb58945a$export$2e2bcd8739ae039)(node));
}





function $11d03ecd18a4a7cd$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $e82855d9d6cf2ee7$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $4b1d85e5a1fd6a28$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $2433a9f5df280133$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($11d03ecd18a4a7cd$export$2e2bcd8739ae039((0, $815b7b20fb58945a$export$2e2bcd8739ae039)(target)));
}







function $b419dfcc069a4259$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $f870e69a25eb1bca$export$2e2bcd8739ae039)(element)) >= 0;
}




function $4e82fc197908cf51$var$getTrueOffsetParent(element) {
    if (!(0, $0947fb5206f9a9d3$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $1675621cee1824c5$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $4e82fc197908cf51$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $ec497c09ea4f40b2$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $ec497c09ea4f40b2$export$2e2bcd8739ae039)());
    if (isIE && (0, $0947fb5206f9a9d3$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $1675621cee1824c5$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $815b7b20fb58945a$export$2e2bcd8739ae039)(element);
    if ((0, $0947fb5206f9a9d3$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $0947fb5206f9a9d3$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $f870e69a25eb1bca$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $1675621cee1824c5$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $4e82fc197908cf51$export$2e2bcd8739ae039(element) {
    var window = (0, $4b1d85e5a1fd6a28$export$2e2bcd8739ae039)(element);
    var offsetParent = $4e82fc197908cf51$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $b419dfcc069a4259$export$2e2bcd8739ae039)(offsetParent) && (0, $1675621cee1824c5$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $4e82fc197908cf51$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $f870e69a25eb1bca$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $f870e69a25eb1bca$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $1675621cee1824c5$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $4e82fc197908cf51$var$getContainingBlock(element) || window;
}



var $2e779885e521706c$export$1e95b668f3b82d = "top";
var $2e779885e521706c$export$40e543e69a8b3fbb = "bottom";
var $2e779885e521706c$export$79ffe56a765070d2 = "right";
var $2e779885e521706c$export$eabcd2c8791e7bf4 = "left";
var $2e779885e521706c$export$dfb5619354ba860 = "auto";
var $2e779885e521706c$export$aec2ce47c367b8c3 = [
    $2e779885e521706c$export$1e95b668f3b82d,
    $2e779885e521706c$export$40e543e69a8b3fbb,
    $2e779885e521706c$export$79ffe56a765070d2,
    $2e779885e521706c$export$eabcd2c8791e7bf4
];
var $2e779885e521706c$export$b3571188c770cc5a = "start";
var $2e779885e521706c$export$bd5df0f255a350f8 = "end";
var $2e779885e521706c$export$390fd549c5303b4d = "clippingParents";
var $2e779885e521706c$export$d7b7311ec04a3e8f = "viewport";
var $2e779885e521706c$export$ae5ab1c730825774 = "popper";
var $2e779885e521706c$export$ca50aac9f3ba507f = "reference";
var $2e779885e521706c$export$368f9a87e87fa4e1 = /*#__PURE__*/ $2e779885e521706c$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $2e779885e521706c$export$b3571188c770cc5a,
        placement + "-" + $2e779885e521706c$export$bd5df0f255a350f8
    ]);
}, []);
var $2e779885e521706c$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($2e779885e521706c$export$aec2ce47c367b8c3, [
    $2e779885e521706c$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $2e779885e521706c$export$b3571188c770cc5a,
        placement + "-" + $2e779885e521706c$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $2e779885e521706c$export$421679a7c3d56e = "beforeRead";
var $2e779885e521706c$export$aafa59e2e03f2942 = "read";
var $2e779885e521706c$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $2e779885e521706c$export$c65e99957a05207c = "beforeMain";
var $2e779885e521706c$export$f22da7240b7add18 = "main";
var $2e779885e521706c$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $2e779885e521706c$export$8d4d2d70e7d46032 = "beforeWrite";
var $2e779885e521706c$export$68d8715fc104d294 = "write";
var $2e779885e521706c$export$70a6e5159acce2e6 = "afterWrite";
var $2e779885e521706c$export$d087d3878fdf71d5 = [
    $2e779885e521706c$export$421679a7c3d56e,
    $2e779885e521706c$export$aafa59e2e03f2942,
    $2e779885e521706c$export$6964f6c886723980,
    $2e779885e521706c$export$c65e99957a05207c,
    $2e779885e521706c$export$f22da7240b7add18,
    $2e779885e521706c$export$bab79516f2d662fe,
    $2e779885e521706c$export$8d4d2d70e7d46032,
    $2e779885e521706c$export$68d8715fc104d294,
    $2e779885e521706c$export$70a6e5159acce2e6
];


function $7f692cf0ab83bd5c$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $7f692cf0ab83bd5c$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $7f692cf0ab83bd5c$var$order(modifiers); // order based on phase
    return (0, $2e779885e521706c$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $5d8fd93b2d78e6a4$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}





function $dfec2761c5f2f54a$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}





var $9701b1e5d970efcc$var$INVALID_ELEMENT_ERROR = "Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.";
var $9701b1e5d970efcc$var$INFINITE_LOOP_ERROR = "Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.";
var $9701b1e5d970efcc$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $9701b1e5d970efcc$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $9701b1e5d970efcc$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $9701b1e5d970efcc$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $9701b1e5d970efcc$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $0947fb5206f9a9d3$export$45a5e7f76e0caa8d)(reference) ? (0, $11d03ecd18a4a7cd$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $11d03ecd18a4a7cd$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $11d03ecd18a4a7cd$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $7f692cf0ab83bd5c$export$2e2bcd8739ae039)((0, $dfec2761c5f2f54a$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                }); // Validate the provided modifiers so that the consumer will get warned
                var modifiers, flipModifier, _getComputedStyle, marginTop, marginRight, marginBottom, marginLeft;
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$9701b1e5d970efcc$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $37ac880899605a33$export$2e2bcd8739ae039)(reference, (0, $4e82fc197908cf51$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $fda9e3966a5a2df0$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                var __debug_loops__ = 0;
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $5d8fd93b2d78e6a4$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$9701b1e5d970efcc$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref3) {
                var name = _ref3.name, _ref3$options = _ref3.options, options = _ref3$options === void 0 ? {} : _ref3$options, effect = _ref3.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $9701b1e5d970efcc$export$8f7491d57c8f97a9 = /*#__PURE__*/ $9701b1e5d970efcc$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $32830d47ea793be5$var$passive = {
    passive: true
};
function $32830d47ea793be5$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $4b1d85e5a1fd6a28$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $32830d47ea793be5$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $32830d47ea793be5$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $32830d47ea793be5$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $32830d47ea793be5$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $32830d47ea793be5$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $32830d47ea793be5$var$effect,
    data: {}
};



function $7caf5a8762d0684f$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $3dbb910b6c842420$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}


function $6d396e4df3df6d9a$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $baba6bf5cc2f230d$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $7caf5a8762d0684f$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $3dbb910b6c842420$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $2e779885e521706c$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $2e779885e521706c$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $2e779885e521706c$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $2e779885e521706c$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $6d396e4df3df6d9a$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $2e779885e521706c$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $2e779885e521706c$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $dc77281ba0088a6f$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $baba6bf5cc2f230d$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $dc77281ba0088a6f$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $dc77281ba0088a6f$var$popperOffsets,
    data: {}
};










var $1b5999e5f6a7231a$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $1b5999e5f6a7231a$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $28de21ae56c6e620$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $28de21ae56c6e620$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $1b5999e5f6a7231a$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $2e779885e521706c$export$eabcd2c8791e7bf4);
    var sideY = (0, $2e779885e521706c$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $4e82fc197908cf51$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $4b1d85e5a1fd6a28$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $d6bac3b0e61d5bf2$export$2e2bcd8739ae039)(popper);
            if ((0, $1675621cee1824c5$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $2e779885e521706c$export$1e95b668f3b82d) || (placement === (0, $2e779885e521706c$export$eabcd2c8791e7bf4) || placement === (0, $2e779885e521706c$export$79ffe56a765070d2)) && variation === (0, $2e779885e521706c$export$bd5df0f255a350f8)) {
            sideY = (0, $2e779885e521706c$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $2e779885e521706c$export$eabcd2c8791e7bf4) || (placement === (0, $2e779885e521706c$export$1e95b668f3b82d) || placement === (0, $2e779885e521706c$export$40e543e69a8b3fbb)) && variation === (0, $2e779885e521706c$export$bd5df0f255a350f8)) {
            sideX = (0, $2e779885e521706c$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $1b5999e5f6a7231a$var$unsetSides);
    var _ref4 = roundOffsets === true ? $1b5999e5f6a7231a$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $4b1d85e5a1fd6a28$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $1b5999e5f6a7231a$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var transitionProperty;
    var commonStyles = {
        placement: (0, $7caf5a8762d0684f$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $3dbb910b6c842420$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $1b5999e5f6a7231a$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $1b5999e5f6a7231a$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $1b5999e5f6a7231a$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $1b5999e5f6a7231a$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $e5f57be1768a8da3$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $0947fb5206f9a9d3$export$1b3bfaa9684536aa)(element) || !(0, $f870e69a25eb1bca$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $e5f57be1768a8da3$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $0947fb5206f9a9d3$export$1b3bfaa9684536aa)(element) || !(0, $f870e69a25eb1bca$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $e5f57be1768a8da3$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $e5f57be1768a8da3$var$applyStyles,
    effect: $e5f57be1768a8da3$var$effect,
    requires: [
        "computeStyles"
    ]
};




function $9122603a15d4c536$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $7caf5a8762d0684f$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $2e779885e521706c$export$eabcd2c8791e7bf4),
        (0, $2e779885e521706c$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $2e779885e521706c$export$eabcd2c8791e7bf4),
        (0, $2e779885e521706c$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $9122603a15d4c536$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $2e779885e521706c$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $9122603a15d4c536$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $9122603a15d4c536$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $9122603a15d4c536$var$offset
};


var $38001cada0a09659$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $38001cada0a09659$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $38001cada0a09659$var$hash[matched];
    });
}



var $07ca02110e4a64af$var$hash = {
    start: "end",
    end: "start"
};
function $07ca02110e4a64af$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $07ca02110e4a64af$var$hash[matched];
    });
}







function $c40a06a863d6c370$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $4b1d85e5a1fd6a28$export$2e2bcd8739ae039)(element);
    var html = (0, $d6bac3b0e61d5bf2$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $bcf74f6721777ab1$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $884a5007cf276654$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $000479ed0906df0d$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $d6bac3b0e61d5bf2$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $308d4d127fbe31a5$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $28de21ae56c6e620$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $28de21ae56c6e620$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $884a5007cf276654$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $1675621cee1824c5$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $28de21ae56c6e620$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $2b75e657486d2f5d$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $0947fb5206f9a9d3$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $7c2be72446775a51$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $176e89524cdff54e$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $f0801ecebf2a1b6f$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $176e89524cdff54e$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $2e779885e521706c$export$d7b7311ec04a3e8f) ? (0, $7c2be72446775a51$export$2e2bcd8739ae039)((0, $c40a06a863d6c370$export$2e2bcd8739ae039)(element, strategy)) : (0, $0947fb5206f9a9d3$export$45a5e7f76e0caa8d)(clippingParent) ? $176e89524cdff54e$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $7c2be72446775a51$export$2e2bcd8739ae039)((0, $000479ed0906df0d$export$2e2bcd8739ae039)((0, $d6bac3b0e61d5bf2$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $176e89524cdff54e$var$getClippingParents(element) {
    var clippingParents = (0, $11d03ecd18a4a7cd$export$2e2bcd8739ae039)((0, $815b7b20fb58945a$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $1675621cee1824c5$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $0947fb5206f9a9d3$export$1b3bfaa9684536aa)(element) ? (0, $4e82fc197908cf51$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $0947fb5206f9a9d3$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $0947fb5206f9a9d3$export$45a5e7f76e0caa8d)(clippingParent) && (0, $2b75e657486d2f5d$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $f870e69a25eb1bca$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $176e89524cdff54e$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $176e89524cdff54e$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $176e89524cdff54e$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $28de21ae56c6e620$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $28de21ae56c6e620$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $28de21ae56c6e620$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $28de21ae56c6e620$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $176e89524cdff54e$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $eae6eb8ea3b10dd5$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $c2d3b34b4ec74e98$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $eae6eb8ea3b10dd5$export$2e2bcd8739ae039)(), paddingObject);
}


function $adf65e9422d15717$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $889ca6a4964c0a17$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $2e779885e521706c$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $2e779885e521706c$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $2e779885e521706c$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $c2d3b34b4ec74e98$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $adf65e9422d15717$export$2e2bcd8739ae039)(padding, (0, $2e779885e521706c$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $2e779885e521706c$export$ae5ab1c730825774) ? (0, $2e779885e521706c$export$ca50aac9f3ba507f) : (0, $2e779885e521706c$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $176e89524cdff54e$export$2e2bcd8739ae039)((0, $0947fb5206f9a9d3$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $d6bac3b0e61d5bf2$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $f0801ecebf2a1b6f$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $baba6bf5cc2f230d$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $7c2be72446775a51$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $2e779885e521706c$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $2e779885e521706c$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $2e779885e521706c$export$79ffe56a765070d2),
                (0, $2e779885e521706c$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $2e779885e521706c$export$1e95b668f3b82d),
                (0, $2e779885e521706c$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $0681414d7e0cf55b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $2e779885e521706c$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $3dbb910b6c842420$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $2e779885e521706c$export$368f9a87e87fa4e1) : (0, $2e779885e521706c$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $3dbb910b6c842420$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $2e779885e521706c$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $889ca6a4964c0a17$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $7caf5a8762d0684f$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $62fa824338953bab$var$getExpandedFallbackPlacements(placement) {
    if ((0, $7caf5a8762d0684f$export$2e2bcd8739ae039)(placement) === (0, $2e779885e521706c$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $38001cada0a09659$export$2e2bcd8739ae039)(placement);
    return [
        (0, $07ca02110e4a64af$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $07ca02110e4a64af$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $62fa824338953bab$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $7caf5a8762d0684f$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $38001cada0a09659$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $62fa824338953bab$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $7caf5a8762d0684f$export$2e2bcd8739ae039)(placement) === (0, $2e779885e521706c$export$dfb5619354ba860) ? (0, $0681414d7e0cf55b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $7caf5a8762d0684f$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $3dbb910b6c842420$export$2e2bcd8739ae039)(placement) === (0, $2e779885e521706c$export$b3571188c770cc5a);
        var isVertical = [
            (0, $2e779885e521706c$export$1e95b668f3b82d),
            (0, $2e779885e521706c$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $889ca6a4964c0a17$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $2e779885e521706c$export$79ffe56a765070d2) : (0, $2e779885e521706c$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $2e779885e521706c$export$40e543e69a8b3fbb) : (0, $2e779885e521706c$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $38001cada0a09659$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $38001cada0a09659$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $62fa824338953bab$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $62fa824338953bab$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};





function $02f91f246990eb5a$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}



function $d915a0be871db7d1$export$f28d906d67a997f3(min, value, max) {
    return (0, $28de21ae56c6e620$export$8960430cfd85939f)(min, (0, $28de21ae56c6e620$export$96ec731ed4dcb222)(value, max));
}
function $d915a0be871db7d1$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $d915a0be871db7d1$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $be68e13424e3cd26$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $889ca6a4964c0a17$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $7caf5a8762d0684f$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $3dbb910b6c842420$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $6d396e4df3df6d9a$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $02f91f246990eb5a$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $2e779885e521706c$export$1e95b668f3b82d) : (0, $2e779885e521706c$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $2e779885e521706c$export$40e543e69a8b3fbb) : (0, $2e779885e521706c$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $2e779885e521706c$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $2e779885e521706c$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $fda9e3966a5a2df0$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $eae6eb8ea3b10dd5$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $d915a0be871db7d1$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $4e82fc197908cf51$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $d915a0be871db7d1$export$f28d906d67a997f3)(tether ? (0, $28de21ae56c6e620$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $28de21ae56c6e620$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $2e779885e521706c$export$1e95b668f3b82d) : (0, $2e779885e521706c$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $2e779885e521706c$export$40e543e69a8b3fbb) : (0, $2e779885e521706c$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $2e779885e521706c$export$1e95b668f3b82d),
            (0, $2e779885e521706c$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $d915a0be871db7d1$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $d915a0be871db7d1$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $be68e13424e3cd26$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $be68e13424e3cd26$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};












var $007fb0313250e71e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $c2d3b34b4ec74e98$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $adf65e9422d15717$export$2e2bcd8739ae039)(padding, (0, $2e779885e521706c$export$aec2ce47c367b8c3)));
};
function $007fb0313250e71e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $7caf5a8762d0684f$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $6d396e4df3df6d9a$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $2e779885e521706c$export$eabcd2c8791e7bf4),
        (0, $2e779885e521706c$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $007fb0313250e71e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $fda9e3966a5a2df0$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $2e779885e521706c$export$1e95b668f3b82d) : (0, $2e779885e521706c$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $2e779885e521706c$export$40e543e69a8b3fbb) : (0, $2e779885e521706c$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $4e82fc197908cf51$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $d915a0be871db7d1$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $007fb0313250e71e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $2b75e657486d2f5d$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $007fb0313250e71e$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $007fb0313250e71e$var$arrow,
    effect: $007fb0313250e71e$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};




function $ae746e15f3fccb58$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $ae746e15f3fccb58$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $2e779885e521706c$export$1e95b668f3b82d),
        (0, $2e779885e521706c$export$79ffe56a765070d2),
        (0, $2e779885e521706c$export$40e543e69a8b3fbb),
        (0, $2e779885e521706c$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $ae746e15f3fccb58$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $889ca6a4964c0a17$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $889ca6a4964c0a17$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $ae746e15f3fccb58$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $ae746e15f3fccb58$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $ae746e15f3fccb58$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $ae746e15f3fccb58$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $ae746e15f3fccb58$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $ae746e15f3fccb58$var$hide
};




var $0d651d162468cb8e$export$d34966752335dd47 = [
    (0, $32830d47ea793be5$export$2e2bcd8739ae039),
    (0, $dc77281ba0088a6f$export$2e2bcd8739ae039),
    (0, $1b5999e5f6a7231a$export$2e2bcd8739ae039),
    (0, $e5f57be1768a8da3$export$2e2bcd8739ae039),
    (0, $9122603a15d4c536$export$2e2bcd8739ae039),
    (0, $62fa824338953bab$export$2e2bcd8739ae039),
    (0, $be68e13424e3cd26$export$2e2bcd8739ae039),
    (0, $007fb0313250e71e$export$2e2bcd8739ae039),
    (0, $ae746e15f3fccb58$export$2e2bcd8739ae039)
];
var $0d651d162468cb8e$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $9701b1e5d970efcc$export$ed5e13716264f202)({
    defaultModifiers: $0d651d162468cb8e$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


var $26929faffcb5c943$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $26929faffcb5c943$var$hasElementType = typeof Element !== "undefined";
var $26929faffcb5c943$var$hasMap = typeof Map === "function";
var $26929faffcb5c943$var$hasSet = typeof Set === "function";
var $26929faffcb5c943$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $26929faffcb5c943$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$26929faffcb5c943$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($26929faffcb5c943$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$26929faffcb5c943$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($26929faffcb5c943$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($26929faffcb5c943$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($26929faffcb5c943$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$26929faffcb5c943$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$26929faffcb5c943$exports = function isEqual(a, b) {
    try {
        return $26929faffcb5c943$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};



var $2gcPZ = parcelRequire("2gcPZ");
var $b939d5b7e3a6efff$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $b939d5b7e3a6efff$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === "function") {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $b939d5b7e3a6efff$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === "function") return $b939d5b7e3a6efff$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $b939d5b7e3a6efff$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $b939d5b7e3a6efff$export$700979bc83e7db82 = typeof window !== "undefined" && window.document && window.document.createElement ? $2gcPZ.useLayoutEffect : $2gcPZ.useEffect;


var $7cf40d019f36c73b$var$EMPTY_MODIFIERS = [];
var $7cf40d019f36c73b$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $2gcPZ.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || "bottom",
        strategy: options.strategy || "absolute",
        modifiers: options.modifiers || $7cf40d019f36c73b$var$EMPTY_MODIFIERS
    };
    var _React$useState = $2gcPZ.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: "0",
                top: "0"
            },
            arrow: {
                position: "absolute"
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $2gcPZ.useMemo(function() {
        return {
            name: "updateState",
            enabled: true,
            phase: "write",
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $fuyzp.flushSync(function() {
                    setState({
                        styles: (0, $b939d5b7e3a6efff$export$5150077fc2e7c662)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $b939d5b7e3a6efff$export$5150077fc2e7c662)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                "computeStyles"
            ]
        };
    }, []);
    var popperOptions = $2gcPZ.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: "applyStyles",
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($26929faffcb5c943$exports)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $2gcPZ.useRef();
    (0, $b939d5b7e3a6efff$export$700979bc83e7db82)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $b939d5b7e3a6efff$export$700979bc83e7db82)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $0d651d162468cb8e$export$8f7491d57c8f97a9);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};



var $2gcPZ = parcelRequire("2gcPZ");

function $5fbd0a1ef139e392$export$beb3f0fdaadc167a(type) {
    const { color: color } = (0, $4e8e6ea7d6e48c37$export$93d4e7f90805808f)();
    return (0, $2gcPZ.useMemo)(()=>{
        return [
            type === "bg" ? color.bg.emphasis.primary : color.fg.primary,
            ...Object.values(type === "bg" ? color.bg.accent : color.fg.accent)
        ];
    }, [
        color,
        type
    ]);
}


/**
 * Helper function that returns an index that is safe to use as an index for a
 * collection.
 * @param index
 * @param length length of the collection
 */ function $67e2673d33198003$export$7eb1f7cf896acb86(index, length) {
    return (index < 0 ? 0 : index) % length;
}


function $a7634f2acd528865$export$bd4b012f42a4dab7(type = "bg") {
    const accentColors = (0, $5fbd0a1ef139e392$export$beb3f0fdaadc167a)(type);
    const getAccentColorForIndex = (index)=>{
        const safeIndex = (0, $67e2673d33198003$export$7eb1f7cf896acb86)(index, accentColors.length);
        return accentColors[safeIndex];
    };
    return {
        getAccentColorForIndex: getAccentColorForIndex
    };
}



var $2gcPZ = parcelRequire("2gcPZ");



function $94aa7f612f0558e6$export$3939eba9bff0c75e(color) {
    const backgroundAccents = (0, $5fbd0a1ef139e392$export$beb3f0fdaadc167a)("bg");
    const { getAccentColorForIndex: fgAccent } = (0, $a7634f2acd528865$export$bd4b012f42a4dab7)("fg");
    const fgAccent0 = fgAccent(0);
    const fgAccent1 = fgAccent(1);
    const fgAccent2 = fgAccent(2);
    const fgAccent3 = fgAccent(3);
    // Hardcoded colors as they're only used for graph lines for this single use
    // only. Only the first, which is the taccent color, is coming from the theme.
    const graphLineColors = (0, $2gcPZ.useMemo)(()=>[
            [
                fgAccent0,
                "#D43DFF",
                "#6C61FF",
                "#FF38E3",
                "#54A9FF",
                "#B947FF",
                "#8B61FF",
                "#EF3BFF",
                "#5E7EFF"
            ],
            [
                fgAccent1,
                "#FA418C",
                "#B740E3",
                "#FF453D",
                "#9D53FC",
                "#FA3FB8",
                "#DC46F0",
                "#FC3F5F",
                "#A143E8"
            ],
            [
                fgAccent2,
                "#FF8A24",
                "#E83925",
                "#FFB230",
                "#FF3D72",
                "#FF7C2B",
                "#F2532C",
                "#FF9F29",
                "#F5313E"
            ],
            [
                fgAccent3,
                "#FAB423",
                "#E36724",
                "#FFD630",
                "#FA5C3C",
                "#FFAB2E",
                "#EB7E2A",
                "#FFC936",
                "#F06030"
            ]
        ], [
        fgAccent0,
        fgAccent1,
        fgAccent2,
        fgAccent3
    ]);
    const index = backgroundAccents.findIndex((set)=>set.includes(color));
    const safeIndex = (0, $67e2673d33198003$export$7eb1f7cf896acb86)(index, graphLineColors.length);
    return graphLineColors[safeIndex];
}





var $2gcPZ = parcelRequire("2gcPZ");

var $irAxG = parcelRequire("irAxG");

var $2gcPZ = parcelRequire("2gcPZ");
var $dd1c135fbc36bd36$exports = {};
"use strict";
var $dd1c135fbc36bd36$var$has = Object.prototype.hasOwnProperty, $dd1c135fbc36bd36$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $dd1c135fbc36bd36$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $dd1c135fbc36bd36$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $dd1c135fbc36bd36$var$Events().__proto__) $dd1c135fbc36bd36$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $dd1c135fbc36bd36$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $dd1c135fbc36bd36$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $dd1c135fbc36bd36$var$EE(fn, context || emitter, once), evt = $dd1c135fbc36bd36$var$prefix ? $dd1c135fbc36bd36$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $dd1c135fbc36bd36$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $dd1c135fbc36bd36$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $dd1c135fbc36bd36$var$EventEmitter() {
    this._events = new $dd1c135fbc36bd36$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $dd1c135fbc36bd36$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($dd1c135fbc36bd36$var$has.call(events, name)) names.push($dd1c135fbc36bd36$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $dd1c135fbc36bd36$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $dd1c135fbc36bd36$var$prefix ? $dd1c135fbc36bd36$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $dd1c135fbc36bd36$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $dd1c135fbc36bd36$var$prefix ? $dd1c135fbc36bd36$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $dd1c135fbc36bd36$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $dd1c135fbc36bd36$var$prefix ? $dd1c135fbc36bd36$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $dd1c135fbc36bd36$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $dd1c135fbc36bd36$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $dd1c135fbc36bd36$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $dd1c135fbc36bd36$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $dd1c135fbc36bd36$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $dd1c135fbc36bd36$var$prefix ? $dd1c135fbc36bd36$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $dd1c135fbc36bd36$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $dd1c135fbc36bd36$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $dd1c135fbc36bd36$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $dd1c135fbc36bd36$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $dd1c135fbc36bd36$var$prefix ? $dd1c135fbc36bd36$var$prefix + event : event;
        if (this._events[evt]) $dd1c135fbc36bd36$var$clearEvent(this, evt);
    } else {
        this._events = new $dd1c135fbc36bd36$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$dd1c135fbc36bd36$var$EventEmitter.prototype.off = $dd1c135fbc36bd36$var$EventEmitter.prototype.removeListener;
$dd1c135fbc36bd36$var$EventEmitter.prototype.addListener = $dd1c135fbc36bd36$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$dd1c135fbc36bd36$var$EventEmitter.prefixed = $dd1c135fbc36bd36$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$dd1c135fbc36bd36$var$EventEmitter.EventEmitter = $dd1c135fbc36bd36$var$EventEmitter;
$dd1c135fbc36bd36$exports = $dd1c135fbc36bd36$var$EventEmitter;



var $2gcPZ = parcelRequire("2gcPZ");
const $cac150ebb620e91f$var$noDeps = [];
function $cac150ebb620e91f$export$d095b0c879743c0d(handler) {
    const handlerRef = (0, $2gcPZ.useRef)(handler);
    handlerRef.current = handler;
    // @ts-ignore
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $2gcPZ.useCallback)((...args)=>handlerRef.current(...args), $cac150ebb620e91f$var$noDeps);
}


function $7fd7ff57d61a706f$export$86e2cef2561044ac(key, defaultValue) {
    const [value, internalSetValue] = (0, $2gcPZ.useState)(()=>{
        const storedValue = localStorage.getItem(key);
        if (storedValue === null) return defaultValue;
        const parsedValue = $7fd7ff57d61a706f$var$safeJSONParse(storedValue);
        if (parsedValue === null) return defaultValue;
        return parsedValue;
    });
    const handleChange = (0, $cac150ebb620e91f$export$d095b0c879743c0d)((event)=>{
        if (event.key === key) internalSetValue(event.newValue ? JSON.parse(event.newValue) : undefined);
    });
    const handleLocalChange = (0, $cac150ebb620e91f$export$d095b0c879743c0d)((event)=>{
        // If the key is different or the value is the same, do nothing
        if (event.key !== key || event.newValue === value) return;
        // If the value is nul
        if (event.newValue === null && value !== defaultValue) {
            internalSetValue(defaultValue);
            return;
        }
        internalSetValue(event.newValue);
    });
    (0, $2gcPZ.useEffect)(()=>{
        window.addEventListener("storage", handleChange);
        $7fd7ff57d61a706f$var$wrappedLocalStorage.addListener("local_storage", handleLocalChange);
        return ()=>{
            window.removeEventListener("storage", handleChange);
            $7fd7ff57d61a706f$var$wrappedLocalStorage.removeListener("local_storage", handleLocalChange);
        };
    }, [
        handleChange,
        handleLocalChange
    ]);
    // Passing in null will result the value to the initial value
    const setValue = (0, $cac150ebb620e91f$export$d095b0c879743c0d)((value)=>{
        const newValue = value ?? defaultValue;
        internalSetValue(newValue);
        if (value === null) {
            $7fd7ff57d61a706f$var$wrappedLocalStorage.removeItem(key);
            return;
        }
        $7fd7ff57d61a706f$var$wrappedLocalStorage.setItem(key, newValue);
    });
    return [
        value,
        setValue
    ];
}
class $7fd7ff57d61a706f$var$WrappedLocalStorage extends (0, $dd1c135fbc36bd36$exports.EventEmitter) {
    constructor(){
        super();
        window.addEventListener("storage", (event)=>{
            this.emit(event.key, event.newValue);
        });
    }
    getItem(key) {
        const value = localStorage.getItem(key);
        if (value === null) return null;
        return $7fd7ff57d61a706f$var$safeJSONParse(value);
    }
    setItem(key, value) {
        const serializedValue = JSON.stringify(value);
        localStorage.setItem(key, serializedValue);
        this.emit("local_storage", {
            key: key,
            newValue: value
        });
    }
    removeItem(key) {
        localStorage.removeItem(key);
        this.emit("local_storage", {
            key: key,
            newValue: null
        });
    }
}
const $7fd7ff57d61a706f$var$wrappedLocalStorage = new $7fd7ff57d61a706f$var$WrappedLocalStorage();
function $7fd7ff57d61a706f$var$safeJSONParse(value) {
    try {
        return JSON.parse(value);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn("Error parsing json from localStorage", error);
        return null;
    }
}


/**
 * List of all supported features.
 */ const $b1e0ced2c07ab736$export$d6a5c11f04f75862 = [
    "source-code-links",
    "theme-switch"
];
const $b1e0ced2c07ab736$export$95ca08bb851c4d2 = "features";





function $b62e61a689d28909$export$33b822a6faf70e7a(feature) {
    return (0, $b1e0ced2c07ab736$export$d6a5c11f04f75862).includes(feature);
}










/**
 * @deprecated Prefer `rtk-query` over `LoadableData`
 */ 

function $c5bcce893caf17be$export$888c18c43ead4265(theme) {
    return theme === "dark" || theme === "light";
}






const $edc4621501740b0b$var$initialFeatures = {
    enabled: false,
    features: (0, $b1e0ced2c07ab736$export$d6a5c11f04f75862).map((name)=>({
            name: name,
            enabled: false
        }))
};
function $edc4621501740b0b$export$fc97652867e5867e(feature) {
    const [{ enabled: featuresEnabled, features: features }, setStoredFeatures] = $edc4621501740b0b$var$useValidStoredFeatures();
    const isFeatureEnabled = (0, $2gcPZ.useMemo)(()=>{
        const storedFeature = features.find(({ name: name })=>name === feature);
        if (!storedFeature) return false;
        return featuresEnabled && storedFeature.enabled;
    }, [
        feature,
        features,
        featuresEnabled
    ]);
    const setIsFeatureEnabled = (featureEnabled)=>{
        const updatedFeatures = (0, $b1e0ced2c07ab736$export$d6a5c11f04f75862).map((key)=>{
            const existing = features.find(({ name: name })=>name === key);
            const enabled = key === feature ? featureEnabled : existing?.enabled ?? false;
            return {
                name: key,
                enabled: enabled
            };
        });
        setStoredFeatures({
            enabled: featuresEnabled,
            features: updatedFeatures
        });
    };
    return [
        isFeatureEnabled,
        setIsFeatureEnabled
    ];
}
function $edc4621501740b0b$export$4a39035bacc4ed76() {
    const [storedFeatures, setStoredFeatures] = $edc4621501740b0b$var$useValidStoredFeatures();
    const enableFeatures = storedFeatures.enabled;
    const setEnableFeatures = (enabled)=>{
        if (enabled) {
            setStoredFeatures({
                ...storedFeatures,
                enabled: enabled
            });
            return;
        }
        // When features are disabled, we fall back to the initial feature state
        setStoredFeatures($edc4621501740b0b$var$initialFeatures);
    };
    return [
        enableFeatures,
        setEnableFeatures
    ];
}
function $edc4621501740b0b$export$e431d39521b4f177() {
    const [{ features: validStoredFeatures }, setStoredFeatures] = $edc4621501740b0b$var$useValidStoredFeatures();
    const searchParams = new URLSearchParams(window.location.search);
    const parameterFeatures = searchParams.get((0, $b1e0ced2c07ab736$export$95ca08bb851c4d2))?.split(",") || [];
    const validFeatures = new Set(parameterFeatures.filter((0, $b62e61a689d28909$export$33b822a6faf70e7a)));
    // As the localStorage features aren't updated immediately on initial load, we
    // use an empty array as a fallback. We can remove this fallback once we get
    // rid of the temporary hook below.
    const updatedFeatures = (validStoredFeatures || []).map((storedFeature)=>{
        if (validFeatures.has(storedFeature.name)) return {
            ...storedFeature,
            enabled: true
        };
        return storedFeature;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($irAxG)))(()=>{
        if (validFeatures.size === 0) return;
        setStoredFeatures({
            enabled: true,
            features: updatedFeatures
        });
    });
}
/**
 * Temporary hook to handle the transition from the old feature to the new
 * feature state. As we're using the same key for both, we need to handle both
 * cases.
 */ function $edc4621501740b0b$var$useValidStoredFeatures() {
    const [features, setFeatures] = (0, $7fd7ff57d61a706f$export$86e2cef2561044ac)((0, $b1e0ced2c07ab736$export$95ca08bb851c4d2), $edc4621501740b0b$var$initialFeatures);
    if (Array.isArray(features)) {
        const validFeatures = new Set(features.filter((0, $b62e61a689d28909$export$33b822a6faf70e7a)));
        setFeatures({
            enabled: validFeatures.size > 0,
            features: (0, $b1e0ced2c07ab736$export$d6a5c11f04f75862).map((name)=>({
                    name: name,
                    enabled: validFeatures.has(name)
                }))
        });
    }
    return [
        features,
        setFeatures
    ];
}



const $14bbd07b3011052f$export$919b3065fd27c3a8 = (state)=>{
    const { instances: instances, selectedInstance: selectedInstance } = state.environment;
    return instances.find((instance)=>instance.id === selectedInstance);
};


const $2170e4260f2ec713$export$13bf54ecd231bce8 = (state)=>state.ui;
const $2170e4260f2ec713$export$515382aecc9d69f5 = (state)=>$2170e4260f2ec713$export$13bf54ecd231bce8(state).modals;
const $2170e4260f2ec713$export$557d4f28bb6723de = (state)=>$2170e4260f2ec713$export$13bf54ecd231bce8(state).isDatePickerOpen;
const $2170e4260f2ec713$export$e605959bd7e0f76d = (state)=>$2170e4260f2ec713$export$13bf54ecd231bce8(state).insideAM;
const $2170e4260f2ec713$export$f46e8f1c5be206fd = (state)=>$2170e4260f2ec713$export$13bf54ecd231bce8(state).activeTooltip;
const $2170e4260f2ec713$export$5716401efcc21444 = (state)=>$2170e4260f2ec713$export$13bf54ecd231bce8(state).commandMenuIsOpen;
const $2170e4260f2ec713$export$5ed83947c768e4b3 = (state)=>$2170e4260f2ec713$export$13bf54ecd231bce8(state).navMenuIsOpen;




function $489af8f0cf88bff2$export$d41acecbaf77dfd0() {
    return (0, $1a280fbaa3fcabb5$export$2105062e25df4afe)((0, $2170e4260f2ec713$export$e605959bd7e0f76d));
}



var $2gcPZ = parcelRequire("2gcPZ");
const $ebe4a35e848ce6c2$export$7b6039695cd13aa3 = (textAreaRef, value)=>{
    (0, $2gcPZ.useEffect)(()=>{
        // make sure that textAreaRef exists
        if (textAreaRef) {
            // We need to reset the height first to get the correct scrollHeight for the textarea
            textAreaRef.style.height = "0px";
            const { scrollHeight: scrollHeight, style: style } = textAreaRef;
            // Now we set the height directly
            style.height = `${scrollHeight}px`;
        }
    }, [
        textAreaRef,
        value
    ]);
};



var $2gcPZ = parcelRequire("2gcPZ");


function $583285e3aa4c16bf$export$5cc0dd04debd4b19(color) {
    const theme = (0, $4e8e6ea7d6e48c37$export$93d4e7f90805808f)();
    const shapeListColors = (0, $94aa7f612f0558e6$export$3939eba9bff0c75e)(color);
    // HACK (Oscar): temporary solution for getting the fontAxis values
    // programatically from the theme shorthand.
    const fontAxis = (0, $2gcPZ.useMemo)(()=>{
        const bodyElement = window.getComputedStyle(document.body);
        const removeVariableFunction = /var\((.*?)\)/g;
        const variable = theme.font.body.xs.regular.replace(removeVariableFunction, "$1");
        const variableValue = bodyElement.getPropertyValue(variable);
        const font = variableValue.replace(/["']+/g, "");
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const [axisFontWeight, axisFontSizeMaybeWithSlash, _, axisFontFamily] = font.split(" ").filter((x)=>x !== "/");
        // HACK - In production, the space is stripped from the font declaration, so instead of
        //        "10px / 16px" we get "10px/16px". This is a temporary solution for this issue.
        const axisFontSize = (axisFontSizeMaybeWithSlash ?? "").split("/")[0] ?? undefined;
        return {
            axisFontFamily: axisFontFamily,
            axisFontSize: axisFontSize,
            axisFontWeight: axisFontWeight
        };
    }, [
        theme.font.body.xs.regular
    ]);
    const chartTheme = (0, $2gcPZ.useMemo)(()=>({
            ...fontAxis ? {
                axisFontFamily: fontAxis.axisFontFamily,
                axisFontSize: fontAxis.axisFontSize,
                axisFontWeight: fontAxis.axisFontWeight
            } : {},
            axisColor: theme.color.fg.muted,
            eventColor: color,
            expandableGradientColor: theme.color.bg.default,
            gridStrokeColor: theme.color.border.muted,
            legendItemBorderRadius: theme.radius.default,
            legendItemCheckboxBorderRadius: theme.radius.minimal,
            legendItemCheckboxColor: theme.color.neutral.white,
            legendItemColor: theme.color.fg.muted,
            legendItemEmphasisBackgroundColor: theme.color.bg.hover,
            legendItemEmphasisBorderRadius: theme.radius.default,
            legendItemEmphasisColor: theme.color.fg.default,
            legendItemEmphasisFont: theme.font.body.xs.medium,
            legendItemFont: theme.font.body.sm.regular,
            legendItemOnHoverBackgroundColor: theme.color.bg.subtle,
            legendItemOnHoverColor: theme.color.fg.default,
            shapeListColors: shapeListColors,
            targetLatencyColor: theme.color.fg.success
        }), [
        color,
        fontAxis,
        shapeListColors,
        theme.color.bg.default,
        theme.color.bg.hover,
        theme.color.bg.subtle,
        theme.color.border.muted,
        theme.color.fg.default,
        theme.color.fg.muted,
        theme.color.fg.success,
        theme.color.neutral.white,
        theme.font.body.sm.regular,
        theme.font.body.xs.medium,
        theme.radius.default,
        theme.radius.minimal
    ]);
    return chartTheme;
}



var $2gcPZ = parcelRequire("2gcPZ");
function $cd24a65f0e0ab1ba$export$b2199c37e85de4a7(getText, throttleMs = 3000) {
    const [isCopied, setIsCopied] = (0, $2gcPZ.useState)(false);
    (0, $2gcPZ.useEffect)(()=>{
        let timeout;
        if (isCopied && !timeout) timeout = setTimeout(()=>{
            setIsCopied(false);
        }, throttleMs);
        return ()=>{
            if (timeout) clearTimeout(timeout);
        };
    }, [
        isCopied,
        throttleMs
    ]);
    const handleCopy = (0, $2gcPZ.useCallback)(()=>{
        const text = typeof getText === "string" ? getText : getText();
        navigator.clipboard.writeText(text).then(()=>{
            setIsCopied(true);
        });
    }, [
        getText
    ]);
    return {
        isCopied: isCopied,
        handleCopy: handleCopy
    };
}




var $2gcPZ = parcelRequire("2gcPZ");

function $8812df9dcefbf99d$export$625fd1bac9cc790e(handler) {
    const hasBeenCalled = (0, $2gcPZ.useRef)(false);
    const handlerRef = (0, $2gcPZ.useRef)(handler);
    handlerRef.current = handler;
    return (0, $cac150ebb620e91f$export$d095b0c879743c0d)((...args)=>{
        if (!hasBeenCalled.current) {
            handlerRef.current(...args);
            hasBeenCalled.current = true;
        }
    });
}



var $2gcPZ = parcelRequire("2gcPZ");
function $b983b4c95358e607$export$d0951a301bdf7751(key, handler) {
    (0, $2gcPZ.useEffect)(()=>{
        const onKeyDown = (event)=>{
            if (event.key === key) handler(event);
        };
        document.addEventListener("keydown", onKeyDown);
        return ()=>document.addEventListener("keydown", onKeyDown);
    }, [
        key,
        handler
    ]);
}



var $35ed622046626785$exports = {};
"use strict";
Object.defineProperty($35ed622046626785$exports, "__esModule", {
    value: true
});

var $2gcPZ = parcelRequire("2gcPZ");

var $bBRhx = parcelRequire("bBRhx");
var $35ed622046626785$var$getInitialState = function(query, defaultState) {
    // Prevent a React hydration mismatch when a default value is provided by not defaulting to window.matchMedia(query).matches.
    if (defaultState !== undefined) return defaultState;
    if ($bBRhx.isBrowser) return window.matchMedia(query).matches;
    return false;
};
var $35ed622046626785$var$useMedia = function(query, defaultState) {
    var _a = $2gcPZ.useState($35ed622046626785$var$getInitialState(query, defaultState)), state = _a[0], setState = _a[1];
    $2gcPZ.useEffect(function() {
        var mounted = true;
        var mql = window.matchMedia(query);
        var onChange = function() {
            if (!mounted) return;
            setState(!!mql.matches);
        };
        mql.addListener(onChange);
        setState(mql.matches);
        return function() {
            mounted = false;
            mql.removeListener(onChange);
        };
    }, [
        query
    ]);
    return state;
};
$35ed622046626785$exports.default = $35ed622046626785$var$useMedia;



var $iZCiH = parcelRequire("iZCiH");

const $7e31a202c926b18e$export$426e07cd0772984d = {
    sm: 512,
    md: 768,
    lg: 960,
    xl: 1120
};
const $7e31a202c926b18e$export$987d49ffe1b0900f = Object.fromEntries(Object.entries($7e31a202c926b18e$export$426e07cd0772984d).map(([key, value])=>[
        key,
        (...args)=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      @media (min-width: ${value}px) {
        ${(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)(...args)}
      }
    `
    ]));


/* GENERATED BY FIGMA PLUGIN. PLEASE DO NOT MODIFY */ const $d99ce85cb203a783$export$bca14c5b3b88a9c9 = {
    color: {
        primary: {
            grape: {
                50: "var(--color-primary-grape-50)",
                100: "var(--color-primary-grape-100)",
                200: "var(--color-primary-grape-200)",
                300: "var(--color-primary-grape-300)",
                400: "var(--color-primary-grape-400)",
                500: "var(--color-primary-grape-500)",
                600: "var(--color-primary-grape-600)",
                700: "var(--color-primary-grape-700)",
                800: "var(--color-primary-grape-800)",
                900: "var(--color-primary-grape-900)",
                alpha: {
                    50: "var(--color-primary-grape-alpha-50)",
                    100: "var(--color-primary-grape-alpha-100)",
                    200: "var(--color-primary-grape-alpha-200)",
                    300: "var(--color-primary-grape-alpha-300)",
                    400: "var(--color-primary-grape-alpha-400)"
                }
            }
        },
        neutral: {
            50: "var(--color-neutral-50)",
            100: "var(--color-neutral-100)",
            200: "var(--color-neutral-200)",
            300: "var(--color-neutral-300)",
            400: "var(--color-neutral-400)",
            500: "var(--color-neutral-500)",
            600: "var(--color-neutral-600)",
            700: "var(--color-neutral-700)",
            800: "var(--color-neutral-800)",
            900: "var(--color-neutral-900)",
            white: "var(--color-neutral-white)",
            black: "var(--color-neutral-black)",
            alpha: {
                dark: {
                    100: "var(--color-neutral-alpha-dark-100)",
                    200: "var(--color-neutral-alpha-dark-200)",
                    300: "var(--color-neutral-alpha-dark-300)",
                    400: "var(--color-neutral-alpha-dark-400)"
                },
                light: {
                    100: "var(--color-neutral-alpha-light-100)",
                    200: "var(--color-neutral-alpha-light-200)",
                    300: "var(--color-neutral-alpha-light-300)",
                    400: "var(--color-neutral-alpha-light-400)"
                }
            }
        },
        accent: {
            magenta: {
                100: "var(--color-accent-magenta-100)",
                300: "var(--color-accent-magenta-300)",
                500: "var(--color-accent-magenta-500)",
                700: "var(--color-accent-magenta-700)",
                900: "var(--color-accent-magenta-900)",
                alpha: {
                    100: "var(--color-accent-magenta-alpha-100)",
                    200: "var(--color-accent-magenta-alpha-200)",
                    300: "var(--color-accent-magenta-alpha-300)",
                    400: "var(--color-accent-magenta-alpha-400)"
                }
            },
            mustard: {
                100: "var(--color-accent-mustard-100)",
                300: "var(--color-accent-mustard-300)",
                500: "var(--color-accent-mustard-500)",
                700: "var(--color-accent-mustard-700)",
                900: "var(--color-accent-mustard-900)",
                alpha: {
                    100: "var(--color-accent-mustard-alpha-100)",
                    200: "var(--color-accent-mustard-alpha-200)",
                    300: "var(--color-accent-mustard-alpha-300)",
                    400: "var(--color-accent-mustard-alpha-400)"
                }
            },
            rust: {
                100: "var(--color-accent-rust-100)",
                300: "var(--color-accent-rust-300)",
                500: "var(--color-accent-rust-500)",
                700: "var(--color-accent-rust-700)",
                900: "var(--color-accent-rust-900)",
                alpha: {
                    100: "var(--color-accent-rust-alpha-100)",
                    200: "var(--color-accent-rust-alpha-200)",
                    300: "var(--color-accent-rust-alpha-300)",
                    400: "var(--color-accent-rust-alpha-400)"
                }
            }
        },
        support: {
            danger: {
                50: "var(--color-support-danger-50)",
                100: "var(--color-support-danger-100)",
                200: "var(--color-support-danger-200)",
                300: "var(--color-support-danger-300)",
                400: "var(--color-support-danger-400)",
                500: "var(--color-support-danger-500)",
                600: "var(--color-support-danger-600)",
                700: "var(--color-support-danger-700)",
                800: "var(--color-support-danger-800)",
                900: "var(--color-support-danger-900)",
                alpha: {
                    50: "var(--color-support-danger-alpha-50)",
                    100: "var(--color-support-danger-alpha-100)",
                    200: "var(--color-support-danger-alpha-200)",
                    300: "var(--color-support-danger-alpha-300)",
                    400: "var(--color-support-danger-alpha-400)"
                }
            },
            warning: {
                50: "var(--color-support-warning-50)",
                100: "var(--color-support-warning-100)",
                200: "var(--color-support-warning-200)",
                300: "var(--color-support-warning-300)",
                400: "var(--color-support-warning-400)",
                500: "var(--color-support-warning-500)",
                600: "var(--color-support-warning-600)",
                700: "var(--color-support-warning-700)",
                800: "var(--color-support-warning-800)",
                900: "var(--color-support-warning-900)",
                alpha: {
                    50: "var(--color-support-warning-alpha-50)",
                    100: "var(--color-support-warning-alpha-100)",
                    200: "var(--color-support-warning-alpha-200)",
                    300: "var(--color-support-warning-alpha-300)",
                    400: "var(--color-support-warning-alpha-400)"
                }
            },
            success: {
                50: "var(--color-support-success-50)",
                100: "var(--color-support-success-100)",
                200: "var(--color-support-success-200)",
                300: "var(--color-support-success-300)",
                400: "var(--color-support-success-400)",
                500: "var(--color-support-success-500)",
                600: "var(--color-support-success-600)",
                700: "var(--color-support-success-700)",
                800: "var(--color-support-success-800)",
                900: "var(--color-support-success-900)",
                alpha: {
                    50: "var(--color-support-success-alpha-50)",
                    100: "var(--color-support-success-alpha-100)",
                    200: "var(--color-support-success-alpha-200)",
                    300: "var(--color-support-success-alpha-300)",
                    400: "var(--color-support-success-alpha-400)"
                }
            }
        },
        bg: {
            default: "var(--color-bg-default)",
            subtle: "var(--color-bg-subtle)",
            hover: "var(--color-bg-hover)",
            disabled: "var(--color-bg-disabled)",
            accent: {
                1: "var(--color-bg-accent-1)",
                2: "var(--color-bg-accent-2)",
                3: "var(--color-bg-accent-3)"
            },
            elevated: {
                default: "var(--color-bg-elevated-default)",
                hover: "var(--color-bg-elevated-hover)"
            },
            emphasis: {
                default: "var(--color-bg-emphasis-default)",
                primary: "var(--color-bg-emphasis-primary)",
                "primary-subtle": "var(--color-bg-emphasis-primary-subtle)"
            },
            danger: "var(--color-bg-danger)",
            success: "var(--color-bg-success)",
            warning: "var(--color-bg-warning)"
        },
        fg: {
            default: "var(--color-fg-default)",
            muted: "var(--color-fg-muted)",
            subtle: "var(--color-fg-subtle)",
            primary: "var(--color-fg-primary)",
            accent: {
                1: "var(--color-fg-accent-1)",
                2: "var(--color-fg-accent-2)",
                3: "var(--color-fg-accent-3)"
            },
            onemphasis: {
                default: "var(--color-fg-onemphasis-default)",
                subtle: "var(--color-fg-onemphasis-subtle)"
            },
            danger: "var(--color-fg-danger)",
            success: "var(--color-fg-success)",
            warning: "var(--color-fg-warning)"
        },
        border: {
            default: "var(--color-border-default)",
            muted: "var(--color-border-muted)",
            primary: "var(--color-border-primary)",
            danger: "var(--color-border-danger)",
            success: "var(--color-border-success)",
            warning: "var(--color-border-warning)"
        },
        button: {
            primary: {
                bg: {
                    default: "var(--color-button-primary-bg-default)",
                    hover: "var(--color-button-primary-bg-hover)",
                    disabled: "var(--color-button-primary-bg-disabled)"
                },
                fg: {
                    default: "var(--color-button-primary-fg-default)",
                    disabled: "var(--color-button-primary-fg-disabled)"
                }
            },
            secondary: {
                bg: "var(--color-button-secondary-bg)",
                fg: "var(--color-button-secondary-fg)",
                border: "var(--color-button-secondary-border)"
            }
        },
        input: {
            bg: "var(--color-input-bg)",
            fg: {
                input: "var(--color-input-fg-input)",
                placeholder: "var(--color-input-fg-placeholder)"
            },
            border: "var(--color-input-border)"
        },
        timeline: {
            firing: {
                bg: {
                    default: "var(--color-timeline-firing-bg-default)",
                    hover: "var(--color-timeline-firing-bg-hover)"
                },
                fg: "var(--color-timeline-firing-fg)"
            },
            pending: {
                bg: {
                    default: "var(--color-timeline-pending-bg-default)",
                    hover: "var(--color-timeline-pending-bg-hover)"
                },
                fg: "var(--color-timeline-pending-fg)"
            }
        }
    },
    spacing: {
        none: "var(--spacing-none)",
        xxs: "var(--spacing-xxs)",
        xs: "var(--spacing-xs)",
        s: "var(--spacing-s)",
        md: "var(--spacing-md)",
        lg: "var(--spacing-lg)",
        xl: "var(--spacing-xl)",
        "2xl": "var(--spacing-2xl)",
        "3xl": "var(--spacing-3xl)",
        "4xl": "var(--spacing-4xl)"
    },
    radius: {
        none: "var(--radius-none)",
        minimal: "var(--radius-minimal)",
        default: "var(--radius-default)",
        rounded: "var(--radius-rounded)",
        full: "var(--radius-full)"
    },
    font: {
        headings: {
            h1: "var(--font-headings-h1)",
            h2: "var(--font-headings-h2)",
            h3: "var(--font-headings-h3)",
            h4: "var(--font-headings-h4)",
            h5: "var(--font-headings-h5)",
            h6: "var(--font-headings-h6)"
        },
        body: {
            xl: {
                regular: "var(--font-body-xl-regular)",
                medium: "var(--font-body-xl-medium)"
            },
            l: {
                regular: "var(--font-body-l-regular)",
                medium: "var(--font-body-l-medium)"
            },
            md: {
                regular: "var(--font-body-md-regular)",
                medium: "var(--font-body-md-medium)"
            },
            sm: {
                regular: "var(--font-body-sm-regular)",
                medium: "var(--font-body-sm-medium)"
            },
            xs: {
                regular: "var(--font-body-xs-regular)",
                medium: "var(--font-body-xs-medium)"
            }
        },
        buttons: {
            md: "var(--font-buttons-md)",
            sm: "var(--font-buttons-sm)"
        },
        code: {
            regular: "var(--font-code-regular)",
            medium: "var(--font-code-medium)"
        },
        display: {
            1: "var(--font-display-1)"
        }
    },
    effect: {
        focus: {
            primary: "var(--focus-primary)"
        },
        shadow: {
            xxs: "var(--shadow-xxs)",
            m: "var(--shadow-m)"
        }
    }
};





const $24f4cd4ccc4992cc$export$5458b64234d1333c = {
    page: {
        inline: "var(--spacing-page-inline)",
        block: "var(--spacing-page-block)",
        gap: "var(--spacing-page-gap)"
    },
    content: {
        gap: {
            md: "var(--spacing-content-gap-md)",
            lg: "var(--spacing-content-gap-lg)"
        },
        templateColumns: "var(--spacing-content-template-columns)"
    }
};
const $24f4cd4ccc4992cc$export$b1a942d96bc29e05 = (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)(({ theme: { media: media } })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    --spacing-page-inline: 12px;
    --spacing-page-block: 20px 40px;
    --spacing-page-gap: 24px;
    --spacing-content-gap-md: 12px;
    --spacing-content-gap-lg: 16px;
    --spacing-content-template-columns: 1fr;

    ${media.sm`
      --spacing-page-inline: 20px;
      --spacing-page-block: 40px 80px;
      --spacing-content-template-columns: repeat(2, 1fr);
    `}

    ${media.md`
      --spacing-page-inline: 40px;
      --spacing-page-gap: 32px;
      --spacing-content-gap-md: 16px;
      --spacing-content-gap-lg: 20px;
    `}

    ${media.lg`
      --spacing-content-template-columns: repeat(3, 1fr);
    `}
  `);


const $c3cecdc865a218b8$export$bcfc11ac64052319 = (0, (/*@__PURE__*/$parcel$interopDefault($iZCiH)))((0, $d99ce85cb203a783$export$bca14c5b3b88a9c9), {
    color: {
        bg: {
            placeholder: {
                gradient: "var(--color-bg-placeholder-gradient)"
            }
        }
    },
    radius: {
        full: "9999px"
    },
    media: $7e31a202c926b18e$export$987d49ffe1b0900f,
    spacing: $24f4cd4ccc4992cc$export$5458b64234d1333c
});
const $c3cecdc865a218b8$export$99642afd12435d10 = [
    `--color-bg-placeholder-gradient: linear-gradient(
    90deg,
    ${(0, $d99ce85cb203a783$export$bca14c5b3b88a9c9).color.neutral[100]} 25%,
    ${(0, $d99ce85cb203a783$export$bca14c5b3b88a9c9).color.neutral[200]} 75%,
    ${(0, $d99ce85cb203a783$export$bca14c5b3b88a9c9).color.neutral[100]} 100%
  );`
];
const $c3cecdc865a218b8$export$a4e440f824351334 = [
    `--color-bg-placeholder-gradient: linear-gradient(
    90deg,
    ${(0, $d99ce85cb203a783$export$bca14c5b3b88a9c9).color.neutral[800]} 25%,
    ${(0, $d99ce85cb203a783$export$bca14c5b3b88a9c9).color.neutral[700]} 75%,
    ${(0, $d99ce85cb203a783$export$bca14c5b3b88a9c9).color.neutral[800]} 100%
  );`
];





const $a075cbb4f2871a7e$export$f05794e648629f6c = (0, $4e8e6ea7d6e48c37$export$f0f03736edb61697)(({ theme: { color: color, font: font } })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    :root {
      ${0, $c3cecdc865a218b8$export$99642afd12435d10}
      ${0, $24f4cd4ccc4992cc$export$b1a942d96bc29e05}
    }

    body[data-theme="dark"] {
      ${0, $c3cecdc865a218b8$export$a4e440f824351334}
    }
    body[data-switching="true"] {
      &,
      * {
        transition: all 0.1s ease-in;
      }
    }

    * {
      box-sizing: border-box;
    }

    html,
    body {
      font: ${font.body.md.regular};
      color: ${color.fg.default};
      background-color: ${color.bg.default};
    }

    html,
    body,
    #root {
      height: 100%;
      width: 100%;
    }

    h1 {
      font: ${font.headings.h1};
      margin: 0;
    }

    h2 {
      font: ${font.headings.h2};
      margin: 0;
    }

    h3 {
      font: ${font.headings.h3};
      margin: 0;
    }

    h4 {
      font: ${font.headings.h4};
      margin: 0;
    }

    h5 {
      font: ${font.headings.h5};
      margin: 0;
    }

    h6 {
      font: ${font.headings.h6};
      margin: 0;
    }

    p {
      margin: 0;
    }

    ol {
      list-style-type: decimal;
    }

    ol ol {
      list-style-type: lower-alpha;
    }

    ol ol,
    ul ul {
      margin: 0;
    }

    li {
      margin: 0;
    }

    a {
      color: ${color.fg.primary};
      cursor: pointer;
      text-decoration: none;
    }

    pre,
    code {
      font: ${font.code.regular};
    }
  `);





function $0e947f43bc2b09d1$export$32d5543ab307c01(breakpoint) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($35ed622046626785$exports)))(`(min-width: ${(0, $7e31a202c926b18e$export$426e07cd0772984d)[breakpoint]}px)`);
}


var $fba371f6e5a68b67$exports = {};
"use strict";
Object.defineProperty($fba371f6e5a68b67$exports, "__esModule", {
    value: true
});

var $2gcPZ = parcelRequire("2gcPZ");

var $bBRhx = parcelRequire("bBRhx");
var $fba371f6e5a68b67$var$defaultEvents = [
    "mousedown",
    "touchstart"
];
var $fba371f6e5a68b67$var$useClickAway = function(ref, onClickAway, events) {
    if (events === void 0) events = $fba371f6e5a68b67$var$defaultEvents;
    var savedCallback = $2gcPZ.useRef(onClickAway);
    $2gcPZ.useEffect(function() {
        savedCallback.current = onClickAway;
    }, [
        onClickAway
    ]);
    $2gcPZ.useEffect(function() {
        var handler = function(event) {
            var el = ref.current;
            el && !el.contains(event.target) && savedCallback.current(event);
        };
        for(var _i = 0, events_1 = events; _i < events_1.length; _i++){
            var eventName = events_1[_i];
            $bBRhx.on(document, eventName, handler);
        }
        return function() {
            for(var _i = 0, events_2 = events; _i < events_2.length; _i++){
                var eventName = events_2[_i];
                $bBRhx.off(document, eventName, handler);
            }
        };
    }, [
        events,
        ref
    ]);
};
$fba371f6e5a68b67$exports.default = $fba371f6e5a68b67$var$useClickAway;



var $2gcPZ = parcelRequire("2gcPZ");

function $0adc49931d9164a4$export$80138646353f34b1(containerRef) {
    const [opened, setOpened] = (0, $2gcPZ.useState)(false);
    const modalRef = (0, $2gcPZ.useRef)(null);
    const hide = (0, $cac150ebb620e91f$export$d095b0c879743c0d)((event)=>{
        // Avoid closing if the user clicks on the container.
        if (event.type === "mousedown" && event.target instanceof HTMLElement && containerRef.current?.contains(event.target)) return;
        setOpened(false);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($fba371f6e5a68b67$exports)))(modalRef, hide);
    (0, $b983b4c95358e607$export$d0951a301bdf7751)("Escape", hide);
    return {
        opened: opened,
        setOpened: setOpened,
        modalRef: modalRef
    };
}



var $2gcPZ = parcelRequire("2gcPZ");
function $a736ee5d1177a928$export$5cae361ad82dce8b(value) {
    const ref = (0, $2gcPZ.useRef)();
    (0, $2gcPZ.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}



var $kHUM6 = parcelRequire("kHUM6");
var $bEIGg = parcelRequire("bEIGg");
var $jewWr = parcelRequire("jewWr");
var $ffM0i = parcelRequire("ffM0i");

var $jewWr = parcelRequire("jewWr");
parcelRequire("ffM0i");
var $hWhND = parcelRequire("hWhND");

var $fr0vp = parcelRequire("fr0vp");
var $54649b17feedf59f$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $54649b17feedf59f$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $54649b17feedf59f$var$__defProp = Object.defineProperty;
var $54649b17feedf59f$var$__defProps = Object.defineProperties;
var $54649b17feedf59f$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $54649b17feedf59f$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $54649b17feedf59f$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $54649b17feedf59f$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $54649b17feedf59f$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $54649b17feedf59f$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $54649b17feedf59f$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($54649b17feedf59f$var$__hasOwnProp.call(b, prop)) $54649b17feedf59f$var$__defNormalProp(a, prop, b[prop]);
    if ($54649b17feedf59f$var$__getOwnPropSymbols) for(var _j = 0, _k = $54649b17feedf59f$var$__getOwnPropSymbols(b); _j < _k.length; _j++){
        var prop = _k[_j];
        if ($54649b17feedf59f$var$__propIsEnum.call(b, prop)) $54649b17feedf59f$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $54649b17feedf59f$var$__spreadProps = function(a, b) {
    return $54649b17feedf59f$var$__defProps(a, $54649b17feedf59f$var$__getOwnPropDescs(b));
};
var $54649b17feedf59f$var$__objRest = function(source, exclude) {
    var target = {};
    for(var prop in source)if ($54649b17feedf59f$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $54649b17feedf59f$var$__getOwnPropSymbols) for(var _j = 0, _k = $54649b17feedf59f$var$__getOwnPropSymbols(source); _j < _k.length; _j++){
        var prop = _k[_j];
        if (exclude.indexOf(prop) < 0 && $54649b17feedf59f$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $54649b17feedf59f$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
// src/query/core/apiState.ts
var $54649b17feedf59f$export$f4258b89f6bad1d6;
(function(QueryStatus2) {
    QueryStatus2["uninitialized"] = "uninitialized";
    QueryStatus2["pending"] = "pending";
    QueryStatus2["fulfilled"] = "fulfilled";
    QueryStatus2["rejected"] = "rejected";
})($54649b17feedf59f$export$f4258b89f6bad1d6 || ($54649b17feedf59f$export$f4258b89f6bad1d6 = {}));
function $54649b17feedf59f$var$getRequestStatusFlags(status) {
    return {
        status: status,
        isUninitialized: status === $54649b17feedf59f$export$f4258b89f6bad1d6.uninitialized,
        isLoading: status === $54649b17feedf59f$export$f4258b89f6bad1d6.pending,
        isSuccess: status === $54649b17feedf59f$export$f4258b89f6bad1d6.fulfilled,
        isError: status === $54649b17feedf59f$export$f4258b89f6bad1d6.rejected
    };
}
// src/query/utils/isAbsoluteUrl.ts
function $54649b17feedf59f$var$isAbsoluteUrl(url) {
    return new RegExp("(^|:)//").test(url);
}
// src/query/utils/joinUrls.ts
var $54649b17feedf59f$var$withoutTrailingSlash = function(url) {
    return url.replace(/\/$/, "");
};
var $54649b17feedf59f$var$withoutLeadingSlash = function(url) {
    return url.replace(/^\//, "");
};
function $54649b17feedf59f$var$joinUrls(base, url) {
    if (!base) return url;
    if (!url) return base;
    if ($54649b17feedf59f$var$isAbsoluteUrl(url)) return url;
    var delimiter = base.endsWith("/") || !url.startsWith("?") ? "/" : "";
    base = $54649b17feedf59f$var$withoutTrailingSlash(base);
    url = $54649b17feedf59f$var$withoutLeadingSlash(url);
    return "" + base + delimiter + url;
}
// src/query/utils/flatten.ts
var $54649b17feedf59f$var$flatten = function(arr) {
    return [].concat.apply([], arr);
};
// src/query/utils/isOnline.ts
function $54649b17feedf59f$var$isOnline() {
    return typeof navigator === "undefined" ? true : navigator.onLine === void 0 ? true : navigator.onLine;
}
// src/query/utils/isDocumentVisible.ts
function $54649b17feedf59f$var$isDocumentVisible() {
    if (typeof document === "undefined") return true;
    return document.visibilityState !== "hidden";
}
var $54649b17feedf59f$var$isPlainObject = (0, $bEIGg.isPlainObject);
function $54649b17feedf59f$export$b64d4502a1c929bd(oldObj, newObj) {
    if (oldObj === newObj || !($54649b17feedf59f$var$isPlainObject(oldObj) && $54649b17feedf59f$var$isPlainObject(newObj) || Array.isArray(oldObj) && Array.isArray(newObj))) return newObj;
    var newKeys = Object.keys(newObj);
    var oldKeys = Object.keys(oldObj);
    var isSameObject = newKeys.length === oldKeys.length;
    var mergeObj = Array.isArray(newObj) ? [] : {};
    for(var _j = 0, newKeys_1 = newKeys; _j < newKeys_1.length; _j++){
        var key = newKeys_1[_j];
        mergeObj[key] = $54649b17feedf59f$export$b64d4502a1c929bd(oldObj[key], newObj[key]);
        if (isSameObject) isSameObject = oldObj[key] === mergeObj[key];
    }
    return isSameObject ? oldObj : mergeObj;
}
var $54649b17feedf59f$var$defaultFetchFn = function() {
    var args = [];
    for(var _j = 0; _j < arguments.length; _j++)args[_j] = arguments[_j];
    return fetch.apply(void 0, args);
};
var $54649b17feedf59f$var$defaultValidateStatus = function(response) {
    return response.status >= 200 && response.status <= 299;
};
var $54649b17feedf59f$var$defaultIsJsonContentType = function(headers) {
    return /ion\/(vnd\.api\+)?json/.test(headers.get("content-type") || "");
};
function $54649b17feedf59f$var$stripUndefined(obj) {
    if (!(0, $bEIGg.isPlainObject)(obj)) return obj;
    var copy = $54649b17feedf59f$var$__spreadValues({}, obj);
    for(var _j = 0, _k = Object.entries(copy); _j < _k.length; _j++){
        var _l = _k[_j], k = _l[0], v = _l[1];
        if (v === void 0) delete copy[k];
    }
    return copy;
}
function $54649b17feedf59f$export$adcf4c6133c49b4e(_a) {
    var _this = this;
    if (_a === void 0) _a = {};
    var _b = _a, baseUrl = _b.baseUrl, _j = _b.prepareHeaders, prepareHeaders = _j === void 0 ? function(x) {
        return x;
    } : _j, _k = _b.fetchFn, fetchFn = _k === void 0 ? $54649b17feedf59f$var$defaultFetchFn : _k, paramsSerializer = _b.paramsSerializer, _l = _b.isJsonContentType, isJsonContentType = _l === void 0 ? $54649b17feedf59f$var$defaultIsJsonContentType : _l, _m = _b.jsonContentType, jsonContentType = _m === void 0 ? "application/json" : _m, jsonReplacer = _b.jsonReplacer, defaultTimeout = _b.timeout, globalResponseHandler = _b.responseHandler, globalValidateStatus = _b.validateStatus, baseFetchOptions = $54649b17feedf59f$var$__objRest(_b, [
        "baseUrl",
        "prepareHeaders",
        "fetchFn",
        "paramsSerializer",
        "isJsonContentType",
        "jsonContentType",
        "jsonReplacer",
        "timeout",
        "responseHandler",
        "validateStatus"
    ]);
    if (typeof fetch === "undefined" && fetchFn === $54649b17feedf59f$var$defaultFetchFn) console.warn("Warning: `fetch` is not available. Please supply a custom `fetchFn` property to use `fetchBaseQuery` on SSR environments.");
    return function(arg, api) {
        return $54649b17feedf59f$var$__async(_this, null, function() {
            var signal, getState, extra, endpoint, forced, type, meta, _a2, url, _j, headers, _k, params, _l, responseHandler, _m, validateStatus, _o, timeout, rest, config, _p, isJsonifiable, divider, query, request, requestClone, response, timedOut, timeoutId, e_1, responseClone, resultData, responseText, handleResponseError_1, e_2;
            return $54649b17feedf59f$var$__generator(this, function(_q) {
                switch(_q.label){
                    case 0:
                        signal = api.signal, getState = api.getState, extra = api.extra, endpoint = api.endpoint, forced = api.forced, type = api.type;
                        _a2 = typeof arg == "string" ? {
                            url: arg
                        } : arg, url = _a2.url, _j = _a2.headers, headers = _j === void 0 ? new Headers(baseFetchOptions.headers) : _j, _k = _a2.params, params = _k === void 0 ? void 0 : _k, _l = _a2.responseHandler, responseHandler = _l === void 0 ? globalResponseHandler != null ? globalResponseHandler : "json" : _l, _m = _a2.validateStatus, validateStatus = _m === void 0 ? globalValidateStatus != null ? globalValidateStatus : $54649b17feedf59f$var$defaultValidateStatus : _m, _o = _a2.timeout, timeout = _o === void 0 ? defaultTimeout : _o, rest = $54649b17feedf59f$var$__objRest(_a2, [
                            "url",
                            "headers",
                            "params",
                            "responseHandler",
                            "validateStatus",
                            "timeout"
                        ]);
                        config = $54649b17feedf59f$var$__spreadValues($54649b17feedf59f$var$__spreadProps($54649b17feedf59f$var$__spreadValues({}, baseFetchOptions), {
                            signal: signal
                        }), rest);
                        headers = new Headers($54649b17feedf59f$var$stripUndefined(headers));
                        _p = config;
                        return [
                            4 /*yield*/ ,
                            prepareHeaders(headers, {
                                getState: getState,
                                extra: extra,
                                endpoint: endpoint,
                                forced: forced,
                                type: type
                            })
                        ];
                    case 1:
                        _p.headers = _q.sent() || headers;
                        isJsonifiable = function(body) {
                            return typeof body === "object" && ((0, $bEIGg.isPlainObject)(body) || Array.isArray(body) || typeof body.toJSON === "function");
                        };
                        if (!config.headers.has("content-type") && isJsonifiable(config.body)) config.headers.set("content-type", jsonContentType);
                        if (isJsonifiable(config.body) && isJsonContentType(config.headers)) config.body = JSON.stringify(config.body, jsonReplacer);
                        if (params) {
                            divider = ~url.indexOf("?") ? "&" : "?";
                            query = paramsSerializer ? paramsSerializer(params) : new URLSearchParams($54649b17feedf59f$var$stripUndefined(params));
                            url += divider + query;
                        }
                        url = $54649b17feedf59f$var$joinUrls(baseUrl, url);
                        request = new Request(url, config);
                        requestClone = request.clone();
                        meta = {
                            request: requestClone
                        };
                        timedOut = false, timeoutId = timeout && setTimeout(function() {
                            timedOut = true;
                            api.abort();
                        }, timeout);
                        _q.label = 2;
                    case 2:
                        _q.trys.push([
                            2,
                            4,
                            5,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            fetchFn(request)
                        ];
                    case 3:
                        response = _q.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        e_1 = _q.sent();
                        return [
                            2 /*return*/ ,
                            {
                                error: {
                                    status: timedOut ? "TIMEOUT_ERROR" : "FETCH_ERROR",
                                    error: String(e_1)
                                },
                                meta: meta
                            }
                        ];
                    case 5:
                        if (timeoutId) clearTimeout(timeoutId);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 6:
                        responseClone = response.clone();
                        meta.response = responseClone;
                        responseText = "";
                        _q.label = 7;
                    case 7:
                        _q.trys.push([
                            7,
                            9,
                            ,
                            10
                        ]);
                        return [
                            4 /*yield*/ ,
                            Promise.all([
                                handleResponse(response, responseHandler).then(function(r) {
                                    return resultData = r;
                                }, function(e) {
                                    return handleResponseError_1 = e;
                                }),
                                responseClone.text().then(function(r) {
                                    return responseText = r;
                                }, function() {})
                            ])
                        ];
                    case 8:
                        _q.sent();
                        if (handleResponseError_1) throw handleResponseError_1;
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        e_2 = _q.sent();
                        return [
                            2 /*return*/ ,
                            {
                                error: {
                                    status: "PARSING_ERROR",
                                    originalStatus: response.status,
                                    data: responseText,
                                    error: String(e_2)
                                },
                                meta: meta
                            }
                        ];
                    case 10:
                        return [
                            2 /*return*/ ,
                            validateStatus(response, resultData) ? {
                                data: resultData,
                                meta: meta
                            } : {
                                error: {
                                    status: response.status,
                                    data: resultData
                                },
                                meta: meta
                            }
                        ];
                }
            });
        });
    };
    function handleResponse(response, responseHandler) {
        return $54649b17feedf59f$var$__async(this, null, function() {
            var text;
            return $54649b17feedf59f$var$__generator(this, function(_j) {
                switch(_j.label){
                    case 0:
                        if (typeof responseHandler === "function") return [
                            2 /*return*/ ,
                            responseHandler(response)
                        ];
                        if (responseHandler === "content-type") responseHandler = isJsonContentType(response.headers) ? "json" : "text";
                        if (!(responseHandler === "json")) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            response.text()
                        ];
                    case 1:
                        text = _j.sent();
                        return [
                            2 /*return*/ ,
                            text.length ? JSON.parse(text) : null
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            response.text()
                        ];
                }
            });
        });
    }
}
// src/query/HandledError.ts
var $54649b17feedf59f$var$HandledError = /** @class */ function() {
    function HandledError(value, meta) {
        if (meta === void 0) meta = void 0;
        this.value = value;
        this.meta = meta;
    }
    return HandledError;
}();
// src/query/retry.ts
function $54649b17feedf59f$var$defaultBackoff(attempt, maxRetries) {
    if (attempt === void 0) attempt = 0;
    if (maxRetries === void 0) maxRetries = 5;
    return $54649b17feedf59f$var$__async(this, null, function() {
        var attempts, timeout;
        return $54649b17feedf59f$var$__generator(this, function(_j) {
            switch(_j.label){
                case 0:
                    attempts = Math.min(attempt, maxRetries);
                    timeout = ~~((Math.random() + 0.4) * (300 << attempts));
                    return [
                        4 /*yield*/ ,
                        new Promise(function(resolve) {
                            return setTimeout(function(res) {
                                return resolve(res);
                            }, timeout);
                        })
                    ];
                case 1:
                    _j.sent();
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $54649b17feedf59f$var$fail(e) {
    throw Object.assign(new $54649b17feedf59f$var$HandledError({
        error: e
    }), {
        throwImmediately: true
    });
}
var $54649b17feedf59f$var$EMPTY_OPTIONS = {};
var $54649b17feedf59f$var$retryWithBackoff = function(baseQuery, defaultOptions) {
    return function(args, api, extraOptions) {
        return $54649b17feedf59f$var$__async(void 0, null, function() {
            var possibleMaxRetries, maxRetries, defaultRetryCondition, options, retry2, result, e_3;
            return $54649b17feedf59f$var$__generator(this, function(_j) {
                switch(_j.label){
                    case 0:
                        possibleMaxRetries = [
                            5,
                            (defaultOptions || $54649b17feedf59f$var$EMPTY_OPTIONS).maxRetries,
                            (extraOptions || $54649b17feedf59f$var$EMPTY_OPTIONS).maxRetries
                        ].filter(function(x) {
                            return x !== void 0;
                        });
                        maxRetries = possibleMaxRetries.slice(-1)[0];
                        defaultRetryCondition = function(_, __, _j) {
                            var attempt = _j.attempt;
                            return attempt <= maxRetries;
                        };
                        options = $54649b17feedf59f$var$__spreadValues($54649b17feedf59f$var$__spreadValues({
                            maxRetries: maxRetries,
                            backoff: $54649b17feedf59f$var$defaultBackoff,
                            retryCondition: defaultRetryCondition
                        }, defaultOptions), extraOptions);
                        retry2 = 0;
                        _j.label = 1;
                    case 1:
                        _j.label = 2;
                    case 2:
                        _j.trys.push([
                            2,
                            4,
                            ,
                            6
                        ]);
                        return [
                            4 /*yield*/ ,
                            baseQuery(args, api, extraOptions)
                        ];
                    case 3:
                        result = _j.sent();
                        if (result.error) throw new $54649b17feedf59f$var$HandledError(result);
                        return [
                            2 /*return*/ ,
                            result
                        ];
                    case 4:
                        e_3 = _j.sent();
                        retry2++;
                        if (e_3.throwImmediately) {
                            if (e_3 instanceof $54649b17feedf59f$var$HandledError) return [
                                2 /*return*/ ,
                                e_3.value
                            ];
                            throw e_3;
                        }
                        if (e_3 instanceof $54649b17feedf59f$var$HandledError && !options.retryCondition(e_3.value.error, args, {
                            attempt: retry2,
                            baseQueryApi: api,
                            extraOptions: extraOptions
                        })) return [
                            2 /*return*/ ,
                            e_3.value
                        ];
                        return [
                            4 /*yield*/ ,
                            options.backoff(retry2, options.maxRetries)
                        ];
                    case 5:
                        _j.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 6:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 7:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
};
var $54649b17feedf59f$export$9369b12211e1fce4 = /* @__PURE__ */ Object.assign($54649b17feedf59f$var$retryWithBackoff, {
    fail: $54649b17feedf59f$var$fail
});
var $54649b17feedf59f$var$onFocus = /* @__PURE__ */ (0, $bEIGg.createAction)("__rtkq/focused");
var $54649b17feedf59f$var$onFocusLost = /* @__PURE__ */ (0, $bEIGg.createAction)("__rtkq/unfocused");
var $54649b17feedf59f$var$onOnline = /* @__PURE__ */ (0, $bEIGg.createAction)("__rtkq/online");
var $54649b17feedf59f$var$onOffline = /* @__PURE__ */ (0, $bEIGg.createAction)("__rtkq/offline");
var $54649b17feedf59f$var$initialized = false;
function $54649b17feedf59f$export$120c0dbb0351414c(dispatch, customHandler) {
    function defaultHandler() {
        var handleFocus = function() {
            return dispatch($54649b17feedf59f$var$onFocus());
        };
        var handleFocusLost = function() {
            return dispatch($54649b17feedf59f$var$onFocusLost());
        };
        var handleOnline = function() {
            return dispatch($54649b17feedf59f$var$onOnline());
        };
        var handleOffline = function() {
            return dispatch($54649b17feedf59f$var$onOffline());
        };
        var handleVisibilityChange = function() {
            if (window.document.visibilityState === "visible") handleFocus();
            else handleFocusLost();
        };
        if (!$54649b17feedf59f$var$initialized) {
            if (typeof window !== "undefined" && window.addEventListener) {
                window.addEventListener("visibilitychange", handleVisibilityChange, false);
                window.addEventListener("focus", handleFocus, false);
                window.addEventListener("online", handleOnline, false);
                window.addEventListener("offline", handleOffline, false);
                $54649b17feedf59f$var$initialized = true;
            }
        }
        var unsubscribe = function() {
            window.removeEventListener("focus", handleFocus);
            window.removeEventListener("visibilitychange", handleVisibilityChange);
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
            $54649b17feedf59f$var$initialized = false;
        };
        return unsubscribe;
    }
    return customHandler ? customHandler(dispatch, {
        onFocus: $54649b17feedf59f$var$onFocus,
        onFocusLost: $54649b17feedf59f$var$onFocusLost,
        onOffline: $54649b17feedf59f$var$onOffline,
        onOnline: $54649b17feedf59f$var$onOnline
    }) : defaultHandler();
}
// src/query/endpointDefinitions.ts
var $54649b17feedf59f$var$DefinitionType;
(function(DefinitionType2) {
    DefinitionType2["query"] = "query";
    DefinitionType2["mutation"] = "mutation";
})($54649b17feedf59f$var$DefinitionType || ($54649b17feedf59f$var$DefinitionType = {}));
function $54649b17feedf59f$var$isQueryDefinition(e) {
    return e.type === $54649b17feedf59f$var$DefinitionType.query;
}
function $54649b17feedf59f$var$isMutationDefinition(e) {
    return e.type === $54649b17feedf59f$var$DefinitionType.mutation;
}
function $54649b17feedf59f$var$calculateProvidedBy(description, result, error, queryArg, meta, assertTagTypes) {
    if ($54649b17feedf59f$var$isFunction(description)) return description(result, error, queryArg, meta).map($54649b17feedf59f$var$expandTagDescription).map(assertTagTypes);
    if (Array.isArray(description)) return description.map($54649b17feedf59f$var$expandTagDescription).map(assertTagTypes);
    return [];
}
function $54649b17feedf59f$var$isFunction(t) {
    return typeof t === "function";
}
function $54649b17feedf59f$var$expandTagDescription(description) {
    return typeof description === "string" ? {
        type: description
    } : description;
}
// src/query/utils/isNotNullish.ts
function $54649b17feedf59f$var$isNotNullish(v) {
    return v != null;
}
// src/query/core/buildInitiate.ts
var $54649b17feedf59f$var$forceQueryFnSymbol = Symbol("forceQueryFn");
var $54649b17feedf59f$var$isUpsertQuery = function(arg) {
    return typeof arg[$54649b17feedf59f$var$forceQueryFnSymbol] === "function";
};
function $54649b17feedf59f$var$buildInitiate(_j) {
    var serializeQueryArgs = _j.serializeQueryArgs, queryThunk = _j.queryThunk, mutationThunk = _j.mutationThunk, api = _j.api, context = _j.context;
    var runningQueries = new Map();
    var runningMutations = new Map();
    var _k = api.internalActions, unsubscribeQueryResult = _k.unsubscribeQueryResult, removeMutationResult = _k.removeMutationResult, updateSubscriptionOptions = _k.updateSubscriptionOptions;
    return {
        buildInitiateQuery: buildInitiateQuery,
        buildInitiateMutation: buildInitiateMutation,
        getRunningQueryThunk: getRunningQueryThunk,
        getRunningMutationThunk: getRunningMutationThunk,
        getRunningQueriesThunk: getRunningQueriesThunk,
        getRunningMutationsThunk: getRunningMutationsThunk,
        getRunningOperationPromises: getRunningOperationPromises,
        removalWarning: removalWarning
    };
    function removalWarning() {
        throw new Error("This method had to be removed due to a conceptual bug in RTK.\n       Please see https://github.com/reduxjs/redux-toolkit/pull/2481 for details.\n       See https://redux-toolkit.js.org/rtk-query/usage/server-side-rendering for new guidance on SSR.");
    }
    function getRunningOperationPromises() {
        typeof $fr0vp;
        var extract = function(v) {
            return Array.from(v.values()).flatMap(function(queriesForStore) {
                return queriesForStore ? Object.values(queriesForStore) : [];
            });
        };
        return $54649b17feedf59f$var$__spreadArray($54649b17feedf59f$var$__spreadArray([], extract(runningQueries)), extract(runningMutations)).filter($54649b17feedf59f$var$isNotNullish);
    }
    function getRunningQueryThunk(endpointName, queryArgs) {
        return function(dispatch) {
            var _a;
            var endpointDefinition = context.endpointDefinitions[endpointName];
            var queryCacheKey = serializeQueryArgs({
                queryArgs: queryArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            });
            return (_a = runningQueries.get(dispatch)) == null ? void 0 : _a[queryCacheKey];
        };
    }
    function getRunningMutationThunk(_endpointName, fixedCacheKeyOrRequestId) {
        return function(dispatch) {
            var _a;
            return (_a = runningMutations.get(dispatch)) == null ? void 0 : _a[fixedCacheKeyOrRequestId];
        };
    }
    function getRunningQueriesThunk() {
        return function(dispatch) {
            return Object.values(runningQueries.get(dispatch) || {}).filter($54649b17feedf59f$var$isNotNullish);
        };
    }
    function getRunningMutationsThunk() {
        return function(dispatch) {
            return Object.values(runningMutations.get(dispatch) || {}).filter($54649b17feedf59f$var$isNotNullish);
        };
    }
    function middlewareWarning(dispatch) {
        var registered;
    }
    function buildInitiateQuery(endpointName, endpointDefinition) {
        var queryAction = function(arg, _j) {
            var _k = _j === void 0 ? {} : _j, _l = _k.subscribe, subscribe = _l === void 0 ? true : _l, forceRefetch = _k.forceRefetch, subscriptionOptions = _k.subscriptionOptions, _m = $54649b17feedf59f$var$forceQueryFnSymbol, forceQueryFn = _k[_m];
            return function(dispatch, getState) {
                var _j;
                var _a;
                var queryCacheKey = serializeQueryArgs({
                    queryArgs: arg,
                    endpointDefinition: endpointDefinition,
                    endpointName: endpointName
                });
                var thunk = queryThunk((_j = {
                    type: "query",
                    subscribe: subscribe,
                    forceRefetch: forceRefetch,
                    subscriptionOptions: subscriptionOptions,
                    endpointName: endpointName,
                    originalArgs: arg,
                    queryCacheKey: queryCacheKey
                }, _j[$54649b17feedf59f$var$forceQueryFnSymbol] = forceQueryFn, _j));
                var selector = api.endpoints[endpointName].select(arg);
                var thunkResult = dispatch(thunk);
                var stateAfter = selector(getState());
                middlewareWarning(dispatch);
                var requestId = thunkResult.requestId, abort = thunkResult.abort;
                var skippedSynchronously = stateAfter.requestId !== requestId;
                var runningQuery = (_a = runningQueries.get(dispatch)) == null ? void 0 : _a[queryCacheKey];
                var selectFromState = function() {
                    return selector(getState());
                };
                var statePromise = Object.assign(forceQueryFn ? thunkResult.then(selectFromState) : skippedSynchronously && !runningQuery ? Promise.resolve(stateAfter) : Promise.all([
                    runningQuery,
                    thunkResult
                ]).then(selectFromState), {
                    arg: arg,
                    requestId: requestId,
                    subscriptionOptions: subscriptionOptions,
                    queryCacheKey: queryCacheKey,
                    abort: abort,
                    unwrap: function() {
                        return $54649b17feedf59f$var$__async(this, null, function() {
                            var result;
                            return $54649b17feedf59f$var$__generator(this, function(_j) {
                                switch(_j.label){
                                    case 0:
                                        return [
                                            4 /*yield*/ ,
                                            statePromise
                                        ];
                                    case 1:
                                        result = _j.sent();
                                        if (result.isError) throw result.error;
                                        return [
                                            2 /*return*/ ,
                                            result.data
                                        ];
                                }
                            });
                        });
                    },
                    refetch: function() {
                        return dispatch(queryAction(arg, {
                            subscribe: false,
                            forceRefetch: true
                        }));
                    },
                    unsubscribe: function() {
                        if (subscribe) dispatch(unsubscribeQueryResult({
                            queryCacheKey: queryCacheKey,
                            requestId: requestId
                        }));
                    },
                    updateSubscriptionOptions: function(options) {
                        statePromise.subscriptionOptions = options;
                        dispatch(updateSubscriptionOptions({
                            endpointName: endpointName,
                            requestId: requestId,
                            queryCacheKey: queryCacheKey,
                            options: options
                        }));
                    }
                });
                if (!runningQuery && !skippedSynchronously && !forceQueryFn) {
                    var running_1 = runningQueries.get(dispatch) || {};
                    running_1[queryCacheKey] = statePromise;
                    runningQueries.set(dispatch, running_1);
                    statePromise.then(function() {
                        delete running_1[queryCacheKey];
                        if (!Object.keys(running_1).length) runningQueries.delete(dispatch);
                    });
                }
                return statePromise;
            };
        };
        return queryAction;
    }
    function buildInitiateMutation(endpointName) {
        return function(arg, _j) {
            var _k = _j === void 0 ? {} : _j, _l = _k.track, track = _l === void 0 ? true : _l, fixedCacheKey = _k.fixedCacheKey;
            return function(dispatch, getState) {
                var thunk = mutationThunk({
                    type: "mutation",
                    endpointName: endpointName,
                    originalArgs: arg,
                    track: track,
                    fixedCacheKey: fixedCacheKey
                });
                var thunkResult = dispatch(thunk);
                middlewareWarning(dispatch);
                var requestId = thunkResult.requestId, abort = thunkResult.abort, unwrap = thunkResult.unwrap;
                var returnValuePromise = thunkResult.unwrap().then(function(data) {
                    return {
                        data: data
                    };
                }).catch(function(error) {
                    return {
                        error: error
                    };
                });
                var reset = function() {
                    dispatch(removeMutationResult({
                        requestId: requestId,
                        fixedCacheKey: fixedCacheKey
                    }));
                };
                var ret = Object.assign(returnValuePromise, {
                    arg: thunkResult.arg,
                    requestId: requestId,
                    abort: abort,
                    unwrap: unwrap,
                    unsubscribe: reset,
                    reset: reset
                });
                var running = runningMutations.get(dispatch) || {};
                runningMutations.set(dispatch, running);
                running[requestId] = ret;
                ret.then(function() {
                    delete running[requestId];
                    if (!Object.keys(running).length) runningMutations.delete(dispatch);
                });
                if (fixedCacheKey) {
                    running[fixedCacheKey] = ret;
                    ret.then(function() {
                        if (running[fixedCacheKey] === ret) {
                            delete running[fixedCacheKey];
                            if (!Object.keys(running).length) runningMutations.delete(dispatch);
                        }
                    });
                }
                return ret;
            };
        };
    }
}
function $54649b17feedf59f$var$defaultTransformResponse(baseQueryReturnValue) {
    return baseQueryReturnValue;
}
function $54649b17feedf59f$var$buildThunks(_j) {
    var _this = this;
    var reducerPath = _j.reducerPath, baseQuery = _j.baseQuery, endpointDefinitions = _j.context.endpointDefinitions, serializeQueryArgs = _j.serializeQueryArgs, api = _j.api;
    var patchQueryData = function(endpointName, args, patches) {
        return function(dispatch) {
            var endpointDefinition = endpointDefinitions[endpointName];
            dispatch(api.internalActions.queryResultPatched({
                queryCacheKey: serializeQueryArgs({
                    queryArgs: args,
                    endpointDefinition: endpointDefinition,
                    endpointName: endpointName
                }),
                patches: patches
            }));
        };
    };
    var updateQueryData = function(endpointName, args, updateRecipe) {
        return function(dispatch, getState) {
            var _j, _k;
            var currentState = api.endpoints[endpointName].select(args)(getState());
            var ret = {
                patches: [],
                inversePatches: [],
                undo: function() {
                    return dispatch(api.util.patchQueryData(endpointName, args, ret.inversePatches));
                }
            };
            if (currentState.status === $54649b17feedf59f$export$f4258b89f6bad1d6.uninitialized) return ret;
            if ("data" in currentState) {
                if ((0, $jewWr.isDraftable)(currentState.data)) {
                    var _l = (0, $jewWr.produceWithPatches)(currentState.data, updateRecipe), patches = _l[1], inversePatches = _l[2];
                    (_j = ret.patches).push.apply(_j, patches);
                    (_k = ret.inversePatches).push.apply(_k, inversePatches);
                } else {
                    var value = updateRecipe(currentState.data);
                    ret.patches.push({
                        op: "replace",
                        path: [],
                        value: value
                    });
                    ret.inversePatches.push({
                        op: "replace",
                        path: [],
                        value: currentState.data
                    });
                }
            }
            dispatch(api.util.patchQueryData(endpointName, args, ret.patches));
            return ret;
        };
    };
    var upsertQueryData = function(endpointName, args, value) {
        return function(dispatch) {
            var _j;
            return dispatch(api.endpoints[endpointName].initiate(args, (_j = {
                subscribe: false,
                forceRefetch: true
            }, _j[$54649b17feedf59f$var$forceQueryFnSymbol] = function() {
                return {
                    data: value
                };
            }, _j)));
        };
    };
    var executeEndpoint = function(_0, _1) {
        return $54649b17feedf59f$var$__async(_this, [
            _0,
            _1
        ], function(arg, _j) {
            var endpointDefinition, transformResponse, result, baseQueryApi_1, forceQueryFn, what, err, _k, _l, key, _m, error_1, catchedError, transformErrorResponse, _o, e_4;
            var _p, _q;
            var signal = _j.signal, abort = _j.abort, rejectWithValue = _j.rejectWithValue, fulfillWithValue = _j.fulfillWithValue, dispatch = _j.dispatch, getState = _j.getState, extra = _j.extra;
            return $54649b17feedf59f$var$__generator(this, function(_r) {
                switch(_r.label){
                    case 0:
                        endpointDefinition = endpointDefinitions[arg.endpointName];
                        _r.label = 1;
                    case 1:
                        _r.trys.push([
                            1,
                            8,
                            ,
                            13
                        ]);
                        transformResponse = $54649b17feedf59f$var$defaultTransformResponse;
                        result = void 0;
                        baseQueryApi_1 = {
                            signal: signal,
                            abort: abort,
                            dispatch: dispatch,
                            getState: getState,
                            extra: extra,
                            endpoint: arg.endpointName,
                            type: arg.type,
                            forced: arg.type === "query" ? isForcedQuery(arg, getState()) : void 0
                        };
                        forceQueryFn = arg.type === "query" ? arg[$54649b17feedf59f$var$forceQueryFnSymbol] : void 0;
                        if (!forceQueryFn) return [
                            3 /*break*/ ,
                            2
                        ];
                        result = forceQueryFn();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 2:
                        if (!endpointDefinition.query) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            baseQuery(endpointDefinition.query(arg.originalArgs), baseQueryApi_1, endpointDefinition.extraOptions)
                        ];
                    case 3:
                        result = _r.sent();
                        if (endpointDefinition.transformResponse) transformResponse = endpointDefinition.transformResponse;
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            endpointDefinition.queryFn(arg.originalArgs, baseQueryApi_1, endpointDefinition.extraOptions, function(arg2) {
                                return baseQuery(arg2, baseQueryApi_1, endpointDefinition.extraOptions);
                            })
                        ];
                    case 5:
                        result = _r.sent();
                        _r.label = 6;
                    case 6:
                        typeof $fr0vp;
                        if (result.error) throw new $54649b17feedf59f$var$HandledError(result.error, result.meta);
                        _m = fulfillWithValue;
                        return [
                            4 /*yield*/ ,
                            transformResponse(result.data, result.meta, arg.originalArgs)
                        ];
                    case 7:
                        return [
                            2 /*return*/ ,
                            _m.apply(void 0, [
                                _r.sent(),
                                (_p = {
                                    fulfilledTimeStamp: Date.now(),
                                    baseQueryMeta: result.meta
                                }, _p[0, $bEIGg.SHOULD_AUTOBATCH] = true, _p)
                            ])
                        ];
                    case 8:
                        error_1 = _r.sent();
                        catchedError = error_1;
                        if (!(catchedError instanceof $54649b17feedf59f$var$HandledError)) return [
                            3 /*break*/ ,
                            12
                        ];
                        transformErrorResponse = $54649b17feedf59f$var$defaultTransformResponse;
                        if (endpointDefinition.query && endpointDefinition.transformErrorResponse) transformErrorResponse = endpointDefinition.transformErrorResponse;
                        _r.label = 9;
                    case 9:
                        _r.trys.push([
                            9,
                            11,
                            ,
                            12
                        ]);
                        _o = rejectWithValue;
                        return [
                            4 /*yield*/ ,
                            transformErrorResponse(catchedError.value, catchedError.meta, arg.originalArgs)
                        ];
                    case 10:
                        return [
                            2 /*return*/ ,
                            _o.apply(void 0, [
                                _r.sent(),
                                (_q = {
                                    baseQueryMeta: catchedError.meta
                                }, _q[0, $bEIGg.SHOULD_AUTOBATCH] = true, _q)
                            ])
                        ];
                    case 11:
                        e_4 = _r.sent();
                        catchedError = e_4;
                        return [
                            3 /*break*/ ,
                            12
                        ];
                    case 12:
                        typeof $fr0vp;
                        console.error(catchedError);
                        throw catchedError;
                    case 13:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    function isForcedQuery(arg, state) {
        var _a, _b, _c, _d;
        var requestState = (_b = (_a = state[reducerPath]) == null ? void 0 : _a.queries) == null ? void 0 : _b[arg.queryCacheKey];
        var baseFetchOnMountOrArgChange = (_c = state[reducerPath]) == null ? void 0 : _c.config.refetchOnMountOrArgChange;
        var fulfilledVal = requestState == null ? void 0 : requestState.fulfilledTimeStamp;
        var refetchVal = (_d = arg.forceRefetch) != null ? _d : arg.subscribe && baseFetchOnMountOrArgChange;
        if (refetchVal) return refetchVal === true || (Number(new Date()) - Number(fulfilledVal)) / 1e3 >= refetchVal;
        return false;
    }
    var queryThunk = (0, $bEIGg.createAsyncThunk)(reducerPath + "/executeQuery", executeEndpoint, {
        getPendingMeta: function() {
            var _j;
            return _j = {
                startedTimeStamp: Date.now()
            }, _j[0, $bEIGg.SHOULD_AUTOBATCH] = true, _j;
        },
        condition: function(queryThunkArgs, _j) {
            var getState = _j.getState;
            var _a, _b, _c;
            var state = getState();
            var requestState = (_b = (_a = state[reducerPath]) == null ? void 0 : _a.queries) == null ? void 0 : _b[queryThunkArgs.queryCacheKey];
            var fulfilledVal = requestState == null ? void 0 : requestState.fulfilledTimeStamp;
            var currentArg = queryThunkArgs.originalArgs;
            var previousArg = requestState == null ? void 0 : requestState.originalArgs;
            var endpointDefinition = endpointDefinitions[queryThunkArgs.endpointName];
            if ($54649b17feedf59f$var$isUpsertQuery(queryThunkArgs)) return true;
            if ((requestState == null ? void 0 : requestState.status) === "pending") return false;
            if (isForcedQuery(queryThunkArgs, state)) return true;
            if ($54649b17feedf59f$var$isQueryDefinition(endpointDefinition) && ((_c = endpointDefinition == null ? void 0 : endpointDefinition.forceRefetch) == null ? void 0 : _c.call(endpointDefinition, {
                currentArg: currentArg,
                previousArg: previousArg,
                endpointState: requestState,
                state: state
            }))) return true;
            if (fulfilledVal) return false;
            return true;
        },
        dispatchConditionRejection: true
    });
    var mutationThunk = (0, $bEIGg.createAsyncThunk)(reducerPath + "/executeMutation", executeEndpoint, {
        getPendingMeta: function() {
            var _j;
            return _j = {
                startedTimeStamp: Date.now()
            }, _j[0, $bEIGg.SHOULD_AUTOBATCH] = true, _j;
        }
    });
    var hasTheForce = function(options) {
        return "force" in options;
    };
    var hasMaxAge = function(options) {
        return "ifOlderThan" in options;
    };
    var prefetch = function(endpointName, arg, options) {
        return function(dispatch, getState) {
            var force = hasTheForce(options) && options.force;
            var maxAge = hasMaxAge(options) && options.ifOlderThan;
            var queryAction = function(force2) {
                if (force2 === void 0) force2 = true;
                return api.endpoints[endpointName].initiate(arg, {
                    forceRefetch: force2
                });
            };
            var latestStateValue = api.endpoints[endpointName].select(arg)(getState());
            if (force) dispatch(queryAction());
            else if (maxAge) {
                var lastFulfilledTs = latestStateValue == null ? void 0 : latestStateValue.fulfilledTimeStamp;
                if (!lastFulfilledTs) {
                    dispatch(queryAction());
                    return;
                }
                var shouldRetrigger = (Number(new Date()) - Number(new Date(lastFulfilledTs))) / 1e3 >= maxAge;
                if (shouldRetrigger) dispatch(queryAction());
            } else dispatch(queryAction(false));
        };
    };
    function matchesEndpoint(endpointName) {
        return function(action) {
            var _a, _b;
            return ((_b = (_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.arg) == null ? void 0 : _b.endpointName) === endpointName;
        };
    }
    function buildMatchThunkActions(thunk, endpointName) {
        return {
            matchPending: (0, $bEIGg.isAllOf)((0, $bEIGg.isPending)(thunk), matchesEndpoint(endpointName)),
            matchFulfilled: (0, $bEIGg.isAllOf)((0, $bEIGg.isFulfilled)(thunk), matchesEndpoint(endpointName)),
            matchRejected: (0, $bEIGg.isAllOf)((0, $bEIGg.isRejected)(thunk), matchesEndpoint(endpointName))
        };
    }
    return {
        queryThunk: queryThunk,
        mutationThunk: mutationThunk,
        prefetch: prefetch,
        updateQueryData: updateQueryData,
        upsertQueryData: upsertQueryData,
        patchQueryData: patchQueryData,
        buildMatchThunkActions: buildMatchThunkActions
    };
}
function $54649b17feedf59f$var$calculateProvidedByThunk(action, type, endpointDefinitions, assertTagType) {
    return $54649b17feedf59f$var$calculateProvidedBy(endpointDefinitions[action.meta.arg.endpointName][type], (0, $bEIGg.isFulfilled)(action) ? action.payload : void 0, (0, $bEIGg.isRejectedWithValue)(action) ? action.payload : void 0, action.meta.arg.originalArgs, "baseQueryMeta" in action.meta ? action.meta.baseQueryMeta : void 0, assertTagType);
}
function $54649b17feedf59f$var$updateQuerySubstateIfExists(state, queryCacheKey, update) {
    var substate = state[queryCacheKey];
    if (substate) update(substate);
}
function $54649b17feedf59f$var$getMutationCacheKey(id) {
    var _a;
    return (_a = "arg" in id ? id.arg.fixedCacheKey : id.fixedCacheKey) != null ? _a : id.requestId;
}
function $54649b17feedf59f$var$updateMutationSubstateIfExists(state, id, update) {
    var substate = state[$54649b17feedf59f$var$getMutationCacheKey(id)];
    if (substate) update(substate);
}
var $54649b17feedf59f$var$initialState = {};
function $54649b17feedf59f$var$buildSlice(_j) {
    var reducerPath = _j.reducerPath, queryThunk = _j.queryThunk, mutationThunk = _j.mutationThunk, _k = _j.context, definitions = _k.endpointDefinitions, apiUid = _k.apiUid, extractRehydrationInfo = _k.extractRehydrationInfo, hasRehydrationInfo = _k.hasRehydrationInfo, assertTagType = _j.assertTagType, config = _j.config;
    var resetApiState = (0, $bEIGg.createAction)(reducerPath + "/resetApiState");
    var querySlice = (0, $bEIGg.createSlice)({
        name: reducerPath + "/queries",
        initialState: $54649b17feedf59f$var$initialState,
        reducers: {
            removeQueryResult: {
                reducer: function(draft, _j) {
                    var queryCacheKey = _j.payload.queryCacheKey;
                    delete draft[queryCacheKey];
                },
                prepare: (0, $bEIGg.prepareAutoBatched)()
            },
            queryResultPatched: function(draft, _j) {
                var _k = _j.payload, queryCacheKey = _k.queryCacheKey, patches = _k.patches;
                $54649b17feedf59f$var$updateQuerySubstateIfExists(draft, queryCacheKey, function(substate) {
                    substate.data = (0, $jewWr.applyPatches)(substate.data, patches.concat());
                });
            }
        },
        extraReducers: function(builder) {
            builder.addCase(queryThunk.pending, function(draft, _j) {
                var meta = _j.meta, arg = _j.meta.arg;
                var _a, _b;
                var upserting = $54649b17feedf59f$var$isUpsertQuery(arg);
                if (arg.subscribe || upserting) (_b = draft[_a = arg.queryCacheKey]) != null ? _b : draft[_a] = {
                    status: $54649b17feedf59f$export$f4258b89f6bad1d6.uninitialized,
                    endpointName: arg.endpointName
                };
                $54649b17feedf59f$var$updateQuerySubstateIfExists(draft, arg.queryCacheKey, function(substate) {
                    substate.status = $54649b17feedf59f$export$f4258b89f6bad1d6.pending;
                    substate.requestId = upserting && substate.requestId ? substate.requestId : meta.requestId;
                    if (arg.originalArgs !== void 0) substate.originalArgs = arg.originalArgs;
                    substate.startedTimeStamp = meta.startedTimeStamp;
                });
            }).addCase(queryThunk.fulfilled, function(draft, _j) {
                var meta = _j.meta, payload = _j.payload;
                $54649b17feedf59f$var$updateQuerySubstateIfExists(draft, meta.arg.queryCacheKey, function(substate) {
                    var _a;
                    if (substate.requestId !== meta.requestId && !$54649b17feedf59f$var$isUpsertQuery(meta.arg)) return;
                    var merge = definitions[meta.arg.endpointName].merge;
                    substate.status = $54649b17feedf59f$export$f4258b89f6bad1d6.fulfilled;
                    if (merge) {
                        if (substate.data !== void 0) {
                            var fulfilledTimeStamp_1 = meta.fulfilledTimeStamp, arg_1 = meta.arg, baseQueryMeta_1 = meta.baseQueryMeta, requestId_1 = meta.requestId;
                            var newData = (0, $jewWr.default)(substate.data, function(draftSubstateData) {
                                return merge(draftSubstateData, payload, {
                                    arg: arg_1.originalArgs,
                                    baseQueryMeta: baseQueryMeta_1,
                                    fulfilledTimeStamp: fulfilledTimeStamp_1,
                                    requestId: requestId_1
                                });
                            });
                            substate.data = newData;
                        } else substate.data = payload;
                    } else substate.data = ((_a = definitions[meta.arg.endpointName].structuralSharing) != null ? _a : true) ? $54649b17feedf59f$export$b64d4502a1c929bd((0, $jewWr.isDraft)(substate.data) ? (0, $jewWr.original)(substate.data) : substate.data, payload) : payload;
                    delete substate.error;
                    substate.fulfilledTimeStamp = meta.fulfilledTimeStamp;
                });
            }).addCase(queryThunk.rejected, function(draft, _j) {
                var _k = _j.meta, condition = _k.condition, arg = _k.arg, requestId = _k.requestId, error = _j.error, payload = _j.payload;
                $54649b17feedf59f$var$updateQuerySubstateIfExists(draft, arg.queryCacheKey, function(substate) {
                    if (condition) ;
                    else {
                        if (substate.requestId !== requestId) return;
                        substate.status = $54649b17feedf59f$export$f4258b89f6bad1d6.rejected;
                        substate.error = payload != null ? payload : error;
                    }
                });
            }).addMatcher(hasRehydrationInfo, function(draft, action) {
                var queries = extractRehydrationInfo(action).queries;
                for(var _j = 0, _k = Object.entries(queries); _j < _k.length; _j++){
                    var _l = _k[_j], key = _l[0], entry = _l[1];
                    if ((entry == null ? void 0 : entry.status) === $54649b17feedf59f$export$f4258b89f6bad1d6.fulfilled || (entry == null ? void 0 : entry.status) === $54649b17feedf59f$export$f4258b89f6bad1d6.rejected) draft[key] = entry;
                }
            });
        }
    });
    var mutationSlice = (0, $bEIGg.createSlice)({
        name: reducerPath + "/mutations",
        initialState: $54649b17feedf59f$var$initialState,
        reducers: {
            removeMutationResult: {
                reducer: function(draft, _j) {
                    var payload = _j.payload;
                    var cacheKey = $54649b17feedf59f$var$getMutationCacheKey(payload);
                    if (cacheKey in draft) delete draft[cacheKey];
                },
                prepare: (0, $bEIGg.prepareAutoBatched)()
            }
        },
        extraReducers: function(builder) {
            builder.addCase(mutationThunk.pending, function(draft, _j) {
                var meta = _j.meta, _k = _j.meta, requestId = _k.requestId, arg = _k.arg, startedTimeStamp = _k.startedTimeStamp;
                if (!arg.track) return;
                draft[$54649b17feedf59f$var$getMutationCacheKey(meta)] = {
                    requestId: requestId,
                    status: $54649b17feedf59f$export$f4258b89f6bad1d6.pending,
                    endpointName: arg.endpointName,
                    startedTimeStamp: startedTimeStamp
                };
            }).addCase(mutationThunk.fulfilled, function(draft, _j) {
                var payload = _j.payload, meta = _j.meta;
                if (!meta.arg.track) return;
                $54649b17feedf59f$var$updateMutationSubstateIfExists(draft, meta, function(substate) {
                    if (substate.requestId !== meta.requestId) return;
                    substate.status = $54649b17feedf59f$export$f4258b89f6bad1d6.fulfilled;
                    substate.data = payload;
                    substate.fulfilledTimeStamp = meta.fulfilledTimeStamp;
                });
            }).addCase(mutationThunk.rejected, function(draft, _j) {
                var payload = _j.payload, error = _j.error, meta = _j.meta;
                if (!meta.arg.track) return;
                $54649b17feedf59f$var$updateMutationSubstateIfExists(draft, meta, function(substate) {
                    if (substate.requestId !== meta.requestId) return;
                    substate.status = $54649b17feedf59f$export$f4258b89f6bad1d6.rejected;
                    substate.error = payload != null ? payload : error;
                });
            }).addMatcher(hasRehydrationInfo, function(draft, action) {
                var mutations = extractRehydrationInfo(action).mutations;
                for(var _j = 0, _k = Object.entries(mutations); _j < _k.length; _j++){
                    var _l = _k[_j], key = _l[0], entry = _l[1];
                    if (((entry == null ? void 0 : entry.status) === $54649b17feedf59f$export$f4258b89f6bad1d6.fulfilled || (entry == null ? void 0 : entry.status) === $54649b17feedf59f$export$f4258b89f6bad1d6.rejected) && key !== (entry == null ? void 0 : entry.requestId)) draft[key] = entry;
                }
            });
        }
    });
    var invalidationSlice = (0, $bEIGg.createSlice)({
        name: reducerPath + "/invalidation",
        initialState: $54649b17feedf59f$var$initialState,
        reducers: {},
        extraReducers: function(builder) {
            builder.addCase(querySlice.actions.removeQueryResult, function(draft, _j) {
                var queryCacheKey = _j.payload.queryCacheKey;
                for(var _k = 0, _l = Object.values(draft); _k < _l.length; _k++){
                    var tagTypeSubscriptions = _l[_k];
                    for(var _m = 0, _o = Object.values(tagTypeSubscriptions); _m < _o.length; _m++){
                        var idSubscriptions = _o[_m];
                        var foundAt = idSubscriptions.indexOf(queryCacheKey);
                        if (foundAt !== -1) idSubscriptions.splice(foundAt, 1);
                    }
                }
            }).addMatcher(hasRehydrationInfo, function(draft, action) {
                var _a, _b, _c, _d;
                var provided = extractRehydrationInfo(action).provided;
                for(var _j = 0, _k = Object.entries(provided); _j < _k.length; _j++){
                    var _l = _k[_j], type = _l[0], incomingTags = _l[1];
                    for(var _m = 0, _o = Object.entries(incomingTags); _m < _o.length; _m++){
                        var _p = _o[_m], id = _p[0], cacheKeys = _p[1];
                        var subscribedQueries = (_d = (_b = (_a = draft[type]) != null ? _a : draft[type] = {})[_c = id || "__internal_without_id"]) != null ? _d : _b[_c] = [];
                        for(var _q = 0, cacheKeys_1 = cacheKeys; _q < cacheKeys_1.length; _q++){
                            var queryCacheKey = cacheKeys_1[_q];
                            var alreadySubscribed = subscribedQueries.includes(queryCacheKey);
                            if (!alreadySubscribed) subscribedQueries.push(queryCacheKey);
                        }
                    }
                }
            }).addMatcher((0, $bEIGg.isAnyOf)((0, $bEIGg.isFulfilled)(queryThunk), (0, $bEIGg.isRejectedWithValue)(queryThunk)), function(draft, action) {
                var _a, _b, _c, _d;
                var providedTags = $54649b17feedf59f$var$calculateProvidedByThunk(action, "providesTags", definitions, assertTagType);
                var queryCacheKey = action.meta.arg.queryCacheKey;
                for(var _j = 0, _k = Object.values(draft); _j < _k.length; _j++){
                    var tagTypeSubscriptions = _k[_j];
                    for(var _l = 0, _m = Object.values(tagTypeSubscriptions); _l < _m.length; _l++){
                        var idSubscriptions = _m[_l];
                        var foundAt = idSubscriptions.indexOf(queryCacheKey);
                        if (foundAt !== -1) idSubscriptions.splice(foundAt, 1);
                    }
                }
                for(var _o = 0, providedTags_1 = providedTags; _o < providedTags_1.length; _o++){
                    var _p = providedTags_1[_o], type = _p.type, id = _p.id;
                    var subscribedQueries = (_d = (_b = (_a = draft[type]) != null ? _a : draft[type] = {})[_c = id || "__internal_without_id"]) != null ? _d : _b[_c] = [];
                    var alreadySubscribed = subscribedQueries.includes(queryCacheKey);
                    if (!alreadySubscribed) subscribedQueries.push(queryCacheKey);
                }
            });
        }
    });
    var subscriptionSlice = (0, $bEIGg.createSlice)({
        name: reducerPath + "/subscriptions",
        initialState: $54649b17feedf59f$var$initialState,
        reducers: {
            updateSubscriptionOptions: function(d, a) {},
            unsubscribeQueryResult: function(d, a) {},
            internal_probeSubscription: function(d, a) {}
        }
    });
    var internalSubscriptionsSlice = (0, $bEIGg.createSlice)({
        name: reducerPath + "/internalSubscriptions",
        initialState: $54649b17feedf59f$var$initialState,
        reducers: {
            subscriptionsUpdated: {
                reducer: function(state, action) {
                    return (0, $jewWr.applyPatches)(state, action.payload);
                },
                prepare: (0, $bEIGg.prepareAutoBatched)()
            }
        }
    });
    var configSlice = (0, $bEIGg.createSlice)({
        name: reducerPath + "/config",
        initialState: $54649b17feedf59f$var$__spreadValues({
            online: $54649b17feedf59f$var$isOnline(),
            focused: $54649b17feedf59f$var$isDocumentVisible(),
            middlewareRegistered: false
        }, config),
        reducers: {
            middlewareRegistered: function(state, _j) {
                var payload = _j.payload;
                state.middlewareRegistered = state.middlewareRegistered === "conflict" || apiUid !== payload ? "conflict" : true;
            }
        },
        extraReducers: function(builder) {
            builder.addCase($54649b17feedf59f$var$onOnline, function(state) {
                state.online = true;
            }).addCase($54649b17feedf59f$var$onOffline, function(state) {
                state.online = false;
            }).addCase($54649b17feedf59f$var$onFocus, function(state) {
                state.focused = true;
            }).addCase($54649b17feedf59f$var$onFocusLost, function(state) {
                state.focused = false;
            }).addMatcher(hasRehydrationInfo, function(draft) {
                return $54649b17feedf59f$var$__spreadValues({}, draft);
            });
        }
    });
    var combinedReducer = (0, $kHUM6.combineReducers)({
        queries: querySlice.reducer,
        mutations: mutationSlice.reducer,
        provided: invalidationSlice.reducer,
        subscriptions: internalSubscriptionsSlice.reducer,
        config: configSlice.reducer
    });
    var reducer = function(state, action) {
        return combinedReducer(resetApiState.match(action) ? void 0 : state, action);
    };
    var actions = $54649b17feedf59f$var$__spreadProps($54649b17feedf59f$var$__spreadValues($54649b17feedf59f$var$__spreadValues($54649b17feedf59f$var$__spreadValues($54649b17feedf59f$var$__spreadValues($54649b17feedf59f$var$__spreadValues({}, configSlice.actions), querySlice.actions), subscriptionSlice.actions), internalSubscriptionsSlice.actions), mutationSlice.actions), {
        unsubscribeMutationResult: mutationSlice.actions.removeMutationResult,
        resetApiState: resetApiState
    });
    return {
        reducer: reducer,
        actions: actions
    };
}
// src/query/core/buildSelectors.ts
var $54649b17feedf59f$export$1aa5a89531b7670d = /* @__PURE__ */ Symbol.for("RTKQ/skipToken");
var $54649b17feedf59f$export$8b2f5cccb7eda71d = $54649b17feedf59f$export$1aa5a89531b7670d;
var $54649b17feedf59f$var$initialSubState = {
    status: $54649b17feedf59f$export$f4258b89f6bad1d6.uninitialized
};
var $54649b17feedf59f$var$defaultQuerySubState = /* @__PURE__ */ (0, $jewWr.default)($54649b17feedf59f$var$initialSubState, function() {});
var $54649b17feedf59f$var$defaultMutationSubState = /* @__PURE__ */ (0, $jewWr.default)($54649b17feedf59f$var$initialSubState, function() {});
function $54649b17feedf59f$var$buildSelectors(_j) {
    var serializeQueryArgs = _j.serializeQueryArgs, reducerPath = _j.reducerPath;
    var selectSkippedQuery = function(state) {
        return $54649b17feedf59f$var$defaultQuerySubState;
    };
    var selectSkippedMutation = function(state) {
        return $54649b17feedf59f$var$defaultMutationSubState;
    };
    return {
        buildQuerySelector: buildQuerySelector,
        buildMutationSelector: buildMutationSelector,
        selectInvalidatedBy: selectInvalidatedBy
    };
    function withRequestFlags(substate) {
        return $54649b17feedf59f$var$__spreadValues($54649b17feedf59f$var$__spreadValues({}, substate), $54649b17feedf59f$var$getRequestStatusFlags(substate.status));
    }
    function selectInternalState(rootState) {
        var state = rootState[reducerPath];
        return state;
    }
    function buildQuerySelector(endpointName, endpointDefinition) {
        return function(queryArgs) {
            var serializedArgs = serializeQueryArgs({
                queryArgs: queryArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            });
            var selectQuerySubstate = function(state) {
                var _a, _b, _c;
                return (_c = (_b = (_a = selectInternalState(state)) == null ? void 0 : _a.queries) == null ? void 0 : _b[serializedArgs]) != null ? _c : $54649b17feedf59f$var$defaultQuerySubState;
            };
            var finalSelectQuerySubState = queryArgs === $54649b17feedf59f$export$1aa5a89531b7670d ? selectSkippedQuery : selectQuerySubstate;
            return (0, $ffM0i.createSelector)(finalSelectQuerySubState, withRequestFlags);
        };
    }
    function buildMutationSelector() {
        return function(id) {
            var _a;
            var mutationId;
            if (typeof id === "object") mutationId = (_a = $54649b17feedf59f$var$getMutationCacheKey(id)) != null ? _a : $54649b17feedf59f$export$1aa5a89531b7670d;
            else mutationId = id;
            var selectMutationSubstate = function(state) {
                var _a2, _b, _c;
                return (_c = (_b = (_a2 = selectInternalState(state)) == null ? void 0 : _a2.mutations) == null ? void 0 : _b[mutationId]) != null ? _c : $54649b17feedf59f$var$defaultMutationSubState;
            };
            var finalSelectMutationSubstate = mutationId === $54649b17feedf59f$export$1aa5a89531b7670d ? selectSkippedMutation : selectMutationSubstate;
            return (0, $ffM0i.createSelector)(finalSelectMutationSubstate, withRequestFlags);
        };
    }
    function selectInvalidatedBy(state, tags) {
        var _a;
        var apiState = state[reducerPath];
        var toInvalidate = new Set();
        for(var _j = 0, _k = tags.map($54649b17feedf59f$var$expandTagDescription); _j < _k.length; _j++){
            var tag = _k[_j];
            var provided = apiState.provided[tag.type];
            if (!provided) continue;
            var invalidateSubscriptions = (_a = tag.id !== void 0 ? provided[tag.id] : $54649b17feedf59f$var$flatten(Object.values(provided))) != null ? _a : [];
            for(var _l = 0, invalidateSubscriptions_1 = invalidateSubscriptions; _l < invalidateSubscriptions_1.length; _l++){
                var invalidate = invalidateSubscriptions_1[_l];
                toInvalidate.add(invalidate);
            }
        }
        return $54649b17feedf59f$var$flatten(Array.from(toInvalidate.values()).map(function(queryCacheKey) {
            var querySubState = apiState.queries[queryCacheKey];
            return querySubState ? [
                {
                    queryCacheKey: queryCacheKey,
                    endpointName: querySubState.endpointName,
                    originalArgs: querySubState.originalArgs
                }
            ] : [];
        }));
    }
}
var $54649b17feedf59f$var$cache = WeakMap ? new WeakMap() : void 0;
var $54649b17feedf59f$export$db8e4edac9bbb67b = function(_j) {
    var endpointName = _j.endpointName, queryArgs = _j.queryArgs;
    var serialized = "";
    var cached = $54649b17feedf59f$var$cache == null ? void 0 : $54649b17feedf59f$var$cache.get(queryArgs);
    if (typeof cached === "string") serialized = cached;
    else {
        var stringified = JSON.stringify(queryArgs, function(key, value) {
            return (0, $bEIGg.isPlainObject)(value) ? Object.keys(value).sort().reduce(function(acc, key2) {
                acc[key2] = value[key2];
                return acc;
            }, {}) : value;
        });
        if ((0, $bEIGg.isPlainObject)(queryArgs)) $54649b17feedf59f$var$cache == null || $54649b17feedf59f$var$cache.set(queryArgs, stringified);
        serialized = stringified;
    }
    return endpointName + "(" + serialized + ")";
};
function $54649b17feedf59f$export$f957748792d43646() {
    var modules = [];
    for(var _j = 0; _j < arguments.length; _j++)modules[_j] = arguments[_j];
    return function baseCreateApi(options) {
        var extractRehydrationInfo = (0, $hWhND.defaultMemoize)(function(action) {
            var _a, _b;
            return (_b = options.extractRehydrationInfo) == null ? void 0 : _b.call(options, action, {
                reducerPath: (_a = options.reducerPath) != null ? _a : "api"
            });
        });
        var optionsWithDefaults = $54649b17feedf59f$var$__spreadProps($54649b17feedf59f$var$__spreadValues({
            reducerPath: "api",
            keepUnusedDataFor: 60,
            refetchOnMountOrArgChange: false,
            refetchOnFocus: false,
            refetchOnReconnect: false
        }, options), {
            extractRehydrationInfo: extractRehydrationInfo,
            serializeQueryArgs: function(queryArgsApi) {
                var finalSerializeQueryArgs = $54649b17feedf59f$export$db8e4edac9bbb67b;
                if ("serializeQueryArgs" in queryArgsApi.endpointDefinition) {
                    var endpointSQA_1 = queryArgsApi.endpointDefinition.serializeQueryArgs;
                    finalSerializeQueryArgs = function(queryArgsApi2) {
                        var initialResult = endpointSQA_1(queryArgsApi2);
                        if (typeof initialResult === "string") return initialResult;
                        else return $54649b17feedf59f$export$db8e4edac9bbb67b($54649b17feedf59f$var$__spreadProps($54649b17feedf59f$var$__spreadValues({}, queryArgsApi2), {
                            queryArgs: initialResult
                        }));
                    };
                } else if (options.serializeQueryArgs) finalSerializeQueryArgs = options.serializeQueryArgs;
                return finalSerializeQueryArgs(queryArgsApi);
            },
            tagTypes: $54649b17feedf59f$var$__spreadArray([], options.tagTypes || [])
        });
        var context = {
            endpointDefinitions: {},
            batch: function(fn) {
                fn();
            },
            apiUid: (0, $bEIGg.nanoid)(),
            extractRehydrationInfo: extractRehydrationInfo,
            hasRehydrationInfo: (0, $hWhND.defaultMemoize)(function(action) {
                return extractRehydrationInfo(action) != null;
            })
        };
        var api = {
            injectEndpoints: injectEndpoints,
            enhanceEndpoints: function(_j) {
                var addTagTypes = _j.addTagTypes, endpoints = _j.endpoints;
                if (addTagTypes) for(var _k = 0, addTagTypes_1 = addTagTypes; _k < addTagTypes_1.length; _k++){
                    var eT = addTagTypes_1[_k];
                    if (!optionsWithDefaults.tagTypes.includes(eT)) optionsWithDefaults.tagTypes.push(eT);
                }
                if (endpoints) for(var _l = 0, _m = Object.entries(endpoints); _l < _m.length; _l++){
                    var _o = _m[_l], endpointName = _o[0], partialDefinition = _o[1];
                    if (typeof partialDefinition === "function") partialDefinition(context.endpointDefinitions[endpointName]);
                    else Object.assign(context.endpointDefinitions[endpointName] || {}, partialDefinition);
                }
                return api;
            }
        };
        var initializedModules = modules.map(function(m) {
            return m.init(api, optionsWithDefaults, context);
        });
        function injectEndpoints(inject) {
            var evaluatedEndpoints = inject.endpoints({
                query: function(x) {
                    return $54649b17feedf59f$var$__spreadProps($54649b17feedf59f$var$__spreadValues({}, x), {
                        type: $54649b17feedf59f$var$DefinitionType.query
                    });
                },
                mutation: function(x) {
                    return $54649b17feedf59f$var$__spreadProps($54649b17feedf59f$var$__spreadValues({}, x), {
                        type: $54649b17feedf59f$var$DefinitionType.mutation
                    });
                }
            });
            for(var _j = 0, _k = Object.entries(evaluatedEndpoints); _j < _k.length; _j++){
                var _l = _k[_j], endpointName = _l[0], definition = _l[1];
                if (!inject.overrideExisting && endpointName in context.endpointDefinitions) {
                    typeof $fr0vp;
                    continue;
                }
                context.endpointDefinitions[endpointName] = definition;
                for(var _m = 0, initializedModules_1 = initializedModules; _m < initializedModules_1.length; _m++){
                    var m = initializedModules_1[_m];
                    m.injectEndpoint(endpointName, definition);
                }
            }
            return api;
        }
        return api.injectEndpoints({
            endpoints: options.endpoints
        });
    };
}
// src/query/fakeBaseQuery.ts
function $54649b17feedf59f$export$f72b22d3ac378bae() {
    return function() {
        throw new Error("When using `fakeBaseQuery`, all queries & mutations must use the `queryFn` definition syntax.");
    };
}
// src/query/core/buildMiddleware/cacheCollection.ts
function $54649b17feedf59f$var$isObjectEmpty(obj) {
    for(var k in obj)return false;
    return true;
}
var $54649b17feedf59f$var$THIRTY_TWO_BIT_MAX_TIMER_SECONDS = 2147482.647;
var $54649b17feedf59f$var$buildCacheCollectionHandler = function(_j) {
    var reducerPath = _j.reducerPath, api = _j.api, context = _j.context, internalState = _j.internalState;
    var _k = api.internalActions, removeQueryResult = _k.removeQueryResult, unsubscribeQueryResult = _k.unsubscribeQueryResult;
    function anySubscriptionsRemainingForKey(queryCacheKey) {
        var subscriptions = internalState.currentSubscriptions[queryCacheKey];
        return !!subscriptions && !$54649b17feedf59f$var$isObjectEmpty(subscriptions);
    }
    var currentRemovalTimeouts = {};
    var handler = function(action, mwApi, internalState2) {
        var _a;
        if (unsubscribeQueryResult.match(action)) {
            var state = mwApi.getState()[reducerPath];
            var queryCacheKey = action.payload.queryCacheKey;
            handleUnsubscribe(queryCacheKey, (_a = state.queries[queryCacheKey]) == null ? void 0 : _a.endpointName, mwApi, state.config);
        }
        if (api.util.resetApiState.match(action)) for(var _j = 0, _k = Object.entries(currentRemovalTimeouts); _j < _k.length; _j++){
            var _l = _k[_j], key = _l[0], timeout = _l[1];
            if (timeout) clearTimeout(timeout);
            delete currentRemovalTimeouts[key];
        }
        if (context.hasRehydrationInfo(action)) {
            var state = mwApi.getState()[reducerPath];
            var queries = context.extractRehydrationInfo(action).queries;
            for(var _m = 0, _o = Object.entries(queries); _m < _o.length; _m++){
                var _p = _o[_m], queryCacheKey = _p[0], queryState = _p[1];
                handleUnsubscribe(queryCacheKey, queryState == null ? void 0 : queryState.endpointName, mwApi, state.config);
            }
        }
    };
    function handleUnsubscribe(queryCacheKey, endpointName, api2, config) {
        var _a;
        var endpointDefinition = context.endpointDefinitions[endpointName];
        var keepUnusedDataFor = (_a = endpointDefinition == null ? void 0 : endpointDefinition.keepUnusedDataFor) != null ? _a : config.keepUnusedDataFor;
        if (keepUnusedDataFor === Infinity) return;
        var finalKeepUnusedDataFor = Math.max(0, Math.min(keepUnusedDataFor, $54649b17feedf59f$var$THIRTY_TWO_BIT_MAX_TIMER_SECONDS));
        if (!anySubscriptionsRemainingForKey(queryCacheKey)) {
            var currentTimeout = currentRemovalTimeouts[queryCacheKey];
            if (currentTimeout) clearTimeout(currentTimeout);
            currentRemovalTimeouts[queryCacheKey] = setTimeout(function() {
                if (!anySubscriptionsRemainingForKey(queryCacheKey)) api2.dispatch(removeQueryResult({
                    queryCacheKey: queryCacheKey
                }));
                delete currentRemovalTimeouts[queryCacheKey];
            }, finalKeepUnusedDataFor * 1e3);
        }
    }
    return handler;
};
var $54649b17feedf59f$var$buildInvalidationByTagsHandler = function(_j) {
    var reducerPath = _j.reducerPath, context = _j.context, endpointDefinitions = _j.context.endpointDefinitions, mutationThunk = _j.mutationThunk, api = _j.api, assertTagType = _j.assertTagType, refetchQuery = _j.refetchQuery;
    var removeQueryResult = api.internalActions.removeQueryResult;
    var isThunkActionWithTags = (0, $bEIGg.isAnyOf)((0, $bEIGg.isFulfilled)(mutationThunk), (0, $bEIGg.isRejectedWithValue)(mutationThunk));
    var handler = function(action, mwApi) {
        if (isThunkActionWithTags(action)) invalidateTags($54649b17feedf59f$var$calculateProvidedByThunk(action, "invalidatesTags", endpointDefinitions, assertTagType), mwApi);
        if (api.util.invalidateTags.match(action)) invalidateTags($54649b17feedf59f$var$calculateProvidedBy(action.payload, void 0, void 0, void 0, void 0, assertTagType), mwApi);
    };
    function invalidateTags(tags, mwApi) {
        var rootState = mwApi.getState();
        var state = rootState[reducerPath];
        var toInvalidate = api.util.selectInvalidatedBy(rootState, tags);
        context.batch(function() {
            var _a;
            var valuesArray = Array.from(toInvalidate.values());
            for(var _j = 0, valuesArray_1 = valuesArray; _j < valuesArray_1.length; _j++){
                var queryCacheKey = valuesArray_1[_j].queryCacheKey;
                var querySubState = state.queries[queryCacheKey];
                var subscriptionSubState = (_a = state.subscriptions[queryCacheKey]) != null ? _a : {};
                if (querySubState) {
                    if (Object.keys(subscriptionSubState).length === 0) mwApi.dispatch(removeQueryResult({
                        queryCacheKey: queryCacheKey
                    }));
                    else if (querySubState.status !== $54649b17feedf59f$export$f4258b89f6bad1d6.uninitialized) mwApi.dispatch(refetchQuery(querySubState, queryCacheKey));
                }
            }
        });
    }
    return handler;
};
// src/query/core/buildMiddleware/polling.ts
var $54649b17feedf59f$var$buildPollingHandler = function(_j) {
    var reducerPath = _j.reducerPath, queryThunk = _j.queryThunk, api = _j.api, refetchQuery = _j.refetchQuery, internalState = _j.internalState;
    var currentPolls = {};
    var handler = function(action, mwApi) {
        if (api.internalActions.updateSubscriptionOptions.match(action) || api.internalActions.unsubscribeQueryResult.match(action)) updatePollingInterval(action.payload, mwApi);
        if (queryThunk.pending.match(action) || queryThunk.rejected.match(action) && action.meta.condition) updatePollingInterval(action.meta.arg, mwApi);
        if (queryThunk.fulfilled.match(action) || queryThunk.rejected.match(action) && !action.meta.condition) startNextPoll(action.meta.arg, mwApi);
        if (api.util.resetApiState.match(action)) clearPolls();
    };
    function startNextPoll(_j, api2) {
        var queryCacheKey = _j.queryCacheKey;
        var state = api2.getState()[reducerPath];
        var querySubState = state.queries[queryCacheKey];
        var subscriptions = internalState.currentSubscriptions[queryCacheKey];
        if (!querySubState || querySubState.status === $54649b17feedf59f$export$f4258b89f6bad1d6.uninitialized) return;
        var lowestPollingInterval = findLowestPollingInterval(subscriptions);
        if (!Number.isFinite(lowestPollingInterval)) return;
        var currentPoll = currentPolls[queryCacheKey];
        if (currentPoll == null ? void 0 : currentPoll.timeout) {
            clearTimeout(currentPoll.timeout);
            currentPoll.timeout = void 0;
        }
        var nextPollTimestamp = Date.now() + lowestPollingInterval;
        var currentInterval = currentPolls[queryCacheKey] = {
            nextPollTimestamp: nextPollTimestamp,
            pollingInterval: lowestPollingInterval,
            timeout: setTimeout(function() {
                currentInterval.timeout = void 0;
                api2.dispatch(refetchQuery(querySubState, queryCacheKey));
            }, lowestPollingInterval)
        };
    }
    function updatePollingInterval(_j, api2) {
        var queryCacheKey = _j.queryCacheKey;
        var state = api2.getState()[reducerPath];
        var querySubState = state.queries[queryCacheKey];
        var subscriptions = internalState.currentSubscriptions[queryCacheKey];
        if (!querySubState || querySubState.status === $54649b17feedf59f$export$f4258b89f6bad1d6.uninitialized) return;
        var lowestPollingInterval = findLowestPollingInterval(subscriptions);
        if (!Number.isFinite(lowestPollingInterval)) {
            cleanupPollForKey(queryCacheKey);
            return;
        }
        var currentPoll = currentPolls[queryCacheKey];
        var nextPollTimestamp = Date.now() + lowestPollingInterval;
        if (!currentPoll || nextPollTimestamp < currentPoll.nextPollTimestamp) startNextPoll({
            queryCacheKey: queryCacheKey
        }, api2);
    }
    function cleanupPollForKey(key) {
        var existingPoll = currentPolls[key];
        if (existingPoll == null ? void 0 : existingPoll.timeout) clearTimeout(existingPoll.timeout);
        delete currentPolls[key];
    }
    function clearPolls() {
        for(var _j = 0, _k = Object.keys(currentPolls); _j < _k.length; _j++){
            var key = _k[_j];
            cleanupPollForKey(key);
        }
    }
    function findLowestPollingInterval(subscribers) {
        if (subscribers === void 0) subscribers = {};
        var lowestPollingInterval = Number.POSITIVE_INFINITY;
        for(var key in subscribers)if (!!subscribers[key].pollingInterval) lowestPollingInterval = Math.min(subscribers[key].pollingInterval, lowestPollingInterval);
        return lowestPollingInterval;
    }
    return handler;
};
// src/query/core/buildMiddleware/windowEventHandling.ts
var $54649b17feedf59f$var$buildWindowEventHandler = function(_j) {
    var reducerPath = _j.reducerPath, context = _j.context, api = _j.api, refetchQuery = _j.refetchQuery, internalState = _j.internalState;
    var removeQueryResult = api.internalActions.removeQueryResult;
    var handler = function(action, mwApi) {
        if ($54649b17feedf59f$var$onFocus.match(action)) refetchValidQueries(mwApi, "refetchOnFocus");
        if ($54649b17feedf59f$var$onOnline.match(action)) refetchValidQueries(mwApi, "refetchOnReconnect");
    };
    function refetchValidQueries(api2, type) {
        var state = api2.getState()[reducerPath];
        var queries = state.queries;
        var subscriptions = internalState.currentSubscriptions;
        context.batch(function() {
            for(var _j = 0, _k = Object.keys(subscriptions); _j < _k.length; _j++){
                var queryCacheKey = _k[_j];
                var querySubState = queries[queryCacheKey];
                var subscriptionSubState = subscriptions[queryCacheKey];
                if (!subscriptionSubState || !querySubState) continue;
                var shouldRefetch = Object.values(subscriptionSubState).some(function(sub) {
                    return sub[type] === true;
                }) || Object.values(subscriptionSubState).every(function(sub) {
                    return sub[type] === void 0;
                }) && state.config[type];
                if (shouldRefetch) {
                    if (Object.keys(subscriptionSubState).length === 0) api2.dispatch(removeQueryResult({
                        queryCacheKey: queryCacheKey
                    }));
                    else if (querySubState.status !== $54649b17feedf59f$export$f4258b89f6bad1d6.uninitialized) api2.dispatch(refetchQuery(querySubState, queryCacheKey));
                }
            }
        });
    }
    return handler;
};
var $54649b17feedf59f$var$neverResolvedError = new Error("Promise never resolved before cacheEntryRemoved.");
var $54649b17feedf59f$var$buildCacheLifecycleHandler = function(_j) {
    var api = _j.api, reducerPath = _j.reducerPath, context = _j.context, queryThunk = _j.queryThunk, mutationThunk = _j.mutationThunk, internalState = _j.internalState;
    var isQueryThunk = (0, $bEIGg.isAsyncThunkAction)(queryThunk);
    var isMutationThunk = (0, $bEIGg.isAsyncThunkAction)(mutationThunk);
    var isFulfilledThunk = (0, $bEIGg.isFulfilled)(queryThunk, mutationThunk);
    var lifecycleMap = {};
    var handler = function(action, mwApi, stateBefore) {
        var cacheKey = getCacheKey(action);
        if (queryThunk.pending.match(action)) {
            var oldState = stateBefore[reducerPath].queries[cacheKey];
            var state = mwApi.getState()[reducerPath].queries[cacheKey];
            if (!oldState && state) handleNewKey(action.meta.arg.endpointName, action.meta.arg.originalArgs, cacheKey, mwApi, action.meta.requestId);
        } else if (mutationThunk.pending.match(action)) {
            var state = mwApi.getState()[reducerPath].mutations[cacheKey];
            if (state) handleNewKey(action.meta.arg.endpointName, action.meta.arg.originalArgs, cacheKey, mwApi, action.meta.requestId);
        } else if (isFulfilledThunk(action)) {
            var lifecycle = lifecycleMap[cacheKey];
            if (lifecycle == null ? void 0 : lifecycle.valueResolved) {
                lifecycle.valueResolved({
                    data: action.payload,
                    meta: action.meta.baseQueryMeta
                });
                delete lifecycle.valueResolved;
            }
        } else if (api.internalActions.removeQueryResult.match(action) || api.internalActions.removeMutationResult.match(action)) {
            var lifecycle = lifecycleMap[cacheKey];
            if (lifecycle) {
                delete lifecycleMap[cacheKey];
                lifecycle.cacheEntryRemoved();
            }
        } else if (api.util.resetApiState.match(action)) for(var _j = 0, _k = Object.entries(lifecycleMap); _j < _k.length; _j++){
            var _l = _k[_j], cacheKey2 = _l[0], lifecycle = _l[1];
            delete lifecycleMap[cacheKey2];
            lifecycle.cacheEntryRemoved();
        }
    };
    function getCacheKey(action) {
        if (isQueryThunk(action)) return action.meta.arg.queryCacheKey;
        if (isMutationThunk(action)) return action.meta.requestId;
        if (api.internalActions.removeQueryResult.match(action)) return action.payload.queryCacheKey;
        if (api.internalActions.removeMutationResult.match(action)) return $54649b17feedf59f$var$getMutationCacheKey(action.payload);
        return "";
    }
    function handleNewKey(endpointName, originalArgs, queryCacheKey, mwApi, requestId) {
        var endpointDefinition = context.endpointDefinitions[endpointName];
        var onCacheEntryAdded = endpointDefinition == null ? void 0 : endpointDefinition.onCacheEntryAdded;
        if (!onCacheEntryAdded) return;
        var lifecycle = {};
        var cacheEntryRemoved = new Promise(function(resolve) {
            lifecycle.cacheEntryRemoved = resolve;
        });
        var cacheDataLoaded = Promise.race([
            new Promise(function(resolve) {
                lifecycle.valueResolved = resolve;
            }),
            cacheEntryRemoved.then(function() {
                throw $54649b17feedf59f$var$neverResolvedError;
            })
        ]);
        cacheDataLoaded.catch(function() {});
        lifecycleMap[queryCacheKey] = lifecycle;
        var selector = api.endpoints[endpointName].select(endpointDefinition.type === $54649b17feedf59f$var$DefinitionType.query ? originalArgs : queryCacheKey);
        var extra = mwApi.dispatch(function(_, __, extra2) {
            return extra2;
        });
        var lifecycleApi = $54649b17feedf59f$var$__spreadProps($54649b17feedf59f$var$__spreadValues({}, mwApi), {
            getCacheEntry: function() {
                return selector(mwApi.getState());
            },
            requestId: requestId,
            extra: extra,
            updateCachedData: endpointDefinition.type === $54649b17feedf59f$var$DefinitionType.query ? function(updateRecipe) {
                return mwApi.dispatch(api.util.updateQueryData(endpointName, originalArgs, updateRecipe));
            } : void 0,
            cacheDataLoaded: cacheDataLoaded,
            cacheEntryRemoved: cacheEntryRemoved
        });
        var runningHandler = onCacheEntryAdded(originalArgs, lifecycleApi);
        Promise.resolve(runningHandler).catch(function(e) {
            if (e === $54649b17feedf59f$var$neverResolvedError) return;
            throw e;
        });
    }
    return handler;
};
var $54649b17feedf59f$var$buildQueryLifecycleHandler = function(_j) {
    var api = _j.api, context = _j.context, queryThunk = _j.queryThunk, mutationThunk = _j.mutationThunk;
    var isPendingThunk = (0, $bEIGg.isPending)(queryThunk, mutationThunk);
    var isRejectedThunk = (0, $bEIGg.isRejected)(queryThunk, mutationThunk);
    var isFullfilledThunk = (0, $bEIGg.isFulfilled)(queryThunk, mutationThunk);
    var lifecycleMap = {};
    var handler = function(action, mwApi) {
        var _a, _b, _c;
        if (isPendingThunk(action)) {
            var _j = action.meta, requestId = _j.requestId, _k = _j.arg, endpointName_1 = _k.endpointName, originalArgs_1 = _k.originalArgs;
            var endpointDefinition = context.endpointDefinitions[endpointName_1];
            var onQueryStarted = endpointDefinition == null ? void 0 : endpointDefinition.onQueryStarted;
            if (onQueryStarted) {
                var lifecycle_1 = {};
                var queryFulfilled = new Promise(function(resolve, reject) {
                    lifecycle_1.resolve = resolve;
                    lifecycle_1.reject = reject;
                });
                queryFulfilled.catch(function() {});
                lifecycleMap[requestId] = lifecycle_1;
                var selector_1 = api.endpoints[endpointName_1].select(endpointDefinition.type === $54649b17feedf59f$var$DefinitionType.query ? originalArgs_1 : requestId);
                var extra = mwApi.dispatch(function(_, __, extra2) {
                    return extra2;
                });
                var lifecycleApi = $54649b17feedf59f$var$__spreadProps($54649b17feedf59f$var$__spreadValues({}, mwApi), {
                    getCacheEntry: function() {
                        return selector_1(mwApi.getState());
                    },
                    requestId: requestId,
                    extra: extra,
                    updateCachedData: endpointDefinition.type === $54649b17feedf59f$var$DefinitionType.query ? function(updateRecipe) {
                        return mwApi.dispatch(api.util.updateQueryData(endpointName_1, originalArgs_1, updateRecipe));
                    } : void 0,
                    queryFulfilled: queryFulfilled
                });
                onQueryStarted(originalArgs_1, lifecycleApi);
            }
        } else if (isFullfilledThunk(action)) {
            var _l = action.meta, requestId = _l.requestId, baseQueryMeta = _l.baseQueryMeta;
            (_a = lifecycleMap[requestId]) == null || _a.resolve({
                data: action.payload,
                meta: baseQueryMeta
            });
            delete lifecycleMap[requestId];
        } else if (isRejectedThunk(action)) {
            var _m = action.meta, requestId = _m.requestId, rejectedWithValue = _m.rejectedWithValue, baseQueryMeta = _m.baseQueryMeta;
            (_c = lifecycleMap[requestId]) == null || _c.reject({
                error: (_b = action.payload) != null ? _b : action.error,
                isUnhandledError: !rejectedWithValue,
                meta: baseQueryMeta
            });
            delete lifecycleMap[requestId];
        }
    };
    return handler;
};
// src/query/core/buildMiddleware/devMiddleware.ts
var $54649b17feedf59f$var$buildDevCheckHandler = function(_j) {
    var api = _j.api, apiUid = _j.context.apiUid, reducerPath = _j.reducerPath;
    return function(action, mwApi) {
        var _a, _b;
        if (api.util.resetApiState.match(action)) mwApi.dispatch(api.internalActions.middlewareRegistered(apiUid));
        typeof $fr0vp;
    };
};
var $54649b17feedf59f$var$promise;
var $54649b17feedf59f$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function(cb) {
    return ($54649b17feedf59f$var$promise || ($54649b17feedf59f$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $54649b17feedf59f$var$buildBatchedActionsHandler = function(_j) {
    var api = _j.api, queryThunk = _j.queryThunk, internalState = _j.internalState;
    var subscriptionsPrefix = api.reducerPath + "/subscriptions";
    var previousSubscriptions = null;
    var dispatchQueued = false;
    var _k = api.internalActions, updateSubscriptionOptions = _k.updateSubscriptionOptions, unsubscribeQueryResult = _k.unsubscribeQueryResult;
    var actuallyMutateSubscriptions = function(mutableState, action) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i;
        if (updateSubscriptionOptions.match(action)) {
            var _j = action.payload, queryCacheKey = _j.queryCacheKey, requestId = _j.requestId, options = _j.options;
            if ((_a = mutableState == null ? void 0 : mutableState[queryCacheKey]) == null ? void 0 : _a[requestId]) mutableState[queryCacheKey][requestId] = options;
            return true;
        }
        if (unsubscribeQueryResult.match(action)) {
            var _k = action.payload, queryCacheKey = _k.queryCacheKey, requestId = _k.requestId;
            if (mutableState[queryCacheKey]) delete mutableState[queryCacheKey][requestId];
            return true;
        }
        if (api.internalActions.removeQueryResult.match(action)) {
            delete mutableState[action.payload.queryCacheKey];
            return true;
        }
        if (queryThunk.pending.match(action)) {
            var _l = action.meta, arg = _l.arg, requestId = _l.requestId;
            if (arg.subscribe) {
                var substate = (_c = mutableState[_b = arg.queryCacheKey]) != null ? _c : mutableState[_b] = {};
                substate[requestId] = (_e = (_d = arg.subscriptionOptions) != null ? _d : substate[requestId]) != null ? _e : {};
                return true;
            }
        }
        if (queryThunk.rejected.match(action)) {
            var _m = action.meta, condition = _m.condition, arg = _m.arg, requestId = _m.requestId;
            if (condition && arg.subscribe) {
                var substate = (_g = mutableState[_f = arg.queryCacheKey]) != null ? _g : mutableState[_f] = {};
                substate[requestId] = (_i = (_h = arg.subscriptionOptions) != null ? _h : substate[requestId]) != null ? _i : {};
                return true;
            }
        }
        return false;
    };
    return function(action, mwApi) {
        var _a, _b;
        if (!previousSubscriptions) previousSubscriptions = JSON.parse(JSON.stringify(internalState.currentSubscriptions));
        if (api.util.resetApiState.match(action)) {
            previousSubscriptions = internalState.currentSubscriptions = {};
            return [
                true,
                false
            ];
        }
        if (api.internalActions.internal_probeSubscription.match(action)) {
            var _j = action.payload, queryCacheKey = _j.queryCacheKey, requestId = _j.requestId;
            var hasSubscription = !!((_a = internalState.currentSubscriptions[queryCacheKey]) == null ? void 0 : _a[requestId]);
            return [
                false,
                hasSubscription
            ];
        }
        var didMutate = actuallyMutateSubscriptions(internalState.currentSubscriptions, action);
        if (didMutate) {
            if (!dispatchQueued) {
                $54649b17feedf59f$var$queueMicrotaskShim(function() {
                    var newSubscriptions = JSON.parse(JSON.stringify(internalState.currentSubscriptions));
                    var _j = (0, $jewWr.produceWithPatches)(previousSubscriptions, function() {
                        return newSubscriptions;
                    }), patches = _j[1];
                    mwApi.next(api.internalActions.subscriptionsUpdated(patches));
                    previousSubscriptions = newSubscriptions;
                    dispatchQueued = false;
                });
                dispatchQueued = true;
            }
            var isSubscriptionSliceAction = !!((_b = action.type) == null ? void 0 : _b.startsWith(subscriptionsPrefix));
            var isAdditionalSubscriptionAction = queryThunk.rejected.match(action) && action.meta.condition && !!action.meta.arg.subscribe;
            var actionShouldContinue = !isSubscriptionSliceAction && !isAdditionalSubscriptionAction;
            return [
                actionShouldContinue,
                false
            ];
        }
        return [
            true,
            false
        ];
    };
};
// src/query/core/buildMiddleware/index.ts
function $54649b17feedf59f$var$buildMiddleware(input) {
    var reducerPath = input.reducerPath, queryThunk = input.queryThunk, api = input.api, context = input.context;
    var apiUid = context.apiUid;
    var actions = {
        invalidateTags: (0, $bEIGg.createAction)(reducerPath + "/invalidateTags")
    };
    var isThisApiSliceAction = function(action) {
        return !!action && typeof action.type === "string" && action.type.startsWith(reducerPath + "/");
    };
    var handlerBuilders = [
        $54649b17feedf59f$var$buildDevCheckHandler,
        $54649b17feedf59f$var$buildCacheCollectionHandler,
        $54649b17feedf59f$var$buildInvalidationByTagsHandler,
        $54649b17feedf59f$var$buildPollingHandler,
        $54649b17feedf59f$var$buildCacheLifecycleHandler,
        $54649b17feedf59f$var$buildQueryLifecycleHandler
    ];
    var middleware = function(mwApi) {
        var initialized2 = false;
        var internalState = {
            currentSubscriptions: {}
        };
        var builderArgs = $54649b17feedf59f$var$__spreadProps($54649b17feedf59f$var$__spreadValues({}, input), {
            internalState: internalState,
            refetchQuery: refetchQuery
        });
        var handlers = handlerBuilders.map(function(build) {
            return build(builderArgs);
        });
        var batchedActionsHandler = $54649b17feedf59f$var$buildBatchedActionsHandler(builderArgs);
        var windowEventsHandler = $54649b17feedf59f$var$buildWindowEventHandler(builderArgs);
        return function(next) {
            return function(action) {
                if (!initialized2) {
                    initialized2 = true;
                    mwApi.dispatch(api.internalActions.middlewareRegistered(apiUid));
                }
                var mwApiWithNext = $54649b17feedf59f$var$__spreadProps($54649b17feedf59f$var$__spreadValues({}, mwApi), {
                    next: next
                });
                var stateBefore = mwApi.getState();
                var _j = batchedActionsHandler(action, mwApiWithNext, stateBefore), actionShouldContinue = _j[0], hasSubscription = _j[1];
                var res;
                if (actionShouldContinue) res = next(action);
                else res = hasSubscription;
                if (!!mwApi.getState()[reducerPath]) {
                    windowEventsHandler(action, mwApiWithNext, stateBefore);
                    if (isThisApiSliceAction(action) || context.hasRehydrationInfo(action)) for(var _k = 0, handlers_1 = handlers; _k < handlers_1.length; _k++){
                        var handler = handlers_1[_k];
                        handler(action, mwApiWithNext, stateBefore);
                    }
                }
                return res;
            };
        };
    };
    return {
        middleware: middleware,
        actions: actions
    };
    function refetchQuery(querySubState, queryCacheKey, override) {
        if (override === void 0) override = {};
        return queryThunk($54649b17feedf59f$var$__spreadValues({
            type: "query",
            endpointName: querySubState.endpointName,
            originalArgs: querySubState.originalArgs,
            subscribe: false,
            forceRefetch: true,
            queryCacheKey: queryCacheKey
        }, override));
    }
}
// src/query/tsHelpers.ts
function $54649b17feedf59f$var$assertCast(v) {}
function $54649b17feedf59f$var$safeAssign(target) {
    var args = [];
    for(var _j = 1; _j < arguments.length; _j++)args[_j - 1] = arguments[_j];
    Object.assign.apply(Object, $54649b17feedf59f$var$__spreadArray([
        target
    ], args));
}
var $54649b17feedf59f$var$coreModuleName = /* @__PURE__ */ Symbol();
var $54649b17feedf59f$export$eb718ff92afd6f9b = function() {
    return {
        name: $54649b17feedf59f$var$coreModuleName,
        init: function(api, _j, context) {
            var baseQuery = _j.baseQuery, tagTypes = _j.tagTypes, reducerPath = _j.reducerPath, serializeQueryArgs = _j.serializeQueryArgs, keepUnusedDataFor = _j.keepUnusedDataFor, refetchOnMountOrArgChange = _j.refetchOnMountOrArgChange, refetchOnFocus = _j.refetchOnFocus, refetchOnReconnect = _j.refetchOnReconnect;
            (0, $jewWr.enablePatches)();
            $54649b17feedf59f$var$assertCast(serializeQueryArgs);
            var assertTagType = function(tag) {
                typeof $fr0vp;
                return tag;
            };
            Object.assign(api, {
                reducerPath: reducerPath,
                endpoints: {},
                internalActions: {
                    onOnline: $54649b17feedf59f$var$onOnline,
                    onOffline: $54649b17feedf59f$var$onOffline,
                    onFocus: $54649b17feedf59f$var$onFocus,
                    onFocusLost: $54649b17feedf59f$var$onFocusLost
                },
                util: {}
            });
            var _k = $54649b17feedf59f$var$buildThunks({
                baseQuery: baseQuery,
                reducerPath: reducerPath,
                context: context,
                api: api,
                serializeQueryArgs: serializeQueryArgs
            }), queryThunk = _k.queryThunk, mutationThunk = _k.mutationThunk, patchQueryData = _k.patchQueryData, updateQueryData = _k.updateQueryData, upsertQueryData = _k.upsertQueryData, prefetch = _k.prefetch, buildMatchThunkActions = _k.buildMatchThunkActions;
            var _l = $54649b17feedf59f$var$buildSlice({
                context: context,
                queryThunk: queryThunk,
                mutationThunk: mutationThunk,
                reducerPath: reducerPath,
                assertTagType: assertTagType,
                config: {
                    refetchOnFocus: refetchOnFocus,
                    refetchOnReconnect: refetchOnReconnect,
                    refetchOnMountOrArgChange: refetchOnMountOrArgChange,
                    keepUnusedDataFor: keepUnusedDataFor,
                    reducerPath: reducerPath
                }
            }), reducer = _l.reducer, sliceActions = _l.actions;
            $54649b17feedf59f$var$safeAssign(api.util, {
                patchQueryData: patchQueryData,
                updateQueryData: updateQueryData,
                upsertQueryData: upsertQueryData,
                prefetch: prefetch,
                resetApiState: sliceActions.resetApiState
            });
            $54649b17feedf59f$var$safeAssign(api.internalActions, sliceActions);
            var _m = $54649b17feedf59f$var$buildMiddleware({
                reducerPath: reducerPath,
                context: context,
                queryThunk: queryThunk,
                mutationThunk: mutationThunk,
                api: api,
                assertTagType: assertTagType
            }), middleware = _m.middleware, middlewareActions = _m.actions;
            $54649b17feedf59f$var$safeAssign(api.util, middlewareActions);
            $54649b17feedf59f$var$safeAssign(api, {
                reducer: reducer,
                middleware: middleware
            });
            var _o = $54649b17feedf59f$var$buildSelectors({
                serializeQueryArgs: serializeQueryArgs,
                reducerPath: reducerPath
            }), buildQuerySelector = _o.buildQuerySelector, buildMutationSelector = _o.buildMutationSelector, selectInvalidatedBy = _o.selectInvalidatedBy;
            $54649b17feedf59f$var$safeAssign(api.util, {
                selectInvalidatedBy: selectInvalidatedBy
            });
            var _p = $54649b17feedf59f$var$buildInitiate({
                queryThunk: queryThunk,
                mutationThunk: mutationThunk,
                api: api,
                serializeQueryArgs: serializeQueryArgs,
                context: context
            }), buildInitiateQuery = _p.buildInitiateQuery, buildInitiateMutation = _p.buildInitiateMutation, getRunningMutationThunk = _p.getRunningMutationThunk, getRunningMutationsThunk = _p.getRunningMutationsThunk, getRunningQueriesThunk = _p.getRunningQueriesThunk, getRunningQueryThunk = _p.getRunningQueryThunk, getRunningOperationPromises = _p.getRunningOperationPromises, removalWarning = _p.removalWarning;
            $54649b17feedf59f$var$safeAssign(api.util, {
                getRunningOperationPromises: getRunningOperationPromises,
                getRunningOperationPromise: removalWarning,
                getRunningMutationThunk: getRunningMutationThunk,
                getRunningMutationsThunk: getRunningMutationsThunk,
                getRunningQueryThunk: getRunningQueryThunk,
                getRunningQueriesThunk: getRunningQueriesThunk
            });
            return {
                name: $54649b17feedf59f$var$coreModuleName,
                injectEndpoint: function(endpointName, definition) {
                    var _a, _b;
                    var anyApi = api;
                    (_b = (_a = anyApi.endpoints)[endpointName]) != null ? _b : _a[endpointName] = {};
                    if ($54649b17feedf59f$var$isQueryDefinition(definition)) $54649b17feedf59f$var$safeAssign(anyApi.endpoints[endpointName], {
                        name: endpointName,
                        select: buildQuerySelector(endpointName, definition),
                        initiate: buildInitiateQuery(endpointName, definition)
                    }, buildMatchThunkActions(queryThunk, endpointName));
                    else if ($54649b17feedf59f$var$isMutationDefinition(definition)) $54649b17feedf59f$var$safeAssign(anyApi.endpoints[endpointName], {
                        name: endpointName,
                        select: buildMutationSelector(),
                        initiate: buildInitiateMutation(endpointName)
                    }, buildMatchThunkActions(mutationThunk, endpointName));
                }
            };
        }
    };
};
// src/query/core/index.ts
var $54649b17feedf59f$export$9cdc2b9a8d94c842 = /* @__PURE__ */ $54649b17feedf59f$export$f957748792d43646($54649b17feedf59f$export$eb718ff92afd6f9b());



var $bEIGg = parcelRequire("bEIGg");
var $ffM0i = parcelRequire("ffM0i");

var $2gcPZ = parcelRequire("2gcPZ");

var $fuyzp = parcelRequire("fuyzp");

var $fr0vp = parcelRequire("fr0vp");
var $140b755e0815039f$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $140b755e0815039f$var$__defProp = Object.defineProperty;
var $140b755e0815039f$var$__defProps = Object.defineProperties;
var $140b755e0815039f$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $140b755e0815039f$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $140b755e0815039f$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $140b755e0815039f$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $140b755e0815039f$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $140b755e0815039f$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $140b755e0815039f$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($140b755e0815039f$var$__hasOwnProp.call(b, prop)) $140b755e0815039f$var$__defNormalProp(a, prop, b[prop]);
    if ($140b755e0815039f$var$__getOwnPropSymbols) for(var _i = 0, _c = $140b755e0815039f$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($140b755e0815039f$var$__propIsEnum.call(b, prop)) $140b755e0815039f$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $140b755e0815039f$var$__spreadProps = function(a, b) {
    return $140b755e0815039f$var$__defProps(a, $140b755e0815039f$var$__getOwnPropDescs(b));
};
function $140b755e0815039f$var$useStableQueryArgs(queryArgs, serialize, endpointDefinition, endpointName) {
    var incoming = (0, $2gcPZ.useMemo)(function() {
        return {
            queryArgs: queryArgs,
            serialized: typeof queryArgs == "object" ? serialize({
                queryArgs: queryArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            }) : queryArgs
        };
    }, [
        queryArgs,
        serialize,
        endpointDefinition,
        endpointName
    ]);
    var cache2 = (0, $2gcPZ.useRef)(incoming);
    (0, $2gcPZ.useEffect)(function() {
        if (cache2.current.serialized !== incoming.serialized) cache2.current = incoming;
    }, [
        incoming
    ]);
    return cache2.current.serialized === incoming.serialized ? cache2.current.queryArgs : queryArgs;
}
// src/query/react/constants.ts
var $140b755e0815039f$var$UNINITIALIZED_VALUE = Symbol();
function $140b755e0815039f$var$useShallowStableValue(value) {
    var cache2 = (0, $2gcPZ.useRef)(value);
    (0, $2gcPZ.useEffect)(function() {
        if (!(0, $adc60b347c86dc3c$export$2e2bcd8739ae039)(cache2.current, value)) cache2.current = value;
    }, [
        value
    ]);
    return (0, $adc60b347c86dc3c$export$2e2bcd8739ae039)(cache2.current, value) ? cache2.current : value;
}
var $140b755e0815039f$var$cache = WeakMap ? new WeakMap() : void 0;
var $140b755e0815039f$var$defaultSerializeQueryArgs = function(_c) {
    var endpointName = _c.endpointName, queryArgs = _c.queryArgs;
    var serialized = "";
    var cached = $140b755e0815039f$var$cache == null ? void 0 : $140b755e0815039f$var$cache.get(queryArgs);
    if (typeof cached === "string") serialized = cached;
    else {
        var stringified = JSON.stringify(queryArgs, function(key, value) {
            return (0, $bEIGg.isPlainObject)(value) ? Object.keys(value).sort().reduce(function(acc, key2) {
                acc[key2] = value[key2];
                return acc;
            }, {}) : value;
        });
        if ((0, $bEIGg.isPlainObject)(queryArgs)) $140b755e0815039f$var$cache == null || $140b755e0815039f$var$cache.set(queryArgs, stringified);
        serialized = stringified;
    }
    return endpointName + "(" + serialized + ")";
};
// src/query/react/buildHooks.ts
var $140b755e0815039f$var$useIsomorphicLayoutEffect = typeof window !== "undefined" && !!window.document && !!window.document.createElement ? (0, $2gcPZ.useLayoutEffect) : (0, $2gcPZ.useEffect);
var $140b755e0815039f$var$defaultMutationStateSelector = function(x) {
    return x;
};
var $140b755e0815039f$var$noPendingQueryStateSelector = function(selected) {
    if (selected.isUninitialized) return $140b755e0815039f$var$__spreadProps($140b755e0815039f$var$__spreadValues({}, selected), {
        isUninitialized: false,
        isFetching: true,
        isLoading: selected.data !== void 0 ? false : true,
        status: (0, $54649b17feedf59f$export$f4258b89f6bad1d6).pending
    });
    return selected;
};
function $140b755e0815039f$var$buildHooks(_c) {
    var api = _c.api, _d = _c.moduleOptions, batch = _d.batch, useDispatch = _d.useDispatch, useSelector = _d.useSelector, useStore = _d.useStore, unstable__sideEffectsInRender = _d.unstable__sideEffectsInRender, serializeQueryArgs = _c.serializeQueryArgs, context = _c.context;
    var usePossiblyImmediateEffect = unstable__sideEffectsInRender ? function(cb) {
        return cb();
    } : (0, $2gcPZ.useEffect);
    return {
        buildQueryHooks: buildQueryHooks,
        buildMutationHook: buildMutationHook,
        usePrefetch: usePrefetch
    };
    function queryStatePreSelector(currentState, lastResult, queryArgs) {
        if ((lastResult == null ? void 0 : lastResult.endpointName) && currentState.isUninitialized) {
            var endpointName = lastResult.endpointName;
            var endpointDefinition = context.endpointDefinitions[endpointName];
            if (serializeQueryArgs({
                queryArgs: lastResult.originalArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            }) === serializeQueryArgs({
                queryArgs: queryArgs,
                endpointDefinition: endpointDefinition,
                endpointName: endpointName
            })) lastResult = void 0;
        }
        var data = currentState.isSuccess ? currentState.data : lastResult == null ? void 0 : lastResult.data;
        if (data === void 0) data = currentState.data;
        var hasData = data !== void 0;
        var isFetching = currentState.isLoading;
        var isLoading = !hasData && isFetching;
        var isSuccess = currentState.isSuccess || isFetching && hasData;
        return $140b755e0815039f$var$__spreadProps($140b755e0815039f$var$__spreadValues({}, currentState), {
            data: data,
            currentData: currentState.data,
            isFetching: isFetching,
            isLoading: isLoading,
            isSuccess: isSuccess
        });
    }
    function usePrefetch(endpointName, defaultOptions) {
        var dispatch = useDispatch();
        var stableDefaultOptions = $140b755e0815039f$var$useShallowStableValue(defaultOptions);
        return (0, $2gcPZ.useCallback)(function(arg, options) {
            return dispatch(api.util.prefetch(endpointName, arg, $140b755e0815039f$var$__spreadValues($140b755e0815039f$var$__spreadValues({}, stableDefaultOptions), options)));
        }, [
            endpointName,
            dispatch,
            stableDefaultOptions
        ]);
    }
    function buildQueryHooks(name) {
        var useQuerySubscription = function(arg, _c) {
            var _d = _c === void 0 ? {} : _c, refetchOnReconnect = _d.refetchOnReconnect, refetchOnFocus = _d.refetchOnFocus, refetchOnMountOrArgChange = _d.refetchOnMountOrArgChange, _e = _d.skip, skip = _e === void 0 ? false : _e, _f = _d.pollingInterval, pollingInterval = _f === void 0 ? 0 : _f;
            var initiate = api.endpoints[name].initiate;
            var dispatch = useDispatch();
            var stableArg = $140b755e0815039f$var$useStableQueryArgs(skip ? (0, $54649b17feedf59f$export$1aa5a89531b7670d) : arg, $140b755e0815039f$var$defaultSerializeQueryArgs, context.endpointDefinitions[name], name);
            var stableSubscriptionOptions = $140b755e0815039f$var$useShallowStableValue({
                refetchOnReconnect: refetchOnReconnect,
                refetchOnFocus: refetchOnFocus,
                pollingInterval: pollingInterval
            });
            var lastRenderHadSubscription = (0, $2gcPZ.useRef)(false);
            var promiseRef = (0, $2gcPZ.useRef)();
            var _g = promiseRef.current || {}, queryCacheKey = _g.queryCacheKey, requestId = _g.requestId;
            var currentRenderHasSubscription = false;
            if (queryCacheKey && requestId) {
                var returnedValue = dispatch(api.internalActions.internal_probeSubscription({
                    queryCacheKey: queryCacheKey,
                    requestId: requestId
                }));
                currentRenderHasSubscription = !!returnedValue;
            }
            var subscriptionRemoved = !currentRenderHasSubscription && lastRenderHadSubscription.current;
            usePossiblyImmediateEffect(function() {
                lastRenderHadSubscription.current = currentRenderHasSubscription;
            });
            usePossiblyImmediateEffect(function() {
                if (subscriptionRemoved) promiseRef.current = void 0;
            }, [
                subscriptionRemoved
            ]);
            usePossiblyImmediateEffect(function() {
                var _a;
                var lastPromise = promiseRef.current;
                typeof $fr0vp;
                if (stableArg === (0, $54649b17feedf59f$export$1aa5a89531b7670d)) {
                    lastPromise == null || lastPromise.unsubscribe();
                    promiseRef.current = void 0;
                    return;
                }
                var lastSubscriptionOptions = (_a = promiseRef.current) == null ? void 0 : _a.subscriptionOptions;
                if (!lastPromise || lastPromise.arg !== stableArg) {
                    lastPromise == null || lastPromise.unsubscribe();
                    var promise = dispatch(initiate(stableArg, {
                        subscriptionOptions: stableSubscriptionOptions,
                        forceRefetch: refetchOnMountOrArgChange
                    }));
                    promiseRef.current = promise;
                } else if (stableSubscriptionOptions !== lastSubscriptionOptions) lastPromise.updateSubscriptionOptions(stableSubscriptionOptions);
            }, [
                dispatch,
                initiate,
                refetchOnMountOrArgChange,
                stableArg,
                stableSubscriptionOptions,
                subscriptionRemoved
            ]);
            (0, $2gcPZ.useEffect)(function() {
                return function() {
                    var _a;
                    (_a = promiseRef.current) == null || _a.unsubscribe();
                    promiseRef.current = void 0;
                };
            }, []);
            return (0, $2gcPZ.useMemo)(function() {
                return {
                    refetch: function() {
                        var _a;
                        if (!promiseRef.current) throw new Error("Cannot refetch a query that has not been started yet.");
                        return (_a = promiseRef.current) == null ? void 0 : _a.refetch();
                    }
                };
            }, []);
        };
        var useLazyQuerySubscription = function(_c) {
            var _d = _c === void 0 ? {} : _c, refetchOnReconnect = _d.refetchOnReconnect, refetchOnFocus = _d.refetchOnFocus, _e = _d.pollingInterval, pollingInterval = _e === void 0 ? 0 : _e;
            var initiate = api.endpoints[name].initiate;
            var dispatch = useDispatch();
            var _f = (0, $2gcPZ.useState)($140b755e0815039f$var$UNINITIALIZED_VALUE), arg = _f[0], setArg = _f[1];
            var promiseRef = (0, $2gcPZ.useRef)();
            var stableSubscriptionOptions = $140b755e0815039f$var$useShallowStableValue({
                refetchOnReconnect: refetchOnReconnect,
                refetchOnFocus: refetchOnFocus,
                pollingInterval: pollingInterval
            });
            usePossiblyImmediateEffect(function() {
                var _a, _b;
                var lastSubscriptionOptions = (_a = promiseRef.current) == null ? void 0 : _a.subscriptionOptions;
                if (stableSubscriptionOptions !== lastSubscriptionOptions) (_b = promiseRef.current) == null || _b.updateSubscriptionOptions(stableSubscriptionOptions);
            }, [
                stableSubscriptionOptions
            ]);
            var subscriptionOptionsRef = (0, $2gcPZ.useRef)(stableSubscriptionOptions);
            usePossiblyImmediateEffect(function() {
                subscriptionOptionsRef.current = stableSubscriptionOptions;
            }, [
                stableSubscriptionOptions
            ]);
            var trigger = (0, $2gcPZ.useCallback)(function(arg2, preferCacheValue) {
                if (preferCacheValue === void 0) preferCacheValue = false;
                var promise;
                batch(function() {
                    var _a;
                    (_a = promiseRef.current) == null || _a.unsubscribe();
                    promiseRef.current = promise = dispatch(initiate(arg2, {
                        subscriptionOptions: subscriptionOptionsRef.current,
                        forceRefetch: !preferCacheValue
                    }));
                    setArg(arg2);
                });
                return promise;
            }, [
                dispatch,
                initiate
            ]);
            (0, $2gcPZ.useEffect)(function() {
                return function() {
                    var _a;
                    (_a = promiseRef == null ? void 0 : promiseRef.current) == null || _a.unsubscribe();
                };
            }, []);
            (0, $2gcPZ.useEffect)(function() {
                if (arg !== $140b755e0815039f$var$UNINITIALIZED_VALUE && !promiseRef.current) trigger(arg, true);
            }, [
                arg,
                trigger
            ]);
            return (0, $2gcPZ.useMemo)(function() {
                return [
                    trigger,
                    arg
                ];
            }, [
                trigger,
                arg
            ]);
        };
        var useQueryState = function(arg, _c) {
            var _d = _c === void 0 ? {} : _c, _e = _d.skip, skip = _e === void 0 ? false : _e, selectFromResult = _d.selectFromResult;
            var select = api.endpoints[name].select;
            var stableArg = $140b755e0815039f$var$useStableQueryArgs(skip ? (0, $54649b17feedf59f$export$1aa5a89531b7670d) : arg, serializeQueryArgs, context.endpointDefinitions[name], name);
            var lastValue = (0, $2gcPZ.useRef)();
            var selectDefaultResult = (0, $2gcPZ.useMemo)(function() {
                return (0, $ffM0i.createSelector)([
                    select(stableArg),
                    function(_, lastResult) {
                        return lastResult;
                    },
                    function(_) {
                        return stableArg;
                    }
                ], queryStatePreSelector);
            }, [
                select,
                stableArg
            ]);
            var querySelector = (0, $2gcPZ.useMemo)(function() {
                return selectFromResult ? (0, $ffM0i.createSelector)([
                    selectDefaultResult
                ], selectFromResult) : selectDefaultResult;
            }, [
                selectDefaultResult,
                selectFromResult
            ]);
            var currentState = useSelector(function(state) {
                return querySelector(state, lastValue.current);
            }, (0, $adc60b347c86dc3c$export$2e2bcd8739ae039));
            var store = useStore();
            var newLastValue = selectDefaultResult(store.getState(), lastValue.current);
            $140b755e0815039f$var$useIsomorphicLayoutEffect(function() {
                lastValue.current = newLastValue;
            }, [
                newLastValue
            ]);
            return currentState;
        };
        return {
            useQueryState: useQueryState,
            useQuerySubscription: useQuerySubscription,
            useLazyQuerySubscription: useLazyQuerySubscription,
            useLazyQuery: function(options) {
                var _c = useLazyQuerySubscription(options), trigger = _c[0], arg = _c[1];
                var queryStateResults = useQueryState(arg, $140b755e0815039f$var$__spreadProps($140b755e0815039f$var$__spreadValues({}, options), {
                    skip: arg === $140b755e0815039f$var$UNINITIALIZED_VALUE
                }));
                var info = (0, $2gcPZ.useMemo)(function() {
                    return {
                        lastArg: arg
                    };
                }, [
                    arg
                ]);
                return (0, $2gcPZ.useMemo)(function() {
                    return [
                        trigger,
                        queryStateResults,
                        info
                    ];
                }, [
                    trigger,
                    queryStateResults,
                    info
                ]);
            },
            useQuery: function(arg, options) {
                var querySubscriptionResults = useQuerySubscription(arg, options);
                var queryStateResults = useQueryState(arg, $140b755e0815039f$var$__spreadValues({
                    selectFromResult: arg === (0, $54649b17feedf59f$export$1aa5a89531b7670d) || (options == null ? void 0 : options.skip) ? void 0 : $140b755e0815039f$var$noPendingQueryStateSelector
                }, options));
                var data = queryStateResults.data, status = queryStateResults.status, isLoading = queryStateResults.isLoading, isSuccess = queryStateResults.isSuccess, isError = queryStateResults.isError, error = queryStateResults.error;
                (0, $2gcPZ.useDebugValue)({
                    data: data,
                    status: status,
                    isLoading: isLoading,
                    isSuccess: isSuccess,
                    isError: isError,
                    error: error
                });
                return (0, $2gcPZ.useMemo)(function() {
                    return $140b755e0815039f$var$__spreadValues($140b755e0815039f$var$__spreadValues({}, queryStateResults), querySubscriptionResults);
                }, [
                    queryStateResults,
                    querySubscriptionResults
                ]);
            }
        };
    }
    function buildMutationHook(name) {
        return function(_c) {
            var _d = _c === void 0 ? {} : _c, _e = _d.selectFromResult, selectFromResult = _e === void 0 ? $140b755e0815039f$var$defaultMutationStateSelector : _e, fixedCacheKey = _d.fixedCacheKey;
            var _f = api.endpoints[name], select = _f.select, initiate = _f.initiate;
            var dispatch = useDispatch();
            var _g = (0, $2gcPZ.useState)(), promise = _g[0], setPromise = _g[1];
            (0, $2gcPZ.useEffect)(function() {
                return function() {
                    if (!(promise == null ? void 0 : promise.arg.fixedCacheKey)) promise == null || promise.reset();
                };
            }, [
                promise
            ]);
            var triggerMutation = (0, $2gcPZ.useCallback)(function(arg) {
                var promise2 = dispatch(initiate(arg, {
                    fixedCacheKey: fixedCacheKey
                }));
                setPromise(promise2);
                return promise2;
            }, [
                dispatch,
                initiate,
                fixedCacheKey
            ]);
            var requestId = (promise || {}).requestId;
            var mutationSelector = (0, $2gcPZ.useMemo)(function() {
                return (0, $ffM0i.createSelector)([
                    select({
                        fixedCacheKey: fixedCacheKey,
                        requestId: promise == null ? void 0 : promise.requestId
                    })
                ], selectFromResult);
            }, [
                select,
                promise,
                selectFromResult,
                fixedCacheKey
            ]);
            var currentState = useSelector(mutationSelector, (0, $adc60b347c86dc3c$export$2e2bcd8739ae039));
            var originalArgs = fixedCacheKey == null ? promise == null ? void 0 : promise.arg.originalArgs : void 0;
            var reset = (0, $2gcPZ.useCallback)(function() {
                batch(function() {
                    if (promise) setPromise(void 0);
                    if (fixedCacheKey) dispatch(api.internalActions.removeMutationResult({
                        requestId: requestId,
                        fixedCacheKey: fixedCacheKey
                    }));
                });
            }, [
                dispatch,
                fixedCacheKey,
                promise,
                requestId
            ]);
            var endpointName = currentState.endpointName, data = currentState.data, status = currentState.status, isLoading = currentState.isLoading, isSuccess = currentState.isSuccess, isError = currentState.isError, error = currentState.error;
            (0, $2gcPZ.useDebugValue)({
                endpointName: endpointName,
                data: data,
                status: status,
                isLoading: isLoading,
                isSuccess: isSuccess,
                isError: isError,
                error: error
            });
            var finalState = (0, $2gcPZ.useMemo)(function() {
                return $140b755e0815039f$var$__spreadProps($140b755e0815039f$var$__spreadValues({}, currentState), {
                    originalArgs: originalArgs,
                    reset: reset
                });
            }, [
                currentState,
                originalArgs,
                reset
            ]);
            return (0, $2gcPZ.useMemo)(function() {
                return [
                    triggerMutation,
                    finalState
                ];
            }, [
                triggerMutation,
                finalState
            ]);
        };
    }
}
// src/query/endpointDefinitions.ts
var $140b755e0815039f$var$DefinitionType;
(function(DefinitionType2) {
    DefinitionType2["query"] = "query";
    DefinitionType2["mutation"] = "mutation";
})($140b755e0815039f$var$DefinitionType || ($140b755e0815039f$var$DefinitionType = {}));
function $140b755e0815039f$var$isQueryDefinition(e) {
    return e.type === $140b755e0815039f$var$DefinitionType.query;
}
function $140b755e0815039f$var$isMutationDefinition(e) {
    return e.type === $140b755e0815039f$var$DefinitionType.mutation;
}
// src/query/utils/capitalize.ts
function $140b755e0815039f$var$capitalize(str) {
    return str.replace(str[0], str[0].toUpperCase());
}
// src/query/tsHelpers.ts
function $140b755e0815039f$var$safeAssign(target) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    Object.assign.apply(Object, $140b755e0815039f$var$__spreadArray([
        target
    ], args));
}
var $140b755e0815039f$var$reactHooksModuleName = /* @__PURE__ */ Symbol();
var $140b755e0815039f$export$8b98f9e72008ec90 = function(_c) {
    var _d = _c === void 0 ? {} : _c, _e = _d.batch, batch = _e === void 0 ? (0, $fuyzp.unstable_batchedUpdates) : _e, _f = _d.useDispatch, useDispatch = _f === void 0 ? (0, $b1ddf03ae6418ae8$export$8ad76b76a4c905f8) : _f, _g = _d.useSelector, useSelector = _g === void 0 ? (0, $1a280fbaa3fcabb5$export$2105062e25df4afe) : _g, _h = _d.useStore, useStore = _h === void 0 ? (0, $8a1a7714098215c4$export$6ccbb43953eebf8) : _h, _j = _d.unstable__sideEffectsInRender, unstable__sideEffectsInRender = _j === void 0 ? false : _j;
    return {
        name: $140b755e0815039f$var$reactHooksModuleName,
        init: function(api, _c, context) {
            var serializeQueryArgs = _c.serializeQueryArgs;
            var anyApi = api;
            var _d = $140b755e0815039f$var$buildHooks({
                api: api,
                moduleOptions: {
                    batch: batch,
                    useDispatch: useDispatch,
                    useSelector: useSelector,
                    useStore: useStore,
                    unstable__sideEffectsInRender: unstable__sideEffectsInRender
                },
                serializeQueryArgs: serializeQueryArgs,
                context: context
            }), buildQueryHooks = _d.buildQueryHooks, buildMutationHook = _d.buildMutationHook, usePrefetch = _d.usePrefetch;
            $140b755e0815039f$var$safeAssign(anyApi, {
                usePrefetch: usePrefetch
            });
            $140b755e0815039f$var$safeAssign(context, {
                batch: batch
            });
            return {
                injectEndpoint: function(endpointName, definition) {
                    if ($140b755e0815039f$var$isQueryDefinition(definition)) {
                        var _c = buildQueryHooks(endpointName), useQuery = _c.useQuery, useLazyQuery = _c.useLazyQuery, useLazyQuerySubscription = _c.useLazyQuerySubscription, useQueryState = _c.useQueryState, useQuerySubscription = _c.useQuerySubscription;
                        $140b755e0815039f$var$safeAssign(anyApi.endpoints[endpointName], {
                            useQuery: useQuery,
                            useLazyQuery: useLazyQuery,
                            useLazyQuerySubscription: useLazyQuerySubscription,
                            useQueryState: useQueryState,
                            useQuerySubscription: useQuerySubscription
                        });
                        api["use" + $140b755e0815039f$var$capitalize(endpointName) + "Query"] = useQuery;
                        api["useLazy" + $140b755e0815039f$var$capitalize(endpointName) + "Query"] = useLazyQuery;
                    } else if ($140b755e0815039f$var$isMutationDefinition(definition)) {
                        var useMutation = buildMutationHook(endpointName);
                        $140b755e0815039f$var$safeAssign(anyApi.endpoints[endpointName], {
                            useMutation: useMutation
                        });
                        api["use" + $140b755e0815039f$var$capitalize(endpointName) + "Mutation"] = useMutation;
                    }
                }
            };
        }
    };
};
function $140b755e0815039f$export$f4e57f6132f56752(props) {
    var store = (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).useState(function() {
        var _c;
        return (0, $bEIGg.configureStore)({
            reducer: (_c = {}, _c[props.api.reducerPath] = props.api.reducer, _c),
            middleware: function(gDM) {
                return gDM().concat(props.api.middleware);
            }
        });
    })[0];
    (0, $2gcPZ.useEffect)(function() {
        return props.setupListeners === false ? void 0 : (0, $54649b17feedf59f$export$120c0dbb0351414c)(store.dispatch, props.setupListeners);
    }, [
        props.setupListeners,
        store.dispatch
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).createElement((0, $5293de6422d97033$export$2e2bcd8739ae039), {
        store: store,
        context: props.context
    }, props.children);
}
// src/query/react/index.ts
var $140b755e0815039f$export$9cdc2b9a8d94c842 = /* @__PURE__ */ (0, $54649b17feedf59f$export$f957748792d43646)((0, $54649b17feedf59f$export$eb718ff92afd6f9b)(), $140b755e0815039f$export$8b98f9e72008ec90());



/**
 * Fetches timeseries data from the Prometheus `query_range` endpoint.
 *
 * @param query Prometheus query string.
 * @param timeRange Time range to fetch the data for.
 */ async function $d9ef29a97e741a59$export$bf0e175980db8a80(query, timeRange, { baseUrl: baseUrl, mode: mode = "cors", ...requestInit }) {
    const [stepParam, stepSeconds] = $d9ef29a97e741a59$export$aa02a9ec6df7532d(timeRange);
    const params = new URLSearchParams();
    params.append("query", query);
    params.append("start", $d9ef29a97e741a59$export$812a2eab1c1beb61(timeRange.from, stepSeconds, Math.floor));
    params.append("end", $d9ef29a97e741a59$export$812a2eab1c1beb61(timeRange.to, stepSeconds, Math.ceil));
    params.append("step", stepParam);
    const url = `${baseUrl}/api/v1/query_range?${params.toString()}`;
    const response = await fetch(url, {
        mode: mode,
        ...requestInit
    });
    if (!response.ok) throw new Error("Error fetching prometheus data");
    const jsonResponse = await response.json();
    if (!$d9ef29a97e741a59$var$isObject(jsonResponse)) throw new Error("Unexpected response from Prometheus");
    const { data: data } = jsonResponse;
    if (!$d9ef29a97e741a59$var$isObject(data)) throw new Error("Invalid or missing data in Prometheus response");
    const { result: result } = data;
    if (!Array.isArray(result)) throw new Error("Invalid or missing results in Prometheus response");
    return result.map($d9ef29a97e741a59$export$2ff15115ee27d693);
}
/**
 * Maps an entry from the result array returned by the Prometheus API to a
 * Timeseries object.
 *
 * @param entry An entry returned by the Prometheus `query_range` API.
 */ function $d9ef29a97e741a59$export$2ff15115ee27d693(entry) {
    if (!$d9ef29a97e741a59$var$isObject(entry)) throw new Error("Unexpected entry in Prometheus response");
    const { metric: metric, values: values } = entry;
    if (!$d9ef29a97e741a59$var$isObject(metric) || !Array.isArray(values)) throw new Error("Invalid or missing fields in Prometheus entry");
    const { __name__: name = "", ...labels } = metric;
    if (typeof name !== "string") throw new Error("Invalid or missing name in Prometheus response");
    if (!$d9ef29a97e741a59$var$hasOnlyStringValues(labels)) throw new Error("Invalid or missing label value in Prometheus response");
    const metrics = values.map((value)=>{
        if (!Array.isArray(value) || value.length !== 2) throw new Error("Invalid or missing metric value in Prometheus response");
        return {
            time: new Date(value[0] * 1000).toISOString(),
            value: Number.parseFloat(value[1]),
            attributes: {},
            resource: {}
        };
    });
    return {
        name: name,
        labels: labels,
        metrics: metrics,
        attributes: {},
        resource: {},
        visible: true
    };
}
/**
 * Rounds the timestamp to a "grid" with intervals defined by the step size.
 * This assures that when we scroll a chart forward or backward in time, we
 * "snap" to the same grid, to avoid the issue of bucket realignment, giving
 * unexpected jumps in the graph.
 *
 * @param timestamp The timestamp to round.
 * @param stepSeconds The amount of seconds used for the step size.
 * @param round The rounding function to use. Use `Math.floor` for the start
 *              of the time range, and `Math.ceil` for the end.
 */ function $d9ef29a97e741a59$export$812a2eab1c1beb61(timestamp, stepSeconds, round) {
    const seconds = $d9ef29a97e741a59$var$getSecondsFromTimestamp(timestamp);
    return new Date(round(seconds / stepSeconds) * stepSeconds * 1000).toISOString();
}
/**
 * Calculates the step size to be used in Prometheus queries.
 *
 * @returns Step size, both as a string to use with Prometheus, and a number of
 *          seconds.
 */ function $d9ef29a97e741a59$export$aa02a9ec6df7532d(timeRange) {
    const from = $d9ef29a97e741a59$var$getSecondsFromTimestamp(timeRange.from);
    const to = $d9ef29a97e741a59$var$getSecondsFromTimestamp(timeRange.to);
    let step = (to - from) / 120;
    let secondsMultiplier = 1;
    let unit = "s";
    if (step >= 60) {
        step /= 60;
        secondsMultiplier = 60;
        unit = "m";
        if (step >= 60) {
            step /= 60;
            secondsMultiplier *= 60;
            unit = "h";
        }
    }
    const amount = Math.ceil(step);
    return [
        `${amount}${unit}`,
        amount * secondsMultiplier
    ];
}
function $d9ef29a97e741a59$var$getSecondsFromTimestamp(timestamp) {
    return +new Date(timestamp) / 1000;
}
function $d9ef29a97e741a59$var$hasOnlyStringValues(object) {
    return Object.values(object).every((label)=>typeof label === "string");
}
function $d9ef29a97e741a59$var$isObject(maybeObject) {
    return typeof maybeObject === "object" && maybeObject != null;
}


var $a30ca2726c0ab339$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($a30ca2726c0ab339$export$7debb50ef11d5e0b || ($a30ca2726c0ab339$export$7debb50ef11d5e0b = {}));
var $a30ca2726c0ab339$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($a30ca2726c0ab339$export$4aa2142c225fd5c7 || ($a30ca2726c0ab339$export$4aa2142c225fd5c7 = {}));
const $a30ca2726c0ab339$export$5716da67bfaa244d = $a30ca2726c0ab339$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $a30ca2726c0ab339$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $a30ca2726c0ab339$export$5716da67bfaa244d.undefined;
        case "string":
            return $a30ca2726c0ab339$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $a30ca2726c0ab339$export$5716da67bfaa244d.nan : $a30ca2726c0ab339$export$5716da67bfaa244d.number;
        case "boolean":
            return $a30ca2726c0ab339$export$5716da67bfaa244d.boolean;
        case "function":
            return $a30ca2726c0ab339$export$5716da67bfaa244d.function;
        case "bigint":
            return $a30ca2726c0ab339$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $a30ca2726c0ab339$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $a30ca2726c0ab339$export$5716da67bfaa244d.array;
            if (data === null) return $a30ca2726c0ab339$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $a30ca2726c0ab339$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $a30ca2726c0ab339$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $a30ca2726c0ab339$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $a30ca2726c0ab339$export$5716da67bfaa244d.date;
            return $a30ca2726c0ab339$export$5716da67bfaa244d.object;
        default:
            return $a30ca2726c0ab339$export$5716da67bfaa244d.unknown;
    }
};
const $a30ca2726c0ab339$export$5ba560653e4a1035 = $a30ca2726c0ab339$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $a30ca2726c0ab339$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $a30ca2726c0ab339$export$f98dac4b251ab333 extends Error {
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $a30ca2726c0ab339$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
$a30ca2726c0ab339$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $a30ca2726c0ab339$export$f98dac4b251ab333(issues);
    return error;
};
const $a30ca2726c0ab339$export$341b0b6e0a6f5099 = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $a30ca2726c0ab339$export$5716da67bfaa244d.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $a30ca2726c0ab339$export$7debb50ef11d5e0b.jsonStringifyReplacer)}`;
            break;
        case $a30ca2726c0ab339$export$5ba560653e4a1035.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$a30ca2726c0ab339$export$7debb50ef11d5e0b.joinValues(issue.keys, ", ")}`;
            break;
        case $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_union:
            message = `Invalid input`;
            break;
        case $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$a30ca2726c0ab339$export$7debb50ef11d5e0b.joinValues(issue.options)}`;
            break;
        case $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_enum_value:
            message = `Invalid enum value. Expected ${$a30ca2726c0ab339$export$7debb50ef11d5e0b.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_date:
            message = `Invalid date`;
            break;
        case $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $a30ca2726c0ab339$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $a30ca2726c0ab339$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $a30ca2726c0ab339$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $a30ca2726c0ab339$export$5ba560653e4a1035.custom:
            message = `Invalid input`;
            break;
        case $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $a30ca2726c0ab339$export$5ba560653e4a1035.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $a30ca2726c0ab339$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $a30ca2726c0ab339$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
let $a30ca2726c0ab339$var$overrideErrorMap = $a30ca2726c0ab339$export$341b0b6e0a6f5099;
function $a30ca2726c0ab339$export$1097a8289cfd22d7(map) {
    $a30ca2726c0ab339$var$overrideErrorMap = map;
}
function $a30ca2726c0ab339$export$32f27c719778d4c4() {
    return $a30ca2726c0ab339$var$overrideErrorMap;
}
const $a30ca2726c0ab339$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: issueData.message || errorMessage
    };
};
const $a30ca2726c0ab339$export$1526d2e05f74572 = [];
function $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, issueData) {
    const issue = $a30ca2726c0ab339$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            $a30ca2726c0ab339$export$32f27c719778d4c4(),
            $a30ca2726c0ab339$export$341b0b6e0a6f5099
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $a30ca2726c0ab339$export$5b20a5c3d05c1f6f {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $a30ca2726c0ab339$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs)syncPairs.push({
            key: await pair.key,
            value: await pair.value
        });
        return $a30ca2726c0ab339$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $a30ca2726c0ab339$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $a30ca2726c0ab339$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (typeof value.value !== "undefined" || pair.alwaysSet) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const $a30ca2726c0ab339$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $a30ca2726c0ab339$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $a30ca2726c0ab339$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $a30ca2726c0ab339$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $a30ca2726c0ab339$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $a30ca2726c0ab339$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $a30ca2726c0ab339$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
var $a30ca2726c0ab339$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($a30ca2726c0ab339$var$errorUtil || ($a30ca2726c0ab339$var$errorUtil = {}));
class $a30ca2726c0ab339$var$ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const $a30ca2726c0ab339$var$handleResult = (ctx, result)=>{
    if ($a30ca2726c0ab339$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $a30ca2726c0ab339$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $a30ca2726c0ab339$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError
        };
        return {
            message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $a30ca2726c0ab339$export$19342e026b58ebb7 {
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return $a30ca2726c0ab339$export$3e9057828ebd5c7a(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: $a30ca2726c0ab339$export$3e9057828ebd5c7a(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $a30ca2726c0ab339$export$5b20a5c3d05c1f6f(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: $a30ca2726c0ab339$export$3e9057828ebd5c7a(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ($a30ca2726c0ab339$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $a30ca2726c0ab339$export$3e9057828ebd5c7a(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $a30ca2726c0ab339$var$handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $a30ca2726c0ab339$export$3e9057828ebd5c7a(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ($a30ca2726c0ab339$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $a30ca2726c0ab339$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: $a30ca2726c0ab339$export$5ba560653e4a1035.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $a30ca2726c0ab339$export$a60af00cc0ce2582({
            schema: this,
            typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return $a30ca2726c0ab339$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $a30ca2726c0ab339$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $a30ca2726c0ab339$export$7acfc3e64785411.create(this, this._def);
    }
    promise() {
        return $a30ca2726c0ab339$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $a30ca2726c0ab339$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $a30ca2726c0ab339$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $a30ca2726c0ab339$export$a60af00cc0ce2582({
            ...$a30ca2726c0ab339$var$processCreateParams(this._def),
            schema: this,
            typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $a30ca2726c0ab339$export$bb19b37874861e7e({
            ...$a30ca2726c0ab339$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $a30ca2726c0ab339$export$66b0c798a395271f({
            typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$a30ca2726c0ab339$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $a30ca2726c0ab339$export$75a44ec6249ac76b({
            ...$a30ca2726c0ab339$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $a30ca2726c0ab339$export$a3c3ef8a0e95c6da.create(this, target);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const $a30ca2726c0ab339$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $a30ca2726c0ab339$var$cuid2Regex = /^[a-z][a-z0-9]*$/;
const $a30ca2726c0ab339$var$ulidRegex = /[0-9A-HJKMNP-TV-Z]{26}/;
const $a30ca2726c0ab339$var$uuidRegex = /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
const $a30ca2726c0ab339$var$emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $a30ca2726c0ab339$var$emojiRegex = /^(\p{Extended_Pictographic}|\p{Emoji_Component})+$/u;
const $a30ca2726c0ab339$var$ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/;
const $a30ca2726c0ab339$var$ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// Adapted from https://stackoverflow.com/a/3143231
const $a30ca2726c0ab339$var$datetimeRegex = (args)=>{
    if (args.precision) {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}Z$`);
    } else if (args.precision === 0) {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$`);
    } else {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$`);
    }
};
function $a30ca2726c0ab339$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $a30ca2726c0ab339$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $a30ca2726c0ab339$var$ipv6Regex.test(ip)) return true;
    return false;
}
class $a30ca2726c0ab339$export$1230eb29b8d3b502 extends $a30ca2726c0ab339$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this._regex = (regex, validation, message)=>this.refinement((data)=>regex.test(data), {
                validation: validation,
                code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_string,
                ...$a30ca2726c0ab339$var$errorUtil.errToObj(message)
            });
        /**
         * @deprecated Use z.string().min(1) instead.
         * @see {@link ZodString.min}
         */ this.nonempty = (message)=>this.min(1, $a30ca2726c0ab339$var$errorUtil.errToObj(message));
        this.trim = ()=>new $a30ca2726c0ab339$export$1230eb29b8d3b502({
                ...this._def,
                checks: [
                    ...this._def.checks,
                    {
                        kind: "trim"
                    }
                ]
            });
        this.toLowerCase = ()=>new $a30ca2726c0ab339$export$1230eb29b8d3b502({
                ...this._def,
                checks: [
                    ...this._def.checks,
                    {
                        kind: "toLowerCase"
                    }
                ]
            });
        this.toUpperCase = ()=>new $a30ca2726c0ab339$export$1230eb29b8d3b502({
                ...this._def,
                checks: [
                    ...this._def.checks,
                    {
                        kind: "toUpperCase"
                    }
                ]
            });
    }
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $a30ca2726c0ab339$export$5716da67bfaa244d.string) {
            const ctx = this._getOrReturnCtx(input);
            $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_type,
                expected: $a30ca2726c0ab339$export$5716da67bfaa244d.string,
                received: ctx.parsedType
            });
            return $a30ca2726c0ab339$export$9a105a556e65c2c0;
        }
        const status = new $a30ca2726c0ab339$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                        code: $a30ca2726c0ab339$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                        code: $a30ca2726c0ab339$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                        code: $a30ca2726c0ab339$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                        code: $a30ca2726c0ab339$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$a30ca2726c0ab339$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                        validation: "email",
                        code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$a30ca2726c0ab339$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                        validation: "emoji",
                        code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$a30ca2726c0ab339$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                        validation: "uuid",
                        code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$a30ca2726c0ab339$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                        validation: "cuid",
                        code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$a30ca2726c0ab339$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                        validation: "cuid2",
                        code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$a30ca2726c0ab339$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                        validation: "ulid",
                        code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                    validation: "url",
                    code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                        validation: "regex",
                        code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                        code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                        code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                        code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $a30ca2726c0ab339$var$datetimeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                        code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$a30ca2726c0ab339$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                        validation: "ip",
                        code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $a30ca2726c0ab339$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _addCheck(check) {
        return new $a30ca2726c0ab339$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...$a30ca2726c0ab339$var$errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...$a30ca2726c0ab339$var$errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...$a30ca2726c0ab339$var$errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...$a30ca2726c0ab339$var$errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...$a30ca2726c0ab339$var$errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...$a30ca2726c0ab339$var$errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...$a30ca2726c0ab339$var$errorUtil.errToObj(message)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...$a30ca2726c0ab339$var$errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        var _a;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            ...$a30ca2726c0ab339$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...$a30ca2726c0ab339$var$errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...$a30ca2726c0ab339$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...$a30ca2726c0ab339$var$errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...$a30ca2726c0ab339$var$errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...$a30ca2726c0ab339$var$errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...$a30ca2726c0ab339$var$errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...$a30ca2726c0ab339$var$errorUtil.errToObj(message)
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$a30ca2726c0ab339$export$1230eb29b8d3b502.create = (params)=>{
    var _a;
    return new $a30ca2726c0ab339$export$1230eb29b8d3b502({
        checks: [],
        typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$a30ca2726c0ab339$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $a30ca2726c0ab339$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $a30ca2726c0ab339$export$5b070a55c0c43e09 extends $a30ca2726c0ab339$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $a30ca2726c0ab339$export$5716da67bfaa244d.number) {
            const ctx = this._getOrReturnCtx(input);
            $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_type,
                expected: $a30ca2726c0ab339$export$5716da67bfaa244d.number,
                received: ctx.parsedType
            });
            return $a30ca2726c0ab339$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $a30ca2726c0ab339$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$a30ca2726c0ab339$export$7debb50ef11d5e0b.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                        code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                        code: $a30ca2726c0ab339$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                        code: $a30ca2726c0ab339$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($a30ca2726c0ab339$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                        code: $a30ca2726c0ab339$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                        code: $a30ca2726c0ab339$export$5ba560653e4a1035.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $a30ca2726c0ab339$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $a30ca2726c0ab339$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $a30ca2726c0ab339$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $a30ca2726c0ab339$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $a30ca2726c0ab339$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $a30ca2726c0ab339$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $a30ca2726c0ab339$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $a30ca2726c0ab339$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $a30ca2726c0ab339$var$errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $a30ca2726c0ab339$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $a30ca2726c0ab339$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $a30ca2726c0ab339$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $a30ca2726c0ab339$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $a30ca2726c0ab339$var$errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $a30ca2726c0ab339$var$errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $a30ca2726c0ab339$var$errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $a30ca2726c0ab339$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $a30ca2726c0ab339$export$7debb50ef11d5e0b.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
$a30ca2726c0ab339$export$5b070a55c0c43e09.create = (params)=>{
    return new $a30ca2726c0ab339$export$5b070a55c0c43e09({
        checks: [],
        typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$a30ca2726c0ab339$var$processCreateParams(params)
    });
};
class $a30ca2726c0ab339$export$67d741fd70ff98f4 extends $a30ca2726c0ab339$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) input.data = BigInt(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $a30ca2726c0ab339$export$5716da67bfaa244d.bigint) {
            const ctx = this._getOrReturnCtx(input);
            $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_type,
                expected: $a30ca2726c0ab339$export$5716da67bfaa244d.bigint,
                received: ctx.parsedType
            });
            return $a30ca2726c0ab339$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $a30ca2726c0ab339$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                        code: $a30ca2726c0ab339$export$5ba560653e4a1035.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                        code: $a30ca2726c0ab339$export$5ba560653e4a1035.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                        code: $a30ca2726c0ab339$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $a30ca2726c0ab339$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $a30ca2726c0ab339$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $a30ca2726c0ab339$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $a30ca2726c0ab339$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $a30ca2726c0ab339$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $a30ca2726c0ab339$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $a30ca2726c0ab339$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $a30ca2726c0ab339$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $a30ca2726c0ab339$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $a30ca2726c0ab339$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $a30ca2726c0ab339$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $a30ca2726c0ab339$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $a30ca2726c0ab339$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$a30ca2726c0ab339$export$67d741fd70ff98f4.create = (params)=>{
    var _a;
    return new $a30ca2726c0ab339$export$67d741fd70ff98f4({
        checks: [],
        typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$a30ca2726c0ab339$var$processCreateParams(params)
    });
};
class $a30ca2726c0ab339$export$723d146f80596191 extends $a30ca2726c0ab339$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $a30ca2726c0ab339$export$5716da67bfaa244d.boolean) {
            const ctx = this._getOrReturnCtx(input);
            $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_type,
                expected: $a30ca2726c0ab339$export$5716da67bfaa244d.boolean,
                received: ctx.parsedType
            });
            return $a30ca2726c0ab339$export$9a105a556e65c2c0;
        }
        return $a30ca2726c0ab339$export$c6813a8d51f77eaf(input.data);
    }
}
$a30ca2726c0ab339$export$723d146f80596191.create = (params)=>{
    return new $a30ca2726c0ab339$export$723d146f80596191({
        typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$a30ca2726c0ab339$var$processCreateParams(params)
    });
};
class $a30ca2726c0ab339$export$e974be33bdc55521 extends $a30ca2726c0ab339$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $a30ca2726c0ab339$export$5716da67bfaa244d.date) {
            const ctx = this._getOrReturnCtx(input);
            $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_type,
                expected: $a30ca2726c0ab339$export$5716da67bfaa244d.date,
                received: ctx.parsedType
            });
            return $a30ca2726c0ab339$export$9a105a556e65c2c0;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_date
            });
            return $a30ca2726c0ab339$export$9a105a556e65c2c0;
        }
        const status = new $a30ca2726c0ab339$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                        code: $a30ca2726c0ab339$export$5ba560653e4a1035.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                        code: $a30ca2726c0ab339$export$5ba560653e4a1035.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $a30ca2726c0ab339$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $a30ca2726c0ab339$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $a30ca2726c0ab339$var$errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $a30ca2726c0ab339$var$errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$a30ca2726c0ab339$export$e974be33bdc55521.create = (params)=>{
    return new $a30ca2726c0ab339$export$e974be33bdc55521({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodDate,
        ...$a30ca2726c0ab339$var$processCreateParams(params)
    });
};
class $a30ca2726c0ab339$export$bcc3b40f6b638044 extends $a30ca2726c0ab339$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $a30ca2726c0ab339$export$5716da67bfaa244d.symbol) {
            const ctx = this._getOrReturnCtx(input);
            $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_type,
                expected: $a30ca2726c0ab339$export$5716da67bfaa244d.symbol,
                received: ctx.parsedType
            });
            return $a30ca2726c0ab339$export$9a105a556e65c2c0;
        }
        return $a30ca2726c0ab339$export$c6813a8d51f77eaf(input.data);
    }
}
$a30ca2726c0ab339$export$bcc3b40f6b638044.create = (params)=>{
    return new $a30ca2726c0ab339$export$bcc3b40f6b638044({
        typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodSymbol,
        ...$a30ca2726c0ab339$var$processCreateParams(params)
    });
};
class $a30ca2726c0ab339$export$4e780e961c30340d extends $a30ca2726c0ab339$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $a30ca2726c0ab339$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_type,
                expected: $a30ca2726c0ab339$export$5716da67bfaa244d.undefined,
                received: ctx.parsedType
            });
            return $a30ca2726c0ab339$export$9a105a556e65c2c0;
        }
        return $a30ca2726c0ab339$export$c6813a8d51f77eaf(input.data);
    }
}
$a30ca2726c0ab339$export$4e780e961c30340d.create = (params)=>{
    return new $a30ca2726c0ab339$export$4e780e961c30340d({
        typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodUndefined,
        ...$a30ca2726c0ab339$var$processCreateParams(params)
    });
};
class $a30ca2726c0ab339$export$a96281f914484f2d extends $a30ca2726c0ab339$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $a30ca2726c0ab339$export$5716da67bfaa244d.null) {
            const ctx = this._getOrReturnCtx(input);
            $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_type,
                expected: $a30ca2726c0ab339$export$5716da67bfaa244d.null,
                received: ctx.parsedType
            });
            return $a30ca2726c0ab339$export$9a105a556e65c2c0;
        }
        return $a30ca2726c0ab339$export$c6813a8d51f77eaf(input.data);
    }
}
$a30ca2726c0ab339$export$a96281f914484f2d.create = (params)=>{
    return new $a30ca2726c0ab339$export$a96281f914484f2d({
        typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodNull,
        ...$a30ca2726c0ab339$var$processCreateParams(params)
    });
};
class $a30ca2726c0ab339$export$b9d1edb536b4e4eb extends $a30ca2726c0ab339$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return $a30ca2726c0ab339$export$c6813a8d51f77eaf(input.data);
    }
}
$a30ca2726c0ab339$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $a30ca2726c0ab339$export$b9d1edb536b4e4eb({
        typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodAny,
        ...$a30ca2726c0ab339$var$processCreateParams(params)
    });
};
class $a30ca2726c0ab339$export$ef3b1bb1630977ae extends $a30ca2726c0ab339$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return $a30ca2726c0ab339$export$c6813a8d51f77eaf(input.data);
    }
}
$a30ca2726c0ab339$export$ef3b1bb1630977ae.create = (params)=>{
    return new $a30ca2726c0ab339$export$ef3b1bb1630977ae({
        typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodUnknown,
        ...$a30ca2726c0ab339$var$processCreateParams(params)
    });
};
class $a30ca2726c0ab339$export$1e576a20c3ce9fb5 extends $a30ca2726c0ab339$export$19342e026b58ebb7 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
            code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_type,
            expected: $a30ca2726c0ab339$export$5716da67bfaa244d.never,
            received: ctx.parsedType
        });
        return $a30ca2726c0ab339$export$9a105a556e65c2c0;
    }
}
$a30ca2726c0ab339$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $a30ca2726c0ab339$export$1e576a20c3ce9fb5({
        typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodNever,
        ...$a30ca2726c0ab339$var$processCreateParams(params)
    });
};
class $a30ca2726c0ab339$export$7d39f5df85f21031 extends $a30ca2726c0ab339$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $a30ca2726c0ab339$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_type,
                expected: $a30ca2726c0ab339$export$5716da67bfaa244d.void,
                received: ctx.parsedType
            });
            return $a30ca2726c0ab339$export$9a105a556e65c2c0;
        }
        return $a30ca2726c0ab339$export$c6813a8d51f77eaf(input.data);
    }
}
$a30ca2726c0ab339$export$7d39f5df85f21031.create = (params)=>{
    return new $a30ca2726c0ab339$export$7d39f5df85f21031({
        typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodVoid,
        ...$a30ca2726c0ab339$var$processCreateParams(params)
    });
};
class $a30ca2726c0ab339$export$7acfc3e64785411 extends $a30ca2726c0ab339$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $a30ca2726c0ab339$export$5716da67bfaa244d.array) {
            $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_type,
                expected: $a30ca2726c0ab339$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $a30ca2726c0ab339$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                    code: tooBig ? $a30ca2726c0ab339$export$5ba560653e4a1035.too_big : $a30ca2726c0ab339$export$5ba560653e4a1035.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                    code: $a30ca2726c0ab339$export$5ba560653e4a1035.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                    code: $a30ca2726c0ab339$export$5ba560653e4a1035.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $a30ca2726c0ab339$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $a30ca2726c0ab339$export$5b20a5c3d05c1f6f.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $a30ca2726c0ab339$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $a30ca2726c0ab339$export$5b20a5c3d05c1f6f.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $a30ca2726c0ab339$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: $a30ca2726c0ab339$var$errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $a30ca2726c0ab339$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: $a30ca2726c0ab339$var$errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new $a30ca2726c0ab339$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: $a30ca2726c0ab339$var$errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$a30ca2726c0ab339$export$7acfc3e64785411.create = (schema, params)=>{
    return new $a30ca2726c0ab339$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodArray,
        ...$a30ca2726c0ab339$var$processCreateParams(params)
    });
};
function $a30ca2726c0ab339$var$deepPartialify(schema) {
    if (schema instanceof $a30ca2726c0ab339$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $a30ca2726c0ab339$export$aa56fec1e9d629b8.create($a30ca2726c0ab339$var$deepPartialify(fieldSchema));
        }
        return new $a30ca2726c0ab339$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $a30ca2726c0ab339$export$7acfc3e64785411) return new $a30ca2726c0ab339$export$7acfc3e64785411({
        ...schema._def,
        type: $a30ca2726c0ab339$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $a30ca2726c0ab339$export$aa56fec1e9d629b8) return $a30ca2726c0ab339$export$aa56fec1e9d629b8.create($a30ca2726c0ab339$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $a30ca2726c0ab339$export$aaac0b8b429cef5) return $a30ca2726c0ab339$export$aaac0b8b429cef5.create($a30ca2726c0ab339$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $a30ca2726c0ab339$export$e2a18bb771d8e6a3) return $a30ca2726c0ab339$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$a30ca2726c0ab339$var$deepPartialify(item)));
    else return schema;
}
class $a30ca2726c0ab339$export$736315c5b55efbad extends $a30ca2726c0ab339$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $a30ca2726c0ab339$export$7debb50ef11d5e0b.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $a30ca2726c0ab339$export$5716da67bfaa244d.object) {
            const ctx = this._getOrReturnCtx(input);
            $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_type,
                expected: $a30ca2726c0ab339$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $a30ca2726c0ab339$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $a30ca2726c0ab339$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $a30ca2726c0ab339$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $a30ca2726c0ab339$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                        code: $a30ca2726c0ab339$export$5ba560653e4a1035.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $a30ca2726c0ab339$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                syncPairs.push({
                    key: key,
                    value: await pair.value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $a30ca2726c0ab339$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        });
        else return $a30ca2726c0ab339$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $a30ca2726c0ab339$var$errorUtil.errToObj;
        return new $a30ca2726c0ab339$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    var _a, _b, _c, _d;
                    const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (_d = $a30ca2726c0ab339$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $a30ca2726c0ab339$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $a30ca2726c0ab339$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $a30ca2726c0ab339$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $a30ca2726c0ab339$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $a30ca2726c0ab339$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        $a30ca2726c0ab339$export$7debb50ef11d5e0b.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $a30ca2726c0ab339$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        $a30ca2726c0ab339$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $a30ca2726c0ab339$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $a30ca2726c0ab339$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $a30ca2726c0ab339$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $a30ca2726c0ab339$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        $a30ca2726c0ab339$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $a30ca2726c0ab339$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $a30ca2726c0ab339$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $a30ca2726c0ab339$var$createZodEnum($a30ca2726c0ab339$export$7debb50ef11d5e0b.objectKeys(this.shape));
    }
}
$a30ca2726c0ab339$export$736315c5b55efbad.create = (shape, params)=>{
    return new $a30ca2726c0ab339$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $a30ca2726c0ab339$export$1e576a20c3ce9fb5.create(),
        typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodObject,
        ...$a30ca2726c0ab339$var$processCreateParams(params)
    });
};
$a30ca2726c0ab339$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $a30ca2726c0ab339$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $a30ca2726c0ab339$export$1e576a20c3ce9fb5.create(),
        typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodObject,
        ...$a30ca2726c0ab339$var$processCreateParams(params)
    });
};
$a30ca2726c0ab339$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $a30ca2726c0ab339$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $a30ca2726c0ab339$export$1e576a20c3ce9fb5.create(),
        typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodObject,
        ...$a30ca2726c0ab339$var$processCreateParams(params)
    });
};
class $a30ca2726c0ab339$export$a8b236cb5070a311 extends $a30ca2726c0ab339$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $a30ca2726c0ab339$export$f98dac4b251ab333(result.ctx.common.issues));
            $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $a30ca2726c0ab339$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $a30ca2726c0ab339$export$f98dac4b251ab333(issues));
            $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $a30ca2726c0ab339$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$a30ca2726c0ab339$export$a8b236cb5070a311.create = (types, params)=>{
    return new $a30ca2726c0ab339$export$a8b236cb5070a311({
        options: types,
        typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodUnion,
        ...$a30ca2726c0ab339$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $a30ca2726c0ab339$var$getDiscriminator = (type)=>{
    if (type instanceof $a30ca2726c0ab339$export$378d0cfce37406e6) return $a30ca2726c0ab339$var$getDiscriminator(type.schema);
    else if (type instanceof $a30ca2726c0ab339$export$a60af00cc0ce2582) return $a30ca2726c0ab339$var$getDiscriminator(type.innerType());
    else if (type instanceof $a30ca2726c0ab339$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $a30ca2726c0ab339$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $a30ca2726c0ab339$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return Object.keys(type.enum);
    else if (type instanceof $a30ca2726c0ab339$export$bb19b37874861e7e) return $a30ca2726c0ab339$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $a30ca2726c0ab339$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $a30ca2726c0ab339$export$a96281f914484f2d) return [
        null
    ];
    else return null;
};
class $a30ca2726c0ab339$export$5ef2424805ac76a3 extends $a30ca2726c0ab339$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $a30ca2726c0ab339$export$5716da67bfaa244d.object) {
            $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_type,
                expected: $a30ca2726c0ab339$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $a30ca2726c0ab339$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $a30ca2726c0ab339$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $a30ca2726c0ab339$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $a30ca2726c0ab339$export$5ef2424805ac76a3({
            typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$a30ca2726c0ab339$var$processCreateParams(params)
        });
    }
}
function $a30ca2726c0ab339$var$mergeValues(a, b) {
    const aType = $a30ca2726c0ab339$export$3e9057828ebd5c7a(a);
    const bType = $a30ca2726c0ab339$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $a30ca2726c0ab339$export$5716da67bfaa244d.object && bType === $a30ca2726c0ab339$export$5716da67bfaa244d.object) {
        const bKeys = $a30ca2726c0ab339$export$7debb50ef11d5e0b.objectKeys(b);
        const sharedKeys = $a30ca2726c0ab339$export$7debb50ef11d5e0b.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $a30ca2726c0ab339$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $a30ca2726c0ab339$export$5716da67bfaa244d.array && bType === $a30ca2726c0ab339$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $a30ca2726c0ab339$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $a30ca2726c0ab339$export$5716da67bfaa244d.date && bType === $a30ca2726c0ab339$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $a30ca2726c0ab339$export$c02deaf0bb5203d4 extends $a30ca2726c0ab339$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ($a30ca2726c0ab339$export$afa861e3c5730743(parsedLeft) || $a30ca2726c0ab339$export$afa861e3c5730743(parsedRight)) return $a30ca2726c0ab339$export$9a105a556e65c2c0;
            const merged = $a30ca2726c0ab339$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                    code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_intersection_types
                });
                return $a30ca2726c0ab339$export$9a105a556e65c2c0;
            }
            if ($a30ca2726c0ab339$export$910b6cdd390341b3(parsedLeft) || $a30ca2726c0ab339$export$910b6cdd390341b3(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$a30ca2726c0ab339$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $a30ca2726c0ab339$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodIntersection,
        ...$a30ca2726c0ab339$var$processCreateParams(params)
    });
};
class $a30ca2726c0ab339$export$e2a18bb771d8e6a3 extends $a30ca2726c0ab339$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $a30ca2726c0ab339$export$5716da67bfaa244d.array) {
            $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_type,
                expected: $a30ca2726c0ab339$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $a30ca2726c0ab339$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                code: $a30ca2726c0ab339$export$5ba560653e4a1035.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $a30ca2726c0ab339$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                code: $a30ca2726c0ab339$export$5ba560653e4a1035.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $a30ca2726c0ab339$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $a30ca2726c0ab339$export$5b20a5c3d05c1f6f.mergeArray(status, results);
        });
        else return $a30ca2726c0ab339$export$5b20a5c3d05c1f6f.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $a30ca2726c0ab339$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$a30ca2726c0ab339$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $a30ca2726c0ab339$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$a30ca2726c0ab339$var$processCreateParams(params)
    });
};
class $a30ca2726c0ab339$export$a2acc09968cb4b7f extends $a30ca2726c0ab339$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $a30ca2726c0ab339$export$5716da67bfaa244d.object) {
            $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_type,
                expected: $a30ca2726c0ab339$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $a30ca2726c0ab339$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $a30ca2726c0ab339$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $a30ca2726c0ab339$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key))
        });
        if (ctx.common.async) return $a30ca2726c0ab339$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
        else return $a30ca2726c0ab339$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $a30ca2726c0ab339$export$19342e026b58ebb7) return new $a30ca2726c0ab339$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodRecord,
            ...$a30ca2726c0ab339$var$processCreateParams(third)
        });
        return new $a30ca2726c0ab339$export$a2acc09968cb4b7f({
            keyType: $a30ca2726c0ab339$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodRecord,
            ...$a30ca2726c0ab339$var$processCreateParams(second)
        });
    }
}
class $a30ca2726c0ab339$export$163b6a2b712d9542 extends $a30ca2726c0ab339$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $a30ca2726c0ab339$export$5716da67bfaa244d.map) {
            $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_type,
                expected: $a30ca2726c0ab339$export$5716da67bfaa244d.map,
                received: ctx.parsedType
            });
            return $a30ca2726c0ab339$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $a30ca2726c0ab339$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $a30ca2726c0ab339$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $a30ca2726c0ab339$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $a30ca2726c0ab339$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$a30ca2726c0ab339$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $a30ca2726c0ab339$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodMap,
        ...$a30ca2726c0ab339$var$processCreateParams(params)
    });
};
class $a30ca2726c0ab339$export$977057706f816712 extends $a30ca2726c0ab339$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $a30ca2726c0ab339$export$5716da67bfaa244d.set) {
            $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_type,
                expected: $a30ca2726c0ab339$export$5716da67bfaa244d.set,
                received: ctx.parsedType
            });
            return $a30ca2726c0ab339$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                    code: $a30ca2726c0ab339$export$5ba560653e4a1035.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                    code: $a30ca2726c0ab339$export$5ba560653e4a1035.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $a30ca2726c0ab339$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $a30ca2726c0ab339$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $a30ca2726c0ab339$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: $a30ca2726c0ab339$var$errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $a30ca2726c0ab339$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: $a30ca2726c0ab339$var$errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$a30ca2726c0ab339$export$977057706f816712.create = (valueType, params)=>{
    return new $a30ca2726c0ab339$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodSet,
        ...$a30ca2726c0ab339$var$processCreateParams(params)
    });
};
class $a30ca2726c0ab339$export$d4602ba55673f53c extends $a30ca2726c0ab339$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $a30ca2726c0ab339$export$5716da67bfaa244d.function) {
            $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_type,
                expected: $a30ca2726c0ab339$export$5716da67bfaa244d.function,
                received: ctx.parsedType
            });
            return $a30ca2726c0ab339$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return $a30ca2726c0ab339$export$244a85fde9c419ed({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $a30ca2726c0ab339$export$32f27c719778d4c4(),
                    $a30ca2726c0ab339$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return $a30ca2726c0ab339$export$244a85fde9c419ed({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $a30ca2726c0ab339$export$32f27c719778d4c4(),
                    $a30ca2726c0ab339$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $a30ca2726c0ab339$export$3f196b0127d6e50a) return $a30ca2726c0ab339$export$c6813a8d51f77eaf(async (...args)=>{
            const error = new $a30ca2726c0ab339$export$f98dac4b251ab333([]);
            const parsedArgs = await this._def.args.parseAsync(args, params).catch((e)=>{
                error.addIssue(makeArgsIssue(args, e));
                throw error;
            });
            const result = await fn(...parsedArgs);
            const parsedReturns = await this._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                error.addIssue(makeReturnsIssue(result, e));
                throw error;
            });
            return parsedReturns;
        });
        else return $a30ca2726c0ab339$export$c6813a8d51f77eaf((...args)=>{
            const parsedArgs = this._def.args.safeParse(args, params);
            if (!parsedArgs.success) throw new $a30ca2726c0ab339$export$f98dac4b251ab333([
                makeArgsIssue(args, parsedArgs.error)
            ]);
            const result = fn(...parsedArgs.data);
            const parsedReturns = this._def.returns.safeParse(result, params);
            if (!parsedReturns.success) throw new $a30ca2726c0ab339$export$f98dac4b251ab333([
                makeReturnsIssue(result, parsedReturns.error)
            ]);
            return parsedReturns.data;
        });
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $a30ca2726c0ab339$export$d4602ba55673f53c({
            ...this._def,
            args: $a30ca2726c0ab339$export$e2a18bb771d8e6a3.create(items).rest($a30ca2726c0ab339$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $a30ca2726c0ab339$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $a30ca2726c0ab339$export$d4602ba55673f53c({
            args: args ? args : $a30ca2726c0ab339$export$e2a18bb771d8e6a3.create([]).rest($a30ca2726c0ab339$export$ef3b1bb1630977ae.create()),
            returns: returns || $a30ca2726c0ab339$export$ef3b1bb1630977ae.create(),
            typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodFunction,
            ...$a30ca2726c0ab339$var$processCreateParams(params)
        });
    }
}
class $a30ca2726c0ab339$export$378d0cfce37406e6 extends $a30ca2726c0ab339$export$19342e026b58ebb7 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$a30ca2726c0ab339$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $a30ca2726c0ab339$export$378d0cfce37406e6({
        getter: getter,
        typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodLazy,
        ...$a30ca2726c0ab339$var$processCreateParams(params)
    });
};
class $a30ca2726c0ab339$export$7e44096782a165d3 extends $a30ca2726c0ab339$export$19342e026b58ebb7 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_literal,
                expected: this._def.value
            });
            return $a30ca2726c0ab339$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$a30ca2726c0ab339$export$7e44096782a165d3.create = (value, params)=>{
    return new $a30ca2726c0ab339$export$7e44096782a165d3({
        value: value,
        typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodLiteral,
        ...$a30ca2726c0ab339$var$processCreateParams(params)
    });
};
function $a30ca2726c0ab339$var$createZodEnum(values, params) {
    return new $a30ca2726c0ab339$export$d325d1f0e1c20179({
        values: values,
        typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodEnum,
        ...$a30ca2726c0ab339$var$processCreateParams(params)
    });
}
class $a30ca2726c0ab339$export$d325d1f0e1c20179 extends $a30ca2726c0ab339$export$19342e026b58ebb7 {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                expected: $a30ca2726c0ab339$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_type
            });
            return $a30ca2726c0ab339$export$9a105a556e65c2c0;
        }
        if (this._def.values.indexOf(input.data) === -1) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $a30ca2726c0ab339$export$9a105a556e65c2c0;
        }
        return $a30ca2726c0ab339$export$c6813a8d51f77eaf(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values) {
        return $a30ca2726c0ab339$export$d325d1f0e1c20179.create(values);
    }
    exclude(values) {
        return $a30ca2726c0ab339$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)));
    }
}
$a30ca2726c0ab339$export$d325d1f0e1c20179.create = $a30ca2726c0ab339$var$createZodEnum;
class $a30ca2726c0ab339$export$370b2e8d6d6f5c56 extends $a30ca2726c0ab339$export$19342e026b58ebb7 {
    _parse(input) {
        const nativeEnumValues = $a30ca2726c0ab339$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $a30ca2726c0ab339$export$5716da67bfaa244d.string && ctx.parsedType !== $a30ca2726c0ab339$export$5716da67bfaa244d.number) {
            const expectedValues = $a30ca2726c0ab339$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                expected: $a30ca2726c0ab339$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_type
            });
            return $a30ca2726c0ab339$export$9a105a556e65c2c0;
        }
        if (nativeEnumValues.indexOf(input.data) === -1) {
            const expectedValues = $a30ca2726c0ab339$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $a30ca2726c0ab339$export$9a105a556e65c2c0;
        }
        return $a30ca2726c0ab339$export$c6813a8d51f77eaf(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$a30ca2726c0ab339$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $a30ca2726c0ab339$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodNativeEnum,
        ...$a30ca2726c0ab339$var$processCreateParams(params)
    });
};
class $a30ca2726c0ab339$export$3f196b0127d6e50a extends $a30ca2726c0ab339$export$19342e026b58ebb7 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $a30ca2726c0ab339$export$5716da67bfaa244d.promise && ctx.common.async === false) {
            $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_type,
                expected: $a30ca2726c0ab339$export$5716da67bfaa244d.promise,
                received: ctx.parsedType
            });
            return $a30ca2726c0ab339$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === $a30ca2726c0ab339$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
        return $a30ca2726c0ab339$export$c6813a8d51f77eaf(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$a30ca2726c0ab339$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $a30ca2726c0ab339$export$3f196b0127d6e50a({
        type: schema,
        typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodPromise,
        ...$a30ca2726c0ab339$var$processCreateParams(params)
    });
};
class $a30ca2726c0ab339$export$a60af00cc0ce2582 extends $a30ca2726c0ab339$export$19342e026b58ebb7 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $a30ca2726c0ab339$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data);
            if (ctx.common.async) return Promise.resolve(processed).then((processed)=>{
                return this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
            });
            else return this._def.schema._parseSync({
                data: processed,
                path: ctx.path,
                parent: ctx
            });
        }
        const checkCtx = {
            addIssue: (arg)=>{
                $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $a30ca2726c0ab339$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $a30ca2726c0ab339$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!$a30ca2726c0ab339$export$1ea939691cdc45b8(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!$a30ca2726c0ab339$export$1ea939691cdc45b8(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $a30ca2726c0ab339$export$7debb50ef11d5e0b.assertNever(effect);
    }
}
$a30ca2726c0ab339$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $a30ca2726c0ab339$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$a30ca2726c0ab339$var$processCreateParams(params)
    });
};
$a30ca2726c0ab339$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $a30ca2726c0ab339$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodEffects,
        ...$a30ca2726c0ab339$var$processCreateParams(params)
    });
};
class $a30ca2726c0ab339$export$aa56fec1e9d629b8 extends $a30ca2726c0ab339$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $a30ca2726c0ab339$export$5716da67bfaa244d.undefined) return $a30ca2726c0ab339$export$c6813a8d51f77eaf(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$a30ca2726c0ab339$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $a30ca2726c0ab339$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodOptional,
        ...$a30ca2726c0ab339$var$processCreateParams(params)
    });
};
class $a30ca2726c0ab339$export$aaac0b8b429cef5 extends $a30ca2726c0ab339$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $a30ca2726c0ab339$export$5716da67bfaa244d.null) return $a30ca2726c0ab339$export$c6813a8d51f77eaf(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$a30ca2726c0ab339$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $a30ca2726c0ab339$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodNullable,
        ...$a30ca2726c0ab339$var$processCreateParams(params)
    });
};
class $a30ca2726c0ab339$export$bb19b37874861e7e extends $a30ca2726c0ab339$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $a30ca2726c0ab339$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$a30ca2726c0ab339$export$bb19b37874861e7e.create = (type, params)=>{
    return new $a30ca2726c0ab339$export$bb19b37874861e7e({
        innerType: type,
        typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$a30ca2726c0ab339$var$processCreateParams(params)
    });
};
class $a30ca2726c0ab339$export$75a44ec6249ac76b extends $a30ca2726c0ab339$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ($a30ca2726c0ab339$export$aefee5ebe1dcfd9e(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $a30ca2726c0ab339$export$f98dac4b251ab333(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $a30ca2726c0ab339$export$f98dac4b251ab333(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$a30ca2726c0ab339$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $a30ca2726c0ab339$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$a30ca2726c0ab339$var$processCreateParams(params)
    });
};
class $a30ca2726c0ab339$export$26ccfa0145e8511f extends $a30ca2726c0ab339$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $a30ca2726c0ab339$export$5716da67bfaa244d.nan) {
            const ctx = this._getOrReturnCtx(input);
            $a30ca2726c0ab339$export$db7caee60e5d514d(ctx, {
                code: $a30ca2726c0ab339$export$5ba560653e4a1035.invalid_type,
                expected: $a30ca2726c0ab339$export$5716da67bfaa244d.nan,
                received: ctx.parsedType
            });
            return $a30ca2726c0ab339$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$a30ca2726c0ab339$export$26ccfa0145e8511f.create = (params)=>{
    return new $a30ca2726c0ab339$export$26ccfa0145e8511f({
        typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodNaN,
        ...$a30ca2726c0ab339$var$processCreateParams(params)
    });
};
const $a30ca2726c0ab339$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $a30ca2726c0ab339$export$66b0c798a395271f extends $a30ca2726c0ab339$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $a30ca2726c0ab339$export$a3c3ef8a0e95c6da extends $a30ca2726c0ab339$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $a30ca2726c0ab339$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return $a30ca2726c0ab339$export$325a211da9693fcf(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $a30ca2726c0ab339$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $a30ca2726c0ab339$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $a30ca2726c0ab339$export$558106ce543bd011.ZodPipeline
        });
    }
}
const $a30ca2726c0ab339$export$4c00f665f0d4b443 = (check, params = {}, /*
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal)=>{
    if (check) return $a30ca2726c0ab339$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        var _a, _b;
        if (!check(data)) {
            const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            const p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue({
                code: "custom",
                ...p2,
                fatal: _fatal
            });
        }
    });
    return $a30ca2726c0ab339$export$b9d1edb536b4e4eb.create();
};
const $a30ca2726c0ab339$export$1ee8ee30835eab8b = {
    object: $a30ca2726c0ab339$export$736315c5b55efbad.lazycreate
};
var $a30ca2726c0ab339$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
})($a30ca2726c0ab339$export$558106ce543bd011 || ($a30ca2726c0ab339$export$558106ce543bd011 = {}));
const $a30ca2726c0ab339$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$a30ca2726c0ab339$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $a30ca2726c0ab339$export$22b082955e083ec3 = $a30ca2726c0ab339$export$1230eb29b8d3b502.create;
const $a30ca2726c0ab339$export$98e628dec113755e = $a30ca2726c0ab339$export$5b070a55c0c43e09.create;
const $a30ca2726c0ab339$export$9e06de0973666692 = $a30ca2726c0ab339$export$26ccfa0145e8511f.create;
const $a30ca2726c0ab339$export$a0f65b52274bcc00 = $a30ca2726c0ab339$export$67d741fd70ff98f4.create;
const $a30ca2726c0ab339$export$4a21f16c33752377 = $a30ca2726c0ab339$export$723d146f80596191.create;
const $a30ca2726c0ab339$export$324d90190a8b822a = $a30ca2726c0ab339$export$e974be33bdc55521.create;
const $a30ca2726c0ab339$export$8f701197936bc2a6 = $a30ca2726c0ab339$export$bcc3b40f6b638044.create;
const $a30ca2726c0ab339$export$1db45310990710a5 = $a30ca2726c0ab339$export$4e780e961c30340d.create;
const $a30ca2726c0ab339$export$7b1b591b262c240 = $a30ca2726c0ab339$export$a96281f914484f2d.create;
const $a30ca2726c0ab339$export$4154a199d7d90455 = $a30ca2726c0ab339$export$b9d1edb536b4e4eb.create;
const $a30ca2726c0ab339$export$19282c40b967aec6 = $a30ca2726c0ab339$export$ef3b1bb1630977ae.create;
const $a30ca2726c0ab339$export$b3e22bcfd64c1022 = $a30ca2726c0ab339$export$1e576a20c3ce9fb5.create;
const $a30ca2726c0ab339$export$490e536ee7389aeb = $a30ca2726c0ab339$export$7d39f5df85f21031.create;
const $a30ca2726c0ab339$export$2f23118c22fb2630 = $a30ca2726c0ab339$export$7acfc3e64785411.create;
const $a30ca2726c0ab339$export$be5493f9613cbbe = $a30ca2726c0ab339$export$736315c5b55efbad.create;
const $a30ca2726c0ab339$export$8fb0df5f40d0b477 = $a30ca2726c0ab339$export$736315c5b55efbad.strictCreate;
const $a30ca2726c0ab339$export$971dd5b0dfd021b6 = $a30ca2726c0ab339$export$a8b236cb5070a311.create;
const $a30ca2726c0ab339$export$4b888e40c4ee26dd = $a30ca2726c0ab339$export$5ef2424805ac76a3.create;
const $a30ca2726c0ab339$export$bc86dfbf7795668c = $a30ca2726c0ab339$export$c02deaf0bb5203d4.create;
const $a30ca2726c0ab339$export$65e3907585753458 = $a30ca2726c0ab339$export$e2a18bb771d8e6a3.create;
const $a30ca2726c0ab339$export$e5185e241753e543 = $a30ca2726c0ab339$export$a2acc09968cb4b7f.create;
const $a30ca2726c0ab339$export$871de8747c9eaa88 = $a30ca2726c0ab339$export$163b6a2b712d9542.create;
const $a30ca2726c0ab339$export$adaa4cf7ef1b65be = $a30ca2726c0ab339$export$977057706f816712.create;
const $a30ca2726c0ab339$export$44e51c8aac7c2deb = $a30ca2726c0ab339$export$d4602ba55673f53c.create;
const $a30ca2726c0ab339$export$488013bae63b21da = $a30ca2726c0ab339$export$378d0cfce37406e6.create;
const $a30ca2726c0ab339$export$c8ec6e1ec9fefcb0 = $a30ca2726c0ab339$export$7e44096782a165d3.create;
const $a30ca2726c0ab339$export$78a99c8d44d72635 = $a30ca2726c0ab339$export$d325d1f0e1c20179.create;
const $a30ca2726c0ab339$export$6fe7eca19ebe5199 = $a30ca2726c0ab339$export$370b2e8d6d6f5c56.create;
const $a30ca2726c0ab339$export$c957ef27a0ebfd4 = $a30ca2726c0ab339$export$3f196b0127d6e50a.create;
const $a30ca2726c0ab339$export$dc573d8a6576cdb3 = $a30ca2726c0ab339$export$a60af00cc0ce2582.create;
const $a30ca2726c0ab339$export$516e28dec6a4b6d4 = $a30ca2726c0ab339$export$aa56fec1e9d629b8.create;
const $a30ca2726c0ab339$export$133fc36489ac9add = $a30ca2726c0ab339$export$aaac0b8b429cef5.create;
const $a30ca2726c0ab339$export$fc37fe19dfda43ee = $a30ca2726c0ab339$export$a60af00cc0ce2582.createWithPreprocess;
const $a30ca2726c0ab339$export$43f28b24e1eb8181 = $a30ca2726c0ab339$export$a3c3ef8a0e95c6da.create;
const $a30ca2726c0ab339$export$3b3d07727c5b702c = ()=>$a30ca2726c0ab339$export$22b082955e083ec3().optional();
const $a30ca2726c0ab339$export$eb150471a61fced6 = ()=>$a30ca2726c0ab339$export$98e628dec113755e().optional();
const $a30ca2726c0ab339$export$269251733cdcbbf1 = ()=>$a30ca2726c0ab339$export$4a21f16c33752377().optional();
const $a30ca2726c0ab339$export$8c14e57e778d3873 = {
    string: (arg)=>$a30ca2726c0ab339$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$a30ca2726c0ab339$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$a30ca2726c0ab339$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$a30ca2726c0ab339$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$a30ca2726c0ab339$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $a30ca2726c0ab339$export$96c94437c95d7862 = $a30ca2726c0ab339$export$9a105a556e65c2c0;
var $a30ca2726c0ab339$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $a30ca2726c0ab339$export$341b0b6e0a6f5099,
    setErrorMap: $a30ca2726c0ab339$export$1097a8289cfd22d7,
    getErrorMap: $a30ca2726c0ab339$export$32f27c719778d4c4,
    makeIssue: $a30ca2726c0ab339$export$244a85fde9c419ed,
    EMPTY_PATH: $a30ca2726c0ab339$export$1526d2e05f74572,
    addIssueToContext: $a30ca2726c0ab339$export$db7caee60e5d514d,
    ParseStatus: $a30ca2726c0ab339$export$5b20a5c3d05c1f6f,
    INVALID: $a30ca2726c0ab339$export$9a105a556e65c2c0,
    DIRTY: $a30ca2726c0ab339$export$325a211da9693fcf,
    OK: $a30ca2726c0ab339$export$c6813a8d51f77eaf,
    isAborted: $a30ca2726c0ab339$export$afa861e3c5730743,
    isDirty: $a30ca2726c0ab339$export$910b6cdd390341b3,
    isValid: $a30ca2726c0ab339$export$1ea939691cdc45b8,
    isAsync: $a30ca2726c0ab339$export$aefee5ebe1dcfd9e,
    get util () {
        return $a30ca2726c0ab339$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $a30ca2726c0ab339$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $a30ca2726c0ab339$export$5716da67bfaa244d,
    getParsedType: $a30ca2726c0ab339$export$3e9057828ebd5c7a,
    ZodType: $a30ca2726c0ab339$export$19342e026b58ebb7,
    ZodString: $a30ca2726c0ab339$export$1230eb29b8d3b502,
    ZodNumber: $a30ca2726c0ab339$export$5b070a55c0c43e09,
    ZodBigInt: $a30ca2726c0ab339$export$67d741fd70ff98f4,
    ZodBoolean: $a30ca2726c0ab339$export$723d146f80596191,
    ZodDate: $a30ca2726c0ab339$export$e974be33bdc55521,
    ZodSymbol: $a30ca2726c0ab339$export$bcc3b40f6b638044,
    ZodUndefined: $a30ca2726c0ab339$export$4e780e961c30340d,
    ZodNull: $a30ca2726c0ab339$export$a96281f914484f2d,
    ZodAny: $a30ca2726c0ab339$export$b9d1edb536b4e4eb,
    ZodUnknown: $a30ca2726c0ab339$export$ef3b1bb1630977ae,
    ZodNever: $a30ca2726c0ab339$export$1e576a20c3ce9fb5,
    ZodVoid: $a30ca2726c0ab339$export$7d39f5df85f21031,
    ZodArray: $a30ca2726c0ab339$export$7acfc3e64785411,
    ZodObject: $a30ca2726c0ab339$export$736315c5b55efbad,
    ZodUnion: $a30ca2726c0ab339$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $a30ca2726c0ab339$export$5ef2424805ac76a3,
    ZodIntersection: $a30ca2726c0ab339$export$c02deaf0bb5203d4,
    ZodTuple: $a30ca2726c0ab339$export$e2a18bb771d8e6a3,
    ZodRecord: $a30ca2726c0ab339$export$a2acc09968cb4b7f,
    ZodMap: $a30ca2726c0ab339$export$163b6a2b712d9542,
    ZodSet: $a30ca2726c0ab339$export$977057706f816712,
    ZodFunction: $a30ca2726c0ab339$export$d4602ba55673f53c,
    ZodLazy: $a30ca2726c0ab339$export$378d0cfce37406e6,
    ZodLiteral: $a30ca2726c0ab339$export$7e44096782a165d3,
    ZodEnum: $a30ca2726c0ab339$export$d325d1f0e1c20179,
    ZodNativeEnum: $a30ca2726c0ab339$export$370b2e8d6d6f5c56,
    ZodPromise: $a30ca2726c0ab339$export$3f196b0127d6e50a,
    ZodEffects: $a30ca2726c0ab339$export$a60af00cc0ce2582,
    ZodTransformer: $a30ca2726c0ab339$export$a60af00cc0ce2582,
    ZodOptional: $a30ca2726c0ab339$export$aa56fec1e9d629b8,
    ZodNullable: $a30ca2726c0ab339$export$aaac0b8b429cef5,
    ZodDefault: $a30ca2726c0ab339$export$bb19b37874861e7e,
    ZodCatch: $a30ca2726c0ab339$export$75a44ec6249ac76b,
    ZodNaN: $a30ca2726c0ab339$export$26ccfa0145e8511f,
    BRAND: $a30ca2726c0ab339$export$cf2deea74cde46b4,
    ZodBranded: $a30ca2726c0ab339$export$66b0c798a395271f,
    ZodPipeline: $a30ca2726c0ab339$export$a3c3ef8a0e95c6da,
    custom: $a30ca2726c0ab339$export$4c00f665f0d4b443,
    Schema: $a30ca2726c0ab339$export$19342e026b58ebb7,
    ZodSchema: $a30ca2726c0ab339$export$19342e026b58ebb7,
    late: $a30ca2726c0ab339$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $a30ca2726c0ab339$export$558106ce543bd011;
    },
    coerce: $a30ca2726c0ab339$export$8c14e57e778d3873,
    any: $a30ca2726c0ab339$export$4154a199d7d90455,
    array: $a30ca2726c0ab339$export$2f23118c22fb2630,
    bigint: $a30ca2726c0ab339$export$a0f65b52274bcc00,
    boolean: $a30ca2726c0ab339$export$4a21f16c33752377,
    date: $a30ca2726c0ab339$export$324d90190a8b822a,
    discriminatedUnion: $a30ca2726c0ab339$export$4b888e40c4ee26dd,
    effect: $a30ca2726c0ab339$export$dc573d8a6576cdb3,
    "enum": $a30ca2726c0ab339$export$78a99c8d44d72635,
    "function": $a30ca2726c0ab339$export$44e51c8aac7c2deb,
    "instanceof": $a30ca2726c0ab339$export$3d916e7c22dbd8b5,
    intersection: $a30ca2726c0ab339$export$bc86dfbf7795668c,
    lazy: $a30ca2726c0ab339$export$488013bae63b21da,
    literal: $a30ca2726c0ab339$export$c8ec6e1ec9fefcb0,
    map: $a30ca2726c0ab339$export$871de8747c9eaa88,
    nan: $a30ca2726c0ab339$export$9e06de0973666692,
    nativeEnum: $a30ca2726c0ab339$export$6fe7eca19ebe5199,
    never: $a30ca2726c0ab339$export$b3e22bcfd64c1022,
    "null": $a30ca2726c0ab339$export$7b1b591b262c240,
    nullable: $a30ca2726c0ab339$export$133fc36489ac9add,
    number: $a30ca2726c0ab339$export$98e628dec113755e,
    object: $a30ca2726c0ab339$export$be5493f9613cbbe,
    oboolean: $a30ca2726c0ab339$export$269251733cdcbbf1,
    onumber: $a30ca2726c0ab339$export$eb150471a61fced6,
    optional: $a30ca2726c0ab339$export$516e28dec6a4b6d4,
    ostring: $a30ca2726c0ab339$export$3b3d07727c5b702c,
    pipeline: $a30ca2726c0ab339$export$43f28b24e1eb8181,
    preprocess: $a30ca2726c0ab339$export$fc37fe19dfda43ee,
    promise: $a30ca2726c0ab339$export$c957ef27a0ebfd4,
    record: $a30ca2726c0ab339$export$e5185e241753e543,
    set: $a30ca2726c0ab339$export$adaa4cf7ef1b65be,
    strictObject: $a30ca2726c0ab339$export$8fb0df5f40d0b477,
    string: $a30ca2726c0ab339$export$22b082955e083ec3,
    symbol: $a30ca2726c0ab339$export$8f701197936bc2a6,
    transformer: $a30ca2726c0ab339$export$dc573d8a6576cdb3,
    tuple: $a30ca2726c0ab339$export$65e3907585753458,
    "undefined": $a30ca2726c0ab339$export$1db45310990710a5,
    union: $a30ca2726c0ab339$export$971dd5b0dfd021b6,
    unknown: $a30ca2726c0ab339$export$19282c40b967aec6,
    "void": $a30ca2726c0ab339$export$490e536ee7389aeb,
    NEVER: $a30ca2726c0ab339$export$96c94437c95d7862,
    ZodIssueCode: $a30ca2726c0ab339$export$5ba560653e4a1035,
    quotelessJson: $a30ca2726c0ab339$export$913eddeaf297cfea,
    ZodError: $a30ca2726c0ab339$export$f98dac4b251ab333
});


// Define a schema for the labels and annotations
const $a08d7d83bb58b325$var$LabelsSchema = (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).record((0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string());
const $a08d7d83bb58b325$var$AnnotationsSchema = (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).record((0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string());
// Schemas for queries from Prometheus
const $a08d7d83bb58b325$var$PrometheusAlertSchema = (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).object({
    labels: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).optional($a08d7d83bb58b325$var$LabelsSchema),
    annotations: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).optional($a08d7d83bb58b325$var$AnnotationsSchema),
    state: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string(),
    activeAt: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).optional((0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string()),
    updatedAt: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).optional((0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string()),
    value: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string()
}).passthrough();
const $a08d7d83bb58b325$export$56e395aa1e847f1f = (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).object({
    status: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).literal("success"),
    data: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).object({
        alerts: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).array($a08d7d83bb58b325$var$PrometheusAlertSchema)
    })
});
// Helpers for rules schema
// Define a schema for an individual alerting rule
const $a08d7d83bb58b325$var$AlertingRuleSchema = (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).object({
    name: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string(),
    state: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).optional((0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string()),
    query: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string(),
    // duration: z.string(),
    labels: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).optional($a08d7d83bb58b325$var$LabelsSchema),
    annotations: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).optional($a08d7d83bb58b325$var$AnnotationsSchema)
});
// Define a schema for a group of alerting rules
const $a08d7d83bb58b325$var$AlertingRuleGroupSchema = (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).object({
    name: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string(),
    file: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string(),
    rules: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).array($a08d7d83bb58b325$var$AlertingRuleSchema)
});
const $a08d7d83bb58b325$export$ca2fb23824d6bb05 = (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).object({
    status: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).literal("success"),
    data: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).object({
        groups: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).array($a08d7d83bb58b325$var$AlertingRuleGroupSchema)
    })
});
 /**
 * EXAMPLE ALERT RESPONSE
{
  "status": "success",
  "data": {
    "alerts": [
      {
        "labels": {
          "alertname": "HighErrorRate",
          "severity": "critical",
          "instance": "webserver1",
          "job": "webserver",
          "monitor": "prometheus",
          "service": "myapp"
        },
        "annotations": {
          "summary": "High error rate detected on webserver1",
          "description": "The error rate is above the critical threshold."
        },
        "state": "firing",
        "activeAt": "2023-07-28T12:34:56.789Z",
        "value": "0.123",
        "updatedAt": "2023-07-28T12:34:56.789Z"
      },
      // Additional alert entries if there are more active alerts
    ]
  }
}
 */ 


// Schemas for data from Prometheus
/**
 * Schema for a general Prometheus series for an autometricized function
 * NOTE - Assumes `module` is present in the series labels
 */ const $60861bad2fa82ac2$var$AmSeriesSchema = (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).object({
    __name__: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string(),
    function: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string(),
    module: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string(),
    service_name: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string().optional()
}).passthrough();
const $60861bad2fa82ac2$export$bc24f3a0830a9f54 = (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).object({
    status: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string(),
    data: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).array($60861bad2fa82ac2$var$AmSeriesSchema)
});
const $60861bad2fa82ac2$export$ba7e0c49080a12b0 = (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).object({
    name: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string(),
    module: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string(),
    service_name: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string().optional()
});
const $60861bad2fa82ac2$export$119df25acc1f0f6d = (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).object({
    start: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).object({
        column: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).number(),
        line: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).number()
    }),
    end: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).object({
        column: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).number(),
        line: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).number()
    })
});
const $60861bad2fa82ac2$export$41a804bfd3af96eb = (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).object({
    file: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string(),
    range: $60861bad2fa82ac2$export$119df25acc1f0f6d
});
const $60861bad2fa82ac2$export$64521c8b0fb245f4 = (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).object({
    function: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string(),
    module: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string()
});
const $60861bad2fa82ac2$export$5d81a22ffd527d5 = (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).object({
    definition: $60861bad2fa82ac2$export$41a804bfd3af96eb.optional(),
    instrumentation: $60861bad2fa82ac2$export$41a804bfd3af96eb.optional(),
    id: $60861bad2fa82ac2$export$64521c8b0fb245f4,
    language: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string(),
    path: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string()
});
const $60861bad2fa82ac2$export$18ef546fa9c64571 = (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).array($60861bad2fa82ac2$export$5d81a22ffd527d5);



// Schemas for queries from Prometheus
const $0bb0462468179c47$var$MetricValue = (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).object({
    // Labels in result set
    metric: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).object({}).passthrough(),
    // Values in result set [timestamp, value]
    value: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).tuple([
        (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).number(),
        (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string()
    ])
}).passthrough();
const $0bb0462468179c47$export$21e959b024fdf650 = (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).object({
    status: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).literal("success"),
    data: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).object({
        result: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).array($0bb0462468179c47$var$MetricValue),
        resultType: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string()
    })
});




// Schemas for data from Prometheus
const $f4ba6d3372e76af6$var$SuccessRateSeriesName = (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).union([
    (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).literal("function_calls"),
    (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).literal("function_calls_count_total"),
    (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).literal("function_calls_count"),
    (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).literal("function_calls_total")
]);
const $f4ba6d3372e76af6$var$LatencySeriesName = (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).union([
    (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).literal("function_calls_duration_count"),
    (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).literal("function_calls_duration_seconds_count")
]);
const $f4ba6d3372e76af6$export$622c1e54f5d3730d = (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).object({
    __name__: $f4ba6d3372e76af6$var$SuccessRateSeriesName,
    function: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string(),
    module: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string(),
    objective_name: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string(),
    objective_percentile: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string()
}).passthrough();
const $f4ba6d3372e76af6$export$564e2e24cd71d4e1 = (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).object({
    status: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string(),
    data: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).array($f4ba6d3372e76af6$export$622c1e54f5d3730d)
});
const $f4ba6d3372e76af6$export$8f844a8f551a6929 = (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).object({
    __name__: $f4ba6d3372e76af6$var$LatencySeriesName,
    function: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string(),
    module: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string(),
    objective_name: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string(),
    objective_latency_threshold: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string(),
    objective_percentile: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string()
}).passthrough();
const $f4ba6d3372e76af6$export$cfbfa6de45b9d00d = (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).object({
    status: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string(),
    data: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).array($f4ba6d3372e76af6$export$8f844a8f551a6929)
});
/**
 * Schema for a general Prometheus series for an autometrcized function
 * NOTE - Assumes `module` is present in the series labels
 */ const $f4ba6d3372e76af6$var$AmSeriesSchema = (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).object({
    __name__: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string(),
    function: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string(),
    module: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string()
}).passthrough();
// Schemas for transformed SLO data
const $f4ba6d3372e76af6$var$SuccessRate = (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).literal("successRate");
const $f4ba6d3372e76af6$var$SuccessTargetSchema = (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).object({
    percentile: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string()
});
const $f4ba6d3372e76af6$var$SuccessRateObjectiveSchema = (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).object({
    series: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).array($f4ba6d3372e76af6$var$AmSeriesSchema),
    name: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string(),
    functions: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).array((0, $60861bad2fa82ac2$export$ba7e0c49080a12b0)),
    functionsCount: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).optional((0, $a30ca2726c0ab339$export$2e2bcd8739ae039).number()),
    metric: $f4ba6d3372e76af6$var$SuccessRate,
    target: $f4ba6d3372e76af6$var$SuccessTargetSchema
});
const $f4ba6d3372e76af6$var$Latency = (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).literal("latency");
const $f4ba6d3372e76af6$var$LatencyTargetSchema = (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).object({
    percentile: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string(),
    threshold: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string()
});
const $f4ba6d3372e76af6$var$LatencyObjectiveSchema = (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).object({
    series: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).array($f4ba6d3372e76af6$var$AmSeriesSchema),
    name: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string(),
    functions: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).array((0, $60861bad2fa82ac2$export$ba7e0c49080a12b0)),
    functionsCount: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).optional((0, $a30ca2726c0ab339$export$2e2bcd8739ae039).number()),
    metric: $f4ba6d3372e76af6$var$Latency,
    target: $f4ba6d3372e76af6$var$LatencyTargetSchema
});
const $f4ba6d3372e76af6$var$ObjectiveSchema = (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).discriminatedUnion("metric", [
    $f4ba6d3372e76af6$var$SuccessRateObjectiveSchema,
    $f4ba6d3372e76af6$var$LatencyObjectiveSchema
]);
const $f4ba6d3372e76af6$var$ObjectiveTargetSchema = (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).union([
    $f4ba6d3372e76af6$var$SuccessTargetSchema,
    $f4ba6d3372e76af6$var$LatencyTargetSchema
]);
// TODO - add the time range to this schema
const $f4ba6d3372e76af6$var$ObjectiveWithCurrentValueSchema = (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).intersection($f4ba6d3372e76af6$var$ObjectiveSchema, (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).object({
    currentValue: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string().nullable()
}));
const $f4ba6d3372e76af6$var$PrometheusFunctionModuleMetricSchema = (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).object({
    function: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string(),
    module: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string()
}).passthrough();
const $f4ba6d3372e76af6$var$PrometheusObjectiveFunctionModulePairCurrentValueResult = (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).object({
    metric: $f4ba6d3372e76af6$var$PrometheusFunctionModuleMetricSchema,
    value: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).tuple([
        (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).number(),
        (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string()
    ])
});
const $f4ba6d3372e76af6$export$aab53dda4ad2a25b = (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).object({
    status: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string(),
    data: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).object({
        result: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).array($f4ba6d3372e76af6$var$PrometheusObjectiveFunctionModulePairCurrentValueResult)
    })
});





function $6e24479930419a5d$export$7abc1d61b627c701(queryResponse) {
    const result = queryResponse?.data?.data?.result?.[0]?.value?.[1];
    const isString = typeof result === "string";
    if (result && !isString) // eslint-disable-next-line no-console
    console.debug("Got non-string value from prometheus query:", {
        queryResponse: queryResponse,
        result: result
    });
    return isString ? result : null;
}
function $6e24479930419a5d$export$e6d22cfadeec5cbc(queryResult, schema) {
    if (queryResult.error) return {
        error: queryResult.error
    };
    const queryResultParseResult = schema.safeParse(queryResult.data);
    if (queryResultParseResult.success === false) {
        // NOTE - If you are getting a decoding error, this log will tell you why
        // eslint-disable-next-line no-console
        console.error(queryResultParseResult.error);
        return {
            error: {
                status: "CUSTOM_ERROR",
                data: queryResult,
                error: "Decoding error",
                // NOTE - for debugging purposes, we include the error from zod
                //@ts-ignore
                _error: queryResultParseResult.error
            }
        };
    }
    return {
        data: queryResultParseResult.data
    };
}
async function $6e24479930419a5d$export$8192083f64c7bc77(fetchWithBq, fetchArgs, schema) {
    const resultRaw = await fetchWithBq(fetchArgs);
    return $6e24479930419a5d$export$e6d22cfadeec5cbc(resultRaw, schema);
}
const $6e24479930419a5d$export$9106e9e13e927fa6 = // eslint-disable-next-line unicorn/better-regex
/((([0-9]+)y)?(([0-9]+)w)?(([0-9]+)d)?(([0-9]+)h)?(([0-9]+)m(?!s))?(([0-9]+)s)?(([0-9]+)ms)?|0)/;
function $6e24479930419a5d$export$d63a876106b887b0(duration) {
    const matches = duration.match($6e24479930419a5d$export$9106e9e13e927fa6);
    if (!matches) return null;
    const years = matches[3] ? Number.parseInt(matches[3], 10) : 0;
    const weeks = matches[5] ? Number.parseInt(matches[5], 10) : 0;
    const days = matches[7] ? Number.parseInt(matches[7], 10) : 0;
    const hours = matches[9] ? Number.parseInt(matches[9], 10) : 0;
    const minutes = matches[11] ? Number.parseInt(matches[11], 10) : 0;
    const seconds = matches[13] ? Number.parseInt(matches[13], 10) : 0;
    const milliseconds = matches[15] ? Number.parseInt(matches[15], 10) : 0;
    const durationInSeconds = years * 31536000 + // seconds in a year (considering non-leap years)
    weeks * 604800 + // seconds in a week
    days * 86400 + // seconds in a day
    hours * 3600 + // seconds in an hour
    minutes * 60 + // seconds in a minute
    seconds + milliseconds / 1000;
    if (Number.isNaN(durationInSeconds)) return null;
    if (durationInSeconds === 0) return null;
    return durationInSeconds;
}
function $6e24479930419a5d$export$4c205298f1fca81b(yaml) {
    return yaml.split("\n").reduce((accumulator, line)=>{
        const match = line.match(/scrape_interval:\s*(.*)/);
        if (match?.[1]) {
            const duration = $6e24479930419a5d$export$d63a876106b887b0(match[1]);
            if (duration) accumulator.push(duration);
        }
        return accumulator;
    }, []);
}


/**
 * This is a custom baseQuery that uses the baseUrl from the Prometheus config.
 * We need this because the baseUrl is dynamic (the user can configure it themselves)
 */ const $5755db105caee352$var$dynamicBaseQuery = (args, WebApi, extraOptions)=>{
    const instance = (0, $14bbd07b3011052f$export$919b3065fd27c3a8)(WebApi.getState());
    const baseUrl = instance?.url;
    if (!baseUrl) {
        // eslint-disable-next-line no-console
        console.error("No baseUrl found in Prometheus config, throwing error");
        throw new Error("Must configure Prometheus URL");
    }
    const rawBaseQuery = (0, $54649b17feedf59f$export$adcf4c6133c49b4e)({
        baseUrl: baseUrl,
        mode: "cors"
    });
    return rawBaseQuery(args, WebApi, extraOptions);
};
const $5755db105caee352$export$bcc8035e549759b4 = (0, $140b755e0815039f$export$9cdc2b9a8d94c842)({
    baseQuery: $5755db105caee352$var$dynamicBaseQuery,
    endpoints: (builder)=>({
            pingPrometheus: builder.query({
                query: ()=>({
                        url: `/api/v1/query`,
                        method: "GET",
                        params: {
                            query: "up"
                        }
                    }),
                transformResponse: ()=>{
                    return true;
                },
                providesTags: (_tags, _result, environmentUrl)=>{
                    if (environmentUrl) return [
                        {
                            type: "Environment",
                            id: environmentUrl
                        }
                    ];
                    return [];
                }
            }),
            prometheusQueryRange: builder.query({
                query: ({ query: query, start: start, end: end, useTimeRangeAsSpecified: useTimeRangeAsSpecified = false })=>{
                    const [stepParameter, stepSeconds] = (0, $d9ef29a97e741a59$export$aa02a9ec6df7532d)({
                        from: start,
                        to: end
                    });
                    return {
                        url: "/api/v1/query_range",
                        method: "GET",
                        params: {
                            query: query,
                            start: useTimeRangeAsSpecified ? start : (0, $d9ef29a97e741a59$export$812a2eab1c1beb61)(start, stepSeconds, Math.floor),
                            end: useTimeRangeAsSpecified ? end : (0, $d9ef29a97e741a59$export$812a2eab1c1beb61)(end, stepSeconds, Math.ceil),
                            step: stepParameter
                        }
                    };
                },
                transformResponse: (response)=>{
                    return response.data.result.map((0, $d9ef29a97e741a59$export$2ff15115ee27d693));
                },
                providesTags: (_tags, _result, { environmentUrl: environmentUrl })=>{
                    if (environmentUrl) return [
                        {
                            type: "Environment",
                            id: environmentUrl
                        }
                    ];
                    return [];
                }
            }),
            prometheusQuery: builder.query({
                query: ({ query: query, time: time })=>{
                    return {
                        url: "/api/v1/query",
                        method: "GET",
                        params: {
                            query: query,
                            time: time
                        }
                    };
                },
                transformResponse: (response)=>{
                    return (0, $0bb0462468179c47$export$21e959b024fdf650).parse(response);
                },
                providesTags: (_tags, _result, { environmentUrl: environmentUrl })=>{
                    if (environmentUrl) return [
                        {
                            type: "Environment",
                            id: environmentUrl
                        }
                    ];
                    return [];
                }
            }),
            prometheusScrapeIntervals: builder.query({
                query: ()=>{
                    return {
                        url: "/api/v1/status/config",
                        method: "GET"
                    };
                },
                transformResponse: (response)=>{
                    const canParseResponse = typeof response?.data?.yaml === "string";
                    if (canParseResponse) return (0, $6e24479930419a5d$export$4c205298f1fca81b)(response.data?.yaml);
                    return null;
                },
                providesTags: (_tags, _result, { environmentUrl: environmentUrl })=>{
                    if (environmentUrl) return [
                        {
                            type: "Environment",
                            id: environmentUrl
                        }
                    ];
                    return [];
                }
            })
        }),
    reducerPath: "api",
    tagTypes: [
        "Environment"
    ]
});
const { usePingPrometheusQuery: $5755db105caee352$export$c6928c88e13eba01, usePrometheusQueryRangeQuery: $5755db105caee352$export$c386b48e92fd4ce1, usePrometheusQueryQuery: // Lol - the "Query query" means that this is hitting
//       the `/query` endpoint and not the `/query_range` endpoint
$5755db105caee352$export$ca13061e89ab955d, usePrometheusScrapeIntervalsQuery: $5755db105caee352$export$c417b66dfc481843 } = $5755db105caee352$export$bcc8035e549759b4;




const $fe24d45de7923f97$export$db2da65404f64f92 = (0, $140b755e0815039f$export$9cdc2b9a8d94c842)({
    baseQuery: (0, $54649b17feedf59f$export$adcf4c6133c49b4e)({
        mode: "cors"
    }),
    endpoints: (builder)=>({
            pingAnyPrometheus: builder.query({
                query: (environmentUrl)=>({
                        url: `${$fe24d45de7923f97$var$sanitizeEnvironmentUrl(environmentUrl ?? "")}/api/v1/query`,
                        method: "GET",
                        params: {
                            query: "up"
                        }
                    }),
                transformResponse: ()=>{
                    return true;
                },
                providesTags: (_tags, _result, environmentUrl)=>{
                    if (environmentUrl) return [
                        {
                            type: "Environment",
                            id: environmentUrl
                        }
                    ];
                    return [];
                }
            })
        }),
    reducerPath: "pingApi",
    tagTypes: [
        "Environment"
    ]
});
const { usePingAnyPrometheusQuery: $fe24d45de7923f97$export$95c0f256a1e9b1b2 } = $fe24d45de7923f97$export$db2da65404f64f92;
/**
 * Helper function that removes a trailing slash from a URL, if it exists
 */ function $fe24d45de7923f97$var$sanitizeEnvironmentUrl(environmentUrl) {
    return environmentUrl.replace(/\/$/, "");
}





const $a42cea1284cea633$export$89789ac93350bf2d = (0, $5755db105caee352$export$bcc8035e549759b4).injectEndpoints({
    endpoints: (builder)=>({
            // NOTE - Returns active alerts
            getAllAlerts: builder.query({
                async queryFn (_args, _queryApi, _extraOptions, fetchWithBq) {
                    // Fetch all active alerts
                    //
                    // https://prometheus.io/docs/prometheus/latest/querying/api/#alerts
                    //
                    // NOTE: "As the /alerts endpoint is fairly new, it does not have the same stability guarantees as the overarching API v1"
                    const alertsResult = await (0, $6e24479930419a5d$export$8192083f64c7bc77)(fetchWithBq, {
                        url: `/api/v1/alerts`
                    }, (0, $a08d7d83bb58b325$export$56e395aa1e847f1f));
                    // NOTE - the error could happen due to a network error, or a decoding error
                    if ("error" in alertsResult) return alertsResult;
                    const { alerts: alerts } = alertsResult.data.data;
                    return {
                        data: alerts
                    };
                }
            }),
            getAllRules: builder.query({
                async queryFn (_args, _queryApi, _extraOptions, fetchWithBq) {
                    // https://prometheus.io/docs/prometheus/latest/querying/api/#rules
                    const rulesResult = await (0, $6e24479930419a5d$export$8192083f64c7bc77)(fetchWithBq, {
                        url: `/api/v1/rules`
                    }, (0, $a08d7d83bb58b325$export$ca2fb23824d6bb05));
                    // NOTE - the error could happen due to a network error, or a decoding error
                    if ("error" in rulesResult) return rulesResult;
                    const { groups: rules } = rulesResult.data.data;
                    return {
                        data: rules
                    };
                }
            })
        })
}).enhanceEndpoints({
    addTagTypes: [
        "Alerts"
    ],
    endpoints: {
        getAllAlerts: {
            providesTags: (_functions, _error, { environmentUrl: environmentUrl })=>{
                if (environmentUrl) return [
                    {
                        type: "Alerts",
                        id: environmentUrl
                    }
                ];
                return [];
            }
        }
    }
});
const { useGetAllAlertsQuery: $a42cea1284cea633$export$be731d8da3cb66, useGetAllRulesQuery: $a42cea1284cea633$export$db8166517713c60d } = $a42cea1284cea633$export$89789ac93350bf2d;


var $097bfc2d1913d58c$exports = {};

$parcel$export($097bfc2d1913d58c$exports, "filterUniqueFunctionModulePairs", () => $097bfc2d1913d58c$export$3523908de8051340);
$parcel$export($097bfc2d1913d58c$exports, "createSLOQueryLatencyUnderThreshold", () => $097bfc2d1913d58c$export$801d6fd55ca8f449);
$parcel$export($097bfc2d1913d58c$exports, "getPrometheusWindowFromTimeRange", () => $097bfc2d1913d58c$export$2350a09418b1e6bd);
$parcel$export($097bfc2d1913d58c$exports, "createSLOQueryLatencyUnderThresholdByFunction", () => $097bfc2d1913d58c$export$d751314f249f5ea5);
$parcel$export($097bfc2d1913d58c$exports, "createSLOQuerySuccessRate", () => $097bfc2d1913d58c$export$f563c7644decb4be);
$parcel$export($097bfc2d1913d58c$exports, "createSloAllFunctionsLatencyQuery", () => $097bfc2d1913d58c$export$127f3ac22cc3bf7f);
$parcel$export($097bfc2d1913d58c$exports, "translateObjectivePercentileToPromQlPercentile", () => $097bfc2d1913d58c$export$c661c8485d15351e);
$parcel$export($097bfc2d1913d58c$exports, "createSloAllFunctionsSuccessRateQuery", () => $097bfc2d1913d58c$export$e7daf7db2445bd80);
$parcel$export($097bfc2d1913d58c$exports, "createFunctionLatencyQuery", () => $097bfc2d1913d58c$export$20af059881ff972e);
$parcel$export($097bfc2d1913d58c$exports, "createTop5FunctionLatencyQuery", () => $097bfc2d1913d58c$export$26166adba3e316cb);
$parcel$export($097bfc2d1913d58c$exports, "createFunctionErrorRateQuery", () => $097bfc2d1913d58c$export$ad80389edca539cd);
$parcel$export($097bfc2d1913d58c$exports, "createTop5FunctionErrorRateQuery", () => $097bfc2d1913d58c$export$325530f3b64cdd75);
$parcel$export($097bfc2d1913d58c$exports, "createFunctionRequestRateQuery", () => $097bfc2d1913d58c$export$b85e6fe10597adb);
$parcel$export($097bfc2d1913d58c$exports, "createTop5FunctionRequestRateQuery", () => $097bfc2d1913d58c$export$78579788b5ffa4f1);
$parcel$export($097bfc2d1913d58c$exports, "createRequestCountQuery", () => $097bfc2d1913d58c$export$223be44715644635);
$parcel$export($097bfc2d1913d58c$exports, "createErrorCountQuery", () => $097bfc2d1913d58c$export$4689648aa7da5ec3);
$parcel$export($097bfc2d1913d58c$exports, "createVersionQuery", () => $097bfc2d1913d58c$export$9ad8bd389db2f09d);
/**
 * Helper to return the build_info join
 * Accepts an indentation parameter to allow for pretty pretting the query in the UI.
 *
 * @note - An build info interval that is significantly smaller than the scrape interval
 *         will result in a "dot-dash" pattern in the UI. (LINK TO EXAMPLE)
 */ const $097bfc2d1913d58c$var$getBuildInfoQuery = ({ indent: indent = 0, interval: interval = "1s" })=>`
* on (instance, job) group_left(version, commit) (
  last_over_time(build_info[${interval}])
  or on (instance, job) up
)`.trim().split("\n").join("\n" + " ".repeat(indent));
function $097bfc2d1913d58c$export$3523908de8051340(functionModulePairs) {
    const uniqueEntries = [];
    for (const functionModule of functionModulePairs){
        const isDuplicate = uniqueEntries.some((otherFunctionModule)=>{
            return otherFunctionModule.name === functionModule.name && otherFunctionModule.module === functionModule.module;
        });
        if (!isDuplicate) uniqueEntries.push(functionModule);
    }
    return uniqueEntries;
}
function $097bfc2d1913d58c$export$801d6fd55ca8f449(objective, start, end, function_) {
    const objectiveName = objective.name;
    // FIXME
    const latencyThreshold = objective.target.threshold;
    const rateInterval = $097bfc2d1913d58c$export$2350a09418b1e6bd(start, end);
    let query = `
(
  sum(
    rate(
      {
        __name__=~"function_calls_duration(_seconds)?_bucket",
        objective_name="${objectiveName}",
        le="${latencyThreshold}"
      }[${rateInterval}]
    )
  ) or on() vector(0)
) / (
    sum(
      rate(
        {
          __name__=~"function_calls_duration(_seconds)?_count",
          objective_name="${objectiveName}"
        }[${rateInterval}]
      )
    ) > 0
  )
`.trim();
    // INVESTIGATE - should this query not include the objective_name?
    // That way we can look at data before the objective was defined...
    if (function_) {
        query = query.replace('__name__=~"function_calls_duration(_seconds)?_bucket",', `__name__=~"function_calls_duration(_seconds)?_bucket",\nfunction="${function_.name}",\nmodule="${function_.module}",\n`.trim());
        query = query.replace(`__name__=~"function_calls_duration(_seconds)?_count",`, `__name__=~"function_calls_duration(_seconds)?_count",\nfunction="${function_.name}",\nmodule="${function_.module}",\n`.trim());
    }
    return query;
}
function $097bfc2d1913d58c$export$d751314f249f5ea5(objective, start, end) {
    const objectiveName = objective.name;
    // FIXME
    const latencyThreshold = objective.target.threshold;
    const rateInterval = $097bfc2d1913d58c$export$2350a09418b1e6bd(start, end);
    return `
(
  sum by (function, module) (
    rate(
      {
        __name__=~"function_calls_duration(_seconds)?_bucket",
        objective_name="${objectiveName}",
        le="${latencyThreshold}"
      }[${rateInterval}]
    )
  ) or on() vector(0)
) / (
    sum by (function, module) (
      rate(
        {
          __name__=~"function_calls_duration(_seconds)?_count",
          objective_name="${objectiveName}"
        }[${rateInterval}]
      )
    ) > 0
  )
`.trim();
}
function $097bfc2d1913d58c$export$f563c7644decb4be(objective, start, end, function_) {
    const objectiveName = objective.name;
    const rateInterval = $097bfc2d1913d58c$export$2350a09418b1e6bd(start, end);
    if (function_) return `
1 - (
  sum(
    rate(
      {
        __name__=~"function_calls(_count)?(_total)?", 
        objective_name="${objectiveName}",
        result="error",
        function="${function_.name}",
        module="${function_.module}"
      }[${rateInterval}])
    ) or on() vector(0)
  ) / (
    sum(
      rate(
        {
          __name__=~"function_calls(_count)?(_total)?", 
          objective_name="${objectiveName}",
          function="${function_.name}",
          module="${function_.module}"
        }[${rateInterval}]
      )
    ) > 0
  )
    `.trim();
    return `
1 - (
  sum(
    rate(
      {
        __name__=~"function_calls(_count)?(_total)?", 
        objective_name="${objectiveName}", 
        result="error"
      }[${rateInterval}])
    ) or on() vector(0)
  ) / (
    sum(
      rate(
        {
          __name__=~"function_calls(_count)?(_total)?", 
          objective_name="${objectiveName}"
        }[${rateInterval}]
      )
    ) > 0
  )
    `.trim();
}
function $097bfc2d1913d58c$export$127f3ac22cc3bf7f(objective, start, end, buildInfoInterval) {
    const { name: objectiveName } = objective;
    const { target: { percentile: latencyPercentile, threshold: latencyThreshold } } = objective;
    const interval = $097bfc2d1913d58c$export$2350a09418b1e6bd(start, end);
    const promQlPercentile = $097bfc2d1913d58c$export$c661c8485d15351e(latencyPercentile);
    return `
label_replace(
  histogram_quantile(
    ${promQlPercentile},
    sum by (le, function, module, commit, version, service_name) (
      rate({
        __name__=~"function_calls_duration(_seconds)?_bucket",
        objective_name="${objectiveName}",
        objective_percentile="${latencyPercentile}",
        objective_latency_threshold="${latencyThreshold}"
      }[${interval}])
      # Attach the version and commit labels from the build_info metric
      ${$097bfc2d1913d58c$var$getBuildInfoQuery({
        indent: 6,
        interval: buildInfoInterval
    })}
    )
  ),
  # Add the label {percentile_latency="${latencyPercentile}"} to the time series
  "percentile_latency", "${latencyPercentile}", "", ""
)
`.trim();
}
function $097bfc2d1913d58c$export$e7daf7db2445bd80(objective, start, end, buildInfoInterval) {
    const { name: objectiveName } = objective;
    const { target: { percentile: percentile } } = objective;
    const interval = $097bfc2d1913d58c$export$2350a09418b1e6bd(start, end);
    return `
(
  sum by(function, module, version, commit, service_name) (
    rate(
      {
        __name__=~"function_calls(_count)?(_total)?",
        result="ok", 
        objective_name="${objectiveName}",
        objective_percentile="${percentile}"
      }[${interval}]
    )
    ${$097bfc2d1913d58c$var$getBuildInfoQuery({
        indent: 4,
        interval: buildInfoInterval
    })}
  )) / (
  sum by(function, module, version, commit, service_name) (
    rate(
      {
        __name__=~"function_calls(_count)?(_total)?",
        objective_name="${objectiveName}",
        objective_percentile="${percentile}"

      }[${interval}]
    )
    ${$097bfc2d1913d58c$var$getBuildInfoQuery({
        indent: 4,
        interval: buildInfoInterval
    })}
  ) > 0
)`.trim();
}
function $097bfc2d1913d58c$export$20af059881ff972e({ functionName: functionName, moduleName: moduleName, interval: interval = "5m", buildInfoInterval: buildInfoInterval }) {
    return `
label_replace(
  histogram_quantile(
    0.99,
    sum by (le, function, module, commit, version, service_name) (
      rate({
        __name__=~"function_calls_duration(_seconds)?_bucket",
        function=~"${functionName}"${$097bfc2d1913d58c$var$addModuleLabelIfDefined(moduleName, 8)}
      }[${interval}])
      # Attach the version and commit labels from the build_info metric
      ${$097bfc2d1913d58c$var$getBuildInfoQuery({
        indent: 6,
        interval: buildInfoInterval
    })}
    )
  ),
  # Add the label {percentile_latency="99"} to the time series
  "percentile_latency", "99", "", ""
)

or

label_replace(
  histogram_quantile(
    0.95,
    sum by (le, function, module, commit, version, service_name) (
      rate({
        __name__=~"function_calls_duration(_seconds)?_bucket",
        function=~"${functionName}"${$097bfc2d1913d58c$var$addModuleLabelIfDefined(moduleName, 8)}
      }[${interval}])
      # Attach the version and commit labels from the build_info metric
      ${$097bfc2d1913d58c$var$getBuildInfoQuery({
        indent: 6,
        interval: buildInfoInterval
    })}
    )
  ),
  # Add the label {percentile_latency="95"} to the time series
  "percentile_latency", "95", "", ""
)`.trim();
}
function $097bfc2d1913d58c$export$26166adba3e316cb({ interval: interval = "5m", percentile: percentile = 99, buildInfoInterval: buildInfoInterval }) {
    return `
topk(5, label_replace(
  histogram_quantile(
    0.${percentile},
    sum by (le, function, module, commit, version, service_name) (
      rate({
        __name__=~"function_calls_duration(_seconds)?_bucket",
        function=~".*"
      }[${interval}])
      # Attach the version and commit labels from the build_info metric
      ${$097bfc2d1913d58c$var$getBuildInfoQuery({
        indent: 6,
        interval: buildInfoInterval
    })}
    )
  ),
  # Add the label {percentile_latency="${percentile}"} to the time series
  "percentile_latency", "${percentile}", "", ""
))
`.trim();
}
function $097bfc2d1913d58c$export$ad80389edca539cd({ functionName: functionName, moduleName: moduleName, interval: interval = "5m", buildInfoInterval: buildInfoInterval }) {
    return `
(
  sum by(function, module, version, commit, service_name) (
    rate(
      {
        __name__=~"function_calls(_count)?(_total)?",
        result="error", 
        function=~"${functionName}"${$097bfc2d1913d58c$var$addModuleLabelIfDefined(moduleName, 8)}
      }[${interval}]
    )
    ${$097bfc2d1913d58c$var$getBuildInfoQuery({
        indent: 4,
        interval: buildInfoInterval
    })}
  )) / (
  sum by(function, module, version, commit, service_name) (
    rate(
      {
        __name__=~"function_calls(_count)?(_total)?",
        function=~"${functionName}"${$097bfc2d1913d58c$var$addModuleLabelIfDefined(moduleName, 8)}
      }[${interval}]
    )
    ${$097bfc2d1913d58c$var$getBuildInfoQuery({
        indent: 4,
        interval: buildInfoInterval
    })}
  ) > 0
)`.trim();
}
function $097bfc2d1913d58c$export$325530f3b64cdd75({ interval: interval = "5m", buildInfoInterval: buildInfoInterval }) {
    return `
(
  topk(5, sum by(function, module, version, commit, service_name) (
    rate(
      {
        __name__=~"function_calls(_count)?(_total)?",
        result="error", 
        function=~".*"
      }[${interval}]
    )
    ${$097bfc2d1913d58c$var$getBuildInfoQuery({
        indent: 4,
        interval: buildInfoInterval
    })}
  ))) / (
  sum by(function, module, version, commit, service_name) (
    rate(
      {
        __name__=~"function_calls(_count)?(_total)?",
        function=~".*"
      }[${interval}]
    )
    ${$097bfc2d1913d58c$var$getBuildInfoQuery({
        indent: 4,
        interval: buildInfoInterval
    })}
  ) > 0
)
`.trim();
}
function $097bfc2d1913d58c$export$b85e6fe10597adb({ functionName: functionName, moduleName: moduleName, interval: interval = "5m", buildInfoInterval: buildInfoInterval }) {
    return `
sum by (function, module, version, commit, service_name) (
  rate(
    {
      __name__=~"function_calls(_count)?(_total)?",
      function=~"${functionName}"${$097bfc2d1913d58c$var$addModuleLabelIfDefined(moduleName, 6)}
    }[${interval}]
  )
  ${$097bfc2d1913d58c$var$getBuildInfoQuery({
        indent: 2,
        interval: buildInfoInterval
    })}
)`.trim();
}
function $097bfc2d1913d58c$export$78579788b5ffa4f1({ interval: interval = "5m", buildInfoInterval: buildInfoInterval }) {
    return `
topk(5, sum by (function, module, version, commit, service_name) (
  rate(
    {
      __name__=~"function_calls(_count)?(_total)?",
      function=~".*"
    }[${interval}]
  )
  ${$097bfc2d1913d58c$var$getBuildInfoQuery({
        indent: 2,
        interval: buildInfoInterval
    })}
))
`.trim();
}
function $097bfc2d1913d58c$export$223be44715644635({ functionName: functionName, moduleName: moduleName, interval: interval }) {
    return `
sum by (function, module) (
  increase({
    __name__=~"function_calls(_count)?(_total)?", 
    function="${functionName}"${$097bfc2d1913d58c$var$addModuleLabelIfDefined(moduleName, 4)}
  }[${interval}])
)`.trim();
}
function $097bfc2d1913d58c$export$4689648aa7da5ec3({ functionName: functionName, moduleName: moduleName, interval: interval }) {
    return `
sum by (function, module) (
  increase({
    __name__=~"function_calls(_count)?(_total)?", 
    result="error",
    function="${functionName}"${$097bfc2d1913d58c$var$addModuleLabelIfDefined(moduleName, 4)}
  }[${interval}])
)`.trim();
}
function $097bfc2d1913d58c$export$9ad8bd389db2f09d({ functionName: functionName, moduleName: moduleName, interval: interval = "5m" }) {
    return `group by (version, commit) (
    last_over_time(
      { 
        __name__=~"function_calls(_count)?(_total)?",
        function="${functionName}"${$097bfc2d1913d58c$var$addModuleLabelIfDefined(moduleName, 8)}
      }[${interval}]
    )* on(instance, job) group_left(version, commit) (
      build_info
    )
  )`;
}
function $097bfc2d1913d58c$export$2350a09418b1e6bd(start, end) {
    const from = +new Date(start) / 1000;
    const to = +new Date(end) / 1000;
    return `${Math.floor(to - from)}s`;
}
function $097bfc2d1913d58c$export$c661c8485d15351e(percentile) {
    const promQlPercentile = Number.parseFloat(percentile) / 100;
    return promQlPercentile.toFixed(3).replace(/0$/, "");
}
/**
 * Helper function that will add the module label to the query if it is a string.
 * This means if module is the empty string, it will be added as `module=""` to the query's labels.
 */ function $097bfc2d1913d58c$var$addModuleLabelIfDefined(moduleName, padLeft = 0) {
    const padding = " ".repeat(padLeft);
    return typeof moduleName === "string" ? `,\n${padding}module="${moduleName}"` : "";
}


var $176313a6a434cc5e$exports = {};

$parcel$export($176313a6a434cc5e$exports, "useNotificationSettings", () => $0d5c480fb2687e20$export$d476ee5008a9dcb3);
$parcel$export($176313a6a434cc5e$exports, "useNavigateToAlerts", () => $11b6fc6d47385bf9$export$ecda826b14306ed0);
$parcel$export($176313a6a434cc5e$exports, "getServiceWorker", () => $7664b12fc370b925$export$5c10cbeef76d9c2c);
$parcel$export($176313a6a434cc5e$exports, "hasServiceWorkerSupport", () => $7664b12fc370b925$export$888ef00dae8dd17c);

var $2gcPZ = parcelRequire("2gcPZ");




function $17af91cc7c2ff505$export$93b9a4727f4f0778(key) {
    switch(key){
        case "requestRate":
            return {
                title: "Request rate",
                description: "Rate of calls to the function per second, averaged over 5 minute windows",
                index: 0
            };
        case "errorRatio":
            return {
                title: "Error ratio",
                description: "Percentage of calls to the function that return errors, averaged over 5 minute windows",
                index: 1
            };
        case "latency":
            return {
                title: "Latency",
                description: "99th and 95th percentile latency or response time for the function. For example, if the 99th percentile latency is 500 milliseconds, that means that 99% of calls to the function are handled within 500ms or less.",
                index: 2
            };
    }
}


function $205cce2352c35b5b$export$8793edee2d425525() {}


function $28ccb008950fefda$export$43bc4cfd2456f165(currentSearchParams, key, value) {
    const newSearchParams = new URLSearchParams(currentSearchParams.toString());
    if (value === null) newSearchParams.delete(key);
    else newSearchParams.set(key, value);
    return newSearchParams;
}


function $c12fb649da40a3f2$export$caded91e4645de6(functionName, moduleName, serviceName, metricType) {
    let path = "/functions/details";
    if (serviceName) path = `${path}/s/${encodeURIComponent(serviceName)}`;
    if (moduleName) path = `${path}/m/${encodeURIComponent(moduleName)}`;
    path = `${path}/${encodeURIComponent(functionName)}`;
    if (metricType) return `${path}/${metricType}`;
    return path;
}
function $c12fb649da40a3f2$export$fa3ecc25d6e42a0f(objective) {
    // NOTE - we need to escape the name because it can contain slashes and percentages and stuff
    return `/slos/${encodeURIComponent(objective.name)}/${encodeURIComponent(objective.metric)}`;
}



function $9f2c5fb2b4f1603f$export$adb7effb9167af4f(value) {
    switch(value.toLowerCase()){
        case "ctrl":
        case "\u2318":
        case "cmd":
            if (0, $6babf196a55ab307$export$9ac100e40613ea10) return "\u2318";
            return "Ctrl";
        case "alt":
        case "option":
        case "\u2387":
        case "\u2325":
            if (0, $6babf196a55ab307$export$9ac100e40613ea10) return "\u2325";
            return "Alt";
    }
    return value;
}


function $18c515912ab80737$export$741122baf60f6bc3(objective) {
    const { target: target, currentValue: currentValue } = objective;
    if (target.percentile && typeof currentValue === "string") {
        const value = Number.parseFloat(currentValue);
        const percentile = Number.parseFloat(target.percentile);
        return value < percentile * 0.01;
    }
    return false;
}
function $18c515912ab80737$export$76dcc15228d30015(objective, functionActualValue) {
    const { target: target } = objective;
    if (target?.percentile && typeof functionActualValue === "string") {
        const value = Number.parseFloat(functionActualValue);
        const percentile = Number.parseFloat(target.percentile);
        return value < percentile * 0.01;
    }
    return false;
}
function $18c515912ab80737$export$97c5ccbd8ffad6db(target) {
    if (target && "threshold" in target) {
        const threshold = Number.parseFloat(target.threshold);
        return `${threshold * 1000}ms`;
    }
}
function $18c515912ab80737$export$9f3f70cd2f8cef74(target) {
    const percentile = Number.parseFloat(target.percentile);
    return `> ${percentile}%`;
}
function $18c515912ab80737$export$aaa67c14b2bf3b69(target) {
    const percentile = Number.parseFloat(target.percentile);
    const threshold = Number.parseFloat(target.threshold);
    return `${percentile}% < ${threshold * 1000}ms`;
}
function $18c515912ab80737$export$bc62687c0c7b145(value) {
    if (value === null) return "-";
    return Number.parseFloat(value).toLocaleString(undefined, {
        style: "percent",
        minimumFractionDigits: 1,
        maximumFractionDigits: 1
    });
}


/**
 * Sorts an array ascending by priority.
 *
 * *Warning:* As this function uses `Array#sort()` it also mutates the input
 * array.
 */ function $9f9f23ebe544ac69$export$b035e44d7bb4278f(array, getPriorityFn, reverse = false) {
    return array.sort((a, b)=>{
        const priorityA = getPriorityFn(a);
        const priorityB = getPriorityFn(b);
        if (priorityA < priorityB) return reverse === true ? 1 : -1;
        else if (priorityA > priorityB) return reverse === true ? -1 : 1;
        else return 0;
    });
}


function $0cca6883e0725c68$export$e9caaaecfee38128(event) {
    $0cca6883e0725c68$export$51134cce184326b9(event);
    event.preventDefault();
}
function $0cca6883e0725c68$export$51134cce184326b9(event) {
    event.nativeEvent?.stopImmediatePropagation();
    event.stopPropagation();
}


const $89bcf338a8e6a1c2$export$e2c41d5adc1ba178 = {
    LAST_5_MINUTES: "Last 5 minutes",
    LAST_15_MINUTES: "Last 15 minutes",
    LAST_30_MINUTES: "Last 30 minutes",
    LAST_1_HOUR: "Last 1 hour",
    LAST_3_HOURS: "Last 3 hours",
    LAST_6_HOURS: "Last 6 hours",
    LAST_12_HOURS: "Last 12 hours",
    LAST_24_HOURS: "Last 24 hours",
    LAST_2_DAYS: "Last 2 days",
    LAST_7_DAYS: "Last 7 days",
    LAST_30_DAYS: "Last 30 days",
    LAST_90_DAYS: "Last 90 days",
    LAST_6_MONTHS: "Last 6 months",
    LAST_1_YEAR: "Last 1 year",
    LAST_2_YEARS: "Last 2 years",
    LAST_5_YEARS: "Last 5 years",
    LAST_10_YEARS: "Last 10 years",
    LAST_20_YEARS: "Last 20 years"
};
const { LAST_5_MINUTES: $89bcf338a8e6a1c2$var$LAST_5_MINUTES, LAST_15_MINUTES: $89bcf338a8e6a1c2$var$LAST_15_MINUTES, LAST_30_MINUTES: $89bcf338a8e6a1c2$var$LAST_30_MINUTES, LAST_1_HOUR: $89bcf338a8e6a1c2$var$LAST_1_HOUR, LAST_3_HOURS: $89bcf338a8e6a1c2$var$LAST_3_HOURS, LAST_6_HOURS: $89bcf338a8e6a1c2$var$LAST_6_HOURS, LAST_12_HOURS: $89bcf338a8e6a1c2$var$LAST_12_HOURS, LAST_24_HOURS: $89bcf338a8e6a1c2$var$LAST_24_HOURS, LAST_2_DAYS: $89bcf338a8e6a1c2$var$LAST_2_DAYS, LAST_7_DAYS: $89bcf338a8e6a1c2$var$LAST_7_DAYS, LAST_30_DAYS: $89bcf338a8e6a1c2$var$LAST_30_DAYS, LAST_90_DAYS: $89bcf338a8e6a1c2$var$LAST_90_DAYS, LAST_6_MONTHS: $89bcf338a8e6a1c2$var$LAST_6_MONTHS, LAST_1_YEAR: $89bcf338a8e6a1c2$var$LAST_1_YEAR, LAST_2_YEARS: $89bcf338a8e6a1c2$var$LAST_2_YEARS, LAST_5_YEARS: $89bcf338a8e6a1c2$var$LAST_5_YEARS, LAST_10_YEARS: $89bcf338a8e6a1c2$var$LAST_10_YEARS, LAST_20_YEARS: $89bcf338a8e6a1c2$var$LAST_20_YEARS } = $89bcf338a8e6a1c2$export$e2c41d5adc1ba178;
const $89bcf338a8e6a1c2$export$523707e132cb0181 = [
    {
        label: $89bcf338a8e6a1c2$var$LAST_5_MINUTES,
        value: 300000
    },
    {
        label: $89bcf338a8e6a1c2$var$LAST_15_MINUTES,
        value: 900000
    },
    {
        label: $89bcf338a8e6a1c2$var$LAST_30_MINUTES,
        value: 1800000
    },
    {
        label: $89bcf338a8e6a1c2$var$LAST_1_HOUR,
        value: 3600000
    },
    {
        label: $89bcf338a8e6a1c2$var$LAST_3_HOURS,
        value: 10800000
    },
    {
        label: $89bcf338a8e6a1c2$var$LAST_6_HOURS,
        value: 21600000
    },
    {
        label: $89bcf338a8e6a1c2$var$LAST_12_HOURS,
        value: 43200000
    },
    {
        label: $89bcf338a8e6a1c2$var$LAST_24_HOURS,
        value: 86400000
    },
    {
        label: $89bcf338a8e6a1c2$var$LAST_2_DAYS,
        value: 172800000
    },
    {
        label: $89bcf338a8e6a1c2$var$LAST_7_DAYS,
        value: 604800000
    },
    {
        label: $89bcf338a8e6a1c2$var$LAST_30_DAYS,
        value: 2592000000
    },
    {
        label: $89bcf338a8e6a1c2$var$LAST_90_DAYS,
        value: 7776000000
    },
    {
        label: $89bcf338a8e6a1c2$var$LAST_6_MONTHS,
        value: 15552000000
    },
    {
        label: $89bcf338a8e6a1c2$var$LAST_1_YEAR,
        value: 31536000000
    },
    {
        label: $89bcf338a8e6a1c2$var$LAST_2_YEARS,
        value: 63072000000
    },
    {
        label: $89bcf338a8e6a1c2$var$LAST_5_YEARS,
        value: 157680000000
    },
    {
        label: $89bcf338a8e6a1c2$var$LAST_10_YEARS,
        value: 315360000000
    },
    {
        label: $89bcf338a8e6a1c2$var$LAST_20_YEARS,
        value: 630720000000
    }
];
const $89bcf338a8e6a1c2$export$b4d6c2a64cc2b2b0 = (label)=>{
    if (label === undefined) return false;
    return Object.values($89bcf338a8e6a1c2$export$e2c41d5adc1ba178).includes(label);
};
const $89bcf338a8e6a1c2$export$8f45430ccf837300 = [
    "var(--vscode-charts-red)",
    "var(--vscode-charts-blue)",
    "var(--vscode-charts-yellow)",
    "var(--vscode-charts-orange)",
    "var(--vscode-charts-green)",
    "var(--vscode-charts-purple)"
];
function $89bcf338a8e6a1c2$export$67e345da141048a6(date) {
    return {
        month: date.getMonth(),
        date: date.getDate(),
        year: date.getFullYear(),
        timestamp: date.toISOString()
    };
}
const $89bcf338a8e6a1c2$export$64d33c59520c51c1 = (timestamp)=>new Date(timestamp);
function $89bcf338a8e6a1c2$export$3f06d195264d0026(px, baseSize = 13) {
    return `${px / baseSize}em`;
}
function $89bcf338a8e6a1c2$export$832e640e210af61e(values) {
    const { from: fromValue, to: toValue } = values;
    const parsedFrom = $89bcf338a8e6a1c2$export$5949043e4444048(fromValue);
    const parsedTo = $89bcf338a8e6a1c2$export$5949043e4444048(toValue);
    let fromError;
    let toError;
    let globalError;
    if (Number.isNaN(parsedFrom)) fromError = "Invalid date entered";
    if (Number.isNaN(parsedTo)) toError = "Invalid date entered";
    if (parsedTo < parsedFrom) globalError = "End date is before start date";
    return {
        values: {
            from: fromError ? fromValue : $89bcf338a8e6a1c2$export$63e62e07a20d7b8c(parsedFrom),
            to: toError ? toValue : $89bcf338a8e6a1c2$export$63e62e07a20d7b8c(parsedTo)
        },
        errors: {
            from: fromError,
            to: toError,
            global: globalError
        }
    };
}
const $89bcf338a8e6a1c2$export$63e62e07a20d7b8c = (seconds)=>new Date(seconds * 1000).toISOString();
const $89bcf338a8e6a1c2$export$5949043e4444048 = (timestamp)=>new Date(timestamp).getTime() / 1000;
const $89bcf338a8e6a1c2$export$e731e036b2515f5f = (ms)=>new Date(ms).toISOString();
const $89bcf338a8e6a1c2$export$548eeb384550c76a = (timestamp, timeRange)=>timestamp >= timeRange.from && timestamp <= timeRange.to;
function $89bcf338a8e6a1c2$export$1691be63bfdf0baf(label) {
    let option = $89bcf338a8e6a1c2$export$523707e132cb0181.find((option)=>option.label === label);
    if (!option) {
        //eslint-disable-next-line no-console
        console.error("Error looking up relative time range for label:", label);
        // HACK - fall back to 15 minutes. Throwing an error would crash the app, and that's no bueno
        option = {
            label: "Last 15 minutes",
            value: 900000
        };
    }
    return $89bcf338a8e6a1c2$export$e960ce4da64adf02(option);
}
function $89bcf338a8e6a1c2$export$e960ce4da64adf02(option) {
    const now = Date.now();
    return {
        from: $89bcf338a8e6a1c2$export$e731e036b2515f5f(now - option.value),
        to: $89bcf338a8e6a1c2$export$e731e036b2515f5f(now),
        relativeTimeRangeLabel: option.label
    };
}
function $89bcf338a8e6a1c2$export$2065733108560294(searchParams, newTimeRange) {
    searchParams.delete("from");
    searchParams.delete("to");
    searchParams.delete("relativeTimeRangeLabel");
    if (newTimeRange.relativeTimeRangeLabel) searchParams.set("relativeTimeRangeLabel", newTimeRange.relativeTimeRangeLabel);
    searchParams.set("to", newTimeRange.to);
    searchParams.set("from", newTimeRange.from);
}


const $6babf196a55ab307$var$os = typeof navigator === "undefined" ? "" : navigator.platform.match(/mac|win|linux/i)?.[0]?.toLowerCase();
const $6babf196a55ab307$export$9ac100e40613ea10 = $6babf196a55ab307$var$os === "mac";
const $6babf196a55ab307$export$95df08bae54cb4df = typeof navigator === "undefined" ? false : /^((?!chrome|android).)*safari/i.test(navigator.userAgent);




function $11b6fc6d47385bf9$export$ecda826b14306ed0() {
    const navigate = (0, $efeb47d767416279$export$9770f232ac06a008)();
    const { timeRange: timeRange } = (0, $326a17b5958d0a0c$export$43bf3df9dfee3ce5)();
    const [currentSearchParams] = (0, $e7b98158099ae00d$export$f1a78c17382fe22a)();
    return (0, $cac150ebb620e91f$export$d095b0c879743c0d)((timestamp)=>{
        if ((0, $89bcf338a8e6a1c2$export$548eeb384550c76a)(timestamp, timeRange)) navigate({
            pathname: "/alerts",
            search: currentSearchParams.toString()
        });
        else {
            const relativeTimeRangeLabel = $11b6fc6d47385bf9$export$5b5403c2f4f16cc6(timestamp);
            navigate({
                pathname: "/alerts",
                search: new URLSearchParams({
                    relativeTimeRangeLabel: relativeTimeRangeLabel
                }).toString()
            });
        }
    });
}
const $11b6fc6d47385bf9$export$5b5403c2f4f16cc6 = (timestamp, minimalRange = 900000)=>{
    const now = Date.now();
    const target = new Date(timestamp).getTime();
    const diff = now - target;
    const usableDiff = diff < minimalRange ? minimalRange : diff;
    const preset = (0, $89bcf338a8e6a1c2$export$523707e132cb0181).find((option)=>option.value >= usableDiff);
    if (!preset) return (0, $89bcf338a8e6a1c2$export$e2c41d5adc1ba178).LAST_15_MINUTES;
    return preset.label;
};



// If registration is not, it set means the service worker was either:
// * never initialized
// * not active
// * not supported
// * failed to register
let $7664b12fc370b925$var$_registration;
const $7664b12fc370b925$export$5c10cbeef76d9c2c = ()=>$7664b12fc370b925$var$_registration?.active;
const $7664b12fc370b925$export$888ef00dae8dd17c = "serviceWorker" in navigator;
var $c3a14de01ae04c08$exports = {};
$c3a14de01ae04c08$exports = new URL("up_/src/services/notifications/serviceWorker.5749a28c.js", import.meta.url).toString();


async function $7664b12fc370b925$export$c6c2d00cd8b9d1cc() {
    if ($7664b12fc370b925$export$888ef00dae8dd17c === false) return;
    try {
        $7664b12fc370b925$var$_registration = await navigator.serviceWorker.register($c3a14de01ae04c08$exports);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error registering service worker", error);
    }
}


function $0d5c480fb2687e20$export$d476ee5008a9dcb3() {
    const [desktopNotificationsEnabled, setDesktopNotificationsEnabled] = (0, $7fd7ff57d61a706f$export$86e2cef2561044ac)("showDesktopNotifications", true);
    const [notificationState, setNotificationState] = (0, $2gcPZ.useState)($0d5c480fb2687e20$var$DesktopNotificationSettings.getInstance().notificationState);
    (0, $2gcPZ.useEffect)(()=>{
        const handler = (state)=>{
            setNotificationState(state);
        };
        $0d5c480fb2687e20$var$DesktopNotificationSettings.getInstance().on("change", handler);
        return ()=>{
            $0d5c480fb2687e20$var$DesktopNotificationSettings.getInstance().off("change", handler);
        };
    }, []);
    const navigateToAlerts = (0, $11b6fc6d47385bf9$export$ecda826b14306ed0)();
    const requestPermissionHandler = (0, $cac150ebb620e91f$export$d095b0c879743c0d)((timestamp)=>{
        return $0d5c480fb2687e20$var$DesktopNotificationSettings.getInstance().requestPermission().then((allowed)=>{
            if (allowed) {
                const worker = (0, $176313a6a434cc5e$exports).getServiceWorker();
                worker?.postMessage({
                    type: "NOTIFICATIONS_ENABLED"
                });
            }
            if (timestamp) navigateToAlerts(timestamp);
        });
    });
    return {
        settings: {
            notificationState: notificationState,
            desktopNotificationsEnabled: desktopNotificationsEnabled
        },
        setDesktopNotificationsEnabled: setDesktopNotificationsEnabled,
        requestPermission: requestPermissionHandler
    };
}
class $0d5c480fb2687e20$var$DesktopNotificationSettings extends (0, (/*@__PURE__*/$parcel$interopDefault($dd1c135fbc36bd36$exports))) {
    _notificationState;
    static _instance = null;
    constructor(){
        super();
        this._notificationState = "initial";
        navigator.permissions.query({
            name: "notifications"
        }).then((result)=>{
            result.addEventListener("change", ()=>{
                // Result.state is returning "prompt" also when we've not requested it yet.
                this.notificationState = result.state === "prompt" ? "default" : result.state;
            });
        });
    }
    set notificationState(newState) {
        if (this._notificationState === newState) return;
        this._notificationState = newState;
        this.emit("change", newState);
    }
    get notificationState() {
        return this._notificationState;
    }
    // Resolves to true if the permission was granted, false otherwise
    async requestPermission() {
        this.notificationState = "prompt";
        const permission = await window.Notification.requestPermission();
        this.notificationState = permission === "granted" ? "granted" : "denied";
        return permission === "granted";
    }
    static getInstance() {
        if ($0d5c480fb2687e20$var$DesktopNotificationSettings._instance === null) {
            $0d5c480fb2687e20$var$DesktopNotificationSettings._instance = new $0d5c480fb2687e20$var$DesktopNotificationSettings();
            // Singleton with a side effect: we're initializing the service worker also
            (0, $7664b12fc370b925$export$c6c2d00cd8b9d1cc)().then(()=>{
                $0d5c480fb2687e20$var$DesktopNotificationSettings._instance?.emit("change", (0, $7664b12fc370b925$export$5c10cbeef76d9c2c)() === null ? "denied" : window.Notification.permission);
            });
        }
        return $0d5c480fb2687e20$var$DesktopNotificationSettings._instance;
    }
}












const $81accdab4a22bb8e$export$63cac1209355ebdd = (0, $5755db105caee352$export$bcc8035e549759b4).injectEndpoints({
    endpoints: (builder)=>({
            getAllTrackedObjectives: builder.query({
                async queryFn (args, _queryApi, _extraOptions, fetchWithBq) {
                    // Create search params for series that have success rate objective attached
                    // Search for all function_calls series, and only include results that have the following labels set:
                    //  - function
                    //  - module
                    //  - objective_name
                    //  - objective_percentile
                    const successRateParams = new URLSearchParams();
                    successRateParams.append("match[]", '{__name__=~"function_calls(_count)?(_total)?", objective_name!="", objective_percentile!="", function!="", module!=""}');
                    // Create search params for series that have latency objective attached
                    // Search for all function_calls_duration(_seconds)?_count series, and only include results that have the following labels set:
                    //  - function
                    //  - module
                    //  - objective_name
                    //  - objective_percentile
                    //  - objective_latency_threshold
                    const latencyParams = new URLSearchParams();
                    latencyParams.append("match[]", '{__name__=~"function_calls_duration(_seconds)?_count", objective_name!="", objective_percentile!="", objective_latency_threshold!="", function!="", module!=""}');
                    // Fetch the success rate and latency series in parallel
                    const [successRateResult, latencyResult] = await Promise.all([
                        (0, $6e24479930419a5d$export$8192083f64c7bc77)(fetchWithBq, {
                            url: `/api/v1/series`,
                            params: successRateParams
                        }, (0, $f4ba6d3372e76af6$export$564e2e24cd71d4e1)),
                        (0, $6e24479930419a5d$export$8192083f64c7bc77)(fetchWithBq, {
                            url: `/api/v1/series`,
                            params: latencyParams
                        }, (0, $f4ba6d3372e76af6$export$cfbfa6de45b9d00d))
                    ]);
                    // If either request failed, return the rtk-query error
                    // NOTE - the error could happen due to a network error, or a decoding error
                    if ("error" in successRateResult) return successRateResult;
                    if ("error" in latencyResult) return latencyResult;
                    // Combine the success rate and latency objectives into one array
                    const successObjectives = $81accdab4a22bb8e$var$getSuccessObjectiveFromSeries(successRateResult.data.data);
                    const latencyObjectives = $81accdab4a22bb8e$var$getLatencyObjectiveFromSeries(latencyResult.data.data);
                    // Collect and sort the objectives by name
                    return {
                        data: (0, $9f9f23ebe544ac69$export$b035e44d7bb4278f)([
                            ...successObjectives,
                            ...latencyObjectives
                        ], (objective)=>objective.name)
                    };
                }
            }),
            getAllTrackedObjectivesWithCurrentValue: builder.query({
                async queryFn (args, _queryApi, _extraOptions, fetchWithBq) {
                    // Create search params for series that have success rate objective attached
                    // Search for all function_calls series, and only include results that have the following labels set:
                    //  - function
                    //  - module
                    //  - objective_name
                    //  - objective_percentile
                    const successRateParams = new URLSearchParams();
                    successRateParams.append("match[]", '{__name__=~"function_calls(_count)?(_total)?", objective_name!="", objective_percentile!="", function!="", module!=""}');
                    // Create search params for series that have latency objective attached
                    // Search for all function_calls_duration(_seconds)?_count series, and only include results that have the following labels set:
                    //  - function
                    //  - module
                    //  - objective_name
                    //  - objective_percentile
                    //  - objective_latency_threshold
                    const latencyParams = new URLSearchParams();
                    latencyParams.append("match[]", '{__name__=~"function_calls_duration(_seconds)?_count", objective_name!="", objective_percentile!="", objective_latency_threshold!="", function!="", module!=""}');
                    // Fetch the success rate and latency series in parallel
                    const [successRateResult, latencyResult] = await Promise.all([
                        (0, $6e24479930419a5d$export$8192083f64c7bc77)(fetchWithBq, {
                            url: `/api/v1/series`,
                            params: successRateParams
                        }, (0, $f4ba6d3372e76af6$export$564e2e24cd71d4e1)),
                        (0, $6e24479930419a5d$export$8192083f64c7bc77)(fetchWithBq, {
                            url: `/api/v1/series`,
                            params: latencyParams
                        }, (0, $f4ba6d3372e76af6$export$cfbfa6de45b9d00d))
                    ]);
                    // If either request failed, return the rtk-query error
                    // NOTE - the error could happen due to a network error, or a decoding error
                    if ("error" in successRateResult) return successRateResult;
                    if ("error" in latencyResult) return latencyResult;
                    // Combine the success rate and latency objectives into one array
                    const successObjectives = $81accdab4a22bb8e$var$getSuccessObjectiveFromSeries(successRateResult.data.data);
                    const latencyObjectives = $81accdab4a22bb8e$var$getLatencyObjectiveFromSeries(latencyResult.data.data);
                    // Collect and sort the objectives by name
                    const objectives = (0, $9f9f23ebe544ac69$export$b035e44d7bb4278f)([
                        ...successObjectives,
                        ...latencyObjectives
                    ], (objective)=>objective.name);
                    // HACK - fetch all "current values" in parallel, and fail silently for each request
                    const { start: start, end: end } = args;
                    const objectivesWithCurrentValue = await Promise.all(objectives.map(async (objective)=>{
                        const query = $81accdab4a22bb8e$var$getQueryForObjective(objective, start, end);
                        const params = new URLSearchParams();
                        params.append("query", query);
                        const currentValueQuery = await fetchWithBq({
                            url: `/api/v1/query`,
                            params: params
                        });
                        // NOTE - the `getScalarFromPrometheusQueryResponse` will fail silently if there's no value present
                        //        it should log a debug statement, however, about the unexpected response
                        const currentValue = (0, $6e24479930419a5d$export$7abc1d61b627c701)(currentValueQuery);
                        return {
                            ...objective,
                            currentValue: currentValue
                        };
                    }));
                    return {
                        data: objectivesWithCurrentValue
                    };
                }
            }),
            getCurrentValueForObjective: builder.query({
                async queryFn ({ objective: objective, start: start, end: end }, _queryApi, _extraOptions, fetchWithBq) {
                    const query = $81accdab4a22bb8e$var$getQueryForObjective(objective, start, end);
                    const params = new URLSearchParams();
                    params.append("query", query);
                    const currentValueQuery = await fetchWithBq({
                        url: `/api/v1/query`,
                        params: params
                    });
                    // NOTE - the `getScalarFromPrometheusQueryResponse` will fail silently if there's no value present
                    //        it should log a debug statement, however, about the unexpected response
                    const currentValue = (0, $6e24479930419a5d$export$7abc1d61b627c701)(currentValueQuery);
                    return {
                        data: {
                            ...objective,
                            currentValue: currentValue
                        }
                    };
                }
            }),
            getObjectiveFunctionsWithCurrentValue: builder.query({
                async queryFn (args, _queryApi, _extraOptions, fetchWithBq) {
                    const successRateParams = new URLSearchParams();
                    successRateParams.append("match[]", '{__name__=~"function_calls(_count)?(_total)?", objective_name!="", objective_percentile!="", function!="", module!=""}');
                    const latencyParams = new URLSearchParams();
                    latencyParams.append("match[]", '{__name__=~"function_calls_duration(_seconds)?_count", objective_name!="", objective_percentile!="", objective_latency_threshold!="", function!="", module!=""}');
                    // Fetch the success rate and latency series in parallel
                    const [successRateResult, latencyResult] = await Promise.all([
                        (0, $6e24479930419a5d$export$8192083f64c7bc77)(fetchWithBq, {
                            url: `/api/v1/series`,
                            params: successRateParams
                        }, (0, $f4ba6d3372e76af6$export$564e2e24cd71d4e1)),
                        (0, $6e24479930419a5d$export$8192083f64c7bc77)(fetchWithBq, {
                            url: `/api/v1/series`,
                            params: latencyParams
                        }, (0, $f4ba6d3372e76af6$export$cfbfa6de45b9d00d))
                    ]);
                    // If either request failed, return the rtk-query error
                    // NOTE - the error could happen due to a network error, or a decoding error
                    if ("error" in successRateResult) return successRateResult;
                    if ("error" in latencyResult) return latencyResult;
                    // Combine the success rate and latency objectives into one array
                    const successObjectives = $81accdab4a22bb8e$var$getSuccessObjectiveFromSeries(successRateResult.data.data);
                    const latencyObjectives = $81accdab4a22bb8e$var$getLatencyObjectiveFromSeries(latencyResult.data.data);
                    // Collect and sort the objectives by name
                    const objectives = (0, $9f9f23ebe544ac69$export$b035e44d7bb4278f)([
                        ...successObjectives,
                        ...latencyObjectives
                    ], (objective)=>objective.name);
                    const objective = objectives.find(({ name: name, metric: metric })=>name === args.objective.name && metric === args.objective.metric);
                    if (objective) {
                        // HACK - fetch all "current values" in parallel, and fail silently for each request
                        const functionsWithCurrentValue = await Promise.all(objective.functions.map(async (fn)=>{
                            const query = $81accdab4a22bb8e$var$getQueryForObjective(objective, args.start, args.end, {
                                name: fn.name,
                                module: fn.module,
                                service_name: fn.service_name
                            });
                            const params = new URLSearchParams();
                            params.append("query", query);
                            const currentValueQuery = await fetchWithBq({
                                url: `/api/v1/query`,
                                params: params
                            });
                            const currentValue = (0, $6e24479930419a5d$export$7abc1d61b627c701)(currentValueQuery);
                            return {
                                ...fn,
                                currentValue: currentValue
                            };
                        }));
                        // OPTIMIZE - We don't have to N+1 query for the data we need.
                        //            Here is an example of how to get all the function currentValues we need
                        //            using only one query:
                        //
                        // if (objective.metric === "latency") {
                        //   const _mehParams = new URLSearchParams();
                        //   _mehParams.append(
                        //     "query",
                        //     Prometheus.createSLOQueryLatencyUnderThresholdByFunction(
                        //       objective,
                        //       args.start,
                        //       args.end
                        //     )
                        //   );
                        //   const functionsWithCurrentValueAlt = await fetchAndDecode(
                        //     fetchWithBq,
                        //     {
                        //       url: `/api/v1/query`,
                        //       params: _mehParams,
                        //     },
                        //     PrometheusObjectiveFunctionModulePairCurrentValueResponseSchema
                        //   );
                        //   console.log("HIII", functionsWithCurrentValueAlt);
                        // }
                        return {
                            data: functionsWithCurrentValue
                        };
                    }
                    return {
                        data: []
                    };
                }
            })
        })
}).enhanceEndpoints({
    addTagTypes: [
        "Objective",
        "ObjectiveCurrentValue",
        "ObjectiveFunctions"
    ],
    endpoints: {
        getAllTrackedObjectives: {
            providesTags: (objectives, _error, { environmentUrl: environmentUrl, start: start, end: end })=>{
                if (environmentUrl && objectives && objectives.length > 0) return objectives.map((objective)=>{
                    return {
                        type: "Objective",
                        id: `${environmentUrl}:${$81accdab4a22bb8e$var$getObjectiveCacheKey(objective)}:${start}:${end}`
                    };
                });
                return [
                    {
                        type: "Objective"
                    }
                ];
            }
        },
        getCurrentValueForObjective: {
            providesTags: (objective, _error, { environmentUrl: environmentUrl, start: start, end: end })=>{
                if (environmentUrl && objective) return [
                    {
                        type: "ObjectiveCurrentValue",
                        id: `${environmentUrl}:${$81accdab4a22bb8e$var$getObjectiveCacheKey(objective)}:${start}:${end}`
                    }
                ];
                return [
                    {
                        type: "ObjectiveCurrentValue"
                    }
                ];
            }
        },
        getObjectiveFunctionsWithCurrentValue: {
            providesTags: (_functions, _error, { environmentUrl: instanceUrl, objective: objective })=>{
                if (instanceUrl) return [
                    {
                        type: "ObjectiveFunctions",
                        id: `${instanceUrl}:${$81accdab4a22bb8e$var$getObjectiveCacheKey(objective)}`
                    }
                ];
                return [
                    {
                        type: "ObjectiveFunctions"
                    }
                ];
            }
        }
    }
});
function $81accdab4a22bb8e$var$getObjectiveCacheKey({ name: name, metric: metric, target: target }) {
    return `${name}:${metric}:${target.percentile}${"threshold" in target ? `:${target.threshold}` : ""}`;
}
const { useGetAllTrackedObjectivesQuery: $81accdab4a22bb8e$export$d5dc83059f71efcf, useGetAllTrackedObjectivesWithCurrentValueQuery: $81accdab4a22bb8e$export$117f4f94ea08f791, useGetCurrentValueForObjectiveQuery: $81accdab4a22bb8e$export$a6442cc80badd0c3, useGetObjectiveFunctionsWithCurrentValueQuery: $81accdab4a22bb8e$export$3eac9bcbfcea7d64 } = $81accdab4a22bb8e$export$63cac1209355ebdd;
function $81accdab4a22bb8e$var$getLatencyObjectiveKey({ objective_name: objective_name, objective_percentile: objective_percentile, objective_latency_threshold: objective_latency_threshold }) {
    return `${objective_name}:latency:${objective_percentile}:${objective_latency_threshold}`;
}
function $81accdab4a22bb8e$var$getLatencyObjectiveFromSeries(series) {
    // Create an object whose keys are a combination of objective names and settings.
    const objectivesByName = series.reduce((result, currentSeries)=>{
        const key = $81accdab4a22bb8e$var$getLatencyObjectiveKey(currentSeries);
        const objectiveName = currentSeries.objective_name;
        if (!result[key]) result[key] = {
            series: [],
            name: objectiveName,
            functions: [],
            metric: "latency",
            target: {
                percentile: currentSeries.objective_percentile,
                threshold: currentSeries.objective_latency_threshold
            }
        };
        result[key]?.series.push(currentSeries);
        return result;
    }, {});
    // NOTE - If you modify your objectives, old labels will also show up.
    //        We need some form of conflict resolution :grimace:
    return $81accdab4a22bb8e$var$transformObjectiveMetadata(objectivesByName);
}
function $81accdab4a22bb8e$var$getSuccessObjectiveKey({ objective_name: objective_name, objective_percentile: objective_percentile }) {
    return `${objective_name}:successRate:${objective_percentile}`;
}
function $81accdab4a22bb8e$var$getSuccessObjectiveFromSeries(series) {
    // Create an object whose keys are a combination of objective names and settings.
    const objectivesByName = series.reduce((result, currentSeries)=>{
        const key = $81accdab4a22bb8e$var$getSuccessObjectiveKey(currentSeries);
        const objectiveName = currentSeries.objective_name;
        if (!result[key]) result[key] = {
            series: [],
            name: objectiveName,
            functions: [],
            metric: "successRate",
            target: {
                percentile: currentSeries.objective_percentile
            }
        };
        result[key]?.series.push(currentSeries);
        return result;
    }, {});
    return $81accdab4a22bb8e$var$transformObjectiveMetadata(objectivesByName);
}
/**
 * Helper function for the final step of transforming objective metadata
 */ function $81accdab4a22bb8e$var$transformObjectiveMetadata(objectivesByName) {
    // NOTE - If you modify your objectives, old labels will also show up.
    //        We need some form of conflict resolution :grimace:
    for (const objectiveKey of Object.keys(objectivesByName)){
        const objectiveMeta = objectivesByName[objectiveKey];
        if (!objectiveMeta) continue;
        // First, find all functions associated with this SLO
        // TODO - Should we check against the latest build? To make sure we're not using old functions that are no longer part of the SLO
        objectiveMeta.functions = (0, $097bfc2d1913d58c$exports).filterUniqueFunctionModulePairs(objectiveMeta.series.map((entry)=>({
                name: entry.function,
                module: entry.module,
                service_name: ""
            })));
        (0, $9f9f23ebe544ac69$export$b035e44d7bb4278f)(objectiveMeta.functions, (objective)=>objective.name);
        objectiveMeta.functionsCount = objectiveMeta.functions.length;
    }
    return Object.values(objectivesByName);
}
// Helper function to get query for SL0
function $81accdab4a22bb8e$var$getQueryForObjective(objective, start, end, functionModuleLabelPair) {
    if (objective.metric === "latency") return (0, $097bfc2d1913d58c$exports).createSLOQueryLatencyUnderThreshold(objective, start, end, functionModuleLabelPair);
    if (objective.metric === "successRate") return (0, $097bfc2d1913d58c$exports).createSLOQuerySuccessRate(objective, start, end, functionModuleLabelPair);
    return "";
}






const $7530fbaa6f2f256c$export$f46ec044b18f1140 = (0, $5755db105caee352$export$bcc8035e549759b4).injectEndpoints({
    endpoints: (builder)=>({
            getAllTrackedFunctions: builder.query({
                query: ()=>{
                    // Search for all function_calls series, and only include results that have both a function and module label
                    const params = new URLSearchParams();
                    params.append("match[]", '{__name__=~"function_calls(_count)?(_total)?", function!="", module!=""}');
                    return {
                        url: `/api/v1/series?${params.toString()}`
                    };
                },
                // eslint-disable-next-line require-await
                transformResponse: async (response)=>{
                    // NOTE - parse can throw, but the error will be caught by RTK Query and the UI will think there were no results
                    const series = (0, $60861bad2fa82ac2$export$bc24f3a0830a9f54).parse(response).data;
                    return (0, $097bfc2d1913d58c$exports).filterUniqueFunctionModulePairs(series.map((entry)=>({
                            name: entry.function,
                            module: entry.module,
                            service_name: entry.service_name
                        })));
                }
            }),
            getAllSourceLocations: builder.query({
                query: ()=>{
                    const { origin: origin } = window.location;
                    return {
                        url: `${origin}/api/functions`,
                        mode: "cors"
                    };
                },
                // eslint-disable-next-line require-await
                transformResponse: async (response)=>{
                    // NOTE - parse can throw, but the error will be caught by RTK Query and the UI will think there were no results
                    return (0, $60861bad2fa82ac2$export$18ef546fa9c64571).parse(response);
                }
            }),
            getAllChildFunctions: builder.query({
                async queryFn (args, _queryApi, _extraOptions, fetchWithBq) {
                    const { callerFunction: callerFunction, callerModule: callerModule } = args;
                    const oldCallerLabelParams = new URLSearchParams();
                    oldCallerLabelParams.append("match[]", `{__name__=~"function_calls(_count)?(_total)?", function!="", module!="", caller=~"${callerFunction}"}`);
                    const newCallerLabelParams = new URLSearchParams();
                    if (callerModule) newCallerLabelParams.append("match[]", `{__name__=~"function_calls(_count)?(_total)?", function!="", module!="", caller_module="${callerModule}", caller_function=~"${callerFunction}"}`);
                    else newCallerLabelParams.append("match[]", `{__name__=~"function_calls(_count)?(_total)?", function!="", module!="", caller_module!="", caller_function=~"${callerFunction}"}`);
                    // Fetch the old caller series and new caller series in parallel
                    const [oldCallerSeries, newCallerSeries] = await Promise.all([
                        (0, $6e24479930419a5d$export$8192083f64c7bc77)(fetchWithBq, {
                            url: `/api/v1/series`,
                            params: oldCallerLabelParams
                        }, (0, $60861bad2fa82ac2$export$bc24f3a0830a9f54)),
                        (0, $6e24479930419a5d$export$8192083f64c7bc77)(fetchWithBq, {
                            url: `/api/v1/series`,
                            params: newCallerLabelParams
                        }, (0, $60861bad2fa82ac2$export$bc24f3a0830a9f54))
                    ]);
                    // If either request failed, return the rtk-query error
                    // NOTE - the error could happen due to a network error, or a decoding error
                    if ("error" in oldCallerSeries) return oldCallerSeries;
                    if ("error" in newCallerSeries) return newCallerSeries;
                    return {
                        data: (0, $097bfc2d1913d58c$exports).filterUniqueFunctionModulePairs([
                            ...newCallerSeries.data.data,
                            ...oldCallerSeries.data.data
                        ].map((entry)=>({
                                name: entry.function,
                                module: entry.module
                            })))
                    };
                }
            })
        })
}).enhanceEndpoints({
    addTagTypes: [
        "Functions",
        "ChildFunctions"
    ],
    endpoints: {
        getAllTrackedFunctions: {
            providesTags: (_functions, _error, environmentUrl)=>{
                if (environmentUrl) return [
                    {
                        type: "Functions",
                        id: environmentUrl
                    }
                ];
                return [];
            }
        },
        getAllChildFunctions: {
            providesTags: (_functions, _error, { callerFunction: callerFunction, callerModule: callerModule, environmentUrl: environmentUrl })=>{
                if (environmentUrl) {
                    const id = `${environmentUrl}-${callerFunction}-${callerModule}`;
                    return [
                        {
                            type: "ChildFunctions",
                            id: id
                        }
                    ];
                }
                return [];
            }
        }
    }
});
const { useGetAllTrackedFunctionsQuery: $7530fbaa6f2f256c$export$7f85c6a6ff922ea5, useGetAllChildFunctionsQuery: $7530fbaa6f2f256c$export$cfb5320a6bdf069a, useGetAllSourceLocationsQuery: $7530fbaa6f2f256c$export$629df691c102e2da, useLazyGetAllSourceLocationsQuery: $7530fbaa6f2f256c$export$87b7625d1fedbc0e } = $7530fbaa6f2f256c$export$f46ec044b18f1140;




function $ebef9a37eb84c991$export$1fe69f4501914576(environmentUrl) {
    const { data: scrapeIntervals, isLoading: scrapeIntervalIsLoadng, isUninitialized: scrapeIntervalIsUninitialized } = (0, $5755db105caee352$export$c417b66dfc481843)({
        environmentUrl: environmentUrl
    }, {
        skip: !environmentUrl
    });
    const shouldWaitForBuildInfoInterval = scrapeIntervalIsLoadng || scrapeIntervalIsUninitialized;
    const buildInfoInterval = $ebef9a37eb84c991$var$getMinScrapeInterval(scrapeIntervals);
    return {
        shouldWaitForBuildInfoInterval: shouldWaitForBuildInfoInterval,
        buildInfoInterval: buildInfoInterval
    };
}
/**
 * @note - Will not consider scrape intervals of less than 1s
 * @note - Returns the ceiling of the minimum scrape interval, to avoid fractions of seconds
 */ function $ebef9a37eb84c991$var$getMinScrapeInterval(scrapeIntervals) {
    const filteredScrapeIntervals = scrapeIntervals?.filter((interval)=>interval >= 1);
    if (filteredScrapeIntervals?.length) {
        const minimumConfiguredScrapeInterval = filteredScrapeIntervals?.reduce((min, current)=>Math.min(min, current));
        if (typeof minimumConfiguredScrapeInterval === "number") {
            const intervalSeconds = Math.ceil(minimumConfiguredScrapeInterval);
            return `${intervalSeconds}s`;
        }
        return minimumConfiguredScrapeInterval;
    }
}





function $a82ff438e9d7ee7b$export$14a266f6d49360ef() {
    const amDetected = (0, $489af8f0cf88bff2$export$d41acecbaf77dfd0)();
    const [sourceCodeFeatureEnabled] = (0, $edc4621501740b0b$export$fc97652867e5867e)("source-code-links");
    const [value, setValue] = (0, $7fd7ff57d61a706f$export$86e2cef2561044ac)("source-code-link-settings", "off");
    // If the feature is not enabled/available, we always return "off"
    const returnValue = amDetected && sourceCodeFeatureEnabled ? value : "off";
    return {
        value: returnValue,
        set: setValue,
        supported: amDetected && sourceCodeFeatureEnabled
    };
}



var $2gcPZ = parcelRequire("2gcPZ");




function $bbc2cb4268a46f72$export$bace31607121468e() {
    const systemDefaultTheme = $bbc2cb4268a46f72$var$useSystemThemePreference();
    const [storedTheme, setStoredTheme] = (0, $7fd7ff57d61a706f$export$86e2cef2561044ac)("theme", null);
    const setToSystemTheme = (0, $cac150ebb620e91f$export$d095b0c879743c0d)(()=>{
        setStoredTheme(null);
    });
    const setThemePreference = (0, $cac150ebb620e91f$export$d095b0c879743c0d)((theme)=>{
        setStoredTheme(theme);
    });
    // Keeping this around for the toggle button which'll be used in dev only.
    // Handler to toggle the theme from dark to light and vice-versa
    const toggleTheme = (0, $cac150ebb620e91f$export$d095b0c879743c0d)(()=>{
        setStoredTheme(theme === "dark" ? "light" : "dark");
    });
    // The computed theme value
    // - If there's a stored theme and it's valid, use it
    // - Otherwise, use the system default
    const theme = (0, $2gcPZ.useMemo)(()=>{
        if (storedTheme && (0, $c5bcce893caf17be$export$888c18c43ead4265)(storedTheme)) return storedTheme;
        return systemDefaultTheme;
    }, [
        storedTheme,
        systemDefaultTheme
    ]);
    $bbc2cb4268a46f72$var$useSetToBody(theme);
    return {
        currentTheme: theme,
        isSystemPreference: !storedTheme,
        setThemePreference: setThemePreference,
        setToSystemTheme: setToSystemTheme,
        toggleTheme: toggleTheme
    };
}
function $bbc2cb4268a46f72$export$82d1b7ffdac7acac() {
    $bbc2cb4268a46f72$export$bace31607121468e();
}
function $bbc2cb4268a46f72$var$useSetToBody(theme) {
    // Effect to set the theme on the body element when it changes
    (0, $2gcPZ.useEffect)(()=>{
        document.body.dataset.switching = "true";
        setTimeout(()=>{
            document.body.dataset.theme = theme;
        });
        const listenerId = setTimeout(()=>{
            document.body.dataset.switching = "false";
        }, 100);
        return ()=>clearTimeout(listenerId);
    }, [
        theme
    ]);
}
// Hook that returns a theme based on the system's preferred color scheme
function $bbc2cb4268a46f72$var$useSystemThemePreference() {
    const systemPrefersDarkTheme = (0, (/*@__PURE__*/$parcel$interopDefault($35ed622046626785$exports)))("(prefers-color-scheme: dark)");
    return systemPrefersDarkTheme ? "dark" : "light";
}



var $2gcPZ = parcelRequire("2gcPZ");
var $a5001c7e93a4069b$exports = {};
"use strict";
Object.defineProperty($a5001c7e93a4069b$exports, "__esModule", {
    value: true
});
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $1737cdc3dafde60c$var$extendStatics = function(d, b) {
    $1737cdc3dafde60c$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $1737cdc3dafde60c$var$extendStatics(d, b);
};
function $1737cdc3dafde60c$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $1737cdc3dafde60c$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $1737cdc3dafde60c$export$18ce0697a983be9b = function() {
    $1737cdc3dafde60c$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1737cdc3dafde60c$export$18ce0697a983be9b.apply(this, arguments);
};
function $1737cdc3dafde60c$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $1737cdc3dafde60c$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $1737cdc3dafde60c$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $1737cdc3dafde60c$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.push(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.push(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $1737cdc3dafde60c$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $1737cdc3dafde60c$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $1737cdc3dafde60c$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $1737cdc3dafde60c$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $1737cdc3dafde60c$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $1737cdc3dafde60c$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $1737cdc3dafde60c$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $1737cdc3dafde60c$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $1737cdc3dafde60c$export$45d3717a4c69092e(o, m, p);
}
function $1737cdc3dafde60c$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $1737cdc3dafde60c$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $1737cdc3dafde60c$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($1737cdc3dafde60c$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $1737cdc3dafde60c$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $1737cdc3dafde60c$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $1737cdc3dafde60c$export$10c90e4f7922046c(v) {
    return this instanceof $1737cdc3dafde60c$export$10c90e4f7922046c ? (this.v = v, this) : new $1737cdc3dafde60c$export$10c90e4f7922046c(v);
}
function $1737cdc3dafde60c$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $1737cdc3dafde60c$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $1737cdc3dafde60c$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $1737cdc3dafde60c$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $1737cdc3dafde60c$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $1737cdc3dafde60c$export$19a8beecd37a4c45 === "function" ? $1737cdc3dafde60c$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $1737cdc3dafde60c$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $1737cdc3dafde60c$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $1737cdc3dafde60c$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $1737cdc3dafde60c$export$45d3717a4c69092e(result, mod, k);
    }
    $1737cdc3dafde60c$var$__setModuleDefault(result, mod);
    return result;
}
function $1737cdc3dafde60c$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $1737cdc3dafde60c$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $1737cdc3dafde60c$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $1737cdc3dafde60c$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}



var $2gcPZ = parcelRequire("2gcPZ");

var $a5001c7e93a4069b$var$useEffectOnce_1 = $1737cdc3dafde60c$export$da59b14a69baef04((parcelRequire("irAxG")));
var $a5001c7e93a4069b$var$useUnmount = function(fn) {
    var fnRef = $2gcPZ.useRef(fn);
    // update the ref each render so if it change the newest callback will be invoked
    fnRef.current = fn;
    $a5001c7e93a4069b$var$useEffectOnce_1.default(function() {
        return function() {
            return fnRef.current();
        };
    });
};
$a5001c7e93a4069b$exports.default = $a5001c7e93a4069b$var$useUnmount;



function $0256cde7569cadc3$export$4083eefea094a0de(isLoading, delayMs) {
    const [throttledIsLoading, setThrottledIsLoading] = (0, $2gcPZ.useState)(isLoading);
    const prevIsLoading = (0, $a736ee5d1177a928$export$5cae361ad82dce8b)(isLoading);
    const timeout = (0, $2gcPZ.useRef)(null);
    (0, $2gcPZ.useEffect)(()=>{
        if ((prevIsLoading === false || prevIsLoading === undefined) && isLoading === true) {
            setThrottledIsLoading(true);
            timeout.current = setTimeout(()=>{
                setThrottledIsLoading(false);
                timeout.current = null;
            }, delayMs);
        }
    }, [
        isLoading,
        prevIsLoading,
        delayMs
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($a5001c7e93a4069b$exports)))(()=>{
        timeout.current && clearTimeout(timeout.current);
    });
    return isLoading || throttledIsLoading;
}



var $2gcPZ = parcelRequire("2gcPZ");

var $eVLAC = parcelRequire("eVLAC");
function $c6496b0e113bd4b1$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}


function $2ca35d608e949add$export$2e2bcd8739ae039(value) {
    (0, $c6496b0e113bd4b1$export$2e2bcd8739ae039)(1, arguments);
    return value instanceof Date || (0, $eVLAC.default)(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}



var $eVLAC = parcelRequire("eVLAC");

function $238651ed35bf02ba$export$2e2bcd8739ae039(argument) {
    (0, $c6496b0e113bd4b1$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $eVLAC.default)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $4f06c19e96af2305$export$2e2bcd8739ae039(dirtyDate) {
    (0, $c6496b0e113bd4b1$export$2e2bcd8739ae039)(1, arguments);
    if (!(0, $2ca35d608e949add$export$2e2bcd8739ae039)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, $238651ed35bf02ba$export$2e2bcd8739ae039)(dirtyDate);
    return !isNaN(Number(date));
}


function $90191f823867d8d7$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}




function $b9e04c4db1bab719$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $c6496b0e113bd4b1$export$2e2bcd8739ae039)(2, arguments);
    var timestamp = (0, $238651ed35bf02ba$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var amount = (0, $90191f823867d8d7$export$2e2bcd8739ae039)(dirtyAmount);
    return new Date(timestamp + amount);
}




function $aef60fcc7060944d$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $c6496b0e113bd4b1$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $90191f823867d8d7$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $b9e04c4db1bab719$export$2e2bcd8739ae039)(dirtyDate, -amount);
}





var $b9ee2dcca32e486f$var$MILLISECONDS_IN_DAY = 86400000;
function $b9ee2dcca32e486f$export$2e2bcd8739ae039(dirtyDate) {
    (0, $c6496b0e113bd4b1$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $238651ed35bf02ba$export$2e2bcd8739ae039)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $b9ee2dcca32e486f$var$MILLISECONDS_IN_DAY) + 1;
}





function $c7596dc557ba78d3$export$2e2bcd8739ae039(dirtyDate) {
    (0, $c6496b0e113bd4b1$export$2e2bcd8739ae039)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $238651ed35bf02ba$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}





function $f7c3194c452c85ac$export$2e2bcd8739ae039(dirtyDate) {
    (0, $c6496b0e113bd4b1$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $238651ed35bf02ba$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $c7596dc557ba78d3$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $c7596dc557ba78d3$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




function $c4af615479909e96$export$2e2bcd8739ae039(dirtyDate) {
    (0, $c6496b0e113bd4b1$export$2e2bcd8739ae039)(1, arguments);
    var year = (0, $f7c3194c452c85ac$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $c7596dc557ba78d3$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}



var $4e09fe26c4b8318e$var$MILLISECONDS_IN_WEEK = 604800000;
function $4e09fe26c4b8318e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $c6496b0e113bd4b1$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $238651ed35bf02ba$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $c7596dc557ba78d3$export$2e2bcd8739ae039)(date).getTime() - (0, $c4af615479909e96$export$2e2bcd8739ae039)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $4e09fe26c4b8318e$var$MILLISECONDS_IN_WEEK) + 1;
}







var $a212bdf274d94c26$var$defaultOptions = {};
function $a212bdf274d94c26$export$430a3269e24b912e() {
    return $a212bdf274d94c26$var$defaultOptions;
}
function $a212bdf274d94c26$export$95365be1b0704abc(newOptions) {
    $a212bdf274d94c26$var$defaultOptions = newOptions;
}


function $c6fbf0bd147d3956$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $c6496b0e113bd4b1$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $a212bdf274d94c26$export$430a3269e24b912e)();
    var weekStartsOn = (0, $90191f823867d8d7$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $238651ed35bf02ba$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}







function $18e1c6a2e30cd623$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $c6496b0e113bd4b1$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $238651ed35bf02ba$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $a212bdf274d94c26$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $90191f823867d8d7$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $c6fbf0bd147d3956$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $c6fbf0bd147d3956$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $e76c1f53cbb746ec$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $c6496b0e113bd4b1$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $a212bdf274d94c26$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $90191f823867d8d7$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $18e1c6a2e30cd623$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $c6fbf0bd147d3956$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}



var $61ba15ce91a05d27$var$MILLISECONDS_IN_WEEK = 604800000;
function $61ba15ce91a05d27$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $c6496b0e113bd4b1$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $238651ed35bf02ba$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $c6fbf0bd147d3956$export$2e2bcd8739ae039)(date, options).getTime() - (0, $e76c1f53cbb746ec$export$2e2bcd8739ae039)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $61ba15ce91a05d27$var$MILLISECONDS_IN_WEEK) + 1;
}



function $1a383fa7811d41a7$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}



/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $447b9fa297721b70$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $1a383fa7811d41a7$export$2e2bcd8739ae039)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, $1a383fa7811d41a7$export$2e2bcd8739ae039)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $1a383fa7811d41a7$export$2e2bcd8739ae039)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $1a383fa7811d41a7$export$2e2bcd8739ae039)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $1a383fa7811d41a7$export$2e2bcd8739ae039)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $1a383fa7811d41a7$export$2e2bcd8739ae039)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $1a383fa7811d41a7$export$2e2bcd8739ae039)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $1a383fa7811d41a7$export$2e2bcd8739ae039)(fractionalSeconds, token.length);
    }
};
var $447b9fa297721b70$export$2e2bcd8739ae039 = $447b9fa297721b70$var$formatters;


var $663d2d51778cc902$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $663d2d51778cc902$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $447b9fa297721b70$export$2e2bcd8739ae039).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $18e1c6a2e30cd623$export$2e2bcd8739ae039)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, $1a383fa7811d41a7$export$2e2bcd8739ae039)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $1a383fa7811d41a7$export$2e2bcd8739ae039)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $f7c3194c452c85ac$export$2e2bcd8739ae039)(date);
        // Padding
        return (0, $1a383fa7811d41a7$export$2e2bcd8739ae039)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $1a383fa7811d41a7$export$2e2bcd8739ae039)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $1a383fa7811d41a7$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $1a383fa7811d41a7$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $447b9fa297721b70$export$2e2bcd8739ae039).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $1a383fa7811d41a7$export$2e2bcd8739ae039)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $61ba15ce91a05d27$export$2e2bcd8739ae039)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $1a383fa7811d41a7$export$2e2bcd8739ae039)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $4e09fe26c4b8318e$export$2e2bcd8739ae039)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $1a383fa7811d41a7$export$2e2bcd8739ae039)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return (0, $447b9fa297721b70$export$2e2bcd8739ae039).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $b9ee2dcca32e486f$export$2e2bcd8739ae039)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $1a383fa7811d41a7$export$2e2bcd8739ae039)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $1a383fa7811d41a7$export$2e2bcd8739ae039)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $1a383fa7811d41a7$export$2e2bcd8739ae039)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $1a383fa7811d41a7$export$2e2bcd8739ae039)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $663d2d51778cc902$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $663d2d51778cc902$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $663d2d51778cc902$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $663d2d51778cc902$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $663d2d51778cc902$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $663d2d51778cc902$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $447b9fa297721b70$export$2e2bcd8739ae039).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return (0, $447b9fa297721b70$export$2e2bcd8739ae039).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $1a383fa7811d41a7$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $1a383fa7811d41a7$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return (0, $447b9fa297721b70$export$2e2bcd8739ae039).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return (0, $447b9fa297721b70$export$2e2bcd8739ae039).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $447b9fa297721b70$export$2e2bcd8739ae039).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $663d2d51778cc902$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return $663d2d51778cc902$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $663d2d51778cc902$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $663d2d51778cc902$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return $663d2d51778cc902$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $663d2d51778cc902$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $663d2d51778cc902$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $663d2d51778cc902$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $663d2d51778cc902$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $663d2d51778cc902$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $1a383fa7811d41a7$export$2e2bcd8739ae039)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $1a383fa7811d41a7$export$2e2bcd8739ae039)(timestamp, token.length);
    }
};
function $663d2d51778cc902$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, $1a383fa7811d41a7$export$2e2bcd8739ae039)(minutes, 2);
}
function $663d2d51778cc902$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, $1a383fa7811d41a7$export$2e2bcd8739ae039)(Math.abs(offset) / 60, 2);
    }
    return $663d2d51778cc902$var$formatTimezone(offset, dirtyDelimiter);
}
function $663d2d51778cc902$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, $1a383fa7811d41a7$export$2e2bcd8739ae039)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $1a383fa7811d41a7$export$2e2bcd8739ae039)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $663d2d51778cc902$export$2e2bcd8739ae039 = $663d2d51778cc902$var$formatters;


var $d13c67829fe6eb64$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var $d13c67829fe6eb64$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var $d13c67829fe6eb64$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $d13c67829fe6eb64$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $d13c67829fe6eb64$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $d13c67829fe6eb64$var$timeLongFormatter(timePattern, formatLong));
};
var $d13c67829fe6eb64$var$longFormatters = {
    p: $d13c67829fe6eb64$var$timeLongFormatter,
    P: $d13c67829fe6eb64$var$dateTimeLongFormatter
};
var $d13c67829fe6eb64$export$2e2bcd8739ae039 = $d13c67829fe6eb64$var$longFormatters;


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $9eafd1850b7a3ad2$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}


var $d4cc8fc8ebc8937e$var$protectedDayOfYearTokens = [
    "D",
    "DD"
];
var $d4cc8fc8ebc8937e$var$protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function $d4cc8fc8ebc8937e$export$c6cc36aa33304772(token) {
    return $d4cc8fc8ebc8937e$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $d4cc8fc8ebc8937e$export$c6b49d6dceb604a1(token) {
    return $d4cc8fc8ebc8937e$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $d4cc8fc8ebc8937e$export$8073c1ae88f0e727(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}





var $e4b7c853e385f75d$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var $e4b7c853e385f75d$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $e4b7c853e385f75d$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
var $e4b7c853e385f75d$export$2e2bcd8739ae039 = $e4b7c853e385f75d$var$formatDistance;


function $9e19e5a3c59426a7$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $cbaeab0cb4e50bdb$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $cbaeab0cb4e50bdb$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $cbaeab0cb4e50bdb$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $cbaeab0cb4e50bdb$var$formatLong = {
    date: (0, $9e19e5a3c59426a7$export$2e2bcd8739ae039)({
        formats: $cbaeab0cb4e50bdb$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $9e19e5a3c59426a7$export$2e2bcd8739ae039)({
        formats: $cbaeab0cb4e50bdb$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $9e19e5a3c59426a7$export$2e2bcd8739ae039)({
        formats: $cbaeab0cb4e50bdb$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $cbaeab0cb4e50bdb$export$2e2bcd8739ae039 = $cbaeab0cb4e50bdb$var$formatLong;


var $09b24f7bdb70fb67$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $09b24f7bdb70fb67$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $09b24f7bdb70fb67$var$formatRelativeLocale[token];
};
var $09b24f7bdb70fb67$export$2e2bcd8739ae039 = $09b24f7bdb70fb67$var$formatRelative;


function $9b87b13f8ec3e2b8$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $69df13fd3ddf2c48$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $69df13fd3ddf2c48$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $69df13fd3ddf2c48$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $69df13fd3ddf2c48$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $69df13fd3ddf2c48$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $69df13fd3ddf2c48$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var $69df13fd3ddf2c48$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var $69df13fd3ddf2c48$var$localize = {
    ordinalNumber: $69df13fd3ddf2c48$var$ordinalNumber,
    era: (0, $9b87b13f8ec3e2b8$export$2e2bcd8739ae039)({
        values: $69df13fd3ddf2c48$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $9b87b13f8ec3e2b8$export$2e2bcd8739ae039)({
        values: $69df13fd3ddf2c48$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9b87b13f8ec3e2b8$export$2e2bcd8739ae039)({
        values: $69df13fd3ddf2c48$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $9b87b13f8ec3e2b8$export$2e2bcd8739ae039)({
        values: $69df13fd3ddf2c48$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $9b87b13f8ec3e2b8$export$2e2bcd8739ae039)({
        values: $69df13fd3ddf2c48$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $69df13fd3ddf2c48$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $69df13fd3ddf2c48$export$2e2bcd8739ae039 = $69df13fd3ddf2c48$var$localize;


function $2d6481069e7cca54$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $2d6481069e7cca54$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $2d6481069e7cca54$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $2d6481069e7cca54$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $2d6481069e7cca54$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $6aec6b60621d81fe$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $fddedb2cde9af2b1$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $fddedb2cde9af2b1$var$parseOrdinalNumberPattern = /\d+/i;
var $fddedb2cde9af2b1$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $fddedb2cde9af2b1$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $fddedb2cde9af2b1$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $fddedb2cde9af2b1$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $fddedb2cde9af2b1$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $fddedb2cde9af2b1$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $fddedb2cde9af2b1$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $fddedb2cde9af2b1$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $fddedb2cde9af2b1$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $fddedb2cde9af2b1$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $fddedb2cde9af2b1$var$match = {
    ordinalNumber: (0, $6aec6b60621d81fe$export$2e2bcd8739ae039)({
        matchPattern: $fddedb2cde9af2b1$var$matchOrdinalNumberPattern,
        parsePattern: $fddedb2cde9af2b1$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $2d6481069e7cca54$export$2e2bcd8739ae039)({
        matchPatterns: $fddedb2cde9af2b1$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fddedb2cde9af2b1$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $2d6481069e7cca54$export$2e2bcd8739ae039)({
        matchPatterns: $fddedb2cde9af2b1$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fddedb2cde9af2b1$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $2d6481069e7cca54$export$2e2bcd8739ae039)({
        matchPatterns: $fddedb2cde9af2b1$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fddedb2cde9af2b1$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $2d6481069e7cca54$export$2e2bcd8739ae039)({
        matchPatterns: $fddedb2cde9af2b1$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fddedb2cde9af2b1$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $2d6481069e7cca54$export$2e2bcd8739ae039)({
        matchPatterns: $fddedb2cde9af2b1$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $fddedb2cde9af2b1$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $fddedb2cde9af2b1$export$2e2bcd8739ae039 = $fddedb2cde9af2b1$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $842b32665f10d578$var$locale = {
    code: "en-US",
    formatDistance: (0, $e4b7c853e385f75d$export$2e2bcd8739ae039),
    formatLong: (0, $cbaeab0cb4e50bdb$export$2e2bcd8739ae039),
    formatRelative: (0, $09b24f7bdb70fb67$export$2e2bcd8739ae039),
    localize: (0, $69df13fd3ddf2c48$export$2e2bcd8739ae039),
    match: (0, $fddedb2cde9af2b1$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $842b32665f10d578$export$2e2bcd8739ae039 = $842b32665f10d578$var$locale;


var $fb4068a44b3fc263$export$2e2bcd8739ae039 = (0, $842b32665f10d578$export$2e2bcd8739ae039);


// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $3c267db5b66264d3$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $3c267db5b66264d3$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $3c267db5b66264d3$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $3c267db5b66264d3$var$doubleQuoteRegExp = /''/g;
var $3c267db5b66264d3$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $3c267db5b66264d3$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $c6496b0e113bd4b1$export$2e2bcd8739ae039)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $a212bdf274d94c26$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $fb4068a44b3fc263$export$2e2bcd8739ae039);
    var firstWeekContainsDate = (0, $90191f823867d8d7$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $90191f823867d8d7$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = (0, $238651ed35bf02ba$export$2e2bcd8739ae039)(dirtyDate);
    if (!(0, $4f06c19e96af2305$export$2e2bcd8739ae039)(originalDate)) throw new RangeError("Invalid time value");
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $9eafd1850b7a3ad2$export$2e2bcd8739ae039)(originalDate);
    var utcDate = (0, $aef60fcc7060944d$export$2e2bcd8739ae039)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($3c267db5b66264d3$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, $d13c67829fe6eb64$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($3c267db5b66264d3$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $3c267db5b66264d3$var$cleanEscapedString(substring);
        var formatter = (0, $663d2d51778cc902$export$2e2bcd8739ae039)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $d4cc8fc8ebc8937e$export$c6b49d6dceb604a1)(substring)) (0, $d4cc8fc8ebc8937e$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $d4cc8fc8ebc8937e$export$c6cc36aa33304772)(substring)) (0, $d4cc8fc8ebc8937e$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($3c267db5b66264d3$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $3c267db5b66264d3$var$cleanEscapedString(input) {
    var matched = input.match($3c267db5b66264d3$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($3c267db5b66264d3$var$doubleQuoteRegExp, "'");
}





function $329ce98a51021f92$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $c6496b0e113bd4b1$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $238651ed35bf02ba$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $238651ed35bf02ba$export$2e2bcd8739ae039)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}





function $5769a5b9c3824f2d$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $c6496b0e113bd4b1$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $238651ed35bf02ba$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $238651ed35bf02ba$export$2e2bcd8739ae039)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}







function $ca9d75618805b86a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $c6496b0e113bd4b1$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $238651ed35bf02ba$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}




function $f3b88014dc82dc96$export$2e2bcd8739ae039(dirtyDate) {
    (0, $c6496b0e113bd4b1$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $238651ed35bf02ba$export$2e2bcd8739ae039)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}



function $3c750911bae8312e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $c6496b0e113bd4b1$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $238651ed35bf02ba$export$2e2bcd8739ae039)(dirtyDate);
    return (0, $ca9d75618805b86a$export$2e2bcd8739ae039)(date).getTime() === (0, $f3b88014dc82dc96$export$2e2bcd8739ae039)(date).getTime();
}


function $124d24e2c642a878$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $c6496b0e113bd4b1$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $238651ed35bf02ba$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $238651ed35bf02ba$export$2e2bcd8739ae039)(dirtyDateRight);
    var sign = (0, $329ce98a51021f92$export$2e2bcd8739ae039)(dateLeft, dateRight);
    var difference = Math.abs((0, $5769a5b9c3824f2d$export$2e2bcd8739ae039)(dateLeft, dateRight));
    var result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        dateLeft.setDate(30);
        dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        var isLastMonthNotFull = (0, $329ce98a51021f92$export$2e2bcd8739ae039)(dateLeft, dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $3c750911bae8312e$export$2e2bcd8739ae039)((0, $238651ed35bf02ba$export$2e2bcd8739ae039)(dirtyDateLeft)) && difference === 1 && (0, $329ce98a51021f92$export$2e2bcd8739ae039)(dirtyDateLeft, dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}




function $18353a764b856174$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $c6496b0e113bd4b1$export$2e2bcd8739ae039)(2, arguments);
    return (0, $238651ed35bf02ba$export$2e2bcd8739ae039)(dateLeft).getTime() - (0, $238651ed35bf02ba$export$2e2bcd8739ae039)(dateRight).getTime();
}



var $78051d0df86a9584$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $78051d0df86a9584$var$defaultRoundingMethod = "trunc";
function $78051d0df86a9584$export$b6474a47258c1211(method) {
    return method ? $78051d0df86a9584$var$roundingMap[method] : $78051d0df86a9584$var$roundingMap[$78051d0df86a9584$var$defaultRoundingMethod];
}


function $f0446dffa7eede28$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $c6496b0e113bd4b1$export$2e2bcd8739ae039)(2, arguments);
    var diff = (0, $18353a764b856174$export$2e2bcd8739ae039)(dateLeft, dateRight) / 1000;
    return (0, $78051d0df86a9584$export$b6474a47258c1211)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}




function $250db5fe0102340d$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError("assign requires that input parameter not be null or undefined");
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}


function $1bf61f6f602b7d21$export$2e2bcd8739ae039(object) {
    return (0, $250db5fe0102340d$export$2e2bcd8739ae039)({}, object);
}





var $f0fa4c84056a283c$var$MINUTES_IN_DAY = 1440;
var $f0fa4c84056a283c$var$MINUTES_IN_ALMOST_TWO_DAYS = 2520;
var $f0fa4c84056a283c$var$MINUTES_IN_MONTH = 43200;
var $f0fa4c84056a283c$var$MINUTES_IN_TWO_MONTHS = 86400;
function $f0fa4c84056a283c$export$2e2bcd8739ae039(dirtyDate, dirtyBaseDate, options) {
    var _ref, _options$locale;
    (0, $c6496b0e113bd4b1$export$2e2bcd8739ae039)(2, arguments);
    var defaultOptions = (0, $a212bdf274d94c26$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $fb4068a44b3fc263$export$2e2bcd8739ae039);
    if (!locale.formatDistance) throw new RangeError("locale must contain formatDistance property");
    var comparison = (0, $329ce98a51021f92$export$2e2bcd8739ae039)(dirtyDate, dirtyBaseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    var localizeOptions = (0, $250db5fe0102340d$export$2e2bcd8739ae039)((0, $1bf61f6f602b7d21$export$2e2bcd8739ae039)(options), {
        addSuffix: Boolean(options === null || options === void 0 ? void 0 : options.addSuffix),
        comparison: comparison
    });
    var dateLeft;
    var dateRight;
    if (comparison > 0) {
        dateLeft = (0, $238651ed35bf02ba$export$2e2bcd8739ae039)(dirtyBaseDate);
        dateRight = (0, $238651ed35bf02ba$export$2e2bcd8739ae039)(dirtyDate);
    } else {
        dateLeft = (0, $238651ed35bf02ba$export$2e2bcd8739ae039)(dirtyDate);
        dateRight = (0, $238651ed35bf02ba$export$2e2bcd8739ae039)(dirtyBaseDate);
    }
    var seconds = (0, $f0446dffa7eede28$export$2e2bcd8739ae039)(dateRight, dateLeft);
    var offsetInSeconds = ((0, $9eafd1850b7a3ad2$export$2e2bcd8739ae039)(dateRight) - (0, $9eafd1850b7a3ad2$export$2e2bcd8739ae039)(dateLeft)) / 1000;
    var minutes = Math.round((seconds - offsetInSeconds) / 60);
    var months;
    // 0 up to 2 mins
    if (minutes < 2) {
        if (options !== null && options !== void 0 && options.includeSeconds) {
            if (seconds < 5) return locale.formatDistance("lessThanXSeconds", 5, localizeOptions);
            else if (seconds < 10) return locale.formatDistance("lessThanXSeconds", 10, localizeOptions);
            else if (seconds < 20) return locale.formatDistance("lessThanXSeconds", 20, localizeOptions);
            else if (seconds < 40) return locale.formatDistance("halfAMinute", 0, localizeOptions);
            else if (seconds < 60) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", 1, localizeOptions);
        } else {
            if (minutes === 0) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", minutes, localizeOptions);
        }
    } else if (minutes < 45) return locale.formatDistance("xMinutes", minutes, localizeOptions);
    else if (minutes < 90) return locale.formatDistance("aboutXHours", 1, localizeOptions);
    else if (minutes < $f0fa4c84056a283c$var$MINUTES_IN_DAY) {
        var hours = Math.round(minutes / 60);
        return locale.formatDistance("aboutXHours", hours, localizeOptions);
    // 1 day up to 1.75 days
    } else if (minutes < $f0fa4c84056a283c$var$MINUTES_IN_ALMOST_TWO_DAYS) return locale.formatDistance("xDays", 1, localizeOptions);
    else if (minutes < $f0fa4c84056a283c$var$MINUTES_IN_MONTH) {
        var days = Math.round(minutes / $f0fa4c84056a283c$var$MINUTES_IN_DAY);
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 month up to 2 months
    } else if (minutes < $f0fa4c84056a283c$var$MINUTES_IN_TWO_MONTHS) {
        months = Math.round(minutes / $f0fa4c84056a283c$var$MINUTES_IN_MONTH);
        return locale.formatDistance("aboutXMonths", months, localizeOptions);
    }
    months = (0, $124d24e2c642a878$export$2e2bcd8739ae039)(dateRight, dateLeft);
    // 2 months up to 12 months
    if (months < 12) {
        var nearestMonth = Math.round(minutes / $f0fa4c84056a283c$var$MINUTES_IN_MONTH);
        return locale.formatDistance("xMonths", nearestMonth, localizeOptions);
    // 1 year up to max Date
    } else {
        var monthsSinceStartOfYear = months % 12;
        var years = Math.floor(months / 12);
        // N years up to 1 years 3 months
        if (monthsSinceStartOfYear < 3) return locale.formatDistance("aboutXYears", years, localizeOptions);
        else if (monthsSinceStartOfYear < 9) return locale.formatDistance("overXYears", years, localizeOptions);
        else return locale.formatDistance("almostXYears", years + 1, localizeOptions);
    }
}



function $0938b4b5a19d17a8$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $c6496b0e113bd4b1$export$2e2bcd8739ae039)(1, arguments);
    return (0, $f0fa4c84056a283c$export$2e2bcd8739ae039)(dirtyDate, Date.now(), options);
}











var $4989c4703806f369$var$MILLISECONDS_IN_MINUTE = 60000;
var $4989c4703806f369$var$MINUTES_IN_DAY = 1440;
var $4989c4703806f369$var$MINUTES_IN_MONTH = $4989c4703806f369$var$MINUTES_IN_DAY * 30;
var $4989c4703806f369$var$MINUTES_IN_YEAR = $4989c4703806f369$var$MINUTES_IN_DAY * 365;
function $4989c4703806f369$export$2e2bcd8739ae039(dirtyDate, dirtyBaseDate, options) {
    var _ref, _options$locale, _options$roundingMeth;
    (0, $c6496b0e113bd4b1$export$2e2bcd8739ae039)(2, arguments);
    var defaultOptions = (0, $a212bdf274d94c26$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $fb4068a44b3fc263$export$2e2bcd8739ae039);
    if (!locale.formatDistance) throw new RangeError("locale must contain localize.formatDistance property");
    var comparison = (0, $329ce98a51021f92$export$2e2bcd8739ae039)(dirtyDate, dirtyBaseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    var localizeOptions = (0, $250db5fe0102340d$export$2e2bcd8739ae039)((0, $1bf61f6f602b7d21$export$2e2bcd8739ae039)(options), {
        addSuffix: Boolean(options === null || options === void 0 ? void 0 : options.addSuffix),
        comparison: comparison
    });
    var dateLeft;
    var dateRight;
    if (comparison > 0) {
        dateLeft = (0, $238651ed35bf02ba$export$2e2bcd8739ae039)(dirtyBaseDate);
        dateRight = (0, $238651ed35bf02ba$export$2e2bcd8739ae039)(dirtyDate);
    } else {
        dateLeft = (0, $238651ed35bf02ba$export$2e2bcd8739ae039)(dirtyDate);
        dateRight = (0, $238651ed35bf02ba$export$2e2bcd8739ae039)(dirtyBaseDate);
    }
    var roundingMethod = String((_options$roundingMeth = options === null || options === void 0 ? void 0 : options.roundingMethod) !== null && _options$roundingMeth !== void 0 ? _options$roundingMeth : "round");
    var roundingMethodFn;
    if (roundingMethod === "floor") roundingMethodFn = Math.floor;
    else if (roundingMethod === "ceil") roundingMethodFn = Math.ceil;
    else if (roundingMethod === "round") roundingMethodFn = Math.round;
    else throw new RangeError("roundingMethod must be 'floor', 'ceil' or 'round'");
    var milliseconds = dateRight.getTime() - dateLeft.getTime();
    var minutes = milliseconds / $4989c4703806f369$var$MILLISECONDS_IN_MINUTE;
    var timezoneOffset = (0, $9eafd1850b7a3ad2$export$2e2bcd8739ae039)(dateRight) - (0, $9eafd1850b7a3ad2$export$2e2bcd8739ae039)(dateLeft);
    // Use DST-normalized difference in minutes for years, months and days;
    // use regular difference in minutes for hours, minutes and seconds.
    var dstNormalizedMinutes = (milliseconds - timezoneOffset) / $4989c4703806f369$var$MILLISECONDS_IN_MINUTE;
    var defaultUnit = options === null || options === void 0 ? void 0 : options.unit;
    var unit;
    if (!defaultUnit) {
        if (minutes < 1) unit = "second";
        else if (minutes < 60) unit = "minute";
        else if (minutes < $4989c4703806f369$var$MINUTES_IN_DAY) unit = "hour";
        else if (dstNormalizedMinutes < $4989c4703806f369$var$MINUTES_IN_MONTH) unit = "day";
        else if (dstNormalizedMinutes < $4989c4703806f369$var$MINUTES_IN_YEAR) unit = "month";
        else unit = "year";
    } else unit = String(defaultUnit);
    // 0 up to 60 seconds
    if (unit === "second") {
        var seconds = roundingMethodFn(milliseconds / 1000);
        return locale.formatDistance("xSeconds", seconds, localizeOptions);
    // 1 up to 60 mins
    } else if (unit === "minute") {
        var roundedMinutes = roundingMethodFn(minutes);
        return locale.formatDistance("xMinutes", roundedMinutes, localizeOptions);
    // 1 up to 24 hours
    } else if (unit === "hour") {
        var hours = roundingMethodFn(minutes / 60);
        return locale.formatDistance("xHours", hours, localizeOptions);
    // 1 up to 30 days
    } else if (unit === "day") {
        var days = roundingMethodFn(dstNormalizedMinutes / $4989c4703806f369$var$MINUTES_IN_DAY);
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 up to 12 months
    } else if (unit === "month") {
        var months = roundingMethodFn(dstNormalizedMinutes / $4989c4703806f369$var$MINUTES_IN_MONTH);
        return months === 12 && defaultUnit !== "month" ? locale.formatDistance("xYears", 1, localizeOptions) : locale.formatDistance("xMonths", months, localizeOptions);
    // 1 year up to max Date
    } else if (unit === "year") {
        var years = roundingMethodFn(dstNormalizedMinutes / $4989c4703806f369$var$MINUTES_IN_YEAR);
        return locale.formatDistance("xYears", years, localizeOptions);
    }
    throw new RangeError("unit must be 'second', 'minute', 'hour', 'day', 'month' or 'year'");
}



function $ca4def2961a901fb$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $c6496b0e113bd4b1$export$2e2bcd8739ae039)(1, arguments);
    return (0, $4989c4703806f369$export$2e2bcd8739ae039)(dirtyDate, Date.now(), options);
}


// In ms
const $bd1aac28096a588b$var$FIVE_SECONDS = 5000;
const $bd1aac28096a588b$var$TEN_SECONDS = 10000;
const $bd1aac28096a588b$var$HALF_MINUTE = 30000;
const $bd1aac28096a588b$var$MINUTE = 60000; /* 60 * 1000ms */ 
const $bd1aac28096a588b$var$HOUR = 3600000; /* 60 * 60 * 1000ms */ 
const $bd1aac28096a588b$var$DAY = 86400000; /* 24 hours, 24 * 60 * 60 * 1000ms */ 
// By defining the intervals this way, we can determine which interval should
// be applied in a time window. This allows us to give more descriptive readable
// time strings as defined in the `date-fns` documentation:
// https://date-fns.org/v2.29.2/docs/formatDistanceToNow
const $bd1aac28096a588b$var$INTERVALS = {
    [$bd1aac28096a588b$var$FIVE_SECONDS]: {
        interval: $bd1aac28096a588b$var$FIVE_SECONDS,
        nextInterval: $bd1aac28096a588b$var$HALF_MINUTE
    },
    [$bd1aac28096a588b$var$HALF_MINUTE]: {
        interval: $bd1aac28096a588b$var$TEN_SECONDS,
        nextInterval: $bd1aac28096a588b$var$MINUTE
    },
    [$bd1aac28096a588b$var$MINUTE]: {
        interval: $bd1aac28096a588b$var$MINUTE,
        nextInterval: $bd1aac28096a588b$var$HOUR
    },
    [$bd1aac28096a588b$var$HOUR]: {
        interval: $bd1aac28096a588b$var$HOUR,
        nextInterval: $bd1aac28096a588b$var$DAY
    }
};
function $bd1aac28096a588b$export$1deeb1050525eb40(date, options) {
    const { strict: strict = false } = options || {};
    const interval = (0, $2gcPZ.useRef)($bd1aac28096a588b$var$INTERVALS[$bd1aac28096a588b$var$FIVE_SECONDS]);
    const [formattedDate, setFormattedDate] = (0, $2gcPZ.useState)();
    (0, $2gcPZ.useEffect)(()=>{
        if (!date) return;
        const parsedDate = new Date(date);
        const getDifferenceInMilliseconds = ()=>(0, $18353a764b856174$export$2e2bcd8739ae039)(new Date(), parsedDate);
        const setFormatDate = ()=>{
            const formatter = strict ? (0, $ca4def2961a901fb$export$2e2bcd8739ae039) : (0, $0938b4b5a19d17a8$export$2e2bcd8739ae039);
            const formattedDate = formatter(parsedDate, {
                addSuffix: true,
                includeSeconds: true
            });
            setFormattedDate(formattedDate);
        };
        const setConstantDate = ()=>{
            const constantDate = (0, $3c267db5b66264d3$export$2e2bcd8739ae039)(parsedDate, "LLLL d, yyyy");
            setFormattedDate(constantDate);
        };
        // Prevent calling the timeout when we know >= 24hrs has passed & set a
        // formatted post date string.
        if (getDifferenceInMilliseconds() >= $bd1aac28096a588b$var$DAY) {
            setConstantDate();
            return;
        }
        let formatTimeout;
        const setFormatTimeout = ()=>{
            formatTimeout = setTimeout(()=>{
                const differenceInMilliSeconds = getDifferenceInMilliseconds();
                // Prevent calling a new timeout when we know >= 24hrs has passed & set
                // a formatted post date string.
                if (differenceInMilliSeconds >= $bd1aac28096a588b$var$DAY) {
                    setConstantDate();
                    return;
                }
                if (differenceInMilliSeconds >= interval.current.nextInterval) {
                    if (interval.current.nextInterval === $bd1aac28096a588b$var$DAY) {
                        setConstantDate();
                        return;
                    }
                    interval.current = $bd1aac28096a588b$var$INTERVALS[interval.current.nextInterval];
                }
                setFormatDate();
                setFormatTimeout();
            }, interval.current.interval);
        };
        setFormatDate();
        setFormatTimeout();
        return ()=>{
            clearTimeout(formatTimeout);
        };
    }, [
        date,
        strict
    ]);
    return formattedDate;
}



var $2gcPZ = parcelRequire("2gcPZ");


function $326a17b5958d0a0c$export$43bf3df9dfee3ce5() {
    const [searchParams, setSearchParams] = (0, $e7b98158099ae00d$export$f1a78c17382fe22a)();
    const timeRange = (0, $2gcPZ.useMemo)(()=>{
        const queryFrom = searchParams.get("from");
        const queryTo = searchParams.get("to");
        const queryLabelRaw = searchParams.get("relativeTimeRangeLabel");
        const queryLabel = queryLabelRaw && (0, $89bcf338a8e6a1c2$export$b4d6c2a64cc2b2b0)(queryLabelRaw) ? queryLabelRaw : undefined;
        // If a relative time range is provided in the url, we re-compute the from/to properties
        // If from/to are provided, we simply use those
        // Otherwise, we default to "Last 15 mins"
        if (queryLabel) return (0, $89bcf338a8e6a1c2$export$1691be63bfdf0baf)(queryLabel);
        else if (queryFrom && queryTo) return {
            from: queryFrom,
            to: queryTo
        };
        return $326a17b5958d0a0c$export$4eaa35d2e20c7f30();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        searchParams.toString()
    ]);
    const isRelativeTimeRange = "relativeTimeRangeLabel" in timeRange && (0, $89bcf338a8e6a1c2$export$b4d6c2a64cc2b2b0)(timeRange.relativeTimeRangeLabel);
    const updateSearchParams = (newTimeRange, options)=>{
        // Get the current searchParams object
        const currentSearchParams = Object.fromEntries(searchParams);
        // Create a new object to store updated search parameters
        const updatedSearchParams = {};
        // Copy all values from currentSearchParams except "from" and "to"
        for (const [key, value] of Object.entries(currentSearchParams))if (key !== "from" && key !== "to" && key !== "relativeTimeRangeLabel") updatedSearchParams[key] = value;
        // Call setSearchParams with the updated search parameters
        setSearchParams({
            ...updatedSearchParams,
            ...newTimeRange
        }, options);
    };
    const refreshRelativeTimeRange = ()=>{
        if (isRelativeTimeRange && timeRange.relativeTimeRangeLabel) {
            const newTimeRange = (0, $89bcf338a8e6a1c2$export$1691be63bfdf0baf)(timeRange.relativeTimeRangeLabel);
            // NOTE - Refreshing the timerange should replace the entry in history, to preserve behavior of the back/forwards button
            updateSearchParams(newTimeRange, {
                replace: true
            });
        }
    };
    const onChangeTimeRange = (newTimeRange)=>{
        // NOTE - This creates a new entry in history, to allow users to use back/forward to navigate between time ranges they've selected
        updateSearchParams(newTimeRange);
    };
    return {
        timeRange: timeRange,
        isRelativeTimeRange: isRelativeTimeRange,
        onChangeTimeRange: onChangeTimeRange,
        refreshRelativeTimeRange: refreshRelativeTimeRange
    };
}
function $326a17b5958d0a0c$export$4eaa35d2e20c7f30() {
    return {
        from: $326a17b5958d0a0c$var$fifteenMinutesAgo().toISOString(),
        to: new Date().toISOString(),
        relativeTimeRangeLabel: (0, $89bcf338a8e6a1c2$export$e2c41d5adc1ba178).LAST_15_MINUTES
    };
}
function $326a17b5958d0a0c$var$fifteenMinutesAgo(d) {
    d = d ? new Date(d) : new Date();
    d.setMinutes(d.getMinutes() - 15);
    return d;
}






const $87fe9d22a5eec31a$export$8ee68538b664d6db = /*#__PURE__*/ (0, $2gcPZ.createContext)({
    setRef: (0, $205cce2352c35b5b$export$8793edee2d425525),
    style: {}
});
const $87fe9d22a5eec31a$export$fd7a256405e9ea77 = /*#__PURE__*/ (0, $2gcPZ.forwardRef)(function AttachedPopup({ children: originalChildren, element: element, className: className, offset: offset = [
    0,
    0
], placement: placement = "bottom", withArrow: withArrow = false, preventMainAxisOverflow: preventMainAxisOverflow = true }, forwardedRef) {
    const [content, setContent] = (0, $2gcPZ.useState)(null);
    const [arrowElement, setArrowElement] = (0, $2gcPZ.useState)(null);
    const { x: x, y: y } = $87fe9d22a5eec31a$var$getHiddenPosition(placement);
    const modifiers = [
        {
            name: "offset",
            options: {
                offset: offset
            }
        },
        {
            name: "preventOverflow",
            options: {
                padding: 8,
                mainAxis: preventMainAxisOverflow
            }
        }
    ];
    if (withArrow) modifiers.push({
        name: "arrow",
        options: {
            element: arrowElement
        }
    });
    const { styles: styles, attributes: attributes, update: rawUpdate } = (0, $7cf40d019f36c73b$export$f4d5bf230a36dd6e)(element, content, {
        placement: placement,
        modifiers: modifiers
    });
    const update = (0, $cac150ebb620e91f$export$d095b0c879743c0d)(async ()=>{
        if (rawUpdate) await rawUpdate();
    });
    (0, $2gcPZ.useImperativeHandle)(forwardedRef, ()=>({
            update: update
        }));
    const children = withArrow ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($87fe9d22a5eec31a$export$8ee68538b664d6db.Provider, {
        value: {
            setRef: setArrowElement,
            style: styles.arrow || {}
        },
        children: originalChildren
    }) : originalChildren;
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("div", {
        className: className,
        ref: setContent,
        style: styles.popper,
        role: "tooltip",
        ...attributes.popper,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $ac3093982c5abc41$export$851c9e1591280bd9), {
            initialX: x,
            initialY: y,
            children: children
        })
    });
});
function $87fe9d22a5eec31a$var$getHiddenPosition(placement) {
    switch(placement){
        case "top":
            return {
                y: (0, $ac3093982c5abc41$export$83bbae95f3956836)
            };
        case "right":
        case "right-start":
            return {
                x: -(0, $ac3093982c5abc41$export$83bbae95f3956836)
            };
        case "left":
            return {
                x: (0, $ac3093982c5abc41$export$83bbae95f3956836)
            };
        default:
            return {
                y: -(0, $ac3093982c5abc41$export$83bbae95f3956836)
            };
    }
}







var $2gcPZ = parcelRequire("2gcPZ");

var $2gcPZ = parcelRequire("2gcPZ");
var $531a31f385e8e603$export$8793edee2d425525 = function() {};
function $531a31f385e8e603$export$af631764ddc44097(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (obj && obj.addEventListener) obj.addEventListener.apply(obj, args);
}
function $531a31f385e8e603$export$8c8705df4a2dcec9(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (obj && obj.removeEventListener) obj.removeEventListener.apply(obj, args);
}
var $531a31f385e8e603$export$4e09c449d6c407f7 = typeof window !== "undefined";
var $531a31f385e8e603$export$42e7ac6120dd324e = typeof navigator !== "undefined";


var $88bdb421cfe47440$var$useIsomorphicLayoutEffect = (0, $531a31f385e8e603$export$4e09c449d6c407f7) ? (0, $2gcPZ.useLayoutEffect) : (0, $2gcPZ.useEffect);
var $88bdb421cfe47440$export$2e2bcd8739ae039 = $88bdb421cfe47440$var$useIsomorphicLayoutEffect;



var $b8b5111030e66ef0$var$defaultState = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
};
function $b8b5111030e66ef0$var$useMeasure() {
    var _a = (0, $2gcPZ.useState)(null), element = _a[0], ref = _a[1];
    var _b = (0, $2gcPZ.useState)($b8b5111030e66ef0$var$defaultState), rect = _b[0], setRect = _b[1];
    var observer = (0, $2gcPZ.useMemo)(function() {
        return new window.ResizeObserver(function(entries) {
            if (entries[0]) {
                var _a = entries[0].contentRect, x = _a.x, y = _a.y, width = _a.width, height = _a.height, top_1 = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
                setRect({
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    top: top_1,
                    left: left,
                    bottom: bottom,
                    right: right
                });
            }
        });
    }, []);
    (0, $88bdb421cfe47440$export$2e2bcd8739ae039)(function() {
        if (!element) return;
        observer.observe(element);
        return function() {
            observer.disconnect();
        };
    }, [
        element
    ]);
    return [
        ref,
        rect
    ];
}
var $b8b5111030e66ef0$export$2e2bcd8739ae039 = (0, $531a31f385e8e603$export$4e09c449d6c407f7) && typeof window.ResizeObserver !== "undefined" ? $b8b5111030e66ef0$var$useMeasure : function() {
    return [
        (0, $531a31f385e8e603$export$8793edee2d425525),
        $b8b5111030e66ef0$var$defaultState
    ];
};




var $2gcPZ = parcelRequire("2gcPZ");


const $a921dfdbd8dd60fa$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $2gcPZ.forwardRef)(function Button({ children: children, buttonStyle: buttonStyle = "primary", asElement: asElement = "button", ...elementProps }, ref) {
    switch(asElement){
        case "button":
            return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($a921dfdbd8dd60fa$var$StyledButton, {
                ref: ref,
                $buttonStyle: buttonStyle,
                ...elementProps,
                children: children
            });
        case "textButton":
            return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($a921dfdbd8dd60fa$var$StyledTextButton, {
                ref: ref,
                $buttonStyle: buttonStyle,
                ...elementProps,
                children: children
            });
        case "link":
            return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($a921dfdbd8dd60fa$var$StyledLink, {
                ref: ref,
                $buttonStyle: buttonStyle,
                ...elementProps,
                children: children
            });
        case "navLink":
            return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($a921dfdbd8dd60fa$var$StyledNavLink, {
                ref: ref,
                $buttonStyle: buttonStyle,
                ...elementProps,
                children: children
            });
        case "externalLink":
            return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($a921dfdbd8dd60fa$var$StyledButton, {
                ref: ref,
                as: "a",
                $buttonStyle: buttonStyle,
                ...elementProps,
                children: children
            });
    }
});
const $a921dfdbd8dd60fa$export$bb17b15a2100b3f6 = (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)(({ $buttonStyle: $buttonStyle, theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      /* reset default button styles */
      background: none;
      border: none;
      margin: 0;
      outline: none;
      text-decoration: none;
      /* reset default button styles */

      font: ${theme.font.buttons.md};
      max-height: 36px;

      display: flex;
      justify-content: center;
      align-items: center;
      gap: 8px;

      padding: 8px 16px;
      border-radius: ${theme.radius.default};
      box-shadow: ${theme.effect.shadow.xxs};
      transition: background-color 0.1s ease-in-out, color 0.1s ease-in-out,
        border-color 0.2s ease-in-out, box-shadow 0.1s ease-in-out 0.05s;

      ${$a921dfdbd8dd60fa$var$getButtonStyle($buttonStyle)}

      &:focus,
      &:hover,
      &:active {
        cursor: pointer;
      }

      &:disabled {
        cursor: not-allowed;
      }

      &:focus,
      &:focus-visible {
        box-shadow: ${theme.effect.focus.primary};
      }
    `);
const $a921dfdbd8dd60fa$var$StyledButton = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).button`
  ${$a921dfdbd8dd60fa$export$bb17b15a2100b3f6}
`;
const $a921dfdbd8dd60fa$var$StyledLink = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $e7b98158099ae00d$export$a6c7ac8248d6e38a))`
  ${$a921dfdbd8dd60fa$export$bb17b15a2100b3f6}
`;
const $a921dfdbd8dd60fa$var$StyledNavLink = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $e7b98158099ae00d$export$b0d92dbee9b5b60d))`
  ${$a921dfdbd8dd60fa$export$bb17b15a2100b3f6}
`;
const $a921dfdbd8dd60fa$var$StyledTextButton = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).button(({ $buttonStyle: $buttonStyle, theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      ${$a921dfdbd8dd60fa$export$bb17b15a2100b3f6}

      padding: 4px;
      display: inline;
      border: none;
      background: unset;
      height: fit-content;

      ${$buttonStyle === "primary" ? (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
            color: ${theme.color.fg.primary};
          ` : (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
            color: ${theme.color.fg.muted};
          `}

      &:hover {
        color: ${theme.color.fg.default};
        background: unset;
      }
    `);
function $a921dfdbd8dd60fa$var$getButtonStyle(buttonStyle) {
    switch(buttonStyle){
        case "primary":
            return (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
          background-color: ${theme.color.button.primary.bg.default};
          color: ${theme.color.button.primary.fg.default};

          &:hover {
            background-color: ${theme.color.button.primary.bg.hover};
          }

          &:disabled {
            background-color: ${theme.color.button.primary.bg.disabled};
            color: ${theme.color.button.primary.fg.disabled};
            cursor: not-allowed;
          }
        `);
        case "secondary":
            return (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
          background-color: ${theme.color.button.secondary.bg};
          color: ${theme.color.button.secondary.fg};
          border: 1px solid ${theme.color.button.secondary.border};

          &:hover {
            background-color: ${theme.color.bg.hover};
          }

          &:focus,
          &:focus-visible {
            border-color: ${theme.color.border.primary};
          }

          &:disabled {
            border-color: ${theme.color.border.muted};
            background-color: ${theme.color.button.secondary.bg};
            color: ${theme.color.fg.subtle};
          }
        `);
        case "tertiary-color":
            return (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
          box-shadow: none;
          padding: 4px 2px;
          color: ${theme.color.fg.primary};
          border: 1px solid transparent;

          &:hover {
            color: ${theme.color.fg.default};
          }

          &:focus,
          &:focus-visible {
            border-color: ${theme.color.border.primary};
          }

          &:disabled {
            color: ${theme.color.fg.subtle};
          }
        `);
        case "tertiary-grey":
            return (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
          box-shadow: none;
          padding: 4px 2px;
          color: ${theme.color.fg.muted};
          border: 1px solid transparent;

          &:hover {
            background-color: ${theme.color.bg.hover};
          }

          &:focus,
          &:focus-visible {
            border-color: ${theme.color.border.primary};
          }

          &:disabled {
            color: ${theme.color.fg.subtle};
          }

          &.active, /* Adding the .active class here too for NavLinks */
          &:active {
            color: ${theme.color.fg.primary};
          }

          &:disabled {
            color: ${theme.color.fg.subtle};
          }
        `);
    }
}
const $a921dfdbd8dd60fa$var$InputComponentContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: inline-block;
  position: relative;
  width: 16px;
  height: 16px;
  isolation: isolate;
`;
const $a921dfdbd8dd60fa$var$StyledInput = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    display: grid;
    place-items: center;
    background-color: ${theme.color.bg.subtle};
    border: 1px solid ${theme.color.fg.muted};
    border-radius: ${theme.radius.minimal};
    height: 100%;
    width: 100%;
    z-index: 1;
    transition: box-shadow 0.1s ease-in-out 0.05s, border-color 0.2s ease-in-out,
      background-color 0.2s ease-in-out;

    ${$a921dfdbd8dd60fa$var$HiddenInputElement}:hover ~ & {
      border-color: ${theme.color.border.primary};
    }

    ${$a921dfdbd8dd60fa$var$HiddenInputElement}:focus ~ & {
      box-shadow: ${theme.effect.focus.primary};
    }

    ${$a921dfdbd8dd60fa$var$HiddenInputElement}:checked ~ & {
      border-color: ${theme.color.border.primary};
      background-color: ${theme.color.bg.emphasis["primary-subtle"]};
      color: ${theme.color.fg.primary};
    }

    ${$a921dfdbd8dd60fa$var$HiddenInputElement}:disabled ~ & {
      border-color: ${theme.color.border.default};
      background-color: ${theme.color.bg.disabled};
      color: ${theme.color.border.default};
      cursor: default;
    }
  `);
const $a921dfdbd8dd60fa$var$IconContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  @keyframes check {
    to {
      scale: 1;
      opacity: 1;
    }
  }

  & > svg {
    position: absolute;
    z-index: 2;
    inset: 0;
    height: 87.5%;
    width: 87.5%;
    margin: auto;
    scale: 0.3;
    opacity: 0;
    animation: check 0.1s ease-in-out forwards;
  }
`;
const $a921dfdbd8dd60fa$var$HiddenInputElement = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).input`
  appearance: none;
  outline: none;
  border: none;

  cursor: pointer;
  position: absolute;
  inset: 0;
  margin: 0;
  z-index: 3;
`;
const $a921dfdbd8dd60fa$var$CheckBox = /*#__PURE__*/ (0, $2gcPZ.forwardRef)(function Checkbox({ checked: checked, className: className, ...inputProps }, ref) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($a921dfdbd8dd60fa$var$InputComponentContainer, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($a921dfdbd8dd60fa$var$HiddenInputElement, {
                ...inputProps,
                ref: ref,
                checked: checked
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($a921dfdbd8dd60fa$var$StyledInput, {
                children: checked && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($a921dfdbd8dd60fa$var$IconContainer, {
                    children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("title", {
                                children: "Selected"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M9.91741 12.6078L9.91867 12.6091L8.55777 14L4 9.34163L5.3609 7.95069L8.55651 11.2168L14.6391 5L16 6.39094L9.91741 12.6078Z",
                                fill: "currentColor"
                            })
                        ]
                    })
                })
            })
        ]
    });
});
const $a921dfdbd8dd60fa$var$LightSwitch = /*#__PURE__*/ (0, $2gcPZ.forwardRef)(function LightSwitch({ checked: checked, className: className, ...inputProps }, ref) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($a921dfdbd8dd60fa$var$LightSwitchComponentContainer, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($a921dfdbd8dd60fa$var$HiddenInputElement, {
                ...inputProps,
                ref: ref,
                type: "checkbox",
                checked: checked
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($a921dfdbd8dd60fa$var$SwitchContainer, {
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($a921dfdbd8dd60fa$var$Switch, {})
            })
        ]
    });
});
const $a921dfdbd8dd60fa$var$LightSwitchComponentContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)($a921dfdbd8dd60fa$var$InputComponentContainer)`
  height: 20px;
  width: 36px;
`;
const $a921dfdbd8dd60fa$var$Switch = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    position: absolute;
    inset: 2px;
    height: 80%;
    aspect-ratio: 1;
    border-radius: ${theme.radius.full};
    background-color: ${theme.color.fg.onemphasis.default};
    box-shadow: ${theme.effect.shadow.xxs};
    transition: transform 0.2s ease-out;
  `);
const $a921dfdbd8dd60fa$var$SwitchContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)($a921dfdbd8dd60fa$var$StyledInput)(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    border: unset;
    background-color: unset;

    position: relative;
    border-radius: ${theme.radius.full};
    background-color: ${theme.color.bg.disabled};

    ${$a921dfdbd8dd60fa$var$HiddenInputElement}:hover ~ & {
      background-color: ${theme.color.bg.elevated.hover};
    }

    ${$a921dfdbd8dd60fa$var$HiddenInputElement}:checked ~ & {
      background-color: ${theme.color.bg.emphasis.primary};

      ${$a921dfdbd8dd60fa$var$Switch} {
        transform: translateX(100%);
      }
    }

    ${$a921dfdbd8dd60fa$var$HiddenInputElement}:disabled ~ & {
      background-color: ${theme.color.bg.disabled};

      ${$a921dfdbd8dd60fa$var$Switch} {
        background-color: ${theme.color.fg.onemphasis.subtle};
      }
    }
  `);
const $a921dfdbd8dd60fa$var$RadioButton = /*#__PURE__*/ (0, $2gcPZ.forwardRef)(function RadioButton({ checked: checked, className: className, ...inputProps }, ref) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($a921dfdbd8dd60fa$var$InputComponentContainer, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($a921dfdbd8dd60fa$var$HiddenInputElement, {
                ...inputProps,
                ref: ref,
                checked: checked
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($a921dfdbd8dd60fa$var$RadioContainer, {
                children: checked && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($a921dfdbd8dd60fa$var$IconContainer, {
                    children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
                        viewBox: "0 0 20 20",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("title", {
                                children: "Selected"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("circle", {
                                fill: "currentColor",
                                cx: "10",
                                cy: "10",
                                r: "5"
                            })
                        ]
                    })
                })
            })
        ]
    });
});
const $a921dfdbd8dd60fa$var$RadioContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)($a921dfdbd8dd60fa$var$StyledInput)(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    border-radius: ${theme.radius.full};
  `);
const $a921dfdbd8dd60fa$var$TextInput = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).input(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    background-color: ${theme.color.input.bg};
    border: 1px solid ${theme.color.input.border};
    border-radius: ${theme.radius.default};
    color: ${theme.color.input.fg};
    padding: 6px 12px;
    outline: none;
    font: ${theme.font.body.md.regular};
    box-shadow: ${theme.effect.shadow.xxs};

    transition: box-shadow 0.1s ease-in-out 0.05s, border-color 0.2s ease-in-out;

    &::placeholder {
      color: ${theme.color.input.fg.placeholder};
    }

    &:focus,
    &:focus-visible {
      box-shadow: ${theme.effect.focus.primary};
      border-color: ${theme.color.border.primary};
    }
    &[data-invalid="true"],
    &:invalid {
      border-color: ${theme.color.fg.danger};
    }
  `);
const $a921dfdbd8dd60fa$export$f5b8910cec6cf069 = /*#__PURE__*/ (0, $2gcPZ.forwardRef)(function Input(props, ref) {
    switch(props.type){
        case "checkbox":
            return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($a921dfdbd8dd60fa$var$CheckBox, {
                ref: ref,
                ...props
            });
        case "radio":
            return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($a921dfdbd8dd60fa$var$RadioButton, {
                ref: ref,
                ...props
            });
        case "text":
            return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($a921dfdbd8dd60fa$var$TextInput, {
                ref: ref,
                ...props
            });
        case "lightswitch":
            return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($a921dfdbd8dd60fa$var$LightSwitch, {
                ref: ref,
                ...props
            });
        default:
            return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("input", {
                ref: ref,
                ...props
            });
    }
});



const $f3c0cebd0881f06d$var$SIZE_THRESHOLD = 40;
function $f3c0cebd0881f06d$export$3b4e64e77073e307(props) {
    const { title: title, copy: copy, actions: actions, type: type, initialSize: initialSize = "default" } = props;
    const [ref, { height: height }] = (0, $b8b5111030e66ef0$export$2e2bcd8739ae039)();
    // TODO: allow for resizing from small to default again.
    const size = initialSize === "small" && height <= $f3c0cebd0881f06d$var$SIZE_THRESHOLD ? "small" : "default";
    const hasButtons = actions ? actions.length > 0 : false;
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($f3c0cebd0881f06d$var$Container, {
        type: type,
        size: size,
        hasButtons: hasButtons,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($f3c0cebd0881f06d$var$StyledIcon, {
                type: $f3c0cebd0881f06d$var$getIconType(type),
                size: size
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($f3c0cebd0881f06d$var$TextContent, {
                size: size,
                ref: ref,
                children: [
                    title && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($f3c0cebd0881f06d$var$Introduction, {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($f3c0cebd0881f06d$var$CopyContainer, {
                        children: copy
                    })
                ]
            }),
            actions && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($f3c0cebd0881f06d$var$ButtonContainer, {
                children: actions.map((action)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a921dfdbd8dd60fa$export$353f5b6fc5456de1), {
                        buttonStyle: "secondary",
                        onClick: action.onClick,
                        children: action.label
                    }, action.label))
            })
        ]
    });
}
function $f3c0cebd0881f06d$var$getIconType(type) {
    switch(type){
        case "danger":
        case "warning":
            return "warning_octagon";
        case "success":
            return "check";
        case "info":
            return "info";
    }
}
const $f3c0cebd0881f06d$var$Container = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme, type: type, size: size = "default", hasButtons: hasButtons })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    width: 100%;
    padding: 16px 17px;
    display: grid;
    gap: 16px;
    grid-template: ${()=>{
        if (!hasButtons) return (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
          "icon text" auto / 20px auto`;
        if (size === "small") return (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
          "icon text button" auto / 20px auto min-content`;
        return (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
        "icon text" auto "icon button" auto / 20px auto`;
    }};

    ${()=>{
        switch(type){
            case "info":
                return (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
            --emphasis-color: ${theme.color.fg.primary};
            --fg-muted: ${theme.color.fg.muted};
            color: ${theme.color.fg.primary};
            border-left-color: ${theme.color.border.primary};
            background-color: ${theme.color.bg.subtle};
          `;
            case "success":
                return (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
            --emphasis-color: ${theme.color.fg.success};
            --fg-muted: ${theme.color.fg.muted};
            color: ${theme.color.fg.success};
            border-left-color: ${theme.color.border.success};
            background-color: ${theme.color.bg.success};
          `;
            case "warning":
                return (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
            --emphasis-color: ${theme.color.fg.warning};
            --fg-muted: ${theme.color.fg.muted};
            color: ${theme.color.fg.warning};
            border-left-color: ${theme.color.border.warning};
            background-color: ${theme.color.bg.warning};
          `;
            default:
                return (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
            --emphasis-color: ${theme.color.fg.danger};
            --fg-muted: ${theme.color.fg.muted};
            color: ${theme.color.fg.danger};
            border-left-color: ${theme.color.border.danger};
            background-color: ${theme.color.bg.danger};
          `;
        }
    }}
    border-radius: 0 ${theme.radius.rounded} ${theme.radius.rounded} 0;
    border-left: 3px solid transparent;
  `);
const $f3c0cebd0881f06d$var$StyledIcon = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $0a830394bc38e4e3$export$f04a61298a47a40f))(({ size: size = "default" })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    grid-area: icon;
    align-self: ${size === "default" ? "start" : "center"};
  `);
const $f3c0cebd0881f06d$var$TextContent = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ size: size = "default" })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    grid-area: text;
    display: flex;
    gap: ${size === "small" ? "6px" : "8px"};
    flex: 1;
    flex-direction: ${size === "small" ? "row" : "column"};
    color: var(--fg-muted);
    align-items: ${size === "default" ? "flex-start" : "center"};
    font: ${({ theme: theme })=>theme.font.body.sm.regular};

    em {
      color: var(--emphasis-color);
    }
  `);
const $f3c0cebd0881f06d$var$Introduction = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  gap: 16px;
  color: var(--emphasis-color);
  font: ${({ theme: theme })=>theme.font.headings.h5};
`;
const $f3c0cebd0881f06d$var$CopyContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  // This transform is fix to where things wouldn't align nicely
  transform: translateY(1px);
`;
const $f3c0cebd0881f06d$var$ButtonContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  grid-area: button;
`;







var $2gcPZ = parcelRequire("2gcPZ");


const $481f0e286e6dd560$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $2gcPZ.forwardRef)(function IconButton({ iconType: type, ...buttonProps }, ref) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($481f0e286e6dd560$var$StyledButton, {
        ...buttonProps,
        ref: ref,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0a830394bc38e4e3$export$f04a61298a47a40f), {
            type: type,
            height: 20,
            width: 20
        })
    });
});
const $481f0e286e6dd560$var$StyledButton = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $a921dfdbd8dd60fa$export$353f5b6fc5456de1))`
  padding: unset;
  width: 36px;
  aspect-ratio: 1;
`;




var $2gcPZ = parcelRequire("2gcPZ");


var $2gcPZ = parcelRequire("2gcPZ");

var $2gcPZ = parcelRequire("2gcPZ");

function $a46e6bb00bbffb72$export$80c2a3957bcb42ea() {
    const isMounted = (0, $2gcPZ.useRef)(false);
    (0, $ad16f58ee69383b5$export$700979bc83e7db82)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
}


function $4fc8a2809d78e3e4$export$91db9bc4f8ac944a() {
    const isMounted = (0, $a46e6bb00bbffb72$export$80c2a3957bcb42ea)();
    const [forcedRenderCount, setForcedRenderCount] = (0, $2gcPZ.useState)(0);
    const forceRender = (0, $2gcPZ.useCallback)(()=>{
        isMounted.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [
        forcedRenderCount
    ]);
    /**
     * Defer this to the end of the next animation frame in case there are multiple
     * synchronous calls.
     */ const deferredForceRender = (0, $2gcPZ.useCallback)(()=>(0, $d959fd4c7cb328b7$export$2cef06c20297c17d).postRender(forceRender), [
        forceRender
    ]);
    return [
        deferredForceRender,
        forcedRenderCount
    ];
}




var $2gcPZ = parcelRequire("2gcPZ");



var $2gcPZ = parcelRequire("2gcPZ");
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $cbcc85debaadce89$var$PopChildMeasure extends $2gcPZ.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $cbcc85debaadce89$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent }) {
    const id = (0, $2gcPZ.useId)();
    const ref = (0, $2gcPZ.useRef)(null);
    const size = (0, $2gcPZ.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0
    });
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $2gcPZ.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        document.head.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return $2gcPZ.createElement($cbcc85debaadce89$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size
    }, $2gcPZ.cloneElement(children, {
        ref: ref
    }));
}


const $dff7c8d9f165eecf$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode })=>{
    const presenceChildren = (0, $3263fe593d864f70$export$fe4300aa8eebea86)($dff7c8d9f165eecf$var$newChildrenMap);
    const id = (0, $2gcPZ.useId)();
    const context = (0, $2gcPZ.useMemo)(()=>({
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: (childId)=>{
                presenceChildren.set(childId, true);
                for (const isComplete of presenceChildren.values()){
                    if (!isComplete) return; // can stop searching when any is incomplete
                }
                onExitComplete && onExitComplete();
            },
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        }), /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? undefined : [
        isPresent
    ]);
    (0, $2gcPZ.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $2gcPZ.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = $2gcPZ.createElement((0, $cbcc85debaadce89$export$1d6cdde0c6816c6d), {
        isPresent: isPresent
    }, children);
    return $2gcPZ.createElement((0, $3198de5e69aa0cdd$export$f224e4635b6f8ce2).Provider, {
        value: context
    }, children);
};
function $dff7c8d9f165eecf$var$newChildrenMap() {
    return new Map();
}





var $2gcPZ = parcelRequire("2gcPZ");
function $177c0269a7a4156d$export$f3a192d0cbd30b96(callback) {
    return (0, $2gcPZ.useEffect)(()=>()=>callback(), []);
}



const $d3a9d83062c98169$var$getChildKey = (child)=>child.key || "";
function $d3a9d83062c98169$var$updateChildLookup(children, allChildren) {
    children.forEach((child)=>{
        const key = $d3a9d83062c98169$var$getChildKey(child);
        allChildren.set(key, child);
    });
}
function $d3a9d83062c98169$var$onlyElements(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $2gcPZ.Children).forEach(children, (child)=>{
        if ((0, $2gcPZ.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $d3a9d83062c98169$export$3ae376d12526dd6f = ({ children: children, custom: custom, initial: initial = true, onExitComplete: onExitComplete, exitBeforeEnter: exitBeforeEnter, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync" })=>{
    (0, $f3c6a28fc8795b13$export$f5708dca728d7177)(!exitBeforeEnter, "Replace exitBeforeEnter with mode='wait'");
    // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceRender function, or one from a parent context if it exists.
    const forceRender = (0, $2gcPZ.useContext)((0, $f679b97cb314af99$export$a3579ca508007a95)).forceRender || (0, $4fc8a2809d78e3e4$export$91db9bc4f8ac944a)()[0];
    const isMounted = (0, $a46e6bb00bbffb72$export$80c2a3957bcb42ea)();
    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
    const filteredChildren = $d3a9d83062c98169$var$onlyElements(children);
    let childrenToRender = filteredChildren;
    const exitingChildren = (0, $2gcPZ.useRef)(new Map()).current;
    // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting
    const presentChildren = (0, $2gcPZ.useRef)(childrenToRender);
    // A lookup table to quickly reference components by key
    const allChildren = (0, $2gcPZ.useRef)(new Map()).current;
    // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.
    const isInitialRender = (0, $2gcPZ.useRef)(true);
    (0, $ad16f58ee69383b5$export$700979bc83e7db82)(()=>{
        isInitialRender.current = false;
        $d3a9d83062c98169$var$updateChildLookup(filteredChildren, allChildren);
        presentChildren.current = childrenToRender;
    });
    (0, $177c0269a7a4156d$export$f3a192d0cbd30b96)(()=>{
        isInitialRender.current = true;
        allChildren.clear();
        exitingChildren.clear();
    });
    if (isInitialRender.current) return $2gcPZ.createElement($2gcPZ.Fragment, null, childrenToRender.map((child)=>$2gcPZ.createElement((0, $dff7c8d9f165eecf$export$979daf65881a382a), {
            key: $d3a9d83062c98169$var$getChildKey(child),
            isPresent: true,
            initial: initial ? undefined : false,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode
        }, child)));
    // If this is a subsequent render, deal with entering and exiting children
    childrenToRender = [
        ...childrenToRender
    ];
    // Diff the keys of the currently-present and target children to update our
    // exiting list.
    const presentKeys = presentChildren.current.map($d3a9d83062c98169$var$getChildKey);
    const targetKeys = filteredChildren.map($d3a9d83062c98169$var$getChildKey);
    // Diff the present children with our target children and mark those that are exiting
    const numPresent = presentKeys.length;
    for(let i = 0; i < numPresent; i++){
        const key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1 && !exitingChildren.has(key)) exitingChildren.set(key, undefined);
    }
    // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array
    if (mode === "wait" && exitingChildren.size) childrenToRender = [];
    // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.
    exitingChildren.forEach((component, key)=>{
        // If this component is actually entering again, early return
        if (targetKeys.indexOf(key) !== -1) return;
        const child = allChildren.get(key);
        if (!child) return;
        const insertionIndex = presentKeys.indexOf(key);
        let exitingComponent = component;
        if (!exitingComponent) {
            const onExit = ()=>{
                allChildren.delete(key);
                exitingChildren.delete(key);
                // Remove this child from the present children
                const removeIndex = presentChildren.current.findIndex((presentChild)=>presentChild.key === key);
                presentChildren.current.splice(removeIndex, 1);
                // Defer re-rendering until all exiting children have indeed left
                if (!exitingChildren.size) {
                    presentChildren.current = filteredChildren;
                    if (isMounted.current === false) return;
                    forceRender();
                    onExitComplete && onExitComplete();
                }
            };
            exitingComponent = $2gcPZ.createElement((0, $dff7c8d9f165eecf$export$979daf65881a382a), {
                key: $d3a9d83062c98169$var$getChildKey(child),
                isPresent: false,
                onExitComplete: onExit,
                custom: custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode
            }, child);
            exitingChildren.set(key, exitingComponent);
        }
        childrenToRender.splice(insertionIndex, 0, exitingComponent);
    });
    // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders
    childrenToRender = childrenToRender.map((child)=>{
        const key = child.key;
        return exitingChildren.has(key) ? child : $2gcPZ.createElement((0, $dff7c8d9f165eecf$export$979daf65881a382a), {
            key: $d3a9d83062c98169$var$getChildKey(child),
            isPresent: true,
            presenceAffectsLayout: presenceAffectsLayout,
            mode: mode
        }, child);
    });
    return $2gcPZ.createElement($2gcPZ.Fragment, null, exitingChildren.size ? childrenToRender : childrenToRender.map((child)=>(0, $2gcPZ.cloneElement)(child)));
};


parcelRequire("2gcPZ");




function $87f4ad5122dd1b6b$export$ce3d072ff977d36d({ children: children, isSuccessful: isSuccessful, successIconType: successIconType, ...buttonAttributes }) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($87f4ad5122dd1b6b$var$SuccessButtonContainer, {
        ...buttonAttributes,
        buttonStyle: isSuccessful ? "success" : "base",
        onClick: isSuccessful ? (0, $205cce2352c35b5b$export$8793edee2d425525) : buttonAttributes.onClick,
        type: isSuccessful ? "button" : buttonAttributes.type,
        children: [
            successIconType && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $d3a9d83062c98169$export$3ae376d12526dd6f), {
                children: isSuccessful && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($87f4ad5122dd1b6b$var$SuccessIconContainer, {
                    children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($87f4ad5122dd1b6b$var$SuccessIcon, {
                        type: successIconType
                    })
                })
            }),
            children
        ]
    });
}
const $87f4ad5122dd1b6b$var$variants = {
    initial: {
        opacity: 0,
        scale: 0,
        width: "0%"
    },
    animate: {
        opacity: 1,
        scale: 1,
        width: "auto"
    }
};
const $87f4ad5122dd1b6b$var$SuccessIconContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $5980fceb02c72dc0$export$e25e478948902b8b).div).attrs({
    variants: $87f4ad5122dd1b6b$var$variants,
    initial: "initial",
    animate: "animate",
    exit: "initial"
})`
  display: flex;
`;
const $87f4ad5122dd1b6b$var$SuccessButtonContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $a921dfdbd8dd60fa$export$353f5b6fc5456de1))`
  gap: 0.5em;
`;
const $87f4ad5122dd1b6b$var$SuccessIcon = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $0a830394bc38e4e3$export$f04a61298a47a40f))`
  height: 1em;
  width: 1em;
  transform-origin: center;
  scale: 1.5;
`;



const $8d92bb0fb1d49a57$export$69b1032f2ecdf404 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).span`
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 4px 8px;
  background: ${({ theme: theme })=>theme.color.bg.default};
  border-radius: ${({ theme: theme })=>theme.radius.default};
`;





const $8f7cbd990124ab89$export$915e9e7bd4f0f96d = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).span(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      color: ${theme.color.fg.danger};
      font: ${theme.font.body.xs.medium};
    `);





function $6a24c97863e3e2ed$export$2a5819cd7a2ca075({ children: children, color: color }) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($6a24c97863e3e2ed$var$LabelContainer, {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($6a24c97863e3e2ed$var$LabelIcon, {
                color: color
            }),
            children
        ]
    });
}
const $6a24c97863e3e2ed$var$LabelContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).label(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      display: inline-flex;
      align-items: center;
      padding-inline: 6px;
      height: 20px;
      gap: 6px;
      border: 1px solid ${theme.color.border.default};
      border-radius: ${theme.radius.minimal};
    `);
const $6a24c97863e3e2ed$var$LabelIcon = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).label(({ color: color, theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    content: " ";
    width: 8px;
    height: 8px;
    border-radius: ${theme.radius.minimal};
    background: ${color};
  `);




var $2gcPZ = parcelRequire("2gcPZ");

var $0ecf3cf8526159c2$exports = {};
"use strict";
Object.defineProperty($0ecf3cf8526159c2$exports, "__esModule", {
    value: true
});

var $2gcPZ = parcelRequire("2gcPZ");
var $0ecf3cf8526159c2$var$useIntersection = function(ref, options) {
    var _a = $2gcPZ.useState(null), intersectionObserverEntry = _a[0], setIntersectionObserverEntry = _a[1];
    $2gcPZ.useEffect(function() {
        if (ref.current && typeof IntersectionObserver === "function") {
            var handler = function(entries) {
                setIntersectionObserverEntry(entries[0]);
            };
            var observer_1 = new IntersectionObserver(handler, options);
            observer_1.observe(ref.current);
            return function() {
                setIntersectionObserverEntry(null);
                observer_1.disconnect();
            };
        }
        return function() {};
    }, [
        ref.current,
        options.threshold,
        options.root,
        options.rootMargin
    ]);
    return intersectionObserverEntry;
};
$0ecf3cf8526159c2$exports.default = $0ecf3cf8526159c2$var$useIntersection;



function $a1b298a24b81851b$export$3f07479ca1e8eba5({ src: src, ...attributes }) {
    const [isImageLoaded, setIsImageLoaded] = (0, $2gcPZ.useState)(false);
    const imageRef = (0, $2gcPZ.useRef)(null);
    const intersection = (0, (/*@__PURE__*/$parcel$interopDefault($0ecf3cf8526159c2$exports)))(imageRef, {
        root: null,
        rootMargin: "0px",
        threshold: 0.1
    });
    const setImageIsLoaded = (0, $cac150ebb620e91f$export$d095b0c879743c0d)(()=>{
        setIsImageLoaded(true);
    });
    (0, $2gcPZ.useEffect)(()=>{
        const imageElement = new Image();
        if (!isImageLoaded && intersection?.isIntersecting) {
            imageElement.src = src;
            imageElement.addEventListener("load", setImageIsLoaded);
        }
        return ()=>{
            imageElement.removeEventListener("load", setImageIsLoaded);
        };
    }, [
        intersection?.isIntersecting,
        isImageLoaded,
        setImageIsLoaded,
        src
    ]);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($a1b298a24b81851b$var$Img, {
        ...attributes,
        ref: imageRef,
        src: isImageLoaded ? src : "",
        $isVisible: isImageLoaded
    });
}
const $a1b298a24b81851b$var$Img = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).img(({ $isVisible: $isVisible })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    opacity: 0;
    transition: opacity 0.3s ease-in-out;

    ${$isVisible && (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      opacity: 1;
    `}
  `);





function $4b2588c47e3149e9$export$d2dff97f035be373({ metric: metric }) {
    const { color: { fg: fg } } = (0, $4e8e6ea7d6e48c37$export$93d4e7f90805808f)();
    const label = metric === "successRate" ? "Success Rate" : "Latency";
    const color = metric === "successRate" ? fg.accent[1] : fg.accent[2];
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $6a24c97863e3e2ed$export$2a5819cd7a2ca075), {
        color: color,
        children: label
    });
}




const $b9eaf400d2e3afef$export$f5c8616e2cb01d3f = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).span(({ theme: { color: color, font: font } })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    display: grid;
    grid: auto / 20px auto;
    align-items: center;
    gap: 16px;
    color: ${color.fg.muted};
    font: ${font.buttons.md};
    transition: color 0.1s ease-in-out;

    &:hover {
      color: ${color.fg.default};
    }
  `);
const $b9eaf400d2e3afef$export$3e676578822187d7 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $e7b98158099ae00d$export$b0d92dbee9b5b60d))`
  &.active ${$b9eaf400d2e3afef$export$f5c8616e2cb01d3f} {
    color: ${({ theme: theme })=>theme.color.fg.primary};
  }
`;



const $747d2f1afecb66a5$export$5f86df0ee0a255b5 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: { spacing: spacing } })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    width: min(100% - calc(${spacing.page.inline} * 2), 1120px);
    margin-inline: auto;
    padding-block: ${spacing.page.block};
    display: grid;
    gap: ${spacing.page.gap};
  `);
const $747d2f1afecb66a5$export$53f1cd6809577fc5 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).header`
  display: grid;
  gap: 8px;
`;
const $747d2f1afecb66a5$export$9716a88f5535df7c = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).h1`
  font-size: 28px;
  font-family: Basier Square;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
  margin: 0;
`;
const $747d2f1afecb66a5$export$5f24e1347551b2c2 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).p(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    color: ${theme.color.fg.muted};
    font-size: 12px;
    font-family: Inter;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    margin: 0;

    & a {
      color: currentColor;
    }
  `);



const $1490f8cf9996283f$export$4a18869449458453 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).hr`
  border: none;
  border-top: 1px solid ${({ theme: theme })=>theme.color.border.default};
  margin: 0;
  padding: 0;
`;







function $3fd8d40d0eab6e09$export$66c1de921b22048b({ isActive: isActive, ...buttonAttributes }) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($3fd8d40d0eab6e09$var$ButtonContainer, {
        children: [
            isActive && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($3fd8d40d0eab6e09$var$ActiveButtonBackground, {
                layoutId: "pillBox"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($3fd8d40d0eab6e09$var$Button, {
                ...buttonAttributes,
                children: buttonAttributes.children
            })
        ]
    });
}
const $3fd8d40d0eab6e09$export$7f64fe02d2d45e7 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    display: inline-flex;
    line-height: 1;
    background-color: ${theme.color.bg.subtle};
    border-radius: ${theme.radius.full};
    padding: 4px;
  `);
const $3fd8d40d0eab6e09$var$ButtonContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).span`
  position: relative;
  border-radius: ${({ theme: theme })=>theme.radius.full};
  height: 100%;
  width: 100%;
  display: inline-flex;
`;
const $3fd8d40d0eab6e09$var$ActiveButtonBackground = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $5980fceb02c72dc0$export$e25e478948902b8b).div)(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    background-color: ${theme.color.fg.default};
    height: 100%;
    width: 100%;
    position: absolute;
    border-radius: ${theme.radius.full};
    z-index: 0;
  `);
const $3fd8d40d0eab6e09$var$Button = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).button(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    z-index: 1;
    cursor: pointer;
    margin: 0;
    padding: 8px 12px;
    border-radius: ${theme.radius.full};
    border: none;
    outline: none;
    font: ${theme.font.buttons.md};
    line-height: 1;
    background: none;
    color: ${theme.color.neutral.white};
    mix-blend-mode: difference;
  `);



const $b0893cc2f3fde9b8$export$2631a3ab3cdd158d = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: { spacing: spacing } })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    /*
      We're using custom properties here as the scroll container defaults to
      block- and inline values from the theme. These variables can be
      overwritten if the scroll container isn't dependent on the page or content
      values.
    */
    --spacing-scroll-container-block: ${spacing.content.gap.md};
    --spacing-scroll-container-inline: ${spacing.page.inline};

    display: flex;
    gap: ${spacing.content.gap.md};
    overflow-x: auto;
    padding: var(--spacing-scroll-container-block)
      var(--spacing-scroll-container-inline);
    margin: calc(var(--spacing-scroll-container-block) * -1)
      calc(var(--spacing-scroll-container-inline) * -1);

    mask: linear-gradient(
      to right,
      transparent 0%,
      black var(--spacing-scroll-container-inline),
      black calc(100% - var(--spacing-scroll-container-inline)),
      transparent 100%
    );
  `);




var $2gcPZ = parcelRequire("2gcPZ");







function $0c68418c7749c2aa$export$11a8a1ea41bf55d8(props) {
    const { children: children, onSelect: onSelect, selected: selected, value: value } = props;
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($0c68418c7749c2aa$var$Container, {
        role: "option",
        "aria-selected": selected,
        tabIndex: 0,
        onClick: ()=>onSelect(value),
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($0c68418c7749c2aa$var$Label, {
                children: children
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($0c68418c7749c2aa$var$SelectedIcon, {
                type: "check",
                selected: selected
            })
        ]
    });
}
const $0c68418c7749c2aa$var$Container = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  ${({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    font: ${theme.font.body.md.medium};
    padding: 8px 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    width: 100%;
    color: ${theme.color.fg.default};
    cursor: pointer;
    border-radius: ${theme.radius.default};
    outline: none;

    :hover {
      background-color: ${theme.color.bg.elevated.hover};
    }

    &:focus {
      border-color: ${theme.color.border.primary};
      box-shadow: ${theme.effect.focus.primary};
    }
  `}
`;
const $0c68418c7749c2aa$var$Label = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).label`
  min-width: max-content;
  cursor: pointer;
`;
const $0c68418c7749c2aa$var$SelectedIcon = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $0a830394bc38e4e3$export$f04a61298a47a40f))(({ theme: theme, selected: selected })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      color: ${selected ? theme.color.fg.primary : "transparent"};
    `);




function $c755d2e017a9d27b$export$ef9b1a59e592288f({ autoFocus: autoFocus, className: className, disabled: disabled = false, dropdownPlacement: dropdownPlacement, name: name, onChange: onChange, options: options, placeholder: placeholder, leadingIcon: LeadingIcon, trailingIcon: TrailingIcon, value: value, ...attributes }) {
    const containerRef = (0, $2gcPZ.useRef)(null);
    const { opened: opened, setOpened: setOpened, modalRef: modalRef } = (0, $0adc49931d9164a4$export$80138646353f34b1)(containerRef);
    (0, $2gcPZ.useEffect)(()=>{
        if (autoFocus) containerRef.current?.focus();
    }, [
        autoFocus
    ]);
    const selectedOption = value ? options.find((option)=>option.value === value) : undefined;
    const handleKeyDown = (event)=>{
        if (event.key === "Enter" || event.key === " ") {
            (0, $0cca6883e0725c68$export$e9caaaecfee38128)(event);
            setOpened(!opened);
        }
    };
    const handleSelect = (value)=>{
        onChange(value);
        setOpened(false);
    };
    // The `setTimeout()` is necessary to avoid what appears to be a React issue
    // that otherwise causes `handleSelect()` to be invoked immediately when the
    // dropdown is shown and any option other than the first is selected.
    // See: https://fiberplane.slack.com/archives/C01RFR1U3EC/p1677598061465209
    const onClick = ()=>setTimeout(()=>setOpened(!opened), 10);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($c755d2e017a9d27b$export$be92b6f5f03c0fe9, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($c755d2e017a9d27b$var$SelectButton, {
                ...attributes,
                buttonStyle: "secondary",
                disabled: disabled,
                ref: containerRef,
                onClick: disabled ? (0, $205cce2352c35b5b$export$8793edee2d425525) : onClick,
                onKeyDown: handleKeyDown,
                role: "combobox",
                tabIndex: disabled ? -1 : 0,
                children: [
                    LeadingIcon && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)(LeadingIcon, {}),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("span", {
                        children: selectedOption?.children ?? placeholder
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $1c3f96f2902350df$export$657832131d9fbace), {
                        isActive: opened
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("input", {
                        type: "hidden",
                        name: name,
                        value: value
                    }),
                    TrailingIcon && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)(TrailingIcon, {})
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("div", {
                role: "listbox",
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $d3a9d83062c98169$export$3ae376d12526dd6f), {
                    children: opened && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($c755d2e017a9d27b$export$2e50dd3da650cece, {
                        element: containerRef.current,
                        placement: dropdownPlacement,
                        offset: [
                            0,
                            4
                        ],
                        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($c755d2e017a9d27b$export$e44a253a59704894, {
                            ref: modalRef,
                            children: options.map((option)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0c68418c7749c2aa$export$11a8a1ea41bf55d8), {
                                    name: name,
                                    onSelect: handleSelect,
                                    selected: option === selectedOption,
                                    ...option
                                }, option.value))
                        })
                    })
                })
            })
        ]
    });
}
const $c755d2e017a9d27b$var$SelectButton = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $a921dfdbd8dd60fa$export$353f5b6fc5456de1))`
  padding: 8px;
  font: ${({ theme: theme })=>theme.font.body.md.medium};
`;
const $c755d2e017a9d27b$export$2e50dd3da650cece = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $87fe9d22a5eec31a$export$fd7a256405e9ea77))`
  min-width: 100%;
  z-index: 1;
`;
const $c755d2e017a9d27b$export$e44a253a59704894 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    display: flex;
    flex-direction: column;
    gap: 8px;
    overflow: hidden;
    justify-content: flex-start;
    align-items: flex-start;
    flex-grow: 1;
    background-color: ${theme.color.bg.elevated.default};
    border-radius: ${theme.radius.default};
    padding: 8px;
    box-shadow: ${theme.effect.shadow.m};
    width: 100%;
  `);
const $c755d2e017a9d27b$export$be92b6f5f03c0fe9 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  height: min-content;
  position: relative;
`;







function $206fa7d93be79d44$export$3e41faf802a29e71({ isActive: isActive, children: children, ...buttonProps }) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($206fa7d93be79d44$var$TabButton, {
        ...buttonProps,
        role: "tab",
        "aria-selected": isActive,
        tabIndex: isActive ? 0 : -1,
        $isActive: isActive,
        children: children
    });
}
const $206fa7d93be79d44$export$b2539bed5023c21c = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: grid;
  grid-auto-rows: auto;
  gap: ${({ theme: theme })=>theme.spacing.page.gap};
`;
const $206fa7d93be79d44$export$e51a686c67fdaa2d = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    display: grid;
    grid-auto-flow: column;
    gap: 4px;
    padding: 4px;
    width: var(--width-tab-list, fit-content);
    border-radius: ${theme.radius.default};
    background-color: ${theme.color.bg.elevated.hover};
  `);
const $206fa7d93be79d44$var$TabButton = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $a921dfdbd8dd60fa$export$353f5b6fc5456de1)).attrs({
    buttonStyle: "secondary"
})(({ $isActive: $isActive, theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    position: relative;
    border-color: transparent;
    box-shadow: none;
    background: transparent;

    &:hover {
      background-color: ${theme.color.primary.grape.alpha[100]};
    }

    &:focus,
    &:focus-visible {
      box-shadow: none;
    }

    ${$isActive && (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      border-color: ${theme.color.border.primary};
      color: ${theme.color.fg.primary};

      &,
      &:hover {
        background-color: ${theme.color.button.primary.bg.default};
        color: ${theme.color.fg.onemphasis.default};
      }
    `}
  `);




var $2gcPZ = parcelRequire("2gcPZ");

function $5e65b7d195cb25fe$export$ae7b5e50e522fa95() {
    const [loadingIndicator, setLoadingIndicator] = (0, $2gcPZ.useState)("");
    (0, $2gcPZ.useEffect)(()=>{
        const id = setInterval(()=>{
            setLoadingIndicator((oldText)=>{
                let newText = oldText + ". ";
                if (newText.length > 6) newText = "";
                return newText;
            });
        }, 200);
        return ()=>{
            clearInterval(id);
        };
    }, []);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($5e65b7d195cb25fe$var$ThinkingContainer, {
        children: loadingIndicator || " "
    });
}
const $5e65b7d195cb25fe$var$ThinkingContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  white-space: break-spaces;
`;




const $0c5c766c1e242605$export$42a852a2b6b56249 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $5980fceb02c72dc0$export$e25e478948902b8b).div)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80%;
  min-height: 400px;
  padding: 0 6px;
`;
const $0c5c766c1e242605$export$7c6e2c02157bb7d2 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  max-width: 470px;
`;
const $0c5c766c1e242605$export$8b251419efc915eb = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).header`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  gap: 8px;
  min-width: 0;
`;
const $0c5c766c1e242605$export$a8a3e93435678ff9 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).h2`
  font-family: "Basier Square";
  font-style: normal;
  font-weight: 500;
  font-size: 20px;

  display: flex;
  align-items: center;
  margin: 24px 0 0;
`;
const $0c5c766c1e242605$export$7bc3de131d90901c = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).p(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    color: ${theme.color.fg.muted};
    text-align: center;
    width: 100%;
  `);
const $0c5c766c1e242605$export$7e5aa1a6f087569b = ({ type: type, noBorder: noBorder })=>{
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($0c5c766c1e242605$var$DropShadow, {
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($0c5c766c1e242605$var$BigIconContainer, {
            noBorder: noBorder,
            children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($0c5c766c1e242605$var$BigIconInner, {
                type: type
            })
        })
    });
};
const $0c5c766c1e242605$var$DropShadow = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  width: 80px;
  height: 80px;
  position: relative;
  filter: drop-shadow(0px 3px 12px rgba(0, 0, 0, 0.15));
`;
const $0c5c766c1e242605$var$BigIconContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  border: 1px solid
    ${({ theme: theme, noBorder: noBorder })=>noBorder ? "transparent" : theme.color.border.default};
  border-radius: 12px;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const $0c5c766c1e242605$var$BigIconInner = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $0a830394bc38e4e3$export$f04a61298a47a40f)).attrs({
    width: "40",
    height: "40"
})``;


function $b6465ff4e4132c39$export$669f6ea7d267feaf() {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0c5c766c1e242605$export$42a852a2b6b56249), {
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0c5c766c1e242605$export$7c6e2c02157bb7d2), {
            children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $0c5c766c1e242605$export$8b251419efc915eb), {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0c5c766c1e242605$export$7e5aa1a6f087569b), {
                        type: "autometrics"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0c5c766c1e242605$export$a8a3e93435678ff9), {
                        children: "Loading"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0c5c766c1e242605$export$7bc3de131d90901c), {
                        children: "Getting your data from Prometheus\u2026"
                    })
                ]
            })
        })
    });
}







var $61803030807a0e69$exports = {};
$61803030807a0e69$exports = new URL("../img/no-data-url-provided.d2f51ca2.png", import.meta.url).toString();


const { pathname: $ca0bd75019462cd1$var$pathname } = new URL($61803030807a0e69$exports);
function $ca0bd75019462cd1$export$be3dbeb7e994ac04() {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0c5c766c1e242605$export$42a852a2b6b56249), {
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $0c5c766c1e242605$export$7c6e2c02157bb7d2), {
            children: [
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a1b298a24b81851b$export$3f07479ca1e8eba5), {
                    src: $ca0bd75019462cd1$var$pathname
                }),
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $0c5c766c1e242605$export$8b251419efc915eb), {
                    children: [
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($ca0bd75019462cd1$var$StyledHeading, {
                            children: "Missing Prometheus Host"
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $0c5c766c1e242605$export$7bc3de131d90901c), {
                            children: [
                                "To connect to Prometheus, add a host on the",
                                " ",
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $e7b98158099ae00d$export$a6c7ac8248d6e38a), {
                                    to: "/settings",
                                    children: "settings"
                                }),
                                " page."
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
const $ca0bd75019462cd1$var$StyledHeading = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $0c5c766c1e242605$export$a8a3e93435678ff9))`
  margin: 0;
`;







function $8b81d3d733bcd10f$export$78d0d40b8e48fb0f() {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0c5c766c1e242605$export$42a852a2b6b56249), {
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $0c5c766c1e242605$export$7c6e2c02157bb7d2), {
            children: [
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $0c5c766c1e242605$export$8b251419efc915eb), {
                    children: [
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0c5c766c1e242605$export$7e5aa1a6f087569b), {
                            type: "autometrics_black_faded"
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0c5c766c1e242605$export$a8a3e93435678ff9), {
                            children: "No Functions Detected"
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $0c5c766c1e242605$export$7bc3de131d90901c), {
                            children: [
                                "Check that your project is exposing metrics to Prometheus, and that your functions have executed at least once. If you need any help, reach out on",
                                " ",
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("a", {
                                    href: "https://discord.com/invite/MJr7pYzZQ4",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    children: "Discord"
                                }),
                                ", or consult the",
                                " ",
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("a", {
                                    href: "https://docs.autometrics.dev/",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    children: "docs"
                                }),
                                "."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($8b81d3d733bcd10f$var$ButtonGroup, {
                    children: [
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($8b81d3d733bcd10f$var$DiscordButton, {
                            asElement: "externalLink",
                            href: "https://discord.com/invite/MJr7pYzZQ4",
                            children: [
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($8b81d3d733bcd10f$var$StyledIcon, {
                                    type: "discord_logo"
                                }),
                                "Get Help on Discord"
                            ]
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($8b81d3d733bcd10f$var$DocumentationButton, {
                            asElement: "externalLink",
                            href: "https://docs.autometrics.dev/",
                            children: [
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($8b81d3d733bcd10f$var$StyledIcon, {
                                    type: "notebook"
                                }),
                                "View the Docs"
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
const $8b81d3d733bcd10f$var$ButtonGroup = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 24px;
`;
const $8b81d3d733bcd10f$var$DiscordButton = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $a921dfdbd8dd60fa$export$353f5b6fc5456de1))``;
const $8b81d3d733bcd10f$var$DocumentationButton = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $a921dfdbd8dd60fa$export$353f5b6fc5456de1)).attrs({
    buttonStyle: "baseInverted"
})``;
const $8b81d3d733bcd10f$var$StyledIcon = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $0a830394bc38e4e3$export$f04a61298a47a40f))`
  margin-right: 8px;
`;





function $7f2b92de158af7af$export$5eef44829f72c6d0() {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0c5c766c1e242605$export$42a852a2b6b56249), {
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0c5c766c1e242605$export$7c6e2c02157bb7d2), {
            children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $0c5c766c1e242605$export$8b251419efc915eb), {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0c5c766c1e242605$export$7e5aa1a6f087569b), {
                        type: "prometheus_filled_grey"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0c5c766c1e242605$export$a8a3e93435678ff9), {
                        children: "Error contacting Prometheus"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $0c5c766c1e242605$export$7bc3de131d90901c), {
                        children: [
                            "Please check your Prometheus connection. You can add different hostnames on the ",
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $e7b98158099ae00d$export$a6c7ac8248d6e38a), {
                                to: "/settings",
                                children: "settings"
                            }),
                            " page."
                        ]
                    })
                ]
            })
        })
    });
}





const { Container: $b202a283499519c6$var$Container, Content: $b202a283499519c6$var$Content, Header: $b202a283499519c6$var$Header, Heading: $b202a283499519c6$var$Heading, HelperText: $b202a283499519c6$var$HelperText, BigIcon: $b202a283499519c6$var$BigIcon } = (0, $0c5c766c1e242605$exports);
function $b202a283499519c6$export$e94df23e484f280a() {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($b202a283499519c6$var$Container, {
        initial: {
            opacity: 0,
            y: 20
        },
        animate: {
            opacity: 1,
            y: 0
        },
        exit: {
            opacity: 0,
            y: -10
        },
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($b202a283499519c6$var$Content, {
            children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($b202a283499519c6$var$Header, {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($b202a283499519c6$var$BigIcon, {
                        type: "autometrics_color"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($b202a283499519c6$var$Heading, {
                        children: "Select a function to continue"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($b202a283499519c6$var$HelperText, {
                        children: "To start exploring, select a function from the explorer on the left."
                    })
                ]
            })
        })
    });
}








function $192a6ebc11da083f$export$9030be3ebb5e43eb({ className: className, rate: rate, report: report, unit: unit }) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($192a6ebc11da083f$var$MetricDisplayContainer, {
        className: className,
        children: [
            rate || rate === 0 ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($192a6ebc11da083f$var$MetricRate, {
                children: rate
            }) : /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($192a6ebc11da083f$var$MetricRate, {
                isEmpty: true,
                children: "\u2014"
            }),
            unit && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($192a6ebc11da083f$var$MetricUnit, {
                children: unit
            }),
            report && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($192a6ebc11da083f$var$MetricLatest, {
                children: report[0]?.toUpperCase() + report.slice(1)
            })
        ]
    });
}
const $192a6ebc11da083f$var$MetricDisplayContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: grid;
  grid:
    "rate unit" 1fr
    "latest latest" auto / auto 1fr;
  gap: 8px;
`;
const $192a6ebc11da083f$var$MetricRate = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).p(({ isEmpty: isEmpty, theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    grid-area: rate;
    align-self: end;
    font: ${theme.font.body.xl.medium};
    line-height: 1;

    ${isEmpty && (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      opacity: 0.6;
    `}
  `);
const $192a6ebc11da083f$var$MetricLatest = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).p(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    grid-area: latest;
    align-self: end;
    font: ${theme.font.body.sm.medium};
    line-height: 1;
    margin: 0;
    color: var(--text-alternative-color);
  `);
const $192a6ebc11da083f$var$MetricUnit = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)($192a6ebc11da083f$var$MetricLatest)`
  grid-area: unit;
  align-self: end;
`;


const $2042716e2270aa85$export$42a852a2b6b56249 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    padding: ${theme.spacing.content.gap.md};
    border-radius: ${theme.radius.default};
  `);
const $2042716e2270aa85$export$ef2184bd89960b14 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: grid;
  grid: "metrics" auto "graph" 1fr;
  gap: ${({ theme: theme })=>theme.spacing.page.gap};
  padding: 0;
`;
const $2042716e2270aa85$export$2e0db495abdb18ec = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  grid-area: metrics;
  display: flex;
  gap: 40px;
`;
const $2042716e2270aa85$export$c4a562231524e009 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  grid-area: graph;
  position: relative;
  min-width: 0;
`;
const $2042716e2270aa85$export$73722bc4ca9ba271 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $192a6ebc11da083f$export$9030be3ebb5e43eb))`
  --text-alternative-color: ${({ theme: theme })=>theme.color.fg.subtle};
`;




var $2gcPZ = parcelRequire("2gcPZ");


var $2gcPZ = parcelRequire("2gcPZ");


/* eslint-disable no-undefined,no-param-reassign,no-shadow */ /**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param {number} delay -                  A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher)
 *                                            are most useful.
 * @param {Function} callback -               A function to be executed after delay milliseconds. The `this` context and all arguments are passed through,
 *                                            as-is, to `callback` when the throttled-function is executed.
 * @param {object} [options] -              An object to configure options.
 * @param {boolean} [options.noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds
 *                                            while the throttled-function is being called. If noTrailing is false or unspecified, callback will be executed
 *                                            one final time after the last throttled-function call. (After the throttled-function has not been called for
 *                                            `delay` milliseconds, the internal counter is reset).
 * @param {boolean} [options.noLeading] -   Optional, defaults to false. If noLeading is false, the first throttled-function call will execute callback
 *                                            immediately. If noLeading is true, the first the callback execution will be skipped. It should be noted that
 *                                            callback will never executed if both noLeading = true and noTrailing = true.
 * @param {boolean} [options.debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is
 *                                            false (at end), schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function} A new, throttled, function.
 */ function $eaec1d9861b3c597$export$de363e709c412c8a(delay, callback, options) {
    var _ref = options || {}, _ref$noTrailing = _ref.noTrailing, noTrailing = _ref$noTrailing === void 0 ? false : _ref$noTrailing, _ref$noLeading = _ref.noLeading, noLeading = _ref$noLeading === void 0 ? false : _ref$noLeading, _ref$debounceMode = _ref.debounceMode, debounceMode = _ref$debounceMode === void 0 ? undefined : _ref$debounceMode;
    /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */ var timeoutID;
    var cancelled = false; // Keep track of the last time `callback` was executed.
    var lastExec = 0; // Function to clear existing timeout
    function clearExistingTimeout() {
        if (timeoutID) clearTimeout(timeoutID);
    } // Function to cancel next exec
    function cancel(options) {
        var _ref2 = options || {}, _ref2$upcomingOnly = _ref2.upcomingOnly, upcomingOnly = _ref2$upcomingOnly === void 0 ? false : _ref2$upcomingOnly;
        clearExistingTimeout();
        cancelled = !upcomingOnly;
    }
    /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */ function wrapper() {
        for(var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++)arguments_[_key] = arguments[_key];
        var self = this;
        var elapsed = Date.now() - lastExec;
        if (cancelled) return;
         // Execute `callback` and update the `lastExec` timestamp.
        function exec() {
            lastExec = Date.now();
            callback.apply(self, arguments_);
        }
        /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */ function clear() {
            timeoutID = undefined;
        }
        if (!noLeading && debounceMode && !timeoutID) /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`
       * and noLeading != true.
       */ exec();
        clearExistingTimeout();
        if (debounceMode === undefined && elapsed > delay) {
            if (noLeading) {
                /*
         * In throttle mode with noLeading, if `delay` time has
         * been exceeded, update `lastExec` and schedule `callback`
         * to execute after `delay` ms.
         */ lastExec = Date.now();
                if (!noTrailing) timeoutID = setTimeout(debounceMode ? clear : exec, delay);
            } else /*
         * In throttle mode without noLeading, if `delay` time has been exceeded, execute
         * `callback`.
         */ exec();
        } else if (noTrailing !== true) /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */ timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
    wrapper.cancel = cancel; // Return the wrapper function.
    return wrapper;
}
/* eslint-disable no-undefined */ /**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param {number} delay -               A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param {Function} callback -          A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                        to `callback` when the debounced-function is executed.
 * @param {object} [options] -           An object to configure options.
 * @param {boolean} [options.atBegin] -  Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                        after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                        (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 *
 * @returns {Function} A new, debounced function.
 */ function $eaec1d9861b3c597$export$61fc7d43ac8f84b0(delay, callback, options) {
    var _ref = options || {}, _ref$atBegin = _ref.atBegin, atBegin = _ref$atBegin === void 0 ? false : _ref$atBegin;
    return $eaec1d9861b3c597$export$de363e709c412c8a(delay, callback, {
        debounceMode: atBegin !== false
    });
}


const $d2cbe6f410c6408c$export$8793edee2d425525 = (any)=>any;


let $fbd148e25c0bf485$export$491112666e282270 = (0, $d2cbe6f410c6408c$export$8793edee2d425525);
let $fbd148e25c0bf485$export$f5708dca728d7177 = (0, $d2cbe6f410c6408c$export$8793edee2d425525);
var $fbd148e25c0bf485$var$check, $fbd148e25c0bf485$var$message, $fbd148e25c0bf485$var$check1, $fbd148e25c0bf485$var$message1;


function $57b42c80cd6ebb05$export$90ceba2564a894f8(elements, scope, selectorCache) {
    var _a;
    if (typeof elements === "string") {
        let root = document;
        if (scope) {
            (0, $fbd148e25c0bf485$export$f5708dca728d7177)(Boolean(scope.current), "Scope provided, but no element detected.");
            root = scope.current;
        }
        if (selectorCache) {
            (_a = selectorCache[elements]) !== null && _a !== void 0 ? _a : selectorCache[elements] = root.querySelectorAll(elements);
            elements = selectorCache[elements];
        } else elements = root.querySelectorAll(elements);
    } else if (elements instanceof Element) elements = [
        elements
    ];
    /**
     * Return an empty array
     */ return Array.from(elements || []);
}


const $917bdbd54cf82b87$export$bc2a978a17abfdde = new WeakMap();




class $8f03890839b874bc$var$Queue {
    constructor(){
        this.order = [];
        this.scheduled = new Set();
    }
    add(process) {
        if (!this.scheduled.has(process)) {
            this.scheduled.add(process);
            this.order.push(process);
            return true;
        }
    }
    remove(process) {
        const index = this.order.indexOf(process);
        if (index !== -1) {
            this.order.splice(index, 1);
            this.scheduled.delete(process);
        }
    }
    clear() {
        this.order.length = 0;
        this.scheduled.clear();
    }
}
function $8f03890839b874bc$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new $8f03890839b874bc$var$Queue();
    let nextFrame = new $8f03890839b874bc$var$Queue();
    let numToRun = 0;
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (queue.add(callback) && addToCurrentFrame && isProcessing) // If we're adding it to the currently running queue, update its measured size
            numToRun = thisFrame.order.length;
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.remove(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Clear the next frame queue
            nextFrame.clear();
            // Execute this frame
            numToRun = thisFrame.order.length;
            if (numToRun) for(let i = 0; i < numToRun; i++){
                const callback = thisFrame.order[i];
                callback(frameData);
                if (toKeepAlive.has(callback)) {
                    step.schedule(callback);
                    runNextFrame();
                }
            }
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $f3f431ab5bf9d4ab$export$71ecace0a033b35a = [
    "prepare",
    "read",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $f3f431ab5bf9d4ab$var$maxElapsed = 40;
function $f3f431ab5bf9d4ab$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0,
        timestamp: 0,
        isProcessing: false
    };
    const steps = $f3f431ab5bf9d4ab$export$71ecace0a033b35a.reduce((acc, key)=>{
        acc[key] = (0, $8f03890839b874bc$export$b995e5e85f5c8289)(()=>runNextFrame = true);
        return acc;
    }, {});
    const processStep = (stepId)=>steps[stepId].process(state);
    const processBatch = ()=>{
        const timestamp = performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $f3f431ab5bf9d4ab$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        $f3f431ab5bf9d4ab$export$71ecace0a033b35a.forEach(processStep);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = $f3f431ab5bf9d4ab$export$71ecace0a033b35a.reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>$f3f431ab5bf9d4ab$export$71ecace0a033b35a.forEach((key)=>steps[key].cancel(process));
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $20659c72a41d0fd3$export$2cef06c20297c17d, cancel: $20659c72a41d0fd3$export$ec99c0ef4978dccb, state: $20659c72a41d0fd3$export$fff89137e9e818ce, steps: $20659c72a41d0fd3$export$be3f796aed065412 } = (0, $f3f431ab5bf9d4ab$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $d2cbe6f410c6408c$export$8793edee2d425525), true);


function $9e1d977bbbef54ea$export$b4f1bbab0c442a76(update, timeline) {
    let prevProgress;
    const onFrame = ()=>{
        const { currentTime: currentTime } = timeline;
        const percentage = currentTime === null ? 0 : currentTime.value;
        const progress = percentage / 100;
        if (prevProgress !== progress) update(progress);
        prevProgress = progress;
    };
    (0, $20659c72a41d0fd3$export$2cef06c20297c17d).update(onFrame, true);
    return ()=>(0, $20659c72a41d0fd3$export$ec99c0ef4978dccb)(onFrame);
}


function $b2d487df80d1c202$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}


const $965306f4401b9c3b$export$20d68f04f30763a5 = (0, $b2d487df80d1c202$export$7c73462e0d25e514)(()=>window.ScrollTimeline !== undefined);


class $96aff0553a8e500d$export$c1e41718f71efe41 {
    constructor(animations){
        this.animations = animations.filter(Boolean);
    }
    then(onResolve, onReject) {
        return Promise.all(this.animations).then(onResolve).catch(onReject);
    }
    /**
     * TODO: Filter out cancelled or stopped animations before returning
     */ getAll(propName) {
        return this.animations[0][propName];
    }
    setAll(propName, newValue) {
        for(let i = 0; i < this.animations.length; i++)this.animations[i][propName] = newValue;
    }
    attachTimeline(timeline) {
        const cancelAll = this.animations.map((animation)=>{
            if ((0, $965306f4401b9c3b$export$20d68f04f30763a5)() && animation.attachTimeline) animation.attachTimeline(timeline);
            else {
                animation.pause();
                return (0, $9e1d977bbbef54ea$export$b4f1bbab0c442a76)((progress)=>{
                    animation.time = animation.duration * progress;
                }, timeline);
            }
        });
        return ()=>{
            cancelAll.forEach((cancelTimeline, i)=>{
                if (cancelTimeline) cancelTimeline();
                this.animations[i].stop();
            });
        };
    }
    get time() {
        return this.getAll("time");
    }
    set time(time) {
        this.setAll("time", time);
    }
    get speed() {
        return this.getAll("speed");
    }
    set speed(speed) {
        this.setAll("speed", speed);
    }
    get duration() {
        let max = 0;
        for(let i = 0; i < this.animations.length; i++)max = Math.max(max, this.animations[i].duration);
        return max;
    }
    runAll(methodName) {
        this.animations.forEach((controls)=>controls[methodName]());
    }
    play() {
        this.runAll("play");
    }
    pause() {
        this.runAll("pause");
    }
    stop() {
        this.runAll("stop");
    }
    cancel() {
        this.runAll("cancel");
    }
    complete() {
        this.runAll("complete");
    }
}


function $a0be9c8cf1426b29$export$d276bfce3b1077ca(keyframes) {
    return typeof keyframes === "object" && !Array.isArray(keyframes);
}


/**
 * Generate a list of every possible transform key.
 */ const $b519ba7cf8f7f57e$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $b519ba7cf8f7f57e$export$7b42a0094fb00b6e = new Set($b519ba7cf8f7f57e$export$280dc01950909d86);


/**
 * Convert camelCase to dash-case properties.
 */ const $a5fa4ba7c7c4e42d$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();


const $562b99e5f1850f7e$export$ed7b8fa9dbf0105d = "framerAppearId";
const $562b99e5f1850f7e$export$8592e1c077c890a6 = "data-" + (0, $a5fa4ba7c7c4e42d$export$9fd24a634729c672)($562b99e5f1850f7e$export$ed7b8fa9dbf0105d);



/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ const $163563b2e4726aac$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
const $163563b2e4726aac$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;


const $32dfec56e9ec3613$export$888a3d84909f9e3d = {
    current: false
};


const $70a767ee5dfb16fa$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";


function $4620152b4e6bd4de$export$fcdd8f3f2160beda(easing) {
    return Boolean(!easing || typeof easing === "string" && $4620152b4e6bd4de$export$2cf569f5e2221176[easing] || (0, $70a767ee5dfb16fa$export$ff43f99925d7366b)(easing) || Array.isArray(easing) && easing.every($4620152b4e6bd4de$export$fcdd8f3f2160beda));
}
const $4620152b4e6bd4de$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $4620152b4e6bd4de$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: $4620152b4e6bd4de$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: $4620152b4e6bd4de$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: $4620152b4e6bd4de$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: $4620152b4e6bd4de$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $4620152b4e6bd4de$export$916ea73bcd3a6030(easing) {
    if (!easing) return undefined;
    return (0, $70a767ee5dfb16fa$export$ff43f99925d7366b)(easing) ? $4620152b4e6bd4de$export$2523b8f0bd8f44cb(easing) : Array.isArray(easing) ? easing.map($4620152b4e6bd4de$export$916ea73bcd3a6030) : $4620152b4e6bd4de$export$2cf569f5e2221176[easing];
}


function $a6655e578d93a7dd$export$c76cd972d26986f9(element, valueName, keyframes, { delay: delay = 0, duration: duration, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease, times: times } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $4620152b4e6bd4de$export$916ea73bcd3a6030)(ease);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}



function $374c55a95772583b$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }) {
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : keyframes.length - 1;
    return keyframes[index];
}



/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $f198925bccd1a70b$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $f198925bccd1a70b$var$subdivisionPrecision = 0.0000001;
const $f198925bccd1a70b$var$subdivisionMaxIterations = 12;
function $f198925bccd1a70b$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $f198925bccd1a70b$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $f198925bccd1a70b$var$subdivisionPrecision && ++i < $f198925bccd1a70b$var$subdivisionMaxIterations);
    return currentT;
}
function $f198925bccd1a70b$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $d2cbe6f410c6408c$export$8793edee2d425525;
    const getTForX = (aX)=>$f198925bccd1a70b$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $f198925bccd1a70b$var$calcBezier(getTForX(t), mY1, mY2);
}


const $5b444935dec43798$export$929e5a82286172a6 = (0, $f198925bccd1a70b$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $5b444935dec43798$export$57636bb43b1ccbb0 = (0, $f198925bccd1a70b$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $5b444935dec43798$export$c07234257a03d5e9 = (0, $f198925bccd1a70b$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);


const $5d0a11a28f7b03d5$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};






// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $f19a715705e80a68$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $8ce0c5e6263d9b88$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $c6d24e6e982e1be5$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $c6d24e6e982e1be5$export$c8d67a19199d1a50 = (0, $8ce0c5e6263d9b88$export$2c07eeff45156d4d)($c6d24e6e982e1be5$export$e444123e42d03385);
const $c6d24e6e982e1be5$export$30d3455eee55bed5 = (0, $f19a715705e80a68$export$f946554fb8aeaf0d)($c6d24e6e982e1be5$export$c8d67a19199d1a50);





const $9541667b1cbda0cf$export$77edfce482316a60 = (0, $f198925bccd1a70b$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $9541667b1cbda0cf$export$b01116c84cdfe1a2 = (0, $8ce0c5e6263d9b88$export$2c07eeff45156d4d)($9541667b1cbda0cf$export$77edfce482316a60);
const $9541667b1cbda0cf$export$ddc5fd596f6c71b2 = (0, $f19a715705e80a68$export$f946554fb8aeaf0d)($9541667b1cbda0cf$export$b01116c84cdfe1a2);



const $2d06fbf5c322c943$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $9541667b1cbda0cf$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));


const $ddf9a6de7db7bd34$var$easingLookup = {
    linear: (0, $d2cbe6f410c6408c$export$8793edee2d425525),
    easeIn: $5b444935dec43798$export$929e5a82286172a6,
    easeInOut: $5b444935dec43798$export$c07234257a03d5e9,
    easeOut: $5b444935dec43798$export$57636bb43b1ccbb0,
    circIn: $c6d24e6e982e1be5$export$e444123e42d03385,
    circInOut: $c6d24e6e982e1be5$export$30d3455eee55bed5,
    circOut: $c6d24e6e982e1be5$export$c8d67a19199d1a50,
    backIn: $9541667b1cbda0cf$export$b01116c84cdfe1a2,
    backInOut: $9541667b1cbda0cf$export$ddc5fd596f6c71b2,
    backOut: $9541667b1cbda0cf$export$77edfce482316a60,
    anticipate: $2d06fbf5c322c943$export$6b0af63b873d419e
};
const $ddf9a6de7db7bd34$export$ef97fe084f156ca4 = (definition)=>{
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $fbd148e25c0bf485$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $f198925bccd1a70b$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $fbd148e25c0bf485$export$f5708dca728d7177)($ddf9a6de7db7bd34$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $ddf9a6de7db7bd34$var$easingLookup[definition];
    }
    return definition;
};



/**
 * TODO: When we move from string as a source of truth to data models
 * everything in this folder should probably be referred to as models vs types
 */ // If this number is a decimal, make it just five decimal places
// to avoid exponents
const $b8f42e16a7301bfc$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;
const $b8f42e16a7301bfc$export$2444ca58c08448e4 = /(-)?([\d]*\.?[\d])+/g;
const $b8f42e16a7301bfc$export$740b69c5fad25dba = /(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi;
const $b8f42e16a7301bfc$export$ed808ff6ecd39e8d = /^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;
function $b8f42e16a7301bfc$export$844ec244b1367d54(v) {
    return typeof v === "string";
}


const $414e910502dfd816$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);



const $fd5699cd861e5b4f$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $fd5699cd861e5b4f$export$58f0f39f63f3cf42 = {
    ...$fd5699cd861e5b4f$export$98e628dec113755e,
    transform: (v)=>(0, $414e910502dfd816$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $fd5699cd861e5b4f$export$dcdf75081b88279d = {
    ...$fd5699cd861e5b4f$export$98e628dec113755e,
    default: 1
};




/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $d830173ac0ec584e$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean((0, $b8f42e16a7301bfc$export$844ec244b1367d54)(v) && (0, $b8f42e16a7301bfc$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $d830173ac0ec584e$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (!(0, $b8f42e16a7301bfc$export$844ec244b1367d54)(v)) return v;
        const [a, b, c, alpha] = v.match((0, $b8f42e16a7301bfc$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $4039f667230e34b4$var$clampRgbUnit = (v)=>(0, $414e910502dfd816$export$7d15b64cf5a3a4c4)(0, 255, v);
const $4039f667230e34b4$export$7a99c86b5b1f4c9e = {
    ...(0, $fd5699cd861e5b4f$export$98e628dec113755e),
    transform: (v)=>Math.round($4039f667230e34b4$var$clampRgbUnit(v))
};
const $4039f667230e34b4$export$4e46ac54fc82cf3b = {
    test: (0, $d830173ac0ec584e$export$2c8400d58aca05e)("rgb", "red"),
    parse: (0, $d830173ac0ec584e$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $4039f667230e34b4$export$7a99c86b5b1f4c9e.transform(red) + ", " + $4039f667230e34b4$export$7a99c86b5b1f4c9e.transform(green) + ", " + $4039f667230e34b4$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $b8f42e16a7301bfc$export$83d2e9e3e4ee39ed)((0, $fd5699cd861e5b4f$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $ea0a4b0f3ce621e6$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $ea0a4b0f3ce621e6$export$834dfc94dde4b3d8 = {
    test: (0, $d830173ac0ec584e$export$2c8400d58aca05e)("#"),
    parse: $ea0a4b0f3ce621e6$var$parseHex,
    transform: (0, $4039f667230e34b4$export$4e46ac54fc82cf3b).transform
};




const $8f6e75453fcb14be$var$createUnitType = (unit)=>({
        test: (v)=>(0, $b8f42e16a7301bfc$export$844ec244b1367d54)(v) && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $8f6e75453fcb14be$export$41fc368e1a942b97 = $8f6e75453fcb14be$var$createUnitType("deg");
const $8f6e75453fcb14be$export$626336c2cd4b14de = $8f6e75453fcb14be$var$createUnitType("%");
const $8f6e75453fcb14be$export$91c0eda1d06bf008 = $8f6e75453fcb14be$var$createUnitType("px");
const $8f6e75453fcb14be$export$f91e8c45a95a32f2 = $8f6e75453fcb14be$var$createUnitType("vh");
const $8f6e75453fcb14be$export$aed3d7b7d206c196 = $8f6e75453fcb14be$var$createUnitType("vw");
const $8f6e75453fcb14be$export$44e2e1705876d7ed = {
    ...$8f6e75453fcb14be$export$626336c2cd4b14de,
    parse: (v)=>$8f6e75453fcb14be$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$8f6e75453fcb14be$export$626336c2cd4b14de.transform(v * 100)
};




const $07db85ecb8c92152$export$810b04175080204c = {
    test: (0, $d830173ac0ec584e$export$2c8400d58aca05e)("hsl", "hue"),
    parse: (0, $d830173ac0ec584e$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $8f6e75453fcb14be$export$626336c2cd4b14de).transform((0, $b8f42e16a7301bfc$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $8f6e75453fcb14be$export$626336c2cd4b14de).transform((0, $b8f42e16a7301bfc$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $b8f42e16a7301bfc$export$83d2e9e3e4ee39ed)((0, $fd5699cd861e5b4f$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $7e3911c57baed9d4$export$35e9368ef982300f = {
    test: (v)=>(0, $4039f667230e34b4$export$4e46ac54fc82cf3b).test(v) || (0, $ea0a4b0f3ce621e6$export$834dfc94dde4b3d8).test(v) || (0, $07db85ecb8c92152$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $4039f667230e34b4$export$4e46ac54fc82cf3b).test(v)) return (0, $4039f667230e34b4$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $07db85ecb8c92152$export$810b04175080204c).test(v)) return (0, $07db85ecb8c92152$export$810b04175080204c).parse(v);
        else return (0, $ea0a4b0f3ce621e6$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return (0, $b8f42e16a7301bfc$export$844ec244b1367d54)(v) ? v : v.hasOwnProperty("red") ? (0, $4039f667230e34b4$export$4e46ac54fc82cf3b).transform(v) : (0, $07db85ecb8c92152$export$810b04175080204c).transform(v);
    }
};



/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $3c2585c246339658$export$2c9e8a9632a706b2 = (from, to, progress)=>-progress * from + progress * to + from;




// Adapted from https://gist.github.com/mjackson/5311256
function $093cd0f34aac324b$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $093cd0f34aac324b$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $093cd0f34aac324b$var$hueToRgb(p, q, hue + 1 / 3);
        green = $093cd0f34aac324b$var$hueToRgb(p, q, hue);
        blue = $093cd0f34aac324b$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}





// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $d9bd61dfd3ef798b$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    return Math.sqrt(Math.max(0, v * (to * to - fromExpo) + fromExpo));
};
const $d9bd61dfd3ef798b$var$colorTypes = [
    (0, $ea0a4b0f3ce621e6$export$834dfc94dde4b3d8),
    (0, $4039f667230e34b4$export$4e46ac54fc82cf3b),
    (0, $07db85ecb8c92152$export$810b04175080204c)
];
const $d9bd61dfd3ef798b$var$getColorType = (v)=>$d9bd61dfd3ef798b$var$colorTypes.find((type)=>type.test(v));
function $d9bd61dfd3ef798b$var$asRGBA(color) {
    const type = $d9bd61dfd3ef798b$var$getColorType(color);
    (0, $fbd148e25c0bf485$export$f5708dca728d7177)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    let model = type.parse(color);
    if (type === (0, $07db85ecb8c92152$export$810b04175080204c)) // TODO Remove this cast - needed since Framer Motion's stricter typing
    model = (0, $093cd0f34aac324b$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $d9bd61dfd3ef798b$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $d9bd61dfd3ef798b$var$asRGBA(from);
    const toRGBA = $d9bd61dfd3ef798b$var$asRGBA(to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $d9bd61dfd3ef798b$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $d9bd61dfd3ef798b$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $d9bd61dfd3ef798b$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $3c2585c246339658$export$2c9e8a9632a706b2)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $4039f667230e34b4$export$4e46ac54fc82cf3b).transform(blended);
    };
};




/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $9b86ca7b055144d9$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $9b86ca7b055144d9$export$a4627e546088548d = (...transformers)=>transformers.reduce($9b86ca7b055144d9$var$combineFunctions);




const $73c98c223690e4bb$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $73c98c223690e4bb$export$9de1236619d9e756 = $73c98c223690e4bb$var$checkStringStartsWith("--");
const $73c98c223690e4bb$export$31f9caa2600b5723 = $73c98c223690e4bb$var$checkStringStartsWith("var(--");
const $73c98c223690e4bb$export$f7c0a352d8ef6313 = /var\s*\(\s*--[\w-]+(\s*,\s*(?:(?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)+)?\s*\)/g;






function $360d13d13cedb73d$var$test(v) {
    var _a, _b;
    return isNaN(v) && (0, $b8f42e16a7301bfc$export$844ec244b1367d54)(v) && (((_a = v.match((0, $b8f42e16a7301bfc$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $b8f42e16a7301bfc$export$740b69c5fad25dba))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const $360d13d13cedb73d$var$cssVarTokeniser = {
    regex: (0, $73c98c223690e4bb$export$f7c0a352d8ef6313),
    countKey: "Vars",
    token: "${v}",
    parse: (0, $d2cbe6f410c6408c$export$8793edee2d425525)
};
const $360d13d13cedb73d$var$colorTokeniser = {
    regex: (0, $b8f42e16a7301bfc$export$740b69c5fad25dba),
    countKey: "Colors",
    token: "${c}",
    parse: (0, $7e3911c57baed9d4$export$35e9368ef982300f).parse
};
const $360d13d13cedb73d$var$numberTokeniser = {
    regex: (0, $b8f42e16a7301bfc$export$2444ca58c08448e4),
    countKey: "Numbers",
    token: "${n}",
    parse: (0, $fd5699cd861e5b4f$export$98e628dec113755e).parse
};
function $360d13d13cedb73d$var$tokenise(info, { regex: regex, countKey: countKey, token: token, parse: parse }) {
    const matches = info.tokenised.match(regex);
    if (!matches) return;
    info["num" + countKey] = matches.length;
    info.tokenised = info.tokenised.replace(regex, token);
    info.values.push(...matches.map(parse));
}
function $360d13d13cedb73d$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const info = {
        value: originalValue,
        tokenised: originalValue,
        values: [],
        numVars: 0,
        numColors: 0,
        numNumbers: 0
    };
    if (info.value.includes("var(--")) $360d13d13cedb73d$var$tokenise(info, $360d13d13cedb73d$var$cssVarTokeniser);
    $360d13d13cedb73d$var$tokenise(info, $360d13d13cedb73d$var$colorTokeniser);
    $360d13d13cedb73d$var$tokenise(info, $360d13d13cedb73d$var$numberTokeniser);
    return info;
}
function $360d13d13cedb73d$var$parseComplexValue(v) {
    return $360d13d13cedb73d$export$b61fc7c44bf646d5(v).values;
}
function $360d13d13cedb73d$var$createTransformer(source) {
    const { values: values, numColors: numColors, numVars: numVars, tokenised: tokenised } = $360d13d13cedb73d$export$b61fc7c44bf646d5(source);
    const numValues = values.length;
    return (v)=>{
        let output = tokenised;
        for(let i = 0; i < numValues; i++){
            if (i < numVars) output = output.replace($360d13d13cedb73d$var$cssVarTokeniser.token, v[i]);
            else if (i < numVars + numColors) output = output.replace($360d13d13cedb73d$var$colorTokeniser.token, (0, $7e3911c57baed9d4$export$35e9368ef982300f).transform(v[i]));
            else output = output.replace($360d13d13cedb73d$var$numberTokeniser.token, (0, $b8f42e16a7301bfc$export$83d2e9e3e4ee39ed)(v[i]));
        }
        return output;
    };
}
const $360d13d13cedb73d$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $360d13d13cedb73d$var$getAnimatableNone(v) {
    const parsed = $360d13d13cedb73d$var$parseComplexValue(v);
    const transformer = $360d13d13cedb73d$var$createTransformer(v);
    return transformer(parsed.map($360d13d13cedb73d$var$convertNumbersToZero));
}
const $360d13d13cedb73d$export$83a0e34f1302825b = {
    test: $360d13d13cedb73d$var$test,
    parse: $360d13d13cedb73d$var$parseComplexValue,
    createTransformer: $360d13d13cedb73d$var$createTransformer,
    getAnimatableNone: $360d13d13cedb73d$var$getAnimatableNone
};


const $7999f412bc0ba6c2$var$mixImmediate = (origin, target)=>(p)=>`${p > 0 ? target : origin}`;
function $7999f412bc0ba6c2$var$getMixer(origin, target) {
    if (typeof origin === "number") return (v)=>(0, $3c2585c246339658$export$2c9e8a9632a706b2)(origin, target, v);
    else if ((0, $7e3911c57baed9d4$export$35e9368ef982300f).test(origin)) return (0, $d9bd61dfd3ef798b$export$51e568cf5c039bac)(origin, target);
    else return origin.startsWith("var(") ? $7999f412bc0ba6c2$var$mixImmediate(origin, target) : $7999f412bc0ba6c2$export$65516310a87d8205(origin, target);
}
const $7999f412bc0ba6c2$export$3bbefa2f402845c4 = (from, to)=>{
    const output = [
        ...from
    ];
    const numValues = output.length;
    const blendValue = from.map((fromThis, i)=>$7999f412bc0ba6c2$var$getMixer(fromThis, to[i]));
    return (v)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](v);
        return output;
    };
};
const $7999f412bc0ba6c2$export$ebc23b6840c51ba1 = (origin, target)=>{
    const output = {
        ...origin,
        ...target
    };
    const blendValue = {};
    for(const key in output)if (origin[key] !== undefined && target[key] !== undefined) blendValue[key] = $7999f412bc0ba6c2$var$getMixer(origin[key], target[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
};
const $7999f412bc0ba6c2$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $360d13d13cedb73d$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $360d13d13cedb73d$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $360d13d13cedb73d$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.numVars === targetStats.numVars && originStats.numColors === targetStats.numColors && originStats.numNumbers >= targetStats.numNumbers;
    if (canInterpolate) return (0, $9b86ca7b055144d9$export$a4627e546088548d)($7999f412bc0ba6c2$export$3bbefa2f402845c4(originStats.values, targetStats.values), template);
    else {
        (0, $fbd148e25c0bf485$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return $7999f412bc0ba6c2$var$mixImmediate(origin, target);
    }
};



/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ const $469d01f875f55ac1$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};



const $a936a1c0990c6718$var$mixNumber = (from, to)=>(p)=>(0, $3c2585c246339658$export$2c9e8a9632a706b2)(from, to, p);
function $a936a1c0990c6718$var$detectMixerFactory(v) {
    if (typeof v === "number") return $a936a1c0990c6718$var$mixNumber;
    else if (typeof v === "string") return (0, $7e3911c57baed9d4$export$35e9368ef982300f).test(v) ? (0, $d9bd61dfd3ef798b$export$51e568cf5c039bac) : (0, $7999f412bc0ba6c2$export$65516310a87d8205);
    else if (Array.isArray(v)) return 0, $7999f412bc0ba6c2$export$3bbefa2f402845c4;
    else if (typeof v === "object") return 0, $7999f412bc0ba6c2$export$ebc23b6840c51ba1;
    return $a936a1c0990c6718$var$mixNumber;
}
function $a936a1c0990c6718$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || $a936a1c0990c6718$var$detectMixerFactory(output[0]);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $d2cbe6f410c6408c$export$8793edee2d425525) : ease;
            mixer = (0, $9b86ca7b055144d9$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $a936a1c0990c6718$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $fbd148e25c0bf485$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $a936a1c0990c6718$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $469d01f875f55ac1$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $414e910502dfd816$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $ec000638a9f71902$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $469d01f875f55ac1$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $3c2585c246339658$export$2c9e8a9632a706b2)(min, 1, offsetProgress));
    }
}


function $bce7ae17b4555960$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $ec000638a9f71902$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $37bc1bae12cdc84a$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $c147de51e5ae8108$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $5b444935dec43798$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $c147de51e5ae8108$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $5d0a11a28f7b03d5$export$216948827bbdc797)(ease) ? ease.map((0, $ddf9a6de7db7bd34$export$ef97fe084f156ca4)) : (0, $ddf9a6de7db7bd34$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $37bc1bae12cdc84a$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $bce7ae17b4555960$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $a936a1c0990c6718$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $c147de51e5ae8108$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}



/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $03738ca307c85ea0$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}


const $921e83a607a6d826$var$velocitySampleDuration = 5; // ms
function $921e83a607a6d826$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $921e83a607a6d826$var$velocitySampleDuration, 0);
    return (0, $03738ca307c85ea0$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}





const $29b80bacca68b778$var$safeMin = 0.001;
const $29b80bacca68b778$export$a3cdb76e84ee608e = 0.01;
const $29b80bacca68b778$export$1824b851fad8862b = 10.0;
const $29b80bacca68b778$export$ff08f2d53484465 = 0.05;
const $29b80bacca68b778$export$201ca48e54038115 = 1;
function $29b80bacca68b778$export$b15f158dc6d6f458({ duration: duration = 800, bounce: bounce = 0.25, velocity: velocity = 0, mass: mass = 1 }) {
    let envelope;
    let derivative;
    (0, $fbd148e25c0bf485$export$491112666e282270)(duration <= (0, $163563b2e4726aac$export$fc3e7e8557f8c8c7)($29b80bacca68b778$export$1824b851fad8862b), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $414e910502dfd816$export$7d15b64cf5a3a4c4)($29b80bacca68b778$export$ff08f2d53484465, $29b80bacca68b778$export$201ca48e54038115, dampingRatio);
    duration = (0, $414e910502dfd816$export$7d15b64cf5a3a4c4)($29b80bacca68b778$export$a3cdb76e84ee608e, $29b80bacca68b778$export$1824b851fad8862b, (0, $163563b2e4726aac$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $29b80bacca68b778$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $29b80bacca68b778$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $29b80bacca68b778$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $29b80bacca68b778$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$29b80bacca68b778$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $29b80bacca68b778$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $163563b2e4726aac$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $29b80bacca68b778$var$rootIterations = 12;
function $29b80bacca68b778$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $29b80bacca68b778$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $29b80bacca68b778$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


const $ecc45c1e9bba2f42$var$durationKeys = [
    "duration",
    "bounce"
];
const $ecc45c1e9bba2f42$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $ecc45c1e9bba2f42$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $ecc45c1e9bba2f42$var$getSpringOptions(options) {
    let springOptions = {
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$ecc45c1e9bba2f42$var$isSpringType(options, $ecc45c1e9bba2f42$var$physicsKeys) && $ecc45c1e9bba2f42$var$isSpringType(options, $ecc45c1e9bba2f42$var$durationKeys)) {
        const derived = (0, $29b80bacca68b778$export$b15f158dc6d6f458)(options);
        springOptions = {
            ...springOptions,
            ...derived,
            velocity: 0.0,
            mass: 1.0
        };
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $ecc45c1e9bba2f42$export$b36281d89752ae66({ keyframes: keyframes, restDelta: restDelta, restSpeed: restSpeed, ...options }) {
    const origin = keyframes[0];
    const target = keyframes[keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, velocity: velocity, duration: duration, isResolvedFromDuration: isResolvedFromDuration } = $ecc45c1e9bba2f42$var$getSpringOptions(options);
    const initialVelocity = velocity ? -(0, $163563b2e4726aac$export$f64c3bfbc58eec0f)(velocity) : 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $163563b2e4726aac$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? 0.01 : 2);
    restDelta || (restDelta = isGranularScale ? 0.005 : 0.5);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $29b80bacca68b778$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    return {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = initialVelocity;
                if (t !== 0) {
                    /**
                     * We only need to calculate velocity for under-damped springs
                     * as over- and critically-damped springs can't overshoot, so
                     * checking only for displacement is enough.
                     */ if (dampingRatio < 1) currentVelocity = (0, $921e83a607a6d826$export$854187271d233eb5)(resolveSpring, t, current);
                    else currentVelocity = 0;
                }
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        }
    };
}




function $bfca543974c90c66$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $ecc45c1e9bba2f42$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $921e83a607a6d826$export$854187271d233eb5)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t > timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



const $e8f50fb36392647f$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: ()=>(0, $20659c72a41d0fd3$export$2cef06c20297c17d).update(passTimestamp, true),
        stop: ()=>(0, $20659c72a41d0fd3$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $20659c72a41d0fd3$export$fff89137e9e818ce).isProcessing ? (0, $20659c72a41d0fd3$export$fff89137e9e818ce).timestamp : performance.now()
    };
};





/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $26a49ae99b6cd05e$export$f4ff70a5b4808fd8 = 20000;
function $26a49ae99b6cd05e$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $26a49ae99b6cd05e$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $26a49ae99b6cd05e$export$f4ff70a5b4808fd8 ? Infinity : duration;
}


const $fb4fa96c44fce3e3$var$types = {
    decay: (0, $bfca543974c90c66$export$ee3ff3a17106998),
    inertia: $bfca543974c90c66$export$ee3ff3a17106998,
    tween: (0, $c147de51e5ae8108$export$d25ddfdf17c3ad3e),
    keyframes: (0, $c147de51e5ae8108$export$d25ddfdf17c3ad3e),
    spring: $ecc45c1e9bba2f42$export$b36281d89752ae66
};
/**
 * Animate a single value on the main thread.
 *
 * This function is written, where functionality overlaps,
 * to be largely spec-compliant with WAAPI to allow fungibility
 * between the two.
 */ function $fb4fa96c44fce3e3$export$ee9b76de7353d815({ autoplay: autoplay = true, delay: delay = 0, driver: driver = (0, $e8f50fb36392647f$export$c1033964b5ad7fef), keyframes: keyframes$1, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", onPlay: onPlay, onStop: onStop, onComplete: onComplete, onUpdate: onUpdate, ...options }) {
    let speed = 1;
    let hasStopped = false;
    let resolveFinishedPromise;
    let currentFinishedPromise;
    /**
     * Resolve the current Promise every time we enter the
     * finished state. This is WAAPI-compatible behaviour.
     */ const updateFinishedPromise = ()=>{
        currentFinishedPromise = new Promise((resolve)=>{
            resolveFinishedPromise = resolve;
        });
    };
    // Create the first finished promise
    updateFinishedPromise();
    let animationDriver;
    const generatorFactory = $fb4fa96c44fce3e3$var$types[type] || (0, $c147de51e5ae8108$export$d25ddfdf17c3ad3e);
    /**
     * If this isn't the keyframes generator and we've been provided
     * strings as keyframes, we need to interpolate these.
     * TODO: Support velocity for units and complex value types/
     */ let mapNumbersToKeyframes;
    if (generatorFactory !== (0, $c147de51e5ae8108$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
        mapNumbersToKeyframes = (0, $a936a1c0990c6718$export$89e29e4ab65e70a9)([
            0,
            100
        ], keyframes$1, {
            clamp: false
        });
        keyframes$1 = [
            0,
            100
        ];
    }
    const generator = generatorFactory({
        ...options,
        keyframes: keyframes$1
    });
    let mirroredGenerator;
    if (repeatType === "mirror") mirroredGenerator = generatorFactory({
        ...options,
        keyframes: [
            ...keyframes$1
        ].reverse(),
        velocity: -(options.velocity || 0)
    });
    let playState = "idle";
    let holdTime = null;
    let startTime = null;
    let cancelTime = null;
    /**
     * If duration is undefined and we have repeat options,
     * we need to calculate a duration from the generator.
     *
     * We set it to the generator itself to cache the duration.
     * Any timeline resolver will need to have already precalculated
     * the duration by this step.
     */ if (generator.calculatedDuration === null && repeat) generator.calculatedDuration = (0, $26a49ae99b6cd05e$export$cbdd6b3d40ea54e2)(generator);
    const { calculatedDuration: calculatedDuration } = generator;
    let resolvedDuration = Infinity;
    let totalDuration = Infinity;
    if (calculatedDuration !== null) {
        resolvedDuration = calculatedDuration + repeatDelay;
        totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
    }
    let currentTime = 0;
    const tick = (timestamp)=>{
        if (startTime === null) return;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (speed > 0) startTime = Math.min(startTime, timestamp);
        if (speed < 0) startTime = Math.min(timestamp - totalDuration / speed, startTime);
        if (holdTime !== null) currentTime = holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        currentTime = Math.round(timestamp - startTime) * speed;
        // Rebase on delay
        const timeWithoutDelay = currentTime - delay * (speed >= 0 ? 1 : -1);
        const isInDelayPhase = speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        currentTime = Math.max(timeWithoutDelay, 0);
        /**
         * If this animation has finished, set the current time
         * to the total duration.
         */ if (playState === "finished" && holdTime === null) currentTime = totalDuration;
        let elapsed = currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = currentTime / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const iterationIsOdd = Boolean(currentIteration % 2);
            if (iterationIsOdd) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            let p = (0, $414e910502dfd816$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress);
            if (currentTime > totalDuration) p = repeatType === "reverse" && iterationIsOdd ? 1 : 0;
            elapsed = p * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes$1[0]
        } : frameGenerator.next(elapsed);
        if (mapNumbersToKeyframes) state.value = mapNumbersToKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = speed >= 0 ? currentTime >= totalDuration : currentTime <= 0;
        const isAnimationFinished = holdTime === null && (playState === "finished" || playState === "running" && done);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) finish();
        return state;
    };
    const stopAnimationDriver = ()=>{
        animationDriver && animationDriver.stop();
        animationDriver = undefined;
    };
    const cancel = ()=>{
        playState = "idle";
        stopAnimationDriver();
        resolveFinishedPromise();
        updateFinishedPromise();
        startTime = cancelTime = null;
    };
    const finish = ()=>{
        playState = "finished";
        onComplete && onComplete();
        stopAnimationDriver();
        resolveFinishedPromise();
    };
    const play = ()=>{
        if (hasStopped) return;
        if (!animationDriver) animationDriver = driver(tick);
        const now = animationDriver.now();
        onPlay && onPlay();
        if (holdTime !== null) startTime = now - holdTime;
        else if (!startTime || playState === "finished") startTime = now;
        if (playState === "finished") updateFinishedPromise();
        cancelTime = startTime;
        holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ playState = "running";
        animationDriver.start();
    };
    if (autoplay) play();
    const controls = {
        then (resolve, reject) {
            return currentFinishedPromise.then(resolve, reject);
        },
        get time () {
            return (0, $163563b2e4726aac$export$f64c3bfbc58eec0f)(currentTime);
        },
        set time (newTime){
            newTime = (0, $163563b2e4726aac$export$fc3e7e8557f8c8c7)(newTime);
            currentTime = newTime;
            if (holdTime !== null || !animationDriver || speed === 0) holdTime = newTime;
            else startTime = animationDriver.now() - newTime / speed;
        },
        get duration () {
            const duration = generator.calculatedDuration === null ? (0, $26a49ae99b6cd05e$export$cbdd6b3d40ea54e2)(generator) : generator.calculatedDuration;
            return (0, $163563b2e4726aac$export$f64c3bfbc58eec0f)(duration);
        },
        get speed () {
            return speed;
        },
        set speed (newSpeed){
            if (newSpeed === speed || !animationDriver) return;
            speed = newSpeed;
            controls.time = (0, $163563b2e4726aac$export$f64c3bfbc58eec0f)(currentTime);
        },
        get state () {
            return playState;
        },
        play: play,
        pause: ()=>{
            playState = "paused";
            holdTime = currentTime;
        },
        stop: ()=>{
            hasStopped = true;
            if (playState === "idle") return;
            playState = "idle";
            onStop && onStop();
            cancel();
        },
        cancel: ()=>{
            if (cancelTime !== null) tick(cancelTime);
            cancel();
        },
        complete: ()=>{
            playState = "finished";
        },
        sample: (elapsed)=>{
            startTime = 0;
            return tick(elapsed);
        }
    };
    return controls;
}






const $376a15009913b253$var$supportsWaapi = (0, $b2d487df80d1c202$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
/**
 * A list of values that can be hardware-accelerated.
 */ const $376a15009913b253$var$acceleratedValues = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform",
    "backgroundColor"
]);
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $376a15009913b253$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $376a15009913b253$var$maxDuration = 20000;
const $376a15009913b253$var$requiresPregeneratedKeyframes = (valueName, options)=>options.type === "spring" || valueName === "backgroundColor" || !(0, $4620152b4e6bd4de$export$fcdd8f3f2160beda)(options.ease);
function $376a15009913b253$export$4d5d9557ab897126(value, valueName, { onUpdate: onUpdate, onComplete: onComplete, ...options }) {
    const canAccelerateAnimation = $376a15009913b253$var$supportsWaapi() && $376a15009913b253$var$acceleratedValues.has(valueName) && !options.repeatDelay && options.repeatType !== "mirror" && options.damping !== 0 && options.type !== "inertia";
    if (!canAccelerateAnimation) return false;
    /**
     * TODO: Unify with js/index
     */ let hasStopped = false;
    let resolveFinishedPromise;
    let currentFinishedPromise;
    /**
     * Resolve the current Promise every time we enter the
     * finished state. This is WAAPI-compatible behaviour.
     */ const updateFinishedPromise = ()=>{
        currentFinishedPromise = new Promise((resolve)=>{
            resolveFinishedPromise = resolve;
        });
    };
    // Create the first finished promise
    updateFinishedPromise();
    let { keyframes: keyframes, duration: duration = 300, ease: ease, times: times } = options;
    /**
     * If this animation needs pre-generated keyframes then generate.
     */ if ($376a15009913b253$var$requiresPregeneratedKeyframes(valueName, options)) {
        const sampleAnimation = (0, $fb4fa96c44fce3e3$export$ee9b76de7353d815)({
            ...options,
            repeat: 0,
            delay: 0
        });
        let state = {
            done: false,
            value: keyframes[0]
        };
        const pregeneratedKeyframes = [];
        /**
         * Bail after 20 seconds of pre-generated keyframes as it's likely
         * we're heading for an infinite loop.
         */ let t = 0;
        while(!state.done && t < $376a15009913b253$var$maxDuration){
            state = sampleAnimation.sample(t);
            pregeneratedKeyframes.push(state.value);
            t += $376a15009913b253$var$sampleDelta;
        }
        times = undefined;
        keyframes = pregeneratedKeyframes;
        duration = t - $376a15009913b253$var$sampleDelta;
        ease = "linear";
    }
    const animation = (0, $a6655e578d93a7dd$export$c76cd972d26986f9)(value.owner.current, valueName, keyframes, {
        ...options,
        duration: duration,
        /**
         * This function is currently not called if ease is provided
         * as a function so the cast is safe.
         *
         * However it would be possible for a future refinement to port
         * in easing pregeneration from Motion One for browsers that
         * support the upcoming `linear()` easing function.
         */ ease: ease,
        times: times
    });
    /**
     * WAAPI animations don't resolve startTime synchronously. But a blocked
     * thread could delay the startTime resolution by a noticeable amount.
     * For synching handoff animations with the new Motion animation we want
     * to ensure startTime is synchronously set.
     */ if (options.syncStart) animation.startTime = (0, $20659c72a41d0fd3$export$fff89137e9e818ce).isProcessing ? (0, $20659c72a41d0fd3$export$fff89137e9e818ce).timestamp : document.timeline ? document.timeline.currentTime : performance.now();
    const cancelAnimation = ()=>animation.cancel();
    const safeCancel = ()=>{
        (0, $20659c72a41d0fd3$export$2cef06c20297c17d).update(cancelAnimation);
        resolveFinishedPromise();
        updateFinishedPromise();
    };
    /**
     * Prefer the `onfinish` prop as it's more widely supported than
     * the `finished` promise.
     *
     * Here, we synchronously set the provided MotionValue to the end
     * keyframe. If we didn't, when the WAAPI animation is finished it would
     * be removed from the element which would then revert to its old styles.
     */ animation.onfinish = ()=>{
        value.set((0, $374c55a95772583b$export$14de59408fad90b)(keyframes, options));
        onComplete && onComplete();
        safeCancel();
    };
    /**
     * Animation interrupt callback.
     */ const controls = {
        then (resolve, reject) {
            return currentFinishedPromise.then(resolve, reject);
        },
        attachTimeline (timeline) {
            animation.timeline = timeline;
            animation.onfinish = null;
            return 0, $d2cbe6f410c6408c$export$8793edee2d425525;
        },
        get time () {
            return (0, $163563b2e4726aac$export$f64c3bfbc58eec0f)(animation.currentTime || 0);
        },
        set time (newTime){
            animation.currentTime = (0, $163563b2e4726aac$export$fc3e7e8557f8c8c7)(newTime);
        },
        get speed () {
            return animation.playbackRate;
        },
        set speed (newSpeed){
            animation.playbackRate = newSpeed;
        },
        get duration () {
            return (0, $163563b2e4726aac$export$f64c3bfbc58eec0f)(duration);
        },
        play: ()=>{
            if (hasStopped) return;
            animation.play();
            /**
             * Cancel any pending cancel tasks
             */ (0, $20659c72a41d0fd3$export$ec99c0ef4978dccb)(cancelAnimation);
        },
        pause: ()=>animation.pause(),
        stop: ()=>{
            hasStopped = true;
            if (animation.playState === "idle") return;
            /**
             * WAAPI doesn't natively have any interruption capabilities.
             *
             * Rather than read commited styles back out of the DOM, we can
             * create a renderless JS animation and sample it twice to calculate
             * its current value, "previous" value, and therefore allow
             * Motion to calculate velocity for any subsequent animation.
             */ const { currentTime: currentTime } = animation;
            if (currentTime) {
                const sampleAnimation = (0, $fb4fa96c44fce3e3$export$ee9b76de7353d815)({
                    ...options,
                    autoplay: false
                });
                value.setWithVelocity(sampleAnimation.sample(currentTime - $376a15009913b253$var$sampleDelta).value, sampleAnimation.sample(currentTime).value, $376a15009913b253$var$sampleDelta);
            }
            safeCancel();
        },
        complete: ()=>animation.finish(),
        cancel: safeCancel
    };
    return controls;
}




function $845ac079a0dfc6d2$export$6f34fc8ef6c42b70({ keyframes: keyframes, delay: delay, onUpdate: onUpdate, onComplete: onComplete }) {
    const setValue = ()=>{
        onUpdate && onUpdate(keyframes[keyframes.length - 1]);
        onComplete && onComplete();
        /**
         * TODO: As this API grows it could make sense to always return
         * animateValue. This will be a bigger project as animateValue
         * is frame-locked whereas this function resolves instantly.
         * This is a behavioural change and also has ramifications regarding
         * assumptions within tests.
         */ return {
            time: 0,
            speed: 1,
            duration: 0,
            play: (0, $d2cbe6f410c6408c$export$8793edee2d425525),
            pause: (0, $d2cbe6f410c6408c$export$8793edee2d425525),
            stop: (0, $d2cbe6f410c6408c$export$8793edee2d425525),
            then: (resolve)=>{
                resolve();
                return Promise.resolve();
            },
            cancel: (0, $d2cbe6f410c6408c$export$8793edee2d425525),
            complete: (0, $d2cbe6f410c6408c$export$8793edee2d425525)
        };
    };
    return delay ? (0, $fb4fa96c44fce3e3$export$ee9b76de7353d815)({
        keyframes: [
            0,
            1
        ],
        duration: 0,
        delay: delay,
        onComplete: setValue
    }) : setValue();
}



const $4d8aa5a3fc7e49a4$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $4d8aa5a3fc7e49a4$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $4d8aa5a3fc7e49a4$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $4d8aa5a3fc7e49a4$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $4d8aa5a3fc7e49a4$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $4d8aa5a3fc7e49a4$var$keyframesTransition;
    else if ((0, $b519ba7cf8f7f57e$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $4d8aa5a3fc7e49a4$var$criticallyDampedSpring(keyframes[1]) : $4d8aa5a3fc7e49a4$var$underDampedSpring;
    return $4d8aa5a3fc7e49a4$var$ease;
};



/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $b6bdd997a09811cc$export$65676b58b122bc38 = (key, value)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (key === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $360d13d13cedb73d$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};





/**
 * Properties that should default to 1 or 100%
 */ const $ecf1cf8a97c9e030$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $ecf1cf8a97c9e030$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $b8f42e16a7301bfc$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $ecf1cf8a97c9e030$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $ecf1cf8a97c9e030$var$functionRegex = /([a-z-]*)\(.*?\)/g;
const $ecf1cf8a97c9e030$export$3dea766d36a8935f = {
    ...(0, $360d13d13cedb73d$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($ecf1cf8a97c9e030$var$functionRegex);
        return functions ? functions.map($ecf1cf8a97c9e030$var$applyDefaultFilter).join(" ") : v;
    }
};







const $e470dee1c930d24f$export$7d260a2a5f8bc19e = {
    ...(0, $fd5699cd861e5b4f$export$98e628dec113755e),
    transform: Math.round
};


const $f04fc9abc28b2900$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    borderTopWidth: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    borderRightWidth: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    borderRadius: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    radius: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    maxWidth: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    height: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    maxHeight: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    size: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    top: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    right: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    bottom: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    left: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    paddingTop: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    paddingRight: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    paddingBottom: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    paddingLeft: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    margin: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    marginTop: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    marginRight: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    marginBottom: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    marginLeft: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    // Transform props
    rotate: (0, $8f6e75453fcb14be$export$41fc368e1a942b97),
    rotateX: (0, $8f6e75453fcb14be$export$41fc368e1a942b97),
    rotateY: (0, $8f6e75453fcb14be$export$41fc368e1a942b97),
    rotateZ: (0, $8f6e75453fcb14be$export$41fc368e1a942b97),
    scale: $fd5699cd861e5b4f$export$dcdf75081b88279d,
    scaleX: (0, $fd5699cd861e5b4f$export$dcdf75081b88279d),
    scaleY: (0, $fd5699cd861e5b4f$export$dcdf75081b88279d),
    scaleZ: (0, $fd5699cd861e5b4f$export$dcdf75081b88279d),
    skew: (0, $8f6e75453fcb14be$export$41fc368e1a942b97),
    skewX: (0, $8f6e75453fcb14be$export$41fc368e1a942b97),
    skewY: (0, $8f6e75453fcb14be$export$41fc368e1a942b97),
    distance: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    translateX: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    translateY: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    translateZ: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    x: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    y: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    z: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    perspective: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    transformPerspective: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    opacity: (0, $fd5699cd861e5b4f$export$58f0f39f63f3cf42),
    originX: (0, $8f6e75453fcb14be$export$44e2e1705876d7ed),
    originY: (0, $8f6e75453fcb14be$export$44e2e1705876d7ed),
    originZ: (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    // Misc
    zIndex: (0, $e470dee1c930d24f$export$7d260a2a5f8bc19e),
    // SVG
    fillOpacity: (0, $fd5699cd861e5b4f$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $fd5699cd861e5b4f$export$58f0f39f63f3cf42),
    numOctaves: (0, $e470dee1c930d24f$export$7d260a2a5f8bc19e)
};


/**
 * A map of default value types for common values
 */ const $95dcdbcf808a93e0$export$98cd7c72c5a731fb = {
    ...(0, $f04fc9abc28b2900$export$eec14432cd1cb67b),
    color: // Color props
    $7e3911c57baed9d4$export$35e9368ef982300f,
    backgroundColor: (0, $7e3911c57baed9d4$export$35e9368ef982300f),
    outlineColor: (0, $7e3911c57baed9d4$export$35e9368ef982300f),
    fill: (0, $7e3911c57baed9d4$export$35e9368ef982300f),
    stroke: (0, $7e3911c57baed9d4$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $7e3911c57baed9d4$export$35e9368ef982300f),
    borderTopColor: (0, $7e3911c57baed9d4$export$35e9368ef982300f),
    borderRightColor: (0, $7e3911c57baed9d4$export$35e9368ef982300f),
    borderBottomColor: (0, $7e3911c57baed9d4$export$35e9368ef982300f),
    borderLeftColor: (0, $7e3911c57baed9d4$export$35e9368ef982300f),
    filter: $ecf1cf8a97c9e030$export$3dea766d36a8935f,
    WebkitFilter: (0, $ecf1cf8a97c9e030$export$3dea766d36a8935f)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $95dcdbcf808a93e0$export$67d1babe0338d23b = (key)=>$95dcdbcf808a93e0$export$98cd7c72c5a731fb[key];


function $ac38c2c5735e56ab$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $95dcdbcf808a93e0$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $ecf1cf8a97c9e030$export$3dea766d36a8935f)) defaultValueType = (0, $360d13d13cedb73d$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}



/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $4a1c67cbc6b618a4$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/.test(v);


function $6997dabb1bfd0663$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $4a1c67cbc6b618a4$export$ade84c85e44a6cb1)(value);
}


function $4394774b80f6fc52$export$b2b5e866b2fbf2ec(value, valueName, target, transition) {
    const isTargetAnimatable = (0, $b6bdd997a09811cc$export$65676b58b122bc38)(valueName, target);
    let keyframes;
    if (Array.isArray(target)) keyframes = [
        ...target
    ];
    else keyframes = [
        null,
        target
    ];
    const defaultOrigin = transition.from !== undefined ? transition.from : value.get();
    let animatableTemplateValue = undefined;
    const noneKeyframeIndexes = [];
    for(let i = 0; i < keyframes.length; i++){
        /**
         * Fill null/wildcard keyframes
         */ if (keyframes[i] === null) keyframes[i] = i === 0 ? defaultOrigin : keyframes[i - 1];
        if ((0, $6997dabb1bfd0663$export$e56af863d5645d5f)(keyframes[i])) noneKeyframeIndexes.push(i);
        // TODO: Clean this conditional, it works for now
        if (typeof keyframes[i] === "string" && keyframes[i] !== "none" && keyframes[i] !== "0") animatableTemplateValue = keyframes[i];
    }
    if (isTargetAnimatable && noneKeyframeIndexes.length && animatableTemplateValue) for(let i = 0; i < noneKeyframeIndexes.length; i++){
        const index = noneKeyframeIndexes[i];
        keyframes[index] = (0, $ac38c2c5735e56ab$export$cea0cedcb94873b5)(valueName, animatableTemplateValue);
    }
    return keyframes;
}


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $31f04eafa7e4a990$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}
function $31f04eafa7e4a990$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}



const $bf3452c0059f751b$export$90b3dfc33ff3548 = (valueName, value, target, transition = {})=>{
    return (onComplete)=>{
        const valueTransition = (0, $31f04eafa7e4a990$export$7c1391340308742e)(transition, valueName) || {};
        /**
         * Most transition values are currently completely overwritten by value-specific
         * transitions. In the future it'd be nicer to blend these transitions. But for now
         * delay actually does inherit from the root transition if not value-specific.
         */ const delay = valueTransition.delay || transition.delay || 0;
        /**
         * Elapsed isn't a public transition option but can be passed through from
         * optimized appear effects in milliseconds.
         */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $163563b2e4726aac$export$fc3e7e8557f8c8c7)(delay);
        const keyframes = (0, $4394774b80f6fc52$export$b2b5e866b2fbf2ec)(value, valueName, target, valueTransition);
        /**
         * Check if we're able to animate between the start and end keyframes,
         * and throw a warning if we're attempting to animate between one that's
         * animatable and another that isn't.
         */ const originKeyframe = keyframes[0];
        const targetKeyframe = keyframes[keyframes.length - 1];
        const isOriginAnimatable = (0, $b6bdd997a09811cc$export$65676b58b122bc38)(valueName, originKeyframe);
        const isTargetAnimatable = (0, $b6bdd997a09811cc$export$65676b58b122bc38)(valueName, targetKeyframe);
        (0, $fbd148e25c0bf485$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${valueName} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
        let options = {
            keyframes: keyframes,
            velocity: value.getVelocity(),
            ease: "easeOut",
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            }
        };
        /**
         * If there's no transition defined for this value, we can generate
         * unqiue transition settings for this value.
         */ if (!(0, $31f04eafa7e4a990$export$ca8e47dc8ed5a9d7)(valueTransition)) options = {
            ...options,
            ...(0, $4d8aa5a3fc7e49a4$export$262124b154b9f1c0)(valueName, options)
        };
        /**
         * Both WAAPI and our internal animation functions use durations
         * as defined by milliseconds, while our external API defines them
         * as seconds.
         */ if (options.duration) options.duration = (0, $163563b2e4726aac$export$fc3e7e8557f8c8c7)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $163563b2e4726aac$export$fc3e7e8557f8c8c7)(options.repeatDelay);
        if (!isOriginAnimatable || !isTargetAnimatable || (0, $32dfec56e9ec3613$export$888a3d84909f9e3d).current || valueTransition.type === false) /**
             * If we can't animate this value, or the global instant animation flag is set,
             * or this is simply defined as an instant transition, return an instant transition.
             */ return (0, $845ac079a0dfc6d2$export$6f34fc8ef6c42b70)((0, $32dfec56e9ec3613$export$888a3d84909f9e3d).current ? {
            ...options,
            delay: 0
        } : options);
        /**
         * Animate via WAAPI if possible.
         */ if (value.owner && value.owner.current instanceof HTMLElement && !value.owner.getProps().onUpdate) {
            const acceleratedAnimation = (0, $376a15009913b253$export$4d5d9557ab897126)(value, valueName, options);
            if (acceleratedAnimation) return acceleratedAnimation;
        }
        /**
         * If we didn't create an accelerated animation, create a JS animation
         */ return (0, $fb4fa96c44fce3e3$export$ee9b76de7353d815)(options);
    };
};


const $d887c96505e11420$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);


function $9c62d93f1e0de67c$export$98397f3adbf6259f(value) {
    return Boolean((0, $d887c96505e11420$export$605d60a2578142d3)(value) && value.add);
}


/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $7e20fc44969ab657$export$65583ed5a868f2d9 = (v)=>/^\-?\d*\.?\d+$/.test(v);



const $d2297b5e69cea7ff$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


const $d23d9e8514a3672b$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $d23d9e8514a3672b$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $d2297b5e69cea7ff$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
};


function $1b6150944a1ca569$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $1b6150944a1ca569$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $1b6150944a1ca569$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $fdd378d169697ca0$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $1b6150944a1ca569$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $1b6150944a1ca569$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}





const $8020b4d70ab28198$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $8020b4d70ab28198$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $8020b4d70ab28198$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "10.16.4";
        /**
         * Duration, in milliseconds, since last updating frame.
         *
         * @internal
         */ this.timeDelta = 0;
        /**
         * Timestamp of the last time this `MotionValue` was updated.
         *
         * @internal
         */ this.lastUpdated = 0;
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = false;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            this.prev = this.current;
            this.current = v;
            // Update timestamp
            const { delta: delta, timestamp: timestamp } = (0, $20659c72a41d0fd3$export$fff89137e9e818ce);
            if (this.lastUpdated !== timestamp) {
                this.timeDelta = delta;
                this.lastUpdated = timestamp;
                (0, $20659c72a41d0fd3$export$2cef06c20297c17d).postRender(this.scheduleVelocityCheck);
            }
            // Update update subscribers
            if (this.prev !== this.current && this.events.change) this.events.change.notify(this.current);
            // Update velocity subscribers
            if (this.events.velocityChange) this.events.velocityChange.notify(this.getVelocity());
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        /**
         * Schedule a velocity check for the next frame.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.scheduleVelocityCheck = ()=>(0, $20659c72a41d0fd3$export$2cef06c20297c17d).postRender(this.velocityCheck);
        /**
         * Updates `prev` with `current` if the value hasn't been updated this frame.
         * This ensures velocity calculations return `0`.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.velocityCheck = ({ timestamp: timestamp })=>{
            if (timestamp !== this.lastUpdated) {
                this.prev = this.current;
                if (this.events.velocityChange) this.events.velocityChange.notify(this.getVelocity());
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = $8020b4d70ab28198$var$isFloat(this.current);
        this.owner = options.owner;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $fdd378d169697ca0$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $20659c72a41d0fd3$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = prev;
        this.timeDelta = delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v) {
        this.updateAndNotify(v);
        this.prev = v;
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($8020b4d70ab28198$export$67fcd818a264039d.current) $8020b4d70ab28198$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
        return this.canTrackVelocity ? (0, $03738ca307c85ea0$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $8020b4d70ab28198$export$ce8bdc721e76545f(init, options) {
    return new $8020b4d70ab28198$export$8cea36d14ee64562(init, options);
}








/**
 * Tests a provided value against a ValueType
 */ const $b1a08b02ece3637c$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * ValueType for "auto"
 */ const $66b9ba1596016e0f$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


/**
 * A list of value types commonly used for dimensions
 */ const $40f1a2f8797a857d$export$d176691c1998a1f5 = [
    (0, $fd5699cd861e5b4f$export$98e628dec113755e),
    (0, $8f6e75453fcb14be$export$91c0eda1d06bf008),
    (0, $8f6e75453fcb14be$export$626336c2cd4b14de),
    (0, $8f6e75453fcb14be$export$41fc368e1a942b97),
    (0, $8f6e75453fcb14be$export$aed3d7b7d206c196),
    (0, $8f6e75453fcb14be$export$f91e8c45a95a32f2),
    (0, $66b9ba1596016e0f$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $40f1a2f8797a857d$export$eefdd52e3ccae428 = (v)=>$40f1a2f8797a857d$export$d176691c1998a1f5.find((0, $b1a08b02ece3637c$export$6eae4d0a6a7ca7cd)(v));



/**
 * A list of all ValueTypes
 */ const $f62e75887afbe7af$var$valueTypes = [
    ...(0, $40f1a2f8797a857d$export$d176691c1998a1f5),
    (0, $7e3911c57baed9d4$export$35e9368ef982300f),
    (0, $360d13d13cedb73d$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $f62e75887afbe7af$export$950e7e59ea1ffed7 = (v)=>$f62e75887afbe7af$var$valueTypes.find((0, $b1a08b02ece3637c$export$6eae4d0a6a7ca7cd)(v));


function $a7c2d01870909705$export$d68f140c4d9b48bc(props, definition, custom, currentValues = {}, currentVelocity = {}) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") definition = definition(custom !== undefined ? custom : props.custom, currentValues, currentVelocity);
    return definition;
}


/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */ function $37467b1cfae29b6f$var$getCurrent(visualElement) {
    const current = {};
    visualElement.values.forEach((value, key)=>current[key] = value.get());
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */ function $37467b1cfae29b6f$var$getVelocity(visualElement) {
    const velocity = {};
    visualElement.values.forEach((value, key)=>velocity[key] = value.getVelocity());
    return velocity;
}
function $37467b1cfae29b6f$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $a7c2d01870909705$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, $37467b1cfae29b6f$var$getCurrent(visualElement), $37467b1cfae29b6f$var$getVelocity(visualElement));
}


/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $63626ebc76108468$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $8020b4d70ab28198$export$ce8bdc721e76545f)(value));
}
function $63626ebc76108468$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $37467b1cfae29b6f$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $d23d9e8514a3672b$export$5485128c47bd48bb)(target[key]);
        $63626ebc76108468$var$setMotionValue(visualElement, key, value);
    }
}
function $63626ebc76108468$var$setVariants(visualElement, variantLabels) {
    const reversedLabels = [
        ...variantLabels
    ].reverse();
    reversedLabels.forEach((key)=>{
        const variant = visualElement.getVariant(key);
        variant && $63626ebc76108468$export$1f61c53461aff4a5(visualElement, variant);
        if (visualElement.variantChildren) visualElement.variantChildren.forEach((child)=>{
            $63626ebc76108468$var$setVariants(child, variantLabels);
        });
    });
}
function $63626ebc76108468$export$b7771d60d308862f(visualElement, definition) {
    if (Array.isArray(definition)) return $63626ebc76108468$var$setVariants(visualElement, definition);
    else if (typeof definition === "string") return $63626ebc76108468$var$setVariants(visualElement, [
        definition
    ]);
    else $63626ebc76108468$export$1f61c53461aff4a5(visualElement, definition);
}
function $63626ebc76108468$export$6afbed164019a54c(visualElement, target, origin) {
    var _a, _b;
    const newValueKeys = Object.keys(target).filter((key)=>!visualElement.hasValue(key));
    const numNewValues = newValueKeys.length;
    if (!numNewValues) return;
    for(let i = 0; i < numNewValues; i++){
        const key = newValueKeys[i];
        const targetValue = target[key];
        let value = null;
        /**
         * If the target is a series of keyframes, we can use the first value
         * in the array. If this first value is null, we'll still need to read from the DOM.
         */ if (Array.isArray(targetValue)) value = targetValue[0];
        /**
         * If the target isn't keyframes, or the first keyframe was null, we need to
         * first check if an origin value was explicitly defined in the transition as "from",
         * if not read the value from the DOM. As an absolute fallback, take the defined target value.
         */ if (value === null) value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
        /**
         * If value is still undefined or null, ignore it. Preferably this would throw,
         * but this was causing issues in Framer.
         */ if (value === undefined || value === null) continue;
        if (typeof value === "string" && ((0, $7e20fc44969ab657$export$65583ed5a868f2d9)(value) || (0, $4a1c67cbc6b618a4$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
        value = parseFloat(value);
        else if (!(0, $f62e75887afbe7af$export$950e7e59ea1ffed7)(value) && (0, $360d13d13cedb73d$export$83a0e34f1302825b).test(targetValue)) value = (0, $ac38c2c5735e56ab$export$cea0cedcb94873b5)(key, targetValue);
        visualElement.addValue(key, (0, $8020b4d70ab28198$export$ce8bdc721e76545f)(value, {
            owner: visualElement
        }));
        if (origin[key] === undefined) origin[key] = value;
        if (value !== null) visualElement.setBaseTarget(key, value);
    }
}
function $63626ebc76108468$export$c3befe8e18686628(key, transition) {
    if (!transition) return;
    const valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function $63626ebc76108468$export$5a759dc7a1cfb72a(target, transition, visualElement) {
    const origin = {};
    for(const key in target){
        const transitionOrigin = $63626ebc76108468$export$c3befe8e18686628(key, transition);
        if (transitionOrigin !== undefined) origin[key] = transitionOrigin;
        else {
            const value = visualElement.getValue(key);
            if (value) origin[key] = value.get();
        }
    }
    return origin;
}



/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $eb3c5a912ad3d8a3$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $eb3c5a912ad3d8a3$export$68cacfeee78d98d2(visualElement, definition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = visualElement.makeTargetAnimatable(definition);
    const willChange = visualElement.getValue("willChange");
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key);
        const valueTarget = target[key];
        if (!value || valueTarget === undefined || animationTypeState && $eb3c5a912ad3d8a3$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            elapsed: 0,
            ...transition
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ if (window.HandoffAppearAnimations && !value.hasAnimated) {
            const appearId = visualElement.getProps()[0, $562b99e5f1850f7e$export$8592e1c077c890a6];
            if (appearId) {
                valueTransition.elapsed = window.HandoffAppearAnimations(appearId, key, value, (0, $20659c72a41d0fd3$export$2cef06c20297c17d));
                valueTransition.syncStart = true;
            }
        }
        value.start((0, $bf3452c0059f751b$export$90b3dfc33ff3548)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $b519ba7cf8f7f57e$export$7b42a0094fb00b6e).has(key) ? {
            type: false
        } : valueTransition));
        const animation = value.animation;
        if ((0, $9c62d93f1e0de67c$export$98397f3adbf6259f)(willChange)) {
            willChange.add(key);
            animation.then(()=>willChange.remove(key));
        }
        animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        transitionEnd && (0, $63626ebc76108468$export$1f61c53461aff4a5)(visualElement, transitionEnd);
    });
    return animations;
}


function $fd50afff0af4d1a4$export$17eda790a720ec57(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}



const $dfd38347f5e8abcc$export$91ddd985b97788d1 = {};
function $dfd38347f5e8abcc$export$de9e7791c71225fd(correctors) {
    Object.assign($dfd38347f5e8abcc$export$91ddd985b97788d1, correctors);
}



function $a704493a87b77d6b$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $b519ba7cf8f7f57e$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $dfd38347f5e8abcc$export$91ddd985b97788d1)[key] || key === "opacity");
}



function $b26cdd7ff2c572f8$export$16da615486abaa45(props, prevProps) {
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $d887c96505e11420$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $d887c96505e11420$export$605d60a2578142d3)(prevProps.style[key]) || (0, $a704493a87b77d6b$export$6d27ce8e3de1c3cf)(key, props)) newValues[key] = style[key];
    return newValues;
}



function $7a8356f6244456b0$export$16da615486abaa45(props, prevProps) {
    const newValues = (0, $b26cdd7ff2c572f8$export$16da615486abaa45)(props, prevProps);
    for(const key in props)if ((0, $d887c96505e11420$export$605d60a2578142d3)(props[key]) || (0, $d887c96505e11420$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $b519ba7cf8f7f57e$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}






/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $425fd4aa349bf7ad$var$splitCSSVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function $425fd4aa349bf7ad$export$b9f0c1f373aee2b0(current) {
    const match = $425fd4aa349bf7ad$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
}
const $425fd4aa349bf7ad$var$maxDepth = 4;
function $425fd4aa349bf7ad$var$getVariableValue(current, element, depth = 1) {
    (0, $fbd148e25c0bf485$export$f5708dca728d7177)(depth <= $425fd4aa349bf7ad$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $425fd4aa349bf7ad$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $7e20fc44969ab657$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    } else if ((0, $73c98c223690e4bb$export$31f9caa2600b5723)(fallback)) // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
    return $425fd4aa349bf7ad$var$getVariableValue(fallback, element, depth + 1);
    else return fallback;
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */ function $425fd4aa349bf7ad$export$669319b042b57350(visualElement, { ...target }, transitionEnd) {
    const element = visualElement.current;
    if (!(element instanceof Element)) return {
        target: target,
        transitionEnd: transitionEnd
    };
    // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
    // only if they change but I think this reads clearer and this isn't a performance-critical path.
    if (transitionEnd) transitionEnd = {
        ...transitionEnd
    };
    // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
    visualElement.values.forEach((value)=>{
        const current = value.get();
        if (!(0, $73c98c223690e4bb$export$31f9caa2600b5723)(current)) return;
        const resolved = $425fd4aa349bf7ad$var$getVariableValue(current, element);
        if (resolved) value.set(resolved);
    });
    // Cycle through every target property and resolve CSS variables. Currently
    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
    for(const key in target){
        const current = target[key];
        if (!(0, $73c98c223690e4bb$export$31f9caa2600b5723)(current)) continue;
        const resolved = $425fd4aa349bf7ad$var$getVariableValue(current, element);
        if (!resolved) continue;
        // Clone target if it hasn't already been
        target[key] = resolved;
        if (!transitionEnd) transitionEnd = {};
        // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
        // CSS variable. This will ensure that after the animation the component will reflect
        // changes in the value of the CSS variable.
        if (transitionEnd[key] === undefined) transitionEnd[key] = current;
    }
    return {
        target: target,
        transitionEnd: transitionEnd
    };
}






const $a15c8e7d0668f918$export$4e09c449d6c407f7 = typeof document !== "undefined";




const $a0e6340a131a8bfa$var$positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y",
    "translateX",
    "translateY"
]);
const $a0e6340a131a8bfa$var$isPositionalKey = (key)=>$a0e6340a131a8bfa$var$positionalKeys.has(key);
const $a0e6340a131a8bfa$var$hasPositionalKey = (target)=>{
    return Object.keys(target).some($a0e6340a131a8bfa$var$isPositionalKey);
};
const $a0e6340a131a8bfa$var$isNumOrPxType = (v)=>v === (0, $fd5699cd861e5b4f$export$98e628dec113755e) || v === (0, $8f6e75453fcb14be$export$91c0eda1d06bf008);
const $a0e6340a131a8bfa$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $a0e6340a131a8bfa$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/);
        if (matrix3d) return $a0e6340a131a8bfa$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/);
            if (matrix) return $a0e6340a131a8bfa$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $a0e6340a131a8bfa$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $a0e6340a131a8bfa$var$nonTranslationalTransformKeys = (0, $b519ba7cf8f7f57e$export$280dc01950909d86).filter((key)=>!$a0e6340a131a8bfa$var$transformKeys.has(key));
function $a0e6340a131a8bfa$var$removeNonTranslationalTransform(visualElement) {
    const removedTransforms = [];
    $a0e6340a131a8bfa$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    // Apply changes to element before measurement
    if (removedTransforms.length) visualElement.render();
    return removedTransforms;
}
const $a0e6340a131a8bfa$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $a0e6340a131a8bfa$var$getTranslateFromMatrix(4, 13),
    y: $a0e6340a131a8bfa$var$getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
$a0e6340a131a8bfa$export$781d46a8aa670d52.translateX = $a0e6340a131a8bfa$export$781d46a8aa670d52.x;
$a0e6340a131a8bfa$export$781d46a8aa670d52.translateY = $a0e6340a131a8bfa$export$781d46a8aa670d52.y;
const $a0e6340a131a8bfa$var$convertChangedValueTypes = (target, visualElement, changedKeys)=>{
    const originBbox = visualElement.measureViewportBox();
    const element = visualElement.current;
    const elementComputedStyle = getComputedStyle(element);
    const { display: display } = elementComputedStyle;
    const origin = {};
    // If the element is currently set to display: "none", make it visible before
    // measuring the target bounding box
    if (display === "none") visualElement.setStaticValue("display", target.display || "block");
    /**
     * Record origins before we render and update styles
     */ changedKeys.forEach((key)=>{
        origin[key] = $a0e6340a131a8bfa$export$781d46a8aa670d52[key](originBbox, elementComputedStyle);
    });
    // Apply the latest values (as set in checkAndConvertChangedValueTypes)
    visualElement.render();
    const targetBbox = visualElement.measureViewportBox();
    changedKeys.forEach((key)=>{
        // Restore styles to their **calculated computed style**, not their actual
        // originally set style. This allows us to animate between equivalent pixel units.
        const value = visualElement.getValue(key);
        value && value.jump(origin[key]);
        target[key] = $a0e6340a131a8bfa$export$781d46a8aa670d52[key](targetBbox, elementComputedStyle);
    });
    return target;
};
const $a0e6340a131a8bfa$var$checkAndConvertChangedValueTypes = (visualElement, target, origin = {}, transitionEnd = {})=>{
    target = {
        ...target
    };
    transitionEnd = {
        ...transitionEnd
    };
    const targetPositionalKeys = Object.keys(target).filter($a0e6340a131a8bfa$var$isPositionalKey);
    // We want to remove any transform values that could affect the element's bounding box before
    // it's measured. We'll reapply these later.
    let removedTransformValues = [];
    let hasAttemptedToRemoveTransformValues = false;
    const changedValueTypeKeys = [];
    targetPositionalKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (!visualElement.hasValue(key)) return;
        let from = origin[key];
        let fromType = (0, $40f1a2f8797a857d$export$eefdd52e3ccae428)(from);
        const to = target[key];
        let toType;
        // TODO: The current implementation of this basically throws an error
        // if you try and do value conversion via keyframes. There's probably
        // a way of doing this but the performance implications would need greater scrutiny,
        // as it'd be doing multiple resize-remeasure operations.
        if ((0, $d2297b5e69cea7ff$export$9153ad4c4999f4a0)(to)) {
            const numKeyframes = to.length;
            const fromIndex = to[0] === null ? 1 : 0;
            from = to[fromIndex];
            fromType = (0, $40f1a2f8797a857d$export$eefdd52e3ccae428)(from);
            for(let i = fromIndex; i < numKeyframes; i++){
                /**
                 * Don't allow wildcard keyframes to be used to detect
                 * a difference in value types.
                 */ if (to[i] === null) break;
                if (!toType) {
                    toType = (0, $40f1a2f8797a857d$export$eefdd52e3ccae428)(to[i]);
                    (0, $fbd148e25c0bf485$export$f5708dca728d7177)(toType === fromType || $a0e6340a131a8bfa$var$isNumOrPxType(fromType) && $a0e6340a131a8bfa$var$isNumOrPxType(toType), "Keyframes must be of the same dimension as the current value");
                } else (0, $fbd148e25c0bf485$export$f5708dca728d7177)((0, $40f1a2f8797a857d$export$eefdd52e3ccae428)(to[i]) === toType, "All keyframes must be of the same type");
            }
        } else toType = (0, $40f1a2f8797a857d$export$eefdd52e3ccae428)(to);
        if (fromType !== toType) {
            // If they're both just number or px, convert them both to numbers rather than
            // relying on resize/remeasure to convert (which is wasteful in this situation)
            if ($a0e6340a131a8bfa$var$isNumOrPxType(fromType) && $a0e6340a131a8bfa$var$isNumOrPxType(toType)) {
                const current = value.get();
                if (typeof current === "string") value.set(parseFloat(current));
                if (typeof to === "string") target[key] = parseFloat(to);
                else if (Array.isArray(to) && toType === (0, $8f6e75453fcb14be$export$91c0eda1d06bf008)) target[key] = to.map(parseFloat);
            } else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) && (toType === null || toType === void 0 ? void 0 : toType.transform) && (from === 0 || to === 0)) {
                // If one or the other value is 0, it's safe to coerce it to the
                // type of the other without measurement
                if (from === 0) value.set(toType.transform(from));
                else target[key] = fromType.transform(to);
            } else {
                // If we're going to do value conversion via DOM measurements, we first
                // need to remove non-positional transform values that could affect the bbox measurements.
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues = $a0e6340a131a8bfa$var$removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] = transitionEnd[key] !== undefined ? transitionEnd[key] : target[key];
                value.jump(to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        const scrollY = changedValueTypeKeys.indexOf("height") >= 0 ? window.pageYOffset : null;
        const convertedTarget = $a0e6340a131a8bfa$var$convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        // If we removed transform values, reapply them before the next render
        if (removedTransformValues.length) removedTransformValues.forEach(([key, value])=>{
            visualElement.getValue(key).set(value);
        });
        // Reapply original values
        visualElement.render();
        // Restore scroll position
        if ((0, $a15c8e7d0668f918$export$4e09c449d6c407f7) && scrollY !== null) window.scrollTo({
            top: scrollY
        });
        return {
            target: convertedTarget,
            transitionEnd: transitionEnd
        };
    } else return {
        target: target,
        transitionEnd: transitionEnd
    };
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */ function $a0e6340a131a8bfa$export$9e04b0cab841a28(visualElement, target, origin, transitionEnd) {
    return $a0e6340a131a8bfa$var$hasPositionalKey(target) ? $a0e6340a131a8bfa$var$checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd) : {
        target: target,
        transitionEnd: transitionEnd
    };
}


/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */ const $8a537825e07a6d14$export$5849e743e29831d6 = (visualElement, target, origin, transitionEnd)=>{
    const resolved = (0, $425fd4aa349bf7ad$export$669319b042b57350)(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return (0, $a0e6340a131a8bfa$export$9e04b0cab841a28)(visualElement, target, origin, transitionEnd);
};



const $58c39b376858debe$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $58c39b376858debe$export$3d227df54007d73a = ()=>({
        x: $58c39b376858debe$export$ff25708b37f72782(),
        y: $58c39b376858debe$export$ff25708b37f72782()
    });
const $58c39b376858debe$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $58c39b376858debe$export$6459fc9e86be362e = ()=>({
        x: $58c39b376858debe$export$6db76765312617ac(),
        y: $58c39b376858debe$export$6db76765312617ac()
    });


function $852ab9894f4d62ef$export$dedd81df7bc1307(ref) {
    return typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}



// Does this device prefer reduced motion? Returns `null` server-side.
const $57d423237777b83e$export$ff7706047246b98b = {
    current: null
};
const $57d423237777b83e$export$6476d16e2fd2d0db = {
    current: false
};


function $50d2ec244eb9a9ad$export$ca9f41fb23dded3d() {
    (0, $57d423237777b83e$export$6476d16e2fd2d0db).current = true;
    if (!(0, $a15c8e7d0668f918$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $57d423237777b83e$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $57d423237777b83e$export$ff7706047246b98b).current = false;
}








function $d45a0b1e6ffec94b$export$aa71198ceeaf53ce(v) {
    return typeof v === "object" && typeof v.start === "function";
}


/**
 * Decides if the supplied variable is variant label
 */ function $79c1cb2b56c33b00$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


const $cbc6b721546eeb0d$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $cbc6b721546eeb0d$export$1405a65085f40b9 = [
    "initial",
    ...$cbc6b721546eeb0d$export$16e45afcc206d3a8
];


function $61b81189c9acd8fe$export$4b3c3bd8d910d78d(props) {
    return (0, $d45a0b1e6ffec94b$export$aa71198ceeaf53ce)(props.animate) || (0, $cbc6b721546eeb0d$export$1405a65085f40b9).some((name)=>(0, $79c1cb2b56c33b00$export$720b90e312cea233)(props[name]));
}
function $61b81189c9acd8fe$export$ce46fa4165cdec40(props) {
    return Boolean($61b81189c9acd8fe$export$4b3c3bd8d910d78d(props) || props.variants);
}







function $23d0b3097f92bb6e$export$9a552858d5197f6e(element, next, prev) {
    const { willChange: willChange } = next;
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $d887c96505e11420$export$605d60a2578142d3)(nextValue)) {
            /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
            if ((0, $9c62d93f1e0de67c$export$98397f3adbf6259f)(willChange)) willChange.add(key);
        } else if ((0, $d887c96505e11420$export$605d60a2578142d3)(prevValue)) {
            /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $8020b4d70ab28198$export$ce8bdc721e76545f)(nextValue, {
                owner: element
            }));
            if ((0, $9c62d93f1e0de67c$export$98397f3adbf6259f)(willChange)) willChange.remove(key);
        } else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                // TODO: Only update values that aren't being animated or even looked at
                !existingValue.hasAnimated && existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $8020b4d70ab28198$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}




const $c75917c62ee0e48e$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $c75917c62ee0e48e$export$65570e08d843624d = {};
for(const key in $c75917c62ee0e48e$var$featureProps)$c75917c62ee0e48e$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$c75917c62ee0e48e$var$featureProps[key].some((name)=>!!props[name])
};





const $3c8c58fc50d7bbf0$var$featureNames = Object.keys((0, $c75917c62ee0e48e$export$65570e08d843624d));
const $3c8c58fc50d7bbf0$var$numFeatures = $3c8c58fc50d7bbf0$var$featureNames.length;
const $3c8c58fc50d7bbf0$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
const $3c8c58fc50d7bbf0$var$numVariantProps = (0, $cbc6b721546eeb0d$export$1405a65085f40b9).length;
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $3c8c58fc50d7bbf0$export$fa8b653c0f3714e5 {
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.scheduleRender = ()=>(0, $20659c72a41d0fd3$export$2cef06c20297c17d).render(this.render, false, true);
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.isControllingVariants = (0, $61b81189c9acd8fe$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $61b81189c9acd8fe$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {});
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $d887c96505e11420$export$605d60a2578142d3)(value)) {
                value.set(latestValues[key], false);
                if ((0, $9c62d93f1e0de67c$export$98397f3adbf6259f)(willChange)) willChange.add(key);
            }
        }
    }
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps) {
        return {};
    }
    mount(instance) {
        this.current = instance;
        (0, $917bdbd54cf82b87$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $57d423237777b83e$export$6476d16e2fd2d0db).current) (0, $50d2ec244eb9a9ad$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $57d423237777b83e$export$ff7706047246b98b).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        (0, $917bdbd54cf82b87$export$bc2a978a17abfdde).delete(this.current);
        this.projection && this.projection.unmount();
        (0, $20659c72a41d0fd3$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $20659c72a41d0fd3$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features)this.features[key].unmount();
        this.current = null;
    }
    bindToMotionValue(key, value) {
        const valueIsTransform = (0, $b519ba7cf8f7f57e$export$7b42a0094fb00b6e).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $20659c72a41d0fd3$export$2cef06c20297c17d).update(this.notifyUpdate, false, true);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    loadFeatures({ children: children, ...renderedProps }, isStrict, preloadedFeatures, initialLayoutGroupConfig) {
        let ProjectionNodeConstructor;
        let MeasureLayout;
        for(let i = 0; i < $3c8c58fc50d7bbf0$var$numFeatures; i++){
            const name = $3c8c58fc50d7bbf0$var$featureNames[i];
            const { isEnabled: isEnabled, Feature: FeatureConstructor, ProjectionNode: ProjectionNode, MeasureLayout: MeasureLayoutComponent } = (0, $c75917c62ee0e48e$export$65570e08d843624d)[name];
            if (ProjectionNode) ProjectionNodeConstructor = ProjectionNode;
            if (isEnabled(renderedProps)) {
                if (!this.features[name] && FeatureConstructor) this.features[name] = new FeatureConstructor(this);
                if (MeasureLayoutComponent) MeasureLayout = MeasureLayoutComponent;
            }
        }
        if (!this.projection && ProjectionNodeConstructor) {
            this.projection = new ProjectionNodeConstructor(this.latestValues, this.parent && this.parent.projection);
            const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot } = renderedProps;
            this.projection.setOptions({
                layoutId: layoutId,
                layout: layout,
                alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $852ab9894f4d62ef$export$dedd81df7bc1307)(dragConstraints),
                visualElement: this,
                scheduleRender: ()=>this.scheduleRender(),
                /**
                 * TODO: Update options in an effect. This could be tricky as it'll be too late
                 * to update by the time layout animations run.
                 * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
                 * ensuring it gets called if there's no potential layout animations.
                 *
                 */ animationType: typeof layout === "string" ? layout : "both",
                initialPromotionConfig: initialLayoutGroupConfig,
                layoutScroll: layoutScroll,
                layoutRoot: layoutRoot
            });
        }
        return MeasureLayout;
    }
    updateFeatures() {
        for(const key in this.features){
            const feature = this.features[key];
            if (feature.isMounted) feature.update();
            else {
                feature.mount();
                feature.isMounted = true;
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.options, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $58c39b376858debe$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Make a target animatable by Popmotion. For instance, if we're
     * trying to animate width from 100px to 100vw we need to measure 100vw
     * in pixels to determine what we really need to animate to. This is also
     * pluggable to support Framer's custom value types like Color,
     * and CSS variables.
     */ makeTargetAnimatable(target, canMutate = true) {
        return this.makeTargetAnimatableFromInstance(target, this.props, canMutate);
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $3c8c58fc50d7bbf0$var$propEventHandlers.length; i++){
            const key = $3c8c58fc50d7bbf0$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listener = props["on" + key];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $23d0b3097f92bb6e$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    getVariantContext(startAtParent = false) {
        if (startAtParent) return this.parent ? this.parent.getVariantContext() : undefined;
        if (!this.isControllingVariants) {
            const context = this.parent ? this.parent.getVariantContext() || {} : {};
            if (this.props.initial !== undefined) context.initial = this.props.initial;
            return context;
        }
        const context = {};
        for(let i = 0; i < $3c8c58fc50d7bbf0$var$numVariantProps; i++){
            const name = (0, $cbc6b721546eeb0d$export$1405a65085f40b9)[i];
            const prop = this.props[name];
            if ((0, $79c1cb2b56c33b00$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
        }
        return context;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        if (value !== this.values.get(key)) {
            this.removeValue(key);
            this.bindToMotionValue(key, value);
        }
        this.values.set(key, value);
        this.latestValues[key] = value.get();
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $8020b4d70ab28198$export$ce8bdc721e76545f)(defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key) {
        var _a;
        return this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial } = this.props;
        const valueFromInitial = typeof initial === "string" || typeof initial === "object" ? (_a = (0, $a7c2d01870909705$export$d68f140c4d9b48bc)(this.props, initial)) === null || _a === void 0 ? void 0 : _a[key] : undefined;
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $d887c96505e11420$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $fdd378d169697ca0$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}


class $4dd73d7b27aabe8e$export$e49735c2a366bdc7 extends (0, $3c8c58fc50d7bbf0$export$fa8b653c0f3714e5) {
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    makeTargetAnimatableFromInstance({ transition: transition, transitionEnd: transitionEnd, ...target }, { transformValues: transformValues }, isMounted) {
        let origin = (0, $63626ebc76108468$export$5a759dc7a1cfb72a)(target, transition || {}, this);
        /**
         * If Framer has provided a function to convert `Color` etc value types, convert them
         */ if (transformValues) {
            if (transitionEnd) transitionEnd = transformValues(transitionEnd);
            if (target) target = transformValues(target);
            if (origin) origin = transformValues(origin);
        }
        if (isMounted) {
            (0, $63626ebc76108468$export$6afbed164019a54c)(this, target, origin);
            const parsed = (0, $8a537825e07a6d14$export$5849e743e29831d6)(this, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return {
            transition: transition,
            transitionEnd: transitionEnd,
            ...target
        };
    }
}



const $ed23cb33192706df$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $ed23cb33192706df$var$numTransforms = (0, $b519ba7cf8f7f57e$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $ed23cb33192706df$export$bdc96e0d5c8f914(transform, { enableHardwareAcceleration: enableHardwareAcceleration = true, allowTransformNone: allowTransformNone = true }, transformIsDefault, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $ed23cb33192706df$var$numTransforms; i++){
        const key = (0, $b519ba7cf8f7f57e$export$280dc01950909d86)[i];
        if (transform[key] !== undefined) {
            const transformName = $ed23cb33192706df$var$translateAlias[key] || key;
            transformString += `${transformName}(${transform[key]}) `;
        }
    }
    if (enableHardwareAcceleration && !transform.z) transformString += "translateZ(0)";
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (allowTransformNone && transformIsDefault) transformString = "none";
    return transformString;
}




/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $d1c3ce3681df9571$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};



function $aa08508ae34ecd3f$export$bb517f8b40f8e99d(state, latestValues, options, transformTemplate) {
    const { style: style, vars: vars, transform: transform, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    let transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */ if ((0, $73c98c223690e4bb$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        const valueType = (0, $f04fc9abc28b2900$export$eec14432cd1cb67b)[key];
        const valueAsType = (0, $d1c3ce3681df9571$export$453ef540a9a1bd6b)(value, valueType);
        if ((0, $b519ba7cf8f7f57e$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            // If we already know we have a non-default transform, early return
            if (!transformIsNone) continue;
            // Otherwise check to see if this is a default transform
            if (value !== (valueType.default || 0)) transformIsNone = false;
        } else if (key.startsWith("origin")) {
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
            transformOrigin[key] = valueAsType;
        } else style[key] = valueAsType;
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $ed23cb33192706df$export$bdc96e0d5c8f914)(state.transform, options, transformIsNone, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}



function $3d3dbf2651add24a$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $8f6e75453fcb14be$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $3d3dbf2651add24a$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $3d3dbf2651add24a$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $3d3dbf2651add24a$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}



const $278b613b6cf96e4b$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $278b613b6cf96e4b$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $278b613b6cf96e4b$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $278b613b6cf96e4b$var$dashKeys : $278b613b6cf96e4b$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $8f6e75453fcb14be$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $8f6e75453fcb14be$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $8f6e75453fcb14be$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $138ea10ffbe129ca$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, options, isSVGTag, transformTemplate) {
    (0, $aa08508ae34ecd3f$export$bb517f8b40f8e99d)(state, latest, options, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $3d3dbf2651add24a$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $278b613b6cf96e4b$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}



/**
 * A set of attribute names that are always read/written as camel case.
 */ const $ec527c5d10eafc6e$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);




function $87a6e2580f127c0b$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}



function $a64f74a9c7266ede$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $87a6e2580f127c0b$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $ec527c5d10eafc6e$export$28931db5d57958e5).has(key) ? (0, $a5fa4ba7c7c4e42d$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}




const $07bdedf633fd46a3$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";


class $fc34a60adb8dcc4e$export$86bcdffbaf733d84 extends (0, $4dd73d7b27aabe8e$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.isSVGTag = false;
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $b519ba7cf8f7f57e$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $95dcdbcf808a93e0$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $ec527c5d10eafc6e$export$28931db5d57958e5).has(key) ? (0, $a5fa4ba7c7c4e42d$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    measureInstanceViewportBox() {
        return (0, $58c39b376858debe$export$6459fc9e86be362e)();
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return (0, $7a8356f6244456b0$export$16da615486abaa45)(props, prevProps);
    }
    build(renderState, latestValues, options, props) {
        (0, $138ea10ffbe129ca$export$5475d24f125d7053)(renderState, latestValues, options, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $a64f74a9c7266ede$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $07bdedf633fd46a3$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
}








/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $5f50da734b126413$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $5f50da734b126413$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $5f50da734b126413$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



function $43d992ea7f358c65$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $43d992ea7f358c65$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$43d992ea7f358c65$var$isIdentityScale(scale) || !$43d992ea7f358c65$var$isIdentityScale(scaleX) || !$43d992ea7f358c65$var$isIdentityScale(scaleY);
}
function $43d992ea7f358c65$export$a545127cf1fbb600(values) {
    return $43d992ea7f358c65$export$bdf30dca883ea463(values) || $43d992ea7f358c65$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY;
}
function $43d992ea7f358c65$export$bf80f5f8f4dc327f(values) {
    return $43d992ea7f358c65$var$is2DTranslate(values.x) || $43d992ea7f358c65$var$is2DTranslate(values.y);
}
function $43d992ea7f358c65$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $87522e206d8be0b3$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $87522e206d8be0b3$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $87522e206d8be0b3$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $87522e206d8be0b3$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $87522e206d8be0b3$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $87522e206d8be0b3$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $87522e206d8be0b3$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $87522e206d8be0b3$export$d80074982803af5c(box, { x: x, y: y }) {
    $87522e206d8be0b3$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $87522e206d8be0b3$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $87522e206d8be0b3$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const instance = node.instance;
        if (instance && instance.style && instance.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $87522e206d8be0b3$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $87522e206d8be0b3$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $43d992ea7f358c65$export$a545127cf1fbb600)(node.latestValues)) $87522e206d8be0b3$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ treeScale.x = $87522e206d8be0b3$var$snapToDefault(treeScale.x);
    treeScale.y = $87522e206d8be0b3$var$snapToDefault(treeScale.y);
}
function $87522e206d8be0b3$var$snapToDefault(scale) {
    if (Number.isInteger(scale)) return scale;
    return scale > 1.0000000000001 || scale < 0.999999999999 ? scale : 1;
}
function $87522e206d8be0b3$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $87522e206d8be0b3$export$625f1dd140a2f5e7(axis, transforms, [key, scaleKey, originKey]) {
    const axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    const originPoint = (0, $3c2585c246339658$export$2c9e8a9632a706b2)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $87522e206d8be0b3$export$e8e3a712e9ebf422(axis, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $87522e206d8be0b3$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $87522e206d8be0b3$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $87522e206d8be0b3$export$58b16271041fbfb(box, transform) {
    $87522e206d8be0b3$export$625f1dd140a2f5e7(box.x, transform, $87522e206d8be0b3$var$xKeys);
    $87522e206d8be0b3$export$625f1dd140a2f5e7(box.y, transform, $87522e206d8be0b3$var$yKeys);
}


function $7d5292a07e0d8c95$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $5f50da734b126413$export$d3955c6a8f65a36b)((0, $5f50da734b126413$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $7d5292a07e0d8c95$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $7d5292a07e0d8c95$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $87522e206d8be0b3$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $87522e206d8be0b3$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}




function $d670c9b265a0f3b2$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $d670c9b265a0f3b2$export$23fea75b03ac16b3 extends (0, $4dd73d7b27aabe8e$export$e49735c2a366bdc7) {
    readValueFromInstance(instance, key) {
        if ((0, $b519ba7cf8f7f57e$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $95dcdbcf808a93e0$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $d670c9b265a0f3b2$export$3735103072e4a80(instance);
            const value = ((0, $73c98c223690e4bb$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $7d5292a07e0d8c95$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, options, props) {
        (0, $aa08508ae34ecd3f$export$bb517f8b40f8e99d)(renderState, latestValues, options, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps) {
        return (0, $b26cdd7ff2c572f8$export$16da615486abaa45)(props, prevProps);
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $d887c96505e11420$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $87a6e2580f127c0b$export$1a32bf6229c258c0)(instance, renderState, styleProp, projection);
    }
}



function $384a7c8f40e0b2f6$export$f2911d8192f464a8(element) {
    const options = {
        presenceContext: null,
        props: {},
        visualState: {
            renderState: {
                transform: {},
                transformOrigin: {},
                style: {},
                vars: {},
                attrs: {}
            },
            latestValues: {}
        }
    };
    const node = (0, $fd50afff0af4d1a4$export$17eda790a720ec57)(element) ? new (0, $fc34a60adb8dcc4e$export$86bcdffbaf733d84)(options, {
        enableHardwareAcceleration: false
    }) : new (0, $d670c9b265a0f3b2$export$23fea75b03ac16b3)(options, {
        enableHardwareAcceleration: true
    });
    node.mount(element);
    (0, $917bdbd54cf82b87$export$bc2a978a17abfdde).set(element, node);
}





function $d82ab6bb07a1d2e6$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $d887c96505e11420$export$605d60a2578142d3)(value) ? value : (0, $8020b4d70ab28198$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $bf3452c0059f751b$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}





/**
 * Create a progress => progress easing function from a generator.
 */ function $a6be9b7f8872710d$export$7f1511d09ee75a99(options, scale = 100) {
    const generator = (0, $ecc45c1e9bba2f42$export$b36281d89752ae66)({
        keyframes: [
            0,
            scale
        ],
        ...options
    });
    const duration = Math.min((0, $26a49ae99b6cd05e$export$cbdd6b3d40ea54e2)(generator), (0, $26a49ae99b6cd05e$export$f4ff70a5b4808fd8));
    return {
        type: "keyframes",
        ease: (progress)=>generator.next(duration * progress).value / scale,
        duration: (0, $163563b2e4726aac$export$f64c3bfbc58eec0f)(duration)
    };
}








/**
 * Given a absolute or relative time definition and current/prev time state of the sequence,
 * calculate an absolute time for the next keyframes.
 */ function $fee180756c158ce1$export$83ccd85155ba9791(current, next, prev, labels) {
    var _a;
    if (typeof next === "number") return next;
    else if (next.startsWith("-") || next.startsWith("+")) return Math.max(0, current + parseFloat(next));
    else if (next === "<") return prev;
    else return (_a = labels.get(next)) !== null && _a !== void 0 ? _a : current;
}


const $118221430819d8a8$export$4997ffc0176396a6 = (min, max, v)=>{
    const rangeSize = max - min;
    return ((v - min) % rangeSize + rangeSize) % rangeSize + min;
};



function $66c354c7a9764556$export$41c5e731255a462(easing, i) {
    return (0, $5d0a11a28f7b03d5$export$216948827bbdc797)(easing) ? easing[(0, $118221430819d8a8$export$4997ffc0176396a6)(0, easing.length, i)] : easing;
}




function $d27ace5d45d76018$export$6f93cdbb78924b88(sequence, startTime, endTime) {
    for(let i = 0; i < sequence.length; i++){
        const keyframe = sequence[i];
        if (keyframe.at > startTime && keyframe.at < endTime) {
            (0, $1b6150944a1ca569$export$fe2d9b4e03920b4c)(sequence, keyframe);
            // If we remove this item we have to push the pointer back one
            i--;
        }
    }
}
function $d27ace5d45d76018$export$89dfa6760a9f76e7(sequence, keyframes, easing, offset, startTime, endTime) {
    /**
     * Erase every existing value between currentTime and targetTime,
     * this will essentially splice this timeline into any currently
     * defined ones.
     */ $d27ace5d45d76018$export$6f93cdbb78924b88(sequence, startTime, endTime);
    for(let i = 0; i < keyframes.length; i++)sequence.push({
        value: keyframes[i],
        at: (0, $3c2585c246339658$export$2c9e8a9632a706b2)(startTime, endTime, offset[i]),
        easing: (0, $66c354c7a9764556$export$41c5e731255a462)(easing, i)
    });
}


function $1a0ea1560e78279b$export$66dd3fbf44e05bd9(a, b) {
    if (a.at === b.at) {
        if (a.value === null) return 1;
        if (b.value === null) return -1;
        return 0;
    } else return a.at - b.at;
}


const $95baf971a8d87d0f$var$defaultSegmentEasing = "easeInOut";
function $95baf971a8d87d0f$export$1f0f44b51a4b2f73(sequence, { defaultTransition: defaultTransition = {}, ...sequenceTransition } = {}, scope) {
    const defaultDuration = defaultTransition.duration || 0.3;
    const animationDefinitions = new Map();
    const sequences = new Map();
    const elementCache = {};
    const timeLabels = new Map();
    let prevTime = 0;
    let currentTime = 0;
    let totalDuration = 0;
    /**
     * Build the timeline by mapping over the sequence array and converting
     * the definitions into keyframes and offsets with absolute time values.
     * These will later get converted into relative offsets in a second pass.
     */ for(let i = 0; i < sequence.length; i++){
        const segment = sequence[i];
        /**
         * If this is a timeline label, mark it and skip the rest of this iteration.
         */ if (typeof segment === "string") {
            timeLabels.set(segment, currentTime);
            continue;
        } else if (!Array.isArray(segment)) {
            timeLabels.set(segment.name, (0, $fee180756c158ce1$export$83ccd85155ba9791)(currentTime, segment.at, prevTime, timeLabels));
            continue;
        }
        let [subject, keyframes, transition = {}] = segment;
        /**
         * If a relative or absolute time value has been specified we need to resolve
         * it in relation to the currentTime.
         */ if (transition.at !== undefined) currentTime = (0, $fee180756c158ce1$export$83ccd85155ba9791)(currentTime, transition.at, prevTime, timeLabels);
        /**
         * Keep track of the maximum duration in this definition. This will be
         * applied to currentTime once the definition has been parsed.
         */ let maxDuration = 0;
        const resolveValueSequence = (valueKeyframes, valueTransition, valueSequence, elementIndex = 0, numElements = 0)=>{
            const valueKeyframesAsList = $95baf971a8d87d0f$var$keyframesAsList(valueKeyframes);
            const { delay: delay = 0, times: times = (0, $bce7ae17b4555960$export$24dbcec0b26e6d9d)(valueKeyframesAsList), type: type = "keyframes", ...remainingTransition } = valueTransition;
            let { ease: ease = defaultTransition.ease || "easeOut", duration: duration } = valueTransition;
            /**
             * Resolve stagger() if defined.
             */ const calculatedDelay = typeof delay === "function" ? delay(elementIndex, numElements) : delay;
            /**
             * If this animation should and can use a spring, generate a spring easing function.
             */ const numKeyframes = valueKeyframesAsList.length;
            if (numKeyframes <= 2 && type === "spring") {
                /**
                 * As we're creating an easing function from a spring,
                 * ideally we want to generate it using the real distance
                 * between the two keyframes. However this isn't always
                 * possible - in these situations we use 0-100.
                 */ let absoluteDelta = 100;
                if (numKeyframes === 2 && $95baf971a8d87d0f$var$isNumberKeyframesArray(valueKeyframesAsList)) {
                    const delta = valueKeyframesAsList[1] - valueKeyframesAsList[0];
                    absoluteDelta = Math.abs(delta);
                }
                const springTransition = {
                    ...remainingTransition
                };
                if (duration !== undefined) springTransition.duration = (0, $163563b2e4726aac$export$fc3e7e8557f8c8c7)(duration);
                const springEasing = (0, $a6be9b7f8872710d$export$7f1511d09ee75a99)(springTransition, absoluteDelta);
                ease = springEasing.ease;
                duration = springEasing.duration;
            }
            duration !== null && duration !== void 0 ? duration : duration = defaultDuration;
            const startTime = currentTime + calculatedDelay;
            const targetTime = startTime + duration;
            /**
             * If there's only one time offset of 0, fill in a second with length 1
             */ if (times.length === 1 && times[0] === 0) times[1] = 1;
            /**
             * Fill out if offset if fewer offsets than keyframes
             */ const remainder = times.length - valueKeyframesAsList.length;
            remainder > 0 && (0, $ec000638a9f71902$export$dafee61230cf05c6)(times, remainder);
            /**
             * If only one value has been set, ie [1], push a null to the start of
             * the keyframe array. This will let us mark a keyframe at this point
             * that will later be hydrated with the previous value.
             */ valueKeyframesAsList.length === 1 && valueKeyframesAsList.unshift(null);
            /**
             * Add keyframes, mapping offsets to absolute time.
             */ (0, $d27ace5d45d76018$export$89dfa6760a9f76e7)(valueSequence, valueKeyframesAsList, ease, times, startTime, targetTime);
            maxDuration = Math.max(calculatedDelay + duration, maxDuration);
            totalDuration = Math.max(targetTime, totalDuration);
        };
        if ((0, $d887c96505e11420$export$605d60a2578142d3)(subject)) {
            const subjectSequence = $95baf971a8d87d0f$var$getSubjectSequence(subject, sequences);
            resolveValueSequence(keyframes, transition, $95baf971a8d87d0f$var$getValueSequence("default", subjectSequence));
        } else {
            /**
             * Find all the elements specified in the definition and parse value
             * keyframes from their timeline definitions.
             */ const elements = (0, $57b42c80cd6ebb05$export$90ceba2564a894f8)(subject, scope, elementCache);
            const numElements = elements.length;
            /**
             * For every element in this segment, process the defined values.
             */ for(let elementIndex = 0; elementIndex < numElements; elementIndex++){
                /**
                 * Cast necessary, but we know these are of this type
                 */ keyframes;
                transition;
                const element = elements[elementIndex];
                const subjectSequence = $95baf971a8d87d0f$var$getSubjectSequence(element, sequences);
                for(const key in keyframes)resolveValueSequence(keyframes[key], $95baf971a8d87d0f$export$7c1391340308742e(transition, key), $95baf971a8d87d0f$var$getValueSequence(key, subjectSequence), elementIndex, numElements);
            }
            prevTime = currentTime;
            currentTime += maxDuration;
        }
    }
    /**
     * For every element and value combination create a new animation.
     */ sequences.forEach((valueSequences, element)=>{
        for(const key in valueSequences){
            const valueSequence = valueSequences[key];
            /**
             * Arrange all the keyframes in ascending time order.
             */ valueSequence.sort((0, $1a0ea1560e78279b$export$66dd3fbf44e05bd9));
            const keyframes = [];
            const valueOffset = [];
            const valueEasing = [];
            /**
             * For each keyframe, translate absolute times into
             * relative offsets based on the total duration of the timeline.
             */ for(let i = 0; i < valueSequence.length; i++){
                const { at: at, value: value, easing: easing } = valueSequence[i];
                keyframes.push(value);
                valueOffset.push((0, $469d01f875f55ac1$export$504d7abb21fa8c9)(0, totalDuration, at));
                valueEasing.push(easing || "easeOut");
            }
            /**
             * If the first keyframe doesn't land on offset: 0
             * provide one by duplicating the initial keyframe. This ensures
             * it snaps to the first keyframe when the animation starts.
             */ if (valueOffset[0] !== 0) {
                valueOffset.unshift(0);
                keyframes.unshift(keyframes[0]);
                valueEasing.unshift($95baf971a8d87d0f$var$defaultSegmentEasing);
            }
            /**
             * If the last keyframe doesn't land on offset: 1
             * provide one with a null wildcard value. This will ensure it
             * stays static until the end of the animation.
             */ if (valueOffset[valueOffset.length - 1] !== 1) {
                valueOffset.push(1);
                keyframes.push(null);
            }
            if (!animationDefinitions.has(element)) animationDefinitions.set(element, {
                keyframes: {},
                transition: {}
            });
            const definition = animationDefinitions.get(element);
            definition.keyframes[key] = keyframes;
            definition.transition[key] = {
                ...defaultTransition,
                duration: totalDuration,
                ease: valueEasing,
                times: valueOffset,
                ...sequenceTransition
            };
        }
    });
    return animationDefinitions;
}
function $95baf971a8d87d0f$var$getSubjectSequence(subject, sequences) {
    !sequences.has(subject) && sequences.set(subject, {});
    return sequences.get(subject);
}
function $95baf971a8d87d0f$var$getValueSequence(name, sequences) {
    if (!sequences[name]) sequences[name] = [];
    return sequences[name];
}
function $95baf971a8d87d0f$var$keyframesAsList(keyframes) {
    return Array.isArray(keyframes) ? keyframes : [
        keyframes
    ];
}
function $95baf971a8d87d0f$export$7c1391340308742e(transition, key) {
    return transition[key] ? {
        ...transition,
        ...transition[key]
    } : {
        ...transition
    };
}
const $95baf971a8d87d0f$var$isNumber = (keyframe)=>typeof keyframe === "number";
const $95baf971a8d87d0f$var$isNumberKeyframesArray = (keyframes)=>keyframes.every($95baf971a8d87d0f$var$isNumber);



function $2f3f3768f144c5cc$var$animateElements(elementOrSelector, keyframes, options, scope) {
    const elements = (0, $57b42c80cd6ebb05$export$90ceba2564a894f8)(elementOrSelector, scope);
    const numElements = elements.length;
    (0, $fbd148e25c0bf485$export$f5708dca728d7177)(Boolean(numElements), "No valid element provided.");
    const animations = [];
    for(let i = 0; i < numElements; i++){
        const element = elements[i];
        /**
         * Check each element for an associated VisualElement. If none exists,
         * we need to create one.
         */ if (!(0, $917bdbd54cf82b87$export$bc2a978a17abfdde).has(element)) /**
             * TODO: We only need render-specific parts of the VisualElement.
             * With some additional work the size of the animate() function
             * could be reduced significantly.
             */ (0, $384a7c8f40e0b2f6$export$f2911d8192f464a8)(element);
        const visualElement = (0, $917bdbd54cf82b87$export$bc2a978a17abfdde).get(element);
        const transition = {
            ...options
        };
        /**
         * Resolve stagger function if provided.
         */ if (typeof transition.delay === "function") transition.delay = transition.delay(i, numElements);
        animations.push(...(0, $eb3c5a912ad3d8a3$export$68cacfeee78d98d2)(visualElement, {
            ...keyframes,
            transition: transition
        }, {}));
    }
    return new (0, $96aff0553a8e500d$export$c1e41718f71efe41)(animations);
}
const $2f3f3768f144c5cc$var$isSequence = (value)=>Array.isArray(value) && Array.isArray(value[0]);
function $2f3f3768f144c5cc$var$animateSequence(sequence, options, scope) {
    const animations = [];
    const animationDefinitions = (0, $95baf971a8d87d0f$export$1f0f44b51a4b2f73)(sequence, options, scope);
    animationDefinitions.forEach(({ keyframes: keyframes, transition: transition }, subject)=>{
        let animation;
        if ((0, $d887c96505e11420$export$605d60a2578142d3)(subject)) animation = (0, $d82ab6bb07a1d2e6$export$335a17c977067b99)(subject, keyframes.default, transition.default);
        else animation = $2f3f3768f144c5cc$var$animateElements(subject, keyframes, transition);
        animations.push(animation);
    });
    return new (0, $96aff0553a8e500d$export$c1e41718f71efe41)(animations);
}
const $2f3f3768f144c5cc$export$c17e592002be9b90 = (scope)=>{
    /**
     * Implementation
     */ function scopedAnimate(valueOrElementOrSequence, keyframes, options) {
        let animation;
        if ($2f3f3768f144c5cc$var$isSequence(valueOrElementOrSequence)) animation = $2f3f3768f144c5cc$var$animateSequence(valueOrElementOrSequence, keyframes, scope);
        else if ((0, $a0be9c8cf1426b29$export$d276bfce3b1077ca)(keyframes)) animation = $2f3f3768f144c5cc$var$animateElements(valueOrElementOrSequence, keyframes, options, scope);
        else animation = (0, $d82ab6bb07a1d2e6$export$335a17c977067b99)(valueOrElementOrSequence, keyframes, options);
        if (scope) scope.animations.push(animation);
        return animation;
    }
    return scopedAnimate;
};
const $2f3f3768f144c5cc$export$e3607ec2d7a891c4 = $2f3f3768f144c5cc$export$c17e592002be9b90();


var $2gcPZ = parcelRequire("2gcPZ");


var $2gcPZ = parcelRequire("2gcPZ");
/**
 * @public
 */ const $22f1bc8edc40a68d$export$22a697fb29aac98d = (0, $2gcPZ.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});



var $2gcPZ = parcelRequire("2gcPZ");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $669e7e15e4b99af1$export$fe4300aa8eebea86(init) {
    const ref = (0, $2gcPZ.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}


/**
 * Creates a `MotionValue` to track the state and velocity of a value.
 *
 * Usually, these are created automatically. For advanced use-cases, like use with `useTransform`, you can create `MotionValue`s externally and pass them into the animated component via the `style` prop.
 *
 * ```jsx
 * export const MyComponent = () => {
 *   const scale = useMotionValue(1)
 *
 *   return <motion.div style={{ scale }} />
 * }
 * ```
 *
 * @param initial - The initial state.
 *
 * @public
 */ function $91775a08ebdfe246$export$15b697acf84c78b9(initial) {
    const value = (0, $669e7e15e4b99af1$export$fe4300aa8eebea86)(()=>(0, $8020b4d70ab28198$export$ce8bdc721e76545f)(initial));
    /**
     * If this motion value is being used in static mode, like on
     * the Framer canvas, force components to rerender when the motion
     * value is updated.
     */ const { isStatic: isStatic } = (0, $2gcPZ.useContext)((0, $22f1bc8edc40a68d$export$22a697fb29aac98d));
    if (isStatic) {
        const [, setLatest] = (0, $2gcPZ.useState)(initial);
        (0, $2gcPZ.useEffect)(()=>value.on("change", setLatest), []);
    }
    return value;
}


function $c7f2d8c8d4d86dfc$export$2e2bcd8739ae039() {
    $c7f2d8c8d4d86dfc$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c7f2d8c8d4d86dfc$export$2e2bcd8739ae039.apply(this, arguments);
}


function $ab559a235872eed7$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $67d48a72035eada4$export$2e2bcd8739ae039(o, p) {
    $67d48a72035eada4$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $67d48a72035eada4$export$2e2bcd8739ae039(o, p);
}


function $0df4b0e059b7ae39$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $67d48a72035eada4$export$2e2bcd8739ae039)(subClass, superClass);
}


var $7f7c97f41a5d2ad0$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $7f7c97f41a5d2ad0$var$isEqual(first, second) {
    if (first === second) return true;
    if ($7f7c97f41a5d2ad0$var$safeIsNaN(first) && $7f7c97f41a5d2ad0$var$safeIsNaN(second)) return true;
    return false;
}
function $7f7c97f41a5d2ad0$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$7f7c97f41a5d2ad0$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $7f7c97f41a5d2ad0$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $7f7c97f41a5d2ad0$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $7f7c97f41a5d2ad0$export$2e2bcd8739ae039 = $7f7c97f41a5d2ad0$var$memoizeOne;



var $2gcPZ = parcelRequire("2gcPZ");
function $3e1c704ac4a4c38a$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


// Animation frame based implementation of setTimeout.
// Inspired by Joe Lambert, https://gist.github.com/joelambert/1002116#file-requesttimeout-js
var $01ff200d9f4ad87f$var$hasNativePerformanceNow = typeof performance === "object" && typeof performance.now === "function";
var $01ff200d9f4ad87f$var$now = $01ff200d9f4ad87f$var$hasNativePerformanceNow ? function() {
    return performance.now();
} : function() {
    return Date.now();
};
function $01ff200d9f4ad87f$var$cancelTimeout(timeoutID) {
    cancelAnimationFrame(timeoutID.id);
}
function $01ff200d9f4ad87f$var$requestTimeout(callback, delay) {
    var start = $01ff200d9f4ad87f$var$now();
    function tick() {
        if ($01ff200d9f4ad87f$var$now() - start >= delay) callback.call(null);
        else timeoutID.id = requestAnimationFrame(tick);
    }
    var timeoutID = {
        id: requestAnimationFrame(tick)
    };
    return timeoutID;
}
var $01ff200d9f4ad87f$var$size = -1; // This utility copied from "dom-helpers" package.
function $01ff200d9f4ad87f$var$getScrollbarSize(recalculate) {
    if (recalculate === void 0) recalculate = false;
    if ($01ff200d9f4ad87f$var$size === -1 || recalculate) {
        var div = document.createElement("div");
        var style = div.style;
        style.width = "50px";
        style.height = "50px";
        style.overflow = "scroll";
        document.body.appendChild(div);
        $01ff200d9f4ad87f$var$size = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
    }
    return $01ff200d9f4ad87f$var$size;
}
var $01ff200d9f4ad87f$var$cachedRTLResult = null; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
// Chrome does not seem to adhere; its scrollLeft values are positive (measured relative to the left).
// Safari's elastic bounce makes detecting this even more complicated wrt potential false positives.
// The safest way to check this is to intentionally set a negative offset,
// and then verify that the subsequent "scroll" event matches the negative offset.
// If it does not match, then we can assume a non-standard RTL scroll implementation.
function $01ff200d9f4ad87f$var$getRTLOffsetType(recalculate) {
    if (recalculate === void 0) recalculate = false;
    if ($01ff200d9f4ad87f$var$cachedRTLResult === null || recalculate) {
        var outerDiv = document.createElement("div");
        var outerStyle = outerDiv.style;
        outerStyle.width = "50px";
        outerStyle.height = "50px";
        outerStyle.overflow = "scroll";
        outerStyle.direction = "rtl";
        var innerDiv = document.createElement("div");
        var innerStyle = innerDiv.style;
        innerStyle.width = "100px";
        innerStyle.height = "100px";
        outerDiv.appendChild(innerDiv);
        document.body.appendChild(outerDiv);
        if (outerDiv.scrollLeft > 0) $01ff200d9f4ad87f$var$cachedRTLResult = "positive-descending";
        else {
            outerDiv.scrollLeft = 1;
            if (outerDiv.scrollLeft === 0) $01ff200d9f4ad87f$var$cachedRTLResult = "negative";
            else $01ff200d9f4ad87f$var$cachedRTLResult = "positive-ascending";
        }
        document.body.removeChild(outerDiv);
        return $01ff200d9f4ad87f$var$cachedRTLResult;
    }
    return $01ff200d9f4ad87f$var$cachedRTLResult;
}
var $01ff200d9f4ad87f$var$IS_SCROLLING_DEBOUNCE_INTERVAL = 150;
var $01ff200d9f4ad87f$var$defaultItemKey = function defaultItemKey(_ref) {
    var columnIndex = _ref.columnIndex, data = _ref.data, rowIndex = _ref.rowIndex;
    return rowIndex + ":" + columnIndex;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.
var $01ff200d9f4ad87f$var$devWarningsOverscanCount = null;
var $01ff200d9f4ad87f$var$devWarningsOverscanRowsColumnsCount = null;
var $01ff200d9f4ad87f$var$devWarningsTagName = null;
function $01ff200d9f4ad87f$var$createGridComponent(_ref2) {
    var _class;
    var getColumnOffset = _ref2.getColumnOffset, getColumnStartIndexForOffset = _ref2.getColumnStartIndexForOffset, getColumnStopIndexForStartIndex = _ref2.getColumnStopIndexForStartIndex, getColumnWidth = _ref2.getColumnWidth, getEstimatedTotalHeight = _ref2.getEstimatedTotalHeight, getEstimatedTotalWidth = _ref2.getEstimatedTotalWidth, getOffsetForColumnAndAlignment = _ref2.getOffsetForColumnAndAlignment, getOffsetForRowAndAlignment = _ref2.getOffsetForRowAndAlignment, getRowHeight = _ref2.getRowHeight, getRowOffset = _ref2.getRowOffset, getRowStartIndexForOffset = _ref2.getRowStartIndexForOffset, getRowStopIndexForStartIndex = _ref2.getRowStopIndexForStartIndex, initInstanceProps = _ref2.initInstanceProps, shouldResetStyleCacheOnItemSizeChange = _ref2.shouldResetStyleCacheOnItemSizeChange, validateProps = _ref2.validateProps;
    return _class = /*#__PURE__*/ function(_PureComponent) {
        (0, $0df4b0e059b7ae39$export$2e2bcd8739ae039)(Grid, _PureComponent);
        // Always use explicit constructor for React components.
        // It produces less code after transpilation. (#26)
        // eslint-disable-next-line no-useless-constructor
        function Grid(props) {
            var _this;
            _this = _PureComponent.call(this, props) || this;
            _this._instanceProps = initInstanceProps(_this.props, (0, $ab559a235872eed7$export$2e2bcd8739ae039)(_this));
            _this._resetIsScrollingTimeoutId = null;
            _this._outerRef = void 0;
            _this.state = {
                instance: (0, $ab559a235872eed7$export$2e2bcd8739ae039)(_this),
                isScrolling: false,
                horizontalScrollDirection: "forward",
                scrollLeft: typeof _this.props.initialScrollLeft === "number" ? _this.props.initialScrollLeft : 0,
                scrollTop: typeof _this.props.initialScrollTop === "number" ? _this.props.initialScrollTop : 0,
                scrollUpdateWasRequested: false,
                verticalScrollDirection: "forward"
            };
            _this._callOnItemsRendered = void 0;
            _this._callOnItemsRendered = (0, $7f7c97f41a5d2ad0$export$2e2bcd8739ae039)(function(overscanColumnStartIndex, overscanColumnStopIndex, overscanRowStartIndex, overscanRowStopIndex, visibleColumnStartIndex, visibleColumnStopIndex, visibleRowStartIndex, visibleRowStopIndex) {
                return _this.props.onItemsRendered({
                    overscanColumnStartIndex: overscanColumnStartIndex,
                    overscanColumnStopIndex: overscanColumnStopIndex,
                    overscanRowStartIndex: overscanRowStartIndex,
                    overscanRowStopIndex: overscanRowStopIndex,
                    visibleColumnStartIndex: visibleColumnStartIndex,
                    visibleColumnStopIndex: visibleColumnStopIndex,
                    visibleRowStartIndex: visibleRowStartIndex,
                    visibleRowStopIndex: visibleRowStopIndex
                });
            });
            _this._callOnScroll = void 0;
            _this._callOnScroll = (0, $7f7c97f41a5d2ad0$export$2e2bcd8739ae039)(function(scrollLeft, scrollTop, horizontalScrollDirection, verticalScrollDirection, scrollUpdateWasRequested) {
                return _this.props.onScroll({
                    horizontalScrollDirection: horizontalScrollDirection,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    verticalScrollDirection: verticalScrollDirection,
                    scrollUpdateWasRequested: scrollUpdateWasRequested
                });
            });
            _this._getItemStyle = void 0;
            _this._getItemStyle = function(rowIndex, columnIndex) {
                var _this$props = _this.props, columnWidth = _this$props.columnWidth, direction = _this$props.direction, rowHeight = _this$props.rowHeight;
                var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && columnWidth, shouldResetStyleCacheOnItemSizeChange && direction, shouldResetStyleCacheOnItemSizeChange && rowHeight);
                var key = rowIndex + ":" + columnIndex;
                var style;
                if (itemStyleCache.hasOwnProperty(key)) style = itemStyleCache[key];
                else {
                    var _offset = getColumnOffset(_this.props, columnIndex, _this._instanceProps);
                    var isRtl = direction === "rtl";
                    itemStyleCache[key] = style = {
                        position: "absolute",
                        left: isRtl ? undefined : _offset,
                        right: isRtl ? _offset : undefined,
                        top: getRowOffset(_this.props, rowIndex, _this._instanceProps),
                        height: getRowHeight(_this.props, rowIndex, _this._instanceProps),
                        width: getColumnWidth(_this.props, columnIndex, _this._instanceProps)
                    };
                }
                return style;
            };
            _this._getItemStyleCache = void 0;
            _this._getItemStyleCache = (0, $7f7c97f41a5d2ad0$export$2e2bcd8739ae039)(function(_, __, ___) {
                return {};
            });
            _this._onScroll = function(event) {
                var _event$currentTarget = event.currentTarget, clientHeight = _event$currentTarget.clientHeight, clientWidth = _event$currentTarget.clientWidth, scrollLeft = _event$currentTarget.scrollLeft, scrollTop = _event$currentTarget.scrollTop, scrollHeight = _event$currentTarget.scrollHeight, scrollWidth = _event$currentTarget.scrollWidth;
                _this.setState(function(prevState) {
                    if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                    var direction = _this.props.direction; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
                    // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
                    var calculatedScrollLeft = scrollLeft;
                    if (direction === "rtl") switch($01ff200d9f4ad87f$var$getRTLOffsetType()){
                        case "negative":
                            calculatedScrollLeft = -scrollLeft;
                            break;
                        case "positive-descending":
                            calculatedScrollLeft = scrollWidth - clientWidth - scrollLeft;
                            break;
                    }
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    calculatedScrollLeft = Math.max(0, Math.min(calculatedScrollLeft, scrollWidth - clientWidth));
                    var calculatedScrollTop = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
                    return {
                        isScrolling: true,
                        horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? "forward" : "backward",
                        scrollLeft: calculatedScrollLeft,
                        scrollTop: calculatedScrollTop,
                        verticalScrollDirection: prevState.scrollTop < scrollTop ? "forward" : "backward",
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._outerRefSetter = function(ref) {
                var outerRef = _this.props.outerRef;
                _this._outerRef = ref;
                if (typeof outerRef === "function") outerRef(ref);
                else if (outerRef != null && typeof outerRef === "object" && outerRef.hasOwnProperty("current")) outerRef.current = ref;
            };
            _this._resetIsScrollingDebounced = function() {
                if (_this._resetIsScrollingTimeoutId !== null) $01ff200d9f4ad87f$var$cancelTimeout(_this._resetIsScrollingTimeoutId);
                _this._resetIsScrollingTimeoutId = $01ff200d9f4ad87f$var$requestTimeout(_this._resetIsScrolling, $01ff200d9f4ad87f$var$IS_SCROLLING_DEBOUNCE_INTERVAL);
            };
            _this._resetIsScrolling = function() {
                _this._resetIsScrollingTimeoutId = null;
                _this.setState({
                    isScrolling: false
                }, function() {
                    // Clear style cache after state update has been committed.
                    // This way we don't break pure sCU for items that don't use isScrolling param.
                    _this._getItemStyleCache(-1);
                });
            };
            return _this;
        }
        Grid.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            $01ff200d9f4ad87f$var$validateSharedProps(nextProps, prevState);
            validateProps(nextProps);
            return null;
        };
        var _proto = Grid.prototype;
        _proto.scrollTo = function scrollTo(_ref3) {
            var scrollLeft = _ref3.scrollLeft, scrollTop = _ref3.scrollTop;
            if (scrollLeft !== undefined) scrollLeft = Math.max(0, scrollLeft);
            if (scrollTop !== undefined) scrollTop = Math.max(0, scrollTop);
            this.setState(function(prevState) {
                if (scrollLeft === undefined) scrollLeft = prevState.scrollLeft;
                if (scrollTop === undefined) scrollTop = prevState.scrollTop;
                if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) return null;
                return {
                    horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? "forward" : "backward",
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    scrollUpdateWasRequested: true,
                    verticalScrollDirection: prevState.scrollTop < scrollTop ? "forward" : "backward"
                };
            }, this._resetIsScrollingDebounced);
        };
        _proto.scrollToItem = function scrollToItem(_ref4) {
            var _ref4$align = _ref4.align, align = _ref4$align === void 0 ? "auto" : _ref4$align, columnIndex = _ref4.columnIndex, rowIndex = _ref4.rowIndex;
            var _this$props2 = this.props, columnCount = _this$props2.columnCount, height = _this$props2.height, rowCount = _this$props2.rowCount, width = _this$props2.width;
            var _this$state = this.state, scrollLeft = _this$state.scrollLeft, scrollTop = _this$state.scrollTop;
            var scrollbarSize = $01ff200d9f4ad87f$var$getScrollbarSize();
            if (columnIndex !== undefined) columnIndex = Math.max(0, Math.min(columnIndex, columnCount - 1));
            if (rowIndex !== undefined) rowIndex = Math.max(0, Math.min(rowIndex, rowCount - 1));
            var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
            var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps); // The scrollbar size should be considered when scrolling an item into view,
            // to ensure it's fully visible.
            // But we only need to account for its size when it's actually visible.
            var horizontalScrollbarSize = estimatedTotalWidth > width ? scrollbarSize : 0;
            var verticalScrollbarSize = estimatedTotalHeight > height ? scrollbarSize : 0;
            this.scrollTo({
                scrollLeft: columnIndex !== undefined ? getOffsetForColumnAndAlignment(this.props, columnIndex, align, scrollLeft, this._instanceProps, verticalScrollbarSize) : scrollLeft,
                scrollTop: rowIndex !== undefined ? getOffsetForRowAndAlignment(this.props, rowIndex, align, scrollTop, this._instanceProps, horizontalScrollbarSize) : scrollTop
            });
        };
        _proto.componentDidMount = function componentDidMount() {
            var _this$props3 = this.props, initialScrollLeft = _this$props3.initialScrollLeft, initialScrollTop = _this$props3.initialScrollTop;
            if (this._outerRef != null) {
                var outerRef = this._outerRef;
                if (typeof initialScrollLeft === "number") outerRef.scrollLeft = initialScrollLeft;
                if (typeof initialScrollTop === "number") outerRef.scrollTop = initialScrollTop;
            }
            this._callPropsCallbacks();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            var direction = this.props.direction;
            var _this$state2 = this.state, scrollLeft = _this$state2.scrollLeft, scrollTop = _this$state2.scrollTop, scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;
            if (scrollUpdateWasRequested && this._outerRef != null) {
                // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                // So we need to determine which browser behavior we're dealing with, and mimic it.
                var outerRef = this._outerRef;
                if (direction === "rtl") switch($01ff200d9f4ad87f$var$getRTLOffsetType()){
                    case "negative":
                        outerRef.scrollLeft = -scrollLeft;
                        break;
                    case "positive-ascending":
                        outerRef.scrollLeft = scrollLeft;
                        break;
                    default:
                        var clientWidth = outerRef.clientWidth, scrollWidth = outerRef.scrollWidth;
                        outerRef.scrollLeft = scrollWidth - clientWidth - scrollLeft;
                        break;
                }
                else outerRef.scrollLeft = Math.max(0, scrollLeft);
                outerRef.scrollTop = Math.max(0, scrollTop);
            }
            this._callPropsCallbacks();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            if (this._resetIsScrollingTimeoutId !== null) $01ff200d9f4ad87f$var$cancelTimeout(this._resetIsScrollingTimeoutId);
        };
        _proto.render = function render() {
            var _this$props4 = this.props, children = _this$props4.children, className = _this$props4.className, columnCount = _this$props4.columnCount, direction = _this$props4.direction, height = _this$props4.height, innerRef = _this$props4.innerRef, innerElementType = _this$props4.innerElementType, innerTagName = _this$props4.innerTagName, itemData = _this$props4.itemData, _this$props4$itemKey = _this$props4.itemKey, itemKey = _this$props4$itemKey === void 0 ? $01ff200d9f4ad87f$var$defaultItemKey : _this$props4$itemKey, outerElementType = _this$props4.outerElementType, outerTagName = _this$props4.outerTagName, rowCount = _this$props4.rowCount, style = _this$props4.style, useIsScrolling = _this$props4.useIsScrolling, width = _this$props4.width;
            var isScrolling = this.state.isScrolling;
            var _this$_getHorizontalR = this._getHorizontalRangeToRender(), columnStartIndex = _this$_getHorizontalR[0], columnStopIndex = _this$_getHorizontalR[1];
            var _this$_getVerticalRan = this._getVerticalRangeToRender(), rowStartIndex = _this$_getVerticalRan[0], rowStopIndex = _this$_getVerticalRan[1];
            var items = [];
            if (columnCount > 0 && rowCount) {
                for(var _rowIndex = rowStartIndex; _rowIndex <= rowStopIndex; _rowIndex++)for(var _columnIndex = columnStartIndex; _columnIndex <= columnStopIndex; _columnIndex++)items.push((0, $2gcPZ.createElement)(children, {
                    columnIndex: _columnIndex,
                    data: itemData,
                    isScrolling: useIsScrolling ? isScrolling : undefined,
                    key: itemKey({
                        columnIndex: _columnIndex,
                        data: itemData,
                        rowIndex: _rowIndex
                    }),
                    rowIndex: _rowIndex,
                    style: this._getItemStyle(_rowIndex, _columnIndex)
                }));
            } // Read this value AFTER items have been created,
            // So their actual sizes (if variable) are taken into consideration.
            var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
            var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps);
            return (0, $2gcPZ.createElement)(outerElementType || outerTagName || "div", {
                className: className,
                onScroll: this._onScroll,
                ref: this._outerRefSetter,
                style: (0, $c7f2d8c8d4d86dfc$export$2e2bcd8739ae039)({
                    position: "relative",
                    height: height,
                    width: width,
                    overflow: "auto",
                    WebkitOverflowScrolling: "touch",
                    willChange: "transform",
                    direction: direction
                }, style)
            }, (0, $2gcPZ.createElement)(innerElementType || innerTagName || "div", {
                children: items,
                ref: innerRef,
                style: {
                    height: estimatedTotalHeight,
                    pointerEvents: isScrolling ? "none" : undefined,
                    width: estimatedTotalWidth
                }
            }));
        };
        _proto._callPropsCallbacks = function _callPropsCallbacks() {
            var _this$props5 = this.props, columnCount = _this$props5.columnCount, onItemsRendered = _this$props5.onItemsRendered, onScroll = _this$props5.onScroll, rowCount = _this$props5.rowCount;
            if (typeof onItemsRendered === "function") {
                if (columnCount > 0 && rowCount > 0) {
                    var _this$_getHorizontalR2 = this._getHorizontalRangeToRender(), _overscanColumnStartIndex = _this$_getHorizontalR2[0], _overscanColumnStopIndex = _this$_getHorizontalR2[1], _visibleColumnStartIndex = _this$_getHorizontalR2[2], _visibleColumnStopIndex = _this$_getHorizontalR2[3];
                    var _this$_getVerticalRan2 = this._getVerticalRangeToRender(), _overscanRowStartIndex = _this$_getVerticalRan2[0], _overscanRowStopIndex = _this$_getVerticalRan2[1], _visibleRowStartIndex = _this$_getVerticalRan2[2], _visibleRowStopIndex = _this$_getVerticalRan2[3];
                    this._callOnItemsRendered(_overscanColumnStartIndex, _overscanColumnStopIndex, _overscanRowStartIndex, _overscanRowStopIndex, _visibleColumnStartIndex, _visibleColumnStopIndex, _visibleRowStartIndex, _visibleRowStopIndex);
                }
            }
            if (typeof onScroll === "function") {
                var _this$state3 = this.state, _horizontalScrollDirection = _this$state3.horizontalScrollDirection, _scrollLeft = _this$state3.scrollLeft, _scrollTop = _this$state3.scrollTop, _scrollUpdateWasRequested = _this$state3.scrollUpdateWasRequested, _verticalScrollDirection = _this$state3.verticalScrollDirection;
                this._callOnScroll(_scrollLeft, _scrollTop, _horizontalScrollDirection, _verticalScrollDirection, _scrollUpdateWasRequested);
            }
        } // Lazily create and cache item styles while scrolling,
        ;
        _proto._getHorizontalRangeToRender = function _getHorizontalRangeToRender() {
            var _this$props6 = this.props, columnCount = _this$props6.columnCount, overscanColumnCount = _this$props6.overscanColumnCount, overscanColumnsCount = _this$props6.overscanColumnsCount, overscanCount = _this$props6.overscanCount, rowCount = _this$props6.rowCount;
            var _this$state4 = this.state, horizontalScrollDirection = _this$state4.horizontalScrollDirection, isScrolling = _this$state4.isScrolling, scrollLeft = _this$state4.scrollLeft;
            var overscanCountResolved = overscanColumnCount || overscanColumnsCount || overscanCount || 1;
            if (columnCount === 0 || rowCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getColumnStartIndexForOffset(this.props, scrollLeft, this._instanceProps);
            var stopIndex = getColumnStopIndexForStartIndex(this.props, startIndex, scrollLeft, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || horizontalScrollDirection === "backward" ? Math.max(1, overscanCountResolved) : 1;
            var overscanForward = !isScrolling || horizontalScrollDirection === "forward" ? Math.max(1, overscanCountResolved) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(columnCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        _proto._getVerticalRangeToRender = function _getVerticalRangeToRender() {
            var _this$props7 = this.props, columnCount = _this$props7.columnCount, overscanCount = _this$props7.overscanCount, overscanRowCount = _this$props7.overscanRowCount, overscanRowsCount = _this$props7.overscanRowsCount, rowCount = _this$props7.rowCount;
            var _this$state5 = this.state, isScrolling = _this$state5.isScrolling, verticalScrollDirection = _this$state5.verticalScrollDirection, scrollTop = _this$state5.scrollTop;
            var overscanCountResolved = overscanRowCount || overscanRowsCount || overscanCount || 1;
            if (columnCount === 0 || rowCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getRowStartIndexForOffset(this.props, scrollTop, this._instanceProps);
            var stopIndex = getRowStopIndexForStartIndex(this.props, startIndex, scrollTop, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || verticalScrollDirection === "backward" ? Math.max(1, overscanCountResolved) : 1;
            var overscanForward = !isScrolling || verticalScrollDirection === "forward" ? Math.max(1, overscanCountResolved) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(rowCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        return Grid;
    }((0, $2gcPZ.PureComponent)), _class.defaultProps = {
        direction: "ltr",
        itemData: undefined,
        useIsScrolling: false
    }, _class;
}
var $01ff200d9f4ad87f$var$validateSharedProps = function validateSharedProps(_ref5, _ref6) {
    var children = _ref5.children, direction = _ref5.direction, height = _ref5.height, innerTagName = _ref5.innerTagName, outerTagName = _ref5.outerTagName, overscanColumnsCount = _ref5.overscanColumnsCount, overscanCount = _ref5.overscanCount, overscanRowsCount = _ref5.overscanRowsCount, width = _ref5.width;
    var instance = _ref6.instance;
};
var $01ff200d9f4ad87f$var$DEFAULT_ESTIMATED_ITEM_SIZE = 50;
var $01ff200d9f4ad87f$var$getEstimatedTotalHeight = function getEstimatedTotalHeight(_ref, _ref2) {
    var rowCount = _ref.rowCount;
    var rowMetadataMap = _ref2.rowMetadataMap, estimatedRowHeight = _ref2.estimatedRowHeight, lastMeasuredRowIndex = _ref2.lastMeasuredRowIndex;
    var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredRowIndex >= rowCount) lastMeasuredRowIndex = rowCount - 1;
    if (lastMeasuredRowIndex >= 0) {
        var itemMetadata = rowMetadataMap[lastMeasuredRowIndex];
        totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = rowCount - lastMeasuredRowIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedRowHeight;
    return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};
var $01ff200d9f4ad87f$var$getEstimatedTotalWidth = function getEstimatedTotalWidth(_ref3, _ref4) {
    var columnCount = _ref3.columnCount;
    var columnMetadataMap = _ref4.columnMetadataMap, estimatedColumnWidth = _ref4.estimatedColumnWidth, lastMeasuredColumnIndex = _ref4.lastMeasuredColumnIndex;
    var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredColumnIndex >= columnCount) lastMeasuredColumnIndex = columnCount - 1;
    if (lastMeasuredColumnIndex >= 0) {
        var itemMetadata = columnMetadataMap[lastMeasuredColumnIndex];
        totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = columnCount - lastMeasuredColumnIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedColumnWidth;
    return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};
var $01ff200d9f4ad87f$var$getItemMetadata = function getItemMetadata(itemType, props, index, instanceProps) {
    var itemMetadataMap, itemSize, lastMeasuredIndex;
    if (itemType === "column") {
        itemMetadataMap = instanceProps.columnMetadataMap;
        itemSize = props.columnWidth;
        lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
    } else {
        itemMetadataMap = instanceProps.rowMetadataMap;
        itemSize = props.rowHeight;
        lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
    }
    if (index > lastMeasuredIndex) {
        var offset = 0;
        if (lastMeasuredIndex >= 0) {
            var itemMetadata = itemMetadataMap[lastMeasuredIndex];
            offset = itemMetadata.offset + itemMetadata.size;
        }
        for(var i = lastMeasuredIndex + 1; i <= index; i++){
            var size = itemSize(i);
            itemMetadataMap[i] = {
                offset: offset,
                size: size
            };
            offset += size;
        }
        if (itemType === "column") instanceProps.lastMeasuredColumnIndex = index;
        else instanceProps.lastMeasuredRowIndex = index;
    }
    return itemMetadataMap[index];
};
var $01ff200d9f4ad87f$var$findNearestItem = function findNearestItem(itemType, props, instanceProps, offset) {
    var itemMetadataMap, lastMeasuredIndex;
    if (itemType === "column") {
        itemMetadataMap = instanceProps.columnMetadataMap;
        lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
    } else {
        itemMetadataMap = instanceProps.rowMetadataMap;
        lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
    }
    var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;
    if (lastMeasuredItemOffset >= offset) // If we've already measured items within this range just use a binary search as it's faster.
    return $01ff200d9f4ad87f$var$findNearestItemBinarySearch(itemType, props, instanceProps, lastMeasuredIndex, 0, offset);
    else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return $01ff200d9f4ad87f$var$findNearestItemExponentialSearch(itemType, props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
};
var $01ff200d9f4ad87f$var$findNearestItemBinarySearch = function findNearestItemBinarySearch(itemType, props, instanceProps, high, low, offset) {
    while(low <= high){
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = $01ff200d9f4ad87f$var$getItemMetadata(itemType, props, middle, instanceProps).offset;
        if (currentOffset === offset) return middle;
        else if (currentOffset < offset) low = middle + 1;
        else if (currentOffset > offset) high = middle - 1;
    }
    if (low > 0) return low - 1;
    else return 0;
};
var $01ff200d9f4ad87f$var$findNearestItemExponentialSearch = function findNearestItemExponentialSearch(itemType, props, instanceProps, index, offset) {
    var itemCount = itemType === "column" ? props.columnCount : props.rowCount;
    var interval = 1;
    while(index < itemCount && $01ff200d9f4ad87f$var$getItemMetadata(itemType, props, index, instanceProps).offset < offset){
        index += interval;
        interval *= 2;
    }
    return $01ff200d9f4ad87f$var$findNearestItemBinarySearch(itemType, props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};
var $01ff200d9f4ad87f$var$getOffsetForIndexAndAlignment = function getOffsetForIndexAndAlignment(itemType, props, index, align, scrollOffset, instanceProps, scrollbarSize) {
    var size = itemType === "column" ? props.width : props.height;
    var itemMetadata = $01ff200d9f4ad87f$var$getItemMetadata(itemType, props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
    // To ensure it reflects actual measurements instead of just estimates.
    var estimatedTotalSize = itemType === "column" ? $01ff200d9f4ad87f$var$getEstimatedTotalWidth(props, instanceProps) : $01ff200d9f4ad87f$var$getEstimatedTotalHeight(props, instanceProps);
    var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
    var minOffset = Math.max(0, itemMetadata.offset - size + scrollbarSize + itemMetadata.size);
    if (align === "smart") {
        if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = "auto";
        else align = "center";
    }
    switch(align){
        case "start":
            return maxOffset;
        case "end":
            return minOffset;
        case "center":
            return Math.round(minOffset + (maxOffset - minOffset) / 2);
        case "auto":
        default:
            if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
            else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
            // this value can be larger than maxOffset when at the end of the list
            return minOffset;
            else if (scrollOffset < minOffset) return minOffset;
            else return maxOffset;
    }
};
var $01ff200d9f4ad87f$export$32c206c84102e73c = /*#__PURE__*/ $01ff200d9f4ad87f$var$createGridComponent({
    getColumnOffset: function getColumnOffset(props, index, instanceProps) {
        return $01ff200d9f4ad87f$var$getItemMetadata("column", props, index, instanceProps).offset;
    },
    getColumnStartIndexForOffset: function getColumnStartIndexForOffset(props, scrollLeft, instanceProps) {
        return $01ff200d9f4ad87f$var$findNearestItem("column", props, instanceProps, scrollLeft);
    },
    getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(props, startIndex, scrollLeft, instanceProps) {
        var columnCount = props.columnCount, width = props.width;
        var itemMetadata = $01ff200d9f4ad87f$var$getItemMetadata("column", props, startIndex, instanceProps);
        var maxOffset = scrollLeft + width;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < columnCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $01ff200d9f4ad87f$var$getItemMetadata("column", props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    getColumnWidth: function getColumnWidth(props, index, instanceProps) {
        return instanceProps.columnMetadataMap[index].size;
    },
    getEstimatedTotalHeight: $01ff200d9f4ad87f$var$getEstimatedTotalHeight,
    getEstimatedTotalWidth: $01ff200d9f4ad87f$var$getEstimatedTotalWidth,
    getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        return $01ff200d9f4ad87f$var$getOffsetForIndexAndAlignment("column", props, index, align, scrollOffset, instanceProps, scrollbarSize);
    },
    getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        return $01ff200d9f4ad87f$var$getOffsetForIndexAndAlignment("row", props, index, align, scrollOffset, instanceProps, scrollbarSize);
    },
    getRowOffset: function getRowOffset(props, index, instanceProps) {
        return $01ff200d9f4ad87f$var$getItemMetadata("row", props, index, instanceProps).offset;
    },
    getRowHeight: function getRowHeight(props, index, instanceProps) {
        return instanceProps.rowMetadataMap[index].size;
    },
    getRowStartIndexForOffset: function getRowStartIndexForOffset(props, scrollTop, instanceProps) {
        return $01ff200d9f4ad87f$var$findNearestItem("row", props, instanceProps, scrollTop);
    },
    getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(props, startIndex, scrollTop, instanceProps) {
        var rowCount = props.rowCount, height = props.height;
        var itemMetadata = $01ff200d9f4ad87f$var$getItemMetadata("row", props, startIndex, instanceProps);
        var maxOffset = scrollTop + height;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < rowCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $01ff200d9f4ad87f$var$getItemMetadata("row", props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    initInstanceProps: function initInstanceProps(props, instance) {
        var _ref5 = props, estimatedColumnWidth = _ref5.estimatedColumnWidth, estimatedRowHeight = _ref5.estimatedRowHeight;
        var instanceProps = {
            columnMetadataMap: {},
            estimatedColumnWidth: estimatedColumnWidth || $01ff200d9f4ad87f$var$DEFAULT_ESTIMATED_ITEM_SIZE,
            estimatedRowHeight: estimatedRowHeight || $01ff200d9f4ad87f$var$DEFAULT_ESTIMATED_ITEM_SIZE,
            lastMeasuredColumnIndex: -1,
            lastMeasuredRowIndex: -1,
            rowMetadataMap: {}
        };
        instance.resetAfterColumnIndex = function(columnIndex, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instance.resetAfterIndices({
                columnIndex: columnIndex,
                shouldForceUpdate: shouldForceUpdate
            });
        };
        instance.resetAfterRowIndex = function(rowIndex, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instance.resetAfterIndices({
                rowIndex: rowIndex,
                shouldForceUpdate: shouldForceUpdate
            });
        };
        instance.resetAfterIndices = function(_ref6) {
            var columnIndex = _ref6.columnIndex, rowIndex = _ref6.rowIndex, _ref6$shouldForceUpda = _ref6.shouldForceUpdate, shouldForceUpdate = _ref6$shouldForceUpda === void 0 ? true : _ref6$shouldForceUpda;
            if (typeof columnIndex === "number") instanceProps.lastMeasuredColumnIndex = Math.min(instanceProps.lastMeasuredColumnIndex, columnIndex - 1);
            if (typeof rowIndex === "number") instanceProps.lastMeasuredRowIndex = Math.min(instanceProps.lastMeasuredRowIndex, rowIndex - 1);
             // We could potentially optimize further by only evicting styles after this index,
            // But since styles are only cached while scrolling is in progress-
            // It seems an unnecessary optimization.
            // It's unlikely that resetAfterIndex() will be called while a user is scrolling.
            instance._getItemStyleCache(-1);
            if (shouldForceUpdate) instance.forceUpdate();
        };
        return instanceProps;
    },
    shouldResetStyleCacheOnItemSizeChange: false,
    validateProps: function validateProps(_ref7) {
        var columnWidth = _ref7.columnWidth, rowHeight = _ref7.rowHeight;
    }
});
var $01ff200d9f4ad87f$var$IS_SCROLLING_DEBOUNCE_INTERVAL$1 = 150;
var $01ff200d9f4ad87f$var$defaultItemKey$1 = function defaultItemKey(index, data) {
    return index;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.
var $01ff200d9f4ad87f$var$devWarningsDirection = null;
var $01ff200d9f4ad87f$var$devWarningsTagName$1 = null;
function $01ff200d9f4ad87f$var$createListComponent(_ref) {
    var _class;
    var getItemOffset = _ref.getItemOffset, getEstimatedTotalSize = _ref.getEstimatedTotalSize, getItemSize = _ref.getItemSize, getOffsetForIndexAndAlignment = _ref.getOffsetForIndexAndAlignment, getStartIndexForOffset = _ref.getStartIndexForOffset, getStopIndexForStartIndex = _ref.getStopIndexForStartIndex, initInstanceProps = _ref.initInstanceProps, shouldResetStyleCacheOnItemSizeChange = _ref.shouldResetStyleCacheOnItemSizeChange, validateProps = _ref.validateProps;
    return _class = /*#__PURE__*/ function(_PureComponent) {
        (0, $0df4b0e059b7ae39$export$2e2bcd8739ae039)(List, _PureComponent);
        // Always use explicit constructor for React components.
        // It produces less code after transpilation. (#26)
        // eslint-disable-next-line no-useless-constructor
        function List(props) {
            var _this;
            _this = _PureComponent.call(this, props) || this;
            _this._instanceProps = initInstanceProps(_this.props, (0, $ab559a235872eed7$export$2e2bcd8739ae039)(_this));
            _this._outerRef = void 0;
            _this._resetIsScrollingTimeoutId = null;
            _this.state = {
                instance: (0, $ab559a235872eed7$export$2e2bcd8739ae039)(_this),
                isScrolling: false,
                scrollDirection: "forward",
                scrollOffset: typeof _this.props.initialScrollOffset === "number" ? _this.props.initialScrollOffset : 0,
                scrollUpdateWasRequested: false
            };
            _this._callOnItemsRendered = void 0;
            _this._callOnItemsRendered = (0, $7f7c97f41a5d2ad0$export$2e2bcd8739ae039)(function(overscanStartIndex, overscanStopIndex, visibleStartIndex, visibleStopIndex) {
                return _this.props.onItemsRendered({
                    overscanStartIndex: overscanStartIndex,
                    overscanStopIndex: overscanStopIndex,
                    visibleStartIndex: visibleStartIndex,
                    visibleStopIndex: visibleStopIndex
                });
            });
            _this._callOnScroll = void 0;
            _this._callOnScroll = (0, $7f7c97f41a5d2ad0$export$2e2bcd8739ae039)(function(scrollDirection, scrollOffset, scrollUpdateWasRequested) {
                return _this.props.onScroll({
                    scrollDirection: scrollDirection,
                    scrollOffset: scrollOffset,
                    scrollUpdateWasRequested: scrollUpdateWasRequested
                });
            });
            _this._getItemStyle = void 0;
            _this._getItemStyle = function(index) {
                var _this$props = _this.props, direction = _this$props.direction, itemSize = _this$props.itemSize, layout = _this$props.layout;
                var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && itemSize, shouldResetStyleCacheOnItemSizeChange && layout, shouldResetStyleCacheOnItemSizeChange && direction);
                var style;
                if (itemStyleCache.hasOwnProperty(index)) style = itemStyleCache[index];
                else {
                    var _offset = getItemOffset(_this.props, index, _this._instanceProps);
                    var size = getItemSize(_this.props, index, _this._instanceProps); // TODO Deprecate direction "horizontal"
                    var isHorizontal = direction === "horizontal" || layout === "horizontal";
                    var isRtl = direction === "rtl";
                    var offsetHorizontal = isHorizontal ? _offset : 0;
                    itemStyleCache[index] = style = {
                        position: "absolute",
                        left: isRtl ? undefined : offsetHorizontal,
                        right: isRtl ? offsetHorizontal : undefined,
                        top: !isHorizontal ? _offset : 0,
                        height: !isHorizontal ? size : "100%",
                        width: isHorizontal ? size : "100%"
                    };
                }
                return style;
            };
            _this._getItemStyleCache = void 0;
            _this._getItemStyleCache = (0, $7f7c97f41a5d2ad0$export$2e2bcd8739ae039)(function(_, __, ___) {
                return {};
            });
            _this._onScrollHorizontal = function(event) {
                var _event$currentTarget = event.currentTarget, clientWidth = _event$currentTarget.clientWidth, scrollLeft = _event$currentTarget.scrollLeft, scrollWidth = _event$currentTarget.scrollWidth;
                _this.setState(function(prevState) {
                    if (prevState.scrollOffset === scrollLeft) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                    var direction = _this.props.direction;
                    var scrollOffset = scrollLeft;
                    if (direction === "rtl") // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
                    // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
                    switch($01ff200d9f4ad87f$var$getRTLOffsetType()){
                        case "negative":
                            scrollOffset = -scrollLeft;
                            break;
                        case "positive-descending":
                            scrollOffset = scrollWidth - clientWidth - scrollLeft;
                            break;
                    }
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    scrollOffset = Math.max(0, Math.min(scrollOffset, scrollWidth - clientWidth));
                    return {
                        isScrolling: true,
                        scrollDirection: prevState.scrollOffset < scrollLeft ? "forward" : "backward",
                        scrollOffset: scrollOffset,
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._onScrollVertical = function(event) {
                var _event$currentTarget2 = event.currentTarget, clientHeight = _event$currentTarget2.clientHeight, scrollHeight = _event$currentTarget2.scrollHeight, scrollTop = _event$currentTarget2.scrollTop;
                _this.setState(function(prevState) {
                    if (prevState.scrollOffset === scrollTop) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    var scrollOffset = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
                    return {
                        isScrolling: true,
                        scrollDirection: prevState.scrollOffset < scrollOffset ? "forward" : "backward",
                        scrollOffset: scrollOffset,
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._outerRefSetter = function(ref) {
                var outerRef = _this.props.outerRef;
                _this._outerRef = ref;
                if (typeof outerRef === "function") outerRef(ref);
                else if (outerRef != null && typeof outerRef === "object" && outerRef.hasOwnProperty("current")) outerRef.current = ref;
            };
            _this._resetIsScrollingDebounced = function() {
                if (_this._resetIsScrollingTimeoutId !== null) $01ff200d9f4ad87f$var$cancelTimeout(_this._resetIsScrollingTimeoutId);
                _this._resetIsScrollingTimeoutId = $01ff200d9f4ad87f$var$requestTimeout(_this._resetIsScrolling, $01ff200d9f4ad87f$var$IS_SCROLLING_DEBOUNCE_INTERVAL$1);
            };
            _this._resetIsScrolling = function() {
                _this._resetIsScrollingTimeoutId = null;
                _this.setState({
                    isScrolling: false
                }, function() {
                    // Clear style cache after state update has been committed.
                    // This way we don't break pure sCU for items that don't use isScrolling param.
                    _this._getItemStyleCache(-1, null);
                });
            };
            return _this;
        }
        List.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            $01ff200d9f4ad87f$var$validateSharedProps$1(nextProps, prevState);
            validateProps(nextProps);
            return null;
        };
        var _proto = List.prototype;
        _proto.scrollTo = function scrollTo(scrollOffset) {
            scrollOffset = Math.max(0, scrollOffset);
            this.setState(function(prevState) {
                if (prevState.scrollOffset === scrollOffset) return null;
                return {
                    scrollDirection: prevState.scrollOffset < scrollOffset ? "forward" : "backward",
                    scrollOffset: scrollOffset,
                    scrollUpdateWasRequested: true
                };
            }, this._resetIsScrollingDebounced);
        };
        _proto.scrollToItem = function scrollToItem(index, align) {
            if (align === void 0) align = "auto";
            var _this$props2 = this.props, itemCount = _this$props2.itemCount, layout = _this$props2.layout;
            var scrollOffset = this.state.scrollOffset;
            index = Math.max(0, Math.min(index, itemCount - 1)); // The scrollbar size should be considered when scrolling an item into view, to ensure it's fully visible.
            // But we only need to account for its size when it's actually visible.
            // This is an edge case for lists; normally they only scroll in the dominant direction.
            var scrollbarSize = 0;
            if (this._outerRef) {
                var outerRef = this._outerRef;
                if (layout === "vertical") scrollbarSize = outerRef.scrollWidth > outerRef.clientWidth ? $01ff200d9f4ad87f$var$getScrollbarSize() : 0;
                else scrollbarSize = outerRef.scrollHeight > outerRef.clientHeight ? $01ff200d9f4ad87f$var$getScrollbarSize() : 0;
            }
            this.scrollTo(getOffsetForIndexAndAlignment(this.props, index, align, scrollOffset, this._instanceProps, scrollbarSize));
        };
        _proto.componentDidMount = function componentDidMount() {
            var _this$props3 = this.props, direction = _this$props3.direction, initialScrollOffset = _this$props3.initialScrollOffset, layout = _this$props3.layout;
            if (typeof initialScrollOffset === "number" && this._outerRef != null) {
                var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"
                if (direction === "horizontal" || layout === "horizontal") outerRef.scrollLeft = initialScrollOffset;
                else outerRef.scrollTop = initialScrollOffset;
            }
            this._callPropsCallbacks();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            var _this$props4 = this.props, direction = _this$props4.direction, layout = _this$props4.layout;
            var _this$state = this.state, scrollOffset = _this$state.scrollOffset, scrollUpdateWasRequested = _this$state.scrollUpdateWasRequested;
            if (scrollUpdateWasRequested && this._outerRef != null) {
                var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"
                if (direction === "horizontal" || layout === "horizontal") {
                    if (direction === "rtl") // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // So we need to determine which browser behavior we're dealing with, and mimic it.
                    switch($01ff200d9f4ad87f$var$getRTLOffsetType()){
                        case "negative":
                            outerRef.scrollLeft = -scrollOffset;
                            break;
                        case "positive-ascending":
                            outerRef.scrollLeft = scrollOffset;
                            break;
                        default:
                            var clientWidth = outerRef.clientWidth, scrollWidth = outerRef.scrollWidth;
                            outerRef.scrollLeft = scrollWidth - clientWidth - scrollOffset;
                            break;
                    }
                    else outerRef.scrollLeft = scrollOffset;
                } else outerRef.scrollTop = scrollOffset;
            }
            this._callPropsCallbacks();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            if (this._resetIsScrollingTimeoutId !== null) $01ff200d9f4ad87f$var$cancelTimeout(this._resetIsScrollingTimeoutId);
        };
        _proto.render = function render() {
            var _this$props5 = this.props, children = _this$props5.children, className = _this$props5.className, direction = _this$props5.direction, height = _this$props5.height, innerRef = _this$props5.innerRef, innerElementType = _this$props5.innerElementType, innerTagName = _this$props5.innerTagName, itemCount = _this$props5.itemCount, itemData = _this$props5.itemData, _this$props5$itemKey = _this$props5.itemKey, itemKey = _this$props5$itemKey === void 0 ? $01ff200d9f4ad87f$var$defaultItemKey$1 : _this$props5$itemKey, layout = _this$props5.layout, outerElementType = _this$props5.outerElementType, outerTagName = _this$props5.outerTagName, style = _this$props5.style, useIsScrolling = _this$props5.useIsScrolling, width = _this$props5.width;
            var isScrolling = this.state.isScrolling; // TODO Deprecate direction "horizontal"
            var isHorizontal = direction === "horizontal" || layout === "horizontal";
            var onScroll = isHorizontal ? this._onScrollHorizontal : this._onScrollVertical;
            var _this$_getRangeToRend = this._getRangeToRender(), startIndex = _this$_getRangeToRend[0], stopIndex = _this$_getRangeToRend[1];
            var items = [];
            if (itemCount > 0) for(var _index = startIndex; _index <= stopIndex; _index++)items.push((0, $2gcPZ.createElement)(children, {
                data: itemData,
                key: itemKey(_index, itemData),
                index: _index,
                isScrolling: useIsScrolling ? isScrolling : undefined,
                style: this._getItemStyle(_index)
            }));
             // Read this value AFTER items have been created,
            // So their actual sizes (if variable) are taken into consideration.
            var estimatedTotalSize = getEstimatedTotalSize(this.props, this._instanceProps);
            return (0, $2gcPZ.createElement)(outerElementType || outerTagName || "div", {
                className: className,
                onScroll: onScroll,
                ref: this._outerRefSetter,
                style: (0, $c7f2d8c8d4d86dfc$export$2e2bcd8739ae039)({
                    position: "relative",
                    height: height,
                    width: width,
                    overflow: "auto",
                    WebkitOverflowScrolling: "touch",
                    willChange: "transform",
                    direction: direction
                }, style)
            }, (0, $2gcPZ.createElement)(innerElementType || innerTagName || "div", {
                children: items,
                ref: innerRef,
                style: {
                    height: isHorizontal ? "100%" : estimatedTotalSize,
                    pointerEvents: isScrolling ? "none" : undefined,
                    width: isHorizontal ? estimatedTotalSize : "100%"
                }
            }));
        };
        _proto._callPropsCallbacks = function _callPropsCallbacks() {
            if (typeof this.props.onItemsRendered === "function") {
                var itemCount = this.props.itemCount;
                if (itemCount > 0) {
                    var _this$_getRangeToRend2 = this._getRangeToRender(), _overscanStartIndex = _this$_getRangeToRend2[0], _overscanStopIndex = _this$_getRangeToRend2[1], _visibleStartIndex = _this$_getRangeToRend2[2], _visibleStopIndex = _this$_getRangeToRend2[3];
                    this._callOnItemsRendered(_overscanStartIndex, _overscanStopIndex, _visibleStartIndex, _visibleStopIndex);
                }
            }
            if (typeof this.props.onScroll === "function") {
                var _this$state2 = this.state, _scrollDirection = _this$state2.scrollDirection, _scrollOffset = _this$state2.scrollOffset, _scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;
                this._callOnScroll(_scrollDirection, _scrollOffset, _scrollUpdateWasRequested);
            }
        } // Lazily create and cache item styles while scrolling,
        ;
        _proto._getRangeToRender = function _getRangeToRender() {
            var _this$props6 = this.props, itemCount = _this$props6.itemCount, overscanCount = _this$props6.overscanCount;
            var _this$state3 = this.state, isScrolling = _this$state3.isScrolling, scrollDirection = _this$state3.scrollDirection, scrollOffset = _this$state3.scrollOffset;
            if (itemCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getStartIndexForOffset(this.props, scrollOffset, this._instanceProps);
            var stopIndex = getStopIndexForStartIndex(this.props, startIndex, scrollOffset, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || scrollDirection === "backward" ? Math.max(1, overscanCount) : 1;
            var overscanForward = !isScrolling || scrollDirection === "forward" ? Math.max(1, overscanCount) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(itemCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        return List;
    }((0, $2gcPZ.PureComponent)), _class.defaultProps = {
        direction: "ltr",
        itemData: undefined,
        layout: "vertical",
        overscanCount: 2,
        useIsScrolling: false
    }, _class;
} // NOTE: I considered further wrapping individual items with a pure ListItem component.
// This would avoid ever calling the render function for the same index more than once,
// But it would also add the overhead of a lot of components/fibers.
// I assume people already do this (render function returning a class component),
// So my doing it would just unnecessarily double the wrappers.
var $01ff200d9f4ad87f$var$validateSharedProps$1 = function validateSharedProps(_ref2, _ref3) {
    var children = _ref2.children, direction = _ref2.direction, height = _ref2.height, layout = _ref2.layout, innerTagName = _ref2.innerTagName, outerTagName = _ref2.outerTagName, width = _ref2.width;
    var instance = _ref3.instance;
    var isHorizontal;
};
var $01ff200d9f4ad87f$var$DEFAULT_ESTIMATED_ITEM_SIZE$1 = 50;
var $01ff200d9f4ad87f$var$getItemMetadata$1 = function getItemMetadata(props, index, instanceProps) {
    var _ref = props, itemSize = _ref.itemSize;
    var itemMetadataMap = instanceProps.itemMetadataMap, lastMeasuredIndex = instanceProps.lastMeasuredIndex;
    if (index > lastMeasuredIndex) {
        var offset = 0;
        if (lastMeasuredIndex >= 0) {
            var itemMetadata = itemMetadataMap[lastMeasuredIndex];
            offset = itemMetadata.offset + itemMetadata.size;
        }
        for(var i = lastMeasuredIndex + 1; i <= index; i++){
            var size = itemSize(i);
            itemMetadataMap[i] = {
                offset: offset,
                size: size
            };
            offset += size;
        }
        instanceProps.lastMeasuredIndex = index;
    }
    return itemMetadataMap[index];
};
var $01ff200d9f4ad87f$var$findNearestItem$1 = function findNearestItem(props, instanceProps, offset) {
    var itemMetadataMap = instanceProps.itemMetadataMap, lastMeasuredIndex = instanceProps.lastMeasuredIndex;
    var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;
    if (lastMeasuredItemOffset >= offset) // If we've already measured items within this range just use a binary search as it's faster.
    return $01ff200d9f4ad87f$var$findNearestItemBinarySearch$1(props, instanceProps, lastMeasuredIndex, 0, offset);
    else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return $01ff200d9f4ad87f$var$findNearestItemExponentialSearch$1(props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
};
var $01ff200d9f4ad87f$var$findNearestItemBinarySearch$1 = function findNearestItemBinarySearch(props, instanceProps, high, low, offset) {
    while(low <= high){
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = $01ff200d9f4ad87f$var$getItemMetadata$1(props, middle, instanceProps).offset;
        if (currentOffset === offset) return middle;
        else if (currentOffset < offset) low = middle + 1;
        else if (currentOffset > offset) high = middle - 1;
    }
    if (low > 0) return low - 1;
    else return 0;
};
var $01ff200d9f4ad87f$var$findNearestItemExponentialSearch$1 = function findNearestItemExponentialSearch(props, instanceProps, index, offset) {
    var itemCount = props.itemCount;
    var interval = 1;
    while(index < itemCount && $01ff200d9f4ad87f$var$getItemMetadata$1(props, index, instanceProps).offset < offset){
        index += interval;
        interval *= 2;
    }
    return $01ff200d9f4ad87f$var$findNearestItemBinarySearch$1(props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};
var $01ff200d9f4ad87f$var$getEstimatedTotalSize = function getEstimatedTotalSize(_ref2, _ref3) {
    var itemCount = _ref2.itemCount;
    var itemMetadataMap = _ref3.itemMetadataMap, estimatedItemSize = _ref3.estimatedItemSize, lastMeasuredIndex = _ref3.lastMeasuredIndex;
    var totalSizeOfMeasuredItems = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredIndex >= itemCount) lastMeasuredIndex = itemCount - 1;
    if (lastMeasuredIndex >= 0) {
        var itemMetadata = itemMetadataMap[lastMeasuredIndex];
        totalSizeOfMeasuredItems = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = itemCount - lastMeasuredIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedItemSize;
    return totalSizeOfMeasuredItems + totalSizeOfUnmeasuredItems;
};
var $01ff200d9f4ad87f$export$d8ac3b6b20be856e = /*#__PURE__*/ $01ff200d9f4ad87f$var$createListComponent({
    getItemOffset: function getItemOffset(props, index, instanceProps) {
        return $01ff200d9f4ad87f$var$getItemMetadata$1(props, index, instanceProps).offset;
    },
    getItemSize: function getItemSize(props, index, instanceProps) {
        return instanceProps.itemMetadataMap[index].size;
    },
    getEstimatedTotalSize: $01ff200d9f4ad87f$var$getEstimatedTotalSize,
    getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        var direction = props.direction, height = props.height, layout = props.layout, width = props.width; // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === "horizontal" || layout === "horizontal";
        var size = isHorizontal ? width : height;
        var itemMetadata = $01ff200d9f4ad87f$var$getItemMetadata$1(props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
        // To ensure it reflects actual measurements instead of just estimates.
        var estimatedTotalSize = $01ff200d9f4ad87f$var$getEstimatedTotalSize(props, instanceProps);
        var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
        var minOffset = Math.max(0, itemMetadata.offset - size + itemMetadata.size + scrollbarSize);
        if (align === "smart") {
            if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = "auto";
            else align = "center";
        }
        switch(align){
            case "start":
                return maxOffset;
            case "end":
                return minOffset;
            case "center":
                return Math.round(minOffset + (maxOffset - minOffset) / 2);
            case "auto":
            default:
                if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
                else if (scrollOffset < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getStartIndexForOffset: function getStartIndexForOffset(props, offset, instanceProps) {
        return $01ff200d9f4ad87f$var$findNearestItem$1(props, instanceProps, offset);
    },
    getStopIndexForStartIndex: function getStopIndexForStartIndex(props, startIndex, scrollOffset, instanceProps) {
        var direction = props.direction, height = props.height, itemCount = props.itemCount, layout = props.layout, width = props.width; // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === "horizontal" || layout === "horizontal";
        var size = isHorizontal ? width : height;
        var itemMetadata = $01ff200d9f4ad87f$var$getItemMetadata$1(props, startIndex, instanceProps);
        var maxOffset = scrollOffset + size;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < itemCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $01ff200d9f4ad87f$var$getItemMetadata$1(props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    initInstanceProps: function initInstanceProps(props, instance) {
        var _ref4 = props, estimatedItemSize = _ref4.estimatedItemSize;
        var instanceProps = {
            itemMetadataMap: {},
            estimatedItemSize: estimatedItemSize || $01ff200d9f4ad87f$var$DEFAULT_ESTIMATED_ITEM_SIZE$1,
            lastMeasuredIndex: -1
        };
        instance.resetAfterIndex = function(index, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instanceProps.lastMeasuredIndex = Math.min(instanceProps.lastMeasuredIndex, index - 1); // We could potentially optimize further by only evicting styles after this index,
            // But since styles are only cached while scrolling is in progress-
            // It seems an unnecessary optimization.
            // It's unlikely that resetAfterIndex() will be called while a user is scrolling.
            instance._getItemStyleCache(-1);
            if (shouldForceUpdate) instance.forceUpdate();
        };
        return instanceProps;
    },
    shouldResetStyleCacheOnItemSizeChange: false,
    validateProps: function validateProps(_ref5) {
        var itemSize = _ref5.itemSize;
    }
});
var $01ff200d9f4ad87f$export$f331158cccad7361 = /*#__PURE__*/ $01ff200d9f4ad87f$var$createGridComponent({
    getColumnOffset: function getColumnOffset(_ref, index) {
        var columnWidth = _ref.columnWidth;
        return index * columnWidth;
    },
    getColumnWidth: function getColumnWidth(_ref2, index) {
        var columnWidth = _ref2.columnWidth;
        return columnWidth;
    },
    getRowOffset: function getRowOffset(_ref3, index) {
        var rowHeight = _ref3.rowHeight;
        return index * rowHeight;
    },
    getRowHeight: function getRowHeight(_ref4, index) {
        var rowHeight = _ref4.rowHeight;
        return rowHeight;
    },
    getEstimatedTotalHeight: function getEstimatedTotalHeight(_ref5) {
        var rowCount = _ref5.rowCount, rowHeight = _ref5.rowHeight;
        return rowHeight * rowCount;
    },
    getEstimatedTotalWidth: function getEstimatedTotalWidth(_ref6) {
        var columnCount = _ref6.columnCount, columnWidth = _ref6.columnWidth;
        return columnWidth * columnCount;
    },
    getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(_ref7, columnIndex, align, scrollLeft, instanceProps, scrollbarSize) {
        var columnCount = _ref7.columnCount, columnWidth = _ref7.columnWidth, width = _ref7.width;
        var lastColumnOffset = Math.max(0, columnCount * columnWidth - width);
        var maxOffset = Math.min(lastColumnOffset, columnIndex * columnWidth);
        var minOffset = Math.max(0, columnIndex * columnWidth - width + scrollbarSize + columnWidth);
        if (align === "smart") {
            if (scrollLeft >= minOffset - width && scrollLeft <= maxOffset + width) align = "auto";
            else align = "center";
        }
        switch(align){
            case "start":
                return maxOffset;
            case "end":
                return minOffset;
            case "center":
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(width / 2)) return 0; // near the beginning
                else if (middleOffset > lastColumnOffset + Math.floor(width / 2)) return lastColumnOffset; // near the end
                else return middleOffset;
            case "auto":
            default:
                if (scrollLeft >= minOffset && scrollLeft <= maxOffset) return scrollLeft;
                else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
                // this value can be larger than maxOffset when at the end of the list
                return minOffset;
                else if (scrollLeft < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(_ref8, rowIndex, align, scrollTop, instanceProps, scrollbarSize) {
        var rowHeight = _ref8.rowHeight, height = _ref8.height, rowCount = _ref8.rowCount;
        var lastRowOffset = Math.max(0, rowCount * rowHeight - height);
        var maxOffset = Math.min(lastRowOffset, rowIndex * rowHeight);
        var minOffset = Math.max(0, rowIndex * rowHeight - height + scrollbarSize + rowHeight);
        if (align === "smart") {
            if (scrollTop >= minOffset - height && scrollTop <= maxOffset + height) align = "auto";
            else align = "center";
        }
        switch(align){
            case "start":
                return maxOffset;
            case "end":
                return minOffset;
            case "center":
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(height / 2)) return 0; // near the beginning
                else if (middleOffset > lastRowOffset + Math.floor(height / 2)) return lastRowOffset; // near the end
                else return middleOffset;
            case "auto":
            default:
                if (scrollTop >= minOffset && scrollTop <= maxOffset) return scrollTop;
                else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
                // this value can be larger than maxOffset when at the end of the list
                return minOffset;
                else if (scrollTop < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getColumnStartIndexForOffset: function getColumnStartIndexForOffset(_ref9, scrollLeft) {
        var columnWidth = _ref9.columnWidth, columnCount = _ref9.columnCount;
        return Math.max(0, Math.min(columnCount - 1, Math.floor(scrollLeft / columnWidth)));
    },
    getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(_ref10, startIndex, scrollLeft) {
        var columnWidth = _ref10.columnWidth, columnCount = _ref10.columnCount, width = _ref10.width;
        var left = startIndex * columnWidth;
        var numVisibleColumns = Math.ceil((width + scrollLeft - left) / columnWidth);
        return Math.max(0, Math.min(columnCount - 1, startIndex + numVisibleColumns - 1 // -1 is because stop index is inclusive
        ));
    },
    getRowStartIndexForOffset: function getRowStartIndexForOffset(_ref11, scrollTop) {
        var rowHeight = _ref11.rowHeight, rowCount = _ref11.rowCount;
        return Math.max(0, Math.min(rowCount - 1, Math.floor(scrollTop / rowHeight)));
    },
    getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(_ref12, startIndex, scrollTop) {
        var rowHeight = _ref12.rowHeight, rowCount = _ref12.rowCount, height = _ref12.height;
        var top = startIndex * rowHeight;
        var numVisibleRows = Math.ceil((height + scrollTop - top) / rowHeight);
        return Math.max(0, Math.min(rowCount - 1, startIndex + numVisibleRows - 1 // -1 is because stop index is inclusive
        ));
    },
    initInstanceProps: function initInstanceProps(props) {},
    shouldResetStyleCacheOnItemSizeChange: true,
    validateProps: function validateProps(_ref13) {
        var columnWidth = _ref13.columnWidth, rowHeight = _ref13.rowHeight;
    }
});
var $01ff200d9f4ad87f$export$ae9e55e1d8a2f4b7 = /*#__PURE__*/ $01ff200d9f4ad87f$var$createListComponent({
    getItemOffset: function getItemOffset(_ref, index) {
        var itemSize = _ref.itemSize;
        return index * itemSize;
    },
    getItemSize: function getItemSize(_ref2, index) {
        var itemSize = _ref2.itemSize;
        return itemSize;
    },
    getEstimatedTotalSize: function getEstimatedTotalSize(_ref3) {
        var itemCount = _ref3.itemCount, itemSize = _ref3.itemSize;
        return itemSize * itemCount;
    },
    getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(_ref4, index, align, scrollOffset, instanceProps, scrollbarSize) {
        var direction = _ref4.direction, height = _ref4.height, itemCount = _ref4.itemCount, itemSize = _ref4.itemSize, layout = _ref4.layout, width = _ref4.width;
        // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === "horizontal" || layout === "horizontal";
        var size = isHorizontal ? width : height;
        var lastItemOffset = Math.max(0, itemCount * itemSize - size);
        var maxOffset = Math.min(lastItemOffset, index * itemSize);
        var minOffset = Math.max(0, index * itemSize - size + itemSize + scrollbarSize);
        if (align === "smart") {
            if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = "auto";
            else align = "center";
        }
        switch(align){
            case "start":
                return maxOffset;
            case "end":
                return minOffset;
            case "center":
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(size / 2)) return 0; // near the beginning
                else if (middleOffset > lastItemOffset + Math.floor(size / 2)) return lastItemOffset; // near the end
                else return middleOffset;
            case "auto":
            default:
                if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
                else if (scrollOffset < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getStartIndexForOffset: function getStartIndexForOffset(_ref5, offset) {
        var itemCount = _ref5.itemCount, itemSize = _ref5.itemSize;
        return Math.max(0, Math.min(itemCount - 1, Math.floor(offset / itemSize)));
    },
    getStopIndexForStartIndex: function getStopIndexForStartIndex(_ref6, startIndex, scrollOffset) {
        var direction = _ref6.direction, height = _ref6.height, itemCount = _ref6.itemCount, itemSize = _ref6.itemSize, layout = _ref6.layout, width = _ref6.width;
        // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === "horizontal" || layout === "horizontal";
        var offset = startIndex * itemSize;
        var size = isHorizontal ? width : height;
        var numVisibleItems = Math.ceil((size + scrollOffset - offset) / itemSize);
        return Math.max(0, Math.min(itemCount - 1, startIndex + numVisibleItems - 1 // -1 is because stop index is inclusive
        ));
    },
    initInstanceProps: function initInstanceProps(props) {},
    shouldResetStyleCacheOnItemSizeChange: true,
    validateProps: function validateProps(_ref7) {
        var itemSize = _ref7.itemSize;
    }
});
// Pulled from react-compat
// https://github.com/developit/preact-compat/blob/7c5de00e7c85e2ffd011bf3af02899b63f699d3a/src/index.js#L349
function $01ff200d9f4ad87f$var$shallowDiffers(prev, next) {
    for(var attribute in prev){
        if (!(attribute in next)) return true;
    }
    for(var _attribute in next){
        if (prev[_attribute] !== next[_attribute]) return true;
    }
    return false;
}
var $01ff200d9f4ad87f$var$_excluded = [
    "style"
], $01ff200d9f4ad87f$var$_excluded2 = [
    "style"
];
// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-api.html#reactmemo
function $01ff200d9f4ad87f$export$b141efd0b0fb9174(prevProps, nextProps) {
    var prevStyle = prevProps.style, prevRest = (0, $3e1c704ac4a4c38a$export$2e2bcd8739ae039)(prevProps, $01ff200d9f4ad87f$var$_excluded);
    var nextStyle = nextProps.style, nextRest = (0, $3e1c704ac4a4c38a$export$2e2bcd8739ae039)(nextProps, $01ff200d9f4ad87f$var$_excluded2);
    return !$01ff200d9f4ad87f$var$shallowDiffers(prevStyle, nextStyle) && !$01ff200d9f4ad87f$var$shallowDiffers(prevRest, nextRest);
}
// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-component.html#shouldcomponentupdate
function $01ff200d9f4ad87f$export$aa365c903ed149ff(nextProps, nextState) {
    return !$01ff200d9f4ad87f$export$b141efd0b0fb9174(this.props, nextProps) || $01ff200d9f4ad87f$var$shallowDiffers(this.state, nextState);
}


const $97bfc4b4004b00d4$var$defaultChartTheme = {
    axisColor: "#a4a4a4",
    axisFontFamily: "inherit",
    axisFontSize: "12px",
    axisFontStyle: "normal",
    axisFontWeight: "400",
    axisLetterSpacing: "inherit",
    buttonActiveBackgroundColor: "#606266",
    buttonActiveColor: "white",
    buttonBackgroundColor: "transparent",
    buttonBorderRadius: "6px",
    buttonColor: "#1f2023",
    buttonDisabledBackgroundColor: "transparent",
    buttonDisabledColor: "#a4a4a4",
    buttonFocusBackgroundColor: "white",
    buttonFocusBorderColor: "#285fff",
    buttonFocusColor: "#606266",
    buttonFocusOutline: "rgb(183, 201, 255) solid 2px",
    buttonFont: "normal 600 14px / 16px sans-serif",
    buttonGroupBackgroundColor: "#f3f3f3",
    buttonGroupBorderRadius: "6px",
    buttonHoverBackgroundColor: "#e7e7e7",
    buttonHoverColor: "#1f2023",
    eventColor: "#285fff",
    expandableGradientColor: "rgb(255 255 255 / 75%)",
    gridStrokeColor: "#e7e7e7",
    legendItemBorderRadius: "6px",
    legendItemCheckboxBorderRadius: "4px",
    legendItemCheckboxColor: "#285fff",
    legendItemColor: "black",
    legendItemEmphasisBackgroundColor: "#f3f3f3",
    legendItemEmphasisBorderRadius: "4px",
    legendItemEmphasisColor: "black",
    legendItemEmphasisFont: "inherit",
    legendItemFont: "inherit",
    legendItemOnHoverBackgroundColor: "#a4a4a4",
    legendItemOnHoverColor: "inherit",
    legendResultsColor: "inherit",
    legendResultsFont: "inherit",
    legendResultsLetterSpacing: "inherit",
    shapeListColors: [
        "#c00eae",
        "#23304a",
        "#cf3411"
    ],
    targetLatencyColor: "inherit"
};
const $97bfc4b4004b00d4$var$ChartThemeContext = (0, $2gcPZ.createContext)($97bfc4b4004b00d4$var$defaultChartTheme);
const $97bfc4b4004b00d4$export$69b1032f2ecdf404 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).span(()=>{
    const theme = (0, $2gcPZ.useContext)($97bfc4b4004b00d4$var$ChartThemeContext);
    return (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    display: flex;
    gap: 8px;
    align-items: center;
    padding: 4px 8px;
    background: ${theme.buttonGroupBackgroundColor};
    border-radius: ${theme.buttonGroupBorderRadius};
  `;
});
const $97bfc4b4004b00d4$var$Box = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  box-sizing: border-box;
  margin: 0;
  min-width: 0;
`;
const $97bfc4b4004b00d4$var$Container = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)($97bfc4b4004b00d4$var$Box)`
  display: flex;
`;
const $97bfc4b4004b00d4$var$ControlsContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: flex;
  margin: 0 0 12px;
  gap: 24px;
`;
const $97bfc4b4004b00d4$var$ControlsGroup = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 8px;
`;
const $97bfc4b4004b00d4$export$65f0c8bad2ea29b = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 8px;
  align-items: center;
`;
const $97bfc4b4004b00d4$export$12cfa6a5c9403eaa = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).span(()=>{
    const theme = (0, $2gcPZ.useContext)($97bfc4b4004b00d4$var$ChartThemeContext);
    return (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    font: ${theme.buttonFont};
    color: ${theme.buttonColor};
  `;
});
var $97bfc4b4004b00d4$var$_path$6;
function $97bfc4b4004b00d4$var$_extends$6() {
    $97bfc4b4004b00d4$var$_extends$6 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $97bfc4b4004b00d4$var$_extends$6.apply(this, arguments);
}
var $97bfc4b4004b00d4$var$SvgChartBar = function SvgChartBar(props) {
    return /*#__PURE__*/ $2gcPZ.createElement("svg", $97bfc4b4004b00d4$var$_extends$6({
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20"
    }, props), $97bfc4b4004b00d4$var$_path$6 || ($97bfc4b4004b00d4$var$_path$6 = /*#__PURE__*/ $2gcPZ.createElement("path", {
        fill: "currentColor",
        d: "M17.813 15.625h-.625v-12.5a.625.625 0 0 0-.625-.625h-4.375a.625.625 0 0 0-.626.625V6.25h-3.75a.625.625 0 0 0-.625.625V10h-3.75a.625.625 0 0 0-.624.625v5h-.626a.625.625 0 1 0 0 1.25h15.626a.624.624 0 1 0 0-1.25ZM8.438 7.5h3.124v8.125H8.438V7.5Zm-4.376 3.75h3.125v4.375H4.063V11.25Z"
    })));
};
var $97bfc4b4004b00d4$var$_path$5;
function $97bfc4b4004b00d4$var$_extends$5() {
    $97bfc4b4004b00d4$var$_extends$5 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $97bfc4b4004b00d4$var$_extends$5.apply(this, arguments);
}
var $97bfc4b4004b00d4$var$SvgChartLine = function SvgChartLine(props) {
    return /*#__PURE__*/ $2gcPZ.createElement("svg", $97bfc4b4004b00d4$var$_extends$5({
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20"
    }, props), $97bfc4b4004b00d4$var$_path$5 || ($97bfc4b4004b00d4$var$_path$5 = /*#__PURE__*/ $2gcPZ.createElement("path", {
        fill: "currentColor",
        d: "M17.5 15.625H3.125v-2.844L7.531 8.93l4.594 3.445a.625.625 0 0 0 .79-.031l5-4.375a.625.625 0 0 0-.83-.938l-4.616 4.04-4.594-3.446a.625.625 0 0 0-.79.031l-3.96 3.469V3.75a.625.625 0 0 0-1.25 0v12.5a.625.625 0 0 0 .625.625h15a.624.624 0 1 0 0-1.25Z"
    })));
};
var $97bfc4b4004b00d4$var$_path$4;
function $97bfc4b4004b00d4$var$_extends$4() {
    $97bfc4b4004b00d4$var$_extends$4 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $97bfc4b4004b00d4$var$_extends$4.apply(this, arguments);
}
var $97bfc4b4004b00d4$var$SvgCheck = function SvgCheck(props) {
    return /*#__PURE__*/ $2gcPZ.createElement("svg", $97bfc4b4004b00d4$var$_extends$4({
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20"
    }, props), $97bfc4b4004b00d4$var$_path$4 || ($97bfc4b4004b00d4$var$_path$4 = /*#__PURE__*/ $2gcPZ.createElement("path", {
        fill: "currentColor",
        d: "M8.125 15a.665.665 0 0 1-.445-.18l-4.375-4.375a.633.633 0 0 1 .89-.89l3.93 3.937L16.43 5.18a.633.633 0 0 1 .89.89l-8.75 8.75a.665.665 0 0 1-.445.18Z"
    })));
};
var $97bfc4b4004b00d4$var$_path$3;
function $97bfc4b4004b00d4$var$_extends$3() {
    $97bfc4b4004b00d4$var$_extends$3 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $97bfc4b4004b00d4$var$_extends$3.apply(this, arguments);
}
var $97bfc4b4004b00d4$var$SvgCombined = function SvgCombined(props) {
    return /*#__PURE__*/ $2gcPZ.createElement("svg", $97bfc4b4004b00d4$var$_extends$3({
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20"
    }, props), $97bfc4b4004b00d4$var$_path$3 || ($97bfc4b4004b00d4$var$_path$3 = /*#__PURE__*/ $2gcPZ.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.157 3.794a.5.5 0 0 0-.916.011l-2.805 6.64-1.139-2.331a.5.5 0 0 0-.894-.008l-4.43 8.666a.5.5 0 0 0 .445.728h15.168a.5.5 0 0 0 .455-.706l-5.884-13Zm-.76 12.706h5.414L11.716 5.247 9.02 11.635l2.378 4.865Zm-2.894-3.643 1.78 3.643h-3.32l1.54-3.643Zm-.583-1.191L5.878 16.5H3.235l3.603-7.049 1.082 2.215Z",
        clipRule: "evenodd"
    })));
};
var $97bfc4b4004b00d4$var$_path$2;
function $97bfc4b4004b00d4$var$_extends$2() {
    $97bfc4b4004b00d4$var$_extends$2 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $97bfc4b4004b00d4$var$_extends$2.apply(this, arguments);
}
var $97bfc4b4004b00d4$var$SvgPercentage = function SvgPercentage(props) {
    return /*#__PURE__*/ $2gcPZ.createElement("svg", $97bfc4b4004b00d4$var$_extends$2({
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20"
    }, props), $97bfc4b4004b00d4$var$_path$2 || ($97bfc4b4004b00d4$var$_path$2 = /*#__PURE__*/ $2gcPZ.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M15.354 4.646a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.708-.708l10-10a.5.5 0 0 1 .708 0ZM6.5 5.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm8 7a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm1-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z",
        clipRule: "evenodd"
    })));
};
var $97bfc4b4004b00d4$var$_path$1;
function $97bfc4b4004b00d4$var$_extends$1() {
    $97bfc4b4004b00d4$var$_extends$1 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $97bfc4b4004b00d4$var$_extends$1.apply(this, arguments);
}
var $97bfc4b4004b00d4$var$SvgStacked = function SvgStacked(props) {
    return /*#__PURE__*/ $2gcPZ.createElement("svg", $97bfc4b4004b00d4$var$_extends$1({
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20"
    }, props), $97bfc4b4004b00d4$var$_path$1 || ($97bfc4b4004b00d4$var$_path$1 = /*#__PURE__*/ $2gcPZ.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.688 3.125a.5.5 0 0 1 .5-.5h4.374a.5.5 0 0 1 .5.5V16.25a.5.5 0 0 1-.5.5H7.885a.503.503 0 0 1-.142 0H3.438a.5.5 0 0 1-.5-.5V6.812a.5.5 0 0 1 .5-.5h3.874v-.437a.5.5 0 0 1 .5-.5h3.875v-2.25ZM7.311 7.312H3.938V11h3.376V7.312Zm0 4.688H3.938v3.75h3.376V12Zm1 3.75V6.375h3.376v9.375H8.312Zm4.376 0V3.625h3.374V15.75h-3.375Z",
        clipRule: "evenodd"
    })));
};
var $97bfc4b4004b00d4$var$_path;
function $97bfc4b4004b00d4$var$_extends() {
    $97bfc4b4004b00d4$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $97bfc4b4004b00d4$var$_extends.apply(this, arguments);
}
var $97bfc4b4004b00d4$var$SvgTriangleDown = function SvgTriangleDown(props) {
    return /*#__PURE__*/ $2gcPZ.createElement("svg", $97bfc4b4004b00d4$var$_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20"
    }, props), $97bfc4b4004b00d4$var$_path || ($97bfc4b4004b00d4$var$_path = /*#__PURE__*/ $2gcPZ.createElement("path", {
        fill: "currentColor",
        d: "m10.143 13 3.344-6h-6.69l3.346 6Z"
    })));
};
const $97bfc4b4004b00d4$var$ICON_MAP = {
    chart_bar: $97bfc4b4004b00d4$var$SvgChartBar,
    chart_line: $97bfc4b4004b00d4$var$SvgChartLine,
    check: $97bfc4b4004b00d4$var$SvgCheck,
    combined: $97bfc4b4004b00d4$var$SvgCombined,
    percentage: $97bfc4b4004b00d4$var$SvgPercentage,
    stacked: $97bfc4b4004b00d4$var$SvgStacked,
    triangle_down: $97bfc4b4004b00d4$var$SvgTriangleDown
};
function $97bfc4b4004b00d4$export$f04a61298a47a40f({ type: type, ...svgProps }) {
    const Component = $97bfc4b4004b00d4$var$ICON_MAP[type];
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)(Component, {
        ...svgProps
    });
}
const $97bfc4b4004b00d4$var$buttonStyling = (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)(()=>{
    const theme = (0, $2gcPZ.useContext)($97bfc4b4004b00d4$var$ChartThemeContext);
    return (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    --color: var(--button-normal-color);
    --backgroundColor: var(--button-normal-backgroundColor);

    outline: none;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition-property: background-color, border-color;
    transition-duration: 0.2s;
    transition-timing-function: linear;
    border-radius: ${theme.buttonBorderRadius};
    box-sizing: border-box;
    height: var(--icon-button-height, 20px);
    width: var(--icon-button-width, 20px);
    padding: var(--icon-button-padding, 2px);
    color: var(--color);
    background-color: var(--background);
    border: 1px solid var(--background);

    :focus,
    :hover,
    :active,
    .active {
      cursor: pointer;
    }

    :focus {
      border-color: ${theme.buttonFocusBorderColor};
      outline: ${theme.buttonFocusOutline};

      --background: var(--button-focus-backgroundColor);
      --color: var(--button-focus-color);
    }

    &:disabled {
      cursor: default;

      --color: var(--button-disabled-color);
      --background: var(--button-disabled-backgroundColor);
    }

    &.active,
    &:active:not([data-dragging], [disabled]) {
      --background: var(--button-active-backgroundColor);
      --color: var(--button-active-color);
    }

    :hover:not([data-disabled][data-dragging], [disabled]) {
      --background: var(--button-hover-backgroundColor);
      --color: var(--button-hover-color);
      border: none;
    }

    & svg {
      flex: 0 0 var(--icon-button-icon-size);
      width: var(--icon-button-icon-size);
      height: var(--icon-button-icon-size);
    }
  `;
});
const $97bfc4b4004b00d4$var$StyledButton = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).button`
  ${$97bfc4b4004b00d4$var$buttonStyling}
`;
const $97bfc4b4004b00d4$var$buttonSize = {
    padding: "6px",
    width: "32px",
    height: "32px",
    iconSize: "20px"
};
const $97bfc4b4004b00d4$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $2gcPZ.forwardRef)(function IconButton(props, ref) {
    const { className: className = "", style: style = {}, active: active = false, children: children, ...otherProps } = props;
    const theme = (0, $2gcPZ.useContext)($97bfc4b4004b00d4$var$ChartThemeContext);
    const newStyle = {
        ...style,
        "--icon-button-padding": $97bfc4b4004b00d4$var$buttonSize.padding,
        "--icon-button-width": $97bfc4b4004b00d4$var$buttonSize.width,
        "--icon-button-height": $97bfc4b4004b00d4$var$buttonSize.height,
        "--icon-button-icon-size": $97bfc4b4004b00d4$var$buttonSize.iconSize,
        "--button-normal-color": theme.buttonColor,
        "--button-normal-backgroundColor": theme.buttonBackgroundColor,
        "--button-hover-color": theme.buttonHoverColor,
        "--button-hover-backgroundColor": theme.buttonHoverBackgroundColor,
        "--button-active-color": theme.buttonActiveColor,
        "--button-active-backgroundColor": theme.buttonActiveBackgroundColor,
        "--button-focus-color": theme.buttonFocusColor,
        "--button-focus-backgroundColor": theme.buttonFocusBackgroundColor,
        "--button-disabled-color": theme.buttonDisabledColor,
        "--button-disabled-backgroundColor": theme.buttonDisabledBackgroundColor
    };
    const elementProps = {
        ...otherProps,
        ref: ref,
        style: newStyle,
        className: active ? `${className} active` : className,
        "aria-pressed": active
    };
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$var$StyledButton, {
        ...elementProps,
        children: children
    });
});
const $97bfc4b4004b00d4$var$noDeps = [];
function $97bfc4b4004b00d4$var$useHandler(handler) {
    const handlerRef = (0, $2gcPZ.useRef)(handler);
    handlerRef.current = handler;
    // @ts-ignore
    return (0, $2gcPZ.useCallback)((...args)=>handlerRef.current(...args), $97bfc4b4004b00d4$var$noDeps);
}
/**
 * Implements all the logic needed to create an expandable container.
 */ function $97bfc4b4004b00d4$var$useExpandable({ defaultHeight: defaultHeight }) {
    const ref = (0, $2gcPZ.useRef)(null);
    const [showExpandButton, setShowExpandButton] = (0, $2gcPZ.useState)(false);
    const [isExpanded, setIsExpanded] = (0, $2gcPZ.useState)(false);
    const [showGradient, setShowGradient] = (0, $2gcPZ.useState)(false);
    const update = $97bfc4b4004b00d4$var$useHandler((element)=>{
        const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = element;
        if (scrollHeight <= defaultHeight) {
            setShowExpandButton(false);
            setShowGradient(false);
        } else {
            setShowExpandButton(true);
            setShowGradient(scrollHeight - scrollTop > clientHeight);
        }
    });
    // This calls update function with a tiny delay. This fixes
    // errors with the ResizeObserver loop taking too long
    const asyncUpdate = $97bfc4b4004b00d4$var$useHandler(()=>{
        setTimeout(()=>{
            if (ref.current) update(ref.current);
        }, 0);
    });
    (0, $2gcPZ.useEffect)(()=>{
        return ()=>{
            if (ref.current) {
                $97bfc4b4004b00d4$var$unsubscribeFromNode(ref.current, asyncUpdate);
                ref.current = null;
            }
        };
    }, [
        asyncUpdate
    ]);
    const setRef = $97bfc4b4004b00d4$var$useHandler((node)=>{
        if (ref.current === node) return;
        if (ref.current) $97bfc4b4004b00d4$var$unsubscribeFromNode(ref.current, asyncUpdate);
        if (node) {
            $97bfc4b4004b00d4$var$subscribeToNode(node, asyncUpdate);
            update(node);
        }
        ref.current = node;
    });
    const onClickExpand = $97bfc4b4004b00d4$var$useHandler(()=>{
        setIsExpanded(!isExpanded);
    });
    return {
        expandButton: showExpandButton ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$var$Expand, {
            onClick: onClickExpand,
            revert: isExpanded,
            children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$export$f04a61298a47a40f, {
                type: "triangle_down"
            })
        }) : undefined,
        gradient: showGradient ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$var$GradientContainer, {
            children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$var$Gradient, {})
        }) : undefined,
        isExpanded: isExpanded || !showExpandButton,
        onScroll: asyncUpdate,
        ref: setRef
    };
}
const $97bfc4b4004b00d4$var$listenerMap = new WeakMap();
let $97bfc4b4004b00d4$var$observer;
function $97bfc4b4004b00d4$var$observerCallback(entries) {
    for (const entry of entries){
        const listeners = $97bfc4b4004b00d4$var$listenerMap.get(entry.target);
        if (listeners) for (const listener of listeners)listener();
    }
}
function $97bfc4b4004b00d4$var$subscribeToNode(node, listener) {
    const listeners = $97bfc4b4004b00d4$var$listenerMap.get(node);
    if (listeners) listeners.add(listener);
    else {
        $97bfc4b4004b00d4$var$listenerMap.set(node, new Set([
            listener
        ]));
        if (!$97bfc4b4004b00d4$var$observer) $97bfc4b4004b00d4$var$observer = new ResizeObserver($97bfc4b4004b00d4$var$observerCallback);
        $97bfc4b4004b00d4$var$observer.observe(node);
    }
}
function $97bfc4b4004b00d4$var$unsubscribeFromNode(node, listener) {
    const listeners = $97bfc4b4004b00d4$var$listenerMap.get(node);
    if (listeners) {
        listeners.delete(listener);
        if (listeners.size === 0) {
            $97bfc4b4004b00d4$var$listenerMap.delete(node);
            $97bfc4b4004b00d4$var$observer?.unobserve(node);
        }
    }
}
const $97bfc4b4004b00d4$var$Expand = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  color: #4797ff;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: ${({ revert: revert })=>revert ? "rotate(180deg)" : "none"};

  &:hover {
    cursor: pointer;
    background: rgba(71, 151, 255, 30%);
  }
`;
const $97bfc4b4004b00d4$var$Gradient = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(()=>{
    const theme = (0, $2gcPZ.useContext)($97bfc4b4004b00d4$var$ChartThemeContext);
    return (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    width: 100%;
    position: absolute;
    bottom: 0;
    height: 39px;
    background-image: linear-gradient(
      to bottom,
      transparent,
      ${theme.expandableGradientColor} 50%
    );

    border-bottom-right-radius: 6px;
    pointer-events: none;
  `;
});
// The container is sticky, but zero height to prevent the gradient itself
// from reserving any space.
const $97bfc4b4004b00d4$var$GradientContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  bottom: 0;
  height: 0;
  position: sticky;
  width: 100%;
`;
const $97bfc4b4004b00d4$var$reducer = (counter)=>counter + 1;
function $97bfc4b4004b00d4$var$useForceUpdate() {
    const [, forceUpdate] = (0, $2gcPZ.useReducer)($97bfc4b4004b00d4$var$reducer, 0);
    return forceUpdate;
}
const $97bfc4b4004b00d4$var$noEntries = [];
function $97bfc4b4004b00d4$var$useIntersectionObserver(ref, options) {
    const [intersections, setIntersections] = (0, $2gcPZ.useState)($97bfc4b4004b00d4$var$noEntries);
    const element = ref.current;
    (0, $2gcPZ.useEffect)(()=>{
        if (!element) return;
        const observer = new IntersectionObserver(setIntersections, options);
        observer.observe(element);
        return ()=>{
            observer.disconnect();
            setIntersections($97bfc4b4004b00d4$var$noEntries);
        };
    }, [
        element,
        options
    ]);
    return intersections;
}
const $97bfc4b4004b00d4$var$defaultDimensions = {
    width: 0,
    height: 0
};
function $97bfc4b4004b00d4$var$useMeasure() {
    const [element, setElement] = (0, $2gcPZ.useState)(null);
    const [rect, setRect] = (0, $2gcPZ.useState)($97bfc4b4004b00d4$var$defaultDimensions);
    const observer = (0, $2gcPZ.useMemo)(()=>new window.ResizeObserver((entries)=>{
            const entry = entries[0];
            if (entry) {
                const { width: width, height: height } = entry.contentRect;
                setRect({
                    width: width,
                    height: height
                });
            }
        }), []);
    (0, $2gcPZ.useLayoutEffect)(()=>{
        if (!element) return;
        observer.observe(element);
        return ()=>{
            observer.disconnect();
        };
    }, [
        element,
        observer
    ]);
    return [
        setElement,
        rect
    ];
}
/**
 * Strips all falsy values from an array.
 */ function $97bfc4b4004b00d4$var$compact(items) {
    return items.filter(Boolean);
}
/**
 * Return a list of keys whose values vary across series (or don't exist
 * everywhere).
 */ function $97bfc4b4004b00d4$var$findUniqueKeys(timeseriesData) {
    let constantKeys;
    let detectedValues = {};
    for (const timeseries of timeseriesData){
        const keys = Object.keys(timeseries.labels);
        if (constantKeys === undefined) {
            constantKeys = new Set(keys);
            detectedValues = {
                ...timeseries.labels
            };
        } else for (const key of keys){
            if (detectedValues[key] !== timeseries.labels[key]) constantKeys.delete(key);
            detectedValues[key] = timeseries.labels[key] || "";
        }
    }
    const allKeys = Object.keys(detectedValues);
    return allKeys.filter((key)=>constantKeys === undefined || constantKeys.has(key) === false);
}
/**
 * Returns the input value.
 *
 * A function that only returns its input is also known as the identity
 * function.
 */ function $97bfc4b4004b00d4$var$identity(input) {
    return input;
}
/**
 * Taken from: https://github.com/gregberge/react-merge-refs
 *
 * Copyright (c) 2020 Greg Bergé
 *
 * @license MIT
 */ function $97bfc4b4004b00d4$var$mergeRefs(refs) {
    return (value)=>{
        for (const ref of refs){
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        }
    };
}
function $97bfc4b4004b00d4$var$noop() {}
function $97bfc4b4004b00d4$var$preventDefault(event) {
    event.preventDefault();
}
/**
 * Sorts an array ascending by priority.
 *
 * *Warning:* As this function uses `Array#sort()` it also mutates the input
 * array.
 */ function $97bfc4b4004b00d4$var$sortBy(array, getPriorityFn, reverse = false) {
    return array.sort((a, b)=>{
        const priorityA = getPriorityFn(a);
        const priorityB = getPriorityFn(b);
        if (priorityA < priorityB) return reverse === true ? 1 : -1;
        else if (priorityA > priorityB) return reverse === true ? -1 : 1;
        else return 0;
    });
}
const $97bfc4b4004b00d4$var$secondsToTimestamp = (seconds)=>new Date(seconds * 1000).toISOString();
const $97bfc4b4004b00d4$var$timestampToSeconds = (timestamp)=>new Date(timestamp).getTime() / 1000;
const $97bfc4b4004b00d4$var$os = typeof navigator === "undefined" ? "" : navigator.platform.match(/mac|win|linux/i)?.[0]?.toLowerCase();
const $97bfc4b4004b00d4$var$isMac = $97bfc4b4004b00d4$var$os === "mac";
/**
 * Context for tracking the size of the chart.
 */ const $97bfc4b4004b00d4$var$ChartSizeContext = (0, $2gcPZ.createContext)({
    width: 0,
    height: 0,
    xMax: 0,
    yMax: 0,
    marginTop: 0,
    marginRight: 0,
    marginBottom: 0,
    marginLeft: 0
});
function $97bfc4b4004b00d4$var$ChartSizeContainerProvider({ children: children, className: className, overrideHeight: overrideHeight, marginTop: marginTop = 0, marginRight: marginRight = 0, marginBottom: marginBottom = 0, marginLeft: marginLeft = 0 }) {
    const [measureRef, { width: width, height: measuredHeight }] = $97bfc4b4004b00d4$var$useMeasure();
    const intersectionRef = (0, $2gcPZ.useRef)(null);
    const ref = $97bfc4b4004b00d4$var$mergeRefs([
        measureRef,
        intersectionRef
    ]);
    const intersections = $97bfc4b4004b00d4$var$useIntersectionObserver(intersectionRef, $97bfc4b4004b00d4$var$intersectionOptions);
    const [value, setValue] = (0, $2gcPZ.useState)({
        xMax: 0,
        yMax: 0,
        width: 0,
        height: 0,
        marginTop: marginTop,
        marginRight: marginRight,
        marginBottom: marginBottom,
        marginLeft: marginLeft
    });
    const height = overrideHeight ?? measuredHeight;
    const updateValue = (0, $2gcPZ.useMemo)(()=>(0, $eaec1d9861b3c597$export$61fc7d43ac8f84b0)(100, (width, height)=>setValue({
                xMax: width - marginLeft - marginRight,
                yMax: height - marginTop - marginBottom,
                width: width,
                height: height,
                marginTop: marginTop,
                marginRight: marginRight,
                marginBottom: marginBottom,
                marginLeft: marginLeft
            })), [
        marginTop,
        marginRight,
        marginBottom,
        marginLeft
    ]);
    (0, $2gcPZ.useEffect)(()=>{
        updateValue(width, height);
    }, [
        width,
        height,
        updateValue
    ]);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("div", {
        ref: ref,
        className: className,
        children: value.width > 0 && value.height > 0 && intersections.some((intersection)=>intersection.isIntersecting) ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$var$ChartSizeContext.Provider, {
            value: value,
            children: children
        }) : /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$var$ChartSkeleton, {
            height: height
        })
    });
}
function $97bfc4b4004b00d4$var$ChartSkeleton({ height: height }) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("div", {
        style: {
            height: height
        }
    });
}
const $97bfc4b4004b00d4$var$intersectionOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0
};
function $97bfc4b4004b00d4$var$toFactory(coordinate) {
    return typeof coordinate === "function" ? coordinate : $97bfc4b4004b00d4$var$constantFactory(coordinate);
}
function $97bfc4b4004b00d4$var$constantFactory(value) {
    return ()=>value;
}
/**
 * Creates the SVG path definition for an area shape.
 *
 * @param data The data points for the area.
 * @param coordinates The factories and/or constants to produce the coordinates
 *                    from each data point.
 *
 * See also: https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/d
 */ function $97bfc4b4004b00d4$var$createAreaPathDef(data, coordinates) {
    const len = data.length;
    if (len === 0) return "";
    const x = $97bfc4b4004b00d4$var$toFactory(coordinates.x);
    const y0 = $97bfc4b4004b00d4$var$toFactory(coordinates.y0);
    const y1 = $97bfc4b4004b00d4$var$toFactory(coordinates.y1);
    const start = data[0];
    let path = `M${x(start).toFixed(1)},${y0(start).toFixed(1)}`;
    // Draw a line along the y0 coordinates.
    for(let i = 1; i < len; ++i){
        const next = data[i];
        path += `L${x(next).toFixed(1)},${y0(next).toFixed(1)}`;
    }
    // Draw a line backwards along the y1 coordinates.
    for(let i = len - 1; i >= 0; --i){
        const previous = data[i];
        path += `L${x(previous).toFixed(1)},${y1(previous).toFixed(1)}`;
    }
    // Done.
    path += "Z";
    return path;
}
/**
 * Creates the SVG path definition for a line shape.
 *
 * @param data The data points for the line.
 * @param coordinates The factories and/or constants to produce the coordinates
 *                    from each data point.
 *
 * See also: https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/d
 */ function $97bfc4b4004b00d4$var$createLinePathDef(data, coordinates) {
    const len = data.length;
    if (len === 0) return "";
    const x = $97bfc4b4004b00d4$var$toFactory(coordinates.x);
    const y = $97bfc4b4004b00d4$var$toFactory(coordinates.y);
    const start = data[0];
    let path = `M${x(start).toFixed(1)},${y(start).toFixed(1)}`;
    // Draw a line along the data points.
    for(let i = 1; i < len; ++i){
        const next = data[i];
        path += `L${x(next).toFixed(1)},${y(next).toFixed(1)}`;
    }
    return path;
}
const $97bfc4b4004b00d4$var$AreaShape = /*#__PURE__*/ (0, $2gcPZ.memo)(function AreaShape({ anyFocused: anyFocused, areaGradientShown: areaGradientShown, area: area, color: color, focused: focused, scales: scales }) {
    const id = (0, $2gcPZ.useId)();
    const gradientId = `line-${id}`;
    const gradientRef = `url(#${gradientId})`;
    const x = (point)=>scales.xScale(point.x);
    const y0 = (point)=>scales.yScale(point.yMin);
    const y1 = (point)=>scales.yScale(point.yMax);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("g", {
        opacity: focused || !anyFocused ? 1 : 0.2,
        children: [
            areaGradientShown && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("linearGradient", {
                    id: gradientId,
                    x1: 0,
                    y1: 0,
                    x2: 0,
                    y2: 1,
                    children: [
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                            offset: "0%",
                            stopColor: color,
                            stopOpacity: 0.3
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                            offset: "80%",
                            stopColor: color,
                            stopOpacity: 0.06
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: $97bfc4b4004b00d4$var$createAreaPathDef(area.points, {
                    x: x,
                    y0: y0,
                    y1: y1
                }),
                stroke: color,
                strokeDasharray: area.strokeDasharray?.join(" "),
                strokeWidth: focused ? 1.5 : 1,
                fill: areaGradientShown ? gradientRef : "none"
            })
        ]
    });
});
const $97bfc4b4004b00d4$var$LineShape = /*#__PURE__*/ (0, $2gcPZ.memo)(function LineShape({ anyFocused: anyFocused, areaGradientShown: areaGradientShown, color: color, focused: focused, line: line, scales: scales }) {
    const id = (0, $2gcPZ.useId)();
    const gradientId = `line-${id}`;
    const x = (point)=>scales.xScale(point.x);
    const y = (point)=>scales.yScale(point.y);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("g", {
        opacity: focused || !anyFocused ? 1 : 0.2,
        children: [
            areaGradientShown && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("linearGradient", {
                    id: gradientId,
                    x1: 0,
                    y1: 0,
                    x2: 0,
                    y2: 1,
                    children: [
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                            offset: "0%",
                            stopColor: color,
                            stopOpacity: 0.15
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                            offset: "23%",
                            stopColor: color,
                            stopOpacity: 0.03
                        })
                    ]
                })
            }),
            areaGradientShown && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: $97bfc4b4004b00d4$var$createAreaPathDef(line.points, {
                    x: x,
                    y0: y,
                    y1: scales.yScale(0)
                }),
                stroke: "none",
                fill: `url(#${gradientId})`
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: $97bfc4b4004b00d4$var$createLinePathDef(line.points, {
                    x: x,
                    y: y
                }),
                stroke: color,
                strokeDasharray: line.strokeDasharray?.join(" "),
                strokeWidth: focused ? 1.5 : 1,
                fill: "none"
            })
        ]
    });
});
// Dimensions of the chart
const $97bfc4b4004b00d4$var$HEIGHT = 275;
const $97bfc4b4004b00d4$var$MARGINS = {
    top: 0,
    bottom: 20,
    left: 38,
    right: 0
};
// Dimensions of points on the chart
const $97bfc4b4004b00d4$var$POINT_RADIUS = 1;
const $97bfc4b4004b00d4$var$POINT_RADIUS_FOCUSED = 2;
// If a point is directly on the edge of the chart, it can be cut off.
// This overflow margin ensures that the point is still visible.
const $97bfc4b4004b00d4$var$CHART_SHAPE_OVERFLOW_MARGIN = $97bfc4b4004b00d4$var$POINT_RADIUS_FOCUSED;
const $97bfc4b4004b00d4$var$PointShape = /*#__PURE__*/ (0, $2gcPZ.memo)(function PointShape({ color: color, focused: focused, point: point, scales: scales }) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("circle", {
        cx: scales.xScale(point.x),
        cy: scales.yScale(point.y),
        r: focused ? $97bfc4b4004b00d4$var$POINT_RADIUS_FOCUSED : $97bfc4b4004b00d4$var$POINT_RADIUS,
        stroke: color,
        fill: color
    });
});
const $97bfc4b4004b00d4$var$RectangleShape = /*#__PURE__*/ (0, $2gcPZ.memo)(function RectangleShape({ anyFocused: anyFocused, color: color, focused: focused, rectangle: rectangle, scales: { xMax: xMax, yMax: yMax } }) {
    const height = rectangle.height * yMax;
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
        x: rectangle.x * xMax,
        y: yMax - rectangle.y * yMax - height,
        width: rectangle.width * xMax,
        height: height,
        stroke: color,
        fill: color,
        fillOpacity: 0.1,
        opacity: focused || !anyFocused ? 1 : 0.2
    });
});
function $97bfc4b4004b00d4$var$ChartShape({ shape: shape, ...props }) {
    switch(shape.type){
        case "area":
            return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$var$AreaShape, {
                area: shape,
                ...props
            });
        case "line":
            return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$var$LineShape, {
                line: shape,
                ...props
            });
        case "point":
            return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$var$PointShape, {
                point: shape,
                ...props
            });
        case "rectangle":
            return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$var$RectangleShape, {
                rectangle: shape,
                ...props
            });
    }
}
function $97bfc4b4004b00d4$var$ChartContent({ areaGradientShown: areaGradientShown, chart: chart, focusedShapeList: focusedShapeList, getShapeListColor: getShapeListColor, scales: scales }) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $afa7be861492543f$exports.Fragment), {
        children: chart.shapeLists.flatMap((shapeList, listIndex)=>shapeList.shapes.map((shape, shapeIndex)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$var$ChartShape, {
                    anyFocused: !!focusedShapeList,
                    areaGradientShown: areaGradientShown,
                    color: getShapeListColor(shapeList.source, listIndex),
                    focused: shapeList === focusedShapeList,
                    scales: scales,
                    shape: shape
                }, `${listIndex}-${shapeIndex}`)))
    });
}
/**
 * Creates a linear scale function for the given range.
 *
 * Assumes a domain of `[0.0..1.0]` as used for our abstract chart coordinates.
 */ function $97bfc4b4004b00d4$var$createLinearScaleForRange([from, to]) {
    return (value)=>from + value * (to - from);
}
function $97bfc4b4004b00d4$var$getCoordinatesForEvent(event, { xMax: xMax, yMax: yMax }) {
    const svg = $97bfc4b4004b00d4$var$getTarget(event);
    if (svg) {
        const rect = svg.getBoundingClientRect();
        const x = event.clientX - rect.left - $97bfc4b4004b00d4$var$MARGINS.left;
        const y = event.clientY - rect.top - $97bfc4b4004b00d4$var$MARGINS.top;
        if (x < 0 || x > xMax || y < 0 || y > yMax) return null;
        return {
            x: x / xMax,
            y: 1 - y / yMax
        };
    }
    const element = event.currentTarget || event.target;
    if (!element) return null;
    const rect = element.getBoundingClientRect();
    return {
        x: (event.clientX - rect.left) / xMax,
        y: 1 - (event.clientY - rect.top) / yMax
    };
}
/**
 * Finds the root `<svg>` element we use as target. Most event listeners are
 * directly attached to it, but some may be attached elsewhere and we need to
 * travel from the `event.target` to find it.
 */ function $97bfc4b4004b00d4$var$getTarget(event) {
    if (event.currentTarget instanceof SVGSVGElement) return event.currentTarget;
    let target = event.target;
    while(target){
        if (target instanceof SVGSVGElement) return target;
        target = target.parentElement;
    }
    return null;
}
function $97bfc4b4004b00d4$var$GridColumns({ scales: { xScale: xScale, yMax: yMax }, xAxis: { maxValue: maxValue, minValue: minValue }, xTicks: xTicks, ...lineProps }) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("g", {
        children: xTicks.map((time, index)=>{
            const x = xScale((time - minValue) / (maxValue - minValue));
            return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("line", {
                x1: x,
                y1: 0,
                x2: x,
                y2: yMax,
                ...lineProps
            }, index);
        })
    });
}
function $97bfc4b4004b00d4$var$GridRows({ xMax: xMax, yScale: yScale, yTicks: yTicks, ...lineProps }) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("g", {
        children: yTicks.map((value, index)=>{
            const y = yScale(value);
            return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("line", {
                x1: 0,
                y1: y,
                x2: xMax,
                y2: y,
                ...lineProps
            }, index);
        })
    });
}
const $97bfc4b4004b00d4$var$LABEL_OFFSET = 8;
function $97bfc4b4004b00d4$var$XAxis({ formatter: formatter, axisLinesShown: axisLinesShown, scales: { xMax: xMax, xScale: xScale, yMax: yMax }, strokeColor: strokeColor, strokeDasharray: strokeDasharray, ticks: ticks, xAxis: { maxValue: maxValue, minValue: minValue } }) {
    const { axisColor: axisColor, axisFontSize: axisFontSize, axisFontFamily: axisFontFamily, axisFontStyle: axisFontStyle, axisFontWeight: axisFontWeight, axisLetterSpacing: axisLetterSpacing } = (0, $2gcPZ.useContext)($97bfc4b4004b00d4$var$ChartThemeContext);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("g", {
        transform: `translate(0, ${yMax})`,
        children: [
            axisLinesShown && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("line", {
                x1: 0,
                y1: 0,
                x2: xMax,
                y2: 0,
                stroke: strokeColor,
                strokeDasharray: strokeDasharray
            }),
            formatter && ticks.map((time, index)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("text", {
                    x: xScale((time - minValue) / (maxValue - minValue)),
                    y: axisFontSize,
                    dy: $97bfc4b4004b00d4$var$LABEL_OFFSET,
                    fill: axisColor,
                    fontFamily: axisFontFamily,
                    fontStyle: axisFontStyle,
                    fontWeight: axisFontWeight,
                    fontSize: axisFontSize,
                    letterSpacing: axisLetterSpacing,
                    textAnchor: "middle",
                    children: formatter(time)
                }, index))
        ]
    });
}
function $97bfc4b4004b00d4$var$YAxis({ formatter: formatter, axisLinesShown: axisLinesShown, scales: { xMax: xMax, yMax: yMax, yScale: yScale }, strokeColor: strokeColor, strokeDasharray: strokeDasharray, ticks: ticks }) {
    const { axisColor: axisColor, axisFontSize: axisFontSize, axisFontFamily: axisFontFamily, axisFontStyle: axisFontStyle, axisFontWeight: axisFontWeight, axisLetterSpacing: axisLetterSpacing } = (0, $2gcPZ.useContext)($97bfc4b4004b00d4$var$ChartThemeContext);
    const tickLabelProps = {
        dx: "-0.45em",
        dy: "0.25em",
        textAnchor: "end",
        fontFamily: axisFontFamily,
        fontStyle: axisFontStyle,
        fontWeight: axisFontWeight,
        fontSize: axisFontSize,
        letterSpacing: axisLetterSpacing,
        fill: axisColor
    };
    const numTicks = ticks.length - 1;
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("g", {
        children: [
            axisLinesShown && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $afa7be861492543f$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("line", {
                        x1: 0,
                        y1: 0,
                        x2: 0,
                        y2: yMax,
                        stroke: strokeColor,
                        strokeDasharray: strokeDasharray
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("line", {
                        x1: xMax,
                        x2: xMax,
                        y1: 0,
                        y2: yMax,
                        stroke: strokeColor,
                        strokeDasharray: strokeDasharray
                    })
                ]
            }),
            formatter && ticks.map((value, index)=>(index > 0 || index < numTicks - 1) && value.valueOf() !== 0 ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("text", {
                    x: 0,
                    y: yScale(value),
                    ...tickLabelProps,
                    children: formatter(value)
                }, index) : null)
        ]
    });
}
const $97bfc4b4004b00d4$var$GridWithAxes = /*#__PURE__*/ (0, $2gcPZ.memo)(function GridWithAxes({ chart: chart, gridColumnsShown: gridColumnsShown = true, gridRowsShown: gridRowsShown = true, axisLinesShown: axisLinesShown = true, gridDasharray: gridDasharray, scales: scales, shouldAnimateYScale: shouldAnimateYScale, tickFormatters: tickFormatters }) {
    const { xMax: xMax, xScale: xScale, yMax: yMax } = scales;
    const { gridStrokeColor: gridStrokeColor } = (0, $2gcPZ.useContext)($97bfc4b4004b00d4$var$ChartThemeContext);
    const { xAxis: xAxis, yAxis: yAxis } = chart;
    const minValue = $97bfc4b4004b00d4$var$useCustomSpring(yAxis.minValue, shouldAnimateYScale);
    const maxValue = $97bfc4b4004b00d4$var$useCustomSpring(yAxis.maxValue, shouldAnimateYScale);
    const animatedScale = $97bfc4b4004b00d4$var$createLinearScaleForRangeWithCustomDomain([
        yMax,
        0
    ], [
        minValue,
        maxValue
    ]);
    const xTicks = (0, $2gcPZ.useMemo)(()=>$97bfc4b4004b00d4$export$3d27d42b1034de5c(xAxis, xMax, xScale, 12, $97bfc4b4004b00d4$export$305ab1245db5f1fa), [
        xAxis,
        xMax,
        xScale
    ]);
    const yTicks = (0, $2gcPZ.useMemo)(()=>$97bfc4b4004b00d4$export$3d27d42b1034de5c(yAxis, yMax, animatedScale, 8, $97bfc4b4004b00d4$var$getMaxYTickValue), [
        yAxis,
        yMax,
        animatedScale
    ]);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $afa7be861492543f$exports.Fragment), {
        children: [
            gridRowsShown && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$var$GridRows, {
                stroke: gridStrokeColor,
                strokeDasharray: gridDasharray,
                xMax: xMax,
                yScale: animatedScale,
                yTicks: yTicks
            }),
            gridColumnsShown && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$var$GridColumns, {
                scales: scales,
                stroke: gridStrokeColor,
                strokeDasharray: gridDasharray,
                xAxis: xAxis,
                xTicks: xTicks
            }),
            axisLinesShown || tickFormatters.xFormatter ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$var$XAxis, {
                formatter: tickFormatters.xFormatter,
                axisLinesShown: axisLinesShown,
                scales: scales,
                strokeColor: gridStrokeColor,
                strokeDasharray: gridDasharray,
                ticks: xTicks,
                xAxis: xAxis
            }) : null,
            axisLinesShown || tickFormatters.yFormatter ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$var$YAxis, {
                formatter: tickFormatters.yFormatter,
                axisLinesShown: axisLinesShown,
                scales: {
                    ...scales,
                    yScale: animatedScale
                },
                strokeColor: gridStrokeColor,
                strokeDasharray: gridDasharray,
                ticks: yTicks
            }) : null
        ]
    });
});
/**
 * Creates a linear scale function for the given range, but uses a custom
 * domain.
 */ function $97bfc4b4004b00d4$var$createLinearScaleForRangeWithCustomDomain(range, [min, max]) {
    const linearScale = $97bfc4b4004b00d4$var$createLinearScaleForRange(range);
    return (value)=>linearScale((value - min) / (max - min));
}
function $97bfc4b4004b00d4$export$3d27d42b1034de5c(axis, max, scale, numTicks, getMaxAllowedTick) {
    const suggestions = axis.tickSuggestions;
    const { ticks: ticks, interval: interval } = suggestions ? $97bfc4b4004b00d4$var$getTicksAndIntervalFromSuggestions(axis, suggestions, numTicks) : $97bfc4b4004b00d4$var$getTicksAndIntervalFromRange(axis.minValue, axis.maxValue, numTicks);
    if (interval !== undefined) $97bfc4b4004b00d4$var$extendTicksToFitAxis(ticks, axis, max, scale, 2 * numTicks, interval);
    $97bfc4b4004b00d4$var$removeLastTickIfTooCloseToMax(ticks, axis.maxValue, getMaxAllowedTick);
    return ticks;
}
function $97bfc4b4004b00d4$var$getTicksAndIntervalFromRange(minValue, maxValue, numTicks) {
    const interval = (maxValue - minValue) / numTicks;
    // NOTE - We need to handle the case where the interval is less than EPSILON,
    //        which is the smallest interval we can represent with javascript's floating point precision
    //        (see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/EPSILON)
    if (interval < Number.EPSILON) return {
        ticks: [
            minValue,
            maxValue
        ]
    };
    const ticks = [
        minValue
    ];
    let tick = minValue + interval;
    while(tick < maxValue){
        ticks.push(tick);
        tick += interval;
    }
    return {
        ticks: ticks,
        interval: interval
    };
}
function $97bfc4b4004b00d4$var$getTicksAndIntervalFromSuggestions(axis, suggestions, numTicks) {
    const len = suggestions.length;
    if (len < 2) return {
        ticks: suggestions
    };
    const suggestionInterval = suggestions[1] - suggestions[0];
    const axisRange = axis.maxValue - axis.minValue;
    const ticksPerRange = axisRange / suggestionInterval;
    if (ticksPerRange < numTicks) return {
        ticks: suggestions,
        interval: suggestionInterval
    };
    const ticks = [];
    const divisionFactor = Math.ceil(ticksPerRange / numTicks);
    for(let i = 0; i < len; i++)if (i % divisionFactor === 0) ticks.push(suggestions[i]);
    return {
        ticks: ticks,
        interval: divisionFactor * suggestionInterval
    };
}
/**
 * Extends the ticks to cover the full range of the axis.
 *
 * Due to animations/translations it is possible the ticks don't yet cover the
 * full range of the axis. This function extends the ticks as necessary, and
 * also includes a slight margin to prevent a "pop-in" effect of suddenly
 * appearing tick labels from the right edge.
 *
 * @note This function mutates the input ticks.
 */ function $97bfc4b4004b00d4$var$extendTicksToFitAxis(ticks, axis, max, scale, maxTicks, interval) {
    const scaleToAxis = (value)=>scale((value - axis.minValue) / (axis.maxValue - axis.minValue));
    // Trim ticks from the start if the user has dragged them beyond the Y axis.
    while(ticks.length && scaleToAxis(ticks[0]) < 0)ticks.shift();
    let preTick = ticks[0] - interval;
    while(ticks.length < maxTicks && scaleToAxis(preTick) >= 0){
        ticks.unshift(preTick);
        preTick -= interval;
    }
    let postTick = ticks[ticks.length - 1] + interval;
    while(ticks.length < maxTicks && scaleToAxis(postTick) < 1.1 * max){
        ticks.push(postTick);
        postTick += interval;
    }
}
const $97bfc4b4004b00d4$var$spring = {
    type: "tween",
    duration: 1,
    easings: [
        "anticipate"
    ]
};
function $97bfc4b4004b00d4$var$useCustomSpring(value, shouldAnimate = true) {
    const motionValue = (0, $91775a08ebdfe246$export$15b697acf84c78b9)(value);
    const [current, setCurrent] = (0, $2gcPZ.useState)(value);
    (0, $2gcPZ.useLayoutEffect)(()=>{
        return motionValue.on("change", (value)=>setCurrent(value));
    }, [
        motionValue
    ]);
    (0, $2gcPZ.useEffect)(()=>{
        if (shouldAnimate) {
            const controls = (0, $2f3f3768f144c5cc$export$e3607ec2d7a891c4)(motionValue, value, $97bfc4b4004b00d4$var$spring);
            return controls.stop;
        }
        setCurrent(value);
        return $97bfc4b4004b00d4$var$noop;
    }, [
        motionValue,
        value,
        shouldAnimate
    ]);
    return current;
}
/**
 * When rendering our svg charts, we want to avoid cutting off tick labels.
 * The way we can do this (simiar to visx's solution) is by not rendering ticks,
 * if they are too close to the axis's max value.
 *
 * The definition of what is "too close" to the max value
 * is determined by the `getMaxTickValue` function.
 *
 * @note This function mutates the input ticks.
 */ const $97bfc4b4004b00d4$var$removeLastTickIfTooCloseToMax = (ticks, maxValue, getMaxAllowedTick)=>{
    if (ticks.length < 2) return;
    const maxTickValue = getMaxAllowedTick(ticks, maxValue);
    const lastTick = ticks[ticks.length - 1];
    if (lastTick > maxTickValue) ticks.pop();
};
/**
 * Returns a maximum allowed tick value for the X axis.
 *
 * Heuristic:
 *   If a tick's distance to the maxValue is within 1/2 the size of the tick interval,
 *   the tick will get dropped.
 *
 * Note that the heuristic was determined by trial and error.
 */ const $97bfc4b4004b00d4$export$305ab1245db5f1fa = (ticks, maxValue)=>{
    if (ticks.length < 2) return maxValue;
    const interval = ticks[1] - ticks[0];
    return maxValue - interval / 2;
};
/**
 * Returns a maximum allowed tick value for the Y axis.
 *
 * Heuristic:
 *   If a tick's distance to the maxValue is within 1/3 the size of the tick interval,
 *   the tick will get dropped.
 *
 * Note that the heuristic was determined by trial and error.
 */ const $97bfc4b4004b00d4$var$getMaxYTickValue = (ticks, maxValue)=>{
    if (ticks.length < 2) return maxValue;
    const interval = ticks[1] - ticks[0];
    return maxValue - interval / 3;
};
function $97bfc4b4004b00d4$var$ZoomBar({ dimensions: { xMax: xMax, yMax: yMax }, mouseInteraction: mouseInteraction }) {
    if (mouseInteraction.type !== "zoom") return null;
    const { start: start, end: end } = mouseInteraction;
    if (end === undefined) return null;
    const reverseZoom = end < start;
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
        stroke: "#4797ff",
        fill: "#a3cbff",
        fillOpacity: "10%",
        x: (reverseZoom ? end : start) * xMax,
        y: 0,
        width: (reverseZoom ? start - end : end - start) * xMax,
        height: yMax
    });
}
const $97bfc4b4004b00d4$var$defaultState = {
    mouseInteraction: {
        type: "none"
    },
    dragKeyPressed: false,
    zoomKeyPressed: false
};
/**
 * Returns zoom/drag handlers and state.
 */ function $97bfc4b4004b00d4$export$bfb29d1974d1a373(readOnly) {
    const [state, dispatch] = (0, $2gcPZ.useReducer)(readOnly ? $97bfc4b4004b00d4$var$identity : $97bfc4b4004b00d4$var$controlsStateReducer, $97bfc4b4004b00d4$var$defaultState);
    const controls = (0, $2gcPZ.useMemo)(()=>$97bfc4b4004b00d4$var$createControls(dispatch), []);
    return {
        ...controls,
        ...state
    };
}
function $97bfc4b4004b00d4$var$createControls(dispatch) {
    return {
        resetMouseInteraction () {
            dispatch({
                type: "RESET_MOUSE_INTERACTION"
            });
        },
        startDrag (start) {
            dispatch({
                type: "DRAG_START",
                payload: {
                    start: start
                }
            });
        },
        startZoom (start) {
            dispatch({
                type: "ZOOM_START",
                payload: {
                    start: start
                }
            });
        },
        updateEndValue (end) {
            dispatch({
                type: "UPDATE_END_VALUE",
                payload: {
                    end: end
                }
            });
        },
        updatePressedKeys (event) {
            dispatch({
                type: "UPDATE_PRESSED_KEYS",
                payload: {
                    dragKeyPressed: $97bfc4b4004b00d4$var$dragKeyPressed(event),
                    zoomKeyPressed: $97bfc4b4004b00d4$var$zoomKeyPressed(event)
                }
            });
        }
    };
}
function $97bfc4b4004b00d4$var$controlsStateReducer(state, action) {
    switch(action.type){
        case "DRAG_START":
            return {
                ...state,
                mouseInteraction: {
                    type: "drag",
                    start: action.payload.start
                }
            };
        case "RESET_MOUSE_INTERACTION":
            return {
                ...state,
                mouseInteraction: $97bfc4b4004b00d4$var$defaultState.mouseInteraction
            };
        case "UPDATE_END_VALUE":
            if (state.mouseInteraction.type === "none") return state;
            return {
                ...state,
                mouseInteraction: {
                    ...state.mouseInteraction,
                    end: action.payload.end
                }
            };
        case "UPDATE_PRESSED_KEYS":
            return {
                ...state,
                ...action.payload
            };
        case "ZOOM_START":
            return {
                ...state,
                mouseInteraction: {
                    type: "zoom",
                    start: action.payload.start
                }
            };
        default:
            return state;
    }
}
function $97bfc4b4004b00d4$var$dragKeyPressed(event) {
    return event.shiftKey;
}
function $97bfc4b4004b00d4$var$zoomKeyPressed(event) {
    return $97bfc4b4004b00d4$var$isMac ? event.metaKey : event.ctrlKey;
}
const $97bfc4b4004b00d4$var$MIN_DURATION = 60; // in seconds
/**
 * Hook for setting up mouse handlers to control dragging & zoom
 */ function $97bfc4b4004b00d4$export$a579f4d26b6a9c61({ interactiveControls: { dragKeyPressed: dragKeyPressed, zoomKeyPressed: zoomKeyPressed, mouseInteraction: mouseInteraction, resetMouseInteraction: resetMouseInteraction, startDrag: startDrag, startZoom: startZoom, updateEndValue: updateEndValue }, timeRange: timeRange, onChangeTimeRange: onChangeTimeRange, dimensions: dimensions }) {
    function onMouseDown(event) {
        if (event.buttons !== 1 || !onChangeTimeRange) return;
        $97bfc4b4004b00d4$var$preventDefault(event);
        const coords = $97bfc4b4004b00d4$var$getCoordinatesForEvent(event, dimensions);
        if (!coords) return;
        if (dragKeyPressed) startDrag(coords.x);
        else if (zoomKeyPressed) startZoom(coords.x);
    }
    function onMouseMove(event) {
        $97bfc4b4004b00d4$var$preventDefault(event);
        if (mouseInteraction.type === "none") return;
        if (mouseInteraction.type === "drag" && !dragKeyPressed || mouseInteraction.type === "zoom" && !zoomKeyPressed) {
            resetMouseInteraction();
            return;
        }
        const coords = $97bfc4b4004b00d4$var$getCoordinatesForEvent(event, dimensions);
        if (coords) updateEndValue(coords.x);
    }
    function onMouseUp(event) {
        if (event.button !== 0) return;
        $97bfc4b4004b00d4$var$preventDefault(event);
        if (mouseInteraction.type === "zoom") {
            const { start: start, end: end } = mouseInteraction;
            if (end !== undefined && start !== end) onChangeTimeRange?.({
                from: $97bfc4b4004b00d4$var$coordinateToTimestamp(timeRange, Math.min(start, end)),
                to: $97bfc4b4004b00d4$var$coordinateToTimestamp(timeRange, Math.max(start, end))
            });
            resetMouseInteraction();
        } else if (mouseInteraction.type === "drag") {
            const { start: start, end: end } = mouseInteraction;
            if (end !== undefined && start !== end) move(start - end);
            resetMouseInteraction();
        }
    }
    function onWheel(event) {
        if (mouseInteraction.type !== "none" || !zoomKeyPressed) return;
        const coords = $97bfc4b4004b00d4$var$getCoordinatesForEvent(event, dimensions);
        if (!coords) return;
        $97bfc4b4004b00d4$var$preventDefault(event);
        const factor = event.deltaY < 0 ? 0.5 : 2;
        zoom(factor, coords.x);
    }
    /**
   * Moves the time scale.
   *
   * @param deltaRatio The delta to move as a ratio of the current time scale
   *                   window. -1 moves a full window to the left, and 1 moves
   *                   a full window to the right.
   */ function move(deltaRatio) {
        const currentFrom = $97bfc4b4004b00d4$var$timestampToSeconds(timeRange.from);
        const currentTo = $97bfc4b4004b00d4$var$timestampToSeconds(timeRange.to);
        const delta = deltaRatio * (currentTo - currentFrom);
        const from = $97bfc4b4004b00d4$var$secondsToTimestamp(currentFrom + delta);
        const to = $97bfc4b4004b00d4$var$secondsToTimestamp(currentTo + delta);
        onChangeTimeRange?.({
            from: from,
            to: to
        });
    }
    /**
   * Zooms into or out from the graph.
   *
   * @param factor The zoom factor. Anything below 1 makes the time scale
   *               smaller (zooming in), and anything above 1 makes the time
   *               scale larger (zooming out).
   * @param focusRatio The horizontal point on which to focus the zoom,
   *                   expressed as a ratio from 0 (left-hand side of the graph)
   *                   to 1 (right-hand side of the graph).
   */ function zoom(factor, focusRatio = 0.5) {
        const currentFrom = $97bfc4b4004b00d4$var$timestampToSeconds(timeRange.from);
        const currentTo = $97bfc4b4004b00d4$var$timestampToSeconds(timeRange.to);
        const duration = currentTo - currentFrom;
        const focusTimestamp = currentFrom + focusRatio * duration;
        const newDuration = Math.max(duration * factor, $97bfc4b4004b00d4$var$MIN_DURATION);
        const from = $97bfc4b4004b00d4$var$secondsToTimestamp(focusTimestamp - newDuration * focusRatio);
        const to = $97bfc4b4004b00d4$var$secondsToTimestamp(focusTimestamp + newDuration * (1 - focusRatio));
        onChangeTimeRange?.({
            from: from,
            to: to
        });
    }
    return {
        onMouseDown: onMouseDown,
        onMouseMove: onMouseMove,
        onMouseUp: onMouseUp,
        onWheel: onWheel
    };
}
function $97bfc4b4004b00d4$var$coordinateToTimestamp(timeRange, x) {
    const from = $97bfc4b4004b00d4$var$timestampToSeconds(timeRange.from);
    const to = $97bfc4b4004b00d4$var$timestampToSeconds(timeRange.to);
    return $97bfc4b4004b00d4$var$secondsToTimestamp(from + x * (to - from));
}
/**
 * Returns the scales to use for rendering SVG components.
 *
 * Fortunately for us, our abstract charts are normalized along both axes to
 * values from 0.0 to 1.0, meaning we can suffice with trivial linear scales.
 *
 * If the chart is being dragged with the mouse, translation along the X axis
 * is applied.
 */ function $97bfc4b4004b00d4$export$f6e7a46ff0d0d51a({ xMax: xMax, yMax: yMax }, mouseInteraction) {
    return (0, $2gcPZ.useMemo)(()=>({
            xMax: xMax,
            yMax: yMax,
            xScale: $97bfc4b4004b00d4$var$createLinearScaleForRange($97bfc4b4004b00d4$var$translatedRange(xMax, mouseInteraction)),
            yScale: $97bfc4b4004b00d4$var$createLinearScaleForRange([
                yMax,
                0
            ])
        }), [
        mouseInteraction,
        xMax,
        yMax
    ]);
}
function $97bfc4b4004b00d4$var$translatedRange(xMax, mouseInteraction) {
    if (mouseInteraction.type === "drag") {
        const { start: start, end: end } = mouseInteraction;
        if (end !== undefined && start !== end) {
            const delta = (end - start) * xMax;
            return [
                delta,
                xMax + delta
            ];
        }
    }
    return [
        0,
        xMax
    ];
}
/**
 * Handles the detection of where a tooltip should be shown.
 *
 * Should be passed a callback for showing the actual tooltip. If no callback
 * is passed, tooltips are disabled.
 */ function $97bfc4b4004b00d4$var$useTooltip(props) {
    const [graphTooltip, setGraphTooltip] = (0, $2gcPZ.useState)(null);
    const closeFnRef = (0, $2gcPZ.useRef)(null);
    const showTooltipFn = props.showTooltip;
    const showTooltip = showTooltipFn ? (tip)=>{
        setGraphTooltip(tip);
        const element = {
            getBoundingClientRect: ()=>{
                const ctm = tip.element.getScreenCTM();
                const point = tip.element.createSVGPoint();
                point.x = tip.left;
                point.y = tip.top;
                const { x: x, y: y } = ctm ? point.matrixTransform(ctm) : {
                    x: tip.left,
                    y: tip.top
                };
                return new DOMRect(x - 4, y - 4, 8, 8);
            },
            contextElement: tip.element
        };
        closeFnRef.current = showTooltipFn(element, tip.sourcePoint);
    } : $97bfc4b4004b00d4$var$noop;
    const closeTooltip = $97bfc4b4004b00d4$var$useHandler(()=>{
        setGraphTooltip(null);
        if (closeFnRef.current) {
            closeFnRef.current();
            closeFnRef.current = null;
        }
    });
    (0, $2gcPZ.useEffect)(()=>{
        if (!showTooltipFn) closeTooltip();
    }, [
        closeTooltip,
        showTooltipFn
    ]);
    return {
        graphTooltip: graphTooltip,
        onMouseMove: (event)=>{
            const closest = $97bfc4b4004b00d4$var$getClosestSeriesAndPointWithCoordinates(event, props);
            if (!closest) return;
            const [series, point, coords] = closest;
            const { chart: chart, dimensions: dimensions, getShapeListColor: getShapeListColor } = props;
            const shapeListIndex = chart.shapeLists.findIndex((shapeList)=>shapeList.source === series);
            const color = getShapeListColor(series, shapeListIndex);
            showTooltip({
                color: color,
                element: event.currentTarget,
                sourcePoint: [
                    series,
                    point
                ],
                top: (1 - coords.y) * dimensions.yMax + $97bfc4b4004b00d4$var$MARGINS.top,
                left: coords.x * dimensions.xMax + $97bfc4b4004b00d4$var$MARGINS.left
            });
        },
        onMouseLeave: ()=>{
            closeTooltip();
        }
    };
}
/**
 * Returns the closest coordinates where a tooltip should be displayed,
 * including the source series and point that were used to generate the shape
 * at those coordinates.
 */ function $97bfc4b4004b00d4$var$getClosestSeriesAndPointWithCoordinates(event, { chart: chart, dimensions: scales }) {
    const coords = $97bfc4b4004b00d4$var$getCoordinatesForEvent(event, scales);
    if (!coords) return null;
    let closestSeriesAndPoint = null;
    let closestDistance = [
        Infinity,
        0
    ];
    for (const shapeList of chart.shapeLists)for (const shape of shapeList.shapes){
        const closest = $97bfc4b4004b00d4$var$getClosestPointWithDistance(shape, coords);
        if (!closest) continue;
        const [point, closestCoords, distance] = closest;
        if ($97bfc4b4004b00d4$var$isCloser(distance, closestDistance)) {
            closestSeriesAndPoint = [
                shapeList.source,
                point,
                closestCoords
            ];
            closestDistance = distance;
        }
    }
    return closestSeriesAndPoint;
}
function $97bfc4b4004b00d4$var$getClosestPointWithDistance(shape, coords) {
    switch(shape.type){
        case "area":
            return $97bfc4b4004b00d4$var$getClosestPointWithDistanceForArea(shape, coords);
        case "line":
            return $97bfc4b4004b00d4$var$getClosestPointWithDistanceForLine(shape, coords);
        case "point":
            return [
                shape.source,
                shape,
                $97bfc4b4004b00d4$var$getDistance(coords, shape)
            ];
        case "rectangle":
            return $97bfc4b4004b00d4$var$getClosestPointWithDistanceForRectangle(shape, coords);
    }
}
function $97bfc4b4004b00d4$var$getClosestPointWithDistanceForArea(area, coords) {
    const len = area.points.length;
    if (len === 0) return null;
    let closest;
    let horizontalDistance;
    if (coords.x < area.points[0].x) {
        closest = area.points[0];
        horizontalDistance = closest.x - coords.x;
    } else if (coords.x > area.points[len - 1].x) {
        closest = area.points[len - 1];
        horizontalDistance = coords.x - closest.x;
    } else {
        closest = area.points[0];
        horizontalDistance = coords.x - closest.x;
        for(let i = 1; i < len; i++){
            const point = area.points[i];
            const distance = Math.abs(point.x - coords.x);
            if (distance < horizontalDistance) {
                closest = point;
                horizontalDistance = distance;
            } else break;
        }
    }
    let verticalDistance;
    if (coords.y < closest.yMin) verticalDistance = closest.yMin - coords.y;
    else if (coords.y > closest.yMax) verticalDistance = coords.y - closest.yMax;
    else verticalDistance = 0;
    return [
        closest.source,
        {
            x: closest.x,
            y: coords.y < closest.yMin ? closest.yMin : closest.yMax
        },
        [
            horizontalDistance,
            verticalDistance
        ]
    ];
}
function $97bfc4b4004b00d4$var$getClosestPointWithDistanceForLine(line, coords) {
    let closestPoint = null;
    let closestDistance = [
        Infinity,
        0
    ];
    for (const point of line.points){
        const distance = $97bfc4b4004b00d4$var$getDistance(coords, point);
        if ($97bfc4b4004b00d4$var$isCloser(distance, closestDistance)) {
            closestPoint = point;
            closestDistance = distance;
        }
    }
    return closestPoint ? [
        closestPoint.source,
        closestPoint,
        closestDistance
    ] : null;
}
function $97bfc4b4004b00d4$var$getClosestPointWithDistanceForRectangle(rectangle, coords) {
    let horizontal;
    if (coords.x < rectangle.x) horizontal = rectangle.x - coords.x;
    else if (coords.x > rectangle.x + rectangle.width) horizontal = coords.x - (rectangle.x + rectangle.width);
    else horizontal = 0;
    let vertical;
    if (coords.y < rectangle.y) vertical = rectangle.y - coords.y;
    else if (coords.y > rectangle.y + rectangle.height) vertical = coords.y - (rectangle.y + rectangle.height);
    else vertical = 0;
    return [
        rectangle.source,
        {
            x: rectangle.x + 0.5 * rectangle.width,
            y: rectangle.y + rectangle.height
        },
        [
            horizontal,
            vertical
        ]
    ];
}
function $97bfc4b4004b00d4$var$getDistance(p1, p2) {
    return [
        Math.abs(p1.x - p2.x),
        Math.abs(p1.y - p2.y)
    ];
}
/**
 * Returns whether the given distance is closer than the given reference.
 *
 * Horizontal distance is prioritized over vertical distance.
 */ function $97bfc4b4004b00d4$var$isCloser(distance, reference) {
    return distance[0] < reference[0] || distance[0] === reference[0] && distance[1] < reference[1];
}
function $97bfc4b4004b00d4$var$CoreChart({ areaGradientShown: areaGradientShown = true, chart: chart, getShapeListColor: getShapeListColor, onChangeTimeRange: onChangeTimeRange, readOnly: readOnly = false, showTooltip: showTooltip, timeRange: timeRange, ...props }) {
    const interactiveControls = $97bfc4b4004b00d4$export$bfb29d1974d1a373(readOnly);
    const { mouseInteraction: mouseInteraction, updatePressedKeys: updatePressedKeys } = interactiveControls;
    const { width: width, height: height, xMax: xMax, yMax: yMax, marginTop: marginTop, marginLeft: marginLeft } = (0, $2gcPZ.useContext)($97bfc4b4004b00d4$var$ChartSizeContext);
    const dimensions = {
        xMax: xMax,
        yMax: yMax
    };
    const { onMouseDown: onMouseDown, onMouseUp: onMouseUp, onWheel: onWheel, onMouseMove: onMouseMoveControls } = $97bfc4b4004b00d4$export$a579f4d26b6a9c61({
        dimensions: dimensions,
        interactiveControls: interactiveControls,
        onChangeTimeRange: onChangeTimeRange,
        timeRange: timeRange
    });
    const { graphTooltip: graphTooltip, onMouseMove: onMouseMoveTooltip, onMouseLeave: onMouseLeave } = $97bfc4b4004b00d4$var$useTooltip({
        chart: chart,
        dimensions: dimensions,
        getShapeListColor: getShapeListColor,
        showTooltip: $97bfc4b4004b00d4$var$modifierPressed(interactiveControls) ? undefined : showTooltip
    });
    const onMouseMove = (event)=>{
        updatePressedKeys(event);
        onMouseMoveControls(event);
        onMouseMoveTooltip(event);
    };
    const clipPathId = (0, $2gcPZ.useId)();
    const cursor = $97bfc4b4004b00d4$export$131881d04c9bef6f(interactiveControls);
    const scales = $97bfc4b4004b00d4$export$f6e7a46ff0d0d51a(dimensions, mouseInteraction);
    const tickFormatters = (0, $2gcPZ.useMemo)(()=>{
        return typeof props.tickFormatters === "function" ? props.tickFormatters(chart.xAxis, chart.yAxis) : props.tickFormatters;
    }, [
        chart,
        props.tickFormatters
    ]);
    (0, $2gcPZ.useEffect)(()=>{
        const wheelListenerOptions = {
            passive: false
        };
        window.addEventListener("keydown", updatePressedKeys);
        window.addEventListener("keyup", updatePressedKeys);
        window.addEventListener("wheel", onWheel, wheelListenerOptions);
        return ()=>{
            window.removeEventListener("keydown", updatePressedKeys);
            window.removeEventListener("keyup", updatePressedKeys);
            window.removeEventListener("wheel", onWheel, wheelListenerOptions);
        };
    }, [
        onWheel,
        updatePressedKeys
    ]);
    const clipPathYStart = -1 * $97bfc4b4004b00d4$var$CHART_SHAPE_OVERFLOW_MARGIN;
    const clipPathHeight = yMax + 2 * $97bfc4b4004b00d4$var$CHART_SHAPE_OVERFLOW_MARGIN;
    // HACK - For spark charts, the clip path can be larger than the chart itself,
    //        which leads to points getting cut off
    const svgHeight = height > clipPathHeight ? height : clipPathHeight;
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: width,
        height: svgHeight,
        onMouseDown: onMouseDown,
        onMouseMove: onMouseMove,
        onMouseUp: onMouseUp,
        onMouseLeave: onMouseLeave,
        style: {
            cursor: cursor,
            marginTop: 2
        },
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("clipPath", {
                    id: clipPathId,
                    children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                        x: 0,
                        y: clipPathYStart,
                        width: xMax,
                        height: clipPathHeight
                    })
                })
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("g", {
                transform: `translate(${marginLeft}, ${marginTop})`,
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$var$GridWithAxes, {
                        ...props,
                        chart: chart,
                        scales: scales,
                        tickFormatters: tickFormatters
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("g", {
                        clipPath: `url(#${clipPathId})`,
                        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$var$ChartContent, {
                            ...props,
                            areaGradientShown: areaGradientShown,
                            chart: chart,
                            getShapeListColor: getShapeListColor,
                            scales: scales
                        })
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$var$ZoomBar, {
                        dimensions: dimensions,
                        mouseInteraction: mouseInteraction
                    })
                ]
            }),
            graphTooltip && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("line", {
                        x1: graphTooltip.left,
                        y1: 0,
                        x2: graphTooltip.left,
                        y2: yMax,
                        stroke: graphTooltip.color,
                        pointerEvents: "none",
                        strokeDasharray: "1 1"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("circle", {
                        cx: graphTooltip.left,
                        cy: graphTooltip.top,
                        r: 4,
                        fill: graphTooltip.color,
                        pointerEvents: "none"
                    })
                ]
            })
        ]
    });
}
function $97bfc4b4004b00d4$var$modifierPressed(state) {
    return state.dragKeyPressed || state.zoomKeyPressed;
}
function $97bfc4b4004b00d4$export$131881d04c9bef6f(state) {
    switch(state.mouseInteraction.type){
        case "none":
            if (state.dragKeyPressed) return "grab";
            if (state.zoomKeyPressed) return "zoom-in";
            return "default";
        case "drag":
            return "grabbing";
        case "zoom":
            return "zoom-in";
    }
}
/**
 * Converts an RFC 3339-formatted timestamp to a time expressed in seconds since
 * the UNIX epoch.
 */ function $97bfc4b4004b00d4$var$getTimeFromTimestamp(timestamp) {
    const time = new Date(timestamp).getTime() / 1000;
    if (Number.isNaN(time)) throw new TypeError(`Invalid timestamp: ${timestamp}`);
    return time;
}
/**
 * Adds suggestions to the axis based on the position of the first bucket and
 * the interval between buckets.
 *
 * @note This function mutates its input axis.
 */ function $97bfc4b4004b00d4$var$attachSuggestionsToXAxis(xAxis, buckets, interval) {
    if (interval <= 0) return;
    const firstBucketTime = $97bfc4b4004b00d4$var$getFirstBucketTime(buckets);
    if (!firstBucketTime) return;
    const suggestions = [];
    let suggestion = firstBucketTime;
    while(suggestion < xAxis.maxValue){
        if (suggestion >= xAxis.minValue) suggestions.push(suggestion);
        suggestion += interval;
    }
    xAxis.tickSuggestions = suggestions;
}
function $97bfc4b4004b00d4$var$getFirstBucketTime(buckets) {
    let firstBucketTimestamp;
    for (const timestamp of buckets.keys())if (!firstBucketTimestamp || timestamp < firstBucketTimestamp) firstBucketTimestamp = timestamp;
    return firstBucketTimestamp ? $97bfc4b4004b00d4$var$getTimeFromTimestamp(firstBucketTimestamp) : undefined;
}
const $97bfc4b4004b00d4$var$BAR_PADDING = 0.2;
const $97bfc4b4004b00d4$var$BAR_PLUS_PADDING = 1 + $97bfc4b4004b00d4$var$BAR_PADDING;
/**
 * Calculates the width of bars in bar charts.
 */ function $97bfc4b4004b00d4$var$calculateBarWidth(xAxis, interval, numBarsPerGroup) {
    const numGroups = interval === 0 ? 1 : Math.round((xAxis.maxValue - xAxis.minValue) / interval) + 1;
    const numBars = numGroups * numBarsPerGroup;
    return 1 / (numBars * $97bfc4b4004b00d4$var$BAR_PLUS_PADDING);
}
const $97bfc4b4004b00d4$var$HALF_PADDING = 0.5 * $97bfc4b4004b00d4$var$BAR_PADDING;
/**
 * Calculates the (left) X coordinate for a bar in a bar chart.
 *
 * `groupX` is the center coordinate for the bar group that contains all the
 * bars for a given bucket. `barWidth` is the width of an individual bar.
 *
 * `barIndex` and `numShapeLists` define the index of the bar within the group,
 * and how many bars may exist in the group in total, respectively.
 */ function $97bfc4b4004b00d4$var$calculateBarX(groupX, barWidth, barIndex, numShapeLists) {
    return groupX + (barIndex - 0.5 * numShapeLists) * (barWidth * $97bfc4b4004b00d4$var$BAR_PLUS_PADDING) - barWidth * $97bfc4b4004b00d4$var$HALF_PADDING;
}
/**
 * Extends the given min-max, if necessary, with the given value.
 *
 * @note This function mutates its input min-max.
 */ function $97bfc4b4004b00d4$var$extendMinMax(minMax, value) {
    if (value < minMax[0]) minMax[0] = value;
    else if (value > minMax[1]) minMax[1] = value;
    return minMax;
}
/**
 * Returns the initial min-max based on a single value.
 */ function $97bfc4b4004b00d4$var$getInitialMinMax(value) {
    return [
        value,
        value
    ];
}
// NOTE - These constants account for floating point artifacts in the input data
//        E.g., we want to treat 1.0 and 1.0000000000000002 as the same value
//        Otherwise, we'll end up graphing a value like 1.0000000000000002 as a straight line in the middle of the graph
const $97bfc4b4004b00d4$var$ONE = 1.0 + Number.EPSILON;
const $97bfc4b4004b00d4$var$NEGATIVE_ONE = -1 - Number.EPSILON;
const $97bfc4b4004b00d4$var$POSITIVE_ZERO = Number.EPSILON;
/**
 * Returns the Y axis to display results if all results have the same value.
 *
 * For values larger than 1 or smaller than -1, the results will be centered
 * along the Y axis.
 *
 * For values that are functionally 0 (between 0 and EPSILON), the results will be at the very bottom of the chart,
 * and the max will be 1.
 *
 * For values that are functionally 1 (between 1 and 1+EPSILON),
 * the resulting line or dot will be at the very top of the chart, and the max will be the value itself.
 *
 * For values closer to zero, the zero value is kept at the
 * bottom 1/8th (for positive values) or top 1/8th (for negative values) of the
 * axis.
 */ function $97bfc4b4004b00d4$var$getYAxisForConstantValue(value) {
    let axis;
    if (value > $97bfc4b4004b00d4$var$ONE || value < $97bfc4b4004b00d4$var$NEGATIVE_ONE) axis = {
        minValue: value - 1,
        maxValue: value + 1
    };
    else if (value >= 0 && value <= $97bfc4b4004b00d4$var$POSITIVE_ZERO) axis = {
        minValue: 0,
        maxValue: 1
    };
    else if (value >= 1 && value <= $97bfc4b4004b00d4$var$ONE) axis = {
        minValue: 0,
        maxValue: value
    };
    else if (value > 0) // HACK - value * 8 ensures that we'll have enough room to display the tick label for the value
    axis = {
        minValue: 0,
        maxValue: value * 8
    };
    else axis = {
        minValue: value - 1,
        maxValue: 0
    };
    const tickSuggestions = [
        value
    ];
    if (axis.minValue !== value) tickSuggestions.unshift(axis.minValue);
    if (axis.maxValue !== value) tickSuggestions.push(axis.maxValue);
    $97bfc4b4004b00d4$var$attachTickSuggestions(axis, tickSuggestions);
    return axis;
}
/**
 * If the first two tick suggestions are the min and max values, then we
 * divide the tick suggestions into 8 equal parts.
 *
 * If the first two tick suggestions are not the min and max values, then we
 * use the those two suggestions as the interval, and give suggestions with that interval
 * until we reach the max value.
 *
 * @note This function mutates the axis object
 */ function $97bfc4b4004b00d4$var$attachTickSuggestions(axis, suggestions) {
    if (suggestions.length < 2) {
        axis.tickSuggestions = suggestions;
        return;
    }
    const [firstTick, secondTick] = suggestions;
    let interval;
    if (firstTick === axis.minValue && secondTick === axis.maxValue) interval = (secondTick - firstTick) / 8;
    else interval = secondTick - firstTick;
    if (interval < Number.EPSILON) {
        axis.tickSuggestions = suggestions;
        return;
    }
    axis.tickSuggestions = [];
    let currentTick = firstTick;
    while(currentTick <= axis.maxValue){
        axis.tickSuggestions.push(currentTick);
        currentTick += interval;
    }
}
/**
 * Detects the range to display along the Y axis by looking at all the totals
 * inside the buckets.
 *
 * This function is used for stacked charts. When rendering a normal chart, use
 * `calculateYAxisRange()` instead.
 */ function $97bfc4b4004b00d4$var$calculateStackedYAxisRange(buckets, getTotalValue) {
    if (buckets.size === 0) return $97bfc4b4004b00d4$var$getYAxisForConstantValue(0);
    const minMax = $97bfc4b4004b00d4$var$getInitialMinMax(0);
    for (const value of buckets.values())$97bfc4b4004b00d4$var$extendMinMax(minMax, getTotalValue(value));
    const [minValue, maxValue] = minMax;
    if (minValue === maxValue) return $97bfc4b4004b00d4$var$getYAxisForConstantValue(minValue);
    return {
        minValue: minValue,
        maxValue: maxValue
    };
}
function $97bfc4b4004b00d4$var$createMetricBuckets(timeseriesData, reducer, initialValue) {
    const buckets = new Map();
    for (const timeseries of timeseriesData){
        if (!timeseries.visible) continue;
        for (const { time: time, value: value } of timeseries.metrics)if (!Number.isNaN(value)) buckets.set(time, reducer(buckets.get(time) ?? initialValue, value));
    }
    return buckets;
}
/**
 * Returns the X axis to display results for the given time range.
 */ function $97bfc4b4004b00d4$export$20bdbc6e30fb5614(timeRange) {
    return {
        minValue: $97bfc4b4004b00d4$var$getTimeFromTimestamp(timeRange.from),
        maxValue: $97bfc4b4004b00d4$var$getTimeFromTimestamp(timeRange.to)
    };
}
/**
 * Wrapper around `createMetricBuckets()` and axes creation specialized for
 * usage with stacked charts.
 */ function $97bfc4b4004b00d4$var$calculateBucketsAndAxesForStackedChart(input) {
    const buckets = $97bfc4b4004b00d4$var$createMetricBuckets(input.timeseriesData, ({ currentY: currentY, total: total }, value)=>({
            currentY: currentY,
            total: total + value
        }), {
        currentY: 0,
        total: 0
    });
    const isPercentage = input.stackingType === "percentage";
    const xAxis = $97bfc4b4004b00d4$export$20bdbc6e30fb5614(input.timeRange);
    const yAxis = isPercentage ? {
        minValue: 0,
        maxValue: 1
    } : $97bfc4b4004b00d4$var$calculateStackedYAxisRange(buckets, ({ total: total })=>total);
    return {
        buckets: buckets,
        isPercentage: isPercentage,
        xAxis: xAxis,
        yAxis: yAxis
    };
}
/**
 * Calculates the smallest interval between any two timestamps present in the
 * given buckets.
 *
 * Returns `null` if there are insufficient timestamps to calculate an interval.
 */ function $97bfc4b4004b00d4$var$calculateSmallestTimeInterval(buckets) {
    const timestamps = Array.from(buckets.keys(), $97bfc4b4004b00d4$var$getTimeFromTimestamp);
    if (timestamps.length < 2) return null;
    timestamps.sort();
    let smallestInterval = Infinity;
    for(let i = 1; i < timestamps.length; i++){
        const interval = timestamps[i] - timestamps[i - 1];
        if (interval < smallestInterval) smallestInterval = interval;
    }
    return smallestInterval;
}
/**
 * Detects the range to display along the Y axis by looking at all the min-max
 * values inside the buckets.
 *
 * When rendering a stacked chart, use `calculateStackedYAxisRange()` instead.
 */ function $97bfc4b4004b00d4$var$calculateYAxisRange(buckets, getMinMax) {
    const minMax = $97bfc4b4004b00d4$var$getBucketsMinMax(buckets, getMinMax);
    if (!minMax) return $97bfc4b4004b00d4$var$getYAxisForConstantValue(0);
    let [minValue, maxValue] = minMax;
    if (minValue === maxValue) return $97bfc4b4004b00d4$var$getYAxisForConstantValue(minValue);
    const distance = maxValue - minValue;
    const margin = 0.05 * distance;
    if (minValue < 0 || minValue >= margin) minValue -= margin;
    else minValue = 0;
    if (maxValue > 0 || maxValue <= -margin) maxValue += margin;
    else maxValue = 0;
    return {
        minValue: minValue,
        maxValue: maxValue
    };
}
function $97bfc4b4004b00d4$var$getBucketsMinMax(buckets, getMinMax) {
    let minMax;
    for (const value of buckets.values()){
        const bucketMinMax = getMinMax(value);
        if (!minMax) {
            minMax = bucketMinMax;
            continue;
        }
        if (bucketMinMax[0] < minMax[0]) minMax[0] = bucketMinMax[0];
        if (bucketMinMax[1] > minMax[1]) minMax[1] = bucketMinMax[1];
    }
    return minMax;
}
/**
 * Extends the range of an axis with the given interval.
 *
 * The range of the interval is divided among ends of the axis. The purpose of
 * this is to extend the axis with enough space to display the bars for the
 * first and last buckets displayed on the bar chart.
 *
 * @note This function mutates its input axis.
 */ function $97bfc4b4004b00d4$var$extendAxisWithInterval(axis, interval) {
    const halfInterval = 0.5 * interval;
    axis.minValue -= halfInterval;
    axis.maxValue += halfInterval;
    return axis;
}
/**
 * Extends the range of the axis with the given value.
 *
 * If the given value is outside the range of the axis, the range is
 * extended to include the value. Otherwise, nothing happens.
 *
 * @note This function mutates its input axis.
 */ function $97bfc4b4004b00d4$var$extendAxisWithValue(axis, value) {
    if (value < axis.minValue) axis.minValue = value;
    else if (value > axis.maxValue) axis.maxValue = value;
    return axis;
}
/**
 * Takes an absolute value and normalizes it to a value between 0.0 and 1.0 for
 * the given axis.
 */ function $97bfc4b4004b00d4$var$normalizeAlongLinearAxis(value, axis) {
    return (value - axis.minValue) / (axis.maxValue - axis.minValue);
}
/**
 * Takes an array of metrics and divides it into a lines of metrics without
 * gaps.
 *
 * Any metric that has a `NaN` value, or that follows more than `1.5 * interval`
 * after the previous metric is considered to introduce a gap in the metrics.
 */ function $97bfc4b4004b00d4$var$splitIntoContinuousLines(metrics, interval) {
    const lines = [];
    let currentLine = [];
    let previousTime = null;
    for (const metric of metrics){
        if (Number.isNaN(metric.value)) {
            if (currentLine.length > 0) {
                lines.push(currentLine);
                currentLine = [];
            }
            continue;
        }
        const newTime = $97bfc4b4004b00d4$var$getTimeFromTimestamp(metric.time);
        if (previousTime && interval && newTime - previousTime > 1.5 * interval) {
            if (currentLine.length > 0) lines.push(currentLine);
            currentLine = [
                metric
            ];
        } else currentLine.push(metric);
        previousTime = newTime;
    }
    if (currentLine.length > 0) lines.push(currentLine);
    return lines;
}
function $97bfc4b4004b00d4$var$generateBarChartFromTimeseries(input) {
    const visibleTimeseriesData = input.timeseriesData.filter((timeseries)=>timeseries.visible);
    const buckets = $97bfc4b4004b00d4$var$createMetricBuckets(visibleTimeseriesData, (maybeMinMax, value)=>maybeMinMax ? $97bfc4b4004b00d4$var$extendMinMax(maybeMinMax, value) : $97bfc4b4004b00d4$var$getInitialMinMax(value));
    const xAxis = $97bfc4b4004b00d4$export$20bdbc6e30fb5614(input.timeRange);
    const yAxis = $97bfc4b4004b00d4$var$calculateYAxisRange(buckets, $97bfc4b4004b00d4$var$identity);
    for (const value of input.additionalValues)$97bfc4b4004b00d4$var$extendAxisWithValue(yAxis, value);
    const numShapeLists = visibleTimeseriesData.length;
    const interval = $97bfc4b4004b00d4$var$calculateSmallestTimeInterval(buckets);
    if (interval) {
        $97bfc4b4004b00d4$var$extendAxisWithInterval(xAxis, interval);
        $97bfc4b4004b00d4$var$attachSuggestionsToXAxis(xAxis, buckets, interval);
    }
    const barWidth = $97bfc4b4004b00d4$var$calculateBarWidth(xAxis, interval ?? 0, numShapeLists);
    const barArgs = {
        barWidth: barWidth,
        numShapeLists: numShapeLists,
        xAxis: xAxis,
        yAxis: yAxis
    };
    const shapeLists = input.timeseriesData.map((timeseries)=>({
            shapes: timeseries.visible ? $97bfc4b4004b00d4$var$compact(timeseries.metrics.map((metric)=>$97bfc4b4004b00d4$var$getBarShape$1(metric, visibleTimeseriesData.indexOf(timeseries), barArgs))) : [],
            source: timeseries
        }));
    return {
        shapeLists: shapeLists,
        xAxis: xAxis,
        yAxis: yAxis
    };
}
function $97bfc4b4004b00d4$var$getBarShape$1(metric, barIndex, { xAxis: xAxis, yAxis: yAxis, barWidth: barWidth, numShapeLists: numVisibleTimeseries }) {
    if (Number.isNaN(metric.value)) return null;
    const groupX = $97bfc4b4004b00d4$var$normalizeAlongLinearAxis($97bfc4b4004b00d4$var$getTimeFromTimestamp(metric.time), xAxis);
    return {
        type: "rectangle",
        x: $97bfc4b4004b00d4$var$calculateBarX(groupX, barWidth, barIndex, numVisibleTimeseries),
        width: barWidth,
        y: 0,
        height: $97bfc4b4004b00d4$var$normalizeAlongLinearAxis(metric.value, yAxis),
        source: metric
    };
}
function $97bfc4b4004b00d4$var$generateLineChartFromTimeseries(input) {
    const buckets = $97bfc4b4004b00d4$var$createMetricBuckets(input.timeseriesData, (maybeMinMax, value)=>maybeMinMax ? $97bfc4b4004b00d4$var$extendMinMax(maybeMinMax, value) : $97bfc4b4004b00d4$var$getInitialMinMax(value));
    const xAxis = $97bfc4b4004b00d4$export$20bdbc6e30fb5614(input.timeRange);
    const yAxis = $97bfc4b4004b00d4$var$calculateYAxisRange(buckets, $97bfc4b4004b00d4$var$identity);
    for (const value of input.additionalValues)$97bfc4b4004b00d4$var$extendAxisWithValue(yAxis, value);
    const interval = $97bfc4b4004b00d4$var$calculateSmallestTimeInterval(buckets);
    if (interval) $97bfc4b4004b00d4$var$attachSuggestionsToXAxis(xAxis, buckets, interval);
    const shapeLists = input.timeseriesData.map((timeseries)=>({
            shapes: timeseries.visible ? $97bfc4b4004b00d4$var$getShapes$1(timeseries.metrics, xAxis, yAxis, interval) : [],
            source: timeseries
        }));
    return {
        shapeLists: shapeLists,
        xAxis: xAxis,
        yAxis: yAxis
    };
}
function $97bfc4b4004b00d4$var$getShapes$1(metrics, xAxis, yAxis, interval) {
    switch(metrics.length){
        case 0:
            return [];
        case 1:
            {
                const metric = metrics[0];
                return Number.isNaN(metric.value) ? [] : [
                    {
                        type: "point",
                        ...$97bfc4b4004b00d4$var$getPointForMetric$1(metric, xAxis, yAxis)
                    }
                ];
            }
        default:
            {
                const lines = $97bfc4b4004b00d4$var$splitIntoContinuousLines(metrics, interval ?? undefined);
                return lines.map((line)=>// Otherwise, render a line
                    line.length === 1 ? {
                        type: "point",
                        ...$97bfc4b4004b00d4$var$getPointForMetric$1(line[0], xAxis, yAxis)
                    } : {
                        type: "line",
                        points: line.map((metric)=>$97bfc4b4004b00d4$var$getPointForMetric$1(metric, xAxis, yAxis))
                    });
            }
    }
}
function $97bfc4b4004b00d4$var$getPointForMetric$1(metric, xAxis, yAxis) {
    const time = $97bfc4b4004b00d4$var$getTimeFromTimestamp(metric.time);
    return {
        x: $97bfc4b4004b00d4$var$normalizeAlongLinearAxis(time, xAxis),
        y: $97bfc4b4004b00d4$var$normalizeAlongLinearAxis(metric.value, yAxis),
        source: metric
    };
}
function $97bfc4b4004b00d4$var$generateShapeListFromEvents({ minValue: minValue, maxValue: maxValue }, events) {
    return {
        shapes: events.map((event)=>{
            const x = ($97bfc4b4004b00d4$var$getTimeFromTimestamp(event.time) - minValue) / (maxValue - minValue);
            return {
                type: "area",
                points: [
                    {
                        x: x,
                        yMin: 0,
                        yMax: 1,
                        source: event
                    }
                ],
                strokeDasharray: [
                    2
                ]
            };
        }),
        source: {
            type: "events"
        }
    };
}
function $97bfc4b4004b00d4$var$generateShapeListFromTargetLatency(yAxis, value) {
    return {
        shapes: [
            {
                type: "line",
                points: [
                    {
                        x: 0,
                        y: $97bfc4b4004b00d4$var$normalizeAlongLinearAxis(value, yAxis),
                        source: null
                    },
                    {
                        x: 1,
                        y: $97bfc4b4004b00d4$var$normalizeAlongLinearAxis(value, yAxis),
                        source: null
                    }
                ]
            }
        ],
        source: {
            type: "target_latency"
        }
    };
}
function $97bfc4b4004b00d4$var$generateStackedBarChartFromTimeseries(input) {
    const { buckets: buckets, isPercentage: isPercentage, xAxis: xAxis, yAxis: yAxis } = $97bfc4b4004b00d4$var$calculateBucketsAndAxesForStackedChart(input);
    for (const value of input.additionalValues)$97bfc4b4004b00d4$var$extendAxisWithValue(yAxis, value);
    const interval = $97bfc4b4004b00d4$var$calculateSmallestTimeInterval(buckets);
    if (interval) {
        $97bfc4b4004b00d4$var$extendAxisWithInterval(xAxis, interval);
        $97bfc4b4004b00d4$var$attachSuggestionsToXAxis(xAxis, buckets, interval);
    }
    const barWidth = $97bfc4b4004b00d4$var$calculateBarWidth(xAxis, interval ?? 0, 1);
    const barArgs = {
        barWidth: barWidth,
        buckets: buckets,
        isPercentage: isPercentage,
        xAxis: xAxis,
        yAxis: yAxis
    };
    const shapeLists = input.timeseriesData.map((timeseries)=>({
            shapes: timeseries.visible ? $97bfc4b4004b00d4$var$compact(timeseries.metrics.map((metric)=>$97bfc4b4004b00d4$var$getBarShape(metric, barArgs))) : [],
            source: timeseries
        }));
    return {
        shapeLists: shapeLists,
        xAxis: xAxis,
        yAxis: yAxis
    };
}
function $97bfc4b4004b00d4$var$getBarShape(metric, { xAxis: xAxis, yAxis: yAxis, barWidth: barWidth, isPercentage: isPercentage, buckets: buckets }) {
    const bucketValue = buckets.get(metric.time);
    if (!bucketValue || Number.isNaN(metric.value)) return null;
    const time = $97bfc4b4004b00d4$var$getTimeFromTimestamp(metric.time);
    const value = isPercentage ? metric.value / bucketValue.total : metric.value;
    const x = $97bfc4b4004b00d4$var$normalizeAlongLinearAxis(time, xAxis) - 0.5 * barWidth;
    const y = bucketValue.currentY;
    const height = $97bfc4b4004b00d4$var$normalizeAlongLinearAxis(value, yAxis);
    bucketValue.currentY += height;
    return {
        type: "rectangle",
        x: x,
        y: y,
        width: barWidth,
        height: height,
        source: metric
    };
}
function $97bfc4b4004b00d4$var$generateStackedLineChartFromTimeseries(input) {
    const axesAndBuckets = $97bfc4b4004b00d4$var$calculateBucketsAndAxesForStackedChart(input);
    const { buckets: buckets, xAxis: xAxis, yAxis: yAxis } = axesAndBuckets;
    for (const value of input.additionalValues)$97bfc4b4004b00d4$var$extendAxisWithValue(yAxis, value);
    const interval = $97bfc4b4004b00d4$var$calculateSmallestTimeInterval(buckets);
    if (interval) $97bfc4b4004b00d4$var$attachSuggestionsToXAxis(xAxis, buckets, interval);
    const shapeLists = input.timeseriesData.map((timeseries)=>({
            shapes: timeseries.visible ? $97bfc4b4004b00d4$var$getShapes(timeseries.metrics, axesAndBuckets, interval) : [],
            source: timeseries
        }));
    return {
        shapeLists: shapeLists,
        xAxis: xAxis,
        yAxis: yAxis
    };
}
function $97bfc4b4004b00d4$var$getShapes(metrics, axesAndBuckets, interval) {
    const lines = $97bfc4b4004b00d4$var$splitIntoContinuousLines(metrics, interval ?? undefined);
    return lines.map((line)=>({
            type: "area",
            points: $97bfc4b4004b00d4$var$compact(line.map((metric)=>$97bfc4b4004b00d4$var$getPointForMetric(metric, axesAndBuckets)))
        }));
}
function $97bfc4b4004b00d4$var$getPointForMetric(metric, { buckets: buckets, isPercentage: isPercentage, xAxis: xAxis, yAxis: yAxis }) {
    const bucketValue = buckets.get(metric.time);
    if (!bucketValue) return null;
    const time = $97bfc4b4004b00d4$var$getTimeFromTimestamp(metric.time);
    const value = isPercentage ? metric.value / bucketValue.total : metric.value;
    const yMin = bucketValue.currentY;
    const yMax = yMin + $97bfc4b4004b00d4$var$normalizeAlongLinearAxis(value, yAxis);
    bucketValue.currentY = yMax;
    return {
        x: $97bfc4b4004b00d4$var$normalizeAlongLinearAxis(time, xAxis),
        yMin: yMin,
        yMax: yMax,
        source: metric
    };
}
/**
 * Generates an abstract chart from a combination of timeseries data, events and
 * an optional target latency.
 */ function $97bfc4b4004b00d4$export$80d376111cc09ad7({ graphType: graphType, stackingType: stackingType, timeseriesData: timeseriesData, events: events, targetLatency: targetLatency, timeRange: timeRange }) {
    const timeseriesChart = $97bfc4b4004b00d4$export$f929f5d33907bbc5({
        graphType: graphType,
        stackingType: stackingType,
        timeseriesData: timeseriesData,
        timeRange: timeRange,
        additionalValues: targetLatency ? [
            targetLatency
        ] : []
    });
    const chart = {
        ...timeseriesChart,
        shapeLists: timeseriesChart.shapeLists.map((list)=>({
                ...list,
                source: {
                    ...list.source,
                    type: "timeseries"
                }
            }))
    };
    if (graphType === "line" && events.length > 0) chart.shapeLists.push($97bfc4b4004b00d4$var$generateShapeListFromEvents(chart.xAxis, events));
    if (targetLatency) chart.shapeLists.push($97bfc4b4004b00d4$var$generateShapeListFromTargetLatency(chart.yAxis, targetLatency));
    return chart;
}
/**
 * Generates an abstract chart from the given timeseries data.
 */ function $97bfc4b4004b00d4$export$f929f5d33907bbc5(input) {
    if (input.graphType === "line") return input.stackingType === "none" ? $97bfc4b4004b00d4$var$generateLineChartFromTimeseries(input) : $97bfc4b4004b00d4$var$generateStackedLineChartFromTimeseries(input);
    else return input.stackingType === "none" ? $97bfc4b4004b00d4$var$generateBarChartFromTimeseries(input) : $97bfc4b4004b00d4$var$generateStackedBarChartFromTimeseries(input);
}
function $97bfc4b4004b00d4$var$TimeseriesLegendItem({ color: color, onHover: onHover, onToggleTimeseriesVisibility: onToggleTimeseriesVisibility, readOnly: readOnly, index: index, setSize: setSize, style: style, timeseries: timeseries, uniqueKeys: uniqueKeys }) {
    const [ref, { height: height }] = $97bfc4b4004b00d4$var$useMeasure();
    (0, $2gcPZ.useLayoutEffect)(()=>{
        if (height) setSize(index, height);
    }, [
        height,
        setSize,
        index
    ]);
    const toggleTimeseriesVisibility = onToggleTimeseriesVisibility && !readOnly ? (event)=>{
        $97bfc4b4004b00d4$var$preventDefault(event);
        const toggleSingle = $97bfc4b4004b00d4$var$isMac ? event.metaKey : event.ctrlKey;
        onToggleTimeseriesVisibility({
            timeseries: timeseries,
            toggleOthers: !toggleSingle
        });
    } : $97bfc4b4004b00d4$var$noop;
    const onKeyDown = (event)=>{
        if (event.key === "Space") toggleTimeseriesVisibility(event);
    };
    const chartTheme = (0, $2gcPZ.useContext)($97bfc4b4004b00d4$var$ChartThemeContext);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("div", {
        style: style,
        onClick: toggleTimeseriesVisibility,
        onKeyDown: onKeyDown,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$var$ResizeContainer, {
            ref: ref,
            children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($97bfc4b4004b00d4$var$LegendItemContainer, {
                $chartTheme: chartTheme,
                onMouseOver: timeseries.visible ? onHover : $97bfc4b4004b00d4$var$noop,
                interactive: !readOnly && onToggleTimeseriesVisibility !== undefined,
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$var$ColorBlock, {
                        $chartTheme: chartTheme,
                        color: color,
                        selected: timeseries.visible,
                        children: timeseries.visible && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$export$f04a61298a47a40f, {
                            type: "check",
                            width: "12",
                            height: "12"
                        })
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$var$FormattedTimeseries, {
                        metric: timeseries,
                        emphasizedKeys: uniqueKeys
                    })
                ]
            })
        })
    });
}
const $97bfc4b4004b00d4$var$FormattedTimeseries = /*#__PURE__*/ (0, $2gcPZ.memo)(function FormattedTimeseries({ metric: metric, emphasizedKeys: emphasizedKeys = [] }) {
    const { name: name, labels: labels } = metric;
    const labelEntries = $97bfc4b4004b00d4$var$sortBy(Object.entries(labels), ([key])=>key);
    const chartTheme = (0, $2gcPZ.useContext)($97bfc4b4004b00d4$var$ChartThemeContext);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($97bfc4b4004b00d4$var$Text, {
        children: [
            name && `${name}: `,
            labelEntries.map(([key, value], index)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $2gcPZ.Fragment), {
                    children: [
                        index > 0 && ", ",
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("span", {
                            className: key in emphasizedKeys ? "emphasize" : "",
                            children: [
                                key,
                                value && [
                                    ": ",
                                    emphasizedKeys.includes(key) ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$var$Emphasis, {
                                        $chartTheme: chartTheme,
                                        children: value
                                    }, key) : value
                                ]
                            ]
                        })
                    ]
                }, key))
        ]
    });
});
const $97bfc4b4004b00d4$var$ColorBlock = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ $chartTheme: $chartTheme, color: color, selected: selected })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    grid-area: checkbox;
    background: ${selected ? color : "transparent"};
    border: 2px solid ${color};
    width: 14px;
    height: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${$chartTheme.legendItemCheckboxColor};
    border-radius: ${$chartTheme.legendItemCheckboxBorderRadius};
  `);
const $97bfc4b4004b00d4$var$Emphasis = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).span(({ $chartTheme: $chartTheme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    background-color: ${$chartTheme.legendItemEmphasisBackgroundColor};
    color: ${$chartTheme.legendItemEmphasisColor};
    font: ${$chartTheme.legendItemEmphasisFont};
    border-radius: ${$chartTheme.legendItemEmphasisBorderRadius};
    padding: 1px 4px;
    display: inline-block;
  `);
const $97bfc4b4004b00d4$var$ResizeContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  min-height: fit-content;
`;
const $97bfc4b4004b00d4$var$LegendItemContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)($97bfc4b4004b00d4$var$Container)(({ $chartTheme: $chartTheme, interactive: interactive })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    display: grid;
    grid-template: "checkbox text" auto / 20px auto;
    border-radius: ${$chartTheme.legendItemBorderRadius};
    align-items: center;
    font: ${$chartTheme.legendItemFont};
    color: ${$chartTheme.legendItemColor};
    padding: 8px 8px 8px 14px;
    gap: 10px;
    word-wrap: anywhere;

    ${interactive && (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
        cursor: pointer;

        &:hover {
            background: ${$chartTheme.legendItemOnHoverBackgroundColor};
            color: ${$chartTheme.legendItemOnHoverColor};
        }
      `}
  `);
const $97bfc4b4004b00d4$var$Text = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  grid-area: text;
`;
const $97bfc4b4004b00d4$var$DEFAULT_HEIGHT = 293;
const $97bfc4b4004b00d4$var$DEFAULT_SIZE = 30;
const $97bfc4b4004b00d4$var$EXPANDED_HEIGHT = 592;
function $97bfc4b4004b00d4$var$TimeseriesLegend({ footerShown: footerShown = true, getShapeListColor: getShapeListColor, onFocusedShapeListChange: onFocusedShapeListChange, onToggleTimeseriesVisibility: onToggleTimeseriesVisibility, readOnly: readOnly = false, shapeLists: shapeLists }) {
    const { expandButton: expandButton, gradient: gradient, isExpanded: isExpanded, onScroll: onScroll, ref: ref } = $97bfc4b4004b00d4$var$useExpandable({
        defaultHeight: $97bfc4b4004b00d4$var$DEFAULT_HEIGHT
    });
    const maxHeight = isExpanded ? $97bfc4b4004b00d4$var$EXPANDED_HEIGHT : $97bfc4b4004b00d4$var$DEFAULT_HEIGHT;
    const timeseriesData = (0, $2gcPZ.useMemo)(()=>shapeLists.map((shapeList)=>shapeList.source), [
        shapeLists
    ]);
    const numSeries = timeseriesData.length;
    const resultsText = `${numSeries} result${numSeries === 1 ? "" : "s"}`;
    const uniqueKeys = (0, $2gcPZ.useMemo)(()=>$97bfc4b4004b00d4$var$findUniqueKeys(timeseriesData), [
        timeseriesData
    ]);
    const listRef = (0, $2gcPZ.useRef)(null);
    const sizeMap = (0, $2gcPZ.useRef)(new Map());
    const heightRef = (0, $2gcPZ.useRef)(timeseriesData.length * $97bfc4b4004b00d4$var$DEFAULT_SIZE);
    const update = $97bfc4b4004b00d4$var$useForceUpdate();
    const getSize = (index)=>sizeMap.current.get(index) ?? $97bfc4b4004b00d4$var$DEFAULT_SIZE;
    const setSize = $97bfc4b4004b00d4$var$useHandler((index, size)=>{
        const oldSize = getSize(index);
        if (oldSize === size) return;
        sizeMap.current.set(index, size);
        listRef.current?.resetAfterIndex(index);
        heightRef.current += size - oldSize;
        if (heightRef.current < maxHeight) update();
    });
    const onMouseOut = ()=>onFocusedShapeListChange?.(null);
    const setFocusedTimeseries = onFocusedShapeListChange ? (timeseries)=>{
        const shapeList = shapeLists.find((shapeList)=>shapeList.source === timeseries);
        if (shapeList) onFocusedShapeListChange(shapeList);
    } : $97bfc4b4004b00d4$var$noop;
    const render = $97bfc4b4004b00d4$var$useHandler(({ data: data, index: index, style: style })=>{
        const shapeList = data[index];
        const timeseries = shapeList.source;
        return timeseries && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$var$TimeseriesLegendItem, {
            color: getShapeListColor(shapeList.source, index),
            onHover: ()=>setFocusedTimeseries(timeseries),
            onToggleTimeseriesVisibility: onToggleTimeseriesVisibility,
            readOnly: readOnly,
            timeseries: timeseries,
            uniqueKeys: uniqueKeys,
            index: index,
            setSize: setSize,
            style: style
        });
    });
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($97bfc4b4004b00d4$var$ChartLegendContainer, {
        onMouseOut: onMouseOut,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $01ff200d9f4ad87f$export$d8ac3b6b20be856e), {
                estimatedItemSize: $97bfc4b4004b00d4$var$DEFAULT_HEIGHT,
                height: Math.min(heightRef.current, maxHeight),
                onScroll: onScroll,
                outerRef: ref,
                width: "100%",
                ref: listRef,
                itemCount: shapeLists.length,
                itemData: shapeLists,
                itemSize: getSize,
                children: render
            }),
            gradient,
            footerShown && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($97bfc4b4004b00d4$var$Footer, {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$var$Results, {
                        children: resultsText
                    }),
                    expandButton
                ]
            })
        ]
    });
}
const $97bfc4b4004b00d4$var$Footer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const $97bfc4b4004b00d4$var$ChartLegendContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)($97bfc4b4004b00d4$var$Container)`
  flex-direction: column;
  padding: 10px 0 0;
  position: relative;
  word-wrap: break-word;
`;
const $97bfc4b4004b00d4$var$Results = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).span(()=>{
    const theme = (0, $2gcPZ.useContext)($97bfc4b4004b00d4$var$ChartThemeContext);
    return (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    font: ${theme.legendResultsFont};
    letter-spacing: ${theme.legendResultsLetterSpacing};
    color: ${theme.legendResultsColor};
  `;
});
/**
 * Control what kind fo chart you're viewing (and more)
 */ function $97bfc4b4004b00d4$var$ChartControls({ children: children, graphType: graphType, onChangeGraphType: onChangeGraphType, onChangeStackingType: onChangeStackingType, stackingControlsShown: stackingControlsShown, stackingType: stackingType }) {
    if (!onChangeGraphType && !onChangeStackingType) return null;
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($97bfc4b4004b00d4$var$ControlsContainer, {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($97bfc4b4004b00d4$var$ControlsGroup, {
                children: [
                    onChangeGraphType && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($97bfc4b4004b00d4$export$65f0c8bad2ea29b, {
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$export$12cfa6a5c9403eaa, {
                                children: "Type"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($97bfc4b4004b00d4$export$69b1032f2ecdf404, {
                                children: [
                                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$export$c25acd513dcc8062, {
                                        active: graphType === "line",
                                        "aria-label": "Line chart",
                                        className: "iconButton",
                                        onClick: (event)=>{
                                            $97bfc4b4004b00d4$var$preventDefault(event);
                                            onChangeGraphType("line");
                                        },
                                        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$export$f04a61298a47a40f, {
                                            type: "chart_line"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$export$c25acd513dcc8062, {
                                        active: graphType === "bar",
                                        "aria-label": "Bar chart",
                                        className: "iconButton",
                                        onClick: (event)=>{
                                            $97bfc4b4004b00d4$var$preventDefault(event);
                                            onChangeGraphType("bar");
                                        },
                                        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$export$f04a61298a47a40f, {
                                            type: "chart_bar"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    stackingControlsShown && onChangeStackingType && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($97bfc4b4004b00d4$export$65f0c8bad2ea29b, {
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$export$12cfa6a5c9403eaa, {
                                children: "Stacking"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($97bfc4b4004b00d4$export$69b1032f2ecdf404, {
                                children: [
                                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$export$c25acd513dcc8062, {
                                        active: stackingType === "none",
                                        "aria-label": "Combined/default",
                                        className: "iconButton",
                                        onClick: (event)=>{
                                            $97bfc4b4004b00d4$var$preventDefault(event);
                                            onChangeStackingType("none");
                                        },
                                        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$export$f04a61298a47a40f, {
                                            type: "combined"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$export$c25acd513dcc8062, {
                                        active: stackingType === "stacked",
                                        "aria-label": "Stacked",
                                        className: "iconButton",
                                        type: "button",
                                        onClick: (event)=>{
                                            $97bfc4b4004b00d4$var$preventDefault(event);
                                            onChangeStackingType("stacked");
                                        },
                                        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$export$f04a61298a47a40f, {
                                            type: "stacked"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$export$c25acd513dcc8062, {
                                        active: stackingType === "percentage",
                                        "aria-label": "Stacked/percentage",
                                        className: "iconButton",
                                        onClick: (event)=>{
                                            $97bfc4b4004b00d4$var$preventDefault(event);
                                            onChangeStackingType("percentage");
                                        },
                                        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$export$f04a61298a47a40f, {
                                            type: "percentage"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }, "built_in"),
            children && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$var$ControlsGroup, {
                children: children
            }, "custom")
        ]
    });
}
function $97bfc4b4004b00d4$export$f4cb11be864d0ce5(props) {
    const chartTheme = (0, $2gcPZ.useMemo)(()=>({
            ...$97bfc4b4004b00d4$var$defaultChartTheme,
            ...props.chartTheme
        }), [
        props.chartTheme
    ]);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$var$ChartThemeContext.Provider, {
        value: chartTheme,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$var$StyledChartSizeContainerProvider$1, {
            overrideHeight: $97bfc4b4004b00d4$var$HEIGHT,
            marginTop: $97bfc4b4004b00d4$var$MARGINS.top,
            marginRight: $97bfc4b4004b00d4$var$MARGINS.right,
            marginBottom: $97bfc4b4004b00d4$var$MARGINS.bottom,
            marginLeft: $97bfc4b4004b00d4$var$MARGINS.left,
            children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$var$InnerMetricsChart, {
                ...props
            })
        })
    });
}
const $97bfc4b4004b00d4$var$InnerMetricsChart = /*#__PURE__*/ (0, $2gcPZ.memo)(function InnerMetricsChart(props) {
    const { areaGradientShown: areaGradientShown = true, chartControlsShown: chartControlsShown = true, customChartControls: customChartControls, events: events, graphType: graphType, legendShown: legendShown = true, readOnly: readOnly, stackingControlsShown: stackingControlsShown = true, stackingType: stackingType, targetLatency: targetLatency, timeRange: timeRange, timeseriesData: timeseriesData } = props;
    const chart = (0, $2gcPZ.useMemo)(()=>$97bfc4b4004b00d4$export$80d376111cc09ad7({
            events: events ?? [],
            graphType: graphType,
            stackingType: stackingType,
            targetLatency: targetLatency,
            timeRange: timeRange,
            timeseriesData: timeseriesData
        }), [
        events,
        graphType,
        stackingType,
        targetLatency,
        timeRange,
        timeseriesData
    ]);
    const { eventColor: eventColor, shapeListColors: shapeListColors, targetLatencyColor: targetLatencyColor } = (0, $2gcPZ.useContext)($97bfc4b4004b00d4$var$ChartThemeContext);
    const [focusedShapeList, setFocusedShapeList] = (0, $2gcPZ.useState)(null);
    const getShapeListColor = (0, $2gcPZ.useMemo)(()=>{
        return (source, index)=>{
            switch(source.type){
                case "timeseries":
                    return shapeListColors[index % shapeListColors.length];
                case "events":
                    return eventColor;
                case "target_latency":
                    return targetLatencyColor || "transparent";
            }
        };
    }, [
        eventColor,
        shapeListColors,
        targetLatencyColor
    ]);
    const onFocusedShapeListChange = $97bfc4b4004b00d4$var$useHandler((shapeList)=>{
        if (!shapeList || $97bfc4b4004b00d4$var$isTimeseriesShapeList(shapeList)) setFocusedShapeList(shapeList);
    });
    // When the timeseries changes, we want to reset the id so that the legend
    // is re-rendered. This resets the size values for all legend items
    // biome-ignore lint/nursery/useExhaustiveDependencies: this is intentional
    const id = (0, $2gcPZ.useMemo)(()=>crypto.randomUUID(), [
        timeseriesData
    ]);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $afa7be861492543f$exports.Fragment), {
        children: [
            chartControlsShown && !readOnly && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$var$ChartControls, {
                ...props,
                stackingControlsShown: stackingControlsShown,
                children: customChartControls
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$var$CoreChart, {
                ...props,
                areaGradientShown: areaGradientShown,
                chart: chart,
                focusedShapeList: focusedShapeList,
                getShapeListColor: getShapeListColor,
                onFocusedShapeListChange: onFocusedShapeListChange
            }),
            legendShown && /*#__PURE__*/ (0, $2gcPZ.createElement)($97bfc4b4004b00d4$var$TimeseriesLegend, {
                ...props,
                key: id,
                getShapeListColor: getShapeListColor,
                onFocusedShapeListChange: onFocusedShapeListChange,
                shapeLists: chart.shapeLists.filter($97bfc4b4004b00d4$var$isTimeseriesShapeList)
            })
        ]
    });
});
const $97bfc4b4004b00d4$var$StyledChartSizeContainerProvider$1 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)($97bfc4b4004b00d4$var$ChartSizeContainerProvider)`
  display: flex;
  gap: 12px;
  flex-direction: column;
`;
function $97bfc4b4004b00d4$var$isTimeseriesShapeList(shapeList) {
    return shapeList.source.type === "timeseries";
}
function $97bfc4b4004b00d4$export$df5eb60f21dfbe70({ areaGradientShown: areaGradientShown = false, colors: colors, graphType: graphType, stackingType: stackingType, timeRange: timeRange, timeseriesData: timeseriesData, onChangeTimeRange: onChangeTimeRange }) {
    const chart = (0, $2gcPZ.useMemo)(()=>$97bfc4b4004b00d4$export$f929f5d33907bbc5({
            graphType: graphType,
            stackingType: stackingType,
            timeRange: timeRange,
            timeseriesData: timeseriesData,
            additionalValues: []
        }), [
        graphType,
        stackingType,
        timeRange,
        timeseriesData
    ]);
    const getShapeListColor = (0, $2gcPZ.useMemo)(()=>{
        return (_source, index)=>colors[index % colors.length];
    }, [
        colors
    ]);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$var$StyledChartSizeContainerProvider, {
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($97bfc4b4004b00d4$var$CoreChart, {
            areaGradientShown: areaGradientShown,
            chart: chart,
            focusedShapeList: null,
            getShapeListColor: getShapeListColor,
            gridColumnsShown: false,
            axisLinesShown: false,
            gridRowsShown: false,
            onChangeTimeRange: onChangeTimeRange,
            tickFormatters: $97bfc4b4004b00d4$var$tickFormatters,
            timeRange: timeRange
        })
    });
}
const $97bfc4b4004b00d4$var$StyledChartSizeContainerProvider = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)($97bfc4b4004b00d4$var$ChartSizeContainerProvider)`
  width: 100%;
  height: 100%;
`;
// No formatters, which will cause the ticks to not be shown.
const $97bfc4b4004b00d4$var$tickFormatters = {};
function $97bfc4b4004b00d4$var$_define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $97bfc4b4004b00d4$export$cb472f3044a5dae8(axis, kind) {
    switch(kind){
        case "bytes":
            return $97bfc4b4004b00d4$export$da58a8ce49bc00a7(axis);
        case "duration":
            return $97bfc4b4004b00d4$export$7f424ebfd113e8ae(axis);
        case "exponent":
            return $97bfc4b4004b00d4$export$c0ba4ab7d99164e1();
        case "percentage":
            return $97bfc4b4004b00d4$export$f4ad2fa17edf39d7();
        case "scientific":
            return $97bfc4b4004b00d4$export$9bc9750a5e6705d(axis);
        case "time":
            return $97bfc4b4004b00d4$export$22e93c2cab313942(axis);
    }
}
function $97bfc4b4004b00d4$export$da58a8ce49bc00a7(axis) {
    const largestUnit = $97bfc4b4004b00d4$var$ScientificUnit.forValue(axis.maxValue);
    const minimumUnit = $97bfc4b4004b00d4$var$ScientificUnit.None;
    const scientificFormatter = $97bfc4b4004b00d4$var$getScientificFormatterForUnits(largestUnit, minimumUnit);
    return (value)=>{
        return `${scientificFormatter(value)}B`;
    };
}
function $97bfc4b4004b00d4$export$7f424ebfd113e8ae(axis) {
    const largestUnit = $97bfc4b4004b00d4$var$DurationUnit.forValue(axis.maxValue);
    return (value)=>{
        let unit = largestUnit;
        let adjusted = value * unit.multiplier();
        while(Math.abs(adjusted) < 1){
            const nextUnitWithAmount = unit.nextLargest();
            if (nextUnitWithAmount) {
                adjusted *= nextUnitWithAmount[0];
                unit = nextUnitWithAmount[1];
            } else break;
        }
        if (Math.abs(adjusted) >= 10) return `${adjusted.toFixed(1)}${unit}`;
        const nextUnitWithAmount = unit.nextLargest();
        if (nextUnitWithAmount) {
            const first = Math.floor(adjusted);
            const second = Math.round((adjusted - first) * nextUnitWithAmount[0]);
            const nextUnit = nextUnitWithAmount[1];
            return `${first}${unit}${second}${nextUnit}`;
        }
        // unit must be seconds (or smaller)
        const formatter = $97bfc4b4004b00d4$var$getScientificFormatterForUnits($97bfc4b4004b00d4$var$ScientificUnit.None, $97bfc4b4004b00d4$var$ScientificUnit.Pico);
        return `${formatter(adjusted)}s`;
    };
}
function $97bfc4b4004b00d4$export$c0ba4ab7d99164e1() {
    return (value)=>{
        const absoluteValue = Math.abs(value);
        if (absoluteValue >= 10000) {
            let adjusted = value * 0.0001;
            let exponent = 4;
            while(Math.abs(adjusted) > 10){
                adjusted *= 0.1;
                exponent += 1;
            }
            return `${adjusted.toFixed(1)}e${exponent}`;
        } else if (absoluteValue < Number.EPSILON) return "0";
        else if (absoluteValue < 0.01) {
            let adjusted = value * 1000;
            let exponent = -3;
            while(Math.abs(adjusted) < 1){
                adjusted *= 10;
                exponent -= 1;
            }
            return `${adjusted.toFixed(1)}e${exponent}`;
        } else if (absoluteValue < 0.1) return value.toFixed(2);
        else if (value === Math.round(value)) return value.toString();
        else return value.toFixed(1);
    };
}
function $97bfc4b4004b00d4$export$f4ad2fa17edf39d7() {
    return (value)=>{
        const percentageValue = value * 100;
        if (percentageValue === Math.round(percentageValue)) return `${percentageValue}%`;
        else return `${percentageValue.toFixed(1)}%`;
    };
}
function $97bfc4b4004b00d4$export$9bc9750a5e6705d(axis) {
    const largestUnit = $97bfc4b4004b00d4$var$ScientificUnit.forValue(axis.maxValue);
    let minimumUnit = $97bfc4b4004b00d4$var$ScientificUnit.forValue(axis.minValue);
    // It just looks awkward if we go into too much detail on an axis that
    // also has large numbers.
    if (largestUnit.isBiggerThan($97bfc4b4004b00d4$var$ScientificUnit.None) && minimumUnit.isSmallerThan($97bfc4b4004b00d4$var$ScientificUnit.None)) minimumUnit = $97bfc4b4004b00d4$var$ScientificUnit.None;
    return $97bfc4b4004b00d4$var$getScientificFormatterForUnits(largestUnit, minimumUnit);
}
function $97bfc4b4004b00d4$var$getScientificFormatterForUnits(largestUnit, minimumUnit) {
    return (value)=>{
        let unit = largestUnit;
        let adjusted = value * unit.multiplier();
        while(Math.abs(adjusted) < 0.05 && unit.isBiggerThan(minimumUnit)){
            const nextUnit = unit.nextLargest();
            if (nextUnit) unit = nextUnit;
            else break;
            adjusted *= 1000;
        }
        if (Math.abs(adjusted) === 0) return "0";
        else if (adjusted >= 10 || adjusted === Math.round(adjusted)) return `${adjusted.toFixed(0)}${unit}`; // avoid unnecessary `.0` suffix
        else return `${adjusted.toFixed(1)}${unit}`;
    };
}
const $97bfc4b4004b00d4$var$WEEKDAYS = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];
function $97bfc4b4004b00d4$export$22e93c2cab313942(axis) {
    const scale = $97bfc4b4004b00d4$var$getTimeScaleForAxis(axis);
    return (value)=>{
        const date = new Date(value * 1000);
        if (Number.isNaN(date.getTime())) return "-";
        switch(scale){
            case "day_in_month":
                return `${$97bfc4b4004b00d4$var$WEEKDAYS[date.getUTCDay()]} ${date.getUTCDate()}`;
            case "day_in_week":
                return `${$97bfc4b4004b00d4$var$WEEKDAYS[date.getUTCDay()]} ${date.getUTCHours()}h`;
            case "hours":
                return `${date.getUTCHours()}:${date.getUTCMinutes().toString().padStart(2, "0")}`;
            case "minutes":
                return `${date.getUTCHours()}:${date.getUTCMinutes().toString().padStart(2, "0")}:${date.getUTCSeconds().toString().padStart(2, "0")}`;
            case "seconds":
                return `${date.getUTCSeconds()}.${date.getUTCMilliseconds().toString().padStart(3, "0")}`;
            case "milliseconds":
                return `.${date.getUTCMilliseconds().toString().padStart(3, "0")}`;
        }
    };
}
class $97bfc4b4004b00d4$var$DurationUnit {
    /**
   * Returns the most appropriate unit to use for formatting the given
   * duration, without assuming any other context.
   */ static forValue(value) {
        if (value >= 86400) return $97bfc4b4004b00d4$var$DurationUnit.Days;
        else if (value >= 3600) return $97bfc4b4004b00d4$var$DurationUnit.Hours;
        else if (value >= 60) return $97bfc4b4004b00d4$var$DurationUnit.Minutes;
        else return $97bfc4b4004b00d4$var$DurationUnit.Seconds;
    }
    /**
   * The multiplier to apply to a duration if it is to be formatted with this
   * unit.
   */ multiplier() {
        switch(this.unit){
            case "days":
                return 1 / 86400;
            case "hours":
                return 1 / 3600;
            case "minutes":
                return 1 / 60;
            case "seconds":
                return 1;
        }
    }
    /**
   * Returns the next largest unit smaller than this unit, as well as the
   * amount of that unit that fit into this unit, if any.
   */ nextLargest() {
        switch(this.unit){
            case "days":
                return [
                    24,
                    $97bfc4b4004b00d4$var$DurationUnit.Hours
                ];
            case "hours":
                return [
                    60,
                    $97bfc4b4004b00d4$var$DurationUnit.Minutes
                ];
            case "minutes":
                return [
                    60,
                    $97bfc4b4004b00d4$var$DurationUnit.Seconds
                ];
            case "seconds":
                return null;
        }
    }
    toString() {
        switch(this.unit){
            case "days":
                return "d";
            case "hours":
                return "h";
            case "minutes":
                return "m";
            case "seconds":
                return "s";
        }
    }
    constructor(unit){
        $97bfc4b4004b00d4$var$_define_property(this, "unit", void 0);
        this.unit = unit;
    }
}
$97bfc4b4004b00d4$var$_define_property($97bfc4b4004b00d4$var$DurationUnit, "Days", new $97bfc4b4004b00d4$var$DurationUnit("days"));
$97bfc4b4004b00d4$var$_define_property($97bfc4b4004b00d4$var$DurationUnit, "Hours", new $97bfc4b4004b00d4$var$DurationUnit("hours"));
$97bfc4b4004b00d4$var$_define_property($97bfc4b4004b00d4$var$DurationUnit, "Minutes", new $97bfc4b4004b00d4$var$DurationUnit("minutes"));
$97bfc4b4004b00d4$var$_define_property($97bfc4b4004b00d4$var$DurationUnit, "Seconds", new $97bfc4b4004b00d4$var$DurationUnit("seconds"));
class $97bfc4b4004b00d4$var$ScientificUnit {
    /**
   * Returns the most appropriate unit to use for formatting the given
   * value, without assuming any other context.
   */ static forValue(value) {
        if (value >= 1e12) return $97bfc4b4004b00d4$var$ScientificUnit.Tera;
        else if (value >= 1e9) return $97bfc4b4004b00d4$var$ScientificUnit.Giga;
        else if (value >= 1e6) return $97bfc4b4004b00d4$var$ScientificUnit.Mega;
        else if (value >= 1e3) return $97bfc4b4004b00d4$var$ScientificUnit.Kilo;
        else if (value >= 1e3) return $97bfc4b4004b00d4$var$ScientificUnit.Kilo;
        else if (value >= 1) return $97bfc4b4004b00d4$var$ScientificUnit.None;
        else if (value >= 1e-3) return $97bfc4b4004b00d4$var$ScientificUnit.Milli;
        else if (value >= 1e-6) return $97bfc4b4004b00d4$var$ScientificUnit.Micro;
        else if (value >= 1e-9) return $97bfc4b4004b00d4$var$ScientificUnit.Nano;
        else return $97bfc4b4004b00d4$var$ScientificUnit.Pico;
    }
    isBiggerThan(other) {
        return this.step > other.step;
    }
    isSmallerThan(other) {
        return this.step < other.step;
    }
    /**
   * The multiplier to apply to a value if it is to be formatted with this
   * unit.
   */ multiplier() {
        switch(this.step){
            case 4:
                return 1e-12;
            case 3:
                return 1e-9;
            case 2:
                return 1e-6;
            case 1:
                return 1e-3;
            case 0:
                return 1;
            case -1:
                return 1e3;
            case -2:
                return 1e6;
            case -3:
                return 1e9;
            case -4:
                return 1e12;
            default:
                throw new Error(`Unsupported step: ${this.step}`);
        }
    }
    /**
   * Returns the next largest unit smaller than this unit, if any.
   */ nextLargest() {
        if (this.step > -4) return new $97bfc4b4004b00d4$var$ScientificUnit(this.step - 1);
        else return null;
    }
    toString() {
        switch(this.step){
            case 4:
                return "T";
            case 3:
                return "G";
            case 2:
                return "M";
            case 1:
                return "k";
            case 0:
                return "";
            case -1:
                return "m";
            case -2:
                return "\u03BC";
            case -3:
                return "n";
            case -4:
                return "p";
            default:
                throw new Error(`Unsupported step: ${this.step}`);
        }
    }
    constructor(step){
        $97bfc4b4004b00d4$var$_define_property(this, "step", void 0);
        this.step = step;
    }
}
$97bfc4b4004b00d4$var$_define_property($97bfc4b4004b00d4$var$ScientificUnit, "Tera", new $97bfc4b4004b00d4$var$ScientificUnit(4));
$97bfc4b4004b00d4$var$_define_property($97bfc4b4004b00d4$var$ScientificUnit, "Giga", new $97bfc4b4004b00d4$var$ScientificUnit(3));
$97bfc4b4004b00d4$var$_define_property($97bfc4b4004b00d4$var$ScientificUnit, "Mega", new $97bfc4b4004b00d4$var$ScientificUnit(2));
$97bfc4b4004b00d4$var$_define_property($97bfc4b4004b00d4$var$ScientificUnit, "Kilo", new $97bfc4b4004b00d4$var$ScientificUnit(1));
$97bfc4b4004b00d4$var$_define_property($97bfc4b4004b00d4$var$ScientificUnit, "None", new $97bfc4b4004b00d4$var$ScientificUnit(0));
$97bfc4b4004b00d4$var$_define_property($97bfc4b4004b00d4$var$ScientificUnit, "Milli", new $97bfc4b4004b00d4$var$ScientificUnit(-1));
$97bfc4b4004b00d4$var$_define_property($97bfc4b4004b00d4$var$ScientificUnit, "Micro", new $97bfc4b4004b00d4$var$ScientificUnit(-2));
$97bfc4b4004b00d4$var$_define_property($97bfc4b4004b00d4$var$ScientificUnit, "Nano", new $97bfc4b4004b00d4$var$ScientificUnit(-3));
$97bfc4b4004b00d4$var$_define_property($97bfc4b4004b00d4$var$ScientificUnit, "Pico", new $97bfc4b4004b00d4$var$ScientificUnit(-4));
function $97bfc4b4004b00d4$var$getTimeScaleForAxis(axis) {
    const delta = Math.abs(axis.maxValue - axis.minValue);
    if (delta > 864000) return "day_in_month";
    else if (delta > 86400) return "day_in_week";
    else if (delta > 3600) return "hours";
    else if (delta > 60) return "minutes";
    else if (delta > 1) return "seconds";
    else return "milliseconds";
}






function $7cce17cd3ba704c5$export$8b799af4f3123f30({ brandColor: brandColor, isActive: isActive, title: title, latestValue: latestValue, latestValueUnit: latestValueUnit, data: data, timeRange: timeRange, info: info }) {
    const theme = (0, $4e8e6ea7d6e48c37$export$93d4e7f90805808f)();
    const graphLineColors = (0, $94aa7f612f0558e6$export$3939eba9bff0c75e)(brandColor);
    const colors = (0, $2gcPZ.useMemo)(()=>{
        return isActive ? [
            theme.color.fg.onemphasis.default,
            theme.color.fg.onemphasis.subtle
        ] : graphLineColors;
    }, [
        theme,
        graphLineColors,
        isActive
    ]);
    const ref = (0, $2gcPZ.useRef)(null);
    const handleOnClick = ()=>{
        const cardElement = ref.current;
        if (!cardElement) return;
        cardElement.scrollIntoView({
            behavior: "smooth",
            inline: "center"
        });
    };
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($7cce17cd3ba704c5$var$MetricCardContainer, {
        ref: ref,
        brandColor: brandColor,
        isActive: isActive,
        onClick: handleOnClick,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($7cce17cd3ba704c5$var$MetricTitle, {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("h4", {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($7cce17cd3ba704c5$var$InfoIcon, {
                        "aria-label": info
                    })
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $192a6ebc11da083f$export$9030be3ebb5e43eb), {
                rate: latestValue,
                unit: latestValueUnit,
                report: "latest"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($7cce17cd3ba704c5$export$c57aa3c0437dcbce, {
                children: data && timeRange && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $97bfc4b4004b00d4$export$df5eb60f21dfbe70), {
                    graphType: "line",
                    stackingType: "none",
                    timeRange: timeRange,
                    timeseriesData: data,
                    colors: colors
                })
            })
        ]
    });
}
const $7cce17cd3ba704c5$var$MetricCardContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $2042716e2270aa85$export$42a852a2b6b56249))(({ brandColor: brandColor, isActive: isActive, theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    --text-alternative-color: ${theme.color.fg.muted};

    display: grid;
    grid:
      "title title" auto
      "metric graph" 54px / minmax(120px, 176px) minmax(80px, 136px);
    cursor: pointer;
    gap: 16px;

    color: ${theme.color.fg.default};
    background-color: ${theme.color.bg.subtle};
    border: 1px solid ${theme.color.border.muted};
    transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;

    ${isActive ? (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
          --text-alternative-color: ${theme.color.fg.onemphasis.default};

          color: ${theme.color.fg.onemphasis.default};
          background-color: ${brandColor};
          border-color: ${brandColor};
        ` : (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
          &:hover {
            background-color: ${theme.color.bg.hover};
          }
        `};
  `);
const $7cce17cd3ba704c5$var$MetricTitle = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  grid-area: title;
  display: grid;
  grid-template-columns: auto 20px;
  margin: 0;
`;
const $7cce17cd3ba704c5$var$InfoIcon = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $0a830394bc38e4e3$export$f04a61298a47a40f)).attrs({
    type: "info_duotone"
})`
  align-self: top;
`;
const $7cce17cd3ba704c5$export$c57aa3c0437dcbce = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  grid-area: graph;
  overflow: hidden;
  pointer-events: none;
`;




function $35cfa0c2695942cf$export$aff7f2423eafed8e(options) {
    const { functionName: functionName, moduleName: moduleName, metricType: metricType, environmentUrl: environmentUrl, timeRange: timeRange } = options;
    const interval = (0, $097bfc2d1913d58c$exports).getPrometheusWindowFromTimeRange(timeRange.from, timeRange.to);
    let query = metricType === "requestRate" ? `
# Get the call count of all functions called by the given function
sum(
            rate({
              __name__=~"function_calls(_count)?(_total)?",
              function!="",
              module!="",
              caller_function=~"${functionName}",
              caller_module=~"${moduleName}",
              # Range below is the total time (i.e. the past X minutes/hours/etc)
            }[${interval}])
) by (function, module) > 0` : `
    # Get the error ratio
    (
      sum by (function, module) (
        increase({
          __name__=~"function_calls(_count)?(_total)?",
          result="error",
          function!="",
          module!="",
          caller_function=~"${functionName}",
          caller_module=~"${moduleName}",
        }[${interval}])
        )
        or
        0
        * group by (function, module) (
          present_over_time({
              __name__=~"function_calls(_count)?(_total)?",
              function!="",
              module!="",
              caller_function=~"${functionName}",
              caller_module=~"${moduleName}",
            }[${interval}]
          )
      )
    )
    /
    (
      sum by (function, module) (
        increase({
          __name__=~"function_calls(_count)?(_total)?",
          function!="",
          module!="",
          caller_function=~"${functionName}",
          caller_module=~"${moduleName}",
        }[${interval}])
      ) > 0
    )
    * 100`;
    const outgoingQuery = (0, $5755db105caee352$export$ca13061e89ab955d)({
        environmentUrl: environmentUrl,
        query: query,
        time: timeRange.to
    });
    query = metricType === "requestRate" ? `
# Get the call count of all functions called by the given function
sum(
            rate({
              __name__=~"function_calls(_count)?(_total)?",
              caller_function!="",
              module!="",
              function=~"${functionName}",
              module=~"${moduleName}",
            # Range below is the total time (i.e. the past X minutes/hours/etc)
            }[${interval}])
) by (caller_function, caller_module) > 0` : `
# Get the other error ratio
(
  sum by (caller_function, caller_module) (
    increase({
      __name__=~"function_calls(_count)?(_total)?",
      result="error",
      caller_function!="",
      caller_module!="",
      function=~"${functionName}",
      module=~"${moduleName}",
    }[${interval}])
  )
or
0
* group by (caller_function, caller_module) (
    present_over_time({
      __name__=~"function_calls(_count)?(_total)?",
      caller_function!="",
      caller_module!="",
      function=~"${functionName}",
      module=~"${moduleName}",
    }[${interval}])
  )
)
/
(
  sum by (caller_function, caller_module) (
    increase({
      __name__=~"function_calls(_count)?(_total)?",
      caller_function!="",
      caller_module!="",
      function=~"${functionName}",
      module=~"${moduleName}",
    }[${interval}])
  ) > 0
)
* 100`;
    const incomingQuery = (0, $5755db105caee352$export$ca13061e89ab955d)({
        environmentUrl: environmentUrl,
        query: query,
        time: timeRange.to
    });
    return {
        outgoingQuery: outgoingQuery,
        incomingQuery: incomingQuery
    };
}





var $2gcPZ = parcelRequire("2gcPZ");


function $bb43024bd9dbbe83$export$9ad8bd389db2f09d({ functionName: functionName, moduleName: moduleName }) {
    return (0, $097bfc2d1913d58c$exports).createVersionQuery({
        functionName: functionName,
        moduleName: moduleName
    });
}
function $bb43024bd9dbbe83$export$ff253d853c482a8b({ functionName: functionName, moduleName: moduleName, buildInfoInterval: buildInfoInterval }) {
    return (0, $097bfc2d1913d58c$exports).createFunctionLatencyQuery({
        functionName: functionName,
        moduleName: moduleName,
        buildInfoInterval: buildInfoInterval
    });
}
function $bb43024bd9dbbe83$export$5f2798a26e04be50({ buildInfoInterval: buildInfoInterval }) {
    return (0, $097bfc2d1913d58c$exports).createTop5FunctionLatencyQuery({
        buildInfoInterval: buildInfoInterval
    });
}
function $bb43024bd9dbbe83$export$318474253e1e7e49({ functionName: functionName, moduleName: moduleName, buildInfoInterval: buildInfoInterval }) {
    return (0, $097bfc2d1913d58c$exports).createFunctionRequestRateQuery({
        functionName: functionName,
        moduleName: moduleName,
        buildInfoInterval: buildInfoInterval
    });
}
function $bb43024bd9dbbe83$export$78579788b5ffa4f1({ buildInfoInterval: buildInfoInterval }) {
    return (0, $097bfc2d1913d58c$exports).createTop5FunctionRequestRateQuery({
        buildInfoInterval: buildInfoInterval
    });
}
function $bb43024bd9dbbe83$export$7c8dfcce7d0c3f04({ functionName: functionName, moduleName: moduleName, buildInfoInterval: buildInfoInterval }) {
    return (0, $097bfc2d1913d58c$exports).createFunctionErrorRateQuery({
        functionName: functionName,
        moduleName: moduleName,
        buildInfoInterval: buildInfoInterval
    });
}
function $bb43024bd9dbbe83$export$d1056566491e940f({ buildInfoInterval: buildInfoInterval }) {
    return (0, $097bfc2d1913d58c$exports).createTop5FunctionErrorRateQuery({
        buildInfoInterval: buildInfoInterval
    });
}
function $bb43024bd9dbbe83$export$223be44715644635({ functionName: functionName, moduleName: moduleName, timeRange: timeRange }) {
    const interval = (0, $097bfc2d1913d58c$exports).getPrometheusWindowFromTimeRange(timeRange.from, timeRange.to);
    return (0, $097bfc2d1913d58c$exports).createRequestCountQuery({
        functionName: functionName,
        moduleName: moduleName,
        interval: interval
    });
}
function $bb43024bd9dbbe83$export$4689648aa7da5ec3({ functionName: functionName, moduleName: moduleName, timeRange: timeRange }) {
    const interval = (0, $097bfc2d1913d58c$exports).getPrometheusWindowFromTimeRange(timeRange.from, timeRange.to);
    return (0, $097bfc2d1913d58c$exports).createErrorCountQuery({
        functionName: functionName,
        moduleName: moduleName,
        interval: interval
    });
}






const $24d3f45678877ad9$export$54428e230c7f6b57 = "graph";
const $24d3f45678877ad9$export$bd11c95869e508f9 = "call_graph";
function $24d3f45678877ad9$export$2453c71000d2659b(value, metricType) {
    const supportedTypes = $24d3f45678877ad9$export$8464b961cdde59f9(metricType);
    if (value && supportedTypes.includes(value)) return value;
    return $24d3f45678877ad9$export$54428e230c7f6b57;
}
function $24d3f45678877ad9$export$8464b961cdde59f9(metricType) {
    if (metricType === "latency") return [
        $24d3f45678877ad9$export$54428e230c7f6b57
    ];
    return [
        $24d3f45678877ad9$export$54428e230c7f6b57,
        $24d3f45678877ad9$export$bd11c95869e508f9
    ];
}
function $24d3f45678877ad9$export$4d9cbd22a8347c37() {
    const [currentSearchParams] = (0, $e7b98158099ae00d$export$f1a78c17382fe22a)();
    const { metricType: metricType = "requestRate", module: moduleParameter } = (0, $efeb47d767416279$export$99eaa27ddbbb95ef)();
    // This determines whether to show the graph or the query
    const contentType = $24d3f45678877ad9$export$2453c71000d2659b(currentSearchParams.get("contentType"), metricType);
    return {
        searchParams: currentSearchParams,
        metricType: metricType,
        moduleParameter: moduleParameter,
        contentType: contentType
    };
}


function $74e390d084ece18b$export$3bb55d1a5baebf22(timeRange, forceIgnoreModule = false) {
    // NOTE - Module might be undefined because of the way we're using the router
    const { name: functionName, module: moduleName, service: serviceName } = (0, $efeb47d767416279$export$99eaa27ddbbb95ef)();
    const environment = (0, $1a280fbaa3fcabb5$export$2105062e25df4afe)((0, $14bbd07b3011052f$export$919b3065fd27c3a8));
    const { buildInfoInterval: buildInfoInterval, shouldWaitForBuildInfoInterval: shouldWaitForBuildInfoInterval } = (0, $ebef9a37eb84c991$export$1fe69f4501914576)(environment?.url);
    const [fetchSourceCodeLinks, sourceCodeLinks] = (0, $7530fbaa6f2f256c$export$87b7625d1fedbc0e)({
        selectFromResult: ({ data: data, ...rest })=>{
            // Regex pattern to remove the first part of a module/function name definition
            // This is because module name and function names as specified by the am list
            // endpoint don't always match with what the autometrics libraries report
            const regexPattern = /^.*?(::|\.)/;
            const simplifiedModule = moduleName?.replace(regexPattern, "");
            return {
                ...rest,
                data: data?.map((entry)=>{
                    const { id: id, ...rest } = entry;
                    // There's sometimes an issue where the module name contains the full path
                    const cleanedUpModule = id.module.startsWith(rest.path) ? id.module.slice(rest.path.length) : id.module;
                    const moduleMatches = moduleName === undefined || cleanedUpModule === moduleName || cleanedUpModule === simplifiedModule || cleanedUpModule.replace(regexPattern, "") === moduleName;
                    const functionMatches = id.function === functionName || moduleName && id.function.replace(regexPattern, "") === functionName;
                    const valid = moduleMatches && functionMatches;
                    if (valid) return {
                        ...rest,
                        id: {
                            ...id,
                            // Return updated module
                            module: cleanedUpModule
                        }
                    };
                    return null;
                }).filter(Boolean)
            };
        }
    });
    const { value: linkSettings } = (0, $a82ff438e9d7ee7b$export$14a266f6d49360ef)();
    (0, $2gcPZ.useEffect)(()=>{
        // Only AM is injecting a prometheus URL into the DOM
        // So if this value is set, we know explorer is hosted
        // by AM
        if (linkSettings !== "off") fetchSourceCodeLinks({});
    }, [
        fetchSourceCodeLinks,
        linkSettings
    ]);
    const { data: matchedData } = (0, $7530fbaa6f2f256c$export$7f85c6a6ff922ea5)(environment?.url, {
        selectFromResult: ({ data: data, ...rest })=>({
                ...rest,
                data: forceIgnoreModule ? {
                    name: functionName,
                    module: undefined
                } : data?.find((entry)=>moduleName === undefined ? entry.name === functionName : entry.module === moduleName && entry.name === functionName)
            })
    });
    const matchedFunctionName = matchedData?.name ?? functionName ?? "";
    const matchedModuleName = matchedData?.module ?? moduleName;
    const promqlRequestRateQuery = (0, $bb43024bd9dbbe83$export$318474253e1e7e49)({
        functionName: matchedFunctionName,
        moduleName: matchedModuleName,
        buildInfoInterval: buildInfoInterval
    });
    const queriedRequestRate = (0, $5755db105caee352$export$c386b48e92fd4ce1)({
        environmentUrl: environment?.url,
        query: promqlRequestRateQuery,
        start: timeRange.from,
        end: timeRange.to
    }, {
        // NOTE - This allows us to refetch data when the time range changes
        refetchOnMountOrArgChange: true,
        // HACK - to prevent double-queries, we skip the query if we haven't determined the scrape interval yet
        skip: shouldWaitForBuildInfoInterval
    });
    const promqlErrorRatioQuery = (0, $bb43024bd9dbbe83$export$7c8dfcce7d0c3f04)({
        functionName: matchedFunctionName,
        moduleName: matchedModuleName,
        buildInfoInterval: buildInfoInterval
    });
    const queriedErrorRatio = (0, $5755db105caee352$export$c386b48e92fd4ce1)({
        environmentUrl: environment?.url,
        query: promqlErrorRatioQuery,
        start: timeRange.from,
        end: timeRange.to
    }, {
        // NOTE - This allows us to refetch data when the time range changes
        refetchOnMountOrArgChange: true,
        // HACK - to prevent double-queries, we skip the query if we haven't determined the scrape interval yet
        skip: shouldWaitForBuildInfoInterval
    });
    const promqlLatencyQuery = (0, $bb43024bd9dbbe83$export$ff253d853c482a8b)({
        functionName: matchedFunctionName,
        moduleName: matchedModuleName,
        buildInfoInterval: buildInfoInterval
    });
    const queriedLatency = (0, $5755db105caee352$export$c386b48e92fd4ce1)({
        environmentUrl: environment?.url,
        query: promqlLatencyQuery,
        start: timeRange.from,
        end: timeRange.to
    }, {
        // NOTE - This allows us to refetch data when the time range changes
        refetchOnMountOrArgChange: true,
        // HACK - to prevent double-queries, we skip the query if we haven't determined the scrape interval yet
        skip: shouldWaitForBuildInfoInterval
    });
    const promqlRequestCountQuery = (0, $bb43024bd9dbbe83$export$223be44715644635)({
        functionName: matchedFunctionName,
        moduleName: matchedModuleName,
        timeRange: timeRange
    });
    const requestCountQuery = (0, $5755db105caee352$export$ca13061e89ab955d)({
        environmentUrl: environment?.url,
        query: promqlRequestCountQuery,
        time: timeRange.to
    }, {
        // NOTE - This allows us to refetch data when the time range changes
        refetchOnMountOrArgChange: true
    });
    const promqlErrorCountQuery = (0, $bb43024bd9dbbe83$export$4689648aa7da5ec3)({
        functionName: matchedFunctionName,
        moduleName: matchedModuleName,
        timeRange: timeRange
    });
    const errorCountQuery = (0, $5755db105caee352$export$ca13061e89ab955d)({
        environmentUrl: environment?.url,
        query: promqlErrorCountQuery,
        time: timeRange.to
    }, {
        // NOTE - This allows us to refetch data when the time range changes
        refetchOnMountOrArgChange: true
    });
    const { metricType: metricType } = (0, $24d3f45678877ad9$export$4d9cbd22a8347c37)();
    const callGraphData = (0, $35cfa0c2695942cf$export$aff7f2423eafed8e)({
        environmentUrl: environment?.url,
        functionName: matchedFunctionName,
        moduleName: matchedModuleName,
        metricType: metricType,
        timeRange: timeRange
    });
    const promqlVersionQuery = (0, $bb43024bd9dbbe83$export$9ad8bd389db2f09d)({
        functionName: matchedFunctionName,
        moduleName: matchedModuleName
    });
    const queriedVersion = (0, $5755db105caee352$export$c386b48e92fd4ce1)({
        environmentUrl: environment?.url,
        query: promqlVersionQuery,
        start: timeRange.from,
        end: timeRange.to
    }, {
        // NOTE - This allows us to refetch data when the time range changes
        refetchOnMountOrArgChange: true
    });
    const { data: versions, isSuccess: eventsReady } = queriedVersion;
    const events = (0, $2gcPZ.useMemo)(()=>{
        if (eventsReady === false) return;
        return versions?.map((series)=>{
            const { metrics: metrics, ...info } = series;
            const time = metrics[0]?.time;
            if (!time || time < timeRange.from) return undefined;
            return {
                time: time,
                attributes: info.attributes,
                labels: info.labels,
                resource: info.resource,
                title: info.name
            };
        }).filter((item)=>item !== undefined);
    }, [
        versions,
        timeRange.from,
        eventsReady
    ]);
    // FIXME: a bit of a dirty way adding some additional data to the cards
    const functionData = {
        functionName: matchedFunctionName,
        moduleName: moduleName,
        serviceName: serviceName,
        sourceCodeLinks: sourceCodeLinks,
        prometheusData: {
            requestRate: {
                ...queriedRequestRate,
                promqlQuery: promqlRequestRateQuery,
                metrics: [
                    {
                        reportType: "latest",
                        unit: "calls/sec",
                        value: $74e390d084ece18b$var$getLatestValue(queriedRequestRate.data)
                    },
                    {
                        reportType: "sum",
                        unit: "calls",
                        value: $74e390d084ece18b$var$getSumOfAllCalls(requestCountQuery.data)
                    }
                ]
            },
            errorRatio: {
                ...queriedErrorRatio,
                promqlQuery: promqlErrorRatioQuery,
                metrics: [
                    {
                        reportType: "latest",
                        unit: undefined,
                        value: $74e390d084ece18b$var$getLatestValueAsPercentage(queriedErrorRatio.data)
                    },
                    {
                        reportType: "sum",
                        unit: "errors",
                        value: $74e390d084ece18b$var$getSumOfAllCalls(errorCountQuery.data)
                    }
                ]
            },
            latency: {
                ...queriedLatency,
                promqlQuery: promqlLatencyQuery,
                metrics: [
                    {
                        reportType: "latest",
                        unit: "seconds",
                        value: $74e390d084ece18b$var$getLatestSecondsValue(queriedLatency.data)
                    }
                ]
            }
        },
        events: events,
        callGraphData: callGraphData,
        buildInfoInterval: buildInfoInterval
    };
    return functionData;
}
function $74e390d084ece18b$var$getLatestValueFromData(data) {
    const [metricsData] = data ?? [];
    const metrics = metricsData?.metrics;
    return metrics?.[metrics.length - 1]?.value;
}
function $74e390d084ece18b$var$getLatestValue(data, maximumFractionDigits = 2) {
    const value = $74e390d084ece18b$var$getLatestValueFromData(data);
    if (value) return value.toLocaleString(undefined, {
        maximumFractionDigits: maximumFractionDigits
    });
}
function $74e390d084ece18b$var$getLatestSecondsValue(data) {
    const value = $74e390d084ece18b$var$getLatestValueFromData(data);
    if (!value) return;
    // NOTE - We want to show:
    //        * 3 decimal places for values < 1,
    //        * 2 decimal places for values between 1 and 10,
    //        * 1 decimal place for values > 10
    //
    let maximumFractionDigits = 2;
    if (value < 1) maximumFractionDigits = 3;
    else if (value > 10) maximumFractionDigits = 1;
    return value.toLocaleString(undefined, {
        maximumFractionDigits: maximumFractionDigits
    });
}
function $74e390d084ece18b$var$getLatestValueAsPercentage(data) {
    const value = $74e390d084ece18b$var$getLatestValueFromData(data);
    if (value) return `${(value * 100).toLocaleString(undefined, {
        maximumFractionDigits: 2
    })}%`;
}
function $74e390d084ece18b$var$getSumOfAllCalls(data) {
    const value = data?.data?.result?.[0]?.value?.[1] ?? "NaN";
    const numericValue = typeof value === "string" && Number.parseFloat(value);
    if (numericValue) return Math.round(numericValue).toLocaleString();
}









var $2gcPZ = parcelRequire("2gcPZ");






var $kHUM6 = parcelRequire("kHUM6");

var $jewWr = parcelRequire("jewWr");

var $9QQqP = parcelRequire("9QQqP");




/**
 * Actions represent the type of change to a location value.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#action
 */ var $de953fb05d52a83f$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($de953fb05d52a83f$export$e19cd5f9376f8cee || ($de953fb05d52a83f$export$e19cd5f9376f8cee = {}));
var $de953fb05d52a83f$var$readOnly = function(obj) {
    return obj;
};
function $de953fb05d52a83f$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
var $de953fb05d52a83f$var$BeforeUnloadEventType = "beforeunload";
var $de953fb05d52a83f$var$HashChangeEventType = "hashchange";
var $de953fb05d52a83f$var$PopStateEventType = "popstate";
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $de953fb05d52a83f$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    var _options = options, _options$window = _options.window, window = _options$window === void 0 ? document.defaultView : _options$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $de953fb05d52a83f$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || "default"
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $de953fb05d52a83f$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation = getIndexAndLocation(), nextIndex = _getIndexAndLocation[0], nextLocation = _getIndexAndLocation[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                }
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($de953fb05d52a83f$var$PopStateEventType, handlePop);
    var action = $de953fb05d52a83f$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation2 = getIndexAndLocation(), index = _getIndexAndLocation2[0], location = _getIndexAndLocation2[1];
    var listeners = $de953fb05d52a83f$var$createEvents();
    var blockers = $de953fb05d52a83f$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $dc04f589521b3b66$export$2e2bcd8739ae039)({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function createHref(to) {
        return typeof to === "string" ? to : $de953fb05d52a83f$export$fe53371bee54353d(to);
    } // state defaults to `null` because `window.history.state` does
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $de953fb05d52a83f$var$readOnly((0, $dc04f589521b3b66$export$2e2bcd8739ae039)({
            pathname: location.pathname,
            hash: "",
            search: ""
        }, typeof to === "string" ? $de953fb05d52a83f$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $de953fb05d52a83f$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation3 = getIndexAndLocation();
        index = _getIndexAndLocation3[0];
        location = _getIndexAndLocation3[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $de953fb05d52a83f$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr[0], url = _getHistoryStateAndUr[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, "", url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $de953fb05d52a83f$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr2 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr2[0], url = _getHistoryStateAndUr2[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, "", url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($de953fb05d52a83f$var$BeforeUnloadEventType, $de953fb05d52a83f$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($de953fb05d52a83f$var$BeforeUnloadEventType, $de953fb05d52a83f$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $de953fb05d52a83f$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    var _options2 = options, _options2$window = _options2.window, window = _options2$window === void 0 ? document.defaultView : _options2$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _parsePath = $de953fb05d52a83f$export$8ccf933b0513f8d0(window.location.hash.substr(1)), _parsePath$pathname = _parsePath.pathname, pathname = _parsePath$pathname === void 0 ? "/" : _parsePath$pathname, _parsePath$search = _parsePath.search, search = _parsePath$search === void 0 ? "" : _parsePath$search, _parsePath$hash = _parsePath.hash, hash = _parsePath$hash === void 0 ? "" : _parsePath$hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $de953fb05d52a83f$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || "default"
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $de953fb05d52a83f$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation4 = getIndexAndLocation(), nextIndex = _getIndexAndLocation4[0], nextLocation = _getIndexAndLocation4[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                }
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($de953fb05d52a83f$var$PopStateEventType, handlePop); // popstate does not fire on hashchange in IE 11 and old (trident) Edge
    // https://developer.mozilla.org/de/docs/Web/API/Window/popstate_event
    window.addEventListener($de953fb05d52a83f$var$HashChangeEventType, function() {
        var _getIndexAndLocation5 = getIndexAndLocation(), nextLocation = _getIndexAndLocation5[1]; // Ignore extraneous hashchange events.
        if ($de953fb05d52a83f$export$fe53371bee54353d(nextLocation) !== $de953fb05d52a83f$export$fe53371bee54353d(location)) handlePop();
    });
    var action = $de953fb05d52a83f$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation6 = getIndexAndLocation(), index = _getIndexAndLocation6[0], location = _getIndexAndLocation6[1];
    var listeners = $de953fb05d52a83f$var$createEvents();
    var blockers = $de953fb05d52a83f$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $dc04f589521b3b66$export$2e2bcd8739ae039)({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getBaseHref() {
        var base = document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href;
    }
    function createHref(to) {
        return getBaseHref() + "#" + (typeof to === "string" ? to : $de953fb05d52a83f$export$fe53371bee54353d(to));
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $de953fb05d52a83f$var$readOnly((0, $dc04f589521b3b66$export$2e2bcd8739ae039)({
            pathname: location.pathname,
            hash: "",
            search: ""
        }, typeof to === "string" ? $de953fb05d52a83f$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $de953fb05d52a83f$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation7 = getIndexAndLocation();
        index = _getIndexAndLocation7[0];
        location = _getIndexAndLocation7[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $de953fb05d52a83f$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr3 = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr3[0], url = _getHistoryStateAndUr3[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, "", url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $de953fb05d52a83f$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr4 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr4[0], url = _getHistoryStateAndUr4[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, "", url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($de953fb05d52a83f$var$BeforeUnloadEventType, $de953fb05d52a83f$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($de953fb05d52a83f$var$BeforeUnloadEventType, $de953fb05d52a83f$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#creatememoryhistory
 */ function $de953fb05d52a83f$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    var _options3 = options, _options3$initialEntr = _options3.initialEntries, initialEntries = _options3$initialEntr === void 0 ? [
        "/"
    ] : _options3$initialEntr, initialIndex = _options3.initialIndex;
    var entries = initialEntries.map(function(entry) {
        var location = $de953fb05d52a83f$var$readOnly((0, $dc04f589521b3b66$export$2e2bcd8739ae039)({
            pathname: "/",
            search: "",
            hash: "",
            state: null,
            key: $de953fb05d52a83f$var$createKey()
        }, typeof entry === "string" ? $de953fb05d52a83f$export$8ccf933b0513f8d0(entry) : entry));
        return location;
    });
    var index = $de953fb05d52a83f$var$clamp(initialIndex == null ? entries.length - 1 : initialIndex, 0, entries.length - 1);
    var action = $de953fb05d52a83f$export$e19cd5f9376f8cee.Pop;
    var location = entries[index];
    var listeners = $de953fb05d52a83f$var$createEvents();
    var blockers = $de953fb05d52a83f$var$createEvents();
    function createHref(to) {
        return typeof to === "string" ? to : $de953fb05d52a83f$export$fe53371bee54353d(to);
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $de953fb05d52a83f$var$readOnly((0, $dc04f589521b3b66$export$2e2bcd8739ae039)({
            pathname: location.pathname,
            search: "",
            hash: ""
        }, typeof to === "string" ? $de953fb05d52a83f$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $de953fb05d52a83f$var$createKey()
        }));
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction, nextLocation) {
        action = nextAction;
        location = nextLocation;
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $de953fb05d52a83f$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            applyTx(nextAction, nextLocation);
        }
    }
    function replace(to, state) {
        var nextAction = $de953fb05d52a83f$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            entries[index] = nextLocation;
            applyTx(nextAction, nextLocation);
        }
    }
    function go(delta) {
        var nextIndex = $de953fb05d52a83f$var$clamp(index + delta, 0, entries.length - 1);
        var nextAction = $de953fb05d52a83f$export$e19cd5f9376f8cee.Pop;
        var nextLocation = entries[nextIndex];
        function retry() {
            go(delta);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index = nextIndex;
            applyTx(nextAction, nextLocation);
        }
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            return blockers.push(blocker);
        }
    };
    return history;
} ////////////////////////////////////////////////////////////////////////////////
// UTILS
////////////////////////////////////////////////////////////////////////////////
function $de953fb05d52a83f$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
function $de953fb05d52a83f$var$promptBeforeUnload(event) {
    // Cancel the event.
    event.preventDefault(); // Chrome (and legacy IE) requires returnValue to be set.
    event.returnValue = "";
}
function $de953fb05d52a83f$var$createEvents() {
    var handlers = [];
    return {
        get length () {
            return handlers.length;
        },
        push: function push(fn) {
            handlers.push(fn);
            return function() {
                handlers = handlers.filter(function(handler) {
                    return handler !== fn;
                });
            };
        },
        call: function call(arg) {
            handlers.forEach(function(fn) {
                return fn && fn(arg);
            });
        }
    };
}
function $de953fb05d52a83f$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createpath
 */ function $de953fb05d52a83f$export$fe53371bee54353d(_ref) {
    var _ref$pathname = _ref.pathname, pathname = _ref$pathname === void 0 ? "/" : _ref$pathname, _ref$search = _ref.search, search = _ref$search === void 0 ? "" : _ref$search, _ref$hash = _ref.hash, hash = _ref$hash === void 0 ? "" : _ref$hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#parsepath
 */ function $de953fb05d52a83f$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}


const $b1a337507bfbb9cc$export$d035cdafa5d37a89 = "@@router/CALL_HISTORY_METHOD";
const $b1a337507bfbb9cc$export$be84bd1ba815d4c2 = "@@router/LOCATION_CHANGE";
const $b1a337507bfbb9cc$export$dacf827b25d7a046 = (location, action)=>({
        type: $b1a337507bfbb9cc$export$be84bd1ba815d4c2,
        payload: {
            location: location,
            action: action
        }
    });
function $b1a337507bfbb9cc$var$updateLocation(method) {
    // @ts-ignore //support history 5.x back/forward
    return (...args)=>({
            type: $b1a337507bfbb9cc$export$d035cdafa5d37a89,
            payload: {
                method: method,
                args: args
            }
        });
}
const $b1a337507bfbb9cc$export$4cbf152802aa238 = $b1a337507bfbb9cc$var$updateLocation("push");
const $b1a337507bfbb9cc$export$77ad94ebf1c2b9ed = $b1a337507bfbb9cc$var$updateLocation("replace");
const $b1a337507bfbb9cc$export$93bb224d05b3906d = $b1a337507bfbb9cc$var$updateLocation("go");
const $b1a337507bfbb9cc$export$28fca2ccfd38b8f = $b1a337507bfbb9cc$var$updateLocation("goBack");
const $b1a337507bfbb9cc$export$994d0e87e52ba8e3 = $b1a337507bfbb9cc$var$updateLocation("goForward");
const $b1a337507bfbb9cc$export$7c341cb16fc91138 = $b1a337507bfbb9cc$var$updateLocation("back");
const $b1a337507bfbb9cc$export$174bb771924e7eb1 = $b1a337507bfbb9cc$var$updateLocation("forward");


const $ff89bbd79bf0bf47$export$859e04a75151ddb4 = (reduxHistory)=>{
    let transitioning = false;
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    let resolveTransition = ()=>{};
    return {
        // eslint-disable-next-line no-underscore-dangle
        _onTransitionComplete () {
            transitioning = false;
            resolveTransition();
        },
        listen (listener) {
            if (reduxHistory.listenObject) // @ts-ignore
            return reduxHistory.listen(listener);
            // @ts-ignore
            return reduxHistory.listen((location, action)=>listener({
                    location: location,
                    action: action
                }));
        },
        // @ts-ignore
        navigate (to, { state: state, replace: replace = false } = {}) {
            if (transitioning || replace) reduxHistory.replace(to, state);
            else reduxHistory.push(to, state);
            transitioning = true;
            // eslint-disable-next-line no-return-assign
            // @ts-ignore
            return new Promise((res)=>resolveTransition = res);
        },
        // @ts-ignore
        get location () {
            return reduxHistory.location;
        },
        get transitioning () {
            return transitioning;
        }
    };
};




function $05a49bef803e202d$var$appendBasename(location, basename) {
    if (typeof location === "string" && !location.startsWith(basename)) return basename + location;
    if (typeof location === "object" && !!location.pathname && !location.pathname.startsWith(basename)) return Object.assign(Object.assign({}, location), {
        pathname: basename + location.pathname
    });
    return location;
}
const $05a49bef803e202d$export$1fe5128387816284 = ({ history: history, showHistoryAction: showHistoryAction, basename: basename })=>()=>(next)=>(action)=>{
                if (action.type !== (0, $b1a337507bfbb9cc$export$d035cdafa5d37a89)) return next(action);
                const method = action.payload.method;
                // @ts-ignore
                const args = action.payload.args;
                // eslint-disable-next-line default-case
                switch(method){
                    case "push":
                        {
                            let callArgs = args;
                            if (basename && args.length > 0) callArgs = [
                                $05a49bef803e202d$var$appendBasename(args[0], basename),
                                ...args.slice(1)
                            ];
                            history.push(...callArgs);
                            break;
                        }
                    case "replace":
                        {
                            let callArgs = args;
                            if (basename && args.length > 0) callArgs = [
                                $05a49bef803e202d$var$appendBasename(args[0], basename),
                                ...args.slice(1)
                            ];
                            history.replace(...callArgs);
                            break;
                        }
                    case "go":
                        history.go(...args);
                        break;
                    case "back":
                    case "goBack":
                        // @ts-ignore
                        history.goBack && history.goBack(...args);
                        //@ts-ignore //support history 5.x
                        history.back && history.back(...args);
                        break;
                    case "forward":
                    case "goForward":
                        // @ts-ignore
                        history.goForward && history.goForward(...args);
                        //@ts-ignore //support history 5.x
                        history.forward && history.forward(...args);
                        break;
                }
                if (showHistoryAction) return next(action);
            };



const $2c600e5b13a81503$export$4360105d0eb5a11c = ({ savePreviousLocations: savePreviousLocations = 0, basename: basename })=>{
    const initialState = {
        location: null,
        action: null,
        basename: basename
    };
    // eslint-disable-next-line no-restricted-globals
    const numLocationToTrack = isNaN(savePreviousLocations) ? 0 : savePreviousLocations;
    if (numLocationToTrack) initialState.previousLocations = [];
    return (state = initialState, { type: type, payload: payload } = {})=>{
        if (type === (0, $b1a337507bfbb9cc$export$be84bd1ba815d4c2)) {
            const { location: location, action: action } = payload || {};
            const previousLocations = numLocationToTrack // @ts-ignore
             ? [
                {
                    location: location,
                    action: action
                },
                ...state.previousLocations.slice(0, numLocationToTrack)
            ] : undefined;
            return Object.assign(Object.assign({}, state), {
                location: location,
                action: action,
                previousLocations: previousLocations
            });
        }
        return state;
    };
};


const $6127c8415c205cd1$export$8732e94d9346c6a4 = ({ history: history, routerReducerKey: routerReducerKey = "router", reduxTravelling: reduxTravelling = false, showHistoryAction: showHistoryAction = false, selectRouterState: selectRouterState, savePreviousLocations: savePreviousLocations = 0, batch: batch, reachGlobalHistory: reachGlobalHistory, basename: basename })=>{
    let listenObject = false;
    // @ts-ignore
    const callListener = (listener, location, action)=>listenObject ? listener({
            location: location,
            action: action
        }) : listener(location, action);
    if (typeof batch !== "function") batch = (fn)=>{
        fn();
    };
    /** ********************************************  REDUX REDUCER ***************************************************** */ if (typeof selectRouterState !== "function") selectRouterState = (state)=>state[routerReducerKey];
    const routerReducer = (0, $2c600e5b13a81503$export$4360105d0eb5a11c)({
        savePreviousLocations: savePreviousLocations,
        basename: basename
    });
    const routerMiddleware = (0, $05a49bef803e202d$export$1fe5128387816284)({
        history: history,
        showHistoryAction: showHistoryAction,
        basename: basename
    });
    /** ******************************************  REDUX TRAVELLING  ************************************************** */ let isReduxTravelling = false;
    const handleReduxTravelling = (store)=>{
        const locationEqual = (loc1, loc2)=>loc1.pathname === loc2.pathname && loc1.search === loc2.search && loc1.hash === loc2.hash;
        return store.subscribe(()=>{
            // @ts-ignore
            const sLoc = selectRouterState(store.getState()).location;
            const hLoc = history.location;
            if (sLoc && hLoc && !locationEqual(sLoc, hLoc)) {
                isReduxTravelling = true;
                history.push({
                    pathname: sLoc.pathname,
                    search: sLoc.search,
                    hash: sLoc.hash
                });
            }
        });
    };
    /** ******************************************  REDUX FIRST HISTORY   *********************************************** */ const createReduxHistory = (store)=>{
        let registeredCallback = [];
        // init location store
        store.dispatch((0, $b1a337507bfbb9cc$export$dacf827b25d7a046)(history.location, history.action));
        if (reduxTravelling) handleReduxTravelling(store);
        // listen to history API
        // @ts-ignore
        history.listen((location, action)=>{
            // support history v5
            // @ts-ignore
            if (location.location) {
                // @ts-ignore
                action = location.action;
                // @ts-ignore
                location = location.location;
                listenObject = true;
            }
            if (isReduxTravelling) {
                isReduxTravelling = false;
                // notify registered callback travelling
                // @ts-ignore
                const routerState = selectRouterState(store.getState());
                registeredCallback.forEach((c)=>callListener(c, routerState.location, routerState.action));
                return;
            }
            // @ts-ignore
            batch(()=>{
                store.dispatch((0, $b1a337507bfbb9cc$export$dacf827b25d7a046)(location, action));
                // @ts-ignore
                const routerState = selectRouterState(store.getState());
                registeredCallback.forEach((c)=>callListener(c, routerState.location, routerState.action));
            });
        });
        // listen to reach globalHistory (support "navigate")
        if (reachGlobalHistory) reachGlobalHistory.listen(({ location: location, action: action })=>{
            if (action !== `POP`) {
                const loc = {
                    pathname: location.pathname,
                    search: location.search,
                    hash: location.hash,
                    key: location.key,
                    state: location.state
                };
                // @ts-ignore
                batch(()=>{
                    // @ts-ignore
                    store.dispatch((0, $b1a337507bfbb9cc$export$dacf827b25d7a046)(loc, action));
                    // @ts-ignore
                    const routerState = selectRouterState(store.getState());
                    registeredCallback.forEach((c)=>callListener(c, routerState.location, routerState.action));
                });
            }
        });
        // @ts-ignore
        return {
            block: history.block,
            createHref: history.createHref,
            push: (...args)=>store.dispatch((0, $b1a337507bfbb9cc$export$4cbf152802aa238)(...args)),
            replace: (...args)=>store.dispatch((0, $b1a337507bfbb9cc$export$77ad94ebf1c2b9ed)(...args)),
            go: (...args)=>store.dispatch((0, $b1a337507bfbb9cc$export$93bb224d05b3906d)(...args)),
            // @ts-ignore
            goBack: (...args)=>store.dispatch((0, $b1a337507bfbb9cc$export$28fca2ccfd38b8f)(...args)),
            // @ts-ignore
            goForward: (...args)=>// @ts-ignore
                store.dispatch((0, $b1a337507bfbb9cc$export$994d0e87e52ba8e3)(...args)),
            // @ts-ignore
            back: (...args)=>store.dispatch((0, $b1a337507bfbb9cc$export$7c341cb16fc91138)(...args)),
            // @ts-ignore
            forward: (...args)=>store.dispatch((0, $b1a337507bfbb9cc$export$174bb771924e7eb1)(...args)),
            listen: (callback)=>{
                if (registeredCallback.indexOf(callback) < 0) registeredCallback.push(callback);
                return ()=>{
                    registeredCallback = registeredCallback.filter((c)=>c !== callback);
                };
            },
            // @ts-ignore
            get location () {
                // @ts-ignore
                return selectRouterState(store.getState()).location;
            },
            // @ts-ignore
            get action () {
                // @ts-ignore
                return selectRouterState(store.getState()).action;
            },
            get length () {
                // @ts-ignore
                return history.length;
            },
            // @ts-ignore
            get listenObject () {
                return listenObject;
            }
        };
    };
    return {
        routerReducer: routerReducer,
        routerMiddleware: routerMiddleware,
        createReduxHistory: createReduxHistory
    };
};




const $c9a28024b3e23cac$var$history = (0, $de953fb05d52a83f$export$719fc203c4e16dee)();
const { createReduxHistory: $c9a28024b3e23cac$export$5d2a7366f73d240c, routerMiddleware: $c9a28024b3e23cac$export$8014fb44192d8f33, routerReducer: $c9a28024b3e23cac$export$a6e30f0f4d30936a } = (0, $6127c8415c205cd1$export$8732e94d9346c6a4)({
    history: $c9a28024b3e23cac$var$history
});



var $bEIGg = parcelRequire("bEIGg");
var $e46c0d05a3c80666$exports = {};
"use strict";

$e46c0d05a3c80666$exports = (parcelRequire("kL91E"));



const $ecfe56675d6ea75b$var$initialConnectionStatus = {
    ping: (0, $e46c0d05a3c80666$exports.QueryStatus).uninitialized,
    query: (0, $e46c0d05a3c80666$exports.QueryStatus).uninitialized
};
const $ecfe56675d6ea75b$var$initialState = $ecfe56675d6ea75b$var$getInitialState();
const $ecfe56675d6ea75b$export$1d2b60fd9b3f5f3a = (0, $bEIGg.createSlice)({
    name: "environment",
    initialState: $ecfe56675d6ea75b$var$initialState,
    reducers: {
        addInstance: (state, action)=>{
            // HACK - filter possible duplicates
            state.instances = state.instances.filter((instance)=>instance.url !== action.payload.url || instance.name !== action.payload.name);
            state.instances.unshift({
                ...action.payload,
                connectionStatus: $ecfe56675d6ea75b$var$initialConnectionStatus
            });
            // HACK - persist to localStorage
            $ecfe56675d6ea75b$var$saveInstances(state.instances);
        },
        upsertAndSelectInstanceByUrl: (state, action)=>{
            const matchingInstance = state.instances.find((instance)=>instance.url === action.payload);
            if (matchingInstance) state.selectedInstance = matchingInstance.id;
            else {
                const id = Date.now().toString();
                let name = "AM Prometheus";
                const nameNumericIdentifier = state.instances.filter((instance)=>instance.name === "Am Prometheus").length + 1;
                if (nameNumericIdentifier > 1) name = name + " " + nameNumericIdentifier;
                state.instances.push({
                    id: id,
                    name: name,
                    url: action.payload,
                    connectionStatus: $ecfe56675d6ea75b$var$initialConnectionStatus
                });
                state.selectedInstance = id;
            }
            // HACK - persist to localStorage
            $ecfe56675d6ea75b$var$saveInstances(state.instances);
            $ecfe56675d6ea75b$var$saveSelectedInstance(state.selectedInstance);
        },
        removeInstance: (state, action)=>{
            state.instances = state.instances.filter((instance)=>instance.id !== action.payload.id);
            // HACK - persist to localStorage
            $ecfe56675d6ea75b$var$saveInstances(state.instances);
            // HACK - if you deleted the currently active instance, select the next one
            if (state.selectedInstance === action.payload.id) {
                state.selectedInstance = state.instances[0]?.id ?? "";
                // HACK - persist to localStorage
                $ecfe56675d6ea75b$var$saveSelectedInstance(state.selectedInstance);
            }
        },
        switchInstance: (state, action)=>{
            state.selectedInstance = action.payload;
            // HACK - persist to localStorage
            $ecfe56675d6ea75b$var$saveSelectedInstance(state.selectedInstance);
        },
        updateInstance: (state, action)=>{
            for (const instance of state.instances)if (instance.id === action.payload.id) {
                instance.name = action.payload.name ?? instance.name;
                instance.url = action.payload.url ?? instance.url;
            }
            $ecfe56675d6ea75b$var$saveInstances(state.instances);
        }
    },
    extraReducers: (builder)=>{
        builder.addMatcher((0, $fe24d45de7923f97$export$db2da65404f64f92).endpoints.pingAnyPrometheus.matchFulfilled, (state, action)=>{
            const instance = $ecfe56675d6ea75b$var$getEnvironmentByUrl(state, action.meta.arg.originalArgs);
            if (instance) instance.connectionStatus.ping = (0, $e46c0d05a3c80666$exports.QueryStatus).fulfilled;
        });
        builder.addMatcher((0, $fe24d45de7923f97$export$db2da65404f64f92).endpoints.pingAnyPrometheus.matchPending, (state, action)=>{
            const instance = $ecfe56675d6ea75b$var$getEnvironmentByUrl(state, action.meta.arg.originalArgs);
            if (instance?.connectionStatus?.ping === (0, $e46c0d05a3c80666$exports.QueryStatus).uninitialized) instance.connectionStatus.ping = (0, $e46c0d05a3c80666$exports.QueryStatus).pending;
        });
        builder.addMatcher((0, $fe24d45de7923f97$export$db2da65404f64f92).endpoints.pingAnyPrometheus.matchRejected, (state, action)=>{
            const instance = $ecfe56675d6ea75b$var$getEnvironmentByUrl(state, action.meta.arg.originalArgs);
            if (instance) instance.connectionStatus.ping = (0, $e46c0d05a3c80666$exports.QueryStatus).rejected;
        });
        builder.addMatcher((0, $5755db105caee352$export$bcc8035e549759b4).endpoints.prometheusQuery.matchPending, (state, action)=>{
            const instance = $ecfe56675d6ea75b$var$getEnvironmentByUrl(state, action.meta.arg.originalArgs.environmentUrl);
            if (instance) instance.connectionStatus.query = (0, $e46c0d05a3c80666$exports.QueryStatus).pending;
        });
        builder.addMatcher((0, $5755db105caee352$export$bcc8035e549759b4).endpoints.prometheusQuery.matchRejected, (state, action)=>{
            const instance = $ecfe56675d6ea75b$var$getEnvironmentByUrl(state, action.meta.arg.originalArgs.environmentUrl);
            if (instance) instance.connectionStatus.query = (0, $e46c0d05a3c80666$exports.QueryStatus).rejected;
        });
        builder.addMatcher((0, $5755db105caee352$export$bcc8035e549759b4).endpoints.prometheusQuery.matchFulfilled, (state, action)=>{
            const instance = $ecfe56675d6ea75b$var$getEnvironmentByUrl(state, action.meta.arg.originalArgs.environmentUrl);
            if (instance) instance.connectionStatus.query = (0, $e46c0d05a3c80666$exports.QueryStatus).fulfilled;
        });
    }
});
function $ecfe56675d6ea75b$var$getEnvironmentByUrl(state, url) {
    return state.instances.find((instance)=>instance.url === url);
}
const { addInstance: $ecfe56675d6ea75b$export$a78fd88194b4f36a, upsertAndSelectInstanceByUrl: $ecfe56675d6ea75b$export$1df5575955777c32, removeInstance: $ecfe56675d6ea75b$export$99b0db74c81be036, switchInstance: $ecfe56675d6ea75b$export$3b7e95cf3154ca1f, updateInstance: $ecfe56675d6ea75b$export$b72a60b4ff774144 } = $ecfe56675d6ea75b$export$1d2b60fd9b3f5f3a.actions;
// NOTE - Reads from localStorage and DOM, so this is pretty impure
// Here be dragons
// * If there is a "selectedInstance" in the localStorage, use that, but only if there's a matching instance in the instances array
// * Else if there is a prometheusUrl defined in the DOM, use that. If there's no matching instance in the instances array, add it.
// * Else if there are instances in localStorage, use the first one
// * Else, the user will end up seeing a splash page that asks them to give a prometheus URL
function $ecfe56675d6ea75b$var$getInitialState() {
    const lastSelectedInstance = $ecfe56675d6ea75b$var$loadSelectedInstance();
    const state = {
        instances: $ecfe56675d6ea75b$var$loadInstances(),
        selectedInstance: $ecfe56675d6ea75b$var$loadSelectedInstance()
    };
    const domPrometheusUrl = $ecfe56675d6ea75b$export$4ceee2fd99b5f7a2();
    if (domPrometheusUrl) {
        const matchingInstance = state.instances.find((instance)=>instance.url === domPrometheusUrl);
        if (matchingInstance) state.selectedInstance = matchingInstance.id;
        else {
            const id = Date.now().toString();
            state.instances.push({
                id: id,
                name: "Local",
                url: domPrometheusUrl,
                connectionStatus: $ecfe56675d6ea75b$var$initialConnectionStatus
            });
            state.selectedInstance = id;
        }
    } else if (state.instances.length > 0) state.selectedInstance = state.instances[0]?.id ?? "";
    if (lastSelectedInstance && state.instances.some((i)=>i.id === lastSelectedInstance)) state.selectedInstance = lastSelectedInstance;
    return state;
}
function $ecfe56675d6ea75b$export$4ceee2fd99b5f7a2() {
    const url = document.querySelector("textarea#am-prometheus-url")?.value?.trim();
    // TODO - Validate URL
    if (typeof url !== "string") return "";
    return url ?? "";
}
function $ecfe56675d6ea75b$var$loadInstances() {
    const localStorageInstancesRaw = localStorage.getItem("dora.instances");
    if (localStorageInstancesRaw) try {
        const instances = JSON.parse(localStorageInstancesRaw);
        return instances.map(({ id: id, name: name, url: url })=>({
                id: id,
                url: url,
                name: name,
                connectionStatus: $ecfe56675d6ea75b$var$initialConnectionStatus
            }));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error loading instances from localStorage:", error);
    }
    return [];
}
function $ecfe56675d6ea75b$var$loadSelectedInstance() {
    const selectedInstance = localStorage.getItem("dora.selectedInstance");
    if (typeof selectedInstance === "string") return selectedInstance;
    return "";
}
function $ecfe56675d6ea75b$var$saveInstances(instances) {
    localStorage.setItem("dora.instances", JSON.stringify(instances.map(({ id: id, name: name, url: url })=>({
            id: id,
            url: url,
            name: name
        }))));
}
function $ecfe56675d6ea75b$var$saveSelectedInstance(instanceId) {
    localStorage.setItem("dora.selectedInstance", instanceId);
}



var $bEIGg = parcelRequire("bEIGg");
const $c96f342fb290ed4c$var$initialState = {
    ids: [],
    items: {},
    isVisible: false
};
const $c96f342fb290ed4c$export$afb9eb0000d920bf = (0, $bEIGg.createSlice)({
    name: "askAutometrics",
    initialState: $c96f342fb290ed4c$var$initialState,
    reducers: {
        add: (state, action)=>{
            state.ids.push(action.payload.id);
            state.items[action.payload.id] = {
                ...action.payload,
                response: null,
                isError: false
            };
        },
        appendById: (state, action)=>{
            const selectedItem = state.items[action.payload.id];
            if (!selectedItem) return;
            state.items[action.payload.id].response = (selectedItem.response || "") + action.payload.text;
        },
        markErrorById: (state, action)=>{
            const selectedItem = state.items[action.payload];
            if (!selectedItem) return;
            state.items[action.payload].isError = true;
        },
        setVisbility: (state, action)=>{
            state.isVisible = action.payload;
        }
    }
});
const { add: $c96f342fb290ed4c$export$e16d8520af44a096, appendById: $c96f342fb290ed4c$export$c2ef99b1ba0e664b, setVisbility: $c96f342fb290ed4c$export$295a1b2aa4d86817, markErrorById: $c96f342fb290ed4c$export$37bfc436a1b38646 } = $c96f342fb290ed4c$export$afb9eb0000d920bf.actions;




const $f7cf41d7a90d10a9$export$c9796fac990bf36 = "ui/hideActiveContextMenu";
const $f7cf41d7a90d10a9$export$8fd4b4b20b2a10d8 = "ui/hideActiveTooltip";
const $f7cf41d7a90d10a9$export$13c0f6bde07cf138 = "ui/hideCommandMenu";
const $f7cf41d7a90d10a9$export$a50d3ec4bddc9c0e = "ui/hideEngageMenu";
const $f7cf41d7a90d10a9$export$974831f076c2c3e4 = "ui/hideModal";
const $f7cf41d7a90d10a9$export$49276ccd2ea96fdb = "ui/hideSideMenu";
const $f7cf41d7a90d10a9$export$2a24c652e09185d3 = "ui/setActiveContextMenu";
const $f7cf41d7a90d10a9$export$1aed166826ca2834 = "ui/setActiveTooltip";
const $f7cf41d7a90d10a9$export$a963beab80ebdc85 = "ui/setDatepickerVisible";
const $f7cf41d7a90d10a9$export$bf68182595086291 = "ui/setDraggedElement";
const $f7cf41d7a90d10a9$export$86b8f793c78905c = "ui/setNotebookFocused";
const $f7cf41d7a90d10a9$export$cb20c9d4e317211a = "ui/setSideMenuBehavior";
const $f7cf41d7a90d10a9$export$f75562dab83118a8 = "ui/setSideMenuButtonVisibleOutside";
const $f7cf41d7a90d10a9$export$636fee1a445976fd = "ui/setViewsDisplayType";
const $f7cf41d7a90d10a9$export$d16b5e15901855a6 = "ui/setWindowFocused";
const $f7cf41d7a90d10a9$export$15779acd87b94b6a = "ui/showCommandMenu";
const $f7cf41d7a90d10a9$export$82e707280f851b4 = "ui/showEngageMenu";
const $f7cf41d7a90d10a9$export$a9c2c9cc69b6b7fc = "ui/showModal";
const $f7cf41d7a90d10a9$export$f56a0262c0f96cc3 = "ui/showSideMenu";
const $f7cf41d7a90d10a9$export$92a0513de1069908 = "ui/updateModal";
const $f7cf41d7a90d10a9$export$a0f5914cb9d5bfd9 = "ui/setShowNavMenu";
function $f7cf41d7a90d10a9$export$a9548c5c4bfe5e1b() {
    return {
        type: $f7cf41d7a90d10a9$export$8fd4b4b20b2a10d8
    };
}
function $f7cf41d7a90d10a9$export$bc715ad2dd70c26e() {
    return {
        type: $f7cf41d7a90d10a9$export$a50d3ec4bddc9c0e
    };
}
function $f7cf41d7a90d10a9$export$3a398bb9c369059a() {
    return {
        type: $f7cf41d7a90d10a9$export$49276ccd2ea96fdb
    };
}
function $f7cf41d7a90d10a9$export$f3481a172e9a9849(tooltip) {
    return {
        type: $f7cf41d7a90d10a9$export$1aed166826ca2834,
        payload: tooltip
    };
}
function $f7cf41d7a90d10a9$export$8064e326d2d51488() {
    return {
        type: $f7cf41d7a90d10a9$export$a963beab80ebdc85
    };
}
function $f7cf41d7a90d10a9$export$cc4f9a9838dfc683(element) {
    return {
        type: $f7cf41d7a90d10a9$export$bf68182595086291,
        payload: element
    };
}
function $f7cf41d7a90d10a9$export$1afeff25bbe845ee(isNotebookFocused) {
    return {
        type: $f7cf41d7a90d10a9$export$86b8f793c78905c,
        payload: isNotebookFocused
    };
}
function $f7cf41d7a90d10a9$export$ee03bf7a7aa5d5f9(visibleOutside) {
    return {
        type: $f7cf41d7a90d10a9$export$f75562dab83118a8,
        payload: visibleOutside
    };
}
function $f7cf41d7a90d10a9$export$6d3112daa1131ce5(isWindowFocused) {
    return {
        type: $f7cf41d7a90d10a9$export$d16b5e15901855a6,
        payload: isWindowFocused
    };
}
function $f7cf41d7a90d10a9$export$f7f4867d6f1da8f0() {
    return {
        type: $f7cf41d7a90d10a9$export$82e707280f851b4
    };
}
function $f7cf41d7a90d10a9$export$28059cffc1bedb37() {
    return {
        type: $f7cf41d7a90d10a9$export$f56a0262c0f96cc3
    };
}
function $f7cf41d7a90d10a9$export$564ba700ce02cb93(key, modal) {
    return {
        type: $f7cf41d7a90d10a9$export$92a0513de1069908,
        payload: {
            key: key,
            modal: modal
        }
    };
}
function $f7cf41d7a90d10a9$export$ec1cdefe2f176838(show) {
    return {
        type: $f7cf41d7a90d10a9$export$a0f5914cb9d5bfd9,
        payload: show
    };
}






function $8a3eec2fc27aa664$var$createInitialState() {
    return {
        activeContextMenu: null,
        activeTooltip: null,
        commandMenuIsOpen: false,
        dragAndDrop: {
            draggedElement: null
        },
        engageMenuIsOpen: false,
        insideAM: (0, $ecfe56675d6ea75b$export$4ceee2fd99b5f7a2)() !== "",
        isDatePickerOpen: false,
        isNotebookFocused: false,
        isWindowFocused: true,
        modals: new Map(),
        navMenuIsOpen: false,
        sideMenuBehavior: "overlay",
        sideMenuButtonVisibleOutside: false,
        sideMenuIsOpen: undefined,
        viewsDisplayType: "grid"
    };
}
function $8a3eec2fc27aa664$export$95881ffef5b0c248(rootState, action) {
    const state = rootState?.ui ?? $8a3eec2fc27aa664$var$createInitialState();
    switch(action.type){
        case 0, $f7cf41d7a90d10a9$export$c9796fac990bf36:
            return {
                ...state,
                activeContextMenu: null
            };
        case 0, $f7cf41d7a90d10a9$export$8fd4b4b20b2a10d8:
            return {
                ...state,
                activeTooltip: null
            };
        case 0, $f7cf41d7a90d10a9$export$13c0f6bde07cf138:
            return {
                ...state,
                commandMenuIsOpen: false
            };
        case 0, $f7cf41d7a90d10a9$export$a50d3ec4bddc9c0e:
            return {
                ...state,
                engageMenuIsOpen: false
            };
        case 0, $f7cf41d7a90d10a9$export$974831f076c2c3e4:
            return $8a3eec2fc27aa664$var$handleHideModal(rootState, state, action);
        case 0, $f7cf41d7a90d10a9$export$49276ccd2ea96fdb:
            return {
                ...state,
                sideMenuIsOpen: false
            };
        case 0, $f7cf41d7a90d10a9$export$2a24c652e09185d3:
            return {
                ...state,
                activeContextMenu: action.payload
            };
        case 0, $f7cf41d7a90d10a9$export$1aed166826ca2834:
            {
                const { anchor: anchor, content: content, options: options } = action.payload;
                return {
                    ...state,
                    activeTooltip: {
                        anchor: ()=>anchor,
                        content: ()=>content,
                        options: options
                    }
                };
            }
        case 0, $f7cf41d7a90d10a9$export$a963beab80ebdc85:
            return {
                ...state,
                isDatePickerOpen: !state.isDatePickerOpen
            };
        case 0, $f7cf41d7a90d10a9$export$bf68182595086291:
            return {
                ...state,
                dragAndDrop: {
                    draggedElement: action.payload
                }
            };
        case 0, $f7cf41d7a90d10a9$export$86b8f793c78905c:
            return {
                ...state,
                isNotebookFocused: action.payload
            };
        case 0, $f7cf41d7a90d10a9$export$cb20c9d4e317211a:
            return {
                ...state,
                sideMenuBehavior: action.payload
            };
        case 0, $f7cf41d7a90d10a9$export$f75562dab83118a8:
            return {
                ...state,
                sideMenuButtonVisibleOutside: action.payload
            };
        case 0, $f7cf41d7a90d10a9$export$636fee1a445976fd:
            return {
                ...state,
                viewsDisplayType: action.payload
            };
        case 0, $f7cf41d7a90d10a9$export$d16b5e15901855a6:
            return {
                ...state,
                isWindowFocused: action.payload
            };
        case 0, $f7cf41d7a90d10a9$export$15779acd87b94b6a:
            return {
                ...state,
                commandMenuIsOpen: true
            };
        case 0, $f7cf41d7a90d10a9$export$82e707280f851b4:
            return {
                ...state,
                engageMenuIsOpen: true
            };
        case 0, $f7cf41d7a90d10a9$export$a9c2c9cc69b6b7fc:
            return $8a3eec2fc27aa664$var$handleShowModal(state, action);
        case 0, $f7cf41d7a90d10a9$export$f56a0262c0f96cc3:
            return {
                ...state,
                sideMenuIsOpen: true
            };
        case 0, $f7cf41d7a90d10a9$export$92a0513de1069908:
            return $8a3eec2fc27aa664$var$handleUpdateModal(state, action);
        case 0, $f7cf41d7a90d10a9$export$a0f5914cb9d5bfd9:
            return {
                ...state,
                navMenuIsOpen: action.payload
            };
        default:
            return state;
    }
}
function $8a3eec2fc27aa664$var$handleHideModal(rootState, state, action) {
    const modals = new Map(state.modals);
    modals.delete(action.payload.key);
    return {
        ...state,
        modals: modals
    };
}
function $8a3eec2fc27aa664$var$handleShowModal(state, action) {
    const { key: key, modal: modal } = action.payload;
    // Any modal that gets opened should implicitly remove the focus from the
    // notebook, otherwise you could continue typing underneath the modal.
    const isNotebookFocused = false;
    const modals = state.modals.has(key) ? state.modals : new Map(state.modals).set(key, modal);
    return {
        ...state,
        isNotebookFocused: isNotebookFocused,
        modals: modals
    };
}
function $8a3eec2fc27aa664$var$handleUpdateModal(state, action) {
    const { key: key, modal: modal } = action.payload;
    if (!state.modals.has(key)) // eslint-disable-next-line no-console
    console.warn("Attempting to update a modal that doesn't exist!");
    const modals = new Map(state.modals).set(key, modal);
    return {
        ...state,
        modals: modals
    };
}


function $8f4cee706116b0d2$export$a8a69c316169e623(state, action) {
    const newState = {
        [(0, $5755db105caee352$export$bcc8035e549759b4).reducerPath]: (0, $5755db105caee352$export$bcc8035e549759b4).reducer(state?.[(0, $5755db105caee352$export$bcc8035e549759b4).reducerPath], action),
        [(0, $fe24d45de7923f97$export$db2da65404f64f92).reducerPath]: (0, $fe24d45de7923f97$export$db2da65404f64f92).reducer(state?.[(0, $fe24d45de7923f97$export$db2da65404f64f92).reducerPath], action),
        askAutometrics: (0, $c96f342fb290ed4c$export$afb9eb0000d920bf).reducer(state?.askAutometrics, action),
        environment: (0, $ecfe56675d6ea75b$export$1d2b60fd9b3f5f3a).reducer(state?.environment, action),
        router: (0, $c9a28024b3e23cac$export$a6e30f0f4d30936a)(state?.router, action),
        ui: (0, $8a3eec2fc27aa664$export$95881ffef5b0c248)(state, action)
    };
    return state && (0, $adc60b347c86dc3c$export$2e2bcd8739ae039)(state, newState) ? state : newState;
}









const $162ecfa8ddc7a9ff$export$f51d452c10d5b956 = (0, $b1ddf03ae6418ae8$export$8ad76b76a4c905f8);
const $162ecfa8ddc7a9ff$export$a7347740d65f620b = (0, $1a280fbaa3fcabb5$export$2105062e25df4afe);


// Change `trace` to `true` to enable action specific stack traces on the Redux Dev Tools
const $c41f178228bd3003$var$trace = false;
const $c41f178228bd3003$var$traceLimit = 25;
// Allow ES6 `Map` and `Set` types to be used in our store:
(0, $jewWr.enableMapSet)();
const $c41f178228bd3003$var$isProduction = true;
const $c41f178228bd3003$var$composeEnhancers = // @ts-ignore
typeof window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === "function" && !$c41f178228bd3003$var$isProduction && // @ts-ignore
window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    trace: $c41f178228bd3003$var$trace,
    traceLimit: $c41f178228bd3003$var$traceLimit,
    serialize: {
        options: {
            map: true,
            undefined: true
        },
        replacer: (key, value)=>{
            // We permit storing mutable values in our UI slice, which includes
            // DOM nodes in some cases. DOM nodes make the Redux DevTools horribly
            // slow however, so we replace them with a constant string here...
            if (value instanceof HTMLElement) return "(HTML element)";
            if (value instanceof Function) return value.toString();
            return value;
        }
    }
}) || (0, $kHUM6.compose);
const $c41f178228bd3003$var$store = (0, $kHUM6.createStore)((0, $8f4cee706116b0d2$export$a8a69c316169e623), $c41f178228bd3003$var$composeEnhancers((0, $kHUM6.applyMiddleware)((0, $c9a28024b3e23cac$export$8014fb44192d8f33), (0, $9QQqP.default), (0, $5755db105caee352$export$bcc8035e549759b4).middleware, // HACK - I don't know why Typescript gets mad here, and I just wanna push this hotfix
// @ts-ignore
(0, $fe24d45de7923f97$export$db2da65404f64f92).middleware)));
// Required for refetchOnFocus / refetchOnReconnect behaviors
(0, $54649b17feedf59f$export$120c0dbb0351414c)($c41f178228bd3003$var$store.dispatch);
var $c41f178228bd3003$export$2e2bcd8739ae039 = $c41f178228bd3003$var$store;
const $c41f178228bd3003$export$635e15bbd66f01ea = $c41f178228bd3003$var$store.dispatch;
const $c41f178228bd3003$export$50fdfeece43146fd = $c41f178228bd3003$var$store.getState;
const $c41f178228bd3003$export$55abd4691b317664 = (0, $c9a28024b3e23cac$export$5d2a7366f73d240c)($c41f178228bd3003$var$store);



function $b289d9cb7ca375da$export$e4ba1b9b774550b4() {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($b289d9cb7ca375da$var$NoDataContainer, {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0a830394bc38e4e3$export$f04a61298a47a40f), {
                type: "autometrics",
                width: 32,
                height: 32
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($b289d9cb7ca375da$var$NoDataTitle, {
                children: "No data for this graph"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($b289d9cb7ca375da$var$NoDataDescription, {
                children: "There is no data for your selected time range. Edit the time range or wait for Prometheus to collect more data."
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a921dfdbd8dd60fa$export$353f5b6fc5456de1), {
                onClick: ()=>(0, $c41f178228bd3003$export$635e15bbd66f01ea)((0, $f7cf41d7a90d10a9$export$8064e326d2d51488)()),
                children: "Edit time range"
            })
        ]
    });
}
const $b289d9cb7ca375da$var$NoDataContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  backdrop-filter: blur(4px);
  position: absolute;
  inset: 0;
  padding-top: 5%;
  display: flex;
  flex-direction: column;
  place-items: center;
`;
const $b289d9cb7ca375da$var$NoDataTitle = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).h4`
  margin: 16px 0 8px;
  font-style: italic;
`;
const $b289d9cb7ca375da$var$NoDataDescription = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).p(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    color: ${theme.color.fg.muted};
    max-width: 320px;
    margin: 0 20px 20px;
  `);





var $2gcPZ = parcelRequire("2gcPZ");

parcelRequire("2gcPZ");
const $1aadff28a0ac620f$var$SvgArrow = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        width: 13,
        height: 12,
        viewBox: "0 0 13 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M6.5 0 13 11.258H0L6.5 0Z",
            fill: "currentColor"
        })
    });
var $1aadff28a0ac620f$export$2e2bcd8739ae039 = $1aadff28a0ac620f$var$SvgArrow;



function $26aff4842955852f$export$28c660c63b792dea({ tip: tip }) {
    const { anchor: anchor, content: content, options: options } = tip;
    const { placement: placement = "bottom" } = options;
    const children = content();
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $87fe9d22a5eec31a$export$fd7a256405e9ea77), {
        element: anchor(),
        placement: placement,
        withArrow: true,
        offset: [
            0,
            12
        ],
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($26aff4842955852f$var$TooltipContent, {
            children: children
        })
    });
}
/**
 * The real content of a tooltip. Declared separately because we
 * need to use the ArrowContext
 */ function $26aff4842955852f$var$TooltipContent({ children: children }) {
    const { style: arrowStyle, setRef: setRef } = (0, $2gcPZ.useContext)((0, $87fe9d22a5eec31a$export$8ee68538b664d6db));
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($26aff4842955852f$var$StyledToolTip, {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($26aff4842955852f$var$ArrowContainer, {
                style: arrowStyle,
                ref: setRef,
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($26aff4842955852f$var$StyledArrow, {})
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($26aff4842955852f$var$StyledContent, {
                children: children
            })
        ]
    });
}
const $26aff4842955852f$var$StyledToolTip = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  flex-grow: 0;
  border-radius: 0;
  padding: 0;
  max-width: min(600px, 90vw);
`;
const $26aff4842955852f$var$StyledContent = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    display: flex;
    flex-direction: row;
    position: relative;
    gap: 8px;
    justify-content: center;
    align-items: center;
    flex-grow: 0;
    border-radius: ${theme.radius.default};
    padding: 8px 14px;
    box-shadow: ${theme.effect.shadow.m};
    background: ${theme.color.bg.emphasis.default};
    color: ${theme.color.fg.onemphasis.default};
    font: ${theme.font.body.md.medium};
    width: max-content;
  `);
const $26aff4842955852f$var$ArrowContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  position: absolute;
  z-index: 1;

  [data-popper-placement^="top"] & {
    bottom: -12px;
  }

  [data-popper-placement^="right"] & {
    left: -12px;
  }

  [data-popper-placement^="bottom"] & {
    top: -12px;
  }

  [data-popper-placement^="left"] & {
    right: -12px;
  }
`;
const $26aff4842955852f$var$StyledArrow = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $1aadff28a0ac620f$export$2e2bcd8739ae039))`
  color: ${({ theme: theme })=>theme.color.bg.emphasis.default};
  overflow: hidden;

  [data-popper-placement^="top"] & {
    transform: rotate(180deg);
  }

  [data-popper-placement^="right"] & {
    transform: rotate(-90deg);
  }

  [data-popper-placement^="left"] & {
    transform: rotate(90deg);
  }
`;



var $2gcPZ = parcelRequire("2gcPZ");

// NOTE - if you need thunks, add them here


let $6287c72d1ca35f8e$var$hideTooltipTimeout = null;
const $6287c72d1ca35f8e$export$add63f471a2df484 = (key, modalProps)=>(dispatch)=>{
        const onRequestClose = ()=>{
            dispatch($6287c72d1ca35f8e$export$a05fcf779b804fb6(key));
        };
        const modal = {
            ...modalProps,
            type: "confirmationDialog"
        };
        dispatch({
            type: (0, $f7cf41d7a90d10a9$export$a9c2c9cc69b6b7fc),
            payload: {
                key: key,
                modal: {
                    onRequestClose: onRequestClose,
                    modal: modal
                }
            }
        });
    };
const $6287c72d1ca35f8e$export$a05fcf779b804fb6 = (key)=>(dispatch)=>{
        dispatch({
            type: (0, $f7cf41d7a90d10a9$export$974831f076c2c3e4),
            payload: {
                key: key
            }
        });
    };
const $6287c72d1ca35f8e$export$dba11b50e1aa3c12 = (anchor, content, options = {})=>(dispatch, getState)=>{
        if ($6287c72d1ca35f8e$var$hideTooltipTimeout != null) {
            clearTimeout($6287c72d1ca35f8e$var$hideTooltipTimeout);
            $6287c72d1ca35f8e$var$hideTooltipTimeout = null;
        }
        const currentAnchor = (0, $2170e4260f2ec713$export$f46e8f1c5be206fd)(getState())?.anchor();
        if (anchor !== currentAnchor) dispatch((0, $f7cf41d7a90d10a9$export$f3481a172e9a9849)({
            anchor: anchor,
            content: content,
            options: options
        }));
        return ()=>dispatch((0, $f7cf41d7a90d10a9$export$a9548c5c4bfe5e1b)());
    };
const $6287c72d1ca35f8e$export$ed5fcb7096e0b8a4 = (timeout)=>(dispatch)=>{
        if ($6287c72d1ca35f8e$var$hideTooltipTimeout != null) clearTimeout($6287c72d1ca35f8e$var$hideTooltipTimeout);
        $6287c72d1ca35f8e$var$hideTooltipTimeout = setTimeout(()=>{
            $6287c72d1ca35f8e$var$hideTooltipTimeout = null;
            dispatch((0, $f7cf41d7a90d10a9$export$a9548c5c4bfe5e1b)());
        }, timeout);
    };



const $4beae11c8214cfec$var$REMOTE_HOST = "https://xlkarzuhgbiwmmvkjnwa.supabase.co";
const $4beae11c8214cfec$export$3b3a9a3ad9f17c98 = (prompt)=>(dispatch, getState)=>{
        const { askAutometrics: askAutometrics } = getState();
        const id = askAutometrics.ids.length.toString();
        setTimeout(()=>{
            dispatch((0, $c96f342fb290ed4c$export$295a1b2aa4d86817)(true));
        }, 0);
        dispatch((0, $c96f342fb290ed4c$export$e16d8520af44a096)({
            id: id,
            prompt: prompt
        }));
        const query = new URLSearchParams({
            query: prompt
        });
        const projectUrl = `${$4beae11c8214cfec$var$REMOTE_HOST}/functions/v1/vector-search`;
        const queryURL = `${projectUrl}?${query}`;
        const eventSource = new EventSource(queryURL);
        eventSource.addEventListener("error", async ()=>{
            eventSource.close();
            dispatch((0, $c96f342fb290ed4c$export$37bfc436a1b38646)(id));
            for (const text of $4beae11c8214cfec$var$chunkSubstr("Rate limit has been exceeded. Please try again in a bit.", 4)){
                dispatch((0, $c96f342fb290ed4c$export$c2ef99b1ba0e664b)({
                    id: id,
                    text: text
                }));
                await $4beae11c8214cfec$var$awaitableTimeout(50);
            }
        });
        eventSource.addEventListener("message", (message)=>{
            if (message.data === "[DONE]") {
                eventSource.close();
                return;
            }
            const completionResponse = JSON.parse(message.data);
            const text = completionResponse.choices[0]?.text ?? "";
            dispatch((0, $c96f342fb290ed4c$export$c2ef99b1ba0e664b)({
                id: id,
                text: text
            }));
        });
    };
function $4beae11c8214cfec$var$chunkSubstr(input, size) {
    const numChunks = Math.ceil(input.length / size);
    const chunks = Array.from({
        length: numChunks
    });
    for(let i = 0, o = 0; i < numChunks; i++, o += size)chunks[i] = input.slice(o, o + size);
    return chunks;
}
function $4beae11c8214cfec$var$awaitableTimeout(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}




function $6863bac21e813f6e$export$47da2dfd093ff7d1() {
    (0, $2gcPZ.useEffect)(()=>{
        document.body.addEventListener("mouseover", $6863bac21e813f6e$var$onMouseOver);
        return ()=>document.body.removeEventListener("mouseover", $6863bac21e813f6e$var$onMouseOver);
    }, []);
}
function $6863bac21e813f6e$var$onMouseOver({ target: target }) {
    const isIconSVG = target instanceof SVGElement && target.nodeName === "svg";
    const isMatchableElement = target instanceof HTMLElement || isIconSVG;
    const match = isMatchableElement && target.closest(`[aria-label]:not([aria-pressed="true"]):not(.active):not([data-no-tooltip]),
          [data-shortcut]:not([aria-pressed="true"]):not(.active)`);
    if (!match) return;
    const text = match.getAttribute("aria-label") || "";
    const content = text;
    (0, $c41f178228bd3003$export$635e15bbd66f01ea)((0, $6287c72d1ca35f8e$export$dba11b50e1aa3c12)(match, content, {
        placement: $6863bac21e813f6e$var$getPlacement(match.dataset.tooltipPlacement ?? null)
    }));
}
function $6863bac21e813f6e$var$getPlacement(placement) {
    switch(placement){
        case "top":
        case "right":
        case "bottom":
        case "left":
            return placement;
    }
}




var $2gcPZ = parcelRequire("2gcPZ");








var $fuyzp = parcelRequire("fuyzp");

var $2gcPZ = parcelRequire("2gcPZ");
function $547dabb67e630363$export$7b36b8f925ab7497({ children: children }) {
    const [element] = (0, $2gcPZ.useState)($547dabb67e630363$var$createElement);
    (0, $2gcPZ.useEffect)(()=>{
        return ()=>element.remove();
    }, [
        element
    ]);
    return /*#__PURE__*/ (0, $fuyzp.createPortal)(children, element);
}
function $547dabb67e630363$var$createElement() {
    const element = document.createElement("div");
    element.dataset.tooltipContainer = "";
    element.style.pointerEvents = "none";
    // HACK - give this a z-index greater than the modal overlay so we can show tooltips in modals
    element.style.position = "relative";
    element.style.zIndex = "10000";
    document.body.append(element);
    return element;
}


function $78110f9f0727b51a$export$44ec04c6081e3a25({ tip: tip }) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $547dabb67e630363$export$7b36b8f925ab7497), {
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $d3a9d83062c98169$export$3ae376d12526dd6f), {
            children: tip && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $26aff4842955852f$export$28c660c63b792dea), {
                tip: tip
            })
        })
    });
}


function $4a9d80e15a452f2e$export$eef8a221e93f06b0() {
    const tip = (0, $1a280fbaa3fcabb5$export$2105062e25df4afe)((0, $2170e4260f2ec713$export$f46e8f1c5be206fd));
    (0, $2gcPZ.useEffect)(()=>{
        if (tip) {
            document.body.addEventListener("mouseout", $4a9d80e15a452f2e$var$mouseOut);
            document.body.addEventListener("click", $4a9d80e15a452f2e$var$blur);
            document.body.addEventListener("mousedown", $4a9d80e15a452f2e$var$blur);
            return ()=>{
                document.body.removeEventListener("mouseout", $4a9d80e15a452f2e$var$mouseOut);
                document.body.removeEventListener("click", $4a9d80e15a452f2e$var$blur);
                document.body.removeEventListener("mousedown", $4a9d80e15a452f2e$var$blur);
            };
        }
    }, [
        tip
    ]);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $78110f9f0727b51a$export$44ec04c6081e3a25), {
        tip: tip
    });
}
function $4a9d80e15a452f2e$var$blur({ target: target }) {
    if (!target.closest("[data-tooltip-container]")) (0, $c41f178228bd3003$export$635e15bbd66f01ea)((0, $6287c72d1ca35f8e$export$ed5fcb7096e0b8a4)(0));
}
function $4a9d80e15a452f2e$var$mouseOut(event) {
    const { relatedTarget: relatedTarget } = event;
    const isElement = relatedTarget instanceof Element;
    const isTooltipElement = isElement && relatedTarget.hasAttribute("aria-label") || relatedTarget instanceof HTMLElement && relatedTarget.dataset["shortcut"];
    if (relatedTarget instanceof Node === false || isTooltipElement || isElement && relatedTarget.closest("[aria-label],[data-shortcut]") !== null) return;
    return (0, $c41f178228bd3003$export$635e15bbd66f01ea)((0, $6287c72d1ca35f8e$export$ed5fcb7096e0b8a4)(400));
}






function $7d293902c76b0d5e$export$6890034ddb70b59b({ labels: labels }) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("tbody", {
        children: Object.entries(labels).map(([key, value])=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("tr", {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($7d293902c76b0d5e$var$LabelTd, {
                        children: [
                            key,
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($7d293902c76b0d5e$var$LabelTd, {
                        children: value
                    })
                ]
            }, key))
    });
}
const $7d293902c76b0d5e$var$LabelTd = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).td`
  word-wrap: anywhere;
`;



const $f1fe2006172a4e94$export$a134bd96afae8c80 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).caption`
  font-weight: bold;
  text-align: left;
  color: ${({ theme: theme })=>theme.color.fg.onemphasis.subtle};
`;


function $905ee6c2eecf18ca$export$f3d19dae01cee316({ event: event }) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("table", {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $f1fe2006172a4e94$export$a134bd96afae8c80), {
                children: [
                    event.title,
                    " @ ",
                    event.time
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $7d293902c76b0d5e$export$6890034ddb70b59b), {
                labels: event.labels
            })
        ]
    });
}





function $d0b2655bd72fd034$export$3978dee83c4fe6bf({ timeseries: timeseries, metric: metric }) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("table", {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $f1fe2006172a4e94$export$a134bd96afae8c80), {
                children: metric.time
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("thead", {
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("th", {
                            children: timeseries.name || "value"
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("th", {
                            children: metric.value
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $7d293902c76b0d5e$export$6890034ddb70b59b), {
                labels: timeseries.labels
            })
        ]
    });
}


function $b7b57423e9554b4f$export$1190a21963505760(props) {
    const [series, point] = props.content;
    if (series.type === "target_latency") return null;
    return series.type === "events" ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $905ee6c2eecf18ca$export$f3d19dae01cee316), {
        event: point
    }) : /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $d0b2655bd72fd034$export$3978dee83c4fe6bf), {
        timeseries: series,
        metric: point
    });
}






var $2gcPZ = parcelRequire("2gcPZ");




const $df0358d28239ecdc$export$4cf474b72a9918be = ()=>{
    const { currentTheme: currentTheme } = (0, $bbc2cb4268a46f72$export$bace31607121468e)();
    const isDarkTheme = currentTheme === "dark";
    const containerRef = (0, $2gcPZ.useRef)(null);
    const { opened: opened, setOpened: setOpened, modalRef: modalRef } = (0, $0adc49931d9164a4$export$80138646353f34b1)(containerRef);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $afa7be861492543f$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($df0358d28239ecdc$var$GraphHelperIconContainer, {
                $open: opened,
                ref: containerRef,
                onMouseDown: (event)=>{
                    // HACK - this is a workaround to accommodate behavior of `useOpen`
                    event.stopPropagation();
                },
                onClick: ()=>{
                    setOpened((currentOpened)=>!currentOpened);
                },
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($df0358d28239ecdc$var$GraphHelperIcon, {})
            }),
            opened && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $87fe9d22a5eec31a$export$fd7a256405e9ea77), {
                element: containerRef.current,
                placement: "top-end",
                offset: [
                    0,
                    8
                ],
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($df0358d28239ecdc$var$KeyboardShortcutsContainer, {
                    ref: modalRef,
                    $dark: isDarkTheme,
                    children: [
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($df0358d28239ecdc$var$KeyboardShortcutTitle, {
                            children: "Keyboard shortcuts"
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($df0358d28239ecdc$var$KeyboardShortcuts, {
                            children: [
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($df0358d28239ecdc$var$KeyboardShortcut, {
                                    children: [
                                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($df0358d28239ecdc$var$KeyboardShortcutDescription, {
                                            children: "Drag time range"
                                        }),
                                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($df0358d28239ecdc$var$KeyboardShortcutKeys, {
                                            children: [
                                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($df0358d28239ecdc$var$KeyboardShortcutKey, {
                                                    children: "shift"
                                                }),
                                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($df0358d28239ecdc$var$KeyboardShortcutKey, {
                                                    children: "drag"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($df0358d28239ecdc$var$KeyboardShortcut, {
                                    children: [
                                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($df0358d28239ecdc$var$KeyboardShortcutDescription, {
                                            children: "Zoom in"
                                        }),
                                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($df0358d28239ecdc$var$KeyboardShortcutKeys, {
                                            children: [
                                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($df0358d28239ecdc$var$KeyboardShortcutKey, {
                                                    children: (0, $6babf196a55ab307$export$9ac100e40613ea10) ? "cmd" : "ctrl"
                                                }),
                                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($df0358d28239ecdc$var$KeyboardShortcutKey, {
                                                    children: "drag"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($df0358d28239ecdc$var$KeyboardShortcut, {
                                    children: [
                                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($df0358d28239ecdc$var$KeyboardShortcutDescription, {
                                            children: "Zoom out"
                                        }),
                                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($df0358d28239ecdc$var$KeyboardShortcutKeys, {
                                            children: [
                                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($df0358d28239ecdc$var$KeyboardShortcutKey, {
                                                    children: (0, $6babf196a55ab307$export$9ac100e40613ea10) ? "cmd" : "ctrl"
                                                }),
                                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($df0358d28239ecdc$var$KeyboardShortcutKey, {
                                                    children: "scroll"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
const $df0358d28239ecdc$var$KeyboardShortcutsContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ $dark: $dark, theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    border-radius: ${theme.radius.minimal};
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 16px;
    background-color: ${theme.color.bg.default};
    width: 300px;

    box-shadow: 0 4px 25px 0
      ${$dark ? "rgba(255, 255, 255, 0.2)" : "rgba(0, 0, 0, 0.25)"};
  `);
const $df0358d28239ecdc$var$KeyboardShortcutTitle = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).h5`
  color: ${({ theme: theme })=>theme.color.fg.default};
  margin: 0;
  height: 30px;
  display: flex;
  align-items: center;
`;
const $df0358d28239ecdc$var$KeyboardShortcuts = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;
const $df0358d28239ecdc$var$KeyboardShortcut = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
`;
const $df0358d28239ecdc$var$KeyboardShortcutDescription = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).p`
  display: flex;
  align-items: center;
  color: ${({ theme: theme })=>theme.color.fg.default};
`;
const $df0358d28239ecdc$var$KeyboardShortcutKeys = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 8px;
  margin-left: auto;
`;
const $df0358d28239ecdc$var$KeyboardShortcutKey = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).span(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    display: inline-flex;
    width: 46px;
    padding: 5px 10px;
    justify-content: center;
    align-items: center;
    gap: 10px;

    border-radius: ${theme.radius.default};
    background: ${theme.color.bg.hover};
    color: ${theme.color.fg.default};
    font: ${theme.font.body.sm.medium};
  `);
const $df0358d28239ecdc$var$GraphHelperIconContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ $open: $open, theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    cursor: pointer;
    margin-top: 20px;
    margin-left: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: ${theme.radius.rounded};
    border: 1px solid
      ${$open ? theme.color.border.primary : theme.color.button.secondary.border};
    background-color: ${theme.color.button.secondary.bg};

    ${$open && (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      box-shadow: 0px 0px 0px 4px rgba(165, 80, 255, 0.2);
    `}
  `);
const $df0358d28239ecdc$var$GraphHelperIcon = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $0a830394bc38e4e3$export$f04a61298a47a40f)).attrs({
    type: "keyboard_duotone"
})`
  width: 20px;
  height: 20px;
`;






const $bf9cd47341cbb418$export$614db49f3febe941 = (props)=>{
    const { color: color, currentMetric: currentMetric, currentMetricData: currentMetricData, metricType: metricType, onChangeTimeRange: onChangeTimeRange, events: events, timeRange: timeRange } = props;
    const graphTheme = (0, $583285e3aa4c16bf$export$5cc0dd04debd4b19)(color);
    const [tooltipState, setTooltipState] = (0, $2gcPZ.useState)(null);
    const { hideableMetricData: hideableMetricData, toggleSeriesMatchingLabel: toggleSeriesMatchingLabel } = $bf9cd47341cbb418$var$useHideableMetricData(currentMetricData);
    const hasMultipleMetrics = currentMetricData?.length > 1;
    const tickFormattersFactory = (0, $2gcPZ.useMemo)(()=>(xAxis, yAxis)=>({
                xFormatter: (0, $97bfc4b4004b00d4$export$22e93c2cab313942)(xAxis),
                yFormatter: metricType === "latency" ? (0, $97bfc4b4004b00d4$export$7f424ebfd113e8ae)(yAxis) : metricType === "errorRatio" ? (0, $97bfc4b4004b00d4$export$f4ad2fa17edf39d7)() : (0, $97bfc4b4004b00d4$export$9bc9750a5e6705d)(yAxis)
            }), [
        metricType
    ]);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $2042716e2270aa85$export$ef2184bd89960b14), {
        children: [
            currentMetricData && currentMetricData.length > 0 && // grid-area: "metrics"
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $2042716e2270aa85$export$2e0db495abdb18ec), {
                children: currentMetric.metrics?.map(({ reportType: reportType, value: value, unit: unit })=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $2042716e2270aa85$export$73722bc4ca9ba271), {
                        rate: value,
                        unit: unit,
                        report: reportType
                    }, reportType))
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $2042716e2270aa85$export$c4a562231524e009), {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $97bfc4b4004b00d4$export$f4cb11be864d0ce5), {
                        chartTheme: graphTheme,
                        graphType: "line",
                        stackingType: "none",
                        timeRange: timeRange,
                        timeseriesData: hideableMetricData ?? [],
                        onChangeTimeRange: (newTimeRange)=>{
                            onChangeTimeRange(newTimeRange);
                        },
                        footerShown: false,
                        showTooltip: (anchor, [series, point])=>{
                            if (point) setTooltipState({
                                anchor: ()=>anchor,
                                content: ()=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $b7b57423e9554b4f$export$1190a21963505760), {
                                        content: [
                                            series,
                                            point
                                        ]
                                    }),
                                options: {
                                    placement: "top"
                                }
                            });
                            return ()=>setTooltipState(null);
                        },
                        events: events,
                        onToggleTimeseriesVisibility: (metric)=>{
                            toggleSeriesMatchingLabel({
                                function: metric?.timeseries?.labels?.function ?? "",
                                module: metric?.timeseries?.labels?.module ?? "",
                                percentile_latency: metric?.timeseries?.labels?.percentile_latency ?? "",
                                version: metric?.timeseries?.labels?.version ?? "",
                                commit: metric?.timeseries?.labels?.commit ?? "",
                                service_name: metric?.timeseries?.labels?.service_name ?? ""
                            });
                        },
                        legendShown: hasMultipleMetrics,
                        tickFormatters: tickFormattersFactory,
                        shouldAnimateYScale: false
                    }),
                    !currentMetricData || currentMetricData.length === 0 && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $b289d9cb7ca375da$export$e4ba1b9b774550b4), {}),
                    currentMetricData && currentMetricData.length > 0 && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $df0358d28239ecdc$export$4cf474b72a9918be), {})
                ]
            }),
            tooltipState && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $26aff4842955852f$export$28c660c63b792dea), {
                tip: tooltipState
            })
        ]
    });
};
function $bf9cd47341cbb418$var$useHideableMetricData(currentMetricData) {
    const [hiddenLabels, setHiddenLabels] = (0, $2gcPZ.useState)([]);
    const hideableMetricData = (0, $2gcPZ.useMemo)(()=>{
        return currentMetricData?.map((metric)=>{
            const isHidden = hiddenLabels.some((label)=>{
                return metric?.labels?.function === label.function && metric?.labels?.module === label.module && (metric?.labels?.percentile_latency ?? "") === label.percentile_latency && (metric?.labels?.version ?? "") === label.version && (metric?.labels?.commit ?? "") === label.commit && (metric?.labels?.service_name ?? "") === label.service_name;
            });
            return {
                ...metric,
                visible: !isHidden
            };
        });
    }, [
        hiddenLabels,
        currentMetricData
    ]);
    const toggleSeriesMatchingLabel = (timeseriesLabels)=>{
        setHiddenLabels((prevHiddenLabels)=>{
            const isHidden = prevHiddenLabels.some((label)=>label.function === timeseriesLabels?.function && label.module === timeseriesLabels?.module && label.percentile_latency === timeseriesLabels?.percentile_latency && label.version === timeseriesLabels?.version && label.commit === timeseriesLabels?.commit && label.service_name === timeseriesLabels?.service_name);
            return isHidden ? prevHiddenLabels.filter((label)=>{
                return label.function !== timeseriesLabels?.function && label.module !== timeseriesLabels?.module && label.percentile_latency !== timeseriesLabels?.percentile_latency && label.version !== timeseriesLabels?.version && label.commit !== timeseriesLabels?.commit && label.service_name !== timeseriesLabels?.service_name;
            }) : [
                ...prevHiddenLabels,
                {
                    function: timeseriesLabels?.function,
                    module: timeseriesLabels?.module,
                    percentile_latency: timeseriesLabels?.percentile_latency,
                    version: timeseriesLabels?.version,
                    commit: timeseriesLabels?.commit,
                    service_name: timeseriesLabels?.service_name
                }
            ];
        });
    };
    return {
        hideableMetricData: hideableMetricData,
        toggleSeriesMatchingLabel: toggleSeriesMatchingLabel
    };
}






var $9bcc877a156e04f6$exports = {};
/* **********************************************
     Begin prism-core.js
********************************************** */ /// <reference lib="WebWorker"/>
var $9bcc877a156e04f6$var$_self = typeof window !== "undefined" ? window // if in browser
 : typeof WorkerGlobalScope !== "undefined" && self instanceof WorkerGlobalScope ? self // if in worker
 : {} // if in node js
;
/**
 * Prism: Lightweight, robust, elegant syntax highlighting
 *
 * @license MIT <https://opensource.org/licenses/MIT>
 * @author Lea Verou <https://lea.verou.me>
 * @namespace
 * @public
 */ var $9bcc877a156e04f6$var$Prism = function(_self) {
    // Private helper vars
    var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
    var uniqueId = 0;
    // The grammar object for plaintext
    var plainTextGrammar = {};
    var _ = {
        /**
		 * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
		 * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
		 * additional languages or plugins yourself.
		 *
		 * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
		 *
		 * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.manual = true;
		 * // add a new <script> to load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */ manual: _self.Prism && _self.Prism.manual,
        /**
		 * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
		 * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
		 * own worker, you don't want it to do this.
		 *
		 * By setting this value to `true`, Prism will not add its own listeners to the worker.
		 *
		 * You obviously have to change this value before Prism executes. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.disableWorkerMessageHandler = true;
		 * // Load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */ disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,
        /**
		 * A namespace for utility methods.
		 *
		 * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
		 * change or disappear at any time.
		 *
		 * @namespace
		 * @memberof Prism
		 */ util: {
            encode: function encode(tokens) {
                if (tokens instanceof Token) return new Token(tokens.type, encode(tokens.content), tokens.alias);
                else if (Array.isArray(tokens)) return tokens.map(encode);
                else return tokens.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
            },
            /**
			 * Returns the name of the type of the given value.
			 *
			 * @param {any} o
			 * @returns {string}
			 * @example
			 * type(null)      === 'Null'
			 * type(undefined) === 'Undefined'
			 * type(123)       === 'Number'
			 * type('foo')     === 'String'
			 * type(true)      === 'Boolean'
			 * type([1, 2])    === 'Array'
			 * type({})        === 'Object'
			 * type(String)    === 'Function'
			 * type(/abc+/)    === 'RegExp'
			 */ type: function(o) {
                return Object.prototype.toString.call(o).slice(8, -1);
            },
            /**
			 * Returns a unique number for the given object. Later calls will still return the same number.
			 *
			 * @param {Object} obj
			 * @returns {number}
			 */ objId: function(obj) {
                if (!obj["__id"]) Object.defineProperty(obj, "__id", {
                    value: ++uniqueId
                });
                return obj["__id"];
            },
            /**
			 * Creates a deep clone of the given object.
			 *
			 * The main intended use of this function is to clone language definitions.
			 *
			 * @param {T} o
			 * @param {Record<number, any>} [visited]
			 * @returns {T}
			 * @template T
			 */ clone: function deepClone(o, visited) {
                visited = visited || {};
                var clone;
                var id;
                switch(_.util.type(o)){
                    case "Object":
                        id = _.util.objId(o);
                        if (visited[id]) return visited[id];
                        clone = /** @type {Record<string, any>} */ {};
                        visited[id] = clone;
                        for(var key in o)if (o.hasOwnProperty(key)) clone[key] = deepClone(o[key], visited);
                        return /** @type {any} */ clone;
                    case "Array":
                        id = _.util.objId(o);
                        if (visited[id]) return visited[id];
                        clone = [];
                        visited[id] = clone;
                        /** @type {Array} */ /** @type {any} */ o.forEach(function(v, i) {
                            clone[i] = deepClone(v, visited);
                        });
                        return /** @type {any} */ clone;
                    default:
                        return o;
                }
            },
            /**
			 * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
			 *
			 * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
			 *
			 * @param {Element} element
			 * @returns {string}
			 */ getLanguage: function(element) {
                while(element){
                    var m = lang.exec(element.className);
                    if (m) return m[1].toLowerCase();
                    element = element.parentElement;
                }
                return "none";
            },
            /**
			 * Sets the Prism `language-xxxx` class of the given element.
			 *
			 * @param {Element} element
			 * @param {string} language
			 * @returns {void}
			 */ setLanguage: function(element, language) {
                // remove all `language-xxxx` classes
                // (this might leave behind a leading space)
                element.className = element.className.replace(RegExp(lang, "gi"), "");
                // add the new `language-xxxx` class
                // (using `classList` will automatically clean up spaces for us)
                element.classList.add("language-" + language);
            },
            /**
			 * Returns the script element that is currently executing.
			 *
			 * This does __not__ work for line script element.
			 *
			 * @returns {HTMLScriptElement | null}
			 */ currentScript: function() {
                if (typeof document === "undefined") return null;
                if ("currentScript" in document && true /* hack to trip TS' flow analysis */ ) return /** @type {any} */ document.currentScript;
                // IE11 workaround
                // we'll get the src of the current script by parsing IE11's error stack trace
                // this will not work for inline scripts
                try {
                    throw new Error();
                } catch (err) {
                    // Get file src url from stack. Specifically works with the format of stack traces in IE.
                    // A stack will look like this:
                    //
                    // Error
                    //    at _.util.currentScript (http://localhost/components/prism-core.js:119:5)
                    //    at Global code (http://localhost/components/prism-core.js:606:1)
                    var src = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(err.stack) || [])[1];
                    if (src) {
                        var scripts = document.getElementsByTagName("script");
                        for(var i in scripts){
                            if (scripts[i].src == src) return scripts[i];
                        }
                    }
                    return null;
                }
            },
            /**
			 * Returns whether a given class is active for `element`.
			 *
			 * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
			 * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
			 * given class is just the given class with a `no-` prefix.
			 *
			 * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
			 * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
			 * ancestors have the given class or the negated version of it, then the default activation will be returned.
			 *
			 * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
			 * version of it, the class is considered active.
			 *
			 * @param {Element} element
			 * @param {string} className
			 * @param {boolean} [defaultActivation=false]
			 * @returns {boolean}
			 */ isActive: function(element, className, defaultActivation) {
                var no = "no-" + className;
                while(element){
                    var classList = element.classList;
                    if (classList.contains(className)) return true;
                    if (classList.contains(no)) return false;
                    element = element.parentElement;
                }
                return !!defaultActivation;
            }
        },
        /**
		 * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
		 *
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ languages: {
            /**
			 * The grammar for plain, unformatted text.
			 */ plain: plainTextGrammar,
            plaintext: plainTextGrammar,
            text: plainTextGrammar,
            txt: plainTextGrammar,
            /**
			 * Creates a deep copy of the language with the given id and appends the given tokens.
			 *
			 * If a token in `redef` also appears in the copied language, then the existing token in the copied language
			 * will be overwritten at its original position.
			 *
			 * ## Best practices
			 *
			 * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
			 * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
			 * understand the language definition because, normally, the order of tokens matters in Prism grammars.
			 *
			 * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
			 * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
			 *
			 * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
			 * @param {Grammar} redef The new tokens to append.
			 * @returns {Grammar} The new language created.
			 * @public
			 * @example
			 * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
			 *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
			 *     // at its original position
			 *     'comment': { ... },
			 *     // CSS doesn't have a 'color' token, so this token will be appended
			 *     'color': /\b(?:red|green|blue)\b/
			 * });
			 */ extend: function(id, redef) {
                var lang = _.util.clone(_.languages[id]);
                for(var key in redef)lang[key] = redef[key];
                return lang;
            },
            /**
			 * Inserts tokens _before_ another token in a language definition or any other grammar.
			 *
			 * ## Usage
			 *
			 * This helper method makes it easy to modify existing languages. For example, the CSS language definition
			 * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
			 * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
			 * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
			 * this:
			 *
			 * ```js
			 * Prism.languages.markup.style = {
			 *     // token
			 * };
			 * ```
			 *
			 * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
			 * before existing tokens. For the CSS example above, you would use it like this:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'cdata', {
			 *     'style': {
			 *         // token
			 *     }
			 * });
			 * ```
			 *
			 * ## Special cases
			 *
			 * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
			 * will be ignored.
			 *
			 * This behavior can be used to insert tokens after `before`:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'comment', {
			 *     'comment': Prism.languages.markup.comment,
			 *     // tokens after 'comment'
			 * });
			 * ```
			 *
			 * ## Limitations
			 *
			 * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
			 * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
			 * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
			 * deleting properties which is necessary to insert at arbitrary positions.
			 *
			 * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
			 * Instead, it will create a new object and replace all references to the target object with the new one. This
			 * can be done without temporarily deleting properties, so the iteration order is well-defined.
			 *
			 * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
			 * you hold the target object in a variable, then the value of the variable will not change.
			 *
			 * ```js
			 * var oldMarkup = Prism.languages.markup;
			 * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
			 *
			 * assert(oldMarkup !== Prism.languages.markup);
			 * assert(newMarkup === Prism.languages.markup);
			 * ```
			 *
			 * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
			 * object to be modified.
			 * @param {string} before The key to insert before.
			 * @param {Grammar} insert An object containing the key-value pairs to be inserted.
			 * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
			 * object to be modified.
			 *
			 * Defaults to `Prism.languages`.
			 * @returns {Grammar} The new grammar object.
			 * @public
			 */ insertBefore: function(inside, before, insert, root) {
                root = root || /** @type {any} */ _.languages;
                var grammar = root[inside];
                /** @type {Grammar} */ var ret = {};
                for(var token in grammar)if (grammar.hasOwnProperty(token)) {
                    if (token == before) {
                        for(var newToken in insert)if (insert.hasOwnProperty(newToken)) ret[newToken] = insert[newToken];
                    }
                    // Do not insert token which also occur in insert. See #1525
                    if (!insert.hasOwnProperty(token)) ret[token] = grammar[token];
                }
                var old = root[inside];
                root[inside] = ret;
                // Update references in other language definitions
                _.languages.DFS(_.languages, function(key, value) {
                    if (value === old && key != inside) this[key] = ret;
                });
                return ret;
            },
            // Traverse a language definition with Depth First Search
            DFS: function DFS(o, callback, type, visited) {
                visited = visited || {};
                var objId = _.util.objId;
                for(var i in o)if (o.hasOwnProperty(i)) {
                    callback.call(o, i, o[i], type || i);
                    var property = o[i];
                    var propertyType = _.util.type(property);
                    if (propertyType === "Object" && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, null, visited);
                    } else if (propertyType === "Array" && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, i, visited);
                    }
                }
            }
        },
        plugins: {},
        /**
		 * This is the most high-level function in Prism’s API.
		 * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
		 * each one of them.
		 *
		 * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
		 *
		 * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
		 * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
		 * @memberof Prism
		 * @public
		 */ highlightAll: function(async, callback) {
            _.highlightAllUnder(document, async, callback);
        },
        /**
		 * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
		 * {@link Prism.highlightElement} on each one of them.
		 *
		 * The following hooks will be run:
		 * 1. `before-highlightall`
		 * 2. `before-all-elements-highlight`
		 * 3. All hooks of {@link Prism.highlightElement} for each element.
		 *
		 * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
		 * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
		 * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
		 * @memberof Prism
		 * @public
		 */ highlightAllUnder: function(container, async, callback) {
            var env = {
                callback: callback,
                container: container,
                selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
            };
            _.hooks.run("before-highlightall", env);
            env.elements = Array.prototype.slice.apply(env.container.querySelectorAll(env.selector));
            _.hooks.run("before-all-elements-highlight", env);
            for(var i = 0, element; element = env.elements[i++];)_.highlightElement(element, async === true, env.callback);
        },
        /**
		 * Highlights the code inside a single element.
		 *
		 * The following hooks will be run:
		 * 1. `before-sanity-check`
		 * 2. `before-highlight`
		 * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
		 * 4. `before-insert`
		 * 5. `after-highlight`
		 * 6. `complete`
		 *
		 * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
		 * the element's language.
		 *
		 * @param {Element} element The element containing the code.
		 * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
		 * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
		 * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
		 * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
		 *
		 * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
		 * asynchronous highlighting to work. You can build your own bundle on the
		 * [Download page](https://prismjs.com/download.html).
		 * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
		 * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
		 * @memberof Prism
		 * @public
		 */ highlightElement: function(element, async, callback) {
            // Find language
            var language = _.util.getLanguage(element);
            var grammar = _.languages[language];
            // Set language on the element, if not present
            _.util.setLanguage(element, language);
            // Set language on the parent, for styling
            var parent = element.parentElement;
            if (parent && parent.nodeName.toLowerCase() === "pre") _.util.setLanguage(parent, language);
            var code = element.textContent;
            var env = {
                element: element,
                language: language,
                grammar: grammar,
                code: code
            };
            function insertHighlightedCode(highlightedCode) {
                env.highlightedCode = highlightedCode;
                _.hooks.run("before-insert", env);
                env.element.innerHTML = env.highlightedCode;
                _.hooks.run("after-highlight", env);
                _.hooks.run("complete", env);
                callback && callback.call(env.element);
            }
            _.hooks.run("before-sanity-check", env);
            // plugins may change/add the parent/element
            parent = env.element.parentElement;
            if (parent && parent.nodeName.toLowerCase() === "pre" && !parent.hasAttribute("tabindex")) parent.setAttribute("tabindex", "0");
            if (!env.code) {
                _.hooks.run("complete", env);
                callback && callback.call(env.element);
                return;
            }
            _.hooks.run("before-highlight", env);
            if (!env.grammar) {
                insertHighlightedCode(_.util.encode(env.code));
                return;
            }
            if (async && _self.Worker) {
                var worker = new Worker(_.filename);
                worker.onmessage = function(evt) {
                    insertHighlightedCode(evt.data);
                };
                worker.postMessage(JSON.stringify({
                    language: env.language,
                    code: env.code,
                    immediateClose: true
                }));
            } else insertHighlightedCode(_.highlight(env.code, env.grammar, env.language));
        },
        /**
		 * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
		 * and the language definitions to use, and returns a string with the HTML produced.
		 *
		 * The following hooks will be run:
		 * 1. `before-tokenize`
		 * 2. `after-tokenize`
		 * 3. `wrap`: On each {@link Token}.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @param {string} language The name of the language definition passed to `grammar`.
		 * @returns {string} The highlighted HTML.
		 * @memberof Prism
		 * @public
		 * @example
		 * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
		 */ highlight: function(text, grammar, language) {
            var env = {
                code: text,
                grammar: grammar,
                language: language
            };
            _.hooks.run("before-tokenize", env);
            if (!env.grammar) throw new Error('The language "' + env.language + '" has no grammar.');
            env.tokens = _.tokenize(env.code, env.grammar);
            _.hooks.run("after-tokenize", env);
            return Token.stringify(_.util.encode(env.tokens), env.language);
        },
        /**
		 * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
		 * and the language definitions to use, and returns an array with the tokenized code.
		 *
		 * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
		 *
		 * This method could be useful in other contexts as well, as a very crude parser.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @returns {TokenStream} An array of strings and tokens, a token stream.
		 * @memberof Prism
		 * @public
		 * @example
		 * let code = `var foo = 0;`;
		 * let tokens = Prism.tokenize(code, Prism.languages.javascript);
		 * tokens.forEach(token => {
		 *     if (token instanceof Prism.Token && token.type === 'number') {
		 *         console.log(`Found numeric literal: ${token.content}`);
		 *     }
		 * });
		 */ tokenize: function(text, grammar) {
            var rest = grammar.rest;
            if (rest) {
                for(var token in rest)grammar[token] = rest[token];
                delete grammar.rest;
            }
            var tokenList = new LinkedList();
            addAfter(tokenList, tokenList.head, text);
            matchGrammar(text, tokenList, grammar, tokenList.head, 0);
            return toArray(tokenList);
        },
        /**
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ hooks: {
            all: {},
            /**
			 * Adds the given callback to the list of callbacks for the given hook.
			 *
			 * The callback will be invoked when the hook it is registered for is run.
			 * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
			 *
			 * One callback function can be registered to multiple hooks and the same hook multiple times.
			 *
			 * @param {string} name The name of the hook.
			 * @param {HookCallback} callback The callback function which is given environment variables.
			 * @public
			 */ add: function(name, callback) {
                var hooks = _.hooks.all;
                hooks[name] = hooks[name] || [];
                hooks[name].push(callback);
            },
            /**
			 * Runs a hook invoking all registered callbacks with the given environment variables.
			 *
			 * Callbacks will be invoked synchronously and in the order in which they were registered.
			 *
			 * @param {string} name The name of the hook.
			 * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
			 * @public
			 */ run: function(name, env) {
                var callbacks = _.hooks.all[name];
                if (!callbacks || !callbacks.length) return;
                for(var i = 0, callback; callback = callbacks[i++];)callback(env);
            }
        },
        Token: Token
    };
    _self.Prism = _;
    // Typescript note:
    // The following can be used to import the Token type in JSDoc:
    //
    //   @typedef {InstanceType<import("./prism-core")["Token"]>} Token
    /**
	 * Creates a new token.
	 *
	 * @param {string} type See {@link Token#type type}
	 * @param {string | TokenStream} content See {@link Token#content content}
	 * @param {string|string[]} [alias] The alias(es) of the token.
	 * @param {string} [matchedStr=""] A copy of the full string this token was created from.
	 * @class
	 * @global
	 * @public
	 */ function Token(type, content, alias, matchedStr) {
        /**
		 * The type of the token.
		 *
		 * This is usually the key of a pattern in a {@link Grammar}.
		 *
		 * @type {string}
		 * @see GrammarToken
		 * @public
		 */ this.type = type;
        /**
		 * The strings or tokens contained by this token.
		 *
		 * This will be a token stream if the pattern matched also defined an `inside` grammar.
		 *
		 * @type {string | TokenStream}
		 * @public
		 */ this.content = content;
        /**
		 * The alias(es) of the token.
		 *
		 * @type {string|string[]}
		 * @see GrammarToken
		 * @public
		 */ this.alias = alias;
        // Copy of the full string this token was created from
        this.length = (matchedStr || "").length | 0;
    }
    /**
	 * A token stream is an array of strings and {@link Token Token} objects.
	 *
	 * Token streams have to fulfill a few properties that are assumed by most functions (mostly internal ones) that process
	 * them.
	 *
	 * 1. No adjacent strings.
	 * 2. No empty strings.
	 *
	 *    The only exception here is the token stream that only contains the empty string and nothing else.
	 *
	 * @typedef {Array<string | Token>} TokenStream
	 * @global
	 * @public
	 */ /**
	 * Converts the given token or token stream to an HTML representation.
	 *
	 * The following hooks will be run:
	 * 1. `wrap`: On each {@link Token}.
	 *
	 * @param {string | Token | TokenStream} o The token or token stream to be converted.
	 * @param {string} language The name of current language.
	 * @returns {string} The HTML representation of the token or token stream.
	 * @memberof Token
	 * @static
	 */ Token.stringify = function stringify(o, language) {
        if (typeof o == "string") return o;
        if (Array.isArray(o)) {
            var s = "";
            o.forEach(function(e) {
                s += stringify(e, language);
            });
            return s;
        }
        var env = {
            type: o.type,
            content: stringify(o.content, language),
            tag: "span",
            classes: [
                "token",
                o.type
            ],
            attributes: {},
            language: language
        };
        var aliases = o.alias;
        if (aliases) {
            if (Array.isArray(aliases)) Array.prototype.push.apply(env.classes, aliases);
            else env.classes.push(aliases);
        }
        _.hooks.run("wrap", env);
        var attributes = "";
        for(var name in env.attributes)attributes += " " + name + '="' + (env.attributes[name] || "").replace(/"/g, "&quot;") + '"';
        return "<" + env.tag + ' class="' + env.classes.join(" ") + '"' + attributes + ">" + env.content + "</" + env.tag + ">";
    };
    /**
	 * @param {RegExp} pattern
	 * @param {number} pos
	 * @param {string} text
	 * @param {boolean} lookbehind
	 * @returns {RegExpExecArray | null}
	 */ function matchPattern(pattern, pos, text, lookbehind) {
        pattern.lastIndex = pos;
        var match = pattern.exec(text);
        if (match && lookbehind && match[1]) {
            // change the match to remove the text matched by the Prism lookbehind group
            var lookbehindLength = match[1].length;
            match.index += lookbehindLength;
            match[0] = match[0].slice(lookbehindLength);
        }
        return match;
    }
    /**
	 * @param {string} text
	 * @param {LinkedList<string | Token>} tokenList
	 * @param {any} grammar
	 * @param {LinkedListNode<string | Token>} startNode
	 * @param {number} startPos
	 * @param {RematchOptions} [rematch]
	 * @returns {void}
	 * @private
	 *
	 * @typedef RematchOptions
	 * @property {string} cause
	 * @property {number} reach
	 */ function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
        for(var token in grammar){
            if (!grammar.hasOwnProperty(token) || !grammar[token]) continue;
            var patterns = grammar[token];
            patterns = Array.isArray(patterns) ? patterns : [
                patterns
            ];
            for(var j = 0; j < patterns.length; ++j){
                if (rematch && rematch.cause == token + "," + j) return;
                var patternObj = patterns[j];
                var inside = patternObj.inside;
                var lookbehind = !!patternObj.lookbehind;
                var greedy = !!patternObj.greedy;
                var alias = patternObj.alias;
                if (greedy && !patternObj.pattern.global) {
                    // Without the global flag, lastIndex won't work
                    var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
                    patternObj.pattern = RegExp(patternObj.pattern.source, flags + "g");
                }
                /** @type {RegExp} */ var pattern = patternObj.pattern || patternObj;
                for(var currentNode = startNode.next, pos = startPos; currentNode !== tokenList.tail; pos += currentNode.value.length, currentNode = currentNode.next){
                    if (rematch && pos >= rematch.reach) break;
                    var str = currentNode.value;
                    if (tokenList.length > text.length) // Something went terribly wrong, ABORT, ABORT!
                    return;
                    if (str instanceof Token) continue;
                    var removeCount = 1; // this is the to parameter of removeBetween
                    var match;
                    if (greedy) {
                        match = matchPattern(pattern, pos, text, lookbehind);
                        if (!match || match.index >= text.length) break;
                        var from = match.index;
                        var to = match.index + match[0].length;
                        var p = pos;
                        // find the node that contains the match
                        p += currentNode.value.length;
                        while(from >= p){
                            currentNode = currentNode.next;
                            p += currentNode.value.length;
                        }
                        // adjust pos (and p)
                        p -= currentNode.value.length;
                        pos = p;
                        // the current node is a Token, then the match starts inside another Token, which is invalid
                        if (currentNode.value instanceof Token) continue;
                        // find the last node which is affected by this match
                        for(var k = currentNode; k !== tokenList.tail && (p < to || typeof k.value === "string"); k = k.next){
                            removeCount++;
                            p += k.value.length;
                        }
                        removeCount--;
                        // replace with the new match
                        str = text.slice(pos, p);
                        match.index -= pos;
                    } else {
                        match = matchPattern(pattern, 0, str, lookbehind);
                        if (!match) continue;
                    }
                    // eslint-disable-next-line no-redeclare
                    var from = match.index;
                    var matchStr = match[0];
                    var before = str.slice(0, from);
                    var after = str.slice(from + matchStr.length);
                    var reach = pos + str.length;
                    if (rematch && reach > rematch.reach) rematch.reach = reach;
                    var removeFrom = currentNode.prev;
                    if (before) {
                        removeFrom = addAfter(tokenList, removeFrom, before);
                        pos += before.length;
                    }
                    removeRange(tokenList, removeFrom, removeCount);
                    var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
                    currentNode = addAfter(tokenList, removeFrom, wrapped);
                    if (after) addAfter(tokenList, currentNode, after);
                    if (removeCount > 1) {
                        // at least one Token object was removed, so we have to do some rematching
                        // this can only happen if the current pattern is greedy
                        /** @type {RematchOptions} */ var nestedRematch = {
                            cause: token + "," + j,
                            reach: reach
                        };
                        matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);
                        // the reach might have been extended because of the rematching
                        if (rematch && nestedRematch.reach > rematch.reach) rematch.reach = nestedRematch.reach;
                    }
                }
            }
        }
    }
    /**
	 * @typedef LinkedListNode
	 * @property {T} value
	 * @property {LinkedListNode<T> | null} prev The previous node.
	 * @property {LinkedListNode<T> | null} next The next node.
	 * @template T
	 * @private
	 */ /**
	 * @template T
	 * @private
	 */ function LinkedList() {
        /** @type {LinkedListNode<T>} */ var head = {
            value: null,
            prev: null,
            next: null
        };
        /** @type {LinkedListNode<T>} */ var tail = {
            value: null,
            prev: head,
            next: null
        };
        head.next = tail;
        /** @type {LinkedListNode<T>} */ this.head = head;
        /** @type {LinkedListNode<T>} */ this.tail = tail;
        this.length = 0;
    }
    /**
	 * Adds a new node with the given value to the list.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {T} value
	 * @returns {LinkedListNode<T>} The added node.
	 * @template T
	 */ function addAfter(list, node, value) {
        // assumes that node != list.tail && values.length >= 0
        var next = node.next;
        var newNode = {
            value: value,
            prev: node,
            next: next
        };
        node.next = newNode;
        next.prev = newNode;
        list.length++;
        return newNode;
    }
    /**
	 * Removes `count` nodes after the given node. The given node will not be removed.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {number} count
	 * @template T
	 */ function removeRange(list, node, count) {
        var next = node.next;
        for(var i = 0; i < count && next !== list.tail; i++)next = next.next;
        node.next = next;
        next.prev = node;
        list.length -= i;
    }
    /**
	 * @param {LinkedList<T>} list
	 * @returns {T[]}
	 * @template T
	 */ function toArray(list) {
        var array = [];
        var node = list.head.next;
        while(node !== list.tail){
            array.push(node.value);
            node = node.next;
        }
        return array;
    }
    if (!_self.document) {
        if (!_self.addEventListener) // in Node.js
        return _;
        if (!_.disableWorkerMessageHandler) // In worker
        _self.addEventListener("message", function(evt) {
            var message = JSON.parse(evt.data);
            var lang = message.language;
            var code = message.code;
            var immediateClose = message.immediateClose;
            _self.postMessage(_.highlight(code, _.languages[lang], lang));
            if (immediateClose) _self.close();
        }, false);
        return _;
    }
    // Get current script and highlight
    var script = _.util.currentScript();
    if (script) {
        _.filename = script.src;
        if (script.hasAttribute("data-manual")) _.manual = true;
    }
    function highlightAutomaticallyCallback() {
        if (!_.manual) _.highlightAll();
    }
    if (!_.manual) {
        // If the document state is "loading", then we'll use DOMContentLoaded.
        // If the document state is "interactive" and the prism.js script is deferred, then we'll also use the
        // DOMContentLoaded event because there might be some plugins or languages which have also been deferred and they
        // might take longer one animation frame to execute which can create a race condition where only some plugins have
        // been loaded when Prism.highlightAll() is executed, depending on how fast resources are loaded.
        // See https://github.com/PrismJS/prism/issues/2102
        var readyState = document.readyState;
        if (readyState === "loading" || readyState === "interactive" && script && script.defer) document.addEventListener("DOMContentLoaded", highlightAutomaticallyCallback);
        else if (window.requestAnimationFrame) window.requestAnimationFrame(highlightAutomaticallyCallback);
        else window.setTimeout(highlightAutomaticallyCallback, 16);
    }
    return _;
}($9bcc877a156e04f6$var$_self);
if (0, $9bcc877a156e04f6$exports) $9bcc877a156e04f6$exports = $9bcc877a156e04f6$var$Prism;
// hack for components to work correctly in node.js
if (typeof $parcel$global !== "undefined") $parcel$global.Prism = $9bcc877a156e04f6$var$Prism;
// some additional documentation/types
/**
 * The expansion of a simple `RegExp` literal to support additional properties.
 *
 * @typedef GrammarToken
 * @property {RegExp} pattern The regular expression of the token.
 * @property {boolean} [lookbehind=false] If `true`, then the first capturing group of `pattern` will (effectively)
 * behave as a lookbehind group meaning that the captured text will not be part of the matched text of the new token.
 * @property {boolean} [greedy=false] Whether the token is greedy.
 * @property {string|string[]} [alias] An optional alias or list of aliases.
 * @property {Grammar} [inside] The nested grammar of this token.
 *
 * The `inside` grammar will be used to tokenize the text value of each token of this kind.
 *
 * This can be used to make nested and even recursive language definitions.
 *
 * Note: This can cause infinite recursion. Be careful when you embed different languages or even the same language into
 * each another.
 * @global
 * @public
 */ /**
 * @typedef Grammar
 * @type {Object<string, RegExp | GrammarToken | Array<RegExp | GrammarToken>>}
 * @property {Grammar} [rest] An optional grammar object that will be appended to this grammar.
 * @global
 * @public
 */ /**
 * A function which will invoked after an element was successfully highlighted.
 *
 * @callback HighlightCallback
 * @param {Element} element The element successfully highlighted.
 * @returns {void}
 * @global
 * @public
 */ /**
 * @callback HookCallback
 * @param {Object<string, any>} env The environment variables of the hook.
 * @returns {void}
 * @global
 * @public
 */ /* **********************************************
     Begin prism-markup.js
********************************************** */ $9bcc877a156e04f6$var$Prism.languages.markup = {
    "comment": {
        pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
        greedy: true
    },
    "prolog": {
        pattern: /<\?[\s\S]+?\?>/,
        greedy: true
    },
    "doctype": {
        // https://www.w3.org/TR/xml/#NT-doctypedecl
        pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
        greedy: true,
        inside: {
            "internal-subset": {
                pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
                lookbehind: true,
                greedy: true,
                inside: null // see below
            },
            "string": {
                pattern: /"[^"]*"|'[^']*'/,
                greedy: true
            },
            "punctuation": /^<!|>$|[[\]]/,
            "doctype-tag": /^DOCTYPE/i,
            "name": /[^\s<>'"]+/
        }
    },
    "cdata": {
        pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
        greedy: true
    },
    "tag": {
        pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
        greedy: true,
        inside: {
            "tag": {
                pattern: /^<\/?[^\s>\/]+/,
                inside: {
                    "punctuation": /^<\/?/,
                    "namespace": /^[^\s>\/:]+:/
                }
            },
            "special-attr": [],
            "attr-value": {
                pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
                inside: {
                    "punctuation": [
                        {
                            pattern: /^=/,
                            alias: "attr-equals"
                        },
                        {
                            pattern: /^(\s*)["']|["']$/,
                            lookbehind: true
                        }
                    ]
                }
            },
            "punctuation": /\/?>/,
            "attr-name": {
                pattern: /[^\s>\/]+/,
                inside: {
                    "namespace": /^[^\s>\/:]+:/
                }
            }
        }
    },
    "entity": [
        {
            pattern: /&[\da-z]{1,8};/i,
            alias: "named-entity"
        },
        /&#x?[\da-f]{1,8};/i
    ]
};
$9bcc877a156e04f6$var$Prism.languages.markup["tag"].inside["attr-value"].inside["entity"] = $9bcc877a156e04f6$var$Prism.languages.markup["entity"];
$9bcc877a156e04f6$var$Prism.languages.markup["doctype"].inside["internal-subset"].inside = $9bcc877a156e04f6$var$Prism.languages.markup;
// Plugin to make entity title show the real entity, idea by Roman Komarov
$9bcc877a156e04f6$var$Prism.hooks.add("wrap", function(env) {
    if (env.type === "entity") env.attributes["title"] = env.content.replace(/&amp;/, "&");
});
Object.defineProperty($9bcc877a156e04f6$var$Prism.languages.markup.tag, "addInlined", {
    /**
	 * Adds an inlined language to markup.
	 *
	 * An example of an inlined language is CSS with `<style>` tags.
	 *
	 * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addInlined('style', 'css');
	 */ value: function addInlined(tagName, lang) {
        var includedCdataInside = {};
        includedCdataInside["language-" + lang] = {
            pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
            lookbehind: true,
            inside: $9bcc877a156e04f6$var$Prism.languages[lang]
        };
        includedCdataInside["cdata"] = /^<!\[CDATA\[|\]\]>$/i;
        var inside = {
            "included-cdata": {
                pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
                inside: includedCdataInside
            }
        };
        inside["language-" + lang] = {
            pattern: /[\s\S]+/,
            inside: $9bcc877a156e04f6$var$Prism.languages[lang]
        };
        var def = {};
        def[tagName] = {
            pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
                return tagName;
            }), "i"),
            lookbehind: true,
            greedy: true,
            inside: inside
        };
        $9bcc877a156e04f6$var$Prism.languages.insertBefore("markup", "cdata", def);
    }
});
Object.defineProperty($9bcc877a156e04f6$var$Prism.languages.markup.tag, "addAttribute", {
    /**
	 * Adds an pattern to highlight languages embedded in HTML attributes.
	 *
	 * An example of an inlined language is CSS with `style` attributes.
	 *
	 * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addAttribute('style', 'css');
	 */ value: function(attrName, lang) {
        $9bcc877a156e04f6$var$Prism.languages.markup.tag.inside["special-attr"].push({
            pattern: RegExp(/(^|["'\s])/.source + "(?:" + attrName + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, "i"),
            lookbehind: true,
            inside: {
                "attr-name": /^[^\s=]+/,
                "attr-value": {
                    pattern: /=[\s\S]+/,
                    inside: {
                        "value": {
                            pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                            lookbehind: true,
                            alias: [
                                lang,
                                "language-" + lang
                            ],
                            inside: $9bcc877a156e04f6$var$Prism.languages[lang]
                        },
                        "punctuation": [
                            {
                                pattern: /^=/,
                                alias: "attr-equals"
                            },
                            /"|'/
                        ]
                    }
                }
            }
        });
    }
});
$9bcc877a156e04f6$var$Prism.languages.html = $9bcc877a156e04f6$var$Prism.languages.markup;
$9bcc877a156e04f6$var$Prism.languages.mathml = $9bcc877a156e04f6$var$Prism.languages.markup;
$9bcc877a156e04f6$var$Prism.languages.svg = $9bcc877a156e04f6$var$Prism.languages.markup;
$9bcc877a156e04f6$var$Prism.languages.xml = $9bcc877a156e04f6$var$Prism.languages.extend("markup", {});
$9bcc877a156e04f6$var$Prism.languages.ssml = $9bcc877a156e04f6$var$Prism.languages.xml;
$9bcc877a156e04f6$var$Prism.languages.atom = $9bcc877a156e04f6$var$Prism.languages.xml;
$9bcc877a156e04f6$var$Prism.languages.rss = $9bcc877a156e04f6$var$Prism.languages.xml;
/* **********************************************
     Begin prism-css.js
********************************************** */ (function(Prism) {
    var string = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
    Prism.languages.css = {
        "comment": /\/\*[\s\S]*?\*\//,
        "atrule": {
            pattern: RegExp("@[\\w-](?:" + /[^;{\s"']|\s+(?!\s)/.source + "|" + string.source + ")*?" + /(?:;|(?=\s*\{))/.source),
            inside: {
                "rule": /^@[\w-]+/,
                "selector-function-argument": {
                    pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
                    lookbehind: true,
                    alias: "selector"
                },
                "keyword": {
                    pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
                    lookbehind: true
                }
            }
        },
        "url": {
            // https://drafts.csswg.org/css-values-3/#urls
            pattern: RegExp("\\burl\\((?:" + string.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)", "i"),
            greedy: true,
            inside: {
                "function": /^url/i,
                "punctuation": /^\(|\)$/,
                "string": {
                    pattern: RegExp("^" + string.source + "$"),
                    alias: "url"
                }
            }
        },
        "selector": {
            pattern: RegExp("(^|[{}\\s])[^{}\\s](?:[^{};\"'\\s]|\\s+(?![\\s{])|" + string.source + ")*(?=\\s*\\{)"),
            lookbehind: true
        },
        "string": {
            pattern: string,
            greedy: true
        },
        "property": {
            pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
            lookbehind: true
        },
        "important": /!important\b/i,
        "function": {
            pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
            lookbehind: true
        },
        "punctuation": /[(){};:,]/
    };
    Prism.languages.css["atrule"].inside.rest = Prism.languages.css;
    var markup = Prism.languages.markup;
    if (markup) {
        markup.tag.addInlined("style", "css");
        markup.tag.addAttribute("style", "css");
    }
})($9bcc877a156e04f6$var$Prism);
/* **********************************************
     Begin prism-clike.js
********************************************** */ $9bcc877a156e04f6$var$Prism.languages.clike = {
    "comment": [
        {
            pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
            lookbehind: true,
            greedy: true
        },
        {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: true,
            greedy: true
        }
    ],
    "string": {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: true
    },
    "class-name": {
        pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
        lookbehind: true,
        inside: {
            "punctuation": /[.\\]/
        }
    },
    "keyword": /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
    "boolean": /\b(?:false|true)\b/,
    "function": /\b\w+(?=\()/,
    "number": /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    "operator": /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
    "punctuation": /[{}[\];(),.:]/
};
/* **********************************************
     Begin prism-javascript.js
********************************************** */ $9bcc877a156e04f6$var$Prism.languages.javascript = $9bcc877a156e04f6$var$Prism.languages.extend("clike", {
    "class-name": [
        $9bcc877a156e04f6$var$Prism.languages.clike["class-name"],
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
            lookbehind: true
        }
    ],
    "keyword": [
        {
            pattern: /((?:^|\})\s*)catch\b/,
            lookbehind: true
        },
        {
            pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
            lookbehind: true
        }
    ],
    // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
    "function": /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    "number": {
        pattern: RegExp(/(^|[^\w$])/.source + "(?:" + // constant
        (/NaN|Infinity/.source + "|" + // binary integer
        /0[bB][01]+(?:_[01]+)*n?/.source + "|" + // octal integer
        /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + // hexadecimal integer
        /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + // decimal bigint
        /\d+(?:_\d+)*n/.source + "|" + // decimal number (integer or float) but no bigint
        /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ")" + /(?![\w$])/.source),
        lookbehind: true
    },
    "operator": /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
});
$9bcc877a156e04f6$var$Prism.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;
$9bcc877a156e04f6$var$Prism.languages.insertBefore("javascript", "keyword", {
    "regex": {
        pattern: RegExp(// lookbehind
        // eslint-disable-next-line regexp/no-dupe-characters-character-class
        /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + // Regex pattern:
        // There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
        // classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
        // with the only syntax, so we have to define 2 different regex patterns.
        /\//.source + "(?:" + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + "|" + // `v` flag syntax. This supports 3 levels of nested character classes.
        /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ")" + // lookahead
        /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source),
        lookbehind: true,
        greedy: true,
        inside: {
            "regex-source": {
                pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                lookbehind: true,
                alias: "language-regex",
                inside: $9bcc877a156e04f6$var$Prism.languages.regex
            },
            "regex-delimiter": /^\/|\/$/,
            "regex-flags": /^[a-z]+$/
        }
    },
    // This must be declared before keyword because we use "function" inside the look-forward
    "function-variable": {
        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
        alias: "function"
    },
    "parameter": [
        {
            pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
            lookbehind: true,
            inside: $9bcc877a156e04f6$var$Prism.languages.javascript
        },
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
            lookbehind: true,
            inside: $9bcc877a156e04f6$var$Prism.languages.javascript
        },
        {
            pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
            lookbehind: true,
            inside: $9bcc877a156e04f6$var$Prism.languages.javascript
        },
        {
            pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
            lookbehind: true,
            inside: $9bcc877a156e04f6$var$Prism.languages.javascript
        }
    ],
    "constant": /\b[A-Z](?:[A-Z_]|\dx?)*\b/
});
$9bcc877a156e04f6$var$Prism.languages.insertBefore("javascript", "string", {
    "hashbang": {
        pattern: /^#!.*/,
        greedy: true,
        alias: "comment"
    },
    "template-string": {
        pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
        greedy: true,
        inside: {
            "template-punctuation": {
                pattern: /^`|`$/,
                alias: "string"
            },
            "interpolation": {
                pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                lookbehind: true,
                inside: {
                    "interpolation-punctuation": {
                        pattern: /^\$\{|\}$/,
                        alias: "punctuation"
                    },
                    rest: $9bcc877a156e04f6$var$Prism.languages.javascript
                }
            },
            "string": /[\s\S]+/
        }
    },
    "string-property": {
        pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
        lookbehind: true,
        greedy: true,
        alias: "property"
    }
});
$9bcc877a156e04f6$var$Prism.languages.insertBefore("javascript", "operator", {
    "literal-property": {
        pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
        lookbehind: true,
        alias: "property"
    }
});
if ($9bcc877a156e04f6$var$Prism.languages.markup) {
    $9bcc877a156e04f6$var$Prism.languages.markup.tag.addInlined("script", "javascript");
    // add attribute support for all DOM events.
    // https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
    $9bcc877a156e04f6$var$Prism.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, "javascript");
}
$9bcc877a156e04f6$var$Prism.languages.js = $9bcc877a156e04f6$var$Prism.languages.javascript;
/* **********************************************
     Begin prism-file-highlight.js
********************************************** */ (function() {
    if (typeof $9bcc877a156e04f6$var$Prism === "undefined" || typeof document === "undefined") return;
    // https://developer.mozilla.org/en-US/docs/Web/API/Element/matches#Polyfill
    if (!Element.prototype.matches) Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    var LOADING_MESSAGE = "Loading\u2026";
    var FAILURE_MESSAGE = function(status, message) {
        return "\u2716 Error " + status + " while fetching file: " + message;
    };
    var FAILURE_EMPTY_MESSAGE = "\u2716 Error: File does not exist or is empty";
    var EXTENSIONS = {
        "js": "javascript",
        "py": "python",
        "rb": "ruby",
        "ps1": "powershell",
        "psm1": "powershell",
        "sh": "bash",
        "bat": "batch",
        "h": "c",
        "tex": "latex"
    };
    var STATUS_ATTR = "data-src-status";
    var STATUS_LOADING = "loading";
    var STATUS_LOADED = "loaded";
    var STATUS_FAILED = "failed";
    var SELECTOR = "pre[data-src]:not([" + STATUS_ATTR + '="' + STATUS_LOADED + '"])' + ":not([" + STATUS_ATTR + '="' + STATUS_LOADING + '"])';
    /**
	 * Loads the given file.
	 *
	 * @param {string} src The URL or path of the source file to load.
	 * @param {(result: string) => void} success
	 * @param {(reason: string) => void} error
	 */ function loadFile(src, success, error) {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", src, true);
        xhr.onreadystatechange = function() {
            if (xhr.readyState == 4) {
                if (xhr.status < 400 && xhr.responseText) success(xhr.responseText);
                else if (xhr.status >= 400) error(FAILURE_MESSAGE(xhr.status, xhr.statusText));
                else error(FAILURE_EMPTY_MESSAGE);
            }
        };
        xhr.send(null);
    }
    /**
	 * Parses the given range.
	 *
	 * This returns a range with inclusive ends.
	 *
	 * @param {string | null | undefined} range
	 * @returns {[number, number | undefined] | undefined}
	 */ function parseRange(range) {
        var m = /^\s*(\d+)\s*(?:(,)\s*(?:(\d+)\s*)?)?$/.exec(range || "");
        if (m) {
            var start = Number(m[1]);
            var comma = m[2];
            var end = m[3];
            if (!comma) return [
                start,
                start
            ];
            if (!end) return [
                start,
                undefined
            ];
            return [
                start,
                Number(end)
            ];
        }
        return undefined;
    }
    $9bcc877a156e04f6$var$Prism.hooks.add("before-highlightall", function(env) {
        env.selector += ", " + SELECTOR;
    });
    $9bcc877a156e04f6$var$Prism.hooks.add("before-sanity-check", function(env) {
        var pre = /** @type {HTMLPreElement} */ env.element;
        if (pre.matches(SELECTOR)) {
            env.code = ""; // fast-path the whole thing and go to complete
            pre.setAttribute(STATUS_ATTR, STATUS_LOADING); // mark as loading
            // add code element with loading message
            var code = pre.appendChild(document.createElement("CODE"));
            code.textContent = LOADING_MESSAGE;
            var src = pre.getAttribute("data-src");
            var language = env.language;
            if (language === "none") {
                // the language might be 'none' because there is no language set;
                // in this case, we want to use the extension as the language
                var extension = (/\.(\w+)$/.exec(src) || [
                    ,
                    "none"
                ])[1];
                language = EXTENSIONS[extension] || extension;
            }
            // set language classes
            $9bcc877a156e04f6$var$Prism.util.setLanguage(code, language);
            $9bcc877a156e04f6$var$Prism.util.setLanguage(pre, language);
            // preload the language
            var autoloader = $9bcc877a156e04f6$var$Prism.plugins.autoloader;
            if (autoloader) autoloader.loadLanguages(language);
            // load file
            loadFile(src, function(text) {
                // mark as loaded
                pre.setAttribute(STATUS_ATTR, STATUS_LOADED);
                // handle data-range
                var range = parseRange(pre.getAttribute("data-range"));
                if (range) {
                    var lines = text.split(/\r\n?|\n/g);
                    // the range is one-based and inclusive on both ends
                    var start = range[0];
                    var end = range[1] == null ? lines.length : range[1];
                    if (start < 0) start += lines.length;
                    start = Math.max(0, Math.min(start - 1, lines.length));
                    if (end < 0) end += lines.length;
                    end = Math.max(0, Math.min(end, lines.length));
                    text = lines.slice(start, end).join("\n");
                    // add data-start for line numbers
                    if (!pre.hasAttribute("data-start")) pre.setAttribute("data-start", String(start + 1));
                }
                // highlight code
                code.textContent = text;
                $9bcc877a156e04f6$var$Prism.highlightElement(code);
            }, function(error) {
                // mark as failed
                pre.setAttribute(STATUS_ATTR, STATUS_FAILED);
                code.textContent = error;
            });
        }
    });
    $9bcc877a156e04f6$var$Prism.plugins.fileHighlight = {
        /**
		 * Executes the File Highlight plugin for all matching `pre` elements under the given container.
		 *
		 * Note: Elements which are already loaded or currently loading will not be touched by this method.
		 *
		 * @param {ParentNode} [container=document]
		 */ highlight: function highlight(container) {
            var elements = (container || document).querySelectorAll(SELECTOR);
            for(var i = 0, element; element = elements[i++];)$9bcc877a156e04f6$var$Prism.highlightElement(element);
        }
    };
    var logged = false;
    /** @deprecated Use `Prism.plugins.fileHighlight.highlight` instead. */ $9bcc877a156e04f6$var$Prism.fileHighlight = function() {
        if (!logged) {
            console.warn("Prism.fileHighlight is deprecated. Use `Prism.plugins.fileHighlight.highlight` instead.");
            logged = true;
        }
        $9bcc877a156e04f6$var$Prism.plugins.fileHighlight.highlight.apply(this, arguments);
    };
})();


// Thanks to: https://github.com/prometheus-community/monaco-promql/blob/master/src/promql/promql.ts
// As well as: https://kausal.co/blog/slate-prism-add-new-syntax-promql/
(function(Prism1) {
    // PromQL Aggregation Operators
    // (https://prometheus.io/docs/prometheus/latest/querying/operators/#aggregation-operators)
    var aggregations = [
        "sum",
        "min",
        "max",
        "avg",
        "group",
        "stddev",
        "stdvar",
        "count",
        "count_values",
        "bottomk",
        "topk",
        "quantile"
    ];
    // PromQL vector matching + the by and without clauses
    // (https://prometheus.io/docs/prometheus/latest/querying/operators/#vector-matching)
    var vectorMatching = [
        "on",
        "ignoring",
        "group_right",
        "group_left",
        "by",
        "without"
    ];
    // PromQL offset modifier
    // (https://prometheus.io/docs/prometheus/latest/querying/basics/#offset-modifier)
    var offsetModifier = [
        "offset"
    ];
    var keywords = aggregations.concat(vectorMatching, offsetModifier);
    Prism1.languages.promql = {
        "comment": {
            pattern: /(^[ \t]*)#.*/m,
            lookbehind: true
        },
        "vector-match": {
            // Match the comma-separated label lists inside vector matching:
            pattern: new RegExp("((?:" + vectorMatching.join("|") + ")\\s*)\\([^)]*\\)"),
            lookbehind: true,
            inside: {
                "label-key": {
                    pattern: /\b[^,]+\b/,
                    alias: "attr-name"
                },
                "punctuation": /[(),]/
            }
        },
        "context-labels": {
            pattern: /\{[^{}]*\}/,
            inside: {
                "label-key": {
                    pattern: /\b[a-z_]\w*(?=\s*(?:=|![=~]))/,
                    alias: "attr-name"
                },
                "label-value": {
                    pattern: /(["'`])(?:\\[\s\S]|(?!\1)[^\\])*\1/,
                    greedy: true,
                    alias: "attr-value"
                },
                "punctuation": /\{|\}|=~?|![=~]|,/
            }
        },
        "context-range": [
            {
                pattern: /\[[\w\s:]+\]/,
                inside: {
                    "punctuation": /\[|\]|:/,
                    "range-duration": {
                        pattern: /\b(?:\d+(?:[smhdwy]|ms))+\b/i,
                        alias: "number"
                    }
                }
            },
            {
                pattern: /(\boffset\s+)\w+/,
                lookbehind: true,
                inside: {
                    "range-duration": {
                        pattern: /\b(?:\d+(?:[smhdwy]|ms))+\b/i,
                        alias: "number"
                    }
                }
            }
        ],
        "keyword": new RegExp("\\b(?:" + keywords.join("|") + ")\\b", "i"),
        "function": /\b[a-z_]\w*(?=\s*\()/i,
        "number": /[-+]?(?:(?:\b\d+(?:\.\d+)?|\B\.\d+)(?:e[-+]?\d+)?\b|\b(?:0x[0-9a-f]+|nan|inf)\b)/i,
        "operator": /[\^*/%+-]|==|!=|<=|<|>=|>|\b(?:and|or|unless)\b/i,
        "punctuation": /[{};()`,.[\]]/
    };
})(Prism);




// PromQL functions
// (https://prometheus.io/docs/prometheus/latest/querying/functions/)
const $03f0b9165266200f$export$bd0beaf6ab8f5bbd = [
    "abs",
    "absent",
    "ceil",
    "changes",
    "clamp_max",
    "clamp_min",
    "day_of_month",
    "day_of_week",
    "days_in_month",
    "delta",
    "deriv",
    "exp",
    "floor",
    "histogram_quantile",
    "holt_winters",
    "hour",
    "idelta",
    "increase",
    "irate",
    "label_join",
    "label_replace",
    "ln",
    "log2",
    "log10",
    "minute",
    "month",
    "predict_linear",
    "rate",
    "resets",
    "round",
    "scalar",
    "sort",
    "sort_desc",
    "sqrt",
    "time",
    "timestamp",
    "vector",
    "year",
    "avg_over_time",
    "min_over_time",
    "max_over_time",
    "sum_over_time",
    "count_over_time",
    "quantile_over_time",
    "stddev_over_time",
    "stdvar_over_time"
];


// Extend the PromQL syntax highlighting to include PromQL functions
const { promql: $c4bae4e8fa7c3f9d$var$promql } = (0, (/*@__PURE__*/$parcel$interopDefault($9bcc877a156e04f6$exports))).languages;
if (!$c4bae4e8fa7c3f9d$var$promql) throw new Error("PromQL syntax not defined");
$c4bae4e8fa7c3f9d$var$promql.function = new RegExp("\\b(?:" + (0, $03f0b9165266200f$export$bd0beaf6ab8f5bbd).join("|") + ")(?=\\s*\\()", "i");
const $c4bae4e8fa7c3f9d$var$grammar = $c4bae4e8fa7c3f9d$var$promql;
const $c4bae4e8fa7c3f9d$export$62297b13309008b2 = (props)=>{
    const { text: text } = props;
    const { isCopied: isCopied, handleCopy: handleCopy } = (0, $cd24a65f0e0ab1ba$export$b2199c37e85de4a7)(()=>text);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($c4bae4e8fa7c3f9d$var$Container, {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($c4bae4e8fa7c3f9d$var$CopyButton, {
                disabled: isCopied,
                onClick: handleCopy,
                children: isCopied ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $afa7be861492543f$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0a830394bc38e4e3$export$f04a61298a47a40f), {
                            type: "check"
                        }),
                        "Copied"
                    ]
                }) : /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $afa7be861492543f$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0a830394bc38e4e3$export$f04a61298a47a40f), {
                            type: "copy"
                        }),
                        "Copy"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $b0893cc2f3fde9b8$export$2631a3ab3cdd158d), {
                as: "pre",
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("code", {
                    className: "language-promql",
                    dangerouslySetInnerHTML: {
                        __html: (0, (/*@__PURE__*/$parcel$interopDefault($9bcc877a156e04f6$exports))).highlight(text, $c4bae4e8fa7c3f9d$var$grammar, "promql")
                    }
                })
            })
        ]
    });
};
const $c4bae4e8fa7c3f9d$var$Container = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    --spacing-query-container: 12px;
    --spacing-scroll-container-inline: var(--spacing-query-container);

    position: relative;
    overflow: hidden;
    padding: var(--spacing-query-container);
    background-color: ${theme.color.bg.elevated.default};
    border-radius: ${theme.radius.rounded};

    pre,
    code {
      background-color: inherit;
      text-shadow: 0 1px ${theme.color.bg.default};

      transition: background-color 0.2s ease-in-out;
    }

    code[class*="language-"],
    pre[class*="language-"] {
      color: ${theme.color.fg.default};
    }

    .language-promql {
      .token.punctuation {
        color: ${theme.color.fg.default};
      }

      .token.function {
        color: ${theme.color.fg.primary};
      }
      .token.keyword {
        color: ${theme.color.fg.primary};
      }

      .token.vector-match .token.attr-name {
        color: ${theme.color.fg.accent[3]};
      }

      .context-labels .token.label-key {
        color: ${theme.color.fg.accent[3]};
      }

      .context-labels .token.label-value {
        color: ${theme.color.fg.accent[2]};
      }

      .token.number {
        color: ${theme.color.fg.accent[1]};
      }

      .token.operator {
        background-color: transparent;
        color: ${theme.color.fg.default};
      }
    }
  `);
const $c4bae4e8fa7c3f9d$var$CopyButton = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $a921dfdbd8dd60fa$export$353f5b6fc5456de1)).attrs({
    buttonStyle: "secondary"
})`
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 1;
`;








var $2gcPZ = parcelRequire("2gcPZ");



const $ea0b2a3aa915942e$var$THROTTLE_MS = 250;
function $ea0b2a3aa915942e$export$2b7b2ce432c10f7c({ isRefreshing: isRefreshing, lastUpdatedAt: lastUpdatedAt, refresh: refresh }) {
    const throttledIsRefreshing = (0, $0256cde7569cadc3$export$4083eefea094a0de)(isRefreshing, $ea0b2a3aa915942e$var$THROTTLE_MS);
    const relativeTimeString = (0, $bd1aac28096a588b$export$1deeb1050525eb40)($ea0b2a3aa915942e$var$isValidDate(lastUpdatedAt) ? lastUpdatedAt : undefined);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($ea0b2a3aa915942e$var$Container, {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $d3a9d83062c98169$export$3ae376d12526dd6f), {
                mode: "wait",
                children: throttledIsRefreshing ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $2gcPZ.Fragment), {
                    children: "Refreshing..."
                }, "refreshing") : /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $2gcPZ.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($ea0b2a3aa915942e$var$Label, {
                            children: "Last updated:"
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("span", {
                            children: relativeTimeString ?? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $afa7be861492543f$exports.Fragment), {
                                children: "\u2014"
                            })
                        })
                    ]
                }, "lastUpdated")
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($ea0b2a3aa915942e$var$RefreshIcon, {
                $isRefreshing: throttledIsRefreshing,
                onClick: refresh,
                type: "arrow_clockwise"
            })
        ]
    });
}
const $ea0b2a3aa915942e$var$isValidDate = (date)=>!Number.isNaN(date.getTime());
const $ea0b2a3aa915942e$var$Container = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).span(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font: ${theme.font.body.md.regular};
  `);
const $ea0b2a3aa915942e$var$Label = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).span`
  font: ${({ theme: theme })=>theme.font.body.md.medium};
`;
const $ea0b2a3aa915942e$var$spinAnimation = (0, $4e8e6ea7d6e48c37$export$d25ddfdf17c3ad3e)`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;
const $ea0b2a3aa915942e$var$RefreshIcon = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $0a830394bc38e4e3$export$f04a61298a47a40f))(({ theme: theme, $isRefreshing: $isRefreshing })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      color: ${theme.color.fg.primary};
      cursor: pointer;
      animation: ${$isRefreshing ? (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
            ${$ea0b2a3aa915942e$var$spinAnimation} ${$ea0b2a3aa915942e$var$THROTTLE_MS}ms ease-in-out forwards infinite
          ` : "unset"};
    `);









function $3827d9421870a8da$export$67efe7a6dccb9914({ definition: definition }) {
    const { isCopied: isCopied, handleCopy: handleCopy } = (0, $cd24a65f0e0ab1ba$export$b2199c37e85de4a7)(()=>definition ? $3827d9421870a8da$var$getText(definition) : "");
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($3827d9421870a8da$var$Code, {
        role: "button",
        onClick: handleCopy,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("span", {
                children: isCopied ? "Copied" : $3827d9421870a8da$var$getText(definition)
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0a830394bc38e4e3$export$f04a61298a47a40f), {
                type: "copy"
            })
        ]
    });
}
const $3827d9421870a8da$var$Code = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).code(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    display: grid;
    grid: auto / max-content auto;
    align-items: center;
    width: min-content;
    gap: 8px;
    color: ${theme.color.fg.muted};
    cursor: pointer;

    &:hover {
      color: ${theme.color.fg.default};
    }
  `);
function $3827d9421870a8da$var$getText(definition) {
    const { range: range, file: file } = definition;
    const line = range.start.line + 1;
    const column = range.start.column + 1;
    return `${file}:${line}:${column}`;
}





parcelRequire("2gcPZ");
const $0cdc27807401b728$var$SvgVscode = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("g", {
                clipPath: "url(#vscode_svg__a)",
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11.011 15.102a.896.896 0 0 0 .715-.027l2.964-1.427a.9.9 0 0 0 .51-.81V3.163a.9.9 0 0 0-.51-.81L11.726.926a.897.897 0 0 0-1.023.174L5.027 6.279 2.555 4.402a.6.6 0 0 0-.766.034l-.793.721a.6.6 0 0 0 0 .888L3.14 8 .996 9.957a.6.6 0 0 0 0 .887l.793.721a.6.6 0 0 0 .766.034l2.472-1.876 5.676 5.178c.09.09.195.157.308.201Zm.591-10.37L7.296 8l4.306 3.269V4.732Z",
                    fill: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("clipPath", {
                    id: "vscode_svg__a",
                    children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h16v16H0z"
                    })
                })
            })
        ]
    });
var $0cdc27807401b728$export$2e2bcd8739ae039 = $0cdc27807401b728$var$SvgVscode;


function $70a6bd756124047e$export$83253b7d41b9b623(props) {
    const { path: path, definition: { range: range, file: file } } = props;
    const line = range.start.line + 1;
    const column = range.start.column + 1;
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($70a6bd756124047e$var$Link, {
        href: `vscode://file/${path}/${file}:${line}:${column}`,
        "aria-label": `Open in VS Code`,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0cdc27807401b728$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("span", {
                children: [
                    file,
                    " L:",
                    line,
                    " C:",
                    column
                ]
            })
        ]
    }, file);
}
const $70a6bd756124047e$var$Link = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).a(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    display: grid;
    grid: auto / min-content auto;
    align-items: center;
    width: fit-content;
    gap: 8px;
    color: ${theme.color.fg.muted};

    &:hover {
      color: ${theme.color.fg.default};
      text-decoration: underline;
    }
  `);


function $7e238b08b3b56153$export$9076b358b44b9252(props) {
    const { sourceLocation: sourceLocation } = props;
    const definition = sourceLocation.definition || sourceLocation.instrumentation;
    if (!definition) return null;
    if (props.type === "text") return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $3827d9421870a8da$export$67efe7a6dccb9914), {
        definition: definition
    });
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $70a6bd756124047e$export$83253b7d41b9b623), {
        definition: definition,
        path: sourceLocation.path
    });
}


function $82fbd94b7dc617c2$export$381c2295fbe7b5eb(props) {
    const { value: linkSettings } = (0, $a82ff438e9d7ee7b$export$14a266f6d49360ef)();
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $afa7be861492543f$exports.Fragment), {
        children: props.data.map((sourceLocation, index)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $7e238b08b3b56153$export$9076b358b44b9252), {
                sourceLocation: sourceLocation,
                type: linkSettings === "vscode" ? "vscode" : "text"
            }, index))
    });
}







var $2gcPZ = parcelRequire("2gcPZ");


/**
 * This is the rectangle that the graph lines are drawn to/from
 */ const $031a788638d96e6b$export$eb077e679c213897 = 10;
const $031a788638d96e6b$export$2632ce76b419a164 = 25;
const $031a788638d96e6b$export$eb0a3df2028adadd = 5;
const $031a788638d96e6b$export$d3cda41e44a6352b = 7;
const $031a788638d96e6b$export$f981f70d61d1405a = 200;
const $031a788638d96e6b$export$507b37241cc637ae = 48;
const $031a788638d96e6b$export$793ed84f5e13fedc = 2;




const $2e1166b070d8ce1b$export$d3716278a214a826 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).rect(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    fill: ${theme.color.bg.emphasis.default};
    fill-opacity: 1;
    stroke-width: 1;
    stroke: ${theme.color.border.default};
  `);
const $2e1166b070d8ce1b$export$6d577df87755bf76 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).path(({ theme: theme, fill: fill })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    fill: ${fill || theme.color.primary.grape.alpha[300]};
  `);
function $2e1166b070d8ce1b$export$807353b0fb179a04(props) {
    const { id: id, from: from, to: to, fromOpacity: fromOpacity = 0, toOpacity: toOpacity = 1 } = props;
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("linearGradient", {
        id: id,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                stopColor: from,
                offset: "0%",
                stopOpacity: fromOpacity
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                stopColor: to,
                offset: "100%",
                stopOpacity: toOpacity
            })
        ]
    });
}
function $2e1166b070d8ce1b$export$2bb7e317d1d704d1({ id: id, reverse: reverse }) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("defs", {
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("pattern", {
            id: id,
            width: "8",
            height: "8",
            patternTransform: `rotate(${reverse ? "" : "-"}45 0 0)`,
            patternUnits: "userSpaceOnUse",
            children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($2e1166b070d8ce1b$var$EmptyLine, {
                x1: "1",
                y1: "0",
                x2: "1",
                y2: "8"
            })
        })
    });
}
const $2e1166b070d8ce1b$var$EmptyLine = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).line(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    stroke: ${theme.color.primary.grape.alpha[300]};
    stroke-width: 2px;
    stroke-linecap: round;
  `);




var $2gcPZ = parcelRequire("2gcPZ");









const $9603b1710251dc9f$export$c05cc9851db0f76f = (props)=>{
    const { y: y, width: width, height: height, name: name, module: module, align: align, value: value } = props;
    const x = Number.isNaN(props.x) ? 20 : props.x;
    const { metricType: metricType, searchParams: searchParams } = (0, $24d3f45678877ad9$export$4d9cbd22a8347c37)();
    const generateUrl = (name, module, service)=>{
        return {
            pathname: (0, $c12fb649da40a3f2$export$caded91e4645de6)(name, module, service, metricType),
            search: searchParams.toString()
        };
    };
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("foreignObject", {
        x: x,
        y: y,
        width: width,
        height: height,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($9603b1710251dc9f$var$Container, {
            children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($9603b1710251dc9f$var$Label, {
                to: generateUrl(name, module),
                "aria-label": `${value}`,
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($9603b1710251dc9f$var$TextSection, {
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($9603b1710251dc9f$var$Text, {
                                $align: align,
                                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("strong", {
                                    children: name
                                })
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($9603b1710251dc9f$var$Text, {
                                $align: align,
                                children: module || null
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0a830394bc38e4e3$export$f04a61298a47a40f), {
                        type: "link_out"
                    })
                ]
            })
        })
    });
};
const $9603b1710251dc9f$var$Container = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: grid;
  width: 100%;
  height: 100%;
  align-items: center;
`;
const $9603b1710251dc9f$var$Label = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $e7b98158099ae00d$export$a6c7ac8248d6e38a))(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    display: grid;
    grid-template-columns: 1fr 20px;
    align-items: center;
    gap: 8px;
    color: ${theme.color.fg.default};
    cursor: pointer;
    background-color: ${theme.color.bg.hover};

    padding: 4px 8px;
    border-radius: 8px;
    min-width: 0;

    &:hover {
      color: ${theme.color.fg.default};
      background-color: ${theme.color.bg.elevated.hover};
    }
  `);
const $9603b1710251dc9f$var$TextSection = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  line-height: 1.3em;
`;
const $9603b1710251dc9f$var$Text = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme, $align: $align })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    fill: ${theme.color.fg.default};
    font: ${theme.font.body.sm.regular};
    text-align: ${$align};
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  `);


function $4d10905f338cd68d$export$b5aea0e2c615808(props) {
    const { totalNodeHeight: totalNodeHeight, incomingNodes: incomingNodes, valueToPixelRatio: valueToPixelRatio, renderValue: renderValue, middle: middle, renderGradients: renderGradients = false } = props;
    let incomingNodeY = (0, $031a788638d96e6b$export$793ed84f5e13fedc);
    let centerY = 1;
    const halfwayPoint = (middle - (0, $031a788638d96e6b$export$f981f70d61d1405a)) * 0.5 + (0, $031a788638d96e6b$export$f981f70d61d1405a);
    const theme = (0, $4e8e6ea7d6e48c37$export$93d4e7f90805808f)();
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("g", {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $2e1166b070d8ce1b$export$2bb7e317d1d704d1), {
                id: "incoming-empty"
            }),
            incomingNodes.map((node, index)=>{
                const nodeHeight = Math.max(node.value * valueToPixelRatio, (0, $031a788638d96e6b$export$eb0a3df2028adadd));
                centerY += nodeHeight;
                const topCoordinate = nodeHeight < (0, $031a788638d96e6b$export$507b37241cc637ae) ? incomingNodeY + 0.5 * ((0, $031a788638d96e6b$export$507b37241cc637ae) - nodeHeight) : incomingNodeY;
                const labelY = Math.max(incomingNodeY, incomingNodeY - 0.5 * ((0, $031a788638d96e6b$export$507b37241cc637ae) - nodeHeight));
                incomingNodeY += Math.max(nodeHeight, (0, $031a788638d96e6b$export$507b37241cc637ae)) + (0, $031a788638d96e6b$export$d3cda41e44a6352b);
                const topAmountCoordinate = centerY - nodeHeight;
                const fraction = 2 * (node.value * valueToPixelRatio) / totalNodeHeight;
                return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $2gcPZ.Fragment), {
                    children: [
                        renderGradients && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("defs", {
                            children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $2e1166b070d8ce1b$export$807353b0fb179a04), {
                                id: `incoming${index}`,
                                to: theme.color.bg.accent[1],
                                toOpacity: Math.min(0.7, fraction)
                            })
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $2e1166b070d8ce1b$export$d3716278a214a826), {
                            x: (0, $031a788638d96e6b$export$f981f70d61d1405a),
                            y: topCoordinate,
                            width: (0, $031a788638d96e6b$export$eb077e679c213897),
                            height: nodeHeight,
                            "aria-label": renderValue(node.value)
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $2e1166b070d8ce1b$export$6d577df87755bf76), {
                            fill: node.value === 0 ? "url(#incoming-empty)" : undefined,
                            d: `
                M${(0, $031a788638d96e6b$export$eb077e679c213897) + (0, $031a788638d96e6b$export$f981f70d61d1405a)} ${topCoordinate} 
                C${halfwayPoint},${topCoordinate} ${halfwayPoint},${topAmountCoordinate} ${middle},${topAmountCoordinate} 
                L${middle},${centerY} 
                C${halfwayPoint},${centerY} ${halfwayPoint},${topCoordinate + nodeHeight} ${(0, $031a788638d96e6b$export$eb077e679c213897) + (0, $031a788638d96e6b$export$f981f70d61d1405a)},${topCoordinate + nodeHeight}
                Z
            `
                        }),
                        renderGradients && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $2e1166b070d8ce1b$export$6d577df87755bf76), {
                            fill: `url(#incoming${index})`,
                            d: `
                  M${(0, $031a788638d96e6b$export$eb077e679c213897) + (0, $031a788638d96e6b$export$f981f70d61d1405a)} ${topCoordinate} 
                  C${halfwayPoint},${topCoordinate} ${halfwayPoint},${topAmountCoordinate} ${middle},${topAmountCoordinate} 
                  L${middle},${centerY} 
                  C${halfwayPoint},${centerY} ${halfwayPoint},${topCoordinate + nodeHeight} ${(0, $031a788638d96e6b$export$eb077e679c213897) + (0, $031a788638d96e6b$export$f981f70d61d1405a)},${topCoordinate + nodeHeight}
                  Z
                `
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $9603b1710251dc9f$export$c05cc9851db0f76f), {
                            x: 0,
                            y: labelY,
                            width: 192,
                            height: (0, $031a788638d96e6b$export$507b37241cc637ae),
                            align: "start",
                            name: node.name,
                            module: node.module,
                            service: node.service_name,
                            value: renderValue(node.value)
                        })
                    ]
                }, node.name);
            })
        ]
    });
}




var $2gcPZ = parcelRequire("2gcPZ");




function $aaf399f20b0e3777$export$aacc4830c28421a8(props) {
    const { outgoingNodes: outgoingNodes, valueToPixelRatio: valueToPixelRatio, renderValue: renderValue, middle: middle, right: right, renderGradients: renderGradients = false, totalNodeHeight: totalNodeHeight } = props;
    let outgoingNodeY = (0, $031a788638d96e6b$export$793ed84f5e13fedc);
    let centerY = 1;
    const rightBetweenPoint = (right - middle) * 0.5 + middle;
    const theme = (0, $4e8e6ea7d6e48c37$export$93d4e7f90805808f)();
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("g", {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $2e1166b070d8ce1b$export$2bb7e317d1d704d1), {
                id: "outgoing-empty",
                reverse: true
            }),
            outgoingNodes.map((node, index)=>{
                const nodeHeight = Math.max(node.value * valueToPixelRatio, (0, $031a788638d96e6b$export$eb0a3df2028adadd));
                centerY += nodeHeight;
                const topCoordinate = nodeHeight < (0, $031a788638d96e6b$export$507b37241cc637ae) ? outgoingNodeY + 0.5 * ((0, $031a788638d96e6b$export$507b37241cc637ae) - nodeHeight) : outgoingNodeY;
                const labelY = Math.max(outgoingNodeY, outgoingNodeY - 0.5 * ((0, $031a788638d96e6b$export$507b37241cc637ae) - nodeHeight));
                outgoingNodeY += Math.max(nodeHeight, (0, $031a788638d96e6b$export$507b37241cc637ae)) + (0, $031a788638d96e6b$export$d3cda41e44a6352b);
                const topAmountCoordinate = centerY - nodeHeight;
                const fraction = node.value * valueToPixelRatio / totalNodeHeight;
                return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $2gcPZ.Fragment), {
                    children: [
                        renderGradients && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("defs", {
                            children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $2e1166b070d8ce1b$export$807353b0fb179a04), {
                                id: `outgoing${index}`,
                                to: theme.color.accent.rust[700],
                                toOpacity: Math.min(1, fraction)
                            })
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $2e1166b070d8ce1b$export$d3716278a214a826), {
                            x: right,
                            y: topCoordinate,
                            width: (0, $031a788638d96e6b$export$eb077e679c213897),
                            height: nodeHeight
                        }),
                        renderGradients && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $2e1166b070d8ce1b$export$6d577df87755bf76), {
                            fill: `url(#outgoing${index})`,
                            d: `
              M${right} ${topCoordinate} 
              C${rightBetweenPoint},${topCoordinate} ${rightBetweenPoint},${topAmountCoordinate} ${middle},${topAmountCoordinate} 
              L${middle},${centerY} 
              C${rightBetweenPoint},${centerY} ${rightBetweenPoint},${topCoordinate + nodeHeight} ${right},${topCoordinate + nodeHeight} 
              Z
            `
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $2e1166b070d8ce1b$export$6d577df87755bf76), {
                            fill: node.value === 0 ? "url(#outgoing-empty)" : undefined,
                            d: `
              M${right} ${topCoordinate} 
              C${rightBetweenPoint},${topCoordinate} ${rightBetweenPoint},${topAmountCoordinate} ${middle},${topAmountCoordinate} 
              L${middle},${centerY} 
              C${rightBetweenPoint},${centerY} ${rightBetweenPoint},${topCoordinate + nodeHeight} ${right},${topCoordinate + nodeHeight} 
              Z
            `
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $9603b1710251dc9f$export$c05cc9851db0f76f), {
                            x: right + (0, $031a788638d96e6b$export$eb077e679c213897) + 8,
                            y: labelY - 2,
                            width: 192,
                            height: (0, $031a788638d96e6b$export$507b37241cc637ae),
                            align: "start",
                            name: node.name,
                            module: node.module,
                            value: renderValue(node.value)
                        })
                    ]
                }, node.name);
            })
        ]
    });
}



function $938d190478a56785$export$aa05d3e147ece210(incomingNodes, outgoingNodes) {
    const incomingNodesCount = incomingNodes.length;
    const outgoingNodesCount = outgoingNodes.length;
    const maxNodes = Math.max(incomingNodesCount, outgoingNodesCount);
    const estimatedHeight = maxNodes * (0, $031a788638d96e6b$export$2632ce76b419a164) - (0, $031a788638d96e6b$export$d3cda41e44a6352b);
    // Get the total amount of incoming/outgoing calls
    const incomingAmount = incomingNodes.reduce((accumulator, node)=>accumulator + node.value, 0);
    const outgoingAmount = outgoingNodes.reduce((accumulator, node)=>accumulator + node.value, 0);
    const largestAmount = Math.max(incomingAmount, outgoingAmount);
    // Calculate the total space for the lines/nodes (excluding PADDING)
    // This estimatedHeight might change later if we have many nodes that are too small
    let totalNodeHeight = largestAmount === 0 ? maxNodes * (0, $031a788638d96e6b$export$eb0a3df2028adadd) : estimatedHeight;
    // Calculate the target ratio amount -> pixels (height)
    // However if the largestAmount === 0 there's no valueToPixelRatio to calculate
    const valueToPixelRatio = largestAmount === 0 ? 0 : totalNodeHeight / largestAmount;
    // Recalculate the height based on the valueToPixelRatio (and allow for a minimal height of MINIMAL_NODE_HEIGHT)
    totalNodeHeight = Math.max(incomingNodes.reduce((accumulator, node)=>accumulator + Math.max(node.value * valueToPixelRatio, (0, $031a788638d96e6b$export$eb0a3df2028adadd)), 0), outgoingNodes.reduce((accumulator, node)=>accumulator + Math.max(node.value * valueToPixelRatio, (0, $031a788638d96e6b$export$eb0a3df2028adadd)), 0));
    const incomingNodeHeight = incomingNodes.reduce((accumulator, node)=>accumulator + Math.max(node.value * valueToPixelRatio, (0, $031a788638d96e6b$export$eb0a3df2028adadd), (0, $031a788638d96e6b$export$507b37241cc637ae)) + (0, $031a788638d96e6b$export$d3cda41e44a6352b), 0);
    const outgoingNodeHeight = outgoingNodes.reduce((accumulator, node)=>accumulator + Math.max(node.value * valueToPixelRatio, (0, $031a788638d96e6b$export$eb0a3df2028adadd), (0, $031a788638d96e6b$export$507b37241cc637ae)) + (0, $031a788638d96e6b$export$d3cda41e44a6352b), 0);
    return {
        height: Math.max(incomingNodeHeight, outgoingNodeHeight),
        totalNodeHeight: totalNodeHeight,
        valueToPixelRatio: valueToPixelRatio
    };
}


function $e3451fb38186547b$export$d5e39a2871af1b21(props) {
    const { incomingNodes: originalIncomingNodes, outgoingNodes: originalOutgoingNodes, renderValue: renderValue, renderGradients: renderGradients = false } = props;
    const [ref, { width: width = 600 }] = (0, $b8b5111030e66ef0$export$2e2bcd8739ae039)();
    const incomingNodes = [
        ...originalIncomingNodes
    ].sort((a, b)=>b.value - a.value);
    const outgoingNodes = [
        ...originalOutgoingNodes
    ].sort((a, b)=>b.value - a.value);
    const { totalNodeHeight: totalNodeHeight, height: height, valueToPixelRatio: valueToPixelRatio } = (0, $938d190478a56785$export$aa05d3e147ece210)(incomingNodes, outgoingNodes);
    const right = width - 200 - (0, $031a788638d96e6b$export$eb077e679c213897);
    const leftMiddle = width / 2 - (0, $031a788638d96e6b$export$eb077e679c213897) / 2;
    const rightMiddle = leftMiddle + (0, $031a788638d96e6b$export$eb077e679c213897);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("div", {
        ref: ref,
        children: width > 0 && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
            viewBox: `0 0 ${width} ${height + 15}`,
            children: [
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("g", {
                    children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $2e1166b070d8ce1b$export$d3716278a214a826), {
                        width: (0, $031a788638d96e6b$export$eb077e679c213897),
                        height: totalNodeHeight,
                        x: width / 2 - (0, $031a788638d96e6b$export$eb077e679c213897) / 2,
                        y: 1
                    })
                }),
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $4d10905f338cd68d$export$b5aea0e2c615808), {
                    incomingNodes: incomingNodes,
                    middle: leftMiddle,
                    renderValue: renderValue,
                    totalNodeHeight: totalNodeHeight,
                    valueToPixelRatio: valueToPixelRatio,
                    renderGradients: renderGradients
                }),
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $aaf399f20b0e3777$export$aacc4830c28421a8), {
                    middle: rightMiddle,
                    outgoingNodes: outgoingNodes,
                    renderValue: renderValue,
                    right: right,
                    totalNodeHeight: totalNodeHeight,
                    renderGradients: renderGradients,
                    valueToPixelRatio: valueToPixelRatio
                })
            ]
        })
    });
}






function $3c75587ec8349fa8$var$simplifyFormattedNumber(value) {
    return value.replace(/\.?0+$/, "").replace(/\.$/, "");
}
function $3c75587ec8349fa8$export$f5dd818bff069720(value) {
    // Check if the value is greater than or equal to 100
    if (value >= 100) // Limit the value of digits after the decimal point to 2
    return $3c75587ec8349fa8$var$simplifyFormattedNumber(value.toFixed(2));
    if (value >= 10) // Limit the value of digits after the decimal point to 2
    return $3c75587ec8349fa8$var$simplifyFormattedNumber(value.toFixed(4));
    if (value >= 1) // Limit the value of digits after the decimal point to 2
    return $3c75587ec8349fa8$var$simplifyFormattedNumber(value.toFixed(6));
    return $3c75587ec8349fa8$var$simplifyFormattedNumber(value.toFixed(7));
}



const $bd24ab81077c53a9$var$EMPTY_CALL_GRAPH_NODE = [];
function $bd24ab81077c53a9$export$80e2436cbcc5a677({ functionName: functionName, isLoading: isLoading, incomingResult: incomingResult, outgoingResult: outgoingResult, metricType: metricType }) {
    const incomingNodes = (0, $2gcPZ.useMemo)(()=>incomingResult?.map((value)=>({
                name: value.metric.caller_function,
                module: value.metric.caller_module,
                value: Number.parseFloat(value.value[1])
            })) ?? $bd24ab81077c53a9$var$EMPTY_CALL_GRAPH_NODE, [
        incomingResult
    ]);
    const outgoingNodes = (0, $2gcPZ.useMemo)(()=>outgoingResult?.map((value)=>({
                name: value.metric.function,
                module: value.metric.module,
                value: Number.parseFloat(value.value[1])
            })) ?? $bd24ab81077c53a9$var$EMPTY_CALL_GRAPH_NODE, [
        outgoingResult
    ]);
    if (isLoading) return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $c624abcc931dc034$export$bd7370ffb2917ab7), {
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $b6465ff4e4132c39$export$669f6ea7d267feaf), {})
    }, "functionPageCallGraphIsLoading");
    const noData = incomingNodes.length === 0 && outgoingNodes.length === 0;
    const renderValue = metricType === "errorRatio" ? (value)=>`Error ratio: ${(0, $3c75587ec8349fa8$export$f5dd818bff069720)(value)}%` : (value)=>`${(0, $3c75587ec8349fa8$export$f5dd818bff069720)(value)} calls/sec`;
    const metrics = noData || metricType !== "requestRate" ? [] : [
        {
            reportType: "incoming",
            value: (0, $3c75587ec8349fa8$export$f5dd818bff069720)(incomingNodes.reduce((sum, { value: value })=>sum + value, 0)),
            unit: "calls/sec"
        },
        {
            reportType: "outgoing",
            value: (0, $3c75587ec8349fa8$export$f5dd818bff069720)(outgoingNodes.reduce((sum, { value: value })=>sum + value, 0)),
            unit: "calls/sec"
        }
    ];
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $2042716e2270aa85$export$ef2184bd89960b14), {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($bd24ab81077c53a9$var$CallGraphHeaderSection, {
                children: [
                    metrics && metrics.length > 0 && // grid-area: "metrics"
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($bd24ab81077c53a9$var$CallGraphObjectiveMetricsWrapper, {
                        children: metrics.map(({ reportType: reportType, value: value, unit: unit }, index)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($bd24ab81077c53a9$var$CallGraphMetricDisplay, {
                                rate: value,
                                unit: unit,
                                report: reportType
                            }, index))
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($bd24ab81077c53a9$var$InfoIcon, {
                        type: "info",
                        width: "16",
                        height: "16",
                        "aria-label": "The height of the lines in the graph below indicate the amount. If line sections have diagonal lines then they indicate a 0 value"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $2042716e2270aa85$export$c4a562231524e009), {
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($bd24ab81077c53a9$var$CallGraphContainer, {
                    children: [
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($bd24ab81077c53a9$var$CallGraphContainerHeader, {
                            children: [
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($bd24ab81077c53a9$var$CallGraphHeaderIncoming, {
                                    children: "Incoming"
                                }),
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($bd24ab81077c53a9$var$CallGraphHeaderMain, {
                                    children: functionName
                                }),
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($bd24ab81077c53a9$var$CallGraphHeaderOutgoing, {
                                    children: "Outgoing"
                                })
                            ]
                        }),
                        noData ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $afa7be861492543f$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($bd24ab81077c53a9$var$NoDataSpacer, {}),
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $b289d9cb7ca375da$export$e4ba1b9b774550b4), {})
                            ]
                        }) : /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $e3451fb38186547b$export$d5e39a2871af1b21), {
                            renderGradients: metricType === "errorRatio",
                            renderValue: renderValue,
                            outgoingNodes: outgoingNodes,
                            incomingNodes: incomingNodes
                        })
                    ]
                })
            })
        ]
    });
}
const $bd24ab81077c53a9$var$CallGraphHeaderSection = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: grid;
  grid-area: metrics;
  grid-template-columns: auto 16px;
  grid-template-areas: "metrics icon";
  gap: 8px;
`;
const $bd24ab81077c53a9$var$InfoIcon = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $0a830394bc38e4e3$export$f04a61298a47a40f))`
  grid-area: icon;
`;
const $bd24ab81077c53a9$var$CallGraphObjectiveMetricsWrapper = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $2042716e2270aa85$export$2e0db495abdb18ec))`
  justify-content: space-between;
`;
const $bd24ab81077c53a9$var$CallGraphMetricDisplay = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $2042716e2270aa85$export$73722bc4ca9ba271))`
  flex: 200px 0 0;
`;
const $bd24ab81077c53a9$var$CallGraphContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  margin-top: 16px;
  display: grid;
  gap: 12px;
  align-items: center;
  position: relative;
  min-width: 600px;
`;
const $bd24ab81077c53a9$var$NoDataSpacer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  position: relative;
  height: 207px;
  min-width: 380px;
  margin: 20px 0;
`;
const $bd24ab81077c53a9$var$CallGraphContainerHeader = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    display: grid;
    grid-template-columns: 200px auto 200px;
    font: ${theme.font.body.md};
  `);
const $bd24ab81077c53a9$var$CallGraphHeaderIncoming = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  text-align: right;
`;
const $bd24ab81077c53a9$var$CallGraphHeaderMain = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  text-align: center;
`;
const $bd24ab81077c53a9$var$CallGraphHeaderOutgoing = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  text-align: left;
`;






function $09d2e9a1d35fdeb5$export$c5f6100e9951d145() {
    const { metricType: metricType, moduleParameter: moduleParameter, contentType: contentType, searchParams: currentSearchParams } = (0, $24d3f45678877ad9$export$4d9cbd22a8347c37)();
    const supportedContentTypes = (0, $24d3f45678877ad9$export$8464b961cdde59f9)(metricType);
    const shouldShowGraph = contentType === (0, $24d3f45678877ad9$export$54428e230c7f6b57);
    const shouldShowCallGraph = contentType === (0, $24d3f45678877ad9$export$bd11c95869e508f9);
    const { getAccentColorForIndex: getAccentColorForIndex } = (0, $a7634f2acd528865$export$bd4b012f42a4dab7)();
    const { timeRange: timeRange, isRelativeTimeRange: isRelativeTimeRange, onChangeTimeRange: onChangeTimeRange, refreshRelativeTimeRange: refreshRelativeTimeRange } = (0, $326a17b5958d0a0c$export$43bf3df9dfee3ce5)();
    const { moduleName: moduleName, functionName: functionName, serviceName: serviceName, prometheusData: prometheusData, callGraphData: callGraphData, events: events, sourceCodeLinks: sourceCodeLinks } = (0, $74e390d084ece18b$export$3bb55d1a5baebf22)(timeRange, moduleParameter === undefined);
    const currentMetric = prometheusData[metricType];
    const currentMetricData = currentMetric?.data;
    const { title: title, index: index } = (0, $17af91cc7c2ff505$export$93b9a4727f4f0778)(metricType);
    const color = getAccentColorForIndex(index);
    const { value: linkSettings } = (0, $a82ff438e9d7ee7b$export$14a266f6d49360ef)();
    const loadingGraphData = callGraphData.outgoingQuery.isFetching || callGraphData.incomingQuery.isFetching;
    if (!currentMetric) return null;
    if (currentMetric.error) return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $7f2b92de158af7af$export$5eef44829f72c6d0), {});
    // NOTE - WE only show "refresh" logic for relative time ranges (i.e., the presets in the date picker)
    const shouldShowRefresh = isRelativeTimeRange && currentMetric.isSuccess;
    const lastUpdatedAt = new Date(currentMetric.fulfilledTimeStamp);
    const isRefetching = currentMetric.isFetching;
    const refetchMetricData = ()=>{
        // NOTE - We cannot update the data using RTK-query's `refetch`,
        //        since it will just use the same prometheus query as before,
        //        which contains a hardcoded time range.
        //        (This means we would end up getting the same data back, and nothing would change in the UI.)
        //
        //        Instead, we update everything by just recomputing the relative time range.
        //
        refreshRelativeTimeRange();
    };
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($09d2e9a1d35fdeb5$var$FunctionsExplorerContainer, {
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($09d2e9a1d35fdeb5$var$FunctionsExplorerContent, {
            className: "functionPageContainerChild",
            children: [
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($09d2e9a1d35fdeb5$var$HeadingWrapper, {
                    children: [
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($09d2e9a1d35fdeb5$var$PageHeading, {
                            children: moduleName ?? "Live metrics for your autometrics function"
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($09d2e9a1d35fdeb5$var$PageSubheadingWrapper, {
                            children: [
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($09d2e9a1d35fdeb5$var$NameAndLastUpdated, {
                                    children: [
                                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("h1", {
                                            children: functionName
                                        }),
                                        shouldShowRefresh && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $ea0b2a3aa915942e$export$2b7b2ce432c10f7c), {
                                            isRefreshing: isRefetching,
                                            lastUpdatedAt: lastUpdatedAt,
                                            refresh: refetchMetricData
                                        })
                                    ]
                                }),
                                linkSettings !== "off" && sourceCodeLinks.data && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $82fbd94b7dc617c2$export$381c2295fbe7b5eb), {
                                    data: sourceCodeLinks.data
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $b0893cc2f3fde9b8$export$2631a3ab3cdd158d), {
                    children: Object.entries(prometheusData).map(([key, { metrics: metrics, data: data }])=>{
                        const latestMetric = metrics.find(({ reportType: reportType })=>reportType === "latest");
                        if (!latestMetric) return null;
                        const { title: title, index: index, description: description } = (0, $17af91cc7c2ff505$export$93b9a4727f4f0778)(key);
                        const color = getAccentColorForIndex(index);
                        const path = (0, $c12fb649da40a3f2$export$caded91e4645de6)(functionName, moduleName, serviceName, key);
                        return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($09d2e9a1d35fdeb5$var$MetricLink, {
                            to: {
                                pathname: path,
                                search: currentSearchParams.toString()
                            },
                            children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $7cce17cd3ba704c5$export$8b799af4f3123f30), {
                                brandColor: color,
                                isActive: metricType === key,
                                latestValue: latestMetric.value,
                                latestValueUnit: latestMetric.unit,
                                title: title,
                                info: description,
                                data: data,
                                timeRange: timeRange
                            })
                        }, key);
                    })
                }),
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($09d2e9a1d35fdeb5$var$FunctionDetailsContainer, {
                    children: [
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($09d2e9a1d35fdeb5$var$FunctionDescriptionWrapper, {
                            children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("h4", {
                                children: title
                            })
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($09d2e9a1d35fdeb5$var$TabContainer, {
                            children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $206fa7d93be79d44$export$b2539bed5023c21c), {
                                children: [
                                    supportedContentTypes.length > 1 && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $206fa7d93be79d44$export$e51a686c67fdaa2d), {
                                        children: [
                                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $206fa7d93be79d44$export$3e41faf802a29e71), {
                                                to: {
                                                    search: (0, $28ccb008950fefda$export$43bc4cfd2456f165)(currentSearchParams, "contentType", (0, $24d3f45678877ad9$export$54428e230c7f6b57)).toString(),
                                                    replace: shouldShowGraph
                                                },
                                                isActive: shouldShowGraph,
                                                asElement: "link",
                                                children: [
                                                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0a830394bc38e4e3$export$f04a61298a47a40f), {
                                                        type: "graph_duotone"
                                                    }),
                                                    "Graph"
                                                ]
                                            }, (0, $24d3f45678877ad9$export$54428e230c7f6b57)),
                                            supportedContentTypes.includes((0, $24d3f45678877ad9$export$bd11c95869e508f9)) && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $206fa7d93be79d44$export$3e41faf802a29e71), {
                                                to: {
                                                    search: (0, $28ccb008950fefda$export$43bc4cfd2456f165)(currentSearchParams, "contentType", (0, $24d3f45678877ad9$export$bd11c95869e508f9)).toString(),
                                                    replace: shouldShowCallGraph
                                                },
                                                isActive: shouldShowCallGraph,
                                                asElement: "link",
                                                children: [
                                                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0a830394bc38e4e3$export$f04a61298a47a40f), {
                                                        type: "call_graph"
                                                    }),
                                                    "Call graph"
                                                ]
                                            }, (0, $24d3f45678877ad9$export$bd11c95869e508f9))
                                        ]
                                    }),
                                    shouldShowGraph && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $afa7be861492543f$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $bf9cd47341cbb418$export$614db49f3febe941), {
                                                color: color,
                                                currentMetric: currentMetric,
                                                currentMetricData: currentMetricData,
                                                metricType: metricType,
                                                onChangeTimeRange: onChangeTimeRange,
                                                events: events,
                                                timeRange: timeRange
                                            }),
                                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($09d2e9a1d35fdeb5$var$QueryContainer, {
                                                children: [
                                                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("h4", {
                                                        children: "PromQL"
                                                    }),
                                                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $c4bae4e8fa7c3f9d$export$62297b13309008b2), {
                                                        text: currentMetric?.promqlQuery
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    shouldShowCallGraph && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $bd24ab81077c53a9$export$80e2436cbcc5a677), {
                                        functionName: functionName,
                                        isLoading: loadingGraphData,
                                        incomingResult: callGraphData.incomingQuery.data?.data?.result,
                                        outgoingResult: callGraphData.outgoingQuery.data?.data?.result,
                                        metricType: metricType
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
}
const $09d2e9a1d35fdeb5$var$FunctionsExplorerContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  /* @container defined in ./FunctionPage.css */
  container: functionPageContainer / inline-size;
`;
const $09d2e9a1d35fdeb5$var$FunctionsExplorerContent = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: { spacing: spacing } })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      display: grid;
      grid-template-rows: repeat(3, auto) 1fr;
      position: relative;

      padding-inline: ${spacing.page.inline};
      padding-block: ${spacing.page.block};
      gap: ${spacing.page.gap};
    `);
const $09d2e9a1d35fdeb5$var$HeadingWrapper = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: grid;
  gap: 8px;
`;
const $09d2e9a1d35fdeb5$var$PageHeading = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).h4(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      color: ${theme.color.fg.subtle};
    `);
const $09d2e9a1d35fdeb5$var$PageSubheadingWrapper = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const $09d2e9a1d35fdeb5$var$NameAndLastUpdated = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: var(--flex-direction-name-last-updated, row);
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
`;
const $09d2e9a1d35fdeb5$var$MetricLink = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $e7b98158099ae00d$export$a6c7ac8248d6e38a))`
  color: inherit;
  text-decoration: none;
`;
const $09d2e9a1d35fdeb5$var$FunctionDetailsContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $2042716e2270aa85$export$42a852a2b6b56249))(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      display: grid;
      gap: 24px; /* TODO (Oscar): add responsive spacing value */
      grid-template:
        "heading" auto
        "graph" auto
        "query" auto / auto;
      padding: 0;
      border-radius: ${theme.radius.rounded};
      background-color: ${theme.color.bg.subtle};
    `);
const $09d2e9a1d35fdeb5$var$FunctionDescriptionWrapper = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      grid-area: heading;
      padding: 8px 20px;
      // Get the same border radius as the container
      border-radius: inherit;
      background: ${theme.color.bg.hover};
      color: ${theme.color.fg.default};
      font: ${theme.font.headings.h3};
    `);
const $09d2e9a1d35fdeb5$var$TabContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  grid-area: graph;
  padding: 0 20px;
`;
const $09d2e9a1d35fdeb5$var$QueryContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: grid;
  grid: "heading" 40px "query" auto / auto;
`;












var $2gcPZ = parcelRequire("2gcPZ");

function $33224f592fd5d292$export$3d8b76852abe86ae(query) {
    const caller = $33224f592fd5d292$export$b5d18f678c37540b(query);
    if (caller) // Is a caller related function
    return;
    if ($33224f592fd5d292$export$55d6f83d663d1a8e(query)) return "requestRate";
    if ($33224f592fd5d292$export$587e43750b491f22(query)) return "errorRatio";
    if ($33224f592fd5d292$export$40eef26f36d66f38(query)) return "latency";
}
// See how many times the rate for function_calls_count* is used in the query
function $33224f592fd5d292$var$getRequestRateQueryCount(query) {
    const callCountPattern = /rate\s*?\(function_calls_count/g;
    let match = query.match(callCountPattern);
    if (match === null) {
        const alternativeCallPattern = /rate\s*?\(\s*?{\s*?__name__=(~?)"function_calls_count/g;
        match = query.match(alternativeCallPattern);
    }
    if (match === null) {
        const alternativeCallPattern = /rate\s*?\(\s*?{\s*?__name__=(~?)"function_calls\(_count\)/g;
        match = query.match(alternativeCallPattern);
    }
    return match?.length ?? 0;
}
// If only once it's likely a single function request rate query
function $33224f592fd5d292$var$isMultiRequestRateQuery(query) {
    return $33224f592fd5d292$var$getRequestRateQueryCount(query) > 1;
}
function $33224f592fd5d292$export$55d6f83d663d1a8e(query) {
    return $33224f592fd5d292$var$getRequestRateQueryCount(query) === 1;
}
function $33224f592fd5d292$export$587e43750b491f22(query) {
    if ($33224f592fd5d292$var$isMultiRequestRateQuery(query) === false) return false;
    const errorRatioPattern = /result="error"/;
    const match = query.match(errorRatioPattern);
    return match !== null;
}
function $33224f592fd5d292$export$40eef26f36d66f38(query) {
    return query.includes('"percentile_latency"') && query.includes("histogram_quantile");
}
function $33224f592fd5d292$export$aad197c7121a6651(query) {
    const pattern = /function(\s*)=(~?)"(?<name>\w*)"/;
    const match = query.match(pattern);
    if (match === null) return undefined;
    return match.groups?.name;
}
function $33224f592fd5d292$export$73be28aa0626e9a4(query) {
    const pattern = /module(\s*)=(~?)"(?<name>\w*)"/;
    const match = query.match(pattern);
    if (match === null) return undefined;
    return match.groups?.name;
}
function $33224f592fd5d292$export$b5d18f678c37540b(query) {
    const pattern = /cal{2}er(\s*)=(~?)"(?<name>\w*)"/;
    const match = query.match(pattern);
    if (match === null) return undefined;
    return match.groups?.name;
}


function $f00dce5c9348e88b$export$b4e8e2b160ce726b() {
    const [params] = (0, $e7b98158099ae00d$export$f1a78c17382fe22a)();
    const rawQuery = params.get("g0.expr") ?? "";
    const result = (0, $2gcPZ.useMemo)(()=>{
        if (rawQuery === "") return;
        const functionName = (0, $33224f592fd5d292$export$aad197c7121a6651)(rawQuery);
        const moduleName = (0, $33224f592fd5d292$export$73be28aa0626e9a4)(rawQuery);
        const metricType = (0, $33224f592fd5d292$export$3d8b76852abe86ae)(rawQuery);
        return {
            functionName: functionName,
            moduleName: moduleName,
            metricType: metricType
        };
    }, [
        rawQuery
    ]);
    return {
        query: rawQuery,
        result: result
    };
}




const { BigIcon: $9e168e6a08a96d8c$var$BigIcon, Container: $9e168e6a08a96d8c$var$Container, Content: $9e168e6a08a96d8c$var$Content, Header: $9e168e6a08a96d8c$var$Header, Heading: $9e168e6a08a96d8c$var$Heading, HelperText: $9e168e6a08a96d8c$var$HelperText } = (0, $0c5c766c1e242605$exports);
function $9e168e6a08a96d8c$export$9327b30e1a5f3d7d({ heading: heading, helperText: helperText }) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($9e168e6a08a96d8c$var$Container, {
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($9e168e6a08a96d8c$var$Content, {
            children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($9e168e6a08a96d8c$var$Header, {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($9e168e6a08a96d8c$var$BigIcon, {
                        type: "warning"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($9e168e6a08a96d8c$var$Heading, {
                        children: heading
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($9e168e6a08a96d8c$var$HelperText, {
                        children: helperText
                    })
                ]
            })
        })
    });
}


function $05945b92f2cc5b07$export$bdc723d08dd9b8f8(props) {
    const { query: query, result: result } = (0, $f00dce5c9348e88b$export$b4e8e2b160ce726b)();
    if (!result) return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("div", {
        children: "This page expects parameters that were not specified"
    });
    if (!props.autometricsData) return null;
    if (!result.functionName) return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $9e168e6a08a96d8c$export$9327b30e1a5f3d7d), {
        heading: "Unable to extract function name from query",
        helperText: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $afa7be861492543f$exports.Fragment), {
            children: [
                "Unable to extract the relevant function name from the query. Received:",
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($05945b92f2cc5b07$var$StyledPre, {
                    children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("code", {
                        children: query
                    })
                })
            ]
        })
    });
    if (!result.metricType) return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $9e168e6a08a96d8c$export$9327b30e1a5f3d7d), {
        heading: "Unable to extract metric type",
        helperText: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $afa7be861492543f$exports.Fragment), {
            children: [
                "The query doesn\u2019t match the expected format of autometrics related queries. The function name was extracted, so instead you may want to look at the function page for",
                " ",
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $e7b98158099ae00d$export$a6c7ac8248d6e38a), {
                    to: (0, $c12fb649da40a3f2$export$caded91e4645de6)(result.functionName, result.moduleName),
                    children: [
                        " ",
                        result.functionName
                    ]
                }),
                ". If you feel like this is a mistake feel free to open an issue on",
                " ",
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("a", {
                    href: "https://github.com/autometrics-dev/am",
                    children: "https://github.com/autometrics-dev/am"
                }),
                ". Attempted to extract query type from:",
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($05945b92f2cc5b07$var$StyledPre, {
                    children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("code", {
                        children: query
                    })
                })
            ]
        })
    });
    const items = props.autometricsData.filter((item)=>{
        return item.name === result.functionName;
    });
    if (items.length === 0 || items.length === 1) {
        const functionName = items[0]?.name ?? result.functionName;
        const moduleName = items[0]?.module ?? result.moduleName;
        const serviceName = items[0]?.service_name;
        return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $efeb47d767416279$export$444b3ab0cb9aec40), {
            to: (0, $c12fb649da40a3f2$export$caded91e4645de6)(functionName, moduleName, serviceName, result.metricType)
        });
    }
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $efeb47d767416279$export$444b3ab0cb9aec40), {
        to: (0, $c12fb649da40a3f2$export$caded91e4645de6)(result.functionName, undefined, undefined, result.metricType)
    });
}
// TODO: use syntax highlighting for query
const $05945b92f2cc5b07$var$StyledPre = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).pre`
  text-align: initial;
  min-width: 0;
  max-width: 100%;
  overflow-x: scroll;
  display: block;
  background: transparent;
  color: inherit;
`;






var $2gcPZ = parcelRequire("2gcPZ");


var $e383728c6bfde635$exports = {};
"use strict";
$e383728c6bfde635$exports = function() {
    throw new Error("Don't instantiate Resizable directly! Use require('react-resizable').Resizable");
};

$e383728c6bfde635$exports.Resizable = (parcelRequire("iTIA1")).default;

$e383728c6bfde635$exports.ResizableBox = (parcelRequire("gSv69")).default;






var $2gcPZ = parcelRequire("2gcPZ");




var $2gcPZ = parcelRequire("2gcPZ");


function $0379ace7bea2febc$export$79a4ab773c7ace54(node) {
    // Currently FunctionTree doesn't have access to the named routes, so we have
    // to use the wildcard route and parse the params ourselves.
    const params = (0, $efeb47d767416279$export$99eaa27ddbbb95ef)()["*"];
    const moduleNode = (0, $2gcPZ.useMemo)(()=>{
        if (!params || node.type === "function") return;
        let module = "";
        let service = "";
        const kvPairs = params.split("/").slice(1, -1);
        for(let index = 0; index < kvPairs.length; index += 2){
            const key = kvPairs[index];
            if (key === "m" && typeof kvPairs[index + 1] === "string") module = kvPairs[index + 1];
            if (key === "s" && typeof kvPairs[index + 1] === "string") service = kvPairs[index + 1];
        }
        if (node.type === "service" && node.name === service) return true;
        if (node.type === "module" && node.name === module) return true;
    }, [
        node.name,
        node.type,
        params
    ]);
    return !!moduleNode;
}
function $0379ace7bea2febc$export$1d663a8875362671({ default: default_, min: min, max: max }) {
    const [storedWidth, setStoredWidth] = (0, $7fd7ff57d61a706f$export$86e2cef2561044ac)("explorer.functionsListWidth", null);
    const getClampedWidth = (0, $2gcPZ.useCallback)((newWidth)=>{
        return Math.min(max, Math.max(newWidth, min));
    }, [
        min,
        max
    ]);
    const width = (0, $2gcPZ.useMemo)(()=>{
        if (storedWidth) return getClampedWidth(storedWidth);
        return getClampedWidth(default_);
    }, [
        storedWidth,
        getClampedWidth,
        default_
    ]);
    // NOTE - It could be good to debounce calls to localstorage in this handler,
    //        but I didn't notice any lag while testing.
    const handleResize = (0, $2gcPZ.useCallback)((event, { size: size })=>{
        setStoredWidth(getClampedWidth(size.width));
    }, [
        setStoredWidth,
        getClampedWidth
    ]);
    return {
        width: width,
        handleResize: handleResize
    };
}




var $bEIGg = parcelRequire("bEIGg");
const $e69fd3c66e7700a7$var$HIERARCHY = [
    "service",
    "module",
    "function"
];
function $e69fd3c66e7700a7$export$1a1a77d806b52ba7(functions) {
    // Initialize the root of the tree
    const tree = {
        id: "root",
        children: [],
        type: "service",
        name: "",
        module: "",
        service_name: ""
    };
    // Loop through each set of function labels and add it to the tree
    // The strategy is to first add the service (if it doesn't exist),
    // then add the module (if it doesn't exist) as a child of the service,
    // then add the function as a child of the module.
    // Effectively, this is a depth-first approach to building the tree.
    for (const function_ of functions){
        // Create a `cursor` to track the current position in the tree
        // We always start at the root node
        let cursor = tree;
        const { name: functionName, module: moduleName, service_name: serviceName } = function_;
        // An array of identifiers which will form the path in the tree
        // These are ordered left-to-right according to the hierarchy of the tree,
        // where the service is at the top, then the module, then the function
        const labelValues = [
            serviceName,
            moduleName,
            functionName
        ];
        // Now we loop through the label values according to the hierarchy of the tree
        //
        // Here the `hierarchyIndex` reflects:
        //   service (0) -> module (1) -> function (2)
        //
        // And the `nodeName` will be our way to look for existing nodes in the tree.
        //   For example, if we're at the module level, we'll search for a node
        //   with the same name as the current module name.
        //
        for (const [hierarchyIndex, nodeName] of labelValues.entries()){
            // If the current node name is undefined, skip it
            if (!nodeName) continue;
            // Reconstruct the node type from known hierarchy.
            // Since we know that index can only be 0, 1, or 2,
            // we can safely map a value from the lookup array.
            const nodeType = $e69fd3c66e7700a7$var$HIERARCHY[hierarchyIndex];
            // Ensure that the current (cursor) tree node has a children array
            if (!cursor.children) cursor.children = [];
            // Look for an existing node in the tree with the same name as the current node
            const existingChild = cursor.children.find((child)=>child.name === nodeName);
            if (existingChild) // If there's already a node with this identifier in the tree,
            // update the cursor to point to that node
            cursor = existingChild;
            else {
                // If this identifier was not found in the tree,
                // create a new child node on the cursor with a unique id,
                // and give it the correct "type" based on its hierarchy (service, function, or module).
                const newChild = {
                    id: (0, $bEIGg.nanoid)(),
                    name: nodeName,
                    module: moduleName ?? "",
                    type: nodeType,
                    service_name: serviceName ?? "",
                    children: []
                };
                cursor.children.push(newChild);
                cursor = newChild;
            }
        }
    }
    $e69fd3c66e7700a7$var$recursiveSort(tree, $e69fd3c66e7700a7$var$sortFunction);
    return tree.children ?? [];
}
function $e69fd3c66e7700a7$var$sortFunction(node1, node2) {
    if (node1.type === node2.type) return node1.name.localeCompare(node2.name);
    // this ensures that more generic group always comes first
    if (node1.type === "service") return -1;
    if (node1.type === "module") {
        if (node2.type === "service") return 1;
        return -1;
    }
    return 1;
}
function $e69fd3c66e7700a7$var$recursiveSort(node, sortFunction) {
    if (node.children) {
        node.children.sort(sortFunction);
        for (const child of node.children)$e69fd3c66e7700a7$var$recursiveSort(child, sortFunction);
    }
}



const $4ed73a3daab450e4$export$f784d0f0a1f56aac = ({ autometricsData: autometricsData, filterValue: filterValue })=>{
    const filteredAutometricsData = (0, $2gcPZ.useMemo)(()=>{
        if (!filterValue) return autometricsData;
        return autometricsData.filter((data)=>data.name.toLowerCase().includes(filterValue.toLowerCase()) || data.module?.toLowerCase().includes(filterValue.toLowerCase()));
    }, [
        autometricsData,
        filterValue
    ]);
    const tree = (0, $2gcPZ.useMemo)(()=>{
        return (0, $e69fd3c66e7700a7$export$1a1a77d806b52ba7)(filteredAutometricsData || []);
    }, [
        filteredAutometricsData
    ]);
    const showEmptyFilterState = !!filterValue && filteredAutometricsData.length === 0;
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $afa7be861492543f$exports.Fragment), {
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($4ed73a3daab450e4$var$FunctionTreeContainer, {
            children: [
                tree.map((node)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($4ed73a3daab450e4$var$FunctionTreeNode, {
                        node: node,
                        forceExpand: !!filterValue
                    }, node.id)),
                showEmptyFilterState && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($4ed73a3daab450e4$var$NoFilteredFunctions, {
                    initial: {
                        opacity: 0,
                        y: 10
                    },
                    animate: {
                        opacity: 1,
                        y: 0
                    },
                    exit: {
                        opacity: 0,
                        y: -10
                    },
                    transition: {
                        duration: 0.1
                    },
                    children: [
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0a830394bc38e4e3$export$f04a61298a47a40f), {
                            type: "autometrics"
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("div", {
                            children: "No matching functions"
                        })
                    ]
                }, "functionTreeListLoadingOuter")
            ]
        })
    });
};
/**
 * Render {@link FunctionTreeNodeData}
 *
 * Note: This component is recursive
 */ function $4ed73a3daab450e4$var$FunctionTreeNode({ node: node, forceExpand: forceExpand }) {
    const isActiveModuleNode = (0, $0379ace7bea2febc$export$79a4ab773c7ace54)(node);
    const [isModuleExpanded, setIsModuleExpanded] = (0, $2gcPZ.useState)(isActiveModuleNode);
    const [currentSearchParams] = (0, $e7b98158099ae00d$export$f1a78c17382fe22a)();
    const isModule = node.type === "module" || node.type === "service";
    const iconClosed = node.type === "service" ? "modules_duotone" : "folder_duotone";
    const iconOpen = node.type === "service" ? "modules_duotone" : "folder_open_duotone";
    const onModuleClick = ()=>setIsModuleExpanded((expanded)=>!expanded);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($4ed73a3daab450e4$var$FunctionTreeNodeContainer, {
        isModule: isModule,
        children: isModule ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $afa7be861492543f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($4ed73a3daab450e4$var$ModuleName, {
                    onClick: onModuleClick,
                    children: [
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($4ed73a3daab450e4$var$ModuleIcon, {
                            type: isModuleExpanded || forceExpand ? "caret_down" : "caret_right"
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($4ed73a3daab450e4$var$ModuleIcon, {
                            type: isModuleExpanded || forceExpand ? iconOpen : iconClosed
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($4ed73a3daab450e4$var$Ellipsis, {
                            title: node.name,
                            children: node.name
                        })
                    ]
                }),
                node.children && (isModuleExpanded || forceExpand) && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($4ed73a3daab450e4$var$FunctionTreeNodeChildrenContainer, {
                    initial: {
                        opacity: 0,
                        height: 0
                    },
                    animate: {
                        opacity: 1,
                        height: "auto"
                    },
                    children: node.children.map((node)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($4ed73a3daab450e4$var$FunctionTreeNode, {
                            node: node,
                            forceExpand: false
                        }, node.id))
                })
            ]
        }) : /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($4ed73a3daab450e4$var$FunctionNavLink, {
            to: {
                pathname: (0, $c12fb649da40a3f2$export$caded91e4645de6)(node.name, node.module, node.service_name),
                // Preserve current search params because they'll contain the time range
                search: currentSearchParams.toString()
            },
            children: ({ isActive: isActive })=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($4ed73a3daab450e4$var$FunctionName, {
                    $isActive: isActive,
                    children: [
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($4ed73a3daab450e4$var$ModuleIcon, {
                            type: "function_duotone"
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($4ed73a3daab450e4$var$Ellipsis, {
                            title: node.name,
                            children: node.name
                        })
                    ]
                })
        })
    });
}
const $4ed73a3daab450e4$var$gridTemplateColumns = (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
  grid-template-columns: 24px 32px 1fr;
`;
const $4ed73a3daab450e4$var$GridContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $5980fceb02c72dc0$export$e25e478948902b8b).div)`
  display: grid;
  row-gap: 8px;
`;
const $4ed73a3daab450e4$var$FunctionTreeContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)($4ed73a3daab450e4$var$GridContainer)`
  position: relative;
`;
const $4ed73a3daab450e4$var$FunctionTreeNodeContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)($4ed73a3daab450e4$var$GridContainer)(({ isModule: isModule })=>isModule && $4ed73a3daab450e4$var$gridTemplateColumns);
const $4ed73a3daab450e4$var$FunctionTreeNodeChildrenContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)($4ed73a3daab450e4$var$GridContainer)`
  grid-column: 2 / -1;
`;
const $4ed73a3daab450e4$var$ModuleIcon = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $0a830394bc38e4e3$export$f04a61298a47a40f))`
  width: 24px;
`;
const $4ed73a3daab450e4$var$ModuleName = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      ${$4ed73a3daab450e4$var$gridTemplateColumns};

      display: grid;
      grid-column: 1 / -1;
      align-items: center;
      cursor: pointer;
      color: ${theme.color.fg.muted};
      isolation: isolate;
      user-select: none;

      ${$4ed73a3daab450e4$var$ModuleIcon} {
        color: ${theme.color.fg.subtle};
      }

      &::before {
        content: "";
        display: block;
        position: absolute;
        left: 0;
        border-radius: ${theme.radius.default};
        background-color: transparent;
        height: 32px;
        width: 100%;
        z-index: -1;

        ${(0, $6babf196a55ab307$export$95df08bae54cb4df) && (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
          transform: translateY(-4px);
        `}
      }

      &:hover::before {
        background-color: ${theme.color.bg.hover};
      }
    `);
const $4ed73a3daab450e4$var$FunctionName = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)($4ed73a3daab450e4$var$ModuleName)(({ $isActive: $isActive, theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      grid-template-columns: 24px 1fr;
      column-gap: 8px;
      transition: background-color 0.1s ease-in-out;

      ${$isActive && (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
        font: ${theme.font.body.md.medium};
        border-radius: ${theme.radius.default};
        color: ${theme.color.fg.onemphasis.default};

        &&::before {
          background-color: ${theme.color.bg.emphasis.primary};
        }
      `}

      ${$4ed73a3daab450e4$var$ModuleIcon} {
        color: ${$isActive ? "inherit" : theme.color.fg.subtle};
      }
    `);
const $4ed73a3daab450e4$var$FunctionNavLink = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $e7b98158099ae00d$export$b0d92dbee9b5b60d))`
  text-decoration: none;
`;
const $4ed73a3daab450e4$var$NoFilteredFunctions = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $5980fceb02c72dc0$export$e25e478948902b8b).div)`
  margin-top: 22px; /* magic number - when search is unhidden, change to 20px */
  padding-top: 40px; /* offset for the hover bg element */
  text-align: center;

  color: ${({ theme: theme })=>theme.color.fg.muted};
  font-size: 12px;
`;
const $4ed73a3daab450e4$var$Ellipsis = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).span`
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-wrap: normal;
`;









const $9e6102ff5740ba92$export$3a2fda0935932360 = (props)=>{
    const { value: value, onChange: onChange } = props;
    const onInputChange = (event)=>{
        onChange(event.target.value);
    };
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($9e6102ff5740ba92$var$SearchContainer, {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($9e6102ff5740ba92$var$StyledIcon, {
                type: "search_duotone"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($9e6102ff5740ba92$var$StyledInput, {
                placeholder: "Filter functions",
                value: value,
                onChange: onInputChange
            })
        ]
    });
};
const $9e6102ff5740ba92$var$SearchContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  padding: 0;
  margin: 8px 0 16px;
  gap: 8px;
  position: relative;
`;
const $9e6102ff5740ba92$var$StyledIcon = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $0a830394bc38e4e3$export$f04a61298a47a40f)).attrs({
    height: 16,
    width: 16
})`
  position: absolute;
  top: 7px;
  left: 8px;
  color: ${({ theme: theme })=>theme.color.fg.muted};
`;
const $9e6102ff5740ba92$var$StyledInput = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $a921dfdbd8dd60fa$export$f5b8910cec6cf069)).attrs({
    type: "text"
})`
  width: 100%;
  padding: 2px 12px 2px 32px;

  &::placeholder {
    color: ${({ theme: theme })=>theme.color.fg.muted};
    font-size: 12px;
  }
`;


const $81efe3b1a83e5601$var$resizableFunctionListDimensions = {
    default: 280,
    min: 140,
    max: 680
};
const $81efe3b1a83e5601$export$f340d5f42e619f9e = ({ autometricsData: autometricsData, isLoading: isLoading })=>{
    const [isHovered, setIsHovered] = (0, $2gcPZ.useState)(false);
    const throttledIsLoading = (0, $0256cde7569cadc3$export$4083eefea094a0de)(isLoading, 500);
    const { handleResize: handleResize, width: width } = (0, $0379ace7bea2febc$export$1d663a8875362671)($81efe3b1a83e5601$var$resizableFunctionListDimensions);
    const [filterValue, setFilterValue] = (0, $2gcPZ.useState)("");
    const onFilterChange = (0, $cac150ebb620e91f$export$d095b0c879743c0d)((value)=>setFilterValue(value));
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $e383728c6bfde635$exports.Resizable), {
        width: width,
        axis: "x" // Restrict resizing to the horizontal axis
        ,
        onResize: handleResize,
        resizeHandles: [
            "e"
        ],
        handle: (_, ref)=>// Render a custom handle component, so we can indicate "resizability"
            // along the entire right side of the container
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($81efe3b1a83e5601$var$ResizableHandle, {
                ref: ref,
                onMouseEnter: ()=>setIsHovered(true),
                onMouseLeave: ()=>setIsHovered(false)
            }),
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($81efe3b1a83e5601$var$FunctionListSection, {
            style: {
                width: width
            },
            $isHovered: isHovered,
            children: [
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($81efe3b1a83e5601$var$FunctionTreeListHeader, {
                    children: "Explorer"
                }),
                throttledIsLoading ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($81efe3b1a83e5601$var$LoadingFunctions, {
                    initial: {
                        opacity: 0,
                        y: 10
                    },
                    animate: {
                        opacity: 1,
                        y: 0
                    },
                    exit: {
                        opacity: 0,
                        y: -10
                    },
                    transition: {
                        duration: 0.1
                    },
                    children: [
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $f71dd936b17623f4$export$ec58be8144c543a7), {
                            children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0a830394bc38e4e3$export$f04a61298a47a40f), {
                                type: "autometrics"
                            })
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("div", {
                            children: "Loading Functions"
                        })
                    ]
                }, "functionTreeListLoadingOuter") : (autometricsData ?? []).length > 0 && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $afa7be861492543f$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($81efe3b1a83e5601$var$FunctionSearchContainer, {
                            initial: {
                                opacity: 0,
                                y: 10
                            },
                            animate: {
                                opacity: 1,
                                y: 0
                            },
                            children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $9e6102ff5740ba92$export$3a2fda0935932360), {
                                value: filterValue,
                                onChange: onFilterChange
                            })
                        }, "functionTreeListSearch"),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($81efe3b1a83e5601$var$FunctionTreeListContainer, {
                            initial: {
                                opacity: 0,
                                y: 10
                            },
                            animate: {
                                opacity: 1,
                                y: 0
                            },
                            children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $4ed73a3daab450e4$export$f784d0f0a1f56aac), {
                                autometricsData: autometricsData ?? [],
                                filterValue: filterValue
                            })
                        }, "functionTreeList")
                    ]
                })
            ]
        })
    });
};
const $81efe3b1a83e5601$var$FunctionListSection = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ $isHovered: $isHovered, theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    display: grid;
    grid-template-rows: auto auto 1fr;
    padding: 20px 20px 0;
    /* HACK - Knows height of nav bar */
    max-height: calc(100vh - 60px);
    background-color: ${theme.color.bg.subtle};
    border-right: 1px solid ${theme.color.border.muted};
    transition: border-color 0.2s ease-in-out;

    ${$isHovered && (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      border-color: ${theme.color.border.default};
    `}
  `);
const $81efe3b1a83e5601$var$FunctionTreeListHeader = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    font: ${theme.font.body.md.medium};
    color: ${theme.color.fg.muted};
  `);
const $81efe3b1a83e5601$var$FunctionTreeListContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $5980fceb02c72dc0$export$e25e478948902b8b).div)`
  padding-top: 4px; /* offset for the hover bg element */
  overflow: auto;
`;
const $81efe3b1a83e5601$var$FunctionSearchContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $5980fceb02c72dc0$export$e25e478948902b8b).div)`
  overflow: visible;
`;
const $81efe3b1a83e5601$var$LoadingFunctions = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $5980fceb02c72dc0$export$e25e478948902b8b).div)`
  margin-top: 22px; /* magic number - when search is unhidden, change to 20px */
  padding-top: 40px; /* offset for the hover bg element */
  text-align: center;

  color: ${({ theme: theme })=>theme.color.fg.muted};
  font-size: 12px;
`;
const $81efe3b1a83e5601$var$ResizableHandle = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  width: 15px;
  height: 100%;
  cursor: ew-resize;
  top: 0;
  right: -8px;
  position: absolute;
  z-index: 1;
`;




const $cb333cafab87328e$export$fd36c1ee89d6448e = ()=>{
    // Use selector to read the active prometheus instance error state
    const instance = (0, $1a280fbaa3fcabb5$export$2105062e25df4afe)((0, $14bbd07b3011052f$export$919b3065fd27c3a8));
    const { error: prometheusError } = (0, $5755db105caee352$export$c6928c88e13eba01)(instance?.url, {
        refetchOnMountOrArgChange: true,
        skip: !instance?.url
    });
    const { data: autometricsData, isFetching: autometricsDataIsFetching } = (0, $7530fbaa6f2f256c$export$7f85c6a6ff922ea5)(instance?.url, {
        skip: !instance?.url
    });
    if (!instance?.url) return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $ca0bd75019462cd1$export$be3dbeb7e994ac04), {});
    if (prometheusError) return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $7f2b92de158af7af$export$5eef44829f72c6d0), {});
    if ((!autometricsData || autometricsData.length === 0) && !autometricsDataIsFetching) return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $8b81d3d733bcd10f$export$78d0d40b8e48fb0f), {});
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($cb333cafab87328e$var$FunctionExplorerGrid, {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $81efe3b1a83e5601$export$f340d5f42e619f9e), {
                autometricsData: autometricsData,
                isLoading: autometricsDataIsFetching
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($cb333cafab87328e$var$MainSection, {
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $efeb47d767416279$export$3565eb3d00ca5a74), {
                    children: [
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $efeb47d767416279$export$e7b0ac011bb776c6), {
                            index: true,
                            element: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $b202a283499519c6$export$e94df23e484f280a), {})
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $efeb47d767416279$export$e7b0ac011bb776c6), {
                            path: "query/*",
                            element: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $05945b92f2cc5b07$export$bdc723d08dd9b8f8), {
                                autometricsData: autometricsData
                            })
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $efeb47d767416279$export$e7b0ac011bb776c6), {
                            path: "details/m/:module/:name/:metricType?",
                            element: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $09d2e9a1d35fdeb5$export$c5f6100e9951d145), {})
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $efeb47d767416279$export$e7b0ac011bb776c6), {
                            path: "details/s/:service/m/:module/:name/:metricType?",
                            element: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $09d2e9a1d35fdeb5$export$c5f6100e9951d145), {})
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $efeb47d767416279$export$e7b0ac011bb776c6), {
                            path: "details/:name/:metricType?",
                            element: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $09d2e9a1d35fdeb5$export$c5f6100e9951d145), {})
                        })
                    ]
                })
            })
        ]
    });
};
const $cb333cafab87328e$var$MainSection = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  /* HACK - Knows height of nav bar */
  height: calc(100vh - 60px);
  overflow: auto;
`;
const $cb333cafab87328e$var$FunctionExplorerGrid = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 0;
`;












var $2gcPZ = parcelRequire("2gcPZ");










function $df697ffc301b2e75$export$9bb2c5592f957d1c({ feature: feature, description: description, title: title }) {
    const [hasFeature, setHasFeature] = (0, $edc4621501740b0b$export$fc97652867e5867e)(feature);
    const handleInputChange = ({ target: { checked: checked, id: feature } })=>{
        const isValidFeature = (0, $b62e61a689d28909$export$33b822a6faf70e7a)(feature);
        if (!isValidFeature) return;
        setHasFeature(checked);
    };
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($df697ffc301b2e75$var$CardContainer, {
        $isSelected: hasFeature,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("label", {
                htmlFor: feature,
                children: title
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a921dfdbd8dd60fa$export$f5b8910cec6cf069), {
                type: "checkbox",
                id: feature,
                checked: hasFeature,
                onChange: handleInputChange
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("p", {
                children: description
            })
        ]
    });
}
const $df697ffc301b2e75$var$CardContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ $isSelected: $isSelected, theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    display: grid;
    grid: "checkbox title" "checkbox description" 1fr / min-content 1fr;
    gap: 4px 16px;
    padding: 16px;
    border-radius: ${theme.radius.rounded};
    background-color: ${theme.color.bg.default};
    border: 1px solid ${theme.color.border.default};

    transition: background-color 0.1s ease-in-out, color 0.1s ease-in-out,
      border-color 0.2s ease-in-out;

    & > input {
      grid-area: checkbox;
    }

    & > label {
      grid-area: title;
      align-self: center;
      cursor: pointer;
      line-height: 1;
      font: ${theme.font.headings.h5};
    }

    & > p {
      grid-area: description;
      font: ${theme.font.body.sm.regular};
      color: ${theme.color.fg.muted};
    }

    ${$isSelected && (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      border-color: ${theme.color.border.primary};
      background-color: ${theme.color.bg.emphasis["primary-subtle"]};
    `}
  `);


const $a9f837368ec7e3b5$var$FEATURES = [
    {
        feature: "source-code-links",
        title: "Source code links",
        description: "The Source code links feature will enable information about where a function resides in your source code and can even support links to the file/function directly in your (VS Code) editor."
    },
    {
        feature: "theme-switch",
        title: "Theme switch",
        description: "Adds the theme switcher as a lightswitch to the nav bar."
    }
];
function $a9f837368ec7e3b5$export$a9b79ba328f9bd6e() {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($a9f837368ec7e3b5$var$ExperimentalFeaturesContainer, {
        children: $a9f837368ec7e3b5$var$FEATURES.map(({ feature: feature, description: description, title: title })=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $df697ffc301b2e75$export$9bb2c5592f957d1c), {
                feature: feature,
                description: description,
                title: title
            }, feature))
    });
}
const $a9f837368ec7e3b5$var$ExperimentalFeaturesContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 300px), 1fr));
  justify-content: start;
  gap: 16px;
`;







function $10b2926302cc13b9$export$84555a67d3b65469() {
    const [hasFeaturesEnabled, setHasFeaturesEnabled] = (0, $edc4621501740b0b$export$4a39035bacc4ed76)();
    const handleLightSwitchOnChange = (0, $cac150ebb620e91f$export$d095b0c879743c0d)((event)=>setHasFeaturesEnabled(event.target.checked));
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($10b2926302cc13b9$var$ExperimentalContent, {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($10b2926302cc13b9$var$LightSwitchContainer, {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a921dfdbd8dd60fa$export$f5b8910cec6cf069), {
                        type: "lightswitch",
                        checked: hasFeaturesEnabled,
                        onChange: handleLightSwitchOnChange
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("h4", {
                        children: "Enable beta features"
                    })
                ]
            }),
            hasFeaturesEnabled && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a9f837368ec7e3b5$export$a9b79ba328f9bd6e), {})
        ]
    });
}
const $10b2926302cc13b9$var$ExperimentalContent = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: grid;
  gap: 16px;
`;
const $10b2926302cc13b9$var$LightSwitchContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 12px;
`;










const $9e604dd7bbd62f05$export$21675fbbea47cdb6 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).li(({ $isActive: $isActive, theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      display: grid;
      grid:
        "icon name buttons" auto
        "icon url buttons" auto
        "icon errors buttons" auto
        / auto 1fr auto;
      gap: 2px 16px;
      padding: 16px;
      margin: 0;
      cursor: pointer;
      border: 1px solid ${theme.color.border.default};
      border-radius: ${theme.radius.rounded};
      align-items: center;

      /* TODO (Oscar): this is coming from the Button component; these rules
        should end up in a central place */
      transition: background-color 0.1s ease-in-out, color 0.1s ease-in-out,
        border-color 0.2s ease-in-out;

      ${$isActive && (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
        border-color: ${theme.color.border.primary};
        background-color: ${theme.color.bg.emphasis["primary-subtle"]};
      `}
    `);
const $9e604dd7bbd62f05$export$9e22197817ed9e0d = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).h5`
  grid-area: name;
  display: flex;
  gap: 8px;
  align-items: center;
`;
const $9e604dd7bbd62f05$export$3cee892aeea6082e = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  grid-area: buttons;
  display: flex;
  align-items: center;
  gap: 16px;
  align-self: flex-start;
`;
const $9e604dd7bbd62f05$export$94c28a8f63a8b536 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).header`
  display: grid;
  align-content: start;
  gap: 4px;
`;
const $9e604dd7bbd62f05$export$a464fbac34c32d2f = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).p(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    font: ${theme.font.body.sm.regular};
    color: ${theme.color.fg.muted};
    margin-bottom: 16px;
  `);


function $19fc4b06e3edd1c2$export$f7546b33f512fa1f() {
    const { settings: notificationSettings, setDesktopNotificationsEnabled: setDesktopNotificationsEnabled, requestPermission: requestPermission } = (0, $176313a6a434cc5e$exports).useNotificationSettings();
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($19fc4b06e3edd1c2$var$Container, {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($19fc4b06e3edd1c2$var$StatusBanner, {
                notificationState: notificationSettings.notificationState,
                requestPermission: requestPermission
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($19fc4b06e3edd1c2$var$FormContainer, {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("h4", {
                        children: "Receive notifications about"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($19fc4b06e3edd1c2$var$FormContent, {
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($19fc4b06e3edd1c2$var$StyledLabel, {
                                children: [
                                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a921dfdbd8dd60fa$export$f5b8910cec6cf069), {
                                        type: "radio",
                                        name: "notificationSettings",
                                        value: "alerts",
                                        disabled: notificationSettings.notificationState === "denied",
                                        checked: notificationSettings.desktopNotificationsEnabled,
                                        onChange: ()=>{
                                            setDesktopNotificationsEnabled(true);
                                        }
                                    }),
                                    "Alerts"
                                ]
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($19fc4b06e3edd1c2$var$StyledLabel, {
                                children: [
                                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a921dfdbd8dd60fa$export$f5b8910cec6cf069), {
                                        type: "radio",
                                        name: "notificationSettings",
                                        value: "nothing",
                                        checked: !notificationSettings.desktopNotificationsEnabled,
                                        disabled: notificationSettings.notificationState === "denied",
                                        onChange: ()=>{
                                            setDesktopNotificationsEnabled(false);
                                        }
                                    }),
                                    "Nothing"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function $19fc4b06e3edd1c2$var$StatusBanner(props) {
    const { notificationState: notificationState, requestPermission: requestPermission } = props;
    switch(notificationState){
        case "default":
            return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($19fc4b06e3edd1c2$var$IntroContainer, {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($19fc4b06e3edd1c2$var$Intro, {
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("h4", {
                                children: "Enable desktop notifications"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $9e604dd7bbd62f05$export$a464fbac34c32d2f), {
                                children: "You will be notified as long as you keep a browser tab open"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $a921dfdbd8dd60fa$export$353f5b6fc5456de1), {
                            onClick: ()=>requestPermission(),
                            children: [
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0a830394bc38e4e3$export$f04a61298a47a40f), {
                                    type: "alarm_duotone"
                                }),
                                "Enable notifications"
                            ]
                        })
                    })
                ]
            });
        case "prompt":
            return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $f3c0cebd0881f06d$export$3b4e64e77073e307), {
                type: "info",
                title: "",
                initialSize: "small",
                copy: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $afa7be861492543f$exports.Fragment), {
                    children: [
                        "Click `",
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("em", {
                            children: "Allow"
                        }),
                        "` in the browser popup to enable notifications"
                    ]
                })
            });
        case "denied":
            // Check if the browser supports service workers
            if (!(0, $176313a6a434cc5e$exports).hasServiceWorkerSupport) return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $f3c0cebd0881f06d$export$3b4e64e77073e307), {
                type: "danger",
                title: "Desktop notifications are not supported",
                copy: "This browser may be running in incognito mode or not support notifications."
            });
            // If there's a service worker, if so the user denied notifications
            // otherwise the service worker failed to load
            return (0, $176313a6a434cc5e$exports).getServiceWorker() ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $f3c0cebd0881f06d$export$3b4e64e77073e307), {
                type: "danger",
                title: "Desktop notifications not enabled",
                copy: " You've disallowed notifications in your browser. You'll need to open your browser preferences to change that."
            }) : /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $f3c0cebd0881f06d$export$3b4e64e77073e307), {
                type: "danger",
                title: "Desktop notifications are not supported",
                copy: "For some reason the service worker failed to load or start, so we can't enable notifications."
            });
        case "granted":
            return null;
    }
    return null;
}
const $19fc4b06e3edd1c2$var$Container = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: grid;
  gap: 24px;
`;
const $19fc4b06e3edd1c2$var$IntroContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: grid;
  gap: 12px;
`;
const $19fc4b06e3edd1c2$var$Intro = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: grid;
  gap: 4px;
`;
const $19fc4b06e3edd1c2$var$FormContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: grid;
  gap: 12px;
`;
const $19fc4b06e3edd1c2$var$FormContent = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: grid;
  gap: 4px;
`;
const $19fc4b06e3edd1c2$var$StyledLabel = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).label`
  display: flex;
  align-items: center;
  gap: 8px;
`;




var $2gcPZ = parcelRequire("2gcPZ");







var $2gcPZ = parcelRequire("2gcPZ");
var $21ecd847d8c48ab1$var$isCheckBoxInput = (element)=>element.type === "checkbox";
var $21ecd847d8c48ab1$var$isDateObject = (value1)=>value1 instanceof Date;
var $21ecd847d8c48ab1$var$isNullOrUndefined = (value1)=>value1 == null;
const $21ecd847d8c48ab1$var$isObjectType = (value1)=>typeof value1 === "object";
var $21ecd847d8c48ab1$var$isObject = (value1)=>!$21ecd847d8c48ab1$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $21ecd847d8c48ab1$var$isObjectType(value1) && !$21ecd847d8c48ab1$var$isDateObject(value1);
var $21ecd847d8c48ab1$var$getEventValue = (event)=>$21ecd847d8c48ab1$var$isObject(event) && event.target ? $21ecd847d8c48ab1$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var $21ecd847d8c48ab1$var$getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var $21ecd847d8c48ab1$var$isNameInFieldArray = (names, name)=>names.has($21ecd847d8c48ab1$var$getNodeParentName(name));
var $21ecd847d8c48ab1$var$isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return $21ecd847d8c48ab1$var$isObject(prototypeCopy) && prototypeCopy.hasOwnProperty("isPrototypeOf");
};
var $21ecd847d8c48ab1$var$isWeb = typeof window !== "undefined" && typeof window.HTMLElement !== "undefined" && typeof document !== "undefined";
function $21ecd847d8c48ab1$var$cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) copy = new Date(data);
    else if (data instanceof Set) copy = new Set(data);
    else if (!($21ecd847d8c48ab1$var$isWeb && (data instanceof Blob || data instanceof FileList)) && (isArray || $21ecd847d8c48ab1$var$isObject(data))) {
        copy = isArray ? [] : {};
        if (!Array.isArray(data) && !$21ecd847d8c48ab1$var$isPlainObject(data)) copy = data;
        else for(const key in data)copy[key] = $21ecd847d8c48ab1$var$cloneObject(data[key]);
    } else return data;
    return copy;
}
var $21ecd847d8c48ab1$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var $21ecd847d8c48ab1$var$isUndefined = (val)=>val === undefined;
var $21ecd847d8c48ab1$export$3988ae62b71be9a3 = (obj, path, defaultValue)=>{
    if (!path || !$21ecd847d8c48ab1$var$isObject(obj)) return defaultValue;
    const result = $21ecd847d8c48ab1$var$compact(path.split(/[,[\].]+?/)).reduce((result, key)=>$21ecd847d8c48ab1$var$isNullOrUndefined(result) ? result : result[key], obj);
    return $21ecd847d8c48ab1$var$isUndefined(result) || result === obj ? $21ecd847d8c48ab1$var$isUndefined(obj[path]) ? defaultValue : obj[path] : result;
};
const $21ecd847d8c48ab1$var$EVENTS = {
    BLUR: "blur",
    FOCUS_OUT: "focusout",
    CHANGE: "change"
};
const $21ecd847d8c48ab1$var$VALIDATION_MODE = {
    onBlur: "onBlur",
    onChange: "onChange",
    onSubmit: "onSubmit",
    onTouched: "onTouched",
    all: "all"
};
const $21ecd847d8c48ab1$var$INPUT_VALIDATION_RULES = {
    max: "max",
    min: "min",
    maxLength: "maxLength",
    minLength: "minLength",
    pattern: "pattern",
    required: "required",
    validate: "validate"
};
const $21ecd847d8c48ab1$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $21ecd847d8c48ab1$export$4d957a5e1be13b03 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).useContext($21ecd847d8c48ab1$var$HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useFrom methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $21ecd847d8c48ab1$export$8ce1ff4f94d08846 = (props)=>{
    const { children: children, ...data } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).createElement($21ecd847d8c48ab1$var$HookFormContext.Provider, {
        value: data
    }, children);
};
var $21ecd847d8c48ab1$var$getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {
        defaultValues: control._defaultValues
    };
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== $21ecd847d8c48ab1$var$VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || $21ecd847d8c48ab1$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
var $21ecd847d8c48ab1$var$isEmptyObject = (value1)=>$21ecd847d8c48ab1$var$isObject(value1) && !Object.keys(value1).length;
var $21ecd847d8c48ab1$var$shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name: name, ...formState } = formStateData;
    return $21ecd847d8c48ab1$var$isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || $21ecd847d8c48ab1$var$VALIDATION_MODE.all));
};
var $21ecd847d8c48ab1$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $21ecd847d8c48ab1$var$shouldSubscribeByName = (name, signalName, exact)=>exact && signalName ? name === signalName : !name || !signalName || name === signalName || $21ecd847d8c48ab1$var$convertToArrayPayload(name).some((currentName)=>currentName && (currentName.startsWith(signalName) || signalName.startsWith(currentName)));
function $21ecd847d8c48ab1$var$useSubscribe(props) {
    const _props = (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).useRef(props);
    _props.current = props;
    (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).useEffect(()=>{
        const subscription = !props.disabled && _props.current.subject && _props.current.subject.subscribe({
            next: _props.current.next
        });
        return ()=>{
            subscription && subscription.unsubscribe();
        };
    }, [
        props.disabled
    ]);
}
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $21ecd847d8c48ab1$export$606f11b2eb45ecc6(props) {
    const methods = $21ecd847d8c48ab1$export$4d957a5e1be13b03();
    const { control: control = methods.control, disabled: disabled, name: name, exact: exact } = props || {};
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).useState(control._formState);
    const _mounted = (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).useRef(true);
    const _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).useRef(name);
    _name.current = name;
    $21ecd847d8c48ab1$var$useSubscribe({
        disabled: disabled,
        next: (value1)=>_mounted.current && $21ecd847d8c48ab1$var$shouldSubscribeByName(_name.current, value1.name, exact) && $21ecd847d8c48ab1$var$shouldRenderFormState(value1, _localProxyFormState.current, control._updateFormState) && updateFormState({
                ...control._formState,
                ...value1
            }),
        subject: control._subjects.state
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).useEffect(()=>{
        _mounted.current = true;
        _localProxyFormState.current.isValid && control._updateValid(true);
        return ()=>{
            _mounted.current = false;
        };
    }, [
        control
    ]);
    return $21ecd847d8c48ab1$var$getProxyFormState(formState, control, _localProxyFormState.current, false);
}
var $21ecd847d8c48ab1$var$isString = (value1)=>typeof value1 === "string";
var $21ecd847d8c48ab1$var$generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if ($21ecd847d8c48ab1$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $21ecd847d8c48ab1$export$3988ae62b71be9a3(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $21ecd847d8c48ab1$export$3988ae62b71be9a3(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/api/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { watch } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $21ecd847d8c48ab1$export$3c773aa2b84f29e0(props) {
    const methods = $21ecd847d8c48ab1$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, defaultValue: defaultValue, disabled: disabled, exact: exact } = props || {};
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).useRef(name);
    _name.current = name;
    $21ecd847d8c48ab1$var$useSubscribe({
        disabled: disabled,
        subject: control._subjects.values,
        next: (formState)=>{
            if ($21ecd847d8c48ab1$var$shouldSubscribeByName(_name.current, formState.name, exact)) updateValue($21ecd847d8c48ab1$var$cloneObject($21ecd847d8c48ab1$var$generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
        }
    });
    const [value1, updateValue] = (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).useState(control._getWatch(name, defaultValue));
    (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).useEffect(()=>control._removeUnmounted());
    return value1;
}
var $21ecd847d8c48ab1$var$isKey = (value1)=>/^\w*$/.test(value1);
var $21ecd847d8c48ab1$var$stringToPath = (input)=>$21ecd847d8c48ab1$var$compact(input.replace(/["|']|\]/g, "").split(/\.|\[/));
function $21ecd847d8c48ab1$export$adaa4cf7ef1b65be(object, path, value1) {
    let index = -1;
    const tempPath = $21ecd847d8c48ab1$var$isKey(path) ? [
        path
    ] : $21ecd847d8c48ab1$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $21ecd847d8c48ab1$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $21ecd847d8c48ab1$export$e8c786024a2b0a79(props) {
    const methods = $21ecd847d8c48ab1$export$4d957a5e1be13b03();
    const { name: name, control: control = methods.control, shouldUnregister: shouldUnregister } = props;
    const isArrayField = $21ecd847d8c48ab1$var$isNameInFieldArray(control._names.array, name);
    const value1 = $21ecd847d8c48ab1$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: $21ecd847d8c48ab1$export$3988ae62b71be9a3(control._formValues, name, $21ecd847d8c48ab1$export$3988ae62b71be9a3(control._defaultValues, name, props.defaultValue)),
        exact: true
    });
    const formState = $21ecd847d8c48ab1$export$606f11b2eb45ecc6({
        control: control,
        name: name
    });
    const _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).useRef(control.register(name, {
        ...props.rules,
        value: value1
    }));
    (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const updateMounted = (name, value1)=>{
            const field = $21ecd847d8c48ab1$export$3988ae62b71be9a3(control._fields, name);
            if (field) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = $21ecd847d8c48ab1$var$cloneObject($21ecd847d8c48ab1$export$3988ae62b71be9a3(control._options.defaultValues, name));
            $21ecd847d8c48ab1$export$adaa4cf7ef1b65be(control._defaultValues, name, value1);
            if ($21ecd847d8c48ab1$var$isUndefined($21ecd847d8c48ab1$export$3988ae62b71be9a3(control._formValues, name))) $21ecd847d8c48ab1$export$adaa4cf7ef1b65be(control._formValues, name, value1);
        }
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    return {
        field: {
            name: name,
            value: value1,
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).useCallback((event)=>_registerProps.current.onChange({
                    target: {
                        value: $21ecd847d8c48ab1$var$getEventValue(event),
                        name: name
                    },
                    type: $21ecd847d8c48ab1$var$EVENTS.CHANGE
                }), [
                name
            ]),
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).useCallback(()=>_registerProps.current.onBlur({
                    target: {
                        value: $21ecd847d8c48ab1$export$3988ae62b71be9a3(control._formValues, name),
                        name: name
                    },
                    type: $21ecd847d8c48ab1$var$EVENTS.BLUR
                }), [
                name,
                control
            ]),
            ref: (elm)=>{
                const field = $21ecd847d8c48ab1$export$3988ae62b71be9a3(control._fields, name);
                if (field && elm) field._f.ref = {
                    focus: ()=>elm.focus(),
                    select: ()=>elm.select(),
                    setCustomValidity: (message)=>elm.setCustomValidity(message),
                    reportValidity: ()=>elm.reportValidity()
                };
            }
        },
        formState: formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!$21ecd847d8c48ab1$export$3988ae62b71be9a3(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!$21ecd847d8c48ab1$export$3988ae62b71be9a3(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!$21ecd847d8c48ab1$export$3988ae62b71be9a3(formState.touchedFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>$21ecd847d8c48ab1$export$3988ae62b71be9a3(formState.errors, name)
            }
        })
    };
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $21ecd847d8c48ab1$export$bd0bf19f25da8474 = (props)=>props.render($21ecd847d8c48ab1$export$e8c786024a2b0a79(props));
var $21ecd847d8c48ab1$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? {
        ...errors[name],
        types: {
            ...errors[name] && errors[name].types ? errors[name].types : {},
            [type]: message || true
        }
    } : {};
const $21ecd847d8c48ab1$var$focusFieldBy = (fields, callback, fieldsNames)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        const field = $21ecd847d8c48ab1$export$3988ae62b71be9a3(fields, key);
        if (field) {
            const { _f: _f, ...currentField } = field;
            if (_f && callback(_f.name)) {
                if (_f.ref.focus) {
                    _f.ref.focus();
                    break;
                } else if (_f.refs && _f.refs[0].focus) {
                    _f.refs[0].focus();
                    break;
                }
            } else if ($21ecd847d8c48ab1$var$isObject(currentField)) $21ecd847d8c48ab1$var$focusFieldBy(currentField, callback);
        }
    }
};
var $21ecd847d8c48ab1$var$generateId = ()=>{
    const d = typeof performance === "undefined" ? Date.now() : performance.now() * 1000;
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == "x" ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $21ecd847d8c48ab1$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $21ecd847d8c48ab1$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$21ecd847d8c48ab1$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : "";
var $21ecd847d8c48ab1$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $21ecd847d8c48ab1$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $21ecd847d8c48ab1$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $21ecd847d8c48ab1$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $21ecd847d8c48ab1$var$VALIDATION_MODE.all,
        isOnTouch: mode === $21ecd847d8c48ab1$var$VALIDATION_MODE.onTouched
    });
var $21ecd847d8c48ab1$var$isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
var $21ecd847d8c48ab1$var$updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = $21ecd847d8c48ab1$var$compact($21ecd847d8c48ab1$export$3988ae62b71be9a3(errors, name));
    $21ecd847d8c48ab1$export$adaa4cf7ef1b65be(fieldArrayErrors, "root", error[name]);
    $21ecd847d8c48ab1$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
var $21ecd847d8c48ab1$var$isBoolean = (value1)=>typeof value1 === "boolean";
var $21ecd847d8c48ab1$var$isFileInput = (element)=>element.type === "file";
var $21ecd847d8c48ab1$var$isFunction = (value1)=>typeof value1 === "function";
var $21ecd847d8c48ab1$var$isHTMLElement = (value1)=>{
    if (!$21ecd847d8c48ab1$var$isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var $21ecd847d8c48ab1$var$isMessage = (value1)=>$21ecd847d8c48ab1$var$isString(value1);
var $21ecd847d8c48ab1$var$isRadioInput = (element)=>element.type === "radio";
var $21ecd847d8c48ab1$var$isRegex = (value1)=>value1 instanceof RegExp;
const $21ecd847d8c48ab1$var$defaultResult = {
    value: false,
    isValid: false
};
const $21ecd847d8c48ab1$var$validResult = {
    value: true,
    isValid: true
};
var $21ecd847d8c48ab1$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$21ecd847d8c48ab1$var$isUndefined(options[0].attributes.value) ? $21ecd847d8c48ab1$var$isUndefined(options[0].value) || options[0].value === "" ? $21ecd847d8c48ab1$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $21ecd847d8c48ab1$var$validResult : $21ecd847d8c48ab1$var$defaultResult;
    }
    return $21ecd847d8c48ab1$var$defaultResult;
};
const $21ecd847d8c48ab1$var$defaultReturn = {
    isValid: false,
    value: null
};
var $21ecd847d8c48ab1$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $21ecd847d8c48ab1$var$defaultReturn) : $21ecd847d8c48ab1$var$defaultReturn;
function $21ecd847d8c48ab1$var$getValidateError(result, ref, type = "validate") {
    if ($21ecd847d8c48ab1$var$isMessage(result) || Array.isArray(result) && result.every($21ecd847d8c48ab1$var$isMessage) || $21ecd847d8c48ab1$var$isBoolean(result) && !result) return {
        type: type,
        message: $21ecd847d8c48ab1$var$isMessage(result) ? result : "",
        ref: ref
    };
}
var $21ecd847d8c48ab1$var$getValueAndMessage = (validationData)=>$21ecd847d8c48ab1$var$isObject(validationData) && !$21ecd847d8c48ab1$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ""
    };
var $21ecd847d8c48ab1$var$validateField = async (field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref: ref, refs: refs, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate, name: name, valueAsNumber: valueAsNumber, mount: mount, disabled: disabled } = field._f;
    const inputValue = $21ecd847d8c48ab1$export$3988ae62b71be9a3(formValues, name);
    if (!mount || disabled) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity($21ecd847d8c48ab1$var$isBoolean(message) ? "" : message || "");
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = $21ecd847d8c48ab1$var$isRadioInput(ref);
    const isCheckBox = $21ecd847d8c48ab1$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $21ecd847d8c48ab1$var$isFileInput(ref)) && $21ecd847d8c48ab1$var$isUndefined(ref.value) && $21ecd847d8c48ab1$var$isUndefined(inputValue) || $21ecd847d8c48ab1$var$isHTMLElement(ref) && ref.value === "" || inputValue === "" || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = $21ecd847d8c48ab1$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $21ecd847d8c48ab1$var$INPUT_VALIDATION_RULES.maxLength, minType = $21ecd847d8c48ab1$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message)
        };
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $21ecd847d8c48ab1$var$isNullOrUndefined(inputValue)) || $21ecd847d8c48ab1$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$21ecd847d8c48ab1$var$getCheckboxValue(refs).isValid || isRadio && !$21ecd847d8c48ab1$var$getRadioValue(refs).isValid)) {
        const { value: value1, message: message } = $21ecd847d8c48ab1$var$isMessage(required) ? {
            value: !!required,
            message: required
        } : $21ecd847d8c48ab1$var$getValueAndMessage(required);
        if (value1) {
            error[name] = {
                type: $21ecd847d8c48ab1$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef,
                ...appendErrorsCurry($21ecd847d8c48ab1$var$INPUT_VALIDATION_RULES.required, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$21ecd847d8c48ab1$var$isNullOrUndefined(min) || !$21ecd847d8c48ab1$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $21ecd847d8c48ab1$var$getValueAndMessage(max);
        const minOutput = $21ecd847d8c48ab1$var$getValueAndMessage(min);
        if (!$21ecd847d8c48ab1$var$isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!$21ecd847d8c48ab1$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$21ecd847d8c48ab1$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + " " + time);
            const isTime = ref.type == "time";
            const isWeek = ref.type == "week";
            if ($21ecd847d8c48ab1$var$isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if ($21ecd847d8c48ab1$var$isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $21ecd847d8c48ab1$var$INPUT_VALIDATION_RULES.max, $21ecd847d8c48ab1$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && ($21ecd847d8c48ab1$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = $21ecd847d8c48ab1$var$getValueAndMessage(maxLength);
        const minLengthOutput = $21ecd847d8c48ab1$var$getValueAndMessage(minLength);
        const exceedMax = !$21ecd847d8c48ab1$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !$21ecd847d8c48ab1$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $21ecd847d8c48ab1$var$isString(inputValue)) {
        const { value: patternValue, message: message } = $21ecd847d8c48ab1$var$getValueAndMessage(pattern);
        if ($21ecd847d8c48ab1$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: $21ecd847d8c48ab1$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref,
                ...appendErrorsCurry($21ecd847d8c48ab1$var$INPUT_VALIDATION_RULES.pattern, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($21ecd847d8c48ab1$var$isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = $21ecd847d8c48ab1$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry($21ecd847d8c48ab1$var$INPUT_VALIDATION_RULES.validate, validateError.message)
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($21ecd847d8c48ab1$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$21ecd847d8c48ab1$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $21ecd847d8c48ab1$var$getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message)
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$21ecd847d8c48ab1$var$isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult
                };
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
function $21ecd847d8c48ab1$var$append(data, value1) {
    return [
        ...data,
        ...$21ecd847d8c48ab1$var$convertToArrayPayload(value1)
    ];
}
var $21ecd847d8c48ab1$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function $21ecd847d8c48ab1$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$21ecd847d8c48ab1$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $21ecd847d8c48ab1$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($21ecd847d8c48ab1$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
function $21ecd847d8c48ab1$var$prepend(data, value1) {
    return [
        ...$21ecd847d8c48ab1$var$convertToArrayPayload(value1),
        ...$21ecd847d8c48ab1$var$convertToArrayPayload(data)
    ];
}
function $21ecd847d8c48ab1$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $21ecd847d8c48ab1$var$compact(temp).length ? temp : [];
}
var $21ecd847d8c48ab1$var$removeArrayAt = (data, index)=>$21ecd847d8c48ab1$var$isUndefined(index) ? [] : $21ecd847d8c48ab1$var$removeAtIndexes(data, $21ecd847d8c48ab1$var$convertToArrayPayload(index).sort((a, b)=>a - b));
var $21ecd847d8c48ab1$var$swapArrayAt = (data, indexA, indexB)=>{
    data[indexA] = [
        data[indexB],
        data[indexB] = data[indexA]
    ][0];
};
function $21ecd847d8c48ab1$var$baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = $21ecd847d8c48ab1$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $21ecd847d8c48ab1$var$isEmptyArray(obj) {
    for(const key in obj){
        if (!$21ecd847d8c48ab1$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $21ecd847d8c48ab1$var$unset(object, path) {
    const paths = Array.isArray(path) ? path : $21ecd847d8c48ab1$var$isKey(path) ? [
        path
    ] : $21ecd847d8c48ab1$var$stringToPath(path);
    const childObject = paths.length === 1 ? object : $21ecd847d8c48ab1$var$baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && ($21ecd847d8c48ab1$var$isObject(childObject) && $21ecd847d8c48ab1$var$isEmptyObject(childObject) || Array.isArray(childObject) && $21ecd847d8c48ab1$var$isEmptyArray(childObject))) $21ecd847d8c48ab1$var$unset(object, paths.slice(0, -1));
    return object;
}
var $21ecd847d8c48ab1$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $21ecd847d8c48ab1$export$310131896651d559(props) {
    const methods = $21ecd847d8c48ab1$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, keyName: keyName = "id", shouldUnregister: shouldUnregister } = props;
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).useState(control._getFieldArray(name));
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).useRef(control._getFieldArray(name).map($21ecd847d8c48ab1$var$generateId));
    const _fieldIds = (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).useRef(fields);
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).useRef(name);
    const _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules && control.register(name, props.rules);
    $21ecd847d8c48ab1$var$useSubscribe({
        next: ({ values: values, name: fieldArrayName })=>{
            if (fieldArrayName === _name.current || !fieldArrayName) {
                const fieldValues = $21ecd847d8c48ab1$export$3988ae62b71be9a3(values, _name.current);
                if (Array.isArray(fieldValues)) {
                    setFields(fieldValues);
                    ids.current = fieldValues.map($21ecd847d8c48ab1$var$generateId);
                }
            }
        },
        subject: control._subjects.array
    });
    const updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append$1 = (value1, options)=>{
        const appendValue = $21ecd847d8c48ab1$var$convertToArrayPayload($21ecd847d8c48ab1$var$cloneObject(value1));
        const updatedFieldArrayValues = $21ecd847d8c48ab1$var$append(control._getFieldArray(name), appendValue);
        control._names.focus = $21ecd847d8c48ab1$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $21ecd847d8c48ab1$var$append(ids.current, appendValue.map($21ecd847d8c48ab1$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $21ecd847d8c48ab1$var$append, {
            argA: $21ecd847d8c48ab1$var$fillEmptyArray(value1)
        });
    };
    const prepend$1 = (value1, options)=>{
        const prependValue = $21ecd847d8c48ab1$var$convertToArrayPayload($21ecd847d8c48ab1$var$cloneObject(value1));
        const updatedFieldArrayValues = $21ecd847d8c48ab1$var$prepend(control._getFieldArray(name), prependValue);
        control._names.focus = $21ecd847d8c48ab1$var$getFocusFieldName(name, 0, options);
        ids.current = $21ecd847d8c48ab1$var$prepend(ids.current, prependValue.map($21ecd847d8c48ab1$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $21ecd847d8c48ab1$var$prepend, {
            argA: $21ecd847d8c48ab1$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = $21ecd847d8c48ab1$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $21ecd847d8c48ab1$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $21ecd847d8c48ab1$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = $21ecd847d8c48ab1$var$convertToArrayPayload($21ecd847d8c48ab1$var$cloneObject(value1));
        const updatedFieldArrayValues = $21ecd847d8c48ab1$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $21ecd847d8c48ab1$var$getFocusFieldName(name, index, options);
        ids.current = $21ecd847d8c48ab1$var$insert(ids.current, index, insertValue.map($21ecd847d8c48ab1$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $21ecd847d8c48ab1$var$insert, {
            argA: index,
            argB: $21ecd847d8c48ab1$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $21ecd847d8c48ab1$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $21ecd847d8c48ab1$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $21ecd847d8c48ab1$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $21ecd847d8c48ab1$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $21ecd847d8c48ab1$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $21ecd847d8c48ab1$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = $21ecd847d8c48ab1$var$cloneObject(value1);
        const updatedFieldArrayValues = $21ecd847d8c48ab1$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $21ecd847d8c48ab1$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, updatedFieldArrayValues, $21ecd847d8c48ab1$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = $21ecd847d8c48ab1$var$convertToArrayPayload($21ecd847d8c48ab1$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($21ecd847d8c48ab1$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).useEffect(()=>{
        control._state.action = false;
        $21ecd847d8c48ab1$var$isWatched(name, control._names) && control._subjects.state.next({
            ...control._formState
        });
        if (_actioned.current && (!$21ecd847d8c48ab1$var$getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted)) {
            if (control._options.resolver) control._executeSchema([
                name
            ]).then((result)=>{
                const error = $21ecd847d8c48ab1$export$3988ae62b71be9a3(result.errors, name);
                const existingError = $21ecd847d8c48ab1$export$3988ae62b71be9a3(control._formState.errors, name);
                if (existingError ? !error && existingError.type : error && error.type) {
                    error ? $21ecd847d8c48ab1$export$adaa4cf7ef1b65be(control._formState.errors, name, error) : $21ecd847d8c48ab1$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = $21ecd847d8c48ab1$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f) $21ecd847d8c48ab1$var$validateField(field, control._formValues, control._options.criteriaMode === $21ecd847d8c48ab1$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!$21ecd847d8c48ab1$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $21ecd847d8c48ab1$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.values.next({
            name: name,
            values: {
                ...control._formValues
            }
        });
        control._names.focus && $21ecd847d8c48ab1$var$focusFieldBy(control._fields, (key)=>!!key && key.startsWith(control._names.focus || ""));
        control._names.focus = "";
        control._updateValid();
    }, [
        fields,
        name,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).useEffect(()=>{
        !$21ecd847d8c48ab1$export$3988ae62b71be9a3(control._formValues, name) && control._updateFieldArray(name);
        return ()=>{
            (control._options.shouldUnregister || shouldUnregister) && control.unregister(name);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).useCallback(prepend$1, [
            updateValues,
            name,
            control
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).useCallback(append$1, [
            updateValues,
            name,
            control
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).useMemo(()=>fields.map((field, index)=>({
                    ...field,
                    [keyName]: ids.current[index] || $21ecd847d8c48ab1$var$generateId()
                })), [
            fields,
            keyName
        ])
    };
}
function $21ecd847d8c48ab1$var$createSubject() {
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
}
var $21ecd847d8c48ab1$var$isPrimitive = (value1)=>$21ecd847d8c48ab1$var$isNullOrUndefined(value1) || !$21ecd847d8c48ab1$var$isObjectType(value1);
function $21ecd847d8c48ab1$var$deepEqual(object1, object2) {
    if ($21ecd847d8c48ab1$var$isPrimitive(object1) || $21ecd847d8c48ab1$var$isPrimitive(object2)) return object1 === object2;
    if ($21ecd847d8c48ab1$var$isDateObject(object1) && $21ecd847d8c48ab1$var$isDateObject(object2)) return object1.getTime() === object2.getTime();
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== "ref") {
            const val2 = object2[key];
            if ($21ecd847d8c48ab1$var$isDateObject(val1) && $21ecd847d8c48ab1$var$isDateObject(val2) || $21ecd847d8c48ab1$var$isObject(val1) && $21ecd847d8c48ab1$var$isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !$21ecd847d8c48ab1$var$deepEqual(val1, val2) : val1 !== val2) return false;
        }
    }
    return true;
}
var $21ecd847d8c48ab1$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
var $21ecd847d8c48ab1$var$isRadioOrCheckbox = (ref)=>$21ecd847d8c48ab1$var$isRadioInput(ref) || $21ecd847d8c48ab1$var$isCheckBoxInput(ref);
var $21ecd847d8c48ab1$var$live = (ref)=>$21ecd847d8c48ab1$var$isHTMLElement(ref) && ref.isConnected;
var $21ecd847d8c48ab1$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($21ecd847d8c48ab1$var$isFunction(data[key])) return true;
    }
    return false;
};
function $21ecd847d8c48ab1$var$markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if ($21ecd847d8c48ab1$var$isObject(data) || isParentNodeArray) for(const key in data){
        if (Array.isArray(data[key]) || $21ecd847d8c48ab1$var$isObject(data[key]) && !$21ecd847d8c48ab1$var$objectHasFunction(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            $21ecd847d8c48ab1$var$markFieldsDirty(data[key], fields[key]);
        } else if (!$21ecd847d8c48ab1$var$isNullOrUndefined(data[key])) fields[key] = true;
    }
    return fields;
}
function $21ecd847d8c48ab1$var$getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if ($21ecd847d8c48ab1$var$isObject(data) || isParentNodeArray) {
        for(const key in data)if (Array.isArray(data[key]) || $21ecd847d8c48ab1$var$isObject(data[key]) && !$21ecd847d8c48ab1$var$objectHasFunction(data[key])) {
            if ($21ecd847d8c48ab1$var$isUndefined(formValues) || $21ecd847d8c48ab1$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? $21ecd847d8c48ab1$var$markFieldsDirty(data[key], []) : {
                ...$21ecd847d8c48ab1$var$markFieldsDirty(data[key])
            };
            else $21ecd847d8c48ab1$var$getDirtyFieldsFromDefaultValues(data[key], $21ecd847d8c48ab1$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else dirtyFieldsFromValues[key] = !$21ecd847d8c48ab1$var$deepEqual(data[key], formValues[key]);
    }
    return dirtyFieldsFromValues;
}
var $21ecd847d8c48ab1$var$getDirtyFields = (defaultValues, formValues)=>$21ecd847d8c48ab1$var$getDirtyFieldsFromDefaultValues(defaultValues, formValues, $21ecd847d8c48ab1$var$markFieldsDirty(formValues));
var $21ecd847d8c48ab1$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber, valueAsDate: valueAsDate, setValueAs: setValueAs })=>$21ecd847d8c48ab1$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === "" ? NaN : value1 ? +value1 : value1 : valueAsDate && $21ecd847d8c48ab1$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
function $21ecd847d8c48ab1$var$getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref)=>ref.disabled) : ref.disabled) return;
    if ($21ecd847d8c48ab1$var$isFileInput(ref)) return ref.files;
    if ($21ecd847d8c48ab1$var$isRadioInput(ref)) return $21ecd847d8c48ab1$var$getRadioValue(_f.refs).value;
    if ($21ecd847d8c48ab1$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if ($21ecd847d8c48ab1$var$isCheckBoxInput(ref)) return $21ecd847d8c48ab1$var$getCheckboxValue(_f.refs).value;
    return $21ecd847d8c48ab1$var$getFieldValueAs($21ecd847d8c48ab1$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $21ecd847d8c48ab1$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $21ecd847d8c48ab1$export$3988ae62b71be9a3(_fields, name);
        field && $21ecd847d8c48ab1$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $21ecd847d8c48ab1$var$getRuleValue = (rule)=>$21ecd847d8c48ab1$var$isUndefined(rule) ? rule : $21ecd847d8c48ab1$var$isRegex(rule) ? rule.source : $21ecd847d8c48ab1$var$isObject(rule) ? $21ecd847d8c48ab1$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
var $21ecd847d8c48ab1$var$hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
function $21ecd847d8c48ab1$var$schemaErrorLookup(errors, _fields, name) {
    const error = $21ecd847d8c48ab1$export$3988ae62b71be9a3(errors, name);
    if (error || $21ecd847d8c48ab1$var$isKey(name)) return {
        error: error,
        name: name
    };
    const names = name.split(".");
    while(names.length){
        const fieldName = names.join(".");
        const field = $21ecd847d8c48ab1$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $21ecd847d8c48ab1$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $21ecd847d8c48ab1$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $21ecd847d8c48ab1$var$unsetEmptyArray = (ref, name)=>!$21ecd847d8c48ab1$var$compact($21ecd847d8c48ab1$export$3988ae62b71be9a3(ref, name)).length && $21ecd847d8c48ab1$var$unset(ref, name);
const $21ecd847d8c48ab1$var$defaultOptions = {
    mode: $21ecd847d8c48ab1$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $21ecd847d8c48ab1$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function $21ecd847d8c48ab1$var$createFormControl(props = {}, flushRootRender) {
    let _options = {
        ...$21ecd847d8c48ab1$var$defaultOptions,
        ...props
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isLoading: $21ecd847d8c48ab1$var$isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        errors: {}
    };
    let _fields = {};
    let _defaultValues = $21ecd847d8c48ab1$var$isObject(_options.defaultValues) || $21ecd847d8c48ab1$var$isObject(_options.values) ? $21ecd847d8c48ab1$var$cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : $21ecd847d8c48ab1$var$cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    const _subjects = {
        values: $21ecd847d8c48ab1$var$createSubject(),
        array: $21ecd847d8c48ab1$var$createSubject(),
        state: $21ecd847d8c48ab1$var$createSubject()
    };
    const shouldCaptureDirtyFields = props.resetOptions && props.resetOptions.keepDirtyValues;
    const validationModeBeforeSubmit = $21ecd847d8c48ab1$var$getValidationModes(_options.mode);
    const validationModeAfterSubmit = $21ecd847d8c48ab1$var$getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === $21ecd847d8c48ab1$var$VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _updateValid = async (shouldUpdateValid)=>{
        if (_proxyFormState.isValid || shouldUpdateValid) {
            const isValid = _options.resolver ? $21ecd847d8c48ab1$var$isEmptyObject((await _executeSchema()).errors) : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid: isValid
            });
        }
    };
    const _updateIsValidating = (value1)=>_proxyFormState.isValidating && _subjects.state.next({
            isValidating: value1
        });
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($21ecd847d8c48ab1$export$3988ae62b71be9a3(_fields, name))) {
                const fieldValues = method($21ecd847d8c48ab1$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $21ecd847d8c48ab1$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray($21ecd847d8c48ab1$export$3988ae62b71be9a3(_formState.errors, name))) {
                const errors = method($21ecd847d8c48ab1$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $21ecd847d8c48ab1$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $21ecd847d8c48ab1$var$unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields && shouldUpdateFieldsAndState && Array.isArray($21ecd847d8c48ab1$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                const touchedFields = method($21ecd847d8c48ab1$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $21ecd847d8c48ab1$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) _formState.dirtyFields = $21ecd847d8c48ab1$var$getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                name: name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $21ecd847d8c48ab1$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        $21ecd847d8c48ab1$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $21ecd847d8c48ab1$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            const defaultValue = $21ecd847d8c48ab1$export$3988ae62b71be9a3(_formValues, name, $21ecd847d8c48ab1$var$isUndefined(value1) ? $21ecd847d8c48ab1$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $21ecd847d8c48ab1$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $21ecd847d8c48ab1$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $21ecd847d8c48ab1$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _state.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name: name
        };
        if (!isBlurEvent || shouldDirty) {
            if (_proxyFormState.isDirty) {
                isPreviousDirty = _formState.isDirty;
                _formState.isDirty = output.isDirty = _getDirty();
                shouldUpdateField = isPreviousDirty !== output.isDirty;
            }
            const isCurrentFieldPristine = $21ecd847d8c48ab1$var$deepEqual($21ecd847d8c48ab1$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
            isPreviousDirty = $21ecd847d8c48ab1$export$3988ae62b71be9a3(_formState.dirtyFields, name);
            isCurrentFieldPristine ? $21ecd847d8c48ab1$var$unset(_formState.dirtyFields, name) : $21ecd847d8c48ab1$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
            output.dirtyFields = _formState.dirtyFields;
            shouldUpdateField = shouldUpdateField || _proxyFormState.dirtyFields && isPreviousDirty !== !isCurrentFieldPristine;
        }
        if (isBlurEvent) {
            const isPreviousFieldTouched = $21ecd847d8c48ab1$export$3988ae62b71be9a3(_formState.touchedFields, name);
            if (!isPreviousFieldTouched) {
                $21ecd847d8c48ab1$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
                output.touchedFields = _formState.touchedFields;
                shouldUpdateField = shouldUpdateField || _proxyFormState.touchedFields && isPreviousFieldTouched !== isBlurEvent;
            }
        }
        shouldUpdateField && shouldRender && _subjects.state.next(output);
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = $21ecd847d8c48ab1$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid && $21ecd847d8c48ab1$var$isBoolean(isValid) && _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(props.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? $21ecd847d8c48ab1$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $21ecd847d8c48ab1$var$unset(_formState.errors, name);
        }
        if ((error ? !$21ecd847d8c48ab1$var$deepEqual(previousFieldError, error) : previousFieldError) || !$21ecd847d8c48ab1$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...shouldUpdateValid && $21ecd847d8c48ab1$var$isBoolean(isValid) ? {
                    isValid: isValid
                } : {},
                errors: _formState.errors,
                name: name
            };
            _formState = {
                ..._formState,
                ...updatedFormState
            };
            _subjects.state.next(updatedFormState);
        }
        _updateIsValidating(false);
    };
    const _executeSchema = async (name)=>_options.resolver(_formValues, _options.context, $21ecd847d8c48ab1$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors: errors } = await _executeSchema();
        if (names) for (const name of names){
            const error = $21ecd847d8c48ab1$export$3988ae62b71be9a3(errors, name);
            error ? $21ecd847d8c48ab1$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $21ecd847d8c48ab1$var$unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const name in fields){
            const field = fields[name];
            if (field) {
                const { _f: _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const fieldError = await $21ecd847d8c48ab1$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) break;
                    }
                    !shouldOnlyCheckValid && ($21ecd847d8c48ab1$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $21ecd847d8c48ab1$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $21ecd847d8c48ab1$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $21ecd847d8c48ab1$var$unset(_formState.errors, _f.name));
                }
                fieldValue && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $21ecd847d8c48ab1$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$21ecd847d8c48ab1$var$live(ref)) : !$21ecd847d8c48ab1$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>(name && data && $21ecd847d8c48ab1$export$adaa4cf7ef1b65be(_formValues, name, data), !$21ecd847d8c48ab1$var$deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>$21ecd847d8c48ab1$var$generateWatchOutput(names, _names, {
            ..._state.mount ? _formValues : $21ecd847d8c48ab1$var$isUndefined(defaultValue) ? _defaultValues : $21ecd847d8c48ab1$var$isString(names) ? {
                [names]: defaultValue
            } : defaultValue
        }, isGlobal, defaultValue);
    const _getFieldArray = (name)=>$21ecd847d8c48ab1$var$compact($21ecd847d8c48ab1$export$3988ae62b71be9a3(_state.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? $21ecd847d8c48ab1$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = $21ecd847d8c48ab1$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $21ecd847d8c48ab1$export$adaa4cf7ef1b65be(_formValues, name, $21ecd847d8c48ab1$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $21ecd847d8c48ab1$var$isHTMLElement(fieldReference.ref) && $21ecd847d8c48ab1$var$isNullOrUndefined(value1) ? "" : value1;
                if ($21ecd847d8c48ab1$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if ($21ecd847d8c48ab1$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.length > 1 ? fieldReference.refs.forEach((checkboxRef)=>(!checkboxRef.defaultChecked || !checkboxRef.disabled) && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find((data)=>data === checkboxRef.value) : fieldValue === checkboxRef.value)) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($21ecd847d8c48ab1$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = "";
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.values.next({
                        name: name,
                        values: {
                            ..._formValues
                        }
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            const fieldValue = value1[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = $21ecd847d8c48ab1$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || !$21ecd847d8c48ab1$var$isPrimitive(fieldValue) || field && !field._f) && !$21ecd847d8c48ab1$var$isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = $21ecd847d8c48ab1$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = $21ecd847d8c48ab1$var$cloneObject(value1);
        $21ecd847d8c48ab1$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: {
                    ..._formValues
                }
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) && options.shouldDirty) _subjects.state.next({
                name: name,
                dirtyFields: $21ecd847d8c48ab1$var$getDirtyFields(_defaultValues, _formValues),
                isDirty: _getDirty(name, cloneValue)
            });
        } else field && !field._f && !$21ecd847d8c48ab1$var$isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        $21ecd847d8c48ab1$var$isWatched(name, _names) && _subjects.state.next({
            ..._formState
        });
        _subjects.values.next({
            name: name,
            values: {
                ..._formValues
            }
        });
        !_state.mount && flushRootRender();
    };
    const onChange = async (event)=>{
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = $21ecd847d8c48ab1$export$3988ae62b71be9a3(_fields, name);
        const getCurrentFieldValue = ()=>target.type ? $21ecd847d8c48ab1$var$getFieldValue(field._f) : $21ecd847d8c48ab1$var$getEventValue(event);
        if (field) {
            let error;
            let isValid;
            const fieldValue = getCurrentFieldValue();
            const isBlurEvent = event.type === $21ecd847d8c48ab1$var$EVENTS.BLUR || event.type === $21ecd847d8c48ab1$var$EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !$21ecd847d8c48ab1$var$hasValidation(field._f) && !_options.resolver && !$21ecd847d8c48ab1$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $21ecd847d8c48ab1$var$skipValidation(isBlurEvent, $21ecd847d8c48ab1$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = $21ecd847d8c48ab1$var$isWatched(name, _names, isBlurEvent);
            $21ecd847d8c48ab1$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !$21ecd847d8c48ab1$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.values.next({
                name: name,
                type: event.type,
                values: {
                    ..._formValues
                }
            });
            if (shouldSkipValidation) {
                _proxyFormState.isValid && _updateValid();
                return shouldRender && _subjects.state.next({
                    name: name,
                    ...watched ? {} : fieldState
                });
            }
            !isBlurEvent && watched && _subjects.state.next({
                ..._formState
            });
            _updateIsValidating(true);
            if (_options.resolver) {
                const { errors: errors } = await _executeSchema([
                    name
                ]);
                const previousErrorLookupResult = $21ecd847d8c48ab1$var$schemaErrorLookup(_formState.errors, _fields, name);
                const errorLookupResult = $21ecd847d8c48ab1$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                error = errorLookupResult.error;
                name = errorLookupResult.name;
                isValid = $21ecd847d8c48ab1$var$isEmptyObject(errors);
            } else {
                error = (await $21ecd847d8c48ab1$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                isFieldValueUpdated = isNaN(fieldValue) || fieldValue === $21ecd847d8c48ab1$export$3988ae62b71be9a3(_formValues, name, fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid) isValid = await executeBuiltInValidation(_fields, true);
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = $21ecd847d8c48ab1$var$convertToArrayPayload(name);
        _updateIsValidating(true);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($21ecd847d8c48ab1$var$isUndefined(name) ? name : fieldNames);
            isValid = $21ecd847d8c48ab1$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$21ecd847d8c48ab1$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $21ecd847d8c48ab1$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        } else validationResult = isValid = await executeBuiltInValidation(_fields);
        _subjects.state.next({
            ...!$21ecd847d8c48ab1$var$isString(name) || _proxyFormState.isValid && isValid !== _formState.isValid ? {} : {
                name: name
            },
            ..._options.resolver || !name ? {
                isValid: isValid
            } : {},
            errors: _formState.errors,
            isValidating: false
        });
        options.shouldFocus && !validationResult && $21ecd847d8c48ab1$var$focusFieldBy(_fields, (key)=>key && $21ecd847d8c48ab1$export$3988ae62b71be9a3(_formState.errors, key), name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames)=>{
        const values = {
            ..._defaultValues,
            ..._state.mount ? _formValues : {}
        };
        return $21ecd847d8c48ab1$var$isUndefined(fieldNames) ? values : $21ecd847d8c48ab1$var$isString(fieldNames) ? $21ecd847d8c48ab1$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$21ecd847d8c48ab1$export$3988ae62b71be9a3(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!$21ecd847d8c48ab1$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$21ecd847d8c48ab1$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            isTouched: !!$21ecd847d8c48ab1$export$3988ae62b71be9a3((formState || _formState).touchedFields, name),
            error: $21ecd847d8c48ab1$export$3988ae62b71be9a3((formState || _formState).errors, name)
        });
    const clearErrors = (name)=>{
        name && $21ecd847d8c48ab1$var$convertToArrayPayload(name).forEach((inputName)=>$21ecd847d8c48ab1$var$unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = ($21ecd847d8c48ab1$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        $21ecd847d8c48ab1$export$adaa4cf7ef1b65be(_formState.errors, name, {
            ...error,
            ref: ref
        });
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>$21ecd847d8c48ab1$var$isFunction(name) ? _subjects.values.subscribe({
            next: (payload)=>name(_getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? $21ecd847d8c48ab1$var$convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                $21ecd847d8c48ab1$var$unset(_fields, fieldName);
                $21ecd847d8c48ab1$var$unset(_formValues, fieldName);
            }
            !options.keepError && $21ecd847d8c48ab1$var$unset(_formState.errors, fieldName);
            !options.keepDirty && $21ecd847d8c48ab1$var$unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && $21ecd847d8c48ab1$var$unset(_formState.touchedFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && $21ecd847d8c48ab1$var$unset(_defaultValues, fieldName);
        }
        _subjects.values.next({
            values: {
                ..._formValues
            }
        });
        _subjects.state.next({
            ..._formState,
            ...!options.keepDirty ? {} : {
                isDirty: _getDirty()
            }
        });
        !options.keepIsValid && _updateValid();
    };
    const register = (name, options = {})=>{
        let field = $21ecd847d8c48ab1$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $21ecd847d8c48ab1$var$isBoolean(options.disabled);
        $21ecd847d8c48ab1$export$adaa4cf7ef1b65be(_fields, name, {
            ...field || {},
            _f: {
                ...field && field._f ? field._f : {
                    ref: {
                        name: name
                    }
                },
                name: name,
                mount: true,
                ...options
            }
        });
        _names.mount.add(name);
        field ? disabledIsDefined && $21ecd847d8c48ab1$export$adaa4cf7ef1b65be(_formValues, name, options.disabled ? undefined : $21ecd847d8c48ab1$export$3988ae62b71be9a3(_formValues, name, $21ecd847d8c48ab1$var$getFieldValue(field._f))) : updateValidAndValue(name, true, options.value);
        return {
            ...disabledIsDefined ? {
                disabled: options.disabled
            } : {},
            ..._options.shouldUseNativeValidation ? {
                required: !!options.required,
                min: $21ecd847d8c48ab1$var$getRuleValue(options.min),
                max: $21ecd847d8c48ab1$var$getRuleValue(options.max),
                minLength: $21ecd847d8c48ab1$var$getRuleValue(options.minLength),
                maxLength: $21ecd847d8c48ab1$var$getRuleValue(options.maxLength),
                pattern: $21ecd847d8c48ab1$var$getRuleValue(options.pattern)
            } : {},
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = $21ecd847d8c48ab1$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $21ecd847d8c48ab1$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll("input,select,textarea")[0] || ref : ref : ref;
                    const radioOrCheckbox = $21ecd847d8c48ab1$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    $21ecd847d8c48ab1$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: {
                            ...field._f,
                            ...radioOrCheckbox ? {
                                refs: [
                                    ...refs.filter($21ecd847d8c48ab1$var$live),
                                    fieldRef,
                                    ...Array.isArray($21ecd847d8c48ab1$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                        {}
                                    ] : []
                                ],
                                ref: {
                                    type: fieldRef.type,
                                    name: name
                                }
                            } : {
                                ref: fieldRef
                            }
                        }
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $21ecd847d8c48ab1$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($21ecd847d8c48ab1$var$isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        };
    };
    const _focusError = ()=>_options.shouldFocusError && $21ecd847d8c48ab1$var$focusFieldBy(_fields, (key)=>key && $21ecd847d8c48ab1$export$3988ae62b71be9a3(_formState.errors, key), _names.mount);
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = $21ecd847d8c48ab1$var$cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors: errors, values: values } = await _executeSchema();
                _formState.errors = errors;
                fieldValues = values;
            } else await executeBuiltInValidation(_fields);
            $21ecd847d8c48ab1$var$unset(_formState.errors, "root");
            if ($21ecd847d8c48ab1$var$isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                await onValid(fieldValues, e);
            } else {
                if (onInvalid) await onInvalid({
                    ..._formState.errors
                }, e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: $21ecd847d8c48ab1$var$isEmptyObject(_formState.errors),
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
        };
    const resetField = (name, options = {})=>{
        if ($21ecd847d8c48ab1$export$3988ae62b71be9a3(_fields, name)) {
            if ($21ecd847d8c48ab1$var$isUndefined(options.defaultValue)) setValue(name, $21ecd847d8c48ab1$export$3988ae62b71be9a3(_defaultValues, name));
            else {
                setValue(name, options.defaultValue);
                $21ecd847d8c48ab1$export$adaa4cf7ef1b65be(_defaultValues, name, options.defaultValue);
            }
            if (!options.keepTouched) $21ecd847d8c48ab1$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $21ecd847d8c48ab1$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $21ecd847d8c48ab1$export$3988ae62b71be9a3(_defaultValues, name)) : _getDirty();
            }
            if (!options.keepError) {
                $21ecd847d8c48ab1$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({
                ..._formState
            });
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues || _defaultValues;
        const cloneUpdatedValues = $21ecd847d8c48ab1$var$cloneObject(updatedValues);
        const values = formValues && !$21ecd847d8c48ab1$var$isEmptyObject(formValues) ? cloneUpdatedValues : _defaultValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues || shouldCaptureDirtyFields) for (const fieldName of _names.mount)$21ecd847d8c48ab1$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName) ? $21ecd847d8c48ab1$export$adaa4cf7ef1b65be(values, fieldName, $21ecd847d8c48ab1$export$3988ae62b71be9a3(_formValues, fieldName)) : setValue(fieldName, $21ecd847d8c48ab1$export$3988ae62b71be9a3(values, fieldName));
            else {
                if ($21ecd847d8c48ab1$var$isWeb && $21ecd847d8c48ab1$var$isUndefined(formValues)) for (const name of _names.mount){
                    const field = $21ecd847d8c48ab1$export$3988ae62b71be9a3(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if ($21ecd847d8c48ab1$var$isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest("form");
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister ? keepStateOptions.keepDefaultValues ? $21ecd847d8c48ab1$var$cloneObject(_defaultValues) : {} : cloneUpdatedValues;
            _subjects.array.next({
                values: {
                    ...values
                }
            });
            _subjects.values.next({
                values: {
                    ...values
                }
            });
        }
        _names = {
            mount: new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ""
        };
        !_state.mount && flushRootRender();
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid;
        _state.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !$21ecd847d8c48ab1$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: keepStateOptions.keepDirtyValues ? _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $21ecd847d8c48ab1$var$getDirtyFields(_defaultValues, formValues) : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitting: false,
            isSubmitSuccessful: false
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset($21ecd847d8c48ab1$var$isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
    const setFocus = (name, options = {})=>{
        const field = $21ecd847d8c48ab1$export$3988ae62b71be9a3(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && fieldRef.select();
            }
        }
    };
    const _updateFormState = (updatedFormState)=>{
        _formState = {
            ..._formState,
            ...updatedFormState
        };
    };
    const _resetDefaultValues = ()=>$21ecd847d8c48ab1$var$isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    return {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            _executeSchema: _executeSchema,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _updateValid: _updateValid,
            _removeUnmounted: _removeUnmounted,
            _updateFieldArray: _updateFieldArray,
            _getFieldArray: _getFieldArray,
            _reset: _reset,
            _resetDefaultValues: _resetDefaultValues,
            _updateFormState: _updateFormState,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            set _formState (value){
                _formState = value;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = {
                    ..._options,
                    ...value
                };
            }
        },
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $21ecd847d8c48ab1$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).useRef();
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).useState({
        isDirty: false,
        isValidating: false,
        isLoading: $21ecd847d8c48ab1$var$isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        errors: {},
        defaultValues: $21ecd847d8c48ab1$var$isFunction(props.defaultValues) ? undefined : props.defaultValues
    });
    if (!_formControl.current) _formControl.current = {
        ...$21ecd847d8c48ab1$var$createFormControl(props, ()=>updateFormState((formState)=>({
                    ...formState
                }))),
        formState: formState
    };
    const control = _formControl.current.control;
    control._options = props;
    $21ecd847d8c48ab1$var$useSubscribe({
        subject: control._subjects.state,
        next: (value1)=>{
            if ($21ecd847d8c48ab1$var$shouldRenderFormState(value1, control._proxyFormState, control._updateFormState, true)) updateFormState({
                ...control._formState
            });
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).useEffect(()=>{
        if (props.values && !$21ecd847d8c48ab1$var$deepEqual(props.values, control._defaultValues)) control._reset(props.values, control._options.resetOptions);
        else control._resetDefaultValues();
    }, [
        props.values,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($2gcPZ))).useEffect(()=>{
        if (!control._state.mount) {
            control._updateValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({
                ...control._formState
            });
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = $21ecd847d8c48ab1$var$getProxyFormState(formState, control);
    return _formControl.current;
}





var $32254342c34c4824$var$e = function(i, e, t) {
    if (i && "reportValidity" in i) {
        var f = (0, $21ecd847d8c48ab1$export$3988ae62b71be9a3)(t, e);
        i.setCustomValidity(f && f.message || ""), i.reportValidity();
    }
}, $32254342c34c4824$export$6bd436d70894afff = function(r, i) {
    var t = function(t) {
        var f = i.fields[t];
        f && f.ref && "reportValidity" in f.ref ? $32254342c34c4824$var$e(f.ref, t, r) : f.refs && f.refs.forEach(function(i) {
            return $32254342c34c4824$var$e(i, t, r);
        });
    };
    for(var f in i.fields)t(f);
}, $32254342c34c4824$export$3cfb7e8a4d7a0630 = function(e, f) {
    f.shouldUseNativeValidation && $32254342c34c4824$export$6bd436d70894afff(e, f);
    var o = {};
    for(var a in e){
        var n = (0, $21ecd847d8c48ab1$export$3988ae62b71be9a3)(f.fields, a);
        (0, $21ecd847d8c48ab1$export$adaa4cf7ef1b65be)(o, a, Object.assign(e[a] || {}, {
            ref: n && n.ref
        }));
    }
    return o;
};


var $bfa0c473fca02259$var$n = function(e, o) {
    for(var n = {}; e.length;){
        var t = e[0], s = t.code, i = t.message, a = t.path.join(".");
        if (!n[a]) {
            if ("unionErrors" in t) {
                var u = t.unionErrors[0].errors[0];
                n[a] = {
                    message: u.message,
                    type: u.code
                };
            } else n[a] = {
                message: i,
                type: s
            };
        }
        if ("unionErrors" in t && t.unionErrors.forEach(function(r) {
            return r.errors.forEach(function(r) {
                return e.push(r);
            });
        }), o) {
            var c = n[a].types, f = c && c[t.code];
            n[a] = (0, $21ecd847d8c48ab1$export$b196c2a4f765bd30)(a, o, n, s, f ? [].concat(f, t.message) : t.message);
        }
        e.shift();
    }
    return n;
}, $bfa0c473fca02259$export$66b7b5879c70f722 = function(r, t, s) {
    return void 0 === s && (s = {}), function(i, a, u) {
        try {
            return Promise.resolve(function(o, n) {
                try {
                    var a = Promise.resolve(r["sync" === s.mode ? "parse" : "parseAsync"](i, t)).then(function(r) {
                        return u.shouldUseNativeValidation && (0, $32254342c34c4824$export$6bd436d70894afff)({}, u), {
                            errors: {},
                            values: s.raw ? i : r
                        };
                    });
                } catch (r) {
                    return n(r);
                }
                return a && a.then ? a.then(void 0, n) : a;
            }(0, function(r) {
                if (function(r) {
                    return null != r.errors;
                }(r)) return {
                    values: {},
                    errors: (0, $32254342c34c4824$export$3cfb7e8a4d7a0630)($bfa0c473fca02259$var$n(r.errors, !u.shouldUseNativeValidation && "all" === u.criteriaMode), u)
                };
                throw r;
            }));
        } catch (r) {
            return Promise.reject(r);
        }
    };
};








// A simple regex pattern for a valid URL path
const $c458e9b3bec448e8$var$urlPathPattern = /^\/[^ "]*$/;
const $c458e9b3bec448e8$var$UrlOrPathSchema = (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).union([
    (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string().nonempty("A url or path is required").url(),
    (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string().nonempty().refine((value)=>$c458e9b3bec448e8$var$urlPathPattern.test(value), {
        message: "Not a valid URL or path"
    })
]);
const $c458e9b3bec448e8$var$formSchema = (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).object({
    name: (0, $a30ca2726c0ab339$export$2e2bcd8739ae039).string().nonempty("A name is required"),
    url: $c458e9b3bec448e8$var$UrlOrPathSchema
});
function $c458e9b3bec448e8$export$21cde1e6a73cf500({ closeForm: closeForm, environment: environment }) {
    const { handleSubmit: handleSubmit, register: register, formState: formState } = (0, $21ecd847d8c48ab1$export$87c0cf8eb5a167e0)({
        resolver: (0, $bfa0c473fca02259$export$66b7b5879c70f722)($c458e9b3bec448e8$var$formSchema),
        defaultValues: {
            name: environment?.name ?? "",
            url: environment?.url ?? ""
        }
    });
    const handleEscape = ()=>{
        const activeElement = document.activeElement;
        const isInput = activeElement instanceof HTMLInputElement;
        if (isInput && (activeElement.id === "name" || activeElement.id === "url")) closeForm();
    };
    (0, $b983b4c95358e607$export$d0951a301bdf7751)("Escape", handleEscape);
    const onSubmitForm = (changes)=>{
        if (environment) {
            const { id: id } = environment;
            (0, $c41f178228bd3003$export$635e15bbd66f01ea)((0, $ecfe56675d6ea75b$export$b72a60b4ff774144)({
                ...changes,
                id: id
            }));
            (0, $c41f178228bd3003$export$635e15bbd66f01ea)((0, $ecfe56675d6ea75b$export$3b7e95cf3154ca1f)(id));
        } else {
            const id = String(Date.now());
            (0, $c41f178228bd3003$export$635e15bbd66f01ea)((0, $ecfe56675d6ea75b$export$a78fd88194b4f36a)({
                ...changes,
                id: id
            }));
            (0, $c41f178228bd3003$export$635e15bbd66f01ea)((0, $ecfe56675d6ea75b$export$3b7e95cf3154ca1f)(id));
        }
        closeForm();
    };
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($c458e9b3bec448e8$var$AddEnvironment, {
        as: "form",
        onSubmit: handleSubmit(onSubmitForm),
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($c458e9b3bec448e8$var$EnvironmentInputFields, {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($c458e9b3bec448e8$var$InputLabel, {
                        as: "label",
                        htmlFor: "prometheusName",
                        children: "Name"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($c458e9b3bec448e8$var$StyledTextInput, {
                        placeholder: "e.g., Production",
                        id: "prometheusName",
                        autoFocus: true,
                        ...register("name"),
                        "data-invalid": formState.errors.name === undefined ? undefined : true
                    }),
                    formState.errors.name && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $8f7cbd990124ab89$export$915e9e7bd4f0f96d), {
                        children: formState.errors.name.message
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($c458e9b3bec448e8$var$InputLabel, {
                        as: "label",
                        htmlFor: "url",
                        children: "URL"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($c458e9b3bec448e8$var$StyledTextInput, {
                        placeholder: "e.g., http://localhost:9090",
                        id: "url",
                        ...register("url"),
                        "data-invalid": formState.errors.url === undefined ? undefined : true
                    }),
                    formState.errors.url && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $8f7cbd990124ab89$export$915e9e7bd4f0f96d), {
                        children: formState.errors.url.message
                    })
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($c458e9b3bec448e8$var$FormButtonsContainer, {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a921dfdbd8dd60fa$export$353f5b6fc5456de1), {
                        type: "reset",
                        buttonStyle: "secondary",
                        onClick: ()=>closeForm(),
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a921dfdbd8dd60fa$export$353f5b6fc5456de1), {
                        type: "submit",
                        buttonStyle: "primary",
                        children: "Save"
                    })
                ]
            })
        ]
    });
}
const $c458e9b3bec448e8$var$FormButtonsContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $9e604dd7bbd62f05$export$3cee892aeea6082e))`
  gap: 8px;
  justify-content: end;
`;
const $c458e9b3bec448e8$var$AddEnvironment = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $9e604dd7bbd62f05$export$21675fbbea47cdb6))`
  grid:
    "input" auto
    "buttons" auto
    / 1fr;
  gap: 16px;
  cursor: default;
`;
const $c458e9b3bec448e8$var$InputLabel = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $9e604dd7bbd62f05$export$9e22197817ed9e0d))`
  grid-area: unset;
`;
const $c458e9b3bec448e8$var$StyledTextInput = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $a921dfdbd8dd60fa$export$f5b8910cec6cf069)).attrs({
    type: "text"
})``;
const $c458e9b3bec448e8$var$EnvironmentInputFields = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  grid-area: input;
  display: grid;
  align-items: center;
  grid: auto-flow / auto 1fr;
  gap: 12px 16px;

  ${$c458e9b3bec448e8$var$InputLabel} {
    grid-column: 1;
  }

  ${$c458e9b3bec448e8$var$StyledTextInput}, ${(0, $8f7cbd990124ab89$export$915e9e7bd4f0f96d)} {
    grid-column: 2;
  }
`;












function $d1fad42211507a32$export$ec62ed858d4e20a7({ status: status }) {
    const errorCount = Object.values(status).filter((success)=>success === (0, $e46c0d05a3c80666$exports.QueryStatus).rejected).length;
    const text = $d1fad42211507a32$var$getText(errorCount);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($d1fad42211507a32$var$Container, {
        $errorCount: errorCount,
        children: text
    });
}
function $d1fad42211507a32$var$getText(errorCount) {
    switch(errorCount){
        case 0:
            return "Connected";
        case 1:
            return "1 error";
        default:
            return `${errorCount} errors`;
    }
}
const $d1fad42211507a32$var$Container = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).span(({ $errorCount: $errorCount, theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      display: inline-flex;
      padding: 0px 6px;
      align-items: center;
      gap: 6px;
      color: ${theme.color.fg.muted};
      border: 1px solid ${theme.color.border.muted};
      border-radius: ${theme.radius.minimal};
      font: ${theme.font.body.sm.regular};

      ${()=>{
        switch($errorCount){
            case 0:
                return (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
              color: ${theme.color.fg.success};
              border-color: ${theme.color.border.success};
            `;
            default:
                return (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
              color: ${theme.color.fg.danger};
              border-color: ${theme.color.border.danger};
            `;
        }
    }}
    `);






function $4b8b6ef9798f461d$export$3ac9ba9f17e95dcb({ status: status }) {
    const errors = Object.entries(status).filter(([, status])=>status === (0, $e46c0d05a3c80666$exports.QueryStatus).rejected);
    if (errors.length === 0) return null;
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($4b8b6ef9798f461d$var$List, {
        children: errors.map(([errorKey])=>{
            return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($4b8b6ef9798f461d$var$ListItem, {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($4b8b6ef9798f461d$var$ErrorIcon, {
                        type: "close"
                    }),
                    $4b8b6ef9798f461d$var$getErrorMessage(errorKey)
                ]
            }, errorKey);
        })
    });
}
function $4b8b6ef9798f461d$var$getErrorMessage(key) {
    switch(key){
        case "ping":
            return "Unable to connect to the Prometheus instance";
        case "query":
            return "Unable to query the Prometheus instance";
    }
}
const $4b8b6ef9798f461d$var$List = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).ul(()=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    grid-area: errors;
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin: 0;
    padding: 0;
  `);
const $4b8b6ef9798f461d$var$ListItem = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).li(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    display: flex;
    align-items: flex-start;
    gap: 8px;
    font: ${theme.font.body.sm.medium};
    color: ${theme.color.fg.muted};
  `);
const $4b8b6ef9798f461d$var$ErrorIcon = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $0a830394bc38e4e3$export$f04a61298a47a40f))(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      color: ${theme.color.fg.danger};
    `);




var $2gcPZ = parcelRequire("2gcPZ");




function $5e870d7173835f5f$export$3d15a619de7c43b6({ onEdit: onEdit, onRemove: onRemove }) {
    const buttonRef = (0, $2gcPZ.useRef)(null);
    const [menuIsVisible, setMenuIsVisible] = (0, $2gcPZ.useState)(false);
    const toggleMenu = (event)=>{
        (0, $0cca6883e0725c68$export$e9caaaecfee38128)(event);
        setMenuIsVisible((current)=>!current);
    };
    const menuRef = (0, $2gcPZ.useRef)(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($fba371f6e5a68b67$exports)))(menuRef, ()=>{
        if (menuIsVisible) setMenuIsVisible(false);
    });
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $afa7be861492543f$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $481f0e286e6dd560$export$c25acd513dcc8062), {
                buttonStyle: "tertiary-grey",
                iconType: "dots_three",
                onClick: toggleMenu,
                ref: buttonRef,
                type: "button"
            }),
            menuIsVisible && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $87fe9d22a5eec31a$export$fd7a256405e9ea77), {
                element: buttonRef.current,
                offset: [
                    0,
                    8
                ],
                placement: "bottom",
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($5e870d7173835f5f$var$MenuContainer, {
                    ref: menuRef,
                    children: [
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($5e870d7173835f5f$var$MenuItem, {
                            onClick: onRemove,
                            children: "Delete"
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($5e870d7173835f5f$var$MenuItem, {
                            onClick: onEdit,
                            children: "Edit"
                        })
                    ]
                })
            })
        ]
    });
}
const $5e870d7173835f5f$var$MenuContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).nav(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      display: flex;
      padding: 8px;
      gap: 8px;
      flex-direction: column;
      align-items: flex-start;
      align-self: stretch;
      border-radius: ${theme.radius.default};
      background: ${theme.color.bg.elevated.default};
      box-shadow: ${theme.effect.shadow.m};
    `);
const $5e870d7173835f5f$var$MenuItem = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).button(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      display: flex;
      padding: 8px 12px;
      align-items: center;
      gap: 12px;
      width: 100%;
      border: none;
      border-radius: ${theme.radius.default};
      box-shadow: none;
      background: transparent;
      font: ${theme.font.body.md.regular};
      color: ${theme.color.fg.default};

      &:hover {
        background: ${theme.color.bg.elevated.hover};
        cursor: pointer;
      }
    `);


const $0fc6f20358bc535f$var$DEFAULT_INTERVAL = 20000;
function $0fc6f20358bc535f$export$278a1b6bc2b22995({ environment: environment, onEdit: onEdit }) {
    const { selectedInstance: selectedInstance } = (0, $162ecfa8ddc7a9ff$export$a7347740d65f620b)((state)=>state.environment);
    const isActiveInstance = environment.id === selectedInstance;
    // We poll the ping endpoint regularly to keep track of connection status.
    // The environment slice keeps track of the rtk queries and updates the
    // connection status per environment.
    (0, $fe24d45de7923f97$export$95c0f256a1e9b1b2)(environment.url, {
        refetchOnMountOrArgChange: true,
        skip: !environment.url,
        pollingInterval: $0fc6f20358bc535f$var$DEFAULT_INTERVAL
    });
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $9e604dd7bbd62f05$export$21675fbbea47cdb6), {
        $isActive: isActiveInstance,
        onClick: ()=>(0, $c41f178228bd3003$export$635e15bbd66f01ea)((0, $ecfe56675d6ea75b$export$3b7e95cf3154ca1f)(environment.id)),
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a921dfdbd8dd60fa$export$f5b8910cec6cf069), {
                type: "radio",
                checked: isActiveInstance,
                readOnly: true
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $9e604dd7bbd62f05$export$9e22197817ed9e0d), {
                children: [
                    environment.name,
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $d1fad42211507a32$export$ec62ed858d4e20a7), {
                        status: environment.connectionStatus
                    })
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($0fc6f20358bc535f$var$EnvironmentUrl, {
                children: environment.url
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $4b8b6ef9798f461d$export$3ac9ba9f17e95dcb), {
                status: environment.connectionStatus
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $9e604dd7bbd62f05$export$3cee892aeea6082e), {
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $5e870d7173835f5f$export$3d15a619de7c43b6), {
                    onRemove: ()=>(0, $c41f178228bd3003$export$635e15bbd66f01ea)((0, $ecfe56675d6ea75b$export$99b0db74c81be036)(environment)),
                    onEdit: onEdit
                })
            })
        ]
    }, environment.id);
}
const $0fc6f20358bc535f$var$EnvironmentUrl = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).p(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      grid-area: url;
      font: ${theme.font.body.sm.regular};
      color: ${theme.color.fg.muted};
    `);


function $887356c12179bd9c$export$a0740a2a20745763() {
    const [showAddEnvironment, setShowAddEnvironment] = (0, $2gcPZ.useState)(false);
    const [editEnvironmentId, setEditEnvironmentId] = (0, $2gcPZ.useState)();
    const { instances: instances } = (0, $162ecfa8ddc7a9ff$export$a7347740d65f620b)((state)=>state.environment);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($887356c12179bd9c$var$EnvironmentsContainer, {
        children: [
            instances.length > 0 && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($887356c12179bd9c$var$EnvironmentsList, {
                children: instances.map((instance)=>{
                    if (editEnvironmentId === instance.id) return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $c458e9b3bec448e8$export$21cde1e6a73cf500), {
                        // eslint-disable-next-line unicorn/no-useless-undefined
                        closeForm: ()=>setEditEnvironmentId(undefined),
                        environment: instance
                    }, instance.id);
                    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0fc6f20358bc535f$export$278a1b6bc2b22995), {
                        environment: instance,
                        onEdit: ()=>setEditEnvironmentId(instance.id)
                    }, instance.id);
                })
            }),
            showAddEnvironment && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $c458e9b3bec448e8$export$21cde1e6a73cf500), {
                closeForm: ()=>setShowAddEnvironment(false)
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($887356c12179bd9c$var$StyledButton, {
                onClick: ()=>setShowAddEnvironment(true),
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0a830394bc38e4e3$export$f04a61298a47a40f), {
                        type: "plus"
                    }),
                    " New URL"
                ]
            })
        ]
    });
}
const $887356c12179bd9c$var$StyledButton = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $a921dfdbd8dd60fa$export$353f5b6fc5456de1))(({ theme: { media: media } })=>media.sm`
    justify-self: start;
  `);
const $887356c12179bd9c$var$EnvironmentsList = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).ul`
  padding: 0;
  margin: 0;
  display: grid;
  gap: ${({ theme: theme })=>theme.spacing.content.gap.md};
`;
const $887356c12179bd9c$var$EnvironmentsContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: grid;
  row-gap: 20px;
`;








function $2c0f3c0766bd233f$export$d7344b2b6d802efd() {
    const { value: value, set: updateSettings, supported: supported } = (0, $a82ff438e9d7ee7b$export$14a266f6d49360ef)();
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($2c0f3c0766bd233f$var$Container, {
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($2c0f3c0766bd233f$var$FormContainer, {
            children: [
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("h4", {
                    children: "Show links to source code"
                }),
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($2c0f3c0766bd233f$var$FormContent, {
                    children: [
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($2c0f3c0766bd233f$var$StyledLabel, {
                            children: [
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a921dfdbd8dd60fa$export$f5b8910cec6cf069), {
                                    type: "radio",
                                    name: "notificationSettings",
                                    value: "off",
                                    disabled: !supported,
                                    checked: value === "off",
                                    onChange: ()=>{
                                        updateSettings("off");
                                    }
                                }),
                                "Off"
                            ]
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($2c0f3c0766bd233f$var$StyledLabel, {
                            children: [
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a921dfdbd8dd60fa$export$f5b8910cec6cf069), {
                                    type: "radio",
                                    name: "notificationSettings",
                                    value: "vscode",
                                    disabled: !supported,
                                    checked: value === "vscode",
                                    onChange: ()=>{
                                        updateSettings("vscode");
                                    }
                                }),
                                "Link to Visual Studio Code"
                            ]
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($2c0f3c0766bd233f$var$StyledLabel, {
                            children: [
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a921dfdbd8dd60fa$export$f5b8910cec6cf069), {
                                    type: "radio",
                                    name: "notificationSettings",
                                    value: "text",
                                    disabled: !supported,
                                    checked: value === "text",
                                    onChange: ()=>{
                                        updateSettings("text");
                                    }
                                }),
                                "Plain text"
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
const $2c0f3c0766bd233f$var$Container = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: grid;
  gap: 24px;
`;
const $2c0f3c0766bd233f$var$FormContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: grid;
  gap: 12px;
`;
const $2c0f3c0766bd233f$var$FormContent = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: grid;
  gap: 8px;
`;
const $2c0f3c0766bd233f$var$StyledLabel = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).label`
  display: flex;
  align-items: center;
  gap: 8px;
`;






parcelRequire("2gcPZ");
const $b911fc6ed0e74800$var$SvgThemeLight = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 184,
        height: 120,
        viewBox: "0 0 184 120",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("g", {
                clipPath: "url(#ThemeLight_svg__a)",
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                        d: "M0 6a6 6 0 0 1 6-6h172a6 6 0 0 1 6 6v108a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6Z",
                        fill: "#EBEAED"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("g", {
                        clipPath: "url(#ThemeLight_svg__b)",
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("mask", {
                                id: "ThemeLight_svg__c",
                                fill: "#fff",
                                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                    d: "M12 12h160v9.6H12V12Z"
                                })
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M12 12h160v9.6H12V12Z",
                                fill: "#fff"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("circle", {
                                cx: 16.8,
                                cy: 16.8,
                                fill: "#9027FF",
                                r: 1.6
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("circle", {
                                cx: 21.6,
                                cy: 16.8,
                                fill: "#FA52F1",
                                r: 1.6
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("circle", {
                                cx: 26.399,
                                cy: 16.8,
                                fill: "#FA9F34",
                                r: 1.6
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                                x: 152.8,
                                y: 14.4,
                                width: 16,
                                height: 4.8,
                                rx: 0.8,
                                fill: "#EBEAED"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M172 21.2H12v.8h160v-.8Z",
                                fill: "#D6D4D9",
                                mask: "url(#ThemeLight_svg__c)"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                fill: "#fff",
                                d: "M12 21.6h160v111.25H12z"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                                x: 15.2,
                                y: 28.6,
                                width: 18,
                                height: 3.2,
                                rx: 0.8,
                                fill: "#EBEAED"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                                x: 15.2,
                                y: 35,
                                width: 18,
                                height: 3.2,
                                rx: 0.8,
                                fill: "#EBEAED"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                                x: 15.2,
                                y: 41.4,
                                width: 18,
                                height: 3.2,
                                rx: 0.8,
                                fill: "#EBEAED"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                                x: 15.2,
                                y: 47.8,
                                width: 18,
                                height: 3.2,
                                rx: 0.8,
                                fill: "#BB7AFF"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                                x: 15.2,
                                y: 54.2,
                                width: 18,
                                height: 3.2,
                                rx: 0.8,
                                fill: "#EBEAED"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                                x: 15.2,
                                y: 60.6,
                                width: 18,
                                height: 3.2,
                                rx: 0.8,
                                fill: "#EBEAED"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                                x: 15.2,
                                y: 67,
                                width: 18,
                                height: 3.2,
                                rx: 0.8,
                                fill: "#EBEAED"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M42.4 21.6v111.25h.8V21.6h-.8Z",
                                fill: "#D6D4D9",
                                mask: "url(#ThemeLight_svg__path-11-inside-2_1227_39362)"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                                x: 49.2,
                                y: 28,
                                width: 23,
                                height: 6,
                                rx: 0.8,
                                fill: "#EBEAED"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                                x: 49.2,
                                y: 37.2,
                                width: 26.7,
                                height: 16,
                                rx: 1.6,
                                fill: "#BB7AFF"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                                x: 79.1,
                                y: 37.2,
                                width: 26.7,
                                height: 16,
                                rx: 1.6,
                                fill: "#EBEAED"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                                x: 109,
                                y: 37.2,
                                width: 26.7,
                                height: 16,
                                rx: 1.6,
                                fill: "#EBEAED"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                                x: 138.9,
                                y: 37.2,
                                width: 26.7,
                                height: 16,
                                rx: 1.6,
                                fill: "#EBEAED"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                                x: 49.2,
                                y: 62.8,
                                width: 25.6,
                                height: 4.8,
                                rx: 0.8,
                                fill: "#EBEAED"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("g", {
                                clipPath: "url(#ThemeLight_svg__d)",
                                children: [
                                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                        stroke: "#EBEAED",
                                        strokeWidth: 0.4,
                                        d: "M49.2 75.6h116.4M49.2 81.4h116.4M49.2 87.2h116.4M49.2 93h116.4M49.2 98.8h116.4M49.2 104.6h116.4M49.2 110.4h116.4M49.2 116.2h116.4"
                                    }),
                                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                        d: "m48.496 113.491-4.417-1.212v4.21H170.72v-12.503l-2.045 7.974-4.418 2.36-2.209-1.02-2.29-3.573h-2.209l-2.209 4.912-2.209-10.908-2.291 7.655-2.127-4.019-2.209 7.591-2.208-1.212-2.291.192-2.209 1.467-2.209-12.121-2.209 11.355-2.29-4.338-2.209.766-2.291 2.743-2.127-1.084-2.291 1.084-2.209-3.636-2.29.765-2.127 1.914-2.291-7.272-2.127 1.594-2.209 6.252-2.291-5.295-2.291 3.126-2.29 1.787-2.046-.638-2.372 2.296-2.127-5.614-2.209-2.169-2.373 5.295-2.208 1.212-2.046 1.85-2.29-4.784-2.373.765-2.045-.765-2.29-5.423-2.21 4.338-2.209 1.276-2.29-35.342-2.21 39.935-2.126-1.084-2.21-2.169-1.88 1.148-2.619 1.148-2.209-7.081-2.127 5.04-2.372 1.595h-2.127l-2.29-2.807-2.292 2.424Z",
                                        fill: "url(#ThemeLight_svg__e)"
                                    }),
                                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                        d: "m44.079 112.279 4.417 1.212 2.291-2.424 2.29 2.807h2.128l2.372-1.595 2.127-5.04 2.21 7.081 2.617-1.148 1.882-1.148 2.209 2.169 2.127 1.084 2.209-39.935 2.29 35.342 2.21-1.276 2.208-4.338 2.29 5.423 2.046.765 2.373-.765 2.29 4.784 2.046-1.85 2.209-1.212 2.372-5.295 2.209 2.169 2.127 5.614 2.373-2.296 2.045.638 2.29-1.787 2.291-3.126 2.291 5.295 2.209-6.252 2.127-1.594 2.291 7.272 2.127-1.914 2.29-.765 2.209 3.636 2.291-1.084 2.127 1.084 2.291-2.743 2.209-.766 2.29 4.338 2.209-11.355 2.209 12.121 2.209-1.467 2.291-.192 2.208 1.212 2.209-7.591 2.127 4.019 2.291-7.655 2.209 10.908 2.209-4.912h2.209l2.29 3.573 2.209 1.02 4.418-2.36 2.045-7.974",
                                        stroke: "#9027FF",
                                        strokeWidth: 0.4
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                        x: 12.2,
                        y: 12.2,
                        width: 159.6,
                        height: 120.45,
                        rx: 3,
                        stroke: "#D6D4D9",
                        strokeWidth: 0.4
                    })
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M.5 6A5.5 5.5 0 0 1 6 .5h172a5.5 5.5 0 0 1 5.5 5.5v108a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 114V6Z",
                stroke: "#D6D4D9"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("clipPath", {
                        id: "ThemeLight_svg__a",
                        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                            d: "M0 6a6 6 0 0 1 6-6h172a6 6 0 0 1 6 6v108a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6Z",
                            fill: "#fff"
                        })
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("clipPath", {
                        id: "ThemeLight_svg__b",
                        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                            x: 12,
                            y: 12,
                            width: 160,
                            height: 120.85,
                            rx: 3.2,
                            fill: "#fff"
                        })
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("clipPath", {
                        id: "ThemeLight_svg__d",
                        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                            x: 49.2,
                            y: 70.181,
                            width: 116.4,
                            height: 46.308,
                            rx: 3.226,
                            fill: "#fff"
                        })
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("linearGradient", {
                        id: "ThemeLight_svg__e",
                        x1: 107.4,
                        y1: 75.342,
                        x2: 107.4,
                        y2: 116.489,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                stopColor: "#A550FF"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#A550FF",
                                stopOpacity: 0.05
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $b911fc6ed0e74800$export$2e2bcd8739ae039 = $b911fc6ed0e74800$var$SvgThemeLight;



parcelRequire("2gcPZ");
const $30e88034a6917a95$var$SvgThemeDark = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("svg", {
        width: 184,
        height: 120,
        viewBox: "0 0 184 120",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("g", {
                clipPath: "url(#ThemeDark_svg__a)",
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                        d: "M0 6a6 6 0 0 1 6-6h172a6 6 0 0 1 6 6v108a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6Z",
                        fill: "#000"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("g", {
                        clipPath: "url(#ThemeDark_svg__b)",
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("mask", {
                                id: "ThemeDark_svg__c",
                                fill: "#fff",
                                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                    d: "M12 12h160v9.6H12V12Z"
                                })
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M12 12h160v9.6H12V12Z",
                                fill: "#3A383C"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("circle", {
                                cx: 16.8,
                                cy: 16.8,
                                fill: "#BB7AFF",
                                r: 1.6
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("circle", {
                                cx: 21.6,
                                cy: 16.8,
                                fill: "#FA52F1",
                                r: 1.6
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("circle", {
                                cx: 26.399,
                                cy: 16.8,
                                fill: "#FA9F34",
                                r: 1.6
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                                x: 152.8,
                                y: 14.4,
                                width: 16,
                                height: 4.8,
                                rx: 0.8,
                                fill: "#6C696F"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M172 21.2H12v.8h160v-.8Z",
                                fill: "#6C696F",
                                mask: "url(#ThemeDark_svg__c)"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                fill: "#3A383C",
                                d: "M12 21.6h160v111.25H12z"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                                x: 15.2,
                                y: 28.6,
                                width: 18,
                                height: 3.2,
                                rx: 0.8,
                                fill: "#6C696F"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                                x: 15.2,
                                y: 35,
                                width: 18,
                                height: 3.2,
                                rx: 0.8,
                                fill: "#6C696F"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                                x: 15.2,
                                y: 41.4,
                                width: 18,
                                height: 3.2,
                                rx: 0.8,
                                fill: "#6C696F"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                                x: 15.2,
                                y: 47.8,
                                width: 18,
                                height: 3.2,
                                rx: 0.8,
                                fill: "#BB7AFF"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                                x: 15.2,
                                y: 54.2,
                                width: 18,
                                height: 3.2,
                                rx: 0.8,
                                fill: "#6C696F"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                                x: 15.2,
                                y: 60.6,
                                width: 18,
                                height: 3.2,
                                rx: 0.8,
                                fill: "#6C696F"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                                x: 15.2,
                                y: 67,
                                width: 18,
                                height: 3.2,
                                rx: 0.8,
                                fill: "#6C696F"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                d: "M42.4 21.6v111.25h.8V21.6h-.8Z",
                                fill: "#6C696F",
                                mask: "url(#ThemeDark_svg__path-11-inside-2_1227_39419)"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                                x: 49.2,
                                y: 28,
                                width: 23,
                                height: 6,
                                rx: 0.8,
                                fill: "#6C696F"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                                x: 49.2,
                                y: 37.2,
                                width: 26.7,
                                height: 16,
                                rx: 1.6,
                                fill: "#BB7AFF"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                                x: 79.1,
                                y: 37.2,
                                width: 26.7,
                                height: 16,
                                rx: 1.6,
                                fill: "#6C696F"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                                x: 109,
                                y: 37.2,
                                width: 26.7,
                                height: 16,
                                rx: 1.6,
                                fill: "#6C696F"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                                x: 138.9,
                                y: 37.2,
                                width: 26.7,
                                height: 16,
                                rx: 1.6,
                                fill: "#6C696F"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                                x: 49.2,
                                y: 62.8,
                                width: 25.6,
                                height: 4.8,
                                rx: 0.8,
                                fill: "#6C696F"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("g", {
                                clipPath: "url(#ThemeDark_svg__d)",
                                children: [
                                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                        stroke: "#3A383C",
                                        strokeWidth: 0.4,
                                        d: "M49.2 75.6h116.4M49.2 81.4h116.4M49.2 87.2h116.4M49.2 93h116.4M49.2 98.8h116.4M49.2 104.6h116.4M49.2 110.4h116.4M49.2 116.2h116.4"
                                    }),
                                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                        d: "m48.496 113.491-4.417-1.212v4.21H170.72v-12.503l-2.045 7.974-4.418 2.36-2.209-1.02-2.29-3.573h-2.209l-2.209 4.912-2.209-10.908-2.291 7.655-2.127-4.019-2.209 7.591-2.208-1.212-2.291.192-2.209 1.467-2.209-12.121-2.209 11.355-2.29-4.338-2.209.766-2.291 2.743-2.127-1.084-2.291 1.084-2.209-3.636-2.29.765-2.127 1.914-2.291-7.272-2.127 1.594-2.209 6.252-2.291-5.295-2.291 3.126-2.29 1.787-2.046-.638-2.372 2.296-2.127-5.614-2.209-2.169-2.373 5.295-2.208 1.212-2.046 1.85-2.29-4.784-2.373.765-2.045-.765-2.29-5.423-2.21 4.338-2.209 1.276-2.29-35.342-2.21 39.935-2.126-1.084-2.21-2.169-1.88 1.148-2.619 1.148-2.209-7.081-2.127 5.04-2.372 1.595h-2.127l-2.29-2.807-2.292 2.424Z",
                                        fill: "url(#ThemeDark_svg__e)"
                                    }),
                                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                                        d: "m44.079 112.279 4.417 1.212 2.291-2.424 2.29 2.807h2.128l2.372-1.595 2.127-5.04 2.21 7.081 2.617-1.148 1.882-1.148 2.209 2.169 2.127 1.084 2.209-39.935 2.29 35.342 2.21-1.276 2.208-4.338 2.29 5.423 2.046.765 2.373-.765 2.29 4.784 2.046-1.85 2.209-1.212 2.372-5.295 2.209 2.169 2.127 5.614 2.373-2.296 2.045.638 2.29-1.787 2.291-3.126 2.291 5.295 2.209-6.252 2.127-1.594 2.291 7.272 2.127-1.914 2.29-.765 2.209 3.636 2.291-1.084 2.127 1.084 2.291-2.743 2.209-.766 2.29 4.338 2.209-11.355 2.209 12.121 2.209-1.467 2.291-.192 2.208 1.212 2.209-7.591 2.127 4.019 2.291-7.655 2.209 10.908 2.209-4.912h2.209l2.29 3.573 2.209 1.02 4.418-2.36 2.045-7.974",
                                        stroke: "#BB7AFF",
                                        strokeWidth: 0.4
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                        x: 12.2,
                        y: 12.2,
                        width: 159.6,
                        height: 120.45,
                        rx: 3,
                        stroke: "#6C696F",
                        strokeWidth: 0.4
                    })
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                d: "M.5 6A5.5 5.5 0 0 1 6 .5h172a5.5 5.5 0 0 1 5.5 5.5v108a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 114V6Z",
                stroke: "#6C696F"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("clipPath", {
                        id: "ThemeDark_svg__a",
                        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
                            d: "M0 6a6 6 0 0 1 6-6h172a6 6 0 0 1 6 6v108a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6Z",
                            fill: "#fff"
                        })
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("clipPath", {
                        id: "ThemeDark_svg__b",
                        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                            x: 12,
                            y: 12,
                            width: 160,
                            height: 120.85,
                            rx: 3.2,
                            fill: "#fff"
                        })
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("clipPath", {
                        id: "ThemeDark_svg__d",
                        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("rect", {
                            x: 49.2,
                            y: 70.181,
                            width: 116.4,
                            height: 46.308,
                            rx: 3.226,
                            fill: "#fff"
                        })
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("linearGradient", {
                        id: "ThemeDark_svg__e",
                        x1: 107.4,
                        y1: 75.342,
                        x2: 107.4,
                        y2: 116.489,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                stopColor: "#A550FF"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("stop", {
                                offset: 1,
                                stopColor: "#A550FF",
                                stopOpacity: 0.05
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $30e88034a6917a95$export$2e2bcd8739ae039 = $30e88034a6917a95$var$SvgThemeDark;






function $44f845dbed47150f$export$9d63163ee2173b37() {
    const { currentTheme: currentTheme, isSystemPreference: isSystemPreference, setThemePreference: setThemePreference, setToSystemTheme: setToSystemTheme } = (0, $bbc2cb4268a46f72$export$bace31607121468e)();
    const onRadioChange = (event)=>{
        const themePreference = event.target.value;
        const validTheme = (0, $c5bcce893caf17be$export$888c18c43ead4265)(themePreference);
        if (validTheme) {
            setThemePreference(themePreference);
            return;
        }
        setToSystemTheme();
    };
    const isLightActive = !isSystemPreference && currentTheme === "light";
    const isDarkActive = !isSystemPreference && currentTheme === "dark";
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $b0893cc2f3fde9b8$export$2631a3ab3cdd158d), {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($44f845dbed47150f$var$ThemeCard, {
                $isActive: isSystemPreference,
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($44f845dbed47150f$var$ThemeImageContainer, {
                        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($44f845dbed47150f$var$SystemThemeVisual, {
                            onClick: setToSystemTheme,
                            children: [
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($44f845dbed47150f$var$HalfIcon, {
                                    children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($44f845dbed47150f$var$ThemeLightSvg, {})
                                }),
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($44f845dbed47150f$var$ThemeDarkSvg, {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($44f845dbed47150f$var$ThemeCardTitle, {
                        as: "label",
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a921dfdbd8dd60fa$export$f5b8910cec6cf069), {
                                type: "radio",
                                value: "system",
                                checked: isSystemPreference,
                                onChange: onRadioChange,
                                id: "system",
                                name: "theme"
                            }),
                            "System setting"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($44f845dbed47150f$var$ThemeCard, {
                $isActive: isLightActive,
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($44f845dbed47150f$var$ThemeImageContainer, {
                        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($44f845dbed47150f$var$ThemeLightSvg, {
                            onClick: ()=>setThemePreference("light")
                        })
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($44f845dbed47150f$var$ThemeCardTitle, {
                        as: "label",
                        htmlFor: "light",
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a921dfdbd8dd60fa$export$f5b8910cec6cf069), {
                                type: "radio",
                                id: "light",
                                value: "light",
                                name: "theme",
                                onChange: onRadioChange,
                                checked: isLightActive
                            }),
                            "Light"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($44f845dbed47150f$var$ThemeCard, {
                $isActive: isDarkActive,
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($44f845dbed47150f$var$ThemeImageContainer, {
                        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($44f845dbed47150f$var$ThemeDarkSvg, {
                            onClick: ()=>setThemePreference("dark")
                        })
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($44f845dbed47150f$var$ThemeCardTitle, {
                        as: "label",
                        htmlFor: "dark",
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a921dfdbd8dd60fa$export$f5b8910cec6cf069), {
                                type: "radio",
                                id: "dark",
                                value: "dark",
                                name: "theme",
                                onChange: onRadioChange,
                                checked: isDarkActive
                            }),
                            "Dark"
                        ]
                    })
                ]
            })
        ]
    });
}
const $44f845dbed47150f$var$ThemeImageContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  transition: 0.2s transform ease-in-out;
`;
const $44f845dbed47150f$var$SystemThemeVisual = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  position: relative;
  margin-bottom: -8px; /* offset invisible overflow from SVG */
`;
// Wrap the SVGs in styled component so we can use selectors to style them
const $44f845dbed47150f$var$ThemeLightSvg = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $b911fc6ed0e74800$export$2e2bcd8739ae039))``;
const $44f845dbed47150f$var$ThemeDarkSvg = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $30e88034a6917a95$export$2e2bcd8739ae039))``;
const $44f845dbed47150f$var$ThemeCard = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ $isActive: $isActive, theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    display: grid;
    row-gap: 8px;
    cursor: pointer;

    ${$isActive && (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      ${$44f845dbed47150f$var$ThemeLightSvg}, ${$44f845dbed47150f$var$ThemeDarkSvg} {
        border-radius: ${theme.radius.default};
        outline: 2px solid ${theme.color.border.primary};
      }
    `}

    &:hover ${$44f845dbed47150f$var$ThemeImageContainer} {
      transform: scale(1.02);
    }
  `);
const $44f845dbed47150f$var$ThemeCardTitle = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $9e604dd7bbd62f05$export$9e22197817ed9e0d))`
  grid-area: unset;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;
const $44f845dbed47150f$var$HalfIcon = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  position: absolute;
  clip-path: polygon(0 0, 85% 0, 0 110%);
`;





var $2gcPZ = parcelRequire("2gcPZ");

function $382ee1306c4b2027$export$2d8d895a0a0f636e({ to: to, options: options }) {
    const redirect = (0, $efeb47d767416279$export$9770f232ac06a008)();
    (0, $2gcPZ.useEffect)(()=>{
        redirect(to, options);
    }, [
        options,
        redirect,
        to
    ]);
    return null;
}


function $ee74eeda9851fa66$export$9b3dfc284969e257({ url: url, title: title, description: description }) {
    const settingsContent = (0, $2gcPZ.useMemo)(()=>{
        switch(url){
            case "prometheus-urls":
                return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $887356c12179bd9c$export$a0740a2a20745763), {});
            case "notifications":
                return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $19fc4b06e3edd1c2$export$f7546b33f512fa1f), {});
            case "theme":
                return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $44f845dbed47150f$export$9d63163ee2173b37), {});
            case "experimental":
                return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $10b2926302cc13b9$export$84555a67d3b65469), {});
            case "source-code-links":
                return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $2c0f3c0766bd233f$export$d7344b2b6d802efd), {});
        }
    }, [
        url
    ]);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($ee74eeda9851fa66$var$SettingsBlock, {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $9e604dd7bbd62f05$export$94c28a8f63a8b536), {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("h2", {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $9e604dd7bbd62f05$export$a464fbac34c32d2f), {
                        children: description
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $1490f8cf9996283f$export$4a18869449458453), {})
                ]
            }),
            settingsContent
        ]
    });
}
function $ee74eeda9851fa66$export$b6836eb34b47a004({ description: description, feature: feature, title: title, url: url }) {
    const [hasFeature] = (0, $edc4621501740b0b$export$fc97652867e5867e)(feature);
    const params = (0, $efeb47d767416279$export$99eaa27ddbbb95ef)();
    if (hasFeature) return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($ee74eeda9851fa66$export$9b3dfc284969e257, {
        url: url,
        title: title,
        description: description
    });
    // In case the user navigates to a beta tab directly even though the feature
    // is disabled, redirect them to the root settings page.
    if (params["*"] === url) return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $382ee1306c4b2027$export$2d8d895a0a0f636e), {
        to: "settings",
        options: {
            replace: true
        }
    });
    return null;
}
const $ee74eeda9851fa66$var$SettingsBlock = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: grid;
  gap: 32px 0;
  align-content: start;
`;







function $75f6eaa78b0a79c6$export$c3dbc660e4a4b578({ iconType: iconType, title: title, url: url, showBetaTag: showBetaTag }) {
    const [currentSearchParams] = (0, $e7b98158099ae00d$export$f1a78c17382fe22a)();
    const search = currentSearchParams.toString();
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $b9eaf400d2e3afef$export$3e676578822187d7), {
        to: {
            pathname: url,
            search: search
        },
        end: true,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($75f6eaa78b0a79c6$var$StyledNavLinkContent, {
            children: [
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0a830394bc38e4e3$export$f04a61298a47a40f), {
                    type: iconType
                }),
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($75f6eaa78b0a79c6$var$TitleSpan, {
                    children: [
                        title,
                        showBetaTag && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($75f6eaa78b0a79c6$var$BetaTag, {
                            children: "BETA"
                        })
                    ]
                })
            ]
        })
    });
}
function $75f6eaa78b0a79c6$export$2936155b4e7b74c5(props) {
    const [hasFeature] = (0, $edc4621501740b0b$export$fc97652867e5867e)(props.feature);
    if (hasFeature) return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($75f6eaa78b0a79c6$export$c3dbc660e4a4b578, {
        ...props,
        showBetaTag: true
    });
    return null;
}
const $75f6eaa78b0a79c6$var$StyledNavLinkContent = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $b9eaf400d2e3afef$export$f5c8616e2cb01d3f))`
  grid-template-columns: 20px max-content;
`;
const $75f6eaa78b0a79c6$var$TitleSpan = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).span`
  display: inline-block;
  position: relative;
`;
const $75f6eaa78b0a79c6$var$BetaTag = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).span(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    display: block;
    padding: 4px 8px;
    border-radius: ${theme.radius.full};
    font: ${theme.font.buttons.sm};
    line-height: 1;
    color: ${theme.color.fg.primary};
    background-color: ${theme.color.bg.emphasis["primary-subtle"]};
    position: absolute;
    top: -2px;
    right: -52px;
  `);



const $b265bd128a18ba04$var$SETTINGS = [
    {
        title: "Prometheus URLs",
        iconType: "environments_duotone",
        url: "prometheus-urls",
        description: "Add Prometheus URLs to see real time metrics for your Autometrics functions."
    },
    {
        title: "Notifications",
        iconType: "alarm_duotone",
        url: "notifications",
        description: "Get a notification when there is a new alert"
    },
    {
        title: "Theme",
        iconType: "moon_duotone",
        url: "theme",
        description: "Switch theme of your Autometrics explorer"
    },
    {
        title: "Preview",
        iconType: "bolt_duotone",
        url: "experimental",
        description: "Be the first to try out new features."
    },
    {
        title: "Source code links",
        iconType: "code_duotone",
        url: "source-code-links",
        description: "Enable source code information or links to your source code",
        feature: "source-code-links"
    }
];
function $b265bd128a18ba04$export$c72f6eaae7b9adff() {
    const firstElementUrl = $b265bd128a18ba04$var$SETTINGS[0]?.url ?? "/";
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $747d2f1afecb66a5$export$5f86df0ee0a255b5), {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("h1", {
                children: "Settings"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($b265bd128a18ba04$var$SettingsContentDesktop, {
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($b265bd128a18ba04$var$SettingsContent, {
                    children: [
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($b265bd128a18ba04$var$SettingsSideMenu, {
                            children: $b265bd128a18ba04$var$SETTINGS.map(({ title: title, iconType: iconType, url: url, feature: feature })=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($b265bd128a18ba04$var$SettingsMenuListItem, {
                                    children: feature ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $75f6eaa78b0a79c6$export$2936155b4e7b74c5), {
                                        title: title,
                                        url: url,
                                        feature: feature,
                                        iconType: iconType
                                    }) : /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $75f6eaa78b0a79c6$export$c3dbc660e4a4b578), {
                                        title: title,
                                        url: url,
                                        iconType: iconType,
                                        showBetaTag: url === "experimental"
                                    })
                                }, title))
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $efeb47d767416279$export$3565eb3d00ca5a74), {
                            children: [
                                $b265bd128a18ba04$var$SETTINGS.map(({ url: url, title: title, description: description, feature: feature })=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $efeb47d767416279$export$e7b0ac011bb776c6), {
                                        path: url,
                                        element: feature ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $ee74eeda9851fa66$export$b6836eb34b47a004), {
                                            url: url,
                                            title: title,
                                            description: description,
                                            feature: feature
                                        }) : /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $ee74eeda9851fa66$export$9b3dfc284969e257), {
                                            url: url,
                                            title: title,
                                            description: description
                                        })
                                    }, url)),
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $efeb47d767416279$export$e7b0ac011bb776c6), {
                                    path: "*",
                                    element: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $382ee1306c4b2027$export$2d8d895a0a0f636e), {
                                        to: firstElementUrl
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($b265bd128a18ba04$var$SettingsContentMobile, {
                children: $b265bd128a18ba04$var$SETTINGS.map(({ url: url, title: title, description: description, feature: feature })=>{
                    if (feature) return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $ee74eeda9851fa66$export$b6836eb34b47a004), {
                        url: url,
                        title: title,
                        description: description,
                        feature: feature
                    }, url);
                    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $ee74eeda9851fa66$export$9b3dfc284969e257), {
                        url: url,
                        title: title,
                        description: description
                    }, url);
                })
            })
        ]
    });
}
const $b265bd128a18ba04$var$SettingsContentDesktop = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: { media: media } })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    display: none;

    ${media.md`
      display: block;
    `}
  `);
const $b265bd128a18ba04$var$SettingsContentMobile = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: { media: media } })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    display: grid;
    gap: 64px;

    ${media.md`
      display: none;
    `}
  `);
const $b265bd128a18ba04$var$SettingsContent = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: { media: media } })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    display: grid;

    ${media.md`
      grid-template-columns:
        minmax(max-content, 170px) minmax(min-content, 640px);
      gap: 0 115px;
    `}
  `);
const $b265bd128a18ba04$var$SettingsSideMenu = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).ul`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0;
  margin: 0;
`;
const $b265bd128a18ba04$var$SettingsMenuListItem = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).li`
  list-style: none;
`;












function $e3aa85e7acb33985$export$86e5dd73a6f654fb({ brandColor: brandColor, description: description, title: title, iconType: iconType, url: url = "#" }) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($e3aa85e7acb33985$var$StyledLink, {
        to: url,
        target: "_blank",
        rel: "noopener",
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($e3aa85e7acb33985$var$DocumentationCardContainer, {
            $brandColor: brandColor,
            children: [
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($e3aa85e7acb33985$var$CardIcon, {
                    type: iconType,
                    width: "20",
                    height: "20"
                }),
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($e3aa85e7acb33985$var$CardTitle, {
                    children: title
                }),
                description && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($e3aa85e7acb33985$var$CardDescription, {
                    children: description
                })
            ]
        })
    });
}
function $e3aa85e7acb33985$export$ae3ea6b85618c07d({ description: description, image: image, meta: meta, title: title, url: url = "#" }) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($e3aa85e7acb33985$var$StyledLink, {
        to: url,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($e3aa85e7acb33985$var$TutorialCardContainer, {
            children: [
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($e3aa85e7acb33985$var$TutorialCardImageContainer, {
                    children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($e3aa85e7acb33985$var$VisualCardImage, {
                        src: image
                    })
                }),
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($e3aa85e7acb33985$var$BlogCardContent, {
                    children: [
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($e3aa85e7acb33985$var$CardTitle, {
                            children: title
                        }),
                        description && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($e3aa85e7acb33985$var$CardDescription, {
                            children: description
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($e3aa85e7acb33985$var$BlogCardMetaContainer, {
                            children: [
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($e3aa85e7acb33985$var$AutorImageContainer, {
                                    children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($e3aa85e7acb33985$var$VisualCardImage, {
                                        src: meta.authorImage
                                    })
                                }),
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($e3aa85e7acb33985$var$MetaText, {
                                    children: [
                                        meta.author,
                                        " \u2022 ",
                                        meta.date
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
function $e3aa85e7acb33985$export$5313280cb700b1f3({ icon: LanguageIcon, image: image, title: title, description: description, ctas: ctas }) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($e3aa85e7acb33985$var$TutorialCardContainer, {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($e3aa85e7acb33985$var$VisualCardImageWrapper, {
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($e3aa85e7acb33985$var$TutorialCardImageContainer, {
                    children: [
                        LanguageIcon && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($e3aa85e7acb33985$var$VisualCardIconContainer, {
                            children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)(LanguageIcon, {
                                height: 32,
                                width: 32
                            })
                        }),
                        image && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($e3aa85e7acb33985$var$VisualCardImage, {
                            src: image
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($e3aa85e7acb33985$var$TutorialCardContent, {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($e3aa85e7acb33985$var$CardTitle, {
                        children: title
                    }),
                    description && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($e3aa85e7acb33985$var$CardDescription, {
                        children: description
                    }),
                    ctas && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($e3aa85e7acb33985$var$CTAsContainer, {
                        children: ctas.map((cta)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($e3aa85e7acb33985$var$StyledLink, {
                                to: cta.url,
                                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($e3aa85e7acb33985$var$CardCTA, {
                                    children: [
                                        cta.title,
                                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0a830394bc38e4e3$export$f04a61298a47a40f), {
                                            type: "arrow_right",
                                            height: "1.1em",
                                            width: "1.1em"
                                        })
                                    ]
                                })
                            }, cta.url))
                    })
                ]
            })
        ]
    });
}
function $e3aa85e7acb33985$export$a42f5eaaf607cc9c({ image: image, title: title, description: description, url: url }) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($e3aa85e7acb33985$var$StyledLink, {
        to: url,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($e3aa85e7acb33985$var$VisualCardContainer, {
            children: [
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($e3aa85e7acb33985$var$VisualCardImageWrapper, {
                    children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($e3aa85e7acb33985$var$VisualCardImageContainer, {
                        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($e3aa85e7acb33985$var$VisualCardImage, {
                            src: image
                        })
                    })
                }),
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($e3aa85e7acb33985$var$VisualCardContent, {
                    children: [
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($e3aa85e7acb33985$var$CardTitle, {
                            children: title
                        }),
                        description && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($e3aa85e7acb33985$var$CardDescription, {
                            children: description
                        })
                    ]
                })
            ]
        })
    });
}
const $e3aa85e7acb33985$var$BaseContentCard = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ $brandColor: $brandColor, theme: theme })=>{
    return (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      --brand-color: ${$brandColor || theme.color.fg.primary};
      --border-radius: 8px;

      display: grid;
      gap: 8px;
      border-radius: var(--border-radius);
      padding: 20px; /* use CSS var */
      background-color: ${theme.color.bg.subtle};
      box-shadow: 0px 1px 2px rgb(0 0 0 / 5%);
      height: 100%;
    `;
});
const $e3aa85e7acb33985$var$DocumentationCardContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)($e3aa85e7acb33985$var$BaseContentCard)`
  grid: "icon title" auto "icon description" 1fr / 20px 1fr;
  gap: 8px 20px;
  transition: scale 0.2s ease-in-out;

  &:hover {
    cursor: pointer;
    scale: 1.03;
  }
`;
const $e3aa85e7acb33985$var$VisualCardImageWrapper = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  grid-area: image;
  overflow: hidden;
`;
const $e3aa85e7acb33985$var$TutorialCardImageContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      display: grid;
      place-items: center;
      height: 100%;
      width: 100%;
      aspect-ratio: 16 / 9;
      background: linear-gradient(
        225deg,
        ${theme.color.fg.primary} 0%,
        ${theme.color.fg.accent[1]} 35.35%,
        ${theme.color.fg.accent[2]} 85.92%,
        ${theme.color.fg.accent[3]} 100%
      );
      box-shadow: inset 0 0 2rem ${theme.color.neutral.alpha.light[200]};
      position: relative;
      transition: scale 0.2s ease-in-out;
    `);
const $e3aa85e7acb33985$var$VisualCardImageContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)($e3aa85e7acb33985$var$TutorialCardImageContainer)`
  aspect-ratio: 9 / 4;
`;
const $e3aa85e7acb33985$var$TutorialCardContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)($e3aa85e7acb33985$var$BaseContentCard)`
  display: grid;
  grid: "image" auto "content" 1fr / 1fr;
  padding: 0;
  overflow: hidden;
  gap: 0;
`;
const $e3aa85e7acb33985$var$VisualCardContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)($e3aa85e7acb33985$var$TutorialCardContainer)`
  &:hover ${$e3aa85e7acb33985$var$TutorialCardImageContainer} {
    scale: 1.03;
  }
`;
const $e3aa85e7acb33985$var$VisualCardImage = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $a1b298a24b81851b$export$3f07479ca1e8eba5))`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  position: absolute;
  inset: 0;
`;
const $e3aa85e7acb33985$var$VisualCardIconContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      background: grey;
      border-radius: 10px;
      padding: 16px;
      background: linear-gradient(
        45deg,
        rgba(255, 255, 255, 0.95) 0%,
        rgba(255, 255, 255, 0.6) 100%
      );
      box-shadow: 0px 4px 24px 0px ${theme.color.fg.primary};
      height: 65px;
      color: ${theme.color.neutral[900]};
    `);
const $e3aa85e7acb33985$var$BlogCardContent = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)($e3aa85e7acb33985$var$BaseContentCard)`
  grid-area: content;
  grid: "title" auto "description" 1fr "meta" auto / 1fr;
  border: none;
  border-radius: 0 0 var(--border-radius) var(--border-radius);
`;
const $e3aa85e7acb33985$var$TutorialCardContent = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)($e3aa85e7acb33985$var$BlogCardContent)`
  grid: "title" auto "description" 1fr "ctas" auto / 1fr;
`;
const $e3aa85e7acb33985$var$VisualCardContent = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)($e3aa85e7acb33985$var$BlogCardContent)`
  grid: "title" auto "description" 1fr / 1fr;
`;
const $e3aa85e7acb33985$var$BlogCardMetaContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  grid-area: meta;
  display: grid;
  grid-template-columns: 20px 1fr;
  gap: 12px;
  margin-top: 32px;
`;
const $e3aa85e7acb33985$var$AutorImageContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)($e3aa85e7acb33985$var$TutorialCardImageContainer)`
  aspect-ratio: 1;
  border-radius: 50%;
  grid-area: unset;
  height: unset;
  overflow: hidden;
`;
const $e3aa85e7acb33985$var$MetaText = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).p(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      font: ${theme.font.body.sm.medium};
      margin: 0;
    `);
const $e3aa85e7acb33985$var$CardTitle = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).h3(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      grid-area: title;
      font: ${theme.font.body.l.medium};
    `);
const $e3aa85e7acb33985$var$CardDescription = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).p(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      grid-area: description;
      font: ${theme.font.body.md.regular};
      color: ${theme.color.fg.muted};
    `);
const $e3aa85e7acb33985$var$CardCTA = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).span(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      grid-area: cta;
      display: inline-flex;
      align-items: center;
      gap: 10px;
      font: ${theme.font.buttons.md};
      color: ${theme.color.fg.primary};
      margin: 10px 0 0;
      margin: 0; /* HACK - Only here while we have the description commented out */

      &:hover {
        text-decoration: underline;
      }
    `);
const $e3aa85e7acb33985$var$CTAsContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  grid-area: ctas;
  margin-top: 4px;
  display: grid;

  ${$e3aa85e7acb33985$var$CardCTA} {
    grid-area: unset;
    cursor: pointer;
  }
`;
const $e3aa85e7acb33985$var$CardIcon = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $0a830394bc38e4e3$export$f04a61298a47a40f))`
  grid-area: icon;
  color: var(--brand-color);
`;
const $e3aa85e7acb33985$var$StyledLink = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $e7b98158099ae00d$export$a6c7ac8248d6e38a))`
  color: unset;
  text-decoration: unset;
`;



parcelRequire("2gcPZ");
const $b1a7cbe37fe57f73$var$SvgRust = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        stroke: "currentColor",
        fill: "currentColor",
        strokeWidth: 0,
        viewBox: "0 0 512 512",
        height: "1em",
        width: "1em",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "m508.52 249.75-21.82-13.51c-.17-2-.34-3.93-.55-5.88l18.72-17.5a7.35 7.35 0 0 0-2.44-12.25l-24-9c-.54-1.88-1.08-3.78-1.67-5.64l15-20.83a7.35 7.35 0 0 0-4.79-11.54l-25.42-4.15c-.9-1.73-1.79-3.45-2.73-5.15l10.68-23.42a7.35 7.35 0 0 0-6.95-10.39l-25.82.91q-1.79-2.22-3.61-4.4L439 81.84a7.36 7.36 0 0 0-8.84-8.84L405 78.93q-2.17-1.83-4.4-3.61l.91-25.82a7.35 7.35 0 0 0-10.39-7L367.7 53.23c-1.7-.94-3.43-1.84-5.15-2.73l-4.15-25.42a7.35 7.35 0 0 0-11.54-4.79L326 35.26c-1.86-.59-3.75-1.13-5.64-1.67l-9-24a7.35 7.35 0 0 0-12.25-2.44l-17.5 18.72c-1.95-.21-3.91-.38-5.88-.55L262.25 3.48a7.35 7.35 0 0 0-12.5 0L236.24 25.3c-2 .17-3.93.34-5.88.55l-17.5-18.72a7.35 7.35 0 0 0-12.25 2.44l-9 24c-1.89.55-3.79 1.08-5.66 1.68l-20.82-15a7.35 7.35 0 0 0-11.54 4.79l-4.15 25.41c-1.73.9-3.45 1.79-5.16 2.73l-23.4-10.63a7.35 7.35 0 0 0-10.39 7l.92 25.81c-1.49 1.19-3 2.39-4.42 3.61L81.84 73A7.36 7.36 0 0 0 73 81.84L78.93 107c-1.23 1.45-2.43 2.93-3.62 4.41l-25.81-.91a7.42 7.42 0 0 0-6.37 3.26 7.35 7.35 0 0 0-.57 7.13l10.66 23.41c-.94 1.7-1.83 3.43-2.73 5.16l-25.41 4.14a7.35 7.35 0 0 0-4.79 11.54l15 20.82c-.59 1.87-1.13 3.77-1.68 5.66l-24 9a7.35 7.35 0 0 0-2.44 12.25l18.72 17.5c-.21 1.95-.38 3.91-.55 5.88l-21.86 13.5a7.35 7.35 0 0 0 0 12.5l21.82 13.51c.17 2 .34 3.92.55 5.87l-18.72 17.5a7.35 7.35 0 0 0 2.44 12.25l24 9c.55 1.89 1.08 3.78 1.68 5.65l-15 20.83a7.35 7.35 0 0 0 4.79 11.54l25.42 4.15c.9 1.72 1.79 3.45 2.73 5.14l-10.63 23.43a7.35 7.35 0 0 0 .57 7.13 7.13 7.13 0 0 0 6.37 3.26l25.83-.91q1.77 2.22 3.6 4.4L73 430.16a7.36 7.36 0 0 0 8.84 8.84l25.16-5.93q2.18 1.83 4.41 3.61l-.92 25.82a7.35 7.35 0 0 0 10.39 6.95l23.43-10.68c1.69.94 3.42 1.83 5.14 2.73l4.15 25.42a7.34 7.34 0 0 0 11.54 4.78l20.83-15c1.86.6 3.76 1.13 5.65 1.68l9 24a7.36 7.36 0 0 0 12.25 2.44l17.5-18.72c1.95.21 3.92.38 5.88.55l13.51 21.82a7.35 7.35 0 0 0 12.5 0l13.51-21.82c2-.17 3.93-.34 5.88-.56l17.5 18.73a7.36 7.36 0 0 0 12.25-2.44l9-24c1.89-.55 3.78-1.08 5.65-1.68l20.82 15a7.34 7.34 0 0 0 11.54-4.78l4.15-25.42c1.72-.9 3.45-1.79 5.15-2.73l23.42 10.68a7.35 7.35 0 0 0 10.39-6.95l-.91-25.82q2.22-1.79 4.4-3.61l25.15 5.93a7.36 7.36 0 0 0 8.84-8.84L433.07 405q1.83-2.17 3.61-4.4l25.82.91a7.23 7.23 0 0 0 6.37-3.26 7.35 7.35 0 0 0 .58-7.13l-10.68-23.42c.94-1.7 1.83-3.43 2.73-5.15l25.42-4.15a7.35 7.35 0 0 0 4.79-11.54l-15-20.83c.59-1.87 1.13-3.76 1.67-5.65l24-9a7.35 7.35 0 0 0 2.44-12.25l-18.72-17.5c.21-1.95.38-3.91.55-5.87l21.82-13.51a7.35 7.35 0 0 0 0-12.5Zm-151 129.08A13.91 13.91 0 0 0 341 389.51l-7.64 35.67a187.51 187.51 0 0 1-156.36-.74l-7.64-35.66a13.87 13.87 0 0 0-16.46-10.68l-31.51 6.76a187.38 187.38 0 0 1-16.26-19.21H258.3c1.72 0 2.89-.29 2.89-1.91v-54.19c0-1.57-1.17-1.91-2.89-1.91h-44.83l.05-34.35H262c4.41 0 23.66 1.28 29.79 25.87 1.91 7.55 6.17 32.14 9.06 40 2.89 8.82 14.6 26.46 27.1 26.46H407a187.3 187.3 0 0 1-17.34 20.09Zm25.77 34.49A15.24 15.24 0 1 1 368 398.08h.44a15.23 15.23 0 0 1 14.8 15.24Zm-225.62-.68a15.24 15.24 0 1 1-15.25-15.25h.45a15.25 15.25 0 0 1 14.75 15.25Zm-88.1-178.49 32.83-14.6a13.88 13.88 0 0 0 7.06-18.33L102.69 186h26.56v119.73h-53.6a187.65 187.65 0 0 1-6.08-71.58Zm-11.26-36.06a15.24 15.24 0 0 1 15.23-15.25H74a15.24 15.24 0 1 1-15.67 15.24Zm155.16 24.49.05-35.32h63.26c3.28 0 23.07 3.77 23.07 18.62 0 12.29-15.19 16.7-27.68 16.7ZM399 306.71c-9.8 1.13-20.63-4.12-22-10.09-5.78-32.49-15.39-39.4-30.57-51.4 18.86-11.95 38.46-29.64 38.46-53.26 0-25.52-17.49-41.59-29.4-49.48-16.76-11-35.28-13.23-40.27-13.23h-198.9a187.49 187.49 0 0 1 104.89-59.19l23.47 24.6a13.82 13.82 0 0 0 19.6.44l26.26-25a187.51 187.51 0 0 1 128.37 91.43l-18 40.57a14 14 0 0 0 7.09 18.33l34.59 15.33a187.12 187.12 0 0 1 .4 32.54h-19.28c-1.91 0-2.69 1.27-2.69 3.13v8.82C421 301 409.31 305.58 399 306.71ZM240 60.21A15.24 15.24 0 0 1 255.21 45h.45A15.24 15.24 0 1 1 240 60.21ZM436.84 214a15.24 15.24 0 1 1 0-30.48h.44a15.24 15.24 0 0 1-.44 30.48Z",
            stroke: "none"
        })
    });
var $b1a7cbe37fe57f73$export$2e2bcd8739ae039 = $b1a7cbe37fe57f73$var$SvgRust;



parcelRequire("2gcPZ");
const $8dd2bb62639d6e8f$var$SvgTypeScript = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        stroke: "currentColor",
        fill: "currentColor",
        strokeWidth: 0,
        viewBox: "0 0 24 24",
        height: "1em",
        width: "1em",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M1.125 0C.502 0 0 .502 0 1.125v21.75C0 23.498.502 24 1.125 24h21.75c.623 0 1.125-.502 1.125-1.125V1.125C24 .502 23.498 0 22.875 0zm17.363 9.75c.612 0 1.154.037 1.627.111a6.38 6.38 0 0 1 1.306.34v2.458a3.95 3.95 0 0 0-.643-.361 5.093 5.093 0 0 0-.717-.26 5.453 5.453 0 0 0-1.426-.2c-.3 0-.573.028-.819.086a2.1 2.1 0 0 0-.623.242c-.17.104-.3.229-.393.374a.888.888 0 0 0-.14.49c0 .196.053.373.156.529.104.156.252.304.443.444s.423.276.696.41c.273.135.582.274.926.416.47.197.892.407 1.266.628.374.222.695.473.963.753.268.279.472.598.614.957.142.359.214.776.214 1.253 0 .657-.125 1.21-.373 1.656a3.033 3.033 0 0 1-1.012 1.085 4.38 4.38 0 0 1-1.487.596c-.566.12-1.163.18-1.79.18a9.916 9.916 0 0 1-1.84-.164 5.544 5.544 0 0 1-1.512-.493v-2.63a5.033 5.033 0 0 0 3.237 1.2c.333 0 .624-.03.872-.09.249-.06.456-.144.623-.25.166-.108.29-.234.373-.38a1.023 1.023 0 0 0-.074-1.089 2.12 2.12 0 0 0-.537-.5 5.597 5.597 0 0 0-.807-.444 27.72 27.72 0 0 0-1.007-.436c-.918-.383-1.602-.852-2.053-1.405-.45-.553-.676-1.222-.676-2.005 0-.614.123-1.141.369-1.582.246-.441.58-.804 1.004-1.089a4.494 4.494 0 0 1 1.47-.629 7.536 7.536 0 0 1 1.77-.201zm-15.113.188h9.563v2.166H9.506v9.646H6.789v-9.646H3.375z",
            stroke: "none"
        })
    });
var $8dd2bb62639d6e8f$export$2e2bcd8739ae039 = $8dd2bb62639d6e8f$var$SvgTypeScript;



parcelRequire("2gcPZ");
const $82c51e0ff6f82618$var$SvgGoLang = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        stroke: "currentColor",
        fill: "currentColor",
        strokeWidth: 0,
        viewBox: "0 0 640 512",
        height: "1em",
        width: "1em",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M400.1 194.8c-10.9 2.8-19.9 4.3-29.1 7.6-7.3 1.9-14.7 3.9-23.2 6.1l-.6.1c-4.2 1.2-4.6 1.3-8.5-3.2-4.7-5.3-8.1-8.7-14.6-11.9-19.7-9.6-38.7-6.8-56.4 4.7-21.2 13.7-32.1 34-31.8 59.2.3 25 17.4 45.5 41.2 48.9 22 2.8 39.8-4.6 53.8-20.5 2.1-2.6 4-5.3 6.1-8.3.8-1 1.5-2.1 2.3-3.3h-60.1c-6.5 0-8.1-4-5.9-9.3 4-9.7 11.5-25.9 15.9-34 .9-1.8 3.1-5.8 6.9-5.8h101.1c4.5-13.4 11.8-26.9 21.6-39.7 22.7-29.9 49.3-45.5 87.2-52 31.8-5.6 61.7-2.5 88.9 15.9 24.6 16.8 39.8 39.6 43.9 69.5 5.3 42.1-6.9 76.3-36.7 105.6-19.7 20.9-44.9 34-73.9 39.9-5.6 1-11.1 1.5-16.5 2-2.9.2-5.7.5-8.5.8-28.3-.6-54.2-8.7-76-27.4-15.3-13.3-25.9-29.6-31.1-48.5-3.7 7.3-8 14.4-14 21.1-21.6 29.6-50.9 48-87.9 52.9-30.6 4.1-58.9-1.8-83.9-20.5-23-17.5-36.1-40.5-39.5-69.2-4.1-34 5.9-65.4 26.4-91.3 22.2-29 51.5-47.4 87.3-53.9 29.3-6.2 57.3-1.9 82.6 15.3 16.5 10.9 28.3 25.8 36.1 43.9 1.9 2.8.6 4.4-3.1 5.3zm-351.8 5.6c-1.25 0-1.56-.6-.94-1.6l6.55-8.4c.62-.9 2.18-1.5 3.43-1.5H168.6c1.2 0 1.5.9.9 1.8l-5.3 8.1c-.6 1-2.2 1.9-3.1 1.9l-112.8-.3zM1.246 229.1c-1.246 0-1.558-.7-.934-1.6l6.543-8.4c.624-.9 2.182-1.6 3.425-1.6H152.4c1.2 0 1.8 1 1.5 1.9l-2.5 7.5c-.3 1.2-1.5 1.9-2.8 1.9l-147.354.3zm74.474 26.8c-.62.9-.31 1.8.93 1.8l67.95.3c.9 0 2.2-.9 2.2-2.1l.6-7.5c0-1.3-.6-2.2-1.9-2.2H83.2c-1.25 0-2.49.9-3.12 1.9l-4.36 7.8zm501.48-18c-.2-2.6-.3-4.8-.7-7-5.6-30.8-34-48.3-63.6-41.4-29 6.5-47.7 24.9-54.5 54.2-5.6 24.3 6.2 48.9 28.6 58.9 17.2 7.5 34.3 6.6 50.8-1.9 24.6-13.6 38-32.7 39.6-59.5-.1-1.2-.1-2.3-.2-3.3z",
            stroke: "none"
        })
    });
var $82c51e0ff6f82618$export$2e2bcd8739ae039 = $82c51e0ff6f82618$var$SvgGoLang;



parcelRequire("2gcPZ");
const $91c2bc5ecbc76b06$var$SvgPython = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        stroke: "currentColor",
        fill: "currentColor",
        strokeWidth: 0,
        viewBox: "0 0 448 512",
        height: "1em",
        width: "1em",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M439.8 200.5c-7.7-30.9-22.3-54.2-53.4-54.2h-40.1v47.4c0 36.8-31.2 67.8-66.8 67.8H172.7c-29.2 0-53.4 25-53.4 54.3v101.8c0 29 25.2 46 53.4 54.3 33.8 9.9 66.3 11.7 106.8 0 26.9-7.8 53.4-23.5 53.4-54.3v-40.7H226.2v-13.6h160.2c31.1 0 42.6-21.7 53.4-54.2 11.2-33.5 10.7-65.7 0-108.6zM286.2 404c11.1 0 20.1 9.1 20.1 20.3 0 11.3-9 20.4-20.1 20.4-11 0-20.1-9.2-20.1-20.4.1-11.3 9.1-20.3 20.1-20.3zM167.8 248.1h106.8c29.7 0 53.4-24.5 53.4-54.3V91.9c0-29-24.4-50.7-53.4-55.6-35.8-5.9-74.7-5.6-106.8.1-45.2 8-53.4 24.7-53.4 55.6v40.7h106.9v13.6h-147c-31.1 0-58.3 18.7-66.8 54.2-9.8 40.7-10.2 66.1 0 108.6 7.6 31.6 25.7 54.2 56.8 54.2H101v-48.8c0-35.3 30.5-66.4 66.8-66.4zm-6.7-142.6c-11.1 0-20.1-9.1-20.1-20.3.1-11.3 9-20.4 20.1-20.4 11 0 20.1 9.2 20.1 20.4s-9 20.3-20.1 20.3z",
            stroke: "none"
        })
    });
var $91c2bc5ecbc76b06$export$2e2bcd8739ae039 = $91c2bc5ecbc76b06$var$SvgPython;



parcelRequire("2gcPZ");
const $29f4b150ad871b34$var$SvgCSharp = (props)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("svg", {
        stroke: "currentColor",
        fill: "currentColor",
        strokeWidth: 0,
        viewBox: "0 0 24 24",
        height: "1em",
        width: "1em",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("path", {
            d: "M12 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0zM9.426 7.12a5.55 5.55 0 0 1 1.985.38v1.181a4.5 4.5 0 0 0-2.25-.566 3.439 3.439 0 0 0-2.625 1.087 4.099 4.099 0 0 0-1.012 2.906 3.9 3.9 0 0 0 .945 2.754 3.217 3.217 0 0 0 2.482 1.023 4.657 4.657 0 0 0 2.464-.634l-.004 1.08a5.543 5.543 0 0 1-2.625.555 4.211 4.211 0 0 1-3.228-1.297 4.793 4.793 0 0 1-1.212-3.409 5.021 5.021 0 0 1 1.365-3.663 4.631 4.631 0 0 1 3.473-1.392 5.55 5.55 0 0 1 .12-.004 5.55 5.55 0 0 1 .122 0zm5.863.155h.836l-.555 2.652h1.661l.567-2.652h.81l-.555 2.652 1.732-.004-.15.697H17.91l-.412 1.98h1.852l-.176.698h-1.816l-.58 2.625h-.83l.567-2.625h-1.65l-.555 2.625h-.81l.555-2.625h-1.74l.131-.698h1.748l.401-1.976h-1.826l.138-.697h1.826zm.142 3.345L15 12.6h1.673l.423-1.98z",
            stroke: "none"
        })
    });
var $29f4b150ad871b34$export$2e2bcd8739ae039 = $29f4b150ad871b34$var$SvgCSharp;


const $3c6593db6c725708$export$189b23f03c8acf15 = [
    {
        cta: "Watch the quickstart video",
        title: "Rust",
        url: "https://docs.autometrics.dev/rust/quickstart",
        icon: (0, $b1a7cbe37fe57f73$export$2e2bcd8739ae039)
    },
    {
        cta: "Watch the quickstart video",
        title: "Typescript",
        url: "https://docs.autometrics.dev/typescript/quickstart",
        icon: (0, $8dd2bb62639d6e8f$export$2e2bcd8739ae039)
    },
    {
        cta: "Watch the quickstart video",
        title: "Go",
        url: "https://docs.autometrics.dev/go/quickstart",
        icon: (0, $82c51e0ff6f82618$export$2e2bcd8739ae039)
    },
    {
        cta: "Watch the quickstart video",
        title: "Python",
        url: "https://docs.autometrics.dev/python/quickstart",
        icon: (0, $91c2bc5ecbc76b06$export$2e2bcd8739ae039)
    },
    {
        cta: "Visit the Repo",
        title: "C#",
        description: "Community contributed!",
        url: "https://github.com/autometrics-dev/autometrics-cs#getting-started",
        icon: (0, $29f4b150ad871b34$export$2e2bcd8739ae039)
    }
];
const $3c6593db6c725708$export$4c1cc6b10d203845 = [
    {
        title: "Why Autometrics?",
        description: "Learn more about using metrics for faster and cheaper monitoring.",
        iconType: "autometrics_color",
        url: "https://docs.autometrics.dev/why-autometrics"
    },
    {
        title: "Local development",
        description: "Test your metrics and alerts with a proper local development workflow.",
        iconType: "desktop",
        url: "https://docs.autometrics.dev/local-development"
    },
    {
        title: "Configuring Prometheus",
        description: "Let's ship it. Learn more how to configure Prometheus in production.",
        iconType: "prometheus",
        url: "https://docs.autometrics.dev/configuring-prometheus"
    }
];
const $3c6593db6c725708$export$c0af5d89c5c4a607 = [
    {
        title: "Rust",
        image: "https://i.ytimg.com/vi/Slnjt1TPDBo/hqdefault.jpg",
        description: "Learn how to get started with Autometrics in Rust.",
        ctas: [
            {
                title: "Watch the quickstart video",
                url: "https://www.youtube.com/watch?v=Slnjt1TPDBo&t=18s"
            },
            {
                title: "Read the docs",
                url: "https://docs.autometrics.dev/rust/quickstart"
            }
        ]
    },
    {
        title: "TypeScript",
        image: "https://i.ytimg.com/vi/iRmaufIu-rk/hqdefault.jpg",
        description: "Learn how to get started with Autometrics in TypeScript.",
        ctas: [
            {
                title: "Watch the quickstart video",
                url: "https://www.youtube.com/watch?v=iRmaufIu-rk&t=19s"
            },
            {
                title: "Read the docs",
                url: "https://docs.autometrics.dev/typescript/quickstart"
            }
        ]
    },
    {
        title: "Go",
        image: "https://i.ytimg.com/vi/TbHKYjzsX-c/hqdefault.jpg",
        description: "Learn how to get started with Autometrics in Go.",
        ctas: [
            {
                title: "Watch the quickstart video",
                url: "https://www.youtube.com/watch?v=TbHKYjzsX-c&t=3s"
            },
            {
                title: "Read the docs",
                url: "https://docs.autometrics.dev/go/quickstart"
            }
        ]
    },
    {
        title: "Python",
        image: "https://i.ytimg.com/vi/X3U1d9wzYM8/hqdefault.jpg",
        description: "Learn how to get started with Autometrics in Python.",
        ctas: [
            {
                title: "Watch the quickstart video",
                url: "https://www.youtube.com/watch?v=X3U1d9wzYM8&t=6s"
            },
            {
                title: "Read the docs",
                url: "https://docs.autometrics.dev/python/quickstart"
            }
        ]
    },
    {
        title: "C#",
        description: "Learn how to get started with Autometrics in C#.",
        icon: (0, $29f4b150ad871b34$export$2e2bcd8739ae039),
        ctas: [
            {
                title: "Read the docs",
                url: "https://github.com/autometrics-dev/autometrics-cs#getting-started"
            }
        ]
    }
];
var $dbade2c0cb37def0$exports = {};
$dbade2c0cb37def0$exports = new URL("../img/functions.2b01697e.png", import.meta.url).toString();


var $732b21a30020d75f$exports = {};
$732b21a30020d75f$exports = new URL("../img/slos.165bf3c0.png", import.meta.url).toString();


var $4cacdcd7a84a8015$exports = {};
$4cacdcd7a84a8015$exports = new URL("../img/alerts.66111ab0.png", import.meta.url).toString();


const $3c6593db6c725708$export$b8de7d271b3ffa06 = [
    {
        title: "Functions",
        image: new URL($dbade2c0cb37def0$exports).toString(),
        description: "Dig into useful metrics for your instrumented functions, like their request rate, error rate, and latency.",
        url: "/functions"
    },
    {
        title: "SLOs",
        image: new URL($732b21a30020d75f$exports).toString(),
        description: "Check up on the performance targets for your applications, and make sure everything's running smoothly.",
        url: "/slos"
    },
    {
        title: "Alerts",
        image: new URL($4cacdcd7a84a8015$exports).toString(),
        description: "Look at current or historical alerts, and investigate which functions are causing issues.",
        url: "alerts"
    }
];



function $a923dedecd33d9d8$export$b94310965bed44e6() {
    const { getAccentColorForIndex: getAccentColorForIndex } = (0, $a7634f2acd528865$export$bd4b012f42a4dab7)();
    const { icon: LinkOutIcon, startAnimation: startAnimation, animateToInitial: animateToInitial } = (0, $cf5557e4cde6a3c7$export$362afcc43006a410)("link_out");
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($a923dedecd33d9d8$var$HomeContainer, {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($a923dedecd33d9d8$var$Header, {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($a923dedecd33d9d8$var$PageTitle, {
                        children: "Welcome to Autometrics"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($a923dedecd33d9d8$var$PageDescription, {
                        children: "An open source micro framework for observability that makes it trivial to instrument your code and writes Prometheus queries for you."
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($a923dedecd33d9d8$var$HeaderCTA, {
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $a921dfdbd8dd60fa$export$353f5b6fc5456de1), {
                                asElement: "link",
                                to: "/functions",
                                children: [
                                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0a830394bc38e4e3$export$f04a61298a47a40f), {
                                        type: "magnifying_glass",
                                        height: "18",
                                        width: "18"
                                    }),
                                    "Start Exploring"
                                ]
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $a921dfdbd8dd60fa$export$353f5b6fc5456de1), {
                                asElement: "externalLink",
                                buttonStyle: "secondary",
                                href: "https://marketplace.visualstudio.com/items?itemName=Fiberplane.autometrics",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: [
                                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0a830394bc38e4e3$export$f04a61298a47a40f), {
                                        type: "vscode",
                                        height: "18",
                                        width: "18"
                                    }),
                                    "Get the VSCode Extension"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($a923dedecd33d9d8$var$ContentBlock, {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($a923dedecd33d9d8$var$BlockTitle, {
                        children: "Getting started"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($a923dedecd33d9d8$var$ContentContainer, {
                        children: (0, $3c6593db6c725708$export$b8de7d271b3ffa06).map(({ title: title, description: description, url: url, image: image })=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $e3aa85e7acb33985$export$a42f5eaaf607cc9c), {
                                title: title,
                                description: description,
                                url: url,
                                image: image
                            }, title))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($a923dedecd33d9d8$var$ContentBlock, {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($a923dedecd33d9d8$var$BlockTitle, {
                        children: [
                            "Documentation",
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($a923dedecd33d9d8$var$StyledButton, {
                                buttonStyle: "tertiary-color",
                                to: "https://docs.autometrics.dev/",
                                target: "_blank",
                                rel: "noopener noreferrer",
                                asElement: "link",
                                onMouseEnter: startAnimation,
                                onMouseLeave: animateToInitial,
                                children: [
                                    "View all",
                                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)(LinkOutIcon, {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($a923dedecd33d9d8$var$ContentContainer, {
                        children: (0, $3c6593db6c725708$export$4c1cc6b10d203845).map(({ description: description, iconType: iconType, title: title, url: url }, index)=>{
                            const accentColor = getAccentColorForIndex(index);
                            return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $e3aa85e7acb33985$export$86e5dd73a6f654fb), {
                                brandColor: accentColor,
                                description: description,
                                title: title,
                                iconType: iconType,
                                url: url
                            }, title);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($a923dedecd33d9d8$var$ContentBlock, {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($a923dedecd33d9d8$var$BlockTitle, {
                        children: "Get started with these tutorials"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($a923dedecd33d9d8$var$ContentContainer, {
                        children: (0, $3c6593db6c725708$export$c0af5d89c5c4a607).map(({ title: title, description: description, url: url, image: image, ctas: ctas, icon: icon })=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $e3aa85e7acb33985$export$5313280cb700b1f3), {
                                title: title,
                                description: description,
                                url: url,
                                image: image,
                                ctas: ctas,
                                icon: icon
                            }, title))
                    })
                ]
            })
        ]
    });
}
const $a923dedecd33d9d8$var$HomeContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $747d2f1afecb66a5$export$5f86df0ee0a255b5))(({ theme: { media: media } })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    padding: 40px 0;
    gap: 40px;

    ${media.md`
      padding: 80px 0;
      gap: 64px;
    `}
  `);
const $a923dedecd33d9d8$var$ContentBlock = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).section`
  display: grid;
  gap: 24px;
`;
const $a923dedecd33d9d8$var$BlockTitle = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).h2`
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: "Basier Square";
  font-size: 20px;
  font-weight: 500;
  line-height: 1;
  letter-spacing: -0.01em;
`;
const $a923dedecd33d9d8$var$Header = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).header`
  display: grid;
  row-gap: 8px;
`;
const $a923dedecd33d9d8$var$PageTitle = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).h1`
  font: ${({ theme: theme })=>theme.font.display[1]};
`;
const $a923dedecd33d9d8$var$PageDescription = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).p(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      font: ${theme.font.body.l.regular};
      color: ${theme.color.fg.muted};
      margin: 0;
    `);
const $a923dedecd33d9d8$var$HeaderCTA = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: { media: media } })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 16px;

    ${media.sm`
      flex-direction: row;
    `}
  `);
const $a923dedecd33d9d8$var$ContentContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: { spacing: spacing } })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    display: grid;
    grid-auto-rows: fit-content;
    gap: ${spacing.content.gap.lg};
    grid-template-columns: ${spacing.content.templateColumns};
  `);
const $a923dedecd33d9d8$var$StyledButton = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $a921dfdbd8dd60fa$export$353f5b6fc5456de1))`
  align-items: end;
`;






var $2gcPZ = parcelRequire("2gcPZ");


















const { Container: $99643ce9709efb50$var$Container, Content: $99643ce9709efb50$var$Content, Header: $99643ce9709efb50$var$Header, Heading: $99643ce9709efb50$var$Heading, HelperText: $99643ce9709efb50$var$HelperText, BigIcon: $99643ce9709efb50$var$BigIcon } = (0, $0c5c766c1e242605$exports);
function $99643ce9709efb50$export$bd8705ca756a6606({ objectiveName: objectiveName }) {
    const [searchParams] = (0, $e7b98158099ae00d$export$f1a78c17382fe22a)();
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($99643ce9709efb50$var$StyledContainer, {
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($99643ce9709efb50$var$StyledContent, {
            children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($99643ce9709efb50$var$Header, {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($99643ce9709efb50$var$BigIcon, {
                        type: "autometrics_black_faded"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($99643ce9709efb50$var$Heading, {
                        children: "SLO Not Found"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($99643ce9709efb50$var$HelperText, {
                        children: objectiveName ? `The SLO "${objectiveName}" was not found in Prometheus.` : "No data were found for this SLO."
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($99643ce9709efb50$var$ButtonGroup, {
                        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($99643ce9709efb50$var$GoBackButton, {
                            asElement: "link",
                            to: {
                                pathname: "/slos",
                                search: searchParams.toString()
                            },
                            children: "View all SLOs"
                        })
                    })
                ]
            })
        })
    });
}
const $99643ce9709efb50$var$StyledContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)($99643ce9709efb50$var$Container)`
  height: 100%;
  min-height: 400px;
  align-items: flex-start;
  padding: 72px 0;
`;
const $99643ce9709efb50$var$StyledContent = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)($99643ce9709efb50$var$Content)`
  max-width: 640px;
  display: flex;
  flex-direction: column;
  gap: 32px;
`;
const $99643ce9709efb50$var$ButtonGroup = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 16px;
`;
const $99643ce9709efb50$var$GoBackButton = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $a921dfdbd8dd60fa$export$353f5b6fc5456de1))``;







const { Container: $58fc4bbaeff94670$var$Container, Content: $58fc4bbaeff94670$var$Content, Header: $58fc4bbaeff94670$var$Header, Heading: $58fc4bbaeff94670$var$Heading, HelperText: $58fc4bbaeff94670$var$HelperText, BigIcon: $58fc4bbaeff94670$var$BigIcon } = (0, $0c5c766c1e242605$exports);
function $58fc4bbaeff94670$export$669f6ea7d267feaf() {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($58fc4bbaeff94670$var$StyledContainer, {
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($58fc4bbaeff94670$var$Content, {
            children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($58fc4bbaeff94670$var$Header, {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $f71dd936b17623f4$export$ec58be8144c543a7), {
                        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($58fc4bbaeff94670$var$BigIcon, {
                            type: "autometrics",
                            noBorder: true
                        })
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($58fc4bbaeff94670$var$Heading, {
                        children: "Loading"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($58fc4bbaeff94670$var$HelperText, {
                        children: "Fetching your SLO data from Prometheus\u2026"
                    })
                ]
            })
        })
    });
}
const $58fc4bbaeff94670$var$StyledContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)($58fc4bbaeff94670$var$Container)`
  padding-top: 72px;
  height: auto;
  min-height: 0;
`;




/**
 * table-core
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ // Is this type a tuple?
// If this type is a tuple, what indices are allowed?
///
function $93a274dd46b4c3ff$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $93a274dd46b4c3ff$export$8793edee2d425525() {
//
}
function $93a274dd46b4c3ff$export$2b5605d8069324bd(key, instance) {
    return (updater)=>{
        instance.setState((old)=>{
            return {
                ...old,
                [key]: $93a274dd46b4c3ff$export$7f095f455ad5af3f(updater, old[key])
            };
        });
    };
}
function $93a274dd46b4c3ff$export$f6e2535fb5126e54(d) {
    return d instanceof Function;
}
function $93a274dd46b4c3ff$export$5cd576d1827d40c8(d) {
    return Array.isArray(d) && d.every((val)=>typeof val === "number");
}
function $93a274dd46b4c3ff$export$bf4548421d1b2c8(arr, getChildren) {
    const flat = [];
    const recurse = (subArr)=>{
        subArr.forEach((item)=>{
            flat.push(item);
            const children = getChildren(item);
            if (children != null && children.length) recurse(children);
        });
    };
    recurse(arr);
    return flat;
}
function $93a274dd46b4c3ff$export$7c73462e0d25e514(getDeps, fn, opts) {
    let deps = [];
    let result;
    return ()=>{
        let depTime;
        if (opts.key && opts.debug) depTime = Date.now();
        const newDeps = getDeps();
        const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index)=>deps[index] !== dep);
        if (!depsChanged) return result;
        deps = newDeps;
        let resultTime;
        if (opts.key && opts.debug) resultTime = Date.now();
        result = fn(...newDeps);
        opts == null || opts.onChange == null || opts.onChange(result);
        if (opts.key && opts.debug) {
            if (opts != null && opts.debug()) {
                const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
                const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
                const resultFpsPercentage = resultEndTime / 16;
                const pad = (str, num)=>{
                    str = String(str);
                    while(str.length < num)str = " " + str;
                    return str;
                };
                console.info(`%c\u{23F1} ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
            }
        }
        return result;
    };
}
function $93a274dd46b4c3ff$export$1bfa986e9c92c0b5(table, columnDef, depth, parent) {
    var _ref, _resolvedColumnDef$id;
    const defaultColumn = table._getDefaultColumnDef();
    const resolvedColumnDef = {
        ...defaultColumn,
        ...columnDef
    };
    const accessorKey = resolvedColumnDef.accessorKey;
    let id = (_ref = (_resolvedColumnDef$id = resolvedColumnDef.id) != null ? _resolvedColumnDef$id : accessorKey ? accessorKey.replace(".", "_") : undefined) != null ? _ref : typeof resolvedColumnDef.header === "string" ? resolvedColumnDef.header : undefined;
    let accessorFn;
    if (resolvedColumnDef.accessorFn) accessorFn = resolvedColumnDef.accessorFn;
    else if (accessorKey) {
        // Support deep accessor keys
        if (accessorKey.includes(".")) accessorFn = (originalRow)=>{
            let result = originalRow;
            for (const key of accessorKey.split(".")){
                var _result;
                result = (_result = result) == null ? void 0 : _result[key];
            }
            return result;
        };
        else accessorFn = (originalRow)=>originalRow[resolvedColumnDef.accessorKey];
    }
    if (!id) throw new Error();
    let column = {
        id: `${String(id)}`,
        accessorFn: accessorFn,
        parent: parent,
        depth: depth,
        columnDef: resolvedColumnDef,
        columns: [],
        getFlatColumns: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                true
            ], ()=>{
            var _column$columns;
            return [
                column,
                ...(_column$columns = column.columns) == null ? void 0 : _column$columns.flatMap((d)=>d.getFlatColumns())
            ];
        }, {
            key: "column.getFlatColumns",
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugColumns;
            }
        }),
        getLeafColumns: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                table._getOrderColumnsFn()
            ], (orderColumns)=>{
            var _column$columns2;
            if ((_column$columns2 = column.columns) != null && _column$columns2.length) {
                let leafColumns = column.columns.flatMap((column)=>column.getLeafColumns());
                return orderColumns(leafColumns);
            }
            return [
                column
            ];
        }, {
            key: "column.getLeafColumns",
            debug: ()=>{
                var _table$options$debugA2;
                return (_table$options$debugA2 = table.options.debugAll) != null ? _table$options$debugA2 : table.options.debugColumns;
            }
        })
    };
    column = table._features.reduce((obj, feature)=>{
        return Object.assign(obj, feature.createColumn == null ? void 0 : feature.createColumn(column, table));
    }, column);
    // Yes, we have to convert table to uknown, because we know more than the compiler here.
    return column;
}
//
function $93a274dd46b4c3ff$var$createHeader(table, column, options) {
    var _options$id;
    const id = (_options$id = options.id) != null ? _options$id : column.id;
    let header = {
        id: id,
        column: column,
        index: options.index,
        isPlaceholder: !!options.isPlaceholder,
        placeholderId: options.placeholderId,
        depth: options.depth,
        subHeaders: [],
        colSpan: 0,
        rowSpan: 0,
        headerGroup: null,
        getLeafHeaders: ()=>{
            const leafHeaders = [];
            const recurseHeader = (h)=>{
                if (h.subHeaders && h.subHeaders.length) h.subHeaders.map(recurseHeader);
                leafHeaders.push(h);
            };
            recurseHeader(header);
            return leafHeaders;
        },
        getContext: ()=>({
                table: table,
                header: header,
                column: column
            })
    };
    table._features.forEach((feature)=>{
        Object.assign(header, feature.createHeader == null ? void 0 : feature.createHeader(header, table));
    });
    return header;
}
const $93a274dd46b4c3ff$export$79b704688b15c0f4 = {
    createTable: (table)=>{
        return {
            // Header Groups
            getHeaderGroups: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                    table.getAllColumns(),
                    table.getVisibleLeafColumns(),
                    table.getState().columnPinning.left,
                    table.getState().columnPinning.right
                ], (allColumns, leafColumns, left, right)=>{
                var _left$map$filter, _right$map$filter;
                const leftColumns = (_left$map$filter = left == null ? void 0 : left.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _left$map$filter : [];
                const rightColumns = (_right$map$filter = right == null ? void 0 : right.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _right$map$filter : [];
                const centerColumns = leafColumns.filter((column)=>!(left != null && left.includes(column.id)) && !(right != null && right.includes(column.id)));
                const headerGroups = $93a274dd46b4c3ff$export$d8c3a8af36458fc3(allColumns, [
                    ...leftColumns,
                    ...centerColumns,
                    ...rightColumns
                ], table);
                return headerGroups;
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA;
                    return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugHeaders;
                }
            }),
            getCenterHeaderGroups: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                    table.getAllColumns(),
                    table.getVisibleLeafColumns(),
                    table.getState().columnPinning.left,
                    table.getState().columnPinning.right
                ], (allColumns, leafColumns, left, right)=>{
                leafColumns = leafColumns.filter((column)=>!(left != null && left.includes(column.id)) && !(right != null && right.includes(column.id)));
                return $93a274dd46b4c3ff$export$d8c3a8af36458fc3(allColumns, leafColumns, table, "center");
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA2;
                    return (_table$options$debugA2 = table.options.debugAll) != null ? _table$options$debugA2 : table.options.debugHeaders;
                }
            }),
            getLeftHeaderGroups: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                    table.getAllColumns(),
                    table.getVisibleLeafColumns(),
                    table.getState().columnPinning.left
                ], (allColumns, leafColumns, left)=>{
                var _left$map$filter2;
                const orderedLeafColumns = (_left$map$filter2 = left == null ? void 0 : left.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _left$map$filter2 : [];
                return $93a274dd46b4c3ff$export$d8c3a8af36458fc3(allColumns, orderedLeafColumns, table, "left");
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA3;
                    return (_table$options$debugA3 = table.options.debugAll) != null ? _table$options$debugA3 : table.options.debugHeaders;
                }
            }),
            getRightHeaderGroups: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                    table.getAllColumns(),
                    table.getVisibleLeafColumns(),
                    table.getState().columnPinning.right
                ], (allColumns, leafColumns, right)=>{
                var _right$map$filter2;
                const orderedLeafColumns = (_right$map$filter2 = right == null ? void 0 : right.map((columnId)=>leafColumns.find((d)=>d.id === columnId)).filter(Boolean)) != null ? _right$map$filter2 : [];
                return $93a274dd46b4c3ff$export$d8c3a8af36458fc3(allColumns, orderedLeafColumns, table, "right");
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA4;
                    return (_table$options$debugA4 = table.options.debugAll) != null ? _table$options$debugA4 : table.options.debugHeaders;
                }
            }),
            // Footer Groups
            getFooterGroups: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                    table.getHeaderGroups()
                ], (headerGroups)=>{
                return [
                    ...headerGroups
                ].reverse();
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA5;
                    return (_table$options$debugA5 = table.options.debugAll) != null ? _table$options$debugA5 : table.options.debugHeaders;
                }
            }),
            getLeftFooterGroups: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                    table.getLeftHeaderGroups()
                ], (headerGroups)=>{
                return [
                    ...headerGroups
                ].reverse();
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA6;
                    return (_table$options$debugA6 = table.options.debugAll) != null ? _table$options$debugA6 : table.options.debugHeaders;
                }
            }),
            getCenterFooterGroups: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                    table.getCenterHeaderGroups()
                ], (headerGroups)=>{
                return [
                    ...headerGroups
                ].reverse();
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA7;
                    return (_table$options$debugA7 = table.options.debugAll) != null ? _table$options$debugA7 : table.options.debugHeaders;
                }
            }),
            getRightFooterGroups: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                    table.getRightHeaderGroups()
                ], (headerGroups)=>{
                return [
                    ...headerGroups
                ].reverse();
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA8;
                    return (_table$options$debugA8 = table.options.debugAll) != null ? _table$options$debugA8 : table.options.debugHeaders;
                }
            }),
            // Flat Headers
            getFlatHeaders: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                    table.getHeaderGroups()
                ], (headerGroups)=>{
                return headerGroups.map((headerGroup)=>{
                    return headerGroup.headers;
                }).flat();
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA9;
                    return (_table$options$debugA9 = table.options.debugAll) != null ? _table$options$debugA9 : table.options.debugHeaders;
                }
            }),
            getLeftFlatHeaders: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                    table.getLeftHeaderGroups()
                ], (left)=>{
                return left.map((headerGroup)=>{
                    return headerGroup.headers;
                }).flat();
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA10;
                    return (_table$options$debugA10 = table.options.debugAll) != null ? _table$options$debugA10 : table.options.debugHeaders;
                }
            }),
            getCenterFlatHeaders: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                    table.getCenterHeaderGroups()
                ], (left)=>{
                return left.map((headerGroup)=>{
                    return headerGroup.headers;
                }).flat();
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA11;
                    return (_table$options$debugA11 = table.options.debugAll) != null ? _table$options$debugA11 : table.options.debugHeaders;
                }
            }),
            getRightFlatHeaders: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                    table.getRightHeaderGroups()
                ], (left)=>{
                return left.map((headerGroup)=>{
                    return headerGroup.headers;
                }).flat();
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA12;
                    return (_table$options$debugA12 = table.options.debugAll) != null ? _table$options$debugA12 : table.options.debugHeaders;
                }
            }),
            // Leaf Headers
            getCenterLeafHeaders: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                    table.getCenterFlatHeaders()
                ], (flatHeaders)=>{
                return flatHeaders.filter((header)=>{
                    var _header$subHeaders;
                    return !((_header$subHeaders = header.subHeaders) != null && _header$subHeaders.length);
                });
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA13;
                    return (_table$options$debugA13 = table.options.debugAll) != null ? _table$options$debugA13 : table.options.debugHeaders;
                }
            }),
            getLeftLeafHeaders: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                    table.getLeftFlatHeaders()
                ], (flatHeaders)=>{
                return flatHeaders.filter((header)=>{
                    var _header$subHeaders2;
                    return !((_header$subHeaders2 = header.subHeaders) != null && _header$subHeaders2.length);
                });
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA14;
                    return (_table$options$debugA14 = table.options.debugAll) != null ? _table$options$debugA14 : table.options.debugHeaders;
                }
            }),
            getRightLeafHeaders: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                    table.getRightFlatHeaders()
                ], (flatHeaders)=>{
                return flatHeaders.filter((header)=>{
                    var _header$subHeaders3;
                    return !((_header$subHeaders3 = header.subHeaders) != null && _header$subHeaders3.length);
                });
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA15;
                    return (_table$options$debugA15 = table.options.debugAll) != null ? _table$options$debugA15 : table.options.debugHeaders;
                }
            }),
            getLeafHeaders: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                    table.getLeftHeaderGroups(),
                    table.getCenterHeaderGroups(),
                    table.getRightHeaderGroups()
                ], (left, center, right)=>{
                var _left$0$headers, _left$, _center$0$headers, _center$, _right$0$headers, _right$;
                return [
                    ...(_left$0$headers = (_left$ = left[0]) == null ? void 0 : _left$.headers) != null ? _left$0$headers : [],
                    ...(_center$0$headers = (_center$ = center[0]) == null ? void 0 : _center$.headers) != null ? _center$0$headers : [],
                    ...(_right$0$headers = (_right$ = right[0]) == null ? void 0 : _right$.headers) != null ? _right$0$headers : []
                ].map((header)=>{
                    return header.getLeafHeaders();
                }).flat();
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA16;
                    return (_table$options$debugA16 = table.options.debugAll) != null ? _table$options$debugA16 : table.options.debugHeaders;
                }
            })
        };
    }
};
function $93a274dd46b4c3ff$export$d8c3a8af36458fc3(allColumns, columnsToGroup, table, headerFamily) {
    var _headerGroups$0$heade, _headerGroups$;
    // Find the max depth of the columns:
    // build the leaf column row
    // build each buffer row going up
    //    placeholder for non-existent level
    //    real column for existing level
    let maxDepth = 0;
    const findMaxDepth = function(columns, depth) {
        if (depth === void 0) depth = 1;
        maxDepth = Math.max(maxDepth, depth);
        columns.filter((column)=>column.getIsVisible()).forEach((column)=>{
            var _column$columns;
            if ((_column$columns = column.columns) != null && _column$columns.length) findMaxDepth(column.columns, depth + 1);
        }, 0);
    };
    findMaxDepth(allColumns);
    let headerGroups = [];
    const createHeaderGroup = (headersToGroup, depth)=>{
        // The header group we are creating
        const headerGroup = {
            depth: depth,
            id: [
                headerFamily,
                `${depth}`
            ].filter(Boolean).join("_"),
            headers: []
        };
        // The parent columns we're going to scan next
        const pendingParentHeaders = [];
        // Scan each column for parents
        headersToGroup.forEach((headerToGroup)=>{
            // What is the latest (last) parent column?
            const latestPendingParentHeader = [
                ...pendingParentHeaders
            ].reverse()[0];
            const isLeafHeader = headerToGroup.column.depth === headerGroup.depth;
            let column;
            let isPlaceholder = false;
            if (isLeafHeader && headerToGroup.column.parent) // The parent header is new
            column = headerToGroup.column.parent;
            else {
                // The parent header is repeated
                column = headerToGroup.column;
                isPlaceholder = true;
            }
            if (latestPendingParentHeader && (latestPendingParentHeader == null ? void 0 : latestPendingParentHeader.column) === column) // This column is repeated. Add it as a sub header to the next batch
            latestPendingParentHeader.subHeaders.push(headerToGroup);
            else {
                // This is a new header. Let's create it
                const header = $93a274dd46b4c3ff$var$createHeader(table, column, {
                    id: [
                        headerFamily,
                        depth,
                        column.id,
                        headerToGroup == null ? void 0 : headerToGroup.id
                    ].filter(Boolean).join("_"),
                    isPlaceholder: isPlaceholder,
                    placeholderId: isPlaceholder ? `${pendingParentHeaders.filter((d)=>d.column === column).length}` : undefined,
                    depth: depth,
                    index: pendingParentHeaders.length
                });
                // Add the headerToGroup as a subHeader of the new header
                header.subHeaders.push(headerToGroup);
                // Add the new header to the pendingParentHeaders to get grouped
                // in the next batch
                pendingParentHeaders.push(header);
            }
            headerGroup.headers.push(headerToGroup);
            headerToGroup.headerGroup = headerGroup;
        });
        headerGroups.push(headerGroup);
        if (depth > 0) createHeaderGroup(pendingParentHeaders, depth - 1);
    };
    const bottomHeaders = columnsToGroup.map((column, index)=>$93a274dd46b4c3ff$var$createHeader(table, column, {
            depth: maxDepth,
            index: index
        }));
    createHeaderGroup(bottomHeaders, maxDepth - 1);
    headerGroups.reverse();
    // headerGroups = headerGroups.filter(headerGroup => {
    //   return !headerGroup.headers.every(header => header.isPlaceholder)
    // })
    const recurseHeadersForSpans = (headers)=>{
        const filteredHeaders = headers.filter((header)=>header.column.getIsVisible());
        return filteredHeaders.map((header)=>{
            let colSpan = 0;
            let rowSpan = 0;
            let childRowSpans = [
                0
            ];
            if (header.subHeaders && header.subHeaders.length) {
                childRowSpans = [];
                recurseHeadersForSpans(header.subHeaders).forEach((_ref)=>{
                    let { colSpan: childColSpan, rowSpan: childRowSpan } = _ref;
                    colSpan += childColSpan;
                    childRowSpans.push(childRowSpan);
                });
            } else colSpan = 1;
            const minChildRowSpan = Math.min(...childRowSpans);
            rowSpan = rowSpan + minChildRowSpan;
            header.colSpan = colSpan;
            header.rowSpan = rowSpan;
            return {
                colSpan: colSpan,
                rowSpan: rowSpan
            };
        });
    };
    recurseHeadersForSpans((_headerGroups$0$heade = (_headerGroups$ = headerGroups[0]) == null ? void 0 : _headerGroups$.headers) != null ? _headerGroups$0$heade : []);
    return headerGroups;
}
//
//
const $93a274dd46b4c3ff$export$2f660993f4eb1f29 = {
    size: 150,
    minSize: 20,
    maxSize: Number.MAX_SAFE_INTEGER
};
const $93a274dd46b4c3ff$var$getDefaultColumnSizingInfoState = ()=>({
        startOffset: null,
        startSize: null,
        deltaOffset: null,
        deltaPercentage: null,
        isResizingColumn: false,
        columnSizingStart: []
    });
const $93a274dd46b4c3ff$export$9916c85814812d4a = {
    getDefaultColumnDef: ()=>{
        return $93a274dd46b4c3ff$export$2f660993f4eb1f29;
    },
    getInitialState: (state)=>{
        return {
            columnSizing: {},
            columnSizingInfo: $93a274dd46b4c3ff$var$getDefaultColumnSizingInfoState(),
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            columnResizeMode: "onEnd",
            onColumnSizingChange: $93a274dd46b4c3ff$export$2b5605d8069324bd("columnSizing", table),
            onColumnSizingInfoChange: $93a274dd46b4c3ff$export$2b5605d8069324bd("columnSizingInfo", table)
        };
    },
    createColumn: (column, table)=>{
        return {
            getSize: ()=>{
                var _column$columnDef$min, _ref, _column$columnDef$max;
                const columnSize = table.getState().columnSizing[column.id];
                return Math.min(Math.max((_column$columnDef$min = column.columnDef.minSize) != null ? _column$columnDef$min : $93a274dd46b4c3ff$export$2f660993f4eb1f29.minSize, (_ref = columnSize != null ? columnSize : column.columnDef.size) != null ? _ref : $93a274dd46b4c3ff$export$2f660993f4eb1f29.size), (_column$columnDef$max = column.columnDef.maxSize) != null ? _column$columnDef$max : $93a274dd46b4c3ff$export$2f660993f4eb1f29.maxSize);
            },
            getStart: (position)=>{
                const columns = !position ? table.getVisibleLeafColumns() : position === "left" ? table.getLeftVisibleLeafColumns() : table.getRightVisibleLeafColumns();
                const index = columns.findIndex((d)=>d.id === column.id);
                if (index > 0) {
                    const prevSiblingColumn = columns[index - 1];
                    return prevSiblingColumn.getStart(position) + prevSiblingColumn.getSize();
                }
                return 0;
            },
            resetSize: ()=>{
                table.setColumnSizing((_ref2)=>{
                    let { [column.id]: _, ...rest } = _ref2;
                    return rest;
                });
            },
            getCanResize: ()=>{
                var _column$columnDef$ena, _table$options$enable;
                return ((_column$columnDef$ena = column.columnDef.enableResizing) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableColumnResizing) != null ? _table$options$enable : true);
            },
            getIsResizing: ()=>{
                return table.getState().columnSizingInfo.isResizingColumn === column.id;
            }
        };
    },
    createHeader: (header, table)=>{
        return {
            getSize: ()=>{
                let sum = 0;
                const recurse = (header)=>{
                    if (header.subHeaders.length) header.subHeaders.forEach(recurse);
                    else {
                        var _header$column$getSiz;
                        sum += (_header$column$getSiz = header.column.getSize()) != null ? _header$column$getSiz : 0;
                    }
                };
                recurse(header);
                return sum;
            },
            getStart: ()=>{
                if (header.index > 0) {
                    const prevSiblingHeader = header.headerGroup.headers[header.index - 1];
                    return prevSiblingHeader.getStart() + prevSiblingHeader.getSize();
                }
                return 0;
            },
            getResizeHandler: ()=>{
                const column = table.getColumn(header.column.id);
                const canResize = column == null ? void 0 : column.getCanResize();
                return (e)=>{
                    if (!column || !canResize) return;
                    e.persist == null || e.persist();
                    if ($93a274dd46b4c3ff$var$isTouchStartEvent(e)) {
                        // lets not respond to multiple touches (e.g. 2 or 3 fingers)
                        if (e.touches && e.touches.length > 1) return;
                    }
                    const startSize = header.getSize();
                    const columnSizingStart = header ? header.getLeafHeaders().map((d)=>[
                            d.column.id,
                            d.column.getSize()
                        ]) : [
                        [
                            column.id,
                            column.getSize()
                        ]
                    ];
                    const clientX = $93a274dd46b4c3ff$var$isTouchStartEvent(e) ? Math.round(e.touches[0].clientX) : e.clientX;
                    const newColumnSizing = {};
                    const updateOffset = (eventType, clientXPos)=>{
                        if (typeof clientXPos !== "number") return;
                        table.setColumnSizingInfo((old)=>{
                            var _old$startOffset, _old$startSize;
                            const deltaOffset = clientXPos - ((_old$startOffset = old == null ? void 0 : old.startOffset) != null ? _old$startOffset : 0);
                            const deltaPercentage = Math.max(deltaOffset / ((_old$startSize = old == null ? void 0 : old.startSize) != null ? _old$startSize : 0), -0.999999);
                            old.columnSizingStart.forEach((_ref3)=>{
                                let [columnId, headerSize] = _ref3;
                                newColumnSizing[columnId] = Math.round(Math.max(headerSize + headerSize * deltaPercentage, 0) * 100) / 100;
                            });
                            return {
                                ...old,
                                deltaOffset: deltaOffset,
                                deltaPercentage: deltaPercentage
                            };
                        });
                        if (table.options.columnResizeMode === "onChange" || eventType === "end") table.setColumnSizing((old)=>({
                                ...old,
                                ...newColumnSizing
                            }));
                    };
                    const onMove = (clientXPos)=>updateOffset("move", clientXPos);
                    const onEnd = (clientXPos)=>{
                        updateOffset("end", clientXPos);
                        table.setColumnSizingInfo((old)=>({
                                ...old,
                                isResizingColumn: false,
                                startOffset: null,
                                startSize: null,
                                deltaOffset: null,
                                deltaPercentage: null,
                                columnSizingStart: []
                            }));
                    };
                    const mouseEvents = {
                        moveHandler: (e)=>onMove(e.clientX),
                        upHandler: (e)=>{
                            document.removeEventListener("mousemove", mouseEvents.moveHandler);
                            document.removeEventListener("mouseup", mouseEvents.upHandler);
                            onEnd(e.clientX);
                        }
                    };
                    const touchEvents = {
                        moveHandler: (e)=>{
                            if (e.cancelable) {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                            onMove(e.touches[0].clientX);
                            return false;
                        },
                        upHandler: (e)=>{
                            var _e$touches$;
                            document.removeEventListener("touchmove", touchEvents.moveHandler);
                            document.removeEventListener("touchend", touchEvents.upHandler);
                            if (e.cancelable) {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                            onEnd((_e$touches$ = e.touches[0]) == null ? void 0 : _e$touches$.clientX);
                        }
                    };
                    const passiveIfSupported = $93a274dd46b4c3ff$export$4927b5943c7c0b4() ? {
                        passive: false
                    } : false;
                    if ($93a274dd46b4c3ff$var$isTouchStartEvent(e)) {
                        document.addEventListener("touchmove", touchEvents.moveHandler, passiveIfSupported);
                        document.addEventListener("touchend", touchEvents.upHandler, passiveIfSupported);
                    } else {
                        document.addEventListener("mousemove", mouseEvents.moveHandler, passiveIfSupported);
                        document.addEventListener("mouseup", mouseEvents.upHandler, passiveIfSupported);
                    }
                    table.setColumnSizingInfo((old)=>({
                            ...old,
                            startOffset: clientX,
                            startSize: startSize,
                            deltaOffset: 0,
                            deltaPercentage: 0,
                            columnSizingStart: columnSizingStart,
                            isResizingColumn: column.id
                        }));
                };
            }
        };
    },
    createTable: (table)=>{
        return {
            setColumnSizing: (updater)=>table.options.onColumnSizingChange == null ? void 0 : table.options.onColumnSizingChange(updater),
            setColumnSizingInfo: (updater)=>table.options.onColumnSizingInfoChange == null ? void 0 : table.options.onColumnSizingInfoChange(updater),
            resetColumnSizing: (defaultState)=>{
                var _table$initialState$c;
                table.setColumnSizing(defaultState ? {} : (_table$initialState$c = table.initialState.columnSizing) != null ? _table$initialState$c : {});
            },
            resetHeaderSizeInfo: (defaultState)=>{
                var _table$initialState$c2;
                table.setColumnSizingInfo(defaultState ? $93a274dd46b4c3ff$var$getDefaultColumnSizingInfoState() : (_table$initialState$c2 = table.initialState.columnSizingInfo) != null ? _table$initialState$c2 : $93a274dd46b4c3ff$var$getDefaultColumnSizingInfoState());
            },
            getTotalSize: ()=>{
                var _table$getHeaderGroup, _table$getHeaderGroup2;
                return (_table$getHeaderGroup = (_table$getHeaderGroup2 = table.getHeaderGroups()[0]) == null ? void 0 : _table$getHeaderGroup2.headers.reduce((sum, header)=>{
                    return sum + header.getSize();
                }, 0)) != null ? _table$getHeaderGroup : 0;
            },
            getLeftTotalSize: ()=>{
                var _table$getLeftHeaderG, _table$getLeftHeaderG2;
                return (_table$getLeftHeaderG = (_table$getLeftHeaderG2 = table.getLeftHeaderGroups()[0]) == null ? void 0 : _table$getLeftHeaderG2.headers.reduce((sum, header)=>{
                    return sum + header.getSize();
                }, 0)) != null ? _table$getLeftHeaderG : 0;
            },
            getCenterTotalSize: ()=>{
                var _table$getCenterHeade, _table$getCenterHeade2;
                return (_table$getCenterHeade = (_table$getCenterHeade2 = table.getCenterHeaderGroups()[0]) == null ? void 0 : _table$getCenterHeade2.headers.reduce((sum, header)=>{
                    return sum + header.getSize();
                }, 0)) != null ? _table$getCenterHeade : 0;
            },
            getRightTotalSize: ()=>{
                var _table$getRightHeader, _table$getRightHeader2;
                return (_table$getRightHeader = (_table$getRightHeader2 = table.getRightHeaderGroups()[0]) == null ? void 0 : _table$getRightHeader2.headers.reduce((sum, header)=>{
                    return sum + header.getSize();
                }, 0)) != null ? _table$getRightHeader : 0;
            }
        };
    }
};
let $93a274dd46b4c3ff$var$passiveSupported = null;
function $93a274dd46b4c3ff$export$4927b5943c7c0b4() {
    if (typeof $93a274dd46b4c3ff$var$passiveSupported === "boolean") return $93a274dd46b4c3ff$var$passiveSupported;
    let supported = false;
    try {
        const options = {
            get passive () {
                supported = true;
                return false;
            }
        };
        const noop = ()=>{};
        window.addEventListener("test", noop, options);
        window.removeEventListener("test", noop);
    } catch (err) {
        supported = false;
    }
    $93a274dd46b4c3ff$var$passiveSupported = supported;
    return $93a274dd46b4c3ff$var$passiveSupported;
}
function $93a274dd46b4c3ff$var$isTouchStartEvent(e) {
    return e.type === "touchstart";
}
//
const $93a274dd46b4c3ff$export$c9bad30efcce6e0c = {
    getInitialState: (state)=>{
        return {
            expanded: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onExpandedChange: $93a274dd46b4c3ff$export$2b5605d8069324bd("expanded", table),
            paginateExpandedRows: true
        };
    },
    createTable: (table)=>{
        let registered = false;
        let queued = false;
        return {
            _autoResetExpanded: ()=>{
                var _ref, _table$options$autoRe;
                if (!registered) {
                    table._queue(()=>{
                        registered = true;
                    });
                    return;
                }
                if ((_ref = (_table$options$autoRe = table.options.autoResetAll) != null ? _table$options$autoRe : table.options.autoResetExpanded) != null ? _ref : !table.options.manualExpanding) {
                    if (queued) return;
                    queued = true;
                    table._queue(()=>{
                        table.resetExpanded();
                        queued = false;
                    });
                }
            },
            setExpanded: (updater)=>table.options.onExpandedChange == null ? void 0 : table.options.onExpandedChange(updater),
            toggleAllRowsExpanded: (expanded)=>{
                if (expanded != null ? expanded : !table.getIsAllRowsExpanded()) table.setExpanded(true);
                else table.setExpanded({});
            },
            resetExpanded: (defaultState)=>{
                var _table$initialState$e, _table$initialState;
                table.setExpanded(defaultState ? {} : (_table$initialState$e = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.expanded) != null ? _table$initialState$e : {});
            },
            getCanSomeRowsExpand: ()=>{
                return table.getPrePaginationRowModel().flatRows.some((row)=>row.getCanExpand());
            },
            getToggleAllRowsExpandedHandler: ()=>{
                return (e)=>{
                    e.persist == null || e.persist();
                    table.toggleAllRowsExpanded();
                };
            },
            getIsSomeRowsExpanded: ()=>{
                const expanded = table.getState().expanded;
                return expanded === true || Object.values(expanded).some(Boolean);
            },
            getIsAllRowsExpanded: ()=>{
                const expanded = table.getState().expanded;
                // If expanded is true, save some cycles and return true
                if (typeof expanded === "boolean") return expanded === true;
                if (!Object.keys(expanded).length) return false;
                // If any row is not expanded, return false
                if (table.getRowModel().flatRows.some((row)=>!row.getIsExpanded())) return false;
                // They must all be expanded :shrug:
                return true;
            },
            getExpandedDepth: ()=>{
                let maxDepth = 0;
                const rowIds = table.getState().expanded === true ? Object.keys(table.getRowModel().rowsById) : Object.keys(table.getState().expanded);
                rowIds.forEach((id)=>{
                    const splitId = id.split(".");
                    maxDepth = Math.max(maxDepth, splitId.length);
                });
                return maxDepth;
            },
            getPreExpandedRowModel: ()=>table.getSortedRowModel(),
            getExpandedRowModel: ()=>{
                if (!table._getExpandedRowModel && table.options.getExpandedRowModel) table._getExpandedRowModel = table.options.getExpandedRowModel(table);
                if (table.options.manualExpanding || !table._getExpandedRowModel) return table.getPreExpandedRowModel();
                return table._getExpandedRowModel();
            }
        };
    },
    createRow: (row, table)=>{
        return {
            toggleExpanded: (expanded)=>{
                table.setExpanded((old)=>{
                    var _expanded;
                    const exists = old === true ? true : !!(old != null && old[row.id]);
                    let oldExpanded = {};
                    if (old === true) Object.keys(table.getRowModel().rowsById).forEach((rowId)=>{
                        oldExpanded[rowId] = true;
                    });
                    else oldExpanded = old;
                    expanded = (_expanded = expanded) != null ? _expanded : !exists;
                    if (!exists && expanded) return {
                        ...oldExpanded,
                        [row.id]: true
                    };
                    if (exists && !expanded) {
                        const { [row.id]: _, ...rest } = oldExpanded;
                        return rest;
                    }
                    return old;
                });
            },
            getIsExpanded: ()=>{
                var _table$options$getIsR;
                const expanded = table.getState().expanded;
                return !!((_table$options$getIsR = table.options.getIsRowExpanded == null ? void 0 : table.options.getIsRowExpanded(row)) != null ? _table$options$getIsR : expanded === true || (expanded == null ? void 0 : expanded[row.id]));
            },
            getCanExpand: ()=>{
                var _table$options$getRow, _table$options$enable, _row$subRows;
                return (_table$options$getRow = table.options.getRowCanExpand == null ? void 0 : table.options.getRowCanExpand(row)) != null ? _table$options$getRow : ((_table$options$enable = table.options.enableExpanding) != null ? _table$options$enable : true) && !!((_row$subRows = row.subRows) != null && _row$subRows.length);
            },
            getToggleExpandedHandler: ()=>{
                const canExpand = row.getCanExpand();
                return ()=>{
                    if (!canExpand) return;
                    row.toggleExpanded();
                };
            }
        };
    }
};
const $93a274dd46b4c3ff$var$includesString = (row, columnId, filterValue)=>{
    var _row$getValue, _row$getValue$toStrin, _row$getValue$toStrin2;
    const search = filterValue.toLowerCase();
    return Boolean((_row$getValue = row.getValue(columnId)) == null ? void 0 : (_row$getValue$toStrin = _row$getValue.toString()) == null ? void 0 : (_row$getValue$toStrin2 = _row$getValue$toStrin.toLowerCase()) == null ? void 0 : _row$getValue$toStrin2.includes(search));
};
$93a274dd46b4c3ff$var$includesString.autoRemove = (val)=>$93a274dd46b4c3ff$var$testFalsey(val);
const $93a274dd46b4c3ff$var$includesStringSensitive = (row, columnId, filterValue)=>{
    var _row$getValue2, _row$getValue2$toStri;
    return Boolean((_row$getValue2 = row.getValue(columnId)) == null ? void 0 : (_row$getValue2$toStri = _row$getValue2.toString()) == null ? void 0 : _row$getValue2$toStri.includes(filterValue));
};
$93a274dd46b4c3ff$var$includesStringSensitive.autoRemove = (val)=>$93a274dd46b4c3ff$var$testFalsey(val);
const $93a274dd46b4c3ff$var$equalsString = (row, columnId, filterValue)=>{
    var _row$getValue3, _row$getValue3$toStri;
    return ((_row$getValue3 = row.getValue(columnId)) == null ? void 0 : (_row$getValue3$toStri = _row$getValue3.toString()) == null ? void 0 : _row$getValue3$toStri.toLowerCase()) === (filterValue == null ? void 0 : filterValue.toLowerCase());
};
$93a274dd46b4c3ff$var$equalsString.autoRemove = (val)=>$93a274dd46b4c3ff$var$testFalsey(val);
const $93a274dd46b4c3ff$var$arrIncludes = (row, columnId, filterValue)=>{
    var _row$getValue4;
    return (_row$getValue4 = row.getValue(columnId)) == null ? void 0 : _row$getValue4.includes(filterValue);
};
$93a274dd46b4c3ff$var$arrIncludes.autoRemove = (val)=>$93a274dd46b4c3ff$var$testFalsey(val) || !(val != null && val.length);
const $93a274dd46b4c3ff$var$arrIncludesAll = (row, columnId, filterValue)=>{
    return !filterValue.some((val)=>{
        var _row$getValue5;
        return !((_row$getValue5 = row.getValue(columnId)) != null && _row$getValue5.includes(val));
    });
};
$93a274dd46b4c3ff$var$arrIncludesAll.autoRemove = (val)=>$93a274dd46b4c3ff$var$testFalsey(val) || !(val != null && val.length);
const $93a274dd46b4c3ff$var$arrIncludesSome = (row, columnId, filterValue)=>{
    return filterValue.some((val)=>{
        var _row$getValue6;
        return (_row$getValue6 = row.getValue(columnId)) == null ? void 0 : _row$getValue6.includes(val);
    });
};
$93a274dd46b4c3ff$var$arrIncludesSome.autoRemove = (val)=>$93a274dd46b4c3ff$var$testFalsey(val) || !(val != null && val.length);
const $93a274dd46b4c3ff$var$equals = (row, columnId, filterValue)=>{
    return row.getValue(columnId) === filterValue;
};
$93a274dd46b4c3ff$var$equals.autoRemove = (val)=>$93a274dd46b4c3ff$var$testFalsey(val);
const $93a274dd46b4c3ff$var$weakEquals = (row, columnId, filterValue)=>{
    return row.getValue(columnId) == filterValue;
};
$93a274dd46b4c3ff$var$weakEquals.autoRemove = (val)=>$93a274dd46b4c3ff$var$testFalsey(val);
const $93a274dd46b4c3ff$var$inNumberRange = (row, columnId, filterValue)=>{
    let [min, max] = filterValue;
    const rowValue = row.getValue(columnId);
    return rowValue >= min && rowValue <= max;
};
$93a274dd46b4c3ff$var$inNumberRange.resolveFilterValue = (val)=>{
    let [unsafeMin, unsafeMax] = val;
    let parsedMin = typeof unsafeMin !== "number" ? parseFloat(unsafeMin) : unsafeMin;
    let parsedMax = typeof unsafeMax !== "number" ? parseFloat(unsafeMax) : unsafeMax;
    let min = unsafeMin === null || Number.isNaN(parsedMin) ? -Infinity : parsedMin;
    let max = unsafeMax === null || Number.isNaN(parsedMax) ? Infinity : parsedMax;
    if (min > max) {
        const temp = min;
        min = max;
        max = temp;
    }
    return [
        min,
        max
    ];
};
$93a274dd46b4c3ff$var$inNumberRange.autoRemove = (val)=>$93a274dd46b4c3ff$var$testFalsey(val) || $93a274dd46b4c3ff$var$testFalsey(val[0]) && $93a274dd46b4c3ff$var$testFalsey(val[1]);
// Export
const $93a274dd46b4c3ff$export$6ad8312e296ec316 = {
    includesString: $93a274dd46b4c3ff$var$includesString,
    includesStringSensitive: $93a274dd46b4c3ff$var$includesStringSensitive,
    equalsString: $93a274dd46b4c3ff$var$equalsString,
    arrIncludes: $93a274dd46b4c3ff$var$arrIncludes,
    arrIncludesAll: $93a274dd46b4c3ff$var$arrIncludesAll,
    arrIncludesSome: $93a274dd46b4c3ff$var$arrIncludesSome,
    equals: $93a274dd46b4c3ff$var$equals,
    weakEquals: $93a274dd46b4c3ff$var$weakEquals,
    inNumberRange: $93a274dd46b4c3ff$var$inNumberRange
};
// Utils
function $93a274dd46b4c3ff$var$testFalsey(val) {
    return val === undefined || val === null || val === "";
}
//
const $93a274dd46b4c3ff$export$92a576f896a9bf72 = {
    getDefaultColumnDef: ()=>{
        return {
            filterFn: "auto"
        };
    },
    getInitialState: (state)=>{
        return {
            columnFilters: [],
            globalFilter: undefined,
            // filtersProgress: 1,
            // facetProgress: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnFiltersChange: $93a274dd46b4c3ff$export$2b5605d8069324bd("columnFilters", table),
            onGlobalFilterChange: $93a274dd46b4c3ff$export$2b5605d8069324bd("globalFilter", table),
            filterFromLeafRows: false,
            maxLeafRowFilterDepth: 100,
            globalFilterFn: "auto",
            getColumnCanGlobalFilter: (column)=>{
                var _table$getCoreRowMode, _table$getCoreRowMode2;
                const value = (_table$getCoreRowMode = table.getCoreRowModel().flatRows[0]) == null ? void 0 : (_table$getCoreRowMode2 = _table$getCoreRowMode._getAllCellsByColumnId()[column.id]) == null ? void 0 : _table$getCoreRowMode2.getValue();
                return typeof value === "string" || typeof value === "number";
            }
        };
    },
    createColumn: (column, table)=>{
        return {
            getAutoFilterFn: ()=>{
                const firstRow = table.getCoreRowModel().flatRows[0];
                const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
                if (typeof value === "string") return $93a274dd46b4c3ff$export$6ad8312e296ec316.includesString;
                if (typeof value === "number") return $93a274dd46b4c3ff$export$6ad8312e296ec316.inNumberRange;
                if (typeof value === "boolean") return $93a274dd46b4c3ff$export$6ad8312e296ec316.equals;
                if (value !== null && typeof value === "object") return $93a274dd46b4c3ff$export$6ad8312e296ec316.equals;
                if (Array.isArray(value)) return $93a274dd46b4c3ff$export$6ad8312e296ec316.arrIncludes;
                return $93a274dd46b4c3ff$export$6ad8312e296ec316.weakEquals;
            },
            getFilterFn: ()=>{
                var _table$options$filter, _table$options$filter2;
                return $93a274dd46b4c3ff$export$f6e2535fb5126e54(column.columnDef.filterFn) ? column.columnDef.filterFn : column.columnDef.filterFn === "auto" ? column.getAutoFilterFn() : (_table$options$filter = (_table$options$filter2 = table.options.filterFns) == null ? void 0 : _table$options$filter2[column.columnDef.filterFn]) != null ? _table$options$filter : $93a274dd46b4c3ff$export$6ad8312e296ec316[column.columnDef.filterFn];
            },
            getCanFilter: ()=>{
                var _column$columnDef$ena, _table$options$enable, _table$options$enable2;
                return ((_column$columnDef$ena = column.columnDef.enableColumnFilter) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableColumnFilters) != null ? _table$options$enable : true) && ((_table$options$enable2 = table.options.enableFilters) != null ? _table$options$enable2 : true) && !!column.accessorFn;
            },
            getCanGlobalFilter: ()=>{
                var _column$columnDef$ena2, _table$options$enable3, _table$options$enable4, _table$options$getCol;
                return ((_column$columnDef$ena2 = column.columnDef.enableGlobalFilter) != null ? _column$columnDef$ena2 : true) && ((_table$options$enable3 = table.options.enableGlobalFilter) != null ? _table$options$enable3 : true) && ((_table$options$enable4 = table.options.enableFilters) != null ? _table$options$enable4 : true) && ((_table$options$getCol = table.options.getColumnCanGlobalFilter == null ? void 0 : table.options.getColumnCanGlobalFilter(column)) != null ? _table$options$getCol : true) && !!column.accessorFn;
            },
            getIsFiltered: ()=>column.getFilterIndex() > -1,
            getFilterValue: ()=>{
                var _table$getState$colum, _table$getState$colum2;
                return (_table$getState$colum = table.getState().columnFilters) == null ? void 0 : (_table$getState$colum2 = _table$getState$colum.find((d)=>d.id === column.id)) == null ? void 0 : _table$getState$colum2.value;
            },
            getFilterIndex: ()=>{
                var _table$getState$colum3, _table$getState$colum4;
                return (_table$getState$colum3 = (_table$getState$colum4 = table.getState().columnFilters) == null ? void 0 : _table$getState$colum4.findIndex((d)=>d.id === column.id)) != null ? _table$getState$colum3 : -1;
            },
            setFilterValue: (value)=>{
                table.setColumnFilters((old)=>{
                    const filterFn = column.getFilterFn();
                    const previousfilter = old == null ? void 0 : old.find((d)=>d.id === column.id);
                    const newFilter = $93a274dd46b4c3ff$export$7f095f455ad5af3f(value, previousfilter ? previousfilter.value : undefined);
                    //
                    if ($93a274dd46b4c3ff$export$5b01eb94d7ce58a8(filterFn, newFilter, column)) {
                        var _old$filter;
                        return (_old$filter = old == null ? void 0 : old.filter((d)=>d.id !== column.id)) != null ? _old$filter : [];
                    }
                    const newFilterObj = {
                        id: column.id,
                        value: newFilter
                    };
                    if (previousfilter) {
                        var _old$map;
                        return (_old$map = old == null ? void 0 : old.map((d)=>{
                            if (d.id === column.id) return newFilterObj;
                            return d;
                        })) != null ? _old$map : [];
                    }
                    if (old != null && old.length) return [
                        ...old,
                        newFilterObj
                    ];
                    return [
                        newFilterObj
                    ];
                });
            },
            _getFacetedRowModel: table.options.getFacetedRowModel && table.options.getFacetedRowModel(table, column.id),
            getFacetedRowModel: ()=>{
                if (!column._getFacetedRowModel) return table.getPreFilteredRowModel();
                return column._getFacetedRowModel();
            },
            _getFacetedUniqueValues: table.options.getFacetedUniqueValues && table.options.getFacetedUniqueValues(table, column.id),
            getFacetedUniqueValues: ()=>{
                if (!column._getFacetedUniqueValues) return new Map();
                return column._getFacetedUniqueValues();
            },
            _getFacetedMinMaxValues: table.options.getFacetedMinMaxValues && table.options.getFacetedMinMaxValues(table, column.id),
            getFacetedMinMaxValues: ()=>{
                if (!column._getFacetedMinMaxValues) return undefined;
                return column._getFacetedMinMaxValues();
            }
        };
    },
    createRow: (row, table)=>{
        return {
            columnFilters: {},
            columnFiltersMeta: {}
        };
    },
    createTable: (table)=>{
        return {
            getGlobalAutoFilterFn: ()=>{
                return $93a274dd46b4c3ff$export$6ad8312e296ec316.includesString;
            },
            getGlobalFilterFn: ()=>{
                var _table$options$filter3, _table$options$filter4;
                const { globalFilterFn: globalFilterFn } = table.options;
                return $93a274dd46b4c3ff$export$f6e2535fb5126e54(globalFilterFn) ? globalFilterFn : globalFilterFn === "auto" ? table.getGlobalAutoFilterFn() : (_table$options$filter3 = (_table$options$filter4 = table.options.filterFns) == null ? void 0 : _table$options$filter4[globalFilterFn]) != null ? _table$options$filter3 : $93a274dd46b4c3ff$export$6ad8312e296ec316[globalFilterFn];
            },
            setColumnFilters: (updater)=>{
                const leafColumns = table.getAllLeafColumns();
                const updateFn = (old)=>{
                    var _functionalUpdate;
                    return (_functionalUpdate = $93a274dd46b4c3ff$export$7f095f455ad5af3f(updater, old)) == null ? void 0 : _functionalUpdate.filter((filter)=>{
                        const column = leafColumns.find((d)=>d.id === filter.id);
                        if (column) {
                            const filterFn = column.getFilterFn();
                            if ($93a274dd46b4c3ff$export$5b01eb94d7ce58a8(filterFn, filter.value, column)) return false;
                        }
                        return true;
                    });
                };
                table.options.onColumnFiltersChange == null || table.options.onColumnFiltersChange(updateFn);
            },
            setGlobalFilter: (updater)=>{
                table.options.onGlobalFilterChange == null || table.options.onGlobalFilterChange(updater);
            },
            resetGlobalFilter: (defaultState)=>{
                table.setGlobalFilter(defaultState ? undefined : table.initialState.globalFilter);
            },
            resetColumnFilters: (defaultState)=>{
                var _table$initialState$c, _table$initialState;
                table.setColumnFilters(defaultState ? [] : (_table$initialState$c = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.columnFilters) != null ? _table$initialState$c : []);
            },
            getPreFilteredRowModel: ()=>table.getCoreRowModel(),
            getFilteredRowModel: ()=>{
                if (!table._getFilteredRowModel && table.options.getFilteredRowModel) table._getFilteredRowModel = table.options.getFilteredRowModel(table);
                if (table.options.manualFiltering || !table._getFilteredRowModel) return table.getPreFilteredRowModel();
                return table._getFilteredRowModel();
            },
            _getGlobalFacetedRowModel: table.options.getFacetedRowModel && table.options.getFacetedRowModel(table, "__global__"),
            getGlobalFacetedRowModel: ()=>{
                if (table.options.manualFiltering || !table._getGlobalFacetedRowModel) return table.getPreFilteredRowModel();
                return table._getGlobalFacetedRowModel();
            },
            _getGlobalFacetedUniqueValues: table.options.getFacetedUniqueValues && table.options.getFacetedUniqueValues(table, "__global__"),
            getGlobalFacetedUniqueValues: ()=>{
                if (!table._getGlobalFacetedUniqueValues) return new Map();
                return table._getGlobalFacetedUniqueValues();
            },
            _getGlobalFacetedMinMaxValues: table.options.getFacetedMinMaxValues && table.options.getFacetedMinMaxValues(table, "__global__"),
            getGlobalFacetedMinMaxValues: ()=>{
                if (!table._getGlobalFacetedMinMaxValues) return;
                return table._getGlobalFacetedMinMaxValues();
            }
        };
    }
};
function $93a274dd46b4c3ff$export$5b01eb94d7ce58a8(filterFn, value, column) {
    return (filterFn && filterFn.autoRemove ? filterFn.autoRemove(value, column) : false) || typeof value === "undefined" || typeof value === "string" && !value;
}
const $93a274dd46b4c3ff$var$sum = (columnId, _leafRows, childRows)=>{
    // It's faster to just add the aggregations together instead of
    // process leaf nodes individually
    return childRows.reduce((sum, next)=>{
        const nextValue = next.getValue(columnId);
        return sum + (typeof nextValue === "number" ? nextValue : 0);
    }, 0);
};
const $93a274dd46b4c3ff$var$min = (columnId, _leafRows, childRows)=>{
    let min;
    childRows.forEach((row)=>{
        const value = row.getValue(columnId);
        if (value != null && (min > value || min === undefined && value >= value)) min = value;
    });
    return min;
};
const $93a274dd46b4c3ff$var$max = (columnId, _leafRows, childRows)=>{
    let max;
    childRows.forEach((row)=>{
        const value = row.getValue(columnId);
        if (value != null && (max < value || max === undefined && value >= value)) max = value;
    });
    return max;
};
const $93a274dd46b4c3ff$var$extent = (columnId, _leafRows, childRows)=>{
    let min;
    let max;
    childRows.forEach((row)=>{
        const value = row.getValue(columnId);
        if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    });
    return [
        min,
        max
    ];
};
const $93a274dd46b4c3ff$var$mean = (columnId, leafRows)=>{
    let count = 0;
    let sum = 0;
    leafRows.forEach((row)=>{
        let value = row.getValue(columnId);
        if (value != null && (value = +value) >= value) ++count, sum += value;
    });
    if (count) return sum / count;
    return;
};
const $93a274dd46b4c3ff$var$median = (columnId, leafRows)=>{
    if (!leafRows.length) return;
    const values = leafRows.map((row)=>row.getValue(columnId));
    if (!$93a274dd46b4c3ff$export$5cd576d1827d40c8(values)) return;
    if (values.length === 1) return values[0];
    const mid = Math.floor(values.length / 2);
    const nums = values.sort((a, b)=>a - b);
    return values.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
};
const $93a274dd46b4c3ff$var$unique = (columnId, leafRows)=>{
    return Array.from(new Set(leafRows.map((d)=>d.getValue(columnId))).values());
};
const $93a274dd46b4c3ff$var$uniqueCount = (columnId, leafRows)=>{
    return new Set(leafRows.map((d)=>d.getValue(columnId))).size;
};
const $93a274dd46b4c3ff$var$count = (_columnId, leafRows)=>{
    return leafRows.length;
};
const $93a274dd46b4c3ff$export$3aa4339120b8b25b = {
    sum: $93a274dd46b4c3ff$var$sum,
    min: $93a274dd46b4c3ff$var$min,
    max: $93a274dd46b4c3ff$var$max,
    extent: $93a274dd46b4c3ff$var$extent,
    mean: $93a274dd46b4c3ff$var$mean,
    median: $93a274dd46b4c3ff$var$median,
    unique: $93a274dd46b4c3ff$var$unique,
    uniqueCount: $93a274dd46b4c3ff$var$uniqueCount,
    count: $93a274dd46b4c3ff$var$count
};
//
const $93a274dd46b4c3ff$export$3885c0af90651e94 = {
    getDefaultColumnDef: ()=>{
        return {
            aggregatedCell: (props)=>{
                var _toString, _props$getValue;
                return (_toString = (_props$getValue = props.getValue()) == null ? void 0 : _props$getValue.toString == null ? void 0 : _props$getValue.toString()) != null ? _toString : null;
            },
            aggregationFn: "auto"
        };
    },
    getInitialState: (state)=>{
        return {
            grouping: [],
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onGroupingChange: $93a274dd46b4c3ff$export$2b5605d8069324bd("grouping", table),
            groupedColumnMode: "reorder"
        };
    },
    createColumn: (column, table)=>{
        return {
            toggleGrouping: ()=>{
                table.setGrouping((old)=>{
                    // Find any existing grouping for this column
                    if (old != null && old.includes(column.id)) return old.filter((d)=>d !== column.id);
                    return [
                        ...old != null ? old : [],
                        column.id
                    ];
                });
            },
            getCanGroup: ()=>{
                var _ref, _ref2, _ref3, _column$columnDef$ena;
                return (_ref = (_ref2 = (_ref3 = (_column$columnDef$ena = column.columnDef.enableGrouping) != null ? _column$columnDef$ena : true) != null ? _ref3 : table.options.enableGrouping) != null ? _ref2 : true) != null ? _ref : !!column.accessorFn;
            },
            getIsGrouped: ()=>{
                var _table$getState$group;
                return (_table$getState$group = table.getState().grouping) == null ? void 0 : _table$getState$group.includes(column.id);
            },
            getGroupedIndex: ()=>{
                var _table$getState$group2;
                return (_table$getState$group2 = table.getState().grouping) == null ? void 0 : _table$getState$group2.indexOf(column.id);
            },
            getToggleGroupingHandler: ()=>{
                const canGroup = column.getCanGroup();
                return ()=>{
                    if (!canGroup) return;
                    column.toggleGrouping();
                };
            },
            getAutoAggregationFn: ()=>{
                const firstRow = table.getCoreRowModel().flatRows[0];
                const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
                if (typeof value === "number") return $93a274dd46b4c3ff$export$3aa4339120b8b25b.sum;
                if (Object.prototype.toString.call(value) === "[object Date]") return $93a274dd46b4c3ff$export$3aa4339120b8b25b.extent;
            },
            getAggregationFn: ()=>{
                var _table$options$aggreg, _table$options$aggreg2;
                if (!column) throw new Error();
                return $93a274dd46b4c3ff$export$f6e2535fb5126e54(column.columnDef.aggregationFn) ? column.columnDef.aggregationFn : column.columnDef.aggregationFn === "auto" ? column.getAutoAggregationFn() : (_table$options$aggreg = (_table$options$aggreg2 = table.options.aggregationFns) == null ? void 0 : _table$options$aggreg2[column.columnDef.aggregationFn]) != null ? _table$options$aggreg : $93a274dd46b4c3ff$export$3aa4339120b8b25b[column.columnDef.aggregationFn];
            }
        };
    },
    createTable: (table)=>{
        return {
            setGrouping: (updater)=>table.options.onGroupingChange == null ? void 0 : table.options.onGroupingChange(updater),
            resetGrouping: (defaultState)=>{
                var _table$initialState$g, _table$initialState;
                table.setGrouping(defaultState ? [] : (_table$initialState$g = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.grouping) != null ? _table$initialState$g : []);
            },
            getPreGroupedRowModel: ()=>table.getFilteredRowModel(),
            getGroupedRowModel: ()=>{
                if (!table._getGroupedRowModel && table.options.getGroupedRowModel) table._getGroupedRowModel = table.options.getGroupedRowModel(table);
                if (table.options.manualGrouping || !table._getGroupedRowModel) return table.getPreGroupedRowModel();
                return table._getGroupedRowModel();
            }
        };
    },
    createRow: (row, table)=>{
        return {
            getIsGrouped: ()=>!!row.groupingColumnId,
            getGroupingValue: (columnId)=>{
                if (row._groupingValuesCache.hasOwnProperty(columnId)) return row._groupingValuesCache[columnId];
                const column = table.getColumn(columnId);
                if (!(column != null && column.columnDef.getGroupingValue)) return row.getValue(columnId);
                row._groupingValuesCache[columnId] = column.columnDef.getGroupingValue(row.original);
                return row._groupingValuesCache[columnId];
            },
            _groupingValuesCache: {}
        };
    },
    createCell: (cell, column, row, table)=>{
        return {
            getIsGrouped: ()=>column.getIsGrouped() && column.id === row.groupingColumnId,
            getIsPlaceholder: ()=>!cell.getIsGrouped() && column.getIsGrouped(),
            getIsAggregated: ()=>{
                var _row$subRows;
                return !cell.getIsGrouped() && !cell.getIsPlaceholder() && !!((_row$subRows = row.subRows) != null && _row$subRows.length);
            }
        };
    }
};
function $93a274dd46b4c3ff$export$ac763d2b0470e663(leafColumns, grouping, groupedColumnMode) {
    if (!(grouping != null && grouping.length) || !groupedColumnMode) return leafColumns;
    const nonGroupingColumns = leafColumns.filter((col)=>!grouping.includes(col.id));
    if (groupedColumnMode === "remove") return nonGroupingColumns;
    const groupingColumns = grouping.map((g)=>leafColumns.find((col)=>col.id === g)).filter(Boolean);
    return [
        ...groupingColumns,
        ...nonGroupingColumns
    ];
}
//
const $93a274dd46b4c3ff$export$549aff5da5ccfd97 = {
    getInitialState: (state)=>{
        return {
            columnOrder: [],
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnOrderChange: $93a274dd46b4c3ff$export$2b5605d8069324bd("columnOrder", table)
        };
    },
    createTable: (table)=>{
        return {
            setColumnOrder: (updater)=>table.options.onColumnOrderChange == null ? void 0 : table.options.onColumnOrderChange(updater),
            resetColumnOrder: (defaultState)=>{
                var _table$initialState$c;
                table.setColumnOrder(defaultState ? [] : (_table$initialState$c = table.initialState.columnOrder) != null ? _table$initialState$c : []);
            },
            _getOrderColumnsFn: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                    table.getState().columnOrder,
                    table.getState().grouping,
                    table.options.groupedColumnMode
                ], (columnOrder, grouping, groupedColumnMode)=>(columns)=>{
                    // Sort grouped columns to the start of the column list
                    // before the headers are built
                    let orderedColumns = [];
                    // If there is no order, return the normal columns
                    if (!(columnOrder != null && columnOrder.length)) orderedColumns = columns;
                    else {
                        const columnOrderCopy = [
                            ...columnOrder
                        ];
                        // If there is an order, make a copy of the columns
                        const columnsCopy = [
                            ...columns
                        ];
                        // And make a new ordered array of the columns
                        // Loop over the columns and place them in order into the new array
                        while(columnsCopy.length && columnOrderCopy.length){
                            const targetColumnId = columnOrderCopy.shift();
                            const foundIndex = columnsCopy.findIndex((d)=>d.id === targetColumnId);
                            if (foundIndex > -1) orderedColumns.push(columnsCopy.splice(foundIndex, 1)[0]);
                        }
                        // If there are any columns left, add them to the end
                        orderedColumns = [
                            ...orderedColumns,
                            ...columnsCopy
                        ];
                    }
                    return $93a274dd46b4c3ff$export$ac763d2b0470e663(orderedColumns, grouping, groupedColumnMode);
                }, {
                key: false
            })
        };
    }
};
//
const $93a274dd46b4c3ff$var$defaultPageIndex = 0;
const $93a274dd46b4c3ff$var$defaultPageSize = 10;
const $93a274dd46b4c3ff$var$getDefaultPaginationState = ()=>({
        pageIndex: $93a274dd46b4c3ff$var$defaultPageIndex,
        pageSize: $93a274dd46b4c3ff$var$defaultPageSize
    });
const $93a274dd46b4c3ff$export$68f5e1453c188a82 = {
    getInitialState: (state)=>{
        return {
            ...state,
            pagination: {
                ...$93a274dd46b4c3ff$var$getDefaultPaginationState(),
                ...state == null ? void 0 : state.pagination
            }
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onPaginationChange: $93a274dd46b4c3ff$export$2b5605d8069324bd("pagination", table)
        };
    },
    createTable: (table)=>{
        let registered = false;
        let queued = false;
        return {
            _autoResetPageIndex: ()=>{
                var _ref, _table$options$autoRe;
                if (!registered) {
                    table._queue(()=>{
                        registered = true;
                    });
                    return;
                }
                if ((_ref = (_table$options$autoRe = table.options.autoResetAll) != null ? _table$options$autoRe : table.options.autoResetPageIndex) != null ? _ref : !table.options.manualPagination) {
                    if (queued) return;
                    queued = true;
                    table._queue(()=>{
                        table.resetPageIndex();
                        queued = false;
                    });
                }
            },
            setPagination: (updater)=>{
                const safeUpdater = (old)=>{
                    let newState = $93a274dd46b4c3ff$export$7f095f455ad5af3f(updater, old);
                    return newState;
                };
                return table.options.onPaginationChange == null ? void 0 : table.options.onPaginationChange(safeUpdater);
            },
            resetPagination: (defaultState)=>{
                var _table$initialState$p;
                table.setPagination(defaultState ? $93a274dd46b4c3ff$var$getDefaultPaginationState() : (_table$initialState$p = table.initialState.pagination) != null ? _table$initialState$p : $93a274dd46b4c3ff$var$getDefaultPaginationState());
            },
            setPageIndex: (updater)=>{
                table.setPagination((old)=>{
                    let pageIndex = $93a274dd46b4c3ff$export$7f095f455ad5af3f(updater, old.pageIndex);
                    const maxPageIndex = typeof table.options.pageCount === "undefined" || table.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : table.options.pageCount - 1;
                    pageIndex = Math.max(0, Math.min(pageIndex, maxPageIndex));
                    return {
                        ...old,
                        pageIndex: pageIndex
                    };
                });
            },
            resetPageIndex: (defaultState)=>{
                var _table$initialState$p2, _table$initialState, _table$initialState$p3;
                table.setPageIndex(defaultState ? $93a274dd46b4c3ff$var$defaultPageIndex : (_table$initialState$p2 = (_table$initialState = table.initialState) == null ? void 0 : (_table$initialState$p3 = _table$initialState.pagination) == null ? void 0 : _table$initialState$p3.pageIndex) != null ? _table$initialState$p2 : $93a274dd46b4c3ff$var$defaultPageIndex);
            },
            resetPageSize: (defaultState)=>{
                var _table$initialState$p4, _table$initialState2, _table$initialState2$;
                table.setPageSize(defaultState ? $93a274dd46b4c3ff$var$defaultPageSize : (_table$initialState$p4 = (_table$initialState2 = table.initialState) == null ? void 0 : (_table$initialState2$ = _table$initialState2.pagination) == null ? void 0 : _table$initialState2$.pageSize) != null ? _table$initialState$p4 : $93a274dd46b4c3ff$var$defaultPageSize);
            },
            setPageSize: (updater)=>{
                table.setPagination((old)=>{
                    const pageSize = Math.max(1, $93a274dd46b4c3ff$export$7f095f455ad5af3f(updater, old.pageSize));
                    const topRowIndex = old.pageSize * old.pageIndex;
                    const pageIndex = Math.floor(topRowIndex / pageSize);
                    return {
                        ...old,
                        pageIndex: pageIndex,
                        pageSize: pageSize
                    };
                });
            },
            setPageCount: (updater)=>table.setPagination((old)=>{
                    var _table$options$pageCo;
                    let newPageCount = $93a274dd46b4c3ff$export$7f095f455ad5af3f(updater, (_table$options$pageCo = table.options.pageCount) != null ? _table$options$pageCo : -1);
                    if (typeof newPageCount === "number") newPageCount = Math.max(-1, newPageCount);
                    return {
                        ...old,
                        pageCount: newPageCount
                    };
                }),
            getPageOptions: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                    table.getPageCount()
                ], (pageCount)=>{
                let pageOptions = [];
                if (pageCount && pageCount > 0) pageOptions = [
                    ...new Array(pageCount)
                ].fill(null).map((_, i)=>i);
                return pageOptions;
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA;
                    return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
                }
            }),
            getCanPreviousPage: ()=>table.getState().pagination.pageIndex > 0,
            getCanNextPage: ()=>{
                const { pageIndex: pageIndex } = table.getState().pagination;
                const pageCount = table.getPageCount();
                if (pageCount === -1) return true;
                if (pageCount === 0) return false;
                return pageIndex < pageCount - 1;
            },
            previousPage: ()=>{
                return table.setPageIndex((old)=>old - 1);
            },
            nextPage: ()=>{
                return table.setPageIndex((old)=>{
                    return old + 1;
                });
            },
            getPrePaginationRowModel: ()=>table.getExpandedRowModel(),
            getPaginationRowModel: ()=>{
                if (!table._getPaginationRowModel && table.options.getPaginationRowModel) table._getPaginationRowModel = table.options.getPaginationRowModel(table);
                if (table.options.manualPagination || !table._getPaginationRowModel) return table.getPrePaginationRowModel();
                return table._getPaginationRowModel();
            },
            getPageCount: ()=>{
                var _table$options$pageCo2;
                return (_table$options$pageCo2 = table.options.pageCount) != null ? _table$options$pageCo2 : Math.ceil(table.getPrePaginationRowModel().rows.length / table.getState().pagination.pageSize);
            }
        };
    }
};
//
const $93a274dd46b4c3ff$var$getDefaultPinningState = ()=>({
        left: [],
        right: []
    });
const $93a274dd46b4c3ff$export$5289f180505593b3 = {
    getInitialState: (state)=>{
        return {
            columnPinning: $93a274dd46b4c3ff$var$getDefaultPinningState(),
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnPinningChange: $93a274dd46b4c3ff$export$2b5605d8069324bd("columnPinning", table)
        };
    },
    createColumn: (column, table)=>{
        return {
            pin: (position)=>{
                const columnIds = column.getLeafColumns().map((d)=>d.id).filter(Boolean);
                table.setColumnPinning((old)=>{
                    var _old$left3, _old$right3;
                    if (position === "right") {
                        var _old$left, _old$right;
                        return {
                            left: ((_old$left = old == null ? void 0 : old.left) != null ? _old$left : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                            right: [
                                ...((_old$right = old == null ? void 0 : old.right) != null ? _old$right : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                                ...columnIds
                            ]
                        };
                    }
                    if (position === "left") {
                        var _old$left2, _old$right2;
                        return {
                            left: [
                                ...((_old$left2 = old == null ? void 0 : old.left) != null ? _old$left2 : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                                ...columnIds
                            ],
                            right: ((_old$right2 = old == null ? void 0 : old.right) != null ? _old$right2 : []).filter((d)=>!(columnIds != null && columnIds.includes(d)))
                        };
                    }
                    return {
                        left: ((_old$left3 = old == null ? void 0 : old.left) != null ? _old$left3 : []).filter((d)=>!(columnIds != null && columnIds.includes(d))),
                        right: ((_old$right3 = old == null ? void 0 : old.right) != null ? _old$right3 : []).filter((d)=>!(columnIds != null && columnIds.includes(d)))
                    };
                });
            },
            getCanPin: ()=>{
                const leafColumns = column.getLeafColumns();
                return leafColumns.some((d)=>{
                    var _d$columnDef$enablePi, _table$options$enable;
                    return ((_d$columnDef$enablePi = d.columnDef.enablePinning) != null ? _d$columnDef$enablePi : true) && ((_table$options$enable = table.options.enablePinning) != null ? _table$options$enable : true);
                });
            },
            getIsPinned: ()=>{
                const leafColumnIds = column.getLeafColumns().map((d)=>d.id);
                const { left: left, right: right } = table.getState().columnPinning;
                const isLeft = leafColumnIds.some((d)=>left == null ? void 0 : left.includes(d));
                const isRight = leafColumnIds.some((d)=>right == null ? void 0 : right.includes(d));
                return isLeft ? "left" : isRight ? "right" : false;
            },
            getPinnedIndex: ()=>{
                var _table$getState$colum, _table$getState$colum2, _table$getState$colum3;
                const position = column.getIsPinned();
                return position ? (_table$getState$colum = (_table$getState$colum2 = table.getState().columnPinning) == null ? void 0 : (_table$getState$colum3 = _table$getState$colum2[position]) == null ? void 0 : _table$getState$colum3.indexOf(column.id)) != null ? _table$getState$colum : -1 : 0;
            }
        };
    },
    createRow: (row, table)=>{
        return {
            getCenterVisibleCells: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                    row._getAllVisibleCells(),
                    table.getState().columnPinning.left,
                    table.getState().columnPinning.right
                ], (allCells, left, right)=>{
                const leftAndRight = [
                    ...left != null ? left : [],
                    ...right != null ? right : []
                ];
                return allCells.filter((d)=>!leftAndRight.includes(d.column.id));
            }, {
                key: "row.getCenterVisibleCells",
                debug: ()=>{
                    var _table$options$debugA;
                    return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugRows;
                }
            }),
            getLeftVisibleCells: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                    row._getAllVisibleCells(),
                    table.getState().columnPinning.left,
                    , 
                ], (allCells, left)=>{
                const cells = (left != null ? left : []).map((columnId)=>allCells.find((cell)=>cell.column.id === columnId)).filter(Boolean).map((d)=>({
                        ...d,
                        position: "left"
                    }));
                return cells;
            }, {
                key: "row.getLeftVisibleCells",
                debug: ()=>{
                    var _table$options$debugA2;
                    return (_table$options$debugA2 = table.options.debugAll) != null ? _table$options$debugA2 : table.options.debugRows;
                }
            }),
            getRightVisibleCells: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                    row._getAllVisibleCells(),
                    table.getState().columnPinning.right
                ], (allCells, right)=>{
                const cells = (right != null ? right : []).map((columnId)=>allCells.find((cell)=>cell.column.id === columnId)).filter(Boolean).map((d)=>({
                        ...d,
                        position: "right"
                    }));
                return cells;
            }, {
                key: "row.getRightVisibleCells",
                debug: ()=>{
                    var _table$options$debugA3;
                    return (_table$options$debugA3 = table.options.debugAll) != null ? _table$options$debugA3 : table.options.debugRows;
                }
            })
        };
    },
    createTable: (table)=>{
        return {
            setColumnPinning: (updater)=>table.options.onColumnPinningChange == null ? void 0 : table.options.onColumnPinningChange(updater),
            resetColumnPinning: (defaultState)=>{
                var _table$initialState$c, _table$initialState;
                return table.setColumnPinning(defaultState ? $93a274dd46b4c3ff$var$getDefaultPinningState() : (_table$initialState$c = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.columnPinning) != null ? _table$initialState$c : $93a274dd46b4c3ff$var$getDefaultPinningState());
            },
            getIsSomeColumnsPinned: (position)=>{
                var _pinningState$positio;
                const pinningState = table.getState().columnPinning;
                if (!position) {
                    var _pinningState$left, _pinningState$right;
                    return Boolean(((_pinningState$left = pinningState.left) == null ? void 0 : _pinningState$left.length) || ((_pinningState$right = pinningState.right) == null ? void 0 : _pinningState$right.length));
                }
                return Boolean((_pinningState$positio = pinningState[position]) == null ? void 0 : _pinningState$positio.length);
            },
            getLeftLeafColumns: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                    table.getAllLeafColumns(),
                    table.getState().columnPinning.left
                ], (allColumns, left)=>{
                return (left != null ? left : []).map((columnId)=>allColumns.find((column)=>column.id === columnId)).filter(Boolean);
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA4;
                    return (_table$options$debugA4 = table.options.debugAll) != null ? _table$options$debugA4 : table.options.debugColumns;
                }
            }),
            getRightLeafColumns: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                    table.getAllLeafColumns(),
                    table.getState().columnPinning.right
                ], (allColumns, right)=>{
                return (right != null ? right : []).map((columnId)=>allColumns.find((column)=>column.id === columnId)).filter(Boolean);
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA5;
                    return (_table$options$debugA5 = table.options.debugAll) != null ? _table$options$debugA5 : table.options.debugColumns;
                }
            }),
            getCenterLeafColumns: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                    table.getAllLeafColumns(),
                    table.getState().columnPinning.left,
                    table.getState().columnPinning.right
                ], (allColumns, left, right)=>{
                const leftAndRight = [
                    ...left != null ? left : [],
                    ...right != null ? right : []
                ];
                return allColumns.filter((d)=>!leftAndRight.includes(d.id));
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA6;
                    return (_table$options$debugA6 = table.options.debugAll) != null ? _table$options$debugA6 : table.options.debugColumns;
                }
            })
        };
    }
};
//
const $93a274dd46b4c3ff$export$e8905133e7bf3121 = {
    getInitialState: (state)=>{
        return {
            rowSelection: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onRowSelectionChange: $93a274dd46b4c3ff$export$2b5605d8069324bd("rowSelection", table),
            enableRowSelection: true,
            enableMultiRowSelection: true,
            enableSubRowSelection: true
        };
    },
    createTable: (table)=>{
        return {
            setRowSelection: (updater)=>table.options.onRowSelectionChange == null ? void 0 : table.options.onRowSelectionChange(updater),
            resetRowSelection: (defaultState)=>{
                var _table$initialState$r;
                return table.setRowSelection(defaultState ? {} : (_table$initialState$r = table.initialState.rowSelection) != null ? _table$initialState$r : {});
            },
            toggleAllRowsSelected: (value)=>{
                table.setRowSelection((old)=>{
                    value = typeof value !== "undefined" ? value : !table.getIsAllRowsSelected();
                    const rowSelection = {
                        ...old
                    };
                    const preGroupedFlatRows = table.getPreGroupedRowModel().flatRows;
                    // We don't use `mutateRowIsSelected` here for performance reasons.
                    // All of the rows are flat already, so it wouldn't be worth it
                    if (value) preGroupedFlatRows.forEach((row)=>{
                        if (!row.getCanSelect()) return;
                        rowSelection[row.id] = true;
                    });
                    else preGroupedFlatRows.forEach((row)=>{
                        delete rowSelection[row.id];
                    });
                    return rowSelection;
                });
            },
            toggleAllPageRowsSelected: (value)=>table.setRowSelection((old)=>{
                    const resolvedValue = typeof value !== "undefined" ? value : !table.getIsAllPageRowsSelected();
                    const rowSelection = {
                        ...old
                    };
                    table.getRowModel().rows.forEach((row)=>{
                        $93a274dd46b4c3ff$var$mutateRowIsSelected(rowSelection, row.id, resolvedValue, table);
                    });
                    return rowSelection;
                }),
            // addRowSelectionRange: rowId => {
            //   const {
            //     rows,
            //     rowsById,
            //     options: { selectGroupingRows, selectSubRows },
            //   } = table
            //   const findSelectedRow = (rows: Row[]) => {
            //     let found
            //     rows.find(d => {
            //       if (d.getIsSelected()) {
            //         found = d
            //         return true
            //       }
            //       const subFound = findSelectedRow(d.subRows || [])
            //       if (subFound) {
            //         found = subFound
            //         return true
            //       }
            //       return false
            //     })
            //     return found
            //   }
            //   const firstRow = findSelectedRow(rows) || rows[0]
            //   const lastRow = rowsById[rowId]
            //   let include = false
            //   const selectedRowIds = {}
            //   const addRow = (row: Row) => {
            //     mutateRowIsSelected(selectedRowIds, row.id, true, {
            //       rowsById,
            //       selectGroupingRows: selectGroupingRows!,
            //       selectSubRows: selectSubRows!,
            //     })
            //   }
            //   table.rows.forEach(row => {
            //     const isFirstRow = row.id === firstRow.id
            //     const isLastRow = row.id === lastRow.id
            //     if (isFirstRow || isLastRow) {
            //       if (!include) {
            //         include = true
            //       } else if (include) {
            //         addRow(row)
            //         include = false
            //       }
            //     }
            //     if (include) {
            //       addRow(row)
            //     }
            //   })
            //   table.setRowSelection(selectedRowIds)
            // },
            getPreSelectedRowModel: ()=>table.getCoreRowModel(),
            getSelectedRowModel: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                    table.getState().rowSelection,
                    table.getCoreRowModel()
                ], (rowSelection, rowModel)=>{
                if (!Object.keys(rowSelection).length) return {
                    rows: [],
                    flatRows: [],
                    rowsById: {}
                };
                return $93a274dd46b4c3ff$export$f150e72530556b0b(table, rowModel);
            }, {
                key: false,
                debug: ()=>{
                    var _table$options$debugA;
                    return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
                }
            }),
            getFilteredSelectedRowModel: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                    table.getState().rowSelection,
                    table.getFilteredRowModel()
                ], (rowSelection, rowModel)=>{
                if (!Object.keys(rowSelection).length) return {
                    rows: [],
                    flatRows: [],
                    rowsById: {}
                };
                return $93a274dd46b4c3ff$export$f150e72530556b0b(table, rowModel);
            }, {
                key: "getFilteredSelectedRowModel",
                debug: ()=>{
                    var _table$options$debugA2;
                    return (_table$options$debugA2 = table.options.debugAll) != null ? _table$options$debugA2 : table.options.debugTable;
                }
            }),
            getGroupedSelectedRowModel: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                    table.getState().rowSelection,
                    table.getSortedRowModel()
                ], (rowSelection, rowModel)=>{
                if (!Object.keys(rowSelection).length) return {
                    rows: [],
                    flatRows: [],
                    rowsById: {}
                };
                return $93a274dd46b4c3ff$export$f150e72530556b0b(table, rowModel);
            }, {
                key: "getGroupedSelectedRowModel",
                debug: ()=>{
                    var _table$options$debugA3;
                    return (_table$options$debugA3 = table.options.debugAll) != null ? _table$options$debugA3 : table.options.debugTable;
                }
            }),
            ///
            // getGroupingRowCanSelect: rowId => {
            //   const row = table.getRow(rowId)
            //   if (!row) {
            //     throw new Error()
            //   }
            //   if (typeof table.options.enableGroupingRowSelection === 'function') {
            //     return table.options.enableGroupingRowSelection(row)
            //   }
            //   return table.options.enableGroupingRowSelection ?? false
            // },
            getIsAllRowsSelected: ()=>{
                const preGroupedFlatRows = table.getFilteredRowModel().flatRows;
                const { rowSelection: rowSelection } = table.getState();
                let isAllRowsSelected = Boolean(preGroupedFlatRows.length && Object.keys(rowSelection).length);
                if (isAllRowsSelected) {
                    if (preGroupedFlatRows.some((row)=>row.getCanSelect() && !rowSelection[row.id])) isAllRowsSelected = false;
                }
                return isAllRowsSelected;
            },
            getIsAllPageRowsSelected: ()=>{
                const paginationFlatRows = table.getPaginationRowModel().flatRows.filter((row)=>row.getCanSelect());
                const { rowSelection: rowSelection } = table.getState();
                let isAllPageRowsSelected = !!paginationFlatRows.length;
                if (isAllPageRowsSelected && paginationFlatRows.some((row)=>!rowSelection[row.id])) isAllPageRowsSelected = false;
                return isAllPageRowsSelected;
            },
            getIsSomeRowsSelected: ()=>{
                var _table$getState$rowSe;
                const totalSelected = Object.keys((_table$getState$rowSe = table.getState().rowSelection) != null ? _table$getState$rowSe : {}).length;
                return totalSelected > 0 && totalSelected < table.getFilteredRowModel().flatRows.length;
            },
            getIsSomePageRowsSelected: ()=>{
                const paginationFlatRows = table.getPaginationRowModel().flatRows;
                return table.getIsAllPageRowsSelected() ? false : paginationFlatRows.filter((row)=>row.getCanSelect()).some((d)=>d.getIsSelected() || d.getIsSomeSelected());
            },
            getToggleAllRowsSelectedHandler: ()=>{
                return (e)=>{
                    table.toggleAllRowsSelected(e.target.checked);
                };
            },
            getToggleAllPageRowsSelectedHandler: ()=>{
                return (e)=>{
                    table.toggleAllPageRowsSelected(e.target.checked);
                };
            }
        };
    },
    createRow: (row, table)=>{
        return {
            toggleSelected: (value)=>{
                const isSelected = row.getIsSelected();
                table.setRowSelection((old)=>{
                    value = typeof value !== "undefined" ? value : !isSelected;
                    if (isSelected === value) return old;
                    const selectedRowIds = {
                        ...old
                    };
                    $93a274dd46b4c3ff$var$mutateRowIsSelected(selectedRowIds, row.id, value, table);
                    return selectedRowIds;
                });
            },
            getIsSelected: ()=>{
                const { rowSelection: rowSelection } = table.getState();
                return $93a274dd46b4c3ff$export$710e11cf672b86c(row, rowSelection);
            },
            getIsSomeSelected: ()=>{
                const { rowSelection: rowSelection } = table.getState();
                return $93a274dd46b4c3ff$export$8f4c46e5d7907334(row, rowSelection) === "some";
            },
            getIsAllSubRowsSelected: ()=>{
                const { rowSelection: rowSelection } = table.getState();
                return $93a274dd46b4c3ff$export$8f4c46e5d7907334(row, rowSelection) === "all";
            },
            getCanSelect: ()=>{
                var _table$options$enable;
                if (typeof table.options.enableRowSelection === "function") return table.options.enableRowSelection(row);
                return (_table$options$enable = table.options.enableRowSelection) != null ? _table$options$enable : true;
            },
            getCanSelectSubRows: ()=>{
                var _table$options$enable2;
                if (typeof table.options.enableSubRowSelection === "function") return table.options.enableSubRowSelection(row);
                return (_table$options$enable2 = table.options.enableSubRowSelection) != null ? _table$options$enable2 : true;
            },
            getCanMultiSelect: ()=>{
                var _table$options$enable3;
                if (typeof table.options.enableMultiRowSelection === "function") return table.options.enableMultiRowSelection(row);
                return (_table$options$enable3 = table.options.enableMultiRowSelection) != null ? _table$options$enable3 : true;
            },
            getToggleSelectedHandler: ()=>{
                const canSelect = row.getCanSelect();
                return (e)=>{
                    var _target;
                    if (!canSelect) return;
                    row.toggleSelected((_target = e.target) == null ? void 0 : _target.checked);
                };
            }
        };
    }
};
const $93a274dd46b4c3ff$var$mutateRowIsSelected = (selectedRowIds, id, value, table)=>{
    var _row$subRows;
    const row = table.getRow(id);
    // const isGrouped = row.getIsGrouped()
    // if ( // TODO: enforce grouping row selection rules
    //   !isGrouped ||
    //   (isGrouped && table.options.enableGroupingRowSelection)
    // ) {
    if (value) {
        if (!row.getCanMultiSelect()) Object.keys(selectedRowIds).forEach((key)=>delete selectedRowIds[key]);
        if (row.getCanSelect()) selectedRowIds[id] = true;
    } else delete selectedRowIds[id];
    // }
    if ((_row$subRows = row.subRows) != null && _row$subRows.length && row.getCanSelectSubRows()) row.subRows.forEach((row)=>$93a274dd46b4c3ff$var$mutateRowIsSelected(selectedRowIds, row.id, value, table));
};
function $93a274dd46b4c3ff$export$f150e72530556b0b(table, rowModel) {
    const rowSelection = table.getState().rowSelection;
    const newSelectedFlatRows = [];
    const newSelectedRowsById = {};
    // Filters top level and nested rows
    const recurseRows = function(rows, depth) {
        return rows.map((row)=>{
            var _row$subRows2;
            const isSelected = $93a274dd46b4c3ff$export$710e11cf672b86c(row, rowSelection);
            if (isSelected) {
                newSelectedFlatRows.push(row);
                newSelectedRowsById[row.id] = row;
            }
            if ((_row$subRows2 = row.subRows) != null && _row$subRows2.length) row = {
                ...row,
                subRows: recurseRows(row.subRows)
            };
            if (isSelected) return row;
        }).filter(Boolean);
    };
    return {
        rows: recurseRows(rowModel.rows),
        flatRows: newSelectedFlatRows,
        rowsById: newSelectedRowsById
    };
}
function $93a274dd46b4c3ff$export$710e11cf672b86c(row, selection) {
    var _selection$row$id;
    return (_selection$row$id = selection[row.id]) != null ? _selection$row$id : false;
}
function $93a274dd46b4c3ff$export$8f4c46e5d7907334(row, selection, table) {
    if (row.subRows && row.subRows.length) {
        let allChildrenSelected = true;
        let someSelected = false;
        row.subRows.forEach((subRow)=>{
            // Bail out early if we know both of these
            if (someSelected && !allChildrenSelected) return;
            if ($93a274dd46b4c3ff$export$710e11cf672b86c(subRow, selection)) someSelected = true;
            else allChildrenSelected = false;
        });
        return allChildrenSelected ? "all" : someSelected ? "some" : false;
    }
    return false;
}
const $93a274dd46b4c3ff$export$8758689f50bddb9f = /([0-9]+)/gm;
const $93a274dd46b4c3ff$var$alphanumeric = (rowA, rowB, columnId)=>{
    return $93a274dd46b4c3ff$var$compareAlphanumeric($93a274dd46b4c3ff$var$toString(rowA.getValue(columnId)).toLowerCase(), $93a274dd46b4c3ff$var$toString(rowB.getValue(columnId)).toLowerCase());
};
const $93a274dd46b4c3ff$var$alphanumericCaseSensitive = (rowA, rowB, columnId)=>{
    return $93a274dd46b4c3ff$var$compareAlphanumeric($93a274dd46b4c3ff$var$toString(rowA.getValue(columnId)), $93a274dd46b4c3ff$var$toString(rowB.getValue(columnId)));
};
// The text filter is more basic (less numeric support)
// but is much faster
const $93a274dd46b4c3ff$var$text = (rowA, rowB, columnId)=>{
    return $93a274dd46b4c3ff$var$compareBasic($93a274dd46b4c3ff$var$toString(rowA.getValue(columnId)).toLowerCase(), $93a274dd46b4c3ff$var$toString(rowB.getValue(columnId)).toLowerCase());
};
// The text filter is more basic (less numeric support)
// but is much faster
const $93a274dd46b4c3ff$var$textCaseSensitive = (rowA, rowB, columnId)=>{
    return $93a274dd46b4c3ff$var$compareBasic($93a274dd46b4c3ff$var$toString(rowA.getValue(columnId)), $93a274dd46b4c3ff$var$toString(rowB.getValue(columnId)));
};
const $93a274dd46b4c3ff$var$datetime = (rowA, rowB, columnId)=>{
    const a = rowA.getValue(columnId);
    const b = rowB.getValue(columnId);
    // Can handle nullish values
    // Use > and < because == (and ===) doesn't work with
    // Date objects (would require calling getTime()).
    return a > b ? 1 : a < b ? -1 : 0;
};
const $93a274dd46b4c3ff$var$basic = (rowA, rowB, columnId)=>{
    return $93a274dd46b4c3ff$var$compareBasic(rowA.getValue(columnId), rowB.getValue(columnId));
};
// Utils
function $93a274dd46b4c3ff$var$compareBasic(a, b) {
    return a === b ? 0 : a > b ? 1 : -1;
}
function $93a274dd46b4c3ff$var$toString(a) {
    if (typeof a === "number") {
        if (isNaN(a) || a === Infinity || a === -Infinity) return "";
        return String(a);
    }
    if (typeof a === "string") return a;
    return "";
}
// Mixed sorting is slow, but very inclusive of many edge cases.
// It handles numbers, mixed alphanumeric combinations, and even
// null, undefined, and Infinity
function $93a274dd46b4c3ff$var$compareAlphanumeric(aStr, bStr) {
    // Split on number groups, but keep the delimiter
    // Then remove falsey split values
    const a = aStr.split($93a274dd46b4c3ff$export$8758689f50bddb9f).filter(Boolean);
    const b = bStr.split($93a274dd46b4c3ff$export$8758689f50bddb9f).filter(Boolean);
    // While
    while(a.length && b.length){
        const aa = a.shift();
        const bb = b.shift();
        const an = parseInt(aa, 10);
        const bn = parseInt(bb, 10);
        const combo = [
            an,
            bn
        ].sort();
        // Both are string
        if (isNaN(combo[0])) {
            if (aa > bb) return 1;
            if (bb > aa) return -1;
            continue;
        }
        // One is a string, one is a number
        if (isNaN(combo[1])) return isNaN(an) ? -1 : 1;
        // Both are numbers
        if (an > bn) return 1;
        if (bn > an) return -1;
    }
    return a.length - b.length;
}
// Exports
const $93a274dd46b4c3ff$export$47423a4cd813a815 = {
    alphanumeric: $93a274dd46b4c3ff$var$alphanumeric,
    alphanumericCaseSensitive: $93a274dd46b4c3ff$var$alphanumericCaseSensitive,
    text: $93a274dd46b4c3ff$var$text,
    textCaseSensitive: $93a274dd46b4c3ff$var$textCaseSensitive,
    datetime: $93a274dd46b4c3ff$var$datetime,
    basic: $93a274dd46b4c3ff$var$basic
};
//
const $93a274dd46b4c3ff$export$9707dace2bc98438 = {
    getInitialState: (state)=>{
        return {
            sorting: [],
            ...state
        };
    },
    getDefaultColumnDef: ()=>{
        return {
            sortingFn: "auto",
            sortUndefined: 1
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onSortingChange: $93a274dd46b4c3ff$export$2b5605d8069324bd("sorting", table),
            isMultiSortEvent: (e)=>{
                return e.shiftKey;
            }
        };
    },
    createColumn: (column, table)=>{
        return {
            getAutoSortingFn: ()=>{
                const firstRows = table.getFilteredRowModel().flatRows.slice(10);
                let isString = false;
                for (const row of firstRows){
                    const value = row == null ? void 0 : row.getValue(column.id);
                    if (Object.prototype.toString.call(value) === "[object Date]") return $93a274dd46b4c3ff$export$47423a4cd813a815.datetime;
                    if (typeof value === "string") {
                        isString = true;
                        if (value.split($93a274dd46b4c3ff$export$8758689f50bddb9f).length > 1) return $93a274dd46b4c3ff$export$47423a4cd813a815.alphanumeric;
                    }
                }
                if (isString) return $93a274dd46b4c3ff$export$47423a4cd813a815.text;
                return $93a274dd46b4c3ff$export$47423a4cd813a815.basic;
            },
            getAutoSortDir: ()=>{
                const firstRow = table.getFilteredRowModel().flatRows[0];
                const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
                if (typeof value === "string") return "asc";
                return "desc";
            },
            getSortingFn: ()=>{
                var _table$options$sortin, _table$options$sortin2;
                if (!column) throw new Error();
                return $93a274dd46b4c3ff$export$f6e2535fb5126e54(column.columnDef.sortingFn) ? column.columnDef.sortingFn : column.columnDef.sortingFn === "auto" ? column.getAutoSortingFn() : (_table$options$sortin = (_table$options$sortin2 = table.options.sortingFns) == null ? void 0 : _table$options$sortin2[column.columnDef.sortingFn]) != null ? _table$options$sortin : $93a274dd46b4c3ff$export$47423a4cd813a815[column.columnDef.sortingFn];
            },
            toggleSorting: (desc, multi)=>{
                // if (column.columns.length) {
                //   column.columns.forEach((c, i) => {
                //     if (c.id) {
                //       table.toggleColumnSorting(c.id, undefined, multi || !!i)
                //     }
                //   })
                //   return
                // }
                // this needs to be outside of table.setSorting to be in sync with rerender
                const nextSortingOrder = column.getNextSortingOrder();
                const hasManualValue = typeof desc !== "undefined" && desc !== null;
                table.setSorting((old)=>{
                    // Find any existing sorting for this column
                    const existingSorting = old == null ? void 0 : old.find((d)=>d.id === column.id);
                    const existingIndex = old == null ? void 0 : old.findIndex((d)=>d.id === column.id);
                    let newSorting = [];
                    // What should we do with this sort action?
                    let sortAction;
                    let nextDesc = hasManualValue ? desc : nextSortingOrder === "desc";
                    // Multi-mode
                    if (old != null && old.length && column.getCanMultiSort() && multi) {
                        if (existingSorting) sortAction = "toggle";
                        else sortAction = "add";
                    } else {
                        // Normal mode
                        if (old != null && old.length && existingIndex !== old.length - 1) sortAction = "replace";
                        else if (existingSorting) sortAction = "toggle";
                        else sortAction = "replace";
                    }
                    // Handle toggle states that will remove the sorting
                    if (sortAction === "toggle") {
                        // If we are "actually" toggling (not a manual set value), should we remove the sorting?
                        if (!hasManualValue) // Is our intention to remove?
                        {
                            if (!nextSortingOrder) sortAction = "remove";
                        }
                    }
                    if (sortAction === "add") {
                        var _table$options$maxMul;
                        newSorting = [
                            ...old,
                            {
                                id: column.id,
                                desc: nextDesc
                            }
                        ];
                        // Take latest n columns
                        newSorting.splice(0, newSorting.length - ((_table$options$maxMul = table.options.maxMultiSortColCount) != null ? _table$options$maxMul : Number.MAX_SAFE_INTEGER));
                    } else if (sortAction === "toggle") // This flips (or sets) the
                    newSorting = old.map((d)=>{
                        if (d.id === column.id) return {
                            ...d,
                            desc: nextDesc
                        };
                        return d;
                    });
                    else if (sortAction === "remove") newSorting = old.filter((d)=>d.id !== column.id);
                    else newSorting = [
                        {
                            id: column.id,
                            desc: nextDesc
                        }
                    ];
                    return newSorting;
                });
            },
            getFirstSortDir: ()=>{
                var _ref, _column$columnDef$sor;
                const sortDescFirst = (_ref = (_column$columnDef$sor = column.columnDef.sortDescFirst) != null ? _column$columnDef$sor : table.options.sortDescFirst) != null ? _ref : column.getAutoSortDir() === "desc";
                return sortDescFirst ? "desc" : "asc";
            },
            getNextSortingOrder: (multi)=>{
                var _table$options$enable, _table$options$enable2;
                const firstSortDirection = column.getFirstSortDir();
                const isSorted = column.getIsSorted();
                if (!isSorted) return firstSortDirection;
                if (isSorted !== firstSortDirection && ((_table$options$enable = table.options.enableSortingRemoval) != null ? _table$options$enable : true) && // If enableSortRemove, enable in general
                (multi ? (_table$options$enable2 = table.options.enableMultiRemove) != null ? _table$options$enable2 : true : true // If multi, don't allow if enableMultiRemove))
                )) return false;
                return isSorted === "desc" ? "asc" : "desc";
            },
            getCanSort: ()=>{
                var _column$columnDef$ena, _table$options$enable3;
                return ((_column$columnDef$ena = column.columnDef.enableSorting) != null ? _column$columnDef$ena : true) && ((_table$options$enable3 = table.options.enableSorting) != null ? _table$options$enable3 : true) && !!column.accessorFn;
            },
            getCanMultiSort: ()=>{
                var _ref2, _column$columnDef$ena2;
                return (_ref2 = (_column$columnDef$ena2 = column.columnDef.enableMultiSort) != null ? _column$columnDef$ena2 : table.options.enableMultiSort) != null ? _ref2 : !!column.accessorFn;
            },
            getIsSorted: ()=>{
                var _table$getState$sorti;
                const columnSort = (_table$getState$sorti = table.getState().sorting) == null ? void 0 : _table$getState$sorti.find((d)=>d.id === column.id);
                return !columnSort ? false : columnSort.desc ? "desc" : "asc";
            },
            getSortIndex: ()=>{
                var _table$getState$sorti2, _table$getState$sorti3;
                return (_table$getState$sorti2 = (_table$getState$sorti3 = table.getState().sorting) == null ? void 0 : _table$getState$sorti3.findIndex((d)=>d.id === column.id)) != null ? _table$getState$sorti2 : -1;
            },
            clearSorting: ()=>{
                //clear sorting for just 1 column
                table.setSorting((old)=>old != null && old.length ? old.filter((d)=>d.id !== column.id) : []);
            },
            getToggleSortingHandler: ()=>{
                const canSort = column.getCanSort();
                return (e)=>{
                    if (!canSort) return;
                    e.persist == null || e.persist();
                    column.toggleSorting == null || column.toggleSorting(undefined, column.getCanMultiSort() ? table.options.isMultiSortEvent == null ? void 0 : table.options.isMultiSortEvent(e) : false);
                };
            }
        };
    },
    createTable: (table)=>{
        return {
            setSorting: (updater)=>table.options.onSortingChange == null ? void 0 : table.options.onSortingChange(updater),
            resetSorting: (defaultState)=>{
                var _table$initialState$s, _table$initialState;
                table.setSorting(defaultState ? [] : (_table$initialState$s = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.sorting) != null ? _table$initialState$s : []);
            },
            getPreSortedRowModel: ()=>table.getGroupedRowModel(),
            getSortedRowModel: ()=>{
                if (!table._getSortedRowModel && table.options.getSortedRowModel) table._getSortedRowModel = table.options.getSortedRowModel(table);
                if (table.options.manualSorting || !table._getSortedRowModel) return table.getPreSortedRowModel();
                return table._getSortedRowModel();
            }
        };
    }
};
//
const $93a274dd46b4c3ff$export$5afe92775e3e701d = {
    getInitialState: (state)=>{
        return {
            columnVisibility: {},
            ...state
        };
    },
    getDefaultOptions: (table)=>{
        return {
            onColumnVisibilityChange: $93a274dd46b4c3ff$export$2b5605d8069324bd("columnVisibility", table)
        };
    },
    createColumn: (column, table)=>{
        return {
            toggleVisibility: (value)=>{
                if (column.getCanHide()) table.setColumnVisibility((old)=>({
                        ...old,
                        [column.id]: value != null ? value : !column.getIsVisible()
                    }));
            },
            getIsVisible: ()=>{
                var _table$getState$colum, _table$getState$colum2;
                return (_table$getState$colum = (_table$getState$colum2 = table.getState().columnVisibility) == null ? void 0 : _table$getState$colum2[column.id]) != null ? _table$getState$colum : true;
            },
            getCanHide: ()=>{
                var _column$columnDef$ena, _table$options$enable;
                return ((_column$columnDef$ena = column.columnDef.enableHiding) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableHiding) != null ? _table$options$enable : true);
            },
            getToggleVisibilityHandler: ()=>{
                return (e)=>{
                    column.toggleVisibility == null || column.toggleVisibility(e.target.checked);
                };
            }
        };
    },
    createRow: (row, table)=>{
        return {
            _getAllVisibleCells: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                    row.getAllCells(),
                    table.getState().columnVisibility
                ], (cells)=>{
                return cells.filter((cell)=>cell.column.getIsVisible());
            }, {
                key: "row._getAllVisibleCells",
                debug: ()=>{
                    var _table$options$debugA;
                    return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugRows;
                }
            }),
            getVisibleCells: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                    row.getLeftVisibleCells(),
                    row.getCenterVisibleCells(),
                    row.getRightVisibleCells()
                ], (left, center, right)=>[
                    ...left,
                    ...center,
                    ...right
                ], {
                key: false,
                debug: ()=>{
                    var _table$options$debugA2;
                    return (_table$options$debugA2 = table.options.debugAll) != null ? _table$options$debugA2 : table.options.debugRows;
                }
            })
        };
    },
    createTable: (table)=>{
        const makeVisibleColumnsMethod = (key, getColumns)=>{
            return $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                    getColumns(),
                    getColumns().filter((d)=>d.getIsVisible()).map((d)=>d.id).join("_")
                ], (columns)=>{
                return columns.filter((d)=>d.getIsVisible == null ? void 0 : d.getIsVisible());
            }, {
                key: key,
                debug: ()=>{
                    var _table$options$debugA3;
                    return (_table$options$debugA3 = table.options.debugAll) != null ? _table$options$debugA3 : table.options.debugColumns;
                }
            });
        };
        return {
            getVisibleFlatColumns: makeVisibleColumnsMethod("getVisibleFlatColumns", ()=>table.getAllFlatColumns()),
            getVisibleLeafColumns: makeVisibleColumnsMethod("getVisibleLeafColumns", ()=>table.getAllLeafColumns()),
            getLeftVisibleLeafColumns: makeVisibleColumnsMethod("getLeftVisibleLeafColumns", ()=>table.getLeftLeafColumns()),
            getRightVisibleLeafColumns: makeVisibleColumnsMethod("getRightVisibleLeafColumns", ()=>table.getRightLeafColumns()),
            getCenterVisibleLeafColumns: makeVisibleColumnsMethod("getCenterVisibleLeafColumns", ()=>table.getCenterLeafColumns()),
            setColumnVisibility: (updater)=>table.options.onColumnVisibilityChange == null ? void 0 : table.options.onColumnVisibilityChange(updater),
            resetColumnVisibility: (defaultState)=>{
                var _table$initialState$c;
                table.setColumnVisibility(defaultState ? {} : (_table$initialState$c = table.initialState.columnVisibility) != null ? _table$initialState$c : {});
            },
            toggleAllColumnsVisible: (value)=>{
                var _value;
                value = (_value = value) != null ? _value : !table.getIsAllColumnsVisible();
                table.setColumnVisibility(table.getAllLeafColumns().reduce((obj, column)=>({
                        ...obj,
                        [column.id]: !value ? !(column.getCanHide != null && column.getCanHide()) : value
                    }), {}));
            },
            getIsAllColumnsVisible: ()=>!table.getAllLeafColumns().some((column)=>!(column.getIsVisible != null && column.getIsVisible())),
            getIsSomeColumnsVisible: ()=>table.getAllLeafColumns().some((column)=>column.getIsVisible == null ? void 0 : column.getIsVisible()),
            getToggleAllColumnsVisibilityHandler: ()=>{
                return (e)=>{
                    var _target;
                    table.toggleAllColumnsVisible((_target = e.target) == null ? void 0 : _target.checked);
                };
            }
        };
    }
};
const $93a274dd46b4c3ff$var$features = [
    $93a274dd46b4c3ff$export$79b704688b15c0f4,
    $93a274dd46b4c3ff$export$5afe92775e3e701d,
    $93a274dd46b4c3ff$export$549aff5da5ccfd97,
    $93a274dd46b4c3ff$export$5289f180505593b3,
    $93a274dd46b4c3ff$export$92a576f896a9bf72,
    $93a274dd46b4c3ff$export$9707dace2bc98438,
    $93a274dd46b4c3ff$export$3885c0af90651e94,
    $93a274dd46b4c3ff$export$c9bad30efcce6e0c,
    $93a274dd46b4c3ff$export$68f5e1453c188a82,
    $93a274dd46b4c3ff$export$e8905133e7bf3121,
    $93a274dd46b4c3ff$export$9916c85814812d4a
];
//
function $93a274dd46b4c3ff$export$33bbb3ec7652e187(options) {
    var _options$initialState;
    if (options.debugAll || options.debugTable) console.info("Creating Table Instance...");
    let table = {
        _features: $93a274dd46b4c3ff$var$features
    };
    const defaultOptions = table._features.reduce((obj, feature)=>{
        return Object.assign(obj, feature.getDefaultOptions == null ? void 0 : feature.getDefaultOptions(table));
    }, {});
    const mergeOptions = (options)=>{
        if (table.options.mergeOptions) return table.options.mergeOptions(defaultOptions, options);
        return {
            ...defaultOptions,
            ...options
        };
    };
    const coreInitialState = {};
    let initialState = {
        ...coreInitialState,
        ...(_options$initialState = options.initialState) != null ? _options$initialState : {}
    };
    table._features.forEach((feature)=>{
        var _feature$getInitialSt;
        initialState = (_feature$getInitialSt = feature.getInitialState == null ? void 0 : feature.getInitialState(initialState)) != null ? _feature$getInitialSt : initialState;
    });
    const queued = [];
    let queuedTimeout = false;
    const coreInstance = {
        _features: $93a274dd46b4c3ff$var$features,
        options: {
            ...defaultOptions,
            ...options
        },
        initialState: initialState,
        _queue: (cb)=>{
            queued.push(cb);
            if (!queuedTimeout) {
                queuedTimeout = true;
                // Schedule a microtask to run the queued callbacks after
                // the current call stack (render, etc) has finished.
                Promise.resolve().then(()=>{
                    while(queued.length)queued.shift()();
                    queuedTimeout = false;
                }).catch((error)=>setTimeout(()=>{
                        throw error;
                    }));
            }
        },
        reset: ()=>{
            table.setState(table.initialState);
        },
        setOptions: (updater)=>{
            const newOptions = $93a274dd46b4c3ff$export$7f095f455ad5af3f(updater, table.options);
            table.options = mergeOptions(newOptions);
        },
        getState: ()=>{
            return table.options.state;
        },
        setState: (updater)=>{
            table.options.onStateChange == null || table.options.onStateChange(updater);
        },
        _getRowId: (row, index, parent)=>{
            var _table$options$getRow;
            return (_table$options$getRow = table.options.getRowId == null ? void 0 : table.options.getRowId(row, index, parent)) != null ? _table$options$getRow : `${parent ? [
                parent.id,
                index
            ].join(".") : index}`;
        },
        getCoreRowModel: ()=>{
            if (!table._getCoreRowModel) table._getCoreRowModel = table.options.getCoreRowModel(table);
            return table._getCoreRowModel();
        },
        // The final calls start at the bottom of the model,
        // expanded rows, which then work their way up
        getRowModel: ()=>{
            return table.getPaginationRowModel();
        },
        getRow: (id)=>{
            const row = table.getRowModel().rowsById[id];
            if (!row) throw new Error();
            return row;
        },
        _getDefaultColumnDef: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                table.options.defaultColumn
            ], (defaultColumn)=>{
            var _defaultColumn;
            defaultColumn = (_defaultColumn = defaultColumn) != null ? _defaultColumn : {};
            return {
                header: (props)=>{
                    const resolvedColumnDef = props.header.column.columnDef;
                    if (resolvedColumnDef.accessorKey) return resolvedColumnDef.accessorKey;
                    if (resolvedColumnDef.accessorFn) return resolvedColumnDef.id;
                    return null;
                },
                // footer: props => props.header.column.id,
                cell: (props)=>{
                    var _props$renderValue$to, _props$renderValue;
                    return (_props$renderValue$to = (_props$renderValue = props.renderValue()) == null ? void 0 : _props$renderValue.toString == null ? void 0 : _props$renderValue.toString()) != null ? _props$renderValue$to : null;
                },
                ...table._features.reduce((obj, feature)=>{
                    return Object.assign(obj, feature.getDefaultColumnDef == null ? void 0 : feature.getDefaultColumnDef());
                }, {}),
                ...defaultColumn
            };
        }, {
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugColumns;
            },
            key: false
        }),
        _getColumnDefs: ()=>table.options.columns,
        getAllColumns: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                table._getColumnDefs()
            ], (columnDefs)=>{
            const recurseColumns = function(columnDefs, parent, depth) {
                if (depth === void 0) depth = 0;
                return columnDefs.map((columnDef)=>{
                    const column = $93a274dd46b4c3ff$export$1bfa986e9c92c0b5(table, columnDef, depth, parent);
                    const groupingColumnDef = columnDef;
                    column.columns = groupingColumnDef.columns ? recurseColumns(groupingColumnDef.columns, column, depth + 1) : [];
                    return column;
                });
            };
            return recurseColumns(columnDefs);
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA2;
                return (_table$options$debugA2 = table.options.debugAll) != null ? _table$options$debugA2 : table.options.debugColumns;
            }
        }),
        getAllFlatColumns: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                table.getAllColumns()
            ], (allColumns)=>{
            return allColumns.flatMap((column)=>{
                return column.getFlatColumns();
            });
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA3;
                return (_table$options$debugA3 = table.options.debugAll) != null ? _table$options$debugA3 : table.options.debugColumns;
            }
        }),
        _getAllFlatColumnsById: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                table.getAllFlatColumns()
            ], (flatColumns)=>{
            return flatColumns.reduce((acc, column)=>{
                acc[column.id] = column;
                return acc;
            }, {});
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA4;
                return (_table$options$debugA4 = table.options.debugAll) != null ? _table$options$debugA4 : table.options.debugColumns;
            }
        }),
        getAllLeafColumns: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                table.getAllColumns(),
                table._getOrderColumnsFn()
            ], (allColumns, orderColumns)=>{
            let leafColumns = allColumns.flatMap((column)=>column.getLeafColumns());
            return orderColumns(leafColumns);
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA5;
                return (_table$options$debugA5 = table.options.debugAll) != null ? _table$options$debugA5 : table.options.debugColumns;
            }
        }),
        getColumn: (columnId)=>{
            const column = table._getAllFlatColumnsById()[columnId];
            return column;
        }
    };
    Object.assign(table, coreInstance);
    table._features.forEach((feature)=>{
        return Object.assign(table, feature.createTable == null ? void 0 : feature.createTable(table));
    });
    return table;
}
function $93a274dd46b4c3ff$export$3cb21b6b1233300e(table, row, column, columnId) {
    const getRenderValue = ()=>{
        var _cell$getValue;
        return (_cell$getValue = cell.getValue()) != null ? _cell$getValue : table.options.renderFallbackValue;
    };
    const cell = {
        id: `${row.id}_${column.id}`,
        row: row,
        column: column,
        getValue: ()=>row.getValue(columnId),
        renderValue: getRenderValue,
        getContext: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                table,
                column,
                row,
                cell
            ], (table, column, row, cell)=>({
                table: table,
                column: column,
                row: row,
                cell: cell,
                getValue: cell.getValue,
                renderValue: cell.renderValue
            }), {
            key: false,
            debug: ()=>table.options.debugAll
        })
    };
    table._features.forEach((feature)=>{
        Object.assign(cell, feature.createCell == null ? void 0 : feature.createCell(cell, column, row, table));
    }, {});
    return cell;
}
const $93a274dd46b4c3ff$export$3442c5d213434705 = (table, id, original, rowIndex, depth, subRows, parentId)=>{
    let row = {
        id: id,
        index: rowIndex,
        original: original,
        depth: depth,
        parentId: parentId,
        _valuesCache: {},
        _uniqueValuesCache: {},
        getValue: (columnId)=>{
            if (row._valuesCache.hasOwnProperty(columnId)) return row._valuesCache[columnId];
            const column = table.getColumn(columnId);
            if (!(column != null && column.accessorFn)) return undefined;
            row._valuesCache[columnId] = column.accessorFn(row.original, rowIndex);
            return row._valuesCache[columnId];
        },
        getUniqueValues: (columnId)=>{
            if (row._uniqueValuesCache.hasOwnProperty(columnId)) return row._uniqueValuesCache[columnId];
            const column = table.getColumn(columnId);
            if (!(column != null && column.accessorFn)) return undefined;
            if (!column.columnDef.getUniqueValues) {
                row._uniqueValuesCache[columnId] = [
                    row.getValue(columnId)
                ];
                return row._uniqueValuesCache[columnId];
            }
            row._uniqueValuesCache[columnId] = column.columnDef.getUniqueValues(row.original, rowIndex);
            return row._uniqueValuesCache[columnId];
        },
        renderValue: (columnId)=>{
            var _row$getValue;
            return (_row$getValue = row.getValue(columnId)) != null ? _row$getValue : table.options.renderFallbackValue;
        },
        subRows: subRows != null ? subRows : [],
        getLeafRows: ()=>$93a274dd46b4c3ff$export$bf4548421d1b2c8(row.subRows, (d)=>d.subRows),
        getParentRow: ()=>row.parentId ? table.getRow(row.parentId) : undefined,
        getParentRows: ()=>{
            let parentRows = [];
            let currentRow = row;
            while(true){
                const parentRow = currentRow.getParentRow();
                if (!parentRow) break;
                parentRows.push(parentRow);
                currentRow = parentRow;
            }
            return parentRows.reverse();
        },
        getAllCells: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                table.getAllLeafColumns()
            ], (leafColumns)=>{
            return leafColumns.map((column)=>{
                return $93a274dd46b4c3ff$export$3cb21b6b1233300e(table, row, column, column.id);
            });
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugRows;
            }
        }),
        _getAllCellsByColumnId: $93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                row.getAllCells()
            ], (allCells)=>{
            return allCells.reduce((acc, cell)=>{
                acc[cell.column.id] = cell;
                return acc;
            }, {});
        }, {
            key: "row.getAllCellsByColumnId",
            debug: ()=>{
                var _table$options$debugA2;
                return (_table$options$debugA2 = table.options.debugAll) != null ? _table$options$debugA2 : table.options.debugRows;
            }
        })
    };
    for(let i = 0; i < table._features.length; i++){
        const feature = table._features[i];
        Object.assign(row, feature == null ? void 0 : feature.createRow == null ? void 0 : feature.createRow(row, table));
    }
    return row;
};
// type Person = {
//   firstName: string
//   lastName: string
//   age: number
//   visits: number
//   status: string
//   progress: number
//   createdAt: Date
//   nested: {
//     foo: [
//       {
//         bar: 'bar'
//       }
//     ]
//     bar: { subBar: boolean }[]
//     baz: {
//       foo: 'foo'
//       bar: {
//         baz: 'baz'
//       }
//     }
//   }
// }
// const test: DeepKeys<Person> = 'nested.foo.0.bar'
// const test2: DeepKeys<Person> = 'nested.bar'
// const helper = createColumnHelper<Person>()
// helper.accessor('nested.foo', {
//   cell: info => info.getValue(),
// })
// helper.accessor('nested.foo.0.bar', {
//   cell: info => info.getValue(),
// })
// helper.accessor('nested.bar', {
//   cell: info => info.getValue(),
// })
function $93a274dd46b4c3ff$export$4b44a5cb9651fe5e() {
    return {
        accessor: (accessor, column)=>{
            return typeof accessor === "function" ? {
                ...column,
                accessorFn: accessor
            } : {
                ...column,
                accessorKey: accessor
            };
        },
        display: (column)=>column,
        group: (column)=>column
    };
}
function $93a274dd46b4c3ff$export$32d0bc001e828250() {
    return (table)=>$93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                table.options.data
            ], (data)=>{
            const rowModel = {
                rows: [],
                flatRows: [],
                rowsById: {}
            };
            const accessRows = function(originalRows, depth, parentRow) {
                if (depth === void 0) depth = 0;
                const rows = [];
                for(let i = 0; i < originalRows.length; i++){
                    // This could be an expensive check at scale, so we should move it somewhere else, but where?
                    // if (!id) {
                    //   if (process.env.NODE_ENV !== 'production') {
                    //     throw new Error(`getRowId expected an ID, but got ${id}`)
                    //   }
                    // }
                    // Make the row
                    const row = $93a274dd46b4c3ff$export$3442c5d213434705(table, table._getRowId(originalRows[i], i, parentRow), originalRows[i], i, depth, undefined, parentRow == null ? void 0 : parentRow.id);
                    // Keep track of every row in a flat array
                    rowModel.flatRows.push(row);
                    // Also keep track of every row by its ID
                    rowModel.rowsById[row.id] = row;
                    // Push table row into parent
                    rows.push(row);
                    // Get the original subrows
                    if (table.options.getSubRows) {
                        var _row$originalSubRows;
                        row.originalSubRows = table.options.getSubRows(originalRows[i], i);
                        // Then recursively access them
                        if ((_row$originalSubRows = row.originalSubRows) != null && _row$originalSubRows.length) row.subRows = accessRows(row.originalSubRows, depth + 1, row);
                    }
                }
                return rows;
            };
            rowModel.rows = accessRows(data);
            return rowModel;
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
            },
            onChange: ()=>{
                table._autoResetPageIndex();
            }
        });
}
function $93a274dd46b4c3ff$var$filterRows(rows, filterRowImpl, table) {
    if (table.options.filterFromLeafRows) return $93a274dd46b4c3ff$var$filterRowModelFromLeafs(rows, filterRowImpl, table);
    return $93a274dd46b4c3ff$var$filterRowModelFromRoot(rows, filterRowImpl, table);
}
function $93a274dd46b4c3ff$var$filterRowModelFromLeafs(rowsToFilter, filterRow, table) {
    var _table$options$maxLea;
    const newFilteredFlatRows = [];
    const newFilteredRowsById = {};
    const maxDepth = (_table$options$maxLea = table.options.maxLeafRowFilterDepth) != null ? _table$options$maxLea : 100;
    const recurseFilterRows = function(rowsToFilter, depth) {
        if (depth === void 0) depth = 0;
        const rows = [];
        // Filter from children up first
        for(let i = 0; i < rowsToFilter.length; i++){
            var _row$subRows;
            let row = rowsToFilter[i];
            const newRow = $93a274dd46b4c3ff$export$3442c5d213434705(table, row.id, row.original, row.index, row.depth, undefined, row.parentId);
            newRow.columnFilters = row.columnFilters;
            if ((_row$subRows = row.subRows) != null && _row$subRows.length && depth < maxDepth) {
                newRow.subRows = recurseFilterRows(row.subRows, depth + 1);
                row = newRow;
                if (filterRow(row) && !newRow.subRows.length) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredRowsById[i] = row;
                    continue;
                }
                if (filterRow(row) || newRow.subRows.length) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredRowsById[i] = row;
                    continue;
                }
            } else {
                row = newRow;
                if (filterRow(row)) {
                    rows.push(row);
                    newFilteredRowsById[row.id] = row;
                    newFilteredRowsById[i] = row;
                }
            }
        }
        return rows;
    };
    return {
        rows: recurseFilterRows(rowsToFilter),
        flatRows: newFilteredFlatRows,
        rowsById: newFilteredRowsById
    };
}
function $93a274dd46b4c3ff$var$filterRowModelFromRoot(rowsToFilter, filterRow, table) {
    var _table$options$maxLea2;
    const newFilteredFlatRows = [];
    const newFilteredRowsById = {};
    const maxDepth = (_table$options$maxLea2 = table.options.maxLeafRowFilterDepth) != null ? _table$options$maxLea2 : 100;
    // Filters top level and nested rows
    const recurseFilterRows = function(rowsToFilter, depth) {
        if (depth === void 0) depth = 0;
        // Filter from parents downward first
        const rows = [];
        // Apply the filter to any subRows
        for(let i = 0; i < rowsToFilter.length; i++){
            let row = rowsToFilter[i];
            const pass = filterRow(row);
            if (pass) {
                var _row$subRows2;
                if ((_row$subRows2 = row.subRows) != null && _row$subRows2.length && depth < maxDepth) {
                    const newRow = $93a274dd46b4c3ff$export$3442c5d213434705(table, row.id, row.original, row.index, row.depth, undefined, row.parentId);
                    newRow.subRows = recurseFilterRows(row.subRows, depth + 1);
                    row = newRow;
                }
                rows.push(row);
                newFilteredFlatRows.push(row);
                newFilteredRowsById[row.id] = row;
            }
        }
        return rows;
    };
    return {
        rows: recurseFilterRows(rowsToFilter),
        flatRows: newFilteredFlatRows,
        rowsById: newFilteredRowsById
    };
}
function $93a274dd46b4c3ff$export$26f255a2756e1638() {
    return (table)=>$93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                table.getPreFilteredRowModel(),
                table.getState().columnFilters,
                table.getState().globalFilter
            ], (rowModel, columnFilters, globalFilter)=>{
            if (!rowModel.rows.length || !(columnFilters != null && columnFilters.length) && !globalFilter) {
                for(let i = 0; i < rowModel.flatRows.length; i++){
                    rowModel.flatRows[i].columnFilters = {};
                    rowModel.flatRows[i].columnFiltersMeta = {};
                }
                return rowModel;
            }
            const resolvedColumnFilters = [];
            const resolvedGlobalFilters = [];
            (columnFilters != null ? columnFilters : []).forEach((d)=>{
                var _filterFn$resolveFilt;
                const column = table.getColumn(d.id);
                if (!column) return;
                const filterFn = column.getFilterFn();
                if (!filterFn) return;
                resolvedColumnFilters.push({
                    id: d.id,
                    filterFn: filterFn,
                    resolvedValue: (_filterFn$resolveFilt = filterFn.resolveFilterValue == null ? void 0 : filterFn.resolveFilterValue(d.value)) != null ? _filterFn$resolveFilt : d.value
                });
            });
            const filterableIds = columnFilters.map((d)=>d.id);
            const globalFilterFn = table.getGlobalFilterFn();
            const globallyFilterableColumns = table.getAllLeafColumns().filter((column)=>column.getCanGlobalFilter());
            if (globalFilter && globalFilterFn && globallyFilterableColumns.length) {
                filterableIds.push("__global__");
                globallyFilterableColumns.forEach((column)=>{
                    var _globalFilterFn$resol;
                    resolvedGlobalFilters.push({
                        id: column.id,
                        filterFn: globalFilterFn,
                        resolvedValue: (_globalFilterFn$resol = globalFilterFn.resolveFilterValue == null ? void 0 : globalFilterFn.resolveFilterValue(globalFilter)) != null ? _globalFilterFn$resol : globalFilter
                    });
                });
            }
            let currentColumnFilter;
            let currentGlobalFilter;
            // Flag the prefiltered row model with each filter state
            for(let j = 0; j < rowModel.flatRows.length; j++){
                const row = rowModel.flatRows[j];
                row.columnFilters = {};
                if (resolvedColumnFilters.length) for(let i = 0; i < resolvedColumnFilters.length; i++){
                    currentColumnFilter = resolvedColumnFilters[i];
                    const id = currentColumnFilter.id;
                    // Tag the row with the column filter state
                    row.columnFilters[id] = currentColumnFilter.filterFn(row, id, currentColumnFilter.resolvedValue, (filterMeta)=>{
                        row.columnFiltersMeta[id] = filterMeta;
                    });
                }
                if (resolvedGlobalFilters.length) {
                    for(let i = 0; i < resolvedGlobalFilters.length; i++){
                        currentGlobalFilter = resolvedGlobalFilters[i];
                        const id = currentGlobalFilter.id;
                        // Tag the row with the first truthy global filter state
                        if (currentGlobalFilter.filterFn(row, id, currentGlobalFilter.resolvedValue, (filterMeta)=>{
                            row.columnFiltersMeta[id] = filterMeta;
                        })) {
                            row.columnFilters.__global__ = true;
                            break;
                        }
                    }
                    if (row.columnFilters.__global__ !== true) row.columnFilters.__global__ = false;
                }
            }
            const filterRowsImpl = (row)=>{
                // Horizontally filter rows through each column
                for(let i = 0; i < filterableIds.length; i++){
                    if (row.columnFilters[filterableIds[i]] === false) return false;
                }
                return true;
            };
            // Filter final rows using all of the active filters
            return $93a274dd46b4c3ff$var$filterRows(rowModel.rows, filterRowsImpl, table);
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
            },
            onChange: ()=>{
                table._autoResetPageIndex();
            }
        });
}
function $93a274dd46b4c3ff$export$3519aa0e35dc33b4() {
    return (table, columnId)=>$93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                table.getPreFilteredRowModel(),
                table.getState().columnFilters,
                table.getState().globalFilter,
                table.getFilteredRowModel()
            ], (preRowModel, columnFilters, globalFilter)=>{
            if (!preRowModel.rows.length || !(columnFilters != null && columnFilters.length) && !globalFilter) return preRowModel;
            const filterableIds = [
                ...columnFilters.map((d)=>d.id).filter((d)=>d !== columnId),
                globalFilter ? "__global__" : undefined
            ].filter(Boolean);
            const filterRowsImpl = (row)=>{
                // Horizontally filter rows through each column
                for(let i = 0; i < filterableIds.length; i++){
                    if (row.columnFilters[filterableIds[i]] === false) return false;
                }
                return true;
            };
            return $93a274dd46b4c3ff$var$filterRows(preRowModel.rows, filterRowsImpl, table);
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
            },
            onChange: ()=>{}
        });
}
function $93a274dd46b4c3ff$export$1fb5d0c1edc37de2() {
    return (table, columnId)=>$93a274dd46b4c3ff$export$7c73462e0d25e514(()=>{
            var _table$getColumn;
            return [
                (_table$getColumn = table.getColumn(columnId)) == null ? void 0 : _table$getColumn.getFacetedRowModel()
            ];
        }, (facetedRowModel)=>{
            if (!facetedRowModel) return new Map();
            let facetedUniqueValues = new Map();
            for(let i = 0; i < facetedRowModel.flatRows.length; i++){
                const values = facetedRowModel.flatRows[i].getUniqueValues(columnId);
                for(let j = 0; j < values.length; j++){
                    const value = values[j];
                    if (facetedUniqueValues.has(value)) {
                        var _facetedUniqueValues$;
                        facetedUniqueValues.set(value, ((_facetedUniqueValues$ = facetedUniqueValues.get(value)) != null ? _facetedUniqueValues$ : 0) + 1);
                    } else facetedUniqueValues.set(value, 1);
                }
            }
            return facetedUniqueValues;
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
            },
            onChange: ()=>{}
        });
}
function $93a274dd46b4c3ff$export$d17dd32c9eab9fc7() {
    return (table, columnId)=>$93a274dd46b4c3ff$export$7c73462e0d25e514(()=>{
            var _table$getColumn;
            return [
                (_table$getColumn = table.getColumn(columnId)) == null ? void 0 : _table$getColumn.getFacetedRowModel()
            ];
        }, (facetedRowModel)=>{
            var _facetedRowModel$flat;
            if (!facetedRowModel) return undefined;
            const firstValue = (_facetedRowModel$flat = facetedRowModel.flatRows[0]) == null ? void 0 : _facetedRowModel$flat.getUniqueValues(columnId);
            if (typeof firstValue === "undefined") return undefined;
            let facetedMinMaxValues = [
                firstValue,
                firstValue
            ];
            for(let i = 0; i < facetedRowModel.flatRows.length; i++){
                const values = facetedRowModel.flatRows[i].getUniqueValues(columnId);
                for(let j = 0; j < values.length; j++){
                    const value = values[j];
                    if (value < facetedMinMaxValues[0]) facetedMinMaxValues[0] = value;
                    else if (value > facetedMinMaxValues[1]) facetedMinMaxValues[1] = value;
                }
            }
            return facetedMinMaxValues;
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
            },
            onChange: ()=>{}
        });
}
function $93a274dd46b4c3ff$export$4ca93ca80835d8c1() {
    return (table)=>$93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                table.getState().sorting,
                table.getPreSortedRowModel()
            ], (sorting, rowModel)=>{
            if (!rowModel.rows.length || !(sorting != null && sorting.length)) return rowModel;
            const sortingState = table.getState().sorting;
            const sortedFlatRows = [];
            // Filter out sortings that correspond to non existing columns
            const availableSorting = sortingState.filter((sort)=>{
                var _table$getColumn;
                return (_table$getColumn = table.getColumn(sort.id)) == null ? void 0 : _table$getColumn.getCanSort();
            });
            const columnInfoById = {};
            availableSorting.forEach((sortEntry)=>{
                const column = table.getColumn(sortEntry.id);
                if (!column) return;
                columnInfoById[sortEntry.id] = {
                    sortUndefined: column.columnDef.sortUndefined,
                    invertSorting: column.columnDef.invertSorting,
                    sortingFn: column.getSortingFn()
                };
            });
            const sortData = (rows)=>{
                // This will also perform a stable sorting using the row index
                // if needed.
                const sortedData = [
                    ...rows
                ];
                sortedData.sort((rowA, rowB)=>{
                    for(let i = 0; i < availableSorting.length; i += 1){
                        var _sortEntry$desc;
                        const sortEntry = availableSorting[i];
                        const columnInfo = columnInfoById[sortEntry.id];
                        const isDesc = (_sortEntry$desc = sortEntry == null ? void 0 : sortEntry.desc) != null ? _sortEntry$desc : false;
                        let sortInt = 0;
                        // All sorting ints should always return in ascending order
                        if (columnInfo.sortUndefined) {
                            const aValue = rowA.getValue(sortEntry.id);
                            const bValue = rowB.getValue(sortEntry.id);
                            const aUndefined = aValue === undefined;
                            const bUndefined = bValue === undefined;
                            if (aUndefined || bUndefined) sortInt = aUndefined && bUndefined ? 0 : aUndefined ? columnInfo.sortUndefined : -columnInfo.sortUndefined;
                        }
                        if (sortInt === 0) sortInt = columnInfo.sortingFn(rowA, rowB, sortEntry.id);
                        // If sorting is non-zero, take care of desc and inversion
                        if (sortInt !== 0) {
                            if (isDesc) sortInt *= -1;
                            if (columnInfo.invertSorting) sortInt *= -1;
                            return sortInt;
                        }
                    }
                    return rowA.index - rowB.index;
                });
                // If there are sub-rows, sort them
                sortedData.forEach((row)=>{
                    var _row$subRows;
                    sortedFlatRows.push(row);
                    if ((_row$subRows = row.subRows) != null && _row$subRows.length) row.subRows = sortData(row.subRows);
                });
                return sortedData;
            };
            return {
                rows: sortData(rowModel.rows),
                flatRows: sortedFlatRows,
                rowsById: rowModel.rowsById
            };
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
            },
            onChange: ()=>{
                table._autoResetPageIndex();
            }
        });
}
function $93a274dd46b4c3ff$export$2b7f4b57ce71b81() {
    return (table)=>$93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                table.getState().grouping,
                table.getPreGroupedRowModel()
            ], (grouping, rowModel)=>{
            if (!rowModel.rows.length || !grouping.length) return rowModel;
            // Filter the grouping list down to columns that exist
            const existingGrouping = grouping.filter((columnId)=>table.getColumn(columnId));
            const groupedFlatRows = [];
            const groupedRowsById = {};
            // const onlyGroupedFlatRows: Row[] = [];
            // const onlyGroupedRowsById: Record<RowId, Row> = {};
            // const nonGroupedFlatRows: Row[] = [];
            // const nonGroupedRowsById: Record<RowId, Row> = {};
            // Recursively group the data
            const groupUpRecursively = function(rows, depth, parentId) {
                if (depth === void 0) depth = 0;
                // Grouping depth has been been met
                // Stop grouping and simply rewrite thd depth and row relationships
                if (depth >= existingGrouping.length) return rows.map((row)=>{
                    row.depth = depth;
                    groupedFlatRows.push(row);
                    groupedRowsById[row.id] = row;
                    if (row.subRows) row.subRows = groupUpRecursively(row.subRows, depth + 1, row.id);
                    return row;
                });
                const columnId = existingGrouping[depth];
                // Group the rows together for this level
                const rowGroupsMap = $93a274dd46b4c3ff$var$groupBy(rows, columnId);
                // Peform aggregations for each group
                const aggregatedGroupedRows = Array.from(rowGroupsMap.entries()).map((_ref, index)=>{
                    let [groupingValue, groupedRows] = _ref;
                    let id = `${columnId}:${groupingValue}`;
                    id = parentId ? `${parentId}>${id}` : id;
                    // First, Recurse to group sub rows before aggregation
                    const subRows = groupUpRecursively(groupedRows, depth + 1, id);
                    // Flatten the leaf rows of the rows in this group
                    const leafRows = depth ? $93a274dd46b4c3ff$export$bf4548421d1b2c8(groupedRows, (row)=>row.subRows) : groupedRows;
                    const row = $93a274dd46b4c3ff$export$3442c5d213434705(table, id, leafRows[0].original, index, depth, undefined, parentId);
                    Object.assign(row, {
                        groupingColumnId: columnId,
                        groupingValue: groupingValue,
                        subRows: subRows,
                        leafRows: leafRows,
                        getValue: (columnId)=>{
                            // Don't aggregate columns that are in the grouping
                            if (existingGrouping.includes(columnId)) {
                                if (row._valuesCache.hasOwnProperty(columnId)) return row._valuesCache[columnId];
                                if (groupedRows[0]) {
                                    var _groupedRows$0$getVal;
                                    row._valuesCache[columnId] = (_groupedRows$0$getVal = groupedRows[0].getValue(columnId)) != null ? _groupedRows$0$getVal : undefined;
                                }
                                return row._valuesCache[columnId];
                            }
                            if (row._groupingValuesCache.hasOwnProperty(columnId)) return row._groupingValuesCache[columnId];
                            // Aggregate the values
                            const column = table.getColumn(columnId);
                            const aggregateFn = column == null ? void 0 : column.getAggregationFn();
                            if (aggregateFn) {
                                row._groupingValuesCache[columnId] = aggregateFn(columnId, leafRows, groupedRows);
                                return row._groupingValuesCache[columnId];
                            }
                        }
                    });
                    subRows.forEach((subRow)=>{
                        groupedFlatRows.push(subRow);
                        groupedRowsById[subRow.id] = subRow;
                    // if (subRow.getIsGrouped?.()) {
                    //   onlyGroupedFlatRows.push(subRow);
                    //   onlyGroupedRowsById[subRow.id] = subRow;
                    // } else {
                    //   nonGroupedFlatRows.push(subRow);
                    //   nonGroupedRowsById[subRow.id] = subRow;
                    // }
                    });
                    return row;
                });
                return aggregatedGroupedRows;
            };
            const groupedRows = groupUpRecursively(rowModel.rows, 0);
            groupedRows.forEach((subRow)=>{
                groupedFlatRows.push(subRow);
                groupedRowsById[subRow.id] = subRow;
            // if (subRow.getIsGrouped?.()) {
            //   onlyGroupedFlatRows.push(subRow);
            //   onlyGroupedRowsById[subRow.id] = subRow;
            // } else {
            //   nonGroupedFlatRows.push(subRow);
            //   nonGroupedRowsById[subRow.id] = subRow;
            // }
            });
            return {
                rows: groupedRows,
                flatRows: groupedFlatRows,
                rowsById: groupedRowsById
            };
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
            },
            onChange: ()=>{
                table._queue(()=>{
                    table._autoResetExpanded();
                    table._autoResetPageIndex();
                });
            }
        });
}
function $93a274dd46b4c3ff$var$groupBy(rows, columnId) {
    const groupMap = new Map();
    return rows.reduce((map, row)=>{
        const resKey = `${row.getGroupingValue(columnId)}`;
        const previous = map.get(resKey);
        if (!previous) map.set(resKey, [
            row
        ]);
        else previous.push(row);
        return map;
    }, groupMap);
}
function $93a274dd46b4c3ff$export$53cfec7b1b8d1fcd() {
    return (table)=>$93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                table.getState().expanded,
                table.getPreExpandedRowModel(),
                table.options.paginateExpandedRows
            ], (expanded, rowModel, paginateExpandedRows)=>{
            if (!rowModel.rows.length || expanded !== true && !Object.keys(expanded != null ? expanded : {}).length) return rowModel;
            if (!paginateExpandedRows) // Only expand rows at this point if they are being paginated
            return rowModel;
            return $93a274dd46b4c3ff$export$1293f966cdb38633(rowModel);
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
            }
        });
}
function $93a274dd46b4c3ff$export$1293f966cdb38633(rowModel) {
    const expandedRows = [];
    const handleRow = (row)=>{
        var _row$subRows;
        expandedRows.push(row);
        if ((_row$subRows = row.subRows) != null && _row$subRows.length && row.getIsExpanded()) row.subRows.forEach(handleRow);
    };
    rowModel.rows.forEach(handleRow);
    return {
        rows: expandedRows,
        flatRows: rowModel.flatRows,
        rowsById: rowModel.rowsById
    };
}
function $93a274dd46b4c3ff$export$ddfd3662e196c265(opts) {
    return (table)=>$93a274dd46b4c3ff$export$7c73462e0d25e514(()=>[
                table.getState().pagination,
                table.getPrePaginationRowModel(),
                table.options.paginateExpandedRows ? undefined : table.getState().expanded
            ], (pagination, rowModel)=>{
            if (!rowModel.rows.length) return rowModel;
            const { pageSize: pageSize, pageIndex: pageIndex } = pagination;
            let { rows: rows, flatRows: flatRows, rowsById: rowsById } = rowModel;
            const pageStart = pageSize * pageIndex;
            const pageEnd = pageStart + pageSize;
            rows = rows.slice(pageStart, pageEnd);
            let paginatedRowModel;
            if (!table.options.paginateExpandedRows) paginatedRowModel = $93a274dd46b4c3ff$export$1293f966cdb38633({
                rows: rows,
                flatRows: flatRows,
                rowsById: rowsById
            });
            else paginatedRowModel = {
                rows: rows,
                flatRows: flatRows,
                rowsById: rowsById
            };
            paginatedRowModel.flatRows = [];
            const handleRow = (row)=>{
                paginatedRowModel.flatRows.push(row);
                if (row.subRows.length) row.subRows.forEach(handleRow);
            };
            paginatedRowModel.rows.forEach(handleRow);
            return paginatedRowModel;
        }, {
            key: false,
            debug: ()=>{
                var _table$options$debugA;
                return (_table$options$debugA = table.options.debugAll) != null ? _table$options$debugA : table.options.debugTable;
            }
        });
}



var $2gcPZ = parcelRequire("2gcPZ");







/**
 * react-table
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $2gcPZ = parcelRequire("2gcPZ");

//
function $c7c836d5712824a3$export$f2385bb6e3ac4b4f(Comp, props) {
    return !Comp ? null : $c7c836d5712824a3$var$isReactComponent(Comp) ? /*#__PURE__*/ $2gcPZ.createElement(Comp, props) : Comp;
}
function $c7c836d5712824a3$var$isReactComponent(component) {
    return $c7c836d5712824a3$var$isClassComponent(component) || typeof component === "function" || $c7c836d5712824a3$var$isExoticComponent(component);
}
function $c7c836d5712824a3$var$isClassComponent(component) {
    return typeof component === "function" && (()=>{
        const proto = Object.getPrototypeOf(component);
        return proto.prototype && proto.prototype.isReactComponent;
    })();
}
function $c7c836d5712824a3$var$isExoticComponent(component) {
    return typeof component === "object" && typeof component.$$typeof === "symbol" && [
        "react.memo",
        "react.forward_ref"
    ].includes(component.$$typeof.description);
}
function $c7c836d5712824a3$export$25eaeb3743e6b31f(options) {
    // Compose in the generic options to the user options
    const resolvedOptions = {
        state: {},
        // Dummy state
        onStateChange: ()=>{},
        // noop
        renderFallbackValue: null,
        ...options
    };
    // Create a new table and store it in state
    const [tableRef] = $2gcPZ.useState(()=>({
            current: (0, $93a274dd46b4c3ff$export$33bbb3ec7652e187)(resolvedOptions)
        }));
    // By default, manage table state here using the table's initial state
    const [state, setState] = $2gcPZ.useState(()=>tableRef.current.initialState);
    // Compose the default state above with any user state. This will allow the user
    // to only control a subset of the state if desired.
    tableRef.current.setOptions((prev)=>({
            ...prev,
            ...options,
            state: {
                ...state,
                ...options.state
            },
            // Similarly, we'll maintain both our internal state and any user-provided
            // state.
            onStateChange: (updater)=>{
                setState(updater);
                options.onStateChange == null || options.onStateChange(updater);
            }
        }));
    return tableRef.current;
}



var $2gcPZ = parcelRequire("2gcPZ");




function $424a0880b9fb7d49$export$9479250d18888981(value) {
    return (params)=>{
        params.delete("expanded");
        for (const key of Object.keys(value))params.append("expanded", key);
        return params;
    };
}



const $030f7a5c323de541$var$fadeInAnimation = (0, $4e8e6ea7d6e48c37$export$d25ddfdf17c3ad3e)`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;
const $030f7a5c323de541$var$animateBackground = (0, $4e8e6ea7d6e48c37$export$d25ddfdf17c3ad3e)`
  from {
    background-position: 0% 0%;
  }

  to {
    background-position: var(--background-width) 0%;
  }
`;
const $030f7a5c323de541$export$8f31e4c4a37b8e9c = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div.attrs({
    "aria-label": "Loading placeholder"
})(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      --background-width: 600px;

      animation: ${$030f7a5c323de541$var$fadeInAnimation} 0.5s,
        ${$030f7a5c323de541$var$animateBackground} 1s 0.5s linear infinite;
      background: ${theme.color.bg.placeholder.gradient};
      background-size: var(--background-width) 100%;
      clip-path: inset(0 0 0 0 round 4px);
      width: 100%;
      height: 100%;
    `);




function $957ba347c2325692$export$df30df7ec97b32b5({ columns: columns, data: data, isLoading: isLoading, onRowClick: onRowClick, renderExpanded: renderExpanded }) {
    const [sorting, setSorting] = (0, $2gcPZ.useState)([]);
    // State for search params
    const [searchParams, setSearchParams] = (0, $e7b98158099ae00d$export$f1a78c17382fe22a)();
    // Get the expanded row ID from the URL query parameter
    const expandedRowIds = searchParams.getAll("expanded");
    // Set up the state for the table
    const state = renderExpanded ? {
        sorting: sorting,
        expanded: expandedRowIds.length > 0 ? expandedRowIds.reduce((object, item)=>{
            object[item] = true;
            return object;
        }, {}) : {}
    } : {
        sorting: sorting
    };
    const onExpandedChange = (0, $cac150ebb620e91f$export$d095b0c879743c0d)((updater)=>{
        // The type of updater is either a function a Record<string, boolean> or a boolean
        // However we don't support boolean values right now (that would mean we'd expand all?)
        if (typeof updater === "function") {
            const value = updater(state.expanded);
            setSearchParams((0, $424a0880b9fb7d49$export$9479250d18888981)(value));
            return;
        }
        if (updater && typeof updater === "object") // Final possible type is a Record<string, boolean>
        setSearchParams((0, $424a0880b9fb7d49$export$9479250d18888981)(updater));
    });
    const table = (0, $c7c836d5712824a3$export$25eaeb3743e6b31f)({
        columns: columns,
        data: data,
        getCoreRowModel: (0, $93a274dd46b4c3ff$export$32d0bc001e828250)(),
        getSortedRowModel: (0, $93a274dd46b4c3ff$export$4ca93ca80835d8c1)(),
        onSortingChange: setSorting,
        onExpandedChange: renderExpanded ? onExpandedChange : undefined,
        state: state
    });
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($957ba347c2325692$var$StyledTable, {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($957ba347c2325692$var$StyledThead, {
                children: table.getHeaderGroups().map((headerGroup)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($957ba347c2325692$var$StyledTr, {
                        children: [
                            renderExpanded && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($957ba347c2325692$var$StyledTh, {}),
                            headerGroup.headers.map((header)=>{
                                const canSort = header.column.getCanSort();
                                const isSorted = header.column.getIsSorted();
                                const onClick = header.column.getToggleSortingHandler();
                                return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($957ba347c2325692$var$StyledTh, {
                                    children: header.isPlaceholder ? null : /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($957ba347c2325692$var$ColumnSortButton, {
                                        $active: isSorted !== false,
                                        $canSort: canSort,
                                        onClick: onClick,
                                        children: [
                                            (0, $c7c836d5712824a3$export$f2385bb6e3ac4b4f)(header.column.columnDef.header, header.getContext()),
                                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($957ba347c2325692$export$72820c4f313d7b94, {
                                                type: isSorted === "desc" ? "caret_down" : isSorted === "asc" ? "caret_up" : "caret_double"
                                            })
                                        ]
                                    })
                                }, header.id);
                            })
                        ]
                    }, headerGroup.id))
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("tbody", {
                children: isLoading ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $afa7be861492543f$exports.Fragment), {
                    children: [
                        1,
                        2,
                        3,
                        4
                    ].map((i)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($957ba347c2325692$var$StyledTr, {
                            children: [
                                renderExpanded && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($957ba347c2325692$var$StyledTd, {
                                    children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($957ba347c2325692$var$StyledSkeleton, {})
                                }),
                                Array.from({
                                    length: columns.length
                                }).map((_, index)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($957ba347c2325692$var$StyledTd, {
                                        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($957ba347c2325692$var$StyledSkeleton, {})
                                    }, index))
                            ]
                        }, i))
                }) : /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $afa7be861492543f$exports.Fragment), {
                    children: table.getRowModel().rows.map((row)=>{
                        const isExpanded = row.getIsExpanded() || false;
                        const result = /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($957ba347c2325692$var$StyledTr, {
                            $elevated: isExpanded,
                            $borderLess: isExpanded,
                            onClick: onRowClick ? ()=>onRowClick(row.original) : undefined,
                            children: [
                                renderExpanded && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($957ba347c2325692$var$StyledTd, {
                                    children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $481f0e286e6dd560$export$c25acd513dcc8062), {
                                        onClick: ()=>row.toggleExpanded(),
                                        iconType: isExpanded ? "caret_down" : "caret_right",
                                        buttonStyle: "tertiary-grey"
                                    })
                                }),
                                row.getVisibleCells().map((cell)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($957ba347c2325692$var$StyledTd, {
                                        children: (0, $c7c836d5712824a3$export$f2385bb6e3ac4b4f)(cell.column.columnDef.cell, cell.getContext())
                                    }, cell.id))
                            ]
                        }, row.id);
                        return isExpanded && renderExpanded ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $2gcPZ.Fragment), {
                            children: [
                                result,
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($957ba347c2325692$var$StyledTr, {
                                    $elevated: isExpanded,
                                    children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($957ba347c2325692$var$StyledTd, {
                                        colSpan: columns.length + 1,
                                        children: renderExpanded(row)
                                    })
                                })
                            ]
                        }, row.id) : result;
                    })
                })
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("tfoot", {
                children: table.getFooterGroups().map((footerGroup)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("tr", {
                        children: footerGroup.headers.map((header)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("th", {
                                children: header.isPlaceholder ? null : (0, $c7c836d5712824a3$export$f2385bb6e3ac4b4f)(header.column.columnDef.footer, header.getContext())
                            }, header.id))
                    }, footerGroup.id))
            })
        ]
    });
}
const $957ba347c2325692$var$StyledTable = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).table`
  border-collapse: collapse;
  max-width: 100%;
  table-layout: fixed;
`;
const $957ba347c2325692$var$StyledTr = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).tr(({ theme: theme, onClick: onClick, $elevated: elevated = false, $borderLess: borderLess = false })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    border-bottom: ${borderLess ? "none" : `1px solid ${theme.color.border.default}`};
    background: ${elevated ? theme.color.bg.subtle : "transparent"};
    height: 56px;

    ${onClick && (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      &:hover {
        background: ${theme.color.bg.subtle};
        cursor: pointer;
      }
    `}
  `);
const $957ba347c2325692$var$StyledTd = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).td(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    color: ${theme.color.fg.default};
    padding: ${theme.spacing.xs};
    font: ${theme.font.body.sm.medium};
    align-items: center;
    width: 1%;
    white-space: nowrap;

    &:first-child {
      padding-left: ${theme.spacing.s};
    }

    &:last-child {
      padding-right: ${theme.spacing.s};
    }
  `);
const $957ba347c2325692$var$StyledTh = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)($957ba347c2325692$var$StyledTd).attrs({
    as: "th"
})(()=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    text-align: left;
    font-weight: 600;
    padding: 4px 3px;
  `);
const $957ba347c2325692$var$StyledThead = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).thead`
  ${$957ba347c2325692$var$StyledTr} {
    border-bottom-width: 2px;

    &:hover {
      background: inherit;
    }
  }
`;
const $957ba347c2325692$var$ColumnSortButton = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).button(({ theme: theme, $active: $active, $canSort: $canSort })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 4px;
    font: inherit;
    letter-spacing: inherit;

    border-radius: ${theme.radius.minimal};
    border: 1px solid ${theme.color.bg.default};
    color: ${$active ? theme.color.fg.default : theme.color.fg.muted};
    background: ${theme.color.bg.default};

    ${$canSort && (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      user-select: none;
      cursor: ${$active === undefined ? "initial" : "pointer"};

      &:hover {
        background: ${theme.color.bg.hover};
        border-color: ${theme.color.bg.hover};
      }

      &:focus {
        outline: none;
        background: ${theme.color.bg.default};
        border-color: ${theme.color.border.primary};
        box-shadow: 0px 0px 0px 4px rgba(165, 80, 255, 0.2);
      }
    `}
  `);
const $957ba347c2325692$export$72820c4f313d7b94 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $0a830394bc38e4e3$export$f04a61298a47a40f))`
  width: 16px;
  height: 16px;
`;
const $957ba347c2325692$var$StyledSkeleton = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $030f7a5c323de541$export$8f31e4c4a37b8e9c))`
  min-height: 38px;
`;






function $795cb95bed41b233$export$8ff1ee94cebb82a4(props) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($795cb95bed41b233$var$StyledLink, {
        ...props,
        children: [
            props.children,
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($795cb95bed41b233$var$LinkOutIcon, {})
        ]
    });
}
const $795cb95bed41b233$var$StyledLink = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $e7b98158099ae00d$export$a6c7ac8248d6e38a))(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    display: inline-flex;
    padding: 6px 8px;
    align-items: center;
    gap: 8px;
    border-radius: 6px;
    color: currentColor;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
      background: ${theme.color.bg.hover};
    }
  `);
const $795cb95bed41b233$var$LinkOutIcon = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $0a830394bc38e4e3$export$f04a61298a47a40f)).attrs({
    type: "arrow_out"
})`
  width: 14px;
  height: 14px;
`;





/**
 * TODO:
 * On a first load, it'd be nice for the SLO tables to slide in from the right.
 * However, when the table refetches data, we just want a normal fade in,
 * or any sort of minimal transition.
 *
 * The issues I ran into while trying to do this are:
 *
 * (1) Detecting a "first load" of the table is nontrivial and inconsistent,
 *     since RTK query will not set `isLoading` when you're fetching data
 *     after having visited the page once already.
 *     (We could clear the cache on page transitions though?)
 *
 * (2) Sequencing the page loading animation with the slide in is a pain,
 *     and when I tried to do anything fancy, it was either firing inconsistnetly,
 *     or just looked unnatural for table refetches.
 *
 * Here is my scratchwork for variants that would accomplish the "slide in" effect:
 *
 *
  firstLoadInitial: {
    x: "100vw", // Start from the right
    opacity: 0,
  },
  firstLoadIn: {
    x: 0, // Slide into to center
    opacity: 1,
    transition: {
      type: "tween",
      ease: "anticipate",
      duration: 0.35,
    },
  },
 */ const $27da3f6f6c297608$export$57aca34bc31479ce = {
    initial: {
        opacity: 0
    },
    in: {
        opacity: 1
    },
    out: {
        opacity: 0,
        transition: {
            type: "tween",
            ease: "anticipate",
            duration: 0.05
        }
    }
};





const $8541b3b9bd182188$export$bf99d7e08aaeb9bb = ({ objective: objective })=>{
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $afa7be861492543f$exports.Fragment), {
        children: objective.metric === "successRate" ? (0, $18c515912ab80737$export$9f3f70cd2f8cef74)(objective.target) : (0, $18c515912ab80737$export$aaa67c14b2bf3b69)(objective.target)
    });
};





const $b332f5ae35e8a73c$export$f1e87ebd9c598b0d = ({ currentValue: currentValue, objective: objective, highlightSuccess: highlightSuccess = false })=>{
    if (!currentValue || !objective.target) return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($b332f5ae35e8a73c$var$WarnableSpan, {
        highlightSuccess: false,
        warn: false,
        children: "\u2014"
    });
    const shouldWarn = (0, $18c515912ab80737$export$76dcc15228d30015)(objective, currentValue);
    if (objective.metric === "successRate") return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($b332f5ae35e8a73c$var$WarnableSpan, {
        highlightSuccess: highlightSuccess,
        warn: shouldWarn,
        children: (0, $18c515912ab80737$export$bc62687c0c7b145)(currentValue)
    });
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($b332f5ae35e8a73c$var$WarnableSpan, {
        highlightSuccess: highlightSuccess,
        warn: shouldWarn,
        children: [
            (0, $18c515912ab80737$export$bc62687c0c7b145)(currentValue),
            " <",
            " ",
            (0, $18c515912ab80737$export$97c5ccbd8ffad6db)(objective.target)
        ]
    });
};
const $b332f5ae35e8a73c$var$WarnableSpan = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).span`
  color: ${({ theme: theme, highlightSuccess: highlightSuccess, warn: warn })=>warn ? theme.color.fg.danger : highlightSuccess ? theme.color.fg.success : "currentColor"};
`;



const $0573cdab17511c26$var$EMPTY_FUNCTIONS_LIST = [];
const $0573cdab17511c26$var$columnHelper = (0, $93a274dd46b4c3ff$export$4b44a5cb9651fe5e)();
function $0573cdab17511c26$export$6eba55a6a7b954bf({ objective: objective, timeRange: timeRange }) {
    const [searchParams] = (0, $e7b98158099ae00d$export$f1a78c17382fe22a)();
    const navigate = (0, $efeb47d767416279$export$9770f232ac06a008)();
    const instance = (0, $1a280fbaa3fcabb5$export$2105062e25df4afe)((0, $14bbd07b3011052f$export$919b3065fd27c3a8));
    const { data: functions = $0573cdab17511c26$var$EMPTY_FUNCTIONS_LIST, error: error, isFetching: isFetching, isUninitialized: isUninitialized } = (0, $81accdab4a22bb8e$export$3eac9bcbfcea7d64)({
        environmentUrl: instance?.url,
        objective: objective,
        start: timeRange.from,
        end: timeRange.to
    }, {
        skip: !objective
    });
    const columns = (0, $2gcPZ.useMemo)(()=>[
            $0573cdab17511c26$var$columnHelper.accessor("name", {
                cell: (cellContext)=>{
                    const name = cellContext.getValue();
                    const module = cellContext.row.original.module;
                    const service = cellContext.row.original.service_name;
                    const path = (0, $c12fb649da40a3f2$export$caded91e4645de6)(name, module, service);
                    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $795cb95bed41b233$export$8ff1ee94cebb82a4), {
                        to: `${path}?${searchParams}`,
                        onClick: (event)=>event.stopPropagation(),
                        children: name
                    });
                },
                header: "Name"
            }),
            $0573cdab17511c26$var$columnHelper.accessor("module", {
                cell: (cellContext)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $afa7be861492543f$exports.Fragment), {
                        children: cellContext.getValue()
                    }),
                header: "Module"
            }),
            $0573cdab17511c26$var$columnHelper.accessor("currentValue", {
                cell: (cellContext)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $b332f5ae35e8a73c$export$f1e87ebd9c598b0d), {
                        objective: objective,
                        currentValue: cellContext.getValue()
                    }),
                header: "Actual"
            }),
            $0573cdab17511c26$var$columnHelper.accessor("target", {
                cell: ()=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $8541b3b9bd182188$export$bf99d7e08aaeb9bb), {
                        objective: objective
                    }),
                header: "Target"
            })
        ], [
        objective,
        searchParams
    ]);
    const throttledIsFetching = (0, $0256cde7569cadc3$export$4083eefea094a0de)(isFetching, 250);
    const tableData = (0, $2gcPZ.useMemo)(()=>{
        if (!objective) return [];
        return functions.map((fn)=>({
                ...fn,
                target: objective.target
            }));
    }, [
        functions,
        objective
    ]);
    const onRowClick = (0, $cac150ebb620e91f$export$d095b0c879743c0d)((fn)=>{
        const path = (0, $c12fb649da40a3f2$export$caded91e4645de6)(fn.name, fn.module, fn.service_name);
        navigate([
            path,
            searchParams
        ].join("?"));
    });
    return isUninitialized ? null : throttledIsFetching ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $c624abcc931dc034$export$bd7370ffb2917ab7), {
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $58fc4bbaeff94670$export$669f6ea7d267feaf), {})
    }, "sloDetailIsLoading") : error ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $c624abcc931dc034$export$bd7370ffb2917ab7), {
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $7f2b92de158af7af$export$5eef44829f72c6d0), {})
    }, "sloDetailError") : /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $c624abcc931dc034$export$bd7370ffb2917ab7), {
        initial: "initial",
        animate: "in",
        exit: "out",
        variants: (0, $27da3f6f6c297608$export$57aca34bc31479ce),
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $957ba347c2325692$export$df30df7ec97b32b5), {
            columns: columns,
            data: tableData,
            onRowClick: onRowClick
        })
    }, "sloFunctionsTable");
}





var $2gcPZ = parcelRequire("2gcPZ");










const $004ac84570f5b12e$export$8a23e74e5cf3ca41 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).section(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    display: grid;
    gap: 16px;
    border: 1px solid ${theme.color.border.default};
    border-radius: ${theme.radius.default};
    padding: 24px;
  `);
const $004ac84570f5b12e$export$474db65c3c394e1c = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).strong(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    color: ${theme.color.fg.subtle};
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px; /* 112.5% */
    letter-spacing: -0.5px;
    display: flex;
  `);
const $004ac84570f5b12e$export$cf0f153eb3e3f6ce = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).span`
  display: flex;
  gap: 8px;
  align-items: baseline;
`;
const $004ac84570f5b12e$export$5062880c778c5dd2 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  font-family: Basier square;
  font-size: 36px;
  font-style: normal;
  font-weight: 500;
  letter-spacing: -1px;
`;
const $004ac84570f5b12e$export$ae408d4ba7217daa = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).span(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    color: ${theme.color.fg.subtle};
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px; /* 112.5% */
    letter-spacing: -0.5px;
  `);




const $25b31b62eb7c9a96$var$EMPTY_FUNCTIONS_LIST = [];
function $25b31b62eb7c9a96$export$614db49f3febe941({ objective: objective, timeRange: timeRange, onChangeTimeRange: onChangeTimeRange }) {
    const instance = (0, $1a280fbaa3fcabb5$export$2105062e25df4afe)((0, $14bbd07b3011052f$export$919b3065fd27c3a8));
    const { metric: metricType, target: target } = objective;
    const targetLatency = metricType === "latency" ? Number.parseFloat(target.threshold) : undefined;
    const tickFormattersFactory = (0, $2gcPZ.useMemo)(()=>(xAxis, yAxis)=>({
                xFormatter: (0, $97bfc4b4004b00d4$export$22e93c2cab313942)(xAxis),
                yFormatter: metricType === "latency" ? (0, $97bfc4b4004b00d4$export$7f424ebfd113e8ae)(yAxis) : metricType === "successRate" ? (0, $97bfc4b4004b00d4$export$f4ad2fa17edf39d7)() : (0, $97bfc4b4004b00d4$export$9bc9750a5e6705d)(yAxis)
            }), [
        metricType
    ]);
    const { shouldWaitForBuildInfoInterval: shouldWaitForBuildInfoInterval, buildInfoInterval: buildInfoInterval } = (0, $ebef9a37eb84c991$export$1fe69f4501914576)(instance?.url);
    const chartPromqlQuery = metricType === "successRate" ? (0, $097bfc2d1913d58c$exports).createSloAllFunctionsSuccessRateQuery(objective, timeRange.from, timeRange.to, buildInfoInterval) : metricType === "latency" ? (0, $097bfc2d1913d58c$exports).createSloAllFunctionsLatencyQuery(objective, timeRange.from, timeRange.to, buildInfoInterval) : "";
    const { data: data = $25b31b62eb7c9a96$var$EMPTY_FUNCTIONS_LIST, error: error, isFetching: isFetching, isUninitialized: isUninitialized } = (0, $5755db105caee352$export$c386b48e92fd4ce1)({
        environmentUrl: instance?.url,
        query: chartPromqlQuery,
        start: timeRange.from,
        end: timeRange.to
    }, {
        // HACK - If we don't wait for the build info interval, we can get the "dots and dashes" effect in charts
        skip: shouldWaitForBuildInfoInterval || !chartPromqlQuery
    });
    const throttledIsFetching = (0, $0256cde7569cadc3$export$4083eefea094a0de)(isFetching && isUninitialized, 500);
    const [hiddenTimeseriesKeys, setHiddenTimeseriesKeys] = (0, $2gcPZ.useState)([]);
    const dataWithVisibility = (0, $2gcPZ.useMemo)(()=>{
        return data.map((series)=>{
            const visible = !hiddenTimeseriesKeys.includes($25b31b62eb7c9a96$var$getTimeseriesKey(series));
            return {
                ...series,
                visible: visible
            };
        });
    }, [
        data,
        hiddenTimeseriesKeys
    ]);
    const onToggleTimeseriesVisibility = (0, $cac150ebb620e91f$export$d095b0c879743c0d)(({ timeseries: timeseries })=>{
        const key = $25b31b62eb7c9a96$var$getTimeseriesKey(timeseries);
        if (hiddenTimeseriesKeys.includes($25b31b62eb7c9a96$var$getTimeseriesKey(timeseries))) setHiddenTimeseriesKeys((current)=>current.filter((c)=>c !== key));
        else setHiddenTimeseriesKeys((current)=>[
                ...current,
                key
            ]);
    });
    const { color: { bg: { accent: accent } } } = (0, $4e8e6ea7d6e48c37$export$93d4e7f90805808f)();
    const accentColor = metricType === "successRate" ? accent[2] : accent[3];
    const graphTheme = (0, $583285e3aa4c16bf$export$5cc0dd04debd4b19)(accentColor);
    const [tooltipState, setTooltipState] = (0, $2gcPZ.useState)(null);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($25b31b62eb7c9a96$var$GraphContainer, {
        children: isUninitialized ? null : throttledIsFetching ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $c624abcc931dc034$export$bd7370ffb2917ab7), {
            children: [
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($25b31b62eb7c9a96$var$Title, {
                    children: [
                        metricType === "successRate" ? "Success rate" : "Latency",
                        " by function"
                    ]
                }),
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($25b31b62eb7c9a96$var$SkeletonGraphContainer, {})
            ]
        }, "sloDetailGraphIsLoading") : error ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $c624abcc931dc034$export$bd7370ffb2917ab7), {
            children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $7f2b92de158af7af$export$5eef44829f72c6d0), {})
        }, "sloDetailGraphError") : /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $afa7be861492543f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($25b31b62eb7c9a96$var$Title, {
                    children: [
                        metricType === "successRate" ? "Success rate" : "Latency",
                        " by function"
                    ]
                }),
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($25b31b62eb7c9a96$var$StyledPopIn, {
                    children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($25b31b62eb7c9a96$var$GraphWrapper, {
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $97bfc4b4004b00d4$export$f4cb11be864d0ce5), {
                                chartTheme: graphTheme,
                                areaGradientShown: dataWithVisibility.length < 5,
                                graphType: "line",
                                stackingType: "none",
                                timeRange: timeRange,
                                timeseriesData: dataWithVisibility,
                                onChangeTimeRange: (newTimeRange)=>{
                                    onChangeTimeRange(newTimeRange);
                                },
                                onToggleTimeseriesVisibility: onToggleTimeseriesVisibility,
                                footerShown: false,
                                tickFormatters: tickFormattersFactory,
                                targetLatency: targetLatency,
                                showTooltip: (anchor, [series, point])=>{
                                    if (point) setTooltipState({
                                        anchor: ()=>anchor,
                                        content: ()=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $b7b57423e9554b4f$export$1190a21963505760), {
                                                content: [
                                                    series,
                                                    point
                                                ]
                                            }),
                                        options: {
                                            placement: "top"
                                        }
                                    });
                                    return ()=>setTooltipState(null);
                                },
                                shouldAnimateYScale: false
                            }),
                            tooltipState && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $26aff4842955852f$export$28c660c63b792dea), {
                                tip: tooltipState
                            }),
                            dataWithVisibility && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $df0358d28239ecdc$export$4cf474b72a9918be), {})
                        ]
                    })
                }, "sloDetailGraph"),
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($25b31b62eb7c9a96$var$SelectionInfo, {
                    children: [
                        data.length - hiddenTimeseriesKeys.length,
                        " out of ",
                        data.length,
                        " ",
                        "selected"
                    ]
                })
            ]
        })
    });
}
function $25b31b62eb7c9a96$var$getTimeseriesKey(timeseries) {
    return Object.entries(timeseries.labels).map((series)=>series.join(":")).join("/");
}
const $25b31b62eb7c9a96$var$SkeletonGraphContainer = ()=>{
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($25b31b62eb7c9a96$var$SkeletonGraphGrid, {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($25b31b62eb7c9a96$var$SkeletonYAxis, {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($25b31b62eb7c9a96$var$SkeletonYAxisLabel, {}),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($25b31b62eb7c9a96$var$SkeletonYAxisLabel, {}),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($25b31b62eb7c9a96$var$SkeletonYAxisLabel, {}),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($25b31b62eb7c9a96$var$SkeletonYAxisLabel, {}),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($25b31b62eb7c9a96$var$SkeletonYAxisLabel, {}),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($25b31b62eb7c9a96$var$SkeletonYAxisLabel, {}),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($25b31b62eb7c9a96$var$SkeletonYAxisLabel, {}),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($25b31b62eb7c9a96$var$SkeletonYAxisLabel, {})
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($25b31b62eb7c9a96$var$SkeletonGraph, {})
        ]
    });
};
const $25b31b62eb7c9a96$var$SkeletonGraphGrid = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  min-height: 290px;
  padding: 16px 0;
`;
const $25b31b62eb7c9a96$var$SkeletonYAxis = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 48px;
  padding: 8px 0;
`;
const $25b31b62eb7c9a96$var$SkeletonYAxisLabel = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $030f7a5c323de541$export$8f31e4c4a37b8e9c))`
  min-height: 20px;
`;
const $25b31b62eb7c9a96$var$SkeletonGraph = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $030f7a5c323de541$export$8f31e4c4a37b8e9c))`
  flex-grow: 1;
  margin-left: 20px;
`;
const $25b31b62eb7c9a96$var$GraphContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $004ac84570f5b12e$export$8a23e74e5cf3ca41))`
  padding: 16px 12px 12px;
`;
const $25b31b62eb7c9a96$var$Title = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $004ac84570f5b12e$export$474db65c3c394e1c))`
  margin-bottom: 16px;
`;
const $25b31b62eb7c9a96$var$StyledPopIn = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $1f0ff5a61e121104$export$7bd61839e455449b))`
  /* Prevent grid overflow by setting min-width */
  min-width: 0;
`;
const $25b31b62eb7c9a96$var$GraphWrapper = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  position: relative;
  /* Prevent grid overflow by setting min-width */
  min-width: 0;
`;
const $25b31b62eb7c9a96$var$SelectionInfo = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).footer(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      border-top: 1px solid ${theme.color.border.default};
      margin: 12px 8px 0;
      padding-top: 12px;
      font: ${theme.font.body.sm.regular};
    `);







function $3de6122f72e257c2$export$aa575b030e88811b({ objective: objective }) {
    const metricLabel = objective?.metric === "latency" ? "Latency" : objective?.metric === "successRate" ? "Success rate" : "Objective";
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $004ac84570f5b12e$export$8a23e74e5cf3ca41), {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $004ac84570f5b12e$export$474db65c3c394e1c), {
                children: [
                    metricLabel,
                    " (current)"
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $004ac84570f5b12e$export$cf0f153eb3e3f6ce), {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $004ac84570f5b12e$export$5062880c778c5dd2), {
                        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $1f0ff5a61e121104$export$7bd61839e455449b), {
                            children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $b332f5ae35e8a73c$export$f1e87ebd9c598b0d), {
                                currentValue: objective.currentValue,
                                objective: objective,
                                highlightSuccess: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $004ac84570f5b12e$export$ae408d4ba7217daa), {
                        children: [
                            "Target: ",
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $8541b3b9bd182188$export$bf99d7e08aaeb9bb), {
                                objective: objective
                            })
                        ]
                    })
                ]
            })
        ]
    });
}





var $eVLAC = parcelRequire("eVLAC");



function $9a7a8588cad18185$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $c6496b0e113bd4b1$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $238651ed35bf02ba$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $90191f823867d8d7$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}





function $7c0ae31c33749239$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $c6496b0e113bd4b1$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $238651ed35bf02ba$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $90191f823867d8d7$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}





function $ec8b69573f7d2be1$export$2e2bcd8739ae039(dirtyDate, duration) {
    (0, $c6496b0e113bd4b1$export$2e2bcd8739ae039)(2, arguments);
    if (!duration || (0, $eVLAC.default)(duration) !== "object") return new Date(NaN);
    var years = duration.years ? (0, $90191f823867d8d7$export$2e2bcd8739ae039)(duration.years) : 0;
    var months = duration.months ? (0, $90191f823867d8d7$export$2e2bcd8739ae039)(duration.months) : 0;
    var weeks = duration.weeks ? (0, $90191f823867d8d7$export$2e2bcd8739ae039)(duration.weeks) : 0;
    var days = duration.days ? (0, $90191f823867d8d7$export$2e2bcd8739ae039)(duration.days) : 0;
    var hours = duration.hours ? (0, $90191f823867d8d7$export$2e2bcd8739ae039)(duration.hours) : 0;
    var minutes = duration.minutes ? (0, $90191f823867d8d7$export$2e2bcd8739ae039)(duration.minutes) : 0;
    var seconds = duration.seconds ? (0, $90191f823867d8d7$export$2e2bcd8739ae039)(duration.seconds) : 0;
    // Add years and months
    var date = (0, $238651ed35bf02ba$export$2e2bcd8739ae039)(dirtyDate);
    var dateWithMonths = months || years ? (0, $7c0ae31c33749239$export$2e2bcd8739ae039)(date, months + years * 12) : date;
    // Add weeks and days
    var dateWithDays = days || weeks ? (0, $9a7a8588cad18185$export$2e2bcd8739ae039)(dateWithMonths, days + weeks * 7) : dateWithMonths;
    // Add days, hours, minutes and seconds
    var minutesToAdd = minutes + hours * 60;
    var secondsToAdd = seconds + minutesToAdd * 60;
    var msToAdd = secondsToAdd * 1000;
    var finalDate = new Date(dateWithDays.getTime() + msToAdd);
    return finalDate;
}




function $c85a5bdc12429670$export$2e2bcd8739ae039(date, options) {
    var _options$format, _options$representati;
    (0, $c6496b0e113bd4b1$export$2e2bcd8739ae039)(1, arguments);
    var originalDate = (0, $238651ed35bf02ba$export$2e2bcd8739ae039)(date);
    if (isNaN(originalDate.getTime())) throw new RangeError("Invalid time value");
    var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : "extended");
    var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : "complete");
    if (format !== "extended" && format !== "basic") throw new RangeError("format must be 'extended' or 'basic'");
    if (representation !== "date" && representation !== "time" && representation !== "complete") throw new RangeError("representation must be 'date', 'time', or 'complete'");
    var result = "";
    var tzOffset = "";
    var dateDelimiter = format === "extended" ? "-" : "";
    var timeDelimiter = format === "extended" ? ":" : "";
    // Representation is either 'date' or 'complete'
    if (representation !== "time") {
        var day = (0, $1a383fa7811d41a7$export$2e2bcd8739ae039)(originalDate.getDate(), 2);
        var month = (0, $1a383fa7811d41a7$export$2e2bcd8739ae039)(originalDate.getMonth() + 1, 2);
        var year = (0, $1a383fa7811d41a7$export$2e2bcd8739ae039)(originalDate.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
    }
    // Representation is either 'time' or 'complete'
    if (representation !== "date") {
        // Add the timezone.
        var offset = originalDate.getTimezoneOffset();
        if (offset !== 0) {
            var absoluteOffset = Math.abs(offset);
            var hourOffset = (0, $1a383fa7811d41a7$export$2e2bcd8739ae039)(Math.floor(absoluteOffset / 60), 2);
            var minuteOffset = (0, $1a383fa7811d41a7$export$2e2bcd8739ae039)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            var sign = offset < 0 ? "+" : "-";
            tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
        } else tzOffset = "Z";
        var hour = (0, $1a383fa7811d41a7$export$2e2bcd8739ae039)(originalDate.getHours(), 2);
        var minute = (0, $1a383fa7811d41a7$export$2e2bcd8739ae039)(originalDate.getMinutes(), 2);
        var second = (0, $1a383fa7811d41a7$export$2e2bcd8739ae039)(originalDate.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        var separator = result === "" ? "" : "T";
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        var time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
    }
    return result;
}


var $eVLAC = parcelRequire("eVLAC");





function $93d83c664d15e6bf$export$2e2bcd8739ae039(dirtyDate) {
    (0, $c6496b0e113bd4b1$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $238651ed35bf02ba$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}



function $5253e219be62e9ed$export$2e2bcd8739ae039(dirtyDate, dirtyMonth) {
    (0, $c6496b0e113bd4b1$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $238651ed35bf02ba$export$2e2bcd8739ae039)(dirtyDate);
    var month = (0, $90191f823867d8d7$export$2e2bcd8739ae039)(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, $93d83c664d15e6bf$export$2e2bcd8739ae039)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
}




function $98687327f8bc711d$export$2e2bcd8739ae039(dirtyDate, values) {
    (0, $c6496b0e113bd4b1$export$2e2bcd8739ae039)(2, arguments);
    if ((0, $eVLAC.default)(values) !== "object" || values === null) throw new RangeError("values parameter must be an object");
    var date = (0, $238651ed35bf02ba$export$2e2bcd8739ae039)(dirtyDate);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    if (values.year != null) date.setFullYear(values.year);
    if (values.month != null) date = (0, $5253e219be62e9ed$export$2e2bcd8739ae039)(date, values.month);
    if (values.date != null) date.setDate((0, $90191f823867d8d7$export$2e2bcd8739ae039)(values.date));
    if (values.hours != null) date.setHours((0, $90191f823867d8d7$export$2e2bcd8739ae039)(values.hours));
    if (values.minutes != null) date.setMinutes((0, $90191f823867d8d7$export$2e2bcd8739ae039)(values.minutes));
    if (values.seconds != null) date.setSeconds((0, $90191f823867d8d7$export$2e2bcd8739ae039)(values.seconds));
    if (values.milliseconds != null) date.setMilliseconds((0, $90191f823867d8d7$export$2e2bcd8739ae039)(values.milliseconds));
    return date;
}













function $cce4dfc281113044$export$523f9cfce937b192({ objective: objective }) {
    const instance = (0, $1a280fbaa3fcabb5$export$2105062e25df4afe)((0, $14bbd07b3011052f$export$919b3065fd27c3a8));
    const today = (0, $98687327f8bc711d$export$2e2bcd8739ae039)(new Date(), {
        hours: 23,
        minutes: 59,
        seconds: 59
    });
    const start = (0, $c85a5bdc12429670$export$2e2bcd8739ae039)((0, $ec8b69573f7d2be1$export$2e2bcd8739ae039)(today, {
        days: -30
    }));
    const end = (0, $c85a5bdc12429670$export$2e2bcd8739ae039)(today);
    const { data: data, error: error, isFetching: isFetching, isUninitialized: isUninitialized } = (0, $81accdab4a22bb8e$export$a6442cc80badd0c3)({
        objective: objective,
        environmentUrl: instance?.url,
        start: start,
        end: end
    }, {
        skip: !instance
    });
    // Use a throttled loading state to avoid too much of a flash-in when data loads quickly
    const throttledIsFetching = (0, $0256cde7569cadc3$export$4083eefea094a0de)(isFetching, 250);
    const metricLabel = objective?.metric === "latency" ? "Latency" : objective?.metric === "successRate" ? "Success rate" : "Objective";
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $004ac84570f5b12e$export$8a23e74e5cf3ca41), {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $004ac84570f5b12e$export$474db65c3c394e1c), {
                children: [
                    metricLabel,
                    " (30 Days)",
                    "",
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($cce4dfc281113044$var$CardTitleLabel, {
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($cce4dfc281113044$var$CardTitleIcon, {
                                type: "lock_key"
                            }),
                            "Last 30 days"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $004ac84570f5b12e$export$cf0f153eb3e3f6ce), {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $004ac84570f5b12e$export$5062880c778c5dd2), {
                        children: isUninitialized ? null : throttledIsFetching ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $c624abcc931dc034$export$bd7370ffb2917ab7), {
                            children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($cce4dfc281113044$var$StyledShimmer, {
                                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $8541b3b9bd182188$export$bf99d7e08aaeb9bb), {
                                    objective: objective
                                })
                            })
                        }) : error ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $1f0ff5a61e121104$export$7bd61839e455449b), {
                            children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($cce4dfc281113044$var$ErrorSpan, {
                                children: "Error"
                            })
                        }) : data ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $1f0ff5a61e121104$export$7bd61839e455449b), {
                            children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $b332f5ae35e8a73c$export$f1e87ebd9c598b0d), {
                                currentValue: data.currentValue,
                                objective: objective,
                                highlightSuccess: true
                            })
                        }) : null
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $004ac84570f5b12e$export$ae408d4ba7217daa), {
                        children: [
                            "Target: ",
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $8541b3b9bd182188$export$bf99d7e08aaeb9bb), {
                                objective: objective
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
const $cce4dfc281113044$var$CardTitleLabel = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).span(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      margin-left: auto;
      display: inline-flex;
      padding: 2px 8px;
      justify-content: center;
      align-items: center;
      gap: 4px;
      border-radius: ${theme.radius.minimal};
      background: linear-gradient(
        90deg,
        ${theme.color.bg.accent[3]} 0%,
        ${theme.color.bg.accent[2]} 52.08%,
        ${theme.color.bg.accent[1]} 100%
      );
      color: ${theme.color.fg.onemphasis.default};
      text-align: center;
      font-family: Inter;
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: 16px;
    `);
const $cce4dfc281113044$var$CardTitleIcon = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $0a830394bc38e4e3$export$f04a61298a47a40f))`
  width: 12px;
  height: 12px;
`;
const $cce4dfc281113044$var$ErrorSpan = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).span`
  color: ${({ theme: theme })=>theme.color.fg.danger};
`;
const $cce4dfc281113044$var$StyledShimmer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $030f7a5c323de541$export$8f31e4c4a37b8e9c))`
  color: transparent;
`;


function $7ee161e0e8fe7b1c$export$a05aa9aaead79c76({ timeRange: timeRange, onChangeTimeRange: onChangeTimeRange }) {
    const instance = (0, $1a280fbaa3fcabb5$export$2105062e25df4afe)((0, $14bbd07b3011052f$export$919b3065fd27c3a8));
    const { objectiveName: objectiveName, metricType: metricType } = (0, $efeb47d767416279$export$99eaa27ddbbb95ef)();
    // OPTIMIZE: - If there were a lot of objectives, this would be making many unnecessary requests
    const { data: objective, error: error, isFetching: isFetching } = (0, $81accdab4a22bb8e$export$117f4f94ea08f791)({
        environmentUrl: instance?.url,
        start: timeRange.from,
        end: timeRange.to
    }, {
        skip: !objectiveName,
        selectFromResult: ({ data: data, ...rest })=>({
                data: data && data.find(({ name: name, metric: metric })=>name === objectiveName && metric === metricType),
                ...rest
            })
    });
    // Use a throttled loading state to avoid too much of a flash-in when data loads quickly
    const throttledIsFetching = (0, $0256cde7569cadc3$export$4083eefea094a0de)(isFetching && objective === undefined, 250);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $afa7be861492543f$exports.Fragment), {
        children: throttledIsFetching ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $c624abcc931dc034$export$bd7370ffb2917ab7), {
            children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $58fc4bbaeff94670$export$669f6ea7d267feaf), {})
        }, "sloDetailIsLoading") : error ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $c624abcc931dc034$export$bd7370ffb2917ab7), {
            children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $7f2b92de158af7af$export$5eef44829f72c6d0), {})
        }, "sloDetailError") : objective ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $afa7be861492543f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($7ee161e0e8fe7b1c$var$Grid, {
                    children: [
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $3de6122f72e257c2$export$aa575b030e88811b), {
                            objective: objective
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $cce4dfc281113044$export$523f9cfce937b192), {
                            objective: objective
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $25b31b62eb7c9a96$export$614db49f3febe941), {
                            objective: objective,
                            timeRange: timeRange,
                            onChangeTimeRange: onChangeTimeRange
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0573cdab17511c26$export$6eba55a6a7b954bf), {
                    objective: objective,
                    timeRange: timeRange
                })
            ]
        }) : /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $c624abcc931dc034$export$bd7370ffb2917ab7), {
            children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $99643ce9709efb50$export$bd8705ca756a6606), {
                objectiveName: objectiveName
            })
        }, "sloDetailEmptyState")
    });
}
const $7ee161e0e8fe7b1c$var$Grid = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(3, auto);
  gap: 16px 12px;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, auto);

    ${(0, $004ac84570f5b12e$export$8a23e74e5cf3ca41)}:nth-of-type(3) {
      grid-column: 1 / 3;
    }
  }
`;











var $2gcPZ = parcelRequire("2gcPZ");










var $2gcPZ = parcelRequire("2gcPZ");



(function(Prism1) {
    var multilineComment = /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\//.source;
    for(var i = 0; i < 2; i++)// support 4 levels of nested comments
    multilineComment = multilineComment.replace(/<self>/g, function() {
        return multilineComment;
    });
    multilineComment = multilineComment.replace(/<self>/g, function() {
        return /[^\s\S]/.source;
    });
    Prism1.languages.rust = {
        "comment": [
            {
                pattern: RegExp(/(^|[^\\])/.source + multilineComment),
                lookbehind: true,
                greedy: true
            },
            {
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        "string": {
            pattern: /b?"(?:\\[\s\S]|[^\\"])*"|b?r(#*)"(?:[^"]|"(?!\1))*"\1/,
            greedy: true
        },
        "char": {
            pattern: /b?'(?:\\(?:x[0-7][\da-fA-F]|u\{(?:[\da-fA-F]_*){1,6}\}|.)|[^\\\r\n\t'])'/,
            greedy: true
        },
        "attribute": {
            pattern: /#!?\[(?:[^\[\]"]|"(?:\\[\s\S]|[^\\"])*")*\]/,
            greedy: true,
            alias: "attr-name",
            inside: {
                "string": null // see below
            }
        },
        // Closure params should not be confused with bitwise OR |
        "closure-params": {
            pattern: /([=(,:]\s*|\bmove\s*)\|[^|]*\||\|[^|]*\|(?=\s*(?:\{|->))/,
            lookbehind: true,
            greedy: true,
            inside: {
                "closure-punctuation": {
                    pattern: /^\||\|$/,
                    alias: "punctuation"
                },
                rest: null // see below
            }
        },
        "lifetime-annotation": {
            pattern: /'\w+/,
            alias: "symbol"
        },
        "fragment-specifier": {
            pattern: /(\$\w+:)[a-z]+/,
            lookbehind: true,
            alias: "punctuation"
        },
        "variable": /\$\w+/,
        "function-definition": {
            pattern: /(\bfn\s+)\w+/,
            lookbehind: true,
            alias: "function"
        },
        "type-definition": {
            pattern: /(\b(?:enum|struct|trait|type|union)\s+)\w+/,
            lookbehind: true,
            alias: "class-name"
        },
        "module-declaration": [
            {
                pattern: /(\b(?:crate|mod)\s+)[a-z][a-z_\d]*/,
                lookbehind: true,
                alias: "namespace"
            },
            {
                pattern: /(\b(?:crate|self|super)\s*)::\s*[a-z][a-z_\d]*\b(?:\s*::(?:\s*[a-z][a-z_\d]*\s*::)*)?/,
                lookbehind: true,
                alias: "namespace",
                inside: {
                    "punctuation": /::/
                }
            }
        ],
        "keyword": [
            // https://github.com/rust-lang/reference/blob/master/src/keywords.md
            /\b(?:Self|abstract|as|async|await|become|box|break|const|continue|crate|do|dyn|else|enum|extern|final|fn|for|if|impl|in|let|loop|macro|match|mod|move|mut|override|priv|pub|ref|return|self|static|struct|super|trait|try|type|typeof|union|unsafe|unsized|use|virtual|where|while|yield)\b/,
            // primitives and str
            // https://doc.rust-lang.org/stable/rust-by-example/primitives.html
            /\b(?:bool|char|f(?:32|64)|[ui](?:8|16|32|64|128|size)|str)\b/
        ],
        // functions can technically start with an upper-case letter, but this will introduce a lot of false positives
        // and Rust's naming conventions recommend snake_case anyway.
        // https://doc.rust-lang.org/1.0.0/style/style/naming/README.html
        "function": /\b[a-z_]\w*(?=\s*(?:::\s*<|\())/,
        "macro": {
            pattern: /\b\w+!/,
            alias: "property"
        },
        "constant": /\b[A-Z_][A-Z_\d]+\b/,
        "class-name": /\b[A-Z]\w*\b/,
        "namespace": {
            pattern: /(?:\b[a-z][a-z_\d]*\s*::\s*)*\b[a-z][a-z_\d]*\s*::(?!\s*<)/,
            inside: {
                "punctuation": /::/
            }
        },
        // Hex, oct, bin, dec numbers with visual separators and type suffix
        "number": /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0o[0-7](?:_?[0-7])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)(?:_?(?:f32|f64|[iu](?:8|16|32|64|size)?))?\b/,
        "boolean": /\b(?:false|true)\b/,
        "punctuation": /->|\.\.=|\.{1,3}|::|[{}[\];(),:]/,
        "operator": /[-+*\/%!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?=?|[@?]/
    };
    Prism1.languages.rust["closure-params"].inside.rest = Prism1.languages.rust;
    Prism1.languages.rust["attribute"].inside["string"] = Prism1.languages.rust["string"];
})(Prism);




function $7a6e31e113a87bc5$export$98d245bf919adcba() {
    return `
use autometrics::autometrics;
use autometrics::objectives::{
  Objective, ObjectiveLatency, ObjectivePercentile
};

const API_SLO: Objective = Objective::new("api") 
    .success_rate(ObjectivePercentile::P99_9)
    .latency(ObjectiveLatency::Ms250, ObjectivePercentile::P99);

#[autometrics(objective = API_SLO)]
pub fn my_api_handler() {
    // ...
}
`.trim();
}
function $7a6e31e113a87bc5$export$a3965aad6c505dc7() {
    return `
import {
  autometrics,
  Objective,
  ObjectiveLatency,
  ObjectivePercentile
} from "@autometrics/autometrics";
 
const API_SLO: Objective = {
  name: "api",
  successRate: ObjectivePercentile.P99_9,
  latency: [ObjectiveLatency.Ms250, ObjectivePercentile.P99],
};
 
const handler = autometrics(
  { objective: API_SLO },
  function handle(
    // ...
  )
);
`.trim();
}
function $7a6e31e113a87bc5$export$8953cb6e31f30d51() {
    return `
//autometrics:inst --slo "Api" --success-target 90
func RouteHandler(args interface{}) (err error) {
    // ...
    return nil
}
`.trim();
}
function $7a6e31e113a87bc5$export$c232aff1845971ef() {
    return `
from autometrics import autometrics
from autometrics.objectives import (
    Objective, ObjectiveLatency, ObjectivePercentile
)
 
API_SLO = Objective(
    "api_slo",
    success_rate=ObjectivePercentile.P99_9,
    latency=(ObjectiveLatency.Ms250, ObjectivePercentile.P99),
)
 
@autometrics(objective=API_SLO)
def create_user():
    # ...
`.trim();
}


const { rust: $ab2aebcc0b27402e$var$rust } = (0, (/*@__PURE__*/$parcel$interopDefault($9bcc877a156e04f6$exports))).languages;
if (!$ab2aebcc0b27402e$var$rust) throw new Error("Rust syntax not defined");
const $ab2aebcc0b27402e$var$grammar = $ab2aebcc0b27402e$var$rust;
const $ab2aebcc0b27402e$export$add30503fbf3880e = ()=>{
    const [language, setLanguage] = (0, $2gcPZ.useState)("rust");
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $afa7be861492543f$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($ab2aebcc0b27402e$var$CodeSampleSelector, {
                language: language,
                setLanguage: setLanguage
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($ab2aebcc0b27402e$var$CodeSample, {
                language: language
            })
        ]
    });
};
const $ab2aebcc0b27402e$var$CodeSampleSelector = ({ language: language, setLanguage: setLanguage })=>{
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($ab2aebcc0b27402e$var$LanguageButtonGroupContainer, {
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($ab2aebcc0b27402e$var$LanguageButtonGroup, {
            children: [
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a921dfdbd8dd60fa$export$353f5b6fc5456de1), {
                    buttonStyle: language === "rust" ? "primary" : "secondary",
                    onClick: ()=>setLanguage("rust"),
                    children: "Rust"
                }),
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a921dfdbd8dd60fa$export$353f5b6fc5456de1), {
                    buttonStyle: language === "typescript" ? "primary" : "secondary",
                    onClick: ()=>setLanguage("typescript"),
                    children: "TypeScript"
                }),
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a921dfdbd8dd60fa$export$353f5b6fc5456de1), {
                    buttonStyle: language === "python" ? "primary" : "secondary",
                    onClick: ()=>setLanguage("python"),
                    children: "Python"
                }),
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a921dfdbd8dd60fa$export$353f5b6fc5456de1), {
                    buttonStyle: language === "go" ? "primary" : "secondary",
                    onClick: ()=>setLanguage("go"),
                    children: "Go"
                })
            ]
        })
    });
};
const $ab2aebcc0b27402e$var$CodeSample = ({ language: language })=>{
    let text;
    switch(language){
        case "rust":
            text = (0, $7a6e31e113a87bc5$export$98d245bf919adcba)();
            break;
        case "python":
            text = (0, $7a6e31e113a87bc5$export$c232aff1845971ef)();
            break;
        case "go":
            text = (0, $7a6e31e113a87bc5$export$8953cb6e31f30d51)();
            break;
        case "typescript":
            text = (0, $7a6e31e113a87bc5$export$a3965aad6c505dc7)();
            break;
    }
    const { isCopied: isCopied, handleCopy: handleCopy } = (0, $cd24a65f0e0ab1ba$export$b2199c37e85de4a7)(()=>text);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($ab2aebcc0b27402e$var$Container, {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($ab2aebcc0b27402e$var$CopyButton, {
                disabled: isCopied,
                onClick: handleCopy,
                children: isCopied ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $afa7be861492543f$exports.Fragment), {
                    children: [
                        " ",
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0a830394bc38e4e3$export$f04a61298a47a40f), {
                            type: "check"
                        }),
                        "Copied"
                    ]
                }) : /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $afa7be861492543f$exports.Fragment), {
                    children: [
                        " ",
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0a830394bc38e4e3$export$f04a61298a47a40f), {
                            type: "copy"
                        }),
                        "Copy"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("pre", {
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("code", {
                    className: "language-autometrics",
                    dangerouslySetInnerHTML: {
                        __html: (0, (/*@__PURE__*/$parcel$interopDefault($9bcc877a156e04f6$exports))).highlight(text, $ab2aebcc0b27402e$var$grammar, language)
                    }
                })
            })
        ]
    });
};
const $ab2aebcc0b27402e$var$Container = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    background-color: ${theme.color.bg.subtle};
    border-radius: ${theme.radius.rounded};
    padding: 12px;
    position: relative;
    margin: 0 auto;

    /* HACK - code samples have been optimized for 600px */
    @media (min-width: 600px) {
      width: 600px;
    }

    pre {
      overflow-x: auto;
      white-space: nowrap;
    }

    pre,
    code {
      background-color: ${theme.color.bg.subtle};
      text-shadow: 0 1px ${theme.color.bg.default};

      transition: background-color 0.2s ease-in-out;
    }

    code[class*="language-"],
    pre[class*="language-"] {
      color: ${theme.color.fg.default};
    }

    .language-autometrics {
      .token.punctuation {
        color: ${theme.color.fg.default};
      }

      .token.function {
        color: ${theme.color.fg.primary};
      }
      .token.keyword {
        color: ${theme.color.fg.primary};
      }

      .token.string {
        color: ${theme.color.fg.accent[1]};
      }

      .token.class-name {
        color: ${theme.color.fg.default};
      }
      .token.constant {
        color: ${theme.color.fg.default};
      }

      .token.function-definition.function {
        color: ${theme.color.fg.accent[2]};
      }

      .token.namespace {
        color: ${theme.color.fg.accent[3]};
      }

      .token.attribute.attr-name {
        color: ${theme.color.fg.default};
      }

      .token.number {
        color: ${theme.color.fg.accent[1]};
      }

      .token.operator {
        background-color: transparent;
        color: ${theme.color.fg.default};
      }
    }
  `);
const $ab2aebcc0b27402e$var$CopyButton = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $a921dfdbd8dd60fa$export$353f5b6fc5456de1))(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    position: absolute;
    top: 0;
    right: 0;
    margin: 8px;
    padding: 4px 8px;
    font-size: 12px;
    border-radius: ${theme.radius.minimal};
    background-color: ${theme.color.bg.default};
    color: ${theme.color.fg.default};
    border: 1px solid ${theme.color.bg.subtle};

    display: flex;
    align-items: center;
    gap: 4px;

    &:hover {
      background-color: ${theme.color.bg.hover};
    }
  `);
const $ab2aebcc0b27402e$var$LanguageButtonGroupContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: center;
`;
const $ab2aebcc0b27402e$var$LanguageButtonGroup = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    display: inline-flex;
    gap: 4px;
    padding: 4px;
    border-radius: ${theme.radius.default};
    background-color: ${theme.color.bg.subtle};
  `);


const { Container: $a76aa824193173e3$var$Container, Content: $a76aa824193173e3$var$Content, Header: $a76aa824193173e3$var$Header, Heading: $a76aa824193173e3$var$Heading, HelperText: $a76aa824193173e3$var$HelperText, BigIcon: $a76aa824193173e3$var$BigIcon } = (0, $0c5c766c1e242605$exports);
function $a76aa824193173e3$export$906a2ccca5d2a479() {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($a76aa824193173e3$var$StyledContainer, {
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($a76aa824193173e3$var$StyledContent, {
            children: [
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($a76aa824193173e3$var$Header, {
                    children: [
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($a76aa824193173e3$var$BigIcon, {
                            type: "autometrics_black_faded"
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($a76aa824193173e3$var$Heading, {
                            children: "No SLOs Found"
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($a76aa824193173e3$var$HelperText, {
                            children: [
                                "SLOs (Service Level Objectives) are performance promises made by a service or system. Read more about SLOs in the",
                                " ",
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("a", {
                                    href: "https://docs.autometrics.dev/features#alerts-and-slos-without-yaml",
                                    target: "_blank",
                                    rel: "noreferrer noopener",
                                    children: "documentation"
                                }),
                                ", or try one of the code samples below."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $ab2aebcc0b27402e$export$add30503fbf3880e), {})
            ]
        })
    });
}
const $a76aa824193173e3$var$StyledContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)($a76aa824193173e3$var$Container)`
  height: 100%;
  min-height: 400px;
  align-items: flex-start;
  padding: 72px 0;
`;
const $a76aa824193173e3$var$StyledContent = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)($a76aa824193173e3$var$Content)`
  max-width: 640px;
  display: flex;
  flex-direction: column;
  gap: 32px;
`;














const { Container: $784d3423da3bef2a$var$Container, Content: $784d3423da3bef2a$var$Content, Header: $784d3423da3bef2a$var$Header, Heading: $784d3423da3bef2a$var$Heading, BigIcon: $784d3423da3bef2a$var$BigIcon } = (0, $0c5c766c1e242605$exports);
function $784d3423da3bef2a$export$82dd68b50c353d5c({ resetFilters: resetFilters }) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($784d3423da3bef2a$var$StyledContainer, {
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($784d3423da3bef2a$var$StyledContent, {
            children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($784d3423da3bef2a$var$Header, {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($784d3423da3bef2a$var$BigIcon, {
                        type: "autometrics_black_faded"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($784d3423da3bef2a$var$Heading, {
                        children: "No SLOs match your filters"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a921dfdbd8dd60fa$export$353f5b6fc5456de1), {
                        onClick: resetFilters,
                        children: "Reset filters"
                    })
                ]
            })
        })
    });
}
const $784d3423da3bef2a$var$StyledContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)($784d3423da3bef2a$var$Container)`
  height: 100%;
  min-height: 400px;
  align-items: flex-start;
`;
const $784d3423da3bef2a$var$StyledContent = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)($784d3423da3bef2a$var$Content)`
  max-width: 640px;
  display: flex;
  flex-direction: column;
  gap: 32px;
`;


const $a514c7dbd4ee6ba5$var$EMPTY_SLO_LIST = [];
const $a514c7dbd4ee6ba5$var$columnHelper = (0, $93a274dd46b4c3ff$export$4b44a5cb9651fe5e)();
const $a514c7dbd4ee6ba5$var$columns = [
    $a514c7dbd4ee6ba5$var$columnHelper.accessor("name", {
        cell: (cellContext)=>cellContext.getValue(),
        header: "Name"
    }),
    $a514c7dbd4ee6ba5$var$columnHelper.accessor("metric", {
        cell: (cellContext)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $4b2588c47e3149e9$export$d2dff97f035be373), {
                metric: cellContext.getValue()
            }),
        header: "Metric"
    }),
    $a514c7dbd4ee6ba5$var$columnHelper.accessor("functionsCount", {
        cell: (cellContext)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($a514c7dbd4ee6ba5$var$FunctionsCountLabel, {
                children: cellContext.getValue()
            }),
        header: "# Functions"
    }),
    $a514c7dbd4ee6ba5$var$columnHelper.accessor("target", {
        cell: (cellContext)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $8541b3b9bd182188$export$bf99d7e08aaeb9bb), {
                objective: cellContext.row.original
            }),
        header: "Target"
    }),
    $a514c7dbd4ee6ba5$var$columnHelper.accessor("currentValue", {
        cell: (cellContext)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $b332f5ae35e8a73c$export$f1e87ebd9c598b0d), {
                currentValue: cellContext.getValue(),
                objective: cellContext.row.original
            }),
        header: "Actual"
    })
];
function $a514c7dbd4ee6ba5$export$a9c14ed1269e6127({ timeRange: timeRange }) {
    const [searchParams] = (0, $e7b98158099ae00d$export$f1a78c17382fe22a)();
    const navigate = (0, $efeb47d767416279$export$9770f232ac06a008)();
    const instance = (0, $1a280fbaa3fcabb5$export$2105062e25df4afe)((0, $14bbd07b3011052f$export$919b3065fd27c3a8));
    const { data: data = $a514c7dbd4ee6ba5$var$EMPTY_SLO_LIST, error: error, isLoading: isLoading, isFetching: isFetching, isUninitialized: isUninitialized } = (0, $81accdab4a22bb8e$export$117f4f94ea08f791)({
        environmentUrl: instance?.url,
        start: timeRange.from,
        end: timeRange.to
    }, {
        skip: !instance?.url
    });
    const throttledIsLoading = (0, $0256cde7569cadc3$export$4083eefea094a0de)(isLoading || isFetching, 1500);
    const [metricFilter, setMetricFilter] = (0, $2gcPZ.useState)("all");
    const [targetFilter, setTargetFilter] = (0, $2gcPZ.useState)("all");
    const resetFilters = ()=>{
        setMetricFilter("all");
        setTargetFilter("all");
    };
    const filteredData = (0, $2gcPZ.useMemo)(()=>{
        return data.filter((objective)=>{
            const matchesMetricFilter = metricFilter === "all" || metricFilter === objective.metric;
            let matchesTargetFilter = true;
            const isViolating = (0, $18c515912ab80737$export$76dcc15228d30015)(objective, objective.currentValue);
            if (targetFilter === "onTarget") matchesTargetFilter = !isViolating;
            else if (targetFilter === "offTarget") matchesTargetFilter = isViolating;
            return matchesMetricFilter && matchesTargetFilter;
        });
    }, [
        data,
        metricFilter,
        targetFilter
    ]);
    const isEmpty = data.length === 0;
    const isEmptyFiltered = filteredData.length === 0;
    if (isUninitialized) return null;
    if (error) return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $c624abcc931dc034$export$bd7370ffb2917ab7), {
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $7f2b92de158af7af$export$5eef44829f72c6d0), {})
    }, "sloOverviewError");
    if (!throttledIsLoading && isEmpty) return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $c624abcc931dc034$export$bd7370ffb2917ab7), {
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a76aa824193173e3$export$906a2ccca5d2a479), {})
    }, "sloOverviewEmptyState");
    // NOTE - we render `null` when uninitialized to accomodate funkiness of using
    // AnimatePresence with our routing
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($a514c7dbd4ee6ba5$var$Container, {
        initial: "initial",
        animate: "in",
        exit: "out",
        variants: (0, $27da3f6f6c297608$export$57aca34bc31479ce),
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($a514c7dbd4ee6ba5$var$FilterList, {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $c755d2e017a9d27b$export$ef9b1a59e592288f), {
                        disabled: throttledIsLoading,
                        name: "target",
                        onChange: (value)=>{
                            setTargetFilter(value);
                        },
                        options: [
                            {
                                value: "all",
                                children: "All targets"
                            },
                            {
                                value: "onTarget",
                                children: "On target"
                            },
                            {
                                value: "offTarget",
                                children: "Off target"
                            }
                        ],
                        value: targetFilter ?? "all",
                        leadingIcon: ()=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0a830394bc38e4e3$export$f04a61298a47a40f), {
                                type: "target_duotone"
                            })
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $c755d2e017a9d27b$export$ef9b1a59e592288f), {
                        disabled: throttledIsLoading,
                        name: "metric",
                        onChange: (value)=>{
                            setMetricFilter(value);
                        },
                        options: [
                            {
                                value: "all",
                                children: "All metrics"
                            },
                            {
                                value: "successRate",
                                children: "Success rate"
                            },
                            {
                                value: "latency",
                                children: "Latency"
                            }
                        ],
                        value: metricFilter ?? "all",
                        leadingIcon: ()=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0a830394bc38e4e3$export$f04a61298a47a40f), {
                                type: "graph_duotone"
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $957ba347c2325692$export$df30df7ec97b32b5), {
                isLoading: throttledIsLoading,
                data: filteredData,
                columns: $a514c7dbd4ee6ba5$var$columns,
                onRowClick: (objective)=>navigate({
                        pathname: (0, $c12fb649da40a3f2$export$fa3ecc25d6e42a0f)(objective),
                        search: searchParams.toString()
                    })
            }),
            isEmptyFiltered && !throttledIsLoading && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $784d3423da3bef2a$export$82dd68b50c353d5c), {
                resetFilters: resetFilters
            })
        ]
    }, "sloOverviewContent");
}
const $a514c7dbd4ee6ba5$var$Container = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $5980fceb02c72dc0$export$e25e478948902b8b).div)`
  display: grid;
  gap: 32px;
`;
const $a514c7dbd4ee6ba5$var$FunctionsCountLabel = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).span(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      border-radius: ${theme.radius.minimal};
      background: ${theme.color.bg.emphasis["primary-subtle"]};
      color: ${theme.color.fg.primary};
      text-align: center;
      font-size: 12px;
      font-family: Inter;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      display: inline-block;
      height: 20px;
      min-width: 20px;
    `);
const $a514c7dbd4ee6ba5$var$FilterList = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 8px;
`;









function $fa97a35e8d9b0fd8$export$49299131159349d6() {
    const { "*": path = "" } = (0, $efeb47d767416279$export$99eaa27ddbbb95ef)();
    const [searchParams] = (0, $e7b98158099ae00d$export$f1a78c17382fe22a)();
    const instance = (0, $1a280fbaa3fcabb5$export$2105062e25df4afe)((0, $14bbd07b3011052f$export$919b3065fd27c3a8));
    // HACK - This is a hack to get the objective name from the path
    const objectiveName = (0, $2gcPZ.useMemo)(()=>{
        return path.split("/")[0];
    }, [
        path
    ]);
    const { timeRange: timeRange, onChangeTimeRange: onChangeTimeRange } = (0, $326a17b5958d0a0c$export$43bf3df9dfee3ce5)();
    const { data: objectives, error: error, isFetching: isFetching, isUninitialized: isUninitialized } = (0, $81accdab4a22bb8e$export$117f4f94ea08f791)({
        environmentUrl: instance?.url,
        start: timeRange.from,
        end: timeRange.to
    }, {
        skip: !instance?.url
    });
    if (!instance?.url) return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $ca0bd75019462cd1$export$be3dbeb7e994ac04), {});
    // NOTE - We handle the "No SLOs Found" path here for stylistic reasons
    //        The empty state component looks a lot better without the page heading and filters
    const shouldShowNoSlosFound = !isUninitialized && !isFetching && !error && !objectives?.length;
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $747d2f1afecb66a5$export$5f86df0ee0a255b5), {
        children: shouldShowNoSlosFound ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $1f0ff5a61e121104$export$7bd61839e455449b), {
            children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a76aa824193173e3$export$906a2ccca5d2a479), {})
        }) : /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $afa7be861492543f$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $747d2f1afecb66a5$export$53f1cd6809577fc5), {
                    children: [
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $747d2f1afecb66a5$export$9716a88f5535df7c), {
                            children: objectiveName ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $afa7be861492543f$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($fa97a35e8d9b0fd8$var$HeadingLink, {
                                        to: {
                                            pathname: "/slos",
                                            search: searchParams.toString()
                                        },
                                        children: [
                                            "SLOs /",
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($fa97a35e8d9b0fd8$var$HeadingPart, {
                                        $active: true,
                                        children: objectiveName
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($fa97a35e8d9b0fd8$var$HeadingPart, {
                                $active: true,
                                children: "SLOs"
                            })
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $747d2f1afecb66a5$export$5f24e1347551b2c2), {
                            children: [
                                "SLOs (Service Level Objectives) are performance promises made by a service or system. Read more about SLOs in our",
                                " ",
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("a", {
                                    href: "https://docs.autometrics.dev/features#alerts-and-slos-without-yaml",
                                    target: "_blank",
                                    rel: "noreferrer noopener",
                                    children: "documentation"
                                }),
                                "."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $d3a9d83062c98169$export$3ae376d12526dd6f), {
                    mode: "wait",
                    children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $efeb47d767416279$export$3565eb3d00ca5a74), {
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $efeb47d767416279$export$e7b0ac011bb776c6), {
                                index: true,
                                element: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a514c7dbd4ee6ba5$export$a9c14ed1269e6127), {
                                    timeRange: timeRange
                                }, "SloOverviewPage")
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $efeb47d767416279$export$e7b0ac011bb776c6), {
                                path: ":objectiveName/:metricType?",
                                element: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $7ee161e0e8fe7b1c$export$a05aa9aaead79c76), {
                                    onChangeTimeRange: onChangeTimeRange,
                                    timeRange: timeRange
                                }, "sloDetailPage")
                            })
                        ]
                    })
                })
            ]
        })
    });
}
const $fa97a35e8d9b0fd8$var$HeadingLink = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $e7b98158099ae00d$export$a6c7ac8248d6e38a))(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    color: ${theme.color.fg.subtle};
    text-decoration: none;
  `);
const $fa97a35e8d9b0fd8$var$HeadingPart = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).span(({ theme: theme, $active: $active })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    color: ${$active ? theme.color.fg.default : theme.color.fg.subtle};
  `);







var $2gcPZ = parcelRequire("2gcPZ");










const { Container: $d980919f7167a1a7$var$Container, Content: $d980919f7167a1a7$var$Content, Header: $d980919f7167a1a7$var$Header, Heading: $d980919f7167a1a7$var$Heading, HelperText: $d980919f7167a1a7$var$HelperText, BigIcon: $d980919f7167a1a7$var$BigIcon } = (0, $0c5c766c1e242605$exports);
function $d980919f7167a1a7$export$b02d156a9b379ca1() {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($d980919f7167a1a7$var$StyledContainer, {
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($d980919f7167a1a7$var$StyledContent, {
            children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($d980919f7167a1a7$var$Header, {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($d980919f7167a1a7$var$BigIcon, {
                        type: "autometrics_black_faded"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($d980919f7167a1a7$var$Heading, {
                        children: "No alerts found"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($d980919f7167a1a7$var$HelperText, {
                        children: [
                            "Read more about alerts in the",
                            " ",
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("a", {
                                href: "https://docs.autometrics.dev/features#alerts-and-slos-without-yaml",
                                target: "_blank",
                                rel: "noreferrer noopener",
                                children: "documentation"
                            })
                        ]
                    })
                ]
            })
        })
    });
}
const $d980919f7167a1a7$var$StyledContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)($d980919f7167a1a7$var$Container)`
  height: 100%;
  min-height: 400px;
  align-items: flex-start;
  padding: 72px 0;
`;
const $d980919f7167a1a7$var$StyledContent = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)($d980919f7167a1a7$var$Content)`
  max-width: 640px;
  display: flex;
  flex-direction: column;
  gap: 32px;
`;






var $2gcPZ = parcelRequire("2gcPZ");



function $b2eefb481d1eb013$export$95660c0b89f783ad(timeRange) {
    const environment = (0, $1a280fbaa3fcabb5$export$2105062e25df4afe)((0, $14bbd07b3011052f$export$919b3065fd27c3a8));
    const [step, stepSeconds] = (0, $d9ef29a97e741a59$export$aa02a9ec6df7532d)(timeRange);
    const result = (0, $5755db105caee352$export$c386b48e92fd4ce1)({
        environmentUrl: environment?.url,
        start: timeRange.from,
        end: timeRange.to,
        query: "sum by (alertname, objective_name, severity, category, objective_percentile, sloth_id) (ALERTS)",
        useTimeRangeAsSpecified: true
    }, {
        refetchOnMountOrArgChange: true,
        skip: !environment?.url
    });
    const modifiedData = (0, $2gcPZ.useMemo)(()=>{
        if (!result.data) return result.data;
        const isFiringCutOffTime = (0, $89bcf338a8e6a1c2$export$5949043e4444048)(timeRange.to) - stepSeconds;
        return result.data.map((alert)=>{
            const lastTime = alert.metrics?.[alert.metrics.length - 1]?.time;
            const isFiring = lastTime && (0, $89bcf338a8e6a1c2$export$5949043e4444048)(lastTime) >= isFiringCutOffTime || false;
            const labels = {
                ...alert.labels,
                // TODO: Add support for handling pending alerts
                //       Right now autometrics doesn't have any alerts that can be in a pending state
                //       so we don't need to worry about this for now
                state: isFiring ? "firing" : "inactive",
                lastseen: isFiring ? "still firing" : lastTime || ""
            };
            return {
                ...alert,
                labels: labels
            };
        });
    }, [
        result.data,
        timeRange.to,
        stepSeconds
    ]);
    return {
        result: {
            ...result,
            data: modifiedData
        },
        step: step,
        stepSeconds: stepSeconds
    };
}











var $2gcPZ = parcelRequire("2gcPZ");











var $2gcPZ = parcelRequire("2gcPZ");




function $c3ce69d9ef349b9a$export$c3459683951cd8f8(props) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($c3ce69d9ef349b9a$var$Container, {
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("table", {
            children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("tbody", {
                children: Object.entries(props.labels).map(([key, value])=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($c3ce69d9ef349b9a$var$Td, {
                                children: [
                                    key,
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($c3ce69d9ef349b9a$var$Td, {
                                children: value
                            })
                        ]
                    }, key))
            })
        })
    });
}
const $c3ce69d9ef349b9a$var$Container = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    display: grid;
    gap: ${theme.spacing.xs};
  `);
const $c3ce69d9ef349b9a$var$Td = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).td(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    padding: 0 ${theme.spacing.xxs};
  `);



const $aedbee50e2fdcd9e$var$HIDE_LABELS = new Set([
    "alertname",
    "severity",
    "lastseen",
    "state",
    "objective_name"
]);
function $aedbee50e2fdcd9e$export$d2a4f01410217a0e(props) {
    const pairs = Object.entries(props.labels).filter(([key])=>$aedbee50e2fdcd9e$var$HIDE_LABELS.has(key) === false);
    const visiblePairs = pairs.slice(0, Math.max(1, Math.floor(props.width / 200)));
    const hideRef = (0, $2gcPZ.useRef)(null);
    const labelRef = (0, $2gcPZ.useRef)(null);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $afa7be861492543f$exports.Fragment), {
        children: [
            visiblePairs.map(([key, value])=>{
                if ($aedbee50e2fdcd9e$var$HIDE_LABELS.has(key)) return null;
                return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($aedbee50e2fdcd9e$var$Label, {
                    children: [
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($aedbee50e2fdcd9e$var$LabelKey, {
                            children: [
                                key,
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($aedbee50e2fdcd9e$var$LabelValue, {
                            children: value
                        })
                    ]
                }, key);
            }),
            pairs.length > visiblePairs.length && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($aedbee50e2fdcd9e$var$MoreLabel, {
                ref: labelRef,
                onMouseOver: ()=>{
                    if (labelRef.current) hideRef.current = (0, $c41f178228bd3003$export$635e15bbd66f01ea)((0, $6287c72d1ca35f8e$export$dba11b50e1aa3c12)(labelRef.current, /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $c3ce69d9ef349b9a$export$c3459683951cd8f8), {
                        labels: props.labels
                    }), {
                        placement: "top"
                    }));
                },
                onMouseOut: ()=>{
                    if (hideRef.current !== null) hideRef.current();
                    hideRef.current = null;
                },
                children: "More..."
            })
        ]
    });
}
const $aedbee50e2fdcd9e$var$Label = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    display: grid;
    grid-template-columns: auto auto;
    gap: ${theme.spacing.xxs};
    color: ${theme.color.fg.primary};
    font: ${theme.font.body.sm.regular};
    border: 1px solid ${theme.color.border.primary};
    border-radius: ${theme.radius.minimal};
    padding: 0 ${theme.spacing.xxs} 0 ${theme.spacing.xxs};
  `);
const $aedbee50e2fdcd9e$var$MoreLabel = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)($aedbee50e2fdcd9e$var$Label)(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    border-color: ${theme.color.border.default};
    color: ${theme.color.fg.default};
    cursor: pointer;
  `);
const $aedbee50e2fdcd9e$var$LabelKey = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  border-right: 0;
  flex: 0 0 auto;
  margin: 0;
`;
const $aedbee50e2fdcd9e$var$LabelValue = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  border-left: 0;
  margin: 0;
  max-width: 200px;
  margin-right: 10px;

  &:last-child {
    margin-right: 0;
  }
`;


function $15e04d203dc8b2e5$export$f3c114a5f487e814(props) {
    const [ref, { width: width = 0 }] = (0, $b8b5111030e66ef0$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($15e04d203dc8b2e5$var$Labels, {
        ref: ref,
        children: width > 0 && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $aedbee50e2fdcd9e$export$d2a4f01410217a0e), {
            width: width,
            labels: props.labels
        })
    });
}
const $15e04d203dc8b2e5$var$Labels = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    display: grid;
    grid-template-columns: repeat(5, auto);
    justify-content: end;
    min-width: 0;
    white-space: nowrap;
    overflow: auto;
    gap: ${theme.spacing.xs};
  `);




function $653c23921cca748f$export$35a29f3bee4168cd(props) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($653c23921cca748f$var$Container, {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($653c23921cca748f$var$Content, {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($653c23921cca748f$var$Title, {
                        children: "History"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $15e04d203dc8b2e5$export$f3c114a5f487e814), {
                        labels: props.labels
                    })
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($653c23921cca748f$var$Output, {
                children: props.children
            })
        ]
    });
}
const $653c23921cca748f$var$Container = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    display: grid;
    padding: ${theme.spacing.md};
    min-width: 0;
    border: 1px solid ${theme.color.border.muted};
    background: ${theme.color.bg.default};
    border-radius: ${theme.radius.rounded};
    white-space: normal;
  `);
const $653c23921cca748f$var$Content = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    height: auto;
    display: grid;
    grid-template-columns: min-content 1fr;
    align-items: center;
    gap: ${theme.spacing.md};
  `);
const $653c23921cca748f$var$Output = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  min-width: 0;
`;
const $653c23921cca748f$var$Title = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).h5(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    color: ${theme.color.fg.muted};
  `);






function $41096163463269d2$export$a6b704528925a96(props) {
    const { labels: labels, query: query } = props;
    const environment = (0, $1a280fbaa3fcabb5$export$2105062e25df4afe)((0, $14bbd07b3011052f$export$919b3065fd27c3a8));
    const { timeRange: timeRange, onChangeTimeRange: onChangeTimeRange } = (0, $326a17b5958d0a0c$export$43bf3df9dfee3ce5)();
    const result = (0, $5755db105caee352$export$c386b48e92fd4ce1)({
        environmentUrl: environment?.url,
        start: timeRange.from,
        end: timeRange.to,
        query: query
    });
    const graphTheme = (0, $583285e3aa4c16bf$export$5cc0dd04debd4b19)("successRate");
    const tickFormattersFactory = (0, $2gcPZ.useMemo)(()=>(xAxis, yAxis)=>({
                xFormatter: (0, $97bfc4b4004b00d4$export$22e93c2cab313942)(xAxis),
                yFormatter: (0, $97bfc4b4004b00d4$export$9bc9750a5e6705d)(yAxis)
            }), []);
    if (!result.data) return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $653c23921cca748f$export$35a29f3bee4168cd), {
        labels: labels,
        children: "Loading"
    });
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $653c23921cca748f$export$35a29f3bee4168cd), {
        labels: labels,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $97bfc4b4004b00d4$export$f4cb11be864d0ce5), {
            chartTheme: graphTheme,
            areaGradientShown: result.data.length < 5,
            graphType: "line",
            stackingType: "none",
            timeRange: timeRange,
            timeseriesData: result.data,
            tickFormatters: tickFormattersFactory,
            footerShown: false,
            shouldAnimateYScale: false,
            onChangeTimeRange: onChangeTimeRange,
            showTooltip: (anchor, [series, point])=>{
                if (point) return (0, $c41f178228bd3003$export$635e15bbd66f01ea)((0, $6287c72d1ca35f8e$export$dba11b50e1aa3c12)(anchor, /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $b7b57423e9554b4f$export$1190a21963505760), {
                    content: [
                        series,
                        point
                    ]
                }), {
                    placement: "top"
                }));
                return 0, $205cce2352c35b5b$export$8793edee2d425525;
            }
        })
    });
}



function $3d18af30fbbb75b9$export$dd2698081e2fbfed(props) {
    const { data: data } = props;
    const environment = (0, $1a280fbaa3fcabb5$export$2105062e25df4afe)((0, $14bbd07b3011052f$export$919b3065fd27c3a8));
    const rules = (0, $a42cea1284cea633$export$db8166517713c60d)({
        environmentUrl: environment?.url
    });
    if (rules.data === undefined) return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $b6465ff4e4132c39$export$669f6ea7d267feaf), {});
    let currentRules = [];
    for (const ruleGroup of rules.data){
        const matching = ruleGroup.rules.filter((rule)=>rule.name === data.original.labels.alertname);
        if (matching.length > 0) currentRules.push(...matching);
    }
    currentRules = currentRules.filter((rule)=>rule.labels?.severity === data.original.labels.severity);
    const query = currentRules[0]?.query || 'ALERTS{alertname="' + data.original.labels.alertname + '"}';
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $41096163463269d2$export$a6b704528925a96), {
        labels: data.original.labels,
        query: query
    });
}




const $35e204dad5c20bba$var$EMPTY_ALERTS_LIST = [];
const $35e204dad5c20bba$var$columnHelper = (0, $93a274dd46b4c3ff$export$4b44a5cb9651fe5e)();
const $35e204dad5c20bba$export$7a76bf180c86084f = function Alerts() {
    const [currentSearchParams] = (0, $e7b98158099ae00d$export$f1a78c17382fe22a)();
    const { timeRange: timeRange } = (0, $326a17b5958d0a0c$export$43bf3df9dfee3ce5)();
    const { result: activeAlertsQuery, step: step } = (0, $b2eefb481d1eb013$export$95660c0b89f783ad)(timeRange);
    const columns = (0, $2gcPZ.useMemo)(()=>[
            $35e204dad5c20bba$var$columnHelper.accessor("labels.state", {
                cell: (cellContext)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($35e204dad5c20bba$var$StatusLabel, {
                        state: cellContext.row.original.labels?.state === "firing" ? "firing" : "inactive"
                    }),
                header: "Status"
            }),
            $35e204dad5c20bba$var$columnHelper.accessor("labels.lastseen", {
                cell: (cellContext)=>{
                    const value = cellContext.getValue() || "";
                    if (value === "") return value;
                    return value === "still firing" ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($35e204dad5c20bba$var$WarnableDateSpan, {
                        children: value
                    }) : value;
                },
                header: `Last seen (\xb1 ${step})`
            }),
            $35e204dad5c20bba$var$columnHelper.accessor("labels.severity", {
                cell: (cellContext)=>cellContext.getValue() || "",
                header: "Severity"
            }),
            $35e204dad5c20bba$var$columnHelper.accessor("labels.alertname", {
                cell: (cellContext)=>cellContext.getValue() || "",
                header: "Name"
            }),
            $35e204dad5c20bba$var$columnHelper.accessor("labels.objective_name", {
                cell: (cellContext)=>{
                    const { sloth_id: sloth_id } = cellContext.row.original.labels;
                    const objective_name = cellContext.getValue();
                    if (sloth_id && objective_name) {
                        const metric = sloth_id.includes("latency") ? "latency" : "successRate";
                        return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $795cb95bed41b233$export$8ff1ee94cebb82a4), {
                            to: {
                                pathname: (0, $c12fb649da40a3f2$export$fa3ecc25d6e42a0f)({
                                    metric: metric,
                                    name: objective_name
                                }),
                                search: currentSearchParams.toString()
                            },
                            children: objective_name
                        });
                    }
                },
                header: "SLO"
            })
        ], [
        currentSearchParams,
        step
    ]);
    const { data: alerts = $35e204dad5c20bba$var$EMPTY_ALERTS_LIST, error: alertsError, isLoading: isAlertsLoading, isUninitialized: isAlertsUninitialized } = activeAlertsQuery;
    const isEmpty = !isAlertsUninitialized && !isAlertsLoading && alertsError && alerts.length === 0;
    const renderExpanded = (0, $cac150ebb620e91f$export$d095b0c879743c0d)((data)=>{
        return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $3d18af30fbbb75b9$export$dd2698081e2fbfed), {
            data: data
        });
    });
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $747d2f1afecb66a5$export$5f86df0ee0a255b5), {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $747d2f1afecb66a5$export$53f1cd6809577fc5), {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $747d2f1afecb66a5$export$9716a88f5535df7c), {
                        children: "Alerts"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $747d2f1afecb66a5$export$5f24e1347551b2c2), {
                        children: [
                            "Below you can see the alerts that have fired in the following time range:",
                            " ",
                            "relativeTimeRangeLabel" in timeRange ? timeRange.relativeTimeRangeLabel?.toLowerCase() : `${timeRange.from} - ${timeRange.to}`,
                            ". Read more about alerts in the",
                            " ",
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("a", {
                                href: "https://docs.autometrics.dev/features#alerts-and-slos-without-yaml",
                                target: "_blank",
                                rel: "noreferrer noopener",
                                children: "documentation"
                            }),
                            "."
                        ]
                    })
                ]
            }),
            alertsError ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $c624abcc931dc034$export$bd7370ffb2917ab7), {
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $7f2b92de158af7af$export$5eef44829f72c6d0), {})
            }, "alertsPageError") : isEmpty ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $c624abcc931dc034$export$bd7370ffb2917ab7), {
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $d980919f7167a1a7$export$b02d156a9b379ca1), {})
            }, "alertsPageEmptyState") : /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $c624abcc931dc034$export$bd7370ffb2917ab7), {
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $957ba347c2325692$export$df30df7ec97b32b5), {
                    columns: columns,
                    data: alerts,
                    isLoading: isAlertsLoading,
                    renderExpanded: renderExpanded
                })
            }, "alertsPageList")
        ]
    });
};
function $35e204dad5c20bba$var$StatusLabel({ state: state }) {
    const theme = (0, $4e8e6ea7d6e48c37$export$93d4e7f90805808f)();
    if (state === "inactive") return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $6a24c97863e3e2ed$export$2a5819cd7a2ca075), {
        color: theme.color.neutral[400],
        children: "Inactive"
    });
    if (state === "firing") return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $6a24c97863e3e2ed$export$2a5819cd7a2ca075), {
        color: theme.color.fg.danger,
        children: "Firing"
    });
    return null;
}
const $35e204dad5c20bba$var$WarnableDateSpan = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).span(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      color: ${theme.color.fg.danger};
    `);






var $2gcPZ = parcelRequire("2gcPZ");




function $12f54f34ea8c6092$export$86e8e5cd689fa595() {
    const dispatch = (0, $b1ddf03ae6418ae8$export$8ad76b76a4c905f8)();
    const [hashSearchParams, setHashSearchParams] = (0, $e7b98158099ae00d$export$f1a78c17382fe22a)();
    const hashPrometheusUrl = hashSearchParams.get("prometheusUrl");
    const currentUrl = new URL(window.location.href);
    const prometheusUrl = currentUrl.searchParams.get("prometheusUrl");
    // NOTE - only runs once
    (0, $2gcPZ.useEffect)(()=>{
        // For simplicity, always delete the hash search param
        const hashParamsWithoutPrometheusUrl = (0, $28ccb008950fefda$export$43bc4cfd2456f165)(hashSearchParams, "prometheusUrl", null);
        setHashSearchParams(hashParamsWithoutPrometheusUrl, {
            replace: true
        });
        if (prometheusUrl !== null) {
            // NOTE - we use native browser apis for search parameters because
            //        using `hashRouter` means the search param has to come after the # url
            currentUrl.searchParams.delete("prometheusUrl");
            // Replace the current URL in the browser's history
            window.history.replaceState({}, document.title, currentUrl.toString());
            // Only add the instance if it's not the empty string
            if (prometheusUrl) dispatch((0, $ecfe56675d6ea75b$export$1df5575955777c32)(prometheusUrl));
        } else if (hashPrometheusUrl) dispatch((0, $ecfe56675d6ea75b$export$1df5575955777c32)(hashPrometheusUrl));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}








var $2gcPZ = parcelRequire("2gcPZ");




async function $6b380e4574f6ebca$export$5e14cdade93d6f7b(data, recentAlerts, startTime) {
    const allowed = window.Notification.permission === "granted";
    if (allowed === false) return [];
    const active = await (0, $176313a6a434cc5e$exports).getServiceWorker();
    if (!active) return [];
    const newRecentAlerts = [];
    const newAlerts = data.map((alert)=>{
        const { state: state, lastseen: lastseen, ...labels } = alert.labels;
        return {
            name: alert.name,
            labels: labels,
            attributes: alert.attributes
        };
    }).filter((alert)=>{
        // Our poor mans deduplication is using serialized alerts
        // to find out whether we've already notified the user or not
        const serialized = JSON.stringify(alert);
        newRecentAlerts.push(serialized);
        return recentAlerts.includes(serialized) === false;
    });
    if (newAlerts.length > 1) active.postMessage({
        type: "MULTIPLE_NOTIFICATIONS",
        payload: {
            alertCount: newAlerts.length,
            timestamp: startTime
        }
    });
    else for (const alert of newAlerts)active.postMessage({
        type: "NOTIFICATION",
        payload: {
            alert: alert,
            timestamp: startTime
        }
    });
    return newRecentAlerts;
}
function $6b380e4574f6ebca$export$19290bf8f2acc1f5(start) {
    const to = new Date();
    const from = start || new Date(to.getTime() - 5000).toISOString();
    return {
        from: from,
        to: to.toISOString()
    };
}


const { useNotificationSettings: $f0aff19b51ff7a01$var$useNotificationSettings, getServiceWorker: $f0aff19b51ff7a01$var$getServiceWorker, hasServiceWorkerSupport: $f0aff19b51ff7a01$var$hasServiceWorkerSupport } = (0, $176313a6a434cc5e$exports);
function $f0aff19b51ff7a01$export$e0174ade3106e0cf() {
    const navigateToAlerts = (0, $176313a6a434cc5e$exports).useNavigateToAlerts();
    const [pollingTimeRange, setPollingTimeRange] = (0, $2gcPZ.useState)((0, $6b380e4574f6ebca$export$19290bf8f2acc1f5));
    const { result: result } = (0, $b2eefb481d1eb013$export$95660c0b89f783ad)(pollingTimeRange);
    const [activeAlerts, setActiveAlerts] = (0, $2gcPZ.useState)(false);
    const { settings: notificationSettings } = $f0aff19b51ff7a01$var$useNotificationSettings();
    // TODO only send notifications if the user is not on the alerts page
    // Right now we might show notifications for alerts that are already on display
    // However given that we're polling and the alerts page is not, the alerts page
    // might be out of date
    const showNotifications = (notificationSettings.desktopNotificationsEnabled ?? notificationSettings.notificationState) && $f0aff19b51ff7a01$var$hasServiceWorkerSupport;
    const handleMessageEvent = (0, $cac150ebb620e91f$export$d095b0c879743c0d)((event)=>{
        if (event.data.type === "FOCUS_ALERT") navigateToAlerts(event.data.payload.timestamp);
    });
    (0, $2gcPZ.useEffect)(()=>{
        if (!showNotifications) return;
        navigator.serviceWorker.addEventListener("message", handleMessageEvent);
        return ()=>{
            navigator.serviceWorker.removeEventListener("message", handleMessageEvent);
        };
    }, [
        handleMessageEvent,
        showNotifications
    ]);
    (0, $2gcPZ.useEffect)(()=>{
        // No need to poll if the user doesn't want notifications (or if they aren't supported)
        if (showNotifications === false) return;
        const timeoutId = setTimeout(()=>setPollingTimeRange((0, $6b380e4574f6ebca$export$19290bf8f2acc1f5)(pollingTimeRange.to)), 30000);
        return ()=>{
            clearTimeout(timeoutId);
        };
    }, [
        pollingTimeRange.to,
        showNotifications
    ]);
    const alertsRef = (0, $2gcPZ.useRef)([]);
    (0, $2gcPZ.useEffect)(()=>{
        const data = result.data;
        if (data && $f0aff19b51ff7a01$var$hasServiceWorkerSupport) {
            // If the service worker is not registered or working, don't do anything
            if ($f0aff19b51ff7a01$var$getServiceWorker() === null) return;
            // Check settings and ask the user if they want to enable notifications
            if (notificationSettings.notificationState === "granted") setActiveAlerts(true);
            // If the user wants notifications, notify!
            if (showNotifications) {
                setActiveAlerts(true);
                (0, $6b380e4574f6ebca$export$5e14cdade93d6f7b)(data, alertsRef.current, pollingTimeRange.to).then((newRecentAlerts)=>{
                    alertsRef.current = newRecentAlerts;
                });
            }
        }
    }, [
        result.data,
        pollingTimeRange.to,
        pollingTimeRange.from,
        notificationSettings.notificationState,
        showNotifications,
        navigateToAlerts
    ]);
    return {
        activeAlerts: activeAlerts
    };
}








function $568d64c292b2fcfd$export$2e6b0affd88703b6() {
    const { requestPermission: requestPermission } = (0, $176313a6a434cc5e$exports).useNotificationSettings();
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($568d64c292b2fcfd$var$Container, {
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $f3c0cebd0881f06d$export$3b4e64e77073e307), {
            type: "info",
            title: "Desktop notifications",
            copy: "Do you want to receive desktop notifications for future alerts?",
            initialSize: "small",
            actions: [
                {
                    label: "Allow",
                    onClick: ()=>{
                        requestPermission();
                    }
                }
            ]
        })
    });
}
const $568d64c292b2fcfd$var$Container = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $747d2f1afecb66a5$export$5f86df0ee0a255b5))`
  display: flex;
  padding: 40px 0 0;
`;


function $fce68a245efc33ac$export$24e4c25c8f3847c1() {
    const newAlerts = (0, $f0aff19b51ff7a01$export$e0174ade3106e0cf)();
    const { settings: notificationSettings } = (0, $176313a6a434cc5e$exports).useNotificationSettings();
    if (newAlerts && notificationSettings.notificationState === "default" && notificationSettings.desktopNotificationsEnabled) return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $efeb47d767416279$export$3565eb3d00ca5a74), {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $efeb47d767416279$export$e7b0ac011bb776c6), {
                path: "/alerts",
                element: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $568d64c292b2fcfd$export$2e6b0affd88703b6), {})
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $efeb47d767416279$export$e7b0ac011bb776c6), {
                path: "*",
                element: null
            })
        ]
    });
    return null;
}







function $bda49d0f75b55532$export$2e2bcd8739ae039() {
    $bda49d0f75b55532$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bda49d0f75b55532$export$2e2bcd8739ae039.apply(this, arguments);
}



var $2gcPZ = parcelRequire("2gcPZ");
function $48d68b49782585c1$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}



var $2gcPZ = parcelRequire("2gcPZ");
/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $05915cfeee427336$var$$6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $05915cfeee427336$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$05915cfeee427336$var$$6ed0406888f73fc4$var$setRef(ref, node));
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $05915cfeee427336$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $2gcPZ.useCallback)($05915cfeee427336$export$43e446d32b3d21af(...refs), refs);
}



var $2gcPZ = parcelRequire("2gcPZ");
function $402570e42a37610f$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = /*#__PURE__*/ (0, $2gcPZ.createContext)(defaultContext);
    function Provider(props) {
        const { children: children, ...context } = props; // Only re-memoize when prop values change
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const value = (0, $2gcPZ.useMemo)(()=>context, Object.values(context));
        return /*#__PURE__*/ (0, $2gcPZ.createElement)(Context.Provider, {
            value: value
        }, children);
    }
    function useContext(consumerName) {
        const context = (0, $2gcPZ.useContext)(Context);
        if (context) return context;
        if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext
    ];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function $402570e42a37610f$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        const BaseContext = /*#__PURE__*/ (0, $2gcPZ.createContext)(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope, children: children, ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const value = (0, $2gcPZ.useMemo)(()=>context, Object.values(context));
            return /*#__PURE__*/ (0, $2gcPZ.createElement)(Context.Provider, {
                value: value
            }, children);
        }
        function useContext(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = (0, $2gcPZ.useContext)(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext
        ];
    }
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return /*#__PURE__*/ (0, $2gcPZ.createContext)(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return (0, $2gcPZ.useMemo)(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        $402570e42a37610f$var$$c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function $402570e42a37610f$var$$c512c27ab02ef895$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope1 = ()=>{
        const scopeHooks = scopes.map((createScope)=>({
                useScope: createScope(),
                scopeName: createScope.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope: useScope, scopeName: scopeName })=>{
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes,
                    ...currentScope
                };
            }, {});
            return (0, $2gcPZ.useMemo)(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes1
                }), [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}



var $2gcPZ = parcelRequire("2gcPZ");

var $2gcPZ = parcelRequire("2gcPZ");
/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ const $6ad78e487ebda330$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? (0, $2gcPZ.useLayoutEffect) : ()=>{};


const $10f2f07514fc651e$var$$1746a345f3d73bb7$var$useReactId = $2gcPZ["useId".toString()] || (()=>undefined);
let $10f2f07514fc651e$var$$1746a345f3d73bb7$var$count = 0;
function $10f2f07514fc651e$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $2gcPZ.useState($10f2f07514fc651e$var$$1746a345f3d73bb7$var$useReactId()); // React versions older than 18 will have client-side ids only.
    (0, $6ad78e487ebda330$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId !== null && reactId !== void 0 ? reactId : String($10f2f07514fc651e$var$$1746a345f3d73bb7$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}



var $2gcPZ = parcelRequire("2gcPZ");

var $2gcPZ = parcelRequire("2gcPZ");
/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ function $082e2d363a8e49dd$export$25bec8c6f54ee79a(callback) {
    const callbackRef = (0, $2gcPZ.useRef)(callback);
    (0, $2gcPZ.useEffect)(()=>{
        callbackRef.current = callback;
    }); // https://github.com/facebook/react/issues/19240
    return (0, $2gcPZ.useMemo)(()=>(...args)=>{
            var _callbackRef$current;
            return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
        }, []);
}


function $4ca5406d9c1c19f2$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{} }) {
    const [uncontrolledProp, setUncontrolledProp] = $4ca5406d9c1c19f2$var$$71cd76cc60e0454e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== undefined;
    const value1 = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $082e2d363a8e49dd$export$25bec8c6f54ee79a)(onChange);
    const setValue = (0, $2gcPZ.useCallback)((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value !== prop) handleChange(value);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value1,
        setValue
    ];
}
function $4ca5406d9c1c19f2$var$$71cd76cc60e0454e$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const uncontrolledState = (0, $2gcPZ.useState)(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = (0, $2gcPZ.useRef)(value);
    const handleChange = (0, $082e2d363a8e49dd$export$25bec8c6f54ee79a)(onChange);
    (0, $2gcPZ.useEffect)(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}




var $2gcPZ = parcelRequire("2gcPZ");



var $2gcPZ = parcelRequire("2gcPZ");

var $fuyzp = parcelRequire("fuyzp");


var $2gcPZ = parcelRequire("2gcPZ");

/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const $9e5ea6b8bf7bed41$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0, $2gcPZ.forwardRef)((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    const childrenArray = (0, $2gcPZ.Children).toArray(children);
    const slottable = childrenArray.find($9e5ea6b8bf7bed41$var$$5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if ((0, $2gcPZ.Children).count(newElement) > 1) return (0, $2gcPZ.Children).only(null);
                return /*#__PURE__*/ (0, $2gcPZ.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0, $2gcPZ.createElement)($9e5ea6b8bf7bed41$var$$5e63c961fc1ce211$var$SlotClone, (0, $bda49d0f75b55532$export$2e2bcd8739ae039)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0, $2gcPZ.isValidElement)(newElement) ? /*#__PURE__*/ (0, $2gcPZ.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0, $2gcPZ.createElement)($9e5ea6b8bf7bed41$var$$5e63c961fc1ce211$var$SlotClone, (0, $bda49d0f75b55532$export$2e2bcd8739ae039)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$9e5ea6b8bf7bed41$export$8c6ed5c666ac1360.displayName = "Slot";
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const $9e5ea6b8bf7bed41$var$$5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0, $2gcPZ.forwardRef)((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    if (/*#__PURE__*/ (0, $2gcPZ.isValidElement)(children)) return /*#__PURE__*/ (0, $2gcPZ.cloneElement)(children, {
        ...$9e5ea6b8bf7bed41$var$$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: (0, $05915cfeee427336$export$43e446d32b3d21af)(forwardedRef, children.ref)
    });
    return (0, $2gcPZ.Children).count(children) > 1 ? (0, $2gcPZ.Children).only(null) : null;
});
$9e5ea6b8bf7bed41$var$$5e63c961fc1ce211$var$SlotClone.displayName = "SlotClone";
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const $9e5ea6b8bf7bed41$export$d9f1ccf0bdb05d45 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2gcPZ.createElement)((0, $2gcPZ.Fragment), null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $9e5ea6b8bf7bed41$var$$5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0, $2gcPZ.isValidElement)(child) && child.type === $9e5ea6b8bf7bed41$export$d9f1ccf0bdb05d45;
}
function $9e5ea6b8bf7bed41$var$$5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName); // if it's a handler, modify the override by composing the base handler
        if (isHandler) overrideProps[propName] = (...args)=>{
            childPropValue === null || childPropValue === void 0 || childPropValue(...args);
            slotPropValue === null || slotPropValue === void 0 || slotPropValue(...args);
        };
        else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
const $9e5ea6b8bf7bed41$export$be92b6f5f03c0fe9 = $9e5ea6b8bf7bed41$export$8c6ed5c666ac1360;


const $f90ab5fd41e8b6ae$var$$8927f6f2acc4f386$var$NODES = [
    "a",
    "button",
    "div",
    "h2",
    "h3",
    "img",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const $f90ab5fd41e8b6ae$export$250ffa63cdc0d034 = $f90ab5fd41e8b6ae$var$$8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ (0, $2gcPZ.forwardRef)((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? (0, $9e5ea6b8bf7bed41$export$8c6ed5c666ac1360) : node;
        (0, $2gcPZ.useEffect)(()=>{
            window[Symbol.for("radix-ui")] = true;
        }, []);
        return /*#__PURE__*/ (0, $2gcPZ.createElement)(Comp, (0, $bda49d0f75b55532$export$2e2bcd8739ae039)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function $f90ab5fd41e8b6ae$export$6d1a0317bde7de7f(target, event) {
    if (target) (0, $fuyzp.flushSync)(()=>target.dispatchEvent(event));
}
/* -----------------------------------------------------------------------------------------------*/ const $f90ab5fd41e8b6ae$export$be92b6f5f03c0fe9 = $f90ab5fd41e8b6ae$export$250ffa63cdc0d034;





var $2gcPZ = parcelRequire("2gcPZ");

/**
 * Listens for when the escape key is down
 */ function $c8fa83f51c2a5494$export$3a72a57244d6e765(onEscapeKeyDownProp) {
    const onEscapeKeyDown = (0, $082e2d363a8e49dd$export$25bec8c6f54ee79a)(onEscapeKeyDownProp);
    (0, $2gcPZ.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>document.removeEventListener("keydown", handleKeyDown);
    }, [
        onEscapeKeyDown
    ]);
}


/* -------------------------------------------------------------------------------------------------
 * DismissableLayer
 * -----------------------------------------------------------------------------------------------*/ const $7273f1a572fa7952$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
const $7273f1a572fa7952$var$$5cb92bef7577960e$var$CONTEXT_UPDATE = "dismissableLayer.update";
const $7273f1a572fa7952$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
const $7273f1a572fa7952$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
let $7273f1a572fa7952$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
const $7273f1a572fa7952$var$$5cb92bef7577960e$var$DismissableLayerContext = /*#__PURE__*/ (0, $2gcPZ.createContext)({
    layers: new Set(),
    layersWithOutsidePointerEventsDisabled: new Set(),
    branches: new Set()
});
const $7273f1a572fa7952$export$177fb62ff3ec1f22 = /*#__PURE__*/ (0, $2gcPZ.forwardRef)((props, forwardedRef)=>{
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, ...layerProps } = props;
    const context = (0, $2gcPZ.useContext)($7273f1a572fa7952$var$$5cb92bef7577960e$var$DismissableLayerContext);
    const [node1, setNode] = (0, $2gcPZ.useState)(null);
    const [, force] = (0, $2gcPZ.useState)({});
    const composedRefs = (0, $05915cfeee427336$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setNode(node));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1); // prettier-ignore
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled); // prettier-ignore
    const index = node1 ? layers.indexOf(node1) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $7273f1a572fa7952$var$$5cb92bef7577960e$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside === null || onPointerDownOutside === void 0 || onPointerDownOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    });
    const focusOutside = $7273f1a572fa7952$var$$5cb92bef7577960e$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside === null || onFocusOutside === void 0 || onFocusOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    });
    (0, $c8fa83f51c2a5494$export$3a72a57244d6e765)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    });
    (0, $2gcPZ.useEffect)(()=>{
        if (!node1) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $7273f1a572fa7952$var$$5cb92bef7577960e$var$originalBodyPointerEvents = document.body.style.pointerEvents;
                document.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node1);
        }
        context.layers.add(node1);
        $7273f1a572fa7952$var$$5cb92bef7577960e$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) document.body.style.pointerEvents = $7273f1a572fa7952$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
        };
    }, [
        node1,
        disableOutsidePointerEvents,
        context
    ]);
    /**
   * We purposefully prevent combining this effect with the `disableOutsidePointerEvents` effect
   * because a change to `disableOutsidePointerEvents` would remove this layer from the stack
   * and add it to the end again so the layering order wouldn't be _creation order_.
   * We only want them to be removed from context stacks when unmounted.
   */ (0, $2gcPZ.useEffect)(()=>{
        return ()=>{
            if (!node1) return;
            context.layers.delete(node1);
            context.layersWithOutsidePointerEventsDisabled.delete(node1);
            $7273f1a572fa7952$var$$5cb92bef7577960e$var$dispatchUpdate();
        };
    }, [
        node1,
        context
    ]);
    (0, $2gcPZ.useEffect)(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($7273f1a572fa7952$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($7273f1a572fa7952$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /*#__PURE__*/ (0, $2gcPZ.createElement)((0, $f90ab5fd41e8b6ae$export$250ffa63cdc0d034).div, (0, $bda49d0f75b55532$export$2e2bcd8739ae039)({}, layerProps, {
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : undefined,
            ...props.style
        },
        onFocusCapture: (0, $48d68b49782585c1$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $48d68b49782585c1$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $48d68b49782585c1$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    }));
});
/*#__PURE__*/ Object.assign($7273f1a572fa7952$export$177fb62ff3ec1f22, {
    displayName: $7273f1a572fa7952$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DismissableLayerBranch
 * -----------------------------------------------------------------------------------------------*/ const $7273f1a572fa7952$var$$5cb92bef7577960e$var$BRANCH_NAME = "DismissableLayerBranch";
const $7273f1a572fa7952$export$4d5eb2109db14228 = /*#__PURE__*/ (0, $2gcPZ.forwardRef)((props, forwardedRef)=>{
    const context = (0, $2gcPZ.useContext)($7273f1a572fa7952$var$$5cb92bef7577960e$var$DismissableLayerContext);
    const ref = (0, $2gcPZ.useRef)(null);
    const composedRefs = (0, $05915cfeee427336$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    (0, $2gcPZ.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /*#__PURE__*/ (0, $2gcPZ.createElement)((0, $f90ab5fd41e8b6ae$export$250ffa63cdc0d034).div, (0, $bda49d0f75b55532$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($7273f1a572fa7952$export$4d5eb2109db14228, {
    displayName: $7273f1a572fa7952$var$$5cb92bef7577960e$var$BRANCH_NAME
});
/* -----------------------------------------------------------------------------------------------*/ /**
 * Listens for `pointerdown` outside a react subtree. We use `pointerdown` rather than `pointerup`
 * to mimic layer dismissing behaviour present in OS.
 * Returns props to pass to the node we want to check for outside events.
 */ function $7273f1a572fa7952$var$$5cb92bef7577960e$var$usePointerDownOutside(onPointerDownOutside) {
    const handlePointerDownOutside = (0, $082e2d363a8e49dd$export$25bec8c6f54ee79a)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = (0, $2gcPZ.useRef)(false);
    const handleClickRef = (0, $2gcPZ.useRef)(()=>{});
    (0, $2gcPZ.useEffect)(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                function handleAndDispatchPointerDownOutsideEvent() {
                    $7273f1a572fa7952$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($7273f1a572fa7952$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                }
                /**
         * On touch devices, we need to wait for a click event because browsers implement
         * a ~350ms delay between the time the user stops touching the display and when the
         * browser executres events. We need to ensure we don't reactivate pointer-events within
         * this timeframe otherwise the browser may execute events that should have been prevented.
         *
         * Additionally, this also lets us deal automatically with cancellations when a click event
         * isn't raised because the page was considered scrolled/drag-scrolled, long-pressed, etc.
         *
         * This is why we also continuously remove the previous listener, because we cannot be
         * certain that it was raised, and therefore cleaned-up.
         */ if (event.pointerType === "touch") {
                    document.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent;
                    document.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent();
            }
            isPointerInsideReactTreeRef.current = false;
        };
        /**
     * if this hook executes in a component that mounts via a `pointerdown` event, the event
     * would bubble up to the document and trigger a `pointerDownOutside` event. We avoid
     * this by delaying the event listener registration on the document.
     * This is not React specific, but rather how the DOM works, ie:
     * ```
     * button.addEventListener('pointerdown', () => {
     *   console.log('I will log');
     *   document.addEventListener('pointerdown', () => {
     *     console.log('I will also log');
     *   })
     * });
     */ const timerId = window.setTimeout(()=>{
            document.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            document.removeEventListener("pointerdown", handlePointerDown);
            document.removeEventListener("click", handleClickRef.current);
        };
    }, [
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
/**
 * Listens for when focus happens outside a react subtree.
 * Returns props to pass to the root (node) of the subtree we want to check.
 */ function $7273f1a572fa7952$var$$5cb92bef7577960e$var$useFocusOutside(onFocusOutside) {
    const handleFocusOutside = (0, $082e2d363a8e49dd$export$25bec8c6f54ee79a)(onFocusOutside);
    const isFocusInsideReactTreeRef = (0, $2gcPZ.useRef)(false);
    (0, $2gcPZ.useEffect)(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $7273f1a572fa7952$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($7273f1a572fa7952$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        document.addEventListener("focusin", handleFocus);
        return ()=>document.removeEventListener("focusin", handleFocus);
    }, [
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $7273f1a572fa7952$var$$5cb92bef7577960e$var$dispatchUpdate() {
    const event = new CustomEvent($7273f1a572fa7952$var$$5cb92bef7577960e$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $7273f1a572fa7952$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $f90ab5fd41e8b6ae$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
const $7273f1a572fa7952$export$be92b6f5f03c0fe9 = $7273f1a572fa7952$export$177fb62ff3ec1f22;
const $7273f1a572fa7952$export$aecb2ddcb55c95be = $7273f1a572fa7952$export$4d5eb2109db14228;




var $2gcPZ = parcelRequire("2gcPZ");



const $07f3d261abb253b0$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
const $07f3d261abb253b0$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
const $07f3d261abb253b0$var$$d3863c46a17e8a28$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * FocusScope
 * -----------------------------------------------------------------------------------------------*/ const $07f3d261abb253b0$var$$d3863c46a17e8a28$var$FOCUS_SCOPE_NAME = "FocusScope";
const $07f3d261abb253b0$export$20e40289641fbbb6 = /*#__PURE__*/ (0, $2gcPZ.forwardRef)((props, forwardedRef)=>{
    const { loop: loop = false, trapped: trapped = false, onMountAutoFocus: onMountAutoFocusProp, onUnmountAutoFocus: onUnmountAutoFocusProp, ...scopeProps } = props;
    const [container1, setContainer] = (0, $2gcPZ.useState)(null);
    const onMountAutoFocus = (0, $082e2d363a8e49dd$export$25bec8c6f54ee79a)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $082e2d363a8e49dd$export$25bec8c6f54ee79a)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = (0, $2gcPZ.useRef)(null);
    const composedRefs = (0, $05915cfeee427336$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContainer(node));
    const focusScope = (0, $2gcPZ.useRef)({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current; // Takes care of trapping focus if focus is moved outside programmatically for example
    (0, $2gcPZ.useEffect)(()=>{
        if (trapped) {
            function handleFocusIn(event) {
                if (focusScope.paused || !container1) return;
                const target = event.target;
                if (container1.contains(target)) lastFocusedElementRef.current = target;
                else $07f3d261abb253b0$var$$d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }
            function handleFocusOut(event) {
                if (focusScope.paused || !container1) return;
                if (!container1.contains(event.relatedTarget)) $07f3d261abb253b0$var$$d3863c46a17e8a28$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }
            document.addEventListener("focusin", handleFocusIn);
            document.addEventListener("focusout", handleFocusOut);
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn);
                document.removeEventListener("focusout", handleFocusOut);
            };
        }
    }, [
        trapped,
        container1,
        focusScope.paused
    ]);
    (0, $2gcPZ.useEffect)(()=>{
        if (container1) {
            $07f3d261abb253b0$var$$d3863c46a17e8a28$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container1.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($07f3d261abb253b0$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, $07f3d261abb253b0$var$$d3863c46a17e8a28$var$EVENT_OPTIONS);
                container1.addEventListener($07f3d261abb253b0$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container1.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $07f3d261abb253b0$var$$d3863c46a17e8a28$var$focusFirst($07f3d261abb253b0$var$$d3863c46a17e8a28$var$removeLinks($07f3d261abb253b0$var$$d3863c46a17e8a28$var$getTabbableCandidates(container1)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $07f3d261abb253b0$var$$d3863c46a17e8a28$var$focus(container1);
                }
            }
            return ()=>{
                container1.removeEventListener($07f3d261abb253b0$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus); // We hit a react bug (fixed in v17) with focusing in unmount.
                // We need to delay the focus a little to get around it for now.
                // See: https://github.com/facebook/react/issues/17894
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($07f3d261abb253b0$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, $07f3d261abb253b0$var$$d3863c46a17e8a28$var$EVENT_OPTIONS);
                    container1.addEventListener($07f3d261abb253b0$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container1.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $07f3d261abb253b0$var$$d3863c46a17e8a28$var$focus(previouslyFocusedElement !== null && previouslyFocusedElement !== void 0 ? previouslyFocusedElement : document.body, {
                        select: true
                    });
                    // we need to remove the listener after we `dispatchEvent`
                    container1.removeEventListener($07f3d261abb253b0$var$$d3863c46a17e8a28$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $07f3d261abb253b0$var$$d3863c46a17e8a28$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container1,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]); // Takes care of looping focus (when tabbing whilst at the edges)
    const handleKeyDown = (0, $2gcPZ.useCallback)((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container = event.currentTarget;
            const [first, last] = $07f3d261abb253b0$var$$d3863c46a17e8a28$var$getTabbableEdges(container);
            const hasTabbableElementsInside = first && last; // we can only wrap focus if we have tabbable edges
            if (!hasTabbableElementsInside) {
                if (focusedElement === container) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $07f3d261abb253b0$var$$d3863c46a17e8a28$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $07f3d261abb253b0$var$$d3863c46a17e8a28$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /*#__PURE__*/ (0, $2gcPZ.createElement)((0, $f90ab5fd41e8b6ae$export$250ffa63cdc0d034).div, (0, $bda49d0f75b55532$export$2e2bcd8739ae039)({
        tabIndex: -1
    }, scopeProps, {
        ref: composedRefs,
        onKeyDown: handleKeyDown
    }));
});
/*#__PURE__*/ Object.assign($07f3d261abb253b0$export$20e40289641fbbb6, {
    displayName: $07f3d261abb253b0$var$$d3863c46a17e8a28$var$FOCUS_SCOPE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Attempts focusing the first element in a list of candidates.
 * Stops when focus has actually moved.
 */ function $07f3d261abb253b0$var$$d3863c46a17e8a28$var$focusFirst(candidates, { select: select = false } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $07f3d261abb253b0$var$$d3863c46a17e8a28$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
/**
 * Returns the first and last tabbable elements inside a container.
 */ function $07f3d261abb253b0$var$$d3863c46a17e8a28$var$getTabbableEdges(container) {
    const candidates = $07f3d261abb253b0$var$$d3863c46a17e8a28$var$getTabbableCandidates(container);
    const first = $07f3d261abb253b0$var$$d3863c46a17e8a28$var$findVisible(candidates, container);
    const last = $07f3d261abb253b0$var$$d3863c46a17e8a28$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
/**
 * Returns a list of potential tabbable candidates.
 *
 * NOTE: This is only a close approximation. For example it doesn't take into account cases like when
 * elements are not visible. This cannot be worked out easily by just reading a property, but rather
 * necessitate runtime knowledge (computed styles, etc). We deal with these cases separately.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker
 * Credit: https://github.com/discord/focus-layers/blob/master/src/util/wrapFocus.tsx#L1
 */ function $07f3d261abb253b0$var$$d3863c46a17e8a28$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP; // `.tabIndex` is not the same as the `tabindex` attribute. It works on the
            // runtime's understanding of tabbability, so this automatically accounts
            // for any kind of element that could be tabbed to.
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode); // we do not take into account the order of nodes with positive `tabIndex` as it
    // hinders accessibility to have tab order different from visual order.
    return nodes;
}
/**
 * Returns the first visible element in a list.
 * NOTE: Only checks visibility up to the `container`.
 */ function $07f3d261abb253b0$var$$d3863c46a17e8a28$var$findVisible(elements, container) {
    for (const element of elements){
        // we stop checking if it's hidden at the `container` level (excluding)
        if (!$07f3d261abb253b0$var$$d3863c46a17e8a28$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $07f3d261abb253b0$var$$d3863c46a17e8a28$var$isHidden(node, { upTo: upTo }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        // we stop at `upTo` (excluding it)
        if (upTo !== undefined && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function $07f3d261abb253b0$var$$d3863c46a17e8a28$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function $07f3d261abb253b0$var$$d3863c46a17e8a28$var$focus(element, { select: select = false } = {}) {
    // only focus if that element is focusable
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement; // NOTE: we prevent scrolling on focus, to minimize jarring transitions for users
        element.focus({
            preventScroll: true
        }); // only select if its not the same element, it supports selection and we need to select
        if (element !== previouslyFocusedElement && $07f3d261abb253b0$var$$d3863c46a17e8a28$var$isSelectableInput(element) && select) element.select();
    }
}
/* -------------------------------------------------------------------------------------------------
 * FocusScope stack
 * -----------------------------------------------------------------------------------------------*/ const $07f3d261abb253b0$var$$d3863c46a17e8a28$var$focusScopesStack = $07f3d261abb253b0$var$$d3863c46a17e8a28$var$createFocusScopesStack();
function $07f3d261abb253b0$var$$d3863c46a17e8a28$var$createFocusScopesStack() {
    /** A stack of focus scopes, with the active one at the top */ let stack = [];
    return {
        add (focusScope) {
            // pause the currently active focus scope (at the top of the stack)
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope === null || activeFocusScope === void 0 || activeFocusScope.pause();
            // remove in case it already exists (because we'll re-add it at the top of the stack)
            stack = $07f3d261abb253b0$var$$d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            var _stack$;
            stack = $07f3d261abb253b0$var$$d3863c46a17e8a28$var$arrayRemove(stack, focusScope);
            (_stack$ = stack[0]) === null || _stack$ === void 0 || _stack$.resume();
        }
    };
}
function $07f3d261abb253b0$var$$d3863c46a17e8a28$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $07f3d261abb253b0$var$$d3863c46a17e8a28$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
const $07f3d261abb253b0$export$be92b6f5f03c0fe9 = $07f3d261abb253b0$export$20e40289641fbbb6;




var $2gcPZ = parcelRequire("2gcPZ");

var $fuyzp = parcelRequire("fuyzp");

/* -------------------------------------------------------------------------------------------------
 * Portal
 * -----------------------------------------------------------------------------------------------*/ const $a6c3741f57737702$var$$f1701beae083dbae$var$PORTAL_NAME = "Portal";
const $a6c3741f57737702$export$602eac185826482c = /*#__PURE__*/ (0, $2gcPZ.forwardRef)((props, forwardedRef)=>{
    var _globalThis$document;
    const { container: container = globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body, ...portalProps } = props;
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fuyzp))).createPortal(/*#__PURE__*/ (0, $2gcPZ.createElement)((0, $f90ab5fd41e8b6ae$export$250ffa63cdc0d034).div, (0, $bda49d0f75b55532$export$2e2bcd8739ae039)({}, portalProps, {
        ref: forwardedRef
    })), container) : null;
});
/*#__PURE__*/ Object.assign($a6c3741f57737702$export$602eac185826482c, {
    displayName: $a6c3741f57737702$var$$f1701beae083dbae$var$PORTAL_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $a6c3741f57737702$export$be92b6f5f03c0fe9 = $a6c3741f57737702$export$602eac185826482c;



var $2gcPZ = parcelRequire("2gcPZ");

var $fuyzp = parcelRequire("fuyzp");


function $0677d6de7ec319af$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
    return (0, $2gcPZ.useReducer)((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}
const $0677d6de7ec319af$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present, children: children } = props;
    const presence = $0677d6de7ec319af$var$$921a889cee6df7e8$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : (0, $2gcPZ.Children).only(children);
    const ref = (0, $05915cfeee427336$export$c7b2cbe3552a0d05)(presence.ref, child.ref);
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? /*#__PURE__*/ (0, $2gcPZ.cloneElement)(child, {
        ref: ref
    }) : null;
};
$0677d6de7ec319af$export$99c2b779aa4e8b8b.displayName = "Presence";
/* -------------------------------------------------------------------------------------------------
 * usePresence
 * -----------------------------------------------------------------------------------------------*/ function $0677d6de7ec319af$var$$921a889cee6df7e8$var$usePresence(present) {
    const [node1, setNode] = (0, $2gcPZ.useState)();
    const stylesRef = (0, $2gcPZ.useRef)({});
    const prevPresentRef = (0, $2gcPZ.useRef)(present);
    const prevAnimationNameRef = (0, $2gcPZ.useRef)("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $0677d6de7ec319af$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    (0, $2gcPZ.useEffect)(()=>{
        const currentAnimationName = $0677d6de7ec319af$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $6ad78e487ebda330$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $0677d6de7ec319af$var$$921a889cee6df7e8$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || (styles === null || styles === void 0 ? void 0 : styles.display) === "none") // so we unmount instantly
            send("UNMOUNT");
            else {
                /**
         * When `present` changes to `false`, we check changes to animation-name to
         * determine whether an animation has started. We chose this approach (reading
         * computed styles) because there is no `animationrun` event and `animationstart`
         * fires after `animation-delay` has expired which would be too late.
         */ const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $6ad78e487ebda330$export$e5c5a5f917a5871c)(()=>{
        if (node1) {
            /**
       * Triggering an ANIMATION_OUT during an ANIMATION_IN will fire an `animationcancel`
       * event for ANIMATION_IN after we have entered `unmountSuspended` state. So, we
       * make sure we only trigger ANIMATION_END for the currently active animation.
       */ const handleAnimationEnd = (event)=>{
                const currentAnimationName = $0677d6de7ec319af$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node1 && isCurrentAnimation) // a frame after the animation ends, creating a flash of visible content.
                // By manually flushing we ensure they sync within a frame, removing the flash.
                (0, $fuyzp.flushSync)(()=>send("ANIMATION_END"));
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node1) prevAnimationNameRef.current = $0677d6de7ec319af$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
            };
            node1.addEventListener("animationstart", handleAnimationStart);
            node1.addEventListener("animationcancel", handleAnimationEnd);
            node1.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                node1.removeEventListener("animationstart", handleAnimationStart);
                node1.removeEventListener("animationcancel", handleAnimationEnd);
                node1.removeEventListener("animationend", handleAnimationEnd);
            };
        } else // We avoid doing so during cleanup as the node may change but still exist.
        send("ANIMATION_END");
    }, [
        node1,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: (0, $2gcPZ.useCallback)((node)=>{
            if (node) stylesRef.current = getComputedStyle(node);
            setNode(node);
        }, [])
    };
}
/* -----------------------------------------------------------------------------------------------*/ function $0677d6de7ec319af$var$$921a889cee6df7e8$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || "none";
}




var $2gcPZ = parcelRequire("2gcPZ");
/** Number of components which have requested interest to have focus guards */ let $1e23601cfc033e79$var$$3db38b7d1fb3fe6a$var$count = 0;
function $1e23601cfc033e79$export$ac5b58043b79449b(props) {
    $1e23601cfc033e79$export$b7ece24a22aeda8c();
    return props.children;
}
/**
 * Injects a pair of focus guards at the edges of the whole DOM tree
 * to ensure `focusin` & `focusout` events can be caught consistently.
 */ function $1e23601cfc033e79$export$b7ece24a22aeda8c() {
    (0, $2gcPZ.useEffect)(()=>{
        var _edgeGuards$, _edgeGuards$2;
        const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
        document.body.insertAdjacentElement("afterbegin", (_edgeGuards$ = edgeGuards[0]) !== null && _edgeGuards$ !== void 0 ? _edgeGuards$ : $1e23601cfc033e79$var$$3db38b7d1fb3fe6a$var$createFocusGuard());
        document.body.insertAdjacentElement("beforeend", (_edgeGuards$2 = edgeGuards[1]) !== null && _edgeGuards$2 !== void 0 ? _edgeGuards$2 : $1e23601cfc033e79$var$$3db38b7d1fb3fe6a$var$createFocusGuard());
        $1e23601cfc033e79$var$$3db38b7d1fb3fe6a$var$count++;
        return ()=>{
            if ($1e23601cfc033e79$var$$3db38b7d1fb3fe6a$var$count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach((node)=>node.remove());
            $1e23601cfc033e79$var$$3db38b7d1fb3fe6a$var$count--;
        };
    }, []);
}
function $1e23601cfc033e79$var$$3db38b7d1fb3fe6a$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none";
    return element;
}
const $1e23601cfc033e79$export$be92b6f5f03c0fe9 = $1e23601cfc033e79$export$ac5b58043b79449b;




var $2gcPZ = parcelRequire("2gcPZ");


var $2gcPZ = parcelRequire("2gcPZ");
var $d2db2ee4ac98ab87$export$1da7500147d4bc3 = "right-scroll-bar-position";
var $d2db2ee4ac98ab87$export$898e37bbd2a0ae4e = "width-before-scroll-bar";
var $d2db2ee4ac98ab87$export$bb813dfbbc432abc = "with-scroll-bars-hidden";
var $d2db2ee4ac98ab87$export$63d0edf80fea83b1 = "--removed-body-scroll-bar-size";


/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $3efe3a9af786a067$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $2gcPZ = parcelRequire("2gcPZ");
function $4de9e5dc35a736b9$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $2gcPZ.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


function $2c40894d917f74d6$export$74665b213cb5c4cf(refs, defaultValue) {
    return (0, $4de9e5dc35a736b9$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $3efe3a9af786a067$export$d734136a7b018efe)(ref, newValue);
        });
    });
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $f000febc53786e5a$var$extendStatics = function(d, b) {
    $f000febc53786e5a$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $f000febc53786e5a$var$extendStatics(d, b);
};
function $f000febc53786e5a$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $f000febc53786e5a$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f000febc53786e5a$export$18ce0697a983be9b = function() {
    $f000febc53786e5a$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f000febc53786e5a$export$18ce0697a983be9b.apply(this, arguments);
};
function $f000febc53786e5a$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f000febc53786e5a$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $f000febc53786e5a$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $f000febc53786e5a$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $f000febc53786e5a$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $f000febc53786e5a$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $f000febc53786e5a$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $f000febc53786e5a$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $f000febc53786e5a$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f000febc53786e5a$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $f000febc53786e5a$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $f000febc53786e5a$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $f000febc53786e5a$export$45d3717a4c69092e(o, m, p);
}
function $f000febc53786e5a$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $f000febc53786e5a$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $f000febc53786e5a$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f000febc53786e5a$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $f000febc53786e5a$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $f000febc53786e5a$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $f000febc53786e5a$export$10c90e4f7922046c(v) {
    return this instanceof $f000febc53786e5a$export$10c90e4f7922046c ? (this.v = v, this) : new $f000febc53786e5a$export$10c90e4f7922046c(v);
}
function $f000febc53786e5a$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f000febc53786e5a$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $f000febc53786e5a$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $f000febc53786e5a$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $f000febc53786e5a$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $f000febc53786e5a$export$19a8beecd37a4c45 === "function" ? $f000febc53786e5a$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $f000febc53786e5a$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $f000febc53786e5a$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $f000febc53786e5a$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f000febc53786e5a$export$45d3717a4c69092e(result, mod, k);
    }
    $f000febc53786e5a$var$__setModuleDefault(result, mod);
    return result;
}
function $f000febc53786e5a$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $f000febc53786e5a$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $f000febc53786e5a$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $f000febc53786e5a$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $f000febc53786e5a$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $f000febc53786e5a$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $f000febc53786e5a$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $f000febc53786e5a$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $f000febc53786e5a$export$2e2bcd8739ae039 = {
    __extends: $f000febc53786e5a$export$a8ba968b8961cb8a,
    __assign: $f000febc53786e5a$export$18ce0697a983be9b,
    __rest: $f000febc53786e5a$export$3c9a16f847548506,
    __decorate: $f000febc53786e5a$export$29e00dfd3077644b,
    __param: $f000febc53786e5a$export$d5ad3fd78186038f,
    __metadata: $f000febc53786e5a$export$f1db080c865becb9,
    __awaiter: $f000febc53786e5a$export$1050f835b63b671e,
    __generator: $f000febc53786e5a$export$67ebef60e6f28a6,
    __createBinding: $f000febc53786e5a$export$45d3717a4c69092e,
    __exportStar: $f000febc53786e5a$export$f33643c0debef087,
    __values: $f000febc53786e5a$export$19a8beecd37a4c45,
    __read: $f000febc53786e5a$export$8d051b38c9118094,
    __spread: $f000febc53786e5a$export$afc72e2116322959,
    __spreadArrays: $f000febc53786e5a$export$6388937ca91ccae8,
    __spreadArray: $f000febc53786e5a$export$1216008129fb82ed,
    __await: $f000febc53786e5a$export$10c90e4f7922046c,
    __asyncGenerator: $f000febc53786e5a$export$e427f37a30a4de9b,
    __asyncDelegator: $f000febc53786e5a$export$bbd80228419bb833,
    __asyncValues: $f000febc53786e5a$export$e3b29a3d6162315f,
    __makeTemplateObject: $f000febc53786e5a$export$4fb47efe1390b86f,
    __importStar: $f000febc53786e5a$export$c21735bcef00d192,
    __importDefault: $f000febc53786e5a$export$da59b14a69baef04,
    __classPrivateFieldGet: $f000febc53786e5a$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $f000febc53786e5a$export$d40a35129aaff81f,
    __classPrivateFieldIn: $f000febc53786e5a$export$81fdc39f203e4e04,
    __addDisposableResource: $f000febc53786e5a$export$88ac25d8e944e405,
    __disposeResources: $f000febc53786e5a$export$8f076105dc360e92
};


function $5ee50c386a39e553$var$ItoI(a) {
    return a;
}
function $5ee50c386a39e553$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $5ee50c386a39e553$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $5ee50c386a39e553$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $5ee50c386a39e553$var$ItoI;
    return $5ee50c386a39e553$var$innerCreateMedium(defaults, middleware);
}
function $5ee50c386a39e553$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $5ee50c386a39e553$var$innerCreateMedium(null);
    medium.options = (0, $f000febc53786e5a$export$18ce0697a983be9b)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $9d0026c89db042d0$export$e27363444bedfeac = (0, $5ee50c386a39e553$export$e13ec7dd7a14088d)();


var $1f19d0b6637f29c9$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $1f19d0b6637f29c9$export$22940b497e769dee = $2gcPZ.forwardRef(function(props, parentRef) {
    var ref = $2gcPZ.useRef(null);
    var _a = $2gcPZ.useState({
        onScrollCapture: $1f19d0b6637f29c9$var$nothing,
        onWheelCapture: $1f19d0b6637f29c9$var$nothing,
        onTouchMoveCapture: $1f19d0b6637f29c9$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, rest = (0, $1737cdc3dafde60c$export$3c9a16f847548506)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $2c40894d917f74d6$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $1737cdc3dafde60c$export$18ce0697a983be9b)((0, $1737cdc3dafde60c$export$18ce0697a983be9b)({}, rest), callbacks);
    return $2gcPZ.createElement($2gcPZ.Fragment, null, enabled && $2gcPZ.createElement(SideCar, {
        sideCar: (0, $9d0026c89db042d0$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref
    }), forwardProps ? $2gcPZ.cloneElement($2gcPZ.Children.only(children), (0, $1737cdc3dafde60c$export$18ce0697a983be9b)((0, $1737cdc3dafde60c$export$18ce0697a983be9b)({}, containerProps), {
        ref: containerRef
    })) : $2gcPZ.createElement(Container, (0, $1737cdc3dafde60c$export$18ce0697a983be9b)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$1f19d0b6637f29c9$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$1f19d0b6637f29c9$export$22940b497e769dee.classNames = {
    fullWidth: (0, $d2db2ee4ac98ab87$export$898e37bbd2a0ae4e),
    zeroRight: (0, $d2db2ee4ac98ab87$export$1da7500147d4bc3)
};




var $2gcPZ = parcelRequire("2gcPZ");
var $c6378d1b07292a72$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $f000febc53786e5a$export$3c9a16f847548506)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
    var Target = sideCar.read();
    if (!Target) throw new Error("Sidecar medium not found");
    return $2gcPZ.createElement(Target, (0, $f000febc53786e5a$export$18ce0697a983be9b)({}, rest));
};
$c6378d1b07292a72$var$SideCar.isSideCarExport = true;
function $c6378d1b07292a72$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $c6378d1b07292a72$var$SideCar;
}




var $2gcPZ = parcelRequire("2gcPZ");

var $2gcPZ = parcelRequire("2gcPZ");

var $2gcPZ = parcelRequire("2gcPZ");
var $4bed58b6c6165739$var$currentNonce;
var $4bed58b6c6165739$export$c5f670b24c0ae95a = function(nonce) {
    $4bed58b6c6165739$var$currentNonce = nonce;
};
var $4bed58b6c6165739$export$2b85b721e524d74b = function() {
    if ($4bed58b6c6165739$var$currentNonce) return $4bed58b6c6165739$var$currentNonce;
    if (typeof __webpack_nonce__ !== "undefined") return __webpack_nonce__;
    return undefined;
};


function $9ba4ce6a52a7d032$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement("style");
    tag.type = "text/css";
    var nonce = (0, $4bed58b6c6165739$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute("nonce", nonce);
    return tag;
}
function $9ba4ce6a52a7d032$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $9ba4ce6a52a7d032$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(tag);
}
var $9ba4ce6a52a7d032$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $9ba4ce6a52a7d032$var$makeStyleTag()) {
                    $9ba4ce6a52a7d032$var$injectStyles(stylesheet, style);
                    $9ba4ce6a52a7d032$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


var $66f57da57c7f2fd1$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $9ba4ce6a52a7d032$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $2gcPZ.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


var $0cf0ae3bb2a93dc9$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $66f57da57c7f2fd1$export$7d7b35c2d250e94c)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};







var $3e2752d64693ef76$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $3e2752d64693ef76$var$parse = function(x) {
    return parseInt(x || "", 10) || 0;
};
var $3e2752d64693ef76$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
    var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
    var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
    return [
        $3e2752d64693ef76$var$parse(left),
        $3e2752d64693ef76$var$parse(top),
        $3e2752d64693ef76$var$parse(right)
    ];
};
var $3e2752d64693ef76$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = "margin";
    if (typeof window === "undefined") return $3e2752d64693ef76$export$efed13b5d0ca3386;
    var offsets = $3e2752d64693ef76$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $160ce299367dff83$var$Style = (0, $0cf0ae3bb2a93dc9$export$c1248ee86ba532c8)();
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $160ce299367dff83$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = "margin";
    return "\n  .".concat((0, $d2db2ee4ac98ab87$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(""), "\n  }\n  \n  .").concat((0, $d2db2ee4ac98ab87$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $d2db2ee4ac98ab87$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $d2db2ee4ac98ab87$export$1da7500147d4bc3), " .").concat((0, $d2db2ee4ac98ab87$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $d2db2ee4ac98ab87$export$898e37bbd2a0ae4e), " .").concat((0, $d2db2ee4ac98ab87$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body {\n    ").concat((0, $d2db2ee4ac98ab87$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $160ce299367dff83$export$9aa43b459c5ae9b9 = function(props) {
    var noRelative = props.noRelative, noImportant = props.noImportant, _a = props.gapMode, gapMode = _a === void 0 ? "margin" : _a;
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $2gcPZ.useMemo(function() {
        return (0, $3e2752d64693ef76$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $2gcPZ.createElement($160ce299367dff83$var$Style, {
        styles: $160ce299367dff83$var$getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "")
    });
};







var $41d9d9a4c416869a$var$passiveSupported = false;
if (typeof window !== "undefined") try {
    var $41d9d9a4c416869a$var$options = Object.defineProperty({}, "passive", {
        get: function() {
            $41d9d9a4c416869a$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener("test", $41d9d9a4c416869a$var$options, $41d9d9a4c416869a$var$options);
    // @ts-ignore
    window.removeEventListener("test", $41d9d9a4c416869a$var$options, $41d9d9a4c416869a$var$options);
} catch (err) {
    $41d9d9a4c416869a$var$passiveSupported = false;
}
var $41d9d9a4c416869a$export$10a6e88623fa9454 = $41d9d9a4c416869a$var$passiveSupported ? {
    passive: false
} : false;


var $f586b05efad33f9f$var$elementCouldBeVScrolled = function(node) {
    var styles = window.getComputedStyle(node);
    return styles.overflowY !== "hidden" && // not-not-scrollable
    !(styles.overflowY === styles.overflowX && styles.overflowY === "visible" // scrollable
    );
};
var $f586b05efad33f9f$var$elementCouldBeHScrolled = function(node) {
    var styles = window.getComputedStyle(node);
    return styles.overflowX !== "hidden" && // not-not-scrollable
    !(styles.overflowY === styles.overflowX && styles.overflowX === "visible" // scrollable
    );
};
var $f586b05efad33f9f$export$9ec64480cae49817 = function(axis, node) {
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $f586b05efad33f9f$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $f586b05efad33f9f$var$getScrollVariables(axis, current), s = _a[1], d = _a[2];
            if (s > d) return true;
        }
        current = current.parentNode;
    }while (current && current !== document.body);
    return false;
};
var $f586b05efad33f9f$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $f586b05efad33f9f$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $f586b05efad33f9f$var$elementCouldBeScrolled = function(axis, node) {
    return axis === "v" ? $f586b05efad33f9f$var$elementCouldBeVScrolled(node) : $f586b05efad33f9f$var$elementCouldBeHScrolled(node);
};
var $f586b05efad33f9f$var$getScrollVariables = function(axis, node) {
    return axis === "v" ? $f586b05efad33f9f$var$getVScrollVariables(node) : $f586b05efad33f9f$var$getHScrollVariables(node);
};
var $f586b05efad33f9f$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === "h" && direction === "rtl" ? -1 : 1;
};
var $f586b05efad33f9f$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $f586b05efad33f9f$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = $f586b05efad33f9f$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($f586b05efad33f9f$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    if (isDeltaPositive && (noOverscroll && availableScroll === 0 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && availableScrollTop === 0 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $5037e10606b71a31$export$6e085704a79f4f56 = function(event) {
    return "changedTouches" in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $5037e10606b71a31$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $5037e10606b71a31$var$extractRef = function(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $5037e10606b71a31$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $5037e10606b71a31$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $5037e10606b71a31$var$idCounter = 0;
var $5037e10606b71a31$var$lockStack = [];
function $5037e10606b71a31$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $2gcPZ.useRef([]);
    var touchStartRef = $2gcPZ.useRef([
        0,
        0
    ]);
    var activeAxis = $2gcPZ.useRef();
    var id = $2gcPZ.useState($5037e10606b71a31$var$idCounter++)[0];
    var Style = $2gcPZ.useState(function() {
        return (0, $0cf0ae3bb2a93dc9$export$c1248ee86ba532c8)();
    })[0];
    var lastProps = $2gcPZ.useRef(props);
    $2gcPZ.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $2gcPZ.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $1737cdc3dafde60c$export$1216008129fb82ed)([
                props.lockRef.current
            ], (props.shards || []).map($5037e10606b71a31$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $2gcPZ.useCallback(function(event, parent) {
        if ("touches" in event && event.touches.length === 2) return !lastProps.current.allowPinchZoom;
        var touch = $5037e10606b71a31$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ("touches" in event && moveDirection === "h" && target.type === "range") return false;
        var canBeScrolledInMainDirection = (0, $f586b05efad33f9f$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === "v" ? "h" : "v";
            canBeScrolledInMainDirection = (0, $f586b05efad33f9f$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $f586b05efad33f9f$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $2gcPZ.useCallback(function(_event) {
        var event = _event;
        if (!$5037e10606b71a31$var$lockStack.length || $5037e10606b71a31$var$lockStack[$5037e10606b71a31$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = "deltaY" in event ? $5037e10606b71a31$export$39efaa2ca254a28d(event) : $5037e10606b71a31$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && e.target === event.target && $5037e10606b71a31$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($5037e10606b71a31$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) event.preventDefault();
        }
    }, []);
    var shouldCancel = $2gcPZ.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $2gcPZ.useCallback(function(event) {
        touchStartRef.current = $5037e10606b71a31$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $2gcPZ.useCallback(function(event) {
        shouldCancel(event.type, $5037e10606b71a31$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $2gcPZ.useCallback(function(event) {
        shouldCancel(event.type, $5037e10606b71a31$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $2gcPZ.useEffect(function() {
        $5037e10606b71a31$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener("wheel", shouldPrevent, (0, $41d9d9a4c416869a$export$10a6e88623fa9454));
        document.addEventListener("touchmove", shouldPrevent, (0, $41d9d9a4c416869a$export$10a6e88623fa9454));
        document.addEventListener("touchstart", scrollTouchStart, (0, $41d9d9a4c416869a$export$10a6e88623fa9454));
        return function() {
            $5037e10606b71a31$var$lockStack = $5037e10606b71a31$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener("wheel", shouldPrevent, (0, $41d9d9a4c416869a$export$10a6e88623fa9454));
            document.removeEventListener("touchmove", shouldPrevent, (0, $41d9d9a4c416869a$export$10a6e88623fa9454));
            document.removeEventListener("touchstart", scrollTouchStart, (0, $41d9d9a4c416869a$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $2gcPZ.createElement($2gcPZ.Fragment, null, inert ? $2gcPZ.createElement(Style, {
        styles: $5037e10606b71a31$var$generateStyle(id)
    }) : null, removeScrollBar ? $2gcPZ.createElement((0, $160ce299367dff83$export$9aa43b459c5ae9b9), {
        gapMode: "margin"
    }) : null);
}



var $1f201f0954ab1819$export$2e2bcd8739ae039 = (0, $c6378d1b07292a72$export$6cacc8fb0a9b94ce)((0, $9d0026c89db042d0$export$e27363444bedfeac), (0, $5037e10606b71a31$export$a09dbff87b5da2d));


var $0da2fea6ab4df45f$var$ReactRemoveScroll = $2gcPZ.forwardRef(function(props, ref) {
    return $2gcPZ.createElement((0, $1f19d0b6637f29c9$export$22940b497e769dee), (0, $1737cdc3dafde60c$export$18ce0697a983be9b)({}, props, {
        ref: ref,
        sideCar: (0, $1f201f0954ab1819$export$2e2bcd8739ae039)
    }));
});
$0da2fea6ab4df45f$var$ReactRemoveScroll.classNames = (0, $1f19d0b6637f29c9$export$22940b497e769dee).classNames;
var $0da2fea6ab4df45f$export$2e2bcd8739ae039 = $0da2fea6ab4df45f$var$ReactRemoveScroll;


var $4ccfb26567124652$var$getDefaultParent = function(originalTarget) {
    if (typeof document === "undefined") return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $4ccfb26567124652$var$counterMap = new WeakMap();
var $4ccfb26567124652$var$uncontrolledNodes = new WeakMap();
var $4ccfb26567124652$var$markerMap = {};
var $4ccfb26567124652$var$lockCount = 0;
var $4ccfb26567124652$var$unwrapHost = function(node) {
    return node && (node.host || $4ccfb26567124652$var$unwrapHost(node.parentNode));
};
var $4ccfb26567124652$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $4ccfb26567124652$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $4ccfb26567124652$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $4ccfb26567124652$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$4ccfb26567124652$var$markerMap[markerName]) $4ccfb26567124652$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $4ccfb26567124652$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== "false";
                var counterValue = ($4ccfb26567124652$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $4ccfb26567124652$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $4ccfb26567124652$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, "true");
                if (!alreadyHidden) node.setAttribute(controlAttribute, "true");
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $4ccfb26567124652$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $4ccfb26567124652$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $4ccfb26567124652$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$4ccfb26567124652$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $4ccfb26567124652$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $4ccfb26567124652$var$lockCount--;
        if (!$4ccfb26567124652$var$lockCount) {
            // clear
            $4ccfb26567124652$var$counterMap = new WeakMap();
            $4ccfb26567124652$var$counterMap = new WeakMap();
            $4ccfb26567124652$var$uncontrolledNodes = new WeakMap();
            $4ccfb26567124652$var$markerMap = {};
        }
    };
};
var $4ccfb26567124652$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-aria-hidden";
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $4ccfb26567124652$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide ariaLive elements - https://github.com/theKashey/aria-hidden/issues/10
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live]")));
    return $4ccfb26567124652$var$applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};
var $4ccfb26567124652$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-inert-ed";
    var activeParentNode = parentNode || $4ccfb26567124652$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $4ccfb26567124652$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, "inert");
};
var $4ccfb26567124652$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== "undefined" && HTMLElement.prototype.hasOwnProperty("inert");
};
var $4ccfb26567124652$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-suppressed";
    return ($4ccfb26567124652$export$cc95fea82d705fca() ? $4ccfb26567124652$export$59151cc8db999a24 : $4ccfb26567124652$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};



/* -------------------------------------------------------------------------------------------------
 * Dialog
 * -----------------------------------------------------------------------------------------------*/ const $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME = "Dialog";
const [$af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$createDialogContext, $af9b113fa5c0743b$export$cc702773b8ea3e41] = (0, $402570e42a37610f$export$50c7b4e9d9f19c1)($af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME);
const [$af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$DialogProvider, $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$useDialogContext] = $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$createDialogContext($af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME);
const $af9b113fa5c0743b$export$3ddf2d174ce01153 = (props)=>{
    const { __scopeDialog: __scopeDialog, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = true } = props;
    const triggerRef = (0, $2gcPZ.useRef)(null);
    const contentRef = (0, $2gcPZ.useRef)(null);
    const [open = false, setOpen] = (0, $4ca5406d9c1c19f2$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0, $2gcPZ.createElement)($af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$DialogProvider, {
        scope: __scopeDialog,
        triggerRef: triggerRef,
        contentRef: contentRef,
        contentId: (0, $10f2f07514fc651e$export$f680877a34711e37)(),
        titleId: (0, $10f2f07514fc651e$export$f680877a34711e37)(),
        descriptionId: (0, $10f2f07514fc651e$export$f680877a34711e37)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: (0, $2gcPZ.useCallback)(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal: modal
    }, children);
};
/*#__PURE__*/ Object.assign($af9b113fa5c0743b$export$3ddf2d174ce01153, {
    displayName: $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$DIALOG_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogTrigger
 * -----------------------------------------------------------------------------------------------*/ const $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$TRIGGER_NAME = "DialogTrigger";
const $af9b113fa5c0743b$export$2e1e1122cf0cba88 = /*#__PURE__*/ (0, $2gcPZ.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...triggerProps } = props;
    const context = $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$useDialogContext($af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$TRIGGER_NAME, __scopeDialog);
    const composedTriggerRef = (0, $05915cfeee427336$export$c7b2cbe3552a0d05)(forwardedRef, context.triggerRef);
    return /*#__PURE__*/ (0, $2gcPZ.createElement)((0, $f90ab5fd41e8b6ae$export$250ffa63cdc0d034).button, (0, $bda49d0f75b55532$export$2e2bcd8739ae039)({
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$getState(context.open)
    }, triggerProps, {
        ref: composedTriggerRef,
        onClick: (0, $48d68b49782585c1$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    }));
});
/*#__PURE__*/ Object.assign($af9b113fa5c0743b$export$2e1e1122cf0cba88, {
    displayName: $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogPortal
 * -----------------------------------------------------------------------------------------------*/ const $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME = "DialogPortal";
const [$af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$PortalProvider, $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$usePortalContext] = $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$createDialogContext($af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME, {
    forceMount: undefined
});
const $af9b113fa5c0743b$export$dad7c95542bacce0 = (props)=>{
    const { __scopeDialog: __scopeDialog, forceMount: forceMount, children: children, container: container } = props;
    const context = $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$useDialogContext($af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $2gcPZ.createElement)($af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$PortalProvider, {
        scope: __scopeDialog,
        forceMount: forceMount
    }, (0, $2gcPZ.Children).map(children, (child)=>/*#__PURE__*/ (0, $2gcPZ.createElement)((0, $0677d6de7ec319af$export$99c2b779aa4e8b8b), {
            present: forceMount || context.open
        }, /*#__PURE__*/ (0, $2gcPZ.createElement)((0, $a6c3741f57737702$export$602eac185826482c), {
            asChild: true,
            container: container
        }, child))));
};
/*#__PURE__*/ Object.assign($af9b113fa5c0743b$export$dad7c95542bacce0, {
    displayName: $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogOverlay
 * -----------------------------------------------------------------------------------------------*/ const $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME = "DialogOverlay";
const $af9b113fa5c0743b$export$bd1d06c79be19e17 = /*#__PURE__*/ (0, $2gcPZ.forwardRef)((props, forwardedRef)=>{
    const portalContext = $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$usePortalContext($af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...overlayProps } = props;
    const context = $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$useDialogContext($af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME, props.__scopeDialog);
    return context.modal ? /*#__PURE__*/ (0, $2gcPZ.createElement)((0, $0677d6de7ec319af$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $2gcPZ.createElement)($af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$DialogOverlayImpl, (0, $bda49d0f75b55532$export$2e2bcd8739ae039)({}, overlayProps, {
        ref: forwardedRef
    }))) : null;
});
/*#__PURE__*/ Object.assign($af9b113fa5c0743b$export$bd1d06c79be19e17, {
    displayName: $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME
});
const $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$DialogOverlayImpl = /*#__PURE__*/ (0, $2gcPZ.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...overlayProps } = props;
    const context = $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$useDialogContext($af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$OVERLAY_NAME, __scopeDialog);
    return(/*#__PURE__*/ // ie. when `Overlay` and `Content` are siblings
    (0, $2gcPZ.createElement)((0, $0da2fea6ab4df45f$export$2e2bcd8739ae039), {
        as: (0, $9e5ea6b8bf7bed41$export$8c6ed5c666ac1360),
        allowPinchZoom: true,
        shards: [
            context.contentRef
        ]
    }, /*#__PURE__*/ (0, $2gcPZ.createElement)((0, $f90ab5fd41e8b6ae$export$250ffa63cdc0d034).div, (0, $bda49d0f75b55532$export$2e2bcd8739ae039)({
        "data-state": $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$getState(context.open)
    }, overlayProps, {
        ref: forwardedRef // We re-enable pointer-events prevented by `Dialog.Content` to allow scrolling the overlay.
        ,
        style: {
            pointerEvents: "auto",
            ...overlayProps.style
        }
    }))));
});
/* -------------------------------------------------------------------------------------------------
 * DialogContent
 * -----------------------------------------------------------------------------------------------*/ const $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME = "DialogContent";
const $af9b113fa5c0743b$export$b6d9565de1e068cf = /*#__PURE__*/ (0, $2gcPZ.forwardRef)((props, forwardedRef)=>{
    const portalContext = $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$usePortalContext($af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$useDialogContext($af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    return /*#__PURE__*/ (0, $2gcPZ.createElement)((0, $0677d6de7ec319af$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, context.modal ? /*#__PURE__*/ (0, $2gcPZ.createElement)($af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$DialogContentModal, (0, $bda49d0f75b55532$export$2e2bcd8739ae039)({}, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ (0, $2gcPZ.createElement)($af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$DialogContentNonModal, (0, $bda49d0f75b55532$export$2e2bcd8739ae039)({}, contentProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($af9b113fa5c0743b$export$b6d9565de1e068cf, {
    displayName: $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$DialogContentModal = /*#__PURE__*/ (0, $2gcPZ.forwardRef)((props, forwardedRef)=>{
    const context = $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$useDialogContext($af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const contentRef = (0, $2gcPZ.useRef)(null);
    const composedRefs = (0, $05915cfeee427336$export$c7b2cbe3552a0d05)(forwardedRef, context.contentRef, contentRef); // aria-hide everything except the content (better supported equivalent to setting aria-modal)
    (0, $2gcPZ.useEffect)(()=>{
        const content = contentRef.current;
        if (content) return (0, $4ccfb26567124652$export$6e33d16126ed003c)(content);
    }, []);
    return /*#__PURE__*/ (0, $2gcPZ.createElement)($af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$DialogContentImpl, (0, $bda49d0f75b55532$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs // we make sure focus isn't trapped once `DialogContent` has been closed
        ,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: (0, $48d68b49782585c1$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
            var _context$triggerRef$c;
            event.preventDefault();
            (_context$triggerRef$c = context.triggerRef.current) === null || _context$triggerRef$c === void 0 || _context$triggerRef$c.focus();
        }),
        onPointerDownOutside: (0, $48d68b49782585c1$export$b9ecd428b558ff10)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick; // If the event is a right-click, we shouldn't close because
            // it is effectively as if we right-clicked the `Overlay`.
            if (isRightClick) event.preventDefault();
        }) // When focus is trapped, a `focusout` event may still happen.
        ,
        onFocusOutside: (0, $48d68b49782585c1$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault())
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$DialogContentNonModal = /*#__PURE__*/ (0, $2gcPZ.forwardRef)((props, forwardedRef)=>{
    const context = $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$useDialogContext($af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, props.__scopeDialog);
    const hasInteractedOutsideRef = (0, $2gcPZ.useRef)(false);
    return /*#__PURE__*/ (0, $2gcPZ.createElement)($af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$DialogContentImpl, (0, $bda49d0f75b55532$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            var _props$onCloseAutoFoc;
            (_props$onCloseAutoFoc = props.onCloseAutoFocus) === null || _props$onCloseAutoFoc === void 0 || _props$onCloseAutoFoc.call(props, event);
            if (!event.defaultPrevented) {
                var _context$triggerRef$c2;
                if (!hasInteractedOutsideRef.current) (_context$triggerRef$c2 = context.triggerRef.current) === null || _context$triggerRef$c2 === void 0 || _context$triggerRef$c2.focus(); // Always prevent auto focus because we either focus manually or want user agent focus
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            var _props$onInteractOuts, _context$triggerRef$c3;
            (_props$onInteractOuts = props.onInteractOutside) === null || _props$onInteractOuts === void 0 || _props$onInteractOuts.call(props, event);
            if (!event.defaultPrevented) hasInteractedOutsideRef.current = true; // Prevent dismissing when clicking the trigger.
            // As the trigger is already setup to close, without doing so would
            // cause it to close and immediately open.
            //
            // We use `onInteractOutside` as some browsers also
            // focus on pointer down, creating the same issue.
            const target = event.target;
            const targetIsTrigger = (_context$triggerRef$c3 = context.triggerRef.current) === null || _context$triggerRef$c3 === void 0 ? void 0 : _context$triggerRef$c3.contains(target);
            if (targetIsTrigger) event.preventDefault();
        }
    }));
});
/* -----------------------------------------------------------------------------------------------*/ const $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$DialogContentImpl = /*#__PURE__*/ (0, $2gcPZ.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, ...contentProps } = props;
    const context = $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$useDialogContext($af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME, __scopeDialog);
    const contentRef = (0, $2gcPZ.useRef)(null);
    const composedRefs = (0, $05915cfeee427336$export$c7b2cbe3552a0d05)(forwardedRef, contentRef); // Make sure the whole tree has focus guards as our `Dialog` will be
    // the last element in the DOM (beacuse of the `Portal`)
    (0, $1e23601cfc033e79$export$b7ece24a22aeda8c)();
    return /*#__PURE__*/ (0, $2gcPZ.createElement)((0, $2gcPZ.Fragment), null, /*#__PURE__*/ (0, $2gcPZ.createElement)((0, $07f3d261abb253b0$export$20e40289641fbbb6), {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus
    }, /*#__PURE__*/ (0, $2gcPZ.createElement)((0, $7273f1a572fa7952$export$177fb62ff3ec1f22), (0, $bda49d0f75b55532$export$2e2bcd8739ae039)({
        role: "dialog",
        id: context.contentId,
        "aria-describedby": context.descriptionId,
        "aria-labelledby": context.titleId,
        "data-state": $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$getState(context.open)
    }, contentProps, {
        ref: composedRefs,
        onDismiss: ()=>context.onOpenChange(false)
    }))), false);
});
/* -------------------------------------------------------------------------------------------------
 * DialogTitle
 * -----------------------------------------------------------------------------------------------*/ const $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$TITLE_NAME = "DialogTitle";
const $af9b113fa5c0743b$export$16f7638e4a34b909 = /*#__PURE__*/ (0, $2gcPZ.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...titleProps } = props;
    const context = $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$useDialogContext($af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$TITLE_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $2gcPZ.createElement)((0, $f90ab5fd41e8b6ae$export$250ffa63cdc0d034).h2, (0, $bda49d0f75b55532$export$2e2bcd8739ae039)({
        id: context.titleId
    }, titleProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($af9b113fa5c0743b$export$16f7638e4a34b909, {
    displayName: $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$TITLE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogDescription
 * -----------------------------------------------------------------------------------------------*/ const $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_NAME = "DialogDescription";
const $af9b113fa5c0743b$export$94e94c2ec2c954d5 = /*#__PURE__*/ (0, $2gcPZ.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...descriptionProps } = props;
    const context = $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$useDialogContext($af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $2gcPZ.createElement)((0, $f90ab5fd41e8b6ae$export$250ffa63cdc0d034).p, (0, $bda49d0f75b55532$export$2e2bcd8739ae039)({
        id: context.descriptionId
    }, descriptionProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($af9b113fa5c0743b$export$94e94c2ec2c954d5, {
    displayName: $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DialogClose
 * -----------------------------------------------------------------------------------------------*/ const $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$CLOSE_NAME = "DialogClose";
const $af9b113fa5c0743b$export$fba2fb7cd781b7ac = /*#__PURE__*/ (0, $2gcPZ.forwardRef)((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...closeProps } = props;
    const context = $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$useDialogContext($af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$CLOSE_NAME, __scopeDialog);
    return /*#__PURE__*/ (0, $2gcPZ.createElement)((0, $f90ab5fd41e8b6ae$export$250ffa63cdc0d034).button, (0, $bda49d0f75b55532$export$2e2bcd8739ae039)({
        type: "button"
    }, closeProps, {
        ref: forwardedRef,
        onClick: (0, $48d68b49782585c1$export$b9ecd428b558ff10)(props.onClick, ()=>context.onOpenChange(false))
    }));
});
/*#__PURE__*/ Object.assign($af9b113fa5c0743b$export$fba2fb7cd781b7ac, {
    displayName: $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$CLOSE_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$getState(open) {
    return open ? "open" : "closed";
}
const $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME = "DialogTitleWarning";
const [$af9b113fa5c0743b$export$69b62a49393917d6, $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$useWarningContext] = (0, $402570e42a37610f$export$fd42f52fd3ae1109)($af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME, {
    contentName: $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$CONTENT_NAME,
    titleName: $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$TITLE_NAME,
    docsSlug: "dialog"
});
const $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$TitleWarning = ({ titleId: titleId })=>{
    const titleWarningContext = $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$useWarningContext($af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$TITLE_WARNING_NAME);
    const MESSAGE = `\`${titleWarningContext.contentName}\` requires a \`${titleWarningContext.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${titleWarningContext.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${titleWarningContext.docsSlug}`;
    (0, $2gcPZ.useEffect)(()=>{
        if (titleId) {
            const hasTitle = document.getElementById(titleId);
            if (!hasTitle) throw new Error(MESSAGE);
        }
    }, [
        MESSAGE,
        titleId
    ]);
    return null;
};
const $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_WARNING_NAME = "DialogDescriptionWarning";
const $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$DescriptionWarning = ({ contentRef: contentRef, descriptionId: descriptionId })=>{
    const descriptionWarningContext = $af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$useWarningContext($af9b113fa5c0743b$var$$5d3850c4d0b4e6c7$var$DESCRIPTION_WARNING_NAME);
    const MESSAGE = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${descriptionWarningContext.contentName}}.`;
    (0, $2gcPZ.useEffect)(()=>{
        var _contentRef$current;
        const describedById = (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.getAttribute("aria-describedby"); // if we have an id and the user hasn't set aria-describedby={undefined}
        if (descriptionId && describedById) {
            const hasDescription = document.getElementById(descriptionId);
            if (!hasDescription) console.warn(MESSAGE);
        }
    }, [
        MESSAGE,
        contentRef,
        descriptionId
    ]);
    return null;
};
const $af9b113fa5c0743b$export$be92b6f5f03c0fe9 = $af9b113fa5c0743b$export$3ddf2d174ce01153;
const $af9b113fa5c0743b$export$41fb9f06171c75f4 = $af9b113fa5c0743b$export$2e1e1122cf0cba88;
const $af9b113fa5c0743b$export$602eac185826482c = $af9b113fa5c0743b$export$dad7c95542bacce0;
const $af9b113fa5c0743b$export$c6fdb837b070b4ff = $af9b113fa5c0743b$export$bd1d06c79be19e17;
const $af9b113fa5c0743b$export$7c6e2c02157bb7d2 = $af9b113fa5c0743b$export$b6d9565de1e068cf;
const $af9b113fa5c0743b$export$f99233281efd08a0 = $af9b113fa5c0743b$export$16f7638e4a34b909;
const $af9b113fa5c0743b$export$393edc798c47379d = $af9b113fa5c0743b$export$94e94c2ec2c954d5;
const $af9b113fa5c0743b$export$f39c2d165cd861fe = $af9b113fa5c0743b$export$fba2fb7cd781b7ac;



var $2gcPZ = parcelRequire("2gcPZ");
var $b4e97491b0623db7$exports = {};
// The scores are arranged so that a continuous match of characters will
// result in a total score of 1.
//
// The best case, this character is a match, and either this is the start
// of the string, or the previous character was also a match.
var $b4e97491b0623db7$var$SCORE_CONTINUE_MATCH = 1, // A new match at the start of a word scores better than a new match
// elsewhere as it's more likely that the user will type the starts
// of fragments.
// (Our notion of word includes CamelCase and hypen-separated, etc.)
$b4e97491b0623db7$var$SCORE_WORD_JUMP = 0.9, // Any other match isn't ideal, but we include it for completeness.
$b4e97491b0623db7$var$SCORE_CHARACTER_JUMP = 0.3, // If the user transposed two letters, it should be signficantly penalized.
//
// i.e. "ouch" is more likely than "curtain" when "uc" is typed.
$b4e97491b0623db7$var$SCORE_TRANSPOSITION = 0.1, // If the user jumped to half-way through a subsequent word, it should be
// very significantly penalized.
//
// i.e. "loes" is very unlikely to match "loch ness".
// NOTE: this is set to 0 for superhuman right now, but we may want to revisit.
$b4e97491b0623db7$var$SCORE_LONG_JUMP = 0, // The goodness of a match should decay slightly with each missing
// character.
//
// i.e. "bad" is more likely than "bard" when "bd" is typed.
//
// This will not change the order of suggestions based on SCORE_* until
// 100 characters are inserted between matches.
$b4e97491b0623db7$var$PENALTY_SKIPPED = 0.999, // The goodness of an exact-case match should be higher than a
// case-insensitive match by a small amount.
//
// i.e. "HTML" is more likely than "haml" when "HM" is typed.
//
// This will not change the order of suggestions based on SCORE_* until
// 1000 characters are inserted between matches.
$b4e97491b0623db7$var$PENALTY_CASE_MISMATCH = 0.9999, // If the word has more characters than the user typed, it should
// be penalised slightly.
//
// i.e. "html" is more likely than "html5" if I type "html".
//
// However, it may well be the case that there's a sensible secondary
// ordering (like alphabetical) that it makes sense to rely on when
// there are many prefix matches, so we don't make the penalty increase
// with the number of tokens.
$b4e97491b0623db7$var$PENALTY_NOT_COMPLETE = 0.99;
var $b4e97491b0623db7$var$IS_GAP_REGEXP = /[\\\/\-_+.# \t"@\[\(\{&]/, $b4e97491b0623db7$var$COUNT_GAPS_REGEXP = /[\\\/\-_+.# \t"@\[\(\{&]/g;
function $b4e97491b0623db7$var$commandScoreInner(string, abbreviation, lowerString, lowerAbbreviation, stringIndex, abbreviationIndex) {
    if (abbreviationIndex === abbreviation.length) {
        if (stringIndex === string.length) return $b4e97491b0623db7$var$SCORE_CONTINUE_MATCH;
        return $b4e97491b0623db7$var$PENALTY_NOT_COMPLETE;
    }
    var abbreviationChar = lowerAbbreviation.charAt(abbreviationIndex);
    var index = lowerString.indexOf(abbreviationChar, stringIndex);
    var highScore = 0;
    var score, transposedScore, wordBreaks;
    while(index >= 0){
        score = $b4e97491b0623db7$var$commandScoreInner(string, abbreviation, lowerString, lowerAbbreviation, index + 1, abbreviationIndex + 1);
        if (score > highScore) {
            if (index === stringIndex) score *= $b4e97491b0623db7$var$SCORE_CONTINUE_MATCH;
            else if ($b4e97491b0623db7$var$IS_GAP_REGEXP.test(string.charAt(index - 1))) {
                score *= $b4e97491b0623db7$var$SCORE_WORD_JUMP;
                wordBreaks = string.slice(stringIndex, index - 1).match($b4e97491b0623db7$var$COUNT_GAPS_REGEXP);
                if (wordBreaks && stringIndex > 0) score *= Math.pow($b4e97491b0623db7$var$PENALTY_SKIPPED, wordBreaks.length);
            } else if ($b4e97491b0623db7$var$IS_GAP_REGEXP.test(string.slice(stringIndex, index - 1))) {
                score *= $b4e97491b0623db7$var$SCORE_LONG_JUMP;
                if (stringIndex > 0) score *= Math.pow($b4e97491b0623db7$var$PENALTY_SKIPPED, index - stringIndex);
            } else {
                score *= $b4e97491b0623db7$var$SCORE_CHARACTER_JUMP;
                if (stringIndex > 0) score *= Math.pow($b4e97491b0623db7$var$PENALTY_SKIPPED, index - stringIndex);
            }
            if (string.charAt(index) !== abbreviation.charAt(abbreviationIndex)) score *= $b4e97491b0623db7$var$PENALTY_CASE_MISMATCH;
        }
        if (score < $b4e97491b0623db7$var$SCORE_TRANSPOSITION && lowerString.charAt(index - 1) === lowerAbbreviation.charAt(abbreviationIndex + 1) && lowerString.charAt(index - 1) !== lowerAbbreviation.charAt(abbreviationIndex)) {
            transposedScore = $b4e97491b0623db7$var$commandScoreInner(string, abbreviation, lowerString, lowerAbbreviation, index + 1, abbreviationIndex + 2);
            if (transposedScore * $b4e97491b0623db7$var$SCORE_TRANSPOSITION > score) score = transposedScore * $b4e97491b0623db7$var$SCORE_TRANSPOSITION;
        }
        if (score > highScore) highScore = score;
        index = lowerString.indexOf(abbreviationChar, index + 1);
    }
    return highScore;
}
function $b4e97491b0623db7$var$commandScore(string, abbreviation) {
    /* NOTE:
     * in the original, we used to do the lower-casing on each recursive call, but this meant that toLowerCase()
     * was the dominating cost in the algorithm, passing both is a little ugly, but considerably faster.
     */ return $b4e97491b0623db7$var$commandScoreInner(string, abbreviation, string.toLowerCase(), abbreviation.toLowerCase(), 0, 0);
}
$b4e97491b0623db7$exports = $b4e97491b0623db7$var$commandScore;


var $f8f3429cfd7577a0$var$ue = '[cmdk-list-sizer=""]', $f8f3429cfd7577a0$var$M = '[cmdk-group=""]', $f8f3429cfd7577a0$var$N = '[cmdk-group-items=""]', $f8f3429cfd7577a0$var$de = '[cmdk-group-heading=""]', $f8f3429cfd7577a0$var$ee = '[cmdk-item=""]', $f8f3429cfd7577a0$var$Z = `${$f8f3429cfd7577a0$var$ee}:not([aria-disabled="true"])`, $f8f3429cfd7577a0$var$z = "cmdk-item-select", $f8f3429cfd7577a0$var$S = "data-value", $f8f3429cfd7577a0$var$fe = (n, a)=>(0, (/*@__PURE__*/$parcel$interopDefault($b4e97491b0623db7$exports)))(n, a), $f8f3429cfd7577a0$var$te = $2gcPZ.createContext(void 0), $f8f3429cfd7577a0$var$k = ()=>$2gcPZ.useContext($f8f3429cfd7577a0$var$te), $f8f3429cfd7577a0$var$re = $2gcPZ.createContext(void 0), $f8f3429cfd7577a0$var$U = ()=>$2gcPZ.useContext($f8f3429cfd7577a0$var$re), $f8f3429cfd7577a0$var$ne = $2gcPZ.createContext(void 0), $f8f3429cfd7577a0$export$6def88b96ee4affb = $2gcPZ.forwardRef((n, a)=>{
    let r = $2gcPZ.useRef(null), o = $f8f3429cfd7577a0$var$x(()=>({
            search: "",
            value: "",
            filtered: {
                count: 0,
                items: new Map,
                groups: new Set
            }
        })), u = $f8f3429cfd7577a0$var$x(()=>new Set), l = $f8f3429cfd7577a0$var$x(()=>new Map), p = $f8f3429cfd7577a0$var$x(()=>new Map), f = $f8f3429cfd7577a0$var$x(()=>new Set), d = $f8f3429cfd7577a0$var$ae(n), { label: v, children: E, value: R, onValueChange: w, filter: O, shouldFilter: ie, ...D } = n, F = $2gcPZ.useId(), g = $2gcPZ.useId(), A = $2gcPZ.useId(), y = $f8f3429cfd7577a0$var$ye();
    $f8f3429cfd7577a0$var$L(()=>{
        if (R !== void 0) {
            let e = R.trim().toLowerCase();
            o.current.value = e, y(6, W), h.emit();
        }
    }, [
        R
    ]);
    let h = $2gcPZ.useMemo(()=>({
            subscribe: (e)=>(f.current.add(e), ()=>f.current.delete(e)),
            snapshot: ()=>o.current,
            setState: (e, c, i)=>{
                var s, m, b;
                if (!Object.is(o.current[e], c)) {
                    if (o.current[e] = c, e === "search") j(), G(), y(1, V);
                    else if (e === "value") {
                        if (((s = d.current) == null ? void 0 : s.value) !== void 0) {
                            (b = (m = d.current).onValueChange) == null || b.call(m, c);
                            return;
                        } else i || y(5, W);
                    }
                    h.emit();
                }
            },
            emit: ()=>{
                f.current.forEach((e)=>e());
            }
        }), []), K = $2gcPZ.useMemo(()=>({
            value: (e, c)=>{
                c !== p.current.get(e) && (p.current.set(e, c), o.current.filtered.items.set(e, B(c)), y(2, ()=>{
                    G(), h.emit();
                }));
            },
            item: (e, c)=>(u.current.add(e), c && (l.current.has(c) ? l.current.get(c).add(e) : l.current.set(c, new Set([
                    e
                ]))), y(3, ()=>{
                    j(), G(), o.current.value || V(), h.emit();
                }), ()=>{
                    p.current.delete(e), u.current.delete(e), o.current.filtered.items.delete(e), y(4, ()=>{
                        j(), V(), h.emit();
                    });
                }),
            group: (e)=>(l.current.has(e) || l.current.set(e, new Set), ()=>{
                    p.current.delete(e), l.current.delete(e);
                }),
            filter: ()=>d.current.shouldFilter,
            label: v || n["aria-label"],
            listId: F,
            inputId: A,
            labelId: g
        }), []);
    function B(e) {
        var i;
        let c = ((i = d.current) == null ? void 0 : i.filter) ?? $f8f3429cfd7577a0$var$fe;
        return e ? c(e, o.current.search) : 0;
    }
    function G() {
        if (!r.current || !o.current.search || d.current.shouldFilter === !1) return;
        let e = o.current.filtered.items, c = [];
        o.current.filtered.groups.forEach((s)=>{
            let m = l.current.get(s), b = 0;
            m.forEach((P)=>{
                let ce = e.get(P);
                b = Math.max(ce, b);
            }), c.push([
                s,
                b
            ]);
        });
        let i = r.current.querySelector($f8f3429cfd7577a0$var$ue);
        I().sort((s, m)=>{
            let b = s.getAttribute($f8f3429cfd7577a0$var$S), P = m.getAttribute($f8f3429cfd7577a0$var$S);
            return (e.get(P) ?? 0) - (e.get(b) ?? 0);
        }).forEach((s)=>{
            let m = s.closest($f8f3429cfd7577a0$var$N);
            m ? m.appendChild(s.parentElement === m ? s : s.closest(`${$f8f3429cfd7577a0$var$N} > *`)) : i.appendChild(s.parentElement === i ? s : s.closest(`${$f8f3429cfd7577a0$var$N} > *`));
        }), c.sort((s, m)=>m[1] - s[1]).forEach((s)=>{
            let m = r.current.querySelector(`${$f8f3429cfd7577a0$var$M}[${$f8f3429cfd7577a0$var$S}="${s[0]}"]`);
            m == null || m.parentElement.appendChild(m);
        });
    }
    function V() {
        let e = I().find((i)=>!i.ariaDisabled), c = e == null ? void 0 : e.getAttribute($f8f3429cfd7577a0$var$S);
        h.setState("value", c || void 0);
    }
    function j() {
        if (!o.current.search || d.current.shouldFilter === !1) {
            o.current.filtered.count = u.current.size;
            return;
        }
        o.current.filtered.groups = new Set;
        let e = 0;
        for (let c of u.current){
            let i = p.current.get(c), s = B(i);
            o.current.filtered.items.set(c, s), s > 0 && e++;
        }
        for (let [c, i] of l.current)for (let s of i)if (o.current.filtered.items.get(s) > 0) {
            o.current.filtered.groups.add(c);
            break;
        }
        o.current.filtered.count = e;
    }
    function W() {
        var c, i, s;
        let e = _();
        e && (((c = e.parentElement) == null ? void 0 : c.firstChild) === e && ((s = (i = e.closest($f8f3429cfd7577a0$var$M)) == null ? void 0 : i.querySelector($f8f3429cfd7577a0$var$de)) == null || s.scrollIntoView({
            block: "nearest"
        })), e.scrollIntoView({
            block: "nearest"
        }));
    }
    function _() {
        return r.current.querySelector(`${$f8f3429cfd7577a0$var$ee}[aria-selected="true"]`);
    }
    function I() {
        return Array.from(r.current.querySelectorAll($f8f3429cfd7577a0$var$Z));
    }
    function q(e) {
        let i = I()[e];
        i && h.setState("value", i.getAttribute($f8f3429cfd7577a0$var$S));
    }
    function $(e) {
        var b;
        let c = _(), i = I(), s = i.findIndex((P)=>P === c), m = i[s + e];
        (b = d.current) != null && b.loop && (m = s + e < 0 ? i[i.length - 1] : s + e === i.length ? i[0] : i[s + e]), m && h.setState("value", m.getAttribute($f8f3429cfd7577a0$var$S));
    }
    function J(e) {
        let c = _(), i = c == null ? void 0 : c.closest($f8f3429cfd7577a0$var$M), s;
        for(; i && !s;)i = e > 0 ? $f8f3429cfd7577a0$var$Se(i, $f8f3429cfd7577a0$var$M) : $f8f3429cfd7577a0$var$Ce(i, $f8f3429cfd7577a0$var$M), s = i == null ? void 0 : i.querySelector($f8f3429cfd7577a0$var$Z);
        s ? h.setState("value", s.getAttribute($f8f3429cfd7577a0$var$S)) : $(e);
    }
    let Q = ()=>q(I().length - 1), X = (e)=>{
        e.preventDefault(), e.metaKey ? Q() : e.altKey ? J(1) : $(1);
    }, Y = (e)=>{
        e.preventDefault(), e.metaKey ? q(0) : e.altKey ? J(-1) : $(-1);
    };
    return $2gcPZ.createElement("div", {
        ref: $f8f3429cfd7577a0$var$H([
            r,
            a
        ]),
        ...D,
        "cmdk-root": "",
        onKeyDown: (e)=>{
            var c;
            if ((c = D.onKeyDown) == null || c.call(D, e), !e.defaultPrevented) switch(e.key){
                case "n":
                case "j":
                    e.ctrlKey && X(e);
                    break;
                case "ArrowDown":
                    X(e);
                    break;
                case "p":
                case "k":
                    e.ctrlKey && Y(e);
                    break;
                case "ArrowUp":
                    Y(e);
                    break;
                case "Home":
                    e.preventDefault(), q(0);
                    break;
                case "End":
                    e.preventDefault(), Q();
                    break;
                case "Enter":
                    {
                        e.preventDefault();
                        let i = _();
                        if (i) {
                            let s = new Event($f8f3429cfd7577a0$var$z);
                            i.dispatchEvent(s);
                        }
                    }
            }
        }
    }, $2gcPZ.createElement("label", {
        "cmdk-label": "",
        htmlFor: K.inputId,
        id: K.labelId,
        style: $f8f3429cfd7577a0$var$xe
    }, v), $2gcPZ.createElement($f8f3429cfd7577a0$var$re.Provider, {
        value: h
    }, $2gcPZ.createElement($f8f3429cfd7577a0$var$te.Provider, {
        value: K
    }, E)));
}), $f8f3429cfd7577a0$export$b9b346a733d36f61 = $2gcPZ.forwardRef((n, a)=>{
    let r = $2gcPZ.useId(), o = $2gcPZ.useRef(null), u = $2gcPZ.useContext($f8f3429cfd7577a0$var$ne), l = $f8f3429cfd7577a0$var$k(), p = $f8f3429cfd7577a0$var$ae(n);
    $f8f3429cfd7577a0$var$L(()=>l.item(r, u), []);
    let f = $f8f3429cfd7577a0$var$se(r, o, [
        n.value,
        n.children,
        o
    ]), d = $f8f3429cfd7577a0$var$U(), v = $f8f3429cfd7577a0$export$606184d999862dff((g)=>g.value && g.value === f.current), E = $f8f3429cfd7577a0$export$606184d999862dff((g)=>l.filter() === !1 ? !0 : g.search ? g.filtered.items.get(r) > 0 : !0);
    $2gcPZ.useEffect(()=>{
        let g = o.current;
        if (!(!g || n.disabled)) return g.addEventListener($f8f3429cfd7577a0$var$z, R), ()=>g.removeEventListener($f8f3429cfd7577a0$var$z, R);
    }, [
        E,
        n.onSelect,
        n.disabled
    ]);
    function R() {
        var g, A;
        (A = (g = p.current).onSelect) == null || A.call(g, f.current);
    }
    function w() {
        d.setState("value", f.current, !0);
    }
    if (!E) return null;
    let { disabled: O, value: ie, onSelect: D, ...F } = n;
    return $2gcPZ.createElement("div", {
        ref: $f8f3429cfd7577a0$var$H([
            o,
            a
        ]),
        ...F,
        "cmdk-item": "",
        role: "option",
        "aria-disabled": O || void 0,
        "aria-selected": v || void 0,
        "data-selected": v || void 0,
        onPointerMove: O ? void 0 : w,
        onClick: O ? void 0 : R
    }, n.children);
}), $f8f3429cfd7577a0$export$c157b9873a7a0fbd = $2gcPZ.forwardRef((n, a)=>{
    let { heading: r, children: o, ...u } = n, l = $2gcPZ.useId(), p = $2gcPZ.useRef(null), f = $2gcPZ.useRef(null), d = $2gcPZ.useId(), v = $f8f3429cfd7577a0$var$k(), E = $f8f3429cfd7577a0$export$606184d999862dff((w)=>v.filter() === !1 ? !0 : w.search ? w.filtered.groups.has(l) : !0);
    $f8f3429cfd7577a0$var$L(()=>v.group(l), []), $f8f3429cfd7577a0$var$se(l, p, [
        n.value,
        n.heading,
        f
    ]);
    let R = $2gcPZ.createElement($f8f3429cfd7577a0$var$ne.Provider, {
        value: l
    }, o);
    return $2gcPZ.createElement("div", {
        ref: $f8f3429cfd7577a0$var$H([
            p,
            a
        ]),
        ...u,
        "cmdk-group": "",
        role: "presentation",
        hidden: E ? void 0 : !0
    }, r && $2gcPZ.createElement("div", {
        ref: f,
        "cmdk-group-heading": "",
        "aria-hidden": !0,
        id: d
    }, r), $2gcPZ.createElement("div", {
        "cmdk-group-items": "",
        role: "group",
        "aria-labelledby": r ? d : void 0
    }, R));
}), $f8f3429cfd7577a0$export$ace649eed6990b42 = $2gcPZ.forwardRef((n, a)=>{
    let { alwaysRender: r, ...o } = n, u = $2gcPZ.useRef(null), l = $f8f3429cfd7577a0$export$606184d999862dff((p)=>!p.search);
    return !r && !l ? null : $2gcPZ.createElement("div", {
        ref: $f8f3429cfd7577a0$var$H([
            u,
            a
        ]),
        ...o,
        "cmdk-separator": "",
        role: "separator"
    });
}), $f8f3429cfd7577a0$export$ebdebb88e46df62a = $2gcPZ.forwardRef((n, a)=>{
    let { onValueChange: r, ...o } = n, u = n.value != null, l = $f8f3429cfd7577a0$var$U(), p = $f8f3429cfd7577a0$export$606184d999862dff((d)=>d.search), f = $f8f3429cfd7577a0$var$k();
    return $2gcPZ.useEffect(()=>{
        n.value != null && l.setState("search", n.value);
    }, [
        n.value
    ]), $2gcPZ.createElement("input", {
        ref: a,
        ...o,
        "cmdk-input": "",
        autoComplete: "off",
        autoCorrect: "off",
        spellCheck: !1,
        "aria-autocomplete": "list",
        role: "combobox",
        "aria-expanded": !0,
        "aria-controls": f.listId,
        "aria-labelledby": f.labelId,
        id: f.inputId,
        type: "text",
        value: u ? n.value : p,
        onChange: (d)=>{
            u || l.setState("search", d.target.value), r == null || r(d.target.value);
        }
    });
}), $f8f3429cfd7577a0$export$9cffcb65e9381872 = $2gcPZ.forwardRef((n, a)=>{
    let { children: r, ...o } = n, u = $2gcPZ.useRef(null), l = $2gcPZ.useRef(null), p = $f8f3429cfd7577a0$var$k();
    return $2gcPZ.useEffect(()=>{
        if (l.current && u.current) {
            let f = l.current, d = u.current, v, E = new ResizeObserver(()=>{
                v = requestAnimationFrame(()=>{
                    let R = f.getBoundingClientRect().height;
                    d.style.setProperty("--cmdk-list-height", R.toFixed(1) + "px");
                });
            });
            return E.observe(f), ()=>{
                cancelAnimationFrame(v), E.unobserve(f);
            };
        }
    }, []), $2gcPZ.createElement("div", {
        ref: $f8f3429cfd7577a0$var$H([
            u,
            a
        ]),
        ...o,
        "cmdk-list": "",
        role: "listbox",
        "aria-label": "Suggestions",
        id: p.listId,
        "aria-labelledby": p.inputId
    }, $2gcPZ.createElement("div", {
        ref: l,
        "cmdk-list-sizer": ""
    }, r));
}), $f8f3429cfd7577a0$export$98f0540b5c04f3e8 = $2gcPZ.forwardRef((n, a)=>{
    let { open: r, onOpenChange: o, container: u, ...l } = n;
    return $2gcPZ.createElement($af9b113fa5c0743b$export$be92b6f5f03c0fe9, {
        open: r,
        onOpenChange: o
    }, $2gcPZ.createElement($af9b113fa5c0743b$export$602eac185826482c, {
        container: u
    }, $2gcPZ.createElement($af9b113fa5c0743b$export$c6fdb837b070b4ff, {
        "cmdk-overlay": ""
    }), $2gcPZ.createElement($af9b113fa5c0743b$export$7c6e2c02157bb7d2, {
        "aria-label": n.label,
        "cmdk-dialog": ""
    }, $2gcPZ.createElement($f8f3429cfd7577a0$export$6def88b96ee4affb, {
        ref: a,
        ...l
    }))));
}), $f8f3429cfd7577a0$export$f1753c65029fce09 = $2gcPZ.forwardRef((n, a)=>{
    let r = $2gcPZ.useRef(!0), o = $f8f3429cfd7577a0$export$606184d999862dff((u)=>u.filtered.count === 0);
    return $2gcPZ.useEffect(()=>{
        r.current = !1;
    }, []), r.current || !o ? null : $2gcPZ.createElement("div", {
        ref: a,
        ...n,
        "cmdk-empty": "",
        role: "presentation"
    });
}), $f8f3429cfd7577a0$export$8980984ffcab084a = $2gcPZ.forwardRef((n, a)=>{
    let { progress: r, children: o, ...u } = n;
    return $2gcPZ.createElement("div", {
        ref: a,
        ...u,
        "cmdk-loading": "",
        role: "progressbar",
        "aria-valuenow": r,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-label": "Loading..."
    }, $2gcPZ.createElement("div", {
        "aria-hidden": !0
    }, o));
}), $f8f3429cfd7577a0$export$cc7e12c76513e857 = Object.assign($f8f3429cfd7577a0$export$6def88b96ee4affb, {
    List: $f8f3429cfd7577a0$export$9cffcb65e9381872,
    Item: $f8f3429cfd7577a0$export$b9b346a733d36f61,
    Input: $f8f3429cfd7577a0$export$ebdebb88e46df62a,
    Group: $f8f3429cfd7577a0$export$c157b9873a7a0fbd,
    Separator: $f8f3429cfd7577a0$export$ace649eed6990b42,
    Dialog: $f8f3429cfd7577a0$export$98f0540b5c04f3e8,
    Empty: $f8f3429cfd7577a0$export$f1753c65029fce09,
    Loading: $f8f3429cfd7577a0$export$8980984ffcab084a
});
function $f8f3429cfd7577a0$var$Se(n, a) {
    let r = n.nextElementSibling;
    for(; r;){
        if (r.matches(a)) return r;
        r = r.nextElementSibling;
    }
}
function $f8f3429cfd7577a0$var$Ce(n, a) {
    let r = n.previousElementSibling;
    for(; r;){
        if (r.matches(a)) return r;
        r = r.previousElementSibling;
    }
}
function $f8f3429cfd7577a0$var$ae(n) {
    let a = $2gcPZ.useRef(n);
    return $f8f3429cfd7577a0$var$L(()=>{
        a.current = n;
    }), a;
}
var $f8f3429cfd7577a0$var$L = typeof window > "u" ? $2gcPZ.useEffect : $2gcPZ.useLayoutEffect;
function $f8f3429cfd7577a0$var$x(n) {
    let a = $2gcPZ.useRef();
    return a.current === void 0 && (a.current = n()), a;
}
function $f8f3429cfd7577a0$var$H(n) {
    return (a)=>{
        n.forEach((r)=>{
            typeof r == "function" ? r(a) : r != null && (r.current = a);
        });
    };
}
function $f8f3429cfd7577a0$export$606184d999862dff(n) {
    let a = $f8f3429cfd7577a0$var$U(), r = ()=>n(a.snapshot());
    return $2gcPZ.useSyncExternalStore(a.subscribe, r, r);
}
function $f8f3429cfd7577a0$var$se(n, a, r) {
    let o = $2gcPZ.useRef(), u = $f8f3429cfd7577a0$var$k();
    return $f8f3429cfd7577a0$var$L(()=>{
        var p;
        let l = (()=>{
            var f;
            for (let d of r){
                if (typeof d == "string") return d.trim().toLowerCase();
                if (typeof d == "object" && "current" in d && d.current) return (f = d.current.textContent) == null ? void 0 : f.trim().toLowerCase();
            }
        })();
        u.value(n, l), (p = a.current) == null || p.setAttribute($f8f3429cfd7577a0$var$S, l), o.current = l;
    }), o;
}
var $f8f3429cfd7577a0$var$ye = ()=>{
    let [n, a] = $2gcPZ.useState(), r = $f8f3429cfd7577a0$var$x(()=>new Map);
    return $f8f3429cfd7577a0$var$L(()=>{
        r.current.forEach((o)=>o()), r.current = new Map;
    }, [
        n
    ]), (o, u)=>{
        r.current.set(o, u), a({});
    };
}, $f8f3429cfd7577a0$var$xe = {
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: "0",
    margin: "-1px",
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    borderWidth: "0"
};



var $2gcPZ = parcelRequire("2gcPZ");










var $3d3fa9ba1cb5a516$exports = {};
/*! @license DOMPurify 3.0.6 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.0.6/LICENSE */ (function(global, factory) {
    $3d3fa9ba1cb5a516$exports = factory();
})($3d3fa9ba1cb5a516$exports, function() {
    "use strict";
    const { entries: entries, setPrototypeOf: setPrototypeOf, isFrozen: isFrozen, getPrototypeOf: getPrototypeOf, getOwnPropertyDescriptor: getOwnPropertyDescriptor } = Object;
    let { freeze: freeze, seal: seal, create: create } = Object; // eslint-disable-line import/no-mutable-exports
    let { apply: apply, construct: construct } = typeof Reflect !== "undefined" && Reflect;
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!construct) construct = function construct(Func, args) {
        return new Func(...args);
    };
    const arrayForEach = unapply(Array.prototype.forEach);
    const arrayPop = unapply(Array.prototype.pop);
    const arrayPush = unapply(Array.prototype.push);
    const stringToLowerCase = unapply(String.prototype.toLowerCase);
    const stringToString = unapply(String.prototype.toString);
    const stringMatch = unapply(String.prototype.match);
    const stringReplace = unapply(String.prototype.replace);
    const stringIndexOf = unapply(String.prototype.indexOf);
    const stringTrim = unapply(String.prototype.trim);
    const regExpTest = unapply(RegExp.prototype.test);
    const typeErrorCreate = unconstruct(TypeError);
    /**
   * Creates a new function that calls the given function with a specified thisArg and arguments.
   *
   * @param {Function} func - The function to be wrapped and called.
   * @returns {Function} A new function that calls the given function with a specified thisArg and arguments.
   */ function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    /**
   * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
   *
   * @param {Function} func - The constructor function to be wrapped and called.
   * @returns {Function} A new function that constructs an instance of the given constructor function with the provided arguments.
   */ function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /**
   * Add properties to a lookup table
   *
   * @param {Object} set - The set to which elements will be added.
   * @param {Array} array - The array containing elements to be added to the set.
   * @param {Function} transformCaseFunc - An optional function to transform the case of each element before adding to the set.
   * @returns {Object} The modified set with added elements.
   */ function addToSet(set, array) {
        let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        let l = array.length;
        while(l--){
            let element = array[l];
            if (typeof element === "string") {
                const lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /**
   * Shallow clone an object
   *
   * @param {Object} object - The object to be cloned.
   * @returns {Object} A new object that copies the original.
   */ function clone(object) {
        const newObject = create(null);
        for (const [property, value] of entries(object))if (getOwnPropertyDescriptor(object, property) !== undefined) newObject[property] = value;
        return newObject;
    }
    /**
   * This method automatically checks if the prop is function or getter and behaves accordingly.
   *
   * @param {Object} object - The object to look up the getter function in its prototype chain.
   * @param {String} prop - The property name for which to find the getter function.
   * @returns {Function} The getter function found in the prototype chain or a fallback function.
   */ function lookupGetter(object, prop) {
        while(object !== null){
            const desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === "function") return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue(element) {
            console.warn("fallback value for", element);
            return null;
        }
        return fallbackValue;
    }
    const html$1 = freeze([
        "a",
        "abbr",
        "acronym",
        "address",
        "area",
        "article",
        "aside",
        "audio",
        "b",
        "bdi",
        "bdo",
        "big",
        "blink",
        "blockquote",
        "body",
        "br",
        "button",
        "canvas",
        "caption",
        "center",
        "cite",
        "code",
        "col",
        "colgroup",
        "content",
        "data",
        "datalist",
        "dd",
        "decorator",
        "del",
        "details",
        "dfn",
        "dialog",
        "dir",
        "div",
        "dl",
        "dt",
        "element",
        "em",
        "fieldset",
        "figcaption",
        "figure",
        "font",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hgroup",
        "hr",
        "html",
        "i",
        "img",
        "input",
        "ins",
        "kbd",
        "label",
        "legend",
        "li",
        "main",
        "map",
        "mark",
        "marquee",
        "menu",
        "menuitem",
        "meter",
        "nav",
        "nobr",
        "ol",
        "optgroup",
        "option",
        "output",
        "p",
        "picture",
        "pre",
        "progress",
        "q",
        "rp",
        "rt",
        "ruby",
        "s",
        "samp",
        "section",
        "select",
        "shadow",
        "small",
        "source",
        "spacer",
        "span",
        "strike",
        "strong",
        "style",
        "sub",
        "summary",
        "sup",
        "table",
        "tbody",
        "td",
        "template",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "time",
        "tr",
        "track",
        "tt",
        "u",
        "ul",
        "var",
        "video",
        "wbr"
    ]); // SVG
    const svg$1 = freeze([
        "svg",
        "a",
        "altglyph",
        "altglyphdef",
        "altglyphitem",
        "animatecolor",
        "animatemotion",
        "animatetransform",
        "circle",
        "clippath",
        "defs",
        "desc",
        "ellipse",
        "filter",
        "font",
        "g",
        "glyph",
        "glyphref",
        "hkern",
        "image",
        "line",
        "lineargradient",
        "marker",
        "mask",
        "metadata",
        "mpath",
        "path",
        "pattern",
        "polygon",
        "polyline",
        "radialgradient",
        "rect",
        "stop",
        "style",
        "switch",
        "symbol",
        "text",
        "textpath",
        "title",
        "tref",
        "tspan",
        "view",
        "vkern"
    ]);
    const svgFilters = freeze([
        "feBlend",
        "feColorMatrix",
        "feComponentTransfer",
        "feComposite",
        "feConvolveMatrix",
        "feDiffuseLighting",
        "feDisplacementMap",
        "feDistantLight",
        "feDropShadow",
        "feFlood",
        "feFuncA",
        "feFuncB",
        "feFuncG",
        "feFuncR",
        "feGaussianBlur",
        "feImage",
        "feMerge",
        "feMergeNode",
        "feMorphology",
        "feOffset",
        "fePointLight",
        "feSpecularLighting",
        "feSpotLight",
        "feTile",
        "feTurbulence"
    ]); // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    const svgDisallowed = freeze([
        "animate",
        "color-profile",
        "cursor",
        "discard",
        "font-face",
        "font-face-format",
        "font-face-name",
        "font-face-src",
        "font-face-uri",
        "foreignobject",
        "hatch",
        "hatchpath",
        "mesh",
        "meshgradient",
        "meshpatch",
        "meshrow",
        "missing-glyph",
        "script",
        "set",
        "solidcolor",
        "unknown",
        "use"
    ]);
    const mathMl$1 = freeze([
        "math",
        "menclose",
        "merror",
        "mfenced",
        "mfrac",
        "mglyph",
        "mi",
        "mlabeledtr",
        "mmultiscripts",
        "mn",
        "mo",
        "mover",
        "mpadded",
        "mphantom",
        "mroot",
        "mrow",
        "ms",
        "mspace",
        "msqrt",
        "mstyle",
        "msub",
        "msup",
        "msubsup",
        "mtable",
        "mtd",
        "mtext",
        "mtr",
        "munder",
        "munderover",
        "mprescripts"
    ]); // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    const mathMlDisallowed = freeze([
        "maction",
        "maligngroup",
        "malignmark",
        "mlongdiv",
        "mscarries",
        "mscarry",
        "msgroup",
        "mstack",
        "msline",
        "msrow",
        "semantics",
        "annotation",
        "annotation-xml",
        "mprescripts",
        "none"
    ]);
    const text = freeze([
        "#text"
    ]);
    const html = freeze([
        "accept",
        "action",
        "align",
        "alt",
        "autocapitalize",
        "autocomplete",
        "autopictureinpicture",
        "autoplay",
        "background",
        "bgcolor",
        "border",
        "capture",
        "cellpadding",
        "cellspacing",
        "checked",
        "cite",
        "class",
        "clear",
        "color",
        "cols",
        "colspan",
        "controls",
        "controlslist",
        "coords",
        "crossorigin",
        "datetime",
        "decoding",
        "default",
        "dir",
        "disabled",
        "disablepictureinpicture",
        "disableremoteplayback",
        "download",
        "draggable",
        "enctype",
        "enterkeyhint",
        "face",
        "for",
        "headers",
        "height",
        "hidden",
        "high",
        "href",
        "hreflang",
        "id",
        "inputmode",
        "integrity",
        "ismap",
        "kind",
        "label",
        "lang",
        "list",
        "loading",
        "loop",
        "low",
        "max",
        "maxlength",
        "media",
        "method",
        "min",
        "minlength",
        "multiple",
        "muted",
        "name",
        "nonce",
        "noshade",
        "novalidate",
        "nowrap",
        "open",
        "optimum",
        "pattern",
        "placeholder",
        "playsinline",
        "poster",
        "preload",
        "pubdate",
        "radiogroup",
        "readonly",
        "rel",
        "required",
        "rev",
        "reversed",
        "role",
        "rows",
        "rowspan",
        "spellcheck",
        "scope",
        "selected",
        "shape",
        "size",
        "sizes",
        "span",
        "srclang",
        "start",
        "src",
        "srcset",
        "step",
        "style",
        "summary",
        "tabindex",
        "title",
        "translate",
        "type",
        "usemap",
        "valign",
        "value",
        "width",
        "xmlns",
        "slot"
    ]);
    const svg = freeze([
        "accent-height",
        "accumulate",
        "additive",
        "alignment-baseline",
        "ascent",
        "attributename",
        "attributetype",
        "azimuth",
        "basefrequency",
        "baseline-shift",
        "begin",
        "bias",
        "by",
        "class",
        "clip",
        "clippathunits",
        "clip-path",
        "clip-rule",
        "color",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "cx",
        "cy",
        "d",
        "dx",
        "dy",
        "diffuseconstant",
        "direction",
        "display",
        "divisor",
        "dur",
        "edgemode",
        "elevation",
        "end",
        "fill",
        "fill-opacity",
        "fill-rule",
        "filter",
        "filterunits",
        "flood-color",
        "flood-opacity",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "fx",
        "fy",
        "g1",
        "g2",
        "glyph-name",
        "glyphref",
        "gradientunits",
        "gradienttransform",
        "height",
        "href",
        "id",
        "image-rendering",
        "in",
        "in2",
        "k",
        "k1",
        "k2",
        "k3",
        "k4",
        "kerning",
        "keypoints",
        "keysplines",
        "keytimes",
        "lang",
        "lengthadjust",
        "letter-spacing",
        "kernelmatrix",
        "kernelunitlength",
        "lighting-color",
        "local",
        "marker-end",
        "marker-mid",
        "marker-start",
        "markerheight",
        "markerunits",
        "markerwidth",
        "maskcontentunits",
        "maskunits",
        "max",
        "mask",
        "media",
        "method",
        "mode",
        "min",
        "name",
        "numoctaves",
        "offset",
        "operator",
        "opacity",
        "order",
        "orient",
        "orientation",
        "origin",
        "overflow",
        "paint-order",
        "path",
        "pathlength",
        "patterncontentunits",
        "patterntransform",
        "patternunits",
        "points",
        "preservealpha",
        "preserveaspectratio",
        "primitiveunits",
        "r",
        "rx",
        "ry",
        "radius",
        "refx",
        "refy",
        "repeatcount",
        "repeatdur",
        "restart",
        "result",
        "rotate",
        "scale",
        "seed",
        "shape-rendering",
        "specularconstant",
        "specularexponent",
        "spreadmethod",
        "startoffset",
        "stddeviation",
        "stitchtiles",
        "stop-color",
        "stop-opacity",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke",
        "stroke-width",
        "style",
        "surfacescale",
        "systemlanguage",
        "tabindex",
        "targetx",
        "targety",
        "transform",
        "transform-origin",
        "text-anchor",
        "text-decoration",
        "text-rendering",
        "textlength",
        "type",
        "u1",
        "u2",
        "unicode",
        "values",
        "viewbox",
        "visibility",
        "version",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "width",
        "word-spacing",
        "wrap",
        "writing-mode",
        "xchannelselector",
        "ychannelselector",
        "x",
        "x1",
        "x2",
        "xmlns",
        "y",
        "y1",
        "y2",
        "z",
        "zoomandpan"
    ]);
    const mathMl = freeze([
        "accent",
        "accentunder",
        "align",
        "bevelled",
        "close",
        "columnsalign",
        "columnlines",
        "columnspan",
        "denomalign",
        "depth",
        "dir",
        "display",
        "displaystyle",
        "encoding",
        "fence",
        "frame",
        "height",
        "href",
        "id",
        "largeop",
        "length",
        "linethickness",
        "lspace",
        "lquote",
        "mathbackground",
        "mathcolor",
        "mathsize",
        "mathvariant",
        "maxsize",
        "minsize",
        "movablelimits",
        "notation",
        "numalign",
        "open",
        "rowalign",
        "rowlines",
        "rowspacing",
        "rowspan",
        "rspace",
        "rquote",
        "scriptlevel",
        "scriptminsize",
        "scriptsizemultiplier",
        "selection",
        "separator",
        "separators",
        "stretchy",
        "subscriptshift",
        "supscriptshift",
        "symmetric",
        "voffset",
        "width",
        "xmlns"
    ]);
    const xml = freeze([
        "xlink:href",
        "xml:id",
        "xlink:title",
        "xml:space",
        "xmlns:xlink"
    ]);
    const MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    const ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    const TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
    const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
    const ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    const DOCTYPE_NAME = seal(/^html$/i);
    var EXPRESSIONS = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        MUSTACHE_EXPR: MUSTACHE_EXPR,
        ERB_EXPR: ERB_EXPR,
        TMPLIT_EXPR: TMPLIT_EXPR,
        DATA_ATTR: DATA_ATTR,
        ARIA_ATTR: ARIA_ATTR,
        IS_ALLOWED_URI: IS_ALLOWED_URI,
        IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA,
        ATTR_WHITESPACE: ATTR_WHITESPACE,
        DOCTYPE_NAME: DOCTYPE_NAME
    });
    const getGlobal = function getGlobal() {
        return typeof window === "undefined" ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {HTMLScriptElement} purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported or creating the policy failed).
   */ const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
        if (typeof trustedTypes !== "object" || typeof trustedTypes.createPolicy !== "function") return null;
         // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        let suffix = null;
        const ATTR_NAME = "data-tt-policy-suffix";
        if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
        const policyName = "dompurify" + (suffix ? "#" + suffix : "");
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML (html) {
                    return html;
                },
                createScriptURL (scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn("TrustedTypes policy " + policyName + " could not be created.");
            return null;
        }
    };
    function createDOMPurify() {
        let window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        const DOMPurify = (root)=>createDOMPurify(root);
        /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */ DOMPurify.version = "3.0.6";
        /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */ DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== 9) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        let { document: document } = window1;
        const originalDocument = document;
        const currentScript = originalDocument.currentScript;
        const { DocumentFragment: DocumentFragment, HTMLTemplateElement: HTMLTemplateElement, Node: Node, Element: Element, NodeFilter: NodeFilter, NamedNodeMap: NamedNodeMap = window1.NamedNodeMap || window1.MozNamedAttrMap, HTMLFormElement: HTMLFormElement, DOMParser: DOMParser, trustedTypes: trustedTypes } = window1;
        const ElementPrototype = Element.prototype;
        const cloneNode = lookupGetter(ElementPrototype, "cloneNode");
        const getNextSibling = lookupGetter(ElementPrototype, "nextSibling");
        const getChildNodes = lookupGetter(ElementPrototype, "childNodes");
        const getParentNode = lookupGetter(ElementPrototype, "parentNode"); // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === "function") {
            const template = document.createElement("template");
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        let trustedTypesPolicy;
        let emptyHTML = "";
        const { implementation: implementation, createNodeIterator: createNodeIterator, createDocumentFragment: createDocumentFragment, getElementsByTagName: getElementsByTagName } = document;
        const { importNode: importNode } = originalDocument;
        let hooks = {};
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof entries === "function" && typeof getParentNode === "function" && implementation && implementation.createHTMLDocument !== undefined;
        const { MUSTACHE_EXPR: MUSTACHE_EXPR, ERB_EXPR: ERB_EXPR, TMPLIT_EXPR: TMPLIT_EXPR, DATA_ATTR: DATA_ATTR, ARIA_ATTR: ARIA_ATTR, IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA, ATTR_WHITESPACE: ATTR_WHITESPACE } = EXPRESSIONS;
        let { IS_ALLOWED_URI: IS_ALLOWED_URI$1 } = EXPRESSIONS;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ let ALLOWED_TAGS = null;
        const DEFAULT_ALLOWED_TAGS = addToSet({}, [
            ...html$1,
            ...svg$1,
            ...svgFilters,
            ...mathMl$1,
            ...text
        ]);
        /* Allowed attribute names */ let ALLOWED_ATTR = null;
        const DEFAULT_ALLOWED_ATTR = addToSet({}, [
            ...html,
            ...svg,
            ...mathMl,
            ...xml
        ]);
        /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ let FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ let FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ let ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ let ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ let ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ let ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ let SAFE_FOR_TEMPLATES = false;
        /* Decide if document with <html>... should be returned */ let WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ let SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ let FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ let RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ let RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ let RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ let SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ let SANITIZE_NAMED_PROPS = false;
        const SANITIZE_NAMED_PROPS_PREFIX = "user-content-";
        /* Keep element content when removing element? */ let KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ let IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ let USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ let FORBID_CONTENTS = null;
        const DEFAULT_FORBID_CONTENTS = addToSet({}, [
            "annotation-xml",
            "audio",
            "colgroup",
            "desc",
            "foreignobject",
            "head",
            "iframe",
            "math",
            "mi",
            "mn",
            "mo",
            "ms",
            "mtext",
            "noembed",
            "noframes",
            "noscript",
            "plaintext",
            "script",
            "style",
            "svg",
            "template",
            "thead",
            "title",
            "video",
            "xmp"
        ]);
        /* Tags that are safe for data: URIs */ let DATA_URI_TAGS = null;
        const DEFAULT_DATA_URI_TAGS = addToSet({}, [
            "audio",
            "video",
            "img",
            "source",
            "image",
            "track"
        ]);
        /* Attributes safe for values like "javascript:" */ let URI_SAFE_ATTRIBUTES = null;
        const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            "alt",
            "class",
            "for",
            "id",
            "label",
            "name",
            "pattern",
            "placeholder",
            "role",
            "summary",
            "title",
            "value",
            "style",
            "xmlns"
        ]);
        const MATHML_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
        const SVG_NAMESPACE = "http://www.w3.org/2000/svg";
        const HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
        /* Document namespace */ let NAMESPACE = HTML_NAMESPACE;
        let IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ let ALLOWED_NAMESPACES = null;
        const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        /* Parsing of strict XHTML documents */ let PARSER_MEDIA_TYPE = null;
        const SUPPORTED_PARSER_MEDIA_TYPES = [
            "application/xhtml+xml",
            "text/html"
        ];
        const DEFAULT_PARSER_MEDIA_TYPE = "text/html";
        let transformCaseFunc = null;
        /* Keep a reference to config to pass to hooks */ let CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ const formElement = document.createElement("form");
        const isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */ // eslint-disable-next-line complexity
        const _parseConfig = function _parseConfig() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || typeof cfg !== "object") cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE; // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === "application/xhtml+xml" ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = "ALLOWED_TAGS" in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = "ALLOWED_ATTR" in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = "ALLOWED_NAMESPACES" in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = "ADD_URI_SAFE_ATTR" in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = "ADD_DATA_URI_TAGS" in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = "FORBID_CONTENTS" in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = "FORBID_TAGS" in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = "FORBID_ATTR" in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = "USE_PROFILES" in cfg ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === "boolean") CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, [
                    ...text
                ]);
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS["#text"] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                "html",
                "head",
                "body"
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    "tbody"
                ]);
                delete FORBID_TAGS.tbody;
            }
            if (cfg.TRUSTED_TYPES_POLICY) {
                if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== "function") throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== "function") throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                 // Overwrite existing TrustedTypes policy.
                trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY; // Sign local variables required by `sanitize`.
                emptyHTML = trustedTypesPolicy.createHTML("");
            } else {
                // Uninitialized policy, attempt to initialize the internal dompurify policy.
                if (trustedTypesPolicy === undefined) trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
                 // If creating the internal policy succeeded sign internal variables.
                if (trustedTypesPolicy !== null && typeof emptyHTML === "string") emptyHTML = trustedTypesPolicy.createHTML("");
            } // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        const MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            "mi",
            "mo",
            "mn",
            "ms",
            "mtext"
        ]);
        const HTML_INTEGRATION_POINTS = addToSet({}, [
            "foreignobject",
            "desc",
            "title",
            "annotation-xml"
        ]); // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            "title",
            "style",
            "font",
            "a",
            "script"
        ]);
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ const ALL_SVG_TAGS = addToSet({}, svg$1);
        addToSet(ALL_SVG_TAGS, svgFilters);
        addToSet(ALL_SVG_TAGS, svgDisallowed);
        const ALL_MATHML_TAGS = addToSet({}, mathMl$1);
        addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
        /**
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ const _checkValidNamespace = function _checkValidNamespace(element) {
            let parent = getParentNode(element); // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: "template"
            };
            const tagName = stringToLowerCase(element.tagName);
            const parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === "svg";
                 // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === "svg" && (parentTagName === "annotation-xml" || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                 // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === "math";
                 // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === "math" && HTML_INTEGRATION_POINTS[parentTagName];
                 // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                 // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            } // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
             // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */ const _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                node.parentNode.removeChild(node);
            } catch (_) {
                node.remove();
            }
        };
        /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */ const _removeAttribute = function _removeAttribute(name, node) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: node.getAttributeNode(name),
                    from: node
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: node
                });
            }
            node.removeAttribute(name); // We void attribute values for unremovable "is"" attributes
            if (name === "is" && !ALLOWED_ATTR[name]) {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(node);
                } catch (_) {}
                else try {
                    node.setAttribute(name, "");
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */ const _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ let doc = null;
            let leadingWhitespace = null;
            if (FORCE_BODY) dirty = "<remove></remove>" + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ const matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === "application/xhtml+xml" && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + "</body></html>";
            const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, "template", null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {}
            }
            const body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? "html" : "body")[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
     *
     * @param  {Node} root The root element or node to start traversing on.
     * @return {NodeIterator} The created NodeIterator
     */ const _createNodeIterator = function _createNodeIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT, null);
        };
        /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */ const _isClobbered = function _isClobbered(elm) {
            return elm instanceof HTMLFormElement && (typeof elm.nodeName !== "string" || typeof elm.textContent !== "string" || typeof elm.removeChild !== "function" || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== "function" || typeof elm.setAttribute !== "function" || typeof elm.namespaceURI !== "string" || typeof elm.insertBefore !== "function" || typeof elm.hasChildNodes !== "function");
        };
        /**
     * Checks whether the given object is a DOM node.
     *
     * @param  {Node} object object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */ const _isNode = function _isNode(object) {
            return typeof Node === "function" && object instanceof Node;
        };
        /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */ const _executeHook = function _executeHook(entryPoint, currentNode, data) {
            if (!hooks[entryPoint]) return;
            arrayForEach(hooks[entryPoint], (hook)=>{
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        };
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */ const _sanitizeElements = function _sanitizeElements(currentNode) {
            let content = null;
            /* Execute a hook if present */ _executeHook("beforeSanitizeElements", currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ const tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHook("uponSanitizeElement", currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    const parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    const childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        const childCount = childNodes.length;
                        for(let i = childCount - 1; i >= 0; --i)parentNode.insertBefore(cloneNode(childNodes[i], true), getNextSibling(currentNode));
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === "noscript" || tagName === "noembed" || tagName === "noframes") && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
                /* Get the element's text content */ content = currentNode.textContent;
                arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    content = stringReplace(content, expr, " ");
                });
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHook("afterSanitizeElements", currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === "id" || lcName === "name") && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === "is" && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE, ""))) ;
            else if ((lcName === "src" || lcName === "xlink:href" || lcName === "href") && lcTag !== "script" && stringIndexOf(value, "data:") === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA, stringReplace(value, ATTR_WHITESPACE, ""))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _isBasicCustomElement
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     *
     * @param {string} tagName name of the tag of the node to sanitize
     * @returns {boolean} Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
     */ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
            return tagName.indexOf("-") > 0;
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */ const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            /* Execute a hook if present */ _executeHook("beforeSanitizeAttributes", currentNode, null);
            const { attributes: attributes } = currentNode;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes) return;
            const hookEvent = {
                attrName: "",
                attrValue: "",
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR
            };
            let l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                const attr = attributes[l];
                const { name: name, namespaceURI: namespaceURI, value: attrValue } = attr;
                const lcName = transformCaseFunc(name);
                let value = name === "value" ? attrValue : stringTrim(attrValue);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHook("uponSanitizeAttribute", currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    value = stringReplace(value, expr, " ");
                });
                /* Is `value` valid for this attribute? */ const lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === "id" || lcName === "name")) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode); // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && typeof trustedTypes === "object" && typeof trustedTypes.getAttributeType === "function") {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case "TrustedHTML":
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case "TrustedScriptURL":
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHook("afterSanitizeAttributes", currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */ const _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            let shadowNode = null;
            const shadowIterator = _createNodeIterator(fragment);
            /* Execute a hook if present */ _executeHook("beforeSanitizeShadowDOM", fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHook("uponSanitizeShadowNode", shadowNode, null);
                /* Sanitize tags and elements */ if (_sanitizeElements(shadowNode)) continue;
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(shadowNode);
            }
            /* Execute a hook if present */ _executeHook("afterSanitizeShadowDOM", fragment, null);
        };
        /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} cfg object
     */ // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            let body = null;
            let importedNode = null;
            let currentNode = null;
            let returnNode = null;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = "<!-->";
            /* Stringify, in case dirty is an object */ if (typeof dirty !== "string" && !_isNode(dirty)) {
                if (typeof dirty.toString === "function") {
                    dirty = dirty.toString();
                    if (typeof dirty !== "string") throw typeErrorCreate("dirty is not a string, aborting");
                } else throw typeErrorCreate("toString is not a function");
            }
            /* Return dirty HTML if DOMPurify cannot run */ if (!DOMPurify.isSupported) return dirty;
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === "string") IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    const tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate("root node is forbidden and cannot be sanitized in-place");
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument("<!---->");
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === 1 && importedNode.nodeName === "BODY") /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === "HTML") body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf("<") === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : "";
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Sanitize tags and elements */ if (_sanitizeElements(currentNode)) continue;
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(currentNode);
            }
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS["!doctype"] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = "<!DOCTYPE " + body.ownerDocument.doctype.name + ">\n" + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) arrayForEach([
                MUSTACHE_EXPR,
                ERB_EXPR,
                TMPLIT_EXPR
            ], (expr)=>{
                serializedHTML = stringReplace(serializedHTML, expr, " ");
            });
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */ DOMPurify.setConfig = function() {
            let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        /**
     * Public method to remove the configuration
     * clearConfig
     *
     */ DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {String} tag Tag name of containing element.
     * @param  {String} attr Attribute name.
     * @param  {String} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */ DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            const lcTag = transformCaseFunc(tag);
            const lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */ DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== "function") return;
            hooks[entryPoint] = hooks[entryPoint] || [];
            arrayPush(hooks[entryPoint], hookFunction);
        };
        /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */ DOMPurify.removeHook = function(entryPoint) {
            if (hooks[entryPoint]) return arrayPop(hooks[entryPoint]);
        };
        /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */ DOMPurify.removeHooks = function(entryPoint) {
            if (hooks[entryPoint]) hooks[entryPoint] = [];
        };
        /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     */ DOMPurify.removeAllHooks = function() {
            hooks = {};
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});



var $2gcPZ = parcelRequire("2gcPZ");


var $a00fa2db16d86f9f$exports = {};
/**
 * marked v9.1.2 - a markdown parser
 * Copyright (c) 2011-2023, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */ /**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */ (function(global, factory) {
    factory($a00fa2db16d86f9f$exports);
})($a00fa2db16d86f9f$exports, function(exports1) {
    "use strict";
    /**
     * Gets the original marked default options.
     */ function _getDefaults() {
        return {
            async: false,
            breaks: false,
            extensions: null,
            gfm: true,
            hooks: null,
            pedantic: false,
            renderer: null,
            silent: false,
            tokenizer: null,
            walkTokens: null
        };
    }
    exports1.defaults = _getDefaults();
    function changeDefaults(newDefaults) {
        exports1.defaults = newDefaults;
    }
    /**
     * Helpers
     */ const escapeTest = /[&<>"']/;
    const escapeReplace = new RegExp(escapeTest.source, "g");
    const escapeTestNoEncode = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/;
    const escapeReplaceNoEncode = new RegExp(escapeTestNoEncode.source, "g");
    const escapeReplacements = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    const getEscapeReplacement = (ch)=>escapeReplacements[ch];
    function escape(html, encode) {
        if (encode) {
            if (escapeTest.test(html)) return html.replace(escapeReplace, getEscapeReplacement);
        } else {
            if (escapeTestNoEncode.test(html)) return html.replace(escapeReplaceNoEncode, getEscapeReplacement);
        }
        return html;
    }
    const unescapeTest = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;
    function unescape(html) {
        // explicitly match decimal, hex, and named HTML entities
        return html.replace(unescapeTest, (_, n)=>{
            n = n.toLowerCase();
            if (n === "colon") return ":";
            if (n.charAt(0) === "#") return n.charAt(1) === "x" ? String.fromCharCode(parseInt(n.substring(2), 16)) : String.fromCharCode(+n.substring(1));
            return "";
        });
    }
    const caret = /(^|[^\[])\^/g;
    function edit(regex, opt) {
        regex = typeof regex === "string" ? regex : regex.source;
        opt = opt || "";
        const obj = {
            replace: (name, val)=>{
                val = typeof val === "object" && "source" in val ? val.source : val;
                val = val.replace(caret, "$1");
                regex = regex.replace(name, val);
                return obj;
            },
            getRegex: ()=>{
                return new RegExp(regex, opt);
            }
        };
        return obj;
    }
    function cleanUrl(href) {
        try {
            href = encodeURI(href).replace(/%25/g, "%");
        } catch (e) {
            return null;
        }
        return href;
    }
    const noopTest = {
        exec: ()=>null
    };
    function splitCells(tableRow, count) {
        // ensure that every cell-delimiting pipe has a space
        // before it to distinguish it from an escaped pipe
        const row = tableRow.replace(/\|/g, (match, offset, str)=>{
            let escaped = false;
            let curr = offset;
            while(--curr >= 0 && str[curr] === "\\")escaped = !escaped;
            if (escaped) // odd number of slashes means | is escaped
            // so we leave it alone
            return "|";
            else // add space before unescaped |
            return " |";
        }), cells = row.split(/ \|/);
        let i = 0;
        // First/last cell in a row cannot be empty if it has no leading/trailing pipe
        if (!cells[0].trim()) cells.shift();
        if (cells.length > 0 && !cells[cells.length - 1].trim()) cells.pop();
        if (count) {
            if (cells.length > count) cells.splice(count);
            else while(cells.length < count)cells.push("");
        }
        for(; i < cells.length; i++)// leading or trailing whitespace is ignored per the gfm spec
        cells[i] = cells[i].trim().replace(/\\\|/g, "|");
        return cells;
    }
    /**
     * Remove trailing 'c's. Equivalent to str.replace(/c*$/, '').
     * /c*$/ is vulnerable to REDOS.
     *
     * @param str
     * @param c
     * @param invert Remove suffix of non-c chars instead. Default falsey.
     */ function rtrim(str, c, invert) {
        const l = str.length;
        if (l === 0) return "";
        // Length of suffix matching the invert condition.
        let suffLen = 0;
        // Step left until we fail to match the invert condition.
        while(suffLen < l){
            const currChar = str.charAt(l - suffLen - 1);
            if (currChar === c && !invert) suffLen++;
            else if (currChar !== c && invert) suffLen++;
            else break;
        }
        return str.slice(0, l - suffLen);
    }
    function findClosingBracket(str, b) {
        if (str.indexOf(b[1]) === -1) return -1;
        let level = 0;
        for(let i = 0; i < str.length; i++){
            if (str[i] === "\\") i++;
            else if (str[i] === b[0]) level++;
            else if (str[i] === b[1]) {
                level--;
                if (level < 0) return i;
            }
        }
        return -1;
    }
    function outputLink(cap, link, raw, lexer) {
        const href = link.href;
        const title = link.title ? escape(link.title) : null;
        const text = cap[1].replace(/\\([\[\]])/g, "$1");
        if (cap[0].charAt(0) !== "!") {
            lexer.state.inLink = true;
            const token = {
                type: "link",
                raw: raw,
                href: href,
                title: title,
                text: text,
                tokens: lexer.inlineTokens(text)
            };
            lexer.state.inLink = false;
            return token;
        }
        return {
            type: "image",
            raw: raw,
            href: href,
            title: title,
            text: escape(text)
        };
    }
    function indentCodeCompensation(raw, text) {
        const matchIndentToCode = raw.match(/^(\s+)(?:```)/);
        if (matchIndentToCode === null) return text;
        const indentToCode = matchIndentToCode[1];
        return text.split("\n").map((node)=>{
            const matchIndentInNode = node.match(/^\s+/);
            if (matchIndentInNode === null) return node;
            const [indentInNode] = matchIndentInNode;
            if (indentInNode.length >= indentToCode.length) return node.slice(indentToCode.length);
            return node;
        }).join("\n");
    }
    /**
     * Tokenizer
     */ class _Tokenizer {
        options;
        // TODO: Fix this rules type
        rules;
        lexer;
        constructor(options){
            this.options = options || exports1.defaults;
        }
        space(src) {
            const cap = this.rules.block.newline.exec(src);
            if (cap && cap[0].length > 0) return {
                type: "space",
                raw: cap[0]
            };
        }
        code(src) {
            const cap = this.rules.block.code.exec(src);
            if (cap) {
                const text = cap[0].replace(/^ {1,4}/gm, "");
                return {
                    type: "code",
                    raw: cap[0],
                    codeBlockStyle: "indented",
                    text: !this.options.pedantic ? rtrim(text, "\n") : text
                };
            }
        }
        fences(src) {
            const cap = this.rules.block.fences.exec(src);
            if (cap) {
                const raw = cap[0];
                const text = indentCodeCompensation(raw, cap[3] || "");
                return {
                    type: "code",
                    raw: raw,
                    lang: cap[2] ? cap[2].trim().replace(this.rules.inline._escapes, "$1") : cap[2],
                    text: text
                };
            }
        }
        heading(src) {
            const cap = this.rules.block.heading.exec(src);
            if (cap) {
                let text = cap[2].trim();
                // remove trailing #s
                if (/#$/.test(text)) {
                    const trimmed = rtrim(text, "#");
                    if (this.options.pedantic) text = trimmed.trim();
                    else if (!trimmed || / $/.test(trimmed)) // CommonMark requires space before trailing #s
                    text = trimmed.trim();
                }
                return {
                    type: "heading",
                    raw: cap[0],
                    depth: cap[1].length,
                    text: text,
                    tokens: this.lexer.inline(text)
                };
            }
        }
        hr(src) {
            const cap = this.rules.block.hr.exec(src);
            if (cap) return {
                type: "hr",
                raw: cap[0]
            };
        }
        blockquote(src) {
            const cap = this.rules.block.blockquote.exec(src);
            if (cap) {
                const text = rtrim(cap[0].replace(/^ *>[ \t]?/gm, ""), "\n");
                const top = this.lexer.state.top;
                this.lexer.state.top = true;
                const tokens = this.lexer.blockTokens(text);
                this.lexer.state.top = top;
                return {
                    type: "blockquote",
                    raw: cap[0],
                    tokens: tokens,
                    text: text
                };
            }
        }
        list(src) {
            let cap = this.rules.block.list.exec(src);
            if (cap) {
                let bull = cap[1].trim();
                const isordered = bull.length > 1;
                const list = {
                    type: "list",
                    raw: "",
                    ordered: isordered,
                    start: isordered ? +bull.slice(0, -1) : "",
                    loose: false,
                    items: []
                };
                bull = isordered ? `\\d{1,9}\\${bull.slice(-1)}` : `\\${bull}`;
                if (this.options.pedantic) bull = isordered ? bull : "[*+-]";
                // Get next list item
                const itemRegex = new RegExp(`^( {0,3}${bull})((?:[\t ][^\\n]*)?(?:\\n|$))`);
                let raw = "";
                let itemContents = "";
                let endsWithBlankLine = false;
                // Check if current bullet point can start a new List Item
                while(src){
                    let endEarly = false;
                    if (!(cap = itemRegex.exec(src))) break;
                    if (this.rules.block.hr.test(src)) break;
                    raw = cap[0];
                    src = src.substring(raw.length);
                    let line = cap[2].split("\n", 1)[0].replace(/^\t+/, (t)=>" ".repeat(3 * t.length));
                    let nextLine = src.split("\n", 1)[0];
                    let indent = 0;
                    if (this.options.pedantic) {
                        indent = 2;
                        itemContents = line.trimStart();
                    } else {
                        indent = cap[2].search(/[^ ]/); // Find first non-space char
                        indent = indent > 4 ? 1 : indent; // Treat indented code blocks (> 4 spaces) as having only 1 indent
                        itemContents = line.slice(indent);
                        indent += cap[1].length;
                    }
                    let blankLine = false;
                    if (!line && /^ *$/.test(nextLine)) {
                        raw += nextLine + "\n";
                        src = src.substring(nextLine.length + 1);
                        endEarly = true;
                    }
                    if (!endEarly) {
                        const nextBulletRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ \t][^\\n]*)?(?:\\n|$))`);
                        const hrRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`);
                        const fencesBeginRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:\`\`\`|~~~)`);
                        const headingBeginRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}#`);
                        // Check if following lines should be included in List Item
                        while(src){
                            const rawLine = src.split("\n", 1)[0];
                            nextLine = rawLine;
                            // Re-align to follow commonmark nesting rules
                            if (this.options.pedantic) nextLine = nextLine.replace(/^ {1,4}(?=( {4})*[^ ])/g, "  ");
                            // End list item if found code fences
                            if (fencesBeginRegex.test(nextLine)) break;
                            // End list item if found start of new heading
                            if (headingBeginRegex.test(nextLine)) break;
                            // End list item if found start of new bullet
                            if (nextBulletRegex.test(nextLine)) break;
                            // Horizontal rule found
                            if (hrRegex.test(src)) break;
                            if (nextLine.search(/[^ ]/) >= indent || !nextLine.trim()) itemContents += "\n" + nextLine.slice(indent);
                            else {
                                // not enough indentation
                                if (blankLine) break;
                                // paragraph continuation unless last line was a different block level element
                                if (line.search(/[^ ]/) >= 4) break;
                                if (fencesBeginRegex.test(line)) break;
                                if (headingBeginRegex.test(line)) break;
                                if (hrRegex.test(line)) break;
                                itemContents += "\n" + nextLine;
                            }
                            if (!blankLine && !nextLine.trim()) blankLine = true;
                            raw += rawLine + "\n";
                            src = src.substring(rawLine.length + 1);
                            line = nextLine.slice(indent);
                        }
                    }
                    if (!list.loose) {
                        // If the previous item ended with a blank line, the list is loose
                        if (endsWithBlankLine) list.loose = true;
                        else if (/\n *\n *$/.test(raw)) endsWithBlankLine = true;
                    }
                    let istask = null;
                    let ischecked;
                    // Check for task list items
                    if (this.options.gfm) {
                        istask = /^\[[ xX]\] /.exec(itemContents);
                        if (istask) {
                            ischecked = istask[0] !== "[ ] ";
                            itemContents = itemContents.replace(/^\[[ xX]\] +/, "");
                        }
                    }
                    list.items.push({
                        type: "list_item",
                        raw: raw,
                        task: !!istask,
                        checked: ischecked,
                        loose: false,
                        text: itemContents,
                        tokens: []
                    });
                    list.raw += raw;
                }
                // Do not consume newlines at end of final item. Alternatively, make itemRegex *start* with any newlines to simplify/speed up endsWithBlankLine logic
                list.items[list.items.length - 1].raw = raw.trimEnd();
                list.items[list.items.length - 1].text = itemContents.trimEnd();
                list.raw = list.raw.trimEnd();
                // Item child tokens handled here at end because we needed to have the final item to trim it first
                for(let i = 0; i < list.items.length; i++){
                    this.lexer.state.top = false;
                    list.items[i].tokens = this.lexer.blockTokens(list.items[i].text, []);
                    if (!list.loose) {
                        // Check if list should be loose
                        const spacers = list.items[i].tokens.filter((t)=>t.type === "space");
                        const hasMultipleLineBreaks = spacers.length > 0 && spacers.some((t)=>/\n.*\n/.test(t.raw));
                        list.loose = hasMultipleLineBreaks;
                    }
                }
                // Set all items to loose if list is loose
                if (list.loose) for(let i = 0; i < list.items.length; i++)list.items[i].loose = true;
                return list;
            }
        }
        html(src) {
            const cap = this.rules.block.html.exec(src);
            if (cap) {
                const token = {
                    type: "html",
                    block: true,
                    raw: cap[0],
                    pre: cap[1] === "pre" || cap[1] === "script" || cap[1] === "style",
                    text: cap[0]
                };
                return token;
            }
        }
        def(src) {
            const cap = this.rules.block.def.exec(src);
            if (cap) {
                const tag = cap[1].toLowerCase().replace(/\s+/g, " ");
                const href = cap[2] ? cap[2].replace(/^<(.*)>$/, "$1").replace(this.rules.inline._escapes, "$1") : "";
                const title = cap[3] ? cap[3].substring(1, cap[3].length - 1).replace(this.rules.inline._escapes, "$1") : cap[3];
                return {
                    type: "def",
                    tag: tag,
                    raw: cap[0],
                    href: href,
                    title: title
                };
            }
        }
        table(src) {
            const cap = this.rules.block.table.exec(src);
            if (cap) {
                if (!/[:|]/.test(cap[2])) // delimiter row must have a pipe (|) or colon (:) otherwise it is a setext heading
                return;
                const item = {
                    type: "table",
                    raw: cap[0],
                    header: splitCells(cap[1]).map((c)=>{
                        return {
                            text: c,
                            tokens: []
                        };
                    }),
                    align: cap[2].replace(/^\||\| *$/g, "").split("|"),
                    rows: cap[3] && cap[3].trim() ? cap[3].replace(/\n[ \t]*$/, "").split("\n") : []
                };
                if (item.header.length === item.align.length) {
                    let l = item.align.length;
                    let i, j, k, row;
                    for(i = 0; i < l; i++){
                        const align = item.align[i];
                        if (align) {
                            if (/^ *-+: *$/.test(align)) item.align[i] = "right";
                            else if (/^ *:-+: *$/.test(align)) item.align[i] = "center";
                            else if (/^ *:-+ *$/.test(align)) item.align[i] = "left";
                            else item.align[i] = null;
                        }
                    }
                    l = item.rows.length;
                    for(i = 0; i < l; i++)item.rows[i] = splitCells(item.rows[i], item.header.length).map((c)=>{
                        return {
                            text: c,
                            tokens: []
                        };
                    });
                    // parse child tokens inside headers and cells
                    // header child tokens
                    l = item.header.length;
                    for(j = 0; j < l; j++)item.header[j].tokens = this.lexer.inline(item.header[j].text);
                    // cell child tokens
                    l = item.rows.length;
                    for(j = 0; j < l; j++){
                        row = item.rows[j];
                        for(k = 0; k < row.length; k++)row[k].tokens = this.lexer.inline(row[k].text);
                    }
                    return item;
                }
            }
        }
        lheading(src) {
            const cap = this.rules.block.lheading.exec(src);
            if (cap) return {
                type: "heading",
                raw: cap[0],
                depth: cap[2].charAt(0) === "=" ? 1 : 2,
                text: cap[1],
                tokens: this.lexer.inline(cap[1])
            };
        }
        paragraph(src) {
            const cap = this.rules.block.paragraph.exec(src);
            if (cap) {
                const text = cap[1].charAt(cap[1].length - 1) === "\n" ? cap[1].slice(0, -1) : cap[1];
                return {
                    type: "paragraph",
                    raw: cap[0],
                    text: text,
                    tokens: this.lexer.inline(text)
                };
            }
        }
        text(src) {
            const cap = this.rules.block.text.exec(src);
            if (cap) return {
                type: "text",
                raw: cap[0],
                text: cap[0],
                tokens: this.lexer.inline(cap[0])
            };
        }
        escape(src) {
            const cap = this.rules.inline.escape.exec(src);
            if (cap) return {
                type: "escape",
                raw: cap[0],
                text: escape(cap[1])
            };
        }
        tag(src) {
            const cap = this.rules.inline.tag.exec(src);
            if (cap) {
                if (!this.lexer.state.inLink && /^<a /i.test(cap[0])) this.lexer.state.inLink = true;
                else if (this.lexer.state.inLink && /^<\/a>/i.test(cap[0])) this.lexer.state.inLink = false;
                if (!this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(cap[0])) this.lexer.state.inRawBlock = true;
                else if (this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(cap[0])) this.lexer.state.inRawBlock = false;
                return {
                    type: "html",
                    raw: cap[0],
                    inLink: this.lexer.state.inLink,
                    inRawBlock: this.lexer.state.inRawBlock,
                    block: false,
                    text: cap[0]
                };
            }
        }
        link(src) {
            const cap = this.rules.inline.link.exec(src);
            if (cap) {
                const trimmedUrl = cap[2].trim();
                if (!this.options.pedantic && /^</.test(trimmedUrl)) {
                    // commonmark requires matching angle brackets
                    if (!/>$/.test(trimmedUrl)) return;
                    // ending angle bracket cannot be escaped
                    const rtrimSlash = rtrim(trimmedUrl.slice(0, -1), "\\");
                    if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) return;
                } else {
                    // find closing parenthesis
                    const lastParenIndex = findClosingBracket(cap[2], "()");
                    if (lastParenIndex > -1) {
                        const start = cap[0].indexOf("!") === 0 ? 5 : 4;
                        const linkLen = start + cap[1].length + lastParenIndex;
                        cap[2] = cap[2].substring(0, lastParenIndex);
                        cap[0] = cap[0].substring(0, linkLen).trim();
                        cap[3] = "";
                    }
                }
                let href = cap[2];
                let title = "";
                if (this.options.pedantic) {
                    // split pedantic href and title
                    const link = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(href);
                    if (link) {
                        href = link[1];
                        title = link[3];
                    }
                } else title = cap[3] ? cap[3].slice(1, -1) : "";
                href = href.trim();
                if (/^</.test(href)) {
                    if (this.options.pedantic && !/>$/.test(trimmedUrl)) // pedantic allows starting angle bracket without ending angle bracket
                    href = href.slice(1);
                    else href = href.slice(1, -1);
                }
                return outputLink(cap, {
                    href: href ? href.replace(this.rules.inline._escapes, "$1") : href,
                    title: title ? title.replace(this.rules.inline._escapes, "$1") : title
                }, cap[0], this.lexer);
            }
        }
        reflink(src, links) {
            let cap;
            if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
                let link = (cap[2] || cap[1]).replace(/\s+/g, " ");
                link = links[link.toLowerCase()];
                if (!link) {
                    const text = cap[0].charAt(0);
                    return {
                        type: "text",
                        raw: text,
                        text: text
                    };
                }
                return outputLink(cap, link, cap[0], this.lexer);
            }
        }
        emStrong(src, maskedSrc, prevChar = "") {
            let match = this.rules.inline.emStrong.lDelim.exec(src);
            if (!match) return;
            // _ can't be between two alphanumerics. \p{L}\p{N} includes non-english alphabet/numbers as well
            if (match[3] && prevChar.match(/[\p{L}\p{N}]/u)) return;
            const nextChar = match[1] || match[2] || "";
            if (!nextChar || !prevChar || this.rules.inline.punctuation.exec(prevChar)) {
                // unicode Regex counts emoji as 1 char; spread into array for proper count (used multiple times below)
                const lLength = [
                    ...match[0]
                ].length - 1;
                let rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;
                const endReg = match[0][0] === "*" ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
                endReg.lastIndex = 0;
                // Clip maskedSrc to same section of string as src (move to lexer?)
                maskedSrc = maskedSrc.slice(-1 * src.length + match[0].length - 1);
                while((match = endReg.exec(maskedSrc)) != null){
                    rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
                    if (!rDelim) continue; // skip single * in __abc*abc__
                    rLength = [
                        ...rDelim
                    ].length;
                    if (match[3] || match[4]) {
                        delimTotal += rLength;
                        continue;
                    } else if (match[5] || match[6]) {
                        if (lLength % 3 && !((lLength + rLength) % 3)) {
                            midDelimTotal += rLength;
                            continue; // CommonMark Emphasis Rules 9-10
                        }
                    }
                    delimTotal -= rLength;
                    if (delimTotal > 0) continue; // Haven't found enough closing delimiters
                    // Remove extra characters. *a*** -> *a*
                    rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
                    const raw = [
                        ...src
                    ].slice(0, lLength + match.index + rLength + 1).join("");
                    // Create `em` if smallest delimiter has odd char count. *a***
                    if (Math.min(lLength, rLength) % 2) {
                        const text = raw.slice(1, -1);
                        return {
                            type: "em",
                            raw: raw,
                            text: text,
                            tokens: this.lexer.inlineTokens(text)
                        };
                    }
                    // Create 'strong' if smallest delimiter has even char count. **a***
                    const text = raw.slice(2, -2);
                    return {
                        type: "strong",
                        raw: raw,
                        text: text,
                        tokens: this.lexer.inlineTokens(text)
                    };
                }
            }
        }
        codespan(src) {
            const cap = this.rules.inline.code.exec(src);
            if (cap) {
                let text = cap[2].replace(/\n/g, " ");
                const hasNonSpaceChars = /[^ ]/.test(text);
                const hasSpaceCharsOnBothEnds = /^ /.test(text) && / $/.test(text);
                if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) text = text.substring(1, text.length - 1);
                text = escape(text, true);
                return {
                    type: "codespan",
                    raw: cap[0],
                    text: text
                };
            }
        }
        br(src) {
            const cap = this.rules.inline.br.exec(src);
            if (cap) return {
                type: "br",
                raw: cap[0]
            };
        }
        del(src) {
            const cap = this.rules.inline.del.exec(src);
            if (cap) return {
                type: "del",
                raw: cap[0],
                text: cap[2],
                tokens: this.lexer.inlineTokens(cap[2])
            };
        }
        autolink(src) {
            const cap = this.rules.inline.autolink.exec(src);
            if (cap) {
                let text, href;
                if (cap[2] === "@") {
                    text = escape(cap[1]);
                    href = "mailto:" + text;
                } else {
                    text = escape(cap[1]);
                    href = text;
                }
                return {
                    type: "link",
                    raw: cap[0],
                    text: text,
                    href: href,
                    tokens: [
                        {
                            type: "text",
                            raw: text,
                            text: text
                        }
                    ]
                };
            }
        }
        url(src) {
            let cap;
            if (cap = this.rules.inline.url.exec(src)) {
                let text, href;
                if (cap[2] === "@") {
                    text = escape(cap[0]);
                    href = "mailto:" + text;
                } else {
                    // do extended autolink path validation
                    let prevCapZero;
                    do {
                        prevCapZero = cap[0];
                        cap[0] = this.rules.inline._backpedal.exec(cap[0])[0];
                    }while (prevCapZero !== cap[0]);
                    text = escape(cap[0]);
                    if (cap[1] === "www.") href = "http://" + cap[0];
                    else href = cap[0];
                }
                return {
                    type: "link",
                    raw: cap[0],
                    text: text,
                    href: href,
                    tokens: [
                        {
                            type: "text",
                            raw: text,
                            text: text
                        }
                    ]
                };
            }
        }
        inlineText(src) {
            const cap = this.rules.inline.text.exec(src);
            if (cap) {
                let text;
                if (this.lexer.state.inRawBlock) text = cap[0];
                else text = escape(cap[0]);
                return {
                    type: "text",
                    raw: cap[0],
                    text: text
                };
            }
        }
    }
    /**
     * Block-Level Grammar
     */ // Not all rules are defined in the object literal
    // @ts-expect-error
    const block = {
        newline: /^(?: *(?:\n|$))+/,
        code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
        fences: /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/,
        hr: /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/,
        heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
        blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
        list: /^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/,
        html: "^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))",
        def: /^ {0,3}\[(label)\]: *(?:\n *)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/,
        table: noopTest,
        lheading: /^(?!bull )((?:.|\n(?!\s*?\n|bull ))+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
        // regex template, placeholders will be replaced according to different paragraph
        // interruption rules of commonmark and the original markdown spec:
        _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/,
        text: /^[^\n]+/
    };
    block._label = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
    block._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
    block.def = edit(block.def).replace("label", block._label).replace("title", block._title).getRegex();
    block.bullet = /(?:[*+-]|\d{1,9}[.)])/;
    block.listItemStart = edit(/^( *)(bull) */).replace("bull", block.bullet).getRegex();
    block.list = edit(block.list).replace(/bull/g, block.bullet).replace("hr", "\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))").replace("def", "\\n+(?=" + block.def.source + ")").getRegex();
    block._tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
    block._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/;
    block.html = edit(block.html, "i").replace("comment", block._comment).replace("tag", block._tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
    block.lheading = edit(block.lheading).replace(/bull/g, block.bullet) // lists can interrupt
    .getRegex();
    block.paragraph = edit(block._paragraph).replace("hr", block.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "") // setex headings don't interrupt commonmark paragraphs
    .replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ") // only lists starting from 1 can interrupt
    .replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", block._tag) // pars can be interrupted by type (6) html blocks
    .getRegex();
    block.blockquote = edit(block.blockquote).replace("paragraph", block.paragraph).getRegex();
    /**
     * Normal Block Grammar
     */ block.normal = {
        ...block
    };
    /**
     * GFM Block Grammar
     */ block.gfm = {
        ...block.normal,
        table: "^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)" // Cells
    };
    block.gfm.table = edit(block.gfm.table).replace("hr", block.hr).replace("heading", " {0,3}#{1,6} ").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ") // only lists starting from 1 can interrupt
    .replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", block._tag) // tables can be interrupted by type (6) html blocks
    .getRegex();
    block.gfm.paragraph = edit(block._paragraph).replace("hr", block.hr).replace("heading", " {0,3}#{1,6} ").replace("|lheading", "") // setex headings don't interrupt commonmark paragraphs
    .replace("table", block.gfm.table) // interrupt paragraphs with table
    .replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ") // only lists starting from 1 can interrupt
    .replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", block._tag) // pars can be interrupted by type (6) html blocks
    .getRegex();
    /**
     * Pedantic grammar (original John Gruber's loose markdown specification)
     */ block.pedantic = {
        ...block.normal,
        html: edit("^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:\"[^\"]*\"|'[^']*'|\\s[^'\"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))").replace("comment", block._comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
        def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
        heading: /^(#{1,6})(.*)(?:\n+|$)/,
        fences: noopTest,
        lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
        paragraph: edit(block.normal._paragraph).replace("hr", block.hr).replace("heading", " *#{1,6} *[^\n]").replace("lheading", block.lheading).replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").getRegex()
    };
    /**
     * Inline-Level Grammar
     */ // Not all rules are defined in the object literal
    // @ts-expect-error
    const inline = {
        escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
        autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
        url: noopTest,
        tag: "^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>",
        link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
        reflink: /^!?\[(label)\]\[(ref)\]/,
        nolink: /^!?\[(ref)\](?:\[\])?/,
        reflinkSearch: "reflink|nolink(?!\\()",
        emStrong: {
            lDelim: /^(?:\*+(?:((?!\*)[punct])|[^\s*]))|^_+(?:((?!_)[punct])|([^\s_]))/,
            //         (1) and (2) can only be a Right Delimiter. (3) and (4) can only be Left.  (5) and (6) can be either Left or Right.
            //         | Skip orphan inside strong      | Consume to delim | (1) #***              | (2) a***#, a***                    | (3) #***a, ***a                  | (4) ***#                 | (5) #***#                         | (6) a***a
            rDelimAst: /^[^_*]*?__[^_*]*?\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\*)[punct](\*+)(?=[\s]|$)|[^punct\s](\*+)(?!\*)(?=[punct\s]|$)|(?!\*)[punct\s](\*+)(?=[^punct\s])|[\s](\*+)(?!\*)(?=[punct])|(?!\*)[punct](\*+)(?!\*)(?=[punct])|[^punct\s](\*+)(?=[^punct\s])/,
            rDelimUnd: /^[^_*]*?\*\*[^_*]*?_[^_*]*?(?=\*\*)|[^_]+(?=[^_])|(?!_)[punct](_+)(?=[\s]|$)|[^punct\s](_+)(?!_)(?=[punct\s]|$)|(?!_)[punct\s](_+)(?=[^punct\s])|[\s](_+)(?!_)(?=[punct])|(?!_)[punct](_+)(?!_)(?=[punct])/ // ^- Not allowed for _
        },
        code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
        br: /^( {2,}|\\)\n(?!\s*$)/,
        del: noopTest,
        text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
        punctuation: /^((?![*_])[\spunctuation])/
    };
    // list of unicode punctuation marks, plus any missing characters from CommonMark spec
    inline._punctuation = "\\p{P}$+<=>`^|~";
    inline.punctuation = edit(inline.punctuation, "u").replace(/punctuation/g, inline._punctuation).getRegex();
    // sequences em should skip over [title](link), `code`, <html>
    inline.blockSkip = /\[[^[\]]*?\]\([^\(\)]*?\)|`[^`]*?`|<[^<>]*?>/g;
    inline.anyPunctuation = /\\[punct]/g;
    inline._escapes = /\\([punct])/g;
    inline._comment = edit(block._comment).replace("(?:-->|$)", "-->").getRegex();
    inline.emStrong.lDelim = edit(inline.emStrong.lDelim, "u").replace(/punct/g, inline._punctuation).getRegex();
    inline.emStrong.rDelimAst = edit(inline.emStrong.rDelimAst, "gu").replace(/punct/g, inline._punctuation).getRegex();
    inline.emStrong.rDelimUnd = edit(inline.emStrong.rDelimUnd, "gu").replace(/punct/g, inline._punctuation).getRegex();
    inline.anyPunctuation = edit(inline.anyPunctuation, "gu").replace(/punct/g, inline._punctuation).getRegex();
    inline._escapes = edit(inline._escapes, "gu").replace(/punct/g, inline._punctuation).getRegex();
    inline._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
    inline._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
    inline.autolink = edit(inline.autolink).replace("scheme", inline._scheme).replace("email", inline._email).getRegex();
    inline._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;
    inline.tag = edit(inline.tag).replace("comment", inline._comment).replace("attribute", inline._attribute).getRegex();
    inline._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
    inline._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/;
    inline._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;
    inline.link = edit(inline.link).replace("label", inline._label).replace("href", inline._href).replace("title", inline._title).getRegex();
    inline.reflink = edit(inline.reflink).replace("label", inline._label).replace("ref", block._label).getRegex();
    inline.nolink = edit(inline.nolink).replace("ref", block._label).getRegex();
    inline.reflinkSearch = edit(inline.reflinkSearch, "g").replace("reflink", inline.reflink).replace("nolink", inline.nolink).getRegex();
    /**
     * Normal Inline Grammar
     */ inline.normal = {
        ...inline
    };
    /**
     * Pedantic Inline Grammar
     */ inline.pedantic = {
        ...inline.normal,
        strong: {
            start: /^__|\*\*/,
            middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
            endAst: /\*\*(?!\*)/g,
            endUnd: /__(?!_)/g
        },
        em: {
            start: /^_|\*/,
            middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
            endAst: /\*(?!\*)/g,
            endUnd: /_(?!_)/g
        },
        link: edit(/^!?\[(label)\]\((.*?)\)/).replace("label", inline._label).getRegex(),
        reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", inline._label).getRegex()
    };
    /**
     * GFM Inline Grammar
     */ inline.gfm = {
        ...inline.normal,
        escape: edit(inline.escape).replace("])", "~|])").getRegex(),
        _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
        url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
        _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
        del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
        text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
    };
    inline.gfm.url = edit(inline.gfm.url, "i").replace("email", inline.gfm._extended_email).getRegex();
    /**
     * GFM + Line Breaks Inline Grammar
     */ inline.breaks = {
        ...inline.gfm,
        br: edit(inline.br).replace("{2,}", "*").getRegex(),
        text: edit(inline.gfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
    };
    /**
     * Block Lexer
     */ class _Lexer {
        tokens;
        options;
        state;
        tokenizer;
        inlineQueue;
        constructor(options){
            // TokenList cannot be created in one go
            // @ts-expect-error
            this.tokens = [];
            this.tokens.links = Object.create(null);
            this.options = options || exports1.defaults;
            this.options.tokenizer = this.options.tokenizer || new _Tokenizer();
            this.tokenizer = this.options.tokenizer;
            this.tokenizer.options = this.options;
            this.tokenizer.lexer = this;
            this.inlineQueue = [];
            this.state = {
                inLink: false,
                inRawBlock: false,
                top: true
            };
            const rules = {
                block: block.normal,
                inline: inline.normal
            };
            if (this.options.pedantic) {
                rules.block = block.pedantic;
                rules.inline = inline.pedantic;
            } else if (this.options.gfm) {
                rules.block = block.gfm;
                if (this.options.breaks) rules.inline = inline.breaks;
                else rules.inline = inline.gfm;
            }
            this.tokenizer.rules = rules;
        }
        /**
         * Expose Rules
         */ static get rules() {
            return {
                block: block,
                inline: inline
            };
        }
        /**
         * Static Lex Method
         */ static lex(src, options) {
            const lexer = new _Lexer(options);
            return lexer.lex(src);
        }
        /**
         * Static Lex Inline Method
         */ static lexInline(src, options) {
            const lexer = new _Lexer(options);
            return lexer.inlineTokens(src);
        }
        /**
         * Preprocessing
         */ lex(src) {
            src = src.replace(/\r\n|\r/g, "\n");
            this.blockTokens(src, this.tokens);
            let next;
            while(next = this.inlineQueue.shift())this.inlineTokens(next.src, next.tokens);
            return this.tokens;
        }
        blockTokens(src, tokens = []) {
            if (this.options.pedantic) src = src.replace(/\t/g, "    ").replace(/^ +$/gm, "");
            else src = src.replace(/^( *)(\t+)/gm, (_, leading, tabs)=>{
                return leading + "    ".repeat(tabs.length);
            });
            let token;
            let lastToken;
            let cutSrc;
            let lastParagraphClipped;
            while(src){
                if (this.options.extensions && this.options.extensions.block && this.options.extensions.block.some((extTokenizer)=>{
                    if (token = extTokenizer.call({
                        lexer: this
                    }, src, tokens)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return true;
                    }
                    return false;
                })) continue;
                // newline
                if (token = this.tokenizer.space(src)) {
                    src = src.substring(token.raw.length);
                    if (token.raw.length === 1 && tokens.length > 0) // if there's a single \n as a spacer, it's terminating the last line,
                    // so move it there so that we don't get unecessary paragraph tags
                    tokens[tokens.length - 1].raw += "\n";
                    else tokens.push(token);
                    continue;
                }
                // code
                if (token = this.tokenizer.code(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    // An indented code block cannot interrupt a paragraph.
                    if (lastToken && (lastToken.type === "paragraph" || lastToken.type === "text")) {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.text;
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else tokens.push(token);
                    continue;
                }
                // fences
                if (token = this.tokenizer.fences(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // heading
                if (token = this.tokenizer.heading(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // hr
                if (token = this.tokenizer.hr(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // blockquote
                if (token = this.tokenizer.blockquote(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // list
                if (token = this.tokenizer.list(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // html
                if (token = this.tokenizer.html(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // def
                if (token = this.tokenizer.def(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && (lastToken.type === "paragraph" || lastToken.type === "text")) {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.raw;
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else if (!this.tokens.links[token.tag]) this.tokens.links[token.tag] = {
                        href: token.href,
                        title: token.title
                    };
                    continue;
                }
                // table (gfm)
                if (token = this.tokenizer.table(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // lheading
                if (token = this.tokenizer.lheading(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // top-level paragraph
                // prevent paragraph consuming extensions by clipping 'src' to extension start
                cutSrc = src;
                if (this.options.extensions && this.options.extensions.startBlock) {
                    let startIndex = Infinity;
                    const tempSrc = src.slice(1);
                    let tempStart;
                    this.options.extensions.startBlock.forEach((getStartIndex)=>{
                        tempStart = getStartIndex.call({
                            lexer: this
                        }, tempSrc);
                        if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                    });
                    if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                }
                if (this.state.top && (token = this.tokenizer.paragraph(cutSrc))) {
                    lastToken = tokens[tokens.length - 1];
                    if (lastParagraphClipped && lastToken.type === "paragraph") {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.text;
                        this.inlineQueue.pop();
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else tokens.push(token);
                    lastParagraphClipped = cutSrc.length !== src.length;
                    src = src.substring(token.raw.length);
                    continue;
                }
                // text
                if (token = this.tokenizer.text(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && lastToken.type === "text") {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.text;
                        this.inlineQueue.pop();
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else tokens.push(token);
                    continue;
                }
                if (src) {
                    const errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(errMsg);
                        break;
                    } else throw new Error(errMsg);
                }
            }
            this.state.top = true;
            return tokens;
        }
        inline(src, tokens = []) {
            this.inlineQueue.push({
                src: src,
                tokens: tokens
            });
            return tokens;
        }
        /**
         * Lexing/Compiling
         */ inlineTokens(src, tokens = []) {
            let token, lastToken, cutSrc;
            // String with links masked to avoid interference with em and strong
            let maskedSrc = src;
            let match;
            let keepPrevChar, prevChar;
            // Mask out reflinks
            if (this.tokens.links) {
                const links = Object.keys(this.tokens.links);
                if (links.length > 0) {
                    while((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null)if (links.includes(match[0].slice(match[0].lastIndexOf("[") + 1, -1))) maskedSrc = maskedSrc.slice(0, match.index) + "[" + "a".repeat(match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
                }
            }
            // Mask out other blocks
            while((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + "[" + "a".repeat(match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
            // Mask out escaped characters
            while((match = this.tokenizer.rules.inline.anyPunctuation.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + "++" + maskedSrc.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
            while(src){
                if (!keepPrevChar) prevChar = "";
                keepPrevChar = false;
                // extensions
                if (this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some((extTokenizer)=>{
                    if (token = extTokenizer.call({
                        lexer: this
                    }, src, tokens)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return true;
                    }
                    return false;
                })) continue;
                // escape
                if (token = this.tokenizer.escape(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // tag
                if (token = this.tokenizer.tag(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && token.type === "text" && lastToken.type === "text") {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                }
                // link
                if (token = this.tokenizer.link(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // reflink, nolink
                if (token = this.tokenizer.reflink(src, this.tokens.links)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && token.type === "text" && lastToken.type === "text") {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                }
                // em & strong
                if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // code
                if (token = this.tokenizer.codespan(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // br
                if (token = this.tokenizer.br(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // del (gfm)
                if (token = this.tokenizer.del(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // autolink
                if (token = this.tokenizer.autolink(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // url (gfm)
                if (!this.state.inLink && (token = this.tokenizer.url(src))) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // text
                // prevent inlineText consuming extensions by clipping 'src' to extension start
                cutSrc = src;
                if (this.options.extensions && this.options.extensions.startInline) {
                    let startIndex = Infinity;
                    const tempSrc = src.slice(1);
                    let tempStart;
                    this.options.extensions.startInline.forEach((getStartIndex)=>{
                        tempStart = getStartIndex.call({
                            lexer: this
                        }, tempSrc);
                        if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                    });
                    if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                }
                if (token = this.tokenizer.inlineText(cutSrc)) {
                    src = src.substring(token.raw.length);
                    if (token.raw.slice(-1) !== "_") prevChar = token.raw.slice(-1);
                    keepPrevChar = true;
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && lastToken.type === "text") {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                }
                if (src) {
                    const errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(errMsg);
                        break;
                    } else throw new Error(errMsg);
                }
            }
            return tokens;
        }
    }
    /**
     * Renderer
     */ class _Renderer {
        options;
        constructor(options){
            this.options = options || exports1.defaults;
        }
        code(code, infostring, escaped) {
            const lang = (infostring || "").match(/^\S*/)?.[0];
            code = code.replace(/\n$/, "") + "\n";
            if (!lang) return "<pre><code>" + (escaped ? code : escape(code, true)) + "</code></pre>\n";
            return '<pre><code class="language-' + escape(lang) + '">' + (escaped ? code : escape(code, true)) + "</code></pre>\n";
        }
        blockquote(quote) {
            return `<blockquote>\n${quote}</blockquote>\n`;
        }
        html(html, block) {
            return html;
        }
        heading(text, level, raw) {
            // ignore IDs
            return `<h${level}>${text}</h${level}>\n`;
        }
        hr() {
            return "<hr>\n";
        }
        list(body, ordered, start) {
            const type = ordered ? "ol" : "ul";
            const startatt = ordered && start !== 1 ? ' start="' + start + '"' : "";
            return "<" + type + startatt + ">\n" + body + "</" + type + ">\n";
        }
        listitem(text, task, checked) {
            return `<li>${text}</li>\n`;
        }
        checkbox(checked) {
            return "<input " + (checked ? 'checked="" ' : "") + 'disabled="" type="checkbox">';
        }
        paragraph(text) {
            return `<p>${text}</p>\n`;
        }
        table(header, body) {
            if (body) body = `<tbody>${body}</tbody>`;
            return "<table>\n<thead>\n" + header + "</thead>\n" + body + "</table>\n";
        }
        tablerow(content) {
            return `<tr>\n${content}</tr>\n`;
        }
        tablecell(content, flags) {
            const type = flags.header ? "th" : "td";
            const tag = flags.align ? `<${type} align="${flags.align}">` : `<${type}>`;
            return tag + content + `</${type}>\n`;
        }
        /**
         * span level renderer
         */ strong(text) {
            return `<strong>${text}</strong>`;
        }
        em(text) {
            return `<em>${text}</em>`;
        }
        codespan(text) {
            return `<code>${text}</code>`;
        }
        br() {
            return "<br>";
        }
        del(text) {
            return `<del>${text}</del>`;
        }
        link(href, title, text) {
            const cleanHref = cleanUrl(href);
            if (cleanHref === null) return text;
            href = cleanHref;
            let out = '<a href="' + href + '"';
            if (title) out += ' title="' + title + '"';
            out += ">" + text + "</a>";
            return out;
        }
        image(href, title, text) {
            const cleanHref = cleanUrl(href);
            if (cleanHref === null) return text;
            href = cleanHref;
            let out = `<img src="${href}" alt="${text}"`;
            if (title) out += ` title="${title}"`;
            out += ">";
            return out;
        }
        text(text) {
            return text;
        }
    }
    /**
     * TextRenderer
     * returns only the textual part of the token
     */ class _TextRenderer {
        // no need for block level renderers
        strong(text) {
            return text;
        }
        em(text) {
            return text;
        }
        codespan(text) {
            return text;
        }
        del(text) {
            return text;
        }
        html(text) {
            return text;
        }
        text(text) {
            return text;
        }
        link(href, title, text) {
            return "" + text;
        }
        image(href, title, text) {
            return "" + text;
        }
        br() {
            return "";
        }
    }
    /**
     * Parsing & Compiling
     */ class _Parser {
        options;
        renderer;
        textRenderer;
        constructor(options){
            this.options = options || exports1.defaults;
            this.options.renderer = this.options.renderer || new _Renderer();
            this.renderer = this.options.renderer;
            this.renderer.options = this.options;
            this.textRenderer = new _TextRenderer();
        }
        /**
         * Static Parse Method
         */ static parse(tokens, options) {
            const parser = new _Parser(options);
            return parser.parse(tokens);
        }
        /**
         * Static Parse Inline Method
         */ static parseInline(tokens, options) {
            const parser = new _Parser(options);
            return parser.parseInline(tokens);
        }
        /**
         * Parse Loop
         */ parse(tokens, top = true) {
            let out = "";
            for(let i = 0; i < tokens.length; i++){
                const token = tokens[i];
                // Run any renderer extensions
                if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
                    const genericToken = token;
                    const ret = this.options.extensions.renderers[genericToken.type].call({
                        parser: this
                    }, genericToken);
                    if (ret !== false || ![
                        "space",
                        "hr",
                        "heading",
                        "code",
                        "table",
                        "blockquote",
                        "list",
                        "html",
                        "paragraph",
                        "text"
                    ].includes(genericToken.type)) {
                        out += ret || "";
                        continue;
                    }
                }
                switch(token.type){
                    case "space":
                        continue;
                    case "hr":
                        out += this.renderer.hr();
                        continue;
                    case "heading":
                        {
                            const headingToken = token;
                            out += this.renderer.heading(this.parseInline(headingToken.tokens), headingToken.depth, unescape(this.parseInline(headingToken.tokens, this.textRenderer)));
                            continue;
                        }
                    case "code":
                        {
                            const codeToken = token;
                            out += this.renderer.code(codeToken.text, codeToken.lang, !!codeToken.escaped);
                            continue;
                        }
                    case "table":
                        {
                            const tableToken = token;
                            let header = "";
                            // header
                            let cell = "";
                            for(let j = 0; j < tableToken.header.length; j++)cell += this.renderer.tablecell(this.parseInline(tableToken.header[j].tokens), {
                                header: true,
                                align: tableToken.align[j]
                            });
                            header += this.renderer.tablerow(cell);
                            let body = "";
                            for(let j = 0; j < tableToken.rows.length; j++){
                                const row = tableToken.rows[j];
                                cell = "";
                                for(let k = 0; k < row.length; k++)cell += this.renderer.tablecell(this.parseInline(row[k].tokens), {
                                    header: false,
                                    align: tableToken.align[k]
                                });
                                body += this.renderer.tablerow(cell);
                            }
                            out += this.renderer.table(header, body);
                            continue;
                        }
                    case "blockquote":
                        {
                            const blockquoteToken = token;
                            const body = this.parse(blockquoteToken.tokens);
                            out += this.renderer.blockquote(body);
                            continue;
                        }
                    case "list":
                        {
                            const listToken = token;
                            const ordered = listToken.ordered;
                            const start = listToken.start;
                            const loose = listToken.loose;
                            let body = "";
                            for(let j = 0; j < listToken.items.length; j++){
                                const item = listToken.items[j];
                                const checked = item.checked;
                                const task = item.task;
                                let itemBody = "";
                                if (item.task) {
                                    const checkbox = this.renderer.checkbox(!!checked);
                                    if (loose) {
                                        if (item.tokens.length > 0 && item.tokens[0].type === "paragraph") {
                                            item.tokens[0].text = checkbox + " " + item.tokens[0].text;
                                            if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === "text") item.tokens[0].tokens[0].text = checkbox + " " + item.tokens[0].tokens[0].text;
                                        } else item.tokens.unshift({
                                            type: "text",
                                            text: checkbox + " "
                                        });
                                    } else itemBody += checkbox + " ";
                                }
                                itemBody += this.parse(item.tokens, loose);
                                body += this.renderer.listitem(itemBody, task, !!checked);
                            }
                            out += this.renderer.list(body, ordered, start);
                            continue;
                        }
                    case "html":
                        {
                            const htmlToken = token;
                            out += this.renderer.html(htmlToken.text, htmlToken.block);
                            continue;
                        }
                    case "paragraph":
                        {
                            const paragraphToken = token;
                            out += this.renderer.paragraph(this.parseInline(paragraphToken.tokens));
                            continue;
                        }
                    case "text":
                        {
                            let textToken = token;
                            let body = textToken.tokens ? this.parseInline(textToken.tokens) : textToken.text;
                            while(i + 1 < tokens.length && tokens[i + 1].type === "text"){
                                textToken = tokens[++i];
                                body += "\n" + (textToken.tokens ? this.parseInline(textToken.tokens) : textToken.text);
                            }
                            out += top ? this.renderer.paragraph(body) : body;
                            continue;
                        }
                    default:
                        {
                            const errMsg = 'Token with "' + token.type + '" type was not found.';
                            if (this.options.silent) {
                                console.error(errMsg);
                                return "";
                            } else throw new Error(errMsg);
                        }
                }
            }
            return out;
        }
        /**
         * Parse Inline Tokens
         */ parseInline(tokens, renderer) {
            renderer = renderer || this.renderer;
            let out = "";
            for(let i = 0; i < tokens.length; i++){
                const token = tokens[i];
                // Run any renderer extensions
                if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
                    const ret = this.options.extensions.renderers[token.type].call({
                        parser: this
                    }, token);
                    if (ret !== false || ![
                        "escape",
                        "html",
                        "link",
                        "image",
                        "strong",
                        "em",
                        "codespan",
                        "br",
                        "del",
                        "text"
                    ].includes(token.type)) {
                        out += ret || "";
                        continue;
                    }
                }
                switch(token.type){
                    case "escape":
                        {
                            const escapeToken = token;
                            out += renderer.text(escapeToken.text);
                            break;
                        }
                    case "html":
                        {
                            const tagToken = token;
                            out += renderer.html(tagToken.text);
                            break;
                        }
                    case "link":
                        {
                            const linkToken = token;
                            out += renderer.link(linkToken.href, linkToken.title, this.parseInline(linkToken.tokens, renderer));
                            break;
                        }
                    case "image":
                        {
                            const imageToken = token;
                            out += renderer.image(imageToken.href, imageToken.title, imageToken.text);
                            break;
                        }
                    case "strong":
                        {
                            const strongToken = token;
                            out += renderer.strong(this.parseInline(strongToken.tokens, renderer));
                            break;
                        }
                    case "em":
                        {
                            const emToken = token;
                            out += renderer.em(this.parseInline(emToken.tokens, renderer));
                            break;
                        }
                    case "codespan":
                        {
                            const codespanToken = token;
                            out += renderer.codespan(codespanToken.text);
                            break;
                        }
                    case "br":
                        out += renderer.br();
                        break;
                    case "del":
                        {
                            const delToken = token;
                            out += renderer.del(this.parseInline(delToken.tokens, renderer));
                            break;
                        }
                    case "text":
                        {
                            const textToken = token;
                            out += renderer.text(textToken.text);
                            break;
                        }
                    default:
                        {
                            const errMsg = 'Token with "' + token.type + '" type was not found.';
                            if (this.options.silent) {
                                console.error(errMsg);
                                return "";
                            } else throw new Error(errMsg);
                        }
                }
            }
            return out;
        }
    }
    class _Hooks {
        options;
        constructor(options){
            this.options = options || exports1.defaults;
        }
        static passThroughHooks = new Set([
            "preprocess",
            "postprocess"
        ]);
        /**
         * Process markdown before marked
         */ preprocess(markdown) {
            return markdown;
        }
        /**
         * Process HTML after marked is finished
         */ postprocess(html) {
            return html;
        }
    }
    class Marked {
        defaults = _getDefaults();
        options = this.setOptions;
        parse = this.#parseMarkdown(_Lexer.lex, _Parser.parse);
        parseInline = this.#parseMarkdown(_Lexer.lexInline, _Parser.parseInline);
        Parser = _Parser;
        parser = _Parser.parse;
        Renderer = _Renderer;
        TextRenderer = _TextRenderer;
        Lexer = _Lexer;
        lexer = _Lexer.lex;
        Tokenizer = _Tokenizer;
        Hooks = _Hooks;
        constructor(...args){
            this.use(...args);
        }
        /**
         * Run callback for every token
         */ walkTokens(tokens, callback) {
            let values = [];
            for (const token of tokens){
                values = values.concat(callback.call(this, token));
                switch(token.type){
                    case "table":
                        {
                            const tableToken = token;
                            for (const cell of tableToken.header)values = values.concat(this.walkTokens(cell.tokens, callback));
                            for (const row of tableToken.rows)for (const cell of row)values = values.concat(this.walkTokens(cell.tokens, callback));
                            break;
                        }
                    case "list":
                        {
                            const listToken = token;
                            values = values.concat(this.walkTokens(listToken.items, callback));
                            break;
                        }
                    default:
                        {
                            const genericToken = token;
                            if (this.defaults.extensions?.childTokens?.[genericToken.type]) this.defaults.extensions.childTokens[genericToken.type].forEach((childTokens)=>{
                                values = values.concat(this.walkTokens(genericToken[childTokens], callback));
                            });
                            else if (genericToken.tokens) values = values.concat(this.walkTokens(genericToken.tokens, callback));
                        }
                }
            }
            return values;
        }
        use(...args) {
            const extensions = this.defaults.extensions || {
                renderers: {},
                childTokens: {}
            };
            args.forEach((pack)=>{
                // copy options to new object
                const opts = {
                    ...pack
                };
                // set async to true if it was set to true before
                opts.async = this.defaults.async || opts.async || false;
                // ==-- Parse "addon" extensions --== //
                if (pack.extensions) {
                    pack.extensions.forEach((ext)=>{
                        if (!ext.name) throw new Error("extension name required");
                        if ("renderer" in ext) {
                            const prevRenderer = extensions.renderers[ext.name];
                            if (prevRenderer) // Replace extension with func to run new extension but fall back if false
                            extensions.renderers[ext.name] = function(...args) {
                                let ret = ext.renderer.apply(this, args);
                                if (ret === false) ret = prevRenderer.apply(this, args);
                                return ret;
                            };
                            else extensions.renderers[ext.name] = ext.renderer;
                        }
                        if ("tokenizer" in ext) {
                            if (!ext.level || ext.level !== "block" && ext.level !== "inline") throw new Error("extension level must be 'block' or 'inline'");
                            const extLevel = extensions[ext.level];
                            if (extLevel) extLevel.unshift(ext.tokenizer);
                            else extensions[ext.level] = [
                                ext.tokenizer
                            ];
                            if (ext.start) {
                                if (ext.level === "block") {
                                    if (extensions.startBlock) extensions.startBlock.push(ext.start);
                                    else extensions.startBlock = [
                                        ext.start
                                    ];
                                } else if (ext.level === "inline") {
                                    if (extensions.startInline) extensions.startInline.push(ext.start);
                                    else extensions.startInline = [
                                        ext.start
                                    ];
                                }
                            }
                        }
                        if ("childTokens" in ext && ext.childTokens) extensions.childTokens[ext.name] = ext.childTokens;
                    });
                    opts.extensions = extensions;
                }
                // ==-- Parse "overwrite" extensions --== //
                if (pack.renderer) {
                    const renderer = this.defaults.renderer || new _Renderer(this.defaults);
                    for(const prop in pack.renderer){
                        const rendererFunc = pack.renderer[prop];
                        const rendererKey = prop;
                        const prevRenderer = renderer[rendererKey];
                        // Replace renderer with func to run extension, but fall back if false
                        renderer[rendererKey] = (...args)=>{
                            let ret = rendererFunc.apply(renderer, args);
                            if (ret === false) ret = prevRenderer.apply(renderer, args);
                            return ret || "";
                        };
                    }
                    opts.renderer = renderer;
                }
                if (pack.tokenizer) {
                    const tokenizer = this.defaults.tokenizer || new _Tokenizer(this.defaults);
                    for(const prop in pack.tokenizer){
                        const tokenizerFunc = pack.tokenizer[prop];
                        const tokenizerKey = prop;
                        const prevTokenizer = tokenizer[tokenizerKey];
                        // Replace tokenizer with func to run extension, but fall back if false
                        tokenizer[tokenizerKey] = (...args)=>{
                            let ret = tokenizerFunc.apply(tokenizer, args);
                            if (ret === false) ret = prevTokenizer.apply(tokenizer, args);
                            return ret;
                        };
                    }
                    opts.tokenizer = tokenizer;
                }
                // ==-- Parse Hooks extensions --== //
                if (pack.hooks) {
                    const hooks = this.defaults.hooks || new _Hooks();
                    for(const prop in pack.hooks){
                        const hooksFunc = pack.hooks[prop];
                        const hooksKey = prop;
                        const prevHook = hooks[hooksKey];
                        if (_Hooks.passThroughHooks.has(prop)) hooks[hooksKey] = (arg)=>{
                            if (this.defaults.async) return Promise.resolve(hooksFunc.call(hooks, arg)).then((ret)=>{
                                return prevHook.call(hooks, ret);
                            });
                            const ret = hooksFunc.call(hooks, arg);
                            return prevHook.call(hooks, ret);
                        };
                        else hooks[hooksKey] = (...args)=>{
                            let ret = hooksFunc.apply(hooks, args);
                            if (ret === false) ret = prevHook.apply(hooks, args);
                            return ret;
                        };
                    }
                    opts.hooks = hooks;
                }
                // ==-- Parse WalkTokens extensions --== //
                if (pack.walkTokens) {
                    const walkTokens = this.defaults.walkTokens;
                    const packWalktokens = pack.walkTokens;
                    opts.walkTokens = function(token) {
                        let values = [];
                        values.push(packWalktokens.call(this, token));
                        if (walkTokens) values = values.concat(walkTokens.call(this, token));
                        return values;
                    };
                }
                this.defaults = {
                    ...this.defaults,
                    ...opts
                };
            });
            return this;
        }
        setOptions(opt) {
            this.defaults = {
                ...this.defaults,
                ...opt
            };
            return this;
        }
        #parseMarkdown(lexer, parser) {
            return (src, options)=>{
                const origOpt = {
                    ...options
                };
                const opt = {
                    ...this.defaults,
                    ...origOpt
                };
                // Show warning if an extension set async to true but the parse was called with async: false
                if (this.defaults.async === true && origOpt.async === false) {
                    if (!opt.silent) console.warn("marked(): The async option was set to true by an extension. The async: false option sent to parse will be ignored.");
                    opt.async = true;
                }
                const throwError = this.#onError(!!opt.silent, !!opt.async);
                // throw error in case of non string input
                if (typeof src === "undefined" || src === null) return throwError(new Error("marked(): input parameter is undefined or null"));
                if (typeof src !== "string") return throwError(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(src) + ", string expected"));
                if (opt.hooks) opt.hooks.options = opt;
                if (opt.async) return Promise.resolve(opt.hooks ? opt.hooks.preprocess(src) : src).then((src)=>lexer(src, opt)).then((tokens)=>opt.walkTokens ? Promise.all(this.walkTokens(tokens, opt.walkTokens)).then(()=>tokens) : tokens).then((tokens)=>parser(tokens, opt)).then((html)=>opt.hooks ? opt.hooks.postprocess(html) : html).catch(throwError);
                try {
                    if (opt.hooks) src = opt.hooks.preprocess(src);
                    const tokens = lexer(src, opt);
                    if (opt.walkTokens) this.walkTokens(tokens, opt.walkTokens);
                    let html = parser(tokens, opt);
                    if (opt.hooks) html = opt.hooks.postprocess(html);
                    return html;
                } catch (e) {
                    return throwError(e);
                }
            };
        }
        #onError(silent, async) {
            return (e)=>{
                e.message += "\nPlease report this to https://github.com/markedjs/marked.";
                if (silent) {
                    const msg = "<p>An error occurred:</p><pre>" + escape(e.message + "", true) + "</pre>";
                    if (async) return Promise.resolve(msg);
                    return msg;
                }
                if (async) return Promise.reject(e);
                throw e;
            };
        }
    }
    const markedInstance = new Marked();
    function marked(src, opt) {
        return markedInstance.parse(src, opt);
    }
    /**
     * Sets the default options.
     *
     * @param options Hash of options
     */ marked.options = marked.setOptions = function(options) {
        markedInstance.setOptions(options);
        marked.defaults = markedInstance.defaults;
        changeDefaults(marked.defaults);
        return marked;
    };
    /**
     * Gets the original marked default options.
     */ marked.getDefaults = _getDefaults;
    marked.defaults = exports1.defaults;
    /**
     * Use Extension
     */ marked.use = function(...args) {
        markedInstance.use(...args);
        marked.defaults = markedInstance.defaults;
        changeDefaults(marked.defaults);
        return marked;
    };
    /**
     * Run callback for every token
     */ marked.walkTokens = function(tokens, callback) {
        return markedInstance.walkTokens(tokens, callback);
    };
    /**
     * Compiles markdown to HTML without enclosing `p` tag.
     *
     * @param src String of markdown source to be compiled
     * @param options Hash of options
     * @return String of compiled HTML
     */ marked.parseInline = markedInstance.parseInline;
    /**
     * Expose
     */ marked.Parser = _Parser;
    marked.parser = _Parser.parse;
    marked.Renderer = _Renderer;
    marked.TextRenderer = _TextRenderer;
    marked.Lexer = _Lexer;
    marked.lexer = _Lexer.lex;
    marked.Tokenizer = _Tokenizer;
    marked.Hooks = _Hooks;
    marked.parse = marked;
    const options = marked.options;
    const setOptions = marked.setOptions;
    const use = marked.use;
    const walkTokens = marked.walkTokens;
    const parseInline = marked.parseInline;
    const parse = marked;
    const parser = _Parser.parse;
    const lexer = _Lexer.lex;
    exports1.Hooks = _Hooks;
    exports1.Lexer = _Lexer;
    exports1.Marked = Marked;
    exports1.Parser = _Parser;
    exports1.Renderer = _Renderer;
    exports1.TextRenderer = _TextRenderer;
    exports1.Tokenizer = _Tokenizer;
    exports1.getDefaults = _getDefaults;
    exports1.lexer = lexer;
    exports1.marked = marked;
    exports1.options = options;
    exports1.parse = parse;
    exports1.parseInline = parseInline;
    exports1.parser = parser;
    exports1.setOptions = setOptions;
    exports1.use = use;
    exports1.walkTokens = walkTokens;
});






const $a7f74cab20265ca8$export$45d31663d4501d23 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $f8f3429cfd7577a0$export$cc7e12c76513e857).Group)(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      [cmdk-group-heading] {
        font: ${theme.font.body.sm.medium};
        color: ${theme.color.fg.subtle};
        padding: 6px 24px;
      }
    `);
const $a7f74cab20265ca8$export$180a7908214a3f63 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).header`
  display: flex;
  gap: 8px;
`;
const $a7f74cab20265ca8$export$84c7afe198486d39 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $f8f3429cfd7577a0$export$cc7e12c76513e857).Item)(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      display: grid;
      grid-template-columns: auto 1fr auto;
      align-items: center;
      gap: 0 12px;
      padding: 6px;
      margin: 0 16px;
      border-radius: ${theme.radius.rounded};
      cursor: pointer;
      color: ${theme.color.fg.default};
      font: ${theme.font.body.md.regular};

      &[data-selected] {
        background: ${theme.color.primary.grape.alpha[50]};
      }
    `);
const $a7f74cab20265ca8$export$76bfbab5e3f9a6a3 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $0a830394bc38e4e3$export$f04a61298a47a40f))`
  grid-column: 1/ 2;
  grid-row: 1 / 3;
  width: 20px;
  height: 20px;
`;
const $a7f74cab20265ca8$export$6b17272dd0bda7e0 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).span`
  grid-column: 2 / 3;
  grid-row: 1 / 2;
  display: flex;
  align-items: center;
  gap: 12px;
`;
const $a7f74cab20265ca8$export$5a1847f21bf57735 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).span(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      color: ${theme.color.fg.muted};
      grid-column: 2 / 3;
      grid-row: 2 / 3;
    `);
const $a7f74cab20265ca8$export$3fbf14393047f53b = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).span`
  grid-column: 3 / 4;
  display: flex;
  align-items: center;
  gap: 16px;
`;
const $a7f74cab20265ca8$export$8b2995843ab6cf09 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).span`
  display: flex;
  gap: 4px;
`;
const $a7f74cab20265ca8$export$36e6bbbe30bb50de = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).span(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      display: flex;
      min-width: 28px;
      height: 28px;
      padding: 10px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 10px;
      border-radius: 6px;
      background: ${theme.color.bg.subtle};
    `);
const $a7f74cab20265ca8$export$ed9857ba217e22b9 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).span(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      display: flex;
      height: 20px;
      padding: 2px 8px;
      justify-content: center;
      align-items: center;
      gap: 4px;
      border-radius: ${theme.radius.minimal};
      background: linear-gradient(
        90deg,
        ${theme.color.accent.mustard["500"]} 0%,
        ${theme.color.accent.magenta["500"]} 52.08%,
        ${theme.color.primary.grape["600"]} 100%
      );
      text-align: center;
      color: ${theme.color.fg.onemphasis.default};
      font: ${theme.font.headings.h6};
    `);
const $a7f74cab20265ca8$export$366c532872f6be44 = ({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    padding: 0;
    border: none;
    border-bottom: 1px solid ${theme.color.border.default};
    background: ${theme.color.bg.default};
    color: ${theme.color.fg.default};
    flex: 1;
    font: ${theme.font.body.l.regular};
    outline: none;
    border: none;

    ::placeholder {
      color: ${theme.color.fg.muted};
    }
  `;





const $667b50082db7e3ee$var$OPTIONS = [
    "What is Autometrics?",
    "How to setup Autometrics?",
    "How to call a function in Autometrics?",
    "How does Autometrics work?"
];
function $667b50082db7e3ee$export$42756c326e3990e0({ query: query, setPage: setPage, setQuery: setQuery }) {
    const dispatch = (0, $162ecfa8ddc7a9ff$export$f51d452c10d5b956)();
    const { ids: ids, items: items, isVisible: isVisible } = (0, $1a280fbaa3fcabb5$export$2105062e25df4afe)((state)=>state.askAutometrics);
    const idArray = (0, $2gcPZ.useMemo)(()=>[
            ...ids
        ].reverse(), [
        ids
    ]);
    const ref = (0, $2gcPZ.useRef)(null);
    const [prompt, setPrompt] = (0, $2gcPZ.useState)("");
    (0, $ebe4a35e848ce6c2$export$7b6039695cd13aa3)(ref.current, prompt);
    (0, $2gcPZ.useEffect)(()=>{
        if (ref.current) {
            ref.current.scrollIntoView({
                behavior: "smooth",
                block: "end"
            });
            ref.current.focus();
        }
    }, [
        isVisible,
        ids,
        items
    ]);
    if (isVisible) return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($667b50082db7e3ee$var$ResultsContainer, {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($667b50082db7e3ee$var$InputContainer, {
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($667b50082db7e3ee$var$StyledInput, {
                    ref: ref,
                    placeholder: "Ask a question about Autometrics...",
                    value: prompt,
                    onChange: (event)=>{
                        setPrompt(event.target.value);
                    },
                    onKeyDown: (event)=>{
                        if (event.key === "Enter" && !event.shiftKey) {
                            event.preventDefault();
                            dispatch((0, $4beae11c8214cfec$export$3b3a9a3ad9f17c98)(prompt));
                            setPrompt("");
                            setQuery("");
                        }
                        if (!prompt && event.key === "Backspace") setPage(null);
                    }
                })
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($667b50082db7e3ee$var$ExperimentalWarning, {
                children: "Experimental: \u2018Ask Autometrics\u2019 is an experiment and may give you incorrect answers."
            }),
            idArray.map((id)=>items[id] && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($667b50082db7e3ee$var$Prompt, {
                    prompt: items[id]
                }, id)).filter(Boolean)
        ]
    });
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $afa7be861492543f$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a7f74cab20265ca8$export$45d31663d4501d23), {
                heading: "Examples",
                children: $667b50082db7e3ee$var$OPTIONS.map((option)=>{
                    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $a7f74cab20265ca8$export$84c7afe198486d39), {
                        onSelect: ()=>{
                            dispatch((0, $4beae11c8214cfec$export$3b3a9a3ad9f17c98)(option));
                            setPrompt("");
                            setQuery("");
                        },
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a7f74cab20265ca8$export$76bfbab5e3f9a6a3), {
                                type: "autometrics_logo_purple"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a7f74cab20265ca8$export$6b17272dd0bda7e0), {
                                children: option
                            })
                        ]
                    }, option);
                })
            }),
            query && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $a7f74cab20265ca8$export$84c7afe198486d39), {
                onSelect: ()=>{
                    dispatch((0, $4beae11c8214cfec$export$3b3a9a3ad9f17c98)(query));
                    setPrompt("");
                },
                value: `"${query}"`,
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a7f74cab20265ca8$export$76bfbab5e3f9a6a3), {
                        type: "autometrics_logo_purple"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a7f74cab20265ca8$export$6b17272dd0bda7e0), {
                        children: query
                    })
                ]
            }, "query")
        ]
    });
}
const $667b50082db7e3ee$var$Prompt = /*#__PURE__*/ (0, $2gcPZ.memo)(function Prompt({ prompt: prompt }) {
    const htmlContent = (0, $2gcPZ.useMemo)(()=>{
        if (!prompt.response) return "";
        const parsed = (0, $a00fa2db16d86f9f$exports.parse)(prompt.response);
        return (0, $3d3fa9ba1cb5a516$exports.sanitize)(parsed);
    }, [
        prompt.response
    ]);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($667b50082db7e3ee$var$PromptContainer, {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("header", {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0a830394bc38e4e3$export$f04a61298a47a40f), {
                        type: "autometrics_logo_purple"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("div", {
                        children: prompt.prompt
                    })
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0a830394bc38e4e3$export$f04a61298a47a40f), {
                        type: "sparkle"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($667b50082db7e3ee$var$ResponseBubble, {
                        isError: prompt.isError,
                        children: prompt.response ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: htmlContent
                            }
                        }) : /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $5e65b7d195cb25fe$export$ae7b5e50e522fa95), {})
                    })
                ]
            })
        ]
    });
});
const $667b50082db7e3ee$var$PromptContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).article(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    & > header,
    & > p {
      display: flex;
    }

    div {
      flex: 1;
      overflow: hidden;
    }

    svg {
      flex-basis: 24px;
      margin-right: 16px;
      flex-shrink: 0;
      path {
        fill: ${theme.color.primary.grape[600]};
      }
    }

    header {
      margin-bottom: 20px;
      color: ${theme.color.fg.muted};
    }
  `);
const $667b50082db7e3ee$var$InputContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  margin-top: 24px;
  border-top: 1px solid ${({ theme: theme })=>theme.color.border.muted};
  width: 100%;
`;
const $667b50082db7e3ee$var$ExperimentalWarning = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    margin: 16px 24px 0 64px;
    padding: ${theme.radius.minimal} ${theme.radius.rounded};
    font: ${theme.font.headings.h6};
    line-height: 16px;
    border-radius: ${theme.radius.minimal};
    border: 1px solid #f8941f;
    background: linear-gradient(
      90deg,
      #f99421 0%,
      #f948ea 52.08%,
      #9027ff 100%
    );
  `);
const $667b50082db7e3ee$var$ResultsContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  padding: 16px 0 0;
  min-height: 512px;
  display: flex;
  flex-direction: column-reverse;
  ${$667b50082db7e3ee$var$InputContainer}, ${$667b50082db7e3ee$var$PromptContainer}, ${$667b50082db7e3ee$var$ExperimentalWarning} {
    padding-left: 24px;
    padding-right: 24px;
  }
  article + article {
    margin-bottom: 32px;
  }
`;
const $667b50082db7e3ee$var$ResponseBubble = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ isError: isError, theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    background: ${isError ? theme.color.support.danger[400] : theme.color.primary.grape.alpha[50]};
    padding: 16px;
    border-radius: 16px;
    transition: background-color 0.25s ease-in;

    table {
      border-collapse: collapse;
      max-width: 100%;
    }
    tr {
      border-bottom: 1px solid ${theme.color.border.default};
    }
    thead tr {
      border-bottom-width: 2px;
    }
    th {
      padding: 8px 16px;
    }

    pre {
      background-color: ${theme.color.bg.subtle};
      border-radius: ${theme.radius.rounded};
      padding: 12px;
      overflow-x: scroll;
      white-space: nowrap;
    }
    pre,
    code {
      font: ${theme.font.code.regular};
      background-color: ${theme.color.bg.subtle};
      text-shadow: 0 1px ${theme.color.bg.default};

      transition: background-color 0.2s ease-in-out;
    }
    code[class*="language-"],
    pre[class*="language-"] {
      color: ${theme.color.fg.default};
    }
    .language-autometrics {
      .token.punctuation {
        color: ${theme.color.fg.default};
      }

      .token.function {
        color: ${theme.color.fg.primary};
      }
      .token.keyword {
        color: ${theme.color.fg.primary};
      }

      .token.string {
        color: ${theme.color.fg.accent[1]};
      }

      .token.class-name {
        color: ${theme.color.fg.default};
      }
      .token.constant {
        color: ${theme.color.fg.default};
      }

      .token.function-definition.function {
        color: ${theme.color.fg.accent[2]};
      }

      .token.namespace {
        color: ${theme.color.fg.accent[3]};
      }

      .token.attribute.attr-name {
        color: ${theme.color.fg.default};
      }

      .token.number {
        color: ${theme.color.fg.accent[1]};
      }

      .token.operator {
        background-color: transparent;
        color: ${theme.color.fg.default};
      }
    }
  `);
const $667b50082db7e3ee$var$StyledInput = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).textarea`
  ${(0, $a7f74cab20265ca8$export$366c532872f6be44)}
  padding: 16px 0 0;
  resize: none;
  width: 100%;
`;




var $2gcPZ = parcelRequire("2gcPZ");



var $2gcPZ = parcelRequire("2gcPZ");

var $9455be0774d719db$var$getInitialState = function(query, defaultState) {
    // Prevent a React hydration mismatch when a default value is provided by not defaulting to window.matchMedia(query).matches.
    if (defaultState !== undefined) return defaultState;
    if (0, $531a31f385e8e603$export$4e09c449d6c407f7) return window.matchMedia(query).matches;
    return false;
};
var $9455be0774d719db$var$useMedia = function(query, defaultState) {
    var _a = (0, $2gcPZ.useState)($9455be0774d719db$var$getInitialState(query, defaultState)), state = _a[0], setState = _a[1];
    (0, $2gcPZ.useEffect)(function() {
        var mounted = true;
        var mql = window.matchMedia(query);
        var onChange = function() {
            if (!mounted) return;
            setState(!!mql.matches);
        };
        mql.addListener(onChange);
        setState(mql.matches);
        return function() {
            mounted = false;
            mql.removeListener(onChange);
        };
    }, [
        query
    ]);
    return state;
};
var $9455be0774d719db$export$2e2bcd8739ae039 = $9455be0774d719db$var$useMedia;











// We limit the amount of commands when there's no query entered, so the user doesn't get overwhelmed
// with commands for functions and objectives
const $19d36dbcd483dc5b$var$COMMAND_PREVIEW_LIMIT = 5;
function $19d36dbcd483dc5b$export$946db6ee7f326c6d({ hideCommandMenu: hideCommandMenu, query: query, setPage: setPage, setQuery: setQuery }) {
    const dispatch = (0, $162ecfa8ddc7a9ff$export$f51d452c10d5b956)();
    const navigate = (0, $efeb47d767416279$export$9770f232ac06a008)();
    const { currentTheme: currentTheme, isSystemPreference: isSystemPreference, setThemePreference: setThemePreference, setToSystemTheme: setToSystemTheme } = (0, $bbc2cb4268a46f72$export$bace31607121468e)();
    const systemPrefersDark = (0, $9455be0774d719db$export$2e2bcd8739ae039)("(prefers-color-scheme: dark)");
    const activeInstance = (0, $1a280fbaa3fcabb5$export$2105062e25df4afe)((0, $14bbd07b3011052f$export$919b3065fd27c3a8));
    const { instances: instances } = (0, $162ecfa8ddc7a9ff$export$a7347740d65f620b)((state)=>state.environment);
    const limitResults = query.length === 0;
    // Filter instances that are not active
    const filteredInstances = activeInstance ? instances.filter(({ id: id })=>id !== activeInstance.id) : instances;
    const { data: trackedFunctions } = (0, $7530fbaa6f2f256c$export$7f85c6a6ff922ea5)(activeInstance?.url, {
        skip: !activeInstance?.url
    });
    // Limit the amount of function commands when there's no query
    const limitedTrackedFunctions = (0, $2gcPZ.useMemo)(()=>{
        if (limitResults && trackedFunctions) return trackedFunctions.slice(0, $19d36dbcd483dc5b$var$COMMAND_PREVIEW_LIMIT);
        return trackedFunctions;
    }, [
        limitResults,
        trackedFunctions
    ]);
    const { timeRange: timeRange } = (0, $326a17b5958d0a0c$export$43bf3df9dfee3ce5)();
    const { data: trackedObjectives } = (0, $81accdab4a22bb8e$export$d5dc83059f71efcf)({
        environmentUrl: activeInstance?.url,
        start: timeRange.from,
        end: timeRange.to
    }, {
        skip: !activeInstance?.url
    });
    // Limit the amount of objective commands when there's no query
    const limitedTrackedObjectives = (0, $2gcPZ.useMemo)(()=>{
        if (limitResults && trackedObjectives) return trackedObjectives.slice(0, $19d36dbcd483dc5b$var$COMMAND_PREVIEW_LIMIT);
        return trackedObjectives;
    }, [
        limitResults,
        trackedObjectives
    ]);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $afa7be861492543f$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a7f74cab20265ca8$export$45d31663d4501d23), {
                heading: "Documentation",
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $a7f74cab20265ca8$export$84c7afe198486d39), {
                    onSelect: ()=>{
                        setPage("askDora");
                        if (query) {
                            dispatch((0, $4beae11c8214cfec$export$3b3a9a3ad9f17c98)(query));
                            setQuery("");
                        }
                    },
                    value: `ask "${query}"`,
                    children: [
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a7f74cab20265ca8$export$76bfbab5e3f9a6a3), {
                            type: "autometrics_logo_purple"
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $a7f74cab20265ca8$export$6b17272dd0bda7e0), {
                            children: [
                                "Ask Autometrics",
                                query && `: ${query}`
                            ]
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a7f74cab20265ca8$export$3fbf14393047f53b), {
                            children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a7f74cab20265ca8$export$ed9857ba217e22b9), {
                                children: "Experimental"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a7f74cab20265ca8$export$45d31663d4501d23), {
                heading: "Time range",
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $a7f74cab20265ca8$export$84c7afe198486d39), {
                    onSelect: ()=>{
                        setPage("timeRange");
                        setQuery("");
                    },
                    children: [
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a7f74cab20265ca8$export$76bfbab5e3f9a6a3), {
                            type: "time_duotone"
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a7f74cab20265ca8$export$6b17272dd0bda7e0), {
                            children: "Change time range"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $a7f74cab20265ca8$export$45d31663d4501d23), {
                heading: "Theme",
                children: [
                    currentTheme === "light" && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $a7f74cab20265ca8$export$84c7afe198486d39), {
                        onSelect: ()=>{
                            setThemePreference("dark");
                            hideCommandMenu();
                        },
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a7f74cab20265ca8$export$76bfbab5e3f9a6a3), {
                                type: "moon_duotone"
                            }),
                            "Switch to dark theme"
                        ]
                    }),
                    currentTheme === "dark" && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $a7f74cab20265ca8$export$84c7afe198486d39), {
                        onSelect: ()=>{
                            setThemePreference("light");
                            hideCommandMenu();
                        },
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a7f74cab20265ca8$export$76bfbab5e3f9a6a3), {
                                type: "sun_duotone"
                            }),
                            "Switch to light theme"
                        ]
                    }),
                    !isSystemPreference && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $a7f74cab20265ca8$export$84c7afe198486d39), {
                        onSelect: ()=>{
                            setToSystemTheme();
                            hideCommandMenu();
                        },
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a7f74cab20265ca8$export$76bfbab5e3f9a6a3), {
                                type: systemPrefersDark ? "moon_duotone" : "sun_duotone"
                            }),
                            "Switch to system theme"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $a7f74cab20265ca8$export$45d31663d4501d23), {
                heading: "Navigation",
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $a7f74cab20265ca8$export$84c7afe198486d39), {
                        onSelect: ()=>{
                            navigate("/dashboard");
                            hideCommandMenu();
                        },
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a7f74cab20265ca8$export$76bfbab5e3f9a6a3), {
                                type: "dashboard_duotone"
                            }),
                            "Go to Dashboard"
                        ]
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $a7f74cab20265ca8$export$84c7afe198486d39), {
                        onSelect: ()=>{
                            navigate("/functions");
                            hideCommandMenu();
                        },
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a7f74cab20265ca8$export$76bfbab5e3f9a6a3), {
                                type: "function_duotone"
                            }),
                            "Go to Functions"
                        ]
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $a7f74cab20265ca8$export$84c7afe198486d39), {
                        onSelect: ()=>{
                            navigate("/slos");
                            hideCommandMenu();
                        },
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a7f74cab20265ca8$export$76bfbab5e3f9a6a3), {
                                type: "slo_duotone"
                            }),
                            "Go to SLOs"
                        ]
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $a7f74cab20265ca8$export$84c7afe198486d39), {
                        onSelect: ()=>{
                            navigate("/alerts");
                            hideCommandMenu();
                        },
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a7f74cab20265ca8$export$76bfbab5e3f9a6a3), {
                                type: "alerts_duotone"
                            }),
                            "Go to Alerts"
                        ]
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $a7f74cab20265ca8$export$84c7afe198486d39), {
                        onSelect: ()=>{
                            navigate("/settings");
                            hideCommandMenu();
                        },
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a7f74cab20265ca8$export$76bfbab5e3f9a6a3), {
                                type: "settings_duotone"
                            }),
                            "Go to Settings"
                        ]
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $a7f74cab20265ca8$export$84c7afe198486d39), {
                        onSelect: ()=>{
                            window.open("https://docs.autometrics.dev/", "_blank")?.focus();
                            hideCommandMenu();
                        },
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a7f74cab20265ca8$export$76bfbab5e3f9a6a3), {
                                type: "docs_duotone"
                            }),
                            "Go to Docs"
                        ]
                    })
                ]
            }),
            instances.length > 1 && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a7f74cab20265ca8$export$45d31663d4501d23), {
                heading: "Environments",
                children: filteredInstances.map((instance)=>{
                    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $a7f74cab20265ca8$export$84c7afe198486d39), {
                        onSelect: ()=>{
                            dispatch((0, $ecfe56675d6ea75b$export$3b7e95cf3154ca1f)(instance.id));
                            hideCommandMenu();
                        },
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a7f74cab20265ca8$export$76bfbab5e3f9a6a3), {
                                type: "environments_duotone"
                            }),
                            "Switch environment to ",
                            instance.name
                        ]
                    }, instance.id);
                })
            }),
            limitedTrackedObjectives && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a7f74cab20265ca8$export$45d31663d4501d23), {
                heading: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $a7f74cab20265ca8$export$180a7908214a3f63), {
                    children: [
                        "SLOs",
                        trackedObjectives.length > limitedTrackedObjectives.length && ` (${trackedObjectives.length})`
                    ]
                }),
                children: limitedTrackedObjectives.map((objective)=>{
                    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $a7f74cab20265ca8$export$84c7afe198486d39), {
                        onSelect: ()=>{
                            navigate((0, $c12fb649da40a3f2$export$fa3ecc25d6e42a0f)(objective));
                            hideCommandMenu();
                        },
                        value: `${objective.metric} ${objective.name}`,
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a7f74cab20265ca8$export$76bfbab5e3f9a6a3), {
                                type: "slo_duotone"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $a7f74cab20265ca8$export$6b17272dd0bda7e0), {
                                children: [
                                    objective.name,
                                    " ",
                                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $4b2588c47e3149e9$export$d2dff97f035be373), {
                                        metric: objective.metric
                                    })
                                ]
                            })
                        ]
                    }, `${objective.metric}:${objective.name}`);
                })
            }),
            limitedTrackedFunctions && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a7f74cab20265ca8$export$45d31663d4501d23), {
                heading: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $a7f74cab20265ca8$export$180a7908214a3f63), {
                    children: [
                        "Functions",
                        trackedFunctions.length > limitedTrackedFunctions.length && ` (${trackedFunctions.length})`
                    ]
                }),
                children: limitedTrackedFunctions.map((fn)=>{
                    const path = (0, $c12fb649da40a3f2$export$caded91e4645de6)(fn.name, fn.module, fn.service_name);
                    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $a7f74cab20265ca8$export$84c7afe198486d39), {
                        onSelect: ()=>{
                            navigate(path);
                            hideCommandMenu();
                        },
                        value: `${fn.module} ${fn.name}`,
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a7f74cab20265ca8$export$76bfbab5e3f9a6a3), {
                                type: "function_duotone"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a7f74cab20265ca8$export$6b17272dd0bda7e0), {
                                children: fn.name
                            }),
                            fn.module && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a7f74cab20265ca8$export$5a1847f21bf57735), {
                                children: fn.module
                            })
                        ]
                    }, path);
                })
            })
        ]
    });
}






function $59973e55892030f8$export$57a021c10ee5a0f({ hideCommandMenu: hideCommandMenu, setPage: setPage }) {
    const { onChangeTimeRange: onChangeTimeRange } = (0, $326a17b5958d0a0c$export$43bf3df9dfee3ce5)();
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a7f74cab20265ca8$export$45d31663d4501d23), {
        heading: "Change time range",
        children: (0, $89bcf338a8e6a1c2$export$523707e132cb0181).map((option)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $a7f74cab20265ca8$export$84c7afe198486d39), {
                onSelect: ()=>{
                    onChangeTimeRange((0, $89bcf338a8e6a1c2$export$e960ce4da64adf02)(option));
                    setPage(null);
                    hideCommandMenu();
                },
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a7f74cab20265ca8$export$76bfbab5e3f9a6a3), {
                        type: "time_duotone"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $a7f74cab20265ca8$export$6b17272dd0bda7e0), {
                        children: [
                            "Change time range to ",
                            option.label.toLowerCase()
                        ]
                    })
                ]
            }, option.value))
    });
}


function $aa1bea30390b79eb$export$e137a548a1cc9233({ pageType: pageType, ...props }) {
    switch(pageType){
        case "timeRange":
            return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $59973e55892030f8$export$57a021c10ee5a0f), {
                ...props
            });
        case "askDora":
            return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $667b50082db7e3ee$export$42756c326e3990e0), {
                ...props
            });
    }
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $19d36dbcd483dc5b$export$946db6ee7f326c6d), {
        ...props
    });
}





const $8b1c79cc1edb35f9$export$8a3d3295db52f41 = ()=>{
    const dispatch = (0, $162ecfa8ddc7a9ff$export$f51d452c10d5b956)();
    const visible = (0, $1a280fbaa3fcabb5$export$2105062e25df4afe)((0, $2170e4260f2ec713$export$5716401efcc21444));
    const isAskAutometricsVisible = (0, $1a280fbaa3fcabb5$export$2105062e25df4afe)((state)=>state.askAutometrics.isVisible);
    // Shortcut handler
    const onKeyDown = (0, $cac150ebb620e91f$export$d095b0c879743c0d)((event)=>{
        switch(event.key){
            case "k":
                if ((0, $6babf196a55ab307$export$9ac100e40613ea10) ? event.metaKey : event.ctrlKey) {
                    (0, $0cca6883e0725c68$export$e9caaaecfee38128)(event);
                    if (visible) $8b1c79cc1edb35f9$var$hide();
                    else $8b1c79cc1edb35f9$var$show();
                }
                break;
            case "Escape":
                if (visible) {
                    (0, $0cca6883e0725c68$export$e9caaaecfee38128)(event);
                    $8b1c79cc1edb35f9$var$hide();
                }
                break;
        }
    });
    (0, $2gcPZ.useEffect)(()=>{
        document.body.addEventListener("keydown", onKeyDown);
        return ()=>document.body.removeEventListener("keydown", onKeyDown);
    }, [
        onKeyDown
    ]);
    const [query, setQuery] = (0, $2gcPZ.useState)("");
    const inputRef = (0, $2gcPZ.useRef)(null);
    const menuRef = (0, $2gcPZ.useRef)(null);
    const [page, setPage] = (0, $2gcPZ.useState)(null);
    const shouldShowCommandElements = page !== "askDora" || !isAskAutometricsVisible;
    (0, $2gcPZ.useEffect)(()=>{
        if (visible) {
            inputRef.current?.focus();
            dispatch((0, $c96f342fb290ed4c$export$295a1b2aa4d86817)(false));
        }
    }, [
        visible,
        page,
        dispatch
    ]);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($8b1c79cc1edb35f9$var$Wrapper, {
        isVisible: visible,
        onClick: (event)=>{
            if (menuRef.current?.contains(event.target)) return (0, $0cca6883e0725c68$export$e9caaaecfee38128)(event);
            $8b1c79cc1edb35f9$var$hide();
        },
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($8b1c79cc1edb35f9$var$StyledCommand, {
            label: "Command Menu",
            ref: menuRef,
            children: [
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($8b1c79cc1edb35f9$var$StyledHeader, {
                    onClick: (event)=>{
                        (0, $0cca6883e0725c68$export$e9caaaecfee38128)(event);
                        inputRef.current?.focus();
                    },
                    children: [
                        page !== null && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($8b1c79cc1edb35f9$var$PageNav, {
                            onClick: ()=>setPage(null),
                            children: [
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0a830394bc38e4e3$export$f04a61298a47a40f), {
                                    type: "arrow_square_left_duotone"
                                }),
                                page === "timeRange" ? "Time range" : page === "askDora" ? "Ask Autometrics" : ""
                            ]
                        }),
                        shouldShowCommandElements && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($8b1c79cc1edb35f9$var$StyledCommandInput, {
                            autoFocus: true,
                            disabled: !visible,
                            placeholder: page === "askDora" ? "Ask a question about Autometrics..." : "Type a command or search",
                            ref: inputRef,
                            value: query,
                            onValueChange: setQuery,
                            onKeyDown: (event)=>{
                                if (page !== null && !query && event.key === "Backspace") setPage(null);
                            }
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($8b1c79cc1edb35f9$var$CloseIconButton, {
                            buttonStyle: "tertiary-color",
                            iconType: "close",
                            onClick: $8b1c79cc1edb35f9$var$hide
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $f8f3429cfd7577a0$export$cc7e12c76513e857).List, {
                    "data-no-tooltip": true,
                    children: [
                        shouldShowCommandElements && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($8b1c79cc1edb35f9$var$StyledCommandEmpty, {
                            children: "No results found."
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $aa1bea30390b79eb$export$e137a548a1cc9233), {
                            hideCommandMenu: $8b1c79cc1edb35f9$var$hide,
                            pageType: page,
                            query: query,
                            setPage: setPage,
                            setQuery: setQuery
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($8b1c79cc1edb35f9$var$Footer, {
                    children: [
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($8b1c79cc1edb35f9$var$FooterSection, {
                            children: [
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($8b1c79cc1edb35f9$var$FooterKey, {
                                    children: "esc"
                                }),
                                " to close",
                                page !== null && !query && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $afa7be861492543f$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($8b1c79cc1edb35f9$var$FooterKey, {
                                            children: "backspace"
                                        }),
                                        " to return"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($8b1c79cc1edb35f9$var$FooterSection, {
                            children: [
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($8b1c79cc1edb35f9$var$FooterKey, {
                                    children: (0, $6babf196a55ab307$export$9ac100e40613ea10) ? "\u2318" : "ctrl"
                                }),
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($8b1c79cc1edb35f9$var$FooterKey, {
                                    children: "K"
                                }),
                                " to open command bar"
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
const $8b1c79cc1edb35f9$var$show = ()=>(0, $c41f178228bd3003$export$635e15bbd66f01ea)({
        type: (0, $f7cf41d7a90d10a9$export$15779acd87b94b6a)
    });
const $8b1c79cc1edb35f9$var$hide = ()=>(0, $c41f178228bd3003$export$635e15bbd66f01ea)({
        type: (0, $f7cf41d7a90d10a9$export$13c0f6bde07cf138)
    });
const $8b1c79cc1edb35f9$var$StyledCommand = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $f8f3429cfd7577a0$export$cc7e12c76513e857))(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      width: 100%;
      max-width: 728px;
      border-radius: ${theme.radius.default};
      border: 1px solid ${theme.color.border.muted};
      background: ${theme.color.bg.default};
      box-shadow: ${theme.effect.shadow.m};
      display: grid;
      gap: 8px;

      [cmdk-list] {
        height: var(--cmdk-list-height);
        min-height: 256px;
        max-height: 512px;
        transition: height 100ms ease;

        overflow-y: auto;
        scroll-padding-block-start: 16px;
        scroll-padding-block-end: 16px;
        padding: 0 0 16px 0;
      }
    `);
const $8b1c79cc1edb35f9$var$Wrapper = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 20vh 32px 32px;
  transition: opacity 0.1s ease-in 0.05s, background 0.1s ease-in;

  & > ${$8b1c79cc1edb35f9$var$StyledCommand} {
    transition: transform 0.1s ease-in 0.05s;
    perspective: 800px;
    transform-style: preserve-3d;
  }

  ${({ isVisible: isVisible })=>isVisible ? (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
          background: rgba(0, 0, 0, 0.25);
          opacity: 1;
          pointer-events: auto;

          & > ${$8b1c79cc1edb35f9$var$StyledCommand} {
            transform: rotateX(0) translateZ(0);
          }
        ` : (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
          background: transparent;
          opacity: 0;
          pointer-events: none;

          & > ${$8b1c79cc1edb35f9$var$StyledCommand} {
            transform: rotateX(20deg) translateZ(-100px);
          }
        `}
`;
const $8b1c79cc1edb35f9$var$StyledHeader = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).header(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      display: grid;
      gap: 12px;
      grid-template-columns: 1fr auto;
      grid-auto-rows: auto;
      align-items: center;
      padding: 16px 16px 16px 24px;
      border-bottom: 1px solid ${theme.color.border.muted};
    `);
const $8b1c79cc1edb35f9$var$PageNav = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).nav(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      grid-column: 1 / 2;
      grid-row: 1 / 2;
      display: flex;
      align-items: center;
      gap: 12px;
      color: red;
      cursor: pointer;
      color: ${theme.color.fg.default};
      font: ${theme.font.body.md.medium};
    `);
const $8b1c79cc1edb35f9$var$StyledCommandInput = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $f8f3429cfd7577a0$export$cc7e12c76513e857).Input)((0, $a7f74cab20265ca8$export$366c532872f6be44));
const $8b1c79cc1edb35f9$var$StyledCommandEmpty = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $f8f3429cfd7577a0$export$cc7e12c76513e857).Empty)`
  padding: 0 24px;
`;
const $8b1c79cc1edb35f9$var$Footer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).footer(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      border-top: 1px solid ${theme.color.border.muted};
      background: ${theme.color.bg.subtle};
      color: ${theme.color.fg.default};
      padding: 6px 24px;
      font: ${theme.font.body.sm.regular};
      display: flex;
      justify-content: space-between;
    `);
const $8b1c79cc1edb35f9$var$FooterSection = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).section`
  display: flex;
  gap: 6px;
  align-items: center;
`;
const $8b1c79cc1edb35f9$var$FooterKey = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).span(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      border-radius: ${theme.radius.minimal};
      border: 1px solid ${theme.color.button.secondary.border};
      background: ${theme.color.bg.default};
      padding: 0 4px;
      display: inline-flex;
    `);
const $8b1c79cc1edb35f9$var$CloseIconButton = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $481f0e286e6dd560$export$c25acd513dcc8062))(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      grid-column: 2 / 3;
      grid-row: 1 / 2;

      color: ${theme.color.fg.muted};

      &:hover {
        color: ${theme.color.fg.default};
      }
    `);









var $e214298c0491f284$exports = {};
"use strict";
Object.defineProperty($e214298c0491f284$exports, "__esModule", {
    value: true
});


var $2gcPZ = parcelRequire("2gcPZ");

var $e214298c0491f284$var$useIsomorphicLayoutEffect_1 = $1737cdc3dafde60c$export$da59b14a69baef04((parcelRequire("lkU6W")));

var $bBRhx = parcelRequire("bBRhx");
var $e214298c0491f284$var$defaultState = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
};
function $e214298c0491f284$var$useMeasure() {
    var _a = $2gcPZ.useState(null), element = _a[0], ref = _a[1];
    var _b = $2gcPZ.useState($e214298c0491f284$var$defaultState), rect = _b[0], setRect = _b[1];
    var observer = $2gcPZ.useMemo(function() {
        return new window.ResizeObserver(function(entries) {
            if (entries[0]) {
                var _a = entries[0].contentRect, x = _a.x, y = _a.y, width = _a.width, height = _a.height, top_1 = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
                setRect({
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    top: top_1,
                    left: left,
                    bottom: bottom,
                    right: right
                });
            }
        });
    }, []);
    $e214298c0491f284$var$useIsomorphicLayoutEffect_1.default(function() {
        if (!element) return;
        observer.observe(element);
        return function() {
            observer.disconnect();
        };
    }, [
        element
    ]);
    return [
        ref,
        rect
    ];
}
$e214298c0491f284$exports.default = $bBRhx.isBrowser && typeof window.ResizeObserver !== "undefined" ? $e214298c0491f284$var$useMeasure : function() {
    return [
        $bBRhx.noop,
        $e214298c0491f284$var$defaultState
    ];
};








const $32b50711bc3b44b1$export$5e6c98af75122bce = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).section(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      border-radius: 12px;
      border: 1px solid ${theme.color.border.muted};
      background: ${theme.color.bg.subtle};
      padding: 16px;
      display: flex;
      flex-direction: column;
      gap: 16px;

      ${theme.media.md`
        padding: 12px;
      `}
    `);
const $32b50711bc3b44b1$export$88971ae2a7c8105b = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).header(()=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: max-content;
    `);
const $32b50711bc3b44b1$export$687e2cc77973f2ea = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).h4(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      display: inline-block;
      color: ${theme.color.fg.default};
      font: ${theme.font.headings.h4};
    `);
const $32b50711bc3b44b1$export$59a72c4d04e3e80d = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).span(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      display: grid;
      gap: ${theme.radius.rounded};
      color: ${theme.color.fg.muted};
      font: ${theme.font.body.sm.regular};
      line-height: 20px; /* 166.667% */
    `);
const $32b50711bc3b44b1$export$6da6b3c99ae248a4 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $e7b98158099ae00d$export$a6c7ac8248d6e38a))(({ theme: theme, $isOnTarget: $isOnTarget })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      width: max-content;
      color: ${$isOnTarget ? theme.color.fg.success : theme.color.fg.danger};

      font-family: Inter;
      font-size: 40px;
      font-style: normal;
      font-weight: 400;
      line-height: 48px; /* 120% */
    `);



function $fd8a96d268088271$export$1c2a9cf14598d0b4() {
    const { timeRange: timeRange } = (0, $326a17b5958d0a0c$export$43bf3df9dfee3ce5)();
    const { result: activeAlertsQuery } = (0, $b2eefb481d1eb013$export$95660c0b89f783ad)(timeRange);
    const alertsFiring = activeAlertsQuery.data?.filter((x)=>x.labels.state === "firing").length ?? 0;
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($fd8a96d268088271$var$AlertsFiringSection, {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $32b50711bc3b44b1$export$88971ae2a7c8105b), {
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $32b50711bc3b44b1$export$687e2cc77973f2ea), {
                    children: "Alerts firing"
                })
            }),
            activeAlertsQuery.isFetching ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $030f7a5c323de541$export$8f31e4c4a37b8e9c), {}) : /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $32b50711bc3b44b1$export$59a72c4d04e3e80d), {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $32b50711bc3b44b1$export$6da6b3c99ae248a4), {
                        $isOnTarget: alertsFiring === 0,
                        to: "/alerts",
                        children: alertsFiring
                    }),
                    "in selected time range"
                ]
            })
        ]
    });
}
const $fd8a96d268088271$var$AlertsFiringSection = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $32b50711bc3b44b1$export$5e6c98af75122bce))(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      ${theme.media.md`
        padding: 24px;

        ${0, $32b50711bc3b44b1$export$88971ae2a7c8105b} {
          margin-bottom: auto;
        }

        grid-column: 7 / 9;
        grid-row: 2 / 3;
      `}
    `);












const $12fbf53a840302bb$var$EMPTY_SLO_LIST = [];
function $12fbf53a840302bb$export$62031d6d7d3bea8f() {
    const instance = (0, $1a280fbaa3fcabb5$export$2105062e25df4afe)((0, $14bbd07b3011052f$export$919b3065fd27c3a8));
    const { timeRange: timeRange } = (0, $326a17b5958d0a0c$export$43bf3df9dfee3ce5)();
    const { data: data = $12fbf53a840302bb$var$EMPTY_SLO_LIST, isFetching: isFetching } = (0, $81accdab4a22bb8e$export$117f4f94ea08f791)({
        environmentUrl: instance?.url,
        start: timeRange.from,
        end: timeRange.to
    }, {
        skip: !instance?.url
    });
    const slosOffTarget = data.filter((objective)=>(0, $18c515912ab80737$export$76dcc15228d30015)(objective, objective.currentValue)).length;
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($12fbf53a840302bb$var$SlosOffTargetSection, {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $32b50711bc3b44b1$export$88971ae2a7c8105b), {
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $32b50711bc3b44b1$export$687e2cc77973f2ea), {
                    children: "SLOs off target"
                })
            }),
            isFetching ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $030f7a5c323de541$export$8f31e4c4a37b8e9c), {}) : /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $32b50711bc3b44b1$export$59a72c4d04e3e80d), {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $32b50711bc3b44b1$export$6da6b3c99ae248a4), {
                        $isOnTarget: slosOffTarget === 0,
                        to: "/slos",
                        children: slosOffTarget
                    }),
                    "in selected time range"
                ]
            })
        ]
    });
}
const $12fbf53a840302bb$var$SlosOffTargetSection = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $32b50711bc3b44b1$export$5e6c98af75122bce))(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      ${theme.media.md`
        padding: 24px;

        grid-column: 7 / 9;
        grid-row: 3 / 4;
      `}
    `);






const $92a8a5c7385d6eeb$export$4d188ac49c556325 = [
    {
        type: "tutorial",
        title: "Deploying a monitoring stack on Render",
        description: "The case for pushing metrics rather than scraping and a blueprint combining OpenTelemetry collector with Prometheus",
        date: "Oct 30, 2023",
        url: "https://autometrics.dev/blog/deploying-a-monitoring-stack-on-render"
    },
    {
        type: "news",
        title: "Announcing the Call Graph",
        description: "Introducing Call Graph visualization to get better, trace-like insights simply with granular metrics.",
        date: "Oct 24, 2023",
        url: "https://autometrics.dev/blog/announcing-the-call-graph"
    },
    {
        type: "blogPost",
        title: "Zero-config Grafana dashboards for application metrics",
        description: "A guide on how to use the preconfigured Grafana dashboards with Autometrics",
        date: "Sep 29, 2023",
        url: "https://autometrics.dev/blog/zero-config-grafana-dashboards-for-application-metrics"
    },
    {
        type: "blogPost",
        title: "The road to 1.0",
        description: "This blog post describes our plans to get the autometrics spec to version 1.0",
        date: "Sep 21, 2023",
        url: "https://autometrics.dev/blog/the-road-to-1-0"
    },
    {
        type: "tutorial",
        title: "Better monitoring insights into your applications running on Railway",
        description: "A tutorial how to add Autometrics to applications running on Railway to gain better perfomance insights and enable a better debugging flow",
        date: "Sep 15, 2023",
        url: "https://autometrics.dev/blog/better-monitoring-insights-into-your-applications-running-on-railway"
    },
    {
        type: "blogPost",
        title: "August in Autometrics",
        description: "Autometrics Explorer, SLO Guide, new library features, and events",
        date: "Sep 1, 2023",
        url: "https://autometrics.dev/blog/august-in-autometrics"
    },
    {
        type: "news",
        title: "Announcing the Autometrics Explorer an opinionated UI for Prometheus metrics",
        description: "The Autometrics Explorer is a developer-friendly UI to visualize Prometheus data and quickly go from alert to misbehaving function facilitating a faster debugging feedback loop.",
        date: "Aug 17, 2023",
        url: "https://autometrics.dev/blog/announcing-the-autometrics-explorer-a-clear-and-contextual-ui-for-prometheus-metrics"
    }
];


function $df701f627bdf4d2e$export$6d249dc6e577fe66({ graphHeight: graphHeight }) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($df701f627bdf4d2e$var$LatestNewsSection, {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $32b50711bc3b44b1$export$88971ae2a7c8105b), {
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $32b50711bc3b44b1$export$687e2cc77973f2ea), {
                    children: "Latest news"
                })
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($df701f627bdf4d2e$var$DashboardNewsList, {
                graphHeight: graphHeight,
                children: (0, $92a8a5c7385d6eeb$export$4d188ac49c556325).map((newsItem)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($df701f627bdf4d2e$var$NewsItemComponent, {
                        newsItem: newsItem
                    }, newsItem.url))
            })
        ]
    });
}
function $df701f627bdf4d2e$var$NewsItemComponent({ newsItem: newsItem }) {
    const { icon: LinkOutIcon, startAnimation: startAnimation, animateToInitial: animateToInitial } = (0, $cf5557e4cde6a3c7$export$362afcc43006a410)("link_out");
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($df701f627bdf4d2e$var$DashboardNewsItem, {
        href: newsItem.url,
        target: "_blank",
        onMouseEnter: startAnimation,
        onMouseLeave: animateToInitial,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($df701f627bdf4d2e$var$DashboardNewsItemHeader, {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($df701f627bdf4d2e$var$DashboardNewsItemType, {
                        type: newsItem.type,
                        children: $df701f627bdf4d2e$var$getNewsTypeLabel(newsItem.type)
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)(LinkOutIcon, {
                        width: 16,
                        height: 16
                    })
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($df701f627bdf4d2e$var$DashboardNewsItemTitle, {
                        children: newsItem.title
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($df701f627bdf4d2e$var$DashboardNewsItemDescription, {
                        children: newsItem.description
                    })
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($df701f627bdf4d2e$var$DashboardNewsItemDate, {
                children: newsItem.date
            })
        ]
    }, newsItem.title);
}
function $df701f627bdf4d2e$var$getTypeColor(type, theme) {
    switch(type){
        case "changelog":
            return theme.color.fg.accent[1];
        case "tutorial":
            return theme.color.fg.warning;
        case "news":
            return theme.color.fg.accent[3];
        case "blogPost":
            return theme.color.fg.primary;
    }
}
function $df701f627bdf4d2e$var$getNewsTypeLabel(type) {
    return `${type.substring(0, 1).toUpperCase()}${type.substring(1).toLowerCase()}`;
}
const $df701f627bdf4d2e$var$LatestNewsSection = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $32b50711bc3b44b1$export$5e6c98af75122bce))(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      align-items: flex-start;
      min-height: 400px;

      ${0, $32b50711bc3b44b1$export$88971ae2a7c8105b} {
        padding: 12px;
      }

      ${theme.media.md`
        grid-column: 6 / 9;
        grid-row: 1 / 2;
      `}
    `);
const $df701f627bdf4d2e$var$DashboardNewsList = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ graphHeight: graphHeight, theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      flex: 1 0 auto;
      display: flex;
      flex-direction: column;
      gap: 4px;
      overflow-y: auto;
      max-height: auto;

      ${theme.media.md`
        max-height: ${graphHeight}px;
      `}
    `);
const $df701f627bdf4d2e$var$DashboardNewsItem = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).a(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      display: flex;
      flex-direction: column;
      padding: 12px;
      color: inherit;
      border-radius: ${theme.radius.default};
      gap: 4px;

      ${$df701f627bdf4d2e$var$DashboardNewsItemHeader} svg {
        opacity: 0;
      }

      &:hover {
        background: ${theme.color.bg.hover};

        ${$df701f627bdf4d2e$var$DashboardNewsItemHeader} svg {
          opacity: 1;
        }
      }
    `);
const $df701f627bdf4d2e$var$DashboardNewsItemHeader = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).header`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const $df701f627bdf4d2e$var$DashboardNewsItemType = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).span(({ theme: theme, type: type })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      color: ${$df701f627bdf4d2e$var$getTypeColor(type, theme)};
      font-family: Inter;
      font-size: 10px;
      font-style: normal;
      font-weight: 600;
      line-height: 16px; /* 160% */
      letter-spacing: 0.6px;
      text-transform: uppercase;
    `);
const $df701f627bdf4d2e$var$DashboardNewsItemTitle = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).h1(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      color: var(--color-fg-default, #000);
      font: ${theme.font.headings.h4};
    `);
const $df701f627bdf4d2e$var$DashboardNewsItemDescription = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).p(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      color: var(--color-fg-default, #000);
      font: ${theme.font.body.sm.regular};
    `);
const $df701f627bdf4d2e$var$DashboardNewsItemDate = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).span(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      color: var(--color-fg-muted, #8c898f);
      font: ${theme.font.body.xs.regular};
    `);





var $2gcPZ = parcelRequire("2gcPZ");














const $516e6fe86434d658$var$EMPTY_TIMESERIES_DATA = [];
const $516e6fe86434d658$export$8172226d95732d40 = /*#__PURE__*/ (0, $2gcPZ.forwardRef)(function FunctionPerformance(_props, graphContainerRef) {
    const { timeRange: timeRange } = (0, $326a17b5958d0a0c$export$43bf3df9dfee3ce5)();
    const [metricType, setMetricType] = (0, $2gcPZ.useState)("requestRate");
    const tickFormattersFactory = (0, $2gcPZ.useMemo)(()=>(xAxis, yAxis)=>({
                xFormatter: (0, $97bfc4b4004b00d4$export$22e93c2cab313942)(xAxis),
                yFormatter: metricType === "latency" ? (0, $97bfc4b4004b00d4$export$7f424ebfd113e8ae)(yAxis) : metricType === "errorRatio" ? (0, $97bfc4b4004b00d4$export$f4ad2fa17edf39d7)() : (0, $97bfc4b4004b00d4$export$9bc9750a5e6705d)(yAxis)
            }), [
        metricType
    ]);
    const graphTheme = (0, $583285e3aa4c16bf$export$5cc0dd04debd4b19)(metricType);
    const { data: timeseriesData = $516e6fe86434d658$var$EMPTY_TIMESERIES_DATA, isFetching: isFetching } = $516e6fe86434d658$var$useTimeseriesDataByMetricType(metricType);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($516e6fe86434d658$var$FunctionPerformanceSection, {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $32b50711bc3b44b1$export$88971ae2a7c8105b), {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $32b50711bc3b44b1$export$687e2cc77973f2ea), {
                        children: "Top 5 functions"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($516e6fe86434d658$var$FunctionPerformanceTabList, {
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($516e6fe86434d658$var$FunctionPerformanceTab, {
                                isActive: metricType === "requestRate",
                                onClick: ()=>setMetricType("requestRate"),
                                children: "Request rate"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($516e6fe86434d658$var$FunctionPerformanceTab, {
                                isActive: metricType === "errorRatio",
                                onClick: ()=>setMetricType("errorRatio"),
                                children: "Error rate"
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($516e6fe86434d658$var$FunctionPerformanceTab, {
                                isActive: metricType === "latency",
                                onClick: ()=>setMetricType("latency"),
                                children: "Latency"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($516e6fe86434d658$var$GraphContainer, {
                ref: graphContainerRef,
                children: isFetching ? /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($516e6fe86434d658$var$SkeletonGraph, {}) : /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($516e6fe86434d658$var$MetricsChartContainer, {
                    children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $97bfc4b4004b00d4$export$f4cb11be864d0ce5), {
                        chartTheme: graphTheme,
                        tickFormatters: tickFormattersFactory,
                        timeRange: timeRange,
                        graphType: "line",
                        stackingType: "none",
                        timeseriesData: timeseriesData,
                        footerShown: false,
                        showTooltip: (anchor, [series, point])=>{
                            if (point) return (0, $c41f178228bd3003$export$635e15bbd66f01ea)((0, $6287c72d1ca35f8e$export$dba11b50e1aa3c12)(anchor, /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $b7b57423e9554b4f$export$1190a21963505760), {
                                content: [
                                    series,
                                    point
                                ]
                            }), {
                                placement: "top"
                            }));
                            return 0, $93a274dd46b4c3ff$export$8793edee2d425525;
                        }
                    })
                })
            })
        ]
    });
});
function $516e6fe86434d658$var$useTimeseriesDataByMetricType(metricType) {
    const instance = (0, $1a280fbaa3fcabb5$export$2105062e25df4afe)((0, $14bbd07b3011052f$export$919b3065fd27c3a8));
    const { timeRange: timeRange } = (0, $326a17b5958d0a0c$export$43bf3df9dfee3ce5)();
    const { buildInfoInterval: buildInfoInterval, shouldWaitForBuildInfoInterval: shouldWaitForBuildInfoInterval } = (0, $ebef9a37eb84c991$export$1fe69f4501914576)(instance?.url);
    const query = $516e6fe86434d658$var$getQueryByMetricType(metricType, buildInfoInterval);
    const { data: data, ...rangeQuery } = (0, $5755db105caee352$export$c386b48e92fd4ce1)({
        environmentUrl: instance?.url,
        query: query,
        start: timeRange.from,
        end: timeRange.to
    }, {
        // NOTE - This allows us to refetch data when the time range changes
        refetchOnMountOrArgChange: true,
        // HACK - to prevent double-queries, we skip the query if we haven't determined the scrape interval yet
        skip: shouldWaitForBuildInfoInterval
    });
    // topk(n, ...) returns the top N per timestamp, so we need to grab the top 5 from those
    const top5Data = (0, $2gcPZ.useMemo)(()=>{
        if (data) return (0, $9f9f23ebe544ac69$export$b035e44d7bb4278f)([
            ...data
        ], ({ metrics: metrics })=>{
            const sorted = (0, $9f9f23ebe544ac69$export$b035e44d7bb4278f)([
                ...metrics
            ], ({ value: value })=>value, true);
            return sorted[0]?.value ?? 0;
        }, true).slice(0, 5);
        return data;
    }, [
        data
    ]);
    return {
        ...rangeQuery,
        data: top5Data
    };
}
function $516e6fe86434d658$var$getQueryByMetricType(metricType, buildInfoInterval) {
    switch(metricType){
        case "errorRatio":
            return (0, $097bfc2d1913d58c$exports).createTop5FunctionErrorRateQuery({
                buildInfoInterval: buildInfoInterval
            });
        case "latency":
            return (0, $097bfc2d1913d58c$exports).createTop5FunctionLatencyQuery({
                buildInfoInterval: buildInfoInterval
            });
        case "requestRate":
            return (0, $097bfc2d1913d58c$exports).createTop5FunctionRequestRateQuery({
                buildInfoInterval: buildInfoInterval
            });
    }
}
const $516e6fe86434d658$var$FunctionPerformanceSection = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $32b50711bc3b44b1$export$5e6c98af75122bce))(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      padding: 24px;

      ${0, $32b50711bc3b44b1$export$88971ae2a7c8105b} {
        align-items: flex-start;
      }

      ${theme.media.md`
        grid-column: 1 / 6;
        grid-row: 1 / 2;
      `}
    `);
const $516e6fe86434d658$var$FunctionPerformanceTabList = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $206fa7d93be79d44$export$e51a686c67fdaa2d))(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      background: ${theme.color.bg.default};
      gap: 4px;
    `);
const $516e6fe86434d658$var$FunctionPerformanceTab = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $206fa7d93be79d44$export$3e41faf802a29e71))(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      padding: 6px 4px;
      border-radius: ${theme.radius.rounded};
      font: ${theme.font.buttons.sm};

      &[aria-selected="true"] {
        background: ${theme.color.bg.emphasis.primary};
        color: ${theme.color.fg.onemphasis.default};
      }
    `);
const $516e6fe86434d658$var$GraphContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      display: flex;
      height: 100%;

      ${theme.media.md`
        min-height: 580px;
      `}

      ${theme.media.lg`
        min-height: 520px;
      `}
    `);
const $516e6fe86434d658$var$SkeletonGraph = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $030f7a5c323de541$export$8f31e4c4a37b8e9c))`
  flex: 1;
`;
const $516e6fe86434d658$var$MetricsChartContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  flex: 1;
`;

















var $2gcPZ = parcelRequire("2gcPZ");
const $121c8a5b19cab889$export$bf6274e6066ada70 = 32;
const $121c8a5b19cab889$export$d3cda41e44a6352b = 4;
const $121c8a5b19cab889$export$52f1b867fc81203 = 60;
const $121c8a5b19cab889$export$97813bbee732bfad = 246;





var $2gcPZ = parcelRequire("2gcPZ");


function $92058730d081d907$export$124968f85c092b4(data, stepSize) {
    const blocks = [];
    let lastTime;
    let startTime;
    for (const metric of data.metrics){
        const time = (0, $89bcf338a8e6a1c2$export$5949043e4444048)(metric.time);
        const value = metric.value;
        if (value === 1 && (!lastTime || time < lastTime + 1.5 * stepSize)) {
            if (startTime === undefined) startTime = time;
            lastTime = time;
        } else if (startTime && lastTime) {
            blocks.push({
                start: startTime,
                end: lastTime
            });
            startTime = undefined;
            lastTime = undefined;
        }
    }
    if (startTime && lastTime) blocks.push({
        start: startTime,
        end: lastTime
    });
    return blocks;
}
function $92058730d081d907$export$957d7daebd899f12(timeseries) {
    return `${timeseries.labels.severity} ${timeseries.labels.objective_name || timeseries.labels.alertname}`;
}











function $6b17bc1214379746$export$90dfdf55197eab9e({ state: state }) {
    const theme = (0, $4e8e6ea7d6e48c37$export$93d4e7f90805808f)();
    if (state === "inactive") return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $6a24c97863e3e2ed$export$2a5819cd7a2ca075), {
        color: theme.color.neutral[400],
        children: "Inactive"
    });
    if (state === "firing") return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $6a24c97863e3e2ed$export$2a5819cd7a2ca075), {
        color: theme.color.fg.danger,
        children: "Firing"
    });
    return null;
}



const $16c380f502305cb1$export$42a852a2b6b56249 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    display: grid;
    gap: ${theme.spacing.xs};
  `);
const $16c380f502305cb1$export$b5738e83c092973d = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    display: grid;
    gap: ${theme.spacing.xs};
  `);
const $16c380f502305cb1$export$5f1af8db9871e1d6 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    font: ${theme.font.body.sm.medium};
  `);


function $70ae28fff5aace86$export$c894de9875f34792(props) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $16c380f502305cb1$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $16c380f502305cb1$export$b5738e83c092973d), {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $6b17bc1214379746$export$90dfdf55197eab9e), {
                            state: props.state
                        })
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $16c380f502305cb1$export$5f1af8db9871e1d6), {
                        children: props.name
                    })
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($70ae28fff5aace86$var$Time, {
                children: [
                    props.from,
                    " - ",
                    props.to
                ]
            })
        ]
    });
}
const $70ae28fff5aace86$var$Time = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    font: ${theme.font.body.md.regular};
    color: ${theme.color.fg.onemphasis.subtle};
  `);





function $41e051a0d4a74e06$export$88204a09bcf12e49(props) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $16c380f502305cb1$export$42a852a2b6b56249), {
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $16c380f502305cb1$export$b5738e83c092973d), {
            children: [
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($41e051a0d4a74e06$var$Hint, {
                    children: "Open in alerts view"
                }),
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("table", {
                    children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("tbody", {
                        children: Object.entries(props.labels).map(([key, value])=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($41e051a0d4a74e06$var$Td, {
                                        children: [
                                            key,
                                            ":"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($41e051a0d4a74e06$var$Td, {
                                        children: value
                                    })
                                ]
                            }, key))
                    })
                })
            ]
        })
    });
}
const $41e051a0d4a74e06$var$Hint = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  text-align: center;
`;
const $41e051a0d4a74e06$var$Td = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).td(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    padding: 0 ${theme.spacing.xxs};
  `);






function $02c8628e02d1d8bf$export$d96a8827a60d6b69(props) {
    const { navigateToAlert: navigateToAlert, x: x, width: width, data: data, start: start, end: end, showTooltip: showTooltip, stepSize: stepSize } = props;
    const from = (0, $89bcf338a8e6a1c2$export$63e62e07a20d7b8c)(start);
    const to = (0, $89bcf338a8e6a1c2$export$63e62e07a20d7b8c)(end);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($02c8628e02d1d8bf$var$Content, {
        style: {
            transform: `translateX(${x}px)`,
            width: width
        },
        onClick: ()=>{
            const options = end - start > 0 ? {
                from: from,
                to: to
            } : {
                from: (0, $89bcf338a8e6a1c2$export$63e62e07a20d7b8c)(start - 0.5 * stepSize),
                to: (0, $89bcf338a8e6a1c2$export$63e62e07a20d7b8c)(end + 0.5 * stepSize)
            };
            navigateToAlert(options);
        },
        onMouseOver: (event)=>{
            const { currentTarget: target } = event;
            const anchor = ()=>target;
            const content = ()=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $70ae28fff5aace86$export$c894de9875f34792), {
                    state: "firing",
                    name: (0, $92058730d081d907$export$957d7daebd899f12)(data),
                    from: from,
                    to: to
                });
            const options = {
                placement: (0, $2e779885e521706c$export$1e95b668f3b82d)
            };
            showTooltip({
                anchor: anchor,
                content: content,
                options: options
            });
        },
        onMouseLeave: ()=>{
            showTooltip(null);
        },
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($02c8628e02d1d8bf$var$BlockText, {
            children: "Firing"
        })
    });
}
const $02c8628e02d1d8bf$var$Content = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    display: flex;
    position: absolute;
    height: ${0, $121c8a5b19cab889$export$bf6274e6066ada70}px;
    border-radius: ${theme.radius.default};
    background: ${theme.color.timeline.firing.bg.default};
    color: ${theme.color.timeline.firing.fg};
    font: ${theme.font.headings.h6};
    overflow: hidden;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &:hover {
      background: ${theme.color.timeline.firing.bg.hover};
    }
  `);
const $02c8628e02d1d8bf$var$BlockText = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  flex: 0 0 max-content;
  width: 100%;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 4px;
`;




var $2gcPZ = parcelRequire("2gcPZ");


function $90bb9dde9e7aeef1$export$78698ae1a412a1ed({ width: width, height: height, mouseInteraction: mouseInteraction, from: from, to: to }) {
    const scales = (0, $97bfc4b4004b00d4$export$f6e7a46ff0d0d51a)({
        xMax: width,
        yMax: height
    }, mouseInteraction);
    const axis = (0, $2gcPZ.useMemo)(()=>(0, $97bfc4b4004b00d4$export$20bdbc6e30fb5614)({
            from: from,
            to: to
        }), [
        from,
        to
    ]);
    const ticks = (0, $2gcPZ.useMemo)(()=>{
        const numberOfTicks = Math.min(12, Math.floor(width / (0, $121c8a5b19cab889$export$52f1b867fc81203)));
        return (0, $97bfc4b4004b00d4$export$3d27d42b1034de5c)(axis, width, scales.xScale, numberOfTicks, (0, $97bfc4b4004b00d4$export$305ab1245db5f1fa));
    }, [
        axis,
        width,
        scales.xScale
    ]);
    const formatter = (0, $2gcPZ.useMemo)(()=>(0, $97bfc4b4004b00d4$export$22e93c2cab313942)(axis), [
        axis
    ]);
    const getX = (0, $cac150ebb620e91f$export$d095b0c879743c0d)((value)=>scales.xScale((value - axis.minValue) / (axis.maxValue - axis.minValue)));
    return {
        ticks: ticks,
        formatter: formatter,
        axis: axis,
        getX: getX
    };
}




function $9b8fcb2cbe98e323$export$c43f26fb91dad547(index) {
    const navigate = (0, $efeb47d767416279$export$9770f232ac06a008)();
    const [currentSearchParams] = (0, $e7b98158099ae00d$export$f1a78c17382fe22a)();
    return (newTimeRange)=>{
        const updatedSearchParams = new URLSearchParams(currentSearchParams);
        updatedSearchParams.set("expanded", index.toString());
        if (newTimeRange) (0, $89bcf338a8e6a1c2$export$2065733108560294)(updatedSearchParams, newTimeRange);
        navigate({
            pathname: "/alerts",
            search: updatedSearchParams.toString()
        });
    };
}




function $03251853ad3494db$export$a8433d4c0960bb9({ data: data, stepSize: stepSize, getX: getX, index: matchingIndex, maxWidth: maxWidth, showTooltip: showTooltip }) {
    const navigateToAlert = (0, $9b8fcb2cbe98e323$export$c43f26fb91dad547)(matchingIndex);
    const blocks = (0, $92058730d081d907$export$124968f85c092b4)(data, stepSize);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $afa7be861492543f$exports.Fragment), {
        children: blocks.map((block, index)=>{
            const x = Math.max(getX(block.start) - 4, 0);
            const width = Math.min(getX(block.end) - x + 4, maxWidth);
            return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $02c8628e02d1d8bf$export$d96a8827a60d6b69), {
                data: data,
                navigateToAlert: navigateToAlert,
                x: x,
                width: width,
                showTooltip: showTooltip,
                stepSize: stepSize,
                ...block
            }, index);
        })
    });
}



const $9d693f37a6f416a6$export$614db49f3febe941 = /*#__PURE__*/ (0, $2gcPZ.memo)(function Graph(props) {
    const { height: height, width: width, ticks: ticks, data: data, stepSize: stepSize, getX: getX, showTooltip: showTooltip } = props;
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($9d693f37a6f416a6$var$Container, {
        style: {
            width: width,
            height: height
        },
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($9d693f37a6f416a6$var$Background, {
                "data-id": "background"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("div", {
                "data-id": "lines",
                children: ticks.map((tick)=>{
                    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($9d693f37a6f416a6$var$Line, {
                        style: {
                            transform: `translateX(${props.getX(tick)}px)`
                        }
                    }, tick);
                })
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("div", {
                "data-id": "graph-elements",
                children: data.map(({ alert: timeseries, matchingIndex: matchingIndex }, index)=>{
                    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("div", {
                        style: {
                            position: "absolute",
                            transform: `translateY(${index * ((0, $121c8a5b19cab889$export$bf6274e6066ada70) + (0, $121c8a5b19cab889$export$d3cda41e44a6352b) + (0, $121c8a5b19cab889$export$d3cda41e44a6352b)) + (0, $121c8a5b19cab889$export$d3cda41e44a6352b)}px)`
                        },
                        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $03251853ad3494db$export$a8433d4c0960bb9), {
                            data: timeseries,
                            stepSize: stepSize,
                            getX: getX,
                            maxWidth: width,
                            showTooltip: showTooltip,
                            index: matchingIndex
                        })
                    }, index);
                })
            })
        ]
    });
});
const $9d693f37a6f416a6$var$Container = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  position: relative;
  max-width: 100%;
`;
const $9d693f37a6f416a6$var$Background = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    position: absolute;
    background: repeating-linear-gradient(
      -47.87deg,
      transparent 3.5px,
      ${theme.color.border.muted} 3.5px,
      ${theme.color.border.muted} 4.5px,
      transparent 4.5px,
      transparent 8px
    );
    width: 100%;
    height: 100%;
  `);
const $9d693f37a6f416a6$var$Line = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    position: absolute;
    height: 100%;
    width: 1px;
    background: ${theme.color.border.default};
  `);












function $e6ce84e25ae744ae$export$dcfb49240088e87f(props) {
    const navigateToAlert = (0, $9b8fcb2cbe98e323$export$c43f26fb91dad547)(props.index);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($e6ce84e25ae744ae$var$LabelContent, {
        onClick: ()=>navigateToAlert(),
        onMouseOver: (event)=>{
            const { currentTarget: target } = event;
            const anchor = ()=>target;
            const content = ()=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $41e051a0d4a74e06$export$88204a09bcf12e49), {
                    labels: props.labels
                });
            const options = {
                placement: (0, $2e779885e521706c$export$1e95b668f3b82d)
            };
            props.showTooltip({
                anchor: anchor,
                content: content,
                options: options
            });
        },
        onMouseLeave: ()=>{
            props.showTooltip(null);
        },
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($e6ce84e25ae744ae$var$Text, {
            children: (0, $92058730d081d907$export$957d7daebd899f12)(props)
        })
    }, props.index);
}
const $e6ce84e25ae744ae$var$LabelContent = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    &::before {
      content: "";
      height: 40px;
      position: absolute;
      width: 100%;
      left: 0;
    }

    &:hover::before {
      background: ${theme.color.bg.hover};
    }
  `);
const $e6ce84e25ae744ae$var$Text = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    position: relative;
    font: ${theme.font.body.sm.medium};
    padding: 10px 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    border-radius: 0 ${theme.radius.default} ${theme.radius.default} 0;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  `);


function $144c9e99b3905147$export$c9ed62821215deda(props) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("div", {
        children: props.data.map(({ alert: timeseries, matchingIndex: matchingIndex }, index)=>{
            return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $e6ce84e25ae744ae$export$dcfb49240088e87f), {
                labels: timeseries.labels,
                index: matchingIndex,
                showTooltip: props.showTooltip
            }, index);
        })
    });
}







var $2gcPZ = parcelRequire("2gcPZ");

const $cd7b7f002199ed47$export$be2d339e7ab71172 = /*#__PURE__*/ (0, $2gcPZ.memo)(function TimelineTickLabels(props) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($cd7b7f002199ed47$var$Container, {
        children: props.ticks.map((tick, index)=>{
            const x = props.getX(tick);
            if (x < (0, $121c8a5b19cab889$export$52f1b867fc81203) || x > props.width - (0, $121c8a5b19cab889$export$52f1b867fc81203)) return null;
            return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($cd7b7f002199ed47$var$Tick, {
                style: {
                    transform: `translateX(${x}px)`
                },
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($cd7b7f002199ed47$var$TickContent, {
                    children: props.formatter(tick)
                })
            }, index);
        })
    });
});
const $cd7b7f002199ed47$var$Container = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  position: relative;
`;
const $cd7b7f002199ed47$var$Tick = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  position: absolute;
`;
const $cd7b7f002199ed47$var$TickContent = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  transform: translateX(-50%);
`;





function $71c75e28f829ec3c$export$7dfe58cac16e196b({ width: width, mouseInteraction: mouseInteraction }) {
    if (mouseInteraction.type !== "zoom") return null;
    const { start: start, end: end } = mouseInteraction;
    if (end === undefined) return null;
    // The value below is in the range [0, 1]
    const x = Math.min(start, end);
    // The value below is in the range [0, 1]
    const barWidth = Math.max(start, end) - x;
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($71c75e28f829ec3c$var$Rect, {
        style: {
            left: `${x * width}px`,
            width: `${barWidth * width}px`
        }
    });
}
const $71c75e28f829ec3c$var$Rect = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    position: absolute;
    pointer-events: none;
    top: 0;
    left: 0;
    background: ${theme.color.bg.emphasis["primary-subtle"]};
    height: 100%;
    border-left: 1px dashed ${theme.color.fg.primary};
    border-right: 1px dashed ${theme.color.fg.primary};
  `);





function $104184f47b21af38$export$51ec1f4fc67ff74b(props) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $afa7be861492543f$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($104184f47b21af38$var$NowLine, {
                style: {
                    transform: `translateX(${props.x}px)`
                }
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($104184f47b21af38$var$Triangle, {
                type: "triangle_down",
                style: {
                    transform: `translateX(${-props.x}px)`
                }
            })
        ]
    });
}
const $104184f47b21af38$var$NowLine = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    width: 1px;
    border: 1px dashed ${theme.color.fg.primary};
    position: absolute;
    top: 0;
    height: 100%;
    pointer-events: none;
  `);
const $104184f47b21af38$var$Triangle = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $0a830394bc38e4e3$export$f04a61298a47a40f))(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    position: absolute;
    left: 0;
    bottom: 0;
    display: inline-block;
    color: ${theme.color.fg.primary};
    margin-left: -9px;
    pointer-events: none;
    rotate: 180deg;
  `);




function $1067b651978ea000$export$d017207e48e43e93(props) {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($1067b651978ea000$var$Label, {
        style: {
            transform: `translateX(${props.x}px)`
        },
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($1067b651978ea000$var$Content, {
            $type: props.type,
            children: props.children
        })
    });
}
const $1067b651978ea000$var$Label = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).label`
  position: absolute;
  width: max-content;
`;
const $1067b651978ea000$var$Content = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme, $type: $type })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    border-radius: 4px;
    padding: 0 4px;
    margin-left: -50%;
    width: max-content;
    ${$type === "current" ? (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
          background-color: ${theme.color.bg.emphasis.primary};
        ` : (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
          background-color: ${theme.color.bg.emphasis.default};
        `}
    color: ${theme.color.fg.onemphasis.default};
  `);






function $1d3f5ab239e36129$export$656a9bb4540e4fd4() {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($1d3f5ab239e36129$var$Container, {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($1d3f5ab239e36129$var$Title, {
                children: "No alerts in this time range"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($1d3f5ab239e36129$var$Body, {
                children: "Great news, none of your alerts are pending or firing in this time range"
            })
        ]
    });
}
const $1d3f5ab239e36129$var$Container = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  text-align: center;
`;
const $1d3f5ab239e36129$var$Title = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).h4(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    color: ${theme.color.fg.success};
  `);
const $1d3f5ab239e36129$var$Body = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    color: ${theme.color.fg.muted};
    width: 400px;
    max-width: 80%;
  `);


function $4d33d9f42e5a6c0a$export$825759012630b529({ data: data }) {
    const { timeRange: timeRange, onChangeTimeRange: onChangeTimeRange } = (0, $326a17b5958d0a0c$export$43bf3df9dfee3ce5)();
    const [ref, { width: width, height: height }] = (0, $b8b5111030e66ef0$export$2e2bcd8739ae039)();
    const interactiveControls = (0, $97bfc4b4004b00d4$export$bfb29d1974d1a373)(false);
    const { mouseInteraction: mouseInteraction, updatePressedKeys: updatePressedKeys } = interactiveControls;
    const cursor = (0, $97bfc4b4004b00d4$export$131881d04c9bef6f)(interactiveControls);
    const dimensions = {
        xMax: width,
        yMax: height
    };
    const { onMouseDown: onMouseDown, onMouseUp: onMouseUp, onWheel: onWheel, onMouseMove: onMouseMoveControls } = (0, $97bfc4b4004b00d4$export$a579f4d26b6a9c61)({
        dimensions: dimensions,
        interactiveControls: interactiveControls,
        onChangeTimeRange: onChangeTimeRange,
        timeRange: timeRange
    });
    const { formatter: formatter, ticks: ticks, getX: getX, axis: axis } = (0, $90bb9dde9e7aeef1$export$78698ae1a412a1ed)({
        from: timeRange.from,
        to: timeRange.to,
        width: width,
        height: height,
        mouseInteraction: mouseInteraction
    });
    const [current, setCurrent] = (0, $2gcPZ.useState)(null);
    const setCurrentTimeIndicator = (event)=>{
        const element = event.currentTarget || event.target;
        if (!element) return null;
        const rect = element.getBoundingClientRect();
        const fraction = (event.clientX - rect.left) / width;
        setCurrent(fraction);
    };
    const resetCurrentTimeIndicator = (event)=>{
        const { currentTarget: currentTarget, target: target } = event;
        if (target.contains(currentTarget)) return;
        setCurrent(null);
    };
    (0, $2gcPZ.useEffect)(()=>{
        const wheelListenerOptions = {
            passive: false
        };
        window.addEventListener("keydown", updatePressedKeys);
        window.addEventListener("keyup", updatePressedKeys);
        window.addEventListener("wheel", onWheel, wheelListenerOptions);
        return ()=>{
            window.removeEventListener("keydown", updatePressedKeys);
            window.removeEventListener("keyup", updatePressedKeys);
            window.removeEventListener("wheel", onWheel, wheelListenerOptions);
        };
    }, [
        onWheel,
        updatePressedKeys
    ]);
    const onMouseMove = (event)=>{
        updatePressedKeys(event);
        onMouseMoveControls(event);
        setCurrentTimeIndicator(event);
        event.preventDefault();
    };
    const stepSize = (0, $d9ef29a97e741a59$export$aa02a9ec6df7532d)(timeRange)[1];
    const closeRef = (0, $2gcPZ.useRef)(null);
    const setTooltipState = (0, $cac150ebb620e91f$export$d095b0c879743c0d)((tip)=>{
        if (tip === null) {
            closeRef.current && closeRef.current();
            closeRef.current = null;
            return;
        }
        closeRef.current = (0, $c41f178228bd3003$export$635e15bbd66f01ea)((0, $6287c72d1ca35f8e$export$dba11b50e1aa3c12)(tip.anchor(), tip.content(), tip.options));
    });
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($4d33d9f42e5a6c0a$var$SplitContainer, {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($4d33d9f42e5a6c0a$var$OverflowContainer, {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($4d33d9f42e5a6c0a$var$GraphContainer, {
                        ref: ref,
                        onMouseDown: onMouseDown,
                        onMouseUp: onMouseUp,
                        onMouseMove: onMouseMove,
                        onMouseLeave: resetCurrentTimeIndicator,
                        style: {
                            cursor: cursor
                        },
                        children: [
                            data.length === 0 && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($4d33d9f42e5a6c0a$var$EmptyContainer, {
                                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $1d3f5ab239e36129$export$656a9bb4540e4fd4), {})
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $9d693f37a6f416a6$export$614db49f3febe941), {
                                height: height,
                                width: width || 1,
                                data: data,
                                ticks: ticks,
                                getX: getX,
                                stepSize: stepSize,
                                showTooltip: setTooltipState
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $71c75e28f829ec3c$export$7dfe58cac16e196b), {
                                width: width,
                                mouseInteraction: mouseInteraction
                            }),
                            current !== null && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $104184f47b21af38$export$51ec1f4fc67ff74b), {
                                x: current * width,
                                height: Math.min((0, $121c8a5b19cab889$export$97813bbee732bfad), height)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($4d33d9f42e5a6c0a$var$LabelContainer, {
                        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $144c9e99b3905147$export$c9ed62821215deda), {
                            data: data,
                            showTooltip: setTooltipState
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($4d33d9f42e5a6c0a$var$FixedContainer, {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $cd7b7f002199ed47$export$be2d339e7ab71172), {
                        formatter: formatter,
                        getX: getX,
                        ticks: ticks,
                        width: width
                    }),
                    current !== null && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $1067b651978ea000$export$d017207e48e43e93), {
                        x: current * width,
                        type: "current",
                        children: formatter(current * (axis.maxValue - axis.minValue) + axis.minValue)
                    })
                ]
            })
        ]
    });
}
const $4d33d9f42e5a6c0a$var$SplitContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: grid;
  grid-template:
    "overflow" auto
    "fixed" 24px;
  gap: 8px;
  position: relative;
  height: 278px;
`;
const $4d33d9f42e5a6c0a$var$OverflowContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  grid-area: overflow;
  display: grid;
  grid: "graph label" auto / 1fr 218px;
  max-height: ${(0, $121c8a5b19cab889$export$97813bbee732bfad)}px;
  overflow-y: auto;
  overflow-x: hidden;
`;
const $4d33d9f42e5a6c0a$var$FixedContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  grid-area: fixed;
  grid-template-columns: auto 218px;
  position: relative;
`;
const $4d33d9f42e5a6c0a$var$GraphContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  grid-area: graph;
  min-width: 0;
  position: relative;
  overflow: hidden;
  /* This is needed to keep the graphs on top of the label hover background */
  z-index: 1;
`;
const $4d33d9f42e5a6c0a$var$LabelContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  grid-area: label;
`;
const $4d33d9f42e5a6c0a$var$EmptyContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  position: absolute;
  width: 100%;
  height: 100%;
`;




const $e4503b41c3b6255a$var$INVALID_LABELS = new Set([
    "lastseen",
    "state"
]);
function $e4503b41c3b6255a$export$4f4bca996c586084() {
    const environment = (0, $1a280fbaa3fcabb5$export$2105062e25df4afe)((0, $14bbd07b3011052f$export$919b3065fd27c3a8));
    const { timeRange: timeRange } = (0, $326a17b5958d0a0c$export$43bf3df9dfee3ce5)();
    const { data: alerts } = (0, $5755db105caee352$export$c386b48e92fd4ce1)({
        environmentUrl: environment?.url,
        query: "ALERTS",
        start: timeRange.from,
        end: timeRange.to
    });
    const { result: { data: groupedAlerts } } = (0, $b2eefb481d1eb013$export$95660c0b89f783ad)(timeRange);
    // TODO: handle loading data gracefully
    if (!alerts || !groupedAlerts) return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $b6465ff4e4132c39$export$669f6ea7d267feaf), {});
    const mappedAlerts = alerts.map((detailedAlert)=>{
        const matchingAlerts = [];
        for (const [index, alert] of groupedAlerts.entries()){
            const hasMismatchedLabel = Object.entries(alert.labels).filter(([key])=>$e4503b41c3b6255a$var$INVALID_LABELS.has(key) === false).some(([key, value])=>detailedAlert.labels[key] !== value);
            if (hasMismatchedLabel === false) matchingAlerts.push(index);
        }
        return {
            alert: detailedAlert,
            matchingIndex: matchingAlerts[0] ?? -1
        };
    });
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $4d33d9f42e5a6c0a$export$825759012630b529), {
        data: mappedAlerts
    });
}




function $41c0dfd51f98ee9b$export$fe82a520fc33e5f4() {
    const [graphContainerRef, { height: graphHeight }] = (0, (/*@__PURE__*/$parcel$interopDefault($e214298c0491f284$exports)))();
    const instance = (0, $1a280fbaa3fcabb5$export$2105062e25df4afe)((0, $14bbd07b3011052f$export$919b3065fd27c3a8));
    (0, $fe24d45de7923f97$export$95c0f256a1e9b1b2)(instance?.url, {
        refetchOnMountOrArgChange: true,
        skip: !instance?.url
    });
    if (!instance || !instance.connectionStatus || instance.connectionStatus.ping === (0, $e46c0d05a3c80666$exports.QueryStatus).rejected) return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $7f2b92de158af7af$export$5eef44829f72c6d0), {});
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($41c0dfd51f98ee9b$var$DashboardPageContainer, {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $516e6fe86434d658$export$8172226d95732d40), {
                ref: graphContainerRef
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($41c0dfd51f98ee9b$var$AlertsTimelineSection, {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $32b50711bc3b44b1$export$88971ae2a7c8105b), {
                        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $32b50711bc3b44b1$export$687e2cc77973f2ea), {
                            children: "Alerts timeline"
                        })
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $e4503b41c3b6255a$export$4f4bca996c586084), {})
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $fd8a96d268088271$export$1c2a9cf14598d0b4), {}),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $12fbf53a840302bb$export$62031d6d7d3bea8f), {}),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $df701f627bdf4d2e$export$6d249dc6e577fe66), {
                graphHeight: graphHeight
            })
        ]
    });
}
const $41c0dfd51f98ee9b$var$DashboardPageContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $747d2f1afecb66a5$export$5f86df0ee0a255b5))(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      ${theme.media.md`
        grid-template-columns: repeat(8, 1fr);
        grid-auto-rows: auto;
      `}
    `);
const $41c0dfd51f98ee9b$var$AlertsTimelineSection = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $32b50711bc3b44b1$export$5e6c98af75122bce))(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      padding: 24px;

      ${0, $32b50711bc3b44b1$export$88971ae2a7c8105b} {
        margin-bottom: auto;
      }

      ${theme.media.md`
        grid-column: 1 / 7;
        grid-row: 2 / 4;
      `}
    `);




// TODO - Implement 404
function $6bee0a7ce67ac334$var$NotFound() {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("div", {
        children: "404 - Not Found"
    });
}
const $6bee0a7ce67ac334$export$86fbec116b87613f = /*#__PURE__*/ (0, $2gcPZ.memo)(function App() {
    (0, $12f54f34ea8c6092$export$86e8e5cd689fa595)();
    (0, $bbc2cb4268a46f72$export$82d1b7ffdac7acac)();
    (0, $6863bac21e813f6e$export$47da2dfd093ff7d1)();
    (0, $edc4621501740b0b$export$e431d39521b4f177)();
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $798c5c40009ebe8a$export$c84671f46d6a1ca), {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $fce68a245efc33ac$export$24e4c25c8f3847c1), {}),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $efeb47d767416279$export$3565eb3d00ca5a74), {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $efeb47d767416279$export$e7b0ac011bb776c6), {
                        path: "/",
                        element: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a923dedecd33d9d8$export$b94310965bed44e6), {})
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $efeb47d767416279$export$e7b0ac011bb776c6), {
                        path: "/dashboard",
                        element: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $41c0dfd51f98ee9b$export$fe82a520fc33e5f4), {})
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $efeb47d767416279$export$e7b0ac011bb776c6), {
                        path: "/functions/*",
                        element: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $cb333cafab87328e$export$fd36c1ee89d6448e), {})
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $efeb47d767416279$export$e7b0ac011bb776c6), {
                        path: "/slos/*",
                        element: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $fa97a35e8d9b0fd8$export$49299131159349d6), {})
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $efeb47d767416279$export$e7b0ac011bb776c6), {
                        path: "/settings/*",
                        element: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $b265bd128a18ba04$export$c72f6eaae7b9adff), {})
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $efeb47d767416279$export$e7b0ac011bb776c6), {
                        path: "/alerts",
                        element: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $35e204dad5c20bba$export$7a76bf180c86084f), {})
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $efeb47d767416279$export$e7b0ac011bb776c6), {
                        path: "*",
                        element: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($6bee0a7ce67ac334$var$NotFound, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $8b1c79cc1edb35f9$export$8a3d3295db52f41), {}),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $4a9d80e15a452f2e$export$eef8a221e93f06b0), {})
        ]
    });
});






var $2gcPZ = parcelRequire("2gcPZ");








var $2gcPZ = parcelRequire("2gcPZ");









var $2gcPZ = parcelRequire("2gcPZ");


var $2gcPZ = parcelRequire("2gcPZ");





function $b9d3cef032e1674d$export$7a9a31a911eb9a20({ day: day, currentMonth: currentMonth, onClick: onClick, onMouseOver: onMouseOver, startParts: startParts, endParts: endParts }) {
    const dayParts = (0, $89bcf338a8e6a1c2$export$67e345da141048a6)(day);
    const isStartDay = dayParts.month === startParts.month && dayParts.date === startParts.date && dayParts.year === startParts.year;
    const isEndDay = dayParts.month === endParts.month && dayParts.date === endParts.date && dayParts.year === endParts.year;
    // You can only be between if you're not already start/end
    const isBetween = !isStartDay && !isEndDay && dayParts.timestamp > startParts.timestamp && dayParts.timestamp < endParts.timestamp;
    const className = `${isStartDay || isEndDay ? "selected" : ""} ${isBetween ? "semi-selected" : ""}`;
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($b9d3cef032e1674d$var$DateItem, {
        tabIndex: -1,
        outside: day.getMonth() !== currentMonth,
        className: className,
        onClick: (event)=>{
            (0, $0cca6883e0725c68$export$e9caaaecfee38128)(event);
            onClick(day);
        },
        onMouseOver: ()=>onMouseOver(day),
        isStartDay: isStartDay,
        isEndDay: isEndDay,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($b9d3cef032e1674d$export$4fe9184bd47dbe20, {
            children: day.getDate().toLocaleString(undefined, {
                minimumIntegerDigits: 2
            })
        })
    });
}
const $b9d3cef032e1674d$var$DateItem = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).td(({ theme: theme, outside: outside, isStartDay: isStartDay, isEndDay: isEndDay })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    text-align: center;
    cursor: pointer;
    opacity: ${outside ? "0.5" : "1.0"};

    &.selected ${$b9d3cef032e1674d$export$4fe9184bd47dbe20} {
      background-color: ${theme.color.bg.emphasis.primary};
      color: ${theme.color.fg.onemphasis.default};
    }

    &.selected + .semi-selected {
      position: relative;

      &::before {
        position: absolute;
        content: "";
        background: ${theme.color.bg.emphasis["primary-subtle"]};
        top: 0;
        bottom: 0;
        left: -10px;
        width: 10px;
        z-index: 1;
      }
    }

    &.semi-selected + .selected {
      position: relative;

      &::before {
        position: absolute;
        content: "";
        background: ${theme.color.bg.emphasis["primary-subtle"]};
        top: 0;
        bottom: 0;
        left: 0;
        width: 8px;
        z-index: 1;
      }
    }

    &.selected + .selected {
      position: relative;

      &::before {
        position: absolute;
        content: "";
        background: ${theme.color.bg.emphasis["primary-subtle"]};
        top: 0;
        bottom: 0;
        left: -8px;
        width: 16px;
        z-index: 1;
      }
    }

    &.semi-selected {
      background: ${theme.color.bg.emphasis["primary-subtle"]};
    }

    &:hover ${$b9d3cef032e1674d$export$4fe9184bd47dbe20} {
      background-color: ${theme.color.bg.emphasis.primary};
      color: ${theme.color.fg.onemphasis.default};
    }

    ${isStartDay && (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      & {
        border-top-left-radius: ${theme.radius.rounded};
        border-bottom-left-radius: ${theme.radius.rounded};
      }
    `}

    ${isEndDay && (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      & {
        border-top-right-radius: ${theme.radius.rounded};
        border-bottom-right-radius: ${theme.radius.rounded};
      }
    `}
  `);
const $b9d3cef032e1674d$export$4fe9184bd47dbe20 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).span(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    z-index: 2;
    position: sticky;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: ${theme.radius.rounded};
    width: 32px;
    height: 28px;
    line-height: 28px;
  `);




const $a39076294ab1d1fc$var$MONTHS = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
const $a39076294ab1d1fc$var$START_DAY_OFFSET = 1;
const $a39076294ab1d1fc$export$18fa4946d43f2e8c = /*#__PURE__*/ (0, $2gcPZ.memo)(function MonthTable(props) {
    // Holds the first date the user clicks
    const [selectedDate, setSelectedDate] = (0, $2gcPZ.useState)(null);
    // Holds the date which the user is hovering over
    const [hoverDate, setHoverDate] = (0, $2gcPZ.useState)(null);
    // Is used to change the currently displayed month
    const [monthOffset, setMonthOffset] = (0, $2gcPZ.useState)(0);
    // Create a new date + set it to the month we want to display (using the monthOffset)
    const offsetDate = (0, $89bcf338a8e6a1c2$export$64d33c59520c51c1)(props.startTime);
    offsetDate.setMonth(offsetDate.getMonth() + monthOffset);
    const monthTimestamp = offsetDate.toISOString();
    const currentMonth = offsetDate.getMonth();
    const year = offsetDate.getFullYear();
    // Create dates from the timestamps so we can check things like day/month/year
    const startDate = (0, $89bcf338a8e6a1c2$export$64d33c59520c51c1)(props.startTime);
    const endDate = (0, $89bcf338a8e6a1c2$export$64d33c59520c51c1)(props.endTime ?? props.startTime);
    let startParts = (0, $89bcf338a8e6a1c2$export$67e345da141048a6)(selectedDate || startDate);
    const hoverParts = hoverDate && (0, $89bcf338a8e6a1c2$export$67e345da141048a6)(hoverDate);
    // Backwards happens when a user has clicked on a date and is
    // hovering over a date that is before that one.
    const backwards = hoverParts && hoverParts.timestamp < startParts.timestamp;
    let endParts = hoverParts || (0, $89bcf338a8e6a1c2$export$67e345da141048a6)(endDate);
    // If we're in backwards mode: swap start & end
    if (backwards && hoverParts) {
        endParts = startParts;
        startParts = hoverParts;
    }
    // Create an array of weeks
    const weeks = (0, $2gcPZ.useMemo)(()=>$a39076294ab1d1fc$var$getMonthWeeks(monthTimestamp), [
        monthTimestamp
    ]);
    const onClick = (day)=>{
        // No end time, so instead of creating a range we set the start time
        if (!props.endTime) {
            props.setStartTime(day.toISOString());
            return;
        }
        if (!selectedDate) {
            setSelectedDate(day);
            setHoverDate(day);
            return;
        }
        const dayParts = (0, $89bcf338a8e6a1c2$export$67e345da141048a6)(day);
        const startDate = (0, $89bcf338a8e6a1c2$export$64d33c59520c51c1)(backwards ? dayParts.timestamp : startParts.timestamp);
        startDate.setHours(0);
        startDate.setMinutes(0);
        startDate.setSeconds(0);
        startDate.setMilliseconds(0);
        props.setStartTime(startDate.toISOString());
        if (props.setEndTime) {
            const endDate = (0, $89bcf338a8e6a1c2$export$64d33c59520c51c1)(backwards ? endParts.timestamp : dayParts.timestamp);
            endDate.setHours(23);
            endDate.setMinutes(59);
            endDate.setSeconds(59);
            endDate.setMilliseconds(999);
            props.setEndTime(endDate.toISOString());
        }
        setSelectedDate(null);
        setMonthOffset(0);
        setHoverDate(null);
    };
    const onMouseOver = (day)=>{
        if (selectedDate) setHoverDate(day);
    };
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($a39076294ab1d1fc$var$Container, {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($a39076294ab1d1fc$var$Header, {
                className: props.className,
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("h5", {
                        children: [
                            $a39076294ab1d1fc$var$MONTHS[currentMonth],
                            " ",
                            year
                        ]
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($a39076294ab1d1fc$var$Controls, {
                        children: [
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($a39076294ab1d1fc$var$IconButton, {
                                buttonStyle: "secondary",
                                onClick: ()=>setMonthOffset(monthOffset - 1),
                                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0a830394bc38e4e3$export$f04a61298a47a40f), {
                                    type: "caret_left"
                                })
                            }),
                            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($a39076294ab1d1fc$var$IconButton, {
                                buttonStyle: "secondary",
                                onClick: ()=>setMonthOffset(monthOffset + 1),
                                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0a830394bc38e4e3$export$f04a61298a47a40f), {
                                    type: "caret_right"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($a39076294ab1d1fc$var$Table, {
                role: "presentation",
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("thead", {
                        "aria-hidden": "true",
                        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("th", {
                                    children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $b9d3cef032e1674d$export$4fe9184bd47dbe20), {
                                        children: "M"
                                    })
                                }),
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("th", {
                                    children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $b9d3cef032e1674d$export$4fe9184bd47dbe20), {
                                        children: "T"
                                    })
                                }),
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("th", {
                                    children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $b9d3cef032e1674d$export$4fe9184bd47dbe20), {
                                        children: "W"
                                    })
                                }),
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("th", {
                                    children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $b9d3cef032e1674d$export$4fe9184bd47dbe20), {
                                        children: "T"
                                    })
                                }),
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("th", {
                                    children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $b9d3cef032e1674d$export$4fe9184bd47dbe20), {
                                        children: "F"
                                    })
                                }),
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("th", {
                                    children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $b9d3cef032e1674d$export$4fe9184bd47dbe20), {
                                        children: "S"
                                    })
                                }),
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("th", {
                                    children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $b9d3cef032e1674d$export$4fe9184bd47dbe20), {
                                        children: "S"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("tbody", {
                        children: weeks.map((week, index)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("tr", {
                                children: week.map((day, index)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $b9d3cef032e1674d$export$7a9a31a911eb9a20), {
                                        day: day,
                                        currentMonth: currentMonth,
                                        onClick: onClick,
                                        onMouseOver: onMouseOver,
                                        startParts: startParts,
                                        endParts: endParts
                                    }, index))
                            }, index))
                    })
                ]
            })
        ]
    });
});
function $a39076294ab1d1fc$var$getMonthWeeks(monthTimestamp) {
    const date = (0, $89bcf338a8e6a1c2$export$64d33c59520c51c1)(monthTimestamp);
    // Go to the first
    date.setDate(1);
    const dayIndex = date.getDay();
    // Calculate the number of days we need to pad at the beginning
    const startPadding = dayIndex - $a39076294ab1d1fc$var$START_DAY_OFFSET;
    // Create a date object that points to the last day
    const lastDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    // Get the number of days we're going to render at minimum
    const intermediateDayCount = lastDate.getDate() + startPadding;
    // Get the number weeks this is and round up
    const weekCount = Math.ceil(intermediateDayCount / 7);
    // Create an array with date objects
    const weeks = [];
    // move to start date/day
    date.setDate(1 - startPadding);
    // Store the date
    let day = date;
    // Repeat for the nr of weeks we want to render
    for(let weekIndex = 0; weekIndex < weekCount; weekIndex++){
        const week = [];
        // Loop until we have 7 days
        while(week.length < 7){
            week.push(day);
            day = new Date(day.getTime());
            day.setDate(day.getDate() + 1);
        }
        // Push the week to the weeks array
        weeks.push(week);
    }
    return weeks;
}
const $a39076294ab1d1fc$var$Container = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: grid;
  grid-row-gap: ${(0, $89bcf338a8e6a1c2$export$3f06d195264d0026)(20)};
`;
const $a39076294ab1d1fc$var$Header = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const $a39076294ab1d1fc$var$Controls = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 4px;
`;
const $a39076294ab1d1fc$var$Table = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).table(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    border-collapse: collapse;
    font-size: inherit;

    thead {
      font: ${theme.font.body.sm.medium};
      color: ${theme.color.fg.subtle};
    }

    tbody {
      display: flex;
      flex-direction: column;
      grid-row-gap: 4px;
    }

    tr {
      display: flex;
    }

    th,
    td {
      display: inline-block;
      text-transform: uppercase;
      text-align: center;
      font: ${theme.font.body.sm.regular};
      padding: 0;
    }

    th {
      color: var(--vscode-editorHoverWidget-foreground);
    }
  `);
const $a39076294ab1d1fc$var$IconButton = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $a921dfdbd8dd60fa$export$353f5b6fc5456de1))`
  padding: 0;
`;




var $2gcPZ = parcelRequire("2gcPZ");



function $8ee77f7511e4c7ae$export$ab52eb04dacab641(props) {
    const { from: from, to: to, onChange: onChange, updateDraftFrom: updateDraftFrom, updateDraftTo: updateDraftTo } = props;
    const fromRef = $2gcPZ.useRef(null);
    const toRef = $2gcPZ.useRef(null);
    const [fromError, setFromError] = $2gcPZ.useState();
    const [toError, setToError] = $2gcPZ.useState();
    const [globalError, setGlobalError] = $2gcPZ.useState();
    const handleSubmit = (event)=>{
        event.preventDefault();
        // Refs shouldn't be null, but it they are there isn't much to validate
        if (!fromRef.current || !toRef.current) return;
        const { errors: errors, values: values } = (0, $89bcf338a8e6a1c2$export$832e640e210af61e)({
            from: fromRef.current.value,
            to: toRef.current.value
        });
        const hasErrors = Object.values(errors).findIndex((value)=>!!value) !== -1;
        // Update state
        setFromError(errors.from);
        setToError(errors.to);
        setGlobalError(errors.global);
        if (hasErrors) return false;
        onChange(values);
    };
    $2gcPZ.useLayoutEffect(()=>{
        fromRef.current?.focus();
    }, [
        fromRef
    ]);
    const handler = (event)=>{
        if (event.target !== fromRef.current && event.target !== toRef.current) return;
        if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
        event.stopPropagation();
    };
    $2gcPZ.useEffect(()=>{
        if (!fromRef.current) return;
        if (fromRef.current.value !== from) fromRef.current.value = from;
    }, [
        from
    ]);
    $2gcPZ.useEffect(()=>{
        if (!toRef.current) return;
        if (toRef.current.value !== to) toRef.current.value = to;
    }, [
        to
    ]);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($8ee77f7511e4c7ae$export$a7fed597f4b8afd8, {
        onSubmit: handleSubmit,
        onKeyDown: handler,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($8ee77f7511e4c7ae$export$6ed20265bd6496f6, {
            children: [
                globalError && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($8ee77f7511e4c7ae$export$185a8afe504e8fca, {
                    children: globalError
                }),
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($8ee77f7511e4c7ae$export$9ca7d99af72dc1f9, {
                    children: [
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($8ee77f7511e4c7ae$var$StyledTextInput, {
                                    placeholder: "From",
                                    type: "text",
                                    name: "fromTime",
                                    className: fromError || globalError ? "error" : "",
                                    "aria-invalid": fromError || globalError ? true : undefined,
                                    onChange: (event)=>{
                                        const { errors: errors, values: values } = (0, $89bcf338a8e6a1c2$export$832e640e210af61e)({
                                            from: event.target.value,
                                            to: to
                                        });
                                        const hasErrors = Object.values(errors).filter((value)=>!!value).length === 0;
                                        if (hasErrors) updateDraftFrom(values.from);
                                    },
                                    defaultValue: from,
                                    ref: fromRef
                                }),
                                fromError && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($8ee77f7511e4c7ae$export$185a8afe504e8fca, {
                                    children: fromError
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($8ee77f7511e4c7ae$var$StyledTextInput, {
                                    placeholder: "To",
                                    type: "text",
                                    defaultValue: to,
                                    className: toError || globalError ? "error" : "",
                                    name: "toTime",
                                    "aria-invalid": toError || globalError ? true : undefined,
                                    onChange: (event)=>{
                                        const { errors: errors, values: values } = (0, $89bcf338a8e6a1c2$export$832e640e210af61e)({
                                            to: event.target.value,
                                            from: from
                                        });
                                        const hasErrors = Object.values(errors).filter((value)=>!!value).length === 0;
                                        if (hasErrors) updateDraftTo(values.to);
                                    },
                                    ref: toRef
                                }),
                                toError && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($8ee77f7511e4c7ae$export$185a8afe504e8fca, {
                                    children: toError
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a921dfdbd8dd60fa$export$353f5b6fc5456de1), {
                    type: "submit",
                    onKeyUp: (event)=>{
                        if (event.key === " " || event.key === "Enter") {
                            event.stopPropagation();
                            handleSubmit(event);
                        }
                    },
                    children: "Apply"
                })
            ]
        })
    });
}
const $8ee77f7511e4c7ae$var$StyledTextInput = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $a921dfdbd8dd60fa$export$f5b8910cec6cf069))`
  width: 100%;
`;
const $8ee77f7511e4c7ae$export$a7fed597f4b8afd8 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).form`
  display: contents;
`;
const $8ee77f7511e4c7ae$export$6ed20265bd6496f6 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: grid;
  gap: 20px;
`;
const $8ee77f7511e4c7ae$export$9ca7d99af72dc1f9 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const $8ee77f7511e4c7ae$export$185a8afe504e8fca = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    font: ${theme.font.body.sm.medium};
    padding: 0 6px;
    background: var(--vscode-inputValidation-errorBackground, #f2dede);
    border-color: var(--vscode-inputValidation-errorBorder, #a1260d);
    color: var(--vscode-foreground, #a1260d);
  `);





function $4ac1c2b3344e3801$export$ba7491697a5a6c7(props) {
    const { onChange: onChange } = props;
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($4ac1c2b3344e3801$var$OptionsList, {
        children: (0, $89bcf338a8e6a1c2$export$523707e132cb0181).map((option)=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($4ac1c2b3344e3801$var$TimeOption, {
                onClick: ()=>{
                    onChange((0, $89bcf338a8e6a1c2$export$e960ce4da64adf02)(option));
                },
                children: option.label
            }, option.label))
    });
}
const $4ac1c2b3344e3801$var$OptionsList = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 4px;
  flex-direction: column;
  overflow: auto;
  max-height: 416px;
`;
const $4ac1c2b3344e3801$var$TimeOption = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).button(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    display: block;
    text-decoration: none;
    background: none;
    outline: none;
    margin: 0;
    border: 0;

    padding: 4px 8px;
    border-radius: ${theme.radius.minimal};
    font: ${theme.font.body.sm.regular};
    text-align: left;
    color: ${theme.color.fg.default};
    cursor: pointer;

    &:hover {
      background-color: ${theme.color.bg.elevated.hover};
    }
  `);


function $356c44e5e8935160$export$7941d24c5c6ee0b4(props) {
    const { onChange: onChange, timeRange: timeRange } = props;
    const { from: from, to: to } = timeRange;
    const [draftFrom, setDraftFrom] = (0, $2gcPZ.useState)(from);
    const [draftTo, setDraftTo] = (0, $2gcPZ.useState)(to);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($356c44e5e8935160$var$Container, {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($356c44e5e8935160$var$MonthTableSection, {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a39076294ab1d1fc$export$18fa4946d43f2e8c), {
                        setStartTime: setDraftFrom,
                        setEndTime: setDraftTo,
                        startTime: draftFrom,
                        endTime: draftTo
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $8ee77f7511e4c7ae$export$ab52eb04dacab641), {
                        from: draftFrom,
                        to: draftTo,
                        onChange: onChange,
                        updateDraftFrom: setDraftFrom,
                        updateDraftTo: setDraftTo
                    })
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($356c44e5e8935160$var$Section, {
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $4ac1c2b3344e3801$export$ba7491697a5a6c7), {
                    onChange: onChange
                })
            })
        ]
    });
}
const $356c44e5e8935160$var$Container = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    display: grid;
    grid-template-columns: 1fr auto;
    background-color: ${theme.color.bg.elevated.default};
    color: ${theme.color.fg.default};
    border-radius: ${theme.radius.rounded};
  `);
const $356c44e5e8935160$var$Section = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  padding: 16px;
`;
const $356c44e5e8935160$var$MonthTableSection = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)($356c44e5e8935160$var$Section)`
  display: grid;
  gap: 20px;
  align-content: baseline;
`;







function $72118d174aea64a2$export$5109c6dd95d8fb00({ onChange: onChange, timeRange: timeRange, className: className }) {
    const isDatePickerOpen = (0, $1a280fbaa3fcabb5$export$2105062e25df4afe)((0, $2170e4260f2ec713$export$557d4f28bb6723de));
    const contentRef = (0, $2gcPZ.useRef)(null);
    const toggleDatePicker = (0, $cac150ebb620e91f$export$d095b0c879743c0d)(()=>{
        (0, $c41f178228bd3003$export$635e15bbd66f01ea)((0, $f7cf41d7a90d10a9$export$8064e326d2d51488)());
    });
    const onClickAway = (0, $cac150ebb620e91f$export$d095b0c879743c0d)((event)=>{
        const target = event.target;
        if (target instanceof HTMLButtonElement && target.dataset.datePicker) return;
        toggleDatePicker();
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($fba371f6e5a68b67$exports)))(contentRef, onClickAway);
    // Show nudge animation when time range changes
    const [nudgeVisible, setNudgeVisibility] = (0, $2gcPZ.useState)(false);
    // Store timer ref to clear it on unmount
    const timerRef = (0, $2gcPZ.useRef)(null);
    // Store initial time range to compare with the current one
    const initialRef = (0, $2gcPZ.useRef)(timeRange);
    (0, $2gcPZ.useEffect)(()=>{
        if (initialRef.current !== timeRange) {
            setNudgeVisibility(true);
            timerRef.current = setTimeout(()=>{
                setNudgeVisibility(false);
                timerRef.current = null;
            }, 1050);
        }
    }, [
        setNudgeVisibility,
        timeRange
    ]);
    // Cleanup timer when needed
    (0, $2gcPZ.useEffect)(()=>{
        return ()=>{
            if (timerRef.current) clearTimeout(timerRef.current);
        };
    }, []);
    const handler = (0, $cac150ebb620e91f$export$d095b0c879743c0d)((timeRange)=>{
        toggleDatePicker();
        initialRef.current = timeRange;
        onChange(timeRange);
    });
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($72118d174aea64a2$var$DatePickerContainer, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($72118d174aea64a2$var$DatePickerButton, {
                $isActive: isDatePickerOpen,
                buttonStyle: "secondary",
                onClick: toggleDatePicker,
                "data-date-picker": true,
                children: [
                    nudgeVisible && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($72118d174aea64a2$var$Nudge, {}),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0a830394bc38e4e3$export$f04a61298a47a40f), {
                        type: "time_duotone"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($72118d174aea64a2$var$DatePickerFormattedTimeRange, {
                        children: $72118d174aea64a2$var$toFormattedTimeRange(timeRange)
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $1c3f96f2902350df$export$657832131d9fbace), {
                        isActive: isDatePickerOpen
                    })
                ]
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $d3a9d83062c98169$export$3ae376d12526dd6f), {
                children: isDatePickerOpen && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($72118d174aea64a2$var$Content, {
                    ref: contentRef,
                    children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $356c44e5e8935160$export$7941d24c5c6ee0b4), {
                        timeRange: timeRange,
                        onChange: handler
                    })
                })
            })
        ]
    });
}
const $72118d174aea64a2$var$fade = (0, $4e8e6ea7d6e48c37$export$d25ddfdf17c3ad3e)`
  from { opacity: 1 }
  to { opacity: 0 }
`;
const $72118d174aea64a2$var$Nudge = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    & {
      position: absolute;
      width: 100%;
      height: 100%;
      background-color: ${theme.color.bg.emphasis["primary-subtle"]};
      border-radius: inherit;
      box-shadow: ${theme.effect.focus.primary};
      animation: 1s ease-in-out forwards ${$72118d174aea64a2$var$fade};
    }
  `);
const $72118d174aea64a2$var$DatePickerContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div`
  position: relative;
`;
const $72118d174aea64a2$var$DatePickerFormattedTimeRange = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const $72118d174aea64a2$var$Content = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $ac3093982c5abc41$export$851c9e1591280bd9))`
  position: absolute;
  right: 0;
  top: calc(100% + 8px); /* offset the button height with 8px spacing */
  z-index: 2;
  min-width: 430px;
  border-radius: ${({ theme: theme })=>theme.radius.default};

  /* Same in light & dark themes; also no variable defined in Figma */
  box-shadow: 0px 4px 25px 0px rgb(0 0 0 / 25%);
`;
const $72118d174aea64a2$var$DatePickerButton = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $a921dfdbd8dd60fa$export$353f5b6fc5456de1))(({ $isActive: $isActive, theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    padding: 8px;
    font: ${theme.font.body.md.medium};
    position: relative;

    /* Prevents clicking child elements in onClickAway */
    & *:not(${$72118d174aea64a2$var$Nudge}) {
      pointer-events: none;
      position: relative;
    }

    /* Force :focus styles when DatePicker is opened */
    ${$isActive && (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      border-color: ${theme.color.border.primary};
      box-shadow: ${theme.effect.focus.primary};
    `}
  `);
const $72118d174aea64a2$var$ONE_DAY = 86400000;
function $72118d174aea64a2$var$toFormattedTimeRange(timeRange) {
    const startTimeNumeric = +new Date(timeRange.from);
    // If the time range contians a valid preset label, render that label
    if ((0, $89bcf338a8e6a1c2$export$b4d6c2a64cc2b2b0)(timeRange?.relativeTimeRangeLabel)) return timeRange.relativeTimeRangeLabel;
    // If start date is less than 24 hours ago, render the time without the date
    const isStartTimeLessThan24HoursAgo = startTimeNumeric > Date.now() - $72118d174aea64a2$var$ONE_DAY;
    if (isStartTimeLessThan24HoursAgo) return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $afa7be861492543f$exports.Fragment), {
        children: [
            $72118d174aea64a2$var$formatLocaleTime(timeRange.from),
            " \u2014",
            " ",
            $72118d174aea64a2$var$formatLocaleTime(timeRange.to)
        ]
    });
    // Otherwise, render the absolute time range
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $afa7be861492543f$exports.Fragment), {
        children: [
            timeRange.from,
            " \u2014 ",
            timeRange.to
        ]
    });
}
function $72118d174aea64a2$var$formatLocaleTime(timestamp) {
    const date = new Date(timestamp);
    // If the date is less than 24 hours ago, show the time
    return date.toLocaleTimeString();
}









const $ca7d3b71ebfee77e$export$84a0021562a1cfd3 = ()=>{
    const { instances: instances, selectedInstance: selectedInstance } = (0, $162ecfa8ddc7a9ff$export$a7347740d65f620b)((state)=>state.environment);
    const activeInstance = instances.find((instance)=>instance.id === selectedInstance);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($ca7d3b71ebfee77e$var$StyledSelect, {
        className: "potato",
        name: "instance",
        onChange: (id)=>(0, $c41f178228bd3003$export$635e15bbd66f01ea)((0, $ecfe56675d6ea75b$export$3b7e95cf3154ca1f)(id)),
        value: activeInstance?.id ?? "",
        leadingIcon: ()=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0a830394bc38e4e3$export$f04a61298a47a40f), {
                type: "environments_duotone"
            }),
        options: instances.map((instance)=>({
                children: instance.name,
                value: instance.id
            }))
    });
};
const $ca7d3b71ebfee77e$var$StyledSelect = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $c755d2e017a9d27b$export$ef9b1a59e592288f))(({ theme: { media: media } })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    span {
      display: none;

      ${media.md`
        display: inline-block;
      `}
    }
  `);






function $89839ac3642c1d53$export$33329ee3d79c1e80() {
    const { currentTheme: currentTheme, toggleTheme: toggleTheme } = (0, $bbc2cb4268a46f72$export$bace31607121468e)();
    const isDarkTheme = currentTheme === "dark";
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($89839ac3642c1d53$var$TogglePillBox, {
        onClick: toggleTheme,
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($89839ac3642c1d53$var$TogglePillItem, {
                isActive: !isDarkTheme,
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0a830394bc38e4e3$export$f04a61298a47a40f), {
                    type: "sun_duotone",
                    height: 18,
                    width: 18
                })
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($89839ac3642c1d53$var$TogglePillItem, {
                isActive: isDarkTheme,
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($89839ac3642c1d53$var$MoonIcon, {
                    height: 18,
                    width: 18
                })
            })
        ]
    });
}
const $89839ac3642c1d53$var$TogglePillBox = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $3fd8d40d0eab6e09$export$7f64fe02d2d45e7))(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    padding: 4px;
    cursor: pointer;
    border: 1px solid ${theme.color.button.secondary.border};
    background-color: ${theme.color.button.secondary.bg};
    box-sizing: border-box;
  `);
// We're scaling the moon here to have the moon's body the same size as the
// sun's.
const $89839ac3642c1d53$var$MoonIcon = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $0a830394bc38e4e3$export$f04a61298a47a40f)).attrs({
    type: "moon_duotone"
})`
  transform: scale(1.2);
`;
const $89839ac3642c1d53$var$TogglePillItem = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $3fd8d40d0eab6e09$export$66c1de921b22048b))`
  padding: 4px;
  aspect-ratio: 1;
  cursor: unset;
  line-height: 0; /* HACK: force the 1 / 1 aspect ratio in Chrome & SafarIE */
`;









function $6f494d71065c335c$export$280930995946bc50() {
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($6f494d71065c335c$var$StyledButton, {
        buttonStyle: "secondary",
        onClick: ()=>(0, $c41f178228bd3003$export$635e15bbd66f01ea)({
                type: (0, $f7cf41d7a90d10a9$export$15779acd87b94b6a)
            }),
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0a830394bc38e4e3$export$f04a61298a47a40f), {
                type: "search_duotone"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($6f494d71065c335c$var$KeyCombo, {
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($6f494d71065c335c$var$Key, {
                        children: (0, $6babf196a55ab307$export$9ac100e40613ea10) ? "\u2318" : "ctrl"
                    }),
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($6f494d71065c335c$var$Key, {
                        children: "K"
                    })
                ]
            })
        ]
    });
}
const $6f494d71065c335c$var$StyledButton = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $a921dfdbd8dd60fa$export$353f5b6fc5456de1))`
  padding: 7px 8px;
`;
const $6f494d71065c335c$var$KeyCombo = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).span`
  display: inline-flex;
  gap: 2px;
`;
const $6f494d71065c335c$var$Key = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).span(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      display: inline-flex;
      border-radius: ${theme.radius.minimal};
      border: 1px solid ${theme.color.button.secondary.border};
      color: ${theme.color.fg.muted};
      font: ${theme.font.buttons.sm};
      padding: 4px;
      width: 20px;
      height: 20px;
      align-items: center;
      justify-content: center;
    `);




const $6084d7dd4753d0c9$export$aa8d2cf8be81ad24 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).ul`
  display: flex;
  gap: 8px;
  align-items: center;
  margin: 0;
  padding: 0;
`;
const $6084d7dd4753d0c9$export$9c3a111f2b26dab5 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).li`
  list-style: none;
  margin: 0;
  padding: 0;
`;
const $6084d7dd4753d0c9$export$51a98f270eb125c5 = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $b9eaf400d2e3afef$export$f5c8616e2cb01d3f))(({ theme: { media: media } })=>media.lg`
    gap: 8px;
  `);




var $2gcPZ = parcelRequire("2gcPZ");

var $fuyzp = parcelRequire("fuyzp");




function $4e019f1e3539498f$export$99325b2a5423c564({ children: children, closeMenu: closeMenu, navRef: navRef }) {
    const childrenCount = (0, $2gcPZ.Children).count(children);
    (0, (/*@__PURE__*/$parcel$interopDefault($fba371f6e5a68b67$exports)))(navRef, closeMenu);
    (0, $b983b4c95358e607$export$d0951a301bdf7751)("Escape", closeMenu);
    (0, $2gcPZ.useEffect)(()=>{
        document.body.style.overflow = "hidden";
        return ()=>{
            document.body.style.overflow = "";
        };
    }, []);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($4e019f1e3539498f$var$AppLinks, {
        $childrenCount: childrenCount,
        children: [
            children,
            /*#__PURE__*/ (0, $fuyzp.createPortal)(/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($4e019f1e3539498f$var$PageOverlay, {}), document.body)
        ]
    });
}
const $4e019f1e3539498f$var$PageOverlay = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    @keyframes pageOverlayFadeInAnimation {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }

    position: absolute;
    inset: 0;
    background: ${theme.color.neutral.alpha.dark[300]};
    animation: pageOverlayFadeInAnimation 0.2s ease-in;
  `);
const $4e019f1e3539498f$var$AppLinks = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $6084d7dd4753d0c9$export$aa8d2cf8be81ad24))(({ $childrenCount: $childrenCount })=>{
    // Create an array of CSS custom properties with animation delays for each
    // child
    const animationDelays = Array.from({
        length: $childrenCount
    }).map((_, i)=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
        &:nth-child(${i + 1}) {
          animation-delay: calc(var(--animation-delay-app-link) * ${i});
        }
      `);
    return (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      --animation-delay-app-link: 0.1s;

      grid-area: app-links;
      display: grid;
      grid-auto-rows: 36px;
      gap: 16px;
      padding-block-start: 4px;

      @keyframes navBarItemAnimation {
        0% {
          opacity: 0;
          transform: translateX(8px);
        }
        100% {
          opacity: 1;
          transform: translateX(0);
        }
      }

      /*
        Apply styles to each nav bar item, including their :nth-child animation
        delays.
      */
      & > ${0, $6084d7dd4753d0c9$export$9c3a111f2b26dab5} {
        animation: navBarItemAnimation 0.15s ease-in-out forwards;
        opacity: 0;

        ${animationDelays}
      }
    `;
});





function $9210a9a266941a46$export$8ab9296042acb886({ children: children }) {
    const { timeRange: timeRange, onChangeTimeRange: onChangeTimeRange } = (0, $326a17b5958d0a0c$export$43bf3df9dfee3ce5)();
    const [currentSearchParams] = (0, $e7b98158099ae00d$export$f1a78c17382fe22a)();
    const search = currentSearchParams.toString();
    const [hasThemeSwitch] = (0, $edc4621501740b0b$export$fc97652867e5867e)("theme-switch");
    const documentation = (0, $cf5557e4cde6a3c7$export$362afcc43006a410)("documentation_duotone");
    const hamburger = (0, $cf5557e4cde6a3c7$export$362afcc43006a410)("hamburger");
    const settings = (0, $cf5557e4cde6a3c7$export$362afcc43006a410)("settings_duotone");
    const dispatch = (0, $162ecfa8ddc7a9ff$export$f51d452c10d5b956)();
    const menuIsOpen = (0, $1a280fbaa3fcabb5$export$2105062e25df4afe)((0, $2170e4260f2ec713$export$5ed83947c768e4b3));
    const isLg = (0, $0e947f43bc2b09d1$export$32d5543ab307c01)("lg");
    const shouldOpenMenu = !isLg && menuIsOpen;
    const navRef = (0, $2gcPZ.useRef)(null);
    const closeMenu = (0, $cac150ebb620e91f$export$d095b0c879743c0d)(()=>{
        dispatch((0, $f7cf41d7a90d10a9$export$ec1cdefe2f176838)(false));
    });
    const handleHamburgerOnClick = ()=>dispatch((0, $f7cf41d7a90d10a9$export$ec1cdefe2f176838)(!menuIsOpen));
    (0, $2gcPZ.useEffect)(()=>{
        hamburger[menuIsOpen ? "startAnimation" : "animateToInitial"]();
    }, [
        hamburger,
        menuIsOpen
    ]);
    (0, $2gcPZ.useEffect)(()=>{
        if (isLg) closeMenu();
    }, [
        closeMenu,
        isLg
    ]);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($9210a9a266941a46$var$NavWrapper, {
        ref: navRef,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($9210a9a266941a46$var$NavContainer, {
            $isOpen: shouldOpenMenu,
            children: [
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($9210a9a266941a46$var$BrandLink, {
                    to: {
                        pathname: "/",
                        search: search
                    },
                    onClick: closeMenu,
                    children: [
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0a830394bc38e4e3$export$f04a61298a47a40f), {
                            type: "autometrics_color",
                            height: 24,
                            width: 24
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0a830394bc38e4e3$export$f04a61298a47a40f), {
                            type: "autometrics_logo_type"
                        })
                    ]
                }),
                shouldOpenMenu && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $4e019f1e3539498f$export$99325b2a5423c564), {
                    navRef: navRef,
                    closeMenu: closeMenu,
                    children: children
                }),
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($9210a9a266941a46$var$AppLinks, {
                    children: children
                }),
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($9210a9a266941a46$var$AppSettings, {
                    children: [
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($9210a9a266941a46$export$a8cd4dcfdefbb36c, {
                            timeRange: timeRange,
                            onChange: onChangeTimeRange
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $ca7d3b71ebfee77e$export$84a0021562a1cfd3), {})
                    ]
                }),
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($9210a9a266941a46$var$HamburgerIconButton, {
                    onClick: handleHamburgerOnClick,
                    buttonStyle: "tertiary-grey",
                    children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)(hamburger.icon, {})
                }),
                /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)($9210a9a266941a46$var$ButtonLinks, {
                    children: [
                        hasThemeSwitch && /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $89839ac3642c1d53$export$33329ee3d79c1e80), {}),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $6f494d71065c335c$export$280930995946bc50), {}),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $b9eaf400d2e3afef$export$3e676578822187d7), {
                            to: {
                                pathname: "/settings",
                                search: search
                            },
                            "aria-label": "settings",
                            children: ({ isActive: isActive })=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($9210a9a266941a46$var$IconNavLink, {
                                    onMouseEnter: isActive ? undefined : settings.startAnimation,
                                    children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)(settings.icon, {})
                                })
                        }),
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $b9eaf400d2e3afef$export$3e676578822187d7), {
                            as: "a",
                            href: "https://docs.autometrics.dev/",
                            rel: "noopener noreferrer",
                            target: "_blank",
                            "aria-label": "go to docs",
                            children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)($9210a9a266941a46$var$IconNavLink, {
                                onMouseEnter: documentation.startAnimation,
                                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)(documentation.icon, {})
                            })
                        })
                    ]
                })
            ]
        })
    });
}
const $9210a9a266941a46$var$NavWrapper = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).nav`
  position: relative;
`;
const $9210a9a266941a46$var$NavContainer = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039).div(({ $isOpen: $isOpen, theme: { color: color, media: media, spacing: spacing } })=>{
    return (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
      display: grid;
      grid:
      /*
        CSS variable inherited from Layout.tsx as it's a responsive layout value
      */
        "branding app-settings hamburger" var(--spacing-nav-container)
        "app-links app-links app-links" / auto 1fr;
      gap: 0 ${spacing.content.gap.md};
      padding-inline: ${spacing.page.inline};
      background: ${color.bg.default};
      border-bottom: 1px solid ${color.border.default};
      position: absolute;
      inset: auto 0;
      z-index: 10; /* arbitrary value */

      ${$isOpen && (0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
        padding-block-end: 20px;
      `}

      ${media.lg`
        grid:
          "branding app-links app-settings button-links"
          minmax(var(--spacing-nav-container), auto)
            / max-content 1fr auto auto;
        gap: 0 16px;
      `}
    `;
});
const $9210a9a266941a46$var$BrandLink = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $e7b98158099ae00d$export$a6c7ac8248d6e38a))(({ theme: theme })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    grid-area: branding;
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${theme.color.fg.default};
    margin-right: ${theme.spacing.content.gap.md};
  `);
const $9210a9a266941a46$var$AppSettings = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $6084d7dd4753d0c9$export$aa8d2cf8be81ad24))`
  grid-area: app-settings;
  justify-self: end;
`;
const $9210a9a266941a46$var$AppLinks = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $6084d7dd4753d0c9$export$aa8d2cf8be81ad24))(({ theme: { media: media } })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    display: none;

    ${media.lg`
      display: flex;
      gap: 24px;

      & > ${0, $6084d7dd4753d0c9$export$9c3a111f2b26dab5}[data-hidden-lg="true"] {
        display: none;
      }
    `}
  `);
const $9210a9a266941a46$var$HamburgerIconButton = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $a921dfdbd8dd60fa$export$353f5b6fc5456de1))(({ theme: { media: media } })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    grid-area: hamburger;
    align-self: center;
    height: 36px;
    aspect-ratio: 1;

    ${media.lg`
      display: none;
    `}
  `);
const $9210a9a266941a46$export$a8cd4dcfdefbb36c = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $72118d174aea64a2$export$5109c6dd95d8fb00))(({ theme: { media: media } })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    span {
      display: none;

      ${media.sm`
        display: inline-block;
      `}
    }
  `);
const $9210a9a266941a46$var$ButtonLinks = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $6084d7dd4753d0c9$export$aa8d2cf8be81ad24))(({ theme: { media: media } })=>(0, $4e8e6ea7d6e48c37$export$dbf350e5966cf602)`
    grid-area: button-links;
    display: none;

    ${media.lg`
      display: flex;
    `}
  `);
const $9210a9a266941a46$var$IconNavLink = (0, $4e8e6ea7d6e48c37$export$2e2bcd8739ae039)((0, $6084d7dd4753d0c9$export$51a98f270eb125c5))`
  padding: 8px;
`;





function $17e1b4f01eadf205$export$afce05b2a4229c8e({ children: children, animatedIconType: animatedIconType, "data-hidden-lg": hiddenLg = false, ...navLinkProps }) {
    const animatedIcon = (0, $cf5557e4cde6a3c7$export$362afcc43006a410)(animatedIconType);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $6084d7dd4753d0c9$export$9c3a111f2b26dab5), {
        "data-hidden-lg": hiddenLg,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $b9eaf400d2e3afef$export$3e676578822187d7), {
            ...navLinkProps,
            children: ({ isActive: isActive })=>/*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $6084d7dd4753d0c9$export$51a98f270eb125c5), {
                    onMouseEnter: isActive ? undefined : animatedIcon.startAnimation,
                    children: [
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)(animatedIcon.icon, {}),
                        children
                    ]
                })
        })
    });
}
function $17e1b4f01eadf205$export$1edef75f6a8e37e0({ animatedIconType: animatedIconType, children: children, "data-hidden-lg": hiddenLg = false, ...anchorProps }) {
    const animatedIcon = (0, $cf5557e4cde6a3c7$export$362afcc43006a410)(animatedIconType);
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $6084d7dd4753d0c9$export$9c3a111f2b26dab5), {
        "data-hidden-lg": hiddenLg,
        children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)("a", {
            ...anchorProps,
            children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $6084d7dd4753d0c9$export$51a98f270eb125c5), {
                onMouseEnter: animatedIcon.startAnimation,
                children: [
                    /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)(animatedIcon.icon, {}),
                    children
                ]
            })
        })
    });
}





function $cb106f951b2907d8$export$ef8da11641c635de() {
    const [currentSearchParams] = (0, $e7b98158099ae00d$export$f1a78c17382fe22a)();
    const search = currentSearchParams.toString();
    const dispatch = (0, $162ecfa8ddc7a9ff$export$f51d452c10d5b956)();
    const closeNavMenuOnClick = ()=>dispatch((0, $f7cf41d7a90d10a9$export$ec1cdefe2f176838)(false));
    return /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $9210a9a266941a46$export$8ab9296042acb886), {
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $17e1b4f01eadf205$export$afce05b2a4229c8e), {
                to: {
                    pathname: "/dashboard",
                    search: search
                },
                animatedIconType: "dashboard_duotone",
                onClick: closeNavMenuOnClick,
                children: "Dashboard"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $17e1b4f01eadf205$export$afce05b2a4229c8e), {
                to: {
                    pathname: "/functions",
                    search: search
                },
                animatedIconType: "function_duotone",
                onClick: closeNavMenuOnClick,
                children: "Functions"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $17e1b4f01eadf205$export$afce05b2a4229c8e), {
                to: {
                    pathname: "/slos",
                    search: search
                },
                animatedIconType: "slo_duotone",
                onClick: closeNavMenuOnClick,
                children: "SLOs"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $17e1b4f01eadf205$export$afce05b2a4229c8e), {
                to: {
                    pathname: "/alerts",
                    search: search
                },
                animatedIconType: "alerts_duotone",
                onClick: closeNavMenuOnClick,
                children: "Alerts"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $17e1b4f01eadf205$export$afce05b2a4229c8e), {
                to: {
                    pathname: "/settings",
                    search: search
                },
                animatedIconType: "settings_duotone",
                "aria-label": "settings",
                onClick: closeNavMenuOnClick,
                "data-hidden-lg": true,
                children: "Settings"
            }),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $17e1b4f01eadf205$export$1edef75f6a8e37e0), {
                animatedIconType: "documentation_duotone",
                href: "https://docs.autometrics.dev/",
                rel: "noopener noreferrer",
                target: "_blank",
                onClick: closeNavMenuOnClick,
                "data-hidden-lg": true,
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)("span", {
                    children: [
                        "Documentation ",
                        /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $0a830394bc38e4e3$export$f04a61298a47a40f), {
                            height: "1em",
                            width: "1em",
                            type: "link_out"
                        })
                    ]
                })
            })
        ]
    });
}








const $4691ad3fe7f1f4f6$var$root = (0, $15fe56b1fcc04799$export$882461b6382ed46c)(document.querySelector("#root"));
$4691ad3fe7f1f4f6$var$root.render(/*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $5293de6422d97033$export$2e2bcd8739ae039), {
    store: (0, $c41f178228bd3003$export$2e2bcd8739ae039),
    children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsxs)((0, $4e8e6ea7d6e48c37$export$d8964aec282183a3), {
        theme: (0, $c3cecdc865a218b8$export$bcfc11ac64052319),
        children: [
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $a075cbb4f2871a7e$export$f05794e648629f6c), {}),
            /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $e7b98158099ae00d$export$7221d69dcfc8e36b), {
                children: /*#__PURE__*/ (0, $afa7be861492543f$exports.jsx)((0, $6bee0a7ce67ac334$export$86fbec116b87613f), {})
            })
        ]
    })
}));


//# sourceMappingURL=index.24432f8e.js.map
